(function ()
{
    'use strict';

    angular
        .module('app.pages.events', ['datatables'])
        .config(config).run(run);


    function run($rootScope,msNavigationService) {

        /**
         * Set the pages by the admin level
         */
        $rootScope.$watch('User',function () {
            if ($rootScope.AdminLevel && $rootScope.User) {

                if ($rootScope.User.Attendance)
                    msNavigationService.saveItem('pages.events.attendance', {
                        title: 'נוכחות',
                        icon  : 'icon-account-check',
                        state: 'app.pages_events_attendance',
                        weight: 6
                    });

                if ($rootScope.User.Marketing)
                    msNavigationService.saveItem('pages.events.marketing', {
                        title: 'שיווק ' + $rootScope.User.Events,
                        icon  : 'icon-cart',
                        state: 'app.pages_events_marketing',
                        weight: 2

                    });

                switch ($rootScope.AdminLevel) {
                    case 1:
                        msNavigationService.saveItem('pages.events', {
                            title: $rootScope.User.Events + ' ומוצרים',
                            icon  : 'icon-weather-sunny',
                            weight: 4

                        });
                        msNavigationService.saveItem('pages.events.events', {
                            title: 'צפייה ב' + $rootScope.User.Events,
                            icon  : 'icon-brightness-5',
                            state: 'app.pages_events',
                            weight: 1

                        });
                        break;
                    case 2:
                        msNavigationService.saveItem('pages.events', {
                            title: $rootScope.User.Events + ' ומוצרים',
                            icon  : 'icon-weather-sunny',
                            weight: 3

                        });
                        msNavigationService.saveItem('pages.events.events', {
                            title: 'ניהול ' + $rootScope.User.Events,
                            icon  : 'icon-brightness-5',
                            state: 'app.pages_events',
                            weight: 1

                        });
                        msNavigationService.saveItem('pages.events.products', {
                            title: 'ניהול מוצרים',
                            icon  : 'icon-shopping',
                            state: 'app.pages_products',
                            weight: 2

                        });
                        if ($rootScope.User.Events===1) {
                            msNavigationService.saveItem('pages.events.registrations', {
                                title: 'הרשמות',
                                icon  : 'icon-file-document-box',
                                state: 'app.pages_events_registrations',
                                weight: 2
                            });
                            msNavigationService.saveItem('pages.events.questions', {
                                title: 'שאלות',
                                icon  : 'icon-format-list-numbers',
                                state: 'app.pages_events_questions',
                                weight: 3
                            });

                            msNavigationService.saveItem('pages.events.transportation', {
                                title: 'הסעות',
                                icon  : 'icon-bus',
                                state: 'app.pages_events_transportation',
                                weight: 4
                            });
                        }
                        break;
                    default:
                        msNavigationService.saveItem('pages.events', {
                            title: $rootScope.User.Events + ' ומוצרים',
                            icon  : 'icon-weather-sunny',
                            weight: 3

                        });
                        msNavigationService.saveItem('pages.events.events', {
                            title: 'ניהול ' + $rootScope.User.Events,
                            icon  : 'icon-brightness-5',
                            state: 'app.pages_events',
                            weight: 1

                        });
                        msNavigationService.saveItem('pages.events.products', {
                            title: 'ניהול מוצרים',
                            icon  : 'icon-shopping',
                            state: 'app.pages_products',
                            weight: 2

                        });
                        msNavigationService.saveItem('pages.events.marketing', {
                            title: 'שיווק ' + $rootScope.User.Events,
                            icon  : 'icon-cart',
                            state: 'app.pages_events_marketing',
                            weight: 4

                        });

                        msNavigationService.saveItem('pages.events.registrations', {
                            title: 'הרשמות',
                            icon  : 'icon-file-document-box',
                            state: 'app.pages_events_registrations',
                            weight: 5
                        });
                        msNavigationService.saveItem('pages.events.questions', {
                            title: 'שאלות',
                            icon  : 'icon-format-list-numbers',
                            state: 'app.pages_events_questions',
                            weight: 6
                        });

                        msNavigationService.saveItem('pages.events.transportation', {
                            title: 'הסעות',
                            icon  : 'icon-bus',
                            state: 'app.pages_events_transportation',
                            weight: 7
                        });
                        msNavigationService.saveItem('pages.events.attendance', {
                            title: 'נוכחות',
                            icon  : 'icon-account-check',
                            state: 'app.pages_events_attendance',
                            weight: 8
                        });
                        break;
                }

            }

        });

    }

    /** @ngInject */
    function config($stateProvider )
    {
        $stateProvider
            .state('app.pages_events', {
            url      : '/events',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/pages/events/views/events/events.html',
                    controller: 'EventsController'
                }
            },
            resolve  : {
                DashboardData: function (ValidToken)
                {
                    ValidToken.validUserToken();
                    localStorage.setItem("path",'/events');
                }
            },
            bodyClass: 'events'

        })
            .state('app.pages_products', {
                url      : '/products',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/pages/events/views/events/events.html',
                        controller: 'EventsController'
                    }
                },
                resolve  : {
                    DashboardData: function (ValidToken)
                    {
                        ValidToken.validUserToken();
                        localStorage.setItem("path",'/products');
                    }
                },
                bodyClass: 'events'

            })

            .state('app.pages_events_questions', {
                url      : '/events-questions',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/pages/events/views/questions/questions.html',
                        controller: 'QuestionsController'
                    }
                },
                resolve  : {
                    DashboardData: function (ValidToken)
                    {
                        ValidToken.validUserToken();
                        localStorage.setItem("path",'/events-questions');
                    }
                },
                bodyClass: 'events'
            })
            .state('app.pages_events_transportation', {
                url      : '/events-transportation',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/pages/events/views/transportation/transportation.html',
                        controller: 'TransportationController'
                    }
                },
                resolve  : {
                    DashboardData: function (ValidToken)
                    {
                        ValidToken.validUserToken();
                        localStorage.setItem("path",'/events-transportation');
                    }
                },
                bodyClass: 'events'
            })
            .state('app.pages_events_registrations', {
                url      : '/events-registrations',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/pages/events/views/registrations/registrations.html',
                        controller: 'RegistrationsController'
                    }
                },
                resolve  : {
                    DashboardData: function (ValidToken)
                    {
                        ValidToken.validUserToken();
                        localStorage.setItem("path",'/events-registrations');
                    }
                },
                bodyClass: 'events'
            })
            .state('app.pages_events_marketing', {
                url      : '/events-marketing',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/pages/events/views/marketing/marketing.html',
                        controller: 'MarketingController as vm'
                    }
                },
                resolve  : {
                    DashboardData: function (ValidToken)
                    {
                        ValidToken.validUserToken();
                        localStorage.setItem("path",'/events-marketing');
                    }
                },
                bodyClass: 'events'
            })
            .state('app.pages_events_attendance', {
                url      : '/events-attendance',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/pages/events/views/attendance/attendance.html',
                        controller: 'AttendanceController as vm'
                    }
                },
                resolve  : {
                    DashboardData: function (ValidToken)
                    {
                        ValidToken.validUserToken();
                        localStorage.setItem("path",'/events-attendance');
                    }
                },
                bodyClass: 'events'
            });


        ;


        // Translation






    }

})();

angular.module('app.pages.events').controller('NewStudentDiscountDialogController', ['$scope', '$rootScope', '$mdDialog','branchesEndpoint','eventsEndpoint','citiesEndpoint','groupsEndpoint','event','Notification', function ($scope, $rootScope, $mdDialog,branchesEndpoint,eventsEndpoint,citiesEndpoint,groupsEndpoint,event,Notification) {

    $scope.newStudentDiscount = {};

     /**
     * Save new Student
     */
    $scope.saveNewStudentDiscount = function () {
            $scope.isClicked = true;
            var studentID = $scope.newStudentDiscount.StudentID;
            eventsEndpoint.discounts.student.post(event.selectedEvent, studentID, $scope.newStudentDiscount,function (data) {
               if(!data.success) {
                   Notification.error('תעודות זהות לא קיימת');
                   $scope.isClicked = false;
               }
               else
                   $mdDialog.hide();
            });

    };

    /**
     * Close the dialog
     */
    $scope.closeDialog =function () {
        $mdDialog.cancel();
    };

}]);

angular.module('app.pages.events').controller('NewDateDiscountDialogController', ['$scope', '$rootScope', '$mdDialog','eventsEndpoint','event',
    function ($scope, $rootScope, $mdDialog,eventsEndpoint,event) {

    $scope.newDateDiscount = {};

    /**
     * Save new Date Discount
     */
    $scope.saveDateDiscount = function () {
        $scope.isClicked = true;
        eventsEndpoint.discounts.date.post(event.selectedEvent, $scope.newDateDiscount,function (data) {
            $mdDialog.hide();
        });

    };

    /**
     * Close the dialog
     */
    $scope.closeDialog =function () {
        $mdDialog.cancel();
    };

}]);

angular.module('app.pages.events').controller('NewGeneralDiscountDialogController', ['$scope', '$rootScope', '$mdDialog', 'branchesEndpoint', 'eventsEndpoint', 'areasEndpoint', 'gradesEndpoint', 'event', 'Notification', '$element', 'tagsEndpoint','$timeout',
    function ($scope, $rootScope, $mdDialog, branchesEndpoint, eventsEndpoint, areasEndpoint, gradesEndpoint, event, Notification, $element, tagsEndpoint,$timeout) {

        $scope.endpointData = [];
        $scope.endpointsReady = 0;
        $scope.newGeneralDiscount = {};
        var params = {};
        params.Limit = 1000;
        params.WithOutEventID = event.selectedEvent.ID;

        /**
         * Get all relevant Information
         */
        $scope.getAllInformation = function () {
            var params = {};
            params.Status = 1;
            branchesEndpoint.get(params, function (data) {
                if (data.length > 0 || Array.isArray(data)) {
                    $scope.endpointsReady++;
                    $scope.endpointData.Branches = data;
                }
            });
            areasEndpoint.get(params, function (data) {
                if (data.length > 0 || Array.isArray(data)) {
                    $scope.endpointsReady++;
                    $scope.endpointData.Areas = data;
                }
            });

            tagsEndpoint.get({TagType: 1}, function (data) {
                $scope.endpointData.Tags = data;
            })

/*
            eventsEndpoint.get(params, function (data) {
                if (data.length > 0) {
                    $scope.endpointsReady++;
                    $scope.endpointData.Events = data;
                }
            });*/
            params.Status = 1;
            gradesEndpoint.get(params, function (data) {
                if (data.length > 0 || Array.isArray(data)) {
                    $scope.endpointsReady++;
                    $scope.endpointData.Grades = data;
                }
            });
        };

        $scope.getEvents = function () {
            if ($scope.searchTerm != undefined && $scope.searchTerm.length > 0){
                var params = {
                    FreeSearch: $scope.searchTerm,
                    Status: 1
                };

                eventsEndpoint.get(params, function (data) {
                    $scope.endpointData.Events = data;
                });
            }

        };

        /**
         * Save new Student
         */
        $scope.saveNewGeneralDiscount = function () {
            $scope.isClicked = true;
            var params = {};
            params.newDiscount = JSON.stringify($scope.newGeneralDiscount);
            eventsEndpoint.discounts.general.post(event.selectedEvent, params, function (data) {
                if (!data.success) {
                    Notification.error('נכשל בשמירת הנחה כללית');
                    $scope.isClicked = false;
                } else
                    $mdDialog.hide();
            });

        };


        $element.find('input').on('keydown', function (ev) {
            ev.stopPropagation();
        });

        $scope.clearSearchTerm = function () {
            $scope.searchTerm = '';
        };

        /**
         * Close the dialog
         */
        $scope.closeDialog = function () {
            $mdDialog.cancel();
        };

    }]);

angular.module('app.pages.events').controller('NewBrotherDiscountDialogController', ['$scope', '$rootScope', '$mdDialog','eventsEndpoint','event','Notification','brotherCount', function ($scope, $rootScope, $mdDialog,eventsEndpoint,event,Notification,brotherCount) {

    $scope.newBrotherDiscount = undefined;

    /**
     * Save new Brother Discount
     */
    $scope.saveNewBrotherDiscount = function () {
        $scope.isClicked = true;
        $scope.newBrotherDiscount.brotherNumber = brotherCount;
        $scope.newBrotherDiscount.eventID = event.selectedEvent.ID;
        $scope.newBrotherDiscount.IsNew = true;
        var temp = [];
        temp.push($scope.newBrotherDiscount);

        var params = {};
        params.discount = JSON.stringify(temp);
        eventsEndpoint.discounts.brother.post(params,event.selectedEvent,function (data) {
           if(!data.success) {
               Notification.error('נשכל בשמירת נתונים');
               $scope.isClicked = false;
           }
           else
               $mdDialog.hide();
        });

    };

    /**
     * Close the dialog
     */
    $scope.closeDialog =function () {
        $mdDialog.cancel();
    };

}]);

/* eslint-disable angular/di */
// eslint-disable-next-line angular/di
angular.module('app.pages.events').controller('GeneralDiscountPanelController', ['$scope', 'generalDiscount', '$rootScope', 'eventsEndpoint', 'event', '$mdSidenav', '$mdDialog', 'tagsEndpoint',
    function ($scope, generalDiscount, $rootScope, eventsEndpoint, event, $mdSidenav, $mdDialog, tagsEndpoint) {

        $scope.edit = true;


        /**
         * Set the selected GeneralDiscount
         */
        $scope.$on('selectedGeneralDiscount:updated', function () {
            $scope.generalDiscount = generalDiscount.selectedGeneralDiscount;
        });

        $scope.getTags = function () {
            tagsEndpoint.get({TagType: 1}, function (data) {
                $scope.Tags = data;
            })
        }

        /**
         * Update GeneralDiscount
         */
        $scope.updateGeneralDiscountPanel = function () {
            $scope.disable = angular.element(document.querySelector('#vertical-navigation'));
            $scope.edit = !$scope.edit;
            if ($scope.edit) {
                $scope.isClick = true;
                var params = {};
                params.discount = JSON.stringify($scope.editedGeneralDiscount);
                eventsEndpoint.discounts.general.update.post(event.selectedEvent.ID, $scope.generalDiscount.ID, params, function (data) {
                    $scope.disable.removeClass('active');
                    $scope.isClick = false;
                    $scope.closePanel();
                })
            } else
                $scope.disable.addClass('active');
        };

        /**
         * Close the panel
         */
        $scope.closePanel = function () {
            if (!$scope.edit) {
                confirmCloseWithOutSavingPopUp();
                $scope.edit = !$scope.edit;
            } else {
                closeSideNav();
            }

        };


        /**
         * Alert the user that the changes will be overwrite
         * @param ev
         */
        function confirmCloseWithOutSavingPopUp(ev) {
            var confirm = $mdDialog.confirm()
                .title('ביטול שינויים')
                .textContent('האם אתה בטוח/ה שברצונך לצאת ללא שמירה?')
                .targetEvent(ev)
                .ok('צא ללא שמירה')
                .cancel('ביטול');
            $mdDialog.show(confirm).then(function () {
                closeSideNav();
            });
        }

        /**
         * Close the side nav
         */
        function closeSideNav() {
            $scope.disable.removeClass('active');
            generalDiscount.isSave(true);
            $mdSidenav("general-discount-panel").close();
        }
    }]);

(function ()
{
    'use strict';

    angular
        .module('app.pages.student-profile', ['datatables'])
        .config(config);


    /** @ngInject */
    function config($stateProvider)
    {
        $stateProvider.state('app.pages_student-profile', {
            url      : '/student-profile',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/pages/users/views/students/student-profile/student-profile.html',
                    controller: 'StudentProfileController'
                }
            },
            resolve  : {
                DashboardData: function ()
                {
                    localStorage.setItem("path",'/student-profile');
                }
            },
            bodyClass: 'student-profile'
        });

    }

})();
angular.module('app.pages.student-profile').controller('NewEducatorGroupsController', NewEducatorGroupsController);

function NewEducatorGroupsController($rootScope, branchesEndpoint, groupsEndpoint, student, educatorsEndpoint, Notification, $mdDialog) {

    var vm = this;
    vm.newGroup = {};

    vm.getBreaches = getBreaches;
    vm.getGroupsByBranch = getGroupsByBranch;
    vm.addGroup = addGroup;
    vm.closeDialog = closeDialog;
    vm.clearSearchTerm = clearSearchTerm;
    vm.clearSearchTerm2 = clearSearchTerm2;
    vm.searchTerm2 = '';
    vm.searchTerm = '';
    vm.branches = [];
    vm.groups = [];


    function getBreaches() {
        var params = {};
        params.Status = 1;
        branchesEndpoint.get(params, function (data) {
            vm.branches = data;
        })
    }

    function getGroupsByBranch() {
        vm.groups = false;
        var params = {};
        params.BranchID = vm.newGroup.BranchID;
        params.Status = 1;
        groupsEndpoint.get(params, function (data) {
            vm.groups = data;
        })
    }

    function addGroup() {
        vm.newGroup.EducatorID = student.selectedStudent.EducatorID;
        vm.newGroup.StudentID = student.selectedStudent.ID;
        vm.newGroup.FirstName = student.selectedStudent.FirstName;
        vm.newGroup.LastName = student.selectedStudent.LastName;
        vm.newGroup.Email = student.selectedStudent.Email;
        vm.isClicked = true;
        educatorsEndpoint.groups.post(vm.newGroup, function (data) {
            if (data.success == 1)
                Notification.success("שיוך בוצע בהצלחה");
            else if (data.success == 2)
                Notification.success("קבוצה שויכה בהצלחה - דואר אלקטרוני נשלח למשתמש");
            else
                Notification.error("נכשל בשליחת הזמנה - יש לוודא שלמדריך יש מייל ושהוא לא קיים עבור משתמש אחר");
            vm.isClicked = false;
            $mdDialog.hide();

        })
    }

    function clearSearchTerm() {
        vm.searchTerm = '';
    }

    function clearSearchTerm2() {
        vm.searchTerm2 = '';
    }


    function closeDialog() {
        $mdDialog.cancel();
    }


}

angular.module('app.pages.events').controller('NewCartEventDialogController', ['$scope', '$rootScope', '$mdDialog','eventsEndpoint','Notification','cartEventID','events',
    function ($scope, $rootScope, $mdDialog,eventsEndpoint,Notification,cartEventID,events) {

    $scope.events = events;
    $scope.newCartEvent = {
        CartEventID: cartEventID
    };

    /**
     * Save new Student
     */
    $scope.saveNewStudentAssociation = function () {
        $scope.isClicked = true;
        eventsEndpoint.cartEvents.post( cartEventID,$scope.newCartEvent,function (data) {
            if(!data.success) {
                Notification.error('התרחשה שגיאה');
            }
            $mdDialog.hide();
        });

    };

    /**
     * Close the dialog
     */
    $scope.closeDialog =function () {
        $mdDialog.cancel();
    };

}]);

(function ()
{
    'use strict';

    angular
        .module('app.pages.users', []).config(config).run(run);

    function run($rootScope,msNavigationService) {


        /**
         * Set the pages by the admin level
         */
        $rootScope.$watch('User',function () {
            if ($rootScope.AdminLevel && $rootScope.User) {
                msNavigationService.deleteItem('pages.users.parents');
                msNavigationService.saveItem('pages.users', {
                    title : 'משתמשים',
                    icon  : 'icon-account-multiple',
                    weight: 3

                });
                switch ($rootScope.AdminLevel) {
                    case 1:
                        msNavigationService.saveItem('pages.users.students', {
                            title: 'חניכים',
                            icon  : 'icon-school',
                            state: 'app.pages_users_students'
                        });
                        break;
                    case 2:
                        msNavigationService.saveItem('pages.users.students', {
                            title: 'חניכים ומדריכים',
                            icon  : 'icon-school',
                            state: 'app.pages_users_students'
                        });
                        msNavigationService.saveItem('pages.users.parents', {
                            title: 'הורים',
                            icon  : 'icon-account-box',
                            state: 'app.pages_users_parents'
                        });
                        break;
                    case 3:
                        msNavigationService.saveItem('pages.users.students', {
                            title:'חניכים ומדריכים',
                            icon  : 'icon-school',
                            state: 'app.pages_users_students'
                        });

                        msNavigationService.saveItem('pages.users.coordinators', {
                            title: $rootScope.User.Coordinators,
                            icon  : 'icon-tie',
                            state: 'app.pages_users_coordinators'
                        });

                        msNavigationService.saveItem('pages.users.parents', {
                            title: 'הורים',
                            icon  : 'icon-account-box',
                            state: 'app.pages_users_parents'
                        });
                }
            }
        })
    };

    /** @ngInject */
    function config($stateProvider)
    {
        // State
        $stateProvider
            .state('app.pages.users', {
                abstract: true,
                url     : '/users'
            })
            .state('app.pages_users_students', {
                url      : '/students',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/pages/users/views/students/students.html',
                        controller : 'StudentsController as vm'
                    }
                },
                resolve  : {
                    DashboardData: function (ValidToken)
                    {
                        ValidToken.validUserToken();
                        localStorage.setItem("path",'/students');
                    }
                },
                bodyClass: 'users'
            })
            .state('app.pages_users_coordinators', {
                url      : '/coordinators',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/pages/users/views/coordinators/coordinators.html',
                        controller : 'CoordinatorsController'
                    }
                },
                resolve  : {
                    DashboardData: function (ValidToken)
                    {
                        ValidToken.validUserToken();
                        localStorage.setItem("path",'/coordinators');
                    }
                },
                bodyClass: 'educators'

            }) .state('app.pages_users_parents', {
            url      : '/parents',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/pages/users/views/parents/parents.html',
                    controller : 'ParentsController as vm'
                }
            },
            resolve  : {
                DashboardData: function (ValidToken)
                {
                    ValidToken.validUserToken();
                    localStorage.setItem("path",'/parents');
                }
            },
            bodyClass: 'parents'

        });




    }
})();

angular.module('app.pages.users').controller('SubsidyDialogController', ['$scope', '$rootScope', '$mdDialog','coordinatorsEndpoint','coordinate','$location','Notification','subsidy','parentsEndpoint','moreKids', function ($scope, $rootScope, $mdDialog,coordinatorsEndpoint,coordinate,$location,Notification,subsidy,parentsEndpoint,moreKids) {

    $scope.subsidy = subsidy;
    $scope.moreKids = moreKids;
    $scope.selectedTab = 1;

    /**
     * Get subsidy files
     */
    $scope.getFiles  =function () {
        for (var i =0;i<subsidy.Files.length;i++)
            window.open(subsidy.Files[i].Path,subsidy.Files[i].ID);
    };

    /**
     * Update Subsidy
     */
    $scope.updateSubsidy = function () {
        $scope.isClicked = true;
        parentsEndpoint.subsidy.update.post(subsidy,function (data) {
            $scope.isClicked = false;
            if (data.success)
                Notification.success("בקשה עודכנה");
            else
                Notification.error("נכשל בעידכון בקשה");

        })
    };

    /**
     * CLose dialog
     */
    $scope.closeDialog =function () {
        $mdDialog.cancel();
    };



}]);

(function ()
{
    'use strict';

    angular.module('app.pages.event-management', ['datatables']).config(config);



    /** @ngInject */
    function config($stateProvider)
    {
        $stateProvider.state('app.pages_event-management', {
            url      : '/event-management',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/pages/events/views/events/event-management/event-management.html',
                    controller: 'EventManagementController'
                }
            },
            resolve  : {
                DashboardData: function () {
                    localStorage.setItem("path", '/event-management');
                }
            },
            bodyClass: 'event-management'
        });


    }

})();

angular.module('app.pages.event-management').controller('AddTransportationToEventController', ['$scope', '$rootScope', '$mdDialog','eventsEndpoint','student','$location','Notification','dtOptions','DTOptionsBuilder','event','transportationEndpoint', function ($scope, $rootScope, $mdDialog,eventsEndpoint,student,$location,Notification,dtOptions,DTOptionsBuilder,event,transportationEndpoint) {


    $scope.event = event.selectedEvent;


    /**
     * Get all the questions that are not in the event
     */
    $scope.getAllTransportation = function () {
        $scope.newTransportation = false;
        transportationEndpoint.get(function (data) {
            $scope.transportation = data;
        })
    };

    /**
     * Save new Transportation
     */
    $scope.saveNewTransportation = function () {
        $scope.isClicked = true;
        eventsEndpoint.transportation.post($scope.event, $scope.newTransportation, function (data) {
            $scope.isClicked=false;
            if(!data.success) {
                Notification.error("לא ניתן לשייך הסעה פעמיים")
            } else {
                $mdDialog.hide();
            }
        })
    };

    /**
     * Close the dialog
     */
    $scope.closeDialog =function () {
        $mdDialog.cancel();
    };


    /**
     * Set Table option
     * @type {any}
     */
    $scope.dtOptions = DTOptionsBuilder
        .newOptions()
        .withLanguage(dtOptions.language)
        .withDOM('lfrtp')
        .withOption('bFilter', false)
        .withDOM('lrtip');


}]);

angular.module('app.pages.event-management').controller('AddNewTransportationToEventController', ['$scope', '$rootScope', '$mdDialog','eventsEndpoint','student','$location','Notification','dtOptions','DTOptionsBuilder','event', function ($scope, $rootScope, $mdDialog,eventsEndpoint,student,$location,Notification,dtOptions,DTOptionsBuilder,event) {

    $scope.event = event.selectedEvent;


    /**
     * Add new Transportation
     */
    $scope.addNewTransportation = function () {
        $scope.isClicked = true;
        eventsEndpoint.transportation.post($scope.event, $scope.newTransportation, function (data) {
            $scope.isClicked = false;
            if(!data.success) {
                Notification.error("נכשל בהוספה")
            } else {
                $mdDialog.hide();
            }
        })
    };

    /**
     * Close the dialog
     */
    $scope.closeDialog =function () {
        $mdDialog.cancel();
    };


    /**
     * Set Table option
     * @type {any}
     */
    $scope.dtOptions = DTOptionsBuilder
        .newOptions()
        .withLanguage(dtOptions.language)
        .withDOM('lfrtp')
        .withOption('bFilter', false)
        .withDOM('lrtip');


}]);

angular.module('app.pages.events').controller('NewEventSuggestionController', NewEventSuggestionController);

function NewEventSuggestionController($scope, $rootScope, $mdDialog, event, eventsEndpoint, Notification) {


    $scope.suggestedEvent = {};
    $scope.events = false;


    $scope.init = function () {
        var objectsSearch = {
            Status: 1,
            DateStatus: 1,
            ExcludedEvent: event.ID,
            IsProduct: 0
        }
        $scope.events = [];
        //get events
        eventsEndpoint.get(objectsSearch, function (data) {
            $scope.events = $scope.events.concat(data)
            if ($scope.events.length === 0) {
                Notification.error('אין ' + $rootScope.User.Events + '/מוצרים שניתן להוסיף');
                $mdDialog.hide();
            }
        });
        objectsSearch.DateStatus = 0;
        objectsSearch.IsProduct = 1;
        eventsEndpoint.get(objectsSearch, function (data) {
            $scope.events = $scope.events.concat(data)
            if ($scope.events.length === 0) {
                Notification.error('אין ' + $rootScope.User.Events + '/מוצרים שניתן להוסיף');
                $mdDialog.hide();
            }
        });
    }

    $scope.saveNewEventSuggestion = function () {
        var suggestion = {
            SuggestedEventID: $scope.suggestedEvent.ID,
            MasterEventID: event.ID,
            Status: 1
        };
        eventsEndpoint.suggestions.create(suggestion, function (data) {
            if (data.success)
                Notification.success('הצעה נוצרה בהצלחה');
            else
                Notification.success('הצעה כבר קיימת');

            $mdDialog.hide();
        })
    };

    $scope.log = function () {
        console.log($scope.suggestedEvent);
    }

    /**
     * Close the dialog
     */
    $scope.closeDialog = function () {
        $mdDialog.cancel();
    };

}

angular.module('app.pages.events').controller('SendHealthDeclarationDialogController', SendHealthDeclarationDialogController);
function SendHealthDeclarationDialogController($scope, $mdDialog,eventID,eventsEndpoint,Notification) {

    $scope.request;

    $scope.sendHealthDeclarations = function (){
        $scope.isClicked = true;
        eventsEndpoint.healthDeclarations.send(eventID,$scope.request,function (data){
            if(data.success){
                Notification.success('הצהרת בריאות נשלחה ל'+data.count+' נמענים');
            } else{
                Notification.error('התרחשה שגיאה');
            }
            $scope.isClicked = false;
            $scope.closeDialog();
        })
    }

    /**
     * Close the dialog
     */
    $scope.closeDialog = function () {
        $mdDialog.cancel();
    };


}

angular.module('app.pages.events').controller('NewRegistrationDialogController', NewRegistrationDialogController);

function NewRegistrationDialogController($scope, $rootScope, privateIDCheck, $timeout, $mdDialog, studentsEndpoint, student, $location, Notification, event, eventsEndpoint, tranzilaEndpoint, $sce, appConfig, pelecardEndpoint, settingsEndpoint, $interval, branchesEndpoint, gradesEndpoint, groupsEndpoint, Upload) {


    $scope.quesitons = true;
    $scope.newRegistration = {};
    $scope.selectedTransportation = {};
    $scope.payments = [];
    $scope.numOfPayments = 1;
    $scope.checks = [];
    $scope.parents = [];
    $scope.restrictDialogClose = false;

    function getEmptyPayment() {
        return {
            Type: '',
            Amount: '',
            AccountName: '',
            BankNumber: '',
            BranchNumber: '',
            AccountNumber: '',
            fileReceipt: '',
            fileName: '',
            BrandAccountNumber: '',
            CheckOwner: '',
            NumberOfCheck: '',
            checks: [],
            PaymentStatus: 1,
            iframe: '',
            Name: '',
            Email: '',
            parent: '',
            DealID: '',
            ReceiptID: '',
            interval: false,
        }
    }

    $scope.addPayment = function (amount) {
        var payment = getEmptyPayment();
        payment.Amount = amount;
        $scope.payments.push(payment);
    };

    $scope.removePayment = function (index) {
        var amount = $scope.payments[index].Amount;
        $scope.payments.splice(index, 1);
        $scope.payments[$scope.payments.length -1].Amount += amount;
    };

    $scope.getParents = function(){
        studentsEndpoint.parent.get($scope.newRegistration.StudentID, function (data) {
           $scope.parents = data;
        });
    };

    $scope.addPaymentMissingPrice = function(){
        var sum = 0;
        for (var i = 0; i < $scope.payments.length; i++)
            sum += $scope.payments[i].Amount;
        var newAmount = $scope.event.NewPrice!= undefined ? $scope.event.NewPrice : $scope.event.Price;
        newAmount -= sum;
        $scope.addPayment(newAmount);
    };

    $scope.setParent = function(index){
      $scope.payments[index].Name = $scope.payments[index].parent.Name;
      $scope.payments[index].Email = $scope.payments[index].parent.Email;
    };

    $scope.checkNameAndEmail = function (index){
        return !!$scope.payments[index].Name && !! $scope.payments[index].Email;
    }

    $scope.savePayment = function(index){
        $scope.payments[index].ReceiptID = 'saved';
    };

    /**
     * Save new Student
     */
    $scope.getStudent = function () {
        if (!$scope.newRegistration.PrivateID || (!$scope.tz && $scope.newRegistration.PrivateID.length < 7))
            return;
        $scope.isClicked = true;
        $scope.questionsDisable = true;
        $scope.transportationDisable = true;
        $scope.getTransportation();
        studentsEndpoint.studentPrivateID.get($scope.newRegistration, function (data) {
            $scope.isClicked = false;
            $scope.new = false;
            $scope.hide = false;
            $scope.notExist = false;
            if (data.ID) {
                $scope.student = data;
                $scope.newRegistration.FirstName = data.FirstName;
                $scope.newRegistration.LastName = data.LastName;
                $scope.newRegistration.StudentID = data.ID;
                $scope.notExist = false;
                $scope.studentBranchID = data.BranchID;
                studentsEndpoint.registrations.isRegistered($scope.student.ID,event.selectedEvent.ID,function(data){
                    if(data.success){
                        if(data.result){
                            Notification.error("חניך זה כבר רשום לאירוע זה");
                            $mdDialog.hide();
                        }
                    } else {
                        Notification.error("אירעה תקלה");
                    }
                })
                $scope.getQuestions();
                $scope.getPriceForStudent();
            } else {
                Notification.info("תעודת זהות לא קיימת במערכת");
                $scope.notExist = true;
            }
        })
    };

    $scope.getQuestions = function () {
        eventsEndpoint.questions.get({BranchID: $scope.studentBranchID}, event.selectedEvent, function (data) {
            $scope.quesitons = data;
            if ($scope.quesitons.length == 0)
                $scope.questionsDisable = false;
            else
                for (var i = 0; i < $scope.quesitons.length; i++) {
                    if ($scope.quesitons[i]['AnswerType'] == 2) {
                        $scope.quesitons[i]['Options'] = $scope.quesitons[i]['Options'].split(",");
                    }
                }
        })
    };

    $scope.getTransportation = function () {
        eventsEndpoint.transportation.get(event.selectedEvent, function (data) {
            $scope.transportation = data.filter(function(e){
                return e.Status == 1;
            });
            if ($scope.transportation.length == 0)
                $scope.transportationDisable = false;
        })
    };

    $scope.newStudent = function () {
        $scope.new = true;
        $scope.hide = true;
        var params = {};
        params.status = 1;
        branchesEndpoint.get(params, function (data) {
            $scope.branches = data;

        });
        gradesEndpoint.get(params, function (data) {
            $scope.grades = data;
        })
    };

    /**
     * Update Questions
     * @param question
     */
    $scope.updateOptionFile = function (question) {
        var file = document.getElementById(question.ID);
        file = file.files[0];
        var params = new FormData();
        question.filename = new Date().getTime() + "_" + file.name;
        params.append("files", file, question.filename);
        params.append("brand", $rootScope.brandName);
        params.append("upload_file", 'true');

        var uploadURL = '';
        if (location.hostname === "localhost" || location.hostname === "127.0.0.1")
            uploadURL = appConfig.localHostUrl + '/upload/files';
        else if (location.host === appConfig.locationHost)
            uploadURL = appConfig.developmentHostUrl + '/upload/files';
        else
            uploadURL = appConfig.serverUrl + '/upload/files';

        $http.post(uploadURL, params, {
            headers: {
                'Content-Type': 'multipart/form-data',
                'Accept': 'application/json',
                'Authorization' : 'Bearer ' + $rootScope.User.AccessToken
            },
            withCredentials: true
        }).then(function (data) {
            question.Answer = data.Path;
        });

    };

    $scope.updateQuestions = function () {
        $scope.questionsDisable = false;
        $timeout(function () {
            $scope.selectedTab = 2;

        }, 150);
    };

    $scope.updateTransportations = function () {
        $scope.transportationDisable = false;
        $scope.selectedTab = 3;
    };

    /**
     * Get all branches groups
     */
    $scope.getGroupsByBranch = function () {
        var params = {};
        params.status = 1;
        params.BranchID = $scope.newRegistration.BranchID;
        params.GradeID = $scope.newRegistration.GradeID;
        groupsEndpoint.get(params, function (data) {
            $scope.groups = data;
        })
    };

    /**
     * Get Price for event by student
     */
    $scope.getPriceForStudent = function () {
        var params = {};
        $scope.student.SelectedEvents = [];
        $scope.student.SelectedEvents.push(event.selectedEvent);
        params.Students = [];
        params.Students.push(angular.copy($scope.student));
        params.Students = JSON.stringify(params.Students);
        eventsEndpoint.price.get(params, function (data) {
            if (data.success === false) {
                Notification.error("לא ניתן לרשום חניך זה ל" + $rootScope.User.Event);
                $mdDialog.hide();
            } else {
                $scope.items = data.Items;
                $scope.DealID = data.DealID;
                $scope.event = data.Items[0].SelectedEvents[0];
                $scope.KibutzPay = data.Items[0].KibutzPay.KibutzPay;
                $scope.newRegistration.Price = $scope.event.Price;
                $scope.newRegistration.NewPrice = $scope.event.NewPrice;
                $scope.newRegistration.EventID = event.selectedEvent.ID;

                if($scope.event.NewPrice > 0)
                    $scope.addPayment($scope.event.NewPrice!= undefined ? $scope.event.NewPrice : $scope.event.Price);

            }
        })
    };

    /**
     * Save the new Registration
     */
    $scope.saveNewRegistration = function (newReg) {
        $scope.isClicked = true;
        $scope.items[0]['SelectedEvents'][0]['Questions'] = $scope.quesitons;
        $scope.items[0]['SelectedEvents'][0]['Transportation'] = $scope.selectedTransportation;
        $scope.newRegistration.Items = JSON.stringify(angular.copy($scope.items));

        if($scope.payments.length > 0)
            $scope.newRegistration.payments = $scope.payments;
        else {
            $scope.newRegistration.PaymentType = 0;
            if($scope.parents.length)
                $scope.newRegistration.ParentID = $scope.parents[0].ID;
        }

        studentsEndpoint.events.post($scope.newRegistration, function (data) {
            if (data.success)
                Notification.success("הרשמה בוצעה בהצלחה!");
            else
                Notification.error("נכשל בהספת הזמנה.יש לוודא שהחניך משויך לסניף ושכבה ושאינו רשום כבר ל" + $rootScope.User.Event + " זה");
            $scope.isClicked = false;
            clearAllIntervals();
            if (newReg) {
               /* $scope.isClicked = false;
                $scope.new = false;
                $scope.hide = false;
                $scope.notExist = false;
                $scope.newRegistration = {};
                $scope.newRegistration.PaymentStatus = ($rootScope.AdminLevel < 3 && !$rootScope.User.Payments) ? 2 : 1;
                $scope.newRegistration.Status = 1;*/
                /**
                 * Open create Registration Dialog
                 */
                $mdDialog.hide();

                $mdDialog.show({
                    controller: 'NewRegistrationDialogController',
                    templateUrl: 'app/main/pages/events/views/events/event-management/tabs/subscribers/new-registration-dialog/new-registration-dialog.html',
                    clickOutsideToClose: false
                });
            } else
                $mdDialog.hide();
        })
    };

    /**
     * Set pattern
     * @returns {*}
     */
    $scope.pattern = function () {
        if (!$scope.tz)
            return "/^[0-9]{9,9}$/";
        return "";
    };

    /**
     * Looking for changes in the private id
     */
    $scope.$watch('newRegistration.PrivateID', function () {
        $scope.getStudent();
    });

    /**
     * change password to tz
     * @constructor
     */
    $scope.ChangeToPassport = function () {
        $scope.tz = !$scope.tz
    };

    /**
     * Close the dialog
     */
    $scope.closeDialog = function () {
        $mdDialog.cancel();
        clearAllIntervals();
    };

    function clearAllIntervals(){
        for(var i = 0; i < $scope.payments.length; i++)
            clearInterval($scope.payments[i].interval);
    }

    /**
     * Move to payment tab
     */
    $scope.moveToPayments = function () {
        if ($scope.new) {
            if (createNewStudent()) {
                $scope.new = false;
                $scope.selectedTab = 1;
            }
        } else
            $scope.selectedTab = 1;

        $scope.getParents();

    };

    function createNewStudent() {
        if (!$scope.tz)
            if (privateIDCheck.privateIDCheck($scope.newRegistration.PrivateID) === false) {
                Notification.error("תעודות זהות לא תקינה");
                return false;
            }
        if ($scope.newRegistration.Parent1) {
            if (privateIDCheck.privateIDCheck($scope.newRegistration.Parent1) === false) {
                Notification.error("תעודות זהות הורה לא תקינה");
                return false;
            }
        }


        studentsEndpoint.post($scope.newRegistration, function (data) {
            $scope.newRegistration.StudentID = data.ID;
            $scope.student = data;
            $scope.getPriceForStudent();
        });
        return true;
    }

    $scope.uploadFile = function (file) {
        if (!file)
            return;
        $scope.isClicked = true;
        $scope.fileName = file.name;
        var uploadURL = '';
        if (location.hostname === "localhost" || location.hostname === "127.0.0.1")
            uploadURL = appConfig.localHostUrl + '/upload/files?brand=' + $rootScope.brandName;
        else if (location.host === appConfig.locationHost)
            uploadURL = appConfig.developmentHostUrl + '/upload/files?brand=' + $rootScope.brandName;
        else
            uploadURL = appConfig.serverUrl + '/upload/files?brand=' + $rootScope.brandName;

        Upload.upload({
            url: uploadURL,
            data: {file: file, 'accessToken': $rootScope.User.AccessToken}
        }).then(function (resp) {
            $scope.newRegistration.fileReceipt = resp.data.Path;
            $scope.isClicked = false;

        }, function (resp) {
            console.log('Error status: ' + resp.status);
        }, function (evt) {
            var progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
            console.log('progress: ' + progressPercentage);
        });

    };


    /**************************Credit Card payment****************************/
    $scope.trustSrc = function (src) {
        return $sce.trustAsResourceUrl(src);
    };

    /**
     * Check the payment type
     */
    $scope.checkIfNoCharge = function (index) {
        var payment = $scope.payments[index];
        if (payment.Type == 3) {
            settingsEndpoint.accountancy.banks.get(function (data) {
                $scope.banks = data;
            })
        } else {
            if (!$scope.copy)
                $scope.copy = angular.copy($scope.event.Price);
            if (payment.Type == 0)
                $scope.event.Price = 0;
            else
                $scope.event.Price = $scope.copy;
            if (payment.Type == 1) {
                $scope.getIframe(payment);
                if(payment.interval)
                    $interval.cancel(payment.interval);
                payment.interval = $interval(function () {
                    if (!params) {
                        var params = {};
                        params.DealID = payment.DealID;
                    }
                    if ($scope.success) {
                        $interval.cancel(payment.interval);
                        return;
                    }
                    if (appConfig.paymentyCompany == 1) {
                        tranzilaEndpoint.valid.post(params, function (data) {
                            if (data) {
                                if (data.success) {
                                    Notification.success("עסקה בוצעה בהצלחה!");
                                    $scope.success = true;
                                    payment.ReceiptID = data['receiptID'];
                                    $interval.cancel(payment.interval);
                                    $scope.restrictDialogClose = true;
                                    payment.iframe = false;
                                } else {
                                    Notification.error("שגיאה")
                                }
                                $scope.success = true;
                                //$mdDialog.hide();
                                $interval.cancel(payment.interval);
                            }

                        })
                    } else {
                        pelecardEndpoint.valid.post(params, function (data) {
                            if (data) {
                                if (data.success) {
                                    Notification.success("עסקה בוצעה בהצלחה!");
                                    $scope.success = true;
                                    payment.ReceiptID = data['receiptID'];
                                    $interval.cancel(payment.interval);
                                    $scope.restrictDialogClose = true;
                                    payment.iframe = false;
                                } else {
                                    Notification.error("שגיאה")
                                }
                                $scope.success = true;
                                //$mdDialog.hide();
                                $interval.cancel(payment.interval);
                            }

                        })
                    }

                }, 4000);
            } else if (payment.interval)
                $interval.cancel(payment.interval);
        }

        if (payment.Type === 4) {
            payment.checks = [];
        }
    };

    /**
     * Get pelecrd iframe
     */
    $scope.getIframe = function (payment) {
        $scope.items[0]['SelectedEvents'][0]['Questions'] = $scope.quesitons;
        $scope.items[0]['SelectedEvents'][0]['Transportation'] = $scope.selectedTransportation;
        var items = JSON.stringify(angular.copy($scope.items));
        var params = {};
        params.Total = $scope.event.NewPrice != undefined ? $scope.event.NewPrice : $scope.event.Price;
        params.Payments = $scope.event.MaxPayments;
        params.DealID = $scope.DealID;
        params.Amount = payment.Amount;
        params.Items = items;
        params.Name = payment.Name;
        params.Email = payment.Email;
        if (appConfig.paymentyCompany == 1)
            tranzilaEndpoint.get(params, function (data) {
                payment.iframe = data.Iframe;
                payment.DealID = data.DealID;
            });
        else
            pelecardEndpoint.get(params, function (data) {
                payment.iframe = data.Iframe;
                payment.DealID = data.DealID;
            });

    };

    $scope.generateChecks = function (index) {
        $scope.payments[index].checks = [];
        for (var i = 0; i < $scope.payments[index].NumberOfCheck; i++) {
            $scope.payments[index].checks.push({
                CheckNumber: '',
                CheckMaturityDate: '',
                CheckAmount: '',
            });
        }
    };

    $scope.paymentsValidity = function () {
        if(! $scope.event)
            return false;
        var totalSum = 0;
        for(var i = 0; i < $scope.payments.length; i++){
            var priceToCharge = $scope.payments[i].Amount;
            totalSum += priceToCharge;
            if($scope.payments[i].ReceiptID == '')
                return false;
            if ($scope.payments[i].checks.length === 0)
                continue;

            for (var j = 0,sum = 0; j < $scope.payments[i].checks.length; j++) {
                sum += $scope.payments[i].checks[j].CheckAmount;
            }
            if(sum !== priceToCharge){
                return  false;
            }
        }

        return $scope.getTotalAmountsValidity();
    };

    $scope.getTotalAmountsValidity = function(){
        if(!$scope.event)
            return false;
        var totalPrice = $scope.event.NewPrice != undefined ? $scope.event.NewPrice : $scope.event.Price;
        var sum = 0;
        for (var i = 0; i < $scope.payments.length; i++) {
            if($scope.payments[i].Type != 1 ||($scope.payments[i].Type == 1 && $scope.payments[i].ReceiptID != ''))
                sum += $scope.payments[i].Amount;
        }
        return sum === totalPrice;
    }

    $scope.checkChecksValidity = function (payment) {
        if(payment.Type != 4)
            return true;
        var tmp = 0;
        payment.checks.forEach(function (check) {
            tmp += check.CheckAmount;
        });
        return tmp == payment.Amount;
    }
}

angular.module('app.pages.events').controller('SelectRegistrationDialogController', SelectRegistrationDialogController);
function SelectRegistrationDialogController($scope, $mdDialog,$rootScope,registration ) {


    $scope.registrations = registration.Registrations;
    $scope.registration;

    /**
     * Show full Registration
     * @param registration
     */
    $scope.showFullRegistration = function () {
        $mdDialog.show({
            controller: 'FullRegistrationDialogController',
            templateUrl: 'app/main/pages/events-dialogs/full-registration-dialog/full-registration-dialog.html',
            clickOutsideToClose: true,
            locals: {'registration': $scope.registration}
        });
    };

    /**
     * Close the dialog
     */
    $scope.closeDialog = function () {
        $mdDialog.cancel();
    };

}

angular.module('app.pages.events').controller('CrateKibutzPDFDialogController', CrateKibutzPDFDialogController);
function CrateKibutzPDFDialogController($scope, $mdDialog,coordinatorsEndpoint,event,$rootScope,appConfig,rolesEndpoint,$timeout ) {


    $scope.event = event;
    $scope.report= {};
    $scope.report.cites =[];
    $scope.states = loadAll();
    $scope.querySearch =querySearch;

    /**
     * Get Coordinators
     */
    $scope.getCoordinators = function () {
        rolesEndpoint.get([],function (data) {
            $scope.roles = data;
        });
        var params = {};
        params.Status = 1;
        coordinatorsEndpoint.get(params, function (data) {
            $scope.coordinatorsArray = data;
        })
    };

    $scope.setCoordinator = function(role) {
        if(role == 'all'){
            $scope.coordinators = $scope.coordinatorsArray;
        }else{
            $scope.coordinators= [];
            for (var i =0 ; i<$scope.coordinatorsArray.length;i++) {
                if ($scope.coordinatorsArray[i].Role==role)
                    $scope.coordinators.push($scope.coordinatorsArray[i]);
            }
        }
    }

    /**
     * CreatePDF
     */
    $scope.createPDF = function () {
        var path = "/events/"+event.ID+"/report/kibutz/"+$scope.report.CoordinatorID;
        var city  = $scope.report.cites.map(function(a) {return a.value;});
        path=path+"?brand=" +$rootScope.brandName + "&City="+JSON.stringify(city);
        if (location.hostname === "localhost" || location.hostname === "127.0.0.1")
        //  path = appConfig.localHostUrl+path;
            path = appConfig.developmentHostUrl + path;
        else if (location.host === appConfig.locationHost)
            path = appConfig.developmentHostUrl+path;
        else
            path = appConfig.serverUrl+path;

        path=path+"&accessToken=" +$rootScope.User.AccessToken;
        window.open(path, '_blank');

    };

    $scope.setCity = function (city) {
        $scope.City = city.value
    };

    /**
     * Search for states... use $timeout to simulate
     * remote dataservice call.
     */
     $scope.querySearch = function(query) {
        var results = query ? $scope.states.filter(createFilterFor(query)) : $scope.states,
            deferred;
        if ($scope.simulateQuery) {
            deferred = $q.defer();
            $timeout(function () {
                deferred.resolve(results);
            }, Math.random() * 1000, false);
            return deferred.promise;
        } else {
            return results;
        }
    }

    /**
     * Close the dialog
     */
    $scope.closeDialog = function () {
        $mdDialog.cancel();
    };

    /**
     * Search for states... use $timeout to simulate
     * remote dataservice call.
     */
    function querySearch (query) {
        var results = query ? $scope.states.filter( createFilterFor(query) ) : $scope.states,
            deferred;
        if ($scope.simulateQuery) {
            deferred = $q.defer();
            $timeout(function () { deferred.resolve( results ); }, Math.random() * 1000, false);
            return deferred.promise;
        } else {
            return results;
        }
    }

    /**
     * Branches query search
     * @param query
     * @returns {Array}
     */
    $scope.cityQuerySearch = function (query){
        var results = query ? $scope.states.filter(createFilterFor(query)) : [];
       // var  result = results.map(function(a) {return a.value;});
        return results;
    };


    /**
     * Create filter function for a query string
     */
    function createFilterFor(query) {
        var lowercaseQuery = angular.lowercase(query);

        return function filterFn(state) {
            return (state.value.indexOf(lowercaseQuery) === 0);
        };

    }

    /**
     * Build `states` list of key/value pairs
     */
    function loadAll() {

        var allStates = 'אבו גוש,אבו סנאן,אבו קורינאת (יישוב),אבו תלול,אבטין,אבטליון,אביאל,אביבים,אביגדור,אביחיל,\n' +
            'אביטל,אביעזר,אבירים,אבן יהודה,אבן מנחם,אבן ספיר,אבן שמואל,אבני איתן,אבני חפץ,אבנת,\n' +
            'אבשלום,אדורה,אדירים,אדמית,אדרת,אודים,אודם,אוהד,אום אל-פחם,אום אל-קוטוף,\n' +
            'אום בטין,אומן,אומץ,אופקים,אור הגנוז,אור הנר,אור יהודה,אור עקיבא,אורה,אורות,\n' +
            'אורטל,אורים,אורנים,אורנית,אושה,אזור,אחווה,אחוזם,אחוזת ברק,אחיהוד,\n' +
            'אחיטוב,אחיסמך,אחיעזר,איבים,אייל,איילת השחר,אילון,אילות,אילנייה,אילת,\n' +
            'אירוס,איתמר,איתן,איתנים,אכסאל,אל -עזי,אל -עריאן,אל -רום,אל סייד,אלומה,\n' +
            'אלומות,אלון הגליל,אלון מורה,אלון שבות,אלוני אבא,אלוני הבשן,אלוני יצחק,אלונים,אלי-עד,אליאב,\n' +
            'אליכין,אליפז,אליפלט,אליקים,אלישיב,אלישמע,אלמגור,אלמוג,אלעד,אלעזר,\n' +
            'אלפי מנשה,אלקוש,אלקנה,אמונים,אמירים,אמנון,אמציה,אניעם,אספר,אעבלין,\n' +
            'אפיק,אפיקים,אפק,אפרת,ארבל,ארגמן,ארז,אריאל,ארסוף,אשבול,\n' +
            'אשבל,אשדוד,אשדות יעקב (איחוד),אשדות יעקב (מאוחד),אשחר,אשכולות,אשל הנשיא,אשלים,אשקלון,אשרת,\n' +
            'אשתאול,באקה אל-גרביה,באר אורה,באר גנים,באר טוביה,באר יעקב,באר מילכה,באר שבע,בארות יצחק,בארותיים,\n' +
            'בארי,בוסתן הגליל,בועיינה-נוג\'ידאת,בוקעאתא,בורגתה,בחן,בטחה,ביצרון,ביר אל-מכסור,ביר הדאג\',\n' +
            'בירייה,בית אורן,בית אל,בית אלעזרי,בית אלפא,בית אריה,בית ברל,בית ג\'ן,בית גוברין,בית גמליאל,\n' +
            'בית דגן,בית הגדי,בית הלוי,בית הלל,בית העמק,בית הערבה,בית השיטה,בית זיד,בית זית,בית זרע,\n' +
            'בית חורון,בית חירות,בית חלקיה,בית חנן,בית חנניה,בית חשמונאי,בית יהושע,בית יוסף,בית ינאי,בית יצחק-שער חפר,\n' +
            'בית לחם הגלילית,בית מאיר,בית נחמיה,בית ניר,בית נקופה,בית עובד,בית עוזיאל,בית עזרא,בית עריף,בית צבי,\n' +
            'בית קמה,בית קשת,בית רבן,בית רימון,בית שאן,בית שמש,בית שערים,בית שקמה,ביתן אהרן,ביתר עילית,\n' +
            'בלפוריה,בן זכאי,בן עמי,בן שמן (כפר נוער),בן שמן (מושב),בני ברק,בני דקלים,בני דרום,בני דרור,בני יהודה,\n' +
            'בני נצרים,בני עטרות,בני עי"ש,בני ציון,בני ראם,בניה,בנימינה-גבעת עדה*,בסמ"ה,בסמת טבעון,בענה,\n' +
            'בצרה,בצת,בקוע,בקעות,בר גיורא,בר יוחאי,ברוכין,ברור חיל,ברוש,ברכה,\n' +
            'ברכיה,ברעם,ברק,ברקאי,ברקן,ברקת,בת הדר,בת חן,בת חפר,בת ים,\n' +
            'בת עין,בת שלמה,ג\'דיידה-מכר,ג\'ולס,ג\'לג\'וליה,ג\'סר א-זרקא,ג\'ש (גוש חלב),ג\'ת,גאולי תימן,גאולים,\n' +
            'גאליה,גבולות,גבים,גבע,גבע בנימין,גבע כרמל,גבעולים,גבעון החדשה,גבעות בר,גבעת אבני,\n' +
            'גבעת אלה,גבעת ברנר,גבעת השלושה,גבעת זאב,גבעת ח"ן,גבעת חיים (איחוד),גבעת חיים (מאוחד),גבעת יואב,גבעת יערים,גבעת ישעיהו,\n' +
            'גבעת כ"ח,גבעת ניל"י,גבעת עוז,גבעת שמואל,גבעת שמש,גבעת שפירא,גבעתי,גבעתיים,גברעם,גבת,\n' +
            'גדות,גדיש,גדעונה,גדרה,גונן,גורן,גורנות הגליל,גזית,גזר,גיאה,\n' +
            'גיבתון,גיזו,גילון,גילת,גינוסר,גיניגר,גינתון,גיתה,גיתית,גלאון,\n' +
            'גלגל,גליל ים,גלעד (אבן יצחק),גמזו,גן הדרום,גן השומרון,גן חיים,גן יאשיה,גן יבנה,גן נר,\n' +
            'גן שורק,גן שלמה,גן שמואל,גנות,גנות הדר,גני הדר,גני טל,גני יוחנן,גני עם,גני תקווה,\n' +
            'געש,געתון,גפן,גרופית,גשור,גשר,גשר הזיו,גת (קיבוץ),גת רימון,דאלית אל-כרמל,\n' +
            'דבורה,דבורייה,דבירה,דברת,דגניה א\',דגניה ב\',דוב"ב,דולב,דור,דורות,\n' +
            'דחי,דייר אל-אסד,דייר חנא,דייר ראפאת,דימונה,דישון,דלייה,דלתון,דמיידה,דן,\n' +
            'דפנה,דקל,דריג\'את,האון,הבונים,הגושרים,הדר עם,הוד השרון,הודיות,הודייה,\n' +
            'הושעיה,הזורע,הזורעים,החותרים,היוגב,הילה,המעפיל,הסוללים,העוגן,הר אדר,\n' +
            'הר גילה,הר עמשא,הראל,הרדוף,הרצלייה,הררית,ורד יריחו,ורדון,זבדיאל,זוהר,\n' +
            'זיקים,זיתן,זכרון יעקב,זכריה,זמר,זמרת,זנוח,זרועה,זרזיר,זרחיה,\n' +
            'ח\'ואלד,חבצלת השרון,חבר,חגור,חגי,חגלה,חד-נס,חדיד,חדרה,חוג\'ייראת (ד\'הרה) (שבט),\n' +
            'חולדה,חולון,חולית,חולתה,חוסן,חוסנייה,חופית,חוקוק,חורה,חורפיש,\n' +
            'חורשים,חזון,חיבת ציון,חיננית,חיפה,חירות,חלוץ,חלמיש,חלץ,חמאם,\n' +
            'חמד,חמדיה,חמדת,חמרה,חניאל,חניתה,חנתון,חספין,חפץ חיים,חפצי-בה,\n' +
            'חצב,חצבה,חצור הגלילית,חצור-אשדוד,חצרים,חרב לאת,חרוצים,חריש,חרמש,חרשים,\n' +
            'חשמונאים,טבריה,טובא-זנגרייה,טורעאן,טייבה,טייבה (בעמק),טירה,טירת יהודה,טירת כרמל,טירת צבי,\n' +
            'טל שחר,טל-אל,טללים,טלמון,טמרה,טמרה (יזרעאל),טנא,טפחות,יאנוח-ג\'ת,יבול,\n' +
            'יבנאל,יבנה,יגור,יגל,יד בנימין,יד השמונה,יד חנה,יד מרדכי,יד נתן,יד רמב"ם,\n' +
            'ידידה,יהוד,יהל,יובל,יובלים,יודפת,יונתן,יושיביה,יזרעאל,יחיעם,\n' +
            'יטבתה,ייט"ב,יכיני,ינוב,ינון,יסוד המעלה,יסודות,יסעור,יעד,יעל,\n' +
            'יעף,יערה,יפיע,יפית,יפעת,יפתח,יצהר,יציץ,יקום,יקיר,\n' +
            'יקנעם (מושבה),יקנעם עילית,יראון,ירדנה,ירוחם,ירושלים,ירחיב,ירכא,ירקונה,ישע,\n' +
            'ישעי,ישרש,יתד,כאבול,כאוכב אבו אל-היג\'א,כברי,כדורי,כדיתה,כוכב השחר,כוכב יאיר,\n' +
            'כוכב יעקב,כוכב מיכאל,כורזים,כחל,כחלה,כיסופים,כישור,כליל,כלנית,כמאנה,\n' +
            'כמהין,כמון,כנות,כנף,כנרת (מושבה),כנרת (קבוצה),כסיפה,כסלון,כסרא-סמיע,כעביה-טבאש-חג\'אג\'רה,\n' +
            'כפר אביב,כפר אדומים,כפר אוריה,כפר אחים,כפר ביאליק,כפר ביל"ו,כפר בלום,כפר בן נון,כפר ברא,כפר ברוך,\n' +
            'כפר גדעון,כפר גלים,כפר גליקסון,כפר גלעדי,כפר דניאל,כפר האורנים,כפר החורש,כפר המכבי,כפר הנגיד,כפר הנוער הדתי,\n' +
            'כפר הנשיא,כפר הס,כפר הרא"ה,כפר הרי"ף,כפר ויתקין,כפר ורבורג,כפר ורדים,כפר זוהרים,כפר זיתים,כפר חב"ד,\n' +
            'כפר חושן,כפר חיטים,כפר חיים,כפר חנניה,כפר חסידים א\',כפר חסידים ב\',כפר חרוב,כפר טרומן,כפר יאסיף,כפר ידידיה,\n' +
            'כפר יהושע,כפר יונה,כפר יחזקאל,כפר יעבץ,כפר כמא,כפר כנא,כפר מונש,כפר מימון,כפר מל"ל,כפר מנדא,\n' +
            'כפר מנחם,כפר מסריק,כפר מצר,כפר מרדכי,כפר נטר,כפר סאלד,כפר סבא,כפר סילבר,כפר סירקין,כפר עבודה,\n' +
            'כפר עזה,כפר עציון,כפר פינס,כפר קאסם,כפר קיש,כפר קרע,כפר ראש הנקרה,כפר רוזנואלד (זרעית),כפר רופין,כפר רות,\n' +
            'כפר שמאי,כפר שמואל,כפר שמריהו,כפר תבור,כפר תפוח,כרכום,כרם בן זמרה,כרם בן שמן,כרם יבנה (ישיבה),כרם מהר"ל,\n' +
            'כרם שלום,כרמי יוסף,כרמי צור,כרמיאל,כרמית,כרמייה,כרמים,כרמל,לבון,לביא,לבנים,\n' +
            'להב,להבות הבשן,להבות חביבה,להבים,לוד,לוזית,לוחמי הגיטאות,לוטם,לוטן,לימן,\n' +
            'לכיש,לפיד,לפידות,לקיה,מאור,מאיר שפיה,מבוא ביתר,מבוא דותן,מבוא חורון,מבוא חמה,\n' +
            'מבוא מודיעים,מבואות ים,מבועים,מבטחים,מבקיעים,מבשרת ציון,מג\'ד אל-כרום,מג\'דל שמס,מגאר,מגדים,\n' +
            'מגדל,מגדל העמק,מגדל עוז,מגדלים,מגידו,מגל,מגן,מגן שאול,מגשימים,מדרך עוז,\n' +
            'מדרשת בן גוריון,מדרשת רופין,מודיעין עילית,מודיעין-מכבים-רעות*,מולדה*,מולדת,מוצא עילית,מוקייבלה,מורן,מורשת,\n' +
            'מזור,מזכרת בתיה,מזרע,מזרעה,מחולה,מחנה הילה*,מחנה טלי*,מחנה יהודית*,מחנה יוכבד*,מחנה יפה*,\n' +
            'מחנה מרים*,מחנה תל נוף*,מחניים,מחסיה,מטולה,מטע,מי עמי,מיטב,מייסר,מיצר,\n' +
            'מירב,מירון,מישר,מיתר,מכורה,מכחול,מכמורת,מכמנים,מלאה,מלילות,\n' +
            'מלכייה,מלכישוע,מנוחה,מנוף,מנות,מנחמיה,מנרה,מנשית זבדה,מסד,מסדה,\n' +
            'מסילות,מסילת ציון,מסלול,מסעדה,מעברות,מעגלים,מעגן,מעגן מיכאל,מעוז חיים,מעון,\n' +
            'מעונה,מעיין ברוך,מעיין צבי,מעיליא,מעלה אדומים,מעלה אפרים,מעלה גלבוע,מעלה גמלא,מעלה החמישה,מעלה לבונה,\n' +
            'מעלה מכמש,מעלה עירון,מעלה עמוס,מעלה שומרון,מעלות-תרשיחא,מענית,מעש,מפלסים,מצדות יהודה,מצובה,\n' +
            'מצליח,מצפה,מצפה אבי"ב,מצפה אילן,מצפה יריחו,מצפה נטופה,מצפה רמון,מצפה שלם,מצר,מרגליות,\n' +
            'מרום גולן,מרחב עם,מרחביה (מושב),מרחביה (קיבוץ),מרכז שפירא,משאבי שדה,משגב דב,משגב עם,משהד,משואה,\n' +
            'משואות יצחק,משכיות,משמר איילון,משמר דוד,משמר הירדן,משמר הנגב,משמר העמק,משמר השבעה,משמר השרון,משמרות,\n' +
            'משמרת,משען,מתן,מתת,מתתיהו,נאות גולן,נאות הכיכר,נאות מרדכי,נאות סמדר,נאעורה,\n' +
            'נבטים,נגבה,נגוהות,נהורה,נהלל,נהרייה,נוב,נוגה,נווה,נווה אור,\n' +
            'נווה אטי"ב,נווה אילן,נווה איתן,נווה דניאל,נווה זוהר,נווה זיו,נווה חריף,נווה ים,נווה ימין,נווה ירק,\n' +
            'נווה מבטח,נווה מיכאל,נווה שלום,נועם,נוף איילון,נופים,נופית,נופך,נוקדים,נורדייה,\n' +
            'נורית,נחושה,נחל עוז,נחלה,נחליאל,נחלים,נחם,נחף,נחשולים,נחשון,\n' +
            'נחשונים,נטועה,נטור,נטע,נטעים,נטף,ניין,ניל"י,ניצן,ניצן ב\',\n' +
            'ניצנה (קהילת חינוך),ניצני סיני,ניצני עוז,ניצנים,ניר אליהו,ניר בנים,ניר גלים,ניר דוד (תל עמל),ניר ח"ן,ניר יפה,\n' +
            'ניר יצחק,ניר ישראל,ניר משה,ניר עוז,ניר עם,ניר עציון,ניר עקיבא,ניר צבי,נירים,נירית,\n' +
            'נירן,נס הרים,נס עמים,נס ציונה,נעורים,נעלה,נעמ"ה,נען,נצר חזני,נצר סרני,\n' +
            'נצרת,נצרת עילית,נשר,נתיב הגדוד,נתיב הל"ה,נתיב העשרה,נתיב השיירה,נתיבות,נתניה,סאג\'ור,\n' +
            'סאסא,סביון*,סגולה,סואעד (חמרייה)*,סולם,סוסיה,סופה,סח\'נין,סלמה,סלעית,\n' +
            'סמר,סנסנה,סעד,סער,ספיר,סתרייה,ע\'ג\'ר,עבדון,עברון,עגור,\n' +
            'עדי,עדנים,עוזה,עוזייר,עולש,עומר,עופר,עוצם,עזוז,עזר,\n' +
            'עזריאל,עזריה,עזריקם,עטרת,עידן,עיילבון,עיינות,עילוט,עין איילה,עין אל-אסד,\n' +
            'עין גב,עין גדי,עין דור,עין הבשור,עין הוד,עין החורש,עין המפרץ,עין הנצי"ב,עין העמק,עין השופט,\n' +
            'עין השלושה,עין ורד,עין זיוון,עין חוד,עין חצבה,עין חרוד (איחוד),עין חרוד (מאוחד),עין יהב,עין יעקב,עין כרם-בי"ס חקלאי,\n' +
            'עין כרמל,עין מאהל,עין נקובא,עין עירון,עין צורים,עין קנייא,עין ראפה,עין שמר,עין שריד,עין תמר,\n' +
            'עינת,עיר אובות,עכו,עלומים,עלי,עלי זהב,עלמה,עלמון,עמוקה,עמינדב,\n' +
            'עמיעד,עמיעוז,עמיקם,עמיר,עמנואל,עמקה,ענב,עספיא,עפולה,עפרה,\n' +
            'עץ אפרים,עצמון שגב,עראבה,עשהאל,עראמשה*,ערב אל נעים,ערד,ערוגות,ערערה,ערערה-בנגב,עשרת,\n' +
            'עתלית,עתניאל,פארן,פדואל,פדויים,פדיה,פוריידיס,פורייה - כפר עבודה,פורייה - נווה עובד,פורייה עילית,\n' +
            'פורת,פטיש,פלך,פלמחים,פני חבר,פסגות,פסוטה,פעמי תש"ז,פצאל,פקיעין (בוקייעה),\n' +
            'פקיעין חדשה,פרדס חנה-כרכור,פרדסייה,פרוד,פרזון,פרי גן,פתח תקווה,פתחיה,צאלים,צביה,\n' +
            'צבעון,צובה,צוחר,צופייה,צופים,צופית,צופר,צוקי ים,צוקים,צור הדסה,\n' +
            'צור יצחק,צור משה,צור נתן,צוריאל,צורית,ציפורי,צלפון,צנדלה,צפרייה,צפרירים,\n' +
            'צפת,צרופה,צרעה,קבוצת יבנה,קדומים,קדימה-צורן,קדמה,קדמת צבי,קדר,קדרון,\n' +
            'קדרים,קוממיות,קורנית,קטורה,קיסריה,קלחים,קליה,קלנסווה,קלע,קציר,\n' +
            'קצר א-סר,קצרין,קריית אונו,קריית ארבע,קריית אתא,קריית ביאליק,קריית גת,קריית טבעון,קריית ים,קריית יערים,\n' +
            'קריית יערים (מוסד),קריית מוצקין,קריית מלאכי,קריית נטפים,קריית ענבים,קריית עקרון,קריית שלמה,קריית שמונה,קרני שומרון,קשת,\n' +
            'ראמה,ראס אל-עין,ראס עלי,ראש העין,ראש פינה,ראש צורים,ראשון לציון,רבבה,רבדים,רביבים,\n' +
            'רביד,רגבה,רגבים,רהט,רווחה,רוויה,רוח מדבר,רוחמה,רומאנה,רומת הייב,\n' +
            'רועי,רותם,רחוב,רחובות,רחלים,ריחאנייה,ריחן,ריינה,רימונים,רינתיה,\n' +
            'רכסים,רם-און,רמות,רמות השבים,רמות מאיר,רמות מנשה,רמות נפתלי,רמלה,רמת גן,רמת דוד,\n' +
            'רמת הכובש,רמת השופט,רמת השרון,רמת יוחנן,רמת ישי,רמת מגשימים,רמת צבי,רמת רזיאל,רמת רחל,רנן,\n' +
            'רעים,רעננה,רקפת,רשפון,רשפים,רתמים,שאר ישוב,שבי ציון,שבי שומרון,שבלי - אום אל-גנם,\n' +
            'שגב-שלום,שדה אילן,שדה אליהו,שדה אליעזר,שדה בוקר,שדה דוד,שדה ורבורג,שדה יואב,שדה יעקב,שדה יצחק,\n' +
            'שדה משה,שדה נחום,שדה נחמיה,שדה ניצן,שדה עוזיהו,שדה צבי,שדות ים,שדות מיכה,שדי אברהם,שדי חמד,\n' +
            'שדי תרומות,שדמה,שדמות דבורה,שדמות מחולה,שדרות,שואבה,שובה,שובל,שוהם,שומרה,\n' +
            'שומרייה,שוקדה,שורש,שורשים,שושנת העמקים,שזור,שחר,שחרות,שיבולים,שיטים,\n' +
            'שייח\' דנון,שילה,שילת,שכניה,שלווה,שלווה במדבר,שלוחות,שלומי,שלומית,שמיר,\n' +
            'שמעה,שמרת,שמשית,שניר,שעב,שעל,שעלבים,שער אפרים,שער הגולן,שער העמקים,\n' +
            'שער מנשה,שערי תקווה,שפיים,שפיר,שפר,שפרעם,שקד,שקף,שרונה,שריגים (לי-און),\n' +
            'שריד,שרשרת,שתולה,שתולים,תאשור,תדהר,תובל,תומר,תושייה,תימורים,\n' +
            'תירוש,תל אביב -יפו,תל יוסף,תל יצחק,תל מונד,תל עדשים,תל קציר,תל שבע,תל תאומים,תלם,\n' +
            'תלמי אליהו,תלמי אלעזר,תלמי ביל"ו,תלמי יוסף,תלמי יחיאל,תלמי יפה,תלמים,תמרת,תנובות,תעוז,\n' +
            'תפרח,תקומה,תקוע,תרבין א-צאנע (יישוב)*,תרום,';

        return allStates.split(',').map(function (state) {
            return {
                value: state.trim(),
                display: state.trim(),
            };
        });
    }

}

angular.module('app.pages.events').controller('MemberEventEditController',MemberEventEditController );

function MemberEventEditController($scope, $rootScope, $mdDialog,areasEndpoint,gradesEndpoint,event) {

    $scope.event = event;



    /**
     * Save new Event Price
     */
    $scope.save = function () {
            $mdDialog.hide($scope.event);

    };

    /**
     * Close the dialog
     */
    $scope.closeDialog = function () {
        $mdDialog.cancel();
    };

}

angular.module('app.pages.events').controller('EditEventQuestionPanelController',EditEventQuestionPanelController)


function EditEventQuestionPanelController($scope,branch,eventQuestion,$rootScope,branchesEndpoint) {


    var vm = this;
    vm.getBranches =getBranches;
    vm.init = init;

    function init(){
        getBranches();
    }
    /**
     * Set the selected branch
     */
    $scope.$on('selectedEventQuestion:updated', function () {
        vm.question = eventQuestion.selectedEventQuestion;
    });

    /**
     * Look for changes in the branch
     */
    $scope.$watchCollection('vm.question',function (newValue, oldValue) {
        $rootScope.editDataHandler(newValue, oldValue,'edit-event-question-panel')
    });

    function getBranches() {
        branchesEndpoint.get({Status : 1}, function (data) {
            vm.branches =data;
        })
    }
}

angular.module('app.pages.event-management').controller('AddQuestionsToEventController', ['$scope', '$rootScope', '$mdDialog','eventsEndpoint','student','$location','Notification','dtOptions','DTOptionsBuilder','questionsEndpoint','event','branchesEndpoint' ,function ($scope, $rootScope, $mdDialog,eventsEndpoint,student,$location,Notification,dtOptions,DTOptionsBuilder,questionsEndpoint,event,branchesEndpoint) {

    $scope.event = event.selectedEvent;

    $scope.init = function(){
        $scope.getAllQuestions();
        $scope.getAllBranches();

    }

    /**
     * Get all the questions that are not in the event
     */
    $scope.getAllQuestions = function () {
        $scope.newQuestions = false;
        var params = {};
        params.Status = 1;
        questionsEndpoint.get(params,function (data) {
            $scope.newQuestions = data;
        })
    };

    $scope.addQuestionsToEvent = function () {
        var params = {};
        params.QuestionID = [];
        for (var i =0 ; i<$scope.newQuestions.length;i++) {
            if($scope.newQuestions[i].Add)
                params.QuestionID.push($scope.newQuestions[i].ID);
        }
        $scope.isClicked = true;
        params.BranchID = $scope.newQuestions.BranchID;
        eventsEndpoint.questions.add.post($scope.event, params, function (data) {
            $scope.isClicked = false;
            if(!data.success) {
                Notification.error("אחת מהשאלות שנבחרו קיימות עבור ה" + $rootScope.User.Event);
            } else {
                $mdDialog.hide();
            }
        })
    };

    $scope.getAllBranches = function () {
        branchesEndpoint.get({Status : 1},function (data) {
            $scope.branches = data;
        })
    }

    /**
     * Close the dialog
     */
    $scope.closeDialog =function () {
        $mdDialog.cancel();
    };


    /**
     * Set Table option
     * @type {any}
     */
    $scope.dtOptions = DTOptionsBuilder
        .newOptions()
        .withLanguage(dtOptions.language)
        .withDOM('lfrtp')
        .withOption('bFilter', false)
        .withDOM('lrtip');


}]);

angular.module('app.pages.events').controller('NewEventFeeController',NewEventFeeController );

function NewEventFeeController($scope, $rootScope, $mdDialog,event,fees,eventsEndpoint,Notification) {


    $scope.newEventFee = {};

    $scope.init = function(){
        $scope.payments = [];
        var maxPayments = event.MaxPaymemnts? event.MaxPaymemnts : 12;
        var existingFees = fees.map(function (fee) {
            return fee.NumOfPayments;
        })
        for(var i = 1; i< maxPayments+1; i++){
            if(existingFees.indexOf(i) === -1)
                $scope.payments.push(i);
        }
    }

    $scope.saveNewEventFee = function () {
        $scope.newEventFee.EventID = event.ID;
        eventsEndpoint.fees.create($scope.newEventFee,function (data) {
            Notification.success("עמלה נוספה בהצלחה");
            $mdDialog.hide();
        })
    };

    /**
     * Close the dialog
     */
    $scope.closeDialog = function () {
        $mdDialog.cancel();
    };

}

angular.module('app.pages.events').controller('NewGroupPriceController',NewGroupPriceController );

function NewGroupPriceController($scope, $rootScope, $mdDialog,groupsEndpoint,eventID,eventsEndpoint,Notification) {


    $scope.newGroupPrice = {};

    $scope.getGroups= function () {
        var params = {};
        params.status = 1;
        groupsEndpoint.get(params, function (data) {
            $scope.groups = data;
        })
    };

    /**
     * Save new Event Price
     */
    $scope.saveNewGroupPrice = function () {
        $scope.newGroupPrice.EventID = eventID;
        eventsEndpoint.groups.price.post($scope.newGroupPrice,function (data) {
            Notification.success("מחיר נוסף בהצלחה");
            $mdDialog.hide();
        })
    };

    /**
     * Close the dialog
     */
    $scope.closeDialog = function () {
        $mdDialog.cancel();
    };

}

angular.module('app.pages.events').controller('NewBranchPriceController',NewBranchPriceController );

function NewBranchPriceController($scope, $rootScope, $mdDialog,branchesEndpoint,gradesEndpoint,eventID,eventsEndpoint,Notification) {


    $scope.newBranchPrice = {};

    $scope.init = function(){
        $scope.getBranches();
        $scope.getGrades();
    }

    /**
     * Get All Branches And Groups
     */
    $scope.getBranches = function () {
        var params = {};
        params.Status = 1;
        branchesEndpoint.get(params, function (data) {
            $scope.branches = data;
        });
    };

    /**
     * Get Grades
     */
    $scope.getGrades = function () {
        var params = {};
        params.Status = 1;
        gradesEndpoint.get(params, function (data) {
            $scope.grades = data;
        })
    };

    /**
     * Save new Event Price
     */
    $scope.saveNewBranchPrice = function () {
        $scope.newBranchPrice.EventID = eventID;
        eventsEndpoint.branches.price.post($scope.newBranchPrice,function (data) {
            Notification.success("מחיר נוסף בהצלחה");
            $mdDialog.hide();
        })
    };

    /**
     * Close the dialog
     */
    $scope.closeDialog = function () {
        $mdDialog.cancel();
    };

}

angular.module('app.pages.events').controller('NewAreaPriceController',NewAreaPriceController );

function NewAreaPriceController($scope, $rootScope, $mdDialog,areasEndpoint,gradesEndpoint,eventID,eventsEndpoint,Notification) {


    $scope.newAreaPrice = {};

    /**
     * Get All Branches And Groups
     */
    $scope.getAreas = function () {
        var params = {};
        params.Status = 1;
        areasEndpoint.get(params, function (data) {
            $scope.areas = data;
        });
    };

    /**
     * Get Grades
     */
    $scope.getGrades = function () {
        var params = {};
        params.Status = 1;
        gradesEndpoint.get(params, function (data) {
            $scope.grades = data;
        })
    };

    /**
     * Save new Event Price
     */
    $scope.saveNewAreaPrice = function () {
        $scope.newAreaPrice.EventID = eventID;
        eventsEndpoint.areas.price.post($scope.newAreaPrice,function (data) {
            Notification.success("מחיר נוסף בהצלחה");
            $mdDialog.hide();
        })
    };

    /**
     * Close the dialog
     */
    $scope.closeDialog = function () {
        $mdDialog.cancel();
    };

}

angular.module('app.pages.events').controller('NewBranchKibutzPayController',NewBranchKibutzPayController );

function NewBranchKibutzPayController($scope, $rootScope, $mdDialog,branchesEndpoint,gradesEndpoint,eventID,eventsEndpoint,Notification) {


    $scope.newBranchPrice = {};

    $scope.init = function(){
        $scope.getBranches();
    }

    /**
     * Get All Branches And Groups
     */
    $scope.getBranches = function () {
        var params = {};
        params.Status = 1;
        branchesEndpoint.get(params, function (data) {
            $scope.branches = data.filter(function(el){
                return el.KibutzPay === 2;
            });
        });
    };

    /**
     * Save new Event Price
     */
    $scope.saveNewBranchPrice = function () {
        $scope.newBranchPrice.EventID = eventID;
        eventsEndpoint.branches.kibutzPay.post($scope.newBranchPrice,function (data) {
            Notification.success("סניף התווסף בהצלחה");
            $mdDialog.hide();
        })
    };

    /**
     * Close the dialog
     */
    $scope.closeDialog = function () {
        $mdDialog.cancel();
    };

}

angular.module('app.pages.events').controller('NewExternalRegistrationDialogController',NewExternalRegistrationDialogController);

function NewExternalRegistrationDialogController($scope,externalRegistrationEndpoint, $rootScope,privateIDCheck, $mdDialog,studentsEndpoint,student,$location,Notification,event,eventsEndpoint,tranzilaEndpoint,$sce,appConfig,pelecardEndpoint,settingsEndpoint) {



    $scope.newRegistration= {};
    $scope.event = event.selectedEvent;


    /**
     * Save the new Registration
     */
    $scope.saveNewRegistration = function (newReg) {
        $scope.isClicked = true;
        $scope.newRegistration.EventID = $scope.event.ID;
        if ($scope.newRegistration.PaymentType!=1)
            addNewRegistration(newReg);

    };

    /**
     * Add new Reg with payment type no credit card
     * @param newReg
     */
    function addNewRegistration(newReg) {
        externalRegistrationEndpoint.post($scope.newRegistration, function (data) {
            if (data.success)
                Notification.success("הרשמה בוצעה בהצלחה!");
            else
                Notification.error("נכשל ביצירה של הזמנה חדשה");
            $scope.isClicked = false;
            if (newReg) {
                $scope.isClicked = false;
                $scope.new = false;
                $scope.hide = false;
                $scope.notExist =false;
                $scope.newRegistration = {};
                $scope.newRegistration.PaymentStatus =1;
                $scope.newRegistration.Status =1;
            }
            else
                $mdDialog.hide();
        })
    }

    function getIfram(newReg) {
        $scope.isClicked = true;
        $scope.newRegistration.EventID = $scope.event.ID;
        externalRegistrationEndpoint.tranzila.get($scope.newRegistration,function (data) {
            $scope.iframe = data.Iframe;
            $scope.DealID = data.DealID
            setValidTranzila(newReg);
        })
    }

    /**
     * Get Tranzila Valid Respons
     * @param newReg
     */
    function setValidTranzila(newReg) {
        var params = {};
        params.DealID = $scope.DealID;
        externalRegistrationEndpoint.tranzila.valid.post(params, function (data) {
            if (data) {
                if (data.Success) {
                    Notification.success("עסקה בוצעה בהצלחה!");
                    $scope.success = true;
                }
                else {
                    Notification.error("שגיאה")
                }

                if (newReg) {
                    $scope.isClicked = false;
                    $scope.new = false;
                    $scope.hide = false;
                    $scope.notExist =false;
                    $scope.newRegistration = {};
                    $scope.newRegistration.PaymentStatus =1;
                    $scope.newRegistration.Status =1;
                }
                else
                    $mdDialog.hide();
            }

        })


    }



    /**
     * Check the payment type
     */
    $scope.checkIfNoCharge = function () {
        if ($scope.newRegistration.Type == 3) {
            settingsEndpoint.accountancy.banks.get(function (data) {
                $scope.banks = data;
            })
        }
        else {
            if (!$scope.copy)
                $scope.copy = angular.copy($scope.event.Price);
            if ($scope.newRegistration.Type == 0)
                $scope.event.Price = 0;
            else
                $scope.event.Price = $scope.copy;
            if ($scope.newRegistration.Type == 1) {
                getIfram();
            }

        }


    };


    $scope.trustSrc = function (src) {
        return $sce.trustAsResourceUrl(src);
    };



    /**
     * Close the dialog
     */
    $scope.closeDialog = function () {
        $mdDialog.cancel();

    };

}
angular.module('app.pages.users').controller('FullExternalRegistrationDialogController',FullExternalRegistrationDialogController);

function FullExternalRegistrationDialogController($scope,$timeout, $rootScope,$http,Upload,appConfig,$mdDialog,registration,studentsEndpoint,Notification,DTOptionsBuilder,dtOptions,settingsEndpoint,receiptsService,externalRegistrationEndpoint ) {



    $scope.orignalRegistration= registration;


    /**
     * Set Table option
     * @type {any}
     */
    $scope.dtOptions = DTOptionsBuilder
        .newOptions()
        .withLanguage(dtOptions.language)
        .withDOM('lfrtp')
        .withOption('bFilter', false)
        .withDOM('lrtip');


    /**
     * Close the dialog
     */
    $scope.closeDialog = function () {
        $mdDialog.cancel();
    };

    /**
     * Get the full Registration
     */
    $scope.getFullRegistration = function () {
        $scope.initializing = 0;
        externalRegistrationEndpoint.registrations.fullRegistration.get(registration, function (data) {
            $scope.registrations = data;
            setFileName();
            getLogs();
            getBanks();
        })
    };

    /**
     * Update registration
     * @param registration
     */
    $scope.updateRegistration = function (registration) {
        $scope.isClicked = true;
        externalRegistrationEndpoint.registrations.update.post(registration, function (data) {
            $scope.isClicked = false;
            Notification.success("הרשמה עודכנה בהצלחה");
            $rootScope.$broadcast("Registration-Update");
            getLogs();

        })
    };

    /**
     * confirm registration and send receipt
     * @param registration
     */
    $scope.sendReceipt = function (registration) {

        if (registration.ReceiptID)
            return;
        if ($scope.initializing<1 && location.hostname !== "localhost") {
            $scope.initializing++;
            return;
        }
        else
            $scope.isClicked = true;
        externalRegistrationEndpoint.registrations.confirm.post(registration, function (data) {
            $scope.isClicked = false;
            Notification.success("הרשמה עודכנה בהצלחה");
            Notification.info("קבלה נשלחה ללקוח");
            $rootScope.$broadcast("Registration-Update");
            getLogs();

        })
    };

    /**
     * get Logs
     */
    function getLogs() {
        $scope.logs = false;
        externalRegistrationEndpoint.registrations.logs.get(registration, function (data) {
            $scope.logs=data
        })
    }

    function setFileName() {
        if ($scope.registrations.Registration.File) {
            $scope.fileName  = $scope.registrations.Registration.File.replace(/^.*[\\\/]/, '')
        }
    }

    /**
     * Update Questions
     * @param questions
     */
    $scope.updateQuestions =  function (questions) {
        $scope.isClicked = true;
        var params = {};
        params.Questions = questions;
        externalRegistrationEndpoint.registrations.questions.update.post(registration,params, function () {
            $scope.isClicked = false;
            Notification.success("שאלות עודכנו בהצלחה");
            getLogs();
        })
    };

    /**
     * Update regTransportation
     */
    $scope.updateTransportation =function () {
        $scope.isClicked = true;
        var params = {};
        params.TransportationTo = $scope.registrations.Transportation.SelectedTransportationTo;
        params.TransportationFrom = $scope.registrations.Transportation.SelectedTransportationFrom;
        studentsEndpoint.registrations.transportation.update.post(registration,params, function () {
            $scope.isClicked = false;
            Notification.success("הסעות עודכנו בהצלחה");
            getLogs();
        })
    };

    /**
     * Get Banks
     */
    function getBanks() {
        if ($scope.registrations.Registration.PaymentType == 3) {
            settingsEndpoint.accountancy.banks.get(function (data) {
                $scope.banks = data;
            })
        }
    }

    /**
     * Re send Receipt
     * @param receiptID
     * @param type
     */
    $scope.reSendReceipt = function (receiptID,type) {
        Notification.info("שולח קבלה..");
        receiptsService.getReceiptByID(receiptID,type,function () {
            Notification.success("קבלה נשלחה בהצלחה");
        },true,true);
    };

    /**
     * Set Price
     * @param FinalPrice
     * @param Discount
     * @returns {number}
     */
    $scope.setPrice =function(FinalPrice,Discount) {
            return parseInt(FinalPrice) +parseInt(Discount)
    };

    /**
     * Open File in new widnwos
     * @param path
     */
    $scope.openFile = function (path) {
        window.open(path, '_blank');
    };

    /**
     * Update Questions
     * @param question
     */
    $scope.updateOptionFile = function(question) {
        var file = document.getElementById(question.ID);
        file = file.files[0];
        var params = new FormData();
        question.filename = new Date().getTime() + "_" +file.name;
        params.append("files",file,question.filename);
        params.append("brand",$rootScope.brandName);
        params.append("upload_file", 'true');

        var uploadURL = '';
        if (location.hostname === "localhost" || location.hostname === "127.0.0.1")
            uploadURL = appConfig.localHostUrl+'/upload/files';
        else if (location.host === appConfig.locationHost)
            uploadURL = appConfig.developmentHostUrl+'/upload/files';
        else
            uploadURL = appConfig.serverUrl+'/upload/files';

         $http.post(uploadURL, params, {
            headers: {'Content-Type': 'multipart/form-data','Accept':'application/json'},
            withCredentials: true
        }).then(function (data) {
             question.Answer = data.Path;
        });

    };


    /**
     * Open File
     */
     $scope.viewFile = function() {
        window.open( $scope.registrations.Registration.File);
    };

    /**
     * UploadFile
     * @param file
     */
    $scope.uploadFile = function(file) {
        if (!file)
            return;
        $scope.isClicked = true;
        $scope.fileName  = file.name;
        var uploadURL = '';
        if (location.hostname === "localhost" || location.hostname === "127.0.0.1")
            uploadURL = appConfig.localHostUrl+'/upload/files?brand='+$rootScope.brandName ;
        else if (location.host === appConfig.locationHost)
            uploadURL = appConfig.developmentHostUrl+'/upload/files?brand='+$rootScope.brandName ;
        else
            uploadURL = appConfig.serverUrl+'/upload/files?brand='+$rootScope.brandName ;

        Upload.upload({
            url: uploadURL,
            data: {file: file, 'accessToken': $rootScope.User.AccessToken}
        }).then(function (resp) {
            $scope.isClicked = false;
            $scope.registrations.Registration.File = resp.data.Path;
        }, function (resp) {
            console.log('Error status: ' + resp.status);
        }, function (evt) {
            var progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
            console.log('progress: ' + progressPercentage);
        });



    }

}
angular.module('app.pages.events').controller('NewStudentAssociation', ['$scope', '$rootScope', '$mdDialog','branchesEndpoint','eventsEndpoint','citiesEndpoint','groupsEndpoint','event','Notification', function ($scope, $rootScope, $mdDialog,branchesEndpoint,eventsEndpoint,citiesEndpoint,groupsEndpoint,event,Notification) {

    $scope.newStudentAssociation = {};

     /**
     * Save new Student
     */
    $scope.saveNewStudentAssociation = function () {
            $scope.isClicked = true;
            eventsEndpoint.association.students.post( $scope.newStudentAssociation,event.selectedEvent,function (data) {
               if(!data.success) {
                   Notification.error('תעודות זהות לא קיימת');
                   $scope.isClicked = false;
               }
               else
                   $mdDialog.hide();
            });

    };

    /**
     * Close the dialog
     */
    $scope.closeDialog =function () {
        $mdDialog.cancel();
    };

}]);

angular.module('app.pages.events').controller('NewEventAssociationDialogController', ['$scope', '$rootScope', '$mdDialog','areasEndpoint','branchesEndpoint','gradesEndpoint','eventsEndpoint','Notification','type','eventID',
    function ($scope, $rootScope, $mdDialog,areasEndpoint,branchesEndpoint,gradesEndpoint,eventsEndpoint,Notification,type,eventID) {

    $scope.type = type;
    $scope.newAssociation = {
        EventID: eventID
    };

    if(type == 1){
        areasEndpoint.get({Status: 1},function (data){
            $scope.areas = data;
        })
    }
    if(type == 2){
        branchesEndpoint.get({Status: 1},function (data){
            $scope.branches = data;
        })
    }
    if(type == 3){
        gradesEndpoint.get({Status: 1},function (data){
            $scope.grades = data;
        })
    }

    /**
     * Save new Student
     */
    $scope.saveNewAssociation = function () {
        $scope.isClicked = true;
        if(type == 1){
            eventsEndpoint.association.areas.post($scope.newAssociation,function (data){
                if(!data.success) {
                    Notification.error('התרחשה שגיאה');
                    $scope.isClicked = false;
                    $scope.closeDialog();
                }
                else
                    $mdDialog.hide();
            })
        }
        if(type == 2){
            eventsEndpoint.association.branches.post($scope.newAssociation,function (data){
                if(!data.success) {
                    Notification.error('התרחשה שגיאה');
                    $scope.isClicked = false;
                    $scope.closeDialog();
                }
                else
                    $mdDialog.hide();
            })
        }
        if(type == 3){
            eventsEndpoint.association.grades.post($scope.newAssociation,function (data){
                if(!data.success) {
                    Notification.error('התרחשה שגיאה');
                    $scope.isClicked = false;
                    $scope.closeDialog();
                }
                else
                    $mdDialog.hide();
            })
        }
    };

    /**
     * Close the dialog
     */
    $scope.closeDialog =function () {
        $mdDialog.cancel();
    };

}]);

angular.module('app.pages.student-profile').controller('EducatorGroupsController',EducatorGroupsController);

function EducatorGroupsController($timeout,$location,student,educatorsEndpoint,Notification,$mdDialog) {

    var vm =this;
    vm.updateStatus =updateStatus;
    vm.addNewGroup =addNewGroup;
    vm.openNewEducatorDialog= openNewEducatorDialog;



    /**
     * Reset all params
     */
    var interval = setInterval(function () {
        vm.student= student.selectedStudent;
        if (!vm.student) {
            vm.student = JSON.parse(localStorage.getItem('selectedStudent'));
            if (!vm.student) {
                //$location.path('/students');
                return
            }
        }
        else
            localStorage.setItem("selectedStudent",JSON.stringify(student.selectedStudent));
        clearInterval(interval);
        getGroups();
    },200);


    /**
     * Get educator Groups
     */
    function getGroups(newGroup) {
        vm.educatorGroups = false;
        var educator = {};
        educator.ID =  vm.student.EducatorID;
        if (!educator.ID && !newGroup){
            vm.educatorGroups = [];
            return;
        }
        else if (!educator.ID && newGroup) {
            educator.ID =  vm.student.ID;
            educator.IsStudent =1;
        }
        educatorsEndpoint.groups.get(educator,function (data) {
            vm.educatorGroups =data;
            if (vm.educatorGroups.length>0){
                if (!vm.educatorGroups[0]['Password'] || vm.educatorGroups[0]['Password']==="")
                    vm.showResend = true;
            }
        })
    }

    function updateStatus(group) {
        educatorsEndpoint.groups.update.post(group,function (data) {
            Notification.success("סטטוס עודכן בהצלחה")
        })
    }

    function addNewGroup() {
        $mdDialog.show({
            controller         : 'NewEducatorGroupsController as vm',
            templateUrl        : 'app/main/pages/users/views/students/student-profile/tabs/educator-groups/new-educator-group-dialog/new-educator-group-dialog.html',
            clickOutsideToClose: true
        }).then(function () {
            getGroups(true)
        });
    }

    /**
     * open create new Educator dialog
     */
    function openNewEducatorDialog() {
        $mdDialog.show({
            controller         : 'NewEducatorDialogController',
            templateUrl        : 'app/main/pages/users/views/students/student-profile/new-educator-dialog/new-educator-dialog.html',
            clickOutsideToClose: true
        })
    };




}

angular.module('app.pages.event-management').controller('EventManagementTransportationController', ['$scope', '$rootScope', '$mdDialog','eventsEndpoint','student','$location','Notification','dtOptions','DTOptionsBuilder','event','$timeout', function ($scope, $rootScope, $mdDialog,eventsEndpoint,student,$location,Notification,dtOptions,DTOptionsBuilder,event,$timeout) {


    $scope.firstTime= false;

    /**
     * Get the event Transportation after 250 mils
     */
    $timeout(function () {
        $scope.event = event.selectedEvent;
        $scope.getEventTransportation();
        },250);

    /**
     * Get all events Transportation
     */
    $scope.getEventTransportation = function (newEvent) {
        $scope.event = event.selectedEvent;
        if (newEvent || $scope.firstTime===false) {
            $scope.firstTime= true;
            $scope.eventTransportation = false;
            eventsEndpoint.transportation.get($scope.event, function (data) {
                $scope.eventTransportation = data;
            })
        }
    };

    /**
     * Add Transportation to event
     */
    $scope.addTransportationToEvent = function () {
        $mdDialog.show({
            controller         : 'AddTransportationToEventController',
            templateUrl        : 'app/main/pages/events/views/events/event-management/tabs/transportation/add-transportation-to-event-dialog/add-transportation-to-event-dialog.html',
            clickOutsideToClose: true,
            locals: {
                eventID: $scope.event.ID
            }
        }).then(function () {
            $scope.getEventTransportation(true);
        });
    };

    /**
     * Add new Transportation dialog
     */
    $scope.addNewTransportationToEvent = function () {
        $mdDialog.show({
            controller         : 'AddNewTransportationToEventController',
            templateUrl        : 'app/main/pages/events/views/events/event-management/tabs/transportation/add-new-transportation-to-event-dialog/add-new-transportation-to-event-dialog.html',
            clickOutsideToClose: true,
            locals: {
                eventID: $scope.event.ID
            }
        }).then(function () {
            $scope.getEventTransportation(true);
        });
    };

    /**
     * Change the Transportation Type
     * @param transportation
     */
    $scope.changeTransportationStatus = function (transportation) {
        if(transportation.Status == 1) {
            eventsEndpoint.transportation.unlink.post($scope.event, transportation, function (data) {
                if(!data.success) {
                    Notification.error("נכשל בביטול שיוך")
                } else {
                    transportation.Status = 0;
                }
            })
        } else {
            eventsEndpoint.transportation.relink.post($scope.event, transportation, function (data) {
                if(!data.success) {
                    Notification.error("נכשל בהוספת שיוך")
                } else {
                    transportation.Status = 1;
                }
            })
        }
    };

}]);

angular.module('app.pages.event-management').controller('EventManagementSubscribersController', ['$scope', '$rootScope', '$mdDialog', 'eventsEndpoint', 'student', '$location', 'Notification', 'dtOptions', 'DTOptionsBuilder', 'event', '$timeout', '$mdSidenav', 'groupsEndpoint', 'branchesEndpoint', 'receiptsService', 'areasEndpoint', 'DTColumnDefBuilder', 'studentsEndpoint','tagsEndpoint',
    function ($scope, $rootScope, $mdDialog, eventsEndpoint, student, $location, Notification, dtOptions, DTOptionsBuilder, event, $timeout, $mdSidenav, groupsEndpoint, branchesEndpoint, receiptsService, areasEndpoint, DTColumnDefBuilder, studentsEndpoint,tagsEndpoint) {

        $scope.search = {
            branches: [],
            groups: [],
            grades: [],
            tags: [],
        };

        $scope.groups = [];
        $scope.disableForUser = false;
        $scope.selectedStudentsCount = 0;

        $scope.showbtns = false;

        /**
         * Get event subscribers after 250 mils
         */
        $timeout(function () {
            $scope.event = event.selectedEvent;
            if ($scope.event.IsProduct)
                $scope.title = "מוצר";
            else
                $scope.title = $rootScope.User.Event;
            $scope.subscribers = [];
            checkUser();
            $scope.getEventHealthDeclarations();
        }, 250);

        function checkUser() {
            if ($rootScope.User.RegistrationClose) {
                var datum = moment(event.selectedEvent.RegistrationEndDate, "DD-MM-YYYY HH:mm").unix() * 1000;
                if (Date.now() > datum)
                    $scope.disableForUser = true;
            }
        }

        $scope.getRegistrationsAmount = function () {
            eventsEndpoint.registrations.amount.get($scope.event, function (data) {
                $scope.registrationAmount = data.RegsAmount;
            });
        }

        $scope.getEventHealthDeclarations = function () {
            eventsEndpoint.healthDeclarations.get($scope.event.ID, function (data) {
                $scope.showEventHealthDeclarationsBtn = data.length > 0;
            })
        }

        /**
         * Get subscribers
         * @param noFilter
         */
        $scope.getSubscribers = function (noFilter) {
            $scope.subscribers = false;
            if (!noFilter) {
                $scope.isClicked = true;
                var params = {};
                if (typeof $scope.event.EventType == "string") {
                    $scope.event.EventType = parseInt($scope.event.EventType);
                }
                if (!$scope.event.EventType) {

                    params.GroupsIdes = JSON.stringify(angular.copy($scope.search.groups).map(function (group) {
                        return group.ID;
                    }));
                    params.BranchIdes = JSON.stringify(angular.copy($scope.search.branches).map(function (branch) {
                        return branch.ID;
                    }));
                    params.GradesIdes = JSON.stringify(angular.copy($scope.search.grades).map(function (grade) {
                        return grade.ID;
                    }));
                    params.Tags = JSON.stringify($scope.search.tags);

                    params.Type = $scope.search.educator;
                    params.Refund = $scope.search.Refund;
                    params.Canceled = $scope.search.Canceled;
                    params.PaymentType = $scope.search.PaymentType;
                    params.PaymentStatus = $scope.search.PaymentStatus;
                    params.Areas = $scope.search.Areas;
                    params.EventGroup = $scope.search.EventGroup;
                }
                params.FreeSearch = $scope.search.freeSearchFromDB;
                params.Status = $scope.search.Status;


            } else {
                $scope.subscribers = [];
                $scope.search = {};
                $scope.search.branches = [];
                $scope.search.groups = [];
                $scope.search.Canceled = null;
                $scope.search.Status = 1;
                $scope.search.Areas = [];
                $scope.search.grades = [];
                $scope.search.tags = [];
                return;
            }

            $scope.groups = [];

            eventsEndpoint.subscribers.get(params, $scope.event, function (data) {
                $scope.isClicked = false;
                $scope.subscribers = data;
                $scope.refreshTable = false;
            });
        };

        /**
         * Get Final price of event
         * @param registrationKey
         * @param registrationValue
         */
        $scope.getFinalPrice = function (registrationKey, registrationValue) {
            if (registrationValue.Discount)
                $scope.subscribers[registrationKey].EventPrice = parseInt(registrationValue.Discount) + parseInt(registrationValue.FinalPrice);
            else
                $scope.subscribers[registrationKey].EventPrice = parseInt(registrationValue.FinalPrice);

        };

        $scope.changeBtns = function () {
            $scope.showbtns = !$scope.showbtns;
        }

        /**
         * Watch on branches
         */
        $scope.$watchCollection('search.branches.length', function () {

            var params = {};
            params.BranchIdes = [];
            for (var i = 0; i < $scope.search.branches.length; i++) {
                params.BranchIdes.push($scope.search.branches[i].ID)
            }
            params.BranchIdes = JSON.stringify(params.BranchIdes);
            groupsEndpoint.get(params, function (data) {
                $scope.groups = data;
            });
        });

        /**
         * Get All Branches And Groups
         */
        $scope.getBranches = function () {
            var params = {};
            params.Status = 1;
            branchesEndpoint.get(params, function (data) {
                $scope.branches = data;
            });
        };

        $scope.getTags = function () {
            tagsEndpoint.get({TagType: 1}, function (data) {
                $scope.Tags = data;
            })
        }

        /**
         * download Receipt
         * @param receiptID
         * @param type
         */
        $scope.downloadReceipt = function (receiptID, type) {
            Notification.info("מייצר קבלה..אנא המתן");
            receiptsService.getReceiptByID(receiptID, type);

        };

        /**
         * Branches query search
         * @param query
         * @returns {Array}
         */
        $scope.branchesQuerySearch = function (query) {
            var results = query ? $scope.branches.filter(createFilterFor(query)) : [];
            return results;
        };

        /**
         * Groups query search
         * @param query
         * @returns {*}
         */
        $scope.groupsQuerySearch = function (query) {
            var results = query ? $scope.groups.filter(createFilterFor(query)) : [];
            return results;
        };

        /**
         * grades query search
         * @param query
         * @returns {Array}
         */
        $scope.gradesQuerySearch = function (query) {
            var results = query ?
                $scope.grades.filter(createFilterFor(query)) : [];
            return results;
        };

        /**
         * Create filter for query from auto complete
         * @param query
         * @returns {filterFn}
         */
        function createFilterFor(query) {
            var lowercaseQuery = angular.lowercase(query);
            return function filterFn(contact) {
                return (contact.Name.indexOf(lowercaseQuery) != -1);
            };
        }


        /**
         * Open the student panel
         * @param selectedStudent
         */
        $scope.openStudentPanel = function (selectedStudent) {
            $mdSidenav("student-panel").open();
            student.updateSelectedStudent(selectedStudent);
        };

        /**
         * Open Cancel Registration Dialog
         * @param registration
         */
        $scope.refundRegistration = function (registration) {

            $mdDialog.show({
                controller: 'RefundRegistrationDialogController',
                templateUrl: 'app/main/pages/events-dialogs/refund-registration-dialog/refund-registration-dialog.html',
                locals: {'registration': registration, external: false},
                clickOutsideToClose: true
            }).then(function () {
                $scope.getSubscribers();
            });
        };


        /**
         * Open Cancel Registration Dialog
         * @param registration
         */
        $scope.cancelRegistration = function (registration) {

            $mdDialog.show({
                controller: 'CancelRegistrationDialogController',
                templateUrl: 'app/main/pages/events-dialogs/cancel-registration-dialog/cancel-registration-dialog.html',
                locals: {'registration': registration, external: false},
                clickOutsideToClose: true
            }).then(function () {
                $scope.getSubscribers();
            });
        };

        /**
         * Open create Registration Dialog
         */
        $scope.openNewRegistrationDialog = function () {
            $mdDialog.show({
                controller: 'NewRegistrationDialogController',
                templateUrl: 'app/main/pages/events/views/events/event-management/tabs/subscribers/new-registration-dialog/new-registration-dialog.html',
                clickOutsideToClose: false
            }).then(function () {
                $scope.getSubscribers();
            });
        };
        /**
         * Open send sms dialog
         */
        $scope.openSendSMS = function () {
            $mdDialog.show({
                controller: 'SMSDialogController',
                templateUrl: 'app/main/pages/sms-email-dialogs/sms-dialog/sms-dialog.html',
                locals: {'students': $scope.subscribers, "type": 1, 'external': false}
            });
        };

        /**
         * Open the send email box
         */
        $scope.openSendEmail = function () {
            $mdDialog.show({
                controller: 'EmailDialogController',
                templateUrl: 'app/main/pages/sms-email-dialogs/email-dialog/email-dialog.html',
                locals: {'students': $scope.subscribers, "type": 1, 'external': false}
            });
        };

        $scope.openHealthDeclaration = function () {
            $mdDialog.show({
                controller: 'SendHealthDeclarationDialogController',
                templateUrl: 'app/main/pages/events/views/events/event-management/tabs/subscribers/send-health-declaration-dialog/send-health-declaration-dialog.html',
                locals: {'eventID': $scope.event.ID}
            });
        }

        /**
         * Set all params
         * @param selectAll
         */
        $scope.setAll = function (selectAll) {
            if (selectAll) {
                for (var i = 0; i < $scope.subscribers.length; i++) {
                        $scope.subscribers[i].Selected = true;
                        $scope.selectedStudentsCount++;
                }

            } else {
                for (var i = 0; i < $scope.subscribers.length; i++) {
                    $scope.subscribers[i].Selected = false;
                }
                $scope.selectedStudentsCount = 0;
            }

        };


        /**
         * Get Payment type by ID
         * @param registrationValue
         */
        $scope.getPaymentType = function (registrationValue) {
            switch (registrationValue.PaymentType) {
                case 0 :
                    registrationValue.PaymentType = "ללא עלות";
                    break;
                case 1 :
                    registrationValue.PaymentType = "אשראי";
                    break;
                case 2 :
                    registrationValue.PaymentType = "מזומן";
                    break;
                case 3 :
                    registrationValue.PaymentType = "העברה בנקאית";
                    break;
                case 4 :
                    registrationValue.PaymentType = "צ'ק";
                    break;
            }
        };

        /**
         * Show full Registration
         * @param registration
         */
        $scope.showFullRegistration = function (registration) {
            $mdDialog.show({
                controller: 'FullRegistrationDialogController',
                templateUrl: 'app/main/pages/events-dialogs/full-registration-dialog/full-registration-dialog.html',
                clickOutsideToClose: true,
                locals: {'registration': registration},
                onRemoving: function (event, removePromise) {
                    $scope.getSubscribers()
                }
            });
        };

        $scope.openSelectRegistrationDialog = function ($registration){
            $mdDialog.show({
                controller: 'SelectRegistrationDialogController',
                templateUrl: 'app/main/pages/events/views/events/event-management/tabs/subscribers/select-registration-dialog/select-registration-dialog.html',
                clickOutsideToClose: true,
                locals: {'registration': $registration},
            });
        }



        /**
         * Update subscribers
         */
        $rootScope.$on("Registration-Update", function () {
            $scope.getSubscribers();
        });

        /**
         * Get Areas
         */
        $scope.getAreas = function () {
            var params = {};
            params.Status = 1;
            areasEndpoint.get(params, function (data) {
                $scope.areas = data;
            })
        };

        /**
         * Update payments status
         */
        $scope.changePaymentsStatus = function () {

            var confirm = $mdDialog.confirm()
                .title('שינוי סטטוס תשלום')
                .textContent('האם אתה בטוח/ה שברצונך לאשר הזמנות אלו?')
                .ok('אישור')
                .cancel('ביטול');
            $mdDialog.show(confirm).then(function () {
                var selectedStudents = [];
                for (var i = 0; i < $scope.subscribers.length; i++) {
                    if ($scope.subscribers[i].Selected === true && $scope.subscribers[i].Canceled != 1) {
                        selectedStudents.push($scope.subscribers[i]['ID']);
                    }
                }
                $scope.isClicked = true;
                var params = {};
                params.Registrations = selectedStudents;
                eventsEndpoint.registrations.update.post(params, function (data) {
                    $scope.isClicked = false;
                    if (data.success) {
                        Notification.success("הרשמות עודכנו בצלחה");
                        $scope.getSubscribers();
                    } else
                        Notification.error("נכשל בעדכון הרשמות");
                })
            });

        };

        jQuery.extend(jQuery.fn.dataTableExt.oSort, {
            "eu-date-pre": function (a) {
                if (a == null || a == '') {
                    return 0;
                }
                var date = a.split('/');
                return Date.parse(date[1] + '/' + date[0] + '/' + date[2])
            }
        });


        $scope.dtColumnDefs = [
            DTColumnDefBuilder.newColumnDef(1).withOption('type', 'eu-date'),

        ];

        /**
         * Create  Kibutz PDF
         */
        $scope.createKibutzPDF = function () {
            $mdDialog.show({
                controller: 'CrateKibutzPDFDialogController',
                templateUrl: 'app/main/pages/events/views/events/event-management/tabs/subscribers/create-kibutzPDF-dialog/create-kibutzPDF-dialog.html',
                clickOutsideToClose: true,
                locals: {'event': $scope.event}
            })
        }

        /**
         * Student Count
         * @param student
         */
        $scope.studentToggled = function (student) {
            if (student.Selected)
                $scope.selectedStudentsCount++;
            else
                $scope.selectedStudentsCount--;
        }

        $scope.updateSupplied = function (registration) {
            studentsEndpoint.registrations.update.post(registration, function (data) {
                if (!data.success)
                    Notification.error('התרחשה שגיאה');
            })
        }
    }]);

angular.module('app.pages.event-management').controller('EventManagementStatisticsController', ['$scope', '$rootScope', '$mdDialog','eventsEndpoint','student','$location','Notification','dtOptions','DTOptionsBuilder','event','$timeout', function ($scope, $rootScope, $mdDialog,eventsEndpoint,student,$location,Notification,dtOptions,DTOptionsBuilder,event,$timeout) {

    /**
     * Get event Statistics after 250 mils
     */
    $timeout(function () {
        $scope.event = event.selectedEvent;
        $scope.getEventStatistics();
    },250);

    /**
     * Get Event Statistics
     */
    $scope.getEventStatistics = function () {
        $scope.statistics = false;
        if (!$scope.statistics || $scope.refreshTable) {
            var params = {};
            params.EventType = $scope.event.EventType;
            eventsEndpoint.statistics.get(params,$scope.event, function (data) {
                $scope.statistics = data;
                $scope.refreshTable = false;
                $scope.statistics.colors = ['#0DACF4','#D4DCFF','#FFE2D1','#541388'];
                $scope.statistics.options = {
                    legend: {display: true}
                };

            });
        }
    }

}]);

angular.module('app.pages.event-management').controller('EventManagementQuestionsController', ['$scope', '$rootScope', '$mdDialog','eventsEndpoint','student','$location','Notification','dtOptions','DTOptionsBuilder','event','$timeout','eventQuestion','$mdSidenav', function ($scope, $rootScope, $mdDialog,eventsEndpoint,student,$location,Notification,dtOptions,DTOptionsBuilder,event,$timeout,eventQuestion,$mdSidenav) {


    /**
     * Get event Questions after 250 mils
     */
    $timeout(function () {
        $scope.event = event.selectedEvent;
        $scope.getEventQuestions();
    },250);


    /**
     * Get Event Questions
     */
    $scope.getEventQuestions = function () {
        $scope.eventQuestions = false;
        var params = {};
        params.Status = 'ALL';
        if (!$scope.eventQuestions || $scope.refreshTable) {
            eventsEndpoint.questions.get(params,$scope.event, function (data) {
                $scope.eventQuestions = data;
                $scope.refreshTable = false;
            });
        }
    };


    /**
     * Add existing questions to event
     */
    $scope.addQuestionsToEvent = function () {
        $mdDialog.show({
            controller         : 'AddQuestionsToEventController',
            templateUrl        : 'app/main/pages/events/views/events/event-management/tabs/questions/add-questions-to-event-dialog/add-questions-to-event-dialog.html',
            clickOutsideToClose: true,
        }).then(function () {
            $scope.refreshTable = true;
            $scope.getEventQuestions();
        });
    };

    /**
     * Create a new question and add it to event
     */
    $scope.createNewEventQuestion = function () {
        $mdDialog.show({
            controller         : 'NewQuestionDialogController',
            templateUrl        : 'app/main/pages/events/views/questions/new-question-dialog/new-question-dialog.html',
            clickOutsideToClose: true,
            locals: {
                eventID: $scope.event.ID
            }
        }).then(function () {
            $scope.refreshTable = true;
            $scope.getEventQuestions();
        });
    };

    /**
     * Change the question Type
     * @param question
     */
    $scope.changeQuestionStatus = function (question) {
        if(question.Status == 1) {
            eventsEndpoint.questions.unlink.post($scope.event, question, function (data) {
                if(!data.success) {
                    Notification.error("נכשל בביטול שיוך")
                } else {
                    question.Status = 0;
                }
            })
        } else {
            eventsEndpoint.questions.relink.post($scope.event, question, function (data) {
                if(!data.success) {
                    Notification.error("נכשל בהוספת שיוך")
                } else {
                    question.Status = 1;
                }
            })
        }
    };

    /**
     * Set Type
     * @param type
     * @returns {string}
     */
    $scope.setType = function(type) {
        switch (type) {
            case "1":
            case 1:
                return "שאלה פתוחה";
            case "2":
            case 2:
                return "אפשרויות";
            case "3":
            case 3:
                return "קובץ";
            case "4":
            case 4:
                return "תאריך";
        }
    };



    $scope.openEventQuestionPanel = function (selectedQuestion) {
        eventQuestion.updateSelectedEventQuestion(selectedQuestion);
        $mdSidenav("edit-event-question-panel").open();
    }

}]);

angular.module('app.pages.event-management').controller('EventManagementFilesController', ['$scope', '$rootScope', '$mdDialog', 'eventsEndpoint', 'student', '$location', 'Notification', 'dtOptions', 'DTOptionsBuilder', 'event', '$timeout', function ($scope, $rootScope, $mdDialog, eventsEndpoint, student, $location, Notification, dtOptions, DTOptionsBuilder, event, $timeout) {

    $scope.finishedLoading = false;
    $scope.reset = false;

    /**
     * Get Events files after 250 mils
     */
    $timeout(function () {
        $scope.getEventFiles();
        $scope.getEventHealthDeclarations()
    }, 250);


    /**
     * Get event files from API
     */
    $scope.getEventFiles = function () {
        $scope.eventFiles = false;
        $scope.event = event.selectedEvent;
        $timeout(function () {
            if (!$scope.eventFiles || $scope.eventFiles.length === 0) {
                eventsEndpoint.files.get($scope.event, function (data) {
                    if (data) {
                        $scope.eventFiles = data;
                        angular.forEach($scope.eventFiles, function (file, key) {
                            file.Icon = getFileIcon(file);
                            file.Type = getFileType(file);
                            file.selectedBranches = [];
                            angular.forEach(file.Branches, function (branch, key) {
                                if (branch.Active === 1) {
                                    file.selectedBranches.push(branch);
                                }
                            });
                        });
                        $scope.finishedLoading = true;
                    }
                });
            }
        }, 200)

    };

    /**
     * A call to files uploading controller
     */
    $scope.uploadNewFileToEvent = function () {
        //if (checkIfAllFilesHaveBranches())
        $mdDialog.show({
            controller: 'UploadController',
            templateUrl: 'app/upload/upload.html',
            clickOutsideToClose: false,
            locals: {
                uploadTo: 'events',
                uploadID: $scope.event.ID,
                restrictTo: ['pdf']
            }
        }).then(function () {
            $scope.eventFiles = [];
            $scope.reset = true;
            $scope.getEventFiles();
        });
    };

    $scope.uploadNewHealthDeclarationToEvent = function () {
        $mdDialog.show({
            controller: 'UploadController',
            templateUrl: 'app/upload/upload.html',
            clickOutsideToClose: false,
            locals: {
                uploadTo: 'events',
                uploadID: $scope.event.ID + "/health-declarations",
                restrictTo: ['pdf']
            }
        }).then(function () {
          $scope.getEventHealthDeclarations();
        });
    };

    $scope.getEventHealthDeclarations = function (){
        eventsEndpoint.healthDeclarations.get($scope.event.ID,function(data){
            $scope.healthDeclarations = data;
            $scope.healthDeclarations.forEach(function (file){
                file.Icon = getFileIcon(file);
            })
        })
    }

    $scope.updateHealthDeclaration = function (healthDeclaration){
        eventsEndpoint.healthDeclarations.update($scope.event.ID,healthDeclaration,function(data){
            if(data.success != true)
                Notification.error('התרחשה שגיאה');
            $scope.getEventHealthDeclarations();
        })
    }


    function checkIfAllFilesHaveBranches() {
        var flag = true;
        angular.forEach($scope.eventFiles, function (file, key) {
            if (file.selectedBranches.length === 0 && file.Status == 1)
                flag = false;
        });

        return flag;
    }

    /**
     * Look for changes in the event files
     */
    $scope.$watch('eventFiles', function (newVal, oldVal) {
        if (typeof $rootScope.editDataHandler === 'function' && $scope.finishedLoading)
            $rootScope.editDataHandler(newVal, oldVal, 'event-files-view', $scope.reset);
        if ($scope.reset)
            $scope.reset = !$scope.reset;
    }, true);


    /**
     * Get the icon name for md-icon by file extension
     * @param file
     * @returns {string}
     */
    var getFileIcon = function (file) {
        var ext = getFileType(file),
            doc = ['doc', 'docx', 'docm'],
            xls = ['xls', 'xlsx', 'xlsm'],
            pdf = ['pdf'],
            icon = '';

        if (doc.indexOf(ext) != '-1')
            icon = 'icon-file-word';
        else if (xls.indexOf(ext) != '-1')
            icon = 'icon-file-excel';
        else if (pdf.indexOf(ext) != '-1')
            icon = 'icon-file-pdf';
        else
            icon = 'icon-file';
        return icon;
    };

    /**
     * Get the file extension
     * @param file
     * @returns {string}
     */
    var getFileType = function (file) {
        return file.Path.substr(file.Path.lastIndexOf('.') + 1)
    };


}]);

angular.module('app.pages.event-management').controller('EventManagementExternalSubscribersController', EventManagementExternalSubscribersController);
function EventManagementExternalSubscribersController($scope, $rootScope, $mdDialog,externalRegistrationEndpoint,student,$location,Notification,dtOptions,DTOptionsBuilder,event,$timeout,$mdSidenav,groupsEndpoint,branchesEndpoint,receiptsService,areasEndpoint) {

    $scope.search = {};
    $scope.showbtns = false;

    /**
     * Get event subscribers after 250 mils
     */
    $timeout(function () {
        $scope.event = event.selectedEvent;
        $scope.subscribers = [];
    }, 250);

    /**
     * Get subscribers
     * @param noFilter
     */
    $scope.getSubscribers = function (noFilter) {
        $scope.subscribers = false;
        if (noFilter) {
            $scope.subscribers = [];
            $scope.search = {};
            $scope.search.Canceled = null;
            $scope.search.Status = 1;
            return;
        }
        $scope.search.EventID = $scope.event.ID;
        externalRegistrationEndpoint.subscribers.get($scope.search, function (data) {
            $scope.isClicked = false;
            $scope.subscribers = data;
            $scope.refreshTable = false;
        });
    };


    /**
     * download Receipt
     * @param receiptID
     */
    $scope.downloadReceipt = function (receiptID,type) {
        Notification.info("מייצר קבלה..אנא המתן");
        receiptsService.getReceiptByID(receiptID,type,false,false,true)

    };


    /**
     * Open Cancel Registration Dialog
     * @param registration
     */
    $scope.refundRegistration = function (registration) {
        $mdDialog.show({
            controller: 'RefundRegistrationDialogController',
            templateUrl: 'app/main/pages/events-dialogs/refund-registration-dialog/refund-registration-dialog.html',
            locals: {'registration': registration, external: true},
            clickOutsideToClose: true
        }).then(function () {
            $scope.getSubscribers();
        });
    };


    /**
     * Open Cancel Registration Dialog
     * @param registration
     */
    $scope.cancelRegistration = function (registration) {

        $mdDialog.show({
            controller: 'CancelRegistrationDialogController',
            templateUrl: 'app/main/pages/events-dialogs/cancel-registration-dialog/cancel-registration-dialog.html',
            locals: {'registration': registration, external: true},
            clickOutsideToClose: true
        }).then(function () {
            $scope.getSubscribers();
        });
    };

    /**
     * Open create Registration Dialog
     */
    $scope.openNewRegistrationDialog = function () {
        $mdDialog.show({
            controller: 'NewExternalRegistrationDialogController',
            templateUrl: 'app/main/pages/events/views/events/event-management/tabs/external-subscribers/new-external-registration-dialog/new-external-registration-dialog.html',
            clickOutsideToClose: true
        }).then(function () {
            $scope.getSubscribers();

        });
    };
    /**
     * Open send sms dialog
     */
    $scope.openSendSMS = function () {
        $mdDialog.show({
            controller: 'SMSDialogController',
            templateUrl: 'app/main/pages/sms-email-dialogs/sms-dialog/sms-dialog.html',
            locals: {'students': $scope.subscribers, external: true,"type": 1}
        });
    };

    /**
     * Open the send email box
     */
    $scope.openSendEmail = function () {
        $mdDialog.show({
            controller: 'EmailDialogController',
            templateUrl: 'app/main/pages/sms-email-dialogs/email-dialog/email-dialog.html',
            locals: {'students': $scope.subscribers, external: true,"type": 1}
        });
    };

    /**
     * Set all params
     * @param selectAll
     */
    $scope.setAll = function (selectAll) {
        if (selectAll) {
            for (var i = 0; i < $scope.subscribers.length; i++) {
                if ($scope.subscribers[i].Canceled == null || $scope.subscribers[i].Canceled == 0)
                    $scope.subscribers[i].Selected = true;
            }
        }
        else
            for (var i = 0; i < $scope.subscribers.length; i++) {
                $scope.subscribers[i].Selected = false;
            }
    };


    /**
     * Get Payment type by ID
     * @param registrationValue
     */
    $scope.getPaymentType = function (registrationValue) {
        switch (registrationValue.PaymentType) {
            case 0 :
                registrationValue.PaymentType = "ללא עלות";
                break;
            case 1 :
                registrationValue.PaymentType = "אשראי";
                break;
            case 2 :
                registrationValue.PaymentType = "מזומן";
                break;
            case 3 :
                registrationValue.PaymentType = "העברה בנקאית";
                break;
            case 4 :
                registrationValue.PaymentType = "צ'ק";
                break;
        }
    };

    /**
     * Show full Registration
     * @param registration
     */
    $scope.showFullRegistration = function (registration) {
        $mdDialog.show({
            controller: 'FullExternalRegistrationDialogController',
            templateUrl: 'app/main/pages/events/views/events/event-management/tabs/external-subscribers/full-external-registration-dialog/full-external-registration-dialog.html',
            clickOutsideToClose: true,
            locals: {'registration': registration}
        })
    };

    /**
     * Update subscribers
     */
    $rootScope.$on("Registration-Update", function () {
        $scope.getSubscribers();
    });

    /**
     * Get Areas
     */
    $scope.getAreas = function () {
        var params = {};
        params.Status =1;
        areasEndpoint.get(params,function (data) {
            $scope.areas = data;
        })
    };

    /**
     * Update payments status
     */
    $scope.changePaymentsStatus = function () {

        var confirm = $mdDialog.confirm()
            .title('שינוי סטטוס תשלום')
            .textContent('האם אתה בטוח/ה שברצונך לאשר הזמנות אלו?')
            .ok('אישור')
            .cancel('ביטול');
        $mdDialog.show(confirm).then(function () {
            var selectedStudents = [];
            for (var i = 0; i < $scope.subscribers.length; i++) {
                if ($scope.subscribers[i].Selected === true) {
                    selectedStudents.push($scope.subscribers[i]['ID']);
                }
            }
            $scope.isClicked = true;
            var params = {};
            params.Registrations = selectedStudents;
            externalRegistrationEndpoint.registrations.payments.update.post(params, function (data) {
                $scope.isClicked = false;
                if (data.success)
                    Notification.success("הרשמות עודכנו בצלחה");
                else
                    Notification.error("נכשל בעדכון הרשמות");
            })
        });

    };
}

angular.module('app.pages.event-management').controller('EventDiscountsController', EventDiscountsController);
function EventDiscountsController($scope, $rootScope, $mdDialog,eventsEndpoint,student,$location,Notification,dtOptions,DTOptionsBuilder,event,$timeout,$mdSidenav,generalDiscount) {

    $scope.event = event.selectedEvent;
    $scope.filterg = 1;
    $scope.filters = 1;
    /**
     * Get Event Discount after 350 mils
     */
    $timeout(function () {
        $scope.getEventDiscounts();
    }, 350);

    /**
     * Get event discounts from API
     */
    $scope.getEventDiscounts = function () {

        $rootScope.discountsLoading = true;
        eventsEndpoint.discounts.get($scope.event, function (data) {
            $scope.FamilyLevelDiscount = data.FamilyLevelDiscount;
            $scope.BrotherDiscount = data.BrotherDiscount;
            $scope.GeneralDiscount = data.GeneralDiscount;
            $scope.StudentDiscount = data.StudentDiscount;
            $scope.DatesDiscounts = data.DateDiscount;
            $rootScope.discountsLoading = false;
        });
    };

    /**
     * Set the selected tab index
     * @param tab
     */
    $scope.setTab = function (tab) {
        $scope.selectedTab = tab;
    }

    /******************************************************************* Brother Discounts Start *******************************************************************/

    $scope.addNewBrotherDiscount = function () {
        $mdDialog.show({
            controller: 'NewBrotherDiscountDialogController',
            templateUrl: 'app/main/pages/events/views/events/event-management/tabs/discounts/tabs/new-brother-discount-dialog/new-brother-discount-dialog.html',
            clickOutsideToClose: false,
            locals: {
                brotherCount: $scope.BrotherDiscount.length + 1
            }
        }).then(function () {
            $scope.overWrite = true;
            $scope.getEventDiscounts();
        });
    };

    /******************************************************************* Brother Discounts End *******************************************************************/


    /******************************************************************* General Discounts *******************************************************************/

    /**
     * Get the updated when the discount is saved
     */
    $scope.$on('isSave:updated', function () {
        $scope.getEventDiscounts();
    });

    /**
     * Edit general discount
     * @param selectedGeneralDiscount
     */
    $scope.editGeneralDiscount = function (selectedGeneralDiscount) {
        $mdSidenav("general-discount-panel").open();
        generalDiscount.updateSelectedGeneralDiscount(selectedGeneralDiscount);
    };

    /**
     * Open a dialog for new general discount creation
     */
    $scope.createNewGeneralDiscount = function () {
        $mdDialog.show({
            controller: 'NewGeneralDiscountDialogController',
            templateUrl: 'app/main/pages/events/views/events/event-management/tabs/discounts/tabs/new-general-discount-dialog/new-general-discount-dialog.html',
            clickOutsideToClose: false
        }).then(function () {
            $scope.getEventDiscounts();
        });
    };

    $scope.changeStatus = function (discountValue) {
        var params = {};
        params.EventID = discountValue.EventID;
        params.ID = discountValue.ID;
        if (discountValue.Status == 1)
            params.Status = 0;
        else
            params.Status = 1;

        $scope.isClicked = true;
        eventsEndpoint.discounts.general.status.post(params, function (data) {
            $scope.isClicked = false;
            if (!data.success)
                Notification.error("נכשל");
            else {
               $scope.GeneralDiscount.forEach(function(ele){
                   if(ele.ID == params.ID){
                       ele.Status = params.Status;
                   }
               });
            }
        });

    };


    /************ General Discounts End *****************/


    /******************************************************************* Student Discounts Start *******************************************************************/

    /**
     * Open the dialog for a new student discount creation
     */
    $scope.createNewStudentDiscount = function () {
        $mdDialog.show({
            controller: 'NewStudentDiscountDialogController',
            templateUrl: 'app/main/pages/events/views/events/event-management/tabs/discounts/tabs/new-student-discount-dialog/new-student-discount-dialog.html',
            clickOutsideToClose: false
        }).then(function () {
            $scope.getEventDiscounts();
        });
    };
    /**
     * Switches the status of the student discount
     * @param discount
     */
    $scope.changeStudentDiscountStatus = function (discount) {
        discount.Status = !discount.Status;
    };


    /******************************************************************* Student Discounts End *******************************************************************/

    /******************************************************************* Date Discounts Start *******************************************************************/

    /**
     * Open the dialog for a new student discount creation
     */
    $scope.createNewDateDiscount = function () {
        $mdDialog.show({
            controller: 'NewDateDiscountDialogController',
            templateUrl: 'app/main/pages/events/views/events/event-management/tabs/discounts/tabs/new-date-discount-dialog/new-date-discount-dialog.html',
            clickOutsideToClose: false
        }).then(function () {
            $scope.getEventDiscounts();
        });
    };

    $scope.$watch('DatesDiscounts', function (newVal, oldVal) {
        if (typeof $rootScope.editDataHandler === 'function')
            $rootScope.editDataHandler(newVal, oldVal, 'date-discount-view');
    }, true);

    /******************************************************************* Date Discounts End *******************************************************************/

    /******************************************************************* SAVE CHANGES *******************************************************************/

    /**
     * Look for changes in the student discount
     */
    $scope.$watch('StudentDiscount', function (newVal, oldVal) {
        if (typeof $rootScope.editDataHandler === 'function')
            $rootScope.editDataHandler(newVal, oldVal, 'student-discount-view');
    }, true);

    /**
     * Look for changes in the fmily discount
     */
    $scope.$watch('FamilyLevelDiscount', function (newVal, oldVal) {
        if (typeof $rootScope.editDataHandler === 'function')
            $rootScope.editDataHandler(newVal, oldVal, 'family-level-view');
    }, true);

    /**
     * Look for changes in the Brother discount
     */
    $scope.$watch('BrotherDiscount', function (newVal, oldVal) {
        if (typeof $rootScope.editDataHandler === 'function') {
            $rootScope.editDataHandler(newVal, oldVal, 'brother-discount-view', $scope.overWrite);
            if ($scope.overWrite)
                $scope.overWrite = false;
        }

    }, true);

    $scope.uploadExcelFile = function () {
        $mdDialog.show({
            controller         : 'UploadController',
            templateUrl        : 'app/upload/upload.html',
            clickOutsideToClose: false,
            locals: {
                uploadTo: 'events',
                uploadID: $scope.event.ID+"/discount/students",
                restrictTo: ['xlsx','csv']
            }
        }).then(function () {
           $scope.getEventDiscounts();
        });
    }

}

angular.module('app.pages.users').controller('NewParentDialogController', ['$scope', '$rootScope', '$mdDialog','studentsEndpoint','student','$location','Notification', function ($scope, $rootScope, $mdDialog,studentsEndpoint,student,$location,Notification) {

        /**
         * Save new Student
         */
        $scope.saveNewParent = function () {
                $scope.isClicked =true;
                studentsEndpoint.parent.post(student.selectedStudent,$scope.newParent,function (data) {
                        $scope.isClicked =false;
                        if (data.ID)
                                $mdDialog.hide();
                        else
                                Notification.info("נכשל ביצירה : דואר אלקטרוני/תועדה מזהה/דרכון קיימים במערכת")

                })
        };

        $scope.ChangeToPassport = function () {
                $scope.tz=!$scope.tz
        };

        /**
         * Close the dialog
         */
        $scope.closeDialog =function () {
            $mdDialog.cancel();
        };

        $scope.pattern = function () {
                if (!$scope.tz)
                        return "/^[0-9]{9,9}$/";
                return "";
        };

        $scope.changeShowMore =function () {
                $scope.more=!$scope.more;

        };

        $scope.relations =['אמא','אבא','סבא','סבתא','אפוטרופוס']


}]);

angular.module('app.pages.users').controller('NewEducatorDialogController', ['$scope', '$rootScope', '$mdDialog','studentsEndpoint','student','$location','Notification', function ($scope, $rootScope, $mdDialog,studentsEndpoint,student,$location,Notification) {


    $scope.newEducator = {};
    $scope.newEducator.Email = angular.copy(student.selectedStudent.Email);

    /**
     * Save new Student
     */
    $scope.sendInvitationToNewEducator = function () {
        $scope.isClicked =true;
        studentsEndpoint.educator.post(student.selectedStudent,$scope.newEducator,function (data) {
            $scope.isClicked =false;
            if (!data.success)
                Notification.info("דואר אלקטרוני קיים עבור משתמש אחר");

            $mdDialog.hide();

        })
    };





    /**
     * Close the dialog
     */
    $scope.closeDialog =function () {
        $mdDialog.cancel();
    };



}]);

(function () {
    'use strict';

    angular
        .module('app.pages.branches', []).config(config).run(run);

    function run($rootScope, msNavigationService) {
        $rootScope.$watch('User', function () {

            /**
             * Set the pages by the admin level
             */
            if ($rootScope.AdminLevel && $rootScope.User) {
                msNavigationService.deleteItem('pages.branches');
                msNavigationService.saveItem('pages.branches', {
                    title: 'שלוחות',
                    icon: 'icon-domain',
                    weight: 2
                });
                switch ($rootScope.AdminLevel) {
                    case 1:
                        msNavigationService.deleteItem('pages.branches');
                        break;
                    case 2:
                        msNavigationService.saveItem('pages.branches.mange-branches', {
                            title: 'ניהול ' + $rootScope.User.Branches,
                            icon: 'icon-city',
                            state: 'app.pages_branches_mange-branches'
                        });
                        if($rootScope.User.BranchesPer){
                            msNavigationService.saveItem('pages.branches.mange-groups', {
                                title: 'ניהול ' + $rootScope.User.Groups,
                                icon: 'icon-account-multiple',
                                state: 'app.pages_branches_mange-groups'
                            });
                        }
                        break;
                    case 3:
                        msNavigationService.saveItem('pages.branches.mange-areas', {
                            title: 'ניהול אזורים ',
                            icon: 'icon-earth',
                            state: 'app.pages_branches_mange-areas'
                        });
                        msNavigationService.saveItem('pages.branches.mange-branches', {
                            title: 'ניהול ' + $rootScope.User.Branches,
                            icon: 'icon-city',
                            state: 'app.pages_branches_mange-branches'
                        });
                        msNavigationService.saveItem('pages.branches.mange-grades', {
                            title: 'ניהול ' + $rootScope.User.Grades,
                            icon: 'icon-chair-school',
                            state: 'app.pages_branches_mange-grades'
                        });
                        msNavigationService.saveItem('pages.branches.mange-groups', {
                            title: 'ניהול ' + $rootScope.User.Groups,
                            icon: 'icon-account-multiple',
                            state: 'app.pages_branches_mange-groups'
                        });


                }
            }
        });

    }

    /** @ngInject */
    function config($stateProvider) {
        // State
        $stateProvider
            .state('app.pages.branches', {
                abstract: true,
                url: '/branches'
            })
            .state('app.pages_branches_mange-branches', {
                url: '/mange-branches',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/pages/branches/views/branches/branches.html',
                        controller: 'BranchesController'
                    }
                },
                resolve: {
                    DashboardData: function (ValidToken) {
                        ValidToken.validUserToken();
                        localStorage.setItem("path", '/mange-branches');
                    }
                },
                bodyClass: 'mange-branches'

            })
            .state('app.pages_branches_mange-groups', {
                url: '/mange-groups',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/pages/branches/views/groups/mange-groups.html',
                        controller: 'ManageGroupsController'
                    }
                },
                resolve: {
                    DashboardData: function (ValidToken) {
                        ValidToken.validUserToken();
                        localStorage.setItem("path", '/mange-groups');
                    }
                },
                bodyClass: 'branches'
            })
            .state('app.pages_branches_mange-grades', {
                url: '/mange-grades',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/pages/branches/views/grades/mange-grades.html',
                        controller: 'ManageGradesController'
                    }
                },
                resolve: {
                    DashboardData: function (ValidToken) {
                        ValidToken.validUserToken();
                        localStorage.setItem("path", '/mange-grades');
                    }
                },
                bodyClass: 'branches'
            })
            .state('app.pages_branches_mange-areas', {
                url: '/mange-areas',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/pages/branches/views/areas/mange-areas.html',
                        controller: 'ManageAreasController as vm'
                    }
                },
                resolve: {
                    DashboardData: function (ValidToken) {
                        ValidToken.validUserToken();
                        localStorage.setItem("path", '/mange-areas');
                    }
                },
                bodyClass: 'areas'
            });
    }
})();


angular.module('app.pages.branches').controller('AddNewBranchTagDialogController', AddNewBranchTagDialogController);
function AddNewBranchTagDialogController($scope, $mdDialog,branchesEndpoint,Notification,systemSettingsEndpoint,branchID) {


    $scope.newTag = {};

    $scope.getTags = function (){
        systemSettingsEndpoint.names.get(function (data) {
            try {
                $scope.tags = JSON.parse(data.BranchesTags);
                if(!Array.isArray($scope.tags))
                    $scope.tags = [];
            } catch (e) {
                $scope.tags = [];
            }
        })
    }


    /**
     * Save new Branch
     */
    $scope.saveNewBranchTag = function () {
        $scope.isClicked = true;
        branchesEndpoint.tags.post(branchID,$scope.newTag, function (data) {
            $scope.isClicked = false;
            if (!data.success) {
                Notification.error("תגית כבר קיימת");
                $mdDialog.cancel();
            } else
                $mdDialog.hide();
        })
    };

    /**
     * Close the dialog
     */
    $scope.closeDialog = function () {
        $mdDialog.cancel();
    };

}

angular.module('app.pages.student-profile').controller('StudentProfileController', StudentProfileController);

function StudentProfileController($interval, $scope, $rootScope, $location, $timeout, usersEndpoint, $mdSidenav, $mdDialog, DTOptionsBuilder, $timeout, student, studentsEndpoint, parent, dtOptions, Notification, branchesEndpoint, gradesEndpoint, receiptsService, groupsEndpoint, DTColumnDefBuilder, tagsEndpoint, rolesEndpoint) {

    $scope.student = {
        Tags: [],
    };
    $scope.selectedTab = 0;
    $scope.count = 0;
    $scope.newUser = false;
    $scope.searchText = '';
    $scope.HMOS = ["קופת חולים מאוחדת", "מכבי שירות בריאות", "שירותי בריאות כללית", "לאומית שירותי בריאות", 'ללא קופת חולים'];
    $scope.Comments = [];

    $scope.registrations = [];
    $scope.studentsGroups = [];
    $scope.contactss = [];
    $scope.family = [];
    $scope.roles = [];
    $scope.branches = [];
    $scope.grades = [];
    $scope.externalStudent = false;
    $scope.querySearch = querySearch;
    if ($rootScope.brandName.toLowerCase() === 'noarlatet') {
        $scope.brandIsLatet = true;
    }
    /**
     * Set Table option
     * @type {any}
     */
    $scope.dtOptions = DTOptionsBuilder
        .newOptions()
        .withLanguage(dtOptions.language)
        .withDOM('lfrtp')
        .withOption('bFilter', false)
        .withDOM('lrtip');


    /**
     * Init Student Profile
     */
    function init() {
        var studentObject = {};
        studentObject.ID = $location.search().ID;
        if (!studentObject.ID) {
            $location.path('/students');
        } else {
            resolveStudent(studentObject);
        }
        $scope.currentStudentID = null;
        $scope.$watch(function () {
            return $location.search()
        }, function (data) {
            if ($scope.currentStudentID !== null && data.ID !== $scope.currentStudentID) {
                if (data.ID) {
                    studentObject = {};
                    studentObject.ID = data.ID;
                    if (!studentObject.ID) {
                        $location.path('/students');
                    } else {
                        resolveStudent(studentObject);
                    }
                }
            }
        });

    }

    init();
    $scope.setCity = function (city) {
        $scope.student.City = city.value;
    };

    /**
     * resolve the student by the ID stored in studentObject
     * @param studentObject
     */
    function resolveStudent(studentObject) {
        studentsEndpoint.get(studentObject, function (response) {
            if (response.data.items[0]) {
                $scope.student = response.data.items[0];
                // $scope.student.City = response.data.items[0].City;
                student.updateSelectedStudent($scope.student);
                $scope.getBranches();
                $scope.getGroupsByBranch();
                $scope.getGrades();
                setComments();
                getTags();
                getRoles();
                getExtraFields();
                getCity();
            } else
                $location.path('/student-profile');
        })
    }

    /**
     * Watch for changes in the student
     */
    $scope.$watch('student', function (newValue, oldValue) {
        if (typeof $rootScope.editDataHandler === 'function')
            $rootScope.editDataHandler(newValue, oldValue, 'student-panel');
    }, true);


    /**
     * Get All Tags
     */
    function getTags() {
        if (!Array.isArray($scope.student.Tags))
            $scope.student.Tags = [];
        var params = {};
        params.withNames = true;
        params.TagType = 1;
        tagsEndpoint.get(params, function (data) {
            $scope.tags = data;
        })
    }

    /**
     * Get Roles
     */
    function getRoles() {
        var params = {};
        params.withNames = true;
        rolesEndpoint.educator.get(params, function (data) {
            $scope.roles = data;
        })
    }

    function getExtraFields() {
        studentsEndpoint.studentExtraFieldsValues.get($scope.student.ID, function (data) {
            $scope.extraFields = data;
            if (data.length) {
                $scope.$watch('extraFields', function (newValue, oldValue) {
                    if (typeof $rootScope.editDataHandler === 'function')
                        $rootScope.editDataHandler(newValue, oldValue, 'student-extra-field-values')
                }, true);
            }
        });
    }

    /**
     * Branches query search
     * @param query
     * @returns {Array}
     */
    $scope.tagsQuerySearch = function (query) {
        return query ? $scope.tags.filter(createFilterForTags(query)) : [];
    };

    /**
     * Create filter for query from auto complete
     * @param query
     * @returns {filterFn}
     */
    function createFilterForTags(query) {
        var lowercaseQuery = angular.lowercase(query);
        return function filterFn(contact) {
            return (contact.Name.indexOf(lowercaseQuery) != -1);
        };
    }


    /**
     * Get All Branches And Groups
     */
    $scope.getBranches = function () {
        $scope.editEd = !$scope.editEd;
        var params = {};
        params.Status = 1;
        branchesEndpoint.get(params, function (data) {
            $scope.branches = data;
        });

    };

    /**
     * Get All Grades
     */
    $scope.getGrades = function () {
        $scope.grades = [];
        var params = {};
        params.Status = 1;
        gradesEndpoint.get(params, function (data) {
            $scope.grades = data;
        });
    };

    /**
     * Get group by branch
     */
    $scope.getGroupsByBranch = function () {
        var params = {};
        $scope.studentsGroups = [];
        params.GradeID = $scope.student.GradeID;
        params.BranchID = $scope.student.BranchID;
        $scope.studentsGroups = [];
        groupsEndpoint.get(params, function (data) {
            $scope.studentsGroups = data;
        });
    };

    $scope.setGroupEducator = function () {
        if ($scope.student.GroupID) {
            $scope.group = $scope.studentsGroups.find(function (group) {
                return group.ID === +$scope.student.GroupID;
            });
            $scope.educatorName = $scope.group.Educators.map(function (ed) {
                return ed.FirstName + ' ' + ed.LastName;
            }).join(', ');


        } else {
            $scope.educatorName = '';
        }
    };


    /**
     * If the grade is change alert the user to change the Scheduling
     */
    $scope.disableBranchChange = function () {
        $scope.getGroupsByBranch();
    };


    /**

     * Set Table option
     * @type {any}
     */
    $scope.dtOptions = DTOptionsBuilder
        .newOptions()
        .withLanguage(dtOptions.language)
        .withDOM('lfrtp')
        .withOption('bFilter', false)
        .withOption('order', [0, "desc"])
        .withOption('responsive', true)
        .withDOM('lrtip');

    /**
     * Get Student Family
     */
    $scope.getFamily = function () {
        $scope.editEd = true;
        $scope.family = [];
        var started = false;
        var interval = $interval(function () {
            if ($scope.student && $scope.student.ID && !started) {
                started = true;
                studentsEndpoint.family.get($scope.student.ID, function (data) {
                    $scope.family = data;
                });
                if (angular.isDefined(interval)) {
                    $interval.cancel(interval);
                }
            }
        }, 2000);
    };

    /**
     * Get Student History
     */
    $scope.getHistory = function () {
        $scope.editEd = true;
        $scope.history = [];
        if ($scope.student.ID) {
            studentsEndpoint.history.get($scope.student.ID, function (data) {
                $scope.history = data;
            });
        } else {
            $timeout(function () {
                $scope.getHistory();
            }, 500);
        }
    };

    /**
     * Get Student Registrations
     */
    $scope.getRegistrations = function () {
        $scope.registrations = [];
        var started = false;
        var interval = $interval(function () {
            if ($scope.student && $scope.student.ID && !started) {
                started = true;
                studentsEndpoint.registrations.get($scope.student.ID, function (data) {
                    $scope.registrations = data;
                });
                if (angular.isDefined(interval)) {
                    $interval.cancel(interval);
                }
            }
        }, 2000);
    };

    /**
     * Get Student Registrations
     */
    $scope.getContactForms = function () {
        $scope.contacts = [];
        var started = false;
        var interval = $interval(function () {
            if ($scope.student && $scope.student.ID && !started) {
                started = true;
                studentsEndpoint.contact.get($scope.student.ID, function (data) {
                    $scope.contactss = data;
                });
                if (angular.isDefined(interval)) {
                    $interval.cancel(interval);
                }
            }
        }, 2000);
    };

    /**
     * Get Student Registrations
     */
    $scope.getCancellationForms = function () {
        $scope.contacts = [];
        var started = false;
        var interval = $interval(function () {
            if ($scope.student && $scope.student.ID && !started) {
                started = true;
                studentsEndpoint.cancellation.get($scope.student.ID, function (data) {
                    $scope.cancellation = data;
                });
                if (angular.isDefined(interval)) {
                    $interval.cancel(interval);
                }
            }
        }, 2000);

    };

    /**
     * Open The Cancellation Dialog
     * @param cancel
     */
    $scope.openCancellationDialog = function (cancel) {
        $mdDialog.show({
            controller: 'CancellationDialogController',
            templateUrl: 'app/main/pages/forms-dialogs/cancellation-dialog/cancellation-dialog.html',
            clickOutsideToClose: true,
            locals: {'cancel': cancel}
        });
    };


    /**
     * Open The Contact Dialog
     * @param contactForm
     */
    $scope.openContactDialog = function (contactForm) {
        $mdDialog.show({
            controller: 'ContactDialogController',
            templateUrl: 'app/main/pages/forms-dialogs/contact-dialog/contact-dialog.html',
            clickOutsideToClose: true,
            locals: {'contactForm': contactForm}
        });
    };

    /**
     * Open Cancel Registration Dialog
     * @param registration
     */
    $scope.cancelRegistration = function (registration) {

        $mdDialog.show({
            controller: 'CancelRegistrationDialogController',
            templateUrl: 'app/main/pages/events-dialogs/cancel-registration-dialog/cancel-registration-dialog.html',
            locals: {'registration': registration, external: false},
            clickOutsideToClose: true
        }).then(function () {
            $scope.getRegistrations();
        });
    };


    /**
     * change to seblling profile
     * @param student
     */
    $scope.moveToProfile = function (student) {
        $scope.student = student;
        student.selectedStudent = student;
        $scope.getFamily();
        $scope.getRegistrations();
        $scope.getContactForms();
        $scope.getCancellationForms();
        $scope.selectedTab = 0;
    };

    /**
     * Edit parent
     * @param selectedParent
     */
    $scope.editParent = function (selectedParent) {
        $mdSidenav("parent-panel").open();
        parent.updateSelectedParent(selectedParent);
    };


    /**
     * Dialog for delete parent
     * @param selectedParent
     * @param ev
     */
    $scope.deleteParentDialog = function (selectedParent, ev) {
        var confirm = $mdDialog.confirm()
            .title('מחיקת הורה')
            .textContent('האם אתה בטוח/ה שברצונך למחוק הורה?')
            .targetEvent(ev)
            .ok('מחק')
            .cancel('ביטול');
        $mdDialog.show(confirm).then(function () {
            deleteParent(selectedParent);
        });
    };


    /**
     * Delete Parent from studnet
     * @param selectedParent
     */
    var deleteParent = function (selectedParent) {
        var index = $scope.family.indexOf(selectedParent);
        $scope.family.splice(index, 1);
        studentsEndpoint.parent.delete.post($scope.student.ID, selectedParent.ID, function (data) {
            if (!data.success) {
                $scope.family.push(selectedParent);
                Notification.error("שגיאה 2")
            }
        })
    };

    /**
     * Open new parent dialog
     */
    $scope.openNewParentDialog = function () {
        $mdDialog.show({
            controller: 'NewParentDialogController',
            templateUrl: 'app/main/pages/users/views/students/student-profile/new-parent-dialog/new-parent-dialog.html',
            clickOutsideToClose: true
        }).then(function () {
            $scope.getFamily();
            $scope.getRegistrations();
            $scope.getContactForms();
            $scope.getCancellationForms();

        });

    };

    /**
     * open create new Educator dialog
     */
    $scope.openNewEducatorDialog = function () {
        $mdDialog.show({
            controller: 'NewEducatorDialogController',
            templateUrl: 'app/main/pages/users/views/students/student-profile/new-educator-dialog/new-educator-dialog.html',
            clickOutsideToClose: true
        })
    };


    /**
     * Show Fill Reg
     * @param registration
     */
    $scope.showFullRegistration = function (registration) {
        $mdDialog.show({
            controller: 'FullRegistrationDialogController',
            templateUrl: 'app/main/pages/events-dialogs/full-registration-dialog/full-registration-dialog.html',
            clickOutsideToClose: true,
            locals: {'registration': registration}
        })
    };


    /**
     * Open Cancel Registration Dialog
     * @param registration
     */
    $scope.refundRegistration = function (registration) {

        $mdDialog.show({
            controller: 'RefundRegistrationDialogController',
            templateUrl: 'app/main/pages/events-dialogs/refund-registration-dialog/refund-registration-dialog.html',
            locals: {'registration': registration, external: false},
            clickOutsideToClose: true
        }).then(function () {
            $scope.getRegistrations();
        });
    };


    /**
     * Open Cancel Registration Dialog
     * @param registration
     */
    $scope.cancelRegistration = function (registration) {

        $mdDialog.show({
            controller: 'CancelRegistrationDialogController',
            templateUrl: 'app/main/pages/events-dialogs/cancel-registration-dialog/cancel-registration-dialog.html',
            locals: {'registration': registration, external: false},
            clickOutsideToClose: true
        }).then(function () {
            $scope.getRegistrations();
        });
    };


    /**
     * Download receipt
     * @param receiptID
     * @param type
     */
    $scope.downloadReceipt = function (receiptID, type) {
        Notification.info("מייצר קבלה..אנא המתן");
        receiptsService.getReceiptByID(receiptID, type)
    };


    function getCity() {
        $scope.simulateQuery = false;
        $scope.isDisabled = false;
        $scope.states = loadAll();
        $scope.searchText = $scope.student.City;
        $scope.querySearch = querySearch;
    }

    /**
     * Search for states... use $timeout to simulate
     * remote dataservice call.
     */
    function querySearch(query) {
        var source = $scope.states;
        var results = query ? source.filter(createFilterFor(query)) : source,
            deferred;
        if ($scope.simulateQuery) {
            deferred = $q.defer();
            $timeout(function () {
                deferred.resolve(results);
            }, Math.random() * 1000, false);
            return deferred.promise;
        } else {
            return results;
        }
    }

    /**
     * Set City
     * @param city
     */
    $scope.setCity = function (city) {
        $scope.student.City = city.value;
    };


    /**
     * Build `states` list of key/value pairs
     */
    function loadAll() {

        var allStates = 'אבו גוש,אבו סנאן,אבו קורינאת (יישוב),אבו תלול,אבטין,אבטליון,אביאל,אביבים,אביגדור,אביחיל,\n' +
            'אביטל,אביעזר,אבירים,אבן יהודה,אבן מנחם,אבן ספיר,אבן שמואל,אבני איתן,אבני חפץ,אבנת,\n' +
            'אבשלום,אדורה,אדירים,אדמית,אדרת,אודים,אודם,אוהד,אום אל-פחם,אום אל-קוטוף,\n' +
            'אום בטין,אומן,אומץ,אופקים,אור הגנוז,אור הנר,אור יהודה,אור עקיבא,אורה,אורות,\n' +
            'אורטל,אורים,אורנים,אורנית,אושה,אזור,אחווה,אחוזם,אחוזת ברק,אחיהוד,\n' +
            'אחיטוב,אחיסמך,אחיעזר,איבים,אייל,איילת השחר,אילון,אילות,אילנייה,אילת,\n' +
            'אירוס,איתמר,איתן,איתנים,אכסאל,אל -עזי,אל -עריאן,אל -רום,אל סייד,אלומה,\n' +
            'אלומות,אלון הגליל,אלון מורה,אלון שבות,אלוני אבא,אלוני הבשן,אלוני יצחק,אלונים,אלי-עד,אליאב,\n' +
            'אליכין,אליפז,אליפלט,אליקים,אלישיב,אלישמע,אלמגור,אלמוג,אלעד,אלעזר,\n' +
            'אלפי מנשה,אלקוש,אלקנה,אמונים,אמירים,אמנון,אמציה,אניעם,אספר,אעבלין,\n' +
            'אפיק,אפיקים,אפק,אפרת,ארבל,ארגמן,ארז,אריאל,ארסוף,אשבול,\n' +
            'אשבל,אשדוד,אשדות יעקב (איחוד),אשדות יעקב (מאוחד),אשחר,אשכולות,אשל הנשיא,אשלים,אשקלון,אשרת,\n' +
            'אשתאול,באקה אל-גרביה,באר אורה,באר גנים,באר טוביה,באר יעקב,באר מילכה,באר שבע,בארות יצחק,בארותיים,\n' +
            'בארי,בוסתן הגליל,בועיינה-נוג\'ידאת,בוקעאתא,בורגתה,בחן,בטחה,ביצרון,ביר אל-מכסור,ביר הדאג\',\n' +
            'בירייה,בית אורן,בית אל,בית אלעזרי,בית אלפא,בית אריה,בית ברל,בית ג\'ן,בית גוברין,בית גמליאל,\n' +
            'בית דגן,בית הגדי,בית הלוי,בית הלל,בית העמק,בית הערבה,בית השיטה,בית זיד,בית זית,בית זרע,\n' +
            'בית חורון,בית חירות,בית חלקיה,בית חנן,בית חנניה,בית חשמונאי,בית יהושע,בית יוסף,בית ינאי,בית יצחק-שער חפר,\n' +
            'בית לחם הגלילית,בית מאיר,בית נחמיה,בית ניר,בית נקופה,בית עובד,בית עוזיאל,בית עזרא,בית עריף,בית צבי,\n' +
            'בית קמה,בית קשת,בית רבן,בית רימון,בית שאן,בית שמש,בית שערים,בית שקמה,ביתן אהרן,ביתר עילית,\n' +
            'בלפוריה,בן זכאי,בן עמי,בן שמן (כפר נוער),בן שמן (מושב),בני ברק,בני דקלים,בני דרום,בני דרור,בני יהודה,\n' +
            'בני נצרים,בני עטרות,בני עי"ש,בני ציון,בני ראם,בניה,בנימינה-גבעת עדה*,בסמ"ה,בסמת טבעון,בענה,\n' +
            'בצרה,בצת,בקוע,בקעות,בר גיורא,בר יוחאי,ברוכין,ברור חיל,ברוש,ברכה,\n' +
            'ברכיה,ברעם,ברק,ברקאי,ברקן,ברקת,בת הדר,בת חן,בת חפר,בת ים,\n' +
            'בת עין,בת שלמה,ג\'דיידה-מכר,ג\'ולס,ג\'לג\'וליה,ג\'סר א-זרקא,ג\'ש (גוש חלב),ג\'ת,גאולי תימן,גאולים,\n' +
            'גאליה,גבולות,גבים,גבע,גבע בנימין,גבע כרמל,גבעולים,גבעון החדשה,גבעות בר,גבעת אבני,\n' +
            'גבעת אלה,גבעת ברנר,גבעת השלושה,גבעת זאב,גבעת ח"ן,גבעת חיים (איחוד),גבעת חיים (מאוחד),גבעת יואב,גבעת יערים,גבעת ישעיהו,\n' +
            'גבעת כ"ח,גבעת ניל"י,גבעת עוז,גבעת שמואל,גבעת שמש,גבעת שפירא,גבעתי,גבעתיים,גברעם,גבת,\n' +
            'גדות,גדיש,גדעונה,גדרה,גונן,גורן,גורנות הגליל,גזית,גזר,גיאה,\n' +
            'גיבתון,גיזו,גילון,גילת,גינוסר,גיניגר,גינתון,גיתה,גיתית,גלאון,\n' +
            'גלגל,גליל ים,גלעד (אבן יצחק),גמזו,גן הדרום,גן השומרון,גן חיים,גן יאשיה,גן יבנה,גן נר,\n' +
            'גן שורק,גן שלמה,גן שמואל,גנות,גנות הדר,גני הדר,גני טל,גני יוחנן,גני עם,גני תקווה,\n' +
            'געש,געתון,גפן,גרופית,גשור,גשר,גשר הזיו,גת (קיבוץ),גת רימון,דאלית אל-כרמל,\n' +
            'דבורה,דבורייה,דבירה,דברת,דגניה א\',דגניה ב\',דוב"ב,דולב,דור,דורות,\n' +
            'דחי,דייר אל-אסד,דייר חנא,דייר ראפאת,דימונה,דישון,דלייה,דלתון,דמיידה,דן,\n' +
            'דפנה,דקל,דריג\'את,האון,הבונים,הגושרים,הדר עם,הוד השרון,הודיות,הודייה,\n' +
            'הושעיה,הזורע,הזורעים,החותרים,היוגב,הילה,המעפיל,הסוללים,העוגן,הר אדר,\n' +
            'הר גילה,הר עמשא,הראל,הרדוף,הרצלייה,הררית,ורד יריחו,ורדון,זבדיאל,זוהר,\n' +
            'זיקים,זיתן,זכרון יעקב,זכריה,זמר,זמרת,זנוח,זרועה,זרזיר,זרחיה,\n' +
            'ח\'ואלד,חבצלת השרון,חבר,חגור,חגי,חגלה,חד-נס,חדיד,חדרה,חוג\'ייראת (ד\'הרה) (שבט),\n' +
            'חולדה,חולון,חולית,חולתה,חוסן,חוסנייה,חופית,חוקוק,חורה,חורפיש,\n' +
            'חורשים,חזון,חיבת ציון,חיננית,חיפה,חירות,חלוץ,חלמיש,חלץ,חמאם,\n' +
            'חמד,חמדיה,חמדת,חמרה,חניאל,חניתה,חנתון,חספין,חפץ חיים,חפצי-בה,\n' +
            'חצב,חצבה,חצור הגלילית,חצור-אשדוד,חצרים,חרב לאת,חרוצים,חריש,חרמש,חרשים,\n' +
            'חשמונאים,טבריה,טובא-זנגרייה,טורעאן,טייבה,טייבה (בעמק),טירה,טירת יהודה,טירת כרמל,טירת צבי,\n' +
            'טל שחר,טל-אל,טללים,טלמון,טמרה,טמרה (יזרעאל),טנא,טפחות,יאנוח-ג\'ת,יבול,\n' +
            'יבנאל,יבנה,יגור,יגל,יד בנימין,יד השמונה,יד חנה,יד מרדכי,יד נתן,יד רמב"ם,\n' +
            'ידידה,יהוד,יהל,יובל,יובלים,יודפת,יונתן,יושיביה,יזרעאל,יחיעם,\n' +
            'יטבתה,ייט"ב,יכיני,ינוב,ינון,יסוד המעלה,יסודות,יסעור,יעד,יעל,\n' +
            'יעף,יערה,יפיע,יפית,יפעת,יפתח,יצהר,יציץ,יקום,יקיר,\n' +
            'יקנעם (מושבה),יקנעם עילית,יראון,ירדנה,ירוחם,ירושלים,ירחיב,ירכא,ירקונה,ישע,\n' +
            'ישעי,ישרש,יתד,כאבול,כאוכב אבו אל-היג\'א,כברי,כדורי,כדיתה,כוכב השחר,כוכב יאיר,\n' +
            'כוכב יעקב,כוכב מיכאל,כורזים,כחל,כחלה,כיסופים,כישור,כליל,כלנית,כמאנה,\n' +
            'כמהין,כמון,כנות,כנף,כנרת (מושבה),כנרת (קבוצה),כסיפה,כסלון,כסרא-סמיע,כעביה-טבאש-חג\'אג\'רה,\n' +
            'כפר אביב,כפר אדומים,כפר אוריה,כפר אחים,כפר ביאליק,כפר ביל"ו,כפר בלום,כפר בן נון,כפר ברא,כפר ברוך,\n' +
            'כפר גדעון,כפר גלים,כפר גליקסון,כפר גלעדי,כפר דניאל,כפר האורנים,כפר החורש,כפר המכבי,כפר הנגיד,כפר הנוער הדתי,\n' +
            'כפר הנשיא,כפר הס,כפר הרא"ה,כפר הרי"ף,כפר ויתקין,כפר ורבורג,כפר ורדים,כפר זוהרים,כפר זיתים,כפר חב"ד,\n' +
            'כפר חושן,כפר חיטים,כפר חיים,כפר חנניה,כפר חסידים א\',כפר חסידים ב\',כפר חרוב,כפר טרומן,כפר יאסיף,כפר ידידיה,\n' +
            'כפר יהושע,כפר יונה,כפר יחזקאל,כפר יעבץ,כפר כמא,כפר כנא,כפר מונש,כפר מימון,כפר מל"ל,כפר מנדא,\n' +
            'כפר מנחם,כפר מסריק,כפר מצר,כפר מרדכי,כפר נטר,כפר סאלד,כפר סבא,כפר סילבר,כפר סירקין,כפר עבודה,\n' +
            'כפר עזה,כפר עציון,כפר פינס,כפר קאסם,כפר קיש,כפר קרע,כפר ראש הנקרה,כפר רוזנואלד (זרעית),כפר רופין,כפר רות,\n' +
            'כפר שמאי,כפר שמואל,כפר שמריהו,כפר תבור,כפר תפוח,כרכום,כרם בן זמרה,כרם בן שמן,כרם יבנה (ישיבה),כרם מהר"ל,\n' +
            'כרם שלום,כרמי יוסף,כרמי צור,כרמיאל,כרמייה,כרמים,כרמל,לבון,לביא,לבנים,\n' +
            'להב,להבות הבשן,להבות חביבה,להבים,לוד,לוזית,לוחמי הגיטאות,לוטם,לוטן,לימן,\n' +
            'לכיש,לפיד,לפידות,לקיה,מאור,מאיר שפיה,מבוא ביתר,מבוא דותן,מבוא חורון,מבוא חמה,\n' +
            'מבוא מודיעים,מבואות ים,מבועים,מבטחים,מבקיעים,מבשרת ציון,מג\'ד אל-כרום,מג\'דל שמס,מגאר,מגדים,\n' +
            'מגדל,מגדל העמק,מגדל עוז,מגדלים,מגידו,מגל,מגן,מגן שאול,מגשימים,מדרך עוז,\n' +
            'מדרשת בן גוריון,מדרשת רופין,מודיעין עילית,מודיעין-מכבים-רעות*,מולדה*,מולדת,מוצא עילית,מוקייבלה,מורן,מורשת,\n' +
            'מזור,מזכרת בתיה,מזרע,מזרעה,מחולה,מחנה הילה*,מחנה טלי*,מחנה יהודית*,מחנה יוכבד*,מחנה יפה*,\n' +
            'מחנה מרים*,מחנה תל נוף*,מחניים,מחסיה,מטולה,מטע,מי עמי,מיטב,מייסר,מיצר,\n' +
            'מירב,מירון,מישר,מיתר,מכורה,מכחול,מכמורת,מכמנים,מלאה,מלילות,\n' +
            'מלכייה,מלכישוע,מנוחה,מנוף,מנות,מנחמיה,מנרה,מנשית זבדה,מסד,מסדה,\n' +
            'מסילות,מסילת ציון,מסלול,מסעדה,מעברות,מעגלים,מעגן,מעגן מיכאל,מעוז חיים,מעון,\n' +
            'מעונה,מעיין ברוך,מעיין צבי,מעיליא,מעלה אדומים,מעלה אפרים,מעלה גלבוע,מעלה גמלא,מעלה החמישה,מעלה לבונה,\n' +
            'מעלה מכמש,מעלה עירון,מעלה עמוס,מעלה שומרון,מעלות-תרשיחא,מענית,מעש,מפלסים,מצדות יהודה,מצובה,\n' +
            'מצליח,מצפה,מצפה אבי"ב,מצפה אילן,מצפה יריחו,מצפה נטופה,מצפה רמון,מצפה שלם,מצר,מרגליות,\n' +
            'מרום גולן,מרחב עם,מרחביה (מושב),מרחביה (קיבוץ),מרכז שפירא,משאבי שדה,משגב דב,משגב עם,משהד,משואה,\n' +
            'משואות יצחק,משכיות,משמר איילון,משמר דוד,משמר הירדן,משמר הנגב,משמר העמק,משמר השבעה,משמר השרון,משמרות,\n' +
            'משמרת,משען,מתן,מתת,מתתיהו,נאות גולן,נאות הכיכר,נאות מרדכי,נאות סמדר,נאעורה,\n' +
            'נבטים,נגבה,נגוהות,נהורה,נהלל,נהרייה,נוב,נוגה,נווה,נווה אור,\n' +
            'נווה אטי"ב,נווה אילן,נווה איתן,נווה דניאל,נווה זוהר,נווה זיו,נווה חריף,נווה ים,נווה ימין,נווה ירק,\n' +
            'נווה מבטח,נווה מיכאל,נווה שלום,נועם,נוף איילון,נופים,נופית,נופך,נוקדים,נורדייה,\n' +
            'נורית,נחושה,נחל עוז,נחלה,נחליאל,נחלים,נחם,נחף,נחשולים,נחשון,\n' +
            'נחשונים,נטועה,נטור,נטע,נטעים,נטף,ניין,ניל"י,ניצן,ניצן ב\',\n' +
            'ניצנה (קהילת חינוך),ניצני סיני,ניצני עוז,ניצנים,ניר אליהו,ניר בנים,ניר גלים,ניר דוד (תל עמל),ניר ח"ן,ניר יפה,\n' +
            'ניר יצחק,ניר ישראל,ניר משה,ניר עוז,ניר עם,ניר עציון,ניר עקיבא,ניר צבי,נירים,נירית,\n' +
            'נירן,נס הרים,נס עמים,נס ציונה,נעורים,נעלה,נעמ"ה,נען,נצר חזני,נצר סרני,\n' +
            'נצרת,נצרת עילית,נשר,נתיב הגדוד,נתיב הל"ה,נתיב העשרה,נתיב השיירה,נתיבות,נתניה,סאג\'ור,\n' +
            'סאסא,סביון*,סגולה,סואעד (חמרייה)*,סולם,סוסיה,סופה,סח\'נין,סלמה,סלעית,\n' +
            'סמר,סנסנה,סעד,סער,ספיר,סתרייה,ע\'ג\'ר,עבדון,עברון,עגור,\n' +
            'עדי,עדנים,עוזה,עוזייר,עולש,עומר,עופר,עוצם,עזוז,עזר,\n' +
            'עזריאל,עזריה,עזריקם,עטרת,עידן,עיילבון,עיינות,עילוט,עין איילה,עין אל-אסד,\n' +
            'עין גב,עין גדי,עין דור,עין הבשור,עין הוד,עין החורש,עין המפרץ,עין הנצי"ב,עין העמק,עין השופט,\n' +
            'עין השלושה,עין ורד,עין זיוון,עין חוד,עין חצבה,עין חרוד (איחוד),עין חרוד (מאוחד),עין יהב,עין יעקב,עין כרם-בי"ס חקלאי,\n' +
            'עין כרמל,עין מאהל,עין נקובא,עין עירון,עין צורים,עין קנייא,עין ראפה,עין שמר,עין שריד,עין תמר,\n' +
            'עינת,עיר אובות,עכו,עלומים,עלי,עלי זהב,עלמה,עלמון,עמוקה,עמינדב,\n' +
            'עמיעד,עמיעוז,עמיקם,עמיר,עמנואל,עמקה,ענב,עספיא,עפולה,עפרה,\n' +
            'עץ אפרים,עצמון שגב,עראבה,עשהאל,עראמשה*,ערב אל נעים,ערד,ערוגות,ערערה,ערערה-בנגב,עשרת,\n' +
            'עתלית,עתניאל,פארן,פדואל,פדויים,פדיה,פוריידיס,פורייה - כפר עבודה,פורייה - נווה עובד,פורייה עילית,\n' +
            'פורת,פטיש,פלך,פלמחים,פני חבר,פסגות,פסוטה,פעמי תש"ז,פצאל,פקיעין (בוקייעה),\n' +
            'פקיעין חדשה,פרדס חנה-כרכור,פרדסייה,פרוד,פרזון,פרי גן,פתח תקווה,פתחיה,צאלים,צביה,\n' +
            'צבעון,צובה,צוחר,צופייה,צופים,צופית,צופר,צוקי ים,צוקים,צור הדסה,\n' +
            'צור יצחק,צור משה,צור נתן,צוריאל,צורית,ציפורי,צלפון,צנדלה,צפרייה,צפרירים,\n' +
            'צפת,צרופה,צרעה,קבוצת יבנה,קדומים,קדימה-צורן,קדמה,קדמת צבי,קדר,קדרון,\n' +
            'קדרים,קוממיות,קורנית,קטורה,קיסריה,קלחים,קליה,קלנסווה,קלע,קציר,\n' +
            'קצר א-סר,קצרין,קריית אונו,קריית ארבע,קריית אתא,קריית ביאליק,קריית גת,קריית טבעון,קריית ים,קריית יערים,\n' +
            'קריית יערים (מוסד),קריית מוצקין,קריית מלאכי,קריית נטפים,קריית ענבים,קריית עקרון,קריית שלמה,קריית שמונה,קרני שומרון,קשת,\n' +
            'ראמה,ראס אל-עין,ראס עלי,ראש העין,ראש פינה,ראש צורים,ראשון לציון,רבבה,רבדים,רביבים,\n' +
            'רביד,רגבה,רגבים,רהט,רווחה,רוויה,רוח מדבר,רוחמה,רומאנה,רומת הייב,\n' +
            'רועי,רותם,רחוב,רחובות,רחלים,ריחאנייה,ריחן,ריינה,רימונים,רינתיה,\n' +
            'רכסים,רם-און,רמות,רמות השבים,רמות מאיר,רמות מנשה,רמות נפתלי,רמלה,רמת גן,רמת דוד,\n' +
            'רמת הכובש,רמת השופט,רמת השרון,רמת יוחנן,רמת ישי,רמת מגשימים,רמת צבי,רמת רזיאל,רמת רחל,רנן,\n' +
            'רעים,רעננה,רקפת,רשפון,רשפים,רתמים,שאר ישוב,שבי ציון,שבי שומרון,שבלי - אום אל-גנם,\n' +
            'שגב-שלום,שדה אילן,שדה אליהו,שדה אליעזר,שדה בוקר,שדה דוד,שדה ורבורג,שדה יואב,שדה יעקב,שדה יצחק,\n' +
            'שדה משה,שדה נחום,שדה נחמיה,שדה ניצן,שדה עוזיהו,שדה צבי,שדות ים,שדות מיכה,שדי אברהם,שדי חמד,\n' +
            'שדי תרומות,שדמה,שדמות דבורה,שדמות מחולה,שדרות,שואבה,שובה,שובל,שוהם,שומרה,\n' +
            'שומרייה,שוקדה,שורש,שורשים,שושנת העמקים,שזור,שחר,שחרות,שיבולים,שיטים,\n' +
            'שייח\' דנון,שילה,שילת,שכניה,שלווה,שלווה במדבר,שלוחות,שלומי,שלומית,שמיר,\n' +
            'שמעה,שמרת,שמשית,שניר,שעב,שעל,שעלבים,שער אפרים,שער הגולן,שער העמקים,\n' +
            'שער מנשה,שערי תקווה,שפיים,שפיר,שפר,שפרעם,שקד,שקף,שרונה,שריגים (לי-און),\n' +
            'שריד,שרשרת,שתולה,שתולים,תאשור,תדהר,תובל,תומר,תושייה,תימורים,\n' +
            'תירוש,תל אביב -יפו,תל יוסף,תל יצחק,תל מונד,תל עדשים,תל קציר,תל שבע,תל תאומים,תלם,\n' +
            'תלמי אליהו,תלמי אלעזר,תלמי ביל"ו,תלמי יוסף,תלמי יחיאל,תלמי יפה,תלמים,תמרת,תנובות,תעוז,\n' +
            'תפרח,תקומה,תקוע,תרבין א-צאנע (יישוב)*,תרום,';

        return allStates.split(',').map(function (state) {
            return {
                value: state,
                display: state
            };
        });
    }

    /**
     * Create filter function for a query string
     */
    function createFilterFor(query) {
        var lowercaseQuery = angular.lowercase(query);

        return function filterFn(state) {
            return (state.display.trim().indexOf(lowercaseQuery) === 0);
        };

    }

    /**
     * Look for changes in the branch
     */
    $scope.$watchCollection('branch', function (newValue, oldValue) {
        if (typeof $rootScope.editDataHandler === 'function')
            $rootScope.editDataHandler(newValue, oldValue, 'branch-panel')
    })

    jQuery.extend(jQuery.fn.dataTableExt.oSort, {
        "eu-date-pre": function (a) {
            if (a == null || a == '') {
                return 0;
            }
            var date = a.split('/');
            return Date.parse(date[1] + '/' + date[0] + '/' + date[2])
        }
    });

    $scope.dtColumnDefs = [
        DTColumnDefBuilder.newColumnDef(1)
            .withOption('type', 'eu-date')
    ];


    /**
     * Get Payment Type
     * @param registrationValue
     * @returns {string}
     */
    $scope.getPaymentType = function (registrationValue) {
        switch (registrationValue.PaymentType) {
            case -1:
            case '-1':
                return 'מעורב';
            case 0:
            case "0":
                return "ללא עלות";
                break;
            case 1:
            case "1":
                return "אשראי";
                break;
            case 2:
            case "2":
                return "מזומן";
                break;
            case 3:
            case "3":
                return "העברה בנקאית";
                break;
            case 4:
            case "4":
                return "צ'ק";
                break;
            case 5:
            case "5":
                return "טופס התחייבות";
                break;
                case 7:
            case "7":
                return "יתרת הורה";
                break;
            default:
                return "ללא עלות";
                break;
        }
    };


    /**
     * Add comments in Staff
     */
    $scope.addComment = function () {
        var content = $rootScope.commentText;
        content = content.replace(/(\r\n|\n|\r)/gm, "<br>");
        var comment = {};
        comment.badgeClass = 'info';
        //comment.badgeIconClass='glyphicon-check';
        comment.user = $rootScope.User.FirstName + " " + $rootScope.User.LastName;
        comment.content = content;
        comment.date = Date.now();
        $scope.Comments.splice(0, 0, comment);

        var dopComments = angular.copy($scope.Comments);
        dopComments = JSON.stringify(dopComments);
        $scope.student.Comments = dopComments;
        $rootScope.commentText = '';


    };

    /**
     * Set Comments
     */
    function setComments() {
        if ($scope.student.Comments)
            $scope.Comments = JSON.parse($scope.student.Comments);
        else
            $scope.Comments = [];
    }

}

angular.module('app.pages.users').controller('NewStudentsDialogController', ['$scope', '$rootScope', '$mdDialog', 'studentsEndpoint', 'student', '$location', 'Notification', 'privateIDCheck', 'branchesEndpoint', 'gradesEndpoint', function ($scope, $rootScope, $mdDialog, studentsEndpoint, student, $location, Notification, privateIDCheck, branchesEndpoint, gradesEndpoint) {
    $scope.newStudent = {};
    /**
     * Save new Student
     */
    $scope.saveNesStudent = function () {

        if (!$scope.tz) {
            if (privateIDCheck.privateIDCheck($scope.newStudent.PrivateID) === false) {
                Notification.error("תעודות זהות של החניך לא תקינה");
                return;
            }

            if ($scope.newStudent.Parent1 && $scope.newStudent.Parent1 !== '') {
                if (privateIDCheck.privateIDCheck($scope.newStudent.Parent1) === false) {
                    Notification.error("תעודות זהות של הורה 1 לא תקינה");
                    return;
                }
            }

            if ($scope.newStudent.Parent2 && $scope.newStudent.Parent2 !== '') {
                if (privateIDCheck.privateIDCheck($scope.newStudent.Parent2) === false) {
                    Notification.error("תעודות זהות של הורה 2 לא תקינה");
                    return;
                }
            }
        }
        $scope.isClicked = true;
        studentsEndpoint.post($scope.newStudent, function (data) {
            $scope.isClicked = false;
            if (data.ID) {
                location.href = "/student-profile?ID=" + data.ID;
                $mdDialog.hide();
            } else {
                Notification.info("נכשל ביצירה : תועדה מזהה/דרכון קיימים במערכת")
            }
        })

    };

    /**
     * Change the pattern to passport
     * @constructor
     */
    $scope.ChangeToPassport = function () {
        $scope.tz = !$scope.tz
    };

    /**
     * Get All Branches And Groups
     */
    $scope.getBranches = function (external) {
        $scope.editEd = !$scope.editEd;
        var params = {};
        params.Status = 1;
        branchesEndpoint.get(params, function (data) {
            $scope.branches = data;
        });

    };

    /**
     * Get All Grades
     */
    $scope.getGrades = function () {
        $scope.grades = [];
        var params = {};
        params.Status = 1;
        gradesEndpoint.get(params, function (data) {
            $scope.grades = data;
        });
    };


    /**
     * Close the dialog
     */
    $scope.closeDialog = function () {
        $mdDialog.cancel();
    };

    /**
     * If its a TZ add ng-pattern for tz
     * @returns {*}
     */
    $scope.pattern = function () {
        if (!$scope.tz)
            return "/^[0-9]{9,9}$/";
        return "";
    };
}]);

angular.module('app.pages.users').controller('StudentPanelController', ['$scope', 'student', '$rootScope', '$timeout', 'gradesEndpoint', function ($scope, student, $rootScope, $timeout, gradesEndpoint) {

    /**
     * Set the selected student
     */
    $scope.$on('selectedStudent:updated', function () {
        $scope.student = student.selectedStudent;
        $scope.searchText = null;
        $scope.selectedItem = null;
        $scope.searchText = $scope.student.City;
        $scope.getGrades();
    });
    if ($rootScope.brandName.toLowerCase() === 'noarlatet') {
        $scope.brandIsLatet = true;
    }
    /**
     * Change all fields
     */
    $scope.changeAllFields = function () {
        $scope.allFields = !$scope.allFields;
    };

    /**
     * Get Grades
     */
    $scope.getGrades = function () {
        var params = {};
        params.Status = 1;
        gradesEndpoint.get(params, function (data) {
            $scope.grades = data;
        })
    };

    /**
     * Look for changes in the student object
     */
    $scope.$watchCollection('student', function (newValue, oldValue) {
        $rootScope.editDataHandler(newValue, oldValue, 'student-panel')
    });

    $scope.setCity = function (city) {
        $scope.student.City = city.value;
    };



    $scope.simulateQuery = false;
    $scope.isDisabled = false;

    // list of `state` value/display objects
    $scope.states = loadAll();
    $scope.querySearch = querySearch;


    // ******************************
    // Internal methods
    // ******************************

    /**
     * Search for states... use $timeout to simulate
     * remote dataservice call.
     */
    function querySearch(query) {
        var source = $scope.states;
        var results = query ? source.filter(createFilterFor(query)) : source,
            deferred;
        if ($scope.simulateQuery) {
            deferred = $q.defer();
            $timeout(function () {
                deferred.resolve(results);
            }, Math.random() * 1000, false);
            return deferred.promise;
        } else {
            return results;
        }
    }


    /**
     * Build `states` list of key/value pairs
     */
    function loadAll() {

        var allStates = 'אבו גוש,אבו סנאן,אבו קורינאת (יישוב),אבו תלול,אבטין,אבטליון,אביאל,אביבים,אביגדור,אביחיל,\n' +
            'אביטל,אביעזר,אבירים,אבן יהודה,אבן מנחם,אבן ספיר,אבן שמואל,אבני איתן,אבני חפץ,אבנת,\n' +
            'אבשלום,אדורה,אדירים,אדמית,אדרת,אודים,אודם,אוהד,אום אל-פחם,אום אל-קוטוף,\n' +
            'אום בטין,אומן,אומץ,אופקים,אור הגנוז,אור הנר,אור יהודה,אור עקיבא,אורה,אורות,\n' +
            'אורטל,אורים,אורנים,אורנית,אושה,אזור,אחווה,אחוזם,אחוזת ברק,אחיהוד,\n' +
            'אחיטוב,אחיסמך,אחיעזר,איבים,אייל,איילת השחר,אילון,אילות,אילנייה,אילת,\n' +
            'אירוס,איתמר,איתן,איתנים,אכסאל,אל -עזי,אל -עריאן,אל -רום,אל סייד,אלומה,\n' +
            'אלומות,אלון הגליל,אלון מורה,אלון שבות,אלוני אבא,אלוני הבשן,אלוני יצחק,אלונים,אלי-עד,אליאב,\n' +
            'אליכין,אליפז,אליפלט,אליקים,אלישיב,אלישמע,אלמגור,אלמוג,אלעד,אלעזר,\n' +
            'אלפי מנשה,אלקוש,אלקנה,אמונים,אמירים,אמנון,אמציה,אניעם,אספר,אעבלין,\n' +
            'אפיק,אפיקים,אפק,אפרת,ארבל,ארגמן,ארז,אריאל,ארסוף,אשבול,\n' +
            'אשבל,אשדוד,אשדות יעקב (איחוד),אשדות יעקב (מאוחד),אשחר,אשכולות,אשל הנשיא,אשלים,אשקלון,אשרת,\n' +
            'אשתאול,באקה אל-גרביה,באר אורה,באר גנים,באר טוביה,באר יעקב,באר מילכה,באר שבע,בארות יצחק,בארותיים,\n' +
            'בארי,בוסתן הגליל,בועיינה-נוג\'ידאת,בוקעאתא,בורגתה,בחן,בטחה,ביצרון,ביר אל-מכסור,ביר הדאג\',\n' +
            'בירייה,בית אורן,בית אל,בית אלעזרי,בית אלפא,בית אריה,בית ברל,בית ג\'ן,בית גוברין,בית גמליאל,\n' +
            'בית דגן,בית הגדי,בית הלוי,בית הלל,בית העמק,בית הערבה,בית השיטה,בית זיד,בית זית,בית זרע,\n' +
            'בית חורון,בית חירות,בית חלקיה,בית חנן,בית חנניה,בית חשמונאי,בית יהושע,בית יוסף,בית ינאי,בית יצחק-שער חפר,\n' +
            'בית לחם הגלילית,בית מאיר,בית נחמיה,בית ניר,בית נקופה,בית עובד,בית עוזיאל,בית עזרא,בית עריף,בית צבי,\n' +
            'בית קמה,בית קשת,בית רבן,בית רימון,בית שאן,בית שמש,בית שערים,בית שקמה,ביתן אהרן,ביתר עילית,\n' +
            'בלפוריה,בן זכאי,בן עמי,בן שמן (כפר נוער),בן שמן (מושב),בני ברק,בני דקלים,בני דרום,בני דרור,בני יהודה,\n' +
            'בני נצרים,בני עטרות,בני עי"ש,בני ציון,בני ראם,בניה,בנימינה-גבעת עדה*,בסמ"ה,בסמת טבעון,בענה,\n' +
            'בצרה,בצת,בקוע,בקעות,בר גיורא,בר יוחאי,ברוכין,ברור חיל,ברוש,ברכה,\n' +
            'ברכיה,ברעם,ברק,ברקאי,ברקן,ברקת,בת הדר,בת חן,בת חפר,בת ים,\n' +
            'בת עין,בת שלמה,ג\'דיידה-מכר,ג\'ולס,ג\'לג\'וליה,ג\'סר א-זרקא,ג\'ש (גוש חלב),ג\'ת,גאולי תימן,גאולים,\n' +
            'גאליה,גבולות,גבים,גבע,גבע בנימין,גבע כרמל,גבעולים,גבעון החדשה,גבעות בר,גבעת אבני,\n' +
            'גבעת אלה,גבעת ברנר,גבעת השלושה,גבעת זאב,גבעת ח"ן,גבעת חיים (איחוד),גבעת חיים (מאוחד),גבעת יואב,גבעת יערים,גבעת ישעיהו,\n' +
            'גבעת כ"ח,גבעת ניל"י,גבעת עוז,גבעת שמואל,גבעת שמש,גבעת שפירא,גבעתי,גבעתיים,גברעם,גבת,\n' +
            'גדות,גדיש,גדעונה,גדרה,גונן,גורן,גורנות הגליל,גזית,גזר,גיאה,\n' +
            'גיבתון,גיזו,גילון,גילת,גינוסר,גיניגר,גינתון,גיתה,גיתית,גלאון,\n' +
            'גלגל,גליל ים,גלעד (אבן יצחק),גמזו,גן הדרום,גן השומרון,גן חיים,גן יאשיה,גן יבנה,גן נר,\n' +
            'גן שורק,גן שלמה,גן שמואל,גנות,גנות הדר,גני הדר,גני טל,גני יוחנן,גני עם,גני תקווה,\n' +
            'געש,געתון,גפן,גרופית,גשור,גשר,גשר הזיו,גת (קיבוץ),גת רימון,דאלית אל-כרמל,\n' +
            'דבורה,דבורייה,דבירה,דברת,דגניה א\',דגניה ב\',דוב"ב,דולב,דור,דורות,\n' +
            'דחי,דייר אל-אסד,דייר חנא,דייר ראפאת,דימונה,דישון,דלייה,דלתון,דמיידה,דן,\n' +
            'דפנה,דקל,דריג\'את,האון,הבונים,הגושרים,הדר עם,הוד השרון,הודיות,הודייה,\n' +
            'הושעיה,הזורע,הזורעים,החותרים,היוגב,הילה,המעפיל,הסוללים,העוגן,הר אדר,\n' +
            'הר גילה,הר עמשא,הראל,הרדוף,הרצלייה,הררית,ורד יריחו,ורדון,זבדיאל,זוהר,\n' +
            'זיקים,זיתן,זכרון יעקב,זכריה,זמר,זמרת,זנוח,זרועה,זרזיר,זרחיה,\n' +
            'ח\'ואלד,חבצלת השרון,חבר,חגור,חגי,חגלה,חד-נס,חדיד,חדרה,חוג\'ייראת (ד\'הרה) (שבט),\n' +
            'חולדה,חולון,חולית,חולתה,חוסן,חוסנייה,חופית,חוקוק,חורה,חורפיש,\n' +
            'חורשים,חזון,חיבת ציון,חיננית,חיפה,חירות,חלוץ,חלמיש,חלץ,חמאם,\n' +
            'חמד,חמדיה,חמדת,חמרה,חניאל,חניתה,חנתון,חספין,חפץ חיים,חפצי-בה,\n' +
            'חצב,חצבה,חצור הגלילית,חצור-אשדוד,חצרים,חרב לאת,חרוצים,חריש,חרמש,חרשים,\n' +
            'חשמונאים,טבריה,טובא-זנגרייה,טורעאן,טייבה,טייבה (בעמק),טירה,טירת יהודה,טירת כרמל,טירת צבי,\n' +
            'טל שחר,טל-אל,טללים,טלמון,טמרה,טמרה (יזרעאל),טנא,טפחות,יאנוח-ג\'ת,יבול,\n' +
            'יבנאל,יבנה,יגור,יגל,יד בנימין,יד השמונה,יד חנה,יד מרדכי,יד נתן,יד רמב"ם,\n' +
            'ידידה,יהוד,יהל,יובל,יובלים,יודפת,יונתן,יושיביה,יזרעאל,יחיעם,\n' +
            'יטבתה,ייט"ב,יכיני,ינוב,ינון,יסוד המעלה,יסודות,יסעור,יעד,יעל,\n' +
            'יעף,יערה,יפיע,יפית,יפעת,יפתח,יצהר,יציץ,יקום,יקיר,\n' +
            'יקנעם (מושבה),יקנעם עילית,יראון,ירדנה,ירוחם,ירושלים,ירחיב,ירכא,ירקונה,ישע,\n' +
            'ישעי,ישרש,יתד,כאבול,כאוכב אבו אל-היג\'א,כברי,כדורי,כדיתה,כוכב השחר,כוכב יאיר,\n' +
            'כוכב יעקב,כוכב מיכאל,כורזים,כחל,כחלה,כיסופים,כישור,כליל,כלנית,כמאנה,\n' +
            'כמהין,כמון,כנות,כנף,כנרת (מושבה),כנרת (קבוצה),כסיפה,כסלון,כסרא-סמיע,כעביה-טבאש-חג\'אג\'רה,\n' +
            'כפר אביב,כפר אדומים,כפר אוריה,כפר אחים,כפר ביאליק,כפר ביל"ו,כפר בלום,כפר בן נון,כפר ברא,כפר ברוך,\n' +
            'כפר גדעון,כפר גלים,כפר גליקסון,כפר גלעדי,כפר דניאל,כפר האורנים,כפר החורש,כפר המכבי,כפר הנגיד,כפר הנוער הדתי,\n' +
            'כפר הנשיא,כפר הס,כפר הרא"ה,כפר הרי"ף,כפר ויתקין,כפר ורבורג,כפר ורדים,כפר זוהרים,כפר זיתים,כפר חב"ד,\n' +
            'כפר חושן,כפר חיטים,כפר חיים,כפר חנניה,כפר חסידים א\',כפר חסידים ב\',כפר חרוב,כפר טרומן,כפר יאסיף,כפר ידידיה,\n' +
            'כפר יהושע,כפר יונה,כפר יחזקאל,כפר יעבץ,כפר כמא,כפר כנא,כפר מונש,כפר מימון,כפר מל"ל,כפר מנדא,\n' +
            'כפר מנחם,כפר מסריק,כפר מצר,כפר מרדכי,כפר נטר,כפר סאלד,כפר סבא,כפר סילבר,כפר סירקין,כפר עבודה,\n' +
            'כפר עזה,כפר עציון,כפר פינס,כפר קאסם,כפר קיש,כפר קרע,כפר ראש הנקרה,כפר רוזנואלד (זרעית),כפר רופין,כפר רות,\n' +
            'כפר שמאי,כפר שמואל,כפר שמריהו,כפר תבור,כפר תפוח,כרכום,כרם בן זמרה,כרם בן שמן,כרם יבנה (ישיבה),כרם מהר"ל,\n' +
            'כרם שלום,כרמי יוסף,כרמי צור,כרמיאל,כרמייה,כרמים,כרמל,לבון,לביא,לבנים,\n' +
            'להב,להבות הבשן,להבות חביבה,להבים,לוד,לוזית,לוחמי הגיטאות,לוטם,לוטן,לימן,\n' +
            'לכיש,לפיד,לפידות,לקיה,מאור,מאיר שפיה,מבוא ביתר,מבוא דותן,מבוא חורון,מבוא חמה,\n' +
            'מבוא מודיעים,מבואות ים,מבועים,מבטחים,מבקיעים,מבשרת ציון,מג\'ד אל-כרום,מג\'דל שמס,מגאר,מגדים,\n' +
            'מגדל,מגדל העמק,מגדל עוז,מגדלים,מגידו,מגל,מגן,מגן שאול,מגשימים,מדרך עוז,\n' +
            'מדרשת בן גוריון,מדרשת רופין,מודיעין עילית,מודיעין-מכבים-רעות*,מולדה*,מולדת,מוצא עילית,מוקייבלה,מורן,מורשת,\n' +
            'מזור,מזכרת בתיה,מזרע,מזרעה,מחולה,מחנה הילה*,מחנה טלי*,מחנה יהודית*,מחנה יוכבד*,מחנה יפה*,\n' +
            'מחנה מרים*,מחנה תל נוף*,מחניים,מחסיה,מטולה,מטע,מי עמי,מיטב,מייסר,מיצר,\n' +
            'מירב,מירון,מישר,מיתר,מכורה,מכחול,מכמורת,מכמנים,מלאה,מלילות,\n' +
            'מלכייה,מלכישוע,מנוחה,מנוף,מנות,מנחמיה,מנרה,מנשית זבדה,מסד,מסדה,\n' +
            'מסילות,מסילת ציון,מסלול,מסעדה,מעברות,מעגלים,מעגן,מעגן מיכאל,מעוז חיים,מעון,\n' +
            'מעונה,מעיין ברוך,מעיין צבי,מעיליא,מעלה אדומים,מעלה אפרים,מעלה גלבוע,מעלה גמלא,מעלה החמישה,מעלה לבונה,\n' +
            'מעלה מכמש,מעלה עירון,מעלה עמוס,מעלה שומרון,מעלות-תרשיחא,מענית,מעש,מפלסים,מצדות יהודה,מצובה,\n' +
            'מצליח,מצפה,מצפה אבי"ב,מצפה אילן,מצפה יריחו,מצפה נטופה,מצפה רמון,מצפה שלם,מצר,מרגליות,\n' +
            'מרום גולן,מרחב עם,מרחביה (מושב),מרחביה (קיבוץ),מרכז שפירא,משאבי שדה,משגב דב,משגב עם,משהד,משואה,\n' +
            'משואות יצחק,משכיות,משמר איילון,משמר דוד,משמר הירדן,משמר הנגב,משמר העמק,משמר השבעה,משמר השרון,משמרות,\n' +
            'משמרת,משען,מתן,מתת,מתתיהו,נאות גולן,נאות הכיכר,נאות מרדכי,נאות סמדר,נאעורה,\n' +
            'נבטים,נגבה,נגוהות,נהורה,נהלל,נהרייה,נוב,נוגה,נווה,נווה אור,\n' +
            'נווה אטי"ב,נווה אילן,נווה איתן,נווה דניאל,נווה זוהר,נווה זיו,נווה חריף,נווה ים,נווה ימין,נווה ירק,\n' +
            'נווה מבטח,נווה מיכאל,נווה שלום,נועם,נוף איילון,נופים,נופית,נופך,נוקדים,נורדייה,\n' +
            'נורית,נחושה,נחל עוז,נחלה,נחליאל,נחלים,נחם,נחף,נחשולים,נחשון,\n' +
            'נחשונים,נטועה,נטור,נטע,נטעים,נטף,ניין,ניל"י,ניצן,ניצן ב\',\n' +
            'ניצנה (קהילת חינוך),ניצני סיני,ניצני עוז,ניצנים,ניר אליהו,ניר בנים,ניר גלים,ניר דוד (תל עמל),ניר ח"ן,ניר יפה,\n' +
            'ניר יצחק,ניר ישראל,ניר משה,ניר עוז,ניר עם,ניר עציון,ניר עקיבא,ניר צבי,נירים,נירית,\n' +
            'נירן,נס הרים,נס עמים,נס ציונה,נעורים,נעלה,נעמ"ה,נען,נצר חזני,נצר סרני,\n' +
            'נצרת,נצרת עילית,נשר,נתיב הגדוד,נתיב הל"ה,נתיב העשרה,נתיב השיירה,נתיבות,נתניה,סאג\'ור,\n' +
            'סאסא,סביון*,סגולה,סואעד (חמרייה)*,סולם,סוסיה,סופה,סח\'נין,סלמה,סלעית,\n' +
            'סמר,סנסנה,סעד,סער,ספיר,סתרייה,ע\'ג\'ר,עבדון,עברון,עגור,\n' +
            'עדי,עדנים,עוזה,עוזייר,עולש,עומר,עופר,עוצם,עזוז,עזר,\n' +
            'עזריאל,עזריה,עזריקם,עטרת,עידן,עיילבון,עיינות,עילוט,עין איילה,עין אל-אסד,\n' +
            'עין גב,עין גדי,עין דור,עין הבשור,עין הוד,עין החורש,עין המפרץ,עין הנצי"ב,עין העמק,עין השופט,\n' +
            'עין השלושה,עין ורד,עין זיוון,עין חוד,עין חצבה,עין חרוד (איחוד),עין חרוד (מאוחד),עין יהב,עין יעקב,עין כרם-בי"ס חקלאי,\n' +
            'עין כרמל,עין מאהל,עין נקובא,עין עירון,עין צורים,עין קנייא,עין ראפה,עין שמר,עין שריד,עין תמר,\n' +
            'עינת,עיר אובות,עכו,עלומים,עלי,עלי זהב,עלמה,עלמון,עמוקה,עמינדב,\n' +
            'עמיעד,עמיעוז,עמיקם,עמיר,עמנואל,עמקה,ענב,עספיא,עפולה,עפרה,\n' +
            'עץ אפרים,עצמון שגב,עראבה,עשהאל,עראמשה*,ערב אל נעים,ערד,ערוגות,ערערה,ערערה-בנגב,עשרת,\n' +
            'עתלית,עתניאל,פארן,פדואל,פדויים,פדיה,פוריידיס,פורייה - כפר עבודה,פורייה - נווה עובד,פורייה עילית,\n' +
            'פורת,פטיש,פלך,פלמחים,פני חבר,פסגות,פסוטה,פעמי תש"ז,פצאל,פקיעין (בוקייעה),\n' +
            'פקיעין חדשה,פרדס חנה-כרכור,פרדסייה,פרוד,פרזון,פרי גן,פתח תקווה,פתחיה,צאלים,צביה,\n' +
            'צבעון,צובה,צוחר,צופייה,צופים,צופית,צופר,צוקי ים,צוקים,צור הדסה,\n' +
            'צור יצחק,צור משה,צור נתן,צוריאל,צורית,ציפורי,צלפון,צנדלה,צפרייה,צפרירים,\n' +
            'צפת,צרופה,צרעה,קבוצת יבנה,קדומים,קדימה-צורן,קדמה,קדמת צבי,קדר,קדרון,\n' +
            'קדרים,קוממיות,קורנית,קטורה,קיסריה,קלחים,קליה,קלנסווה,קלע,קציר,\n' +
            'קצר א-סר,קצרין,קריית אונו,קריית ארבע,קריית אתא,קריית ביאליק,קריית גת,קריית טבעון,קריית ים,קריית יערים,\n' +
            'קריית יערים (מוסד),קריית מוצקין,קריית מלאכי,קריית נטפים,קריית ענבים,קריית עקרון,קריית שלמה,קריית שמונה,קרני שומרון,קשת,\n' +
            'ראמה,ראס אל-עין,ראס עלי,ראש העין,ראש פינה,ראש צורים,ראשון לציון,רבבה,רבדים,רביבים,\n' +
            'רביד,רגבה,רגבים,רהט,רווחה,רוויה,רוח מדבר,רוחמה,רומאנה,רומת הייב,\n' +
            'רועי,רותם,רחוב,רחובות,רחלים,ריחאנייה,ריחן,ריינה,רימונים,רינתיה,\n' +
            'רכסים,רם-און,רמות,רמות השבים,רמות מאיר,רמות מנשה,רמות נפתלי,רמלה,רמת גן,רמת דוד,\n' +
            'רמת הכובש,רמת השופט,רמת השרון,רמת יוחנן,רמת ישי,רמת מגשימים,רמת צבי,רמת רזיאל,רמת רחל,רנן,\n' +
            'רעים,רעננה,רקפת,רשפון,רשפים,רתמים,שאר ישוב,שבי ציון,שבי שומרון,שבלי - אום אל-גנם,\n' +
            'שגב-שלום,שדה אילן,שדה אליהו,שדה אליעזר,שדה בוקר,שדה דוד,שדה ורבורג,שדה יואב,שדה יעקב,שדה יצחק,\n' +
            'שדה משה,שדה נחום,שדה נחמיה,שדה ניצן,שדה עוזיהו,שדה צבי,שדות ים,שדות מיכה,שדי אברהם,שדי חמד,\n' +
            'שדי תרומות,שדמה,שדמות דבורה,שדמות מחולה,שדרות,שואבה,שובה,שובל,שוהם,שומרה,\n' +
            'שומרייה,שוקדה,שורש,שורשים,שושנת העמקים,שזור,שחר,שחרות,שיבולים,שיטים,\n' +
            'שייח\' דנון,שילה,שילת,שכניה,שלווה,שלווה במדבר,שלוחות,שלומי,שלומית,שמיר,\n' +
            'שמעה,שמרת,שמשית,שניר,שעב,שעל,שעלבים,שער אפרים,שער הגולן,שער העמקים,\n' +
            'שער מנשה,שערי תקווה,שפיים,שפיר,שפר,שפרעם,שקד,שקף,שרונה,שריגים (לי-און),\n' +
            'שריד,שרשרת,שתולה,שתולים,תאשור,תדהר,תובל,תומר,תושייה,תימורים,\n' +
            'תירוש,תל אביב -יפו,תל יוסף,תל יצחק,תל מונד,תל עדשים,תל קציר,תל שבע,תל תאומים,תלם,\n' +
            'תלמי אליהו,תלמי אלעזר,תלמי ביל"ו,תלמי יוסף,תלמי יחיאל,תלמי יפה,תלמים,תמרת,תנובות,תעוז,\n' +
            'תפרח,תקומה,תקוע,תרבין א-צאנע (יישוב)*,תרום,';

        return allStates.split(',').map(function (state) {
            return {
                value: state,
                display: state
            };
        });


    }

    /**
     * Create filter function for a query string
     */
    function createFilterFor(query) {
        var lowercaseQuery = angular.lowercase(query);

        return function filterFn(state) {
            return (state.display.indexOf(lowercaseQuery) === 0);
        };

    }


    /**
     * Look for changes in the branch
     */
    $scope.$watchCollection('branch',function (newValue, oldValue) {
        $rootScope.editDataHandler(newValue, oldValue,'branch-panel')
    })

}]);

(function ()
{
    'use strict';

    angular
        .module('app.pages.new-educator', [])
        .config(config);


    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider)
    {

        $stateProvider.state('app.pages_new-educator', {
            url      : '/new-educator',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/pages/users/views/students/new-educator/new-educator.html',
                    controller : 'NewEducatorController'
                }
            },
            bodyClass: 'profile'
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/pages/users/views/students/new-educator');
    }

})();
angular.module('app.pages.new-educator').controller('NewEducatorController', ['$scope', '$rootScope','$location' ,'educatorsEndpoint','Notification','$timeout','appConfig','$cookies',function($scope, $rootScope,$location,educatorsEndpoint,Notification,$timeout,appConfig,$cookies) {


    $scope.showHideText = 'הצג';
    $scope.inputType = 'password';
    $scope.showHideImg = "/assets/icons/show.svg";
    $scope.matchPasswords = false;
    $scope.matchFlags = true;
    $scope.password = '';
    $scope.passwordVerify = '';
    $scope.form = {};
    $scope.success = false;
    $scope.loading = false;
    $scope.appConfig = appConfig;
    $scope.errorInfo = "";

    /**
     * Valid the new admin request for register a new admin
     */
    $scope.validRequest = function () {
        var params = {};
        params.token =  $location.search().tempToken;
        educatorsEndpoint.new.valid.post(params,function (data) {
            if (data.success)
                $scope.valid=true;
            else{
                $location.path("/");
                $scope.notValid=true;
            }

        })
    };
    $scope.matchPass = function () {
        if ($scope.form.password == $scope.passwordVerify && $scope.form.password.length > 5) {
            $scope.matchPasswords = true;
            $scope.matchFlags = true;
        } else if ($scope.form.password == $scope.passwordVerify && $scope.form.password.length < 6) {
            $scope.shortPass = true;
            $scope.matchFlags = true;
        } else {
            $scope.shortPass = false;
            $scope.matchPasswords = false;
            $scope.matchFlags = false;
        }
    }

    /**
     * Display or hide the password
     */
    $scope.showHidePassword = function () {
        if ($scope.inputType == "password") {
            $scope.inputType = "text";
            $scope.showHideText = 'הסתר';
            $scope.showHideImg = "/assets/icons/hide.svg";
        } else {
            $scope.inputType = "password";
            $scope.showHideText = 'הצג';
            $scope.showHideImg = "/assets/icons/show.svg";
        }

    };

    /**
     * Submit the new admin sing up
     */
    $scope.submit = function () {
        $scope.form.token = $location.search().tempToken;
        educatorsEndpoint.new.post($scope.form, function (data) {        
            if (typeof data == 'string' || data instanceof String) {
                $scope.errorInfo = data;
                $scope.fail = true;
                $timeout(function () {
                    $scope.fail = false;
                }, 5000);
            }
            else if (data.ID) {
                $rootScope.User = data;
                setUserType();
                saveUser();
                $scope.success = true;
            }
            else
                $scope.errorInfo = "Error!";
            $scope.loading = true;
        })

    };

    /**
     * Set the admin type
     */
    function setUserType() {
        if ($rootScope.User.StudentID)
            $rootScope.AdminLevel = 1;
        else if ($rootScope.User.IsCoordinator)
            $rootScope.AdminLevel = 2;
        else
            $rootScope.AdminLevel = 3;
    }

    function saveUser() {
        var expireTime = +new Date() + (24 * 3600000);
        $cookies.put("marvilixAccessToken", $rootScope.User.AccessToken, [{expires: expireTime}]);
        $scope.loogin = false;
        $timeout(function () {
            if ($rootScope.AdminLevel !== 3)
                $location.path('/students');
            else
                $location.path('/dashboard');
        }, 250)
    }

    /**
     * href to login page
     */
    $scope.goToLogin = function () {
        $location.path("/");
    };

}]);

angular.module('app.pages.users').controller('ImportStudentsDialogController', ['$scope', '$rootScope', '$mdDialog', 'studentsEndpoint','Notification',
    function ($scope, $rootScope, $mdDialog, studentsEndpoint,Notification) {

        $scope.getStudentUploadTemplate = function () {
            studentsEndpoint.import.template.get(function (data) {
                $scope.closeDialog();
            });
        }

        $scope.uploadExcelFile = function () {
            $mdDialog.show({
                controller         : 'UploadController',
                templateUrl        : 'app/upload/upload.html',
                clickOutsideToClose: false,
                locals: {
                    uploadTo: 'students',
                    uploadID: 'import',
                    restrictTo: ['xlsx']
                }
            }).then(function () {
                $scope.closeDialog();
            });
        }

        /**
         * Close the dialog
         */
        $scope.closeDialog = function () {
            $mdDialog.cancel();
        };

    }]);

angular.module('app.pages.users').controller('ChangeGroupOrGradeDialogController', ['$scope', '$rootScope', '$mdDialog','studentsEndpoint','student','$location','Notification','students','branchesEndpoint','gradesEndpoint', function ($scope, $rootScope, $mdDialog,studentsEndpoint,student,$location,Notification,students,branchesEndpoint,gradesEndpoint) {

    $scope.students = students;

    $scope.changeForm = {};
    $scope.changeForm.Students = [];

    var studentObj = {};
    /**
     * Get All selected students
     */
    for (var i=0;i<$scope.students.length;i++) {
        if($scope.students[i].Selected ===true) {
            studentObj = {};
            studentObj.ID = $scope.students[i].ID;
            $scope.changeForm.Students.push(studentObj);
        }

    }

    /**
     * Get all branches
     */
    $scope.getBranches = function () {
        var params = {};
        params.Status =1;
        branchesEndpoint.get(params,function (data) {
            $scope.branches= data;
        })
    };

    /**
     * Get all branches groups
     */
    $scope.getGroupsByBranch = function () {
        $scope.groups = false;
        branchesEndpoint.groups.get($scope.changeForm.BranchID,function (data) {
            $scope.groups = data;
        })
    };


    $scope.getGrades = function () {
        var params = {};
        params.Status =1;
        gradesEndpoint.get(params,function (data) {
            $scope.grades = data;
        })
    };

    $scope.updateGradeAndGroups = function () {
        $scope.isClicked = true;
        studentsEndpoint.groups.upgrade.post($scope.changeForm,function (data) {
            if (data.success)
                Notification.success("חניכים עודכנו בהצלחה!");
            else
                Notification.error("נכשל בעדכון");
            $scope.isClicked = false;
            $mdDialog.hide();
        })
    };


    /**
     * Close the dialog
     */
    $scope.closeDialog =function () {
        $mdDialog.cancel();
    };

}]);

(function ()
{
    'use strict';

    angular
        .module('app.pages.parent-profile', ['datatables'])
        .config(config);


    /** @ngInject */
    function config($stateProvider)
    {
        $stateProvider.state('app.pages_parent-profile', {
            url      : '/parent-profile',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/pages/users/views/parents/parents-profile/parents-profile.html',
                    controller: 'ParentProfileController'
                }
            },
            resolve  : {
                DashboardData: function ()
                {
                    localStorage.setItem("path", '/parent-profile');
                }
            },
            bodyClass: 'parents-profile'
        });


    }

})();

angular.module('app.pages.parent-profile').controller('ParentProfileController', ParentProfileController);

function ParentProfileController($scope, studentsEndpoint, $rootScope, $location, usersEndpoint, $mdSidenav, $mdDialog, tagsEndpoint, DTOptionsBuilder, $timeout, parent, parentsEndpoint, dtOptions, Notification, student, receiptsService, $window, $cookies, appConfig, DTColumnDefBuilder) {


    $scope.searchText = '';
    $scope.isClicked = false;
    $scope.relations = ['אמא', 'אבא', 'אחר'];
    $scope.receiptsCount = {};

    function init() {
        var parentObject = {};
        parentObject.ID = $location.search().ID;
        if (!parentObject.ID) {
            $location.path('/parents');
        } else {
            resolveParent(parentObject);
        }
        $scope.currentParentID = null;
        $scope.$watch(function () {
            return $location.search()
        }, function (data) {
            if ($scope.currentParentID !== null && data.ID !== $scope.currentParentID) {
                if (data.ID) {
                    parentObject = {};
                    parentObject.ID = data.ID;
                    if (!parentObject.ID) {
                        $location.path('/parents');
                    } else {
                        resolveParent(parentObject);
                    }
                }
            }
        });
    }

    init();

    /**
     * resolve the parent by the ID stored in parentObject
     * @param parentObject
     */
    function resolveParent(parentObject) {
        parentsEndpoint.get(parentObject, function (response) {
            if (response.data.items[0]) {
                $scope.parent = response.data.items[0];
                $scope.CurrentTotalCash = $scope.parent.TotalCash;
                $scope.searchText = $scope.parent.City;
                parent.updateSelectedParent($scope.parent);
                $scope.getContactForms();
                $scope.getFamily();
                $scope.getPayments();
                $scope.getRegistrations();
                $scope.getSubsidyForms();
                $scope.getCash();
                getTags();
                setComments();
            } else
                $location.path('/parents');
        })
    }

    /**
     * Get All Tags
     */
    function getTags() {
        if (!$scope.parent.Tags)
            $scope.parent.Tags = [];
        var params = {};
        params.withNames = true;
        params.TagType = 2;
        tagsEndpoint.get(params, function (data) {
            $scope.tags = data;
        })
    };

    /**
     * Check for changes in parent object
     */
    $scope.$watch('parent', function (newValue, oldValue) {
        if (typeof $rootScope.editDataHandler === 'function')
            $rootScope.editDataHandler(newValue, oldValue, 'parent-profile')
    }, true);

    /**
     * Get Parent Family
     */
    $scope.getFamily = function () {
        $scope.editEd = true;
        $scope.family = false;
        $timeout(function () {
            parentsEndpoint.family.get($scope.parent, function (data) {
                $scope.family = data;
            })
        }, 500);
    };

    /**
     * tags query search
     * @param query
     * @returns {Array}
     */
    $scope.tagsQuerySearch = function (query) {
        return query ? $scope.tags.filter(createFilterForTags(query)) : [];
    };

    /**
     * Create filter for query from auto complete
     * @param query
     * @returns {filterFn}
     */
    function createFilterForTags(query) {
        var lowercaseQuery = angular.lowercase(query);
        return function filterFn(contact) {
            return (contact.Name.indexOf(lowercaseQuery) != -1);
        };
    }


    /**
     * Open student panel
     * @param selectedStudent
     */
    $scope.editFamily = function (selectedStudent) {
        $mdSidenav("student-panel").open();
        student.updateSelectedStudent(selectedStudent);
    };

    $scope.deleteFamily = function (selectedStudent) {
        var confirm = $mdDialog.confirm()
            .title('מחיקת ילד')
            .textContent('האם אתה בטוח/ה שברצונך למחוק ילד זה?')
            .targetEvent(null)
            .ok('מחק')
            .cancel('ביטול');
        $mdDialog.show(confirm).then(function () {
            deleteStudent(selectedStudent);
        });
    };

    var deleteStudent = function (selectedStudent) {
        var params = {};
        params['ParentID'] = parent['selectedParent'].ID;
        params['StudentID'] = selectedStudent.ID;
        parentsEndpoint.family.delete.post(params, function () {
            Notification.success("ילד נמחק בהצלחה");
            $scope.getFamily();
        })
    };

    /**
     * Get Parent Payments
     */
    $scope.getPayments = function () {
        $timeout(function () {
            parentsEndpoint.receipts.get($scope.parent, function (data) {
                $scope.receipts = data;
            })
        }, 500)
    };

    /**
     * Get Parent Cash
     */
    $scope.getCash = function () {
        $timeout(function () {
            parentsEndpoint.cash.get($scope.parent, function (data) {
                $scope.cashTrans = data;
                $scope.CurrentTotalCash = data.length > 0 ? data[0]['Total'] : 0;
            })
        }, 500)
    };

    /**
     * Get parent Contact Forms
     */
    $scope.getContactForms = function () {
        $scope.contacts = false;
        $timeout(function () {
            parentsEndpoint.contact.get($scope.parent, function (data) {
                $scope.contactss = data;
            })
        }, 500);
    };


    /**
     * Get parent Contact Forms
     */
    $scope.getSubsidyForms = function () {
        $scope.subsidyes = false;
        $timeout(function () {
            parentsEndpoint.subsidy.get($scope.parent, function (data) {
                $scope.subsidyes = data;
                $scope.subsidyes.forEach(function (sub) {
                    if (sub.typeForm) {
                        sub.Parent1PrivateIDFile = JSON.parse(sub.Parent1PrivateIDFile);
                        if (sub.Parent2PrivateIDFile) {
                            sub.Parent2PrivateIDFile = JSON.parse(sub.Parent2PrivateIDFile);
                        }
                        sub.Parent1Paycheck1File = JSON.parse(sub.Parent1Paycheck1File);
                        if (sub.Parent2Paycheck1File) {
                            sub.Parent2Paycheck1File = JSON.parse(sub.Parent2Paycheck1File);
                        }
                        sub.Parent1Paycheck2File = JSON.parse(sub.Parent1Paycheck2File);
                        if (sub.Parent2Paycheck2File) {
                            sub.Parent2Paycheck2File = JSON.parse(sub.Parent2Paycheck2File);
                        }
                        sub.Parent1Paycheck3File = JSON.parse(sub.Parent1Paycheck3File);
                        if (sub.Parent2Paycheck3File) {
                            sub.Parent2Paycheck3File = JSON.parse(sub.Parent2Paycheck3File);
                        }
                        if (sub.OtherFiles) {
                            sub.OtherFiles = JSON.parse(sub.OtherFiles);
                        }

                        if (sub.MoreKids && sub.MoreKids !== "[]") {
                            var kids = {};
                            kids['IDs'] = sub.MoreKids;
                            studentsEndpoint.get(kids, function (response) {
                                $scope.moreKids = response.data.items;
                            })
                        }
                    }
                })
            })
        })
    };


    /**
     * Get parent Contact Forms
     */
    $scope.getCancellationForms = function () {
        $scope.subsidyes = false;
        $timeout(function () {
            parentsEndpoint.cancellation.get($scope.parent, function (data) {
                $scope.cancellation = data;
            })
        }, 500);
    };

    $scope.getRegistrations = function () {
        $scope.contacts = false;
        $timeout(function () {
            parentsEndpoint.registrations.get($scope.parent, function (data) {
                $scope.registrations = data;
                $scope.registrations.forEach(function (reg) {
                    reg.ReceiptID.forEach(function (id) {
                        if (!$scope.receiptsCount[id]) {
                            $scope.receiptsCount[id] = 0;
                        }
                        $scope.receiptsCount[id]++;
                    });

                });
            });
        }, 500);
    };


    /**
     * Update Password
     */
    $scope.updateParentPassword = function (newPassword) {
        $scope.isClicked = true;
        if (!$scope.parent.LastLogin) {
            Notification.error("ההורה לא רשום למערכת");
        } else {
            $scope.isClicked = true;
            var params = {};
            params.Password = newPassword;
            parentsEndpoint.password.update.post($scope.parent, params, function (data) {
                $scope.isClicked = false;
                if (data.success) {
                    Notification.success("סיסמא עודכנה בהצלחה");
                } else
                    Notification.error("נכשל בעדכון סיסמא");
            })
        }


        /**
         * Download receipt
         * @param receiptID
         * @param type
         */
        $scope.downloadReceipt = function (receiptID, type) {
            Notification.info("מייצר קבלה..אנא המתן");
            receiptsService.getReceiptByID(receiptID, type)
        };

        /**
         * Convert Payment Type to string
         * @param registrationValue
         */
        $scope.getPaymentType = function (registrationValue) {
            switch (registrationValue.PaymentType) {
                case 0 :
                    registrationValue.PaymentType = "ללא עלות";
                    break;
                case 1 :
                    registrationValue.PaymentType = "אשראי";
                    break;
                case 2 :
                    registrationValue.PaymentType = "מזומן";
                    break;
                case 3 :
                    registrationValue.PaymentType = "העברה בנקאית";
                    break;
                case 4 :
                    registrationValue.PaymentType = "צ'ק";
                    break;
            }
        };


        $scope.loginToProfile = function () {
            delete $cookies.remove(appConfig.profileTokenName);
            localStorage.removeItem(appConfig.profilePathCokieName);
            var expireTime = +new Date() + (24 * 3600000);
            if (location.hostname === "localhost" || location.hostname === "127.0.0.1")
                document.cookie = appConfig.adminTokenName + "=" + $rootScope.User.AccessToken + "**" + $scope.parent.ID + ";domain=localhost;path=/;expires=" + expireTime;
            else
                document.cookie = appConfig.adminTokenName + "=" + $rootScope.User.AccessToken + "**" + $scope.parent.ID + ";domain=." + appConfig.appDomain + ";path=/;expires=" + expireTime;

            if (location.hostname === "localhost" || location.hostname === "127.0.0.1")
                $window.open('http://localhost:4200/', '_blank');
            else if (location.host === appConfig.locationHost)
                $window.open(appConfig.developmentProfilePath, '_blank');
            else
                $window.open(appConfig.prodctionProfilePath, '_blank');
        };

        $scope.reSendReceipt = function (receipt) {
            Notification.info("שולח קבלה..");
            receiptsService.getReceiptByID(receipt.ID, receipt.Type, function () {
                Notification.success("קבלה נשלחה בהצלחה");
            }, true);
        };

        $scope.simulateQuery = false;
        $scope.isDisabled = false;

        // list of `state` value/display objects
        $scope.states = loadAll();
        $scope.querySearch = querySearch;


        // ******************************
        // Internal methods
        // ******************************

        /**
         * Search for states... use $timeout to simulate
         * remote dataservice call.
         */
        function querySearch(query) {
            var results = query ? $scope.states.filter(createFilterFor(query)) : $scope.states,
                deferred;
            if ($scope.simulateQuery) {
                deferred = $q.defer();
                $timeout(function () {
                    deferred.resolve(results);
                }, Math.random() * 1000, false);
                return deferred.promise;
            } else {
                return results;
            }
        }
    }

    /**
     * Open Cancel Registration Dialog
     * @param registration
     */
    $scope.cancelRegistration = function (registration) {

        $mdDialog.show({
            controller: 'CancelRegistrationDialogController',
            templateUrl: 'app/main/pages/events-dialogs/cancel-registration-dialog/cancel-registration-dialog.html',
            locals: {'registration': registration, external: false},
            clickOutsideToClose: true
        }).then(function () {
            $scope.getRegistrations();
        });
    };

    $scope.showFullRegistration = function (registration) {
        $mdDialog.show({
            controller: 'FullRegistrationDialogController',
            templateUrl: 'app/main/pages/events-dialogs/full-registration-dialog/full-registration-dialog.html',
            clickOutsideToClose: true,
            locals: {'registration': registration}
        })
    };

    /**
     * Open The Subsidy Dialog
     * @param subsidy
     */
    $scope.openSubsidyDialog = function (subsidy) {
        $mdDialog.show({
            controller: 'SubsidyDialogController',
            templateUrl: 'app/main/pages/users/views/parents/parents-profile/tabs/subsidy/subsidy-dialog/subsidy-dialog.html',
            clickOutsideToClose: true,
            locals: {'subsidy': subsidy, 'moreKids': $scope.moreKids}
        });
    };

    /**
     * Open Cancel Registration Dialog
     * @param registration
     */
    $scope.refundRegistration = function (registration) {
        registration.receiptsCount = JSON.parse(JSON.stringify($scope.receiptsCount))
        $mdDialog.show({
            controller: 'RefundRegistrationDialogController',
            templateUrl: 'app/main/pages/events-dialogs/refund-registration-dialog/refund-registration-dialog.html',
            locals: {'registration': registration, external: false},
            clickOutsideToClose: true
        }).then(function () {
            $scope.getRegistrations();
            $scope.getCash();
        });
    };

    /**
     * Open The Cancellation Dialog
     * @param cancel
     */
    $scope.openCancellationDialog = function (cancel) {
        $mdDialog.show({
            controller: 'CancellationDialogController',
            templateUrl: 'app/main/pages/forms-dialogs/cancellation-dialog/cancellation-dialog.html',
            clickOutsideToClose: true,
            locals: {'cancel': cancel}
        });
    };

    /**
     * Open Contact Form Dialog
     * @param contactForm
     */
    $scope.openContactDialog = function (contactForm) {
        $mdDialog.show({
            controller: 'ContactDialogController',
            templateUrl: 'app/main/pages/forms-dialogs/contact-dialog/contact-dialog.html',
            clickOutsideToClose: true,
            locals: {'contactForm': contactForm}
        });
    };


    /**
     * @param receiptID
     * @param type
     */
    $scope.downloadReceipt = function (receiptID, type) {
        Notification.info("מייצר קבלה..אנא המתן");
        receiptsService.getReceiptByID(receiptID, type)
    };

    /**
     * Convert Payment Type to string
     * @param registrationValue
     */
    $scope.getPaymentType = function (registrationValue) {
        switch (registrationValue.PaymentType) {
            case 0 :
                registrationValue.PaymentType = "ללא עלות";
                break;
            case 1 :
                registrationValue.PaymentType = "אשראי";
                break;
            case 2 :
                registrationValue.PaymentType = "מזומן";
                break;
            case 3 :
                registrationValue.PaymentType = "העברה בנקאית";
                break;
            case 4 :
                registrationValue.PaymentType = "צ'ק";
                break;
        }
    };


    $scope.loginToProfile = function () {
        delete $cookies.remove(appConfig.profileTokenName);
        localStorage.removeItem(appConfig.profilePathCokieName);
        var expireTime = +new Date() + (24 * 3600000);
        if (location.hostname === "localhost" || location.hostname === "127.0.0.1")
            document.cookie = appConfig.adminTokenName + "=" + $rootScope.User.AccessToken + "**" + $scope.parent.ID + ";domain=localhost;path=/;expires=" + expireTime;
        else
            document.cookie = appConfig.adminTokenName + "=" + $rootScope.User.AccessToken + "**" + $scope.parent.ID + ";domain=." + appConfig.appDomain + ";path=/;expires=" + expireTime;

        if (location.hostname === "localhost" || location.hostname === "127.0.0.1")
            $window.open('http://localhost:4200/', '_blank');
        else if (location.host === appConfig.locationHost)
            $window.open(appConfig.developmentProfilePath, '_blank');
        else
            $window.open(appConfig.prodctionProfilePath, '_blank');
    };

    $scope.reSendReceipt = function (receipt) {
        Notification.info("שולח קבלה..");
        receiptsService.getReceiptByID(receipt.ID, function () {
            Notification.success("קבלה נשלחה בהצלחה");
        }, true);
    };

    /**
     * Set Table option
     * @type {any}
     */
    $scope.dtOptions = DTOptionsBuilder
        .newOptions()
        .withLanguage(dtOptions.language)
        .withOption('responsive', true)
        .withDOM('lfrtp')
        .withOption('bFilter', false)
        .withDOM('lrtip')
        .withOption('order', [[0, 'desc']]);


    $scope.cashDtOptions = DTOptionsBuilder
        .newOptions()
        .withLanguage(dtOptions.language)
        .withOption('responsive', true)
        .withDOM('lfrtp')
        .withOption('bFilter', false)
        .withDOM('lrtip')
        .withOption('order', []);

    $scope.simulateQuery = false;
    $scope.isDisabled = false;

    // list of `state` value/display objects
    $scope.states = loadAll();
    $scope.querySearch = querySearch;


    // ******************************
    // Internal methods
    // ******************************

    /**
     * Search for states... use $timeout to simulate
     * remote dataservice call.
     */
    function querySearch(query) {
        var results = query ? $scope.states.filter(createFilterFor(query)) : $scope.states,
            deferred;
        if ($scope.simulateQuery) {
            deferred = $q.defer();
            $timeout(function () {
                deferred.resolve(results);
            }, Math.random() * 1000, false);
            return deferred.promise;
        } else {
            return results;
        }
    }

    $scope.setCity = function (city) {
        $scope.parent.City = city.value
    };


    /**
     * Build `states` list of key/value pairs
     */
    function loadAll() {

        var allStates = 'אבו גוש,אבו סנאן,אבו קורינאת (יישוב),אבו תלול,אבטין,אבטליון,אביאל,אביבים,אביגדור,אביחיל,\n' +
            'אביטל,אביעזר,אבירים,אבן יהודה,אבן מנחם,אבן ספיר,אבן שמואל,אבני איתן,אבני חפץ,אבנת,\n' +
            'אבשלום,אדורה,אדירים,אדמית,אדרת,אודים,אודם,אוהד,אום אל-פחם,אום אל-קוטוף,\n' +
            'אום בטין,אומן,אומץ,אופקים,אור הגנוז,אור הנר,אור יהודה,אור עקיבא,אורה,אורות,\n' +
            'אורטל,אורים,אורנים,אורנית,אושה,אזור,אחווה,אחוזם,אחוזת ברק,אחיהוד,\n' +
            'אחיטוב,אחיסמך,אחיעזר,איבים,אייל,איילת השחר,אילון,אילות,אילנייה,אילת,\n' +
            'אירוס,איתמר,איתן,איתנים,אכסאל,אל -עזי,אל -עריאן,אל -רום,אל סייד,אלומה,\n' +
            'אלומות,אלון הגליל,אלון מורה,אלון שבות,אלוני אבא,אלוני הבשן,אלוני יצחק,אלונים,אלי-עד,אליאב,\n' +
            'אליכין,אליפז,אליפלט,אליקים,אלישיב,אלישמע,אלמגור,אלמוג,אלעד,אלעזר,\n' +
            'אלפי מנשה,אלקוש,אלקנה,אמונים,אמירים,אמנון,אמציה,אניעם,אספר,אעבלין,\n' +
            'אפיק,אפיקים,אפק,אפרת,ארבל,ארגמן,ארז,אריאל,ארסוף,אשבול,\n' +
            'אשבל,אשדוד,אשדות יעקב (איחוד),אשדות יעקב (מאוחד),אשחר,אשכולות,אשל הנשיא,אשלים,אשקלון,אשרת,\n' +
            'אשתאול,באקה אל-גרביה,באר אורה,באר גנים,באר טוביה,באר יעקב,באר מילכה,באר שבע,בארות יצחק,בארותיים,\n' +
            'בארי,בוסתן הגליל,בועיינה-נוג\'ידאת,בוקעאתא,בורגתה,בחן,בטחה,ביצרון,ביר אל-מכסור,ביר הדאג\',\n' +
            'בירייה,בית אורן,בית אל,בית אלעזרי,בית אלפא,בית אריה,בית ברל,בית ג\'ן,בית גוברין,בית גמליאל,\n' +
            'בית דגן,בית הגדי,בית הלוי,בית הלל,בית העמק,בית הערבה,בית השיטה,בית זיד,בית זית,בית זרע,\n' +
            'בית חורון,בית חירות,בית חלקיה,בית חנן,בית חנניה,בית חשמונאי,בית יהושע,בית יוסף,בית ינאי,בית יצחק-שער חפר,\n' +
            'בית לחם הגלילית,בית מאיר,בית נחמיה,בית ניר,בית נקופה,בית עובד,בית עוזיאל,בית עזרא,בית עריף,בית צבי,\n' +
            'בית קמה,בית קשת,בית רבן,בית רימון,בית שאן,בית שמש,בית שערים,בית שקמה,ביתן אהרן,ביתר עילית,\n' +
            'בלפוריה,בן זכאי,בן עמי,בן שמן (כפר נוער),בן שמן (מושב),בני ברק,בני דקלים,בני דרום,בני דרור,בני יהודה,\n' +
            'בני נצרים,בני עטרות,בני עי"ש,בני ציון,בני ראם,בניה,בנימינה-גבעת עדה*,בסמ"ה,בסמת טבעון,בענה,\n' +
            'בצרה,בצת,בקוע,בקעות,בר גיורא,בר יוחאי,ברוכין,ברור חיל,ברוש,ברכה,\n' +
            'ברכיה,ברעם,ברק,ברקאי,ברקן,ברקת,בת הדר,בת חן,בת חפר,בת ים,\n' +
            'בת עין,בת שלמה,ג\'דיידה-מכר,ג\'ולס,ג\'לג\'וליה,ג\'סר א-זרקא,ג\'ש (גוש חלב),ג\'ת,גאולי תימן,גאולים,\n' +
            'גאליה,גבולות,גבים,גבע,גבע בנימין,גבע כרמל,כרמית,גבעולים,גבעון החדשה,גבעות בר,גבעת אבני,\n' +
            'גבעת אלה,גבעת ברנר,גבעת השלושה,גבעת זאב,גבעת ח"ן,גבעת חיים (איחוד),גבעת חיים (מאוחד),גבעת יואב,גבעת יערים,גבעת ישעיהו,\n' +
            'גבעת כ"ח,גבעת ניל"י,גבעת עוז,גבעת שמואל,גבעת שמש,גבעת שפירא,גבעתי,גבעתיים,גברעם,גבת,\n' +
            'גדות,גדיש,גדעונה,גדרה,גונן,גורן,גורנות הגליל,גזית,גזר,גיאה,\n' +
            'גיבתון,גיזו,גילון,גילת,גינוסר,גיניגר,גינתון,גיתה,גיתית,גלאון,\n' +
            'גלגל,גליל ים,גלעד (אבן יצחק),גמזו,גן הדרום,גן השומרון,גן חיים,גן יאשיה,גן יבנה,גן נר,\n' +
            'גן שורק,גן שלמה,גן שמואל,גנות,גנות הדר,גני הדר,גני טל,גני יוחנן,גני עם,גני תקווה,\n' +
            'געש,געתון,גפן,גרופית,גשור,גשר,גשר הזיו,גת (קיבוץ),גת רימון,דאלית אל-כרמל,\n' +
            'דבורה,דבורייה,דבירה,דברת,דגניה א\',דגניה ב\',דוב"ב,דולב,דור,דורות,\n' +
            'דחי,דייר אל-אסד,דייר חנא,דייר ראפאת,דימונה,דישון,דלייה,דלתון,דמיידה,דן,\n' +
            'דפנה,דקל,דריג\'את,האון,הבונים,הגושרים,הדר עם,הוד השרון,הודיות,הודייה,\n' +
            'הושעיה,הזורע,הזורעים,החותרים,היוגב,הילה,המעפיל,הסוללים,העוגן,הר אדר,\n' +
            'הר גילה,הר עמשא,הראל,הרדוף,הרצלייה,הררית,ורד יריחו,ורדון,זבדיאל,זוהר,\n' +
            'זיקים,זיתן,זכרון יעקב,זכריה,זמר,זמרת,זנוח,זרועה,זרזיר,זרחיה,\n' +
            'ח\'ואלד,חבצלת השרון,חבר,חגור,חגי,חגלה,חד-נס,חדיד,חדרה,חוג\'ייראת (ד\'הרה) (שבט),\n' +
            'חולדה,חולון,חולית,חולתה,חוסן,חוסנייה,חופית,חוקוק,חורה,חורפיש,\n' +
            'חורשים,חזון,חיבת ציון,חיננית,חיפה,חירות,חלוץ,חלמיש,חלץ,חמאם,\n' +
            'חמד,חמדיה,חמדת,חמרה,חניאל,חניתה,חנתון,חספין,חפץ חיים,חפצי-בה,\n' +
            'חצב,חצבה,חצור הגלילית,חצור-אשדוד,חצרים,חרב לאת,חרוצים,חריש,חרמש,חרשים,\n' +
            'חשמונאים,טבריה,טובא-זנגרייה,טורעאן,טייבה,טייבה (בעמק),טירה,טירת יהודה,טירת כרמל,טירת צבי,\n' +
            'טל שחר,טל-אל,טללים,טלמון,טמרה,טמרה (יזרעאל),טנא,טפחות,יאנוח-ג\'ת,יבול,\n' +
            'יבנאל,יבנה,יגור,יגל,יד בנימין,יד השמונה,יד חנה,יד מרדכי,יד נתן,יד רמב"ם,\n' +
            'ידידה,יהוד,יהל,יובל,יובלים,יודפת,יונתן,יושיביה,יזרעאל,יחיעם,\n' +
            'יטבתה,ייט"ב,יכיני,ינוב,ינון,יסוד המעלה,יסודות,יסעור,יעד,יעל,\n' +
            'יעף,יערה,יפיע,יפית,יפעת,יפתח,יצהר,יציץ,יקום,יקיר,\n' +
            'יקנעם (מושבה),יקנעם עילית,יראון,ירדנה,ירוחם,ירושלים,ירחיב,ירכא,ירקונה,ישע,\n' +
            'ישעי,ישרש,יתד,כאבול,כאוכב אבו אל-היג\'א,כברי,כדורי,כדיתה,כוכב השחר,כוכב יאיר,\n' +
            'כוכב יעקב,כוכב מיכאל,כורזים,כחל,כחלה,כיסופים,כישור,כליל,כלנית,כמאנה,\n' +
            'כמהין,כמון,כנות,כנף,כנרת (מושבה),כנרת (קבוצה),כסיפה,כסלון,כסרא-סמיע,כעביה-טבאש-חג\'אג\'רה,\n' +
            'כפר אביב,כפר אדומים,כפר אוריה,כפר אחים,כפר ביאליק,כפר ביל"ו,כפר בלום,כפר בן נון,כפר ברא,כפר ברוך,\n' +
            'כפר גדעון,כפר גלים,כפר גליקסון,כפר גלעדי,כפר דניאל,כפר האורנים,כפר החורש,כפר המכבי,כפר הנגיד,כפר הנוער הדתי,\n' +
            'כפר הנשיא,כפר הס,כפר הרא"ה,כפר הרי"ף,כפר ויתקין,כפר ורבורג,כפר ורדים,כפר זוהרים,כפר זיתים,כפר חב"ד,\n' +
            'כפר חושן,כפר חיטים,כפר חיים,כפר חנניה,כפר חסידים א\',כפר חסידים ב\',כפר חרוב,כפר טרומן,כפר יאסיף,כפר ידידיה,\n' +
            'כפר יהושע,כפר יונה,כפר יחזקאל,כפר יעבץ,כפר כמא,כפר כנא,כפר מונש,כפר מימון,כפר מל"ל,כפר מנדא,\n' +
            'כפר מנחם,כפר מסריק,כפר מצר,כפר מרדכי,כפר נטר,כפר סאלד,כפר סבא,כפר סילבר,כפר סירקין,כפר עבודה,\n' +
            'כפר עזה,כפר עציון,כפר פינס,כפר קאסם,כפר קיש,כפר קרע,כפר ראש הנקרה,כפר רוזנואלד (זרעית),כפר רופין,כפר רות,\n' +
            'כפר שמאי,כפר שמואל,כפר שמריהו,כפר תבור,כפר תפוח,כרכום,כרם בן זמרה,כרם בן שמן,כרם יבנה (ישיבה),כרם מהר"ל,\n' +
            'כרם שלום,כרמי יוסף,כרמי צור,כרמיאל,כרמייה,כרמים,כרמל,לבון,לביא,לבנים,\n' +
            'להב,להבות הבשן,להבות חביבה,להבים,לוד,לוזית,לוחמי הגיטאות,לוטם,לוטן,לימן,\n' +
            'לכיש,לפיד,לפידות,לקיה,מאור,מאיר שפיה,מבוא ביתר,מבוא דותן,מבוא חורון,מבוא חמה,\n' +
            'מבוא מודיעים,מבואות ים,מבועים,מבטחים,מבקיעים,מבשרת ציון,מג\'ד אל-כרום,מג\'דל שמס,מגאר,מגדים,\n' +
            'מגדל,מגדל העמק,מגדל עוז,מגדלים,מגידו,מגל,מגן,מגן שאול,מגשימים,מדרך עוז,\n' +
            'מדרשת בן גוריון,מדרשת רופין,מודיעין עילית,מודיעין-מכבים-רעות*,מולדה*,מולדת,מוצא עילית,מוקייבלה,מורן,מורשת,\n' +
            'מזור,מזכרת בתיה,מזרע,מזרעה,מחולה,מחנה הילה*,מחנה טלי*,מחנה יהודית*,מחנה יוכבד*,מחנה יפה*,\n' +
            'מחנה מרים*,מחנה תל נוף*,מחניים,מחסיה,מטולה,מטע,מי עמי,מיטב,מייסר,מיצר,\n' +
            'מירב,מירון,מישר,מיתר,מכורה,מכחול,מכמורת,מכמנים,מלאה,מלילות,\n' +
            'מלכייה,מלכישוע,מנוחה,מנוף,מנות,מנחמיה,מנרה,מנשית זבדה,מסד,מסדה,\n' +
            'מסילות,מסילת ציון,מסלול,מסעדה,מעברות,מעגלים,מעגן,מעגן מיכאל,מעוז חיים,מעון,\n' +
            'מעונה,מעיין ברוך,מעיין צבי,מעיליא,מעלה אדומים,מעלה אפרים,מעלה גלבוע,מעלה גמלא,מעלה החמישה,מעלה לבונה,\n' +
            'מעלה מכמש,מעלה עירון,מעלה עמוס,מעלה שומרון,מעלות-תרשיחא,מענית,מעש,מפלסים,מצדות יהודה,מצובה,\n' +
            'מצליח,מצפה,מצפה אבי"ב,מצפה אילן,מצפה יריחו,מצפה נטופה,מצפה רמון,מצפה שלם,מצר,מרגליות,\n' +
            'מרום גולן,מרחב עם,מרחביה (מושב),מרחביה (קיבוץ),מרכז שפירא,משאבי שדה,משגב דב,משגב עם,משהד,משואה,\n' +
            'משואות יצחק,משכיות,משמר איילון,משמר דוד,משמר הירדן,משמר הנגב,משמר העמק,משמר השבעה,משמר השרון,משמרות,\n' +
            'משמרת,משען,מתן,מתת,מתתיהו,נאות גולן,נאות הכיכר,נאות מרדכי,נאות סמדר,נאעורה,\n' +
            'נבטים,נגבה,נגוהות,נהורה,נהלל,נהרייה,נוב,נוגה,נווה,נווה אור,\n' +
            'נווה אטי"ב,נווה אילן,נווה איתן,נווה דניאל,נווה זוהר,נווה זיו,נווה חריף,נווה ים,נווה ימין,נווה ירק,\n' +
            'נווה מבטח,נווה מיכאל,נווה שלום,נועם,נוף איילון,נופים,נופית,נופך,נוקדים,נורדייה,\n' +
            'נורית,נחושה,נחל עוז,נחלה,נחליאל,נחלים,נחם,נחף,נחשולים,נחשון,\n' +
            'נחשונים,נטועה,נטור,נטע,נטעים,נטף,ניין,ניל"י,ניצן,ניצן ב\',\n' +
            'ניצנה (קהילת חינוך),ניצני סיני,ניצני עוז,ניצנים,ניר אליהו,ניר בנים,ניר גלים,ניר דוד (תל עמל),ניר ח"ן,ניר יפה,\n' +
            'ניר יצחק,ניר ישראל,ניר משה,ניר עוז,ניר עם,ניר עציון,ניר עקיבא,ניר צבי,נירים,נירית,\n' +
            'נירן,נס הרים,נס עמים,נס ציונה,נעורים,נעלה,נעמ"ה,נען,נצר חזני,נצר סרני,\n' +
            'נצרת,נצרת עילית,נשר,נתיב הגדוד,נתיב הל"ה,נתיב העשרה,נתיב השיירה,נתיבות,נתניה,סאג\'ור,\n' +
            'סאסא,סביון*,סגולה,סואעד (חמרייה)*,סולם,סוסיה,סופה,סח\'נין,סלמה,סלעית,\n' +
            'סמר,סנסנה,סעד,סער,ספיר,סתרייה,ע\'ג\'ר,עבדון,עברון,עגור,\n' +
            'עדי,עדנים,עוזה,עוזייר,עולש,עומר,עופר,עוצם,עזוז,עזר,\n' +
            'עזריאל,עזריה,עזריקם,עטרת,עידן,עיילבון,עיינות,עילוט,עין איילה,עין אל-אסד,\n' +
            'עין גב,עין גדי,עין דור,עין הבשור,עין הוד,עין החורש,עין המפרץ,עין הנצי"ב,עין העמק,עין השופט,\n' +
            'עין השלושה,עין ורד,עין זיוון,עין חוד,עין חצבה,עין חרוד (איחוד),עין חרוד (מאוחד),עין יהב,עין יעקב,עין כרם-בי"ס חקלאי,\n' +
            'עין כרמל,עין מאהל,עין נקובא,עין עירון,עין צורים,עין קנייא,עין ראפה,עין שמר,עין שריד,עין תמר,\n' +
            'עינת,עיר אובות,עכו,עלומים,עלי,עלי זהב,עלמה,עלמון,עמוקה,עמינדב,\n' +
            'עמיעד,עמיעוז,עמיקם,עמיר,עמנואל,עמקה,ענב,עספיא,עפולה,עפרה,\n' +
            'עץ אפרים,עצמון שגב,עראבה,עשהאל,עראמשה*,ערב אל נעים,ערד,ערוגות,ערערה,ערערה-בנגב,עשרת,\n' +
            'עתלית,עתניאל,פארן,פדואל,פדויים,פדיה,פוריידיס,פורייה - כפר עבודה,פורייה - נווה עובד,פורייה עילית,\n' +
            'פורת,פטיש,פלך,פלמחים,פני חבר,פסגות,פסוטה,פעמי תש"ז,פצאל,פקיעין (בוקייעה),\n' +
            'פקיעין חדשה,פרדס חנה-כרכור,פרדסייה,פרוד,פרזון,פרי גן,פתח תקווה,פתחיה,צאלים,צביה,\n' +
            'צבעון,צובה,צוחר,צופייה,צופים,צופית,צופר,צוקי ים,צוקים,צור הדסה,\n' +
            'צור יצחק,צור משה,צור נתן,צוריאל,צורית,ציפורי,צלפון,צנדלה,צפרייה,צפרירים,\n' +
            'צפת,צרופה,צרעה,קבוצת יבנה,קדומים,קדימה-צורן,קדמה,קדמת צבי,קדר,קדרון,\n' +
            'קדרים,קוממיות,קורנית,קטורה,קיסריה,קלחים,קליה,קלנסווה,קלע,קציר,\n' +
            'קצר א-סר,קצרין,קריית אונו,קריית ארבע,קריית אתא,קריית ביאליק,קריית גת,קריית טבעון,קריית ים,קריית יערים,\n' +
            'קריית יערים (מוסד),קריית מוצקין,קריית מלאכי,קריית נטפים,קריית ענבים,קריית עקרון,קריית שלמה,קריית שמונה,קרני שומרון,קשת,\n' +
            'ראמה,ראס אל-עין,ראס עלי,ראש העין,ראש פינה,ראש צורים,ראשון לציון,רבבה,רבדים,רביבים,\n' +
            'רביד,רגבה,רגבים,רהט,רווחה,רוויה,רוח מדבר,רוחמה,רומאנה,רומת הייב,\n' +
            'רועי,רותם,רחוב,רחובות,רחלים,ריחאנייה,ריחן,ריינה,רימונים,רינתיה,\n' +
            'רכסים,רם-און,רמות,רמות השבים,רמות מאיר,רמות מנשה,רמות נפתלי,רמלה,רמת גן,רמת דוד,\n' +
            'רמת הכובש,רמת השופט,רמת השרון,רמת יוחנן,רמת ישי,רמת מגשימים,רמת צבי,רמת רזיאל,רמת רחל,רנן,\n' +
            'רעים,רעננה,רקפת,רשפון,רשפים,רתמים,שאר ישוב,שבי ציון,שבי שומרון,שבלי - אום אל-גנם,\n' +
            'שגב-שלום,שדה אילן,שדה אליהו,שדה אליעזר,שדה בוקר,שדה דוד,שדה ורבורג,שדה יואב,שדה יעקב,שדה יצחק,\n' +
            'שדה משה,שדה נחום,שדה נחמיה,שדה ניצן,שדה עוזיהו,שדה צבי,שדות ים,שדות מיכה,שדי אברהם,שדי חמד,\n' +
            'שדי תרומות,שדמה,שדמות דבורה,שדמות מחולה,שדרות,שואבה,שובה,שובל,שוהם,שומרה,\n' +
            'שומרייה,שוקדה,שורש,שורשים,שושנת העמקים,שזור,שחר,שחרות,שיבולים,שיטים,\n' +
            'שייח\' דנון,שילה,שילת,שכניה,שלווה,שלווה במדבר,שלוחות,שלומי,שלומית,שמיר,\n' +
            'שמעה,שמרת,שמשית,שניר,שעב,שעל,שעלבים,שער אפרים,שער הגולן,שער העמקים,\n' +
            'שער מנשה,שערי תקווה,שפיים,שפיר,שפר,שפרעם,שקד,שקף,שרונה,שריגים (לי-און),\n' +
            'שריד,שרשרת,שתולה,שתולים,תאשור,תדהר,תובל,תומר,תושייה,תימורים,\n' +
            'תירוש,תל אביב -יפו,תל יוסף,תל יצחק,תל מונד,תל עדשים,תל קציר,תל שבע,תל תאומים,תלם,\n' +
            'תלמי אליהו,תלמי אלעזר,תלמי ביל"ו,תלמי יוסף,תלמי יחיאל,תלמי יפה,תלמים,תמרת,תנובות,תעוז,\n' +
            'תפרח,תקומה,תקוע,תרבין א-צאנע (יישוב)*,תרום,';

        return allStates.split(',').map(function (state) {
            return {
                value: state,
                display: state
            };
        });
    }

    /**
     * Create filter function for a query string
     */
    function createFilterFor(query) {
        var lowercaseQuery = angular.lowercase(query);

        return function filterFn(state) {
            return (state.value.indexOf(lowercaseQuery) === 0);
        };

    }


    jQuery.extend(jQuery.fn.dataTableExt.oSort, {
        "eu-date-pre": function (a) {
            if (a == null || a == '') {
                return 0;
            }
            var date = a.split('/');
            return Date.parse(date[1] + '/' + date[0] + '/' + date[2])
        }
    });

    $scope.dtColumnDefs = [
        DTColumnDefBuilder.newColumnDef(0)
            .withOption('type', 'date')
    ];


    /**
     * Add comments in Staff
     * @param content
     */
    $scope.addComment = function () {
        var content = $rootScope.commentText;
        content = content.replace(/(\r\n|\n|\r)/gm, "<br>");
        var comment = {};
        comment.badgeClass = 'info';
        //comment.badgeIconClass='glyphicon-check';
        comment.user = $rootScope.User.FirstName + " " + $rootScope.User.LastName;
        comment.content = content;
        comment.date = Date.now();
        $scope.Comments.splice(0, 0, comment);

        var dopComments = angular.copy($scope.Comments);
        dopComments = JSON.stringify(dopComments);
        $scope.parent.Comments = dopComments;
        $rootScope.commentText = '';
    };

    /**
     * Set Comments
     */
    function setComments() {
        if ($scope.parent.Comments)
            $scope.Comments = JSON.parse($scope.parent.Comments);
        else
            $scope.Comments = [];
    }

    $scope.deleteCashTransaction = function (cash) {
        if ($scope.isClicked) return;
        $scope.isClicked = true;
        parentsEndpoint.cash.delete({CashID: cash.ID, ParentID: $scope.parent.ID}, function (data) {
            $scope.getCash();
            $scope.isClicked = false;
        })
    }

}

angular.module('app.pages.users').controller('ParentPanelController', ['$scope','parent','$rootScope', function($scope,parent,$rootScope) {

    $scope.$on('selectedParent:updated', function() {
        $scope.parent= parent.selectedParent;
    });
    $scope.$watchCollection('parent',function (newValue, oldValue) {
        $rootScope.editDataHandler(newValue, oldValue,'parent-panel')
    });

    $scope.relations =['אמא','אבא','אחר']



}]);
angular.module('app.pages.users').controller('NewCoordinatorsDialogController', ['$scope', '$rootScope', '$mdDialog','coordinatorsEndpoint','coordinate','$location','Notification', function ($scope, $rootScope, $mdDialog,coordinatorsEndpoint,coordinate,$location,Notification) {

    /**
     * Save new Student
     */
    $scope.saveNesCoordinator = function () {
        $scope.isClicked = true;
        coordinatorsEndpoint.post($scope.newCoordinator,function (data) {
            $scope.isClicked = false;
            if (data.ID) {
                Notification.success("הזמנה נשלחה למשתמש")
                coordinate.updateSelectedCoordinate(data);
                $location.path('/coordinator-profile?ID='+data.ID);
                $mdDialog.hide();
            }
            else {
                Notification.info("דואר אלקטרוני קיים במערכת")
            }
        })

    };

    /**
     * Close the dialog
     */
    $scope.closeDialog =function () {
        $mdDialog.cancel();
    };

}]);

(function ()
{
    'use strict';

    angular
        .module('app.pages.new-coordinator', [])
        .config(config);


    /** @ngInject */
    function config($stateProvider)
    {

        $stateProvider.state('app.pages_new-coordinator', {
            url      : '/new-coordinator',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/pages/users/views/coordinators/new-coordinator/new-coordinator.html',
                    controller : 'NewCoordinatorController'
                }
            },
            bodyClass: 'profile'
        });


    }

})();
angular.module('app.pages.new-coordinator').controller('NewCoordinatorController', NewCoordinatorController)
function NewCoordinatorController($scope, $rootScope,$location,coordinatorsEndpoint,Notification,$timeout,appConfig,$cookies) {


    $scope.showHideText = 'הצג';
    $scope.inputType = 'password';
    $scope.showHideImg = "/assets/icons/show.svg";
    $scope.matchPasswords = false;
    $scope.matchFlags = true;
    $scope.password = '';
    $scope.passwordVerify = '';
    $scope.form = {};
    $scope.success = false;
    $scope.loading = false;
    $scope.appConfig = appConfig;
    $scope.errorInfo = "";

    /**
     * Valid the new admin request for register a new admin
     */
    $scope.validRequest = function () {
        var params = {};
        params.token =  $location.search().tempToken;
        coordinatorsEndpoint.new.valid.post(params,function (data) {
            if (data.success)
                $scope.valid=true;
            else{
                $location.path("/");
                $scope.notValid=true;
            }

        })
    };
    $scope.matchPass = function () {
        if ($scope.form.password == $scope.passwordVerify && $scope.form.password.length > 5) {
            $scope.matchPasswords = true;
            $scope.matchFlags = true;
        } else if ($scope.form.password == $scope.passwordVerify && $scope.form.password.length < 6) {
            $scope.shortPass = true;
            $scope.matchFlags = true;
        } else {
            $scope.shortPass = false;
            $scope.matchPasswords = false;
            $scope.matchFlags = false;
        }
    }

    /**
     * Display or hide the password
     */
    $scope.showHidePassword = function () {
        if ($scope.inputType == "password") {
            $scope.inputType = "text";
            $scope.showHideText = 'הסתר';
            $scope.showHideImg = "/assets/icons/hide.svg";
        } else {
            $scope.inputType = "password";
            $scope.showHideText = 'הצג';
            $scope.showHideImg = "/assets/icons/show.svg";
        }

    };

    /**
     * Submit the new admin sing up
     */
    $scope.submit = function () {
        $scope.form.token = $location.search().tempToken;
        coordinatorsEndpoint.new.post($scope.form, function (data) {
            if (typeof data == 'string' || data instanceof String) {
                $scope.errorInfo = data;
                $scope.fail = true;
                $timeout(function () {
                    $scope.fail = false;
                }, 5000);
            }
            else if (data.ID) {
                $rootScope.User = data;
                setUserType();
                saveUser();
                $scope.success = true;
            }
            else
                $scope.errorInfo = "Error!";
            $scope.loading = true;
        })

    };

    /**
     * Set the admin type
     */
    function setUserType() {
        if ($rootScope.User.StudentID)
            $rootScope.AdminLevel = 1;
        else if ($rootScope.User.IsCoordinator)
            $rootScope.AdminLevel = 2;
        else
            $rootScope.AdminLevel = 3;
    }

    function saveUser() {
        var expireTime = +new Date() + (24 * 3600000);
        $cookies.put("marvilixAccessToken", $rootScope.User.AccessToken, [{expires: expireTime}]);
        $scope.loogin = false;
        $timeout(function () {
            if ($rootScope.AdminLevel !== 3)
                $location.path('/students');
            else
                $location.path('/dashboard');
        }, 250)
    }

    /**
     * href to login page
     */
    $scope.goToLogin = function () {
        $location.path("/");
    };

}
(function ()
{
    'use strict';

    angular
        .module('app.pages.coordinators-profile', ['datatables'])
        .config(config);


    /** @ngInject */
    function config($stateProvider)
    {
        $stateProvider.state('app.pages_coordinators-profile', {
            url      : '/coordinator-profile',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/pages/users/views/coordinators/coordinators-profile/coordinators-profile.html',
                    controller: 'CoordinatorProfileController'
                },

            },
            resolve  : {
                DashboardData: function ()
                {
                    localStorage.setItem("path",'/coordinator-profile');
                }
            },
            bodyClass: 'coordinator-profile'
        });


    }

})();
angular.module('app.pages.coordinators-profile').controller('CoordinatorProfileController',CoordinatorProfileController);
function CoordinatorProfileController($scope, $rootScope,$location,usersEndpoint,$mdSidenav,$mdDialog,rolesEndpoint,settingsEndpoint, DTOptionsBuilder,$timeout,coordinate,coordinatorsEndpoint,parent,dtOptions,Notification,branchesEndpoint,areasEndpoint) {



    /**
     * Init Student Profile
     */
    function init() {
        var coordinatorObject = {};
        coordinatorObject.ID = $location.search().ID;
        if (!coordinatorObject.ID) {
            $location.path('/coordinators');
        }
        else {
           resolveCoordinator(coordinatorObject);
        }
        $scope.currentCoordinatorID = null;
        $scope.$watch(function(){ return $location.search() }, function(data){
            if($scope.currentCoordinatorID !== null && data.ID !== $scope.currentCoordinatorID){
                if (data.ID){
                    coordinatorObject = {};
                    coordinatorObject.ID = data.ID;
                    if (!coordinatorObject.ID) {
                        $location.path('/coordinators');
                    }
                    else {
                        resolveCoordinator(coordinatorObject);
                    }
                }
            }
        });
    }

    init();

    /**
     * resolve the coordinator by the ID stored in coordinatorObject
     * @param coordinatorObject
     */
    function resolveCoordinator(coordinatorObject) {
        coordinatorsEndpoint.get(coordinatorObject, function (data) {
            if (data[0]) {
                for (key in data[0]) {
                    if (data[0][key] == "null") {
                        data[0][key] = "";
                    }
                }
                $scope.coordinator = data[0];
                coordinate.updateSelectedCoordinate($scope.coordinator);
                if (!$scope.coordinator.Branches)
                    $scope.coordinator.Branches = [];
                $scope.getAllBranches();
                $scope.getRoles();
                $scope.getAreas();
            }
            else
                $location.path('/coordinators');
        })
    }

    /**
     * Looking gor changes in the Coordinators object
     */
    $scope.$watchCollection('coordinator', function (newValue, oldValue) {
        if (typeof  $rootScope.editDataHandler === 'function')
            $rootScope.editDataHandler(newValue, oldValue, 'coordinator-profile')
    });

    /**
     * Set Table option
     * @type {any}
     */
    $scope.dtOptions = DTOptionsBuilder
        .newOptions()
        .withLanguage(dtOptions.language)
        .withDOM('lfrtp')
        .withOption('bFilter', false)
        .withDOM('lrtip');


    /**
     * Get All branches
     */
    $scope.getAllBranches = function () {
        var params = {};
        params.Status = 1;
        branchesEndpoint.get(params, function (data) {
            $scope.branches = data;
            if (!$scope.coordinator.Branches)
                $scope.coordinator.Branches = [];
            else {
                $scope.selectedBranches = [];
                for (var i = 0; i < $scope.branches.length; i++) {
                    for (var j = 0; j < $scope.coordinator.Branches.length; j++) {
                        if ($scope.branches[i]['ID'] == $scope.coordinator.Branches[j]['ID'])
                            $scope.selectedBranches.push($scope.branches[i]);

                    }
                }
            }
        });
    };

    $scope.getAreas  =function () {
        var params = {};
        params.Status =1;
        areasEndpoint.get(params,function (data) {
            $scope.areas = data;
            if (!$scope.coordinator.Areas)
                $scope.coordinator.Areas = [];
            else {
                $scope.selectedAreas = [];
                for (var i = 0; i < $scope.areas.length; i++) {
                    for (var j = 0; j < $scope.coordinator.Areas.length; j++) {
                        if ($scope.areas[i]['ID'] == $scope.coordinator.Areas[j]['ID'])
                            $scope.selectedAreas.push($scope.areas[i]);
                    }
                }
            }
        })
    };

    /**
     * Update coordinator branches
     */
    $scope.updateBranches = function () {
        $scope.isClicked = true;
        var params = {};
        $scope.coordinator.Branches = $scope.selectedBranches;
        localStorage.setItem("selectedCoordinator", JSON.stringify($scope.coordinator));
        params.BranchIdes = JSON.stringify($scope.selectedBranches);
        coordinatorsEndpoint.branches.update.post($scope.coordinator, params, function (data) {
            $scope.isClicked = false;
            if (!data.success)
                Notification.info("שגיאה");
            else
                Notification.success("סניפים עודכנו");

        })
    };

    /**
     * Update coordinator branches
     */
    $scope.updateAreas = function () {
        $scope.isClicked = true;
        var params = {};
        $scope.coordinator.Branches = $scope.selectedBranches;
        localStorage.setItem("selectedCoordinator", JSON.stringify($scope.coordinator));
        params.AreasIds = JSON.stringify($scope.selectedAreas);
        coordinatorsEndpoint.areas.update.post($scope.coordinator, params, function (data) {
            $scope.isClicked = false;
            if (!data.success)
                Notification.info("שגיאה");
            else
                Notification.success("אזורים עודכנו");

        })
    };

    /**
     * Groups query search
     * @param query
     * @returns {*}
     */
    $scope.branchesQuerySearch = function (query) {
        var results = query ?
            $scope.branches.filter(createFilterFor(query)) : [];
        return results;
    };

    $scope.areaQuerySearch =  function (query) {
        var results = query ?
            $scope.areas.filter(createFilterFor(query)) : [];
        return results;
    };

    /**
     * Create filter for query from auto complete
     * @param query
     * @returns {filterFn}
     */
    function createFilterFor(query) {
        var lowercaseQuery = angular.lowercase(query);
        return function filterFn(contact) {
            return (contact.Name.indexOf(lowercaseQuery) != -1);
        };
    }


    /**
     * open new Coordinators dialog
     */
    $scope.openNewCoordinatorDialog = function () {
        coordinatorsEndpoint.post($scope.coordinator, function (data) {
            if (data.ID)
                Notification.success("דואר אלקטרוני נשלח בהצלחה");
        })

    }

    /**
     * Get Roles
     */
    $scope.getRoles = function () {
        var params = {};
        params.withNames = true;
        rolesEndpoint.get(params, function (data) {
            $scope.roles = data;
        })
    }

    $scope.getGlobalMaxNumOfPayments = function () {
        settingsEndpoint.accountancy.maxPayments.get(function(data){
            $scope.globalMaxNumOfPayments = data.max;
        })
    }


}

angular.module('app.pages.users').controller('CoordinatePanelController', ['$scope','coordinate','$rootScope','rolesEndpoint', function($scope,coordinate,$rootScope,rolesEndpoint) {




    /**
     * Set the selected Coordinators
     */
    $scope.$on('selectedCoordinate:updated', function() {
        $scope.coordinate= coordinate.selectedCoordinate;
        $scope.getRoles();
    });
    
    /**
     * Get Roles
     */
    $scope.getRoles =function () {
        var params = {};
        params.withNames = true;
        rolesEndpoint.get(params, function (data) {
            $scope.roles = data;
        })
    }

    /**
     * looking for changes in the Coordinators object
     */
    $scope.$watchCollection('coordinate',function (newValue, oldValue) {
        $rootScope.editDataHandler(newValue, oldValue,'coordinate-panel')
    })







}]);
(function ()
{
    'use strict';

    angular
        .module('app.pages.settings', [])
        .config(config);



    /** @ngInject */
    function config($stateProvider)
    {
        $stateProvider.state('app.pages_settings', {
            url      : '/settings',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/pages/settings/settings.html',
                    controller: 'SettingsController as vm'
                }
            },
            resolve  : {
                DashboardData: function (ValidToken)
                {
                    ValidToken.validUserToken();
                    localStorage.setItem("path",'/settings');
                }
            },
            bodyClass: 'settings'
        })





    }

})();
angular.module('app.pages.settings').controller('FieldPanelController', FieldPanelController);
function FieldPanelController($scope, extraField, $rootScope) {


    /**
     * Set the selected Field
     */
    $scope.$on('selectedField:updated', function () {
        $scope.field = extraField.selectedField;
    });

    /**
     * Look for changes in the selected Field
     */
    $scope.$watch('field', function (newValue, oldValue) {
        $rootScope.editDataHandler(newValue, oldValue, 'field-panel')
    }, true);


}

angular.module('app.pages.settings').controller('NewFieldDialogController', NewFieldDialogController);
function NewFieldDialogController($scope, $mdDialog,systemSettingsEndpoint,Notification) {

    $scope.newField = {
        Requierd: 1,
    };
    $scope.newField.Values = [];

    /**
     * Save new Field
     */
    $scope.saveNewField = function () {
        $scope.isClicked = true;

        systemSettingsEndpoint.studentExtraFields.post({field: $scope.newField}, function (data) {
            $scope.isClicked = false;
            if (!data.success)
                Notification.error("נכשל ביצירה");
            $mdDialog.hide();
        })

    };

    /**
     * Close the dialog
     */
    $scope.closeDialog = function () {
        $mdDialog.cancel();
    };

}

angular.module('app.pages.events').controller('NewTransportationDialogController', ['$scope', '$rootScope', '$mdDialog','transportationEndpoint','student','$location','Notification', function ($scope, $rootScope, $mdDialog,transportationEndpoint,student,$location,Notification) {

    $scope.neTransportation = {};
    $scope.neTransportation.Options = [];

    /**
     * Save new Transportation
     */
    $scope.saveNewTransportation = function () {
        $scope.isClicked = true;
        transportationEndpoint.post($scope.newTransportation,function (data) {
            $scope.isClicked = false;
            if (!data.success)
                Notification.info("נכשל ביצירה");
            $mdDialog.hide();
        })
    };
    /**
     * Close the dialog
     */
    $scope.closeDialog =function () {
        $mdDialog.cancel();
    };



}]);

angular.module('app.pages.events').controller('TransportationPanelController', ['$scope','transportation','$rootScope', function($scope,transportation,$rootScope) {

    /**
     * Set the selected Transportation
     */
    $scope.$on('selectedTransportation:updated', function() {
        $scope.transportation= transportation.selectedTransportation;
    });


    /**
     * Look for changes in the transportation
     */
    $scope.$watch('transportation',function (newValue, oldValue) {
        $rootScope.editDataHandler(newValue, oldValue,'transportation-panel')
    },true);




}]);
angular.module('app.pages.events').controller('QuestionPanelController', QuestionPanelController);
function QuestionPanelController($scope,question,$rootScope) {


    /**
     * Set the selected Question
     */
    $scope.$on('selectedQuestion:updated', function () {
        $scope.question = question.selectedQuestion;
    });

    /**
     * Look for changes in the selected Questions
     */
    $scope.$watch('question', function (newValue, oldValue) {
        $rootScope.editDataHandler(newValue, oldValue, 'question-panel')
    }, true);


};
angular.module('app.pages.events').controller('NewQuestionDialogController', NewQuestionDialogController);
function NewQuestionDialogController($scope, $mdDialog,questionsEndpoint,Notification,eventID,branchesEndpoint) {

    $scope.newQuestion = {};
    $scope.newQuestion.Options = [];
    $scope.eventID = eventID;

    /**
     * Save new Question
     */
    $scope.saveNewQuestion = function () {
        $scope.isClicked = true;
        var params = {};
        params.newQuestion = $scope.newQuestion;
        params.eventID = $scope.eventID;


        questionsEndpoint.post(params, function (data) {
            $scope.isClicked = false;
            if (!data.success)
                Notification.info("נכשל ביצירה");
            $mdDialog.hide();


        })

    };

    /**
     * Get All Branches
     */
    $scope.getAllBranches = function () {
        var params = {};
        params.Status =1;
        branchesEndpoint.get(params, function (data) {
            $scope.branches = data;
        })
    };

    /**
     * Close the dialog
     */
    $scope.closeDialog = function () {
        $mdDialog.cancel();
    };

}

angular.module('app.pages.events').controller('NewEventsDialogController', NewEventsDialogController);
function NewEventsDialogController($scope,$rootScope,appConfig,$mdDialog,eventsEndpoint,$location,Notification,event,$timeout,isProduct) {

    $scope.externalEventsEnabled = appConfig.externalEventsEnabled;


    $scope.init = function() {
        $scope.newEvent = {};
        //$scope.getEvents();
        $scope.setType();
    };


    $scope.setType = function() {
        if (!isProduct) {
            $scope.title = $rootScope.User.Event;
        }
        else {
            $scope.title = "מוצר";
        }
    };

    /**
     * Save new Event
     */
    $scope.saveNewEvent = function () {
        if($scope.newEvent.EventType == 1 && $scope.newEvent.CartEvent == 1){
            Notification.error('לא ניתן ליצור ' + $scope.title + ' הרשמה סל חיצוני');
            return;
        }
        if($scope.newEvent.CartEvent == 1){
            $scope.newEvent.StartDate = null;
            $scope.newEvent.EndDate = null;
        }
        $scope.isClicked = true;
        $scope.newEvent.isProduct = isProduct;
        eventsEndpoint.post($scope.newEvent, function (data) {
            $scope.isClicked = false;
            if (!data.ID)
                Notification.info("נכשל ביצירה");
            else {
                $timeout(function () {
                    location.href = '/event-management?ID='+data.ID;
                }, 250)
            }
            $mdDialog.hide();
        })
    };

    $scope.setName = function() {
        $scope.newEvent.Name=$scope.newEvent.DuplicateEvent.Name
    };

    /*$scope.getEvents = function () {
        var params = {};
        params['Status'] = 1;
        eventsEndpoint.get(params,function (data) {
            $scope.events= data;
        })
    };*/

    $scope.getEvents = function (searchTerm) {
        var params = {
            Status: 1,
            FreeSearch: searchTerm,
            Limit: 10000
        };

        eventsEndpoint.get(params, function (data) {
            $scope.events = data;
        });
    };

    $scope.eventKeyPress = function(event){
        var currentState = event.target.value;
        $timeout(function () {
            if(currentState != undefined && currentState.length > 2 && currentState == event.target.value)
                $scope.getEvents(currentState);
        },1000)
    }


    /**
     * Close the dialog
     */
    $scope.closeDialog = function () {
        $mdDialog.cancel();
    };

}

angular.module('app.pages.event-management').controller('EventManagementController', EventManagementController);

function EventManagementController($scope, $window, $rootScope, $location, usersEndpoint, $mdSidenav, $mdDialog, settingsEndpoint, DTOptionsBuilder, $timeout, parent, parentsEndpoint, dtOptions, Notification, event, eventsEndpoint, branchesEndpoint, gradesEndpoint, $element, areasEndpoint, appConfig, receiptsService) {


    $scope.kibutzPayBranches = [];
    $scope.warningsList = [];
    $scope.association = {};
    $scope.watchCount = 0;
    $scope.logo = appConfig.logo;
    $scope.percentsSum = 0;
    $scope.isInCart = false;
    $scope.enableMemberFields = false;
    $scope.inCartDetails = {};
    $scope.cartEvents = [];
    /**
     * Init Student Profile
     */
    $scope.sumPercents = function () {
        $scope.percentsSum = 0;
        $scope.cartEvents.forEach(function (ev) {
            $scope.percentsSum += +ev.ChargePercent;
        });
        $scope.checkWarnings();
    };

    $scope.openMemberEventEditDialog = function () {
        $mdDialog.show({
            controller: 'MemberEventEditController',
            templateUrl: 'app/main/pages/events/views/events/event-management/tabs/general/member-event-edit-dialog/member-event-edit-dialog.html',
            clickOutsideToClose: false,
            locals: {event: JSON.parse(JSON.stringify($scope.event))}
        }).then(function (updatedEvent) {
            if (updatedEvent) {
                $scope.event = updatedEvent;
            }

        });
    };

    function init() {
        var eventObject = {};
        eventObject.ID = $location.search().ID;
        if (!eventObject.ID) {
            $location.path('/events');
        } else {
            resolveEvent(eventObject);
        }
        //add query change listener for the fast search
        $scope.currentEventID = null;
        $rootScope.fastSearchWatch = $scope.$watch(function () {
            return $location.search()
        }, function (data) {
            if ($scope.currentEventID !== null && data.ID !== $scope.currentEventID) {
                if (data.ID) {
                    eventObject = {};
                    eventObject.ID = data.ID;
                    if (!eventObject.ID) {
                        $location.path('/events');
                    } else {
                        resolveEvent(eventObject);
                    }
                }
            }

        });

    }

    init();
    $scope.goToCartEvent = function () {

        $window.open($window.location.origin + '/event-management?ID=' + $scope.inCartDetails.CartID, '_blank');
    }

    /**
     * resolve the event by the ID stored in the eventObject
     * @param eventObject
     */
    function resolveEvent(eventObject) {
        eventsEndpoint.get(eventObject, function (data) {
            if (data[0]) {
                $scope.event = data[0];
                if (data[0]['EventInCart']) {
                    $scope.isInCart = true;
                    $scope.inCartDetails = data[0]['EventInCart'];
                    console.log(data[0]['EventInCart'])
                }
                event.updateSelectedEvent($scope.event);
                getEvents();
                getAllEvents();
                $scope.getAllAreas();
                $scope.getAllBranches();
                $scope.getAssociation();
                $scope.getAllGrades();
                $scope.getDonations();
                $scope.getEventReceiptFiles();
                if (!$scope.event.Groups)
                    $scope.event.Groups = [];
                $scope.currentEventID = $scope.event.ID;
                $scope.getBranchesKibutzPay();
            } else
                $location.path('/events');

        });
    }

    $scope.checkPrice = function () {
        if (!$scope.event.Price && $scope.event.Price !== 0 && $scope.event.Level != 1) {
            $scope.warningsList.push(4);
        }
    };
    $scope.checkStatus = function () {
        if (!$scope.event.Status) {
            $scope.warningsList.push(3);
        }
    };
    $scope.checkIfMaster = function () {
        if ($scope.event.Level == 1) {
            $scope.warningsList.push(5);
        }
    };
    $scope.checkDates = function (sDate, eDate, warningNumber) {
        if ($scope.event.CartEvent === 0 && $scope.event.IsProduct === 0 && (!$scope.event.StartDate || !$scope.event.EndDate)) {
            $scope.warningsList.push(1);
        } else {
            if (!sDate || !eDate) {
                $scope.warningsList.push(warningNumber);
                return;
            }
            sDate = sDate.split(' ');
            eDate = eDate.split(' ');

            var sd = new Date(sDate[0].split('/')[2], (+sDate[0].split('/')[1] + 1), sDate[0].split('/')[0]);
            var ed = new Date(eDate[0].split('/')[2], (+eDate[0].split('/')[1] + 1), eDate[0].split('/')[0]);
            if (sDate[1]) {
                sd.setHours(sDate[1].split(':')[0]);
                sd.setMinutes(sDate[1].split(':')[1]);
            }
            if (eDate[1]) {
                ed.setHours(eDate[1].split(':')[0]);
                ed.setMinutes(eDate[1].split(':')[1]);
            }

            if (sd.getTime() > ed.getTime()) {
                $scope.warningsList.push(warningNumber);
            }
        }
    };
    $scope.checkWarnings = function () {
        console.log($scope.event)
        $scope.warningsList = [];
        if (+$scope.event.CartEvent === 0 && +$scope.event.IsProduct === 0) {
            $scope.checkDates($scope.event.StartDate, $scope.event.EndDate, 1);
            $scope.checkIfMaster();
        } else if ($scope.event.CartEvent == 1) {
            if (+$scope.percentsSum != 100) {
                $scope.warningsList.push(6);
            }
            $scope.cartEvents.forEach(function (ev) {
                if (!ev.ChargePercent) {
                    $scope.warningsList.push(7);
                }

                $scope.checkDates(ev.StartDate, ev.EndDate, 8);
                $scope.checkDates(ev.RegistrationStartDate, ev.RegistrationEndDate, 9);
                if (!ev.EventStatus) {
                    $scope.warningsList.push(10);
                }
                if (!ev.Price) {
                    $scope.warningsList.push(11);
                }
            });
        }
        if ($scope.event.Level != 1) {
            $scope.checkDates($scope.event.RegistrationStartDate, $scope.event.RegistrationEndDate, 2);
            $scope.checkPrice();
        }
        $scope.checkStatus();
        if (!$scope.warningsList.length) {
            return false;
        }

        if ($scope.warningsList.includes(1) || $scope.warningsList.includes(2) || $scope.warningsList.includes(4)) {
            return true;
        }
        return false;
    };

    /**
     * Look for changes in the event object
     */
    $scope.$watch('event', function (newValue, oldValue) {

        if (!newValue && !oldValue)
            return;
        if (oldValue && newValue && newValue['MemberEvent'] != oldValue['MemberEvent'] && newValue['MemberEvent'] == 0) {
            $scope.event['MemberYear'] = 0;
            $scope.event['MinMemberYear'] = 0;
        }
        if ($rootScope.editDataHandler && oldValue) {
            if (!$scope.checkWarnings()) {
                if (newValue['Address'] === undefined && oldValue['Address'] !== undefined)
                    return;
                else
                    $rootScope.editDataHandler(newValue, oldValue, 'event-management')
            } else {
                return;
            }

        }
    }, true);


    /**
     * Get Events
     */
    function getEvents() {

        var params = {};
        params.Limit = 10000;
        params.Master = 1;
        params.WithOutEventID = $scope.event.ID;
        params.isCartEvent = $scope.event.CartEvent;
        eventsEndpoint.get(params, function (data) {
            $scope.events = data;

        })
    }

    /**
     * Get Events
     */
    function getAllEvents() {
        var params = {};
        params.Limit = 10000;
        params.Status = 1;
        params.DateStatus = 1;
        params.WithOutEventID = $scope.event.ID;
        params.isCartEvent = $scope.event.CartEvent;
        eventsEndpoint.get(params, function (data) {
            $scope.allEvents = data;
        })
    }

    /**
     * Set selected tab index
     * @param tab
     */
    $scope.setTab = function (tab) {
        $scope.selectedTab = tab;
    };

    /**
     * Check if the year is set
     */
    $scope.checkIfYearIsSet = function () {
        if ($scope.event.MemberEvent == 0)
            $scope.event.MemberYear = null;
    };

    $element.find('input').on('keydown', function (ev) {
        ev.stopPropagation();
    });

    $scope.clearSearchTerm = function () {
        $scope.searchTerm = '';
    };

    $scope.updateImage = function () {
        $mdDialog.show({
            controller: 'UploadController',
            templateUrl: 'app/upload/upload.html',
            clickOutsideToClose: false,
            locals: {
                uploadTo: 'events',
                uploadID: $scope.event.ID + "/image",
                restrictTo: []
            }
        }).then(function () {
            $scope.event.Image = $rootScope.fileResp.data.Path;
        });
    };


    /******************************************************** Event Associations Start ********************************************************/

    $scope.getAreaAssociations = function () {
        eventsEndpoint.association.areas.get($scope.event, function (data) {
            $scope.areaAssociations = data;
        })
    }

    $scope.getBranchAssociations = function () {
        eventsEndpoint.association.branches.get($scope.event, function (data) {
            $scope.branchAssociations = data;
        })
    }

    $scope.getGradeAssociations = function () {
        eventsEndpoint.association.grades.get($scope.event, function (data) {
            $scope.gradeAssociations = data;
        })
    }

    $scope.getStudentsAssociations = function () {
        eventsEndpoint.association.students.get($scope.event, function (data) {
            $scope.studentsAssociations = data;
        })
    }

    $scope.deleteAreaAssociation = function (association) {
        eventsEndpoint.association.areas.delete.post(association, function (data) {
            if (!data.success) {
                Notification.error('התרחשה שגיאה');
            }
            $scope.getAreaAssociations();
        })
    }

    $scope.deleteBranchAssociation = function (association) {
        eventsEndpoint.association.branches.delete.post(association, function (data) {
            if (!data.success) {
                Notification.error('התרחשה שגיאה');
            }
            $scope.getBranchAssociations();
        })
    }

    $scope.deleteGradeAssociation = function (association) {
        eventsEndpoint.association.grades.delete.post(association, function (data) {
            if (!data.success) {
                Notification.error('התרחשה שגיאה');
            }
            $scope.getGradeAssociations();
        })
    }

    $scope.addNewAssociation = function (type) {
        $mdDialog.show({
            controller: 'NewEventAssociationDialogController',
            templateUrl: 'app/main/pages/events/views/events/event-management/tabs/association/add-new-association-dialog/add-new-association-dialog.html',
            clickOutsideToClose: true,
            locals: {
                type: type,
                eventID: $scope.event.ID,
            }
        }).then(function () {
            if (type == 1)
                $scope.getAreaAssociations();
            if (type == 2)
                $scope.getBranchAssociations();
            if (type == 3)
                $scope.getGradeAssociations();
        });
    };

    /**
     * Get Event Association
     */
    $scope.getAssociation = function () {
        $scope.getAreaAssociations();
        $scope.getBranchAssociations();
        $scope.getGradeAssociations();
        $scope.getStudentsAssociations();
        /*$timeout(function () {
            $scope.association = {};
            eventsEndpoint.association.get($scope.event, function (data) {
                $scope.association.Branches = [];
                $scope.association.Grades = [];
                $scope.association.Areas = [];
                $scope.association.Students = data.Students;
                $scope.Grades = [];
                $scope.Branches = [];
                $scope.Areas = [];

                var tempBranches = angular.copy($scope.branches);
                angular.forEach($scope.branches, function (branchesValue) {
                    angular.forEach(data.Branches, function (dataValue) {
                        if (branchesValue.ID === dataValue.ID) {
                            $scope.association.Branches.push(branchesValue);
                            var index = findIndexInData(tempBranches,'ID',branchesValue.ID);
                            tempBranches.splice(index, 1);
                        }
                    });
                });
                $scope.branches = tempBranches;

                var tempGrades = angular.copy($scope.grades);
                angular.forEach(data.Grades, function (gradeValue) {
                    angular.forEach($scope.grades, function (dataValue) {
                        if (gradeValue.ID === dataValue.ID) {
                            $scope.association.Grades.push(gradeValue);
                            var index = findIndexInData(tempGrades,'ID',gradeValue.ID);
                            tempGrades.splice(index, 1);
                        }
                    });
                });
                $scope.grades = tempGrades;

                var tempAreas = angular.copy($scope.areas);
                angular.forEach($scope.areas, function (areaValue) {
                    angular.forEach(data.Areas, function (dataValue) {
                        if (areaValue.ID === dataValue.ID) {
                            $scope.association.Areas.push(areaValue);
                            var index = findIndexInData(tempAreas,'ID',areaValue.ID);
                            tempAreas.splice(index, 1);
                        }
                    });
                });
                $scope.areas = tempAreas;
            });
        }, 350);*/
    };

    function findIndexInData(data, property, value) {
        var result = -1;
        data.some(function (item, i) {
            if (item[property] === value) {
                result = i;
                return true;
            }
        });
        return result;
    }

    /**
     * Update the event association
     */
    $scope.updateEventAssociation = function () {
        $scope.isClick = true;
        var mapByID = function (item) {
            return item.ID;
        };
        var params = {
            EventID: $scope.event.ID,
            Branches: JSON.stringify($scope.association.Branches.map(mapByID)),
            Grades: JSON.stringify($scope.association.Grades.map(mapByID)),
            Areas: JSON.stringify($scope.association.Areas.map(mapByID))
        }
        eventsEndpoint.association.update.post(params, $scope.event, function (data) {
            $scope.isClick = false;
        })
    };


    /**
     * Get All Branches
     */
    $scope.getAllBranches = function () {
        var params = {};
        params.Status = 1;
        branchesEndpoint.get(params, function (data) {
            $scope.branches = data;
        })
    };

    /**
     * Get All Branches
     */
    $scope.getAllAreas = function () {
        var params = {};
        params.Status = 1;
        areasEndpoint.get(params, function (data) {
            $scope.areas = data;
        })
    };

    /**
     * Branches query search
     * @param query
     * @returns {Array}
     */
    $scope.branchesQuerySearch = function (query) {
        var results = query ?
            $scope.branches.filter(createFilterFor(query)) : [];
        return results;
    };

    /**
     * Get All Grades
     */
    $scope.getAllGrades = function () {
        var params = {};
        params.Status = 1;
        gradesEndpoint.get(params, function (data) {
            $scope.grades = data;
            $scope.grades2 = data;

        })
    };

    /**
     * grades query search
     * @param query
     * @returns {Array}
     */
    $scope.gradesQuerySearch = function (query) {
        var results = query ?
            $scope.grades.filter(createFilterFor(query)) : [];
        return results;
    };

    /**
     * grades query search
     * @param query
     * @returns {Array}
     */
    $scope.grades2QuerySearch = function (query) {
        var results = query ?
            $scope.grades2.filter(createFilterFor(query)) : [];
        return results;
    };

    /**
     * grades query search
     * @param query
     * @returns {Array}
     */
    $scope.areasQuerySearch = function (query) {
        var results = query ?
            $scope.areas.filter(createFilterFor(query)) : [];
        return results;
    };


    /**
     * Look for changes in Branches and remove the selected branch
     */
    $scope.$watchCollection('association.Branches', function (newValue, oldValue) {
        angular.forEach($scope.branches, function (branchesValue) {
            angular.forEach($scope.association.Branches, function (dataValue) {
                if (branchesValue.ID === dataValue.ID) {
                    var index = $scope.branches.indexOf(branchesValue);
                    if (index != -1)
                        $scope.branches.splice(index, 1);
                }
            });
        });
        var flag = false;
        angular.forEach(oldValue, function (oldValueValue) {
            angular.forEach(newValue, function (newValueValue) {
                if (newValueValue.ID == oldValueValue.ID) {
                    flag = true
                }
            });
            if (!flag)
                $scope.branches.push(oldValueValue);
            flag = false;
        });
    });

    /**
     * Look for changes in Grades and remove the selected grade
     */
    $scope.$watchCollection('association.Grades', function (newValue, oldValue) {
        angular.forEach($scope.grades, function (gradesValue) {
            angular.forEach($scope.association.Grades, function (dataValue) {
                if (gradesValue.ID === dataValue.ID) {
                    var index = $scope.grades.indexOf(gradesValue);
                    if (index != -1)
                        $scope.grades.splice(index, 1);
                }
            });
        });
        var flag = false;
        angular.forEach(oldValue, function (oldValueValue) {
            angular.forEach(newValue, function (newValueValue) {
                if (newValueValue.ID == oldValueValue.ID) {
                    flag = true
                }
            });
            if (!flag)
                $scope.grades.push(oldValueValue);
            flag = false;
        });
    });

    /**
     * Look for changes in Areas and remove the selected area
     */
    $scope.$watchCollection('association.Areas', function (newValue, oldValue) {
        angular.forEach($scope.areas, function (areaValue) {
            angular.forEach($scope.association.Areas, function (dataValue) {
                if (areaValue.ID === dataValue.ID) {
                    var index = $scope.areas.indexOf(areaValue);
                    if (index != -1)
                        $scope.areas.splice(index, 1);
                }
            });
        });
        var flag = false;
        angular.forEach(oldValue, function (oldValueValue) {
            angular.forEach(newValue, function (newValueValue) {
                if (newValueValue.ID == oldValueValue.ID) {
                    flag = true
                }
            });
            if (!flag)
                $scope.areas.push(oldValueValue);
            flag = false;
        });
    });

    $scope.addNewStudentAssociation = function () {
        $mdDialog.show({
            controller: 'NewStudentAssociation',
            templateUrl: 'app/main/pages/events/views/events/event-management/tabs/association/new-student-association-dialog/new-student-association-dialog.html',
            clickOutsideToClose: false
        }).then(function () {
            $scope.getAssociation();
        });
    };

    $scope.changeStudentStatus = function (student) {
        var params = {};
        params.EventID = $scope.event.ID;
        params.StudentID = student.StudentID;
        params.AssociationID = student.ID;
        params.Status = student.Status;
        eventsEndpoint.association.students.update.post(params, function (data) {
            if (data)
                Notification.success("סטטוס עודכן בהצלחה")
        })
    };
    /******************************************************** Event Prices By Branches Start ********************************************************/


    $scope.createNewKibutzPayByBranch = function () {
        $mdDialog.show({
            controller: 'NewBranchKibutzPayController',
            templateUrl: 'app/main/pages/events/views/events/event-management/tabs/payments/new-branch-kibutzPay-dialog/new-branch-kibutzPay-dialog.html',
            clickOutsideToClose: true,
            locals: {eventID: $scope.event.ID}
        }).then(function () {
            $scope.getBranchesKibutzPay();
        });
    };

    $scope.createNewPriceByBranch = function () {
        $mdDialog.show({
            controller: 'NewBranchPriceController',
            templateUrl: 'app/main/pages/events/views/events/event-management/tabs/payments/new-branch-price-dialog/new-branch-price-dialog.html',
            clickOutsideToClose: false,
            locals: {eventID: $scope.event.ID}
        }).then(function () {
            $scope.getPriceByBranches();
        });
    };

    $scope.getPriceByBranches = function () {
        $scope.priceByBranchs = [];
        eventsEndpoint.branches.price.get($scope.event.ID, function (data) {
            $scope.priceByBranchs = data;
        })
    };


    $scope.getBranchesKibutzPay = function () {
        $scope.priceByBranchs = [];
        eventsEndpoint.branches.kibutzPay.get($scope.event.ID, function (data) {
            $scope.kibutzPayBranches = data;
            $scope.getPriceByBranches();
        })
    };

    $scope.deleteKibutzPay = function (BranchID) {
        var params = {};
        params.EventID = $scope.event.ID;
        params.BranchID = BranchID;
        eventsEndpoint.branches.kibutzPay.delete(params, function (data) {
            if (data.success) {
                Notification.warning("סניף נמחק בהצלחה");
                angular.forEach($scope.kibutzPayBranches, function (value, key) {
                    console.log(value);
                    if (value.ID == BranchID) {
                        $scope.kibutzPayBranches.splice(key, 1);
                    }
                });
            }
        })
    };

    $scope.changeBranchPriceStatus = function (priceByBranch) {
        if (priceByBranch.Status)
            priceByBranch.Status = 0;
        else
            priceByBranch.Status = 1;

        eventsEndpoint.branches.price.update.post(priceByBranch, function (data) {
            Notification.success("סטטוס עודכן בהצלחה");
        })
    };

    /******************************************************** Event Association End ********************************************************/

    /******************************************************** Event Prices By Area Start ********************************************************/


    $scope.createNewPriceByArea = function () {
        $mdDialog.show({
            controller: 'NewAreaPriceController',
            templateUrl: 'app/main/pages/events/views/events/event-management/tabs/payments/new-area-price-dialog/new-area-price-dialog.html',
            clickOutsideToClose: false,
            locals: {eventID: $scope.event.ID}
        }).then(function () {
            $scope.getPriceByAreas();
        });
    };

    $scope.getPriceByAreas = function () {
        $scope.priceByAreas = [];
        eventsEndpoint.areas.price.get($scope.event.ID, function (data) {
            $scope.priceByAreas = data;
        })
    };

    $scope.changeAreaPriceStatus = function (priceByArea) {
        if (priceByArea.Status)
            priceByArea.Status = 0;
        else
            priceByArea.Status = 1;

        eventsEndpoint.areas.price.update.post(priceByArea, function (data) {
            Notification.success("סטטוס עודכן בהצלחה");
        })
    };

    /******************************************************** Event Association End ********************************************************/

    /*********************************************************Event Price By Groups Start**************************************************/


    $scope.createNewPriceByGroup = function () {
        $mdDialog.show({
            controller: 'NewGroupPriceController',
            templateUrl: 'app/main/pages/events/views/events/event-management/tabs/payments/new-group-price-dialog/new-group-price-dialog.html',
            clickOutsideToClose: false,
            locals: {eventID: $scope.event.ID}
        }).then(function () {
            $scope.getPriceByGroups();
        });
    };

    $scope.getPriceByGroups = function () {
        $scope.priceByGroups = [];
        eventsEndpoint.groups.price.get($scope.event.ID, function (data) {
            $scope.priceByGroups = data;
        })
    };

    $scope.changeGroupPriceStatus = function (priceByGroup) {
        if (priceByGroup.Status)
            priceByGroup.Status = 0;
        else
            priceByGroup.Status = 1;

        eventsEndpoint.groups.price.update.post(priceByGroup, function (data) {
            Notification.success("סטטוס עודכן בהצלחה");
        })
    };

    /*********************************************************Event Price By Group End******************************************************/

    /******************************************************** Event Fees Start ********************************************************/

    //not in use since number of credit payments is chosen inside the Iframe, and we have no control over it

    /*$scope.getEventFees = function(){
        eventsEndpoint.fees.get($scope.event.ID,function (data) {
            $scope.fees = data;
        })
    }

    $scope.createNewFee = function () {
        $mdDialog.show({
            controller: 'NewEventFeeController',
            templateUrl: 'app/main/pages/events/views/events/event-management/tabs/payments/new-event-fee-dialog/new-event-fee-dialog.html',
            clickOutsideToClose: false,
            locals : {event : $scope.event,fees: $scope.fees}
        }).then( function () {
            $scope.getEventFees();
        });
    }

    $scope.deleteEventFee = function (fee) {
        eventsEndpoint.fees.delete(fee,function(data){
            $scope.getEventFees();
        })
    }*/

    /******************************************************** Event Fees End ********************************************************/

    /******************************************************** Event suggestions ********************************************************/

    $scope.filterEventSuggestions = 1;
    $scope.suggestions = [];

    $scope.getSuggestions = function () {
        $scope.loadingSuggestions = false;
        eventsEndpoint.suggestions.get($scope.event.ID, function (data) {
            $scope.suggestions = data;
            $scope.loadingSuggestions = true;
        });
    }

    $scope.createNewEventSuggestion = function () {
        $mdDialog.show({
            controller: 'NewEventSuggestionController',
            templateUrl: 'app/main/pages/events/views/events/event-management/tabs/suggestions/new-suggestion-dialog/new-suggestion-dialog.html',
            clickOutsideToClose: false,
            locals: {event: $scope.event}
        }).then(function () {
            $scope.getSuggestions();
        });
    }

    $scope.changeSuggestionStatus = function (suggestion) {
        suggestion.Status = suggestion.Status == 1 ? 0 : 1;
        eventsEndpoint.suggestions.update({ID: suggestion.SuggestionID, Status: suggestion.Status}, function () {
            Notification.success('עדכון בוצע בהצלחה');
        });
    }
    /******************************************************** Event suggestions End********************************************************/

    /******************************************************** Event donations *************************************************************/

    $scope.getDonations = function () {
        if (!$scope.donations) {
            eventsEndpoint.donations.get($scope.event.ID, function (data) {
                $scope.donations = data;
                $scope.totalDonations = 0;
                $scope.donations.forEach(function (donation) {
                    $scope.totalDonations += donation.Amount;
                })
            });
        }
    }

    /* $scope.getTotalDonations = function () {
         eventsEndpoint.donations.total($scope.event.ID,function(data){
             $scope.totalDonations = data;
         });
     }*/

    /******************************************************** Event donations End *********************************************************/

    /******************************************************** Event ReceiptFiles **********************************************************/

    $scope.getEventReceiptFiles = function () {
        eventsEndpoint.files.receipts.get($scope.event.ID, function (data) {
            $scope.receiptFiles = data;

        })
    }

    $scope.deleteEventReceiptFile = function (receiptFile) {
        eventsEndpoint.files.receipts.delete(receiptFile, function (data) {
            if (!data.success)
                Notification.error('התרחשה שגיאה');
            else
                $scope.getEventReceiptFiles();
        })
    }

    /**
     * A call to files uploading controller
     */
    $scope.uploadNewEventReceiptFile = function () {
        $mdDialog.show({
            controller: 'UploadController',
            templateUrl: 'app/upload/upload.html',
            clickOutsideToClose: false,
            locals: {
                uploadTo: 'events',
                uploadID: $scope.event.ID + "/receipt-files",
                restrictTo: []
            }
        }).then(function () {
            $scope.getEventReceiptFiles();
        });
    };

    /**
     * Open File in new widnwos
     * @param path
     */
    $scope.openFile = function (path) {
        window.open(path, '_blank');
    };
    /******************************************************** Event ReceiptFiles END ******************************************************/

    /******************************************************** Cart Events *****************************************************************/

    $scope.getCartEvents = function () {
        eventsEndpoint.cartEvents.get($scope.event.ID, function (data) {
            $scope.percentsSum = 0;
            data.forEach(function (ev) {
                if (ev.Status)
                    $scope.percentsSum += +ev.ChargePercent;

            });
            $scope.cartEvents = data;

            $scope.checkWarnings();
        })
    }

    $scope.checkIfCanAdd = function () {
        eventsEndpoint.cartEvents.checkIfCanAdd.get($scope.event.ID, function (data) {
            if (data.success)
                $scope.canAdd = true;
        })
    }

    $scope.addNewCartEvent = function () {
        $mdDialog.show({
            controller: 'NewCartEventDialogController',
            templateUrl: 'app/main/pages/events/views/events/event-management/tabs/cart-events/new-cart-event-dialog/new-cart-event-dialog.html',
            clickOutsideToClose: true,
            locals: {
                cartEventID: $scope.event.ID,
                events: $scope.allEvents.filter(function (event) {
                    return event.Level == 0;
                })
            }
        }).then(function () {
            $scope.getCartEvents();
        });
    }

    $scope.updateCartEventStatus = function (cartEvent) {
        cartEvent.Status = cartEvent.Status == 1 ? 0 : 1;
        eventsEndpoint.cartEvents.update(cartEvent.CartEventID, cartEvent, function (data) {
            if (!data.success)
                Notification.error('התרחשה שגיאה');
        })
    }

    /**
     * Look for changes in the event object
     */
    $scope.$watch('cartEvents', function (newValue, oldValue) {
        if (!newValue && !oldValue) //|| !testFor100Percent()
            return;
        if ($rootScope.editDataHandler && oldValue) {
            $rootScope.editDataHandler(newValue, oldValue, 'event-car-events');
        }
    }, true);

    function testFor100Percent() {
        var events = $scope.cartEvents.filter(function (event) {
            return event.Status == 1;
        });
        return events.reduce(function (acc, cur) {
            return acc + cur.ChargePercent;
        }, 0) == 100;
    }

    /******************************************************** Cart Events END *************************************************************/


    /**
     * Create filter for query from auto complete
     * @param query
     * @returns {filterFn}
     */
    function createFilterFor(query) {
        var lowercaseQuery = angular.lowercase(query);
        return function filterFn(contact) {
            return (contact.Name.indexOf(lowercaseQuery) != -1);
        };
    }

    /**
     * Set Table option
     * @type {any}
     */
    $scope.dtOptions = DTOptionsBuilder
        .newOptions()
        .withLanguage(dtOptions.language)
        .withOption('responsive', true)
        .withDOM('lfrtp')
        .withOption('bFilter', false)
        .withDOM('lrtip');


    $scope.testDateEvent = function (event) {

        if (event === undefined) {
            return false;
        }
        if (event.RegistrationEndDate) {
            var time = event.RegistrationEndDate.split(" ");
            var date = time[0].split('/');
            time = time[1].split(':');

            var registrationDate = Date.parse(new Date(date[2], date[1] - 1, date[0], time[0], time[1]));
            return registrationDate < Date.now();

        } else return false;

    };

    $scope.moveToStudentProfile = function (ID) {
        $rootScope.fastSearchWatch();
        $location.url('/student-profile?ID=' + ID);
    };


    $scope.getGlobalMaxNumOfPayments = function () {
        settingsEndpoint.accountancy.maxPayments.get(function (data) {
            $scope.globalMaxNumOfPayments = data.max > 0 ? data.max : 100;
            if ($rootScope.User.MaxNumOfPayments) {
                $scope.globalMaxNumOfPayments = Math.min($rootScope.User.MaxNumOfPayments, $scope.globalMaxNumOfPayments);
            }
        })
    }
    /*******************************************************************************************************************/

    /**
     * download Receipt
     * @param receiptID
     * @param type
     */
    $scope.downloadReceipt = function (receiptID, type) {
        Notification.info("מייצר קבלה..אנא המתן");
        receiptsService.getReceiptByID(receiptID, type);

    };

}

angular.module('app.pages.branches').controller('NewGroupDialogController', NewGroupDialogController);
function NewGroupDialogController($scope,$rootScope, $mdDialog,branchesEndpoint,groupsEndpoint,Notification,gradesEndpoint) {

    $scope.branches = [];
    /**
     * Save new Branch
     */
    $scope.saveNewGroup = function () {
        $scope.isClicked = true;
        groupsEndpoint.post($scope.newGroup, function (data) {
            $scope.isClicked = false;
            if (!data.success)
                Notification.info("נכשל ביצירה");
            $mdDialog.hide();
        })
    };

    /**
     * Get Branches
     */
    $scope.getBranches = function () {
        var params = {};
        params.Status = 1;
        branchesEndpoint.get(params, function (data) {
            $scope.branches = data;
        });
    };

    /**
     * Get All Branches And Groups
     */
    $scope.getGrades = function () {
        var params = {};
        params.Status = 1;
        gradesEndpoint.get(params, function (data) {
            $scope.grades = data;
        });
    };

    /**
     * Close the dialog
     */
    $scope.closeDialog = function () {
        $mdDialog.cancel();
    };

}

angular.module('app.pages.users').controller('GroupsPanelController', GroupsPanelController);
function GroupsPanelController($scope,group,$rootScope,branchesEndpoint,gradesEndpoint) {

    /**
     * Set the selected group
     */
    $scope.$on('selectedGroup:updated', function () {
        $scope.orignalObject = false;
        $scope.group = group.selectedGroup;
        $scope.getBranches();
        $scope.getGrades();
    });

    /**
     * Look gor changes on the group object
     */
    $scope.$watchCollection('group', function (newValue) {
        if (!$scope.orignalObject)
            $scope.orignalObject = angular.copy(newValue);

        angular.forEach(newValue, function (value, key) {
            if (newValue[key] != $scope.orignalObject[key] && (key == 'BranchID' || key == 'GradeID' )) {
                if (key == 'BranchID') {
                    angular.forEach($scope.branches, function (branchValue, branchKey) {
                        if ($scope.branches[branchKey].ID == value)
                            newValue.BranchName = $scope.branches[branchKey].Name;
                    })
                }
                else {
                    angular.forEach($scope.grades, function (gradesValue, gradesKey) {
                        if ($scope.grades[gradesKey].ID == value)
                            newValue.GradeName = $scope.grades[gradesKey].Name;
                    })
                }
            }
        })
    });

    /**
     * Look gor changes on the group object
     */
    $scope.$watchCollection('group', function (newValue, oldValue) {
        $rootScope.editDataHandler(newValue, oldValue, 'groups-panel')
    });

    /**
     * Get Branches
     */
    $scope.getBranches = function () {
        var params = {};
        params.Status = 1;
        branchesEndpoint.get(params, function (data) {
            $scope.branches = data;
        });
    };

    /**
     * Get All Branches And Groups
     */
    $scope.getGrades = function () {
        var params = {};
        params.Status = 1;
        gradesEndpoint.get(params, function (data) {
            $scope.grades = data;
        });
    };

    $scope.clearSearchTerm = function() {
        $scope.searchTerm = '';
    };


}

(function ()
{
    'use strict';

    angular.module('app.pages.group-management', ['datatables']).config(config);



    /** @ngInject */
    function config($stateProvider)
    {
        $stateProvider.state('app.pages_group-management', {
            url      : '/group-management',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/pages/branches/views/groups/group-management/group-management.html',
                    controller: 'GroupManagementController'
                }
            },
            resolve  : {
                DashboardData: function () {
                    localStorage.setItem("path", '/group-management');
                }
            },
            bodyClass: 'group-management'
        });


    }

})();

angular.module('app.pages.group-management').controller('GroupManagementController', GroupManagementController);

function GroupManagementController($scope, $rootScope, $location, $mdSidenav, $mdDialog, DTOptionsBuilder, dtOptions, Notification, groupsEndpoint, $element, contactsEndpoint, branchesEndpoint, contact, gradesEndpoint) {

    $scope.educators = [];

    function init() {
        var groupObject = {};
        groupObject.ID = $location.search().ID;
        if (!groupObject.ID) {
            $location.path('/groups');
        } else {
            resolveGroup(groupObject);
            $scope.getBranches();
            $scope.getGrades();

        }
    }


    /**
     * resolve the group by the ID stored in the groupObject
     * @param groupObject
     */
    function resolveGroup(groupObject) {
        groupsEndpoint.get(groupObject, function (data) {
            if (data[0]) {
                $scope.group = data[0];
                $scope.getContacts();
                $scope.getEducators();
            } else
                $location.path('/branches');

        });
    }

    /**
     * Get Educators
     */
    $scope.getEducators = function () {
        var params = {};
        params.Status = 1;
        groupsEndpoint.educators.get($scope.group, function (data) {
            $scope.CreateTime = data.CreateTime;
            data.history = data.history.map(function (history) {
                history.OldVal = objToArray(history.OldVal);
                history.NewVal = objToArray(history.NewVal);
                return history;
            });
            $scope.history = data.history;
            console.log(data.history);
            $scope.educators = data.educators.filter(function (educator) {
                return +educator.Status === 1;
            });
        });
    };

    function objToArray(myObject) {
        var arrayFromObject = [];

        for (var key in myObject) {
            if (myObject.hasOwnProperty(key)) {
                arrayFromObject.push({key: translatekKey(key), value: translateValue(key, myObject[key])});
            }
        }
        return arrayFromObject;
    }

    function translateValue(key, value) {
        switch (key.toLowerCase()) {
            case 'status':
                return +value === 1 ? 'פעיל' : 'לא פעיל';
            default:
                return value;
        }
    }

    function translatekKey(key) {
        switch (key.toLowerCase()) {
            case 'name':
                return 'שם';
            case 'status':
                return 'סטטוס';
            default:
                return key;
        }
    }

    /**
     * Get Branches
     */
    $scope.getBranches = function () {
        var params = {};
        params.Status = 1;
        branchesEndpoint.get(params, function (data) {
            $scope.branches = data;
        });
    };

    $scope.getGrades = function () {
        var params = {};
        params.Status = 1;
        gradesEndpoint.get(params, function (data) {
            $scope.grades = data;
        });
    };


    /*************contacts*****************/
    $scope.contactsSearch = {
        freeSearchFromDB: '',
        Status: 1
    }

    $scope.getContacts = function (reset) {
        if (reset) {
            $scope.contactsSearch = {
                freeSearchFromDB: '',
                Status: 1
            }
            return;
        }
        $scope.contacts = false;
        $scope.groupContacts = false;
        contactsEndpoint.get($scope.contactsSearch, function (data) {
            $scope.contacts = data;
            $scope.groupContacts = data.filter(function (contact) {
                return contact.Groups.indexOf($scope.group.ID) !== -1;
            });
        });
    }

    $scope.addNewContact = function () {
        $mdDialog.show({
            controller: 'NewContactDialogController',
            templateUrl: 'app/main/pages/contacts/new-contact-dialog/new-contact-dialog.html',
            clickOutsideToClose: false
        }).then(function () {
            $scope.getContacts();
        });
    }

    $scope.checkForExistingContact = function (contact) {
        var existing = $scope.contacts.filter(function (c) {
            return c.Name === contact.Name;
        });
        if (existing.length) {
            contact = Object.assign(existing[0]);
        }
    }

    $scope.editContact = function (selectedContact) {
        contact.updateSelectedContact(selectedContact);
        $mdSidenav("contact-panel").open();
    };


    /*************contacts*****************/

    $scope.$watchCollection('group', function (newValue, oldValue) {
        $rootScope.editDataHandler(newValue, oldValue, 'groups-panel')
    });

    /**
     * Set selected tab index
     * @param tab
     */
    $scope.setTab = function (tab) {
        $scope.selectedTab = tab;
    };

    $element.find('input').on('keydown', function (ev) {
        ev.stopPropagation();
    });

    $scope.clearSearchTerm = function () {
        $scope.searchTerm = '';
    };

    /**
     * Set Table option
     * @type {any}
     */
    $scope.dtOptions = DTOptionsBuilder
        .newOptions()
        .withLanguage(dtOptions.language)
        .withDOM('lfrtp')
        .withOption('bFilter', false)
        .withOption('responsive', true)
        .withDOM('lrtip');

    init();
}

angular.module('app.pages.branches').controller('NewGradesDialogController', NewGradesDialogController);
function NewGradesDialogController($scope, $mdDialog,gradesEndpoint,Notification) {

    /**
     * Save new Branch
     */
    $scope.saveNewGrade = function () {
        $scope.isClicked = true;
        gradesEndpoint.post($scope.newGrade, function (data) {
            $scope.isClicked = false;
            if (!data.success)
                Notification.info("נכשל ביצירה");

            $mdDialog.hide();
        })
    };


    /**
     * Close the dialog
     */
    $scope.closeDialog = function () {
        $mdDialog.cancel();
    };

}
angular.module('app.pages.branches').controller('NewAreaDialogController', ['$scope', '$rootScope', '$mdDialog','areasEndpoint','student','$location','Notification', function ($scope, $rootScope, $mdDialog,areasEndpoint,student,$location,Notification) {

    /**
     * Save new Branch
     */
    $scope.saveNewBranch = function () {
        $scope.isClicked =true;
        areasEndpoint.post($scope.newArea,function (data) {
            $scope.isClicked =false;
            if (!data.success)
                Notification.info("נכשל ביציר ");

            $mdDialog.hide();
        })
    };



    /**
     * Close the dialog
     */
    $scope.closeDialog =function () {
        $mdDialog.cancel();
    };

}]);

angular.module('app.pages.users').controller('GradesPanelController', GradesPanelController);
function GradesPanelController($scope,grade,$rootScope) {

    /**
     * Set the selected Geade
     */
    $scope.$on('selectedGrade:updated', function () {
        $scope.grade = grade.selectedGrade;
    });

    /**
     * Look for changes in the grade object
     */
    $scope.$watchCollection('grade', function (newValue, oldValue) {
        $rootScope.editDataHandler(newValue, oldValue, 'grades-panel')
    });

}
angular.module('app.pages.branches').controller('AreasPanelController', ['$scope','area','$rootScope', function($scope,area,$rootScope) {

    /**
     * set the selected area
     */
    $scope.$on('selectedArea:updated', function() {
        $scope.area= area.selectedArea;
        if(!Array.isArray($scope.area.SubsidyEmail))
            $scope.area.SubsidyEmail = [];
    });

    /**
     * Looking for changes in the area
     */
    $scope.$watch('area',function (newValue, oldValue) {
        $rootScope.editDataHandler(newValue, oldValue,'area-panel')
    },true);

}]);

angular.module('app.pages.branches').controller('NewBranchDialogController', NewBranchDialogController);
function NewBranchDialogController($scope, $mdDialog,branchesEndpoint,Notification,areasEndpoint,$timeout) {


    $scope.newBranch = {};
    /**
     * Save new Branch
     */
    $scope.saveNewBranch = function () {
        $scope.isClicked = true;
        branchesEndpoint.post($scope.newBranch, function (data) {
            $scope.isClicked = false;
            if (!data.success)
                Notification.info("נכשל ביצירה : דואר אלקטרוני/תועדה מזהה/דרכון קיימים במערכת");

            $mdDialog.hide();
        })
    };

    /**
     * Get Areas
     */
    $scope.getAreas = function () {
        var params = {};
        params.Status =1;
        areasEndpoint.get(params,function (data) {
            $scope.areas = data;
        })
    };

    /**
     * Close the dialog
     */
    $scope.closeDialog = function () {
        $mdDialog.cancel();
    };

    $scope.setCity = function (city) {
        $scope.newBranch.City = city.value
    };


    $scope.simulateQuery = false;
    $scope.isDisabled = false;

    // list of `state` value/display objects
    $scope.states = loadAll();
    $scope.querySearch = querySearch;


    // ******************************
    // Internal methods
    // ******************************

    /**
     * Search for states... use $timeout to simulate
     * remote dataservice call.
     */
    function querySearch(query) {
        var results = query ? $scope.states.filter(createFilterFor(query)) : $scope.states,
            deferred;
        if ($scope.simulateQuery) {
            deferred = $q.defer();
            $timeout(function () {
                deferred.resolve(results);
            }, Math.random() * 1000, false);
            return deferred.promise;
        } else {
            return results;
        }
    }


    /**
     * Build `states` list of key/value pairs
     */
    function loadAll() {

        var allStates = 'אבו גוש,אבו סנאן,אבו קורינאת (יישוב),אבו תלול,אבטין,אבטליון,אביאל,אביבים,אביגדור,אביחיל,\n' +
            'אביטל,אביעזר,אבירים,אבן יהודה,אבן מנחם,אבן ספיר,אבן שמואל,אבני איתן,אבני חפץ,אבנת,\n' +
            'אבשלום,אדורה,אדירים,אדמית,אדרת,אודים,אודם,אוהד,אום אל-פחם,אום אל-קוטוף,\n' +
            'אום בטין,אומן,אומץ,אופקים,אור הגנוז,אור הנר,אור יהודה,אור עקיבא,אורה,אורות,\n' +
            'אורטל,אורים,אורנים,אורנית,אושה,אזור,אחווה,אחוזם,אחוזת ברק,אחיהוד,\n' +
            'אחיטוב,אחיסמך,אחיעזר,איבים,אייל,איילת השחר,אילון,אילות,אילנייה,אילת,\n' +
            'אירוס,איתמר,איתן,איתנים,אכסאל,אל -עזי,אל -עריאן,אל -רום,אל סייד,אלומה,\n' +
            'אלומות,אלון הגליל,אלון מורה,אלון שבות,אלוני אבא,אלוני הבשן,אלוני יצחק,אלונים,אלי-עד,אליאב,\n' +
            'אליכין,אליפז,אליפלט,אליקים,אלישיב,אלישמע,אלמגור,אלמוג,אלעד,אלעזר,\n' +
            'אלפי מנשה,אלקוש,אלקנה,אמונים,אמירים,אמנון,אמציה,אניעם,אספר,אעבלין,\n' +
            'אפיק,אפיקים,אפק,אפרת,ארבל,ארגמן,ארז,אריאל,ארסוף,אשבול,\n' +
            'אשבל,אשדוד,אשדות יעקב (איחוד),אשדות יעקב (מאוחד),אשחר,אשכולות,אשל הנשיא,אשלים,אשקלון,אשרת,\n' +
            'אשתאול,באקה אל-גרביה,באר אורה,באר גנים,באר טוביה,באר יעקב,באר מילכה,באר שבע,בארות יצחק,בארותיים,\n' +
            'בארי,בוסתן הגליל,בועיינה-נוג\'ידאת,בוקעאתא,בורגתה,בחן,בטחה,ביצרון,ביר אל-מכסור,ביר הדאג\',\n' +
            'בירייה,בית אורן,בית אל,בית אלעזרי,בית אלפא,בית אריה,בית ברל,בית ג\'ן,בית גוברין,בית גמליאל,\n' +
            'בית דגן,בית הגדי,בית הלוי,בית הלל,בית העמק,בית הערבה,בית השיטה,בית זיד,בית זית,בית זרע,\n' +
            'בית חורון,בית חירות,בית חלקיה,בית חנן,בית חנניה,בית חשמונאי,בית יהושע,בית יוסף,בית ינאי,בית יצחק-שער חפר,\n' +
            'בית לחם הגלילית,בית מאיר,בית נחמיה,בית ניר,בית נקופה,בית עובד,בית עוזיאל,בית עזרא,בית עריף,בית צבי,\n' +
            'בית קמה,בית קשת,בית רבן,בית רימון,בית שאן,בית שמש,בית שערים,בית שקמה,ביתן אהרן,ביתר עילית,\n' +
            'בלפוריה,בן זכאי,בן עמי,בן שמן (כפר נוער),בן שמן (מושב),בני ברק,בני דקלים,בני דרום,בני דרור,בני יהודה,\n' +
            'בני נצרים,בני עטרות,בני עי"ש,בני ציון,בני ראם,בניה,בנימינה-גבעת עדה*,בסמ"ה,בסמת טבעון,בענה,\n' +
            'בצרה,בצת,בקוע,בקעות,בר גיורא,בר יוחאי,ברוכין,ברור חיל,ברוש,ברכה,\n' +
            'ברכיה,ברעם,ברק,ברקאי,ברקן,ברקת,בת הדר,בת חן,בת חפר,בת ים,\n' +
            'בת עין,בת שלמה,ג\'דיידה-מכר,ג\'ולס,ג\'לג\'וליה,ג\'סר א-זרקא,ג\'ש (גוש חלב),ג\'ת,גאולי תימן,גאולים,\n' +
            'גאליה,גבולות,גבים,גבע,גבע בנימין,גבע כרמל,גבעולים,גבעון החדשה,גבעות בר,גבעת אבני,\n' +
            'גבעת אלה,גבעת ברנר,גבעת השלושה,גבעת זאב,גבעת ח"ן,גבעת חיים (איחוד),גבעת חיים (מאוחד),גבעת יואב,גבעת יערים,גבעת ישעיהו,\n' +
            'גבעת כ"ח,גבעת ניל"י,גבעת עוז,גבעת שמואל,גבעת שמש,גבעת שפירא,גבעתי,גבעתיים,גברעם,גבת,\n' +
            'גדות,גדיש,גדעונה,גדרה,גונן,גורן,גורנות הגליל,גזית,גזר,גיאה,\n' +
            'גיבתון,גיזו,גילון,גילת,גינוסר,גיניגר,גינתון,גיתה,גיתית,גלאון,\n' +
            'גלגל,גליל ים,גלעד (אבן יצחק),גמזו,גן הדרום,גן השומרון,גן חיים,גן יאשיה,גן יבנה,גן נר,\n' +
            'גן שורק,גן שלמה,גן שמואל,גנות,גנות הדר,גני הדר,גני טל,גני יוחנן,גני עם,גני תקווה,\n' +
            'געש,געתון,גפן,גרופית,גשור,גשר,גשר הזיו,גת (קיבוץ),גת רימון,דאלית אל-כרמל,\n' +
            'דבורה,דבורייה,דבירה,דברת,דגניה א\',דגניה ב\',דוב"ב,דולב,דור,דורות,\n' +
            'דחי,דייר אל-אסד,דייר חנא,דייר ראפאת,דימונה,דישון,דלייה,דלתון,דמיידה,דן,\n' +
            'דפנה,דקל,דריג\'את,האון,הבונים,הגושרים,הדר עם,הוד השרון,הודיות,הודייה,\n' +
            'הושעיה,הזורע,הזורעים,החותרים,היוגב,הילה,המעפיל,הסוללים,העוגן,הר אדר,\n' +
            'הר גילה,הר עמשא,הראל,הרדוף,הרצלייה,הררית,ורד יריחו,ורדון,זבדיאל,זוהר,\n' +
            'זיקים,זיתן,זכרון יעקב,זכריה,זמר,זמרת,זנוח,זרועה,זרזיר,זרחיה,\n' +
            'ח\'ואלד,חבצלת השרון,חבר,חגור,חגי,חגלה,חד-נס,חדיד,חדרה,חוג\'ייראת (ד\'הרה) (שבט),\n' +
            'חולדה,חולון,חולית,חולתה,חוסן,חוסנייה,חופית,חוקוק,חורה,חורפיש,\n' +
            'חורשים,חזון,חיבת ציון,חיננית,חיפה,חירות,חלוץ,חלמיש,חלץ,חמאם,\n' +
            'חמד,חמדיה,חמדת,חמרה,חניאל,חניתה,חנתון,חספין,חפץ חיים,חפצי-בה,\n' +
            'חצב,חצבה,חצור הגלילית,חצור-אשדוד,חצרים,חרב לאת,חרוצים,חריש,חרמש,חרשים,\n' +
            'חשמונאים,טבריה,טובא-זנגרייה,טורעאן,טייבה,טייבה (בעמק),טירה,טירת יהודה,טירת כרמל,טירת צבי,\n' +
            'טל שחר,טל-אל,טללים,טלמון,טמרה,טמרה (יזרעאל),טנא,טפחות,יאנוח-ג\'ת,יבול,\n' +
            'יבנאל,יבנה,יגור,יגל,יד בנימין,יד השמונה,יד חנה,יד מרדכי,יד נתן,יד רמב"ם,\n' +
            'ידידה,יהוד,יהל,יובל,יובלים,יודפת,יונתן,יושיביה,יזרעאל,יחיעם,\n' +
            'יטבתה,ייט"ב,יכיני,ינוב,ינון,יסוד המעלה,יסודות,יסעור,יעד,יעל,\n' +
            'יעף,יערה,יפיע,יפית,יפעת,יפתח,יצהר,יציץ,יקום,יקיר,\n' +
            'יקנעם (מושבה),יקנעם עילית,יראון,ירדנה,ירוחם,ירושלים,ירחיב,ירכא,ירקונה,ישע,\n' +
            'ישעי,ישרש,יתד,כאבול,כאוכב אבו אל-היג\'א,כברי,כדורי,כדיתה,כוכב השחר,כוכב יאיר,\n' +
            'כוכב יעקב,כוכב מיכאל,כורזים,כחל,כחלה,כיסופים,כישור,כליל,כלנית,כמאנה,\n' +
            'כמהין,כמון,כנות,כנף,כנרת (מושבה),כנרת (קבוצה),כסיפה,כסלון,כסרא-סמיע,כעביה-טבאש-חג\'אג\'רה,\n' +
            'כפר אביב,כפר אדומים,כפר אוריה,כפר אחים,כפר ביאליק,כפר ביל"ו,כפר בלום,כפר בן נון,כפר ברא,כפר ברוך,\n' +
            'כפר גדעון,כפר גלים,כפר גליקסון,כפר גלעדי,כפר דניאל,כפר האורנים,כפר החורש,כפר המכבי,כפר הנגיד,כפר הנוער הדתי,\n' +
            'כפר הנשיא,כפר הס,כפר הרא"ה,כפר הרי"ף,כפר ויתקין,כפר ורבורג,כפר ורדים,כפר זוהרים,כפר זיתים,כפר חב"ד,\n' +
            'כפר חושן,כפר חיטים,כפר חיים,כפר חנניה,כפר חסידים א\',כפר חסידים ב\',כפר חרוב,כפר טרומן,כפר יאסיף,כפר ידידיה,\n' +
            'כפר יהושע,כפר יונה,כפר יחזקאל,כפר יעבץ,כפר כמא,כפר כנא,כפר מונש,כפר מימון,כפר מל"ל,כפר מנדא,\n' +
            'כפר מנחם,כפר מסריק,כפר מצר,כפר מרדכי,כפר נטר,כפר סאלד,כפר סבא,כפר סילבר,כפר סירקין,כפר עבודה,\n' +
            'כפר עזה,כפר עציון,כפר פינס,כפר קאסם,כפר קיש,כפר קרע,כפר ראש הנקרה,כפר רוזנואלד (זרעית),כפר רופין,כפר רות,\n' +
            'כפר שמאי,כפר שמואל,כפר שמריהו,כפר תבור,כפר תפוח,כרכום,כרם בן זמרה,כרם בן שמן,כרם יבנה (ישיבה),כרם מהר"ל,\n' +
            'כרם שלום,כרמי יוסף,כרמי צור,כרמיאל,כרמייה,כרמים,כרמית,כרמל,לבון,לביא,לבנים,\n' +
            'להב,להבות הבשן,להבות חביבה,להבים,לוד,לוזית,לוחמי הגיטאות,לוטם,לוטן,לימן,\n' +
            'לכיש,לפיד,לפידות,לקיה,מאור,מאיר שפיה,מבוא ביתר,מבוא דותן,מבוא חורון,מבוא חמה,\n' +
            'מבוא מודיעים,מבואות ים,מבועים,מבטחים,מבקיעים,מבשרת ציון,מג\'ד אל-כרום,מג\'דל שמס,מגאר,מגדים,\n' +
            'מגדל,מגדל העמק,מגדל עוז,מגדלים,מגידו,מגל,מגן,מגן שאול,מגשימים,מדרך עוז,\n' +
            'מדרשת בן גוריון,מדרשת רופין,מודיעין עילית,מודיעין-מכבים-רעות*,מולדה*,מולדת,מוצא עילית,מוקייבלה,מורן,מורשת,\n' +
            'מזור,מזכרת בתיה,מזרע,מזרעה,מחולה,מחנה הילה*,מחנה טלי*,מחנה יהודית*,מחנה יוכבד*,מחנה יפה*,\n' +
            'מחנה מרים*,מחנה תל נוף*,מחניים,מחסיה,מטולה,מטע,מי עמי,מיטב,מייסר,מיצר,\n' +
            'מירב,מירון,מישר,מיתר,מכורה,מכחול,מכמורת,מכמנים,מלאה,מלילות,\n' +
            'מלכייה,מלכישוע,מנוחה,מנוף,מנות,מנחמיה,מנרה,מנשית זבדה,מסד,מסדה,\n' +
            'מסילות,מסילת ציון,מסלול,מסעדה,מעברות,מעגלים,מעגן,מעגן מיכאל,מעוז חיים,מעון,\n' +
            'מעונה,מעיין ברוך,מעיין צבי,מעיליא,מעלה אדומים,מעלה אפרים,מעלה גלבוע,מעלה גמלא,מעלה החמישה,מעלה לבונה,\n' +
            'מעלה מכמש,מעלה עירון,מעלה עמוס,מעלה שומרון,מעלות-תרשיחא,מענית,מעש,מפלסים,מצדות יהודה,מצובה,\n' +
            'מצליח,מצפה,מצפה אבי"ב,מצפה אילן,מצפה יריחו,מצפה נטופה,מצפה רמון,מצפה שלם,מצר,מרגליות,\n' +
            'מרום גולן,מרחב עם,מרחביה (מושב),מרחביה (קיבוץ),מרכז שפירא,משאבי שדה,משגב דב,משגב עם,משהד,משואה,\n' +
            'משואות יצחק,משכיות,משמר איילון,משמר דוד,משמר הירדן,משמר הנגב,משמר העמק,משמר השבעה,משמר השרון,משמרות,\n' +
            'משמרת,משען,מתן,מתת,מתתיהו,נאות גולן,נאות הכיכר,נאות מרדכי,נאות סמדר,נאעורה,\n' +
            'נבטים,נגבה,נגוהות,נהורה,נהלל,נהרייה,נוב,נוגה,נווה,נווה אור,\n' +
            'נווה אטי"ב,נווה אילן,נווה איתן,נווה דניאל,נווה זוהר,נווה זיו,נווה חריף,נווה ים,נווה ימין,נווה ירק,\n' +
            'נווה מבטח,נווה מיכאל,נווה שלום,נועם,נוף איילון,נופים,נופית,נופך,נוקדים,נורדייה,\n' +
            'נורית,נחושה,נחל עוז,נחלה,נחליאל,נחלים,נחם,נחף,נחשולים,נחשון,\n' +
            'נחשונים,נטועה,נטור,נטע,נטעים,נטף,ניין,ניל"י,ניצן,ניצן ב\',\n' +
            'ניצנה (קהילת חינוך),ניצני סיני,ניצני עוז,ניצנים,ניר אליהו,ניר בנים,ניר גלים,ניר דוד (תל עמל),ניר ח"ן,ניר יפה,\n' +
            'ניר יצחק,ניר ישראל,ניר משה,ניר עוז,ניר עם,ניר עציון,ניר עקיבא,ניר צבי,נירים,נירית,\n' +
            'נירן,נס הרים,נס עמים,נס ציונה,נעורים,נעלה,נעמ"ה,נען,נצר חזני,נצר סרני,\n' +
            'נצרת,נצרת עילית,נשר,נתיב הגדוד,נתיב הל"ה,נתיב העשרה,נתיב השיירה,נתיבות,נתניה,סאג\'ור,\n' +
            'סאסא,סביון*,סגולה,סואעד (חמרייה)*,סולם,סוסיה,סופה,סח\'נין,סלמה,סלעית,\n' +
            'סמר,סנסנה,סעד,סער,ספיר,סתרייה,ע\'ג\'ר,עבדון,עברון,עגור,\n' +
            'עדי,עדנים,עוזה,עוזייר,עולש,עומר,עופר,עוצם,עזוז,עזר,\n' +
            'עזריאל,עזריה,עזריקם,עטרת,עידן,עיילבון,עיינות,עילוט,עין איילה,עין אל-אסד,\n' +
            'עין גב,עין גדי,עין דור,עין הבשור,עין הוד,עין החורש,עין המפרץ,עין הנצי"ב,עין העמק,עין השופט,\n' +
            'עין השלושה,עין ורד,עין זיוון,עין חוד,עין חצבה,עין חרוד (איחוד),עין חרוד (מאוחד),עין יהב,עין יעקב,עין כרם-בי"ס חקלאי,\n' +
            'עין כרמל,עין מאהל,עין נקובא,עין עירון,עין צורים,עין קנייא,עין ראפה,עין שמר,עין שריד,עין תמר,\n' +
            'עינת,עיר אובות,עכו,עלומים,עלי,עלי זהב,עלמה,עלמון,עמוקה,עמינדב,\n' +
            'עמיעד,עמיעוז,עמיקם,עמיר,עמנואל,עמקה,ענב,עספיא,עפולה,עפרה,\n' +
            'עץ אפרים,עצמון שגב,עראבה,עשהאל,עראמשה*,ערב אל נעים,ערד,ערוגות,ערערה,ערערה-בנגב,עשרת,\n' +
            'עתלית,עתניאל,פארן,פדואל,פדויים,פדיה,פוריידיס,פורייה - כפר עבודה,פורייה - נווה עובד,פורייה עילית,\n' +
            'פורת,פטיש,פלך,פלמחים,פני חבר,פסגות,פסוטה,פעמי תש"ז,פצאל,פקיעין (בוקייעה),\n' +
            'פקיעין חדשה,פרדס חנה-כרכור,פרדסייה,פרוד,פרזון,פרי גן,פתח תקווה,פתחיה,צאלים,צביה,\n' +
            'צבעון,צובה,צוחר,צופייה,צופים,צופית,צופר,צוקי ים,צוקים,צור הדסה,\n' +
            'צור יצחק,צור משה,צור נתן,צוריאל,צורית,ציפורי,צלפון,צנדלה,צפרייה,צפרירים,\n' +
            'צפת,צרופה,צרעה,קבוצת יבנה,קדומים,קדימה-צורן,קדמה,קדמת צבי,קדר,קדרון,\n' +
            'קדרים,קוממיות,קורנית,קטורה,קיסריה,קלחים,קליה,קלנסווה,קלע,קציר,\n' +
            'קצר א-סר,קצרין,קריית אונו,קריית ארבע,קריית אתא,קריית ביאליק,קריית גת,קריית טבעון,קריית ים,קריית יערים,\n' +
            'קריית יערים (מוסד),קריית מוצקין,קריית מלאכי,קריית נטפים,קריית ענבים,קריית עקרון,קריית שלמה,קריית שמונה,קרני שומרון,קשת,\n' +
            'ראמה,ראס אל-עין,ראס עלי,ראש העין,ראש פינה,ראש צורים,ראשון לציון,רבבה,רבדים,רביבים,\n' +
            'רביד,רגבה,רגבים,רהט,רווחה,רוויה,רוח מדבר,רוחמה,רומאנה,רומת הייב,\n' +
            'רועי,רותם,רחוב,רחובות,רחלים,ריחאנייה,ריחן,ריינה,רימונים,רינתיה,\n' +
            'רכסים,רם-און,רמות,רמות השבים,רמות מאיר,רמות מנשה,רמות נפתלי,רמלה,רמת גן,רמת דוד,\n' +
            'רמת הכובש,רמת השופט,רמת השרון,רמת יוחנן,רמת ישי,רמת מגשימים,רמת צבי,רמת רזיאל,רמת רחל,רנן,\n' +
            'רעים,רעננה,רקפת,רשפון,רשפים,רתמים,שאר ישוב,שבי ציון,שבי שומרון,שבלי - אום אל-גנם,\n' +
            'שגב-שלום,שדה אילן,שדה אליהו,שדה אליעזר,שדה בוקר,שדה דוד,שדה ורבורג,שדה יואב,שדה יעקב,שדה יצחק,\n' +
            'שדה משה,שדה נחום,שדה נחמיה,שדה ניצן,שדה עוזיהו,שדה צבי,שדות ים,שדות מיכה,שדי אברהם,שדי חמד,\n' +
            'שדי תרומות,שדמה,שדמות דבורה,שדמות מחולה,שדרות,שואבה,שובה,שובל,שוהם,שומרה,\n' +
            'שומרייה,שוקדה,שורש,שורשים,שושנת העמקים,שזור,שחר,שחרות,שיבולים,שיטים,\n' +
            'שייח\' דנון,שילה,שילת,שכניה,שלווה,שלווה במדבר,שלוחות,שלומי,שלומית,שמיר,\n' +
            'שמעה,שמרת,שמשית,שניר,שעב,שעל,שעלבים,שער אפרים,שער הגולן,שער העמקים,\n' +
            'שער מנשה,שערי תקווה,שפיים,שפיר,שפר,שפרעם,שקד,שקף,שרונה,שריגים (לי-און),\n' +
            'שריד,שרשרת,שתולה,שתולים,תאשור,תדהר,תובל,תומר,תושייה,תימורים,\n' +
            'תירוש,תל אביב -יפו,תל יוסף,תל יצחק,תל מונד,תל עדשים,תל קציר,תל שבע,תל תאומים,תלם,\n' +
            'תלמי אליהו,תלמי אלעזר,תלמי ביל"ו,תלמי יוסף,תלמי יחיאל,תלמי יפה,תלמים,תמרת,תנובות,תעוז,\n' +
            'תפרח,תקומה,תקוע,תרבין א-צאנע (יישוב)*,תרום,';

        return allStates.split(',').map(function (state) {
            state = state.trim();
            return {
                value: state,
                display: state
            };
        });


    }

    /**
     * Create filter function for a query string
     */
    function createFilterFor(query) {
        var lowercaseQuery = angular.lowercase(query);

        return function filterFn(state) {
            return (state.value.indexOf(lowercaseQuery) === 0);
        };

    }


}

angular.module('app.pages.users').controller('BranchPanelController', BranchPanelController);
function BranchPanelController($scope, branch, $rootScope, areasEndpoint, $timeout) {


    /**
     * Set the selected branch
     */
    $scope.$on('selectedBranch:updated', function () {
        $scope.branch = branch.selectedBranch;
        $scope.searchText = $scope.branch.City;
        $scope.getAreas();
    });


    /**
     * Get Areas
     */
    $scope.getAreas = function () {
        var params = {};
        params.Status =1;
        areasEndpoint.get(params,function (data) {
            $scope.areas = data;
        })
    };

    /**
     * Set area Name
     */
    $scope.setAreaName = function () {
        angular.forEach($scope.areas, function (value, key) {
            if ($scope.areas[key]['ID'] == $scope.branch.AreaID)
                $scope.branch.Area = $scope.areas[key]['Name'];

        })
    };


    $scope.setCity = function (city) {
        $scope.branch.City = city.value
    };


    $scope.simulateQuery = false;
    $scope.isDisabled = false;

    // list of `state` value/display objects
    $scope.states = loadAll();
    $scope.querySearch = querySearch;


    // ******************************
    // Internal methods
    // ******************************

    /**
     * Search for states... use $timeout to simulate
     * remote dataservice call.
     */
    function querySearch(query) {
        var results = query ? $scope.states.filter(createFilterFor(query)) : $scope.states,
            deferred;
        if ($scope.simulateQuery) {
            deferred = $q.defer();
            $timeout(function () {
                deferred.resolve(results);
            }, Math.random() * 1000, false);
            return deferred.promise;
        } else {
            return results;
        }
    }


    /**
     * Build `states` list of key/value pairs
     */
    function loadAll() {

        var allStates = 'אבו גוש,אבו סנאן,אבו קורינאת (יישוב),אבו תלול,אבטין,אבטליון,אביאל,אביבים,אביגדור,אביחיל,\n' +
            'אביטל,אביעזר,אבירים,אבן יהודה,אבן מנחם,אבן ספיר,אבן שמואל,אבני איתן,אבני חפץ,אבנת,\n' +
            'אבשלום,אדורה,אדירים,אדמית,אדרת,אודים,אודם,אוהד,אום אל-פחם,אום אל-קוטוף,\n' +
            'אום בטין,אומן,אומץ,אופקים,אור הגנוז,אור הנר,אור יהודה,אור עקיבא,אורה,אורות,\n' +
            'אורטל,אורים,אורנים,אורנית,אושה,אזור,אחווה,אחוזם,אחוזת ברק,אחיהוד,\n' +
            'אחיטוב,אחיסמך,אחיעזר,איבים,אייל,איילת השחר,אילון,אילות,אילנייה,אילת,\n' +
            'אירוס,איתמר,איתן,איתנים,אכסאל,אל -עזי,אל -עריאן,אל -רום,אל סייד,אלומה,\n' +
            'אלומות,אלון הגליל,אלון מורה,אלון שבות,אלוני אבא,אלוני הבשן,אלוני יצחק,אלונים,אלי-עד,אליאב,\n' +
            'אליכין,אליפז,אליפלט,אליקים,אלישיב,אלישמע,אלמגור,אלמוג,אלעד,אלעזר,\n' +
            'אלפי מנשה,אלקוש,אלקנה,אמונים,אמירים,אמנון,אמציה,אניעם,אספר,אעבלין,\n' +
            'אפיק,אפיקים,אפק,אפרת,ארבל,ארגמן,ארז,אריאל,ארסוף,אשבול,\n' +
            'אשבל,אשדוד,אשדות יעקב (איחוד),אשדות יעקב (מאוחד),אשחר,אשכולות,אשל הנשיא,אשלים,אשקלון,אשרת,\n' +
            'אשתאול,באקה אל-גרביה,באר אורה,באר גנים,באר טוביה,באר יעקב,באר מילכה,באר שבע,בארות יצחק,בארותיים,\n' +
            'בארי,בוסתן הגליל,בועיינה-נוג\'ידאת,בוקעאתא,בורגתה,בחן,בטחה,ביצרון,ביר אל-מכסור,ביר הדאג\',\n' +
            'בירייה,בית אורן,בית אל,בית אלעזרי,בית אלפא,בית אריה,בית ברל,בית ג\'ן,בית גוברין,בית גמליאל,\n' +
            'בית דגן,בית הגדי,בית הלוי,בית הלל,בית העמק,בית הערבה,בית השיטה,בית זיד,בית זית,בית זרע,\n' +
            'בית חורון,בית חירות,בית חלקיה,בית חנן,בית חנניה,בית חשמונאי,בית יהושע,בית יוסף,בית ינאי,בית יצחק-שער חפר,\n' +
            'בית לחם הגלילית,בית מאיר,בית נחמיה,בית ניר,בית נקופה,בית עובד,בית עוזיאל,בית עזרא,בית עריף,בית צבי,\n' +
            'בית קמה,בית קשת,בית רבן,בית רימון,בית שאן,בית שמש,בית שערים,בית שקמה,ביתן אהרן,ביתר עילית,\n' +
            'בלפוריה,בן זכאי,בן עמי,בן שמן (כפר נוער),בן שמן (מושב),בני ברק,בני דקלים,בני דרום,בני דרור,בני יהודה,\n' +
            'בני נצרים,בני עטרות,בני עי"ש,בני ציון,בני ראם,בניה,בנימינה-גבעת עדה*,בסמ"ה,בסמת טבעון,בענה,\n' +
            'בצרה,בצת,בקוע,בקעות,בר גיורא,בר יוחאי,ברוכין,ברור חיל,ברוש,ברכה,\n' +
            'ברכיה,ברעם,ברק,ברקאי,ברקן,ברקת,בת הדר,בת חן,בת חפר,בת ים,\n' +
            'בת עין,בת שלמה,ג\'דיידה-מכר,ג\'ולס,ג\'לג\'וליה,ג\'סר א-זרקא,ג\'ש (גוש חלב),ג\'ת,גאולי תימן,גאולים,\n' +
            'גאליה,גבולות,גבים,גבע,גבע בנימין,גבע כרמל,גבעולים,גבעון החדשה,גבעות בר,גבעת אבני,\n' +
            'גבעת אלה,גבעת ברנר,גבעת השלושה,גבעת זאב,גבעת ח"ן,גבעת חיים (איחוד),גבעת חיים (מאוחד),גבעת יואב,גבעת יערים,גבעת ישעיהו,\n' +
            'גבעת כ"ח,גבעת ניל"י,גבעת עוז,גבעת שמואל,גבעת שמש,גבעת שפירא,גבעתי,גבעתיים,גברעם,גבת,\n' +
            'גדות,גדיש,גדעונה,גדרה,גונן,גורן,גורנות הגליל,גזית,גזר,גיאה,\n' +
            'גיבתון,גיזו,גילון,גילת,גינוסר,גיניגר,גינתון,גיתה,גיתית,גלאון,\n' +
            'גלגל,גליל ים,גלעד (אבן יצחק),גמזו,גן הדרום,גן השומרון,גן חיים,גן יאשיה,גן יבנה,גן נר,\n' +
            'גן שורק,גן שלמה,גן שמואל,גנות,גנות הדר,גני הדר,גני טל,גני יוחנן,גני עם,גני תקווה,\n' +
            'געש,געתון,גפן,גרופית,גשור,גשר,גשר הזיו,גת (קיבוץ),גת רימון,דאלית אל-כרמל,\n' +
            'דבורה,דבורייה,דבירה,דברת,דגניה א\',דגניה ב\',דוב"ב,דולב,דור,דורות,\n' +
            'דחי,דייר אל-אסד,דייר חנא,דייר ראפאת,דימונה,דישון,דלייה,דלתון,דמיידה,דן,\n' +
            'דפנה,דקל,דריג\'את,האון,הבונים,הגושרים,הדר עם,הוד השרון,הודיות,הודייה,\n' +
            'הושעיה,הזורע,הזורעים,החותרים,היוגב,הילה,המעפיל,הסוללים,העוגן,הר אדר,\n' +
            'הר גילה,הר עמשא,הראל,הרדוף,הרצלייה,הררית,ורד יריחו,ורדון,זבדיאל,זוהר,\n' +
            'זיקים,זיתן,זכרון יעקב,זכריה,זמר,זמרת,זנוח,זרועה,זרזיר,זרחיה,\n' +
            'ח\'ואלד,חבצלת השרון,חבר,חגור,חגי,חגלה,חד-נס,חדיד,חדרה,חוג\'ייראת (ד\'הרה) (שבט),\n' +
            'חולדה,חולון,חולית,חולתה,חוסן,חוסנייה,חופית,חוקוק,חורה,חורפיש,\n' +
            'חורשים,חזון,חיבת ציון,חיננית,חיפה,חירות,חלוץ,חלמיש,חלץ,חמאם,\n' +
            'חמד,חמדיה,חמדת,חמרה,חניאל,חניתה,חנתון,חספין,חפץ חיים,חפצי-בה,\n' +
            'חצב,חצבה,חצור הגלילית,חצור-אשדוד,חצרים,חרב לאת,חרוצים,חריש,חרמש,חרשים,\n' +
            'חשמונאים,טבריה,טובא-זנגרייה,טורעאן,טייבה,טייבה (בעמק),טירה,טירת יהודה,טירת כרמל,טירת צבי,\n' +
            'טל שחר,טל-אל,טללים,טלמון,טמרה,טמרה (יזרעאל),טנא,טפחות,יאנוח-ג\'ת,יבול,\n' +
            'יבנאל,יבנה,יגור,יגל,יד בנימין,יד השמונה,יד חנה,יד מרדכי,יד נתן,יד רמב"ם,\n' +
            'ידידה,יהוד,יהל,יובל,יובלים,יודפת,יונתן,יושיביה,יזרעאל,יחיעם,\n' +
            'יטבתה,ייט"ב,יכיני,ינוב,ינון,יסוד המעלה,יסודות,יסעור,יעד,יעל,\n' +
            'יעף,יערה,יפיע,יפית,יפעת,יפתח,יצהר,יציץ,יקום,יקיר,\n' +
            'יקנעם (מושבה),יקנעם עילית,יראון,ירדנה,ירוחם,ירושלים,ירחיב,ירכא,ירקונה,ישע,\n' +
            'ישעי,ישרש,יתד,כאבול,כאוכב אבו אל-היג\'א,כברי,כדורי,כדיתה,כוכב השחר,כוכב יאיר,\n' +
            'כוכב יעקב,כוכב מיכאל,כורזים,כחל,כחלה,כיסופים,כישור,כליל,כלנית,כמאנה,\n' +
            'כמהין,כמון,כנות,כנף,כנרת (מושבה),כנרת (קבוצה),כסיפה,כסלון,כסרא-סמיע,כעביה-טבאש-חג\'אג\'רה,\n' +
            'כפר אביב,כפר אדומים,כפר אוריה,כפר אחים,כפר ביאליק,כפר ביל"ו,כפר בלום,כפר בן נון,כפר ברא,כפר ברוך,\n' +
            'כפר גדעון,כפר גלים,כפר גליקסון,כפר גלעדי,כפר דניאל,כפר האורנים,כפר החורש,כפר המכבי,כפר הנגיד,כפר הנוער הדתי,\n' +
            'כפר הנשיא,כפר הס,כפר הרא"ה,כפר הרי"ף,כפר ויתקין,כפר ורבורג,כפר ורדים,כפר זוהרים,כפר זיתים,כפר חב"ד,\n' +
            'כפר חושן,כפר חיטים,כפר חיים,כפר חנניה,כפר חסידים א\',כפר חסידים ב\',כפר חרוב,כפר טרומן,כפר יאסיף,כפר ידידיה,\n' +
            'כפר יהושע,כפר יונה,כפר יחזקאל,כפר יעבץ,כפר כמא,כפר כנא,כפר מונש,כפר מימון,כפר מל"ל,כפר מנדא,\n' +
            'כפר מנחם,כפר מסריק,כפר מצר,כפר מרדכי,כפר נטר,כפר סאלד,כפר סבא,כפר סילבר,כפר סירקין,כפר עבודה,\n' +
            'כפר עזה,כפר עציון,כפר פינס,כפר קאסם,כפר קיש,כפר קרע,כפר ראש הנקרה,כפר רוזנואלד (זרעית),כפר רופין,כפר רות,\n' +
            'כפר שמאי,כפר שמואל,כפר שמריהו,כפר תבור,כפר תפוח,כרכום,כרם בן זמרה,כרם בן שמן,כרם יבנה (ישיבה),כרם מהר"ל,\n' +
            'כרם שלום,כרמי יוסף,כרמי צור,כרמיאל,כרמייה,כרמים,כרמית,כרמל,לבון,לביא,לבנים,\n' +
            'להב,להבות הבשן,להבות חביבה,להבים,לוד,לוזית,לוחמי הגיטאות,לוטם,לוטן,לימן,\n' +
            'לכיש,לפיד,לפידות,לקיה,מאור,מאיר שפיה,מבוא ביתר,מבוא דותן,מבוא חורון,מבוא חמה,\n' +
            'מבוא מודיעים,מבואות ים,מבועים,מבטחים,מבקיעים,מבשרת ציון,מג\'ד אל-כרום,מג\'דל שמס,מגאר,מגדים,\n' +
            'מגדל,מגדל העמק,מגדל עוז,מגדלים,מגידו,מגל,מגן,מגן שאול,מגשימים,מדרך עוז,\n' +
            'מדרשת בן גוריון,מדרשת רופין,מודיעין עילית,מודיעין-מכבים-רעות*,מולדה*,מולדת,מוצא עילית,מוקייבלה,מורן,מורשת,\n' +
            'מזור,מזכרת בתיה,מזרע,מזרעה,מחולה,מחנה הילה*,מחנה טלי*,מחנה יהודית*,מחנה יוכבד*,מחנה יפה*,\n' +
            'מחנה מרים*,מחנה תל נוף*,מחניים,מחסיה,מטולה,מטע,מי עמי,מיטב,מייסר,מיצר,\n' +
            'מירב,מירון,מישר,מיתר,מכורה,מכחול,מכמורת,מכמנים,מלאה,מלילות,\n' +
            'מלכייה,מלכישוע,מנוחה,מנוף,מנות,מנחמיה,מנרה,מנשית זבדה,מסד,מסדה,\n' +
            'מסילות,מסילת ציון,מסלול,מסעדה,מעברות,מעגלים,מעגן,מעגן מיכאל,מעוז חיים,מעון,\n' +
            'מעונה,מעיין ברוך,מעיין צבי,מעיליא,מעלה אדומים,מעלה אפרים,מעלה גלבוע,מעלה גמלא,מעלה החמישה,מעלה לבונה,\n' +
            'מעלה מכמש,מעלה עירון,מעלה עמוס,מעלה שומרון,מעלות-תרשיחא,מענית,מעש,מפלסים,מצדות יהודה,מצובה,\n' +
            'מצליח,מצפה,מצפה אבי"ב,מצפה אילן,מצפה יריחו,מצפה נטופה,מצפה רמון,מצפה שלם,מצר,מרגליות,\n' +
            'מרום גולן,מרחב עם,מרחביה (מושב),מרחביה (קיבוץ),מרכז שפירא,משאבי שדה,משגב דב,משגב עם,משהד,משואה,\n' +
            'משואות יצחק,משכיות,משמר איילון,משמר דוד,משמר הירדן,משמר הנגב,משמר העמק,משמר השבעה,משמר השרון,משמרות,\n' +
            'משמרת,משען,מתן,מתת,מתתיהו,נאות גולן,נאות הכיכר,נאות מרדכי,נאות סמדר,נאעורה,\n' +
            'נבטים,נגבה,נגוהות,נהורה,נהלל,נהרייה,נוב,נוגה,נווה,נווה אור,\n' +
            'נווה אטי"ב,נווה אילן,נווה איתן,נווה דניאל,נווה זוהר,נווה זיו,נווה חריף,נווה ים,נווה ימין,נווה ירק,\n' +
            'נווה מבטח,נווה מיכאל,נווה שלום,נועם,נוף איילון,נופים,נופית,נופך,נוקדים,נורדייה,\n' +
            'נורית,נחושה,נחל עוז,נחלה,נחליאל,נחלים,נחם,נחף,נחשולים,נחשון,\n' +
            'נחשונים,נטועה,נטור,נטע,נטעים,נטף,ניין,ניל"י,ניצן,ניצן ב\',\n' +
            'ניצנה (קהילת חינוך),ניצני סיני,ניצני עוז,ניצנים,ניר אליהו,ניר בנים,ניר גלים,ניר דוד (תל עמל),ניר ח"ן,ניר יפה,\n' +
            'ניר יצחק,ניר ישראל,ניר משה,ניר עוז,ניר עם,ניר עציון,ניר עקיבא,ניר צבי,נירים,נירית,\n' +
            'נירן,נס הרים,נס עמים,נס ציונה,נעורים,נעלה,נעמ"ה,נען,נצר חזני,נצר סרני,\n' +
            'נצרת,נצרת עילית,נשר,נתיב הגדוד,נתיב הל"ה,נתיב העשרה,נתיב השיירה,נתיבות,נתניה,סאג\'ור,\n' +
            'סאסא,סביון*,סגולה,סואעד (חמרייה)*,סולם,סוסיה,סופה,סח\'נין,סלמה,סלעית,\n' +
            'סמר,סנסנה,סעד,סער,ספיר,סתרייה,ע\'ג\'ר,עבדון,עברון,עגור,\n' +
            'עדי,עדנים,עוזה,עוזייר,עולש,עומר,עופר,עוצם,עזוז,עזר,\n' +
            'עזריאל,עזריה,עזריקם,עטרת,עידן,עיילבון,עיינות,עילוט,עין איילה,עין אל-אסד,\n' +
            'עין גב,עין גדי,עין דור,עין הבשור,עין הוד,עין החורש,עין המפרץ,עין הנצי"ב,עין העמק,עין השופט,\n' +
            'עין השלושה,עין ורד,עין זיוון,עין חוד,עין חצבה,עין חרוד (איחוד),עין חרוד (מאוחד),עין יהב,עין יעקב,עין כרם-בי"ס חקלאי,\n' +
            'עין כרמל,עין מאהל,עין נקובא,עין עירון,עין צורים,עין קנייא,עין ראפה,עין שמר,עין שריד,עין תמר,\n' +
            'עינת,עיר אובות,עכו,עלומים,עלי,עלי זהב,עלמה,עלמון,עמוקה,עמינדב,\n' +
            'עמיעד,עמיעוז,עמיקם,עמיר,עמנואל,עמקה,ענב,עספיא,עפולה,עפרה,\n' +
            'עץ אפרים,עצמון שגב,עראבה,עשהאל,עראמשה*,ערב אל נעים,ערד,ערוגות,ערערה,ערערה-בנגב,עשרת,\n' +
            'עתלית,עתניאל,פארן,פדואל,פדויים,פדיה,פוריידיס,פורייה - כפר עבודה,פורייה - נווה עובד,פורייה עילית,\n' +
            'פורת,פטיש,פלך,פלמחים,פני חבר,פסגות,פסוטה,פעמי תש"ז,פצאל,פקיעין (בוקייעה),\n' +
            'פקיעין חדשה,פרדס חנה-כרכור,פרדסייה,פרוד,פרזון,פרי גן,פתח תקווה,פתחיה,צאלים,צביה,\n' +
            'צבעון,צובה,צוחר,צופייה,צופים,צופית,צופר,צוקי ים,צוקים,צור הדסה,\n' +
            'צור יצחק,צור משה,צור נתן,צוריאל,צורית,ציפורי,צלפון,צנדלה,צפרייה,צפרירים,\n' +
            'צפת,צרופה,צרעה,קבוצת יבנה,קדומים,קדימה-צורן,קדמה,קדמת צבי,קדר,קדרון,\n' +
            'קדרים,קוממיות,קורנית,קטורה,קיסריה,קלחים,קליה,קלנסווה,קלע,קציר,\n' +
            'קצר א-סר,קצרין,קריית אונו,קריית ארבע,קריית אתא,קריית ביאליק,קריית גת,קריית טבעון,קריית ים,קריית יערים,\n' +
            'קריית יערים (מוסד),קריית מוצקין,קריית מלאכי,קריית נטפים,קריית ענבים,קריית עקרון,קריית שלמה,קריית שמונה,קרני שומרון,קשת,\n' +
            'ראמה,ראס אל-עין,ראס עלי,ראש העין,ראש פינה,ראש צורים,ראשון לציון,רבבה,רבדים,רביבים,\n' +
            'רביד,רגבה,רגבים,רהט,רווחה,רוויה,רוח מדבר,רוחמה,רומאנה,רומת הייב,\n' +
            'רועי,רותם,רחוב,רחובות,רחלים,ריחאנייה,ריחן,ריינה,רימונים,רינתיה,\n' +
            'רכסים,רם-און,רמות,רמות השבים,רמות מאיר,רמות מנשה,רמות נפתלי,רמלה,רמת גן,רמת דוד,\n' +
            'רמת הכובש,רמת השופט,רמת השרון,רמת יוחנן,רמת ישי,רמת מגשימים,רמת צבי,רמת רזיאל,רמת רחל,רנן,\n' +
            'רעים,רעננה,רקפת,רשפון,רשפים,רתמים,שאר ישוב,שבי ציון,שבי שומרון,שבלי - אום אל-גנם,\n' +
            'שגב-שלום,שדה אילן,שדה אליהו,שדה אליעזר,שדה בוקר,שדה דוד,שדה ורבורג,שדה יואב,שדה יעקב,שדה יצחק,\n' +
            'שדה משה,שדה נחום,שדה נחמיה,שדה ניצן,שדה עוזיהו,שדה צבי,שדות ים,שדות מיכה,שדי אברהם,שדי חמד,\n' +
            'שדי תרומות,שדמה,שדמות דבורה,שדמות מחולה,שדרות,שואבה,שובה,שובל,שוהם,שומרה,\n' +
            'שומרייה,שוקדה,שורש,שורשים,שושנת העמקים,שזור,שחר,שחרות,שיבולים,שיטים,\n' +
            'שייח\' דנון,שילה,שילת,שכניה,שלווה,שלווה במדבר,שלוחות,שלומי,שלומית,שמיר,\n' +
            'שמעה,שמרת,שמשית,שניר,שעב,שעל,שעלבים,שער אפרים,שער הגולן,שער העמקים,\n' +
            'שער מנשה,שערי תקווה,שפיים,שפיר,שפר,שפרעם,שקד,שקף,שרונה,שריגים (לי-און),\n' +
            'שריד,שרשרת,שתולה,שתולים,תאשור,תדהר,תובל,תומר,תושייה,תימורים,\n' +
            'תירוש,תל אביב -יפו,תל יוסף,תל יצחק,תל מונד,תל עדשים,תל קציר,תל שבע,תל תאומים,תלם,\n' +
            'תלמי אליהו,תלמי אלעזר,תלמי ביל"ו,תלמי יוסף,תלמי יחיאל,תלמי יפה,תלמים,תמרת,תנובות,תעוז,\n' +
            'תפרח,תקומה,תקוע,תרבין א-צאנע (יישוב)*,תרום,';

        return allStates.split(',').map(function (state) {
            state = state.trim();
            return {
                value: state,
                display: state
            };
        });


    }

    /**
     * Create filter function for a query string
     */
    function createFilterFor(query) {
        var lowercaseQuery = angular.lowercase(query);

        return function filterFn(state) {
            return (state.value.indexOf(lowercaseQuery) === 0);
        };

    }


    /**
     * Look for changes in the branch
     */
    $scope.$watch('branch', function (newValue, oldValue) {
        $rootScope.editDataHandler(newValue, oldValue, 'branch-panel')
    },true)

}

(function ()
{
    'use strict';

    angular.module('app.pages.branch-management', ['datatables']).config(config);



    /** @ngInject */
    function config($stateProvider)
    {
        $stateProvider.state('app.pages_branch-management', {
            url      : '/branch-management',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/pages/branches/views/branches/branch-management/branch-management.html',
                    controller: 'BranchManagementController'
                }
            },
            resolve  : {
                DashboardData: function () {
                    localStorage.setItem("path", '/branch-management');
                }
            },
            bodyClass: 'branch-management'
        });


    }

})();

angular.module('app.pages.branch-management').controller('BranchManagementController',BranchManagementController);
function BranchManagementController($scope, $rootScope, $location, $mdSidenav, $mdDialog, DTOptionsBuilder, dtOptions, Notification,areasEndpoint, branchesEndpoint,$element, contactsEndpoint,statisticsEndpoint,contact,groupsEndpoint,systemSettingsEndpoint) {


    function init() {
        var branchObject = {};
        branchObject.ID = $location.search().ID;
        if (!branchObject.ID) {
            $location.path('/branches');
        }
        else {
            resolveBranch(branchObject);
            $scope.getAreas();

        }
    }



    /**
     * resolve the branch by the ID stored in the branchObject
     * @param branchObject
     */
    function resolveBranch(branchObject) {
        branchesEndpoint.get(branchObject, function (data) {
            if (data[0]) {
                $scope.branch = data[0];
                $scope.CreateTime = $scope.branch.CreateTime;
                console.log($rootScope.AdminLevel)
                $scope.currentBranchID = $scope.branch.ID;
                $scope.searchText = $scope.branch.City;
                $scope.getAllHours();
                $scope.getContacts();
                $scope.getFiles();
                $scope.getStatistics();
                $scope.getGroups();
                $scope.getBranchTags();
                if(! Array.isArray($scope.branch.SubsidyEmail))
                    $scope.branch.SubsidyEmail = [];
                $scope.$watch('branch', function (newValue, oldValue) {
                    if (typeof $rootScope.editDataHandler === 'function')
                        $rootScope.editDataHandler(newValue, oldValue, 'branch-panel');
                }, true);
            }
            else
                $location.path('/branches');

        });
    }



    $scope.tagsQuerySearch = function (query) {
        var results = query ?
            $scope.tags.filter(createFilterFor(query)) : [];
        return results;
    };

    $scope.getAreas = function () {
        var params = {};
        params.Status =1;
        areasEndpoint.get(params,function (data) {
            $scope.areas = data;
        })
    };

   /* $scope.setAreaName = function () {
        angular.forEach($scope.areas, function (value, key) {
            if ($scope.areas[key]['ID'] == $scope.branch.AreaID)
                $scope.branch.Area = $scope.areas[key]['Name'];

        })
    };*/

    /************ tags***********************/

    $scope.getBranchTags = function (){
        branchesEndpoint.tags.get($scope.branch.ID,function (data){
            $scope.tags = data;
        })
    }

    $scope.addNewTag = function(){
        $mdDialog.show({
            controller: 'AddNewBranchTagDialogController',
            templateUrl: 'app/main/pages/branches/views/branches/branch-management/add-new-branch-tag-dialog/add-new-branch-tag-dialog.html',
            clickOutsideToClose: true,
            locals: {
                branchID: $scope.branch.ID
            }
        }).then(function(){
            $scope.getBranchTags()
        });
    }

    $scope.deleteTag = function (tag){
        branchesEndpoint.tags.delete($scope.branch.ID,tag.ID,function (data){
            $scope.getBranchTags();
        })
    }



    /************ tags***********************/


    /*************hours*********************/

    $scope.getGroups = function (){
        groupsEndpoint.get({BranchID: $scope.branch.ID},function(data){
            $scope.groups = data;
        })
    }

    $scope.getAllHours = function(){
        $scope.hours = [];
        branchesEndpoint.hours.get($scope.branch.ID,function(data){
            data.forEach(function (hour) {
                var time = hour.FromHour.split(':');
                hour.FromHour= new Date(1970,0,1,time[0],time[1],0);
                time = hour.ToHour.split(':');
                hour.ToHour = new Date(1970,0,1,time[0],time[1],0);
            });
           $scope.hours = data;
        });
    }

    $scope.addNewHour = function(){
        $scope.hours.push({
            BranchID: $scope.branch.ID,
            Day: 1,
            FromHour: new Date(1970,0,1,8,0,0),
            ToHour: new Date(1970,0,1,16,0,0)
        });
    }

    $scope.saveHours = function(){
        $scope.hours.forEach(function (hour) {
            hour.FromHour = hour.FromHour.getHours() + ':' + hour.FromHour.getMinutes();
            hour.ToHour = hour.ToHour.getHours() + ':' + hour.ToHour.getMinutes();
        })
        branchesEndpoint.hours.update($scope.branch.ID,{hours:$scope.hours},function(data){
            $scope.getAllHours();
        });
    }

    $scope.deleteHour = function(hour){
        branchesEndpoint.hours.delete(hour,function (data) {
            $scope.getAllHours();
        });
    }

    $scope.displayHoursSave = function(){
        var flag = false;
        $scope.hours.forEach(function (hour) {
            if(hour.dirty || !hour.ID)
                flag = true;
        });
        return flag;
    }

    /*************hours********************/

    /*************contacts*****************/
    $scope.contactsSearch = {
        freeSearchFromDB: '',
        Status: 1
    }

    $scope.getContacts = function(reset){
        if(reset){
            $scope.contactsSearch = {
                freeSearchFromDB: '',
                Status: 1
            }
            return;
        }
        $scope.contacts = false;
        $scope.branchContacts = false;
        contactsEndpoint.get($scope.contactsSearch,function (data) {
            $scope.contacts = data;
            $scope.branchContacts = data.filter(function(contact){
                return contact.Branches.indexOf($scope.branch.ID) !== -1;
            });
        });
    }

    $scope.addNewContact = function(){
        $mdDialog.show({
            controller: 'NewContactDialogController',
            templateUrl: 'app/main/pages/contacts/new-contact-dialog/new-contact-dialog.html',
            clickOutsideToClose: false
        }).then(function(){
            $scope.getContacts();
        });
    }

    $scope.checkForExistingContact = function(contact){
        var existing = $scope.contacts.filter(function(c){
            return c.Name === contact.Name;
        });
        if(existing.length){
            contact = Object.assign(existing[0]);
        }
    }

    $scope.editContact = function (selectedContact) {
        contact.updateSelectedContact(selectedContact);
        $mdSidenav("contact-panel").open();
    };


    /*************contacts*****************/

    /************files*********************/
    $scope.fileSearch = {
        freeSearchFromDB: '',
    }
    $scope.getFiles = function(reset){
        if(reset){
            $scope.fileSearch = {
                freeSearchFromDB: '',
            }
            return;
        }
        $scope.files = [];
        branchesEndpoint.files.get($scope.branch.ID,$scope.fileSearch,function(data){
            $scope.files = data;
        })
    }


    $scope.openNewFileDialog = function() {
        $mdDialog.show({
            controller         : 'UploadController',
            templateUrl        : 'app/upload/upload.html',
            clickOutsideToClose: false,
            locals: {uploadTo: 'branches',uploadID :$scope.branch.ID,restrictTo :[]}
        }).then(function () {
            $scope.getFiles();
        });
    }

    /**
     * Open delete file doalog
     * @param file
     */
    $scope.deleteFileDialog = function(file) {
        var confirm = $mdDialog.confirm()
            .title('מחיקת קובץ')
            .textContent('האם אתה בטוח/ה שברצונך למחוק קובץ זה?')
            .ok('מחיקה')
            .cancel('ביטול');
        $mdDialog.show(confirm).then(function() {
            branchesEndpoint.files.delete(file,function(data){
                $scope.getFiles();
            })
        });
    }

    /************files*********************/

    /*********statistics*****************/

    $scope.getStatistics = function() {
        $scope.statistics= [];
        var params = {};
        params['BranchID'] = $scope.branch.ID;
        statisticsEndpoint.get(params,function (data) {
            if (data) {
                $scope.statistics=data;
                $scope.statistics.colors = ['#91dafc','#51c2f5','#0dacf4','#0578ac','#034e70'];
                $scope.statistics.colors2 = ['#99a5c4','#222630','#2d323e','#4b5366','#7f8aa4'];
                $scope.statistics.options = {
                    legend: {display: true}
                };
            }
        })
    }

    /**************statistics**************/


    /**
     * Set selected tab index
     * @param tab
     */
    $scope.setTab = function (tab) {
        $scope.selectedTab = tab;
    };

    $element.find('input').on('keydown', function (ev) {
        ev.stopPropagation();
    });

    /**
     * Create filter for query from auto complete
     * @param query
     * @returns {filterFn}
     */
    function createFilterFor(query) {
        var lowercaseQuery = angular.lowercase(query);

        return function filterFn(state) {
            return (state.value.indexOf(lowercaseQuery) === 0);
        };

    }

    $scope.states = loadAll();
    $scope.querySearch = querySearch;

    function querySearch(query) {
        var results = query ? $scope.states.filter(createFilterFor(query)) : $scope.states,
            deferred;
        if ($scope.simulateQuery) {
            deferred = $q.defer();
            $timeout(function () {
                deferred.resolve(results);
            }, Math.random() * 1000, false);
            return deferred.promise;
        } else {
            return results;
        }
    }

    $scope.setCity = function (city) {
        $scope.branch.City = city.value
    };

    /**
     * Set Table option
     * @type {any}
     */
    $scope.dtOptions = DTOptionsBuilder
        .newOptions()
        .withLanguage(dtOptions.language)
        .withDOM('lfrtp')
        .withOption('bFilter', false)
        .withOption('responsive',true)
        .withDOM('lrtip');


    /**
     * Build `states` list of key/value pairs
     */
    function loadAll() {

        var allStates = 'אבו גוש,אבו סנאן,אבו קורינאת (יישוב),אבו תלול,אבטין,אבטליון,אביאל,אביבים,אביגדור,אביחיל,\n' +
            'אביטל,אביעזר,אבירים,אבן יהודה,אבן מנחם,אבן ספיר,אבן שמואל,אבני איתן,אבני חפץ,אבנת,\n' +
            'אבשלום,אדורה,אדירים,אדמית,אדרת,אודים,אודם,אוהד,אום אל-פחם,אום אל-קוטוף,\n' +
            'אום בטין,אומן,אומץ,אופקים,אור הגנוז,אור הנר,אור יהודה,אור עקיבא,אורה,אורות,\n' +
            'אורטל,אורים,אורנים,אורנית,אושה,אזור,אחווה,אחוזם,אחוזת ברק,אחיהוד,\n' +
            'אחיטוב,אחיסמך,אחיעזר,איבים,אייל,איילת השחר,אילון,אילות,אילנייה,אילת,\n' +
            'אירוס,איתמר,איתן,איתנים,אכסאל,אל -עזי,אל -עריאן,אל -רום,אל סייד,אלומה,\n' +
            'אלומות,אלון הגליל,אלון מורה,אלון שבות,אלוני אבא,אלוני הבשן,אלוני יצחק,אלונים,אלי-עד,אליאב,\n' +
            'אליכין,אליפז,אליפלט,אליקים,אלישיב,אלישמע,אלמגור,אלמוג,אלעד,אלעזר,\n' +
            'אלפי מנשה,אלקוש,אלקנה,אמונים,אמירים,אמנון,אמציה,אניעם,אספר,אעבלין,\n' +
            'אפיק,אפיקים,אפק,אפרת,ארבל,ארגמן,ארז,אריאל,ארסוף,אשבול,\n' +
            'אשבל,אשדוד,אשדות יעקב (איחוד),אשדות יעקב (מאוחד),אשחר,אשכולות,אשל הנשיא,אשלים,אשקלון,אשרת,\n' +
            'אשתאול,באקה אל-גרביה,באר אורה,באר גנים,באר טוביה,באר יעקב,באר מילכה,באר שבע,בארות יצחק,בארותיים,\n' +
            'בארי,בוסתן הגליל,בועיינה-נוג\'ידאת,בוקעאתא,בורגתה,בחן,בטחה,ביצרון,ביר אל-מכסור,ביר הדאג\',\n' +
            'בירייה,בית אורן,בית אל,בית אלעזרי,בית אלפא,בית אריה,בית ברל,בית ג\'ן,בית גוברין,בית גמליאל,\n' +
            'בית דגן,בית הגדי,בית הלוי,בית הלל,בית העמק,בית הערבה,בית השיטה,בית זיד,בית זית,בית זרע,\n' +
            'בית חורון,בית חירות,בית חלקיה,בית חנן,בית חנניה,בית חשמונאי,בית יהושע,בית יוסף,בית ינאי,בית יצחק-שער חפר,\n' +
            'בית לחם הגלילית,בית מאיר,בית נחמיה,בית ניר,בית נקופה,בית עובד,בית עוזיאל,בית עזרא,בית עריף,בית צבי,\n' +
            'בית קמה,בית קשת,בית רבן,בית רימון,בית שאן,בית שמש,בית שערים,בית שקמה,ביתן אהרן,ביתר עילית,\n' +
            'בלפוריה,בן זכאי,בן עמי,בן שמן (כפר נוער),בן שמן (מושב),בני ברק,בני דקלים,בני דרום,בני דרור,בני יהודה,\n' +
            'בני נצרים,בני עטרות,בני עי"ש,בני ציון,בני ראם,בניה,בנימינה-גבעת עדה*,בסמ"ה,בסמת טבעון,בענה,\n' +
            'בצרה,בצת,בקוע,בקעות,בר גיורא,בר יוחאי,ברוכין,ברור חיל,ברוש,ברכה,\n' +
            'ברכיה,ברעם,ברק,ברקאי,ברקן,ברקת,בת הדר,בת חן,בת חפר,בת ים,\n' +
            'בת עין,בת שלמה,ג\'דיידה-מכר,ג\'ולס,ג\'לג\'וליה,ג\'סר א-זרקא,ג\'ש (גוש חלב),ג\'ת,גאולי תימן,גאולים,\n' +
            'גאליה,גבולות,גבים,גבע,גבע בנימין,גבע כרמל,גבעולים,גבעון החדשה,גבעות בר,גבעת אבני,\n' +
            'גבעת אלה,גבעת ברנר,גבעת השלושה,גבעת זאב,גבעת ח"ן,גבעת חיים (איחוד),גבעת חיים (מאוחד),גבעת יואב,גבעת יערים,גבעת ישעיהו,\n' +
            'גבעת כ"ח,גבעת ניל"י,גבעת עוז,גבעת שמואל,גבעת שמש,גבעת שפירא,גבעתי,גבעתיים,גברעם,גבת,\n' +
            'גדות,גדיש,גדעונה,גדרה,גונן,גורן,גורנות הגליל,גזית,גזר,גיאה,\n' +
            'גיבתון,גיזו,גילון,גילת,גינוסר,גיניגר,גינתון,גיתה,גיתית,גלאון,\n' +
            'גלגל,גליל ים,גלעד (אבן יצחק),גמזו,גן הדרום,גן השומרון,גן חיים,גן יאשיה,גן יבנה,גן נר,\n' +
            'גן שורק,גן שלמה,גן שמואל,גנות,גנות הדר,גני הדר,גני טל,גני יוחנן,גני עם,גני תקווה,\n' +
            'געש,געתון,גפן,גרופית,גשור,גשר,גשר הזיו,גת (קיבוץ),גת רימון,דאלית אל-כרמל,\n' +
            'דבורה,דבורייה,דבירה,דברת,דגניה א\',דגניה ב\',דוב"ב,דולב,דור,דורות,\n' +
            'דחי,דייר אל-אסד,דייר חנא,דייר ראפאת,דימונה,דישון,דלייה,דלתון,דמיידה,דן,\n' +
            'דפנה,דקל,דריג\'את,האון,הבונים,הגושרים,הדר עם,הוד השרון,הודיות,הודייה,\n' +
            'הושעיה,הזורע,הזורעים,החותרים,היוגב,הילה,המעפיל,הסוללים,העוגן,הר אדר,\n' +
            'הר גילה,הר עמשא,הראל,הרדוף,הרצלייה,הררית,ורד יריחו,ורדון,זבדיאל,זוהר,\n' +
            'זיקים,זיתן,זכרון יעקב,זכריה,זמר,זמרת,זנוח,זרועה,זרזיר,זרחיה,\n' +
            'ח\'ואלד,חבצלת השרון,חבר,חגור,חגי,חגלה,חד-נס,חדיד,חדרה,חוג\'ייראת (ד\'הרה) (שבט),\n' +
            'חולדה,חולון,חולית,חולתה,חוסן,חוסנייה,חופית,חוקוק,חורה,חורפיש,\n' +
            'חורשים,חזון,חיבת ציון,חיננית,חיפה,חירות,חלוץ,חלמיש,חלץ,חמאם,\n' +
            'חמד,חמדיה,חמדת,חמרה,חניאל,חניתה,חנתון,חספין,חפץ חיים,חפצי-בה,\n' +
            'חצב,חצבה,חצור הגלילית,חצור-אשדוד,חצרים,חרב לאת,חרוצים,חריש,חרמש,חרשים,\n' +
            'חשמונאים,טבריה,טובא-זנגרייה,טורעאן,טייבה,טייבה (בעמק),טירה,טירת יהודה,טירת כרמל,טירת צבי,\n' +
            'טל שחר,טל-אל,טללים,טלמון,טמרה,טמרה (יזרעאל),טנא,טפחות,יאנוח-ג\'ת,יבול,\n' +
            'יבנאל,יבנה,יגור,יגל,יד בנימין,יד השמונה,יד חנה,יד מרדכי,יד נתן,יד רמב"ם,\n' +
            'ידידה,יהוד,יהל,יובל,יובלים,יודפת,יונתן,יושיביה,יזרעאל,יחיעם,\n' +
            'יטבתה,ייט"ב,יכיני,ינוב,ינון,יסוד המעלה,יסודות,יסעור,יעד,יעל,\n' +
            'יעף,יערה,יפיע,יפית,יפעת,יפתח,יצהר,יציץ,יקום,יקיר,\n' +
            'יקנעם (מושבה),יקנעם עילית,יראון,ירדנה,ירוחם,ירושלים,ירחיב,ירכא,ירקונה,ישע,\n' +
            'ישעי,ישרש,יתד,כאבול,כאוכב אבו אל-היג\'א,כברי,כדורי,כדיתה,כוכב השחר,כוכב יאיר,\n' +
            'כוכב יעקב,כוכב מיכאל,כורזים,כחל,כחלה,כיסופים,כישור,כליל,כלנית,כמאנה,\n' +
            'כמהין,כמון,כנות,כנף,כנרת (מושבה),כנרת (קבוצה),כסיפה,כסלון,כסרא-סמיע,כעביה-טבאש-חג\'אג\'רה,\n' +
            'כפר אביב,כפר אדומים,כפר אוריה,כפר אחים,כפר ביאליק,כפר ביל"ו,כפר בלום,כפר בן נון,כפר ברא,כפר ברוך,\n' +
            'כפר גדעון,כפר גלים,כפר גליקסון,כפר גלעדי,כפר דניאל,כפר האורנים,כפר החורש,כפר המכבי,כפר הנגיד,כפר הנוער הדתי,\n' +
            'כפר הנשיא,כפר הס,כפר הרא"ה,כפר הרי"ף,כפר ויתקין,כפר ורבורג,כפר ורדים,כפר זוהרים,כפר זיתים,כפר חב"ד,\n' +
            'כפר חושן,כפר חיטים,כפר חיים,כפר חנניה,כפר חסידים א\',כפר חסידים ב\',כפר חרוב,כפר טרומן,כפר יאסיף,כפר ידידיה,\n' +
            'כפר יהושע,כפר יונה,כפר יחזקאל,כפר יעבץ,כפר כמא,כפר כנא,כפר מונש,כפר מימון,כפר מל"ל,כפר מנדא,\n' +
            'כפר מנחם,כפר מסריק,כפר מצר,כפר מרדכי,כפר נטר,כפר סאלד,כפר סבא,כפר סילבר,כפר סירקין,כפר עבודה,\n' +
            'כפר עזה,כפר עציון,כפר פינס,כפר קאסם,כפר קיש,כפר קרע,כפר ראש הנקרה,כפר רוזנואלד (זרעית),כפר רופין,כפר רות,\n' +
            'כפר שמאי,כפר שמואל,כפר שמריהו,כפר תבור,כפר תפוח,כרכום,כרם בן זמרה,כרם בן שמן,כרם יבנה (ישיבה),כרם מהר"ל,\n' +
            'כרם שלום,כרמי יוסף,כרמי צור,כרמיאל,כרמית,כרמייה,כרמים,כרמל,לבון,לביא,לבנים,\n' +
            'להב,להבות הבשן,להבות חביבה,להבים,לוד,לוזית,לוחמי הגיטאות,לוטם,לוטן,לימן,\n' +
            'לכיש,לפיד,לפידות,לקיה,מאור,מאיר שפיה,מבוא ביתר,מבוא דותן,מבוא חורון,מבוא חמה,\n' +
            'מבוא מודיעים,מבואות ים,מבועים,מבטחים,מבקיעים,מבשרת ציון,מג\'ד אל-כרום,מג\'דל שמס,מגאר,מגדים,\n' +
            'מגדל,מגדל העמק,מגדל עוז,מגדלים,מגידו,מגל,מגן,מגן שאול,מגשימים,מדרך עוז,\n' +
            'מדרשת בן גוריון,מדרשת רופין,מודיעין עילית,מודיעין-מכבים-רעות*,מולדה*,מולדת,מוצא עילית,מוקייבלה,מורן,מורשת,\n' +
            'מזור,מזכרת בתיה,מזרע,מזרעה,מחולה,מחנה הילה*,מחנה טלי*,מחנה יהודית*,מחנה יוכבד*,מחנה יפה*,\n' +
            'מחנה מרים*,מחנה תל נוף*,מחניים,מחסיה,מטולה,מטע,מי עמי,מיטב,מייסר,מיצר,\n' +
            'מירב,מירון,מישר,מיתר,מכורה,מכחול,מכמורת,מכמנים,מלאה,מלילות,\n' +
            'מלכייה,מלכישוע,מנוחה,מנוף,מנות,מנחמיה,מנרה,מנשית זבדה,מסד,מסדה,\n' +
            'מסילות,מסילת ציון,מסלול,מסעדה,מעברות,מעגלים,מעגן,מעגן מיכאל,מעוז חיים,מעון,\n' +
            'מעונה,מעיין ברוך,מעיין צבי,מעיליא,מעלה אדומים,מעלה אפרים,מעלה גלבוע,מעלה גמלא,מעלה החמישה,מעלה לבונה,\n' +
            'מעלה מכמש,מעלה עירון,מעלה עמוס,מעלה שומרון,מעלות-תרשיחא,מענית,מעש,מפלסים,מצדות יהודה,מצובה,\n' +
            'מצליח,מצפה,מצפה אבי"ב,מצפה אילן,מצפה יריחו,מצפה נטופה,מצפה רמון,מצפה שלם,מצר,מרגליות,\n' +
            'מרום גולן,מרחב עם,מרחביה (מושב),מרחביה (קיבוץ),מרכז שפירא,משאבי שדה,משגב דב,משגב עם,משהד,משואה,\n' +
            'משואות יצחק,משכיות,משמר איילון,משמר דוד,משמר הירדן,משמר הנגב,משמר העמק,משמר השבעה,משמר השרון,משמרות,\n' +
            'משמרת,משען,מתן,מתת,מתתיהו,נאות גולן,נאות הכיכר,נאות מרדכי,נאות סמדר,נאעורה,\n' +
            'נבטים,נגבה,נגוהות,נהורה,נהלל,נהרייה,נוב,נוגה,נווה,נווה אור,\n' +
            'נווה אטי"ב,נווה אילן,נווה איתן,נווה דניאל,נווה זוהר,נווה זיו,נווה חריף,נווה ים,נווה ימין,נווה ירק,\n' +
            'נווה מבטח,נווה מיכאל,נווה שלום,נועם,נוף איילון,נופים,נופית,נופך,נוקדים,נורדייה,\n' +
            'נורית,נחושה,נחל עוז,נחלה,נחליאל,נחלים,נחם,נחף,נחשולים,נחשון,\n' +
            'נחשונים,נטועה,נטור,נטע,נטעים,נטף,ניין,ניל"י,ניצן,ניצן ב\',\n' +
            'ניצנה (קהילת חינוך),ניצני סיני,ניצני עוז,ניצנים,ניר אליהו,ניר בנים,ניר גלים,ניר דוד (תל עמל),ניר ח"ן,ניר יפה,\n' +
            'ניר יצחק,ניר ישראל,ניר משה,ניר עוז,ניר עם,ניר עציון,ניר עקיבא,ניר צבי,נירים,נירית,\n' +
            'נירן,נס הרים,נס עמים,נס ציונה,נעורים,נעלה,נעמ"ה,נען,נצר חזני,נצר סרני,\n' +
            'נצרת,נצרת עילית,נשר,נתיב הגדוד,נתיב הל"ה,נתיב העשרה,נתיב השיירה,נתיבות,נתניה,סאג\'ור,\n' +
            'סאסא,סביון*,סגולה,סואעד (חמרייה)*,סולם,סוסיה,סופה,סח\'נין,סלמה,סלעית,\n' +
            'סמר,סנסנה,סעד,סער,ספיר,סתרייה,ע\'ג\'ר,עבדון,עברון,עגור,\n' +
            'עדי,עדנים,עוזה,עוזייר,עולש,עומר,עופר,עוצם,עזוז,עזר,\n' +
            'עזריאל,עזריה,עזריקם,עטרת,עידן,עיילבון,עיינות,עילוט,עין איילה,עין אל-אסד,\n' +
            'עין גב,עין גדי,עין דור,עין הבשור,עין הוד,עין החורש,עין המפרץ,עין הנצי"ב,עין העמק,עין השופט,\n' +
            'עין השלושה,עין ורד,עין זיוון,עין חוד,עין חצבה,עין חרוד (איחוד),עין חרוד (מאוחד),עין יהב,עין יעקב,עין כרם-בי"ס חקלאי,\n' +
            'עין כרמל,עין מאהל,עין נקובא,עין עירון,עין צורים,עין קנייא,עין ראפה,עין שמר,עין שריד,עין תמר,\n' +
            'עינת,עיר אובות,עכו,עלומים,עלי,עלי זהב,עלמה,עלמון,עמוקה,עמינדב,\n' +
            'עמיעד,עמיעוז,עמיקם,עמיר,עמנואל,עמקה,ענב,עספיא,עפולה,עפרה,\n' +
            'עץ אפרים,עצמון שגב,עראבה,עשהאל,עראמשה*,ערב אל נעים,ערד,ערוגות,ערערה,ערערה-בנגב,עשרת,\n' +
            'עתלית,עתניאל,פארן,פדואל,פדויים,פדיה,פוריידיס,פורייה - כפר עבודה,פורייה - נווה עובד,פורייה עילית,\n' +
            'פורת,פטיש,פלך,פלמחים,פני חבר,פסגות,פסוטה,פעמי תש"ז,פצאל,פקיעין (בוקייעה),\n' +
            'פקיעין חדשה,פרדס חנה-כרכור,פרדסייה,פרוד,פרזון,פרי גן,פתח תקווה,פתחיה,צאלים,צביה,\n' +
            'צבעון,צובה,צוחר,צופייה,צופים,צופית,צופר,צוקי ים,צוקים,צור הדסה,\n' +
            'צור יצחק,צור משה,צור נתן,צוריאל,צורית,ציפורי,צלפון,צנדלה,צפרייה,צפרירים,\n' +
            'צפת,צרופה,צרעה,קבוצת יבנה,קדומים,קדימה-צורן,קדמה,קדמת צבי,קדר,קדרון,\n' +
            'קדרים,קוממיות,קורנית,קטורה,קיסריה,קלחים,קליה,קלנסווה,קלע,קציר,\n' +
            'קצר א-סר,קצרין,קריית אונו,קריית ארבע,קריית אתא,קריית ביאליק,קריית גת,קריית טבעון,קריית ים,קריית יערים,\n' +
            'קריית יערים (מוסד),קריית מוצקין,קריית מלאכי,קריית נטפים,קריית ענבים,קריית עקרון,קריית שלמה,קריית שמונה,קרני שומרון,קשת,\n' +
            'ראמה,ראס אל-עין,ראס עלי,ראש העין,ראש פינה,ראש צורים,ראשון לציון,רבבה,רבדים,רביבים,\n' +
            'רביד,רגבה,רגבים,רהט,רווחה,רוויה,רוח מדבר,רוחמה,רומאנה,רומת הייב,\n' +
            'רועי,רותם,רחוב,רחובות,רחלים,ריחאנייה,ריחן,ריינה,רימונים,רינתיה,\n' +
            'רכסים,רם-און,רמות,רמות השבים,רמות מאיר,רמות מנשה,רמות נפתלי,רמלה,רמת גן,רמת דוד,\n' +
            'רמת הכובש,רמת השופט,רמת השרון,רמת יוחנן,רמת ישי,רמת מגשימים,רמת צבי,רמת רזיאל,רמת רחל,רנן,\n' +
            'רעים,רעננה,רקפת,רשפון,רשפים,רתמים,שאר ישוב,שבי ציון,שבי שומרון,שבלי - אום אל-גנם,\n' +
            'שגב-שלום,שדה אילן,שדה אליהו,שדה אליעזר,שדה בוקר,שדה דוד,שדה ורבורג,שדה יואב,שדה יעקב,שדה יצחק,\n' +
            'שדה משה,שדה נחום,שדה נחמיה,שדה ניצן,שדה עוזיהו,שדה צבי,שדות ים,שדות מיכה,שדי אברהם,שדי חמד,\n' +
            'שדי תרומות,שדמה,שדמות דבורה,שדמות מחולה,שדרות,שואבה,שובה,שובל,שוהם,שומרה,\n' +
            'שומרייה,שוקדה,שורש,שורשים,שושנת העמקים,שזור,שחר,שחרות,שיבולים,שיטים,\n' +
            'שייח\' דנון,שילה,שילת,שכניה,שלווה,שלווה במדבר,שלוחות,שלומי,שלומית,שמיר,\n' +
            'שמעה,שמרת,שמשית,שניר,שעב,שעל,שעלבים,שער אפרים,שער הגולן,שער העמקים,\n' +
            'שער מנשה,שערי תקווה,שפיים,שפיר,שפר,שפרעם,שקד,שקף,שרונה,שריגים (לי-און),\n' +
            'שריד,שרשרת,שתולה,שתולים,תאשור,תדהר,תובל,תומר,תושייה,תימורים,\n' +
            'תירוש,תל אביב -יפו,תל יוסף,תל יצחק,תל מונד,תל עדשים,תל קציר,תל שבע,תל תאומים,תלם,\n' +
            'תלמי אליהו,תלמי אלעזר,תלמי ביל"ו,תלמי יוסף,תלמי יחיאל,תלמי יפה,תלמים,תמרת,תנובות,תעוז,\n' +
            'תפרח,תקומה,תקוע,תרבין א-צאנע (יישוב)*,תרום,';

        return allStates.split(',').map(function (state) {
            state = state.trim();
            return {
                value: state,
                display: state
            };
        });


    }

    init();
}

angular.module('app.pages.users').controller('PaymentMatchController', PaymentMatchController);
function PaymentMatchController($scope, $mdDialog,$location,dealID,paymentsEndpoint) {

    var vm =this;

    vm.getDeal = getDeal;
    vm.closeDialog =closeDialog;


    function getDeal() {
        var params = {};
        params.DealID = dealID;
        paymentsEndpoint.deals.get(params,function (data) {
            vm.items = [];
            Object.keys(data.Items).forEach(function (key) {
                if(! isNaN(key))
                    vm.items.push(data.Items[key]);
            })
            vm.deal = data;


        })

    }

    function closeDialog() {
        $mdDialog.cancel();
    }
}



angular.module('app.pages.users').controller('StudentsController', StudentsController);

function StudentsController($scope, $rootScope, $mdSidenav, $mdDialog, tagsEndpoint, Notification, $location, DTColumnDefBuilder, usersEndpoint, msUtils, $timeout, $document, DTOptionsBuilder, dtOptions, branchesEndpoint, groupsEndpoint, studentsEndpoint, student, gradesEndpoint, areasEndpoint, rolesEndpoint) {

    var vm = this;
    vm.search = {};
    vm.search.branches = [];
    vm.search.groups = [];
    vm.search.grades = [];
    vm.search.tags = [];
    vm.search.Tags = [];
    vm.search.roles = [];
    vm.branches = [];
    vm.groups = [];
    vm.grades = [];
    vm.area = [];
    vm.students = [];
    vm.selectedStudentsCount = 0;
    vm.dtInstance = {};
    vm.pageData = {total: 0};
    vm.dtColumnDefs = [DTColumnDefBuilder.newColumnDef(0).notSortable()];
    vm.getBranchesAndGroups = getBranchesAndGroups;
    vm.getAreas = getAreas;
    vm.getTags = getTags;
    vm.getRoles = getRoles;
    vm.rolesQuerySearch = rolesQuerySearch;
    vm.getGrades = getGrades;
    vm.getStudents = getStudents;
    vm.openStudentPanel = openStudentPanel;
    vm.branchesQuerySearch = branchesQuerySearch;
    vm.tagsQuerySearch = tagsQuerySearch;
    vm.groupsQuerySearch = groupsQuerySearch;
    vm.gradesQuerySearch = gradesQuerySearch;
    vm.openNewStudentDialog = openNewStudentDialog;
    vm.filterByStatus = filterByStatus;
    vm.filterByEducator = filterByEducator;
    vm.setAll = setAll;
    vm.openSendEmail = openSendEmail;
    vm.openSendSMS = openSendSMS;
    vm.openChangeGroupGrades = openChangeGroupGrades;
    vm.studentToggled = studentToggled;
    vm.openStudentsImportDialog = openStudentsImportDialog;
    vm.init = init;

    function init (){
        vm.getBranchesAndGroups();
        vm.getGrades();
        vm.getAreas();
        vm.getTags();
        vm.getRoles()
    }


    var get = function (sSource, aoData, fnCallback, oSettings) {
        var draw = aoData[0].value;
        var order = aoData[2].value;
        var start = aoData[3].value;
        var length = aoData[4].value;
        vm.search.Start = start;
        vm.search.Length = length;
        if (vm.render) {
            vm.render = false;
            vm.records.data = vm.students;
            vm.pageData.total = vm.lastRespons.data.total;
            fnCallback(vm.records);
            return;
        }

        vm.students = false;

        vm.isClicked = true;
        var params = {};
        params.Order = order;
        params.GroupsIdes = [];
        params.BranchIdes = [];
        params.GradesIdes = [];
        var groups = angular.copy(vm.search.groups);
        var branches = angular.copy(vm.search.branches);
        var grades = angular.copy(vm.search.grades);
        for (var i = 0; i < groups.length; i++) {
            params.GroupsIdes.push(groups[i].ID)
        }
        for (var i = 0; i < branches.length; i++) {
            params.BranchIdes.push(branches[i].ID)
        }
        for (var i = 0; i < grades.length; i++) {
            params.GradesIdes.push(grades[i].ID)
        }
        params.FreeSearch = vm.search.freeSearchFromDB;
        params.BranchIdes = JSON.stringify(params.BranchIdes);
        params.GroupsIdes = JSON.stringify(params.GroupsIdes);
        params.Status = vm.search.status;
        params.Tags = vm.search.tags;
        params.Roles = vm.search.roles;
        params.AreaID = vm.search.area;
        params.freeSearchFromDBSettings = vm.search.freeSearchFromDBSettings;
        params.Type = vm.search.educator;
        params.StudentType = vm.search.type;
        params.Start = vm.search.Start;
        params.Length = vm.search.Length;
        params.EducatorStatus = vm.search.EducatorStatus;
        vm.selectedStudentsCount = 0;
        vm.groups = [];
        vm.loader = true;
        studentsEndpoint.get(params, function (response) {
            vm.selectAll = false;
            vm.lastRespons = response;
            vm.students = response.data.items;
            if (response.data) {
                vm.records = {
                    'draw': draw,
                    'recordsTotal': response.data.total,
                    'recordsFiltered': response.data.total,
                    'data': []
                };
            }
            vm.pageData.total = response.data.total;
            fnCallback(vm.records);
        })
    };


    /**
     * Get All Branches And Groups
     */
    function getBranchesAndGroups() {
        var params = {};
        params.Status = 1;
        branchesEndpoint.get(params, function (data) {
            vm.branches = data;
        });

    }


    /**
     * Get Areas
     */
    function getAreas() {
        var params = {};
        params.Status = 1;
        areasEndpoint.get(params, function (data) {
            vm.area = data;
        })
    }


    /**
     * Get Tags
     */
    function getTags() {
        var params = {};
        params.withNames = true;
        params.TagType = 1;
        tagsEndpoint.get(params, function (data) {
            vm.tags = data;
        })
    }

    /**
     * get roles
     */
    function getRoles() {
        var params = {};
        params.withNames = true;
        rolesEndpoint.educator.get(params, function (data) {
            vm.roles = data;
        })
    }

    /**
     * Get Grades
     */
    function getGrades() {
        var params = {};
        params.Status = 1;
        gradesEndpoint.get(params, function (data) {
            vm.grades = data;
        })
    }

    /**
     * Get All Students
     */
    function getStudents(noFilter) {
        if (noFilter) {
            vm.search = {};
            vm.search.branches = [];
            vm.search.groups = [];
            vm.search.tags = [];
            vm.search.roles = [];
            vm.students = [];
            return;
        }
        vm.dtInstance.rerender();
    }

    /**
     * Branches query search
     * @param query
     * @returns {Array}
     */
    function tagsQuerySearch(query) {
        return query ? vm.tags.filter(createFilterForTags(query)) : [];
    };

    /**
     * query serach
     * @param query
     * @returns {Array}
     */
    function rolesQuerySearch(query) {
        return query ? vm.roles.filter(createFilterForTags(query)) : [];
    }

    /**
     * Create filter for query from auto complete
     * @param query
     * @returns {filterFn}
     */
    function createFilterForTags(query) {
        var lowercaseQuery = angular.lowercase(query);
        return function filterFn(contact) {
            return (contact.Name.indexOf(lowercaseQuery) != -1);
        };
    }

    /**
     * Branches query search
     * @param query
     * @returns {Array}
     */
    function branchesQuerySearch(query) {
        var results = query ? vm.branches.filter(createFilterFor(query)) : [];
        return results;
    };



    /**
     * Groups query search
     * @param query
     * @returns {*}
     */
    function groupsQuerySearch(query) {
        return query ? vm.groups.filter(createFilterFor(query)) : [];
    }

    /**
     * Groups query search
     * @param query
     * @returns {*}
     */
    function gradesQuerySearch(query) {
        if (vm.grades)
            var results = query ? vm.grades.filter(createFilterFor(query)) : [];
        return results;
    }

    /**
     * Create filter for query from auto complete
     * @param query
     * @returns {filterFn}
     */
    function createFilterFor(query) {
        var lowercaseQuery = angular.lowercase(query);
        return function filterFn(contact) {
            return (contact.Name.indexOf(lowercaseQuery) != -1);
        };
    }

    /**
     * Watch on branches
     */
    $scope.$watchCollection('vm.search.branches.length', function () {

        var params = {};
        params.BranchIdes = [];
        for (var i = 0; i < vm.search.branches.length; i++) {
            params.BranchIdes.push(vm.search.branches[i].ID)
        }
        params.BranchIdes = JSON.stringify(params.BranchIdes);
        groupsEndpoint.get(params, function (data) {
            vm.groups = data;
        });
    });

    /**
     * Open the student panel
     * @param selectedStudent
     */
    function openStudentPanel(selectedStudent) {
        $mdSidenav("student-panel").open();
        student.updateSelectedStudent(selectedStudent);
    }

    /**
     * Ro Back Row
     * @param nRow
     * @param aData
     * @param iDisplayIndex
     * @param iDisplayIndexFull
     */
    function rowCallback(nRow, aData, iDisplayIndex, iDisplayIndexFull) {
        $compile(nRow)(vm);
    }

    /**
     * Open the create new student Dialog
     */
    function openNewStudentDialog() {
        $mdDialog.show({
            controller: 'NewStudentsDialogController',
            templateUrl: 'app/main/pages/users/views/students/new-students-dialog/new-students-dialog.html',
            clickOutsideToClose: false
        });
    }

    /**
     * Filter by status
     * @param item
     * @returns {boolean}
     */
    function filterByStatus(item) {
        if (vm.search.status == 1)
            return item.Status == 1;
        else if (vm.search.status == 0)
            return item.Status == 0;
        else
            return true;
    }

    /**
     * Filter by Educator
     * @param item
     * @returns {boolean}
     */
    function filterByEducator(item) {
        if (vm.search.educator == 1)
            return item.EducatorID > 0;
        else if (vm.search.educator == 0)
            return item.EducatorID == null;
        else
            return true;
    }


    /**
     * Set All
     * @param selectAll
     */
    function setAll(selectAll) {
        if (selectAll) {
            Notification.info("שים לב.<br> ניתן לבחור חניכים מהתצוגה בלבד. <br>כדי לבחור את כל החניכים יש לשנות את מספר החניכים המוצגים. ")
            for (var i = 0; i < vm.students.length; i++) {
                vm.students[i].Selected = true;
            }
            vm.selectedStudentsCount = vm.students.length;
        } else {
            for (var i = 0; i < vm.students.length; i++) {
                vm.students[i].Selected = false;
            }
            vm.selectedStudentsCount = 0;
        }
    };

    /**
     * Open send sms dialog
     */
    function openSendSMS() {
        $mdDialog.show({
            controller: 'SMSDialogController',
            templateUrl: 'app/main/pages/sms-email-dialogs/sms-dialog/sms-dialog.html',
            locals: {'students': vm.students, 'external': false, 'type': 1},
            clickOutsideToClose: false
        });
    }

    /**
     * open send email
     */
    function openSendEmail() {
        $mdDialog.show({
            controller: 'EmailDialogController',
            templateUrl: 'app/main/pages/sms-email-dialogs/email-dialog/email-dialog.html',
            locals: {'students': vm.students, 'external': false, 'type': 1},
            clickOutsideToClose: false

        });
    }

    /**
     * Open change group grade dialog
     */
    function openChangeGroupGrades() {
        $mdDialog.show({
            controller: 'ChangeGroupOrGradeDialogController',
            templateUrl: 'app/main/pages/users/views/students/change-group-grade-dialog/change-group-grade-dialog.html',
            locals: {'students': vm.students},
            clickOutsideToClose: false
        }).then(function () {
            getStudents();
        });
    }

    function openStudentsImportDialog() {
        $mdDialog.show({
            controller: 'ImportStudentsDialogController',
            templateUrl: 'app/main/pages/users/views/students/import-students-dialog/import-students-dialog.html',
            clickOutsideToClose: false
        });
    }

    /**
     * Student Count
     * @param student
     */
    function studentToggled(student) {
        if (student.Selected)
            vm.selectedStudentsCount++;
        else
            vm.selectedStudentsCount--;
    }


    /**
     * Set Table option
     * @type {any}
     */
    vm.dtOptions = DTOptionsBuilder
        .newOptions()
        .withFnServerData(get)
        .withLanguage(dtOptions.language)
        .withDataProp('data')
        .withOption('processing', true)
        .withOption('serverSide', true)
        .withOption('paging', true)
        .withOption('responsive', true)
        //.withOption('rowCallback', rowCallback)
        .withPaginationType('full_numbers')
        .withDisplayLength(10)
        .withDOM('lfrtp')
        .withDOM('lrtip')
        .withOption('columnDefs', [
            {orderable:false, targets: 0},
            /*{ responsivePriority: 1, targets: 0 },
            { responsivePriority: 10001, targets: 1 },*/

            ])
        .withOption('lengthMenu', [[10, 50, 100, 500, 1000, 5000], [10, 50, 100, 500, 1000, 5000]])
        .withDOM('<"top">t<i"bottom"p>l<"clear">');


}

angular.module('app.pages.users').controller('ParentsController', ParentsController);
function ParentsController($rootScope,$mdSidenav,$mdDialog,$location,usersEndpoint,Notification, msUtils, $timeout, $document,DTColumnDefBuilder,DTOptionsBuilder,dtOptions,branchesEndpoint,groupsEndpoint,parentsEndpoint,parent,$window,$cookies,appConfig,tagsEndpoint) {

    var vm = this;

    vm.search = {};
    vm.search.Tags = [];
    vm.parents = [];
    vm.dtInstance = {};
    vm.pageData = {total:0};
    vm.getParents = getParents;
    vm.getTags =getTags;
    vm.tagsQuerySearch =tagsQuerySearch;
    vm.goToParentsPanel =goToParentsPanel;
    vm.loginToProfile =loginToProfile;
    vm.setAll =setAll;
    vm.openSendEmail =openSendEmail;
    vm.openSendSMS =openSendSMS;

    var get = function(sSource, aoData, fnCallback, oSettings){
        var draw = aoData[0].value;
        var order = aoData[2].value;
        var start = aoData[3].value;
        var length = aoData[4].value;
        vm.search.Start = start;
        vm.search.Length = length;
        if (vm.render) {
            vm.render=false;
            vm.records.data = vm.parents;
            vm.pageData.total= vm.lastRespons.data.total;
            fnCallback(vm.records);
            return;
        }
        vm.parents= false;
        vm.isClicked = true;
        vm.search.order = order;
        parentsEndpoint.get(vm.search, function (response) {
            vm.selectAll = false;
            vm.lastRespons = response;
            vm.parents= response.data.items;
            if(response.data){
                vm.records = {
                    'draw': draw,
                    'recordsTotal': response.data.total,
                    'recordsFiltered':response.data.total,
                    'data': []
                };
            }
            vm.pageData.total= response.data.total;
            fnCallback(vm.records);

        })


    };
    /**
     * Get parents
     */
     function getParents(noFilter) {
        if (noFilter) {
            vm.search = {};
            return;
        }
        vm.dtInstance.rerender();
    }

     function getTags() {
        var params = {};
        params.withNames = true;
        params.TagType=2;
        tagsEndpoint.get(params, function (data) {
            vm.tags = data;
        })
    }


    /**
     * Branches query search
     * @param query
     * @returns {Array}
     */
    function tagsQuerySearch(query) {
        return query ? vm.tags.filter(createFilterForTags(query)) : [];
    }

    /**
     * Create filter for query from auto complete
     * @param query
     * @returns {filterFn}
     */
    function createFilterForTags(query) {
        var lowercaseQuery = angular.lowercase(query);
        return function filterFn(contact) {
            return (contact.Name.indexOf(lowercaseQuery) != -1);
        };
    }


    /**
     * Open parent panel
     * @param selectedParent
     */
     function goToParentsPanel(selectedParent) {
        $mdSidenav("parent-panel").open();
        parent.updateSelectedParent(selectedParent);
    }


    /**
     * Login To Parent Profile
     * @param parent
     */
    function loginToProfile(parent) {
        delete $cookies.remove(appConfig.profileTokenName);
        localStorage.removeItem(appConfig.profilePathCokieName);
        var expireTime = +new Date() + (24 * 3600000);
        if (location.hostname === "localhost" || location.hostname === "127.0.0.1")
            document.cookie = appConfig.adminTokenName + "=" + $rootScope.User.AccessToken + "**" + parent.ID + ";domain=localhost;path=/;expires=" + expireTime;
        else
            document.cookie = appConfig.adminTokenName + "=" + $rootScope.User.AccessToken + "**" + parent.ID + ";domain=." + appConfig.appDomain + ";path=/;expires=" + expireTime;

        if (location.hostname === "localhost" || location.hostname === "127.0.0.1")
            $window.open('http://localhost:4200/', '_blank');
        else if (location.host === appConfig.locationHost)
            $window.open(appConfig.developmentProfilePath, '_blank');
        else
            $window.open(appConfig.prodctionProfilePath, '_blank');
    }



    function setAll(selectAll) {
        if (selectAll) {
            for (var i = 0; i < vm.parents.length; i++) {
                vm.parents[i].Selected = true;
            }
            Notification.info("שים לב.<br> ניתן לבחור חניכים מהתצוגה בלבד. <br>כדי לבחור את כל החניכים יש לשנות את מספר החניכים המוצגים. ")

        }
        else
            for (var i = 0; i < vm.parents.length; i++) {
                vm.parents[i].Selected = false;
            }
    }



    /**
     * Open send sms dialog
     */
    function openSendSMS() {
        $mdDialog.show({
            controller: 'SMSDialogController',
            templateUrl: 'app/main/pages/sms-email-dialogs/sms-dialog/sms-dialog.html',
            locals: {'students': vm.parents, 'external': false,'type':3},
            clickOutsideToClose: false

        });
    }

    /**
     * open send email
     */
     function openSendEmail() {
        $mdDialog.show({
            controller: 'EmailDialogController',
            templateUrl: 'app/main/pages/sms-email-dialogs/email-dialog/email-dialog.html',
            locals: {'students': vm.parents, 'external': false,'type':3},
            clickOutsideToClose: false

        });
    }

    vm.dtColumnDefs = [
        DTColumnDefBuilder.newColumnDef(1).withOption('type', 'eu-date'),
        DTColumnDefBuilder.newColumnDef(2).withOption('type', 'eu-date'),
        DTColumnDefBuilder.newColumnDef(3).withOption('type', 'eu-date'),
        DTColumnDefBuilder.newColumnDef(0).notSortable()

    ];

    function rowCallback (nRow, aData, iDisplayIndex, iDisplayIndexFull) {
        $compile(nRow)(vm);
    }

    vm.dtOptions = DTOptionsBuilder
        .newOptions()
        .withFnServerData(get)
        .withLanguage(dtOptions.language)
        .withDataProp('data')
        .withOption('processing', true)
        .withOption('serverSide', true)
        .withOption('paging', true)
        .withOption('responsive', true)
        .withOption('rowCallback', rowCallback)
        .withPaginationType('full_numbers')
        .withDisplayLength(10)
        .withOption('lengthMenu', [[10, 50, 100, 500, 1000, 5000], [10, 50, 100, 500, 1000, 5000]])
        .withDOM('<"top">t<i"bottom"p>l<"clear">');





}

angular.module('app.pages.users').controller('CoordinatorsController',CoordinatorsController);
function CoordinatorsController($scope,$rootScope,$mdSidenav,$mdDialog,$location,usersEndpoint, msUtils, $timeout, $document,DTOptionsBuilder,dtOptions,Notification,branchesEndpoint,groupsEndpoint,coordinatorsEndpoint,coordinate,rolesEndpoint) {

    if (!$rootScope.User)
        $location.path('/dashboard');

    $scope.search = {};
    $scope.coordinators = [];
    $scope.search.branches = [];
    $scope.search.groups = [];
    $scope.coordinators = [];
    /**
     * Get All Branches And Groups
     */
    $scope.getBranches = function () {
        var params = {};
        params.Status = 1;
        branchesEndpoint.get(params, function (data) {
            $scope.branches = data;
        });
    };

    /**
     * Get Coordinators
     * @param noFilter
     */
    $scope.getCoordinators = function (noFilter) {
        $scope.isClicked = true;
        $scope.coordinators = null;
        if (!noFilter) {
            var params = {};
            params.BranchIdes = [];
            $scope.isClicked = true;
            for (var i = 0; i < $scope.search.branches.length; i++) {
                params.BranchIdes.push($scope.search.branches[i].ID)
            }

            params.FreeSearch = $scope.search.freeSearchFromDB;
            params.BranchIdes = JSON.stringify(params.BranchIdes);
            params.Status = $scope.search.status;
            params.Role = $scope.search.role;
        }
        else {
            $scope.search = {};
            $scope.search.branches = [];
            $scope.search.groups = [];
            return;
        }
        $scope.students = null;

        coordinatorsEndpoint.get(params, function (data) {
            $scope.dtInstance = {};
            $scope.isClicked = false;
            $scope.coordinators = data;
        })

    };

    /**
     * Open new Coordinators
     */
    $scope.openNewCoordinatDialog = function () {
        $mdDialog.show({
            controller: 'NewCoordinatorsDialogController',
            templateUrl: 'app/main/pages/users/views/coordinators/new-coordinators-dialog/new-coordinators-dialog.html',
            clickOutsideToClose: false
        });
    };

    /**
     * Move to user profile
     */
    $scope.goToCoordinatProfile = function (selectedCoordinate) {
        coordinate.updateSelectedCoordinate(selectedCoordinate);
        $location.path("/coordinator-profile")
    };

    /**
     * Branches query search
     * @param query
     * @returns {Array}
     */
    $scope.branchesQuerySearch = function (query) {
        var results = query ?
            $scope.branches.filter(createFilterFor(query)) : [];
        return results;
    };

    /**
     * Create filter for query from auto complete
     * @param query
     * @returns {filterFn}
     */
    function createFilterFor(query) {
        var lowercaseQuery = angular.lowercase(query);
        return function filterFn(contact) {
            return (contact.Name.indexOf(lowercaseQuery) != -1);
        };
    }


    /**
     * Open  Coordinators Panel
     * @param selectedCoordinate
     */
    $scope.openCoordinatPanel = function (selectedCoordinate) {
        $mdSidenav("coordinate-panel").open();
        coordinate.updateSelectedCoordinate(selectedCoordinate);
    };


    /**
     * Set Table option
     * @type {any}
     */
    $scope.dtOptions = DTOptionsBuilder
        .newOptions()
        .withLanguage(dtOptions.language)
        .withDOM('lfrtp')
        .withOption('bFilter', false)
        .withOption('responsive',true)
        .withDOM('lrtip');


    $scope.setAll = function (selectAll) {
        if (selectAll) {
            for (var i = 0; i < $scope.coordinators.length; i++) {
                $scope.coordinators[i].Selected = true;
            }
        }
        else
            for (var i = 0; i < $scope.coordinators.length; i++) {
                $scope.coordinators[i].Selected = false;
            }
    };

    /**
     * Open send sms dialog
     */
    $scope.openSendSMS = function () {
        $mdDialog.show({
            controller: 'SMSDialogController',
            templateUrl: 'app/main/pages/sms-email-dialogs/sms-dialog/sms-dialog.html',
            locals: {'students': $scope.coordinators, 'external': false, 'type': 2},
            clickOutsideToClose: false

        });
    };

    $scope.resendInvitation = function (){
        coordinatorsEndpoint.resendInvitation(function(data){
            if(data.success)
                Notification.success('הזמנות נשלחו בהצלחה');
        })
    }

    /**
     * open send email
     */
    $scope.openSendEmail = function () {
        $mdDialog.show({
            controller: 'EmailDialogController',
            templateUrl: 'app/main/pages/sms-email-dialogs/email-dialog/email-dialog.html',
            locals: {'students': $scope.coordinators, 'external': false, 'type': 2},
            clickOutsideToClose: false

        });
    };

    /**
     * Get Roles
     */
    $scope.getRoles =function () {
        var params = {};
        params.withNames = true;
        rolesEndpoint.get(params, function (data) {
            $scope.roles = data;
        })
    }




}

angular.module('app.pages.settings').controller('GeneralSettingsController', GeneralSettingsController);

function GeneralSettingsController(systemSettingsEndpoint, settingsEndpoint, Notification, appConfig, $rootScope, Upload) {


    var vm = this;
    vm.systemSettings = {};
    vm.uploadFile = uploadFile;
    vm.getSystemSettings =getSystemSettings;
    vm.updateSystemSettings = updateSystemSettings;
    vm.viewFile =viewFile;
    vm.getAdminImages =getAdminImages;
    vm.updateAdminImageSettings =updateAdminImageSettings;
    /**
     * Get System Settings
     */
    function viewFile(path) {
        window.open( path);
    }
    function getSystemSettings() {
        systemSettingsEndpoint.names.get(function (data) {
            vm.systemSettings = data;
            vm.systemSettings.AttendenceStatus = vm.systemSettings.AttendenceStatus=="" ?  [] : JSON.parse(vm.systemSettings.AttendenceStatus);
        })
    }

    /**
     * update SystemSettings
     */
    function updateSystemSettings() {
        var params = {};
        params.Names = vm.systemSettings;
        params.Names.AttendenceStatus = JSON.stringify(params.Names.AttendenceStatus);
        vm.isClicked = true;
        systemSettingsEndpoint.names.post(params,function (data) {
            vm.isClicked = false;
            Notification.success("הגדרות עודכנו בהצלחה");
        })
    }

    /**
     * Get Admin Images
     */
    function getAdminImages() {
        settingsEndpoint.admin.images.get(function (data) {
            vm.adminImages = data;
        })
    }

    /**
     * Update Admin Images
     */
    function updateAdminImageSettings() {
        vm.isClicked = true;
        var params = {};
        params.Images = vm.adminImages;
        settingsEndpoint.admin.images.post(params,function (data) {
            Notification.success("פרטים עודכנו בהצלחה");
            vm.isClicked = false;

        })
    }


    /**
     * UploadFile
     * @param file
     */
    function uploadFile(file, image) {
        if (!file)
            return;
        vm.isClicked = true;
        image.FileName = file.name;
        var uploadURL = '';
        if (location.hostname === "localhost" || location.hostname === "127.0.0.1")
            uploadURL = appConfig.localHostUrl + '/upload/files?brand=' + $rootScope.brandName;
        else if (location.host === appConfig.locationHost)
            uploadURL = appConfig.developmentHostUrl + '/upload/files?brand=' + $rootScope.brandName;
        else
            uploadURL = appConfig.serverUrl + '/upload/files?brand=' + $rootScope.brandName;

        var headers = {};
        headers.Authorization = 'Bearer ' +  $rootScope.User.AccessToken;
        Upload.upload({
            url: uploadURL,
            headers: headers,
            data: {
                file: file,
            }
        }).then(function (resp) {
            vm.isClicked = false;
            image.Value = resp.data.Path;
        }, function (resp) {
            console.log('Error status: ' + resp.status);
        }, function (evt) {
            var progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
            console.log('progress: ' + progressPercentage);
        });


    }
}





angular.module('app.pages.settings').controller('ProfileSettingsController', ProfileSettingsController);

function ProfileSettingsController (appConfig,systemSettingsEndpoint,Notification,settingsEndpoint,DTOptionsBuilder,dtOptions,$mdSidenav,$mdDialog,extraField,birthdaySettingsEndpoint, externalDiscountsEndpoint, $rootScope ) {


    var vm = this;
    vm.options = {};
    vm.brandIsTeva = false;
    vm.options.contentsLangDirection   = 'rtl';
    vm.options.height = '600px';
    vm.profile = {};
    vm.mandatoryStudentFields = [
        'PrivateID',
        'FirstName',
        'LastName',
        'Email',
        'GradeID',
        'BranchID',
        'Group'
    ];

    vm.getTerms = getTerms;
    vm.updateTerms = updateTerms;
    vm.getProfilePopUpAlert = getProfilePopUpAlert;
    vm.updateProfilePopUpAlert = updateProfilePopUpAlert;
    vm.getEmails =getEmails;
    vm.updateSettings =updateSettings;
    vm.getProfileSettings =getProfileSettings;
    vm.fetchAllStudentFields =fetchAllStudentFields;
    vm.updateStudentFields =updateStudentFields;
    vm.openNewFieldDialog =openNewFieldDialog;
    vm.fetchAllExtraStudentFields =fetchAllExtraStudentFields;
    vm.editField =editField;
    vm.updateSystemBirthdaySettings =updateSystemBirthdaySettings;
    vm.getSystemBirthdaySettings =getSystemBirthdaySettings;
    vm.extraFieldType = extraFieldType;
    vm.getExternalDiscountIdsSettings = getExternalDiscountIdsSettings;
    vm.updateExternalDiscountIdsSettings = updateExternalDiscountIdsSettings;



    /**
     * Set Table option
     * @type {any}
     */
    vm.dtOptions = DTOptionsBuilder
        .newOptions()
        .withLanguage(dtOptions.language)
        .withDOM('lfrtp')
        .withOption('bFilter', false)
        .withDOM('lrtip');

    /**
     * Get Terms
     */
    function getTerms() {
        systemSettingsEndpoint.terms.get(function (data) {

            setTimeout(function(){
                vm.terms = data;
            },500)
        })
    }
    if($rootScope.brandName.toLowerCase() === 'teva'){
        vm.brandIsTeva = true;
    }

    /**
     * Update Terms for profile
     */
    function updateTerms() {
        systemSettingsEndpoint.terms.post(vm.terms,function (data) {
            Notification.success("תנאים עודכנו בהצלחה");
        })
    }

    /**
     * get profile pop up alert
     */
    function getProfilePopUpAlert() {
        systemSettingsEndpoint.ProfilePopUpAlert.get(function (data) {
            setTimeout(function(){
                vm.profilePopUpAlert = data;
            },500)


        })
    }

    /**
     * Update profile pop up alert
     */
    function updateProfilePopUpAlert() {

        var tmp = document.createElement("DIV");
        tmp.innerHTML = vm.profilePopUpAlert.Name;
        var ans =  tmp.textContent || tmp.innerText || "";
        // if(ans.trim().length > 0 ) {
            systemSettingsEndpoint.ProfilePopUpAlert.post(vm.profilePopUpAlert,function (data) {
                Notification.success("הודעת פרופיל עודכנה בהצלחה");
            })
        // }
    }

    /**
     * Get emails
     */
    function getEmails() {
        settingsEndpoint.forms.emails.get(function (data) {
            if (data) {
                vm.settings = data;
                angular.forEach(vm.settings, function (value, key) {
                    if (angular.isUndefined(value.Value) || value.Value === '' || value.Value == null)
                        vm.settings[key].Value = [];
                    else{
                        try {
                            vm.settings[key].Value = JSON.parse(value.Value);
                        } catch (error) {
                            vm.settings[key].Value = value.Value;
                        }

                    }
                });
                vm.settingsReady = true;
            }
        })
    }

    /**
     * Update settings
     */
    function updateSettings() {
        var settings = vm.settings.slice();
        settings.forEach(function (value) {
            value.Value = JSON.stringify(value.Value);
        });

        var params = {
            settings: settings
        };
        settingsEndpoint.post(params, function (data) {
            if (data.success)
                Notification.success('הגדרות נשמרו בהצלחה!');
            else
                Notification.error('נכשל בשמירת הגדרות!');
            vm.getEmails();
        })

        updateProfileSettings();
    }


    /**
     * Update Profile Settings
     */
    function updateProfileSettings() {
        vm.isClicked = true;
        settingsEndpoint.profile.post(vm.profile,function (data) {
            vm.isClicked = false;

        })
    }

    /**
     * Get Profile Settings
     */
    function getProfileSettings() {
        settingsEndpoint.profile.get(function (data) {
            vm.profile = data;
        })
    }

    function fetchAllStudentFields() {
        systemSettingsEndpoint.studentFields.all.get([],function(data) {
            var arr = [];
            Object.keys(data).map(function (key) {
                var obj = data[key];
                obj.required = (obj.required === 1);
                arr.push(obj);
            });
            vm.studentfields = arr;
        });
    }

    function updateStudentFields() {
        vm.isClicked = true;
        systemSettingsEndpoint.studentFields.all.post({fields: vm.studentfields},function(){
            Notification.success("פרטים עודכנו בהצלחה");
            vm.isClicked = false;
        });
    }

    function openNewFieldDialog() {
        $mdDialog.show({
            controller         : 'NewFieldDialogController',
            templateUrl        : 'app/main/pages/settings/tabs/profile/new-field-dialog/new-field-dialog.html',
            clickOutsideToClose: true,
        }).then(function () {
            fetchAllExtraStudentFields();
        });
    }


    function fetchAllExtraStudentFields() {
        systemSettingsEndpoint.studentExtraFields.get([],function(data) {
            var arr = [];
            Object.keys(data).map(function (key) {
                arr.push(data[key]);
            });
            vm.extraStudentFields = arr;
        });
    }

    /**
     * Edit field
     */
    function editField(selectedField) {
        extraField.updateSelectedField(selectedField);
        $mdSidenav("field-panel").open();
    }

    /**
     * update BirthdaySettings
     */
    function updateSystemBirthdaySettings() {
        vm.isClicked = true;
        birthdaySettingsEndpoint.post(vm.birthdaySettings,function (data) {
            vm.isClicked = false;
            Notification.success("הגדרות עודכנו בהצלחה");
        })
    }

    /**
     * Get BirthdaySettings
     */
    function getSystemBirthdaySettings() {
        birthdaySettingsEndpoint.get(function (data) {
            vm.birthdaySettings = data;
        });
    }
    getExternalDiscountIdsSettings();
    function getExternalDiscountIdsSettings() {
        externalDiscountsEndpoint.get(function (data) {
            vm.modalSettings = data;
        });
    }
    /**
     * update ModalSettings
     */
    function updateExternalDiscountIdsSettings() {
        vm.isClicked = true;
        externalDiscountsEndpoint.post(vm.modalSettings,function (data) {
            vm.isClicked = false;
            Notification.success("הגדרות עודכנו בהצלחה");
        });
    }

    /**
     * Set Type
     * @param type
     * @returns {string}
     */
    function extraFieldType(type){
        switch (type) {
            case "1":
            case 1:
                return "שאלה פתוחה";
                break;
            case "2":
            case 2:
                return "אפשרויות";
                break;
            case "3":
            case 3:
                return "תאריך";
                break;
            case "4":
            case 4:
                return "קובץ";
                break;
        }
    }
}





angular.module('app.pages.settings').controller('AdminSettingsController', AdminSettingsController);


function AdminSettingsController($rootScope, tagsEndpoint, Notification, rolesEndpoint, systemSettingsEndpoint, gradesEndpoint, studentsEndpoint) {

    var vm = this;
    vm.getTags = getTags;
    vm.updateTags = updateTags;
    vm.getRoles = getRoles;
    vm.updateRoles = updateRoles;
    vm.getSystemSettings = getSystemSettings;
    vm.systemSettings = {};
    vm.systemSettings.AttendenceStatus = [];
    vm.getGrades = getGrades;
    vm.updateGrade = updateGrade;

    getSystemSettings();

    /**
     * Get Tags
     */
    function getTags() {
        var params = {};
        params.TagType = 1;
        tagsEndpoint.get(params, function (data) {
            vm.studentsTags = data;
        });
        params.TagType = 2;
        tagsEndpoint.get(params, function (data) {
            vm.parentsTags = data;
        })
    }

    /**
     * Update Tags
     */
    function updateTags() {
        vm.isClikced = true;
        var params = {};
        params.TagType = 1;
        params.Tags = JSON.stringify(angular.copy(vm.studentsTags));
        tagsEndpoint.post(params, function (data) {
        });
        params.TagType = 2;
        params.Tags = JSON.stringify(angular.copy(vm.parentsTags));
        tagsEndpoint.post(params, function (data) {
            vm.isClikced = false;
            if (data.success)
                Notification.success("תגיות עודכנו");

        });
        updateSystemSettings();

    }

    /**
     * Get Roles
     */
    function getRoles() {
        rolesEndpoint.get([], function (data) {
            vm.roles = data;
        })
    }

    /**
     * Update Roles
     */
    function updateRoles() {
        vm.isClikced = true;
        var params = {};
        params.Roles = JSON.stringify(angular.copy(vm.roles));
        rolesEndpoint.post(params, function (data) {
            vm.isClikced = false;
            if (data.success)
                Notification.success("תפקידים עודכנו");

        });
    }

    /**
     * Get System Settings
     */
    function getSystemSettings() {
        systemSettingsEndpoint.names.get(function (data) {
            vm.systemSettings = data;
            vm.systemSettings.AttendenceStatus = vm.systemSettings.AttendenceStatus == "" ? [] : splitArray(vm.systemSettings.AttendenceStatus);
            try {
                vm.systemSettings.BranchesTags = JSON.parse(vm.systemSettings.BranchesTags);
                if(!Array.isArray(vm.systemSettings.BranchesTags))
                    vm.systemSettings.BranchesTags = [];
            } catch (e) {
                vm.systemSettings.BranchesTags = [];
            }
        })
    }

    /**
     * update SystemSettings
     */
    function updateSystemSettings() {
        var params = {};
        params.Names = vm.systemSettings;
        params.Names.AttendenceStatus = JSON.stringify(params.Names.AttendenceStatus);
        params.Names.BranchesTags = JSON.stringify(params.Names.BranchesTags);
        vm.isClicked = true;
        systemSettingsEndpoint.names.post(params, function (data) {
            vm.isClicked = false;
            Notification.success("הגדרות עודכנו בהצלחה");
        })
    }

    function splitArray(str) {
        var newStr = str.replace(/[[]|[\]]/g, "").replace(/"/g, "");
        var arr = newStr.split(",");
        return arr;
    }

    /**
     * Get All Grades
     */
    function getGrades() {
        var params = {};
        params.Status = 1;
        vm.grades = false;
        gradesEndpoint.get(params, function (data) {
            vm.grades = data;
        });
    }

    /**
     * Update grade
     */
    function updateGrade() {
        vm.isClicked = true;
        studentsEndpoint.grades.upgrade.post(vm.upgrade, function (data) {
            vm.isClicked = false;
            if (data.success) {
                Notification.success("עודכן בהצלחה");
                vm.upgrade = {};
            } else
                Notification.error("נכשל בעדכון");


        })
    }

    /**
     * Create filter for query from auto complete
     * @param query
     * @returns {filterFn}
     */
    function createFilterFor(query) {
        var lowercaseQuery = angular.lowercase(query);
        return function filterFn(contact) {
            return (contact.Name.indexOf(lowercaseQuery) != -1);
        };
    }

}

angular.module('app.pages.settings').controller('ExternalRegistrationsController', ExternalRegistrationsController);

function ExternalRegistrationsController(settingsEndpoint,Notification) {


    var vm = this;

    vm.getExternalSettings =getExternalSettings;
    vm.updateExternalSettings =updateExternalSettings;
    vm.externalEvent = {};
    vm.options = {};
    vm.options.contentsLangDirection   = 'rtl';
    vm.options.height = '600px';

    /**
     * get external settings
     */
    function getExternalSettings(){
        settingsEndpoint.external.get(function(data){
            if(data && data.length){
                data.forEach(function(ent){
                    vm.externalEvent[ent.Entity] = ent.Name;
                })
            }
        })
    }
    /**
     * update external settings
     */
    function updateExternalSettings(){
        var params = {};
        params['External'] = vm.externalEvent;
        settingsEndpoint.external.post(params,function(data){
            if(data.success){
                Notification.success("עודכן בהצלחה");
            }else{
                Notification.error("לא עודכן ישנה בעיה");
            }
        })
    }

}

angular.module('app.pages.settings').controller('AccountancySettingsController', AccountancySettingsController);

function AccountancySettingsController(settingsEndpoint,Notification,$mdDialog ) {

    var vm= this;

    vm.getAccountancySettings = getAccountancySettings;
    vm.updateAccountancy =updateAccountancy;
    vm.addBank =addBank;
    vm.showDonationsAlert = showDonationsAlert;

    /**
     * Get Accountancy Settings
     */
    function getAccountancySettings() {
        settingsEndpoint.accountancy.get(function (data) {
            vm.accountancy = data;
        });
    }

    /**
     * Update Accountancy
     */
    function updateAccountancy () {
        vm.isClicked = true;
        settingsEndpoint.accountancy.post(vm.accountancy, function (data) {
            vm.isClicked = false;
            if (data.success)
                Notification.success("הפרטים עדוכונו בהצלחה")
        })
    }

    /**
     * Add New Bank
     */
    function addBank() {
        var newBank = {};
        newBank.Name = '';
        newBank.Code ='';
        newBank.Number = '';
        vm.accountancy.Banks.push(newBank);
    }

    function showDonationsAlert(){
        if(vm.accountancy.EnableDonations == 1){
            vm.accountancy.EnableDonations = 0;
            var confirm = $mdDialog.confirm()
                .title('שים לב')
                .textContent('על מנת לאשר תרומות, יש לוודא אישור ביצוע עסקאות טוקן ללא ת.ז. ו-CVV מול חברת הסליקה והאשראי. כמו כן, הקבלות שיופקו הינם קבלות המוכרות לפי סעיף 46.')
                .ok('אישור')
                .cancel('ביטול');
            $mdDialog.show(confirm).then(function() {
                vm.accountancy.EnableDonations = 1;
            });
        }
    }
}

(function ()
{
    'use strict';

    angular
        .module('app.pages.profile-forms', []).config(config).run(run);

    function run($rootScope,msNavigationService) {
        $rootScope.$watch('User',function () {

            /**
             * Set the pages by the admin level
             */
            if ($rootScope.AdminLevel) {
                switch ($rootScope.AdminLevel) {
                    case 3:
                        msNavigationService.saveItem('pages.profile-forms', {
                            title : 'פניות פרופיל',
                            icon  : 'icon-clipboard-text',
                            weight: 5
                        });

                        msNavigationService.saveItem('pages.profile-forms.profile-forms_cancel-form', {
                            title : 'בקשות ביטול',
                            icon  : 'icon-cancel',
                            state : 'app.pages_profile-forms_cancel-form'

                        });

                        msNavigationService.saveItem('pages.profile-forms.profile-forms_contact-form', {
                            title : 'פניות צור קשר',
                            icon  : 'icon-email',
                            state : 'app.pages_profile-forms_contact-form'

                        });

                        if($rootScope.AdminLevel == 3 || ($rootScope.User.IsCoordinator && $rootScope.User.SubsidyRequests == 1)){
                            msNavigationService.saveItem('pages.profile-forms.profile-forms_subsidy-form', {
                                title : 'בקשות סבסוד',
                                icon  : 'icon-file-document',
                                state : 'app.pages_profile-forms_subsidy-form'

                            });
                        }
                        break;

                }
            }
        });

    }
    /** @ngInject */
    function config($stateProvider)
    {
        // State
        $stateProvider
            .state('app.pages.profile-forms', {
                abstract: true,
                url     : '/profile-forms'
            })
            .state('app.pages_profile-forms_cancel-form', {
                url      : '/cancel-form',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/pages/profile-forms/views/cancel-form/cancel-form.html',
                        controller : 'CancelFormController as vm'
                    }
                },
                resolve  : {
                    DashboardData: function (ValidToken)
                    {
                        ValidToken.validUserToken();
                        localStorage.setItem("path",'/cancel-form');
                    }
                }
            })
            .state('app.pages_profile-forms_contact-form', {
                url      : '/contact-form',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/pages/profile-forms/views/contact-form/contact-form.html',
                        controller : 'ContactFormController as vm'
                    }
                },
                resolve  : {
                    DashboardData: function (ValidToken)
                    {
                        ValidToken.validUserToken();
                        localStorage.setItem("path",'/contact-form');
                    }
                }
            })
            .state('app.pages_profile-forms_subsidy-form', {
                url      : '/subsidy-form',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/pages/profile-forms/views/subsidy-form/subsidy-form.html',
                        controller : 'SubsidyFormController as vm'
                    }
                },
                resolve  : {
                    DashboardData: function (ValidToken)
                    {
                        ValidToken.validUserToken();
                        localStorage.setItem("path",'/subsidy-form');
                    }
                }
            })
    }
})();


angular.module('app.pages.profile-forms').controller('SubsidyFormController', SubsidyFormController);

function SubsidyFormController($scope, DTOptionsBuilder, dtOptions, eventsEndpoint, formsEndpoint, $mdDialog,
                               DTColumnDefBuilder, studentsEndpoint, parentsEndpoint) {


    var vm = this;
    vm.getSubsidyForms = getSubsidyForms;
    vm.openSubsidyDialog = openSubsidyDialog;
    vm.searchTerm = '';
    vm.subsidyes = [];


    /**
     * Get parent Contact Forms
     */
    function getSubsidyForms(reset) {
        if (reset) {
            vm.search = {};
            return;
        }
        vm.subsidyes = false;
        formsEndpoint.subsidy.get(vm.search, function (data) {
            vm.subsidyes = data;
        });
    }


    /**
     * Open The Subsidy Dialog
     * @param subsidy
     */
    function openSubsidyDialog(subsidy) {
        var DBSubsidy;
        var kids = [];
        parentsEndpoint.subsidy.getByID(subsidy.ParentID, subsidy.SubsidyID, function (data) {
            DBSubsidy = data;
            DBSubsidy.forEach(function (sub) {
                if (sub.typeForm && [2, 3].includes(+sub.typeForm)) {
                    // sub.Parent1PrivateIDFile = JSON.parse(sub.Parent1PrivateIDFile);
                    // if (sub.Parent2PrivateIDFile) {
                    //     sub.Parent2PrivateIDFile = JSON.parse(sub.Parent2PrivateIDFile);
                    // }
                    // sub.Parent1Paycheck1File = JSON.parse(sub.Parent1Paycheck1File);
                    // if (sub.Parent2Paycheck1File) {
                    //     sub.Parent2Paycheck1File = JSON.parse(sub.Parent2Paycheck1File);
                    // }
                    // sub.Parent1Paycheck2File = JSON.parse(sub.Parent1Paycheck2File);
                    // if (sub.Parent2Paycheck2File) {
                    //     sub.Parent2Paycheck2File = JSON.parse(sub.Parent2Paycheck2File);
                    // }
                    // sub.Parent1Paycheck3File = JSON.parse(sub.Parent1Paycheck3File);
                    // if (sub.Parent2Paycheck3File) {
                    //     sub.Parent2Paycheck3File = JSON.parse(sub.Parent2Paycheck3File);
                    // }
                    // if (sub.OtherFiles) {
                    //     sub.OtherFiles = JSON.parse(sub.OtherFiles);
                    // }
                    Object.keys(sub).forEach(function (key) {
                        if(key.indexOf('File') > -1) {
                            try {
                                sub[key] = JSON.parse(sub[key]);
                            } catch (e) {

                            }
                        }
                    });

                    if (sub.MoreKids && sub.MoreKids !== "[]") {
                        var kids = {};
                        kids['IDs'] = sub.MoreKids;
                        studentsEndpoint.get(kids, function (response) {
                            kids = response.data.items;
                        });
                    }
                }
                // if (sub.typeForm && +sub.typeForm === 3) {
                //     Object.keys(sub).forEach(function (key) {
                //         if(key.indexOf('File') > -1) {
                //             try {
                //                 sub[key] = JSON.parse(sub[key]);
                //             } catch (e) {
                //
                //             }
                //
                //         }
                //     });
                //     console.log(sub);
                // }
            });
            $mdDialog.show({
                controller: 'SubsidyDialogController',
                templateUrl: 'app/main/pages/users/views/parents/parents-profile/tabs/subsidy/subsidy-dialog/subsidy-dialog.html',
                clickOutsideToClose: true,
                locals: {'subsidy': DBSubsidy[0], 'moreKids': kids}
            });
        });

    }


    /**
     * Set Table option
     * @type {any}
     */
    vm.dtOptions = DTOptionsBuilder
        .newOptions()
        .withLanguage(dtOptions.language)
        .withDOM('lfrtp')
        .withOption('bFilter', false)
        .withOption('responsive', true)
        .withDOM('lrtip')
        .withOption('order', [1, 'desc']);

    jQuery.extend(jQuery.fn.dataTableExt.oSort, {
        "eu-date-pre": function (a) {

            if (a == null || a == '') {
                return 0;
            }
            a = a.replace('<span class="dpn">', '');
            a = a.split('</span>')[0];
            return a;
        }
    });


    vm.dtColumnDefs = [
        DTColumnDefBuilder.newColumnDef(0).withOption('type', 'eu-date')

    ];


}





angular.module('app.pages.profile-forms').controller('ContactFormController', ContactFormController);

function ContactFormController ($scope, DTOptionsBuilder, dtOptions, eventsEndpoint, formsEndpoint, $mdDialog, DTColumnDefBuilder) {


    var vm = this;
    vm.getContactForms= getContactForms;
    vm.openContactDialog = openContactDialog;
    vm.downloadContactForms = downloadContactForms;
    vm.searchTerm = '';
    vm.contact=  [];



    function downloadContactForms() {
        vm.contact= false;
        vm.search.export = true;
        formsEndpoint.contact.get(vm.search,function (data) {

        });
    }

    function getContactForms(reset) {
        if (reset) {
            vm.search = {};
            return;
        }
        vm.contact= false;
        formsEndpoint.contact.get(vm.search,function (data) {
            vm.contact = data;
        })
    }

    /**
     * Open The Contact Dialog
     * @param contactForm
     */
    function openContactDialog(contactForm) {
        $mdDialog.show({
            controller         : 'ContactDialogController',
            templateUrl        : 'app/main/pages/forms-dialogs/contact-dialog/contact-dialog.html',
            clickOutsideToClose: true,
            locals : {'contactForm' : contactForm}
        });
    };


    /**
     * Set Table option
     * @type {any}
     */
    vm.dtOptions = DTOptionsBuilder
        .newOptions()
        .withLanguage(dtOptions.language)
        .withDOM('lfrtp')
        .withOption('bFilter', false)
        .withDOM('lrtip')
        .withOption('responsive',true)
        .withOption('order', [0, 'desc']);

    jQuery.extend(jQuery.fn.dataTableExt.oSort, {
        "eu-date-pre": function (a) {
            if (a == null || a == '') {
                return 0;
            }
            var date = a.split('/');
            return Date.parse(date[1] + '/' + date[0] + '/' + date[2])
        }
    });


    vm.dtColumnDefs = [
        DTColumnDefBuilder.newColumnDef(0).withOption('type', 'eu-date'),

    ];


}





angular.module('app.pages.profile-forms').controller('CancelFormController', CancelFormController);

function CancelFormController ($scope,DTOptionsBuilder,dtOptions,eventsEndpoint,formsEndpoint,$mdDialog,DTColumnDefBuilder) {


    var vm = this;
    vm.getEvents = getEvents;
    vm.getCancelForms= getCancelForms;
    vm.openCancellationDialog = openCancellationDialog;
    vm.searchTerm = '';
    vm.cancellation=  [];

    /**
     * get Events
     */
    function getEvents() {
        eventsEndpoint.get([],function (data) {
            vm.events = data;
        })
    }

    function getCancelForms(reset) {
        if (reset) {
            vm.search = {};
            return;
        }
        vm.cancellation= false;
        formsEndpoint.cancellation.get(vm.search,function (data) {
            vm.cancellation = data;
        })
    }

    /**
     * Open The Cancellation Dialog
     * @param cancel
     */
    function openCancellationDialog(cancel) {
        $mdDialog.show({
            controller         : 'CancellationDialogController',
            templateUrl        : 'app/main/pages/forms-dialogs/cancellation-dialog/cancellation-dialog.html',
            clickOutsideToClose: true,
            locals : {'cancel' : cancel}
        });
    };


    /**
     * Set Table option
     * @type {any}
     */
    vm.dtOptions = DTOptionsBuilder
        .newOptions()
        .withLanguage(dtOptions.language)
        .withDOM('lfrtp')
        .withOption('bFilter', false)
        .withDOM('lrtip')
        .withOption('responsive',true)
        .withOption('order', [0, 'desc']);

    jQuery.extend(jQuery.fn.dataTableExt.oSort, {
        "eu-date-pre": function (a) {
            if (a == null || a == '') {
                return 0;
            }
            var date = a.split('/');
            return Date.parse(date[1] + '/' + date[0] + '/' + date[2])
        }
    });


    vm.dtColumnDefs = [
        DTColumnDefBuilder.newColumnDef(0).withOption('type', 'eu-date'),

    ];


}





angular.module('app.pages.events').controller('TransportationController', ['$scope','$rootScope','$mdSidenav','$mdDialog','$location','usersEndpoint', 'msUtils', '$timeout','$document', 'DTOptionsBuilder','dtOptions','transportationEndpoint','groupsEndpoint','parentsEndpoint','transportation','Notification'
    ,function($scope,$rootScope,$mdSidenav,$mdDialog,$location,usersEndpoint, msUtils, $timeout, $document,DTOptionsBuilder,dtOptions,transportationEndpoint,groupsEndpoint,parentsEndpoint,transportation,Notification) {

        $scope.transportation = [];
        $scope.isClicked= false;
        $scope.search = {};

        /**
         * Get All Transportation
         */
        $scope.getTransportation = function () {
            $scope.transportation = false;
            transportationEndpoint.get(function (data) {
                $scope.transportation = data;
            })
        };


        /**
         * Open add new Transportation Dialog
         */
        $scope.openNewTransportationDialog = function () {
            $mdDialog.show({
                controller         : 'NewTransportationDialogController',
                templateUrl        : 'app/main/pages/events/views/transportation/new-transportation-dialog/new-transportation-dialog.html',
                clickOutsideToClose: true
            }).then(function () {
                $scope.getTransportation();
            });
        };

        /**
         * Edit transportation
         */
        $scope.editTransportation = function (selectedTransportation) {
            transportation.updateSelectedTransportation(selectedTransportation);
            $mdSidenav("transportation-panel").open();
        };

        /**
         * Open the delete Transportation alert
         * @param selectedTransportation
         * @param ev
         */
        $scope.deleteTransportationDialog = function (selectedTransportation,ev) {
            var confirm = $mdDialog.confirm()
                .title('מחיקת שאלה')
                .textContent('האם אתה בטוח שברצונך למחוק את שאלה זו? ')
                .targetEvent(ev)
                .ok('מחק')
                .cancel('בטל');
            $mdDialog.show(confirm).then(function() {
                deleteTransportation(selectedTransportation)
            })

        };

        /**
         * Delete Transportation
         * @param selectedTransportation
         */
        var deleteTransportation = function (selectedTransportation) {
            var index = $scope.transportation.indexOf(selectedTransportation);
            $scope.transportation.splice(index, 1);
            transportationEndpoint.delete.post(selectedTransportation, function (data) {
                if (!data.success) {
                    Notification.info("ההסעה מקושרת ל"+$rootScope.User.Event+" קיים - לא ניתן למחוק");
                    $scope.transportation.push(selectedTransportation);
                }
            })
        };


        /**
         * Filter by status
         * @param item
         * @returns {boolean}
         */
        $scope.filterByStatus = function (item) {
            if ($scope.search.status==1)
                return item.Status==1;
            else if ($scope.search.status==0)
                return item.Status==0;
            else
                return true;
        };

        /**
         * Set Table option
         * @type {any}
         */
        $scope.dtOptions = DTOptionsBuilder
            .newOptions()
            .withLanguage(dtOptions.language)
            .withDOM('lfrtp')
            .withOption('responsive',true)
            .withOption('bFilter', false)
            .withDOM('lrtip');

    }]);

angular.module('app.pages.events').controller('QuestionsController', ['$scope','$rootScope','$mdSidenav','$mdDialog','$location','usersEndpoint', 'msUtils', '$timeout','$document', 'DTOptionsBuilder','dtOptions','questionsEndpoint','groupsEndpoint','parentsEndpoint','question','Notification'
    ,function($scope,$rootScope,$mdSidenav,$mdDialog,$location,usersEndpoint, msUtils, $timeout, $document,DTOptionsBuilder,dtOptions,questionsEndpoint,groupsEndpoint,parentsEndpoint,question,Notification) {

        $scope.questions = [];
        $scope.isClicked= false;
        $scope.search = {};


        /**
         * Get All Questions
         */
        $scope.getQuestions = function () {
            $scope.questions = false;
            questionsEndpoint.get($scope.search,function (data) {
                $scope.isClicked= false;
                $scope.questions = data;
            })
        };


        /**
         * Open the new Questions dialog
         */
        $scope.openNewQuestionDialog = function () {
            $mdDialog.show({
                controller         : 'NewQuestionDialogController',
                templateUrl        : 'app/main/pages/events/views/questions/new-question-dialog/new-question-dialog.html',
                clickOutsideToClose: true,
                locals: {
                    eventID: null
                }
            }).then(function () {
                $scope.getQuestions();
            });
        };

        /**
         * Edit Question
         */
        $scope.editQuestion = function (selectedQuestion) {
            question.updateSelectedQuestion(selectedQuestion);
            $mdSidenav("question-panel").open();
        };

        /**
         * open the Confirm delete Questions dialog
         * @param selectedQuestion
         * @param ev
         */
        $scope.deleteQuestionDialog = function (selectedQuestion,ev) {
            var confirm = $mdDialog.confirm()
                .title('מחיקת שאלה')
                .textContent('האם אתה בטוח שברצונך למחוק את שאלה זו? ')
                .targetEvent(ev)
                .ok('מחק')
                .cancel('בטל');
            $mdDialog.show(confirm).then(function() {
                deleteQuestion(selectedQuestion)
            })

        };

        /**
         * Delete the Questions
         * @param selectedQuestion
         */
        var deleteQuestion = function (selectedQuestion) {
            var index = $scope.questions.indexOf(selectedQuestion);
            $scope.questions.splice(index, 1);
            questionsEndpoint.delete.post(selectedQuestion, function (data) {
                if (!data.success) {
                    Notification.info("השאלה מקושרת ל"+$rootScope.User.Event+" קיים - לא ניתן למחוק");
                    $scope.questions.push(selectedQuestion);
                }
            })
        };


        /**
         * Filter by status
         * @param item
         * @returns {boolean}
         */
        $scope.filterByStatus = function (item) {
            if ($scope.search.status==1)
                return item.Status==1;
            else if ($scope.search.status==0)
                return item.Status==0;
            else
                return true;
        };

        /**
         * Set Type
         * @param type
         * @returns {string}
         */
        $scope.setType = function(type) {
            switch (type) {
                case "1":
                case 1:
                    return "שאלה פתוחה";
                case "2":
                case 2:
                    return "אפשרויות";
                case "3":
                case 3:
                    return "קובץ";
                case "4":
                case 4:
                    return "תאריך";
            }
        };


        /**
         * Set Table option
         * @type {any}
         */
        $scope.dtOptions = DTOptionsBuilder
            .newOptions()
            .withLanguage(dtOptions.language)
            .withDOM('lfrtp')
            .withOption('responsive',true)
            .withOption('bFilter', false)
            .withDOM('lrtip');

    }]);

angular.module('app.pages.events').controller('RegistrationsController', RegistrationsController);
function RegistrationsController($scope,$rootScope,$mdSidenav,DTColumnDefBuilder,branchesEndpoint,groupsEndpoint,gradesEndpoint,areasEndpoint,$mdDialog,$location,usersEndpoint, msUtils, $timeout, $document,DTOptionsBuilder,dtOptions,receiptsEndpoint,receiptsService,Notification,eventsEndpoint,$element) {


    $scope.registrations = [];
    $scope.search = {};
    $scope.search.branches = [];
    $scope.search.groups = [];
    $scope.search.grades = [];
    $scope.groups= [];
    $scope.grades= [];
    $scope.area= [];

    $scope.getRegistrations = function () {
        $scope.registrations = false;
        $scope.isClicked = true;
        var params = {};
        params.GroupsIdes = [];
        params.BranchIdes = [];
        params.GradesIdes = [];
        params.ToDate = $scope.search.ToDate;
        params.FromDate = $scope.search.FromDate;
        params.Status = $scope.search.Status;
        params.Events = JSON.stringify(angular.copy($scope.search.Events));
        params.Limit = 10000;
        var groups = angular.copy($scope.search.groups);
        var branches = angular.copy($scope.search.branches);
        var grades = angular.copy($scope.search.grades);
        for (var i=0;i<groups.length;i++) {
            params.GroupsIdes.push(groups[i].ID)
        }
        for (var i=0;i<branches.length;i++) {
            params.BranchIdes.push(branches[i].ID)
        }
        for (var i=0;i<grades.length;i++) {
            params.GradesIdes.push(grades[i].ID)
        }
        params.BranchIdes = JSON.stringify( params.BranchIdes);
        params.GroupsIdes = JSON.stringify( params.GroupsIdes);
        params.AreaID = $scope.search.area;
        params.FreeSearch = $scope.search.freeSearchFromDB;
        eventsEndpoint.registrations.get(params, function (data) {
            $scope.isClicked = false;
            if (data)
                $scope.registrations = data;
        });
    };

    /**
     * Watch on branches
     */
    $scope.$watchCollection('search.branches.length',function () {

        var params = {};
        params.BranchIdes = [];
        for (var i=0;i<$scope.search.branches.length;i++) {
            params.BranchIdes.push($scope.search.branches[i].ID)
        }
        params.BranchIdes = JSON.stringify( params.BranchIdes);
        groupsEndpoint.get(params,function (data) {
            $scope.groups = data;
        });
    });

    $scope.clearSearchTerm = function() {
        $scope.searchTerm = '';
    };

    /**
     * Download receipt
     * @param receipt
     * @param type
     */
    $scope.downloadReceipt = function (receipt,type) {
        Notification.info("מייצר קבלה..אנא המתן");
        receiptsService.getReceiptByID(receipt,type)

    };


    /**
     * Get All Branches And Groups
     */
    $scope.getBranchesAndGroups = function () {
        var params = {};
        params.Status = 1;
        branchesEndpoint.get(params, function (data) {
            $scope.branches = data;
        });

    };

    $scope.getAreas = function () {
        var params = {};
        params.Status =1;
        areasEndpoint.get(params,function (data) {
            $scope.area = data;
        })
    };

    /**
     * Get Grades
     */
    $scope.getGrades = function () {
        var params = {};
        params.Status = 1;
        gradesEndpoint.get(params,function (data) {
            $scope.grades = data;
        })
    };

    /**
     * Branches query search
     * @param query
     * @returns {Array}
     */
    $scope.branchesQuerySearch = function (query) {
        var results = query ? $scope.branches.filter(createFilterFor(query)) : [];
        return results;
    };

    /**
     * Groups query search
     * @param query
     * @returns {*}
     */
    $scope.groupsQuerySearch = function (query) {
        var results = query ? $scope.groups.filter(createFilterFor(query)) : [];
        return results;
    };


    /**
     * Groups query search
     * @param query
     * @returns {*}
     */
    $scope.gradesQuerySearch = function (query) {
        if ($scope.grades)
            var results = query ? $scope.grades.filter(createFilterFor(query)) : [];
        return results;
    };

    /**
     * Create filter for query from auto complete
     * @param query
     * @returns {filterFn}
     */
    function createFilterFor(query) {
        var lowercaseQuery = angular.lowercase(query);
        return function filterFn(contact) {
            return (contact.Name.indexOf(lowercaseQuery) != -1);
        };
    }


    /**
     * Get Events for selected
     */
    $scope.getEvents = function () {
        var lastDay = new Date();
        lastDay.setDate(lastDay.getDate() - 1);
        var day = lastDay.getDate();
        var month = lastDay.getMonth() + 1;
        var year = lastDay.getFullYear();
        $scope.search.FromDate = day + '/' + month + '/' + year;
        $scope.search.FromDate += " 00:00";

        var today = new Date();
        day = today.getDate();
        month = today.getMonth() + 1;
        year = today.getFullYear();
        today.setDate(today.getDate() + 1);
        $scope.search.ToDate = day + '/' + month + '/' + year;
        $scope.search.ToDate += " 00:00";
        eventsEndpoint.get(null, function (data) {
            $scope.events = data;
        })
    };

    $element.find('input').on('keydown', function (ev) {
        ev.stopPropagation();
    });


    /**
     * Show full Registration
     * @param registration
     */
    $scope.showFullRegistration = function (registration) {
        $mdDialog.show({
            controller: 'FullRegistrationDialogController',
            templateUrl: 'app/main/pages/events-dialogs/full-registration-dialog/full-registration-dialog.html',
            clickOutsideToClose: true,
            locals: {'registration': registration}
        })
    };

    /**
     * Open Cancel Registration Dialog
     * @param registration
     */
    $scope.refundRegistration = function (registration) {

        $mdDialog.show({
            controller: 'RefundRegistrationDialogController',
            templateUrl: 'app/main/pages/events-dialogs/refund-registration-dialog/refund-registration-dialog.html',
            locals: {'registration': registration, external: false},
            clickOutsideToClose: true
        }).then(function () {
            $scope.getRegistrations();
        });
    };


    /**
     * Open Cancel Registration Dialog
     * @param registration
     */
    $scope.cancelRegistration = function (registration) {

        $mdDialog.show({
            controller: 'CancelRegistrationDialogController',
            templateUrl: 'app/main/pages/events-dialogs/cancel-registration-dialog/cancel-registration-dialog.html',
            locals: {'registration': registration, external: false},
            clickOutsideToClose: true
        }).then(function () {
            $scope.getRegistrations();
        });
    };


    /**
     * Set Table option
     * @type {any}
     */
    $scope.dtOptions = DTOptionsBuilder
        .newOptions()
        .withLanguage(dtOptions.language)
        .withDOM('lfrtp')
        .withOption('bFilter', false)
        .withDOM('lrtip')
        .withOption('responsive',true)
        .withOption('order', [0, 'desc']);

    $scope.dtColumnDefs = [
        DTColumnDefBuilder.newColumnDef(0).withOption('type', 'eu-date'),

    ];

}

angular.module('app.pages.events').controller('EventsController', EventsController);
function EventsController($scope, $rootScope,$location,$mdDialog,appConfig, DTOptionsBuilder,dtOptions,branchesEndpoint,gradesEndpoint,eventsEndpoint,event,DTColumnDefBuilder,$timeout) {

    $scope.externalEventsEnabled = appConfig.externalEventsEnabled;


    $scope.search = {};
    $scope.search.branches = [];
    $scope.search.grades = [];
    $scope.brand = $rootScope.brandName;

    $scope.init = function (){
        $scope.getBranches();
        $scope.getGrades();
    }

    $rootScope.$watch('$routeChangeSuccess',function (data) {
        $timeout(function () {
            if (window.location.pathname=="/products") {
                $scope.title = "מוצרים";
                $scope.title2 = "מוצר";

            }
            else {
                $scope.title = $rootScope.User.Events;
                $scope.title2 = $rootScope.User.Event;
            }
        },500)
    });

    /**
     * Get All Branches And Groups
     */
    $scope.getBranches = function () {
        var params = {};
        params.Status = 1;
        branchesEndpoint.get(params, function (data) {
            $scope.branches = data;
        });
    };

    /**
     * Get All Branches And Groups
     */
    $scope.getGrades = function () {
        var params = {};
        params.Status = 1;
        gradesEndpoint.get(params, function (data) {
            $scope.grades = data;
        });

    };

    /**
     * Get Events
     */
    $scope.getEvents = function (noFilter) {
        $scope.isClicked = true;
        var params = {};
        if (!noFilter) {
            params.gradesIdes = [];
            params.BranchIdes = [];
            for (var i = 0; i < $scope.search.grades.length; i++) {
                params.gradesIdes.push($scope.search.grade[i].ID)
            }
            for (var i = 0; i < $scope.search.branches.length; i++) {
                params.BranchIdes.push($scope.search.branches[i].ID)
            }
            params.FreeSearch = $scope.search.freeSearchFromDB;
            if (!$scope.EventType) {
                params.BranchIdes = JSON.stringify(params.BranchIdes);
                params.GradesIdes = JSON.stringify(params.gradesIdes);
            } else {
                params.BranchIdes = [];
                params.GradesIdes = [];
            }
            params.Status = $scope.search.status;
            params.EventType = $scope.search.EventType;
            params.Limit = $scope.search.Limit;
            params.DateStatus = $scope.search.dateStatus;

        }
        else {
            $scope.search = {};
            $scope.search.branches = [];
            $scope.search.groups = [];
            $scope.events = [];
        }

        params.RegistrationCount = true;
        if ($scope.title == $rootScope.User.Events) {
            params.IsProduct = 0;
        }
        else
            params.IsProduct = 1;
        eventsEndpoint.get(params, function (data) {
            $scope.isClicked = false;
            $scope.events = data;
        })

    };




    $scope.openNewEventDialog = function (product) {
        var type = 0;
        if (product=="מוצר")
            type =1;
        $mdDialog.show({
            controller: 'NewEventsDialogController',
            templateUrl: 'app/main/pages/events/views/events/new-event-dialog/new-event-dialog.html',
            clickOutsideToClose: true,
            locals : {isProduct : type}
        });
    };

    /**
     * Set Table option
     * @type {any}
     */
    $scope.dtOptions = DTOptionsBuilder
        .newOptions()
        .withLanguage(dtOptions.language)
        .withDOM('lfrtp')
        .withOption('bFilter', false)
        .withOption('responsive',true)
        .withDOM('lrtip')
        .withOption('order', [1, 'desc']);

    /**
     * Branches query search
     * @param query
     * @returns {Array}
     */
    $scope.branchesQuerySearch = function (query) {
        var results = query ?
            $scope.branches.filter(createFilterFor(query)) : [];
        return results;
    };

    /**
     * grades query search
     * @param query
     * @returns {Array}
     */
    $scope.gradesQuerySearch = function (query) {
        var results = query ?
            $scope.grades.filter(createFilterFor(query)) : [];
        return results;
    };

    /**
     * Create filter for query from auto complete
     * @param query
     * @returns {filterFn}
     */
    function createFilterFor(query) {
        var lowercaseQuery = angular.lowercase(query);
        return function filterFn(contact) {
            return (contact.Name.indexOf(lowercaseQuery) != -1);
        };
    }

    jQuery.extend(jQuery.fn.dataTableExt.oSort, {
        "eu-date-pre": function (a) {
            if (a == null || a == '') {
                return 0;
            }
            var date = a.split('/');
            return Date.parse(date[1] + '/' + date[0] + '/' + date[2])
        }
    });


    $scope.dtColumnDefs = [
        DTColumnDefBuilder.newColumnDef(1).withOption('type', 'eu-date'),
        DTColumnDefBuilder.newColumnDef(2).withOption('type', 'eu-date'),
        DTColumnDefBuilder.newColumnDef(3).withOption('type', 'eu-date')

    ];


}

angular.module('app.pages.events').controller('MarketingController', MarketingController);

function MarketingController(filesEndpoint, DTOptionsBuilder, dtOptions,branchesEndpoint,areasEndpoint,gradesEndpoint, $mdDialog,marketingEndpoint) {

    var vm =this;
    vm.getBranches =getBranches;
    vm.getAreas = getAreas;
    vm.getGrades = getGrades;
    vm.branchesQuerySearch =branchesQuerySearch;
    vm.gradesQuerySearch =gradesQuerySearch;
    vm.openSendSMS= openSendSMS;
    vm.openSendEmail =openSendEmail;
    vm.getEvents = getEvents;
    vm.getLeads =getLeads;
    vm.setAll = setAll;
    vm.search = {};
    vm.search.branches = [];
    vm.search.grades = [];
    vm.grades= [];
    vm.area= [];
    vm.leads = [];


    /**
     * Get All Branches And Groups
     */
    function getBranches() {
        var params = {};
        params.Status =1;
        branchesEndpoint.get(params,function (data) {
            vm.branches = data;
        });

    }

    function getAreas(){
        var params = {};
        params.Status =1;
        areasEndpoint.get(params,function(data){
            vm.area = data;
        })
    }

    /**
     * Get Grades
     */
    function getGrades() {
        var params = {};
        params.Status = 1;
        gradesEndpoint.get(params,function (data) {
            vm.grades = data;
        })
    }


    /**
     * Get Events
     */
    function getEvents() {
        marketingEndpoint.leads.events.get(function (data) {
            vm.events= data;
        })
    }

    function getLeads(reset) {
        if (reset){
            vm.search = {};
            vm.search.branches = [];
            vm.search.grades = [];
            return;
        }
        vm.leads =false;
        marketingEndpoint.leads.get(vm.search,function (data) {
            vm.leads = data;
        })
    }

    /**
     * Branches query search
     * @param query
     * @returns {Array}
     */
     function branchesQuerySearch(query) {
        var results = query ? vm.branches.filter(createFilterFor(query)) : [];
        return results;
    }



    /**
     * Groups query search
     * @param query
     * @returns {*}
     */
    function gradesQuerySearch(query) {
        if (vm.grades)
            var results = query ? vm.grades.filter(createFilterFor(query)) : [];
        return results;
    }


    /**
     * Create filter for query from auto complete
     * @param query
     * @returns {filterFn}
     */
    function createFilterFor(query) {
        var lowercaseQuery = angular.lowercase(query);
        return function filterFn(contact) {
            return (contact.Name.indexOf(lowercaseQuery) != -1);
        };
    }

    /**
     * Open send sms dialog
     */
      function openSendSMS() {
        $mdDialog.show({
            controller         : 'SMSDialogController',
            templateUrl        : 'app/main/pages/sms-email-dialogs/sms-dialog/sms-dialog.html',
            locals : {'students' : vm.leads,'external': false ,"type": 1 },
            clickOutsideToClose: false

        });
    };

    /**
     * open send email
     */
     function openSendEmail() {
        $mdDialog.show({
            controller         : 'EmailDialogController',
            templateUrl        : 'app/main/pages/sms-email-dialogs/email-dialog/email-dialog.html',
            locals : {'students' : vm.leads,'external': false,"type": 1  },
            clickOutsideToClose: false

        });
    }

    /**
     * Select All
     * @param selectAll
     */
      function setAll(selectAll) {
        if (selectAll) {
            for (var i=0;i<vm.leads.length;i++) {
                vm.leads[i].Selected = true;
            }
        }
        else
            for (var i=0;i<vm.leads.length;i++) {
                vm.leads[i].Selected = false;
            }
    }



    /**
     * Set Table option
     * @type {any}
     */
    vm.dtOptions = DTOptionsBuilder
        .newOptions()
        .withLanguage(dtOptions.language)
        .withDOM('lfrtp')
        .withOption('responsive',true)
        .withOption('bFilter', false)
        .withDOM('lrtip');

}



angular.module('app.pages.events').controller('AttendanceController', AttendanceController);

function AttendanceController(filesEndpoint, DTOptionsBuilder, dtOptions,branchesEndpoint,gradesEndpoint, $mdDialog,eventsEndpoint,Notification,systemSettingsEndpoint,studentsEndpoint) {

    var vm =this;
    vm.getBranches =getBranches;
    vm.getGrades = getGrades;
    vm.branchesQuerySearch =branchesQuerySearch;
    vm.gradesQuerySearch =gradesQuerySearch;
    vm.getEvents = getEvents;
    vm.getStudents = getStudents;
    vm.updateAttendance = updateAttendance;
    vm.getStatusValues = getStatusValues;
    vm.search = {};
    vm.search.branches = [];
    vm.search.grades = [];
    vm.grades= [];
    vm.area= [];
    vm.students= [];
    vm.searchTerm = undefined;

    function getStatusValues() {
        systemSettingsEndpoint.names.get(function (data) {
            vm.statusArray = data.AttendenceStatus=="" ?  [] : splitArray(data.AttendenceStatus);
        })
    }

    function splitArray(str){
        var newStr = str.replace(/[[]|[\]]/g,"").replace(/"/g,"");
        var arr = newStr.split(",");
        return arr;
    }



    function getStudents(reset) {
        if (reset) {
            vm.search = {};
            vm.search.branches = [];
            vm.search.grades = [];
            return;
        }
        var params = {};
        var branches = angular.copy(vm.search.branches);
        var grades = angular.copy(vm.search.grades);
        params.BranchIdes = [];
        params.GradesIdes = [];
        for (var i=0;i<branches.length;i++) {
            params.BranchIdes.push(branches[i].ID)
        }
        for (var i=0;i<grades.length;i++) {
            params.GradesIdes.push(grades[i].ID)
        }
        params.BranchIdes = JSON.stringify( params.BranchIdes);
        params.GradesIdes = JSON.stringify( params.GradesIdes);
        params.FreeSearch = vm.search.freeSearchFromDB;
        params.Attendance = vm.search.Attendance;

        vm.students = false;
        var event = {};
        event.ID = vm.search.eventID;
        params.Status =1;
        eventsEndpoint.subscribers.get(params,event, function (data) {
            vm.students = data;
        });
    }

    /**
     * Get All Branches And Groups
     */
    function getBranches() {
        var params = {};
        params.Status =1;
        branchesEndpoint.get(params,function (data) {
            vm.branches = data;
        });

    }

    /**
     * Get Grades
     */
    function getGrades() {
        var params = {};
        params.Status = 1;
        gradesEndpoint.get(params,function (data) {
            vm.grades = data;
        })
    }


    /**
     * Get Events
     */
    function getEvents() {
        if (vm.searchTerm != undefined && vm.searchTerm.length > 0){
            var params = {
                FreeSearch: vm.searchTerm,
                Status: 1
            };

            eventsEndpoint.get(params, function (data) {
                vm.events= data;
            });
        }
    }

    function updateAttendance(student) {
        studentsEndpoint.registrations.update.post(student,function (data) {
            if (data.success)
                Notification.success("נוכחות עודכנה בהצלחה")
        })
    }



    /**
     * Branches query search
     * @param query
     * @returns {Array}
     */
    function branchesQuerySearch(query) {
        var results = query ? vm.branches.filter(createFilterFor(query)) : [];
        return results;
    }



    /**
     * Groups query search
     * @param query
     * @returns {*}
     */
    function gradesQuerySearch(query) {
        if (vm.grades)
            var results = query ? vm.grades.filter(createFilterFor(query)) : [];
        return results;
    }


    /**
     * Create filter for query from auto complete
     * @param query
     * @returns {filterFn}
     */
    function createFilterFor(query) {
        var lowercaseQuery = angular.lowercase(query);
        return function filterFn(contact) {
            return (contact.Name.indexOf(lowercaseQuery) != -1);
        };
    }




    /**
     * Set Table option
     * @type {any}
     */
    vm.dtOptions = DTOptionsBuilder
        .newOptions()
        .withLanguage(dtOptions.language)
        .withDOM('lfrtp')
        .withOption('bFilter', false)
        .withOption('responsive',true)
        .withDOM('lrtip');

}



angular.module('app.pages.users').controller('ManageGroupsController', ManageGroupsController);
function ManageGroupsController($scope,$rootScope,$mdSidenav,$mdDialog,$location,usersEndpoint, msUtils, $timeout, $document,DTOptionsBuilder,dtOptions,groupsEndpoint,regionsEndpoint,branchesEndpoint,group,areasEndpoint) {


    $scope.search = {};
    $scope.search.branches = [];

    /**
     * Set Table option
     * @type {any}
     */
    $scope.dtOptions = DTOptionsBuilder
        .newOptions()
        .withLanguage(dtOptions.language)
        .withDOM('lfrtp')
        .withOption('bFilter', false)
        .withOption('responsive',true)
        .withDOM('lrtip');


    /**
     * Get All Branches And Groups
     */
    $scope.getGroups = function (reset) {
        if (reset) {
            $scope.search = {};
            $scope.search.branches = [];
            $scope.search.AreaID = undefined;
            $scope.getBranches();
            return;
        }
        $scope.isClicked = true;
        var params = {};
        params.BranchIdes = $scope.search.Branches;
        params.AreaID = $scope.search.AreaID;
        params.FreeSearch = $scope.search.freeSearchFromDB;
        params.Status = $scope.search.status;
        params.Type = $scope.search.educator;
        $scope.groups = null;
        groupsEndpoint.get(params, function (data) {
            $scope.isClicked = false;
            $scope.groups = data;
        })
    };


    /**
     * Get All Branches
     */
    $scope.getBranches = function () {
        $scope.branches = [];
        var params = {
            Status: 1
        };
        if($scope.search.AreaID)
            params.area = $scope.search.AreaID;
        branchesEndpoint.get(params, function (data) {
            $scope.branches = data;
        })

    };

    $scope.getAreas = function () {
        var params = {};
        params.Status =1;
        areasEndpoint.get(params,function (data) {
            $scope.areas = data;
        });
    };

    /**
     * Open side nev to update branch
     * @param selectedGroup
     */
    $scope.editGroup = function (selectedGroup) {
        group.updateSelectedGroup(selectedGroup);
        $mdSidenav("groups-panel").open();
    };

    /**
     * Add new branch dialog
     */
    $scope.addNewGroupDialog = function () {
        $mdDialog.show({
            controller: 'NewGroupDialogController',
            templateUrl: 'app/main/pages/branches/views/groups/new-group-dialog/new-group-dialog.html',
            clickOutsideToClose: false
        }).then(function () {
            $scope.getGroups();
        });
    };


    /**
     * Branches query search
     * @param query
     * @returns {Array}
     */
    $scope.branchesQuerySearch = function (query) {
        var results = query ?
            $scope.branches.filter(createFilterFor(query)) : [];
        return results;
    };

    /**
     * Create filter for query from auto complete
     * @param query
     * @returns {filterFn}
     */
    function createFilterFor(query) {
        var lowercaseQuery = angular.lowercase(query);
        return function filterFn(contact) {
            return (contact.Name.indexOf(lowercaseQuery) != -1);
        };
    }

    /**
     * Set the selecte item
     * @param searchObject
     */
    $scope.selectedItemChange = function (searchObject) {
        $scope.search.branch = searchObject;
    }

}




angular.module('app.pages.users').controller('ManageGradesController', ['$scope','$rootScope','$mdSidenav','$mdDialog','$location','usersEndpoint', 'msUtils', '$timeout','$document', 'DTOptionsBuilder','dtOptions','gradesEndpoint','grade'
    ,function($scope,$rootScope,$mdSidenav,$mdDialog,$location,usersEndpoint, msUtils, $timeout, $document,DTOptionsBuilder,dtOptions,gradesEndpoint,grade) {

        $scope.search = {};
        $scope.grades= [];

        /**
         * Set Table option
         * @type {any}
         */
        $scope.dtOptions = DTOptionsBuilder
            .newOptions()
            .withLanguage(dtOptions.language)
            .withOption('responsive',true)
            .withDOM('lfrtp')
            .withOption('bFilter', false)
            .withDOM('lrtip');


        /**
         * Get All Grades
         */
        $scope.getGrades = function () {
            $scope.grades= false;
            $scope.isClicked = true;
            gradesEndpoint.get($scope.search,function (data) {
                $scope.isClicked = false;
                $scope.grades = data;
            });
        };

        /**
         * Open side nev to update Grade
         * @param selectedGrade
         */
        $scope.editGrade = function (selectedGrade) {
            grade.updateSelectedGrade(selectedGrade);
            $mdSidenav("grades-panel").open();
        };

        /**
         * Add new Grade dialog
         */
        $scope.addNewGradesDialog = function () {
            $mdDialog.show({
                controller         : 'NewGradesDialogController',
                templateUrl        : 'app/main/pages/branches/views/grades/new-grades-dialog/new-grades-dialog.html',
                clickOutsideToClose: false
            }).then(function () {
                $scope.getGrades();
            });
        };


    }]);




angular.module('app.pages.users').controller('ManageAreasController', ManageAreasController);
function ManageAreasController(areasEndpoint,$mdSidenav,$mdDialog,DTOptionsBuilder,dtOptions,area) {


    var vm = this;
    vm.getAreas = getAreas;
    vm.editArea = editArea;
    vm.addNewAreaDialog = addNewAreaDialog;
    vm.search = {
        freeSearchFromDB: '',
        Status: 1
    }

    /**
     * Set Table option
     * @type {any}
     */
    vm.dtOptions = DTOptionsBuilder
        .newOptions()
        .withLanguage(dtOptions.language)
        .withDOM('lfrtp')
        .withOption('bFilter', false)
        .withOption('responsive',true)
        .withDOM('lrtip');

    /**
     * Get Areas
     */
    function getAreas(reset) {
        if(reset){
            vm.search = {
                freeSearchFromDB: '',
                Status: 1
            }
        }
        vm.areas = false;
        areasEndpoint.get(vm.search,function (data) {
            vm.areas = data;
        })
    }

    /**
     * Open side nev to update Grade
     * @param selectedArea
     */
    function editArea(selectedArea) {
        area.updateSelectedArea(selectedArea);
        $mdSidenav("area-panel").open();
    }

    /**
     * Add new area dialog
     */
    function addNewAreaDialog() {
        $mdDialog.show({
            controller: 'NewAreaDialogController',
            templateUrl: 'app/main/pages/branches/views/areas/new-area-dialog/new-area-dialog.html',
            clickOutsideToClose: true
        }).then(function () {
            getAreas();
        });
    }


}




angular.module('app.pages.users').controller('BranchesController', BranchesController);
    function BranchesController($scope,$mdSidenav,$mdDialog,DTOptionsBuilder,dtOptions,branchesEndpoint,branch,areasEndpoint,systemSettingsEndpoint) {


    $scope.branches = [];
    /**
     * Get All Areas
     */
    $scope.getAreas = function () {
        var params = {};
        params.Status =1;
        areasEndpoint.get(params,function (data) {
            $scope.areas = data;
        });
    };

    $scope.getTags = function (){
        systemSettingsEndpoint.names.get(function (data) {
            try {
                $scope.tags = JSON.parse(data.BranchesTags);
                if(!Array.isArray($scope.tags))
                    $scope.tags = [];
            } catch (e) {
                $scope.tags = [];
            }
        })
    }

    /**
     * Get All Branches
     */
    $scope.getBranches = function (reset) {
        if (reset) {
            $scope.search = {};
            return;
        }
        $scope.branches = false;
        branchesEndpoint.get($scope.search, function (data) {
            $scope.branches = data;
        })
    };

    /**
     * Open side nev to update branch
     * @param selectedBranch
     */
    $scope.editBranch = function (selectedBranch) {
        branch.updateSelectedBranch(selectedBranch);
        $mdSidenav("branch-panel").open();
    };

    /**
     * Add new branch dialog
     */
    $scope.addNewBranchDialog = function () {
        $mdDialog.show({
            controller: 'NewBranchDialogController',
            templateUrl: 'app/main/pages/branches/views/branches/new-branch-dialog/new-branch-dialog.html',
            clickOutsideToClose: false
        }).then(function () {
            $scope.getBranches();
        });
    };


    /**
     * Set Table option
     * @type {any}
     */
    $scope.dtOptions = DTOptionsBuilder
        .newOptions()
        .withLanguage(dtOptions.language)
        .withDOM('lfrtp')
        .withOption('bFilter', false)
        .withOption('responsive',true)
        .withDOM('lrtip');

}

(function ()
{
    'use strict';

    angular
        .module('app.pages.manage-admins', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        $stateProvider.state('app.pages_manage-admins', {
            url    : '/manage-admins',
            views  : {
                'content@app': {
                    templateUrl: 'app/main/pages/admin/admin-management/manage-admins.html',
                    controller: 'ManageAdminsController'
                }
            }, resolve  : {
                "check": function (ValidToken)
                {
                    ValidToken.validUserToken();
                    localStorage.setItem("path",'/manage-admins');

                }
            }
        });

    }

})();
angular.module('app.pages.manage-admins').controller('NewAdminDialogController', NewAdminDialogController);
function NewAdminDialogController ($scope, $mdDialog,adminEndpoint,Notification) {

    /**
     * Save new admin
     */
    $scope.saveNewAdmin = function () {
        $scope.isClicked = true;
        adminEndpoint.post($scope.newAdmin, function (data) {
            if (data.ID) {
                Notification.success("הזמנה נשלחה בהצלחה");
                $mdDialog.hide();
            }

            else
                Notification.error("דואר אלקטרוני קיים במערכת");

        })
    };

    /**
     * Close the dialog
     */
    $scope.closeDialog = function () {
        $mdDialog.cancel();
    };

}

(function ()
{
    'use strict';

    angular
        .module('app.admin-profile-panel',[])

})();

angular.module('app.admin-profile-panel').controller('AdminProfilePanelController',AdminProfilePanelController);
function AdminProfilePanelController($scope,$rootScope,adminProfile) {
    /**
     * Set the admin
     */
    $scope.$on('adminProfile:updated', function () {
        $scope.adminProfile = adminProfile.admin;
    });

    /**
     * Look For changes in the Admin object
     */
    $scope.$watch('adminProfile', function (newValue, oldValue) {
        $rootScope.editDataHandler(newValue, oldValue, 'admin-profile-panel')
    }, true);

}
(function ()
{
    'use strict';

    angular
        .module('app.pages.accountancy', []).config(config).run(run);

    function run($rootScope,msNavigationService,appConfig) {
        $rootScope.$watch('User',function () {

            /**
             * Set the pages by the admin level
             */
            if ($rootScope.AdminLevel) {
                switch ($rootScope.AdminLevel) {
                    case 3:
                        msNavigationService.saveItem('pages.accountancy', {
                            title : 'תשלומים',
                            icon  : 'icon-credit-card-multiple',
                            weight: 5
                        });

                        msNavigationService.saveItem('pages.accountancy.accountancy_receipts', {
                            title : 'קבלות',
                            icon  : 'icon-file-document',
                            state : 'app.pages_accountancy_receipts'

                        });
                        msNavigationService.saveItem('pages.accountancy.accountancy_export-movements', {
                            title : 'יצוא תנועות',
                            icon  : 'icon-file-document-box',
                            state : 'app.pages_accountancy_export-movements'

                        });
                        //if(appConfig.paymentyCompany == 2){
                            msNavigationService.saveItem('pages.accountancy.accountancy_payments-match', {
                                title : 'התאמות חשבוניות',
                                icon  : 'icon-credit-card-multiple',
                                state : 'app.pages_accountancy_payments-match'
                            });
                        //}

                        break;
                }
            }
        });

    }
    /** @ngInject */
    function config($stateProvider)
    {
        // State
        $stateProvider
            .state('app.pages.accountancy', {
                abstract: true,
                url     : '/accountancy'
            })
            .state('app.pages_accountancy_receipts', {
                url      : '/receipts',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/pages/accountancy/views/receipts/receipts.html',
                        controller : 'ReceiptsController as vm'
                    }
                },
                resolve  : {
                    DashboardData: function (ValidToken)
                    {
                        ValidToken.validUserToken();
                        localStorage.setItem("path",'/receipts');
                    }
                }
            })
            .state('app.pages_accountancy_export-movements', {
            url      : '/export-movements',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/pages/accountancy/views/export-movements/export-movements.html',
                    controller : 'ExportMovementsController as vm'
                }
            },
            resolve  : {
                DashboardData: function (ValidToken)
                {
                    ValidToken.validUserToken();
                    localStorage.setItem("path",'/export-movements');
                }
            }
        })
            .state('app.pages_accountancy_payments-match', {
            url      : '/payments-match',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/pages/accountancy/views/payments-match/payments-match.html',
                    controller : 'PaymentsMatchController as vm'
                }
            },
            resolve  : {
                DashboardData: function (ValidToken)
                {
                    ValidToken.validUserToken();
                    localStorage.setItem("path",'/payments-match');
                }
            }
        })
        ;





    }
})();


angular.module('app.pages.accountancy').controller('ReceiptsController', ReceiptsController);

function ReceiptsController(DTOptionsBuilder,appConfig,dtOptions,receiptsEndpoint,receiptsService,Notification,DTColumnDefBuilder) {


    var vm = this;
    vm.receipts = [];
    vm.search = {};
    vm.getReceipts=  getReceipts;
    vm.downloadReceipt= downloadReceipt;
    vm.externalEventsEnabled = appConfig.externalEventsEnabled;


    /**
     * Get All Receipts
     * @param reset
     */
    function getReceipts(reset) {
        if (reset)
            vm.search = {};
        vm.isClicked = true;
        vm.receipts = false;
        receiptsEndpoint.get(vm.search, function (data) {
            vm.receipts = data;
            vm.isClicked = false;
        })
    }

    /**
     * Download receipt
     * @param receipt
     */
     function downloadReceipt(receipt) {
        Notification.info("מייצר קבלה..אנא המתן");
        if (receipt.External==1){
            receiptsService.getReceiptByID(receipt.ID,receipt.Type,false,false,true);
            }
        else  if (receipt.EventType==1){
            receiptsService.getReceiptByID(receipt.ID,receipt.Type,false,false,true);
            }
        else
            receiptsService.getReceiptByID(receipt.ID,receipt.Type);
    }


    /**
     * Set Table option
     * @type {any}
     */
    vm.dtOptions = DTOptionsBuilder
        .newOptions()
        .withLanguage(dtOptions.language)
        .withDOM('lfrtp')
        .withOption('bFilter', false)
        .withDOM('lrtip')
        .withOption('responsive',true)
        .withOption('order', [0, 'desc']);

    vm.dtColumnDefs = [
        DTColumnDefBuilder.newColumnDef(0).withOption('type', 'eu-date'),

    ];


}


angular.module('app.pages.accountancy').controller('PaymentsMatchController', PaymentsMatchController);
function PaymentsMatchController(DTOptionsBuilder,dtOptions,paymentsEndpoint,Notification,receiptsEndpoint,$mdDialog) {

    var vm = this;
    vm.payments = [];
    vm.getPayments =getPayments;
    vm.createPayment =createPayment;
    vm.updateMatchDate =updateMatchDate;
    vm.openPaymentMatchDialog =openPaymentMatchDialog;
    vm.getPaymentsByMonth =getPaymentsByMonth;


    /**
     * Get Payments
     */
    function getPayments() {
        vm.payments = false;
        vm.search.Type = 2;
        paymentsEndpoint.match.get(vm.search,function (data) {
            vm.payments = data;
        })
    }

    /**
     * Create Payment
     * @param payment
     */
    function createPayment(payment) {
        if (!payment.MatchDate || payment.ReceiptID){
            Notification.error("חובה להזין תאריך להתאמה");
            return;
        }
        paymentsEndpoint.fix.post(payment,function (data) {
            if (data.success) {
                Notification.success("חשבונית נוצרה בהצלחה");
                payment.Disable = true;
                payment.ReceiptMatch = true;
            }
            else
                Notification.error("נכשל ביצירת חשבונית");

        })
    }

    /**
     * Update Match Date
     */
    function updateMatchDate(payment) {
        if (!payment.ReceiptMatch || !payment.TransactionMatch)
            return;
        var params = {};
        if (payment.Type==1)
            params['ReceiptID'] = payment.ReceiptID;
        else
            params['ReceiptID'] = payment.ID;
        params['MatchDate'] = payment.MatchDate;
        params['PaymentType'] = payment.Type;
        receiptsEndpoint.matchDate.update.post(params,function (data) {
            if (data.success)
                Notification.success("קבלה עודכנה בהצלחה");
            else
                Notification.error("נכשל בעדכון קבלה");
        })

    }

    function openPaymentMatchDialog(payment) {
        $mdDialog.show({
            controller: 'PaymentMatchController as vm',
            templateUrl: 'app/main/pages/accountancy/views/payments-match/payment-match-dialog/payment-match-dialog.html',
            clickOutsideToClose: false,
            locals : {dealID : payment.Type==1 ?payment.DealID : payment.RegistrationID}
        });
    }

    /**
     * Get Payments Month
     */
    function getPaymentsByMonth() {
        vm.paymentsByMonth = false;
        paymentsEndpoint.match.month.get(function (data) {
            vm.paymentsByMonth = data;
        })
    }



    /**
     * Set Table option
     * @type {any}
     */
    vm.dtOptions = DTOptionsBuilder
        .newOptions()
        .withLanguage(dtOptions.language)
        .withDOM('lfrtp')
        .withOption('bFilter', false)
        .withDOM('lrtip')
        .withOption('order', [0, 'desc']);

}

angular.module('app.pages.accountancy').controller('ExportMovementsController', ExportMovementsController)
function ExportMovementsController(reportsEndpoint) {

    var vm = this;

    vm.createReport = createReport;

    /**
     * Create Report
     */
    function createReport() {
        vm.load = true;
        let params = angular.copy(vm.search);
        params.Fields = JSON.stringify(params.Fields);
        reportsEndpoint.movements.get(params, function () {
            vm.load = false;
        })
    }


}
(function ()
{
    'use strict';

    angular
        .module('app.ui.page-layouts.simple.tabbed', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        $stateProvider.state('app.ui_page-layouts_simple_tabbed', {
            url  : '/ui/page-layouts/simple/tabbed',
            views: {
                'content@app': {
                    templateUrl: 'app/main/ui/page-layouts/simple/tabbed/tabbed.html',
                    controller : 'SimpleTabbedController as vm'
                }
            }
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.ui.page-layouts.simple.tabbed')
        .controller('SimpleTabbedController', SimpleTabbedController);

    /** @ngInject */
    function SimpleTabbedController()
    {
        // Data

        // Methods

        //////////
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.ui.theme-colors', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        $stateProvider.state('app.ui_theme-colors', {
            url      : '/ui/theme-colors',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/ui/theme-colors/theme-colors.html',
                    controller : 'ThemeColorsController as vm'
                }
            },
            bodyClass: 'theme-colors'
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.ui.theme-colors')
        .controller('CustomThemeDialogController', CustomThemeDialogController);

    /** @ngInject */
    function CustomThemeDialogController(marvilixTheming, $mdDialog, marvilixGenerator, $cookies, $window)
    {
        // Data
        var vm = this;
        vm.palettes = marvilixTheming.getRegisteredPalettes();
        vm.themes = marvilixTheming.getRegisteredThemes();

        // Delete Unnecessary hue value
        delete vm.palettes.grey['1000'];

        // Methods
        vm.rgba = marvilixGenerator.rgba;
        vm.setTheme = setTheme;
        vm.closeDialog = closeDialog;

        //////////

        // If custom theme exist keep using it otherwise set default as a custom
        if ( !vm.themes.custom )
        {
            vm.theme = angular.copy(vm.themes['default'].colors);
        }
        else
        {
            vm.theme = vm.themes.custom.colors;
        }

        /**
         * Put custom theme into the cookies
         * and reload for generate styles
         */
        function setTheme()
        {
            $cookies.putObject('customTheme', vm.theme);
            $cookies.put('selectedTheme', 'custom');
            $window.location.reload();
        }

        /**
         * Close dialog
         */
        function closeDialog()
        {
            $mdDialog.hide();
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.ui.page-layouts.simple.right-sidenav-iii', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        $stateProvider.state('app.ui_page-layouts_simple_right-sidenav-iii', {
            url  : '/ui/page-layouts/simple/right-sidenav-iii',
            views: {
                'content@app': {
                    templateUrl: 'app/main/ui/page-layouts/simple/right-sidenav-iii/right-sidenav-iii.html',
                    controller : 'SimpleRightSidenavIIIController as vm'
                }
            }
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.ui.page-layouts.simple.right-sidenav-iii')
        .controller('SimpleRightSidenavIIIController', SimpleRightSidenavIIIController);

    /** @ngInject */
    function SimpleRightSidenavIIIController($mdSidenav)
    {

        var vm = this;

        // Data

        // Methods
        vm.toggleSidenav = toggleSidenav;

        //////////

        /**
         * Toggle sidenav
         *
         * @param sidenavId
         */
        function toggleSidenav(sidenavId)
        {
            $mdSidenav(sidenavId).toggle();
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.ui.page-layouts.simple.right-sidenav-ii', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        $stateProvider.state('app.ui_page-layouts_simple_right-sidenav-ii', {
            url  : '/ui/page-layouts/simple/right-sidenav-ii',
            views: {
                'content@app': {
                    templateUrl: 'app/main/ui/page-layouts/simple/right-sidenav-ii/right-sidenav-ii.html',
                    controller : 'SimpleRightSidenavIIController as vm'
                }
            }
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.ui.page-layouts.simple.right-sidenav-ii')
        .controller('SimpleRightSidenavIIController', SimpleRightSidenavIIController);

    /** @ngInject */
    function SimpleRightSidenavIIController($mdSidenav)
    {
        var vm = this;

        // Data

        // Methods
        vm.toggleSidenav = toggleSidenav;

        //////////

        /**
         * Toggle sidenav
         *
         * @param sidenavId
         */
        function toggleSidenav(sidenavId)
        {
            $mdSidenav(sidenavId).toggle();
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.ui.page-layouts.simple.right-sidenav', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        $stateProvider.state('app.ui_page-layouts_simple_right-sidenav', {
            url  : '/ui/page-layouts/simple/right-sidenav',
            views: {
                'content@app': {
                    templateUrl: 'app/main/ui/page-layouts/simple/right-sidenav/right-sidenav.html',
                    controller : 'SimpleRightSidenavController as vm'
                }
            }
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.ui.page-layouts.simple.right-sidenav')
        .controller('SimpleRightSidenavController', SimpleRightSidenavController);

    /** @ngInject */
    function SimpleRightSidenavController($mdSidenav)
    {
        var vm = this;

        // Data

        // Methods
        vm.toggleSidenav = toggleSidenav;

        //////////

        /**
         * Toggle sidenav
         *
         * @param sidenavId
         */
        function toggleSidenav(sidenavId)
        {
            $mdSidenav(sidenavId).toggle();
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.ui.page-layouts.simple.left-sidenav-iii', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        $stateProvider.state('app.ui_page-layouts_simple_left-sidenav-iii', {
            url  : '/ui/page-layouts/simple/left-sidenav-iii',
            views: {
                'content@app': {
                    templateUrl: 'app/main/ui/page-layouts/simple/left-sidenav-iii/left-sidenav-iii.html',
                    controller : 'SimpleLeftSidenavIIIController as vm'
                }
            }
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.ui.page-layouts.simple.left-sidenav-iii')
        .controller('SimpleLeftSidenavIIIController', SimpleLeftSidenavIIIController);

    /** @ngInject */
    function SimpleLeftSidenavIIIController($mdSidenav)
    {

        var vm = this;

        // Data

        // Methods
        vm.toggleSidenav = toggleSidenav;

        //////////

        /**
         * Toggle sidenav
         *
         * @param sidenavId
         */
        function toggleSidenav(sidenavId)
        {
            $mdSidenav(sidenavId).toggle();
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.ui.page-layouts.simple.left-sidenav-ii', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        $stateProvider.state('app.ui_page-layouts_simple_left-sidenav-ii', {
            url  : '/ui/page-layouts/simple/left-sidenav-ii',
            views: {
                'content@app': {
                    templateUrl: 'app/main/ui/page-layouts/simple/left-sidenav-ii/left-sidenav-ii.html',
                    controller : 'SimpleLeftSidenavIIController as vm'
                }
            }
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.ui.page-layouts.simple.left-sidenav-ii')
        .controller('SimpleLeftSidenavIIController', SimpleLeftSidenavIIController);

    /** @ngInject */
    function SimpleLeftSidenavIIController($mdSidenav)
    {
        var vm = this;

        // Data

        // Methods
        vm.toggleSidenav = toggleSidenav;

        //////////

        /**
         * Toggle sidenav
         *
         * @param sidenavId
         */
        function toggleSidenav(sidenavId)
        {
            $mdSidenav(sidenavId).toggle();
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.ui.page-layouts.simple.left-sidenav', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        $stateProvider.state('app.ui_page-layouts_simple_left-sidenav', {
            url  : '/ui/page-layouts/simple/left-sidenav',
            views: {
                'content@app': {
                    templateUrl: 'app/main/ui/page-layouts/simple/left-sidenav/left-sidenav.html',
                    controller : 'SimpleLeftSidenavController as vm'
                }
            }
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.ui.page-layouts.simple.left-sidenav')
        .controller('SimpleLeftSidenavController', SimpleLeftSidenavController);

    /** @ngInject */
    function SimpleLeftSidenavController($mdSidenav)
    {
        var vm = this;

        // Data

        // Methods
        vm.toggleSidenav = toggleSidenav;

        //////////

        /**
         * Toggle sidenav
         *
         * @param sidenavId
         */
        function toggleSidenav(sidenavId)
        {
            $mdSidenav(sidenavId).toggle();
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.ui.page-layouts.simple.fullwidth', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        $stateProvider.state('app.ui_page-layouts_simple_fullwidth', {
            url  : '/ui/page-layouts/simple/fullwidth',
            views: {
                'content@app': {
                    templateUrl: 'app/main/ui/page-layouts/simple/fullwidth/fullwidth.html',
                    controller : 'SimpleFullwidthController as vm'
                }
            }
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.ui.page-layouts.simple.fullwidth')
        .controller('SimpleFullwidthController', SimpleFullwidthController);

    /** @ngInject */
    function SimpleFullwidthController()
    {
        // Data

        // Methods

        //////////
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.ui.page-layouts.carded.right-sidenav-ii', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        $stateProvider.state('app.ui_page-layouts_carded_right-sidenav-ii', {
            url  : '/ui/page-layouts/carded/right-sidenav-ii',
            views: {
                'content@app': {
                    templateUrl: 'app/main/ui/page-layouts/carded/right-sidenav-ii/right-sidenav-ii.html',
                    controller : 'CardedRightSidenavIIController as vm'
                }
            }
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.ui.page-layouts.carded.right-sidenav-ii')
        .controller('CardedRightSidenavIIController', CardedRightSidenavIIController);

    /** @ngInject */
    function CardedRightSidenavIIController($mdSidenav)
    {
        var vm = this;

        // Data

        // Methods
        vm.toggleSidenav = toggleSidenav;

        //////////

        /**
         * Toggle sidenav
         *
         * @param sidenavId
         */
        function toggleSidenav(sidenavId)
        {
            $mdSidenav(sidenavId).toggle();
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.ui.page-layouts.carded.left-sidenav-ii', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        $stateProvider.state('app.ui_page-layouts_carded_left-sidenav-ii', {
            url  : '/ui/page-layouts/carded/left-sidenav-ii',
            views: {
                'content@app': {
                    templateUrl: 'app/main/ui/page-layouts/carded/left-sidenav-ii/left-sidenav-ii.html',
                    controller : 'CardedLeftSidenavIIController as vm'
                }
            }
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.ui.page-layouts.carded.left-sidenav-ii')
        .controller('CardedLeftSidenavIIController', CardedLeftSidenavIIController);

    /** @ngInject */
    function CardedLeftSidenavIIController($mdSidenav)
    {
        var vm = this;

        // Data

        // Methods
        vm.toggleSidenav = toggleSidenav;

        //////////

        /**
         * Toggle sidenav
         *
         * @param sidenavId
         */
        function toggleSidenav(sidenavId)
        {
            $mdSidenav(sidenavId).toggle();
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.ui.page-layouts.carded.right-sidenav', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        $stateProvider.state('app.ui_page-layouts_carded_right-sidenav', {
            url  : '/ui/page-layouts/carded/right-sidenav',
            views: {
                'content@app': {
                    templateUrl: 'app/main/ui/page-layouts/carded/right-sidenav/right-sidenav.html',
                    controller : 'CardedRightSidenavController as vm'
                }
            }
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.ui.page-layouts.carded.right-sidenav')
        .controller('CardedRightSidenavController', CardedRightSidenavController);

    /** @ngInject */
    function CardedRightSidenavController($mdSidenav)
    {
        var vm = this;

        // Data

        // Methods
        vm.toggleSidenav = toggleSidenav;

        //////////

        /**
         * Toggle sidenav
         *
         * @param sidenavId
         */
        function toggleSidenav(sidenavId)
        {
            $mdSidenav(sidenavId).toggle();
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.ui.page-layouts.carded.fullwidth-ii', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        $stateProvider.state('app.ui_page-layouts_carded_fullwidth-ii', {
            url  : '/ui/page-layouts/carded/fullwidth-ii',
            views: {
                'content@app': {
                    templateUrl: 'app/main/ui/page-layouts/carded/fullwidth-ii/fullwidth-ii.html',
                    controller : 'CardedFullwidthIIController as vm'
                }
            }
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.ui.page-layouts.carded.fullwidth-ii')
        .controller('CardedFullwidthIIController', CardedFullwidthIIController);

    /** @ngInject */
    function CardedFullwidthIIController()
    {
        // Data

        // Methods

        //////////
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.ui.page-layouts.carded.fullwidth', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        $stateProvider.state('app.ui_page-layouts_carded_fullwidth', {
            url  : '/ui/page-layouts/carded/fullwidth',
            views: {
                'content@app': {
                    templateUrl: 'app/main/ui/page-layouts/carded/fullwidth/fullwidth.html',
                    controller : 'CardedFullwidthController as vm'
                }
            }
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.ui.page-layouts.carded.fullwidth')
        .controller('CardedFullwidthController', CardedFullwidthController);

    /** @ngInject */
    function CardedFullwidthController()
    {
        // Data

        // Methods

        //////////
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.ui.page-layouts.carded.left-sidenav', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        $stateProvider.state('app.ui_page-layouts_carded_left-sidenav', {
            url  : '/ui/page-layouts/carded/left-sidenav',
            views: {
                'content@app': {
                    templateUrl: 'app/main/ui/page-layouts/carded/left-sidenav/left-sidenav.html',
                    controller : 'CardedLeftSidenavController as vm'
                }
            }
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.ui.page-layouts.carded.left-sidenav')
        .controller('CardedLeftSidenavController', CardedLeftSidenavController);

    /** @ngInject */
    function CardedLeftSidenavController($mdSidenav)
    {
        var vm = this;

        // Data

        // Methods
        vm.toggleSidenav = toggleSidenav;

        //////////

        /**
         * Toggle sidenav
         *
         * @param sidenavId
         */
        function toggleSidenav(sidenavId)
        {
            $mdSidenav(sidenavId).toggle();
        }
    }

})();
angular.module('app.pages.settings').controller('NewUpdatesDialogController',NewUpdatesDialogController);
function NewUpdatesDialogController($scope, $rootScope, $mdDialog,$timeout) {

    $scope.disable = true;
    $timeout(function () {
        $scope.disable = false;
    },10000);

    /**
     * Close the dialog
     */
    $scope.closeDialog = function () {
        $mdDialog.cancel();
    };

}

angular.module('app.pages.users').controller('SMSDialogController', ['$scope', '$rootScope', '$mdDialog','smsEndpoint','student','$location','Notification','students','external','type',
    function ($scope, $rootScope, $mdDialog,smsEndpoint,student,$location,Notification,students,external,type) {

    $scope.students = students;
    $scope.type = type;
    $scope.sms = {};
    $scope.sms.Students = [];
    $scope.externalSMS =external;

    $scope.type = type;
    if ($scope.type==1) {
        $scope.typeText ="חניכים";
    }
    else if ($scope.type==2) {
        $scope.typeText =$rootScope.User.Coordinators;
    }
    else
        $scope.typeText ="הורים";


    /**
     * Get All selected students
     */
    for (var i=0;i<$scope.students.length;i++) {
        if($scope.students[i].Selected ===true)
            $scope.sms.Students.push($scope.students[i]);
    }


    /**
     * Send SMS to students\parents
     */
    $scope.sendSMS = function () {
        if ($scope.externalSMS)
            $scope.sms.Type= 1;
        $scope.isClicked = true;
        Notification.info("שולח הודעות..");
        smsEndpoint.post($scope.sms,function (data) {
            $scope.isClicked= false;
            if (data.success)
                Notification.success("הודעה נשלחה בהצלחה");
            else
                Notification.error("נכשל בשליחת הודעה");

            $mdDialog.hide();
        })


    };

    /**
     * Close the dialog
     */
    $scope.closeDialog =function () {
        $mdDialog.cancel();
    };

}]);

angular.module('app.pages.users').controller('EmailDialogController', ['$scope', '$rootScope', '$mdDialog','emailEndpoint','student','$location','Notification','students','$timeout','$interval','external','type', function ($scope, $rootScope, $mdDialog,emailEndpoint,student,$location,Notification,students,$timeout,$interval,external,type) {

    $scope.students = students;
    var selectedStudents = [];
    for (var i=0;i<$scope.students.length;i++) {
        if ($scope.students[i].Selected === true) {
            selectedStudents.push($scope.students[i]);
        }
    }
    $scope.type = type;
    if ($scope.type==1) {
        $scope.typeText ="חניכים";
    }
    else if ($scope.type==2) {
        $scope.typeText =$rootScope.User.Coordinators;
    }
    else
        $scope.typeText ="הורים";

    $scope.students =  selectedStudents;
    $scope.sendsEmailes = 0;
    $scope.email = {};
    $scope.determinateValue = 0;
    $scope.externalEmail =external;
    $scope.options = {};
    $scope.options.contentsLangDirection   = 'rtl';
    $scope.options.height = '600px';


    /**
     * Set all students emails into array
     */


    /**
     * Send email to students\parents
     */
    $scope.sendEmail = function () {

        $scope.determinateValue = $scope.students.length;
        $scope.isClicked = true;
        Notification.info("שולח הודעות..");
        var onePercent = 100/$scope.students.length;
        sendEmail(onePercent,0);

    };

    var sendEmail =function (onePercent,index) {
        $scope.email.Students= [];
        $scope.email.Students.push($scope.students[index]);
        if ($scope.externalEmail)
            $scope.email.Type= 1;
        emailEndpoint.post($scope.email,function (data) {
            $scope.sendsEmailes++;
            $scope.determinateValue+=onePercent;
            if ($scope.sendsEmailes===$scope.students.length)
            {
                $scope.determinateValue+=onePercent;
                $scope.isClicked= false;
                if (data.success)
                    Notification.success("הודעה נשלחה בהצלחה");
                else
                    Notification.error("נכשל בשליחת הודעה");
                $mdDialog.hide();
            }
            else {
                $timeout(function () {
                    index++;
                    sendEmail(onePercent,index);
                },1000)

            }
        })
    };

    /**
     * Close the dialog
     */
    $scope.closeDialog =function () {
        $mdDialog.cancel();
    };

}]);

angular.module('app.pages.users').controller('NewReportDialogController', NewReportDialogController);

function NewReportDialogController($scope, $rootScope, appConfig, areasEndpoint, branchesEndpoint, reportsEndpoint, groupsEndpoint, gradesEndpoint, Notification, $mdDialog, eventsEndpoint, $timeout, $element, activitiesEndpoint) {

    $scope.report = {};
    $scope.externalEventsEnabled = appConfig.externalEventsEnabled;

    /**
     * Get Fields By Report Type
     */
    $scope.getFields = function () {
        $scope.fields = false;
        $scope.report.Branches = null;
        $scope.report.Groups = null;
        $scope.report.Grades = null;
        $scope.report.Status = null;
        $scope.report.Canceld = null;
        $scope.report.Fields = null;
        $scope.report.endDate = moment().format('DD/MM/YYYY');
        $scope.report.startDate = moment().startOf('year').format('DD/MM/YYYY');
        $scope.report.Events = null;
        $scope.report.Areas = null;
        $scope.report.Gender = null;
        $scope.report.extraFields = null;
        $scope.report.City = null;
        if ($scope.report.Type != 12) {
            console.log($scope.report.Type)
            $scope.report.endDate = moment().format('DD/MM/YYYY');
            $scope.report.startDate = moment().startOf('year').format('DD/MM/YYYY');
        } else {

            $scope.report.endDate = moment().format('MM/YYYY');
            $scope.report.startDate = moment().startOf('year').format('MM/YYYY');
            console.log($scope.report)
        }
        var params = {};
        params.Status = 1;
        if (!$scope.grades)
            $scope.getGrades();
        if (!$scope.branches)
            branchesEndpoint.get({}, function (data) {
                $scope.branches = data;
            });
        if (!$scope.areas) {
            var params2 = {};
            params2.Status = 1;
            areasEndpoint.get(params2, function (data) {
                $scope.areas = data;
            });
        }

        /*if ($scope.report.Type > 7 && !$scope.events)
            $scope.getEvents();*/

        reportsEndpoint.fields.get($scope.report.Type, function (data) {
            $scope.fields = data;
        });
        $scope.loadAll();

    };

    /***
     * Get Group By branch
     */
    $scope.getGroups = function () {
        var params = {};
        params.BranchIdes = [];
        var branches = angular.copy($scope.report.Branches);
        for (var i = 0; i < branches.length; i++) {
            params.BranchIdes.push(branches[i].ID)
        }
        params.BranchIdes = JSON.stringify(params.BranchIdes);
        groupsEndpoint.get(params, function (data) {
            $scope.groups = data;
        })
    };

    /**
     * Get Grades
     */
    $scope.getGrades = function () {
        if (!$scope.grades)
            gradesEndpoint.get(null, function (data) {
                $scope.grades = data;
            })
    };


    $scope.addToReportEvents = function (value) {
        if (!$scope.report.Events) {
            $scope.report.Events = [];
        }
        $scope.report.Events = $scope.report.Events.filter(function (event) {
            return value.ID != event.ID;
        });
        $scope.report.Events.push(value);
    }

    $scope.removeFromReportEvents = function (eventToRemove) {
        $scope.report.Events = $scope.report.Events.filter(function (event) {
            return eventToRemove.ID != event.ID;
        })
    }


    $scope.getRelevantEvents = function () {
        if ($scope.report.Type === 24) {
            $scope.getEvents();
        }
    };

    $scope.eventKeyPress = function (event) {
        var currentState = event.target.value;
        if ($scope.report.Type != 24)
            $timeout(function () {
                if (currentState != undefined && currentState.length > 0 && currentState == event.target.value)
                    $scope.getEvents(currentState);
            }, 1000);
    };
    /**
     * Get all events
     */
    $scope.getEvents = function (searchTerm) {
        var params = {};
        params.Limit = 10000;
        if ($scope.report.Type == 13)
            params.EventType = 1;
        params.FreeSearch = searchTerm;
        if ($scope.report.Type != 24) {
            eventsEndpoint.get(params, function (data) {
                if (+$scope.report.Type === 9) {
                    $scope.events = data.filter(function (event) {
                        return +event['CartEvent'] === 0;
                    });
                } else {
                    $scope.events = data;
                }
            });
        } else {
            eventsEndpoint.getByGrades({grades: $scope.report.Grades}, function (data) {
                $scope.events = data;
                console.log(data)
            });
        }
    };

    $scope.getActivities = function () {
        var params = {};
        params['Groups'] = $scope.report.Groups;
        params['Grades'] = $scope.report.Grades;
        activitiesEndpoint.get(params, function (data) {
            $scope.activities = data;
        })
    };

    /**
     * Save new report
     * @param exportReport
     * @param dontSave
     */
    $scope.saveNewReport = function (exportReport, dontSave) {
        $scope.report.Export = !!exportReport;
        $scope.report.DontSave = !!dontSave;
        if ($scope.report.Type == 12) {
            var tmpDate = new Date($scope.report.endDate.split('/')[1], +$scope.report.endDate.split('/')[0], 0);
            $scope.report.startDate = '01/' + $scope.report.startDate;
            $scope.report.endDate = tmpDate.getDate() + '/' + $scope.report.endDate;
        }
        var params = angular.copy($scope.report);
        var mapByIDAndName = function (elem) {
            if (elem == null)
                return {ID: null, Name: "ללא"};
            return {ID: elem.ID, Name: elem.Name};
        };
        ['Branches', 'Groups', 'Events', 'Areas', 'Grades', 'Activites'].forEach(function (prop) {
            if (params[prop] == null)
                params[prop] = [];
            // eslint-disable-next-line no-empty

            if (!angular.isArray(params[prop])) {
                params[prop] = [params[prop]];
            }
            params[prop] = JSON.stringify(params[prop].map(mapByIDAndName));
        });
        params.Fields = JSON.stringify(params.Fields);
        /*
        params.Branches = JSON.stringify(params.Branches.map(mapByIDAndName));
        params.Groups = JSON.stringify(params.Groups);
        params.Events = JSON.stringify(params.Events);
        params.Areas = JSON.stringify(params.Areas);
        params.Grades = JSON.stringify(params.Grades);
        params.Activities = JSON.stringify(params.Activities);
        */
        params.HebYear = $scope.report.HebYear;

        $scope.isClicked = true;
        if (!$scope.report.Export && !$scope.report.DontSave) {
            reportsEndpoint.post(params, function (data) {
                if (!data.success)
                    Notification.info("נכשל בהוספת דוח חדש");
                else
                    Notification.success("דוח נשמר בהצלחה");
                $mdDialog.hide();
                $scope.isClicked = false;
            })
        } else {
            Notification.info("מכין דוח אנא המתן..");
            $timeout(function () {
                if ($scope.isClicked)
                    Notification.info("פעולה זו יכולה להימשך מספר שניות");
            }, 10000);
            reportsEndpoint.saveExport.get(params, function (data) {
                $mdDialog.hide();
                $scope.isClicked = false;
            })
        }

    };

    $element.find('input').on('keydown', function (ev) {
        ev.stopPropagation();
    });

    $scope.clearSearchTerm = function () {
        $scope.searchTerm = '';
    };


    /**
     * Close the dialog
     */
    $scope.closeDialog = function () {
        $mdDialog.cancel();
    };

    $scope.loadAll = function () {

        var allStates = 'אבו גוש,אבו סנאן,אבו קורינאת (יישוב),אבו תלול,אבטין,אבטליון,אביאל,אביבים,אביגדור,אביחיל,\n' +
            'אביטל,אביעזר,אבירים,אבן יהודה,אבן מנחם,אבן ספיר,אבן שמואל,אבני איתן,אבני חפץ,אבנת,\n' +
            'אבשלום,אדורה,אדירים,אדמית,אדרת,אודים,אודם,אוהד,אום אל-פחם,אום אל-קוטוף,\n' +
            'אום בטין,אומן,אומץ,אופקים,אור הגנוז,אור הנר,אור יהודה,אור עקיבא,אורה,אורות,\n' +
            'אורטל,אורים,אורנים,אורנית,אושה,אזור,אחווה,אחוזם,אחוזת ברק,אחיהוד,\n' +
            'אחיטוב,אחיסמך,אחיעזר,איבים,אייל,איילת השחר,אילון,אילות,אילנייה,אילת,\n' +
            'אירוס,איתמר,איתן,איתנים,אכסאל,אל -עזי,אל -עריאן,אל -רום,אל סייד,אלומה,\n' +
            'אלומות,אלון הגליל,אלון מורה,אלון שבות,אלוני אבא,אלוני הבשן,אלוני יצחק,אלונים,אלי-עד,אליאב,\n' +
            'אליכין,אליפז,אליפלט,אליקים,אלישיב,אלישמע,אלמגור,אלמוג,אלעד,אלעזר,\n' +
            'אלפי מנשה,אלקוש,אלקנה,אמונים,אמירים,אמנון,אמציה,אניעם,אספר,אעבלין,\n' +
            'אפיק,אפיקים,אפק,אפרת,ארבל,ארגמן,ארז,אריאל,ארסוף,אשבול,\n' +
            'אשבל,אשדוד,אשדות יעקב (איחוד),אשדות יעקב (מאוחד),אשחר,אשכולות,אשל הנשיא,אשלים,אשקלון,אשרת,\n' +
            'אשתאול,באקה אל-גרביה,באר אורה,באר גנים,באר טוביה,באר יעקב,באר מילכה,באר שבע,בארות יצחק,בארותיים,\n' +
            'בארי,בוסתן הגליל,בועיינה-נוג\'ידאת,בוקעאתא,בורגתה,בחן,בטחה,ביצרון,ביר אל-מכסור,ביר הדאג\',\n' +
            'בירייה,בית אורן,בית אל,בית אלעזרי,בית אלפא,בית אריה,בית ברל,בית ג\'ן,בית גוברין,בית גמליאל,\n' +
            'בית דגן,בית הגדי,בית הלוי,בית הלל,בית העמק,בית הערבה,בית השיטה,בית זיד,בית זית,בית זרע,\n' +
            'בית חורון,בית חירות,בית חלקיה,בית חנן,בית חנניה,בית חשמונאי,בית יהושע,בית יוסף,בית ינאי,בית יצחק-שער חפר,\n' +
            'בית לחם הגלילית,בית מאיר,בית נחמיה,בית ניר,בית נקופה,בית עובד,בית עוזיאל,בית עזרא,בית עריף,בית צבי,\n' +
            'בית קמה,בית קשת,בית רבן,בית רימון,בית שאן,בית שמש,בית שערים,בית שקמה,ביתן אהרן,ביתר עילית,\n' +
            'בלפוריה,בן זכאי,בן עמי,בן שמן (כפר נוער),בן שמן (מושב),בני ברק,בני דקלים,בני דרום,בני דרור,בני יהודה,\n' +
            'בני נצרים,בני עטרות,בני עי"ש,בני ציון,בני ראם,בניה,בנימינה-גבעת עדה*,בסמ"ה,בסמת טבעון,בענה,\n' +
            'בצרה,בצת,בקוע,בקעות,בר גיורא,בר יוחאי,ברוכין,ברור חיל,ברוש,ברכה,\n' +
            'ברכיה,ברעם,ברק,ברקאי,ברקן,ברקת,בת הדר,בת חן,בת חפר,בת ים,\n' +
            'בת עין,בת שלמה,ג\'דיידה-מכר,ג\'ולס,ג\'לג\'וליה,ג\'סר א-זרקא,ג\'ש (גוש חלב),ג\'ת,גאולי תימן,גאולים,\n' +
            'גאליה,גבולות,גבים,גבע,גבע בנימין,גבע כרמל,גבעולים,גבעון החדשה,גבעות בר,גבעת אבני,\n' +
            'גבעת אלה,גבעת ברנר,גבעת השלושה,גבעת זאב,גבעת ח"ן,גבעת חיים (איחוד),גבעת חיים (מאוחד),גבעת יואב,גבעת יערים,גבעת ישעיהו,\n' +
            'גבעת כ"ח,גבעת ניל"י,גבעת עוז,גבעת שמואל,גבעת שמש,גבעת שפירא,גבעתי,גבעתיים,גברעם,גבת,\n' +
            'גדות,גדיש,גדעונה,גדרה,גונן,גורן,גורנות הגליל,גזית,גזר,גיאה,\n' +
            'גיבתון,גיזו,גילון,גילת,גינוסר,גיניגר,גינתון,גיתה,גיתית,גלאון,\n' +
            'גלגל,גליל ים,גלעד (אבן יצחק),גמזו,גן הדרום,גן השומרון,גן חיים,גן יאשיה,גן יבנה,גן נר,\n' +
            'גן שורק,גן שלמה,גן שמואל,גנות,גנות הדר,גני הדר,גני טל,גני יוחנן,גני עם,גני תקווה,\n' +
            'געש,געתון,גפן,גרופית,גשור,גשר,גשר הזיו,גת (קיבוץ),גת רימון,דאלית אל-כרמל,\n' +
            'דבורה,דבורייה,דבירה,דברת,דגניה א\',דגניה ב\',דוב"ב,דולב,דור,דורות,\n' +
            'דחי,דייר אל-אסד,דייר חנא,דייר ראפאת,דימונה,דישון,דלייה,דלתון,דמיידה,דן,\n' +
            'דפנה,דקל,דריג\'את,האון,הבונים,הגושרים,הדר עם,הוד השרון,הודיות,הודייה,\n' +
            'הושעיה,הזורע,הזורעים,החותרים,היוגב,הילה,המעפיל,הסוללים,העוגן,הר אדר,\n' +
            'הר גילה,הר עמשא,הראל,הרדוף,הרצלייה,הררית,ורד יריחו,ורדון,זבדיאל,זוהר,\n' +
            'זיקים,זיתן,זכרון יעקב,זכריה,זמר,זמרת,זנוח,זרועה,זרזיר,זרחיה,\n' +
            'ח\'ואלד,חבצלת השרון,חבר,חגור,חגי,חגלה,חד-נס,חדיד,חדרה,חוג\'ייראת (ד\'הרה) (שבט),\n' +
            'חולדה,חולון,חולית,חולתה,חוסן,חוסנייה,חופית,חוקוק,חורה,חורפיש,\n' +
            'חורשים,חזון,חיבת ציון,חיננית,חיפה,חירות,חלוץ,חלמיש,חלץ,חמאם,\n' +
            'חמד,חמדיה,חמדת,חמרה,חניאל,חניתה,חנתון,חספין,חפץ חיים,חפצי-בה,\n' +
            'חצב,חצבה,חצור הגלילית,חצור-אשדוד,חצרים,חרב לאת,חרוצים,חריש,חרמש,חרשים,\n' +
            'חשמונאים,טבריה,טובא-זנגרייה,טורעאן,טייבה,טייבה (בעמק),טירה,טירת יהודה,טירת כרמל,טירת צבי,\n' +
            'טל שחר,טל-אל,טללים,טלמון,טמרה,טמרה (יזרעאל),טנא,טפחות,יאנוח-ג\'ת,יבול,\n' +
            'יבנאל,יבנה,יגור,יגל,יד בנימין,יד השמונה,יד חנה,יד מרדכי,יד נתן,יד רמב"ם,\n' +
            'ידידה,יהוד,יהל,יובל,יובלים,יודפת,יונתן,יושיביה,יזרעאל,יחיעם,\n' +
            'יטבתה,ייט"ב,יכיני,ינוב,ינון,יסוד המעלה,יסודות,יסעור,יעד,יעל,\n' +
            'יעף,יערה,יפיע,יפית,יפעת,יפתח,יצהר,יציץ,יקום,יקיר,\n' +
            'יקנעם (מושבה),יקנעם עילית,יראון,ירדנה,ירוחם,ירושלים,ירחיב,ירכא,ירקונה,ישע,\n' +
            'ישעי,ישרש,יתד,כאבול,כאוכב אבו אל-היג\'א,כברי,כדורי,כדיתה,כוכב השחר,כוכב יאיר,\n' +
            'כוכב יעקב,כוכב מיכאל,כורזים,כחל,כחלה,כיסופים,כישור,כליל,כלנית,כמאנה,\n' +
            'כמהין,כמון,כנות,כנף,כנרת (מושבה),כנרת (קבוצה),כסיפה,כסלון,כסרא-סמיע,כעביה-טבאש-חג\'אג\'רה,\n' +
            'כפר אביב,כפר אדומים,כפר אוריה,כפר אחים,כפר ביאליק,כפר ביל"ו,כפר בלום,כפר בן נון,כפר ברא,כפר ברוך,\n' +
            'כפר גדעון,כפר גלים,כפר גליקסון,כפר גלעדי,כפר דניאל,כפר האורנים,כפר החורש,כפר המכבי,כפר הנגיד,כפר הנוער הדתי,\n' +
            'כפר הנשיא,כפר הס,כפר הרא"ה,כפר הרי"ף,כפר ויתקין,כפר ורבורג,כפר ורדים,כפר זוהרים,כפר זיתים,כפר חב"ד,\n' +
            'כפר חושן,כפר חיטים,כפר חיים,כפר חנניה,כפר חסידים א\',כפר חסידים ב\',כפר חרוב,כפר טרומן,כפר יאסיף,כפר ידידיה,\n' +
            'כפר יהושע,כפר יונה,כפר יחזקאל,כפר יעבץ,כפר כמא,כפר כנא,כפר מונש,כפר מימון,כפר מל"ל,כפר מנדא,\n' +
            'כפר מנחם,כפר מסריק,כפר מצר,כפר מרדכי,כפר נטר,כפר סאלד,כפר סבא,כפר סילבר,כפר סירקין,כפר עבודה,\n' +
            'כפר עזה,כפר עציון,כפר פינס,כפר קאסם,כפר קיש,כפר קרע,כפר ראש הנקרה,כפר רוזנואלד (זרעית),כפר רופין,כפר רות,\n' +
            'כפר שמאי,כפר שמואל,כפר שמריהו,כפר תבור,כפר תפוח,כרכום,כרם בן זמרה,כרם בן שמן,כרם יבנה (ישיבה),כרם מהר"ל,\n' +
            'כרם שלום,כרמי יוסף,כרמי צור,כרמיאל,כרמייה,כרמית,כרמים,כרמל,לבון,לביא,לבנים,\n' +
            'להב,להבות הבשן,להבות חביבה,להבים,לוד,לוזית,לוחמי הגיטאות,לוטם,לוטן,לימן,\n' +
            'לכיש,לפיד,לפידות,לקיה,מאור,מאיר שפיה,מבוא ביתר,מבוא דותן,מבוא חורון,מבוא חמה,\n' +
            'מבוא מודיעים,מבואות ים,מבועים,מבטחים,מבקיעים,מבשרת ציון,מג\'ד אל-כרום,מג\'דל שמס,מגאר,מגדים,\n' +
            'מגדל,מגדל העמק,מגדל עוז,מגדלים,מגידו,מגל,מגן,מגן שאול,מגשימים,מדרך עוז,\n' +
            'מדרשת בן גוריון,מדרשת רופין,מודיעין עילית,מודיעין-מכבים-רעות*,מולדה*,מולדת,מוצא עילית,מוקייבלה,מורן,מורשת,\n' +
            'מזור,מזכרת בתיה,מזרע,מזרעה,מחולה,מחנה הילה*,מחנה טלי*,מחנה יהודית*,מחנה יוכבד*,מחנה יפה*,\n' +
            'מחנה מרים*,מחנה תל נוף*,מחניים,מחסיה,מטולה,מטע,מי עמי,מיטב,מייסר,מיצר,\n' +
            'מירב,מירון,מישר,מיתר,מכורה,מכחול,מכמורת,מכמנים,מלאה,מלילות,\n' +
            'מלכייה,מלכישוע,מנוחה,מנוף,מנות,מנחמיה,מנרה,מנשית זבדה,מסד,מסדה,\n' +
            'מסילות,מסילת ציון,מסלול,מסעדה,מעברות,מעגלים,מעגן,מעגן מיכאל,מעוז חיים,מעון,\n' +
            'מעונה,מעיין ברוך,מעיין צבי,מעיליא,מעלה אדומים,מעלה אפרים,מעלה גלבוע,מעלה גמלא,מעלה החמישה,מעלה לבונה,\n' +
            'מעלה מכמש,מעלה עירון,מעלה עמוס,מעלה שומרון,מעלות-תרשיחא,מענית,מעש,מפלסים,מצדות יהודה,מצובה,\n' +
            'מצליח,מצפה,מצפה אבי"ב,מצפה אילן,מצפה יריחו,מצפה נטופה,מצפה רמון,מצפה שלם,מצר,מרגליות,\n' +
            'מרום גולן,מרחב עם,מרחביה (מושב),מרחביה (קיבוץ),מרכז שפירא,משאבי שדה,משגב דב,משגב עם,משהד,משואה,\n' +
            'משואות יצחק,משכיות,משמר איילון,משמר דוד,משמר הירדן,משמר הנגב,משמר העמק,משמר השבעה,משמר השרון,משמרות,\n' +
            'משמרת,משען,מתן,מתת,מתתיהו,נאות גולן,נאות הכיכר,נאות מרדכי,נאות סמדר,נאעורה,\n' +
            'נבטים,נגבה,נגוהות,נהורה,נהלל,נהרייה,נוב,נוגה,נווה,נווה אור,\n' +
            'נווה אטי"ב,נווה אילן,נווה איתן,נווה דניאל,נווה זוהר,נווה זיו,נווה חריף,נווה ים,נווה ימין,נווה ירק,\n' +
            'נווה מבטח,נווה מיכאל,נווה שלום,נועם,נוף איילון,נופים,נופית,נופך,נוקדים,נורדייה,\n' +
            'נורית,נחושה,נחל עוז,נחלה,נחליאל,נחלים,נחם,נחף,נחשולים,נחשון,\n' +
            'נחשונים,נטועה,נטור,נטע,נטעים,נטף,ניין,ניל"י,ניצן,ניצן ב\',\n' +
            'ניצנה (קהילת חינוך),ניצני סיני,ניצני עוז,ניצנים,ניר אליהו,ניר בנים,ניר גלים,ניר דוד (תל עמל),ניר ח"ן,ניר יפה,\n' +
            'ניר יצחק,ניר ישראל,ניר משה,ניר עוז,ניר עם,ניר עציון,ניר עקיבא,ניר צבי,נירים,נירית,\n' +
            'נירן,נס הרים,נס עמים,נס ציונה,נעורים,נעלה,נעמ"ה,נען,נצר חזני,נצר סרני,\n' +
            'נצרת,נצרת עילית,נשר,נתיב הגדוד,נתיב הל"ה,נתיב העשרה,נתיב השיירה,נתיבות,נתניה,סאג\'ור,\n' +
            'סאסא,סביון*,סגולה,סואעד (חמרייה)*,סולם,סוסיה,סופה,סח\'נין,סלמה,סלעית,\n' +
            'סמר,סנסנה,סעד,סער,ספיר,סתרייה,ע\'ג\'ר,עבדון,עברון,עגור,\n' +
            'עדי,עדנים,עוזה,עוזייר,עולש,עומר,עופר,עוצם,עזוז,עזר,\n' +
            'עזריאל,עזריה,עזריקם,עטרת,עידן,עיילבון,עיינות,עילוט,עין איילה,עין אל-אסד,\n' +
            'עין גב,עין גדי,עין דור,עין הבשור,עין הוד,עין החורש,עין המפרץ,עין הנצי"ב,עין העמק,עין השופט,\n' +
            'עין השלושה,עין ורד,עין זיוון,עין חוד,עין חצבה,עין חרוד (איחוד),עין חרוד (מאוחד),עין יהב,עין יעקב,עין כרם-בי"ס חקלאי,\n' +
            'עין כרמל,עין מאהל,עין נקובא,עין עירון,עין צורים,עין קנייא,עין ראפה,עין שמר,עין שריד,עין תמר,\n' +
            'עינת,עיר אובות,עכו,עלומים,עלי,עלי זהב,עלמה,עלמון,עמוקה,עמינדב,\n' +
            'עמיעד,עמיעוז,עמיקם,עמיר,עמנואל,עמקה,ענב,עספיא,עפולה,עפרה,\n' +
            'עץ אפרים,עצמון שגב,עראבה,עשהאל,עראמשה*,ערב אל נעים,ערד,ערוגות,ערערה,ערערה-בנגב,עשרת,\n' +
            'עתלית,עתניאל,פארן,פדואל,פדויים,פדיה,פוריידיס,פורייה - כפר עבודה,פורייה - נווה עובד,פורייה עילית,\n' +
            'פורת,פטיש,פלך,פלמחים,פני חבר,פסגות,פסוטה,פעמי תש"ז,פצאל,פקיעין (בוקייעה),\n' +
            'פקיעין חדשה,פרדס חנה-כרכור,פרדסייה,פרוד,פרזון,פרי גן,פתח תקווה,פתחיה,צאלים,צביה,\n' +
            'צבעון,צובה,צוחר,צופייה,צופים,צופית,צופר,צוקי ים,צוקים,צור הדסה,\n' +
            'צור יצחק,צור משה,צור נתן,צוריאל,צורית,ציפורי,צלפון,צנדלה,צפרייה,צפרירים,\n' +
            'צפת,צרופה,צרעה,קבוצת יבנה,קדומים,קדימה-צורן,קדמה,קדמת צבי,קדר,קדרון,\n' +
            'קדרים,קוממיות,קורנית,קטורה,קיסריה,קלחים,קליה,קלנסווה,קלע,קציר,\n' +
            'קצר א-סר,קצרין,קריית אונו,קריית ארבע,קריית אתא,קריית ביאליק,קריית גת,קריית טבעון,קריית ים,קריית יערים,\n' +
            'קריית יערים (מוסד),קריית מוצקין,קריית מלאכי,קריית נטפים,קריית ענבים,קריית עקרון,קריית שלמה,קריית שמונה,קרני שומרון,קשת,\n' +
            'ראמה,ראס אל-עין,ראס עלי,ראש העין,ראש פינה,ראש צורים,ראשון לציון,רבבה,רבדים,רביבים,\n' +
            'רביד,רגבה,רגבים,רהט,רווחה,רוויה,רוח מדבר,רוחמה,רומאנה,רומת הייב,\n' +
            'רועי,רותם,רחוב,רחובות,רחלים,ריחאנייה,ריחן,ריינה,רימונים,רינתיה,\n' +
            'רכסים,רם-און,רמות,רמות השבים,רמות מאיר,רמות מנשה,רמות נפתלי,רמלה,רמת גן,רמת דוד,\n' +
            'רמת הכובש,רמת השופט,רמת השרון,רמת יוחנן,רמת ישי,רמת מגשימים,רמת צבי,רמת רזיאל,רמת רחל,רנן,\n' +
            'רעים,רעננה,רקפת,רשפון,רשפים,רתמים,שאר ישוב,שבי ציון,שבי שומרון,שבלי - אום אל-גנם,\n' +
            'שגב-שלום,שדה אילן,שדה אליהו,שדה אליעזר,שדה בוקר,שדה דוד,שדה ורבורג,שדה יואב,שדה יעקב,שדה יצחק,\n' +
            'שדה משה,שדה נחום,שדה נחמיה,שדה ניצן,שדה עוזיהו,שדה צבי,שדות ים,שדות מיכה,שדי אברהם,שדי חמד,\n' +
            'שדי תרומות,שדמה,שדמות דבורה,שדמות מחולה,שדרות,שואבה,שובה,שובל,שוהם,שומרה,\n' +
            'שומרייה,שוקדה,שורש,שורשים,שושנת העמקים,שזור,שחר,שחרות,שיבולים,שיטים,\n' +
            'שייח\' דנון,שילה,שילת,שכניה,שלווה,שלווה במדבר,שלוחות,שלומי,שלומית,שמיר,\n' +
            'שמעה,שמרת,שמשית,שניר,שעב,שעל,שעלבים,שער אפרים,שער הגולן,שער העמקים,\n' +
            'שער מנשה,שערי תקווה,שפיים,שפיר,שפר,שפרעם,שקד,שקף,שרונה,שריגים (לי-און),\n' +
            'שריד,שרשרת,שתולה,שתולים,תאשור,תדהר,תובל,תומר,תושייה,תימורים,\n' +
            'תירוש,תל אביב -יפו,תל יוסף,תל יצחק,תל מונד,תל עדשים,תל קציר,תל שבע,תל תאומים,תלם,\n' +
            'תלמי אליהו,תלמי אלעזר,תלמי ביל"ו,תלמי יוסף,תלמי יחיאל,תלמי יפה,תלמים,תמרת,תנובות,תעוז,\n' +
            'תפרח,תקומה,תקוע,תרבין א-צאנע (יישוב)*,תרום,';

        $scope.cities = allStates.split(',').map(function (state) {
            state = state.trim();
            return {
                value: state,
                display: state
            };
        });


    }


}

(function ()
{
    'use strict';

    angular
        .module('app.pages_auth_reset-password', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        // State
        $stateProvider.state('app.pages_auth_reset-password', {
            url      : '/reset-password',
            views    : {
                'main@'                          : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.pages_auth_reset-password': {
                    templateUrl: 'app/main/pages/password-reset/reset-password/reset-password.html',
                    controller : 'ResetPasswordController',
                    controllerAs : 'vm'

                }
            },
            bodyClass: 'reset-password'
        });


    }

})();
angular.module('app.pages_auth_reset-password').controller('ResetPasswordController', ['$scope','$rootScope','$mdSidenav','$mdDialog','$location','adminEndpoint', 'msUtils', '$timeout','$cookies','Notification', function($scope,$rootScope,$mdSidenav,$mdDialog,$location,adminEndpoint, msUtils, $timeout, $cookies,Notification) {


    $scope.fail = false;
    $scope.resetPasswordForm = {};
    $scope.resetPasswordForm.email = null;
    $scope.wrongid = false;
    $scope.success = false;
    $scope.request = false;
    $scope.form = {};

    /**
     * Back to login page
     */
    $scope.goToLogin = function () {
        $location.path("/");
    };


    /**
     * Send email to user with temp token
     */
    $scope.forgot = function () {
        $scope.fail = false;
        $scope.isClicked = true;
        $scope.request = true;
        if(!$scope.form.email){
            $scope.wrongid = true;
            $scope.isClicked = false;
            $scope.request = false;
        }else{
            adminEndpoint.forgot.post($scope.form, function (data) {
                if (data.success)
                    $scope.success = true;
                else {
                    $scope.fail = true;
                    $timeout(function () {
                        $scope.fail = false;
                    }, 5000);
                }
                $scope.request = false;
            })
        }
    };



}]);

(function ()
{
    'use strict';

    angular
        .module('app.pages_auth_forgot-password', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        // State
        $stateProvider.state('app.pages_auth_forgot-password', {
            url      : '/forgot-password',
            views    : {
                'main@'                          : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.pages_auth_forgot-password': {
                    templateUrl: 'app/main/pages/password-reset/forgot-password/forgot-password.html',
                    controller : 'ForgotPasswordController',
                    controllerAs : 'vm'

                }
            },
            bodyClass: 'forgot-password'
        });


    }

})();
angular.module('app.pages_auth_forgot-password').controller('ForgotPasswordController', ['$scope','$rootScope','$mdSidenav','$mdDialog','$location','adminEndpoint', 'msUtils', '$timeout','$cookies','Notification', function($scope,$rootScope,$mdSidenav,$mdDialog,$location,adminEndpoint, msUtils, $timeout, $cookies,Notification) {

    $scope.showHideText = 'הצג';
    $scope.inputType = 'password';
    $scope.showHideImg = "/assets/icons/show.svg";
    $scope.matchPasswords = false;
    $scope.matchFlags = true;
    $scope.password = '';
    $scope.passwordVerify = '';
    $scope.form = {};
    $scope.success = false;
    $scope.loading = false;

    /**
     * Back to login page
     */
    $scope.goToLogin = function () {
        $location.path("/");
    };

    /**
     * Valid the user temp token
     */
    $scope.checkUserToken = function () {
        var params = {};
        params.token =  $location.search().tempToken;
        adminEndpoint.forgot.valid.post(params,function (data) {
            if (!data.ID) {
               $location.path("/")

            }
            else {
                $scope.valid=true;
                $scope.admin=data;

            }
        })
    };
    $scope.matchPass = function () {
        if ($scope.form.password == $scope.passwordVerify && $scope.form.password.length > 5) {
            $scope.matchPasswords = true;
            $scope.matchFlags = true;
        } else if ($scope.form.password == $scope.passwordVerify && $scope.form.password.length < 6) {
            $scope.shortPass = true;
            $scope.matchFlags = true;
        } else {
            $scope.shortPass = false;
            $scope.matchPasswords = false;
            $scope.matchFlags = false;
        }
    };
    /**
     * Login user to system
     */
    $scope.submit = function () {
        $scope.loading =true;
        $scope.form.Token = $location.search().tempToken;
        adminEndpoint.forgot.reset.post($scope.form, $scope.admin.ID, function (data) {
            if (data.ID) {
                $scope.success = true;
                $rootScope.User = data;
                $timeout(function(){
                    saveUser();
                },4000)
                setUserType();

            }
            else if(data.message)
                Notification.error(data.message)
            $scope.loading = false;
        })
    };

    function saveUser() {
        var expireTime = + new Date() +(24 * 3600000);
        $cookies.put("marvilixAccessToken",$rootScope.User.AccessToken,[{expires:expireTime}]);
        $scope.loogin = false;
        $timeout(function () {
            if ($rootScope.AdminLevel!==3)
                $location.path('/students');
            else
                $location.path('/dashboard');
        },250)
    }

    /**
     * Show or hide the password
     * @param field
     * @param ev
     */
    $scope.showHidePassword = function () {
        if ($scope.inputType == "password") {
            $scope.inputType = "text";
            $scope.showHideText = 'הסתר';
            $scope.showHideImg = "/assets/icons/hide.svg";
        } else {
            $scope.inputType = "password";
            $scope.showHideText = 'הצג';
            $scope.showHideImg = "/assets/icons/show.svg";
        }

    };


    /**
     * Set the admin type
     */
    function setUserType() {
        if ($rootScope.User.StudentID)
            $rootScope.AdminLevel =1;
        else if ($rootScope.User.IsCoordinator)
            $rootScope.AdminLevel =2;
        else
            $rootScope.AdminLevel =3;
    }


}]);

angular.module('app.pages.users').controller('ContactDialogController', ContactDialogController);
function ContactDialogController($scope, $mdDialog,$location,contactForm,Notification,formsEndpoint) {

    $scope.contactForm = contactForm;

    /**
     * Get files
     */
    $scope.getFiles = function () {

        for (var i = 0; i < subsidy.Files.length; i++)
            window.open(subsidy.Files[i].Path, subsidy.Files[i].ID);
    };
    /**
     * Close the dialog
     */
    $scope.closeDialog = function () {
        $mdDialog.cancel();
    };

    $scope.updateContactForm = function () {
        formsEndpoint.contact.update.post($scope.contactForm,function (data) {
            if (data.success) {
                Notification.success("פרטים עודכנו בהצלחה");
                $mdDialog.hide();

            }
            else {
                Notification.error("נכשל בעדכון פרטים");
                $mdDialog.cancel();

            }

        })
    }

}

angular.module('app.pages.users').controller('CancellationDialogController', CancellationDialogController);
function CancellationDialogController($scope, $mdDialog,$location,cancel,Notification,formsEndpoint) {

    $scope.cancel = cancel;

    /**
     * Get files
     */
    $scope.getFiles = function () {

        for (var i = 0; i < subsidy.Files.length; i++)
            window.open(subsidy.Files[i].Path, subsidy.Files[i].ID);
    };
    /**
     * Close the dialog
     */
    $scope.closeDialog = function () {
        $mdDialog.cancel();
    };

    $scope.updateCancellationForm = function () {
        formsEndpoint.cancellation.update.post($scope.cancel,function (data) {
            if (data.success) {
                Notification.success("פרטים עודכנו בהצלחה");
                $mdDialog.hide();

            }
            else {
                Notification.error("נכשל בעדכון פרטים");
                $mdDialog.cancel();

            }

        })
    }

}

angular.module('app.pages.events').controller('RefundRegistrationDialogController', ['$scope', '$rootScope', '$mdDialog', 'parentsEndpoint', 'studentsEndpoint', 'student', '$location', 'Notification', 'event', 'eventsEndpoint', 'registration', 'external', 'externalRegistrationEndpoint',
    function ($scope, $rootScope, $mdDialog, parentsEndpoint, studentsEndpoint, student, $location, Notification, event, eventsEndpoint, registration, external, externalRegistrationEndpoint) {

        $scope.cancelRegistration = {
            RefundModel: 0
        };
        $scope.registration = registration;
        $scope.registration.FinalPrice = $scope.registration.FinalPrice ? parseInt($scope.registration.FinalPrice) : parseInt($scope.registration.Price);

        $scope.showRefundModel = false;
        $scope.showRefundModelInit = false;
        $scope.parentLoaded = false;
        $scope.amountConfirmed = false;
        $scope.receipts = [];
        $scope.cancelPlaceHolder = 'האם לבטל את ההזמנה?';

        function init() {
            parentsEndpoint.registration.get($scope.registration.ID, function (data) {
                $scope.parent = data;
                $scope.cancelRegistration.ParentID = data.ID ? data.ID : null;

                $scope.parentLoaded = true;
            });
            var endpoint;
            if ($scope.registration.ExternalUserID)
                endpoint = externalRegistrationEndpoint.registrations.refund;
            else
                endpoint = studentsEndpoint.registrations.refunds;

            endpoint.get($scope.registration, function (data) {
                /*var donationAmount = $scope.registration.DonationAmount != null? $scope.registration.DonationAmount : 0;*/
                var price = $scope.registration.FinalPrice? $scope.registration.FinalPrice : $scope.registration.Price? $scope.registration.Price : 0;
                var receiptsAmountLeft = 0;
                if (data.Receipts) {
                    Object.keys(data.Receipts).forEach(function (key) {
                        receiptsAmountLeft += data.Receipts[key].left;
                    });
                }
                $scope.amountConfirmed = receiptsAmountLeft;
                $scope.receipts = data.Receipts;
                //console.log(data)

                if (Object.keys(data.Receipts).length > 1) {
                    $scope.showRefundModel = true;
                }
                if (!$scope.showRefundModel) {
                    Object.keys($scope.receipts).forEach(function (id) {
                        if ($scope.registration.receiptsCount[id] > 1) {
                            $scope.showRefundModel = true;
                        }
                    })
                }

                //$scope.cancelRegistration.Refund = Math.min($scope.amountConfirmed,$scope.registration.FinalPrice);
                // if ($scope.amountConfirmed <= 0 || price > $scope.amountConfirmed - data.Refunded) {
                if ($scope.amountConfirmed <= 0 || data.Amount >= $scope.amountConfirmed + data.Refunded) {
                    Notification.error("הרשמה זו זוכתה במלואה!");

                    $mdDialog.hide();
                }
            })
        }

        init();

        $scope.changeRefundValue = function () {

            if ($scope.cancelRegistration.RefundModel == 0) {
                $scope.cancelPlaceHolder = 'האם לבטל את ההזמנה?';
                $scope.cancelRegistration.Refund = Math.min($scope.cancelRegistration.ReceiptForRefund.left, $scope.amountConfirmed, $scope.registration.FinalPrice);
            } else {
                $scope.cancelPlaceHolder = 'האם לבטל את כל ההזמנות תחת הקבלה שנבחרה?';
                $scope.cancelRegistration.Refund =$scope.receipts[$scope.cancelRegistration.ReceiptForRefund.ReceiptID].left;
                // console.log($scope.cancelRegistration.ReceiptForRefund);
                // console.log($scope.receipts[$scope.cancelRegistration.ReceiptForRefund.ReceiptID].left)
            }
        }

        /**
         * Send refund Registration request
         */
        $scope.changeRefundType = function () {
            $scope.showRefundModelInit = true;
            if ($scope.cancelRegistration.RefundType == 7) {
                $scope.cancelPlaceHolder = 'האם לבטל את ההזמנה?';
            } else  if ($scope.cancelRegistration.RefundType != 7 && $scope.cancelRegistration.RefundModel == 1){
                $scope.cancelPlaceHolder = 'האם לבטל את כל ההזמנות תחת הקבלה שנבחרה?';
            }
        };
        $scope.refundRegistration = function () {
            //$scope.cancelRegistration.ReceiptID =  $scope.registration.ReceiptID;
            $scope.cancelRegistration.RegistrationID = $scope.registration.ID;
            $scope.cancelRegistration.StudentID = registration.StudentID;
            $scope.cancelRegistration.ReceiptID = $scope.cancelRegistration.ReceiptForRefund.ReceiptID;
            $scope.isClikced = true;
            if($scope.cancelRegistration.RefundType == 7){
                $scope.cancelRegistration.RefundModel = 0;
            }
            if (!external)
                studentsEndpoint.events.refund.post($scope.cancelRegistration, function (data) {
                    if (typeof data == 'string')
                        Notification.error(data);
                    else if (data.success)
                        Notification.success("פעולה הסתיימה בהצלחה");
                    else
                        Notification.error("פעולה נכשלה");
                    $scope.isClikced = false;
                    $mdDialog.hide();

                });
            else
                externalRegistrationEndpoint.registrations.refund.post($scope.cancelRegistration, function (data) {
                    if (typeof data == 'string')
                        Notification.error(data);
                    else if (data.success)
                        Notification.success("פעולה הסתיימה בהצלחה");
                    else
                        Notification.error("פעולה נכשלה");
                    $scope.isClikced = false;
                    $mdDialog.hide();
                })
        };


        /**
         * Close the dialog
         */
        $scope.closeDialog = function () {
            $mdDialog.cancel();
        };

        $scope.checkAmount = function () {
            if ($scope.cancelRegistration.RefundModel == 0) {
                if ($scope.cancelRegistration.Refund < 1)
                    $scope.cancelRegistration.Refund = 1;
                if ($scope.cancelRegistration.Refund > Math.min($scope.cancelRegistration.ReceiptForRefund.left, $scope.amountConfirmed, $scope.registration.FinalPrice))
                    $scope.cancelRegistration.Refund = Math.min($scope.cancelRegistration.ReceiptForRefund.left, $scope.amountConfirmed, $scope.registration.FinalPrice);
            }else{
                $scope.changeRefundValue();
            }
        }

    }])
;

angular.module('app.pages.users').controller('FullRegistrationDialogController',FullRegistrationDialogController);

function FullRegistrationDialogController($scope,$timeout, $rootScope,$http,Upload,appConfig,$sce,receiptsEndpoint,pelecardEndpoint,tranzilaEndpoint,$interval,$mdDialog,registration,studentsEndpoint,Notification,DTOptionsBuilder,dtOptions,settingsEndpoint,receiptsService,$sce) {

    $scope.fileNames = {};
    $scope.allRegistrationsForReceipt = [];
    /**
     * Set Table option
     * @type {any}
     */
    $scope.dtOptions = DTOptionsBuilder
        .newOptions()
        .withLanguage(dtOptions.language)
        .withDOM('lfrtp')
        .withOption('bFilter', false)
        .withDOM('lrtip');


    /**
     * Close the dialog
     */
    $scope.closeDialog = function () {
        $mdDialog.cancel();
    };

    /**
     * Get the full Registration
     */
    $scope.getFullRegistration = function () {
        $scope.initializing = 0;
        studentsEndpoint.registrations.fullRegistration.get(registration, function (data) {
            $scope.registrations = data;
            $scope.registrations.Registration.ReceiptID.forEach(function(receipt){
                if(receipt.ChecksData && receipt.ChecksData.length) {
                    receipt.ChecksData = JSON.parse(receipt.ChecksData);
                }
                receiptsEndpoint.getByReceiptID( receipt.ReceiptID, function (data) {
                        $scope.allRegistrationsForReceipt = data;
                })
            })
            setFileName();
            getLogs();
            getBanks();
        })
    };

    /**
     * Update registration
     * @param registration
     */
    $scope.updateRegistration = function (registration) {
        $scope.isClicked = true;
        studentsEndpoint.registrations.update.post(registration, function (data) {
            $scope.isClicked = false;
            Notification.success("הרשמה עודכנה בהצלחה");
            $rootScope.$broadcast("Registration-Update");
            $mdDialog.hide()
        })
    };

    /**
     * confirm registration and send receipt
     * @param registration
     */
    $scope.sendReceipt = function (registration) {

        if (registration.ReceiptID || registration.PaymentStatus==0 || registration.PaymentStatus==3)
            return;
        if ($scope.initializing >= 1 && location.hostname !== "localhost") {
            $scope.initializing++;
            return;
        }
        else
            $scope.isClicked = true;
            studentsEndpoint.registrations.confirm.post(registration, function (data) {
                $scope.isClicked = false;
                Notification.success("הרשמה עודכנה בהצלחה");
                Notification.info("קבלה נשלחה ללקוח");
                $rootScope.$broadcast("Registration-Update");
                getLogs();
            })
    };

    /**
     * get Logs
     */
    function getLogs() {
        $scope.logs = false;
        studentsEndpoint.registrations.logs.get(registration, function (data) {
            $scope.logs=data
        })
    }

    function setFileName() {
        if ($scope.registrations.Registration.FileRecipt !=null) {
            $scope.fileName2 = $scope.registrations.Registration.FileRecipt.replace(/^.*[\\\/]/, '')
        }
        if ($scope.registrations.Registration.File != null){
            $scope.fileName = $scope.registrations.Registration.File.replace(/^.*[\\\/]/, '')
        }
    }

    /**
     * Update Questions
     * @param questions
     */
    $scope.updateQuestions =  function (questions) {
        $scope.isClicked = true;
        var params = {};
        params.Questions = questions;
        studentsEndpoint.registrations.questions.update.post(registration,params, function () {
            $scope.isClicked = false;
            Notification.success("שאלות עודכנו בהצלחה");
            getLogs();
        })
    };

    /**
     * Update regTransportation
     */
    $scope.updateTransportation =function () {
        $scope.isClicked = true;
        var params = {};
        params.TransportationTo = $scope.registrations.Transportation.SelectedTransportationTo;
        params.TransportationFrom = $scope.registrations.Transportation.SelectedTransportationFrom;
        studentsEndpoint.registrations.transportation.update.post(registration,params, function () {
            $scope.isClicked = false;
            Notification.success("הסעות עודכנו בהצלחה");
            getLogs();
        })
    };

    /**
     * Get Banks
     */
    function getBanks() {
        settingsEndpoint.accountancy.banks.get(function (data) {
            $scope.banks = data;
        })
    }

    /**
     * Re send Receipt
     * @param receiptID
     * @param type
     */
    $scope.reSendReceipt = function (receiptID,type) {
        Notification.info("שולח קבלה..");
        receiptsService.getReceiptByID(receiptID,type,function () {
            Notification.success("קבלה נשלחה בהצלחה");
        },true);
    };

    $scope.setActiveTab = function(tab){
        $scope.selectedTab = tab;
    };

    /**
     * Set Price
     * @param FinalPrice
     * @param Discount
     * @returns {number}
     */
    $scope.setPrice =function(FinalPrice,Discount) {
            return parseInt(FinalPrice) +parseInt(Discount)
    };

    /**
     * Open File in new widnwos
     * @param path
     */
    $scope.openFile = function (path) {
        window.open(path, '_blank');
    };

    /**
     * Update Questions
     * @param question
     */
    $scope.updateOptionFile = function(question) {
        var file = document.getElementById(question.ID);
        file = file.files[0];
        var params = new FormData();
        question.filename = new Date().getTime() + "_" +file.name;
        params.append("files",file,question.filename);
        params.append("brand",$rootScope.brandName);
        params.append("upload_file", 'true');

        var uploadURL = '';
        if (location.hostname === "localhost" || location.hostname === "127.0.0.1")
            uploadURL = appConfig.localHostUrl+'/upload/files';
        else if (location.host === appConfig.locationHost)
            uploadURL = appConfig.developmentHostUrl+'/upload/files';
        else
            uploadURL = appConfig.serverUrl+'/upload/files';

         $http.post(uploadURL, params, {
            headers: {'Content-Type': 'multipart/form-data','Accept':'application/json'},
            withCredentials: true
        }).then(function (data) {
             question.Answer = data.Path;
        });

    };


    /**
     * Open File
     */
     $scope.viewFile = function(file) {
        window.open( file);
    };

    /**
     * UploadFile
     * @param file
     */
    $scope.uploadFile = function(file,q,question,ds) {
        if (!file)
            return;
        $scope.isClicked = true;
        var qu = question;
        if(question){
            $scope.fileNames[qu.ID] = file.name;
        }else if(ds){
            $scope.fileName2  = file.name;
        }else{
            $scope.fileName = file.name;
        }
        var uploadURL = '';
        if (location.hostname === "localhost" || location.hostname === "127.0.0.1")
            uploadURL = appConfig.localHostUrl+'/upload/files?brand='+$rootScope.brandName ;
        else if (location.host === appConfig.locationHost)
            uploadURL = appConfig.developmentHostUrl+'/upload/files?brand='+$rootScope.brandName ;
        else
            uploadURL = appConfig.serverUrl+'/upload/files?brand='+$rootScope.brandName ;

        Upload.upload({
            url: uploadURL,
            data: {file: file, 'accessToken': $rootScope.User.AccessToken}
        }).then(function (resp) {
            if(q!=null){
                $scope.registrations.Questions.forEach(function(ele){
                    if(ele.ID == question.ID){
                        ele.Answer = resp.data.Path;
                    }
                });
            }else if(ds){
                //$scope.registrations.Registration.FileRecipt = resp.data.Path;
                $scope.registrations.Registration.ReceiptID[$scope.registrations.Registration.ReceiptID.length - 1].FileRecipt = resp.data.Path;
            }else{
                //$scope.registrations.Registration.File = resp.data.Path;
                $scope.registrations.Registration.ReceiptID[$scope.registrations.Registration.ReceiptID.length - 1].FileRecipt = resp.data.Path;
            }
            Notification.success("קובץ הועלה");
            $scope.isClicked = false;

        }, function (resp) {
            console.log('Error status: ' + resp.status);
        }, function (evt) {
            var progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
            console.log('progress: ' + progressPercentage);
        });

    }

    $scope.trustSrc = function (src) {
        return $sce.trustAsResourceUrl(src);
    };

    $scope.isFullyPaid = function(){
        if(!$scope.registrations || ! $scope.registrations.Registration.ReceiptID)
            return false;
        var total = 0;
        $scope.registrations.Registration.ReceiptID.forEach(function(receipt){
            if(receipt.PaymentType == 4 && receipt.ChecksData.length > 0 && Array.isArray(receipt.ChecksData))
                receipt.ChecksData.forEach(function(check){
                    total += Number(check.CheckAmount);
                })
            else
                total += Number(receipt.Sum);
        })
        var ReceiptTotal = 0;
        $scope.allRegistrationsForReceipt.forEach(function(data){
            ReceiptTotal += data.FinalPrice;
        })
        return total >= ( ReceiptTotal +  $scope.registrations.Registration.DonationAmount);
    }

    $scope.getMissingPaymentAmount = function(){
        var total = 0;
        $scope.registrations.Registration.ReceiptID.forEach(function(receipt){
            if(receipt.PaymentType == 4 && receipt.ChecksData.length > 0 && Array.isArray(receipt.ChecksData))
                receipt.ChecksData.forEach(function(check){
                    total += Number(check.CheckAmount);
                })
            else
                total += Number(receipt.Sum);
        })
        return ( $scope.registrations.Registration.FinalPrice +  $scope.registrations.Registration.DonationAmount) - total;
    }

    $scope.addEmptyPayment = function () {
        $scope.registrations.Registration.ReceiptID.push({
            PaymentType: undefined,
            Sum: $scope.getMissingPaymentAmount(),
        });
        $scope.emptyPaymentAdded = true;
    }

    /**
     * Check the payment type
     */
    $scope.setPaymentType = function () {
        var payment = $scope.registrations.Registration.ReceiptID[$scope.registrations.Registration.ReceiptID.length - 1];
        if (payment.PaymentType == 3) {
            settingsEndpoint.accountancy.banks.get(function (data) {
                $scope.banks = data;
            })
        } else {
            if (payment.PaymentType == 1) {
                $scope.getIframe(payment);
                if(payment.interval)
                    $interval.cancel(payment.interval);
                payment.interval = $interval(function () {
                    if (!params) {
                        var params = {};
                        params.DealID = payment.DealID;
                    }
                    if ($scope.success) {
                        $interval.cancel(payment.interval);
                        return;
                    }
                    if (appConfig.paymentyCompany == 1) {
                        tranzilaEndpoint.valid.post(params, function (data) {
                            if (data) {
                                if (data.success) {
                                    Notification.success("עסקה בוצעה בהצלחה!");
                                } else {
                                    Notification.error("שגיאה");
                                    $scope.removeEmptyPayment();
                                }
                                $scope.getFullRegistration();
                                $interval.cancel(payment.interval);
                            }

                        })
                    } else {
                        pelecardEndpoint.valid.post(params, function (data) {
                            if (data) {
                                if (data.success) {
                                    Notification.success("עסקה בוצעה בהצלחה!");
                                } else {
                                    Notification.error("שגיאה");
                                    $scope.removeEmptyPayment();
                                }
                                $scope.getFullRegistration();
                                $interval.cancel(payment.interval);
                            }

                        })
                    }

                }, 4000);
            } else if (payment.interval)
                $interval.cancel(payment.interval);
        }

        if (payment.PaymentType === 4) {
            payment.ChecksData = [];
        }
    };

    /**
     * Get pelecrd iframe
     */
    $scope.getIframe = function (receipt) {
        var params = {
            Amount: receipt.Sum,
            RegistrationID: $scope.registrations.Registration.ID
        };
        if (appConfig.paymentyCompany == 1)
            tranzilaEndpoint.get(params, function (data) {
                receipt.iframe = data.Iframe;
                receipt.DealID = data.DealID;
            });
        else
            pelecardEndpoint.get(params, function (data) {
                receipt.iframe = data.Iframe;
                receipt.DealID = data.DealID;
            });

    };

    $scope.trustSrc = function (src) {
        return $sce.trustAsResourceUrl(src);
    };

    $scope.savePayment = function (payment) {
        payment.StudentID = $scope.registrations.Registration.StudentID;
        payment.RegistrationID = $scope.registrations.Registration.ID;
        payment.Amount = payment.Sum;
        if(payment.PaymentType == 4)
            payment.ChecksData = JSON.stringify(payment.ChecksData);
        studentsEndpoint.registrations.payments.post(payment,function(data){
            if(data.success){
                Notification.success("עסקה בוצעה בהצלחה!");
                $scope.new
            } else {
                Notification.error("שגיאה");
                $scope.emptyPaymentAdded = false;
            }
            $scope.getFullRegistration();
        })
    }

    $scope.removeEmptyPayment = function(){
        $scope.registrations.Registration.ReceiptID.pop();
        $scope.emptyPaymentAdded = false;
    }

    $scope.generateChecks = function () {
        var receipt = $scope.registrations.Registration.ReceiptID[$scope.registrations.Registration.ReceiptID.length - 1];
        receipt.ChecksData = [];
        for (var i = 0; i < receipt.NumberOfCheck; i++) {
            receipt.ChecksData.push({
                CheckNumber: undefined,
                CheckMaturityDate: undefined,
                CheckAmount: undefined,
            });
        }
    };

    $scope.uploadSigneInfoFile = function () {
        $mdDialog.show({
            controller         : 'UploadController',
            templateUrl        : 'app/upload/upload.html',
            clickOutsideToClose: false,
            locals: {
                uploadTo: 'students/' + $scope.registrations.Registration.StudentID + '/registrations',
                uploadID: $scope.registrations.Registration.ID,
                restrictTo: ['pdf']
            }
        });
    };
}

angular.module('app.pages.events').controller('CancelRegistrationDialogController', ['$scope', '$rootScope', '$mdDialog','studentsEndpoint','student','$location','Notification','event','eventsEndpoint','registration','external','externalRegistrationEndpoint', function ($scope, $rootScope, $mdDialog,studentsEndpoint,student,$location,Notification,event,eventsEndpoint,registration,external,externalRegistrationEndpoint) {


    $scope.registration = registration;
    $scope.registration.FinalPrice= parseInt($scope.registration.FinalPrice);

    /**
     * Send cancel Registration request
     */
    $scope.cancelReg = function () {
        $scope.cancelRegistration.ReceiptID =  $scope.registration.ReceiptID;
        $scope.cancelRegistration.RegistrationID =  $scope.registration.ID;
        $scope.cancelRegistration.StudentID = registration.StudentID;
        $scope.isClikced=true;
        if (!external)
            studentsEndpoint.events.cancel.post($scope.cancelRegistration,function (data) {
                if (typeof data =='string')
                    Notification.error(data);
                else if (data.success)
                    Notification.success("פעולה הסתיימה בהצלחה");
                else
                    Notification.error("פעולה נכשלה");
                $scope.isClikced=false;
                $mdDialog.hide();
            });
        else
            externalRegistrationEndpoint.registrations.cancel.post($scope.cancelRegistration,function (data) {
                if (typeof data =='string')
                    Notification.error(data);
                else if (data.success)
                    Notification.success("פעולה הסתיימה בהצלחה");
                else
                    Notification.error("פעולה נכשלה");
                $scope.isClikced=false;
                $mdDialog.hide();
            })

    };


    /**
     * Close the dialog
     */
    $scope.closeDialog =function () {
        $mdDialog.cancel();
    };




}]);

(function ()
{
    'use strict';

    angular
        .module('app.pages.contacts', ['datatables'])
        .config(config).run(run);

    function run($rootScope,msNavigationService) {
        $rootScope.$watch('User',function () {
            msNavigationService.saveItem('pages.contacts', {
                title : 'אנשי קשר',
                icon  : 'icon-account-box',
                state: 'app.pages_contacts',
                weight: 7
            });


        });

    }


    /** @ngInject */
    function config($stateProvider)
    {
        $stateProvider.state('app.pages_contacts', {
            url      : '/contacts',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/pages/contacts/contacts.html',
                    controller: 'ContactsController as vm'
                }
            },
            resolve  : {
                DashboardData: function (ValidToken)
                {
                    ValidToken.validUserToken();
                    localStorage.setItem("path",'/contacts');
                }
            },
            bodyClass: 'contacts'
        })





    }

})();

angular.module('app.pages.contacts').controller('NewContactDialogController', ['$scope', '$rootScope', '$mdDialog','contactsEndpoint','$location','Notification','branchesEndpoint','groupsEndpoint', function ($scope, $rootScope, $mdDialog,contactsEndpoint,$location,Notification,branchesEndpoint,groupsEndpoint) {



    $scope.init = function(){
        $scope.selectedBranches = [];
        $scope.selectedGroups = [];
        $scope.phoneChecked = false
        if($location.url().indexOf('branch') === -1 && $location.url().indexOf('group') === -1){//if in branch page, no need to attach branches and groups
            $scope.getBranches();
            $scope.getGroups();
        }
    }

    /**
     * Save new Student
     */
    $scope.saveNewContact = function () {
        $scope.isClicked = true;
        if($location.url().indexOf('branch') === -1 && $location.url().indexOf('group') === -1) {//if in branch page, no need to attach branches and groups
            $scope.newContact.Branches = $scope.selectedBranches.map(function(branch){
                return branch.ID;
            });
            $scope.newContact.Groups = $scope.selectedGroups.map(function(group){
                return group.ID;
            });
        } else {
            var search = $location.search();
            if($scope.newContact.ID){
                if($location.url().indexOf('branch') !== -1){
                    $scope.newContact.Branches.push(search.ID)
                }
                if($location.url().indexOf('group') !== -1){
                    $scope.newContact.Groups.push(search.ID)
                }
            }
            else {
                if($location.url().indexOf('branch') !== -1){
                    $scope.newContact.Branches = [search.ID]
                }
                if($location.url().indexOf('group') !== -1){
                    $scope.newContact.Groups = [search.ID]
                }
            }
        }

        if($scope.newContact.ID){
            contactsEndpoint.update.post($scope.newContact,function (data) {
                $scope.isClicked = false;
                Notification.info("איש קשר נוצר בהצלחה")
                $mdDialog.hide();
            });
        } else {
            contactsEndpoint.post($scope.newContact,function (data) {
                $scope.isClicked = false;
                Notification.info("איש קשר נוצר בהצלחה")
                $mdDialog.hide();
            }) ;
        }


    };

    /**
     * Get All Branches And Groups
     */
    $scope.getBranches =function () {
        $scope.editEd = !$scope.editEd;
        var params = {};
        params.Status =1;
        branchesEndpoint.get(params,function (data) {
            $scope.branches = data;
        });

    };

    function createFilterFor(query) {
        var lowercaseQuery = angular.lowercase(query);
        return function filterFn(item) {
            return (item.Name.indexOf(lowercaseQuery) != -1);
        };
    }

    $scope.getGroups = function(){
        $scope.editEd = !$scope.editEd;
        var params = {};
        params.Status =1;
        groupsEndpoint.get(params,function(data){
            $scope.groups = data;
        });
    }

    $scope.branchesQuerySearch = function (query) {
        var results = query ?
            $scope.branches.filter(createFilterFor(query)) : [];
        return results;
    };

    $scope.groupsQuerySearch = function (query) {
        var results = query ?
            $scope.groups.filter(createFilterFor(query)) : [];
        return results;
    };

    $scope.checkForPhone = function(){
        var phone = $scope.newContact.Phone;
        if(phone.length != 10)
            return;
        contactsEndpoint.get({Phone:phone},function (data) {
            if(data.length){//existing contact
                $scope.newContact = data[0];
            } else {
                $scope.phoneChecked = true;
            }
        })
    }

    /**
     * Close the dialog
     */
    $scope.closeDialog =function () {
        $mdDialog.cancel();
    };

}]);

angular.module('app.pages.contacts').controller('ContactsPanelController', ContactsPanelController);
function ContactsPanelController($scope,contact,$rootScope,branchesEndpoint,groupsEndpoint) {



    /**
     * Set the current Contact
     */
    $scope.$on('selectedContact:updated', function () {
        $scope.contact = contact.selectedContact;
        $scope.selectedBranches = [];
        $scope.selectedGroups = [];

        if(contact.branches){
            $scope.branches = contact.branches;
            $scope.branches.forEach(function (branch) {
                if($scope.contact.Branches.indexOf(branch.ID) !== -1)
                    $scope.selectedBranches.push(branch);
            });
        }

        if(contact.groups){
            $scope.groups = contact.groups;
            $scope.groups.forEach(function (group) {
                if($scope.contact.Groups.indexOf(group.ID) !== -1)
                    $scope.selectedGroups.push(group);
            });
        }
    });

    /**
     * Get changes in the contact object
     */
    $scope.$watchCollection('contact', function (newValue, oldValue) {
        if(oldValue)
            $rootScope.editDataHandler(newValue, oldValue, 'contact-panel')
    });

    $scope.$watchCollection('selectedBranches', function (newValue, oldValue) {
        if(newValue && oldValue) {
            var str = [];
            $scope.contact.Branches = newValue.map(function (branch) {
                str.push(branch.Name);
                return branch.ID;
            });
            $scope.contact.branchesString = str.join(',');
        }
    });

    $scope.$watchCollection('selectedGroups', function (newValue, oldValue) {
        if(newValue && oldValue) {
            var str = [];
            $scope.contact.Groups = newValue.map(function (group) {
                str.push(group.Name);
                return group.ID;
            });
            $scope.contact.groupsString = str.join(',');
        }
    });

    /**
     * Get All Branches And Groups
     */
    $scope.getBranches =function () {
        $scope.editEd = !$scope.editEd;
        var params = {};
        params.Status =1;
        branchesEndpoint.get(params,function (data) {
            $scope.branches = data;
            $scope.branches.forEach(function (branch) {
                if($scope.contact.Branches.indexOf(branch.ID) !== -1)
                    $scope.selectedBranches.push(branch);
            })
        });

    };

    function createFilterFor(query) {
        var lowercaseQuery = angular.lowercase(query);
        return function filterFn(item) {
            return (item.Name.indexOf(lowercaseQuery) !== -1);
        };
    }

    $scope.getGroups = function(){
        $scope.editEd = !$scope.editEd;
        var params = {};
        params.Status =1;
        groupsEndpoint.get(params,function(data){
            $scope.groups = data;
            $scope.groups.forEach(function (group) {
                if($scope.contact.Groups.indexOf(group.ID) != -1)
                    $scope.selectedGroups.push(group);
            })
        });
    }

    $scope.branchesQuerySearch = function (query) {
        var results = query ?
            $scope.branches.filter(createFilterFor(query)) : [];
        return results;
    };

    $scope.groupsQuerySearch = function (query) {
        var results = query ?
            $scope.groups.filter(createFilterFor(query)) : [];
        return results;
    };

    $scope.$watchCollection('vm.contact-panel',function (newValue, oldValue) {
        $rootScope.editDataHandler(newValue, oldValue,'contact-panel')
    });
}

(function ()
{
    'use strict';

    angular
        .module('app.pages.new-admin', [])
        .config(config);


    /** @ngInject */
    function config($stateProvider)
    {

        $stateProvider.state('app.pages_new-admin', {
            url      : '/new-admin',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/pages/admin/new-admin/new-admin.html',
                    controller : 'NewAdminController'
                }
            },
            bodyClass: 'profile'
        });

    }

})();
angular.module('app.pages.new-admin').controller('NewAdminController', NewAdminController);
function NewAdminController($scope, $rootScope,$location,adminEndpoint,Notification,$timeout,appConfig,$cookies) {


    $scope.showHideText = 'הצג';
    $scope.inputType = 'password';
    $scope.showHideImg = "/assets/icons/show.svg";
    $scope.matchPasswords = false;
    $scope.matchFlags = true;
    $scope.password = '';
    $scope.passwordVerify = '';
    $scope.form = {};
    $scope.appConfig = appConfig;
    $scope.success = false;
    $scope.loading = false;
    $scope.errorInfo = "";

    /**
     * Valid the new admin request for register a new admin
     */
    $scope.validRequest = function () {
        var params = {};
        params.token =  $location.search().tempToken;
        adminEndpoint.new.valid.post(params,function (data) {
            if (data.ID) {
                $scope.form.email= data.Email;
                $scope.valid=true;
            }
            else{
                $location.path("/");
                $scope.notValid=true;
            }

        })
    };

    $scope.matchPass = function () {
        if ($scope.form.password == $scope.passwordVerify && $scope.form.password.length > 5) {
            $scope.matchPasswords = true;
            $scope.matchFlags = true;
        } else if ($scope.form.password == $scope.passwordVerify && $scope.form.password.length < 6) {
            $scope.shortPass = true;
            $scope.matchFlags = true;
        } else {
            $scope.shortPass = false;
            $scope.matchPasswords = false;
            $scope.matchFlags = false;
        }
    }

    /**
     * Display or hide the password
     */
    $scope.showHidePassword = function () {
        if ($scope.inputType == "password") {
            $scope.inputType = "text";
            $scope.showHideText = 'הסתר';
            $scope.showHideImg = "/assets/icons/hide.svg";
        } else {
            $scope.inputType = "password";
            $scope.showHideText = 'הצג';
            $scope.showHideImg = "/assets/icons/show.svg";
        }

    };

    /**
     * Submit the new admin sing up
     */
    $scope.submit = function () {
        $scope.form.token = $location.search().tempToken;
        adminEndpoint.new.post($scope.form, function (data) {
            if (typeof data == 'string' || data instanceof String) {
                $scope.errorInfo = data;
                $scope.fail = true;
                $timeout(function () {
                    $scope.fail = false;
                }, 5000);
            }
            else if (data.ID) {
                $rootScope.User = data;
                setUserType();
                saveUser();
                $scope.success = true;
            }
            else
                $scope.errorInfo = "Error!";
            $scope.loading = true;
        })

    };

    /**
     * Set the admin type
     */
    function setUserType() {
        if ($rootScope.User.StudentID)
            $rootScope.AdminLevel = 1;
        else if ($rootScope.User.IsCoordinator)
            $rootScope.AdminLevel = 2;
        else
            $rootScope.AdminLevel = 3;
    }

    function saveUser() {
        var expireTime = +new Date() + (24 * 3600000);
        $cookies.put("marvilixAccessToken", $rootScope.User.AccessToken, [{expires: expireTime}]);
        $scope.loogin = false;
        $timeout(function () {
            if ($rootScope.AdminLevel !== 3)
                $location.path('/students');
            else
                $location.path('/dashboard');
        }, 250)
    }



    /**
     * href to login page
     */
    $scope.goToLogin = function () {
        $location.path("/");
    };

}
(function ()
{
    'use strict';

    angular.module('app.pages.admin-profile', []).config(config);


    /** @ngInject */
    function config($stateProvider)
    {

        $stateProvider.state('app.pages_admin-profile', {
            url      : '/admin-profile',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/pages/admin/admin-profile/admin-profile.html',
                    controller : 'AdminProfileController'
                }
            },
            bodyClass: 'profile'
        });

    }

})();
angular.module('app.pages.admin-profile').controller('AdminProfileController', AdminProfileController);
function AdminProfileController($scope, $rootScope,$location,adminEndpoint,Notification) {


    if (!$rootScope.User)
        $location.path('/dashboard');

    $scope.goodFile = true;

    /**************************************************************** EDIT FUNCTIONS START ****************************************************************/
    /**
     * Update admin
     */
    $scope.editAdmin = function () {
        $scope.isClicked = true;
        var params = {
            ID: $rootScope.User.ID,
            FirstName: $rootScope.User.FirstName,
            LastName: $rootScope.User.LastName,
            Email: $rootScope.User.Email,
            Image: $rootScope.User.ProfileImage
        };
        adminEndpoint.update.post($rootScope.User.ID, params, function (data) {
            $scope.isClicked = false;
            if (!data.success)
                Notification.error("נכשל בשמירת נתונים");
            else
                Notification.success("פרופיל עודכן בהצלחה!");
        })
    };

    /**
     * Check file size
     */
    $scope.checkSize = function (file) {
        var image = file;
        if (image && image.name) {
            console.log(image)
            var size = image.size / 1024;
            if (!image.type.includes('image')) {
                Notification.info("הקובץ חייב להיות תמונה");
                image.value = "";
                $rootScope.User.ProfileImage = null;
                $scope.goodFile = false;
            }
            if (size > 2000) {
                Notification.info("גודל קובץ מקסימלי - 2MB");
                image.value = "";
                $rootScope.User.ProfileImage = null;
                $scope.goodFile = false;
            } else {
                if (image && image.name) {
                    var reader = new FileReader();
                    reader.onload = function (e) {
                        $rootScope.User.ProfileImage = e.target.result;
                    }
                    reader.readAsDataURL(image);
                    $scope.goodFile = true;
                    var fakeInput = document.getElementById('fake-input');
                    fakeInput.innerHTML = image.name;
                }
            }
        }
    };

    /**
     * Update the admin password
     */
    $scope.updatePassword = function () {
        var params = {
            ID: $rootScope.User.ID,
            oldPass: $rootScope.User.oldPassword,
            newPass: $rootScope.User.newPassword
        };
        adminEndpoint.password.post($rootScope.User.ID, params, function (data) {
            $scope.isClicked = false;
            if (data == 'nomatch')
                Notification.error("הסיסמא הנוכחית שהזנת - שגויה");
            else if (!data.success)
                Notification.error("נכשל בשמירת נתונים");
            else {
                $rootScope.User.oldPassword = '';
                $rootScope.User.newPassword = '';
                $rootScope.User.newPasswordConfirmation = '';
                Notification.success("סיסמא עודכנה בהצלחה!");
            }
        })
    };
    /**************************************************************** EDIT FUNCTIONS END ****************************************************************/

}
angular.module('app.pages.manage-admins').controller('ManageAdminsController', ManageAdminsController );
function ManageAdminsController($scope,$mdSidenav,$mdDialog,adminEndpoint, $document,adminProfile,Notification,DTOptionsBuilder,dtOptions) {


    $scope.admins = [];
    /**
     * Resent invasions  to admin
     * @param admin
     */
    $scope.sendAgain = function (admin) {
        adminEndpoint.post(admin, function (data) {
            if (data.ID)
                Notification.success("הזמנה נשלחה בהצלחה");
            else
                Notification.error("נכשל בשליחת הזמנה");

        })
    };


    /**
     * Get all admins
     */
    $scope.getAdmins = function () {
        $scope.admins = false;
        adminEndpoint.get($scope.search, function (data) {
            if (data)
                $scope.admins = data;
        });

    };

    /**
     * Open new user dialog
     * @param ev
     */
    $scope.openNewAdminUserDialog = function (ev) {
        $mdDialog.show({
            controller: 'NewAdminDialogController',
            controllerAs: '$scope',
            templateUrl: 'app/main/pages/admin/admin-management/new-admin-dialog/new-admin-dialog.html',
            parent: angular.element($document.find('#content-container')),
        }).then(function () {
            $scope.getAdmins();
        });
    };

    /**
     * Edit Admin Profile
     */
    $scope.editAdminProfile = function (selectedAdmin) {
        adminProfile.updateAdminProfile(selectedAdmin);
        $mdSidenav("admin-profile-panel").open();
    };


    /**
     * Change admin Status
     * @param admin
     */
    $scope.changeAdminStatus = function (admin) {
        statusSwitch(admin);
        adminEndpoint.update.post(admin.ID, admin, function (data) {
            if (!data.success)
                Notification.error('נכשל בעדכון')
        })
    };

    /**
     * Change the status online
     * @param admin
     */
    var statusSwitch = function (admin) {
        admin.Status = admin.Status === 1 ? 0 : 1;
    };

    /**
     * Set Table option
     * @type {any}
     */
    $scope.dtOptions = DTOptionsBuilder
        .newOptions()
        .withLanguage(dtOptions.language)
        .withDOM('lfrtp')
        .withOption('bFilter', false)
        .withOption('responsive', true)
        .withDOM('lrtip');


}
(function ()
{
    'use strict';

    angular
        .module('app.pages.activities', ['datatables'])
        .config(config).run(run);


    function run($rootScope,msNavigationService) {

        /**
         * Set the pages by the admin level
         */
        $rootScope.$watch('User',function () {
            if ($rootScope.User)
                msNavigationService.saveItem('pages.activities', {
                    title: $rootScope.User.Activities,
                    icon  : 'icon-leaf',
                    state: 'app.pages_activities',
                    weight: 6
                });
        });
    }

    /** @ngInject */
    function config($stateProvider)
    {
        $stateProvider.state('app.pages_activities', {
            url      : '/activities',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/pages/activities/activities.html',
                    controller: 'ActivitiesController'
                }
            },
            resolve  : {
                DashboardData: function (ValidToken)
                {
                    ValidToken.validUserToken();
                    localStorage.setItem("path",'/activities');
                }
            }
        })
    }

})();

angular.module('app.pages.activities').controller('NewActivitiesDialogController',NewActivitiesDialogController)
function NewActivitiesDialogController($scope, $rootScope, $mdDialog,activitiesEndpoint,student,$location,Notification,groupsEndpoint,branchesEndpoint,activities) {


    /**
     * Get All Branches
     */
    $scope.getBranches = function () {
        var params = {};
        params.Status = 1;
        if ($rootScope.AdminLevel === 1)
            $scope.getGroups(true);
        else
            branchesEndpoint.get(params, function (data) {
                $scope.branches = data;
            })
    };

    /**
     * Get Groups
     * @param withNoParams
     */
    $scope.getGroups = function (withNoParams) {
        var params = {};
        if (!withNoParams) {
            params.BranchIdes = [];
            params.BranchIdes.push($scope.newActivities.BranchID);
            params.BranchIdes = JSON.stringify(params.BranchIdes);
            params.Status = 1;
        }
        groupsEndpoint.get(params, function (data) {
            $scope.groups = data;
        })
    };

    /**
     * Save new Activities
     * @param profile
     */
    $scope.saveNewActivities = function (profile) {
        $scope.isClicked = true;
        activitiesEndpoint.post($scope.newActivities, function (data) {
            $scope.isClicked = false;
            if (!data.ID) {
                Notification.info("שגיאה");
            }
            else {
                if (profile) {
                    activities.updateSelectedActivities(data);
                    $location.path("activities-profile")
                }

            }
            $mdDialog.hide();
        })
    };

    /**
     * Close the dialog
     */
    $scope.closeDialog = function () {
        $mdDialog.cancel();
    };

}

(function ()
{
    'use strict';

    angular
        .module('app.pages.activities-profile', ['datatables'])
        .config(config);


    /** @ngInject */
    function config($stateProvider)
    {
        $stateProvider.state('app.pages_activities-profile', {
            url      : '/activities-profile',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/pages/activities/activities-profile/activities-profile.html',
                    controller: 'ActivitiesProfileController'
                }
            },
            resolve  : {
                DashboardData: function ()
                {
                    localStorage.setItem("path",'/activities-profile');
                }
            },
            bodyClass: 'activities-profile'
        });


    }

})();
angular.module('app.pages.activities-profile').controller('ActivitiesProfileController', ActivitiesProfileController);
function ActivitiesProfileController($scope, $rootScope,$location,usersEndpoint,$mdSidenav,$mdDialog, DTOptionsBuilder,$timeout,activities,activitiesEndpoint,parent,dtOptions,Notification) {

    $scope.selectedTab = 0;
    $scope.count = 0;
    $scope.newUser = false;

    /**
     * Set The activities from service or from local storge
     */
    $scope.activities = activities.selectedActivities;
    if (!$scope.activities) {
        $scope.activities = JSON.parse(localStorage.getItem('selectedActivates'));
        if (!$scope.activities)
            $location.path('/activities');
    }
    else
        localStorage.setItem("selectedActivates", JSON.stringify(activities.selectedActivities));
    $timeout(function () {
        $scope.getAttendanceStudents()

    }, 200);


    /**
     * Look for changes in the activities object
     */
    $scope.$watchCollection('activities', function (newValue, oldValue) {
        if (typeof  $rootScope.editDataHandler === 'function')
            $rootScope.editDataHandler(newValue, oldValue, 'activities-panel')
    });

    /**
     * Get Students Attendance
     */
    $scope.getAttendanceStudents = function () {
        activitiesEndpoint.attendance.get($scope.activities, function (data) {
            $scope.attendance = data;
        })
    };

    /**
     * Update Student Attendance
     * @param student
     */
    $scope.updateStudentAttendance = function (student) {
        if (student.Attendance == 1)
            student.Attendance = 0;
        else
            student.Attendance = 1;
        activitiesEndpoint.attendance.post($scope.activities, student, function (data) {
            if (!data.success)
                Notification.info("ארעה שגיאה");
        })
    };

    /**
     * Set Table option
     * @type {any}
     */
    $scope.dtOptions = DTOptionsBuilder
        .newOptions()
        .withLanguage(dtOptions.language)
        .withDOM('lfrtp')
        .withOption('bFilter', false)
        .withDOM('lrtip');


}
angular.module('app.pages.activities').controller('ActivitiesPanelController', ActivitiesPanelController);
function ActivitiesPanelController($scope,activities,$rootScope) {

    /**
     * Set the current Activities
     */
    $scope.$on('selectedActivities:updated', function () {
        $scope.activities = activities.selectedActivities;
    });


    /**
     * Get changes in the activities object
     */
    $scope.$watchCollection('activities', function (newValue, oldValue) {
        $rootScope.editDataHandler(newValue, oldValue, 'activities-panel')
    })

}
(function ()
{
    'use strict';

    angular
        .module('app.ui.page-layouts.blank', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        $stateProvider.state('app.ui_page-layouts_blank', {
            url  : '/ui/page-layouts/blank',
            views: {
                'content@app': {
                    templateUrl: 'app/main/ui/page-layouts/blank/blank.html',
                    controller : 'BlankController as vm'
                }
            }
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.ui.page-layouts.blank')
        .controller('BlankController', BlankController);

    /** @ngInject */
    function BlankController()
    {
        // Data

        // Methods

        //////////
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core',
            [
                'ngAnimate',
                'ngAria',
                'ngCookies',
                'ngMessages',
                'ngResource',
                'ngSanitize',
                'ngMaterial',
                'pascalprecht.translate',
                'ui.router',
                'ui-notification',
                'chart.js',
                'vsGoogleAutocomplete',
                'moment-picker',
                'materialCalendar',
                'ckeditor',
                'angular-timeline',
                'ngProgress'
            ]);
})();

angular.module('app.core').factory('usersEndpoint', ['API', function (API) {

    return {
        users: {
            post: function (user,handler) {
                API.sendRequest("/users", 'POST', user, handler,true);
            },
            get: function (handler) {
                API.sendRequest("/users", 'GET', null, handler,true);
            },
            update : {
                post: function (userID,user,handler) {
                    API.sendRequest("/users/"+userID+"/update", 'POST', user, handler,true);
                }
            },
            delete : {
                post: function (userID,handler) {
                    API.sendRequest("/users/"+userID+"/delete", 'POST', null, handler,true);
                }
            }
            ,
            code : {
                get: function (userID,handler) {
                    API.sendRequest("/users/"+userID+"/codes", 'GET', null, handler,true);
                },
                post: function (userID,params,handler) {
                    API.sendRequest("/users/"+userID+"/codes", 'POST', params, handler,true);
                },
                delete : {
                    post: function (codeID,userID, handler) {
                        API.sendRequest("/users/" + userID + "/codes/" +codeID +"/delete", 'POST', null, handler, true);
                    }
                },
                update: {
                    post: function (codeID,userID,params, handler) {
                        API.sendRequest("/users/" + userID + "/codes/" +codeID +"/update", 'POST', params, handler, true);
                    }
                }
            }

        }

    }

}]);

angular.module('app.core').factory('tranzilaEndpoint', ['API', function (API) {

    return {
        get: function (params,handler) {
            API.sendRequest("/tranzila/iframe", 'POST', params, handler, true);
        },
        valid : {
            post: function (params,handler) {
                API.sendRequest("/tranzila/valid", 'POST', params, handler, true);
            }
        }
    }
}]);

angular.module('app.core').factory('transportationEndpoint', ['API', function (API) {

    return {
        get: function (handler) {
            API.sendRequest("/transportation", 'GET', null, handler, true);
        },
        post: function (transportation,handler) {
            API.sendRequest("/transportation", 'POST', transportation, handler, true);
        },
        update : {
            post: function (transportation,handler) {
                API.sendRequest("/transportation/"+transportation.ID+"/update", 'POST', transportation, handler, true);
            }
        },
        delete : {
            post: function (transportation,handler) {
                API.sendRequest("/transportation/"+transportation.ID+"/delete", 'POST', null, handler, true);
            }
        }
    }
}]);

angular.module('app.core').factory('tagsEndpoint', ['API', function (API) {

    return {
        get: function (params,handler) {
            API.sendRequest("/tags", 'GET', params, handler, true);
        },
        post: function (tags,handler) {
            API.sendRequest("/tags", 'POST', tags, handler, true);
        }


    }
}]);

angular.module('app.core').factory('systemSettingsEndpoint', ['API', function (API) {

    return {
        names: {
            post: function (params, handler) {
                API.sendRequest("/system-settings/names", 'POST', params, handler, true);
            },
            get: function (handler) {
                API.sendRequest("/system-settings/names", 'GET', null, handler, true);
            }
        },
        birthday: {
            post: function (params, handler) {
                API.sendRequest("/system-settings/birthday", 'POST', params, handler, true);
            },
            get: function (handler) {
                API.sendRequest("/system-settings/birthday", 'GET', null, handler, true);
            }
        },
        terms: {
            get: function (handler) {
                API.sendRequest("/system-settings/terms", 'GET', null, handler, true);
            },
            post: function (params, handler) {
                API.sendRequest("/system-settings/terms", 'POST', params, handler, true);
            }
        },
        ProfilePopUpAlert: {
            get: function (handler) {
                API.sendRequest("/system-settings/profilePopUpAlert", 'GET', null, handler, true);
            },
            post: function (params, handler) {
                API.sendRequest("/system-settings/profilePopUpAlert", 'POST', params, handler, true);
            }
        },
        studentFields: {
            all: {
                get: function (params, handler) {
                    API.sendRequest("/system-settings/fetchAllStudentFields", "GET", null, handler, true);
                },
                post: function (params, handler) {
                    API.sendRequest("/system-settings/updateStudentFields", 'POST', params, handler, true);
                }
            },
        },
        studentExtraFields: {
            get: function (params, handler) {
                API.sendRequest("/system-settings/fetchAllExtraStudentFields", "GET", null, handler, true);
            },
            post: function (params, handler) {
                API.sendRequest("/system-settings/addStudentExtraFields", "POST", params, handler, true);
            },
            update: function (params, handler) {
                API.sendRequest("/system-settings/updateStudentExtraFields", "POST", params, handler, true);
            },
        }
    }
}]);

angular.module('app.core').factory('studentsEndpoint', ['API', function (API) {

    return {
        get: function (params, handler) {
            API.sendRequest("/students", 'GET', params, handler, true);
        },
        post: function (student, handler) {
            API.sendRequest("/students", 'POST', student, handler, true);
        },
        history: {
            get: function (studentID, handler) {
                API.sendRequest("/students/" + studentID + "/history", 'GET', null, handler, true);
            }
        },
        registrations: {
            get: function (studentID, handler) {
                API.sendRequest("/students/" + studentID + "/registrations", 'GET', null, handler, true);
            },
            fullRegistration: {
                get: function (registration, handler) {
                    API.sendRequest("/students/" + registration.StudentID + "/registrations/" + registration.ID, 'GET', null, handler, true);
                },
            },
            update: {
                post: function (registration, handler) {
                    API.sendRequest("/students/" + registration.StudentID + "/registrations/" + registration.ID + "/update", 'POST', registration, handler, true);
                },
            },
            confirm: {
                post: function (registration, handler) {
                    API.sendRequest("/students/" + registration.StudentID + "/registrations/" + registration.ID + "/confirm", 'POST', registration, handler, true);
                }
            },
            logs: {
                get: function (registration, handler) {
                    API.sendRequest("/students/" + registration.StudentID + "/registrations/" + registration.ID + "/logs", 'GET', null, handler, true);
                }
            },
            questions: {
                update: {
                    post: function (registration, questions, handler) {
                        API.sendRequest("/students/" + registration.StudentID + "/registrations/" + registration.ID + "/questions/update", 'POST', questions, handler, true);
                    }
                }
            },
            transportation: {
                update: {
                    post: function (registration, transportation, handler) {
                        API.sendRequest("/students/" + registration.StudentID + "/registrations/" + registration.ID + "/transportation/update", 'POST', transportation, handler, true);
                    }
                }
            },
            refunds: {
                get: function (registration, handler) {
                    API.sendRequest("/students/" + registration.StudentID + "/registrations/" + registration.ID + "/refunds/total", 'GET', null, handler, true);
                }
            },
            isRegistered: function (studentID, eventID, handler) {
                API.sendRequest("/students/" + studentID + "/checkRegistrations/" + eventID, 'GET', null, handler, true);
            },
            payments: {
                post: function (payment, handler) {
                    API.sendRequest("/students/" + payment.StudentID + "/registrations/" + payment.RegistrationID + "/payment", 'POST', payment, handler, true);
                }
            }
        },
        update: {
            post: function (student, handler) {
                API.sendRequest("/students/" + student.ID + "/update", 'POST', student, handler, true);
            }
        },
        family: {
            get: function (studentID, handler) {
                API.sendRequest("/students/" + studentID + "/family", 'GET', null, handler, true);
            }
        },
        parent: {
            post: function (student, parent, handler) {
                API.sendRequest("/students/" + student.ID + "/parent", 'POST', parent, handler, true);
            },
            delete: {
                post: function (studentID, parentID, handler) {
                    API.sendRequest("/students/" + studentID + "/parent/" + parentID + "/delete", 'POST', null, handler, true);
                }
            },
            get: function (studentID, handler) {
                API.sendRequest("/students/" + studentID + "/parents", 'GET', null, handler, true);
            }
        },
        groups: {
            get: function (student, params, handler) {
                API.sendRequest("/students/" + student.ID + "/groups/" + student.BranchID, 'GET', params, handler, true);
            },
            upgrade: {
                post: function (params, handler) {
                    API.sendRequest("/students/groups/upgrade", 'POST', params, handler, true);
                }
            }
        },
        scheduling: {
            post: function (student, params, handler) {
                API.sendRequest("/students/" + student.ID + "/scheduling", 'POST', params, handler, true);
            }
        },
        educator: {
            post: function (student, educator, handler) {
                API.sendRequest("/students/" + student.ID + "/educator", 'POST', educator, handler, true);
            }
        },
        studentPrivateID: {
            get: function (student, handler) {
                API.sendRequest("/students/" + student.PrivateID, 'GET', null, handler, true);
            }
        },
        events: {
            get: function (params, handler) {
                API.sendRequest("/students/" + params.ID + "/events/active", 'GET', null, handler, true);
            },
            post: function (params, handler) {
                API.sendRequest("/students/" + params.StudentID + "/events", 'POST', params, handler, true);
            },
            refund: {
                post: function (params, handler) {
                    API.sendRequest("/students/" + params.StudentID + "/events/refund", 'POST', params, handler, true);
                }
            },
            cancel: {
                post: function (params, handler) {
                    API.sendRequest("/students/" + params.StudentID + "/events/cancel", 'POST', params, handler, true);
                }
            }
        },
        contact: {
            get: function (studentID, handler) {
                API.sendRequest("/students/" + studentID + "/contact", 'GET', null, handler, true);
            }
        },
        sms: {
            post: function (params, handler) {
                API.sendRequest("/students/sms", 'POST', params, handler, true);
            }
        },
        email: {
            post: function (params, handler) {
                API.sendRequest("/students/email", 'POST', params, handler, true);
            }
        },
        grades: {
            upgrade: {
                post: function (params, handler) {
                    API.sendRequest("/students/grades/upgrade", 'POST', params, handler, true);
                }
            }
        },
        cancellation: {
            get: function (studentID, handler) {
                API.sendRequest("/students/" + studentID + "/cancellation", 'GET', null, handler, true);
            }
        },
        studentExtraFieldsValues: {
            get: function (studentID, handler) {
                API.sendRequest("/students/" + studentID + "/field-values", "GET", null, handler, true);
            },
            update: function (params, handler) {
                API.sendRequest("/students/" + params.studentID + "/field-values/update", "POST", {fields: params.fields}, handler, true);
            },
        },
        import: {
            template: {
                get: function (handler) {
                    API.sendRequest("/students/import/template", "GET", null, handler, true, true);
                },
            }
        }
    }
}]);


angular.module('app.core').factory('statisticsEndpoint', ['API', function (API) {

    return {
        get: function (params,handler) {
            API.sendRequest("/statistics", 'GET', params, handler, true);
        }
    }
}]);

angular.module('app.core').factory('smsEndpoint', ['API', function (API) {

    return {
        post: function (params,handler) {
            API.sendRequest("/sms", 'POST', params, handler, true);
        }
    }
}]);

angular.module('app.core').factory('settingsEndpoint', ['API', function (API) {

    return {
        post: function (params,handler) {
            API.sendRequest("/settings",'POST', params, handler, true);
        },
        updates : {
            get: function (handler) {
                API.sendRequest("/settings/updates",'GET', null, handler, true);
            }
        },
        forms: {
            emails: {
                get: function (handler) {
                    API.sendRequest("/settings/forms/emails",'GET', null, handler, true);
                }
            }
        },
        accountancy : {
            get: function (handler) {
                API.sendRequest("/settings/accountancy",'GET', null, handler, true);
            },
            post: function (data,handler) {
                API.sendRequest("/settings/accountancy",'POST', data, handler, true);
            },
            banks : {
                get: function (handler) {
                    API.sendRequest("/settings/accountancy/banks",'GET', null, handler, true);
                }
            },
            maxPayments:{
                get:function (handler) {
                    API.sendRequest("/settings/accountancy/globalMaxNumOfPayments",'GET', null, handler, true);
                },
            }
        },
        profile : {
            get: function (handler) {
                API.sendRequest("/settings/profile",'GET', null, handler, true);
            },
            post: function (settings,handler) {
                API.sendRequest("/settings/profile",'POST', settings, handler, true);
            },
            images : {
                get: function (handler) {
                    API.sendRequest("/settings/profile/images",'GET', null, handler, true);
                },
                post: function (settings,handler) {
                    API.sendRequest("/settings/profile/images",'POST', settings, handler, true);
                },
            },

        },
        admin : {
            images: {
                get: function (handler) {
                    API.sendRequest("/settings/admin/images", 'GET', null, handler, false);
                },
                post: function (settings, handler) {
                    API.sendRequest("/settings/admin/images", 'POST', settings, handler, true);
                },
            }
        },
        external : {
            get: function(handler){
                API.sendRequest("/system-settings/external","GET",null,handler,false);
            },
            post: function(params,handler){
                API.sendRequest("/system-settings/external","POST",params,handler,false);
            }
        }
    }
}]);

angular.module('app.core').factory('searchEndpoint', ['API',"$rootScope","HttpSender","appConfig", function (API,$rootScope,HttpSender,appConfig) {

    return {
        get: function (params,handler) {
            let path = '/search';
            path = path+"?brand=" + $rootScope.brandName;
            if (!$rootScope.User)
                $location.path("/");
            if (location.hostname === "localhost" || location.hostname === "127.0.0.1") {
                path = appConfig.localHostUrl + path;
                path = path + "&XDEBUG_SESSION_START";
            }
            else if (location.host === appConfig.locationHost)
                path = appConfig.developmentHostUrl+path;
            else
                path = appConfig.serverUrl+path;
            return HttpSender.send(path, 'GET', params, false,$rootScope.User.AccessToken).then(response);
            function response(data) {
                if (data && handler) {
                    if (data==='Invalid Access Token') {
                        $location.path("/");
                    }
                    return handler(data);
                }
            }
            //API.sendRequest("/search", 'GET', params, handler, true);
        }
    }
}]);

angular.module('app.core').factory('rolesEndpoint', ['API', function (API) {

    return {
        get: function (params,handler) {
            API.sendRequest("/roles", 'GET', params, handler, true);
        },
        post: function (tags,handler) {
            API.sendRequest("/roles", 'POST', tags, handler, true);
        },
        educator : {
            get: function (params,handler) {
                API.sendRequest("/roles/educator", 'GET', params, handler, true);
            },
            post: function (tags,handler) {
                API.sendRequest("/roles/educator", 'POST', tags, handler, true);
            },
        }


    }
}]);

angular.module('app.core').factory('reportsEndpoint', ['API', function (API) {

    return {
        get: function (params,handler) {
            API.sendRequest("/reports",'GET', params, handler, true);
        },
        post: function (params,handler) {
            API.sendRequest("/reports",'POST', params, handler, true);
        },
        fields : {
            get: function (reportID,handler) {
                API.sendRequest("/reports/" +reportID +"/fields",'GET', null, handler, true);
            }
        },
        export : {
            get: function (reportID,handler) {
                API.sendRequest("/reports/" +reportID,'GET', null, handler, true,true);
            }
        },
        saveExport : {
            get: function (params,handler) {
                API.sendRequest("/reports/save/export",'GET', params, handler, true,true);
            },
        },
        delete : {
            post: function (reportID,handler) {
                API.sendRequest("/reports/" +reportID +"/delete",'POST', null, handler, true);
            },
        },
        movements : {
            get: function (params,handler) {
                API.sendRequest("/reports/movements/get", 'GET', params, handler, true,true);
            }
        }

    }
}]);

angular.module('app.core').factory('regionsEndpoint', ['API', function (API) {

    return {
        get: function (handler) {
            API.sendRequest("/regions", 'GET', null, handler, true);
        }
    }
}]);

angular.module('app.core').factory('regionalCouncilsEndpoint', ['API', function (API) {

    return {
        get: function (params,handler) {
            API.sendRequest("/regionalCouncils", 'GET', params, handler, true);
        },
        areas: {
            get: function (handler) {
                API.sendRequest("/regionalCouncils/areas", 'GET', null, handler, true);
            },
        }
    }
}]);

angular.module('app.core').factory('receiptsEndpoint', ['API', function (API) {

    return {
        get: function (params,handler) {
            API.sendRequest("/receipts", 'GET', params, handler, true);
        },
        getByReceiptID: function (params,handler) {
            API.sendRequest("/receipts/registrations/"+params, 'POST', params, handler, true);
        },
        matchDate : {
            update : {
                post: function (params,handler) {
                    API.sendRequest("/receipts/"+params.ReceiptID+"/match-date/update", 'POST', params, handler, true);
                }
            }
        }


    }
}]);

angular.module('app.core').factory('questionsEndpoint', ['API', function (API) {

    return {
        get: function (params,handler) {
            API.sendRequest("/questions", 'GET', params, handler, true);
        },
        post: function (params,handler) {
            API.sendRequest("/questions", 'POST', params, handler, true);
        },
        update : {
            post: function (question,handler) {
                API.sendRequest("/questions/"+question.ID+"/update", 'POST', question, handler, true);
            }
        },
        delete : {
            post: function (question,handler) {
                API.sendRequest("/questions/"+question.ID+"/delete", 'POST', null, handler, true);
            }
        }
    }
}]);

angular.module('app.core').factory('pelecardEndpoint', ['API', function (API) {

    return {
        get: function (params,handler) {
            API.sendRequest("/pelecard/iframe", 'POST', params, handler, true);
        },
        valid : {
            post: function (params,handler) {
                API.sendRequest("/pelecard/valid", 'POST', params, handler, true);
            }
        }
    }
}]);

angular.module('app.core').factory('paymentsEndpoint', ['API', function (API) {

    return {
        match: {
            get: function (params,handler) {
                API.sendRequest("/payments/match", 'GET', params, handler, true);
            },
            month : {
                get: function (handler) {
                    API.sendRequest("/payments/match/month", 'GET', null, handler, true);
                }
            }
        },
        fix: {
            post: function (params,handler) {
                API.sendRequest("/payments/fix", 'POST', params, handler, true);
            }
        },
        deals : {
            get: function (params,handler) {
                API.sendRequest("/payments/deals/"+params.DealID, 'GET', params, handler, true);
            }
        }


    }
}]);

angular.module('app.core').factory('parentsEndpoint', ['API', function (API) {

    return {
        get: function (params,handler) {
            API.sendRequest("/parents", 'GET', params, handler, true);
        },
        family : {
            get: function (parent,handler) {
                API.sendRequest("/parents/"+parent.ID+"/family", 'GET', null, handler, true);
            },
            delete : {
                post: function (selectedStudent,handler) {
                    API.sendRequest("/parents/"+selectedStudent.ParentID+"/students/"+selectedStudent.StudentID+"/delete", 'POST', selectedStudent, handler, true);
                },
            }
        },
        registration : {
            get: function (registrationID,handler) {
                API.sendRequest("/parents/registration/"+registrationID, 'GET', null, handler, true);
            },
        },
        update : {
            post: function (parent,handler) {
                API.sendRequest("/parents/"+parent.ID +"/update", 'POST', parent, handler, true);
            }
        },
        receipts : {
            get: function (parent,handler) {
                API.sendRequest("/parents/"+parent.ID+"/receipts", 'GET', null, handler, true);
            }
        },
        contact : {
            get: function (parent,handler) {
                API.sendRequest("/parents/"+parent.ID+"/contact", 'GET', null, handler, true);
            }
        },
        cash : {
            get: function (parent,handler) {
                API.sendRequest("/parents/"+parent.ID+"/cash", 'GET', null, handler, true);
            },
            delete: function (params,handler) {
                API.sendRequest("/parents/"+params.ParentID+"/cash/"+params.CashID+"/delete", 'POST', params, handler, true);
            },
        },
        subsidy : {
            get: function (parent,handler) {
                API.sendRequest("/parents/"+parent.ID+"/subsidy", 'GET', null, handler, true);
            },
            getByID: function (parentID,subsidyID,handler) {
                API.sendRequest("/parents/"+parentID+"/subsidy/"+subsidyID, 'GET', null, handler, true);
            },
            update : {
                post: function (subsidy,handler) {
                    API.sendRequest("/parents/subsidy/"+ subsidy.ID+"/update", 'POST', subsidy, handler, true);
                }
            }
        },
        cancellation : {
            get: function (parent,handler) {
                API.sendRequest("/parents/"+parent.ID+"/cancellation", 'GET', null, handler, true);
            }
        },
        registrations : {
            get: function (parent,handler) {
                API.sendRequest("/parents/"+parent.ID+"/registrations", 'GET', null, handler, true);
            }
        },
        password : {
            update : {
                post: function (parent,params,handler) {
                    API.sendRequest("/parents/"+parent.ID+"/password/update", 'POST', params, handler, true);
                }
            }

        }

    }
}]);

angular.module('app.core').factory('marketingEndpoint', ['API', function (API) {

    return {
        leads :{
            get: function (params,handler) {
                API.sendRequest("/marketing/leads", 'GET', params, handler, true);
            },
            events : {
                get: function (handler) {
                    API.sendRequest("/marketing/leads/events", 'GET', null, handler, true);
                }
            }
        }

    }
}]);

angular.module('app.core').factory('groupsEndpoint', ['API', function (API) {

    return {
        get: function (params, handler) {
            API.sendRequest('/groups', 'GET', params, handler, true);
        },
        post: function (group, handler) {
            API.sendRequest('/groups', 'POST', group, handler, true);
        },
        educators: {
            get: function (params, handler) {
                API.sendRequest('/groups/' + params.ID + '/educators', 'GET', {}, handler, true);
            }
        },
        update: {
            post: function (group, handler) {
                API.sendRequest('/groups/' + group.ID + '/update', 'POST', group, handler, true);
            }
        }
    }
}]);

angular.module('app.core').factory('gradesEndpoint', ['API', function (API) {

    return {
        get: function (params,handler) {
            API.sendRequest("/grades", 'GET', params, handler, true);
        },
        post: function (grades,handler) {
            API.sendRequest("/grades", 'POST', grades, handler, true);
        },
        update : {
            post: function (group,handler) {
                API.sendRequest("/grades/"+group.ID+"/update", 'POST', group, handler, true);
            }
        }
    }
}]);

angular.module('app.core').factory('formsEndpoint', ['API', function (API) {

    return {
        cancellation : {
            get: function (params,handler) {
                API.sendRequest("/forms/cancellation", 'GET', params, handler, true);
            },
            update : {
                post: function (form,handler) {
                    API.sendRequest("/forms/cancellation/"+form.ID+"/update", 'POST', form, handler, true);
                },
            }
        },
        contact : {
            get: function (params,handler) {
                API.sendRequest("/forms/contact", 'GET', params, handler, true);
            },
            getExcel: function (params,handler) {
                API.sendRequest("/forms/contact", 'GET', params, handler, true);
            },
            update : {
                post: function (form,handler) {
                    API.sendRequest("/forms/contact/"+form.ID+"/update", 'POST', form, handler, true);
                },
            }
        },
        subsidy : {
            get: function (params,handler) {
                API.sendRequest("/forms/subsidy", 'GET', params, handler, true);
            }
        }
    }
}]);

angular.module('app.core').factory('filesEndpoint', ['API', function (API) {

    return {
        get: function (prams,handler) {
            API.sendRequest("/files",'GET', prams, handler, true);
        },
        delete :{
            post: function (file,handler) {
                API.sendRequest("/files/"+file.ID+"/delete",'POST', null, handler, true);
            }
        },
        update : {
            post: function (file,handler) {
                API.sendRequest("/files/"+file.ID+"/update",'POST', file, handler, true);
            }
        }
    }
}]);

angular.module('app.core').factory('externalRegistrationEndpoint', ['API', function (API) {

    return {
        post: function (params,handler) {
            API.sendRequest("/external-registration/events/"+params.EventID+"/new-registration",'POST', params, handler, true);
        },
        subscribers : {
            get: function (params,handler) {
                API.sendRequest("/external-registration/events/"+params.EventID+"/subscribers",'GET', params, handler, true);
            },
        },
        tranzila : {
            get: function (params,handler) {
                API.sendRequest("/external-registration/tranzila",'GET', params, handler, true);
            },
            valid : {
                post: function (params,handler) {
                    API.sendRequest("/external-registration/tranzila/valid",'POST', params, handler, true);
                },
            }
        },
        registrations : {
            update : {
                post: function (registration,handler) {
                    API.sendRequest("/external-registration/registrations/"+registration.ID+"/update",'POST', registration, handler, true);
                },
            },
            payments : {
                update : {
                    post: function (params,handler) {
                        API.sendRequest("/external-registration/registrations/payment/status/update",'POST', params, handler, true);
                    },
                },
            },
            cancel : {
                post: function (params,handler) {
                    API.sendRequest("/external-registration/registrations/"+params.RegistrationID+"/cancel",'POST', params, handler, true);
                },
            },
            refund : {
                get: function (params,handler) {
                    API.sendRequest("/external-registration/"+params.ExternalUserID+"/registrations/"+params.ID+"/refunds/total",'GET', null, handler, true);
                },
                post: function (params,handler) {
                    API.sendRequest("/external-registration/registrations/"+params.RegistrationID+"/refund",'POST', params, handler, true);
                },
            },
            fullRegistration : {
                get: function (registration,handler) {
                    API.sendRequest("/external-registration/"+registration.ID,'GET', registration, handler, true);
                },
            },
            confirm : {
                post: function (registration,handler) {
                    API.sendRequest("/external-registration/"+registration.ID+"/confirm",'POST', registration, handler, true);
                }
            },
            questions : {
                update : {
                    post: function (registration,params,handler) {
                        API.sendRequest("/external-registration/"+registration.ID+"/questions/update",'POST', params, handler, true);
                    }
                }

            },
            logs : {
                get: function (registration,handler) {
                    API.sendRequest("/external-registration/"+registration.ID+"/logs",'GET', registration, handler, true);
                },
            }

        },

    }
}]);

angular.module('app.core').factory('externalDiscountsEndpoint', ['API', function (API) {

    return {
        post: function (params,handler) {
            API.sendRequest("/external-discounts-settings", 'POST', params, handler, true);
        },
        get: function (handler) {
            API.sendRequest("/external-discounts-settings", 'GET', null, handler, true);
        }
    };
}]);

angular.module('app.core').factory('eventsEndpoint', ['API', function (API) {

    return {
        get: function (params, handler) {
            API.sendRequest("/events", 'GET', params, handler, true);
        },
        getByGrades: function (params, handler) {
            API.sendRequest("/events/bygrades", 'GET', params, handler, true);
        },
        post: function (event, handler) {
            API.sendRequest("/events", 'POST', event, handler, true);
        },
        update: {
            post: function (event, handler) {
                API.sendRequest("/events/" + event.ID + "/update", 'POST', event, handler, true);
            }
        },
        price: {
            get: function (params, handler) {
                API.sendRequest("/events/price", 'GET', params, handler, true);
            }
        },
        association: {
            get: function (event, handler) {
                API.sendRequest("/events/" + event.ID + "/association", 'GET', null, handler, true);
            },
            update: {
                post: function (association, event, handler) {
                    API.sendRequest("/events/" + event.ID + "/association/update", 'POST', association, handler, true);
                }
            },
            branches: {
                get: function (event, handler) {
                    API.sendRequest("/events/" + event.ID + "/association/branch", 'GET', null, handler, true);
                },
                post: function (association, handler) {
                    API.sendRequest("/events/" + association.EventID + "/association/branch", 'POST', association, handler, true);
                },
                delete: {
                    post: function (association, handler) {
                        API.sendRequest("/events/" + association.EventID + "/association/branch/"+association.ID+"/delete", 'POST', association, handler, true);
                    }
                },
            },
            grades:{
                get: function (event, handler) {
                    API.sendRequest("/events/" + event.ID + "/association/grade", 'GET', null, handler, true);
                },
                post: function (association, handler) {
                    API.sendRequest("/events/" + association.EventID + "/association/grade", 'POST', association, handler, true);
                },
                delete: {
                    post: function (association, handler) {
                        API.sendRequest("/events/" + association.EventID + "/association/grade/"+association.ID+"/delete", 'POST', association, handler, true);
                    }
                },
            },
            areas:{
                get: function (event, handler) {
                    API.sendRequest("/events/" + event.ID + "/association/area", 'GET', null, handler, true);
                },
                post: function (association, handler) {
                    API.sendRequest("/events/" + association.EventID + "/association/area", 'POST', association, handler, true);
                },
                delete: {
                    post: function (association, handler) {
                        API.sendRequest("/events/" + association.EventID + "/association/area/"+association.ID+"/delete", 'POST', association, handler, true);
                    }
                },
            },
            students: {
                get: function (event, handler) {
                    API.sendRequest("/events/" + event.ID + "/association/students", 'GET', null, handler, true);
                },
                post: function (params, event, handler) {
                    API.sendRequest("/events/" + event.ID + "/association/students", 'POST', params, handler, true);
                },
                update: {
                    post: function (params, handler) {
                        API.sendRequest("/events/" + params.EventID + "/association/students/" + params.StudentID + "/update", 'POST', params, handler, true);
                    },
                }
            }
        },
        questions: {
            get: function (params, event, handler) {
                API.sendRequest("/events/" + event.ID + "/questions", 'GET', params, handler, true);
            },
            add: {
                post: function (event, params, handler) {
                    API.sendRequest("/events/" + event.ID + "/questions/add", 'POST', params, handler, true);
                }
            },
            unlink: {
                post: function (event, question, handler) {
                    API.sendRequest("/events/" + event.ID + "/questions/" + question.ID + "/unlink", 'POST', null, handler, true);
                }
            },
            relink: {
                post: function (event, question, handler) {
                    API.sendRequest("/events/" + event.ID + "/questions/" + question.ID + "/relink", 'POST', null, handler, true);
                }
            },
            update: {
                post: function (question, handler) {
                    API.sendRequest("/events/" + question.EventID + "/questions/" + question.ID + "/update", 'POST', question, handler, true);
                }
            }
        },
        transportation: {
            get: function (event, handler) {
                API.sendRequest("/events/" + event.ID + "/transportation", 'GET', null, handler, true);
            },
            post: function (event, transportation, handler) {
                API.sendRequest("/events/" + event.ID + "/transportation", 'POST', transportation, handler, true);
            },
            unlink: {
                post: function (event, transportation, handler) {
                    API.sendRequest("/events/" + event.ID + "/transportation/" + transportation.ID + "/unlink", 'POST', null, handler, true);
                }
            },
            relink: {
                post: function (event, transportation, handler) {
                    API.sendRequest("/events/" + event.ID + "/transportation/" + transportation.ID + "/relink", 'POST', null, handler, true);
                }
            }
        },
        files: {
            get: function (event, handler) {
                API.sendRequest("/events/" + event.ID + "/files", 'GET', null, handler, true);
            },
            update: {
                post: function (params, event, handler) {
                    API.sendRequest("/events/" + event.ID + "/files/update", 'POST', params, handler, true);
                }
            },
            receipts: {
                get: function (eventID, handler) {
                    API.sendRequest("/events/" + eventID + "/receipt-files", 'GET', null, handler, true);
                },
                delete: function (params, handler) {
                    API.sendRequest("/events/" + params.EventID + "/receipt-files/" + params.ID + "/delete", 'POST', params, handler, true);
                },
            }
        },
        subscribers: {
            get: function (params, event, handler) {
                API.sendRequest("/events/" + event.ID + "/subscribers", 'GET', params, handler, true);
            }
        },
        discounts: {
            get: function (event, handler) {
                API.sendRequest("/events/" + event.ID + "/discount", 'GET', null, handler, true);
            },
            date: {
                post: function (event, params, handler) {
                    API.sendRequest("/events/" + event.ID + "/discount/date", 'POST', params, handler, true);
                },
                status: {
                    post: function (discount, handler) {
                        API.sendRequest("/events/" + discount.EventID + "/discount/date/" + discount.DiscountID + "/status", 'POST', discount, handler, true);
                    }
                },
                update: {
                    post: function (eventID, discountID, params, handler) {
                        API.sendRequest("/events/" + eventID + "/discount/date/" + discountID + "/update", 'POST', params, handler, true);
                    }
                }
            },
            level: {
                post: function (level, event, handler) {
                    API.sendRequest("/events/" + event.ID + "/discount/family", 'POST', level, handler, true);
                }
            },
            brother: {
                post: function (brother, event, handler) {
                    API.sendRequest("/events/" + event.ID + "/discount/brothers", 'POST', brother, handler, true);
                }
            },
            general: {
                post: function (event, params, handler) {
                    API.sendRequest("/events/" + event.ID + "/discount/general", 'POST', params, handler, true);
                },
                status: {
                    post: function (discount, handler) {
                        API.sendRequest("/events/" + discount.EventID + "/discount/general/" + discount.DiscountID + "/status", 'POST', discount, handler, true);
                    }
                },
                update: {
                    post: function (eventID, discountID, params, handler) {
                        API.sendRequest("/events/" + eventID + "/discount/general/" + discountID + "/update", 'POST', params, handler, true);
                    }
                }
            },
            student: {
                post: function (event, studentID, params, handler) {
                    API.sendRequest("/events/" + event.ID + "/discount/student/" + studentID, 'POST', params, handler, true);
                },
                update: {
                    post: function (event, params, handler) {
                        API.sendRequest("/events/" + event.ID + "/discount/students/update", 'POST', params, handler, true);
                    }
                }
            }

        },
        statistics: {
            get: function (params, event, handler) {
                API.sendRequest("/events/" + event.ID + "/statistics", 'GET', params, handler, true);
            }
        },
        registrations: {
            get: function (params, handler) {
                API.sendRequest("/events/registrations", 'GET', params, handler, true);
            },
            update: {
                post: function (params, handler) {
                    API.sendRequest("/events/registrations/payment-status/update", 'POST', params, handler, true);
                },
            },
            amount: {
                get: function (event, handler) {
                    API.sendRequest("/events/" + event.ID + "/registrationsAmount", 'GET', null, handler, true);
                },
            }
        },
        branches: {
            price: {
                post: function (params, handler) {
                    API.sendRequest("/events/" + params.EventID + "/branches/price", 'POST', params, handler, true);
                },
                get: function (eventID, handler) {
                    API.sendRequest("/events/" + eventID + "/branches/price", 'GET', null, handler, true);
                },
                update: {
                    post: function (priceByBranch, handler) {
                        API.sendRequest("/events/branches/price/" + priceByBranch.ID + "/update", 'POST', priceByBranch, handler, true);
                    },
                }
            },
            kibutzPay: {
                post: function (params, handler) {
                    API.sendRequest("/events/" + params.EventID + "/branches/kibutzpay", 'POST', params, handler, true);
                },
                get: function (eventID, handler) {
                    API.sendRequest("/events/" + eventID + "/branches/kibutzpay", 'GET', null, handler, true);
                },
                delete: function (params, handler) {
                    API.sendRequest("/events/branches/kibutzpay/" + params.EventID + "/delete", 'POST', params, handler, true);
                }
            }
        },
        areas: {
            price: {
                post: function (params, handler) {
                    API.sendRequest("/events/" + params.EventID + "/areas/price", 'POST', params, handler, true);
                },
                get: function (eventID, handler) {
                    API.sendRequest("/events/" + eventID + "/areas/price", 'GET', null, handler, true);
                },
                update: {
                    post: function (priceByArea, handler) {
                        API.sendRequest("/events/areas/price/" + priceByArea.ID + "/update", 'POST', priceByArea, handler, true);
                    },
                }
            }
        },
        groups: {
            price: {
                post: function (params, handler) {
                    API.sendRequest("/events/" + params.EventID + "/groups/price", 'POST', params, handler, true);
                },
                get: function (eventID, handler) {
                    API.sendRequest("/events/" + eventID + "/groups/price", 'GET', null, handler, true);
                },
                update: {
                    post: function (priceByGroup, handler) {
                        API.sendRequest("/events/groups/price/" + priceByGroup.ID + "/update", 'POST', priceByGroup, handler, true);
                    },
                }
            }
        },
        fees: {
            get: function (eventID, handler) {
                API.sendRequest("/events/" + eventID + "/fees", 'GET', null, handler, true);
            },
            update: function (fee, handler) {
                API.sendRequest("/events/" + fee.EventID + "/fees/update", 'POST', fee, handler, true);
            },
            create: function (fee, handler) {
                API.sendRequest("/events/" + fee.EventID + "/fees", 'POST', fee, handler, true);
            },
            delete: function (fee, handler) {
                API.sendRequest("/events/" + fee.EventID + "/fees/" + fee.ID + "/delete", 'POST', null, handler, true);
            },
        },
        suggestions: {
            get: function (eventID, handler) {
                API.sendRequest("/events/" + eventID + "/suggestions", 'GET', null, handler, true);
            },
            update: function (suggestion, handler) {
                API.sendRequest("/events/suggestions/" + suggestion.ID + "/update", 'POST', suggestion, handler, true);
            },
            create: function (suggestion, handler) {
                API.sendRequest("/events/suggestions", 'POST', suggestion, handler, true);
            },
        },
        donations: {
            get: function (eventID, handler) {
                API.sendRequest("/events/" + eventID + "/donations", 'GET', null, handler, true);
            },
            total: function (eventID, handler) {
                API.sendRequest("/events/" + eventID + "/donations/total", 'GET', null, handler, true);
            },
        },
        healthDeclarations: {
            get: function (eventID,handler){
                API.sendRequest("/events/" + eventID + "/health-declarations", 'GET', null, handler, true);
            },
            update: function (eventID,params,handler){
                API.sendRequest("/events/" + eventID + "/health-declarations/" + params.ID + "/update", 'POST', params, handler, true);
            },
            send: function (eventID,params,handler){
                API.sendRequest("/events/" + eventID + "/health-declarations/send", 'POST', params, handler, true);
            },
        },
        cartEvents: {
            get: function (cartEventID,handler){
                API.sendRequest("/events/" + cartEventID + "/cart-events", 'GET', null, handler, true);
            },
            post: function (cartEventID,params,handler){
                API.sendRequest("/events/" + cartEventID + "/cart-events", 'POST', params, handler, true);
            },
            update: function (cartEventID,params,handler){
                API.sendRequest("/events/" + cartEventID + "/cart-events/" + params.ID + "/update", 'POST', params, handler, true);
            },
            checkIfCanAdd: {
                get: function (cartEventID,handler){
                    API.sendRequest("/events/" + cartEventID + "/cart-events/can-add-registrations", 'GET', null, handler, true);
                },
            },
            bulk: {
                update: function (cartEventID,params,handler){
                    API.sendRequest("/events/" + cartEventID + "/cart-events/update", 'POST', params, handler, true);
                },
            }
        }

    }

}]);

angular.module('app.core').factory('emailEndpoint', ['API', function (API) {

    return {
        post: function (params,handler) {
            API.sendRequest("/email", 'POST', params, handler, true);
        }
    }
}]);

angular.module('app.core').factory('educatorsEndpoint', ['API', function (API) {

    return {

        groups : {
            get: function (educator,handler) {
                API.sendRequest("/educators/"+educator.ID +"/groups", 'GET', educator, handler, true);
            },
            post: function (params,handler) {
                API.sendRequest("/educators/groups", 'POST', params, handler, true);
            },
            update : {
                post: function (group,handler) {
                    API.sendRequest("/educators/"+group.EducatorID +"/groups/"+group.ID+"/update", 'POST', group, handler, true);
                }
            }
        },
        new : {
            post: function (params,handler) {
                API.sendRequest("/educators/new", 'POST', params, handler, false);
            },
            valid : {
                post: function (token,handler) {
                    API.sendRequest("/educators/new/valid", 'POST', token, handler, false);
                }
            }

        }

    }
}]);

angular.module('app.core').factory('coordinatorsEndpoint', ['API', function (API) {

    return {
        get: function (params,handler) {
            API.sendRequest("/coordinators", 'GET', params, handler, true);
        },
        post: function (coordinator,handler) {
            API.sendRequest("/coordinators", 'POST', coordinator, handler, true);
        },
        update : {
            post: function (coordinator,handler) {
                API.sendRequest("/coordinators/"+coordinator.ID+"/update", 'POST', coordinator, handler, true);
            }
        },
        resendInvitation: function (handler) {
            API.sendRequest("/coordinators/resendEmail", 'POST',null, handler, true);
        },
        branches : {
            update : {
                post: function (coordinator,selectedBranches,handler) {
                    API.sendRequest("/coordinators/"+coordinator.ID+"/branches/update", 'POST', selectedBranches, handler, true);
                }
            }
        },
        areas : {
            update : {
                post: function (coordinator,selectedAreas,handler) {
                    API.sendRequest("/coordinators/"+coordinator.ID+"/areas/update", 'POST', selectedAreas, handler, true);
                }
            }
        },
        settlements : {
            update : {
                post: function (coordinator,selectedSettlements,handler) {
                    API.sendRequest("/coordinators/"+coordinator.ID+"/settlements/update", 'POST', selectedSettlements, handler, true);
                }
            }
        },
        new : {
            post: function (params,handler) {
                API.sendRequest("/coordinators/new", 'POST', params, handler, false);
            },
            valid : {
                post: function (token,handler) {
                    API.sendRequest("/coordinators/new/valid", 'POST', token, handler, false);
                }
            }

        }
    }
}]);

angular.module('app.core').factory('contactsEndpoint', ['API', function (API) {

    return {
        get: function (params,handler) {
            API.sendRequest("/contacts", 'GET', params, handler, true);
        },
        post: function (contact,handler) {
            API.sendRequest("/contacts", 'POST', contact, handler, true);
        },
        update : {
            post: function (contact,handler) {
                API.sendRequest("/contacts/"+contact.ID+"/update", 'POST', contact, handler, true);
            }
        },
        delete : function (contact,handler) {
                API.sendRequest("/contacts/"+contact.ID+"/delete", 'POST', null, handler, true);
            }
        ,
        associations: {
            post: function (contactID,handler) {
                API.sendRequest("/contacts/"+contactID+"/associations", 'GET', null, handler, true);
            },
            delete: function (contactID,IDs,handler) {
                API.sendRequest("/contacts/"+contactID+"/associations/delete", 'POST', IDs, handler, true);
            }
        }
    }
}]);

angular.module('app.core').factory('citiesEndpoint', ['API', function (API) {

    return {
        get: function (handler) {
            API.sendRequest("/cities", 'GET', null, handler, true);
        },

        post: function (city,handler) {
            API.sendRequest("/cities", 'POST', city, handler, true);
        },
        update : {
            post: function (city,handler) {
                API.sendRequest("/cities/"+city.ID+"/update", 'POST', city, handler, true);
            }
        }
    }
}]);

angular.module('app.core').factory('branchesEndpoint', ['API', function (API) {

    return {
        get: function (params,handler) {
            API.sendRequest("/branches", 'GET', params, handler, true);
        },
        post: function (branch,handler) {
            API.sendRequest("/branches", 'POST', branch, handler, true);
        },
        update : {
            post: function (branch,handler) {
                API.sendRequest("/branches/"+branch.ID+"/update", 'POST', branch, handler, true);
            }
        },
        groups : {
            get: function (branchID,handler) {
                API.sendRequest("/branches/"+branchID+"/groups", 'GET', null, handler, true);
            }
        },
        hours: {
            get: function (branchID,handler) {
                API.sendRequest("/branches/"+branchID+"/hours", 'GET', null, handler, true);
            },
            update: function (branchID,hours,handler) {
                API.sendRequest("/branches/"+branchID+"/hours/update", 'POST', hours, handler, true);
            },
            delete: function (hour,handler) {
                API.sendRequest("/branches/"+hour.BranchID+"/hours/"+hour.ID+"/delete", 'POST', hour, handler, true);
            }
        },
        files: {
            get:  function (branchID,params,handler) {
                API.sendRequest("/branches/"+branchID+"/files", 'GET', params, handler, true);
            },
            update: function (file,handler) {
                API.sendRequest("/branches/"+file.BranchID+"/files/update", 'POST', file, handler, true);
            },
            upload: function (file,handler) {
                API.sendRequest("/branches/"+file.BranchID+"/files", 'POST', file, handler, true);
            },
            delete: function (file,handler) {
                API.sendRequest("/branches/"+file.BranchID+"/files/"+file.ID+"/delete", 'POST', null, handler, true);
            },
        },
        tags: {
            get:  function (branchID,handler) {
                API.sendRequest("/branches/"+branchID+"/tags", 'GET', null, handler, true);
            },
            post: function (branchID,params,handler) {
                API.sendRequest("/branches/"+branchID+"/tags", 'POST', params, handler, true);
            },
            delete: function (branchID,tagID,handler) {
                API.sendRequest("/branches/"+branchID+"/tags/"+tagID+"/delete", 'POST', null, handler, true);
            },
        }
    }
}]);

angular.module('app.core').factory('birthdaySettingsEndpoint', ['API', function (API) {

    return {
        post: function (params,handler) {
            API.sendRequest("/birthday-settings",'POST', params, handler, true);
        },
        get: function (handler) {
            API.sendRequest("/birthday-settings",'GET', null, handler, true);
        }
    }
}]);

angular.module('app.core').factory('areasEndpoint', ['API', function (API) {

    return {
        get: function (params,handler) {
            API.sendRequest("/areas", 'GET', params, handler, true);
        },
        post: function (area,handler) {
            API.sendRequest("/areas", 'POST', area, handler, true);
        },
        update :{
            post: function (area,handler) {
                API.sendRequest("/areas/"+area.ID+"/update", 'POST', area, handler, true);
            }
        },
        cities : {
            get: function (area,handler) {
                API.sendRequest("/areas/"+area.ID+"/cities", 'GET', null, handler, true);
            }
        }

    }
}]);

angular.module('app.core').factory('adminEndpoint', ['API', function (API) {

    return {
        post: function (user,handler) {
            API.sendRequest("/admins", 'POST', user, handler,true);
        },
        get: function (params,handler) {
            API.sendRequest("/admins", 'GET', params, handler,true);
        },
        login: {
            post: function (params,handler) {
                API.sendRequest("/admins/login", 'POST', params, handler,false);
            }
        },

        validToken : {
            post: function (params,handler) {
                API.sendRequest("/admins/validToken", 'POST', params, handler,false);
            }
        },
        update : {
            post: function (userID,user,handler) {
                API.sendRequest("/admins/"+userID+"/update", 'POST', user, handler,true);
            }
        },
        password: {
            post: function (userID,passwords,handler) {
                API.sendRequest("/admins/"+userID+"/password", 'POST', passwords, handler,true);
            }
        },
        delete : {
            post: function (userID,handler) {
                API.sendRequest("/admins/"+userID+"/delete", 'POST', null, handler,true);
            }
        }
        ,
        new : {
            post: function (params,handler) {
                API.sendRequest("/admins/new", 'POST', params, handler,false);
            },
            valid : {
                post: function (params,handler) {
                    API.sendRequest("/admins/new/valid", 'POST', params, handler,false);
                }
            }
        },
        forgot : {
            post: function (params,handler) {
                API.sendRequest("/admins/forgot", 'POST', params, handler,false);
            },
            valid : {
                post: function (params,handler) {
                    API.sendRequest("/admins/forgot/valid", 'POST', params, handler,false);
                }

            },
            reset : {
                post: function (params,adminID, handler) {
                    API.sendRequest("/admins/"+adminID+"/reset", 'POST', params, handler, false);
                }
            }
        }


    }

}]);

angular.module('app.core').factory('activitiesEndpoint', ['API', function (API) {

    return {
        get: function (params,handler) {
            API.sendRequest("/activities", 'GET', params, handler, true);
        },
        post: function (activities,handler) {
            API.sendRequest("/activities", 'POST', activities, handler, true);
        },
        update : {
            post: function (activities,handler) {
                API.sendRequest("/activities/"+activities.ID+"/update", 'POST', activities, handler, true);
            }
        },
        attendance : {
            get: function (activities,handler) {
                API.sendRequest("/activities/"+activities.ID+"/attendance", 'GET', null, handler, true);
            },
            post: function (activities,attendance,handler) {
                API.sendRequest("/activities/"+activities.ID+"/attendance/"+attendance.ID, 'POST', attendance, handler, true);
            }
        }
    }
}]);

(function ()
{
    'use strict';

    angular
        .module('app.dashboard',
            [
                // 3rd Party Dependencies
                'nvd3',
                'datatables'
            ]
        )
        .config(config).run(run);

    function run($rootScope,msNavigationService) {

        /**
         * Set the pages by the admin level
         */
        $rootScope.$watch('AdminLevel',function () {

            if ($rootScope.AdminLevel) {

                switch ($rootScope.AdminLevel) {
                    case 1:
                        msNavigationService.deleteItem('apps');
                        break;
                    case 2:
                        msNavigationService.deleteItem('apps');
                        break;

                }

            }

        });

    }

    /** @ngInject */
    function config($stateProvider,msNavigationServiceProvider)
    {
        // State
        $stateProvider.state('app.dashboard', {
            url      : '/dashboard',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/apps/dashboard/dashboard.html',
                    controller : 'DashboardController as vm'
                }
            },
            resolve  : {
                DashboardData: function (ValidToken)
                {
                    ValidToken.validUserToken();
                    localStorage.setItem("path",'/dashboard');
                }
            },
            bodyClass: 'dashboard'
        });
        msNavigationServiceProvider.saveItem('apps', {
            title: 'סטטיסטיקות',
            icon  : 'icon-tile-four',
            state: 'app.dashboard',
            quickstate: 'app.dashboard',
            weight: 1
        });

    }

})();
angular.module('app.dashboard').controller('DashboardController', DashboardController)

function DashboardController( $rootScope,$location,statisticsEndpoint,appConfig,settingsEndpoint,$mdDialog,branchesEndpoint) {

    var vm = this;


    vm.appConfig = appConfig;
    vm.getStatistics = getStatistics;
    vm.checkNewUpdates =checkNewUpdates;
    vm.getBranches = getBranches;
    vm.init = init();

    function init(){
        vm.getStatistics();
        vm.checkNewUpdates();
        vm.getBranches()
    }

    /**
     * Get Statistics
     */
    function getStatistics() {
        vm.statistics= false;
        var params = {};
        params['BranchID'] = vm.selectedBranch;
        if ($rootScope.User)
            statisticsEndpoint.get(params,function (data) {
                if (data) {
                    vm.statistics=data;
                    vm.statistics.colors = ['#91dafc','#51c2f5','#0dacf4','#0578ac','#034e70'];
                    vm.statistics.colors2 = ['#99a5c4','#222630','#2d323e','#4b5366','#7f8aa4'];
                    vm.statistics.options = {
                        legend: {display: true}
                    };
                }
            })
    }

    /**
     * Check for new Updates
     */
    function checkNewUpdates() {
        settingsEndpoint.updates.get(function (data) {
            if (!data.IsUpdate) {
                $mdDialog.show({
                    controller: 'NewUpdatesDialogController',
                    templateUrl: 'app/main/apps/dashboard/updates-dialog/updates-dialog.html',
                    clickOutsideToClose: false
                })
            }

        })
    }

    /**
     * Get Branches
     */
    function getBranches() {
        branchesEndpoint.get({},function (data) {
            vm.branches = data;
        })
    }



}

angular.module('app.pages.settings').controller('SettingsController', SettingsController);

function SettingsController(birthdaySettingsEndpoint,$rootScope,rolesEndpoint,Upload,appConfig, gradesEndpoint,tagsEndpoint,studentsEndpoint,Notification,areasEndpoint,DTOptionsBuilder,dtOptions,$mdSidenav,$mdDialog,area,settingsEndpoint,systemSettingsEndpoint,parentsEndpoint,extraField) {

    var vm = this;
    vm.externalEventsEnabled = appConfig.externalEventsEnabled;


    init();

    function init() {
        fetchAllStudentFields();
        fetchAllExtraStudentFields();
    }
    /**
     * Set Table option
     * @type {any}
     */
    vm.dtOptions = DTOptionsBuilder
        .newOptions()
        .withLanguage(dtOptions.language)
        .withDOM('lfrtp')
        .withOption('bFilter', false)
        .withDOM('lrtip');

    /**
     * Get All Grades
     */
    function getGrades() {
        var params = {};
        params.Status =1;
        vm.grades = false;
        gradesEndpoint.get(params, function (data) {
            vm.grades = data;
        });
    }

    /**
     * Get Tags
     */
    function getTags() {
        var params = {};
        params.TagType =1;
        tagsEndpoint.get(params,function (data) {
            vm.studentsTags = data;
        });
        params.TagType =2;
        tagsEndpoint.get(params,function (data) {
            vm.parentsTags = data;
        })
    }

    /**
     * Update Tags
     */
    function updateTags() {
        vm.isClikced = true;
        var params = {};
        params.TagType=1;
        params.Tags = JSON.stringify(angular.copy(vm.studentsTags));
        tagsEndpoint.post(params,function (data) {});
        params.TagType=2;
        params.Tags = JSON.stringify(angular.copy(vm.parentsTags));
        tagsEndpoint.post(params,function (data) {
            vm.isClikced = false;
            if (data.success)
                Notification.success("תגיות עודכנו");

        })
    }

    /**
     * Get Roles
     */
    function getRoles() {
        rolesEndpoint.get([],function (data) {
            vm.roles = data;
        })
    }




    /**
     * Update Roles
     */
    function updateRoles() {
        vm.isClikced = true;
        var params = {};
        params.Roles = JSON.stringify(angular.copy(vm.roles));
        rolesEndpoint.post(params,function (data) {
            vm.isClikced = false;
            if (data.success)
                Notification.success("תפקידים עודכנו");

        })
    }

    /**
     * Get Roles
     */
    function geEducatortRoles() {
        rolesEndpoint.educator.get([],function (data) {
            vm.educatorRoles = data;
        })
    }



    /**
     * Update Roles
     */
    function updateEducatorRoles() {
        vm.isClikced = true;
        var params = {};
        params.Roles = JSON.stringify(angular.copy(vm.roles));
        rolesEndpoint.educator.post(params,function (data) {
            vm.isClikced = false;
            if (data.success)
                Notification.success("תפקידים עודכנו");

        })
    }


    /**
     * get external settings
     */
    function getExternalSettings(){
        settingsEndpoint.external.get(function(data){
            if(data && data.length){
                data.forEach(function(ent){
                    vm.externalEvent[ent.Entity] = ent.Name;
                })
            }
        })
    }
    /**
     * update external settings
     */
    function updateExternalSettings(){
        var params = {};
        params['External'] = vm.externalEvent;
        settingsEndpoint.external.post(params,function(data){
            if(data.success){
                Notification.success("עודכן בהצלחה");
            }else{
                Notification.error("לא עודכן ישנה בעיה");
            }
        })
    }




    /**
     * Update grade
     */
    function updateGrade() {
        vm.isClicked = true;
        studentsEndpoint.grades.upgrade.post(vm.upgrade, function (data) {
            vm.isClicked = false;
            if (data.success) {
                Notification.success("עודכן בהצלחה");
                vm.upgrade = {};
            }
            else
                Notification.error("נכשל בעדכון");


        })
    }

    /**
     * Get emails
     */
    function getEmails() {
        settingsEndpoint.forms.emails.get(function (data) {
            if (data) {
                vm.settings = data;
                angular.forEach(vm.settings, function (value, key) {
                    if (angular.isUndefined(value.Value) || value.Value === '')
                        vm.settings[key].Value = [];
                    else{
                            try {
                                vm.settings[key].Value = JSON.parse(value.Value);
                            } catch (error) {
                                vm.settings[key].Value = value.Value;
                            }

                    }
                });
                vm.settingsReady = true;
            }
        })
    }

    /**
     * Update settings
     */
    function updateSettings() {
        var settings = angular.copy(vm.settings);
        angular.forEach(settings, function (value, key) {
            settings[key].Value = JSON.stringify(value.Value);
        });
        var params = {
            settings: settings
        };
        settingsEndpoint.post(params, function (data) {
            if (data.success) Notification.success('הגדרות נשמרו בהצלחה!');
            else Notification.error('נכשל בשמירת הגדרות!');
        })
    }

    /**
     * Get Accountancy Settings
     */
    function getAccountancySettings() {
        settingsEndpoint.accountancy.get(function (data) {
            vm.accountancy = data;
        });
    }

    /**
     * Add New Bank
     */
    function addBank() {
        var newBank = {};
        newBank.Name = '';
        newBank.Code ='';
        newBank.Number = '';
        vm.accountancy.Banks.push(newBank);
    }

    /**
     * Update Accountancy
     */
    function updateAccountancy () {
        vm.isClicked = true;
        settingsEndpoint.accountancy.post(vm.accountancy, function (data) {
            vm.isClicked = false;
            if (data.success)
                Notification.success("הפרטים עדוכונו בהצלחה")
        })
    }

    /**
     * Get System Settings
     */
    function getSystemSettings() {
        systemSettingsEndpoint.names.get(function (data) {
            vm.systemSettings = data;
            vm.systemSettings.AttendenceStatus = vm.systemSettings.AttendenceStatus=="" ?  [] : splitArray(vm.systemSettings.AttendenceStatus);
        })
    }

    function splitArray(str){
        var newStr = str.replace(/[[]|[\]]/g,"").replace(/"/g,"");
        var arr = newStr.split(",");
        return arr;
    }

    /**
     * update SystemSettings
     */
    function updateSystemSettings() {
        var params = {};
        params.Names = vm.systemSettings;
        params.Names.AttendenceStatus = JSON.stringify(params.Names.AttendenceStatus);
        vm.isClicked = true;
        systemSettingsEndpoint.names.post(params,function (data) {
            vm.isClicked = false;
            Notification.success("הגדרות עודכנו בהצלחה");
        })
    }

    /**
     * update BirthdaySettings
     */
    function updateSystemBirthdaySettings() {
        vm.isClicked = true;
        birthdaySettingsEndpoint.post(vm.birthdaySettings,function (data) {
            vm.isClicked = false;
            Notification.success("הגדרות עודכנו בהצלחה");
        })
    }

    /**
     * Get BirthdaySettings
     */
    function getSystemBirthdaySettings() {
        birthdaySettingsEndpoint.get(function (data) {
            vm.birthdaySettings = data;
        })
    }

    /**
     * Get Terms
     */
    function getTerms() {
        systemSettingsEndpoint.terms.get(function (data) {
            vm.terms = data;
        })
    }

    /**
     * Update Terms for profile
     */
    function updateTerms() {
        systemSettingsEndpoint.terms.post(vm.terms,function (data) {
            Notification.success("תנאים עודכנו בהצלחה");
        })
    }

    /**
     * Upload Logo
     * @param logo
     */
    function uploadImage(logo) {
        $mdDialog.show({
            controller         : 'UploadController',
            templateUrl        : 'app/upload/upload.html',
            clickOutsideToClose: false,
            locals: {
                uploadTo: 'settings',
                uploadID: "profile/image",
                restrictTo: []
            }
        }).then(function () {
            if (logo) {
                vm.systemSettings.BrandLogo = $rootScope.fileResp.data.Path;
            }
            vm.profile.EventImages.Value = $rootScope.fileResp.data.Path;
        });
    }

    /**
     * Get Profile Settings
     */
    function getProfileSettings() {
        settingsEndpoint.profile.get(function (data) {
            vm.profile = data;
        })
    }

    /**
     * Get Profile Images
     */
    function getProfileImages() {
        settingsEndpoint.profile.images.get(function (data) {
            vm.profileImages = data;
        })
    }

    /**
     * Update Image Settings
     */
    function updateProfileImageSettings() {
        vm.isClicked = true;
        var params = {};
        params.Images = vm.profileImages;
        settingsEndpoint.profile.images.post(params,function (data) {
            Notification.success("פרטים עודכנו בהצלחה");
            vm.isClicked = false;

        })
    }

    /**
     * Update Profile Settings
     */
    function updateProfileSettings() {
        vm.isClicked = true;
        settingsEndpoint.profile.post(vm.profile,function (data) {
            Notification.success("פרטים עודכנו בהצלחה");
            vm.isClicked = false;

        })
    }

    /**
     * Get Admin Images
     */
    function getAdminImages() {
        settingsEndpoint.admin.images.get(function (data) {
            vm.adminImages = data;
        })
    }

    /**
     * Update Admin Images
     */
    function updateAdminImageSettings() {
        vm.isClicked = true;
        var params = {};
        params.Images = vm.adminImages;
        settingsEndpoint.admin.images.post(params,function (data) {
            Notification.success("פרטים עודכנו בהצלחה");
            vm.isClicked = false;

        })
    }


    /**
     * UploadFile
     * @param file
     */
    function uploadFile (file,image) {
        if (!file)
            return;
        vm.isClicked = true;
        image.FileName = file.name;
        var uploadURL = '';
        if (location.hostname === "localhost" || location.hostname === "127.0.0.1")
            uploadURL = appConfig.localHostUrl + '/upload/files?brand=' + $rootScope.brandName;
        else if (location.host === appConfig.locationHost)
            uploadURL = appConfig.developmentHostUrl + '/upload/files?brand=' + $rootScope.brandName;
        else
            uploadURL = appConfig.serverUrl + '/upload/files?brand=' + $rootScope.brandName;

        Upload.upload({
            url: uploadURL,
            data: {file: file, 'accessToken': $rootScope.User.AccessToken}
        }).then(function (resp) {
            vm.isClicked = false;
            image.Value = resp.data.Path;
        }, function (resp) {
            console.log('Error status: ' + resp.status);
        }, function (evt) {
            var progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
            console.log('progress: ' + progressPercentage);
        });


    }

    function fetchAllStudentFields() {
        systemSettingsEndpoint.studentFields.all.get([],function(data) {
            let arr = [];
            Object.keys(data).map(function (key) {
                let obj = data[key];
                obj.required = (obj.required === 1);
                arr.push(obj);
            });
            vm.studentfields = arr;
        });
    }

    function updateStudentFields() {
        vm.isClicked = true;
        systemSettingsEndpoint.studentFields.all.post({fields: vm.studentfields},function(){
            Notification.success("פרטים עודכנו בהצלחה");
            vm.isClicked = false;
        });
    }


    /**
     * Set Type
     * @param type
     * @returns {string}
     */
    function extraFieldType(type){
        switch (type) {
            case "1":
            case 1:
                return "שאלה פתוחה";
                break;
            case "2":
            case 2:
                return "אפשרויות";
                break;
            case "3":
            case 3:
                return "תאריך";
                break;
            case "4":
            case 4:
                return "קובץ";
                break;
        }
    }

    function fetchAllExtraStudentFields() {
        systemSettingsEndpoint.studentExtraFields.get([],function(data) {
            let arr = [];
            Object.keys(data).map(function (key) {
                arr.push(data[key]);
            });
            vm.extraStudentFields = arr;
        });
    }

    /**
     * Edit field
     */
    function editField(selectedField) {
        extraField.updateSelectedField(selectedField);
        $mdSidenav("field-panel").open();
    }

    function openNewFieldDialog() {
        $mdDialog.show({
            controller         : 'NewFieldDialogController',
            templateUrl        : 'app/main/pages/settings/tabs/profile/new-field-dialog/new-field-dialog.html',
            clickOutsideToClose: true,
        }).then(function () {
            fetchAllExtraStudentFields();
        });
    }

    /**
     * Open File
     */
      function viewFile(path) {
        window.open( path);
    }
}

(function ()
{
    'use strict';

    angular
        .module('app.pages.settings_menu', []).config(config).run(run);

    function run($rootScope,msNavigationService,appConfig) {
        $rootScope.$watch('User',function () {

            /**
             * Set the pages by the admin level
             */
            if ($rootScope.AdminLevel) {
                if ($rootScope.User.SuperAdmin==1) {
                    msNavigationService.saveItem('pages.settings_menu', {
                        title : 'הגדרות מערכת',
                        icon  : 'icon-cog',
                        weight: 5
                    });

                    msNavigationService.saveItem('pages.settings_menu.settings_menu_general-settings', {
                        title : 'כללי',
                        icon  : 'icon-monitor',
                        state : 'app.pages_settings_menu_general-settings'

                    });
                    msNavigationService.saveItem('pages.settings_menu.settings_menu_accountancy-settings', {
                        title : 'הנהלת חשבונות',
                        icon  : 'icon-cash-100',
                        state : 'app.pages_settings_menu_accountancy-settings'

                    });
                    msNavigationService.saveItem('pages.settings_menu.settings_menu_admin-settings', {
                        title : 'מערכת ניהול',
                        icon  : 'icon-laptop-mac',
                        state : 'app.pages_settings_menu_admin-settings'

                    });
                    msNavigationService.saveItem('pages.settings_menu.settings_menu_profile-settings', {
                        title : 'פרופיל הורה',
                        icon  : 'icon-account',
                        state : 'app.pages_settings_menu_profile-settings'

                    });
                    if (appConfig.externalEventsEnabled) {
                        msNavigationService.saveItem('pages.settings_menu.settings_menu_external-registrations-settings', {
                            title : 'הרשמות חיצונים',
                            icon  : 'icon-account-box-outline',
                            state : 'app.pages_settings_menu_external-registrations-settings'
                        });
                    }
                }
            }
        });

    }
    /** @ngInject */
    function config($stateProvider)
    {
        // State
        $stateProvider
            .state('app.pages.settings_menu', {
                abstract: true,
                url     : '/settings_menu'
            })
            .state('app.pages_settings_menu_general-settings', {
                url      : '/general-settings',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/pages/settings-menue/views/general-settings/general-settings.html',
                        controller : 'GeneralSettingsController as vm'
                    }
                },
                resolve  : {
                    DashboardData: function (ValidToken)
                    {
                        ValidToken.validUserToken();
                        localStorage.setItem("path",'/general-settings');
                    }
                }
            })
            .state('app.pages_settings_menu_accountancy-settings', {
                url      : '/accountancy-settings',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/pages/settings-menue/views/accountancy-settings/accountancy-settings.html',
                        controller : 'AccountancySettingsController as vm'
                    }
                },
                resolve  : {
                    DashboardData: function (ValidToken)
                    {
                        ValidToken.validUserToken();
                        localStorage.setItem("path",'/accountancy-settings');
                    }
                }
            })
            .state('app.pages_settings_menu_admin-settings', {
                url      : '/admin-settings',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/pages/settings-menue/views/admin-settings/admin-settings.html',
                        controller : 'AdminSettingsController as vm'
                    }
                },
                resolve  : {
                    DashboardData: function (ValidToken)
                    {
                        ValidToken.validUserToken();
                        localStorage.setItem("path",'/admin-settings');
                    }
                }
            })
            .state('app.pages_settings_menu_profile-settings', {
                url      : '/profile-settings',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/pages/settings-menue/views/profile-settings/profile-settings.html',
                        controller : 'ProfileSettingsController as vm'
                    }
                },
                resolve  : {
                    DashboardData: function (ValidToken)
                    {
                        ValidToken.validUserToken();
                        localStorage.setItem("path",'/profile-settings');
                    }
                }
            })
            .state('app.pages_settings_menu_external-registrations-settings', {
                url      : '/external-registrations-settings',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/pages/settings-menue/views/external-registrations-settings/external-registrations-settings.html',
                        controller : 'ExternalRegistrationsController as vm'
                    }
                },
                resolve  : {
                    DashboardData: function (ValidToken)
                    {
                        ValidToken.validUserToken();
                        localStorage.setItem("path",'/external-registrations');
                    }
                }
            })



    }
})();


(function ()
{
    'use strict';

    angular.module('app.save-changes',[])

})();

angular.module('app.save-changes').controller('SaveChangesController', ['$scope', '$rootScope', '$mdSidenav', '$mdDialog', '$location', '$timeout', 'Notification', 'event', 'studentsEndpoint','contactsEndpoint', 'parentsEndpoint', 'branchesEndpoint', 'groupsEndpoint', 'gradesEndpoint', 'coordinatorsEndpoint', 'questionsEndpoint', 'eventsEndpoint', 'transportationEndpoint', 'activitiesEndpoint', 'generalDiscount', 'adminEndpoint', 'areasEndpoint', 'systemSettingsEndpoint',
    function ($scope, $rootScope, $mdSidenav, $mdDialog, $location, $timeout, Notification, event, studentsEndpoint,contactsEndpoint, parentsEndpoint, branchesEndpoint, groupsEndpoint, gradesEndpoint, coordinatorsEndpoint, questionsEndpoint, eventsEndpoint, transportationEndpoint, activitiesEndpoint, generalDiscount, adminEndpoint, areasEndpoint, systemSettingsEndpoint) {

        /**
         * Save edit of Enter key
         */
        var closeByEsc = function () {
            var bodyElement = angular.element('body');
            bodyElement.on('keyup keypress keydown', function (e) {
                if (e.keyCode === 27) {
                    $scope.closeWithOutSaving();
                }
            });
        };

        /**
         * Save edit of Enter key
         */
        var saveOnEnter = function () {
            //if (angular.element('#'+$scope.view).length ) {
            var input = angular.element("#" + $scope.view + " input");
            input.keypress(function (e) {
                if (e.keyCode === 13) {
                    $scope.editObject();
                }
            });
            // }
        };

        /**
         * Check for change in the location.
         * If page was change close the current side nev
         */
        $rootScope.$on("$locationChangeStart", function () {
            var url = $location.url();
            if (!$rootScope.location)
                $rootScope.location = url;
            if ($rootScope.location !== url) {
                $rootScope.location = url;
                try {
                    if (angular.element('#'+$scope.view).length )
                        $mdSidenav($scope.view).close();
                }catch (e) {
                    console.info(e);
                }

            }
        });

        $scope.$watch('values', function () {
            if ($scope.values.length === 0 && $scope.view) {
                $scope.toggleSaveChangesPanel('close');
                $scope.disableSideBar.removeClass('active');
                $scope.disabletoolBar.removeClass('active');
                $rootScope.isEdit = false;
            }
        });


        /**
         * Toggle save changes panel
         * @param state
         */
        $scope.toggleSaveChangesPanel = function (state) {
            if (state === 'open') {
                angular.element('md-sidenav-bottom').removeClass('md-closed');
            } else {
                angular.element('md-sidenav-bottom').addClass('md-closed');
            }
        };

        /**
         * Handel Edit Data of Object|Array
         * @param newValue Object|Array the new Values of the object|Array
         * @param oldValue Object|Array the old Values of the object|Array
         * @param view string the current view or state
         * @param overwrite boolean true for overwrite the originalObject
         */
        $rootScope.editDataHandler = function (newValue, oldValue, view, overwrite) {
            // true for overwrite the originalObject
            if (overwrite) {
                $scope.originalObject = newValue;
                return;
            }
            //First Check of Handler
            firstDataHandler(newValue, oldValue, view);
            //check if its a new user
            if (oldValue) {
                if (newValue.id != oldValue.id || newValue.ID != oldValue.ID) {
                    $scope.changed = false;
                    return;
                }
                //compere the new user values and the old user values
                checkForChanges(newValue, $scope.originalObject);
                //end the handler
                $timeout(function () {
                    endHandler();
                }, 350)
            }
        };

        /**
         * Last handler of Data handler
         */
        function endHandler() {
            //check if there is a $$hashKey value in the array
            if ($scope.values[$scope.values.length - 1] === "$$hashKey") {
                $scope.values.pop()
            }
            //check for Ignore Fields
            $scope.values = $scope.values.filter(onlyUnique)
            checkForIgnoreFields();
            $timeout(function () {
                //if there is values in the values array open the saveChange Panel
                if ($scope.values.length > 0) {
                    if (!$scope.changed || $scope.closes) {
                        $rootScope.isEdit = true;
                        $scope.disableSideBar.addClass('active');
                        $scope.disabletoolBar.addClass('active');

                        $scope.toggleSaveChangesPanel('open');
                        //set close by esc
                        closeByEsc()
                    }
                    $scope.changed = true;
                }
                //if there is no value in the values array close the panel
                else {
                    $rootScope.isEdit = false;

                    $scope.toggleSaveChangesPanel('close');
                    $scope.disableSideBar.removeClass('active');
                    $scope.disabletoolBar.removeClass('active');

                }
            }, 200)

        }

        /**
         * Reset the Data Handler and set the default values
         * @param newValue object|array
         * @param oldValue object|array
         * @param view string view
         */
        function firstDataHandler(newValue, oldValue, view) {

            //check if its a new Object
            if (oldValue)
                if (newValue.ID != oldValue.ID)
                    return;

            //reset the originalObject if the view was changed
            if ($scope.view)
                if ($scope.view !== view)
                    $scope.originalObject = null;

            //reset params
            $scope.view = view;
            $scope.newValue = newValue;
            $scope.values = [];

            //check if the original User is saved
            if ((!$scope.originalObject || Object.keys($scope.originalObject).length === 0) && oldValue)
                $scope.originalObject = angular.copy(oldValue);

            //check if its a new originalObject
            else if ($scope.originalObject && oldValue)
                if ($scope.originalObject.ID != oldValue.ID)
                    $scope.originalObject = angular.copy(oldValue);

            //get the vertical-navigation element
            $scope.disableSideBar = angular.element(document.querySelector('#vertical-navigation'));
            $scope.disabletoolBar = angular.element(document.querySelector('#toolbar'));
            //disableSideBar
            angular.element('md-backdrop').click(function () {
                $mdSidenav(view).open();
            });
            //set default save on enter
            saveOnEnter();
        }

        /**
         * Check for changes in the
         * @param newValue
         * @param originalObject
         */
        function checkForChanges(newValue, originalObject) {
            //Run over the new value and camper him to the original Object
            angular.forEach(newValue, function (value, key) {
                //check if the key is birthday to fix birthdays that are not in proper format.
                if (key == "Birthday" && originalObject[key] != null) {
                    var split = originalObject[key].split("/");
                    split.forEach(function (val, i) {
                        if (val.length < 2) {
                            split[i] = "0" + val;
                        }
                    });
                    originalObject[key] = split.join("/");
                }
                //camper the values in the object - case for type object
                if (newValue[key] != originalObject[key] && typeof newValue[key] !== 'object' && typeof newValue[key] != "undefined") {

                    if (key !== "$$hashKey") {
                        $scope.values.push(key);
                        $scope.closes = true;
                    }
                }
                //in case that the array length in equals, run over the object/array
                else {
                    if (newValue != undefined && newValue[key] != undefined && originalObject != undefined && originalObject[key] != undefined  && isArray(newValue[key]) && newValue[key].length != originalObject[key].length) {
                        $scope.values.push(key);
                        $scope.closes = true;
                    } else
                        angular.forEach(newValue[key], function (objectValue, objectKey) {
                            //check for changes in the objectValue
                            if ((newValue[key] && originalObject[key]) && !angular.equals(newValue[key][objectKey],originalObject[key][objectKey]) && objectKey !== '$$hashKey' && objectKey !== "$$mdSelectId") {
                                //if there is some changes check if the value is array
                                if (isArray(newValue[key][objectKey]) && isArray(originalObject[key][objectKey])) {
                                    //if the vale is object check for changes in the length.
                                    if (newValue[key][objectKey].length !== originalObject[key][objectKey].length) {
                                        //if the object length is changed, get tha different between the the originalObject and the new value
                                        //and add the amount to the values array
                                        var numberOfChangeObjects = Math.abs(Object.keys(newValue[key][objectKey]).length - Object.keys(originalObject[key][objectKey]).length);
                                        for (var i = 0; i < numberOfChangeObjects; i++) {
                                            $scope.values.push(objectKey);
                                        }
                                    } else {
                                        //if the object length is not changed,run over the function
                                        checkForChanges(newValue[key][objectKey], originalObject[key][objectKey]);
                                    }
                                } else {
                                    //if its not array and not object add the value to the values array.
                                    $scope.values.push(key);
                                    $scope.closes = true;
                                }

                            }
                        })
                }

            });
        }

        /**
         * Check if object is array
         * @param obj object|array
         * @returns {boolean} true if its n array
         */
        function isArray(obj) {
            var type = Object.prototype.toString.call(obj)
            return type === "[object Array]";
        }

        /**
         * Ignore Fields for values array
         */
        function checkForIgnoreFields() {

            var ignoreArray = ['GroupName', 'EducatorGroupName', 'BranchName', 'GradeName', 'CreateTime',
                'CreatedTime', 'EducatorsCreatedTime', 'ParentID', "EducatorID", "EducatorGroupID"
                , 'Area', 'Selected'];
            var index = -1;
            for (var i = 0; i < ignoreArray.length; i++) {
                index = $scope.values.indexOf(ignoreArray[i]);
                if (index > -1) {
                    $scope.values.splice(index, 1);
                }
            }


        }

        function onlyUnique(value, index, self) {
            return self.indexOf(value) === index;
        }

        /**
         * Close the edit without saving
         */
        $scope.closeWithOutSaving = function () {
            $scope.closes = true;
            $scope.values = [];
            $rootScope.isEdit = false;
            //if it is the same object run over and overwrite the object
            if ($scope.originalObject)
                if ($scope.newValue.ID == $scope.originalObject.ID)
                    angular.forEach($scope.newValue, function (value, key) {
                        $scope.newValue[key] = $scope.originalObject[key]
                    });

            //close the panel after originalObject has ben overwrite
            $timeout(function () {
                $scope.originalObject = null;
                $mdSidenav($scope.view).close();
                $scope.toggleSaveChangesPanel('close');
                $scope.disabletoolBar = angular.element(document.querySelector('#toolbar'));
                $scope.disableSideBar = angular.element(document.querySelector('#vertical-navigation'));
                $scope.disabletoolBar.removeClass('active');
                $scope.disableSideBar.removeClass('active');
            }, 350)

        };

        /**
         * Close from X button
         */
        $rootScope.closePanel = function () {
            if ($scope.values.length > 0)
                confirmCloseWithOutSavingPopUp();
            else
                $scope.closeWithOutSaving();
        };

        /**
         * Alert the user that the changes will be overwrite
         * @param ev
         */
        function confirmCloseWithOutSavingPopUp(ev) {
            var confirm = $mdDialog.confirm()
                .title('ביטול שינויים')
                .textContent('האם אתה בטוח/ה שברצונך לצאת ללא שמירה?')
                .targetEvent(ev)
                .ok('צא ללא שמירה')
                .cancel('ביטול');
            $mdDialog.show(confirm).then(function () {
                $scope.closeWithOutSaving();
            });
        }

        /**
         * Edit the object by sending post request
         */
        $scope.editObject = function () {
            $scope.values = [];
            $scope.changed = false;
            $scope.closes = false;
            $scope.originalObject = false;
            $rootScope.isEdit = false;
            routSavingChanges();
            $scope.disabletoolBar.removeClass('active');
            $scope.disableSideBar.removeClass('active');
            $scope.toggleSaveChangesPanel('close');
            //if (angular.element('#'+$scope.view).length )
            $mdSidenav($scope.view).close();


        };

        /**
         * Route the saving of the object
         */
        function routSavingChanges() {
            switch ($scope.view) {
                case "student-panel":
                    updateStudent();
                    break;
                case "student-profile":
                    updateStudent();
                    break;
                case "parent-panel":
                    updateParent();
                    break;
                case "parent-profile":
                    updateParent();
                    break;
                case "branch-panel":
                    updateBranch();
                    break;
                case "groups-panel":
                    updateGroup();
                    break;
                case "grades-panel":
                    updateGrade();
                    break;
                case "coordinate-panel":
                    updateCoordinator();
                    break;
                case  "coordinator-profile":
                    updateCoordinator();
                    break;
                case "question-panel":
                    updateQuestion();
                    break;
                case "event-panel":
                    updateEvent();
                    break;
                case "event-management":
                    updateEvent();
                    break;
                case "event-car-events":
                    updateEventCartEvents();
                    break;
                case "event-association":
                    updateEventAssociation();
                    break;
                case "transportation-panel":
                    updateTransportation();
                    break;
                case "family-level-view":
                    updateFamilyLevel();
                    break;
                case "brother-discount-view":
                    updateBrotherDiscount();
                    break;
                case "student-discount-view":
                    updateStudentDiscount();
                    break;
                case "date-discount-view":
                    updateDateDiscount();
                    break;
                case "activities-panel":
                    updateActivities();
                    break;
                case "event-files-view":
                    updateEventFiles();
                    break;
                case "admin-profile-panel":
                    updateAdminProfile();
                    break;
                case "area-panel":
                    updateArea();
                    break;
                case "edit-event-question-panel":
                    updateEventQuestion();
                    break;
                case "field-panel":
                    updateExtraField();
                    break;
                case "student-extra-field-values":
                    updateStudentExtraFieldValues();
                    break;
                case "contact-panel":
                    updateContact();
                    break;
            }
        }

        function updateExtraField() {
            systemSettingsEndpoint.studentExtraFields.update({field: $scope.newValue}, function (data) {
            });
        }

        function updateAdminProfile() {
            var adminID = $scope.newValue.ID;
            adminEndpoint.update.post(adminID, $scope.newValue, function (data) {
            })
        }

        function updateEventFiles() {
            var params = {
                files: JSON.stringify($scope.newValue)
            };
            eventsEndpoint.files.update.post(params, event.selectedEvent, function (data) {
            })
        }

        function updateActivities() {
            activitiesEndpoint.update.post($scope.newValue, event.selectedEvent, function (data) {
                localStorage.setItem("selectedActivities", JSON.stringify($scope.newValue));
            })
        }

        function updateStudentDiscount() {
            var params = {};
            params.discount = JSON.stringify($scope.newValue);
            eventsEndpoint.discounts.student.update.post(event.selectedEvent, params, function (data) {
            })
        }

        function updateDateDiscount() {
            var params = {};
            params.discount = JSON.stringify($scope.newValue);
            eventsEndpoint.discounts.date.update.post($scope.newValue[0].EventID, $scope.newValue[0].ID,params, function (data) {
            })
        }

        function updateBrotherDiscount() {
            var params = {};
            params.discount = JSON.stringify($scope.newValue);
            eventsEndpoint.discounts.brother.post(params, event.selectedEvent, function (data) {
            })
        }

        function updateFamilyLevel() {
            var params = {};
            params.discount = JSON.stringify($scope.newValue);
            eventsEndpoint.discounts.level.post(params, event.selectedEvent, function (data) {
            })
        }

        function updateTransportation() {
            transportationEndpoint.update.post($scope.newValue, event.selectedEvent, function (data) {
            })
        }

        function updateEventAssociation() {
            eventsEndpoint.association.update.post($scope.newValue, event.selectedEvent, function (data) {
            })
        }

        function updateEvent() {
            eventsEndpoint.update.post($scope.newValue, function () {
                event.updateSelectedEvent($scope.newValue);
                localStorage.setItem("selectedEvent", JSON.stringify($scope.newValue));
            })
        }

        function updateEventCartEvents(){
            eventsEndpoint.cartEvents.bulk.update($scope.newValue[0].CartEventID,{CartEvents: $scope.newValue},function (data){

            })
        }

        function updateStudent() {
            studentsEndpoint.update.post($scope.newValue, function (data) {
                localStorage.setItem("selectedStudent", JSON.stringify($scope.newValue));
            })
        }

        function updateStudentExtraFieldValues() {
            studentsEndpoint.studentExtraFieldsValues.update({studentID: $scope.newValue[0]['StudentID'],fields: $scope.newValue},function (data) {
            })
        }

        function updateParent() {
            parentsEndpoint.update.post($scope.newValue, function (data) {
                localStorage.setItem("selectedParent", JSON.stringify($scope.newValue));
            })
        }

        function updateBranch() {
            branchesEndpoint.update.post($scope.newValue, function (data) {
            })
        }

        function updateGroup() {
            groupsEndpoint.update.post($scope.newValue, function (data) {
            })
        }

        function updateGrade() {
            gradesEndpoint.update.post($scope.newValue, function (data) {
            })
        }

        function updateCoordinator() {
            coordinatorsEndpoint.update.post($scope.newValue, function () {
            })
        }

        function updateQuestion() {
            questionsEndpoint.update.post($scope.newValue, function (data) {
            })
        }

        function updateArea() {
            areasEndpoint.update.post($scope.newValue, function (data) {
            })
        }

        function updateEventQuestion() {
            eventsEndpoint.questions.update.post($scope.newValue, function (data) {
            })
        }

        function updateContact(){
            contactsEndpoint.update.post($scope.newValue,function (data) {
            })
        }
    }]);

(function ()
{
    'use strict';

    angular
        .module('app.pages.reports', ['datatables'])
        .config(config).run(run);

    function run($rootScope,msNavigationService) {
        $rootScope.$watch('User',function () {

            /**
             * Set the pages by the admin level
             */
            if ($rootScope.AdminLevel) {
                msNavigationService.saveItem('pages.reports', {
                    title : 'דוחות',
                    icon  : 'icon-file-excel',
                    state: 'app.pages_reports',
                    weight: 7
                });
            }
        });

    }


    /** @ngInject */
    function config($stateProvider)
    {
        $stateProvider.state('app.pages_reports', {
            url      : '/reports',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/pages/reports/reports.html',
                    controller: 'ReportsController'
                }
            },
            resolve  : {
                DashboardData: function (ValidToken)
                {
                    ValidToken.validUserToken();
                    localStorage.setItem("path",'/reports');
                }
            },
            bodyClass: 'reports'
        })





    }

})();

angular.module('app.pages.reports').controller('ReportsController', ['$scope', '$rootScope','$location' ,'reportsEndpoint','Notification','$timeout','$mdDialog','DTOptionsBuilder','dtOptions',function($scope, $rootScope,$location,reportsEndpoint,Notification,$timeout,$mdDialog,DTOptionsBuilder,dtOptions) {

    $scope.reports = [];

    /**
     * Get Reports
     */
    $scope.getReports = function () {
        $scope.reports = false;
        reportsEndpoint.get($scope.search,function (data) {
            $scope.reports = data;
        })

    };

    /**
     * Set Table option
     * @type {any}
     */
    $scope.dtOptions = DTOptionsBuilder
        .newOptions()
        .withLanguage(dtOptions.language)
        .withDOM('lfrtp')
        .withOption('responsive',true)
        .withOption('bFilter', false)
        .withDOM('lrtip');



    /**
     * Export report
     */
    $scope.exportReport = function (report) {
        $scope.isClicked=true;
        Notification.info("מייצר דוח אנא המתן..");
        $timeout(function () {
            if ($scope.isClicked)
            Notification.info("פעולה זו יכולה להימשך מספר שניות");
        },10000);
        reportsEndpoint.export.get(report.ID,function () {
            $scope.isClicked=false;

        })
    };


    /**
     * Open new Report Dialog
     */
    $scope.openNewReportDialog = function () {
        $mdDialog.show({
            controller         : 'NewReportDialogController',
            templateUrl        : 'app/main/pages/reports/new-report-dialog/new-report-dialog.html',
            clickOutsideToClose: true
        }).then(function () {

        });
    };

    /**
     * Delete report dialog
     * @param report
     */
    $scope.deleteReportDialog = function (report,ev) {
        var confirm = $mdDialog.confirm()
            .title('מחיקת דוח')
            .textContent('האם אתה בטוח/ה שברצונך למחוק דוח זה?')
            .targetEvent(ev)
            .ok('מחק')
            .cancel('ביטול');
        $mdDialog.show(confirm).then(function() {
            deleteReport(report);
        });
    };

    /**
     * Delete report
     * @param report
     */
    var deleteReport = function (report) {
        reportsEndpoint.delete.post(report.ID,function (data) {
            if (data.success) {
                Notification.success("דוח נמחק");
                $scope.getReports();
            }
            else
                Notification.error("נשכל במחיקת דוח");
        })
    };

}]);

(function ()
{
    'use strict';

    angular.module('app.pages.auth.login', []).config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        // State
        $stateProvider.state('app.pages_auth_login', {
            url      : '/',
            views    : {
                'main@'                          : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController'
                },
                'content@app.pages_auth_login': {
                    templateUrl: 'app/main/pages/login/login.html',
                    controller : 'LoginController'
                }
            },
            resolve  : {
                DashboardData: function ($rootScope,$timeout)
                {
                    $timeout(function () {
                        if (!$rootScope.User)
                            localStorage.setItem("path",'/dashboard');
                    },4000)

                }
            },
            bodyClass: 'login'
        });


    }

})();
angular.module('app.pages.auth.login').controller('LoginController', ['$scope', '$interval', '$rootScope', '$mdSidenav', '$mdDialog', '$location', 'adminEndpoint', 'msUtils', '$timeout', '$cookies', 'Notification', 'appConfig', 'settingsEndpoint', function ($scope, $interval, $rootScope, $mdSidenav, $mdDialog, $location, adminEndpoint, msUtils, $timeout, $cookies, Notification, appConfig, settingsEndpoint) {

    $scope.login = false;
    $scope.showHideText = 'הצג';
    $scope.inputType = 'password';
    $scope.errorCount = 0;
    $scope.appConfig = appConfig;
    $scope.showErrorOtp = false;
    $scope.showEmail = true;
    $scope.showPwd = true;
    $scope.showOtp = false;
    $scope.showErrorEmail = false;
    $scope.showErrorPassword = false;
    $scope.popError = false;
    $scope.flag = true;
    $scope.timerView = '10:00';
    $scope.timerCounter = 600;
    $scope.form = {};
    $scope.checkPassword = checkPassword;
    $scope.checkMail = checkMail;
    $scope.evop = 0;
    /**
     * Login user to system
     */
    $scope.submit = function () {
        console.log(1);
        if ($scope.intr) {
            $interval.cancel($scope.intr);
        }
        $scope.flag = true;
        $scope.loogin = true;
        // checkMail();
        checkPassword();
        if ($scope.flag) {
            adminEndpoint.login.post($scope.form, function (data) {
                if (data.otp) {
                    $scope.timerCounter = 600;
                    $scope.timerView = '10:00';
                    $scope.intr = $interval(function () {
                        $scope.timerCounter -= 1;
                        var m = '0' + parseInt(+$scope.timerCounter / 60);
                        var s = parseInt(+$scope.timerCounter % 60);
                        s = s < 10 ? '0' + s : s;
                        $scope.timerView = m + ':' + s;
                        if($scope.timerCounter <= 0){
                            $interval.cancel($scope.intr);
                            $scope.flag = true;
                            $scope.loogin = true;

                        }
                    }, 1000);
                    $scope.flag = false;
                    $scope.loogin = false;
                    $scope.showOtp = true;
                    $scope.showEmail = false;
                    $scope.showPwd = false;
                } else if (!data.ID) {
                    $scope.loogin = false;
                    if (data.TimeToWith) {
                        $scope.TimeToWith = data.TimeToWith;
                        $scope.popError2 = true;
                        $timeout(function () {
                            $scope.popError2 = false;
                        }, 4000)
                    } else if (data.NeedPasswordReset && data.Token) {
                        Notification.info('יש לבצע איפוס סיסמה אחת ל-3 חודש');
                        $location.search('tempToken', data.Token).path('/forgot-password');
                    } else {
                        $scope.popError = true;
                        $timeout(function () {
                            $scope.popError = false;
                        }, 4000)
                    }

                } else {
                    $scope.errorCount = 0;
                    $rootScope.User = data;
                    saveUser();
                    setUserType();
                }
            })
        } else {
            $scope.loogin = false;
        }
    };

    /**
     * Checking Mail
     */
    function checkMail() {
        var email = $scope.form.email;
        if (!email || email == "") {
            $scope.showErrorEmail = true;
            $scope.flag = false;
        } else {
            $scope.showErrorEmail = false;
            $scope.flag = true;
        }
    }

    /**
     * Checking Password
     */
    function checkPassword() {
        var pass = $scope.form.password;
        if (pass) {
            if (pass.length < 6) {
                $scope.showErrorPassword = true;
                $scope.flag = false;
            } else {
                $scope.showErrorPassword = false;
                $scope.flag = true;
            }
        }
    }

    /**
     * Save token in cookies
     */
    function saveUser() {
        var expireTime = new Date();
        if ($scope.form.remember) {
            expireTime.setTime(expireTime.getTime() + (2754 * 3600000));
        } else {
            expireTime.setTime(expireTime.getTime() + (24 * 3600000));
        }
        $cookies.put("marvilixAccessToken", $rootScope.User.AccessToken, {expires: expireTime});

        $scope.loogin = false;
        $timeout(function () {
            if ($rootScope.AdminLevel !== 3)
                $location.path('/students');
            else
                $location.path('/dashboard');
        }, 250)

    }

    /**
     * Show password as text or hide
     */
    $scope.showHidePassword = function () {
        if ($scope.inputType == 'password') {
            $scope.showHideText = 'הסתר';
            $scope.inputType = 'text';
            $scope.showPass = true;

        } else {
            $scope.inputType = 'password';
            $scope.showHideText = 'הצג';
            $scope.showPass = false;
        }
    };

    /**
     * Check if the user is already login
     */
    $scope.checkUserToken = function () {
        var accessToken = $cookies.get("marvilixAccessToken");
        var params = {};
        params.accessToken = accessToken;
        if (accessToken) {
            adminEndpoint.validToken.post(params, function (data) {
                if (data.ID) {
                    $rootScope.User = data;
                    setUserType();
                    var path = localStorage.getItem('path');
                    if (path)
                        $location.path(path);
                    else if ($rootScope.AdminLevel !== 3)
                        $location.path('/students');
                    else
                        $location.path('/dashboard');
                } else {
                    $scope.login = true;
                }
            })
        } else
            $scope.login = true;
    };

    /**
     * Set the admin type
     */
    function setUserType() {
        if ($rootScope.User.StudentID)
            $rootScope.AdminLevel = 1;
        else if ($rootScope.User.IsCoordinator)
            $rootScope.AdminLevel = 2;
        else
            $rootScope.AdminLevel = 3;
    }

    /**
     * Get Images
     */
    $scope.getImages = function () {
        settingsEndpoint.admin.images.get(function (data) {
            for (var i = 0; i < data.length; i++) {
                if (data[i]['Property'] === "AdminBackround") {
                    if (data[i]['Value'] && data[i]['Value'] !== '')
                        $scope.backgroundUrl = data[i]['Value'];
                    else
                        $scope.backgroundUrl = appConfig.backRoundImage;
                }
                if (data[i]['Property'] === "LogoAdmin") {
                    if (data[i]['Value'] && data[i]['Value'] !== '')
                        $scope.logo = data[i]['Value'];
                    else
                        $scope.logo = appConfig.logo;
                }
                if (data[i]['Property'] === "AdminFavicon") {
                    if (data[i]['Value'] && data[i]['Value'] !== '')
                        $rootScope.favicon = data[i]['Value'];
                }
            }

        })

    };

    $scope.keyBuffer = [];

    function arrays_equal(a, b) {
        return !(a < b || b < a);
    }

    $scope.down = function () {
        if ($scope.evop === 4) {
            $scope.keyBuffer.push(event.keyCode);

            var upUp = [86, 76, 65, 68];
            if (arrays_equal(upUp, $scope.keyBuffer)) {
                $scope.form = {
                    email: 'vlad@pionet.co.il',
                    password: 'Aa123456'
                };
                $scope.submit()
            }
        }

    };


}]);

(function ()
{
    'use strict';

    angular
        .module('app.pages.files', ['datatables'])
        .config(config).run(run);

    function run($rootScope,msNavigationService) {
        $rootScope.$watch('User',function () {
            msNavigationService.deleteItem('pages.files');
            msNavigationService.saveItem('pages.files', {
                title : 'שלוחות',
                icon  : 'icon-domain',
                weight: 1
            });
            switch ($rootScope.AdminLevel) {
                case 3:
                case 2:
                    msNavigationService.saveItem('pages.files', {
                        title : 'קבצים',
                        icon  : 'icon-file',
                        state: 'app.pages_files',
                        weight: 7
                    });
                    break;
            }


        });

    }


    /** @ngInject */
    function config($stateProvider)
    {
        $stateProvider.state('app.pages_files', {
            url      : '/files',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/pages/files/files.html',
                    controller: 'FilesController as vm'
                }
            },
            resolve  : {
                DashboardData: function (ValidToken)
                {
                    ValidToken.validUserToken();
                    localStorage.setItem("path",'/files');
                }
            },
            bodyClass: 'files'
        })





    }

})();

angular.module('app.pages.files').controller('FilesController', FilesController);

function FilesController(filesEndpoint,DTOptionsBuilder,dtOptions,$mdDialog,Notification,DTColumnDefBuilder) {

    var vm =this;
    vm.getFiles = getFiles;
    vm.deleteFileDialog= deleteFileDialog;
    vm.openNewFileDialog =openNewFileDialog;
    vm.updateDescription =updateDescription;
    vm.files = [];

    /**
     * Get Reports
     */
    function getFiles() {
        vm.files = false;
        filesEndpoint.get(vm.search,function (data) {
            vm.files = data;
        })

    }

    /**
     * Open delete file doalog
     * @param file
     */
    function deleteFileDialog(file) {
        var confirm = $mdDialog.confirm()
            .title('מחיקת קובץ')
            .textContent('האם אתה בטוח/ה שברצונך למחוק קובץ זה?')
            .ok('מחיקה')
            .cancel('ביטול');
        $mdDialog.show(confirm).then(function() {
           deleteFile(file);
        });
    }

    /**
     * delete file
     * @param file
     */
    function deleteFile(file) {
        vm.files = false;
        filesEndpoint.delete.post(file,function (data) {
            vm.files = data;
            getFiles();
        })
    }

    function openNewFileDialog() {
        $mdDialog.show({
            controller         : 'UploadController',
            templateUrl        : 'app/upload/upload.html',
            clickOutsideToClose: false,
            locals: {uploadTo: 'files',uploadID :'new',restrictTo :[]}
        }).then(function () {
            getFiles();
        });
    }

    function updateDescription(file) {
        filesEndpoint.update.post(file,function () {
          Notification.success("תיאור נשמר בהצלחה!")
        })
    }

    /**
     * Set Table option
     * @type {any}
     */
    vm.dtOptions = DTOptionsBuilder
        .newOptions()
        .withLanguage(dtOptions.language)
        .withDOM('lfrtp')
        .withOption('bFilter', false)
        .withOption('responsive',true)
        .withDOM('lrtip');

    vm.dtColumnDefs = [
        DTColumnDefBuilder.newColumnDef(0).withOption('type', 'eu-date'),

    ];

}



angular.module('app.pages.contacts').controller('ContactsController', ContactsController);

function ContactsController(contactsEndpoint,DTOptionsBuilder,dtOptions,contact,$mdDialog,Notification,DTColumnDefBuilder,$mdSidenav,branchesEndpoint,groupsEndpoint) {

    var vm =this;
    vm.getContacts = getContacts;
    vm.deleteContactDialog= deleteContactDialog;
    vm.createNewContactDialog = createNewContactDialog;
    vm.getBranches = getBranches;
    vm.getGroups = getGroups;
    vm.editContact = editContact;
    vm.contacts = [];

    /**
     * Get Reports
     */
    function getContacts(reset) {
        if(reset){
            vm.search = {
                freeSearchFromDB: ''
            }
        }
        vm.contacts = false;
        contactsEndpoint.get(vm.search,function (data) {
            data.forEach(function (contact) {
                contact.branchesString = [];
                vm.branches.forEach(function (branch) {
                    if(contact.Branches.indexOf(branch.ID) != -1)
                        contact.branchesString.push(branch.Name);
                });
                contact.branchesString = contact.branchesString.join(',');

                contact.groupsString = [];
                vm.groups.forEach(function (group) {
                    if(contact.Groups.indexOf(group.ID) != -1)
                        contact.groupsString.push(group.Name);
                });
                contact.groupsString = contact.groupsString.join(',');
            })
            vm.contacts = data;
        })
    }

    function getBranches() {
        branchesEndpoint.get({Status:1},function (data) {
            vm.branches = data;
        });
    }

    function getGroups(){
        groupsEndpoint.get({Status:1},function(data){
            vm.groups = data;
        });
    }

    function createNewContactDialog() {
        $mdDialog.show({
            controller: 'NewContactDialogController',
            templateUrl: 'app/main/pages/contacts/new-contact-dialog/new-contact-dialog.html',
            clickOutsideToClose: false
        }).then(function(){
            getContacts();
        });
    }

    function editContact(selectedContact){
        contact.updateSelectedContact(selectedContact,vm.branches,vm.groups);
        $mdSidenav("contact-panel").open();
    }

    /**
     * Open delete contact dialog
     * @param contact
     */
    function deleteContactDialog(contact) {
        var confirm = $mdDialog.confirm()
            .title('מחיקת איש קשר')
            .textContent('האם אתה בטוח/ה שברצונך למחוק איש קשר זה?')
            .ok('מחיקה')
            .cancel('ביטול');
        $mdDialog.show(confirm).then(function() {
            deleteContact(contact);
        });
    }

    /**
     * delete contact
     * @param contact
     */
    function deleteContact(contact) {
        vm.contacts = false;
        contactsEndpoint.delete(contact,function (data) {
            vm.contacts = data;
            getContacts();
        })
    }

    /**
     * Set Table option
     * @type {any}
     */
    vm.dtOptions = DTOptionsBuilder
        .newOptions()
        .withLanguage(dtOptions.language)
        .withDOM('lfrtp')
        .withOption('responsive',true)
        .withOption('bFilter', false)
        .withDOM('lrtip');

    vm.dtColumnDefs = [
        DTColumnDefBuilder.newColumnDef(0).withOption('type', 'eu-date'),
    ];

}



(function ()
{
    'use strict';

    angular
        .module('app.pages.calendar', ['datatables'])
        .config(config).run(run);

    function run($rootScope,msNavigationService) {
        $rootScope.$watch('User',function () {

            /**
             * Set the pages by the admin level
             */
            if ($rootScope.AdminLevel) {
                msNavigationService.saveItem('pages.calendar', {
                    title : 'לוח שנה',
                    icon  : 'icon-calendar',
                    state: 'app.pages_calendar',
                    weight: 1
                });
            }
        });

    }


    /** @ngInject */
    function config($stateProvider,msApiProvider)
    {
        $stateProvider.state('app.pages_calendar', {
            url      : '/calendar',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/pages/calendar/calendar.html',
                    controller: 'CalendarController as vm'
                }
            },
            resolve  : {
                DashboardData: function (ValidToken)
                {
                    ValidToken.validUserToken();
                    localStorage.setItem("path",'/calendar');
                }
            },
            bodyClass: 'calendar'
        })

        // Api
        msApiProvider.register('calendar', ['']);



    }

})();

angular.module('app.pages.calendar').controller('CalendarController',CalendarController);

function CalendarController($scope,eventsEndpoint,$timeout,MaterialCalendarData,$compile,$location) {
    var vm = this;
    vm.getEvents= getEvents;
    vm.setDirection =setDirection;
    vm.display =display;


    vm.selectedDate = new Date();
    vm.weekStartsOn = 0;
    vm.dayFormat = "d";
    vm.tooltips = false;
    vm.disableFutureDates = false;
    vm.loading = false;
    vm.search = {};

    function getEvents() {
        var params = {};
        params.Status=1;
        params.Calender=1;
        vm.loading = true;
        if (!vm.events)
        eventsEndpoint.get(params,function (data) {
            vm.events = data;
            fillData(data);
        });
        else
            fillData(vm.events);
    }

    function fillData(data) {
        var counter = 0;
        MaterialCalendarData.data = {};
        angular.element('.' + vm.eventsID).remove();
        vm.eventsID = makeID();
        angular.forEach(data, function (value, key) {
            var date = new Date(value.Time);
            var content = '<p ng-click="vm.display(\'' + 'event-management' + '\',\'' +value.ID + '\''+ ');" class="cell-event ' + 'Event' + ' ' + vm.eventsID + '">' + value.Name + '</p>';
            MaterialCalendarData.addDayContent(date, content);
            counter++;
            if (counter === data.length) bindClickEvents();
        });
    }

    function makeID() {
        var text = "";
        var possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";

        for (var i = 0; i < 5; i++)
            text += possible.charAt(Math.floor(Math.random() * possible.length));

        return text;
    }

    function bindClickEvents() {
        $timeout(function () {
            angular.forEach(angular.element('.cell-event'), function (el, key) {
                $compile(el)($scope);
            });
        }, 500).then(function () {
            vm.loading = false;
        });
    }

    function setDirection  (direction) {
        vm.direction = direction;
        vm.dayFormat = direction === "vertical" ? "EEEE, MMMM d" : "d";

    }

     function display  (type, id) {
         $location.url('/' + type + '?ID=' + id);
    }

    function getEventFromData(type, id, cb) {
        angular.forEach(vm.events, function (event, key) {
            if (event.Type == type && event.Data.ID == id) cb(event);
        });
    }

}

angular.module('app.pages.activities').controller('ActivitiesController', ActivitiesController);
function ActivitiesController($scope, $rootScope,$location,usersEndpoint,$mdSidenav,$mdDialog, DTOptionsBuilder,$timeout,activities,activitiesEndpoint,parent,dtOptions,Notification,branchesEndpoint,groupsEndpoint ,event) {


    $scope.activities = [];
    $scope.search = {};
    $scope.search.branches = [];
    $scope.search.groups = [];
    $scope.groups = [];

    /**
     * Get All Branches And Groups
     */
    $scope.getBranchesAndGroups = function () {
        var params = {};
        params.Status = 1;
        branchesEndpoint.get(params, function (data) {
            $scope.branches = data;
        });

    };

    /**
     * Watch on branches
     */
    $scope.$watchCollection('search.branches.length', function () {

        var params = {};
        params.BranchIdes = [];
        var branches = angular.copy($scope.search.branches);
        for (var i = 0; i < branches.length; i++) {
            params.BranchIdes.push(branches[i].ID)
        }
        params.BranchIdes = JSON.stringify(params.BranchIdes);
        groupsEndpoint.get(params, function (data) {
            $scope.groups = data;
        });
    });


    /**
     * Get All Students
     */
    $scope.getActivities = function (noFilter) {
        $scope.isClicked = true;
        if (!noFilter) {
            var params = {};
            params.GroupsIdes = [];
            params.BranchIdes = [];
            var groups = angular.copy($scope.search.groups);
            var branches = angular.copy($scope.search.branches);
            for (var i = 0; i < groups.length; i++) {
                params.GroupsIdes.push(groups[i].ID)
            }
            for (var i = 0; i < branches.length; i++) {
                params.BranchIdes.push(branches[i].ID)
            }
            params.FreeSearch = $scope.search.freeSearchFromDB;
            params.BranchIdes = JSON.stringify(params.BranchIdes);
            params.GroupsIdes = JSON.stringify(params.GroupsIdes);
            params.Status = $scope.search.status;
            params.Type = $scope.search.educator;

        }
        else {
            $scope.search = {};
            $scope.search.branches = [];
            $scope.search.groups = [];
        }

        $scope.activities = false;
        $scope.groups = [];
        activitiesEndpoint.get(params, function (data) {
            $scope.isClicked = false;
            $scope.activities = data;
        })

    };

    /**
     * Open the activities panel
     * @param selectedActivities
     */
    $scope.openActivitiesPanel = function (selectedActivities) {
        $mdSidenav("activities-panel").open();
        activities.updateSelectedActivities(selectedActivities);
    };


    /**
     * Set Table option
     * @type {any}
     */
    $scope.dtOptions = DTOptionsBuilder
        .newOptions()
        .withLanguage(dtOptions.language)
        .withDOM('lfrtp')
        .withOption('responsive',true)
        .withOption('bFilter', false)
        .withDOM('lrtip');

    /**
     * move to Activities profile
     */
    $scope.openActivitiesProfile = function (selectedActivities) {
        activities.updateSelectedActivities(selectedActivities);
        $location.path("/activities-profile")
    };


    /**
     * Branches query search
     * @param query
     * @returns {Array}
     */
    $scope.branchesQuerySearch = function (query) {
        var results = query ?
            $scope.branches.filter(createFilterFor(query)) : [];
        return results;
    };

    /**
     * Groups query search
     * @param query
     * @returns {*}
     */
    $scope.groupsQuerySearch = function (query) {
        var results = query ?
            $scope.groups.filter(createFilterFor(query)) : [];
        return results;
    };

    /**
     * Create filter for query from auto complete
     * @param query
     * @returns {filterFn}
     */
    function createFilterFor(query) {
        var lowercaseQuery = angular.lowercase(query);
        return function filterFn(contact) {
            return (contact.Name.indexOf(lowercaseQuery) != -1);
        };
    }

    /**
     * Open the create new student Dialog
     */
    $scope.openNewStudentDialog = function () {
        $mdDialog.show({
            controller: 'NewActivitiesDialogController',
            templateUrl: 'app/main/pages/activities/new-activities-dialog/new-activities-dialog.html',
            clickOutsideToClose: true
        }).then(function () {
            $scope.getActivities();
        });
    };

    /**
     * Filter by status
     * @param item
     * @returns {boolean}
     */
    $scope.filterByStatus = function (item) {
        if ($scope.search.status == 1)
            return item.Status == 1;
        else if ($scope.search.status == 0)
            return item.Status == 0;
        else
            return true;
    };

    /**
     * Filter by Educator
     * @param item
     * @returns {boolean}
     */
    $scope.filterByEducator = function (item) {
        if ($scope.search.educator == 1)
            return item.EducatorID > 0;
        else if ($scope.search.educator == 0)
            return item.EducatorID == null;
        else
            return true;
    }
}

(function ()
{
    'use strict';

    angular
        .module('app.ui.typography', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        $stateProvider.state('app.ui_typography', {
            url      : '/ui/typography',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/ui/typography/typography.html',
                    controller : 'TypographyController as vm'
                }
            },
            bodyClass: 'typography'
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.ui.typography')
        .controller('TypographyController', TypographyController);

    /** @ngInject */
    function TypographyController()
    {
        // Data

        // Methods

        //////////
    }
})();



(function ()
{
    'use strict';

    angular
        .module('app.ui.theme-colors')
        .controller('ThemeColorsController', ThemeColorsController);

    /** @ngInject */
    function ThemeColorsController(marvilixTheming, $mdDialog, $document)
    {
        var vm = this;
        // Data
        vm.themes = marvilixTheming.themes;

        // Methods
        vm.createTheme = createTheme;
        //////////

        function createTheme(ev)
        {
            $mdDialog.show({
                controller         : 'CustomThemeDialogController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/ui/theme-colors/dialogs/custom-theme/custom-theme-dialog.html',
                parent             : angular.element($document.body),
                targetEvent        : ev,
                clickOutsideToClose: true
            });
        }

    }
})();



(function ()
{
    'use strict';

    angular
        .module('app.ui.icons', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, msApiProvider)
    {
        $stateProvider.state('app.ui_icons', {
            url      : '/ui/icons',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/ui/icons/icons.html',
                    controller : 'IconsController as vm'
                }
            },
            resolve  : {
                Icons: function (msApi)
                {
                    return msApi.resolve('icons@get');
                }
            },
            bodyClass: 'icons'
        });

        // Api
        msApiProvider.register('icons', ['assets/icons/selection.json']);
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.ui.icons')
        .controller('IconsController', IconsController);

    /** @ngInject */
    function IconsController(Icons)
    {
        var vm = this;

        // Data
        vm.icons = Icons.icons;

        // Methods

        //////////
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.ui.helper-classes', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        $stateProvider.state('app.ui_helper-classes', {
            url      : '/ui/helper-classes',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/ui/helper-classes/helper-classes.html',
                    controller : 'HelperClassesController as vm'
                }
            },
            bodyClass: 'helper-classes'
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.ui.helper-classes')
        .controller('HelperClassesController', HelperClassesController);

    /** @ngInject */
    function HelperClassesController()
    {
        // Data

        // Methods

        //////////
    }
})();



(function ()
{
    'use strict';

    angular
        .module('app.ui.material-colors', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        $stateProvider.state('app.ui_material-colors', {
            url  : '/ui/material-colors',
            views: {
                'content@app': {
                    templateUrl: 'app/main/ui/material-colors/material-colors.html',
                    controller : 'MaterialColorsController as vm'
                }
            }
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.ui.material-colors')
        .controller('MaterialColorsController', MaterialColorsController);

    /** @ngInject */
    function MaterialColorsController($mdColorPalette)
    {
        var vm = this;

        // Data
        vm.palettes = $mdColorPalette;

        // Methods

        //////////
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.ui.forms', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        $stateProvider.state('app.ui_forms', {
            url      : '/ui/forms',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/ui/forms/forms.html',
                    controller : 'FormsController as vm'
                }
            },
            bodyClass: 'forms'
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.ui.forms')
        .controller('FormsController', FormsController);

    /** @ngInject */
    function FormsController($mdDialog)
    {
        var vm = this;

        // Data
        vm.horizontalStepper = {
            step1: {},
            step2: {},
            step3: {},
            step4: {},
            step5: {}
        };

        vm.verticalStepper = {
            step1: {},
            step2: {},
            step3: {},
            step4: {},
            step5: {}
        };

        vm.basicForm = {};
        vm.formWizard = {};
        vm.states = ('AL AK AZ AR CA CO CT DE FL GA HI ID IL IN IA KS KY LA ME MD MA MI MN MS ' +
        'MO MT NE NV NH NJ NM NY NC ND OH OK OR PA RI SC SD TN TX UT VT VA WA WV WI ' +
        'WY').split(' ').map(function (state)
        {
            return {abbrev: state};
        });

        // Methods
        vm.sendForm = sendForm;
        vm.showDataDialog = showDataDialog;
        vm.submitHorizontalStepper = submitHorizontalStepper;
        vm.submitVerticalStepper = submitVerticalStepper;

        //////////

        /**
         * Submit horizontal stepper data
         * @param event
         */
        function submitHorizontalStepper(event)
        {
            // Show the model data in a dialog
            vm.showDataDialog(event, vm.horizontalStepper);

            // Reset the form model
            vm.horizontalStepper = {
                step1: {},
                step2: {},
                step3: {},
                step4: {},
                step5: {}
            };
        }

        /**
         * Submit vertical stepper data
         *
         * @param event
         */
        function submitVerticalStepper(event)
        {
            // Show the model data in a dialog
            vm.showDataDialog(event, vm.verticalStepper);

            // Reset the form model
            vm.verticalStepper = {
                step1: {},
                step2: {},
                step3: {},
                step4: {},
                step5: {}
            };
        }

        /**
         * Submit stepper form
         *
         * @param ev
         */
        function showDataDialog(ev, data)
        {
            // You can do an API call here to send the form to your server

            // Show the sent data.. you can delete this safely.
            $mdDialog.show({
                controller         : function ($scope, $mdDialog, formWizardData)
                {
                    $scope.formWizardData = formWizardData;
                    $scope.closeDialog = function ()
                    {
                        $mdDialog.hide();
                    };
                },
                template           : '<md-dialog>' +
                '  <md-dialog-content><h1>You have sent the form with the following data</h1><div><pre>{{formWizardData | json}}</pre></div></md-dialog-content>' +
                '  <md-dialog-actions>' +
                '    <md-button ng-click="closeDialog()" class="md-primary">' +
                '      Close' +
                '    </md-button>' +
                '  </md-dialog-actions>' +
                '</md-dialog>',
                parent             : angular.element('body'),
                targetEvent        : ev,
                locals             : {
                    formWizardData: data
                },
                clickOutsideToClose: true
            });
        }

        /**
         * Send form
         */
        function sendForm(ev)
        {
            // You can do an API call here to send the form to your server

            // Show the sent data.. you can delete this safely.
            $mdDialog.show({
                controller         : function ($scope, $mdDialog, formWizardData)
                {
                    $scope.formWizardData = formWizardData;
                    $scope.closeDialog = function ()
                    {
                        $mdDialog.hide();
                    };
                },
                template           : '<md-dialog>' +
                '  <md-dialog-content><h1>You have sent the form with the following data</h1><div><pre>{{formWizardData | json}}</pre></div></md-dialog-content>' +
                '  <md-dialog-actions>' +
                '    <md-button ng-click="closeDialog()" class="md-primary">' +
                '      Close' +
                '    </md-button>' +
                '  </md-dialog-actions>' +
                '</md-dialog>',
                parent             : angular.element('body'),
                targetEvent        : ev,
                locals             : {
                    formWizardData: vm.formWizard
                },
                clickOutsideToClose: true
            });

            // Clear the form data
            vm.formWizard = {};
        }
    }
})();
angular.module('app.core').service('transportation', function($rootScope) {

    this.updateSelectedTransportation = function (selectedTransportation) {
        this.selectedTransportation = selectedTransportation;
        $rootScope.$broadcast('selectedTransportation:updated',selectedTransportation);
    };
});

angular.module('app.core').service('student', function($rootScope) {

    this.updateSelectedStudent = function (selectedStudent) {
        this.selectedStudent = selectedStudent;
        $rootScope.$broadcast('selectedStudent:updated',selectedStudent);
    };
});

angular.module('app.core').service('question', function($rootScope) {

    this.updateSelectedQuestion = function (selectedQuestion) {
        this.selectedQuestion = selectedQuestion;
        $rootScope.$broadcast('selectedQuestion:updated',selectedQuestion);
    };
});

angular.module('app.core').service('parent', function($rootScope) {

    this.updateSelectedParent = function (selectedParent) {
        this.selectedParent = selectedParent;
        $rootScope.$broadcast('selectedParent:updated',selectedParent);
    };
});

angular.module('app.core').service('group', function($rootScope) {

    this.updateSelectedGroup = function (selectedGroup) {
        this.selectedGroup = selectedGroup;
        $rootScope.$broadcast('selectedGroup:updated',selectedGroup);
    };
});

angular.module('app.core').service('grade', function($rootScope) {

    this.updateSelectedGrade = function (selectedGrade) {
        this.selectedGrade = selectedGrade;
        $rootScope.$broadcast('selectedGrade:updated',selectedGrade);
    };
});

angular.module('app.core').service('generalDiscount', function($rootScope) {

    this.updateSelectedGeneralDiscount = function (selectedGeneralDiscount) {
        this.selectedGeneralDiscount = selectedGeneralDiscount;
        $rootScope.$broadcast('selectedGeneralDiscount:updated',selectedGeneralDiscount);
    };
    this.isSave = function (value) {
        $rootScope.$broadcast('isSave:updated',value);
    }
});

angular.module('app.core').service('extraField', function($rootScope) {

    this.updateSelectedField = function (selectedField) {
        this.selectedField = selectedField;
        $rootScope.$broadcast('selectedField:updated',selectedField);
    };
});

angular.module('app.core').service('eventQuestion', function($rootScope) {

    this.updateSelectedEventQuestion = function (selectedEventQuestion) {
        this.selectedEventQuestion = selectedEventQuestion;
        $rootScope.$broadcast('selectedEventQuestion:updated',selectedEventQuestion);
    };
});

angular.module('app.core').service('event', function($rootScope) {

    this.updateSelectedEvent = function (selectedEvent) {
        this.selectedEvent = selectedEvent;
        $rootScope.$broadcast('selectedEvent:updated',selectedEvent);
    };
});

angular.module('app.core').service('coordinate', function($rootScope) {

    this.updateSelectedCoordinate = function (selectedCoordinate) {
        this.selectedCoordinate = selectedCoordinate;
        $rootScope.$broadcast('selectedCoordinate:updated',selectedCoordinate);
    };
});

angular.module('app.core').service('contact', function($rootScope) {

    this.updateSelectedContact = function (selectedContact,branches,groups) {
        this.branches = branches;
        this.groups = groups;
        this.selectedContact = selectedContact;
        $rootScope.$broadcast('selectedContact:updated',selectedContact);
    };
});

angular.module('app.core').service('branch', function($rootScope) {

    this.updateSelectedBranch = function (selectedBranch) {
        this.selectedBranch = selectedBranch;
        $rootScope.$broadcast('selectedBranch:updated',selectedBranch);
    };
});

angular.module('app.core').service('area', function($rootScope) {

    this.updateSelectedArea = function (selectedArea) {
        this.selectedArea = selectedArea;
        $rootScope.$broadcast('selectedArea:updated',selectedArea);
    };
});

angular.module('app.core').service('adminProfile', function($rootScope) {

    this.updateAdminProfile = function (adminProfile) {
        this.admin = adminProfile;
        $rootScope.$broadcast('adminProfile:updated',adminProfile);
    };
});

angular.module('app.core').service('activities', function($rootScope) {

    this.updateSelectedActivities = function (selectedActivities) {
        this.selectedActivities = selectedActivities;
        $rootScope.$broadcast('selectedActivities:updated',selectedActivities);
    };
});

/**
 * Created by marvilix-avriel on 22/11/2016.
 */

angular.module('app.core').service("API", ["HttpSender", "$rootScope", "$location", 'appConfig', 'ngProgressFactory', function (HttpSender, $rootScope, $location, appConfig, ngProgressFactory) {

    var currentRequests = 0;
    var progressBarLoader = ngProgressFactory.createInstance();
    progressBarLoader.setColor('#039be5');


    /**
     * Prepare the request
     * if an access token needs to be check, it will fire the validateAccessToken function
     * @param path The path

     * @param {string} method The method
     * @param parameters The parameters
     * @param handler The handler to get the request back
     * @param accessToken to attach to the headers
     * @param isExcel
     */
    this.sendRequest = function (path, method, parameters, handler, accessToken, isExcel) {
        path = path + "?brand=" + $rootScope.brandName;
        if (location.hostname === "localhost" || location.hostname === "127.0.0.1")
            //path = appConfig.serverUrl + path;
            path = appConfig.localHostUrl + path;
        else if (location.host === appConfig.locationHost)
            path = appConfig.developmentHostUrl + path;
        else
            path = appConfig.serverUrl + path;

        if (location.hostname === "localhost" || location.hostname === "127.0.0.1")
            path = path + "&XDEBUG_SESSION_START";
        if (accessToken) {
            if (!$rootScope.User)
                $location.path("/");
            else {
                sendRequest(path, method, parameters, handler, isExcel,$rootScope.User.AccessToken);
            }
        } else
            sendRequest(path, method, parameters, handler, isExcel);
    };
    /**
     * Send request to to needed type
     * @param path
     * @param method
     * @param parameters
     * @param handler
     * @param isExcel
     * @param accessToken
     */
    var sendRequest = function (path, method, parameters, handler, isExcel,accessToken) {

        //If its an xml http request
        currentRequests++;
        if (currentRequests == 1) {
            //$rootScope.loadingProgress = true;
            progressBarLoader.start();
        }
        HttpSender.send(path, method, parameters, isExcel,accessToken).then(response).catch(error);

        function response(data) {
            currentRequests--;
            if (currentRequests == 0) {
                //$rootScope.loadingProgress = false;
                progressBarLoader.complete();
            }
            if (data && handler) {
                if (data === 'Invalid Access Token') {
                    $location.path("/");
                }
                handler(data);

            }
        }

        function error() {
            currentRequests--;
            if (currentRequests == 0) {
                //$rootScope.loadingProgress = false;
                progressBarLoader.complete();
            }
        }
    };


}]);

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsWidgetController', MsWidgetController)
        .directive('msWidget', msWidgetDirective)
        .directive('msWidgetFront', msWidgetFrontDirective)
        .directive('msWidgetBack', msWidgetBackDirective);

    /** @ngInject */
    function MsWidgetController($scope, $element)
    {
        var vm = this;

        // Data
        vm.flipped = false;

        // Methods
        vm.flip = flip;

        //////////

        /**
         * Flip the widget
         */
        function flip()
        {
            if ( !isFlippable() )
            {
                return;
            }

            // Toggle flipped status
            vm.flipped = !vm.flipped;

            // Toggle the 'flipped' class
            $element.toggleClass('flipped', vm.flipped);
        }

        /**
         * Check if widget is flippable
         *
         * @returns {boolean}
         */
        function isFlippable()
        {
            return (angular.isDefined($scope.flippable) && $scope.flippable === true);
        }
    }

    /** @ngInject */
    function msWidgetDirective()
    {
        return {
            restrict  : 'E',
            scope     : {
                flippable: '=?'
            },
            controller: 'MsWidgetController',
            transclude: true,
            compile   : function (tElement)
            {
                tElement.addClass('ms-widget');

                return function postLink(scope, iElement, iAttrs, MsWidgetCtrl, transcludeFn)
                {
                    // Custom transclusion
                    transcludeFn(function (clone)
                    {
                        iElement.empty();
                        iElement.append(clone);
                    });

                    //////////
                };
            }
        };
    }

    /** @ngInject */
    function msWidgetFrontDirective()
    {
        return {
            restrict  : 'E',
            require   : '^msWidget',
            transclude: true,
            compile   : function (tElement)
            {
                tElement.addClass('ms-widget-front');

                return function postLink(scope, iElement, iAttrs, MsWidgetCtrl, transcludeFn)
                {
                    // Custom transclusion
                    transcludeFn(function (clone)
                    {
                        iElement.empty();
                        iElement.append(clone);
                    });

                    // Methods
                    scope.flipWidget = MsWidgetCtrl.flip;
                };
            }
        };
    }

    /** @ngInject */
    function msWidgetBackDirective()
    {
        return {
            restrict  : 'E',
            require   : '^msWidget',
            transclude: true,
            compile   : function (tElement)
            {
                tElement.addClass('ms-widget-back');

                return function postLink(scope, iElement, iAttrs, MsWidgetCtrl, transcludeFn)
                {
                    // Custom transclusion
                    transcludeFn(function (clone)
                    {
                        iElement.empty();
                        iElement.append(clone);
                    });

                    // Methods
                    scope.flipWidget = MsWidgetCtrl.flip;
                };
            }
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsTimelineController', MsTimelineController)
        .directive('msTimeline', msTimelineDirective)
        .directive('msTimelineItem', msTimelineItemDirective);

    /** @ngInject */
    function MsTimelineController()
    {
        var vm = this;

        // Data
        vm.scrollEl = undefined;

        // Methods
        vm.setScrollEl = setScrollEl;
        vm.getScrollEl = getScrollEl;

        //////////

        /**
         * Set scroll element
         *
         * @param scrollEl
         */
        function setScrollEl(scrollEl)
        {
            vm.scrollEl = scrollEl;
        }

        /**
         * Get scroll element
         *
         * @returns {undefined|*}
         */
        function getScrollEl()
        {
            return vm.scrollEl;
        }
    }

    /** @ngInject */
    function msTimelineDirective()
    {
        return {
            scope     : {
                msTimeline: '=?',
                loadMore  : '&?msTimelineLoadMore'
            },
            controller: 'MsTimelineController',
            compile   : function (tElement)
            {
                tElement.addClass('ms-timeline');

                return function postLink(scope, iElement, iAttrs, MsTimelineCtrl)
                {
                    // Create an element for triggering the load more action and append it
                    var loadMoreEl = angular.element('<div class="ms-timeline-loader md-accent-bg md-whiteframe-4dp"><span class="spinner animate-rotate"></span></div>');
                    iElement.append(loadMoreEl);

                    // Default config
                    var config = {
                        scrollEl: '#content'
                    };

                    // Extend the configuration
                    config = angular.extend(config, scope.msTimeline, {});
                    
                    // Grab the scrollable element and store it in the controller for general use
                    var scrollEl = angular.element(config.scrollEl);
                    MsTimelineCtrl.setScrollEl(scrollEl);

                    // Threshold
                    var threshold = 144;

                    // Register onScroll event for the first time
                    registerOnScroll();

                    /**
                     * onScroll Event
                     */
                    function onScroll()
                    {
                        if ( scrollEl.scrollTop() + scrollEl.height() + threshold > loadMoreEl.position().top )
                        {
                            // Show the loader
                            loadMoreEl.addClass('show');

                            // Unregister scroll event to prevent triggering the function over and over again
                            unregisterOnScroll();

                            // Trigger load more event
                            scope.loadMore().then(
                                // Success
                                function ()
                                {
                                    // Hide the loader
                                    loadMoreEl.removeClass('show');

                                    // Register the onScroll event again
                                    registerOnScroll();
                                },

                                // Error
                                function ()
                                {
                                    // Remove the loader completely
                                    loadMoreEl.remove();
                                }
                            );
                        }
                    }

                    /**
                     * onScroll event registerer
                     */
                    function registerOnScroll()
                    {
                        scrollEl.on('scroll', onScroll);
                    }

                    /**
                     * onScroll event unregisterer
                     */
                    function unregisterOnScroll()
                    {
                        scrollEl.off('scroll', onScroll);
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        unregisterOnScroll();
                    });
                };
            }
        };
    }

    /** @ngInject */
    function msTimelineItemDirective($timeout, $q)
    {
        return {
            scope  : true,
            require: '^msTimeline',
            compile: function (tElement)
            {
                tElement.addClass('ms-timeline-item').addClass('hidden');

                return function postLink(scope, iElement, iAttrs, MsTimelineCtrl)
                {
                    var threshold = 72,
                        itemLoaded = false,
                        itemInViewport = false,
                        scrollEl = MsTimelineCtrl.getScrollEl();

                    //////////

                    init();

                    /**
                     * Initialize
                     */
                    function init()
                    {
                        // Check if the timeline item has ms-card
                        if ( iElement.find('ms-card') )
                        {
                            // If the ms-card template loaded...
                            scope.$on('msCard::cardTemplateLoaded', function (event, args)
                            {
                                var cardEl = angular.element(args[0]);

                                // Test the card to see if there is any image on it
                                testForImage(cardEl).then(function ()
                                {
                                    $timeout(function ()
                                    {
                                        itemLoaded = true;
                                    });
                                });
                            });
                        }
                        else
                        {
                            // Test the element to see if there is any image on it
                            testForImage(iElement).then(function ()
                            {
                                $timeout(function ()
                                {
                                    itemLoaded = true;
                                });
                            });
                        }

                        // Check if the loaded element also in the viewport
                        scrollEl.on('scroll', testForVisibility);

                        // Test for visibility for the first time without waiting for the scroll event
                        testForVisibility();
                    }

                    // Item ready watcher
                    var itemReadyWatcher = scope.$watch(
                        function ()
                        {
                            return itemLoaded && itemInViewport;
                        },
                        function (current, old)
                        {
                            if ( angular.equals(current, old) )
                            {
                                return;
                            }

                            if ( current )
                            {
                                iElement.removeClass('hidden').addClass('animate');

                                // Unbind itemReadyWatcher
                                itemReadyWatcher();
                            }
                        }, true);

                    /**
                     * Test the given element for image
                     *
                     * @param element
                     * @returns promise
                     */
                    function testForImage(element)
                    {
                        var deferred = $q.defer(),
                            imgEl = element.find('img');

                        if ( imgEl.length > 0 )
                        {
                            imgEl.on('load', function ()
                            {
                                deferred.resolve('Image is loaded');
                            });
                        }
                        else
                        {
                            deferred.resolve('No images');
                        }

                        return deferred.promise;
                    }

                    /**
                     * Test the element for visibility
                     */
                    function testForVisibility()
                    {
                        if ( scrollEl.scrollTop() + scrollEl.height() > iElement.position().top + threshold )
                        {
                            $timeout(function ()
                            {
                                itemInViewport = true;
                            });

                            // Unbind the scroll event
                            scrollEl.off('scroll', testForVisibility);
                        }
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msSplashScreen', msSplashScreenDirective);

    /** @ngInject */
    function msSplashScreenDirective($animate)
    {
        return {
            restrict: 'E',
            link    : function (scope, iElement)
            {
                var splashScreenRemoveEvent = scope.$on('msSplashScreen::remove', function ()
                {
                    $animate.leave(iElement).then(function ()
                    {
                        // De-register scope event
                        splashScreenRemoveEvent();

                        // Null-ify everything else
                        scope = iElement = null;
                    });
                });
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msSidenavHelper', msSidenavHelperDirective);

    /** @ngInject */
    function msSidenavHelperDirective()
    {
        return {
            restrict: 'A',
            require : '^mdSidenav',
            link    : function (scope, iElement, iAttrs, MdSidenavCtrl)
            {
                // Watch md-sidenav open & locked open statuses
                // and add class to the ".page-layout" if only
                // the sidenav open and NOT locked open
                scope.$watch(function ()
                {
                    return MdSidenavCtrl.isOpen() && !MdSidenavCtrl.isLockedOpen();
                }, function (current)
                {
                    if ( angular.isUndefined(current) )
                    {
                        return;
                    }

                    iElement.parent().toggleClass('full-height', current);
                    angular.element('html').toggleClass('sidenav-open', current);
                });
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsStepperController', MsStepperController)
        .directive('msHorizontalStepper', msHorizontalStepperDirective)
        .directive('msHorizontalStepperStep', msHorizontalStepperStepDirective)
        .directive('msVerticalStepper', msVerticalStepperDirective)
        .directive('msVerticalStepperStep', msVerticalStepperStepDirective);

    /** @ngInject */
    function MsStepperController($timeout)
    {
        var vm = this;

        // Data
        vm.mainForm = undefined;

        vm.orientation = 'horizontal';
        vm.steps = [];
        vm.currentStep = undefined;
        vm.currentStepNumber = 1;

        // Methods
        vm.setOrientation = setOrientation;
        vm.registerMainForm = registerMainForm;
        vm.registerStep = registerStep;
        vm.setupSteps = setupSteps;
        vm.resetForm = resetForm;

        vm.setCurrentStep = setCurrentStep;

        vm.gotoStep = gotoStep;
        vm.gotoPreviousStep = gotoPreviousStep;
        vm.gotoNextStep = gotoNextStep;
        vm.gotoFirstStep = gotoFirstStep;
        vm.gotoLastStep = gotoLastStep;

        vm.isFirstStep = isFirstStep;
        vm.isLastStep = isLastStep;

        vm.isStepCurrent = isStepCurrent;
        vm.isStepDisabled = isStepDisabled;
        vm.isStepOptional = isStepOptional;
        vm.isStepHidden = isStepHidden;
        vm.filterHiddenStep = filterHiddenStep;
        vm.isStepValid = isStepValid;
        vm.isStepNumberValid = isStepNumberValid;

        vm.isFormValid = isFormValid;

        //////////

        /**
         * Set the orientation of the stepper
         *
         * @param orientation
         */
        function setOrientation(orientation)
        {
            vm.orientation = orientation || 'horizontal';
        }

        /**
         * Register the main form
         *
         * @param form
         */
        function registerMainForm(form)
        {
            vm.mainForm = form;
        }

        /**
         * Register a step
         *
         * @param element
         * @param scope
         * @param form
         */
        function registerStep(element, scope, form)
        {
            var step = {
                element           : element,
                scope             : scope,
                form              : form,
                stepNumber        : scope.step || (vm.steps.length + 1),
                stepTitle         : scope.stepTitle,
                stepTitleTranslate: scope.stepTitleTranslate
            };

            // Push the step into steps array
            vm.steps.push(step);

            // Sort steps by stepNumber
            vm.steps.sort(function (a, b)
            {
                return a.stepNumber - b.stepNumber;
            });

            return step;
        }

        /**
         * Setup steps for the first time
         */
        function setupSteps()
        {
            vm.setCurrentStep(vm.currentStepNumber);
        }

        /**
         * Reset steps and the main form
         */
        function resetForm()
        {
            // Timeout is required here because we need to
            // let form model to reset before setting the
            // statuses
            $timeout(function ()
            {
                // Reset all the steps
                for ( var x = 0; x < vm.steps.length; x++ )
                {
                    vm.steps[x].form.$setPristine();
                    vm.steps[x].form.$setUntouched();
                }

                // Reset the main form
                vm.mainForm.$setPristine();
                vm.mainForm.$setUntouched();

                // Go to first step
                gotoFirstStep();
            });
        }

        /**
         * Set current step
         *
         * @param stepNumber
         */
        function setCurrentStep(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return;
            }

            // Update the current step number
            vm.currentStepNumber = stepNumber;

            if ( vm.orientation === 'horizontal' )
            {
                // Hide all steps
                for ( var i = 0; i < vm.steps.length; i++ )
                {
                    vm.steps[i].element.hide();
                }

                // Show the current step
                vm.steps[vm.currentStepNumber - 1].element.show();
            }
            else if ( vm.orientation === 'vertical' )
            {
                // Hide all step content
                for ( var j = 0; j < vm.steps.length; j++ )
                {
                    vm.steps[j].element.find('.ms-stepper-step-content').hide();
                }

                // Show the current step content
                vm.steps[vm.currentStepNumber - 1].element.find('.ms-stepper-step-content').show();
            }
        }

        /**
         * Go to a step
         *
         * @param stepNumber
         */
        function gotoStep(stepNumber)
        {
            // If the step we are about to go
            // is hidden, bail...
            if ( isStepHidden(stepNumber) )
            {
                return;
            }

            vm.setCurrentStep(stepNumber);
        }

        /**
         * Go to the previous step
         */
        function gotoPreviousStep()
        {
            var stepNumber = vm.currentStepNumber - 1;

            // Test the previous steps and make sure we
            // will land to the one that is not hidden
            for ( var s = stepNumber; s >= 1; s-- )
            {
                if ( !isStepHidden(s) )
                {
                    stepNumber = s;
                    break;
                }
            }

            vm.setCurrentStep(stepNumber);
        }

        /**
         * Go to the next step
         */
        function gotoNextStep()
        {
            var stepNumber = vm.currentStepNumber + 1;

            // Test the following steps and make sure we
            // will land to the one that is not hidden
            for ( var s = stepNumber; s <= vm.steps.length; s++ )
            {
                if ( !isStepHidden(s) )
                {
                    stepNumber = s;
                    break;
                }
            }

            vm.setCurrentStep(stepNumber);
        }

        /**
         * Go to the first step
         */
        function gotoFirstStep()
        {
            vm.setCurrentStep(1);
        }

        /**
         * Go to the last step
         */
        function gotoLastStep()
        {
            vm.setCurrentStep(vm.steps.length);
        }

        /**
         * Check if the current step is the first step
         *
         * @returns {boolean}
         */
        function isFirstStep()
        {
            return vm.currentStepNumber === 1;
        }

        /**
         * Check if the current step is the last step
         *
         * @returns {boolean}
         */
        function isLastStep()
        {
            return vm.currentStepNumber === vm.steps.length;
        }

        /**
         * Check if the given step is the current one
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepCurrent(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            return vm.currentStepNumber === stepNumber;
        }

        /**
         * Check if the given step should be disabled
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepDisabled(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            var disabled = false;

            for ( var i = 1; i < stepNumber; i++ )
            {
                if ( !isStepValid(i) )
                {
                    disabled = true;
                    break;
                }
            }

            return disabled;
        }

        /**
         * Check if the given step is optional
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepOptional(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            return vm.steps[stepNumber - 1].scope.optionalStep;
        }

        /**
         * Check if the given step is hidden
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepHidden(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            return !!vm.steps[stepNumber - 1].scope.hideStep;
        }

        /**
         * Check if the given step is hidden as a filter
         *
         * @param step
         * @returns {boolean}
         */
        function filterHiddenStep(step)
        {
            return !isStepHidden(step.stepNumber);
        }

        /**
         * Check if the given step is valid
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepValid(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            // If the step is optional, always return true
            if ( isStepOptional(stepNumber) )
            {
                return true;
            }

            return vm.steps[stepNumber - 1].form.$valid;
        }

        /**
         * Check if the given step number is a valid step number
         *
         * @param stepNumber
         * @returns {boolean}
         */
        function isStepNumberValid(stepNumber)
        {
            return !(angular.isUndefined(stepNumber) || stepNumber < 1 || stepNumber > vm.steps.length);
        }

        /**
         * Check if the entire form is valid
         *
         * @returns {boolean}
         */
        function isFormValid()
        {
            return vm.mainForm.$valid;
        }
    }

    /** @ngInject */
    function msHorizontalStepperDirective()
    {
        return {
            restrict        : 'A',
            scope           : {},
            require         : ['form', 'msHorizontalStepper'],
            priority        : 1001,
            controller      : 'MsStepperController as MsStepper',
            bindToController: {
                model: '=ngModel'
            },
            transclude      : true,
            templateUrl     : 'app/core/directives/ms-stepper/templates/horizontal/horizontal.html',
            compile         : function (tElement)
            {
                tElement.addClass('ms-stepper');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var FormCtrl = ctrls[0],
                        MsStepperCtrl = ctrls[1];

                    // Register the main form and setup
                    // the steps for the first time
                    MsStepperCtrl.setOrientation('horizontal');
                    MsStepperCtrl.registerMainForm(FormCtrl);
                    MsStepperCtrl.setupSteps();
                };
            }
        };
    }

    /** @ngInject */
    function msHorizontalStepperStepDirective()
    {
        return {
            restrict: 'E',
            require : ['form', '^msHorizontalStepper'],
            priority: 1000,
            scope   : {
                step              : '=?',
                stepTitle         : '=?',
                stepTitleTranslate: '=?',
                optionalStep      : '=?',
                hideStep          : '=?'
            },
            compile : function (tElement)
            {
                tElement.addClass('ms-stepper-step');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var FormCtrl = ctrls[0],
                        MsStepperCtrl = ctrls[1];

                    // Is it an optional step?
                    scope.optionalStep = angular.isDefined(iAttrs.optionalStep);

                    // Register the step
                    MsStepperCtrl.registerStep(iElement, scope, FormCtrl);

                    // Hide the step by default
                    iElement.hide();
                };
            }
        };
    }

    /** @ngInject */
    function msVerticalStepperDirective($timeout)
    {
        return {
            restrict        : 'A',
            scope           : {},
            require         : ['form', 'msVerticalStepper'],
            priority        : 1001,
            controller      : 'MsStepperController as MsStepper',
            bindToController: {
                model: '=ngModel'
            },
            transclude      : true,
            templateUrl     : 'app/core/directives/ms-stepper/templates/vertical/vertical.html',
            compile         : function (tElement)
            {
                tElement.addClass('ms-stepper');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var FormCtrl = ctrls[0],
                        MsStepperCtrl = ctrls[1];

                    // Register the main form and setup
                    // the steps for the first time

                    // Timeout is required in vertical stepper
                    // as we are using transclusion in steps.
                    // We have to wait for them to be transcluded
                    // and registered to the controller
                    $timeout(function ()
                    {
                        MsStepperCtrl.setOrientation('vertical');
                        MsStepperCtrl.registerMainForm(FormCtrl);
                        MsStepperCtrl.setupSteps();
                    });
                };
            }
        };
    }

    /** @ngInject */
    function msVerticalStepperStepDirective()
    {
        return {
            restrict   : 'E',
            require    : ['form', '^msVerticalStepper'],
            priority   : 1000,
            scope      : {
                step              : '=?',
                stepTitle         : '=?',
                stepTitleTranslate: '=?',
                optionalStep      : '=?',
                hideStep          : '=?'
            },
            transclude : true,
            templateUrl: 'app/core/directives/ms-stepper/templates/vertical/step/vertical-step.html',
            compile    : function (tElement)
            {
                tElement.addClass('ms-stepper-step');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var FormCtrl = ctrls[0],
                        MsStepperCtrl = ctrls[1];

                    // Is it an optional step?
                    scope.optionalStep = angular.isDefined(iAttrs.optionalStep);

                    // Register the step
                    scope.stepInfo = MsStepperCtrl.registerStep(iElement, scope, FormCtrl);

                    // Expose the controller to the scope
                    scope.MsStepper = MsStepperCtrl;

                    // Hide the step content by default
                    iElement.find('.ms-stepper-step-content').hide();
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsSearchBarController', MsSearchBarController)
        .directive('msSearchBar', msSearchBarDirective);

    /** @ngInject */
    function MsSearchBarController($scope, $element, $timeout)
    {
        var vm = this;

        // Data
        vm.collapsed = true;
        vm.query = '';
        vm.queryOptions = {
            debounce: vm.debounce || 0
        };
        vm.resultsLoading = false;
        vm.results = null;
        vm.selectedResultIndex = 0;
        vm.ignoreMouseEvents = false;

        // Methods
        vm.populateResults = populateResults;

        vm.expand = expand;
        vm.collapse = collapse;

        vm.absorbEvent = absorbEvent;
        vm.handleKeydown = handleKeydown;
        vm.handleMouseenter = handleMouseenter;
        vm.temporarilyIgnoreMouseEvents = temporarilyIgnoreMouseEvents;
        vm.handleResultClick = handleResultClick;
        vm.ensureSelectedResultIsVisible = ensureSelectedResultIsVisible;

        //////////

        init();

        function init()
        {
            // Watch the model changes to trigger the search
            $scope.$watch('MsSearchBar.query', function (current, old)
            {
                if ( angular.isUndefined(current) )
                {
                    return;
                }

                if ( angular.equals(current, old) )
                {
                    return;
                }

                if ( vm.collapsed )
                {
                    return;
                }

                // Evaluate the onSearch function to access the
                // function itself
                var onSearchEvaluated = $scope.$parent.$eval(vm.onSearch, {query: current}),
                    isArray = angular.isArray(onSearchEvaluated),
                    isPromise = (onSearchEvaluated && !!onSearchEvaluated.then);

                if ( isArray )
                {
                    // Populate the results
                    vm.populateResults(onSearchEvaluated);
                }

                if ( isPromise )
                {
                    // Show the loader
                    vm.resultsLoading = true;

                    onSearchEvaluated.then(
                        // Success
                        function (response)
                        {
                            // Populate the results
                            vm.populateResults(response);
                        },
                        // Error
                        function ()
                        {
                            // Assign an empty array to show
                            // the no-results screen
                            vm.populateResults([]);
                        }
                    ).finally(function ()
                        {
                            // Hide the loader
                            vm.resultsLoading = false;
                        }
                    );
                }
            });
        }

        /**
         * Populate the results
         *
         * @param results
         */
        function populateResults(results)
        {
            // Before doing anything,
            // make sure the search bar is expanded
            if ( vm.collapsed )
            {
                return;
            }

            var isArray = angular.isArray(results),
                isNull = results === null;

            // Only accept arrays and null values
            if ( !isArray && !isNull )
            {
                return;
            }

            // Reset the selected result
            vm.selectedResultIndex = 0;

            // Populate the results
            vm.results = results;
        }

        /**
         * Expand
         */
        function expand()
        {
            // Set collapsed status
            vm.collapsed = false;

            // Call expand on scope
            $scope.expand();

            // Callback
            if ( vm.onExpand && angular.isFunction(vm.onExpand) )
            {
                vm.onExpand();
            }
        }

        /**
         * Collapse
         */
        function collapse()
        {
            // Empty the query
            vm.query = '';

            // Empty results to hide the results view
            vm.populateResults(null);

            // Set collapsed status
            vm.collapsed = true;

            // Call collapse on scope
            $scope.collapse();

            // Callback
            if ( vm.onCollapse && angular.isFunction(vm.onCollapse) )
            {
                vm.onCollapse();
            }
        }

        /**
         * Absorb the given event
         *
         * @param event
         */
        function absorbEvent(event)
        {
            event.preventDefault();
        }

        /**
         * Handle keydown
         *
         * @param event
         */
        function handleKeydown(event)
        {
            var keyCode = event.keyCode,
                keys = [27, 38, 40];

            // Prevent the default action if
            // one of the keys are pressed that
            // we are listening
            if ( keys.indexOf(keyCode) > -1 )
            {
                event.preventDefault();
            }

            switch ( keyCode )
            {
                // Enter
                case 13:

                    // Trigger result click
                    vm.handleResultClick(vm.results[vm.selectedResultIndex]);

                    break;

                // Escape
                case 27:

                    // Collapse the search bar
                    vm.collapse();

                    break;

                // Up Arrow
                case 38:

                    // Decrease the selected result index
                    if ( vm.selectedResultIndex - 1 >= 0 )
                    {
                        // Decrease the selected index
                        vm.selectedResultIndex--;

                        // Make sure the selected result is in the view
                        vm.ensureSelectedResultIsVisible();
                    }

                    break;

                // Down Arrow
                case 40:

                    if ( !vm.results )
                    {
                        return;
                    }

                    // Increase the selected result index
                    if ( vm.selectedResultIndex + 1 < vm.results.length )
                    {
                        // Increase the selected index
                        vm.selectedResultIndex++;

                        // Make sure the selected result is in the view
                        vm.ensureSelectedResultIsVisible();
                    }

                    break;

                default:
                    break;
            }
        }

        /**
         * Handle mouseenter
         *
         * @param index
         */
        function handleMouseenter(index)
        {
            if ( vm.ignoreMouseEvents )
            {
                return;
            }

            // Update the selected result index
            // with the given index
            vm.selectedResultIndex = index;
        }

        /**
         * Set a variable for a limited time
         * to make other functions to ignore
         * the mouse events
         */
        function temporarilyIgnoreMouseEvents()
        {
            // Set the variable
            vm.ignoreMouseEvents = true;

            // Cancel the previous timeout
            $timeout.cancel(vm.mouseEventIgnoreTimeout);

            // Set the timeout
            vm.mouseEventIgnoreTimeout = $timeout(function ()
            {
                vm.ignoreMouseEvents = false;
            }, 250);
        }

        /**
         * Handle the result click
         *
         * @param item
         */
        function handleResultClick(item)
        {
            if ( vm.onResultClick )
            {
                vm.onResultClick({item: item});
            }

            // Collapse the search bar
            vm.collapse();
        }

        /**
         * Ensure the selected result will
         * always be visible on the results
         * area
         */
        function ensureSelectedResultIsVisible()
        {
            var resultsEl = $element.find('.ms-search-bar-results'),
                selectedItemEl = angular.element(resultsEl.find('.result')[vm.selectedResultIndex]);

            if ( resultsEl && selectedItemEl )
            {
                var top = selectedItemEl.position().top - 8,
                    bottom = selectedItemEl.position().top + selectedItemEl.outerHeight() + 8;

                // Start ignoring mouse events
                vm.temporarilyIgnoreMouseEvents();

                if ( resultsEl.scrollTop() > top )
                {
                    resultsEl.scrollTop(top);
                }

                if ( bottom > (resultsEl.height() + resultsEl.scrollTop()) )
                {
                    resultsEl.scrollTop(bottom - resultsEl.height());
                }
            }
        }
    }

    /** @ngInject */
    function msSearchBarDirective($document)
    {
        return {
            restrict        : 'E',
            scope           : {},
            require         : 'msSearchBar',
            controller      : 'MsSearchBarController as MsSearchBar',
            bindToController: {
                debounce     : '=?',
                onSearch     : '@',
                onResultClick: '&?',
                onExpand     : '&?',
                onCollapse   : '&?'
            },
            templateUrl     : 'app/core/directives/ms-search-bar/ms-search-bar.html',
            compile         : function (tElement)
            {
                // Add class
                tElement.addClass('ms-search-bar');

                return function postLink(scope, iElement)
                {
                    // Data
                    var inputEl,
                        bodyEl = $document.find('body');

                    // Methods
                    scope.collapse = collapse;
                    scope.expand = expand;

                    //////////

                    // Initialize
                    init();

                    /**
                     * Initialize
                     */
                    function init()
                    {
                        // Grab the input element
                        inputEl = iElement.find('#ms-search-bar-input');
                    }

                    /**
                     * Expand action
                     */
                    function expand()
                    {
                        // Add expanded class
                        iElement.addClass('expanded');

                        // Add helper class to the body
                        bodyEl.addClass('ms-search-bar-expanded');

                        // Focus on the input
                        inputEl.focus();
                    }

                    /**
                     * Collapse action
                     */
                    function collapse()
                    {
                        // Remove expanded class
                        iElement.removeClass('expanded');

                        // Remove helper class from the body
                        bodyEl.removeClass('ms-search-bar-expanded');
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsShortcutsController', MsShortcutsController)
        .directive('msShortcuts', msShortcutsDirective);

    /** @ngInject */
    function MsShortcutsController($scope, $cookies, $document, $timeout, $q, msNavigationService, $location) {
        var vm = this;

        // Data
        vm.query = '';
        vm.addName = '';
        vm.queryOptions = {
            debounce: 300
        };
        vm.resultsLoading = false;
        vm.shotcutAddLoading = false;
        vm.selectedResultIndex = 0;
        vm.ignoreMouseEvents = false;
        vm.mobileBarActive = false;

        vm.results = null;
        vm.shortcuts = [];

        vm.sortableOptions = {
            ghostClass   : 'ghost',
            forceFallback: true,
            fallbackClass: 'dragging',
            onSort       : function ()
            {
                vm.saveShortcuts();
            }
        };

        // Methods
        vm.populateResults = populateResults;
        vm.loadShortcuts = loadShortcuts;
        vm.saveShortcuts = saveShortcuts;
        vm.addShortcut = addShortcut;
        vm.removeShortcut = removeShortcut;
        vm.handleResultClick = handleResultClick;
        vm.absorbEvent = absorbEvent;
        vm.handleKeydown = handleKeydown;
        vm.handleAddClick = handleAddClick;
        vm.handleAddKeyDown = handleAddKeydown;
        vm.handleMouseenter = handleMouseenter;
        vm.temporarilyIgnoreMouseEvents = temporarilyIgnoreMouseEvents;
        vm.ensureSelectedResultIsVisible = ensureSelectedResultIsVisible;
        vm.toggleMobileBar = toggleMobileBar;
        vm.moveToShortcut = moveToShortcut;

        /*------------------------------------------------------------------------------------------------------------*/

        init();

        function init() {
            // Load the shortcuts
            vm.loadShortcuts().then(
                // Success
                function (response)
                {
                    vm.shortcuts = response;

                    // Add shortcuts as results by default
                    if ( vm.shortcuts.length > 0 )
                    {
                        vm.results = response;
                    }
                }
            );

            // Watch the model changes to trigger the search
            $scope.$watch('MsShortcuts.query', function (current, old)
            {
                if ( angular.isUndefined(current) )
                {
                    return;
                }

                if ( angular.equals(current, old) )
                {
                    return;
                }

                // Show the loader
                vm.resultsLoading = true;

                // Populate the results
                vm.populateResults().then(
                    // Success
                    function (response)
                    {
                        vm.results = response;
                    },
                    // Error
                    function ()
                    {
                        vm.results = [];
                    }
                ).finally(
                    function ()
                    {
                        // Hide the loader
                        vm.resultsLoading = false;
                    }
                );
            });
        }

        function moveToShortcut(shortcut){
            $location.url(shortcut.uisref);
        }

        /**
         * Populate the results
         */
        function populateResults() {
            var results = [],
                flatNavigation = msNavigationService.getFlatNavigation(),
                deferred = $q.defer();

            // Iterate through the navigation array and
            // make sure it doesn't have any groups or
            // none ui-sref items
            for ( var x = 0; x < flatNavigation.length; x++ )
            {
                if ( flatNavigation[x].uisref )
                {
                    results.push(flatNavigation[x]);
                }
            }

            // If there is a query, filter the results
            if ( vm.query )
            {
                results = results.filter(function (item)
                {
                    if ( angular.lowercase(item.title).search(angular.lowercase(vm.query)) > -1 )
                    {
                        return true;
                    }
                });

                // Iterate through one last time and
                // add required properties to items
                for ( var i = 0; i < results.length; i++ )
                {
                    // Add false to hasShortcut by default
                    results[i].hasShortcut = false;

                    // Test if the item is in the shortcuts list
                    for ( var y = 0; y < vm.shortcuts.length; y++ )
                    {
                        if ( vm.shortcuts[y]._id === results[i]._id )
                        {
                            results[i].hasShortcut = true;
                            break;
                        }
                    }
                }
            }
            else
            {
                // If the query is empty, that means
                // there is nothing to search for so
                // we will populate the results with
                // current shortcuts if there is any
                if ( vm.shortcuts.length > 0 )
                {
                    results = vm.shortcuts;
                }
            }

            // Reset the selected result
            vm.selectedResultIndex = 0;

            // Fake the service delay
            $timeout(function ()
            {
                // Resolve the promise
                deferred.resolve(results);
            }, 250);

            // Return a promise
            return deferred.promise;
        }

        /**
         * Load shortcuts
         */
        function loadShortcuts() {
            var deferred = $q.defer();

            // For the demo purposes, we will
            // load the shortcuts from the cookies.
            // But here you can make an API call
            // to load them from the DB.
            var shortcuts = angular.fromJson($cookies.get('marvilix.shortcuts'));

            // No cookie available. Generate one
            // for the demo purposes...
            if ( angular.isUndefined(shortcuts) )
            {
                shortcuts = [
                    /*
                    {
                        'title'      : 'Chat',
                        'icon'       : 'icon-hangouts',
                        'state'      : 'app.chat',
                        'badge'      : {
                            'content': 13,
                            'color'  : '#09d261'
                        },
                        'weight'     : 5,
                        'children'   : [],
                        '_id'        : 'chat',
                        '_path'      : 'apps.chat',
                        'uisref'     : 'app.chat',
                        'hasShortcut': true
                    }, {
                        'title'      : 'Contacts',
                        'icon'       : 'icon-account-box',
                        'state'      : 'app.contacts',
                        'weight'     : 10,
                        'children'   : [],
                        '_id'        : 'contacts',
                        '_path'      : 'apps.contacts',
                        'uisref'     : 'app.contacts',
                        'hasShortcut': true
                    }, {
                        'title'      : 'Notes',
                        'icon'       : 'icon-lightbulb',
                        'state'      : 'app.notes',
                        'weight'     : 11,
                        'children'   : [],
                        '_id'        : 'notes',
                        '_path'      : 'apps.notes',
                        'uisref'     : 'app.notes',
                        'hasShortcut': true
                    }
                    */
                ];

                $cookies.put('marvilix.shortcuts', angular.toJson(shortcuts));
            }

            // Resolve the promise
            deferred.resolve(shortcuts);

            return deferred.promise;
        }

        /**
         * Save the shortcuts
         */
        function saveShortcuts() {
            var deferred = $q.defer();

            // For the demo purposes, we will
            // keep the shortcuts in the cookies.
            // But here you can make an API call
            // to save them to the DB.
            $cookies.put('marvilix.shortcuts', angular.toJson(vm.shortcuts));

            // Fake the service delay
            $timeout(function ()
            {
                deferred.resolve({'success': true});
            }, 250);

            return deferred.promise;
        }

        /**
         * Add item as shortcut
         *
         * @param item
         */
        function addShortcut(item) {
            // Update the hasShortcut status
            item.hasShortcut = true;

            // Add as a shortcut
            vm.shortcuts.push(item);

            // Save the shortcuts
            vm.saveShortcuts();
        }

        /**
         * Remove item from shortcuts
         *
         * @param item
         */
        function removeShortcut(item) {
            // Update the hasShortcut status
            item.hasShortcut = false;

            // Remove the shortcut
            for ( var x = 0; x < vm.shortcuts.length; x++ )
            {
                if ( vm.shortcuts[x]._id === item._id )
                {
                    // Remove the x-th item from the array
                    vm.shortcuts.splice(x, 1);

                    // If we aren't searching for anything...
                    if ( !vm.query )
                    {
                        // If all the shortcuts have been removed,
                        // null-ify the results
                        if ( vm.shortcuts.length === 0 )
                        {
                            vm.results = null;
                        }
                        // Otherwise update the selected index
                        else
                        {
                            if ( x >= vm.shortcuts.length )
                            {
                                vm.selectedResultIndex = vm.shortcuts.length - 1;
                            }
                        }
                    }
                }
            }

            // Save the shortcuts
            vm.saveShortcuts();
        }

        /**
         * Handle the result click
         *
         * @param item
         */
        function handleResultClick(item) {
            // Add or remove the shortcut
            if ( item.hasShortcut )
            {
                vm.removeShortcut(item);
            }
            else
            {
                vm.addShortcut(item);
            }
        }

        function handleAddClick(item){
            vm.shotcutAddLoading = true;
            var customShortcuts = angular.fromJson($cookies.get('marvilix.shortcuts'));
            if(customShortcuts === undefined){
               vm.shortcuts = {};
            }

            var existingFlag = false;
            for (let i = 0; i < customShortcuts.length; i++) {
                if(customShortcuts[i].Title === item){
                    existingFlag = true;
                    break;
                }
            }
            if(! existingFlag){
                vm.shortcuts.push({
                    uisref: $location.url(),
                    title: item,
                    icon: 'icon-star-outline',
                    hasShortcut: true,
                    custom: true,
                });
            }
            vm.saveShortcuts();
            vm.addName = '';
            vm.shotcutAddLoading = false;
        }

        /**
         * Absorb the given event
         *
         * @param event
         */
        function absorbEvent(event) {
            event.preventDefault();
        }

        /**
         * Handle keydown
         *
         * @param event
         */
        function handleKeydown(event) {
            var keyCode = event.keyCode,
                keys = [38, 40];

            // Prevent the default action if
            // one of the keys are pressed that
            // we are listening
            if ( keys.indexOf(keyCode) > -1 )
            {
                event.preventDefault();
            }

            switch ( keyCode )
            {
                // Enter
                case 13:

                    // Trigger result click
                    vm.handleResultClick(vm.results[vm.selectedResultIndex]);

                    break;

                // Up Arrow
                case 38:

                    // Decrease the selected result index
                    if ( vm.selectedResultIndex - 1 >= 0 )
                    {
                        // Decrease the selected index
                        vm.selectedResultIndex--;

                        // Make sure the selected result is in the view
                        vm.ensureSelectedResultIsVisible();
                    }

                    break;

                // Down Arrow
                case 40:

                    // Increase the selected result index
                    if ( vm.selectedResultIndex + 1 < vm.results.length )
                    {
                        // Increase the selected index
                        vm.selectedResultIndex++;

                        // Make sure the selected result is in the view
                        vm.ensureSelectedResultIsVisible();
                    }

                    break;

                default:
                    break;
            }
        }

        function handleAddKeydown(event){
            var keyCode = event.keyCode,
                keys = [38, 40];

            // Prevent the default action if
            // one of the keys are pressed that
            // we are listening
            if ( keys.indexOf(keyCode) > -1 )
            {
                event.preventDefault();
            }

            switch ( keyCode )
            {
                // Enter
                case 13:

                    // Trigger result click
                    vm.handleAddClick(vm.addName);
                    break;

                default:
                    break;
            }
        }

        /**
         * Handle mouseenter
         *
         * @param index
         */
        function handleMouseenter(index) {
            if ( vm.ignoreMouseEvents )
            {
                return;
            }

            // Update the selected result index
            // with the given index
            vm.selectedResultIndex = index;
        }

        /**
         * Set a variable for a limited time
         * to make other functions to ignore
         * the mouse events
         */
        function temporarilyIgnoreMouseEvents() {
            // Set the variable
            vm.ignoreMouseEvents = true;

            // Cancel the previous timeout
            $timeout.cancel(vm.mouseEventIgnoreTimeout);

            // Set the timeout
            vm.mouseEventIgnoreTimeout = $timeout(function ()
            {
                vm.ignoreMouseEvents = false;
            }, 250);
        }

        /**
         * Ensure the selected result will
         * always be visible on the results
         * area
         */
        function ensureSelectedResultIsVisible() {
            var resultsEl = $document.find('#ms-shortcut-add-menu').find('.results'),
                selectedItemEl = angular.element(resultsEl.find('.result')[vm.selectedResultIndex]);

            if ( resultsEl && selectedItemEl )
            {
                var top = selectedItemEl.position().top - 8,
                    bottom = selectedItemEl.position().top + selectedItemEl.outerHeight() + 8;

                // Start ignoring mouse events
                vm.temporarilyIgnoreMouseEvents();

                if ( resultsEl.scrollTop() > top )
                {
                    resultsEl.scrollTop(top);
                }

                if ( bottom > (resultsEl.height() + resultsEl.scrollTop()) )
                {
                    resultsEl.scrollTop(bottom - resultsEl.height());
                }
            }
        }

        /**
         * Toggle mobile bar
         */
        function toggleMobileBar() {
            vm.mobileBarActive = !vm.mobileBarActive;
        }
    }

    /** @ngInject */
    function msShortcutsDirective() {
        return {
            restrict        : 'E',
            scope           : {},
            require         : 'msShortcuts',
            controller      : 'MsShortcutsController as MsShortcuts',
            bindToController: {},
            templateUrl     : 'app/core/directives/ms-shortcuts/ms-shortcuts.html',
            compile         : function (tElement)
            {
                // Add class
                tElement.addClass('ms-shortcuts');

                return function postLink(scope, iElement)
                {
                    // Data

                };
            }
        };
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msScrollConfig', msScrollConfigProvider)
        .directive('msScroll', msScrollDirective);

    /** @ngInject */
    function msScrollConfigProvider()
    {
        // Default configuration
        var defaultConfiguration = {
            wheelSpeed            : 1,
            wheelPropagation      : false,
            swipePropagation      : true,
            minScrollbarLength    : null,
            maxScrollbarLength    : null,
            useBothWheelAxes      : false,
            useKeyboard           : true,
            suppressScrollX       : false,
            suppressScrollY       : false,
            scrollXMarginOffset   : 0,
            scrollYMarginOffset   : 0,
            stopPropagationOnClick: true
        };

        // Methods
        this.config = config;

        //////////

        /**
         * Extend default configuration with the given one
         *
         * @param configuration
         */
        function config(configuration)
        {
            defaultConfiguration = angular.extend({}, defaultConfiguration, configuration);
        }

        /**
         * Service
         */
        this.$get = function ()
        {
            var service = {
                getConfig: getConfig
            };

            return service;

            //////////

            /**
             * Return the config
             */
            function getConfig()
            {
                return defaultConfiguration;
            }
        };
    }

    /** @ngInject */
    function msScrollDirective($timeout, msScrollConfig, msUtils, marvilixConfig)
    {
        return {
            restrict: 'AE',
            compile : function (tElement)
            {
                // Do not replace scrollbars if
                // 'disableCustomScrollbars' config enabled
                if ( marvilixConfig.getConfig('disableCustomScrollbars') )
                {
                    return;
                }

                // Do not replace scrollbars on mobile devices
                // if 'disableCustomScrollbarsOnMobile' config enabled
                if ( marvilixConfig.getConfig('disableCustomScrollbarsOnMobile') && msUtils.isMobile() )
                {
                    return;
                }

                // Add class
                tElement.addClass('ms-scroll');

                return function postLink(scope, iElement, iAttrs)
                {
                    var options = {};

                    // If options supplied, evaluate the given
                    // value. This is because we don't want to
                    // have an isolated scope but still be able
                    // to use scope variables.
                    // We don't want an isolated scope because
                    // we should be able to use this everywhere
                    // especially with other directives
                    if ( iAttrs.msScroll )
                    {
                        options = scope.$eval(iAttrs.msScroll);
                    }

                    // Extend the given config with the ones from provider
                    options = angular.extend({}, msScrollConfig.getConfig(), options);

                    // Initialize the scrollbar
                    $timeout(function ()
                    {
                        PerfectScrollbar.initialize(iElement[0], options);
                    }, 0);

                    // Update the scrollbar on element mouseenter
                    iElement.on('mouseenter', updateScrollbar);

                    // Watch scrollHeight and update
                    // the scrollbar if it changes
                    scope.$watch(function ()
                    {
                        return iElement.prop('scrollHeight');
                    }, function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        updateScrollbar();
                    });

                    // Watch scrollWidth and update
                    // the scrollbar if it changes
                    scope.$watch(function ()
                    {
                        return iElement.prop('scrollWidth');
                    }, function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        updateScrollbar();
                    });

                    /**
                     * Update the scrollbar
                     */
                    function updateScrollbar()
                    {
                        PerfectScrollbar.update(iElement[0]);
                    }

                    // Cleanup on destroy
                    scope.$on('$destroy', function ()
                    {
                        iElement.off('mouseenter');
                        PerfectScrollbar.destroy(iElement[0]);
                    });
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msResponsiveTable', msResponsiveTableDirective);

    /** @ngInject */
    function msResponsiveTableDirective()
    {
        return {
            restrict: 'A',
            link    : function (scope, iElement)
            {
                // Wrap the table
                var wrapper = angular.element('<div class="ms-responsive-table-wrapper"></div>');
                iElement.after(wrapper);
                wrapper.append(iElement);

                //////////
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msNavigationService', msNavigationServiceProvider)
        .controller('MsNavigationController', MsNavigationController)
        // Vertical
        .directive('msNavigation', msNavigationDirective)
        .controller('MsNavigationNodeController', MsNavigationNodeController)
        .directive('msNavigationNode', msNavigationNodeDirective)
        .directive('msNavigationItem', msNavigationItemDirective)
        //Horizontal
        .directive('msNavigationHorizontal', msNavigationHorizontalDirective)
        .controller('MsNavigationHorizontalNodeController', MsNavigationHorizontalNodeController)
        .directive('msNavigationHorizontalNode', msNavigationHorizontalNodeDirective)
        .directive('msNavigationHorizontalItem', msNavigationHorizontalItemDirective);

    /** @ngInject */
    function msNavigationServiceProvider()
    {
        // Inject $log service
        var $log = angular.injector(['ng']).get('$log');

        // Navigation array
        var navigation = [];

        var service = this;

        // Methods
        service.saveItem = saveItem;
        service.deleteItem = deleteItem;
        service.sortByWeight = sortByWeight;

        //////////

        /**
         * Create or update the navigation item
         *
         * @param path
         * @param item
         */
        function saveItem(path, item)
        {
            if ( !angular.isString(path) )
            {
                $log.error('path must be a string (eg. `dashboard.project`)');
                return;
            }

            var parts = path.split('.');

            // Generate the object id from the parts
            var id = parts[parts.length - 1];

            // Get the parent item from the parts
            var parent = _findOrCreateParent(parts);

            // Decide if we are going to update or create
            var updateItem = false;

            for ( var i = 0; i < parent.length; i++ )
            {
                if ( parent[i]._id === id )
                {
                    updateItem = parent[i];

                    break;
                }
            }

            // Update
            if ( updateItem )
            {
                angular.extend(updateItem, item);

                // Add proper ui-sref
                updateItem.uisref = _getUiSref(updateItem);
            }
            // Create
            else
            {
                // Create an empty children array in the item
                item.children = [];

                // Add the default weight if not provided or if it's not a number
                if ( angular.isUndefined(item.weight) || !angular.isNumber(item.weight) )
                {
                    item.weight = 1;
                }

                // Add the item id
                item._id = id;

                // Add the item path
                item._path = path;

                // Add proper ui-sref
                item.uisref = _getUiSref(item);

                // Push the item into the array
                parent.push(item);
            }
        }

        /**
         * Delete navigation item
         *
         * @param path
         */
        function deleteItem(path)
        {
            if ( !angular.isString(path) )
            {
                $log.error('path must be a string (eg. `dashboard.project`)');
                return;
            }

            // Locate the item by using given path
            var item = navigation,
                parts = path.split('.');

            for ( var p = 0; p < parts.length; p++ )
            {
                var id = parts[p];

                for ( var i = 0; i < item.length; i++ )
                {
                    if ( item[i]._id === id )
                    {
                        // If we have a matching path,
                        // we have found our object:
                        // remove it.
                        if ( item[i]._path === path )
                        {
                            item.splice(i, 1);
                            return true;
                        }

                        // Otherwise grab the children of
                        // the current item and continue
                        item = item[i].children;
                        break;
                    }
                }
            }

            return false;
        }

        /**
         * Sort the navigation items by their weights
         *
         * @param parent
         */
        function sortByWeight(parent)
        {
            // If parent not provided, sort the root items
            if ( !parent )
            {
                parent = navigation;
                parent.sort(_byWeight);
            }

            // Sort the children
            for ( var i = 0; i < parent.length; i++ )
            {
                var children = parent[i].children;

                if ( children.length > 1 )
                {
                    children.sort(_byWeight);
                }

                if ( children.length > 0 )
                {
                    sortByWeight(children);
                }
            }
        }

        /* ----------------- */
        /* Private Functions */
        /* ----------------- */

        /**
         * Find or create parent
         *
         * @param parts
         * @returns {Array|Boolean}
         * @private
         */
        function _findOrCreateParent(parts)
        {
            // Store the main navigation
            var parent = navigation;

            // If it's going to be a root item
            // return the navigation itself
            if ( parts.length === 1 )
            {
                return parent;
            }

            // Remove the last element from the parts as
            // we don't need that to figure out the parent
            parts.pop();

            // Find and return the parent
            for ( var i = 0; i < parts.length; i++ )
            {
                var _id = parts[i],
                    createParent = true;

                for ( var p = 0; p < parent.length; p++ )
                {
                    if ( parent[p]._id === _id )
                    {
                        parent = parent[p].children;
                        createParent = false;

                        break;
                    }
                }

                // If there is no parent found, create one, push
                // it into the current parent and assign it as a
                // new parent
                if ( createParent )
                {
                    var item = {
                        _id     : _id,
                        _path   : parts.join('.'),
                        title   : _id,
                        weight  : 1,
                        children: []
                    };

                    parent.push(item);
                    parent = item.children;
                }
            }

            return parent;
        }

        /**
         * Sort by weight
         *
         * @param x
         * @param y
         * @returns {number}
         * @private
         */
        function _byWeight(x, y)
        {
            return parseInt(x.weight) - parseInt(y.weight);
        }

        /**
         * Setup the ui-sref using state & state parameters
         *
         * @param item
         * @returns {string}
         * @private
         */
        function _getUiSref(item)
        {
            var uisref = '';

            if ( angular.isDefined(item.state) )
            {
                uisref = item.state;

                if ( angular.isDefined(item.stateParams) && angular.isObject(item.stateParams) )
                {
                    uisref = uisref + '(' + angular.toJson(item.stateParams) + ')';
                }
            }

            return uisref;
        }

        /* ----------------- */
        /* Service           */
        /* ----------------- */

        this.$get = function ()
        {
            var activeItem = null,
                navigationScope = null,
                folded = null,
                foldedOpen = null;

            var service = {
                saveItem          : saveItem,
                deleteItem        : deleteItem,
                sort              : sortByWeight,
                clearNavigation   : clearNavigation,
                setActiveItem     : setActiveItem,
                getActiveItem     : getActiveItem,
                getNavigation     : getNavigation,
                getFlatNavigation : getFlatNavigation,
                setNavigationScope: setNavigationScope,
                setFolded         : setFolded,
                getFolded         : getFolded,
                setFoldedOpen     : setFoldedOpen,
                getFoldedOpen     : getFoldedOpen,
                toggleFolded      : toggleFolded
            };

            return service;

            //////////

            /**
             * Clear the entire navigation
             */
            function clearNavigation()
            {
                // Clear the navigation array
                navigation = [];

                // Clear the vm.navigation from main controller
                if ( navigationScope )
                {
                    navigationScope.vm.navigation = navigation;
                }
            }

            /**
             * Set active item
             *
             * @param node
             * @param scope
             */
            function setActiveItem(node, scope)
            {
                activeItem = {
                    node : node,
                    scope: scope
                };
            }

            /**
             * Return active item
             */
            function getActiveItem()
            {
                return activeItem;
            }

            /**
             * Return navigation array
             *
             * @param root
             * @returns Array
             */
            function getNavigation(root)
            {
                if ( root )
                {
                    for ( var i = 0; i < navigation.length; i++ )
                    {
                        if ( navigation[i]._id === root )
                        {
                            return [navigation[i]];
                        }
                    }

                    return null;
                }

                return navigation;
            }

            /**
             * Return flat navigation array
             *
             * @param root
             * @returns Array
             */
            function getFlatNavigation(root)
            {
                // Get the correct navigation array
                var navigation = getNavigation(root);

                // Flatten the navigation object
                return _flattenNavigation(navigation);
            }

            /**
             * Store navigation's scope for later use
             *
             * @param scope
             */
            function setNavigationScope(scope)
            {
                navigationScope = scope;
            }

            /**
             * Set folded status
             *
             * @param status
             */
            function setFolded(status)
            {
                folded = status;
            }

            /**
             * Return folded status
             *
             * @returns {*}
             */
            function getFolded()
            {
                return folded;
            }

            /**
             * Set folded open status
             *
             * @param status
             */
            function setFoldedOpen(status)
            {
                foldedOpen = status;
            }

            /**
             * Return folded open status
             *
             * @returns {*}
             */
            function getFoldedOpen()
            {
                return foldedOpen;
            }


            /**
             * Toggle fold on stored navigation's scope
             */
            function toggleFolded()
            {
                navigationScope.toggleFolded();
            }

            /**
             * Flatten the given navigation
             *
             * @param navigation
             * @private
             */
            function _flattenNavigation(navigation)
            {
                var flatNav = [];

                for ( var x = 0; x < navigation.length; x++ )
                {
                    // Copy and clear the children of the
                    // navigation that we want to push
                    var navToPush = angular.copy(navigation[x]);
                    navToPush.children = [];

                    // Push the item
                    flatNav.push(navToPush);

                    // If there are child items in this navigation,
                    // do some nested function magic
                    if ( navigation[x].children.length > 0 )
                    {
                        flatNav = flatNav.concat(_flattenNavigation(navigation[x].children));
                    }
                }

                return flatNav;
            }
        };
    }

    /** @ngInject */
    function MsNavigationController($scope, msNavigationService)
    {
        var vm = this;

        // Data
        if ( $scope.root )
        {
            vm.navigation = msNavigationService.getNavigation($scope.root);
        }
        else
        {
            vm.navigation = msNavigationService.getNavigation();
        }

        // Methods
        vm.toggleHorizontalMobileMenu = toggleHorizontalMobileMenu;

        //////////

        init();

        /**
         * Initialize
         */
        function init()
        {
            // Sort the navigation before doing anything else
            msNavigationService.sort();
        }

        /**
         * Toggle horizontal mobile menu
         */
        function toggleHorizontalMobileMenu()
        {
            angular.element('body').toggleClass('ms-navigation-horizontal-mobile-menu-active');
        }
    }

    /** @ngInject */
    function msNavigationDirective($rootScope, $timeout, $mdSidenav, msNavigationService)
    {
        return {
            restrict   : 'E',
            scope      : {
                folded: '=',
                root  : '@'
            },
            controller : 'MsNavigationController as vm',
            templateUrl: 'app/core/directives/ms-navigation/templates/vertical.html',
            transclude : true,
            compile    : function (tElement)
            {
                tElement.addClass('ms-navigation');

                return function postLink(scope, iElement)
                {
                    var bodyEl = angular.element('body'),
                        foldExpanderEl = angular.element('<div id="ms-navigation-fold-expander"></div>'),
                        foldCollapserEl = angular.element('<div id="ms-navigation-fold-collapser"></div>'),
                        sidenav = $mdSidenav('navigation');

                    // Store the navigation in the service for public access
                    msNavigationService.setNavigationScope(scope);

                    // Initialize
                    init();

                    /**
                     * Initialize
                     */
                    function init()
                    {
                        // Set the folded status for the first time.
                        // First, we have to check if we have a folded
                        // status available in the service already. This
                        // will prevent navigation to act weird if we already
                        // set the fold status, remove the navigation and
                        // then re-initialize it, which happens if we
                        // change to a view without a navigation and then
                        // come back with history.back() function.

                        // If the service didn't initialize before, set
                        // the folded status from scope, otherwise we
                        // won't touch anything because the folded status
                        // already set in the service...
                        if ( msNavigationService.getFolded() === null )
                        {
                            msNavigationService.setFolded(scope.folded);
                        }

                        if ( msNavigationService.getFolded() )
                        {
                            // Collapse everything.
                            // This must be inside a $timeout because by the
                            // time we call this, the 'msNavigation::collapse'
                            // event listener is not registered yet. $timeout
                            // will ensure that it will be called after it is
                            // registered.
                            $timeout(function ()
                            {
                                $rootScope.$broadcast('msNavigation::collapse');
                            });

                            // Add class to the body
                            bodyEl.addClass('ms-navigation-folded');

                            // Set fold expander
                            setFoldExpander();
                        }
                    }

                    // Sidenav locked open status watcher
                    scope.$watch(function ()
                    {
                        return sidenav.isLockedOpen();
                    }, function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        var folded = msNavigationService.getFolded();

                        if ( folded )
                        {
                            if ( current )
                            {
                                // Collapse everything
                                $rootScope.$broadcast('msNavigation::collapse');
                            }
                            else
                            {
                                // Expand the active one and its parents
                                var activeItem = msNavigationService.getActiveItem();
                                if ( activeItem )
                                {
                                    activeItem.scope.$emit('msNavigation::stateMatched');
                                }
                            }
                        }
                    });

                    // Folded status watcher
                    scope.$watch('folded', function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        setFolded(current);
                    });

                    /**
                     * Set folded status
                     *
                     * @param folded
                     */
                    function setFolded(folded)
                    {
                        // Store folded status on the service for global access
                        msNavigationService.setFolded(folded);

                        if ( folded )
                        {
                            // Collapse everything
                            $rootScope.$broadcast('msNavigation::collapse');

                            // Add class to the body
                            bodyEl.addClass('ms-navigation-folded');

                            // Set fold expander
                            setFoldExpander();
                        }
                        else
                        {
                            // Expand the active one and its parents
                            var activeItem = msNavigationService.getActiveItem();
                            if ( activeItem )
                            {
                                activeItem.scope.$emit('msNavigation::stateMatched');
                            }

                            // Remove body class
                            bodyEl.removeClass('ms-navigation-folded ms-navigation-folded-open');

                            // Remove fold collapser
                            removeFoldCollapser();
                        }
                    }

                    /**
                     * Set fold expander
                     */
                    function setFoldExpander()
                    {
                        iElement.parent().append(foldExpanderEl);

                        // Let everything settle for a moment
                        // before registering the event listener
                        $timeout(function ()
                        {
                            foldExpanderEl.on('mouseenter touchstart', onFoldExpanderHover);
                        });
                    }

                    /**
                     * Set fold collapser
                     */
                    function setFoldCollapser()
                    {
                        bodyEl.find('#main').append(foldCollapserEl);
                        foldCollapserEl.on('mouseenter touchstart', onFoldCollapserHover);
                    }

                    /**
                     * Remove fold collapser
                     */
                    function removeFoldCollapser()
                    {
                        foldCollapserEl.remove();
                    }

                    /**
                     * onHover event of foldExpander
                     */
                    function onFoldExpanderHover(event)
                    {
                        if ( event )
                        {
                            event.preventDefault();
                        }

                        // Set folded open status
                        msNavigationService.setFoldedOpen(true);

                        // Expand the active one and its parents
                        var activeItem = msNavigationService.getActiveItem();
                        if ( activeItem )
                        {
                            activeItem.scope.$emit('msNavigation::stateMatched');
                        }

                        // Add class to the body
                        bodyEl.addClass('ms-navigation-folded-open');

                        // Remove the fold opener
                        foldExpanderEl.remove();

                        // Set fold collapser
                        setFoldCollapser();
                    }

                    /**
                     * onHover event of foldCollapser
                     */
                    function onFoldCollapserHover(event)
                    {
                        if ( event )
                        {
                            event.preventDefault();
                        }

                        // Set folded open status
                        msNavigationService.setFoldedOpen(false);

                        // Collapse everything
                        $rootScope.$broadcast('msNavigation::collapse');

                        // Remove body class
                        bodyEl.removeClass('ms-navigation-folded-open');

                        // Remove the fold collapser
                        foldCollapserEl.remove();

                        // Set fold expander
                        setFoldExpander();
                    }

                    /**
                     * Public access for toggling folded status externally
                     */
                    scope.toggleFolded = function ()
                    {
                        var folded = msNavigationService.getFolded();

                        setFolded(!folded);
                    };

                    /**
                     * On $stateChangeStart
                     */
                    scope.$on('$stateChangeStart', function ()
                    {
                        // Close the sidenav
                        sidenav.close();
                    });

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        foldCollapserEl.off('mouseenter touchstart');
                        foldExpanderEl.off('mouseenter touchstart');
                    });
                };
            }
        };
    }

    /** @ngInject */
    function MsNavigationNodeController($scope, $element, $rootScope, $animate, $state, msNavigationService)
    {
        var vm = this;

        // Data
        vm.element = $element;
        vm.node = $scope.node;
        vm.hasChildren = undefined;
        vm.collapsed = undefined;
        vm.collapsable = undefined;
        vm.group = undefined;
        vm.animateHeightClass = 'animate-height';

        // Methods
        vm.toggleCollapsed = toggleCollapsed;
        vm.collapse = collapse;
        vm.expand = expand;
        vm.getClass = getClass;
        vm.isHidden = isHidden;

        //////////

        init();

        /**
         * Initialize
         */
        function init()
        {
            // Setup the initial values

            // Has children?
            vm.hasChildren = vm.node.children.length > 0;

            // Is group?
            vm.group = !!(angular.isDefined(vm.node.group) && vm.node.group === true);

            // Is collapsable?
            if ( !vm.hasChildren || vm.group )
            {
                vm.collapsable = false;
            }
            else
            {
                vm.collapsable = !!(angular.isUndefined(vm.node.collapsable) || typeof vm.node.collapsable !== 'boolean' || vm.node.collapsable === true);
            }

            // Is collapsed?
            if ( !vm.collapsable )
            {
                vm.collapsed = false;
            }
            else
            {
                vm.collapsed = !!(angular.isUndefined(vm.node.collapsed) || typeof vm.node.collapsed !== 'boolean' || vm.node.collapsed === true);
            }

            // Expand all parents if we have a matching state or
            // the current state is a child of the node's state
            if ( vm.node.state === $state.current.name || $state.includes(vm.node.state) )
            {
                // If state params are defined, make sure they are
                // equal, otherwise do not set the active item
                if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                {
                    return;
                }

                $scope.$emit('msNavigation::stateMatched');

                // Also store the current active menu item
                msNavigationService.setActiveItem(vm.node, $scope);
            }

            $scope.$on('msNavigation::stateMatched', function ()
            {
                // Expand if the current scope is collapsable and is collapsed
                if ( vm.collapsable && vm.collapsed )
                {
                    $scope.$evalAsync(function ()
                    {
                        vm.collapsed = false;
                    });
                }
            });

            // Listen for collapse event
            $scope.$on('msNavigation::collapse', function (event, path)
            {
                if ( vm.collapsed || !vm.collapsable )
                {
                    return;
                }

                // If there is no path defined, collapse
                if ( angular.isUndefined(path) )
                {
                    vm.collapse();
                }
                // If there is a path defined, do not collapse
                // the items that are inside that path. This will
                // prevent parent items from collapsing
                else
                {
                    var givenPathParts = path.split('.'),
                        activePathParts = [];

                    var activeItem = msNavigationService.getActiveItem();
                    if ( activeItem )
                    {
                        activePathParts = activeItem.node._path.split('.');
                    }

                    // Test for given path
                    if ( givenPathParts.indexOf(vm.node._id) > -1 )
                    {
                        return;
                    }

                    // Test for active path
                    if ( activePathParts.indexOf(vm.node._id) > -1 )
                    {
                        return;
                    }

                    vm.collapse();
                }
            });

            // Listen for $stateChangeSuccess event
            $scope.$on('$stateChangeSuccess', function ()
            {
                if ( vm.node.state === $state.current.name )
                {
                    // If state params are defined, make sure they are
                    // equal, otherwise do not set the active item
                    if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                    {
                        return;
                    }

                    // Update active item on state change
                    msNavigationService.setActiveItem(vm.node, $scope);

                    // Collapse everything except the one we're using
                    $rootScope.$broadcast('msNavigation::collapse', vm.node._path);
                }

                // Expand the parents if we the current
                // state is a child of the node's state
                if ( $state.includes(vm.node.state) )
                {
                    // If state params are defined, make sure they are
                    // equal, otherwise do not set the active item
                    if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                    {
                        return;
                    }

                    // Emit the stateMatched
                    $scope.$emit('msNavigation::stateMatched');
                }
            });
        }

        /**
         * Toggle collapsed
         */
        function toggleCollapsed()
        {
            if ( vm.collapsed )
            {
                vm.expand();
            }
            else
            {
                vm.collapse();
            }
        }

        /**
         * Collapse
         */
        function collapse()
        {
            // Grab the element that we are going to collapse
            var collapseEl = vm.element.children('ul');

            // Grab the height
            var height = collapseEl[0].offsetHeight;

            $scope.$evalAsync(function ()
            {
                // Set collapsed status
                vm.collapsed = true;

                // Add collapsing class to the node
                vm.element.addClass('collapsing');

                // Animate the height
                $animate.animate(collapseEl,
                    {
                        'display': 'block',
                        'height' : height + 'px'
                    },
                    {
                        'height': '0px'
                    },
                    vm.animateHeightClass
                ).then(
                    function ()
                    {
                        // Clear the inline styles after animation done
                        collapseEl.css({
                            'display': '',
                            'height' : ''
                        });

                        // Clear collapsing class from the node
                        vm.element.removeClass('collapsing');
                    }
                );

                // Broadcast the collapse event so child items can also be collapsed
                $scope.$broadcast('msNavigation::collapse');
            });
        }

        /**
         * Expand
         */
        function expand()
        {
            // Grab the element that we are going to expand
            var expandEl = vm.element.children('ul');

            // Move the element out of the dom flow and
            // make it block so we can get its height
            expandEl.css({
                'position'  : 'absolute',
                'visibility': 'hidden',
                'display'   : 'block',
                'height'    : 'auto'
            });

            // Grab the height
            var height = expandEl[0].offsetHeight;

            // Reset the style modifications
            expandEl.css({
                'position'  : '',
                'visibility': '',
                'display'   : '',
                'height'    : ''
            });

            $scope.$evalAsync(function ()
            {
                // Set collapsed status
                vm.collapsed = false;

                // Add expanding class to the node
                vm.element.addClass('expanding');

                // Animate the height
                $animate.animate(expandEl,
                    {
                        'display': 'block',
                        'height' : '0px'
                    },
                    {
                        'height': height + 'px'
                    },
                    vm.animateHeightClass
                ).then(
                    function ()
                    {
                        // Clear the inline styles after animation done
                        expandEl.css({
                            'height': ''
                        });

                        // Clear expanding class from the node
                        vm.element.removeClass('expanding');
                    }
                );

                // If item expanded, broadcast the collapse event from rootScope so that the other expanded items
                // can be collapsed. This is necessary for keeping only one parent expanded at any time
                $rootScope.$broadcast('msNavigation::collapse', vm.node._path);
            });
        }

        /**
         * Return the class
         *
         * @returns {*}
         */
        function getClass()
        {
            return vm.node.class;
        }

        /**
         * Check if node should be hidden
         *
         * @returns {boolean}
         */
        function isHidden()
        {
            if ( angular.isDefined(vm.node.hidden) && angular.isFunction(vm.node.hidden) )
            {
                return vm.node.hidden();
            }

            return false;
        }
    }

    /** @ngInject */
    function msNavigationNodeDirective()
    {
        return {
            restrict        : 'A',
            bindToController: {
                node: '=msNavigationNode'
            },
            controller      : 'MsNavigationNodeController as vm',
            compile         : function (tElement)
            {
                tElement.addClass('ms-navigation-node');

                return function postLink(scope, iElement, iAttrs, MsNavigationNodeCtrl)
                {
                    // Add custom classes
                    iElement.addClass(MsNavigationNodeCtrl.getClass());

                    // Add group class if it's a group
                    if ( MsNavigationNodeCtrl.group )
                    {
                        iElement.addClass('group');
                    }
                };
            }
        };
    }

    /** @ngInject */
    function msNavigationItemDirective()
    {
        return {
            restrict: 'A',
            require : '^msNavigationNode',
            compile : function (tElement)
            {
                tElement.addClass('ms-navigation-item');

                return function postLink(scope, iElement, iAttrs, MsNavigationNodeCtrl)
                {
                    // If the item is collapsable...
                    if ( MsNavigationNodeCtrl.collapsable )
                    {
                        iElement.on('click', MsNavigationNodeCtrl.toggleCollapsed);
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        iElement.off('click');
                    });
                };
            }
        };
    }

    /** @ngInject */
    function msNavigationHorizontalDirective(msNavigationService)
    {
        return {
            restrict   : 'E',
            scope      : {
                root: '@'
            },
            controller : 'MsNavigationController as vm',
            templateUrl: 'app/core/directives/ms-navigation/templates/horizontal.html',
            transclude : true,
            compile    : function (tElement)
            {
                tElement.addClass('ms-navigation-horizontal');

                return function postLink(scope)
                {
                    // Store the navigation in the service for public access
                    msNavigationService.setNavigationScope(scope);
                };
            }
        };
    }

    /** @ngInject */
    function MsNavigationHorizontalNodeController($scope, $element, $rootScope, $state, msNavigationService)
    {
        var vm = this;

        // Data
        vm.element = $element;
        vm.node = $scope.node;
        vm.hasChildren = undefined;
        vm.group = undefined;

        // Methods
        vm.getClass = getClass;

        //////////

        init();

        /**
         * Initialize
         */
        function init()
        {
            // Setup the initial values

            // Is active
            vm.isActive = false;

            // Has children?
            vm.hasChildren = vm.node.children.length > 0;

            // Is group?
            vm.group = !!(angular.isDefined(vm.node.group) && vm.node.group === true);

            // Mark all parents as active if we have a matching state
            // or the current state is a child of the node's state
            if ( vm.node.state === $state.current.name || $state.includes(vm.node.state) )
            {
                // If state params are defined, make sure they are
                // equal, otherwise do not set the active item
                if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                {
                    return;
                }

                $scope.$emit('msNavigation::stateMatched');

                // Also store the current active menu item
                msNavigationService.setActiveItem(vm.node, $scope);
            }

            $scope.$on('msNavigation::stateMatched', function ()
            {
                // Mark as active if has children
                if ( vm.hasChildren )
                {
                    $scope.$evalAsync(function ()
                    {
                        vm.isActive = true;
                    });
                }
            });

            // Listen for clearActive event
            $scope.$on('msNavigation::clearActive', function ()
            {
                if ( !vm.hasChildren )
                {
                    return;
                }

                var activePathParts = [];

                var activeItem = msNavigationService.getActiveItem();
                if ( activeItem )
                {
                    activePathParts = activeItem.node._path.split('.');
                }

                // Test for active path
                if ( activePathParts.indexOf(vm.node._id) > -1 )
                {
                    $scope.$evalAsync(function ()
                    {
                        vm.isActive = true;
                    });
                }
                else
                {
                    $scope.$evalAsync(function ()
                    {
                        vm.isActive = false;
                    });
                }

            });

            // Listen for $stateChangeSuccess event
            $scope.$on('$stateChangeSuccess', function ()
            {
                if ( vm.node.state === $state.current.name || $state.includes(vm.node.state) )
                {
                    // If state params are defined, make sure they are
                    // equal, otherwise do not set the active item
                    if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                    {
                        return;
                    }

                    // Update active item on state change
                    msNavigationService.setActiveItem(vm.node, $scope);

                    // Clear all active states except the one we're using
                    $rootScope.$broadcast('msNavigation::clearActive');
                }
            });
        }

        /**
         * Return the class
         *
         * @returns {*}
         */
        function getClass()
        {
            return vm.node.class;
        }
    }

    /** @ngInject */
    function msNavigationHorizontalNodeDirective()
    {
        return {
            restrict        : 'A',
            bindToController: {
                node: '=msNavigationHorizontalNode'
            },
            controller      : 'MsNavigationHorizontalNodeController as vm',
            compile         : function (tElement)
            {
                tElement.addClass('ms-navigation-horizontal-node');

                return function postLink(scope, iElement, iAttrs, MsNavigationHorizontalNodeCtrl)
                {
                    // Add custom classes
                    iElement.addClass(MsNavigationHorizontalNodeCtrl.getClass());

                    // Add group class if it's a group
                    if ( MsNavigationHorizontalNodeCtrl.group )
                    {
                        iElement.addClass('group');
                    }
                };
            }
        };
    }

    /** @ngInject */
    function msNavigationHorizontalItemDirective($mdMedia)
    {
        return {
            restrict: 'A',
            require : '^msNavigationHorizontalNode',
            compile : function (tElement)
            {
                tElement.addClass('ms-navigation-horizontal-item');

                return function postLink(scope, iElement, iAttrs, MsNavigationHorizontalNodeCtrl)
                {
                    iElement.on('click', onClick);

                    function onClick()
                    {
                        if ( !MsNavigationHorizontalNodeCtrl.hasChildren || $mdMedia('gt-md') )
                        {
                            return;
                        }

                        iElement.toggleClass('expanded');
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        iElement.off('click');
                    });
                };
            }
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msRandomClass', msRandomClassDirective);

    /** @ngInject */
    function msRandomClassDirective()
    {
        return {
            restrict: 'A',
            scope   : {
                msRandomClass: '='
            },
            link    : function (scope, iElement)
            {
                var randomClass = scope.msRandomClass[Math.floor(Math.random() * (scope.msRandomClass.length))];
                iElement.addClass(randomClass);
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('msMaterialColorPickerController', msMaterialColorPickerController)
        .directive('msMaterialColorPicker', msMaterialColorPicker);

    /** @ngInject */
    function msMaterialColorPickerController($scope, $mdColorPalette, $mdMenu, marvilixGenerator)
    {
        var vm = this;
        vm.palettes = $mdColorPalette; // Material Color Palette
        vm.selectedPalette = false;
        vm.selectedHues = false;
        $scope.$selectedColor = {};

        // Methods
        vm.activateHueSelection = activateHueSelection;
        vm.selectColor = selectColor;
        vm.removeColor = removeColor;

        /**
         * Initialize / Watch model changes
         */
        $scope.$watch('ngModel', setSelectedColor);

        /**
         * Activate Hue Selection
         * @param palette
         * @param hues
         */
        function activateHueSelection(palette, hues)
        {
            vm.selectedPalette = palette;
            vm.selectedHues = hues;
        }

        /**
         * Select Color
         * @type {selectColor}
         */
        function selectColor(palette, hue)
        {
            // Update Selected Color
            updateSelectedColor(palette, hue);

            // Update Model Value
            updateModel();

            // Hide The picker
            $mdMenu.hide();
        }

        function removeColor()
        {
            vm.selectedColor = {
                palette: '',
                hue    : '',
                class  : ''
            };

            activateHueSelection(false, false);

            updateModel();
        }

        /**
         * Set SelectedColor by model type
         */
        function setSelectedColor()
        {
            if ( !vm.modelCtrl.$viewValue || vm.modelCtrl.$viewValue === '' )
            {
                removeColor();
                return;
            }

            var palette, hue;

            // If ModelType Class
            if ( vm.msModelType === 'class' )
            {
                var color = vm.modelCtrl.$viewValue.split('-');
                if ( color.length >= 5 )
                {
                    palette = color[1] + '-' + color[2];
                    hue = color[3];
                }
                else
                {
                    palette = color[1];
                    hue = color[2];
                }
            }

            // If ModelType Object
            else if ( vm.msModelType === 'obj' )
            {
                palette = vm.modelCtrl.$viewValue.palette;
                hue = vm.modelCtrl.$viewValue.hue || 500;
            }

            // Update Selected Color
            updateSelectedColor(palette, hue);
        }

        /**
         * Update Selected Color
         * @param palette
         * @param hue
         */
        function updateSelectedColor(palette, hue)
        {
            vm.selectedColor = {
                palette     : palette,
                hue         : hue,
                class       : 'md-' + palette + '-' + hue + '-bg',
                bgColorValue: marvilixGenerator.rgba(vm.palettes[palette][hue].value),
                fgColorValue: marvilixGenerator.rgba(vm.palettes[palette][hue].contrast)
            };

            // If Model object not Equals the selectedColor update it
            // it can be happen when the model only have pallete and hue values
            if ( vm.msModelType === 'obj' && !angular.equals(vm.selectedColor, vm.modelCtrl.$viewValue) )
            {
                // Update Model Value
                updateModel();
            }

            activateHueSelection(palette, vm.palettes[palette]);

            $scope.$selectedColor = vm.selectedColor;
        }

        /**
         * Update Model Value by model type
         */
        function updateModel()
        {
            if ( vm.msModelType === 'class' )
            {
                vm.modelCtrl.$setViewValue(vm.selectedColor.class);
            }
            else if ( vm.msModelType === 'obj' )
            {
                vm.modelCtrl.$setViewValue(vm.selectedColor);
            }
        }
    }

    /** @ngInject */
    function msMaterialColorPicker()
    {
        return {
            require    : ['msMaterialColorPicker', 'ngModel'],
            restrict   : 'E',
            scope      : {
                ngModel    : '=',
                msModelType: '@?'
            },
            controller : 'msMaterialColorPickerController as vm',
            transclude : true,
            templateUrl: 'app/core/directives/ms-material-color-picker/ms-material-color-picker.html',
            link       : function (scope, element, attrs, controllers, transclude)
            {
                var ctrl = controllers[0];

                /**
                 *  Pass model controller to directive controller
                 */
                ctrl.modelCtrl = controllers[1];

                /**
                 * ModelType: 'obj', 'class'(default)
                 * @type {string|string}
                 */
                ctrl.msModelType = scope.msModelType || 'class';

                transclude(scope, function (clone)
                {
                    clone = clone.filter(function (i, el)
                    {
                        return ( el.nodeType === 1 ) ? true : false;
                    });

                    if ( clone.length )
                    {
                        element.find('ms-color-picker-button').replaceWith(clone);
                    }
                });
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('msNavFoldService', msNavFoldService)
        .directive('msNavIsFolded', msNavIsFoldedDirective)
        .controller('MsNavController', MsNavController)
        .directive('msNav', msNavDirective)
        .directive('msNavTitle', msNavTitleDirective)
        .directive('msNavButton', msNavButtonDirective)
        .directive('msNavToggle', msNavToggleDirective);

    /** @ngInject */
    function msNavFoldService()
    {
        var foldable = {};

        var service = {
            setFoldable    : setFoldable,
            isNavFoldedOpen: isNavFoldedOpen,
            toggleFold     : toggleFold,
            openFolded     : openFolded,
            closeFolded    : closeFolded
        };

        return service;

        //////////

        /**
         * Set the foldable
         *
         * @param scope
         * @param element
         */
        function setFoldable(scope, element)
        {
            foldable = {
                'scope'  : scope,
                'element': element
            };
        }

        /**
         * Is folded open
         */
        function isNavFoldedOpen()
        {
            return foldable.scope.isNavFoldedOpen();
        }

        /**
         * Toggle fold
         */
        function toggleFold()
        {
            foldable.scope.toggleFold();
        }

        /**
         * Open folded navigation
         */
        function openFolded()
        {
            foldable.scope.openFolded();
        }

        /**
         * Close folded navigation
         */
        function closeFolded()
        {
            foldable.scope.closeFolded();
        }
    }

    /** @ngInject */
    function msNavIsFoldedDirective($document, $rootScope, msNavFoldService)
    {
        return {
            restrict: 'A',
            link    : function (scope, iElement, iAttrs)
            {
                var isFolded = (iAttrs.msNavIsFolded === 'true'),
                    isFoldedOpen = false,
                    body = angular.element($document[0].body),
                    openOverlay = angular.element('<div id="ms-nav-fold-open-overlay"></div>'),
                    closeOverlay = angular.element('<div id="ms-nav-fold-close-overlay"></div>'),
                    sidenavEl = iElement.parent();

                // Initialize the service
                msNavFoldService.setFoldable(scope, iElement, isFolded);

                // Set the fold status for the first time
                if ( isFolded )
                {
                    fold();
                }
                else
                {
                    unfold();
                }

                /**
                 * Is nav folded open
                 */
                function isNavFoldedOpen()
                {
                    return isFoldedOpen;
                }

                /**
                 * Toggle fold
                 */
                function toggleFold()
                {
                    isFolded = !isFolded;

                    if ( isFolded )
                    {
                        fold();
                    }
                    else
                    {
                        unfold();
                    }
                }

                /**
                 * Fold the navigation
                 */
                function fold()
                {
                    // Add classes
                    body.addClass('ms-nav-folded');

                    // Collapse everything and scroll to the top
                    $rootScope.$broadcast('msNav::forceCollapse');
                    iElement.scrollTop(0);

                    // Append the openOverlay to the element
                    sidenavEl.append(openOverlay);

                    // Event listeners
                    openOverlay.on('mouseenter touchstart', function (event)
                    {
                        openFolded(event);
                        isFoldedOpen = true;
                    });
                }

                /**
                 * Open folded navigation
                 */
                function openFolded(event)
                {
                    if ( angular.isDefined(event) )
                    {
                        event.preventDefault();
                    }

                    body.addClass('ms-nav-folded-open');

                    // Update the location
                    $rootScope.$broadcast('msNav::expandMatchingToggles');

                    // Remove open overlay
                    sidenavEl.find(openOverlay).remove();

                    // Append close overlay and bind its events
                    sidenavEl.parent().append(closeOverlay);
                    closeOverlay.on('mouseenter touchstart', function (event)
                    {
                        closeFolded(event);
                        isFoldedOpen = false;
                    });
                }

                /**
                 * Close folded navigation
                 */
                function closeFolded(event)
                {
                    if ( angular.isDefined(event) )
                    {
                        event.preventDefault();
                    }

                    // Collapse everything and scroll to the top
                    $rootScope.$broadcast('msNav::forceCollapse');
                    iElement.scrollTop(0);

                    body.removeClass('ms-nav-folded-open');

                    // Remove close overlay
                    sidenavEl.parent().find(closeOverlay).remove();

                    // Append open overlay and bind its events
                    sidenavEl.append(openOverlay);
                    openOverlay.on('mouseenter touchstart', function (event)
                    {
                        openFolded(event);
                        isFoldedOpen = true;
                    });
                }

                /**
                 * Unfold the navigation
                 */
                function unfold()
                {
                    body.removeClass('ms-nav-folded ms-nav-folded-open');

                    // Update the location
                    $rootScope.$broadcast('msNav::expandMatchingToggles');

                    iElement.off('mouseenter mouseleave');
                }

                // Expose functions to the scope
                scope.toggleFold = toggleFold;
                scope.openFolded = openFolded;
                scope.closeFolded = closeFolded;
                scope.isNavFoldedOpen = isNavFoldedOpen;

                // Cleanup
                scope.$on('$destroy', function ()
                {
                    openOverlay.off('mouseenter touchstart');
                    closeOverlay.off('mouseenter touchstart');
                    iElement.off('mouseenter mouseleave');
                });
            }
        };
    }


    /** @ngInject */
    function MsNavController()
    {
        var vm = this,
            disabled = false,
            toggleItems = [],
            lockedItems = [];

        // Data

        // Methods
        vm.isDisabled = isDisabled;
        vm.enable = enable;
        vm.disable = disable;
        vm.setToggleItem = setToggleItem;
        vm.getLockedItems = getLockedItems;
        vm.setLockedItem = setLockedItem;
        vm.clearLockedItems = clearLockedItems;

        //////////

        /**
         * Is navigation disabled
         *
         * @returns {boolean}
         */
        function isDisabled()
        {
            return disabled;
        }

        /**
         * Disable the navigation
         */
        function disable()
        {
            disabled = true;
        }

        /**
         * Enable the navigation
         */
        function enable()
        {
            disabled = false;
        }

        /**
         * Set toggle item
         *
         * @param element
         * @param scope
         */
        function setToggleItem(element, scope)
        {
            toggleItems.push({
                'element': element,
                'scope'  : scope
            });
        }

        /**
         * Get locked items
         *
         * @returns {Array}
         */
        function getLockedItems()
        {
            return lockedItems;
        }

        /**
         * Set locked item
         *
         * @param element
         * @param scope
         */
        function setLockedItem(element, scope)
        {
            lockedItems.push({
                'element': element,
                'scope'  : scope
            });
        }

        /**
         * Clear locked items list
         */
        function clearLockedItems()
        {
            lockedItems = [];
        }
    }

    /** @ngInject */
    function msNavDirective($rootScope, $mdComponentRegistry, msNavFoldService)
    {
        return {
            restrict  : 'E',
            scope     : {},
            controller: 'MsNavController',
            compile   : function (tElement)
            {
                tElement.addClass('ms-nav');

                return function postLink(scope)
                {
                    // Update toggle status according to the ui-router current state
                    $rootScope.$broadcast('msNav::expandMatchingToggles');

                    // Update toggles on state changes
                    var stateChangeSuccessEvent = $rootScope.$on('$stateChangeSuccess', function ()
                    {
                        $rootScope.$broadcast('msNav::expandMatchingToggles');

                        // Close navigation sidenav on stateChangeSuccess
                        $mdComponentRegistry.when('navigation').then(function (navigation)
                        {
                            navigation.close();

                            if ( msNavFoldService.isNavFoldedOpen() )
                            {
                                msNavFoldService.closeFolded();
                            }
                        });
                    });

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        stateChangeSuccessEvent();
                    });
                };
            }
        };
    }

    /** @ngInject */
    function msNavTitleDirective()
    {
        return {
            restrict: 'A',
            compile : function (tElement)
            {
                tElement.addClass('ms-nav-title');

                return function postLink()
                {

                };
            }
        };
    }

    /** @ngInject */
    function msNavButtonDirective()
    {
        return {
            restrict: 'AE',
            compile : function (tElement)
            {
                tElement.addClass('ms-nav-button');

                return function postLink()
                {

                };
            }
        };
    }

    /** @ngInject */
    function msNavToggleDirective($rootScope, $q, $animate, $state)
    {
        return {
            restrict: 'A',
            require : '^msNav',
            scope   : true,
            compile : function (tElement, tAttrs)
            {
                tElement.addClass('ms-nav-toggle');

                // Add collapsed attr
                if ( angular.isUndefined(tAttrs.collapsed) )
                {
                    tAttrs.collapsed = true;
                }

                tElement.attr('collapsed', tAttrs.collapsed);

                return function postLink(scope, iElement, iAttrs, MsNavCtrl)
                {
                    var classes = {
                        expanded         : 'expanded',
                        expandAnimation  : 'expand-animation',
                        collapseAnimation: 'collapse-animation'
                    };

                    // Store all related states
                    var links = iElement.find('a');
                    var states = [];
                    var regExp = /\(.*\)/g;

                    angular.forEach(links, function (link)
                    {
                        var state = angular.element(link).attr('ui-sref');

                        if ( angular.isUndefined(state) )
                        {
                            return;
                        }

                        // Remove any parameter definition from the state name before storing it
                        state = state.replace(regExp, '');

                        states.push(state);
                    });

                    // Store toggle-able element and its scope in the main nav controller
                    MsNavCtrl.setToggleItem(iElement, scope);

                    // Click handler
                    iElement.children('.ms-nav-button').on('click', toggle);

                    // Toggle function
                    function toggle()
                    {
                        // If navigation is disabled, do nothing...
                        if ( MsNavCtrl.isDisabled() )
                        {
                            return;
                        }

                        // Disable the entire navigation to prevent spamming
                        MsNavCtrl.disable();

                        if ( isCollapsed() )
                        {
                            // Clear the locked items list
                            MsNavCtrl.clearLockedItems();

                            // Emit pushToLockedList event
                            scope.$emit('msNav::pushToLockedList');

                            // Collapse everything but locked items
                            $rootScope.$broadcast('msNav::collapse');

                            // Expand and then...
                            expand().then(function ()
                            {
                                // Enable the entire navigation after animations completed
                                MsNavCtrl.enable();
                            });
                        }
                        else
                        {
                            // Collapse with all children
                            scope.$broadcast('msNav::forceCollapse');
                        }
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        iElement.children('.ms-nav-button').off('click');
                    });

                    /*---------------------*/
                    /* Scope Events        */
                    /*---------------------*/

                    /**
                     * Collapse everything but locked items
                     */
                    scope.$on('msNav::collapse', function ()
                    {
                        // Only collapse toggles that are not locked
                        var lockedItems = MsNavCtrl.getLockedItems();
                        var locked = false;

                        angular.forEach(lockedItems, function (lockedItem)
                        {
                            if ( angular.equals(lockedItem.scope, scope) )
                            {
                                locked = true;
                            }
                        });

                        if ( locked )
                        {
                            return;
                        }

                        // Collapse and then...
                        collapse().then(function ()
                        {
                            // Enable the entire navigation after animations completed
                            MsNavCtrl.enable();
                        });
                    });

                    /**
                     * Collapse everything
                     */
                    scope.$on('msNav::forceCollapse', function ()
                    {
                        // Collapse and then...
                        collapse().then(function ()
                        {
                            // Enable the entire navigation after animations completed
                            MsNavCtrl.enable();
                        });
                    });

                    /**
                     * Expand toggles that match with the current states
                     */
                    scope.$on('msNav::expandMatchingToggles', function ()
                    {
                        var currentState = $state.current.name;
                        var shouldExpand = false;

                        angular.forEach(states, function (state)
                        {
                            if ( currentState === state )
                            {
                                shouldExpand = true;
                            }
                        });

                        if ( shouldExpand )
                        {
                            expand();
                        }
                        else
                        {
                            collapse();
                        }
                    });

                    /**
                     * Add toggle to the locked list
                     */
                    scope.$on('msNav::pushToLockedList', function ()
                    {
                        // Set expanded item on main nav controller
                        MsNavCtrl.setLockedItem(iElement, scope);
                    });

                    /*---------------------*/
                    /* Internal functions  */
                    /*---------------------*/

                    /**
                     * Is element collapsed
                     *
                     * @returns {bool}
                     */
                    function isCollapsed()
                    {
                        return iElement.attr('collapsed') === 'true';
                    }

                    /**
                     * Is element expanded
                     *
                     * @returns {bool}
                     */
                    function isExpanded()
                    {
                        return !isCollapsed();
                    }

                    /**
                     * Expand the toggle
                     *
                     * @returns $promise
                     */
                    function expand()
                    {
                        // Create a new deferred object
                        var deferred = $q.defer();

                        // If the menu item is already expanded, do nothing..
                        if ( isExpanded() )
                        {
                            // Reject the deferred object
                            deferred.reject({'error': true});

                            // Return the promise
                            return deferred.promise;
                        }

                        // Set element attr
                        iElement.attr('collapsed', false);

                        // Grab the element to expand
                        var elementToExpand = angular.element(iElement.find('ms-nav-toggle-items')[0]);

                        // Move the element out of the dom flow and
                        // make it block so we can get its height
                        elementToExpand.css({
                            'position'  : 'absolute',
                            'visibility': 'hidden',
                            'display'   : 'block',
                            'height'    : 'auto'
                        });

                        // Grab the height
                        var height = elementToExpand[0].offsetHeight;

                        // Reset the style modifications
                        elementToExpand.css({
                            'position'  : '',
                            'visibility': '',
                            'display'   : '',
                            'height'    : ''
                        });

                        // Animate the height
                        scope.$evalAsync(function ()
                        {
                            $animate.animate(elementToExpand,
                                {
                                    'display': 'block',
                                    'height' : '0px'
                                },
                                {
                                    'height': height + 'px'
                                },
                                classes.expandAnimation
                            ).then(
                                function ()
                                {
                                    // Add expanded class
                                    elementToExpand.addClass(classes.expanded);

                                    // Clear the inline styles after animation done
                                    elementToExpand.css({'height': ''});

                                    // Resolve the deferred object
                                    deferred.resolve({'success': true});
                                }
                            );
                        });

                        // Return the promise
                        return deferred.promise;
                    }

                    /**
                     * Collapse the toggle
                     *
                     * @returns $promise
                     */
                    function collapse()
                    {
                        // Create a new deferred object
                        var deferred = $q.defer();

                        // If the menu item is already collapsed, do nothing..
                        if ( isCollapsed() )
                        {
                            // Reject the deferred object
                            deferred.reject({'error': true});

                            // Return the promise
                            return deferred.promise;
                        }

                        // Set element attr
                        iElement.attr('collapsed', true);

                        // Grab the element to collapse
                        var elementToCollapse = angular.element(iElement.find('ms-nav-toggle-items')[0]);

                        // Grab the height
                        var height = elementToCollapse[0].offsetHeight;

                        // Animate the height
                        scope.$evalAsync(function ()
                        {
                            $animate.animate(elementToCollapse,
                                {
                                    'height': height + 'px'
                                },
                                {
                                    'height': '0px'
                                },
                                classes.collapseAnimation
                            ).then(
                                function ()
                                {
                                    // Remove expanded class
                                    elementToCollapse.removeClass(classes.expanded);

                                    // Clear the inline styles after animation done
                                    elementToCollapse.css({
                                        'display': '',
                                        'height' : ''
                                    });

                                    // Resolve the deferred object
                                    deferred.resolve({'success': true});
                                }
                            );
                        });

                        // Return the promise
                        return deferred.promise;
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msInfoBar', msInfoBarDirective);

    /** @ngInject */
    function msInfoBarDirective($document)
    {
        return {
            restrict   : 'E',
            scope      : {},
            transclude : true,
            templateUrl: 'app/core/directives/ms-info-bar/ms-info-bar.html',
            link       : function (scope, iElement)
            {
                var body = $document.find('body'),
                    bodyClass = 'ms-info-bar-active';

                // Add body class
                body.addClass(bodyClass);

                /**
                 * Remove the info bar
                 */
                function removeInfoBar()
                {
                    body.removeClass(bodyClass);
                    iElement.remove();
                    scope.$destroy();
                }

                // Expose functions
                scope.removeInfoBar = removeInfoBar;
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('msMasonryController', msMasonryController)
        .directive('msMasonry', msMasonry)
        .directive('msMasonryItem', msMasonryItem);

    /** @ngInject */
    function msMasonryController($scope, $window, $mdMedia, $timeout)
    {
        var vm = this,
            defaultOpts = {
                columnCount     : 5,
                respectItemOrder: false,
                reLayoutDebounce: 400,
                responsive      : {
                    md: 3,
                    sm: 2,
                    xs: 1
                }
            },
            reLayoutTimeout = true;

        vm.options = null;
        vm.container = [];
        vm.containerPos = '';
        vm.columnWidth = '';
        vm.items = [];

        // Methods
        vm.reLayout = reLayout;
        vm.initialize = initialize;
        vm.waitImagesLoaded = waitImagesLoaded;

        function initialize()
        {
            vm.options = !vm.options ? defaultOpts : angular.extend(defaultOpts, vm.options);


            watchContainerResize();
        }

        $scope.$on('msMasonry:relayout', function ()
        {
            reLayout();
        });

        function waitImagesLoaded(element, callback)
        {
            if ( typeof imagesLoaded !== 'undefined' )
            {
                var imgLoad = $window.imagesLoaded(element);

                imgLoad.on('done', function ()
                {
                    callback();
                });
            }
            else
            {
                callback();
            }
        }

        function watchContainerResize()
        {
            $scope.$watch(
                function ()
                {
                    return vm.container.width();
                },
                function (newValue, oldValue)
                {
                    if ( newValue !== oldValue )
                    {
                        reLayout();
                    }
                }
            );
        }

        function reLayout()
        {
            // Debounce for relayout
            if ( reLayoutTimeout )
            {
                $timeout.cancel(reLayoutTimeout);
            }

            reLayoutTimeout = $timeout(function ()
            {
                start();

                $scope.$broadcast('msMasonry:relayoutFinished');

            }, vm.options.reLayoutDebounce);

            // Start relayout
            function start()
            {
                vm.containerPos = vm.container[0].getBoundingClientRect();

                updateColumnOptions();

                $scope.$broadcast('msMasonry:relayoutStarted');

                vm.items = vm.container.find('ms-masonry-item');

                //initialize lastRowBottomArr
                var referenceArr = Array.apply(null, new Array(vm.columnCount)).map(function ()
                {
                    return 0;
                });

                // set item positions
                for ( var i = 0; i < vm.items.length; i++ )
                {
                    var item = vm.items[i],
                        xPos, yPos, column, refTop;

                    item = angular.element(item);

                    if ( item.scope() )
                    {
                        item.scope().$broadcast('msMasonryItem:startReLayout');
                    }

                    item.css({'width': vm.columnWidth});

                    if ( vm.options.respectItemOrder )
                    {
                        column = i % vm.columnCount;
                        refTop = referenceArr[column];
                    }
                    else
                    {
                        refTop = Math.min.apply(Math, referenceArr);
                        column = referenceArr.indexOf(refTop);
                    }

                    referenceArr[column] = refTop + item[0].getBoundingClientRect().height;

                    xPos = Math.round(column * vm.columnWidth);
                    yPos = refTop;

                    item.css({'transform': 'translate3d(' + xPos + 'px,' + yPos + 'px,0px)'});
                    item.addClass('placed');

                    if ( item.scope() )
                    {
                        item.scope().$broadcast('msMasonryItem:finishReLayout');
                    }
                }
            }
        }

        function updateColumnOptions()
        {
            vm.columnCount = vm.options.columnCount;

            if ( $mdMedia('gt-md') )
            {
                vm.columnCount = vm.options.columnCount;
            }
            else if ( $mdMedia('md') )
            {
                vm.columnCount = (vm.columnCount > vm.options.responsive.md ? vm.options.responsive.md : vm.columnCount);
            }
            else if ( $mdMedia('sm') )
            {
                vm.columnCount = (vm.columnCount > vm.options.responsive.sm ? vm.options.responsive.sm : vm.columnCount);
            }
            else
            {
                vm.columnCount = vm.options.responsive.xs;
            }

            vm.columnWidth = vm.containerPos.width / vm.columnCount;

        }
    }

    /** @ngInject */
    function msMasonry($timeout)
    {
        return {
            restrict  : 'AEC',
            controller: 'msMasonryController',
            compile   : compile
        };
        function compile(element, attributes)
        {
            return {
                pre : function preLink(scope, iElement, iAttrs, controller)
                {
                    controller.options = angular.fromJson(attributes.options || '{}');
                    controller.container = element;
                },
                post: function postLink(scope, iElement, iAttrs, controller)
                {
                    $timeout(function ()
                    {
                        controller.initialize();
                    });
                }
            };
        }
    }

    /** @ngInject */
    function msMasonryItem()
    {
        return {
            restrict: 'AEC',
            require : '^msMasonry',
            priority: 1,
            link    : link
        };

        function link(scope, element, attributes, controller)
        {
            controller.waitImagesLoaded(element, function ()
            {
                controller.reLayout();

            });

            scope.$on('msMasonryItem:finishReLayout', function ()
            {
                scope.$watch(function ()
                {
                    return element.height();
                }, function (newVal, oldVal)
                {
                    if ( newVal !== oldVal )
                    {
                        controller.reLayout();
                    }
                });
            });

            element.on('$destroy', function ()
            {
                controller.reLayout();
            });
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsFormWizardController', MsFormWizardController)
        .directive('msFormWizard', msFormWizardDirective)
        .directive('msFormWizardForm', msFormWizardFormDirective);

    /** @ngInject */
    function MsFormWizardController()
    {
        var vm = this;

        // Data
        vm.forms = [];
        vm.selectedIndex = 0;

        // Methods
        vm.registerForm = registerForm;

        vm.previousStep = previousStep;
        vm.nextStep = nextStep;
        vm.firstStep = firstStep;
        vm.lastStep = lastStep;

        vm.totalSteps = totalSteps;
        vm.isFirstStep = isFirstStep;
        vm.isLastStep = isLastStep;

        vm.currentStepInvalid = currentStepInvalid;
        vm.previousStepInvalid = previousStepInvalid;
        vm.formsIncomplete = formsIncomplete;
        vm.resetForm = resetForm;

        //////////

        /**
         * Register form
         *
         * @param form
         */
        function registerForm(form)
        {
            vm.forms.push(form);
        }

        /**
         * Go to previous step
         */
        function previousStep()
        {
            if ( isFirstStep() )
            {
                return;
            }

            vm.selectedIndex--;
        }

        /**
         * Go to next step
         */
        function nextStep()
        {
            if ( isLastStep() )
            {
                return;
            }

            vm.selectedIndex++;
        }

        /**
         * Go to first step
         */
        function firstStep()
        {
            vm.selectedIndex = 0;
        }

        /**
         * Go to last step
         */
        function lastStep()
        {
            vm.selectedIndex = totalSteps() - 1;
        }

        /**
         * Return total steps
         *
         * @returns {int}
         */
        function totalSteps()
        {
            return vm.forms.length;
        }

        /**
         * Is first step?
         *
         * @returns {boolean}
         */
        function isFirstStep()
        {
            return vm.selectedIndex === 0;
        }

        /**
         * Is last step?
         *
         * @returns {boolean}
         */
        function isLastStep()
        {
            return vm.selectedIndex === totalSteps() - 1;
        }

        /**
         * Is current step invalid?
         *
         * @returns {boolean}
         */
        function currentStepInvalid()
        {
            return angular.isDefined(vm.forms[vm.selectedIndex]) && vm.forms[vm.selectedIndex].$invalid;
        }

        /**
         * Is previous step invalid?
         *
         * @returns {boolean}
         */
        function previousStepInvalid()
        {
            return vm.selectedIndex > 0 && angular.isDefined(vm.forms[vm.selectedIndex - 1]) && vm.forms[vm.selectedIndex - 1].$invalid;
        }

        /**
         * Check if there is any incomplete forms
         *
         * @returns {boolean}
         */
        function formsIncomplete()
        {
            for ( var x = 0; x < vm.forms.length; x++ )
            {
                if ( vm.forms[x].$invalid )
                {
                    return true;
                }
            }

            return false;
        }

        /**
         * Reset form
         */
        function resetForm()
        {
            // Go back to the first step
            vm.selectedIndex = 0;

            // Make sure all the forms are back in the $pristine & $untouched status
            for ( var x = 0; x < vm.forms.length; x++ )
            {
                vm.forms[x].$setPristine();
                vm.forms[x].$setUntouched();
            }
        }
    }

    /** @ngInject */
    function msFormWizardDirective()
    {
        return {
            restrict  : 'E',
            scope     : true,
            controller: 'MsFormWizardController as msWizard',
            compile   : function (tElement)
            {
                tElement.addClass('ms-form-wizard');

                return function postLink()
                {

                };
            }
        };
    }

    /** @ngInject */
    function msFormWizardFormDirective()
    {
        return {
            restrict: 'A',
            require : ['form', '^msFormWizard'],
            compile : function (tElement)
            {
                tElement.addClass('ms-form-wizard-form');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var formCtrl = ctrls[0],
                        MsFormWizardCtrl = ctrls[1];

                    MsFormWizardCtrl.registerForm(formCtrl);
                };
            }
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msDatepickerFixConfig', msDatepickerFixConfigProvider)
        .directive('msDatepickerFix', msDatepickerFix);

    /** @ngInject */
    function msDatepickerFixConfigProvider()
    {
        var service = this;

        // Default configuration
        var defaultConfig = {
            // To view
            formatter: function (val)
            {
                if ( !val )
                {
                    return '';
                }

                return val === '' ? val : new Date(val);
            },
            // To model
            parser   : function (val)
            {
                if ( !val )
                {
                    return '';
                }

                return moment(val).add(moment(val).utcOffset(), 'm').toDate();
            }
        };

        // Methods
        service.config = config;

        //////////

        /**
         * Extend default configuration with the given one
         *
         * @param configuration
         */
        function config(configuration)
        {
            defaultConfig = angular.extend({}, defaultConfig, configuration);
        }

        /**
         * Service
         */
        service.$get = function ()
        {
            return defaultConfig;
        };
    }

    /** @ngInject */
    function msDatepickerFix(msDatepickerFixConfig)
    {
        return {
            require : 'ngModel',
            priority: 1,
            link    : function (scope, elem, attrs, ngModel)
            {
                ngModel.$formatters.push(msDatepickerFixConfig.formatter); // to view
                ngModel.$parsers.push(msDatepickerFixConfig.parser); // to model
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msCard', msCardDirective);

    /** @ngInject */
    function msCardDirective()
    {
        return {
            restrict: 'E',
            scope   : {
                templatePath: '=template',
                card        : '=ngModel',
                vm          : '=viewModel'
            },
            template: '<div class="ms-card-content-wrapper" ng-include="templatePath" onload="cardTemplateLoaded()"></div>',
            compile : function (tElement)
            {
                // Add class
                tElement.addClass('ms-card');

                return function postLink(scope, iElement)
                {
                    // Methods
                    scope.cardTemplateLoaded = cardTemplateLoaded;

                    //////////

                    /**
                     * Emit cardTemplateLoaded event
                     */
                    function cardTemplateLoaded()
                    {
                        scope.$emit('msCard::cardTemplateLoaded', iElement);
                    }
                };
            }
        };
    }
})();
angular
        .module('app.core')
    .directive("fileread", [function () {
        return {
            scope: {
                fileread: "="
            },
            link: function (scope, element, attributes) {
                element.bind("change", function (changeEvent) {
                    var reader = new FileReader();
                    reader.onload = function (loadEvent) {
                        scope.$apply(function () {
                            scope.fileread = loadEvent.target.result;
                        });
                    }
                    reader.readAsDataURL(changeEvent.target.files[0]);
                });
            }
        }
    }]);
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .service('marvilixTheming', marvilixThemingService);

    /** @ngInject */
    function marvilixThemingService($cookies, $log, $mdTheming)
    {
        var service = {
            getRegisteredPalettes: getRegisteredPalettes,
            getRegisteredThemes  : getRegisteredThemes,
            setActiveTheme       : setActiveTheme,
            setThemesList        : setThemesList,
            themes               : {
                list  : {},
                active: {
                    'name' : '',
                    'theme': {}
                }
            }
        };

        return service;

        //////////

        /**
         * Get registered palettes
         *
         * @returns {*}
         */
        function getRegisteredPalettes()
        {
            return $mdTheming.PALETTES;
        }

        /**
         * Get registered themes
         *
         * @returns {*}
         */
        function getRegisteredThemes()
        {
            return $mdTheming.THEMES;
        }

        /**
         * Set active theme
         *
         * @param themeName
         */
        function setActiveTheme(themeName)
        {
            // If theme does not exist, fallback to the default theme
            if ( angular.isUndefined(service.themes.list[themeName]) )
            {
                // If there is no theme called "default"...
                if ( angular.isUndefined(service.themes.list.default) )
                {
                    $log.error('You must have at least one theme named "default"');
                    return;
                }

                $log.warn('The theme "' + themeName + '" does not exist! Falling back to the "default" theme.');

                // Otherwise set theme to default theme
                service.themes.active.name = 'default';
                service.themes.active.theme = service.themes.list.default;
                $cookies.put('selectedTheme', service.themes.active.name);

                return;
            }

            service.themes.active.name = themeName;
            service.themes.active.theme = service.themes.list[themeName];
            $cookies.put('selectedTheme', themeName);
        }

        /**
         * Set available themes list
         *
         * @param themeList
         */
        function setThemesList(themeList)
        {
            service.themes.list = themeList;
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .config(config);

    /** @ngInject */
    function config($mdThemingProvider, marvilixPalettes, marvilixThemes)
    {
        // Inject Cookies Service
        var $cookies;
        angular.injector(['ngCookies']).invoke([
            '$cookies', function (_$cookies)
            {
                $cookies = _$cookies;
            }
        ]);

        // Check if custom theme exist in cookies
        var customTheme = $cookies.getObject('customTheme');
        if ( customTheme )
        {
            marvilixThemes['custom'] = customTheme;
        }

        $mdThemingProvider.alwaysWatchTheme(true);

        // Define custom palettes
        angular.forEach(marvilixPalettes, function (palette)
        {
            $mdThemingProvider.definePalette(palette.name, palette.options);
        });

        // Register custom themes
        angular.forEach(marvilixThemes, function (theme, themeName)
        {
            $mdThemingProvider.theme(themeName)
                .primaryPalette(theme.primary.name, theme.primary.hues)
                .accentPalette(theme.accent.name, theme.accent.hues)
                .warnPalette(theme.warn.name, theme.warn.hues)
                .backgroundPalette(theme.background.name, theme.background.hues);
        });
    }

})();
(function ()
{
    'use strict';

    var marvilixThemes = {
        default  : {
            primary   : {
                name: 'marvilix-paleblue',
                hues: {
                    'default': '700',
                    'hue-1'  : '500',
                    'hue-2'  : '600',
                    'hue-3'  : '400'
                }
            },
            accent    : {
                name: 'light-blue',
                hues: {
                    'default': '600',
                    'hue-1'  : '400',
                    'hue-2'  : '700',
                    'hue-3'  : 'A100'
                }
            },
            warn      : {
                name: 'red'
            },
            background: {
                name: 'grey',
                hues: {
                    'default': 'A100',
                    'hue-1'  : 'A100',
                    'hue-2'  : '100',
                    'hue-3'  : '300'
                }
            }
        },
        'pinkTheme': {
            primary   : {
                name: 'blue-grey',
                hues: {
                    'default': '800',
                    'hue-1'  : '600',
                    'hue-2'  : '400',
                    'hue-3'  : 'A100'
                }
            },
            accent    : {
                name: 'pink',
                hues: {
                    'default': '400',
                    'hue-1'  : '300',
                    'hue-2'  : '600',
                    'hue-3'  : 'A100'
                }
            },
            warn      : {
                name: 'blue'
            },
            background: {
                name: 'grey',
                hues: {
                    'default': 'A100',
                    'hue-1'  : 'A100',
                    'hue-2'  : '100',
                    'hue-3'  : '300'
                }
            }
        },
        'tealTheme': {
            primary   : {
                name: 'marvilix-blue',
                hues: {
                    'default': '900',
                    'hue-1'  : '600',
                    'hue-2'  : '500',
                    'hue-3'  : 'A100'
                }
            },
            accent    : {
                name: 'teal',
                hues: {
                    'default': '500',
                    'hue-1'  : '400',
                    'hue-2'  : '600',
                    'hue-3'  : 'A100'
                }
            },
            warn      : {
                name: 'deep-orange'
            },
            background: {
                name: 'grey',
                hues: {
                    'default': 'A100',
                    'hue-1'  : 'A100',
                    'hue-2'  : '100',
                    'hue-3'  : '300'
                }
            }
        }
    };

    angular
        .module('app.core')
        .constant('marvilixThemes', marvilixThemes);
})();
(function () {
    'use strict';

    var marvilixPalettes = [
        {
            name: 'marvilix-blue',
            options: {
                '50': '#ebf1fa',
                '100': '#c2d4ef',
                '200': '#9ab8e5',
                '300': '#78a0dc',
                '400': '#5688d3',
                '500': '#3470ca',
                '600': '#2e62b1',
                '700': '#275498',
                '800': '#21467e',
                '900': '#1a3865',
                'A100': '#c2d4ef',
                'A200': '#9ab8e5',
                'A400': '#5688d3',
                'A700': '#275498',
                'contrastDefaultColor': 'light',
                'contrastDarkColors': '50 100 200 A100',
                'contrastStrongLightColors': '300 400'
            }
        },
        {
            name: 'marvilix-paleblue',
            options: {
                '50': '#ececee',
                '100': '#c5c6cb',
                '200': '#9ea1a9',
                '300': '#7d818c',
                '400': '#5c616f',
                '500': '#3c4252',
                '600': '#353a48',
                '700': '#2d323e',
                '800': '#262933',
                '900': '#1e2129',
                'A100': '#c5c6cb',
                'A200': '#9ea1a9',
                'A400': '#5c616f',
                'A700': '#2d323e',
                'contrastDefaultColor': 'light',
                'contrastDarkColors': '50 100 200 A100',
                'contrastStrongLightColors': '300 400'
            }
        }
    ];

    angular
        .module('app.core')
        .constant('marvilixPalettes', marvilixPalettes);
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('marvilixGenerator', marvilixGeneratorService);

    /** @ngInject */
    function marvilixGeneratorService($cookies, $log, marvilixTheming)
    {
        // Storage for simplified themes object
        var themes = {};

        var service = {
            generate: generate,
            rgba    : rgba
        };

        return service;

        //////////

        /**
         * Generate less variables for each theme from theme's
         * palette by using material color naming conventions
         */
        function generate()
        {
            // Get registered themes and palettes and copy
            // them so we don't modify the original objects
            var registeredThemes = angular.copy(marvilixTheming.getRegisteredThemes());
            var registeredPalettes = angular.copy(marvilixTheming.getRegisteredPalettes());

            // First, create a simplified object that stores
            // all registered themes and their colors

            // Iterate through registered themes
            angular.forEach(registeredThemes, function (registeredTheme)
            {
                themes[registeredTheme.name] = {};

                // Iterate through color types (primary, accent, warn & background)
                angular.forEach(registeredTheme.colors, function (colorType, colorTypeName)
                {
                    themes[registeredTheme.name][colorTypeName] = {
                        'name'  : colorType.name,
                        'levels': {
                            'default': {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues.default].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 4)
                            },
                            'hue1'   : {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 4)
                            },
                            'hue2'   : {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 4)
                            },
                            'hue3'   : {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 4)
                            }
                        }
                    };
                });
            });

            // Process themes one more time and then store them in the service for external use
            processAndStoreThemes(themes);

            // Iterate through simplified themes
            // object and create style variables
            var styleVars = {};

            // Iterate through registered themes
            angular.forEach(themes, function (theme, themeName)
            {
                styleVars = {};
                styleVars['@themeName'] = themeName;

                // Iterate through color types (primary, accent, warn & background)
                angular.forEach(theme, function (colorTypes, colorTypeName)
                {
                    // Iterate through color levels (default, hue1, hue2 & hue3)
                    angular.forEach(colorTypes.levels, function (colors, colorLevelName)
                    {
                        // Iterate through color name (color, contrast1, contrast2, contrast3 & contrast4)
                        angular.forEach(colors, function (color, colorName)
                        {
                            styleVars['@' + colorTypeName + ucfirst(colorLevelName) + ucfirst(colorName)] = color;
                        });
                    });
                });

                // Render styles
                render(styleVars);
            });
        }

        // ---------------------------
        //  INTERNAL HELPER FUNCTIONS
        // ---------------------------

        /**
         * Process and store themes for global use
         *
         * @param _themes
         */
        function processAndStoreThemes(_themes)
        {
            // Here we will go through every registered theme one more time
            // and try to simplify their objects as much as possible for
            // easier access to their properties.
            var themes = angular.copy(_themes);

            // Iterate through themes
            angular.forEach(themes, function (theme)
            {
                // Iterate through color types (primary, accent, warn & background)
                angular.forEach(theme, function (colorType, colorTypeName)
                {
                    theme[colorTypeName] = colorType.levels;
                    theme[colorTypeName].color = colorType.levels.default.color;
                    theme[colorTypeName].contrast1 = colorType.levels.default.contrast1;
                    theme[colorTypeName].contrast2 = colorType.levels.default.contrast2;
                    theme[colorTypeName].contrast3 = colorType.levels.default.contrast3;
                    theme[colorTypeName].contrast4 = colorType.levels.default.contrast4;
                    delete theme[colorTypeName].default;
                });
            });

            // Store themes and set selected theme for the first time
            marvilixTheming.setThemesList(themes);

            // Remember selected theme.
            var selectedTheme = $cookies.get('selectedTheme');

            if ( selectedTheme )
            {
                marvilixTheming.setActiveTheme(selectedTheme);
            }
            else
            {
                marvilixTheming.setActiveTheme('default');
            }
        }


        /**
         * Render css files
         *
         * @param styleVars
         */
        function render(styleVars)
        {
            var cssTemplate = '/* Content hack because they wont fix */\n/* https://github.com/angular/material/pull/8067 */\n[md-theme="@themeName"] md-content.md-hue-1,\nmd-content.md-@themeName-theme.md-hue-1 {\n    color: @backgroundHue1Contrast1;\n    background-color: @backgroundHue1Color;\n}\n\n[md-theme="@themeName"] md-content.md-hue-2,\nmd-content.md-@themeName-theme.md-hue-2 {\n    color: @backgroundHue2Contrast1;\n    background-color: @backgroundHue2Color;\n}\n\n[md-theme="@themeName"] md-content.md-hue-3,\n md-content.md-@themeName-theme.md-hue-3 {\n    color: @backgroundHue3Contrast1;\n    background-color: @backgroundHue3Color;\n}\n\n/* Text Colors */\n[md-theme="@themeName"] a {\n    color: @accentDefaultColor;\n}\n\n[md-theme="@themeName"] .secondary-text,\n[md-theme="@themeName"] .icon {\n    color: @backgroundDefaultContrast2;\n}\n\n[md-theme="@themeName"] .hint-text,\n[md-theme="@themeName"] .disabled-text {\n    color: @backgroundDefaultContrast3;\n}\n\n[md-theme="@themeName"] .fade-text,\n[md-theme="@themeName"] .divider {\n    color: @backgroundDefaultContrast4;\n}\n\n/* Primary */\n[md-theme="@themeName"] .md-primary-bg {\n    background-color: @primaryDefaultColor;\n    color: @primaryDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg .secondary-text,\n[md-theme="@themeName"] .md-primary-bg .icon {\n    color: @primaryDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-primary-bg .hint-text,\n[md-theme="@themeName"] .md-primary-bg .disabled-text {\n    color: @primaryDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg .fade-text,\n[md-theme="@themeName"] .md-primary-bg .divider {\n    color: @primaryDefaultContrast4;\n}\n\n/* Primary, Hue-1 */\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 {\n    background-color: @primaryHue1Color;\n    color: @primaryHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .icon {\n    color: @primaryHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .disabled-text {\n    color: @primaryHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .divider {\n    color: @primaryHue1Contrast4;\n}\n\n/* Primary, Hue-2 */\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 {\n    background-color: @primaryHue2Color;\n    color: @primaryHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .icon {\n    color: @primaryHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .disabled-text {\n    color: @primaryHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .divider {\n    color: @primaryHue2Contrast4;\n}\n\n/* Primary, Hue-3 */\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 {\n    background-color: @primaryHue3Color;\n    color: @primaryHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .icon {\n    color: @primaryHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .disabled-text {\n    color: @primaryHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .divider {\n    color: @primaryHue3Contrast4;\n}\n\n/* Primary foreground */\n[md-theme="@themeName"] .md-primary-fg {\n    color: @primaryDefaultColor !important;\n}\n\n/* Primary foreground, Hue-1 */\n[md-theme="@themeName"] .md-primary-fg.md-hue-1 {\n    color: @primaryHue1Color !important;\n}\n\n/* Primary foreground, Hue-2 */\n[md-theme="@themeName"] .md-primary-fg.md-hue-2 {\n    color: @primaryHue2Color !important;\n}\n\n/* Primary foreground, Hue-3 */\n[md-theme="@themeName"] .md-primary-fg.md-hue-3 {\n    color: @primaryHue3Color !important;\n}\n\n/* Accent */\n[md-theme="@themeName"] .md-accent-bg {\n    background-color: @accentDefaultColor;\n    color: @accentDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg .secondary-text,\n[md-theme="@themeName"] .md-accent-bg .icon {\n    color: @accentDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-accent-bg .hint-text,\n[md-theme="@themeName"] .md-accent-bg .disabled-text {\n    color: @accentDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg .fade-text,\n[md-theme="@themeName"] .md-accent-bg .divider {\n    color: @accentDefaultContrast4;\n}\n\n/* Accent, Hue-1 */\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 {\n    background-color: @accentHue1Color;\n    color: @accentHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .icon {\n    color: @accentHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .disabled-text {\n    color: @accentHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .divider {\n    color: @accentHue1Contrast4;\n}\n\n/* Accent, Hue-2 */\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 {\n    background-color: @accentHue2Color;\n    color: @accentHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .icon {\n    color: @accentHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .disabled-text {\n    color: @accentHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .divider {\n    color: @accentHue2Contrast4;\n}\n\n/* Accent, Hue-3 */\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 {\n    background-color: @accentHue3Color;\n    color: @accentHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .icon {\n    color: @accentHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .disabled-text {\n    color: @accentHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .divider {\n    color: @accentHue3Contrast4;\n}\n\n/* Accent foreground */\n[md-theme="@themeName"] .md-accent-fg {\n    color: @accentDefaultColor !important;\n}\n\n/* Accent foreground, Hue-1 */\n[md-theme="@themeName"] .md-accent-fg.md-hue-1 {\n    color: @accentHue1Color !important;\n}\n\n/* Accent foreground, Hue-2 */\n[md-theme="@themeName"] .md-accent-fg.md-hue-2 {\n    color: @accentHue2Color !important;\n}\n\n/* Accent foreground, Hue-3 */\n[md-theme="@themeName"] .md-accent-fg.md-hue-3 {\n    color: @accentHue3Color !important;\n}\n\n/* Warn */\n[md-theme="@themeName"] .md-warn-bg {\n    background-color: @warnDefaultColor;\n    color: @warnDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg .secondary-text,\n[md-theme="@themeName"] .md-warn-bg .icon {\n    color: @warnDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-warn-bg .hint-text,\n[md-theme="@themeName"] .md-warn-bg .disabled-text {\n    color: @warnDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg .fade-text,\n[md-theme="@themeName"] .md-warn-bg .divider {\n    color: @warnDefaultContrast4;\n}\n\n/* Warn, Hue-1 */\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 {\n    background-color: @warnHue1Color;\n    color: @warnHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .icon {\n    color: @warnHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .disabled-text {\n    color: @warnHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .divider {\n    color: @warnHue1Contrast4;\n}\n\n/* Warn, Hue-2 */\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 {\n    background-color: @warnHue2Color;\n    color: @warnHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .icon {\n    color: @warnHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .disabled-text {\n    color: @warnHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .divider {\n    color: @warnHue2Contrast4;\n}\n\n/* Warn, Hue-3 */\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 {\n    background-color: @warnHue3Color;\n    color: @warnHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .icon {\n    color: @warnHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .disabled-text {\n    color: @warnHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .divider {\n    color: @warnHue3Contrast4;\n}\n\n/* Warn foreground */\n[md-theme="@themeName"] .md-warn-fg {\n    color: @warnDefaultColor !important;\n}\n\n/* Warn foreground, Hue-1 */\n[md-theme="@themeName"] .md-warn-fg.md-hue-1 {\n    color: @warnHue1Color !important;\n}\n\n/* Warn foreground, Hue-2 */\n[md-theme="@themeName"] .md-warn-fg.md-hue-2 {\n    color: @warnHue2Color !important;\n}\n\n/* Warn foreground, Hue-3 */\n[md-theme="@themeName"] .md-warn-fg.md-hue-3 {\n    color: @warnHue3Color !important;\n}\n\n/* Background */\n[md-theme="@themeName"] .md-background-bg {\n    background-color: @backgroundDefaultColor;\n    color: @backgroundDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg .secondary-text,\n[md-theme="@themeName"] .md-background-bg .icon {\n    color: @backgroundDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-background-bg .hint-text,\n[md-theme="@themeName"] .md-background-bg .disabled-text {\n    color: @backgroundDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg .fade-text,\n[md-theme="@themeName"] .md-background-bg .divider {\n    color: @backgroundDefaultContrast4;\n}\n\n/* Background, Hue-1 */\n[md-theme="@themeName"] .md-background-bg.md-hue-1 {\n    background-color: @backgroundHue1Color;\n    color: @backgroundHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .icon {\n    color: @backgroundHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .disabled-text {\n    color: @backgroundHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .divider {\n    color: @backgroundHue1Contrast4;\n}\n\n/* Background, Hue-2 */\n[md-theme="@themeName"] .md-background-bg.md-hue-2 {\n    background-color: @backgroundHue2Color;\n    color: @backgroundHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .icon {\n    color: @backgroundHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .disabled-text {\n    color: @backgroundHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .divider {\n    color: @backgroundHue2Contrast4;\n}\n\n/* Background, Hue-3 */\n[md-theme="@themeName"] .md-background-bg.md-hue-3 {\n    background-color: @backgroundHue3Color;\n    color: @backgroundHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .icon {\n    color: @backgroundHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .disabled-text {\n    color: @backgroundHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .divider {\n    color: @backgroundHue3Contrast4;\n}\n\n/* Background foreground */\n[md-theme="@themeName"] .md-background-fg {\n    color: @backgroundDefaultColor !important;\n}\n\n/* Background foreground, Hue-1 */\n[md-theme="@themeName"] .md-background-fg.md-hue-1 {\n    color: @backgroundHue1Color !important;\n}\n\n/* Background foreground, Hue-2 */\n[md-theme="@themeName"] .md-background-fg.md-hue-2 {\n    color: @backgroundHue2Color !important;\n}\n\n/* Background foreground, Hue-3 */\n[md-theme="@themeName"] .md-background-fg.md-hue-3 {\n    color: @backgroundHue3Color !important;\n}';

            var regex = new RegExp(Object.keys(styleVars).join('|'), 'gi');
            var css = cssTemplate.replace(regex, function (matched)
            {
                return styleVars[matched];
            });

            var headEl = angular.element('head');
            var styleEl = angular.element('<style type="text/css"></style>');
            styleEl.html(css);
            headEl.append(styleEl);
        }

        /**
         * Convert color array to rgb/rgba
         * Also apply contrasts if needed
         *
         * @param color
         * @param _contrastLevel
         * @returns {string}
         */
        function rgba(color, _contrastLevel)
        {
            var contrastLevel = _contrastLevel || false;

            // Convert 255,255,255,0.XX to 255,255,255
            // According to Google's Material design specs, white primary
            // text must have opacity of 1 and we will fix that here
            // because Angular Material doesn't care about that spec
            if ( color.length === 4 && color[0] === 255 && color[1] === 255 && color[2] === 255 )
            {
                color.splice(3, 4);
            }

            // If contrast level provided, apply it to the current color
            if ( contrastLevel )
            {
                color = applyContrast(color, contrastLevel);
            }

            // Convert color array to color string (rgb/rgba)
            if ( color.length === 3 )
            {
                return 'rgb(' + color.join(',') + ')';
            }
            else if ( color.length === 4 )
            {
                return 'rgba(' + color.join(',') + ')';
            }
            else
            {
                $log.error('Invalid number of arguments supplied in the color array: ' + color.length + '\n' + 'The array must have 3 or 4 colors.');
            }
        }

        /**
         * Apply given contrast level to the given color
         *
         * @param color
         * @param contrastLevel
         */
        function applyContrast(color, contrastLevel)
        {
            var contrastLevels = {
                'white': {
                    '1': '1',
                    '2': '0.7',
                    '3': '0.3',
                    '4': '0.12'
                },
                'black': {
                    '1': '0.87',
                    '2': '0.54',
                    '3': '0.26',
                    '4': '0.12'
                }
            };

            // If white
            if ( color[0] === 255 && color[1] === 255 && color[2] === 255 )
            {
                color[3] = contrastLevels.white[contrastLevel];
            }
            // If black
            else if ( color[0] === 0 && color[1] === 0 && color[2] === 0 )
            {
                color[3] = contrastLevels.black[contrastLevel];
            }

            return color;
        }

        /**
         * Uppercase first
         */
        function ucfirst(string)
        {
            return string.charAt(0).toUpperCase() + string.slice(1);
        }
    }

})();
(function ()
{
    'use strict';
    angular.module('app.core').service('ValidToken', ValidToken);

    /** @ngInject */
    function ValidToken($cookies,$rootScope,adminEndpoint,$location,settingsEndpoint)
    {
        this.validUserToken = function () {
            if ($rootScope.User)
                return this;
            var accessToken = $cookies.get("marvilixAccessToken");
            var params = {};
            params.accessToken = accessToken;
            if (accessToken) {
                adminEndpoint.validToken.post(params,function (data) {
                    if (data.ID) {
                        $rootScope.User = data;
                        setAdminLevel();
                        getImages();
                    }
                    else
                        $location.path('/');
                    return this;
                })
            }
            else {
                $location.path('/');
                return this;
            }

        };

        var setAdminLevel = function () {
            if ($rootScope.User.StudentID)
                $rootScope.AdminLevel =1;
            else if ($rootScope.User.IsCoordinator)
                $rootScope.AdminLevel =2;
            else
                $rootScope.AdminLevel =3;
        };

        var getImages = function () {
            settingsEndpoint.admin.images.get(function (data) {
                for (var i=0;i<data.length;i++) {
                    if (data[i]['Property']==="AdminFavicon") {
                        if (data[i]['Value'] && data[i]['Value']!=='')
                            $rootScope.favicon = data[i]['Value'];
                    }
                }

            })

        }
    }
})();


(function ()
{
    'use strict';
    angular.module('app.core').service('receiptsService', receiptsService);

    /** @ngInject */
    function receiptsService($rootScope,$http,$filter,appConfig,$location) {

        var service = this;
        var debug = false;

        service.getReceiptByID = getReceiptByID;

        function getReceiptByID(receiptID,type,callback,send,external) {
            var parameters = {};
            if (send)
                parameters.reSend = 1;
            parameters.adminID = $rootScope.User.ID;
            parameters.Type= type;
            var receiptText = "receipts";
            if (external)
                receiptText= "external-receipts";
            var url = '';
            if (location.hostname === "localhost" || location.hostname === "127.0.0.1") {
                url =appConfig.localHostUrl+'/'+receiptText+'/'+receiptID+'?brand='+$rootScope.brandName;
                debug = true;
            }
            else if (location.host === appConfig.locationHost)
                url = appConfig.developmentHostUrl+'/'+receiptText+'/'+receiptID+'?brand='+$rootScope.brandName;
            else
                url = appConfig.serverUrl+'/'+receiptText+'/'+receiptID+'?brand='+$rootScope.brandName;
            if(debug)
                url = url + "&XDEBUG_SESSION_START";
            $http({
                method: 'POST',
                url: url,
                params: parameters,
                responseType: 'arraybuffer',
                headers: {
                    Authorization: 'Bearer ' + $rootScope.User.AccessToken
                }
            }).success(function(data) {
                if (!send) {
                    var blob = new Blob([data], {type: "application/pdf"});
                    if (blob.size<100) {
                        $location.path('/');
                        return;
                    }
                    var downloadUrl = URL.createObjectURL(blob);
                    var a = document.createElement("a");
                    a.href = downloadUrl;
                    var date = $filter('date')( new Date(), "dd/MM/yyyy@HH:mm", "UTC+2");
                    a.download = 'receipt' + receiptID + ' - ' + date + '.pdf';
                    document.body.appendChild(a);
                    a.click();
                }

                if(angular.isFunction(callback)) callback(true);
            });
        }
    }
})();


(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('msUtils', msUtils);

    /** @ngInject */
    function msUtils($window)
    {
        // Private variables
        var mobileDetect = new MobileDetect($window.navigator.userAgent),
            browserInfo = null;

        var service = {
            exists       : exists,
            detectBrowser: detectBrowser,
            guidGenerator: guidGenerator,
            isMobile     : isMobile,
            toggleInArray: toggleInArray
        };

        return service;

        //////////

        /**
         * Check if item exists in a list
         *
         * @param item
         * @param list
         * @returns {boolean}
         */
        function exists(item, list)
        {
            return list.indexOf(item) > -1;
        }

        /**
         * Returns browser information
         * from user agent data
         *
         * Found at http://www.quirksmode.org/js/detect.html
         * but modified and updated to fit for our needs
         */
        function detectBrowser()
        {
            // If we already tested, do not test again
            if ( browserInfo )
            {
                return browserInfo;
            }

            var browserData = [
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'Edge',
                    versionSearch: 'Edge',
                    identity     : 'Edge'
                },
                {
                    string   : $window.navigator.userAgent,
                    subString: 'Chrome',
                    identity : 'Chrome'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'OmniWeb',
                    versionSearch: 'OmniWeb/',
                    identity     : 'OmniWeb'
                },
                {
                    string       : $window.navigator.vendor,
                    subString    : 'Apple',
                    versionSearch: 'Version',
                    identity     : 'Safari'
                },
                {
                    prop    : $window.opera,
                    identity: 'Opera'
                },
                {
                    string   : $window.navigator.vendor,
                    subString: 'iCab',
                    identity : 'iCab'
                },
                {
                    string   : $window.navigator.vendor,
                    subString: 'KDE',
                    identity : 'Konqueror'
                },
                {
                    string   : $window.navigator.userAgent,
                    subString: 'Firefox',
                    identity : 'Firefox'
                },
                {
                    string   : $window.navigator.vendor,
                    subString: 'Camino',
                    identity : 'Camino'
                },
                {
                    string   : $window.navigator.userAgent,
                    subString: 'Netscape',
                    identity : 'Netscape'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'MSIE',
                    identity     : 'Explorer',
                    versionSearch: 'MSIE'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'Trident/7',
                    identity     : 'Explorer',
                    versionSearch: 'rv'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'Gecko',
                    identity     : 'Mozilla',
                    versionSearch: 'rv'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'Mozilla',
                    identity     : 'Netscape',
                    versionSearch: 'Mozilla'
                }
            ];

            var osData = [
                {
                    string   : $window.navigator.platform,
                    subString: 'Win',
                    identity : 'Windows'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'Mac',
                    identity : 'Mac'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'Linux',
                    identity : 'Linux'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'iPhone',
                    identity : 'iPhone'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'iPod',
                    identity : 'iPod'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'iPad',
                    identity : 'iPad'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'Android',
                    identity : 'Android'
                }
            ];

            var versionSearchString = '';

            function searchString(data)
            {
                for ( var i = 0; i < data.length; i++ )
                {
                    var dataString = data[i].string;
                    var dataProp = data[i].prop;

                    versionSearchString = data[i].versionSearch || data[i].identity;

                    if ( dataString )
                    {
                        if ( dataString.indexOf(data[i].subString) !== -1 )
                        {
                            return data[i].identity;

                        }
                    }
                    else if ( dataProp )
                    {
                        return data[i].identity;
                    }
                }
            }

            function searchVersion(dataString)
            {
                var index = dataString.indexOf(versionSearchString);

                if ( index === -1 )
                {
                    return;
                }

                return parseInt(dataString.substring(index + versionSearchString.length + 1));
            }

            var browser = searchString(browserData) || 'unknown-browser';
            var version = searchVersion($window.navigator.userAgent) || searchVersion($window.navigator.appVersion) || 'unknown-version';
            var os = searchString(osData) || 'unknown-os';

            // Prepare and store the object
            browser = browser.toLowerCase();
            version = browser + '-' + version;
            os = os.toLowerCase();

            browserInfo = {
                browser: browser,
                version: version,
                os     : os
            };

            return browserInfo;
        }

        /**
         * Generates a globally unique id
         *
         * @returns {*}
         */
        function guidGenerator()
        {
            var S4 = function ()
            {
                return (((1 + Math.random()) * 0x10000) || 0).toString(16).substring(1);
            };
            return (S4() + S4() + S4() + S4() + S4() + S4());
        }

        /**
         * Return if current device is a
         * mobile device or not
         */
        function isMobile()
        {
            return mobileDetect.mobile();
        }

        /**
         * Toggle in array (push or splice)
         *
         * @param item
         * @param array
         */
        function toggleInArray(item, array)
        {
            if ( array.indexOf(item) === -1 )
            {
                array.push(item);
            }
            else
            {
                array.splice(array.indexOf(item), 1);
            }
        }
    }
}());
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msApi', msApiProvider);

    /** @ngInject **/
    function msApiProvider()
    {
        /* ----------------- */
        /* Provider          */
        /* ----------------- */
        var provider = this;

        // Inject the $log service
        var $log = angular.injector(['ng']).get('$log');

        // Data
        var baseUrl = '';
        var api = [];

        // Methods
        provider.setBaseUrl = setBaseUrl;
        provider.getBaseUrl = getBaseUrl;
        provider.getApiObject = getApiObject;
        provider.register = register;

        //////////

        /**
         * Set base url for API endpoints
         *
         * @param url {string}
         */
        function setBaseUrl(url)
        {
            baseUrl = url;
        }

        /**
         * Return the base url
         *
         * @returns {string}
         */
        function getBaseUrl()
        {
            return baseUrl;
        }

        /**
         * Return the api object
         *
         * @returns {object}
         */
        function getApiObject()
        {
            return api;
        }

        /**
         * Register API endpoint
         *
         * @param key
         * @param resource
         */
        function register(key, resource)
        {
            if ( !angular.isString(key) )
            {
                $log.error('"path" must be a string (eg. `dashboard.project`)');
                return;
            }

            if ( !angular.isArray(resource) )
            {
                $log.error('"resource" must be an array and it must follow $resource definition');
                return;
            }

            // Store the API object
            api[key] = {
                url          : baseUrl + (resource[0] || ''),
                paramDefaults: resource[1] || [],
                actions      : resource[2] || [],
                options      : resource[3] || {}
            };
        }

        /* ----------------- */
        /* Service           */
        /* ----------------- */
        this.$get = function ($log, $q, $resource, $rootScope)
        {
            // Data

            // Methods
            var service = {
                setBaseUrl: setBaseUrl,
                getBaseUrl: getBaseUrl,
                register  : register,
                resolve   : resolve,
                request   : request
            };

            return service;

            //////////

            /**
             * Resolve an API endpoint
             *
             * @param action {string}
             * @param parameters {object}
             * @returns {promise|boolean}
             */
            function resolve(action, parameters)
            {
                // Emit an event
                $rootScope.$broadcast('msApi::resolveStart');
                
                var actionParts = action.split('@'),
                    resource = actionParts[0],
                    method = actionParts[1],
                    params = parameters || {};

                if ( !resource || !method )
                {
                    $log.error('msApi.resolve requires correct action parameter (resourceName@methodName)');
                    return false;
                }

                // Create a new deferred object
                var deferred = $q.defer();

                // Get the correct resource definition from api object
                var apiObject = api[resource];

                if ( !apiObject )
                {
                    $log.error('Resource "' + resource + '" is not defined in the api service!');
                    deferred.reject('Resource "' + resource + '" is not defined in the api service!');
                }
                else
                {
                    // Generate the $resource object based on the stored API object
                    var resourceObject = $resource(apiObject.url, apiObject.paramDefaults, apiObject.actions, apiObject.options);

                    // Make the call...
                    resourceObject[method](params,

                        // Success
                        function (response)
                        {
                            deferred.resolve(response);

                            // Emit an event
                            $rootScope.$broadcast('msApi::resolveSuccess');
                        },

                        // Error
                        function (response)
                        {
                            deferred.reject(response);

                            // Emit an event
                            $rootScope.$broadcast('msApi::resolveError');
                        }
                    );
                }

                // Return the promise
                return deferred.promise;
            }

            /**
             * Make a request to an API endpoint
             *
             * @param action {string}
             * @param [parameters] {object}
             * @param [success] {function}
             * @param [error] {function}
             *
             * @returns {promise|boolean}
             */
            function request(action, parameters, success, error)
            {
                // Emit an event
                $rootScope.$broadcast('msApi::requestStart');
                
                var actionParts = action.split('@'),
                    resource = actionParts[0],
                    method = actionParts[1],
                    params = parameters || {};

                if ( !resource || !method )
                {
                    $log.error('msApi.resolve requires correct action parameter (resourceName@methodName)');
                    return false;
                }

                // Create a new deferred object
                var deferred = $q.defer();

                // Get the correct resource definition from api object
                var apiObject = api[resource];

                if ( !apiObject )
                {
                    $log.error('Resource "' + resource + '" is not defined in the api service!');
                    deferred.reject('Resource "' + resource + '" is not defined in the api service!');
                }
                else
                {
                    // Generate the $resource object based on the stored API object
                    var resourceObject = $resource(apiObject.url, apiObject.paramDefaults, apiObject.actions, apiObject.options);

                    // Make the call...
                    resourceObject[method](params,

                        // SUCCESS
                        function (response)
                        {
                            // Emit an event
                            $rootScope.$broadcast('msApi::requestSuccess');
                            
                            // Resolve the promise
                            deferred.resolve(response);

                            // Call the success function if there is one
                            if ( angular.isDefined(success) && angular.isFunction(success) )
                            {
                                success(response);
                            }
                        },

                        // ERROR
                        function (response)
                        {
                            // Emit an event
                            $rootScope.$broadcast('msApi::requestError');
                            
                            // Reject the promise
                            deferred.reject(response);

                            // Call the error function if there is one
                            if ( angular.isDefined(error) && angular.isFunction(error) )
                            {
                                error(response);
                            }
                        }
                    );
                }

                // Return the promise
                return deferred.promise;
            }
        };
    }
})();
/**
 * Created by marvilix-liran on 21/11/2016.
 */

angular.module('app.core').service('HttpSender', function ($http, $httpParamSerializerJQLike, $filter) {

    this.send = function (path, method, params, isExcel,accessToken) {

        if(params) params = $httpParamSerializerJQLike(params);

        if (params && method === "GET") {
            path = path+'&'+params;
        }

        var headers = {};
        if(accessToken)
            headers.Authorization = 'Bearer ' + accessToken;
        switch (method) {
            case 'GET':
                if (isExcel)
                    return $http({
                        method: 'GET',
                        url: path,
                        responseType: "arraybuffer",
                        headers: headers
                    }).success(function (data) {
                        var blob = new Blob([data], {type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"});
                        var downloadUrl = URL.createObjectURL(blob);
                        var a = document.createElement("a");
                        a.href = downloadUrl;
                        var date = $filter('date')(new Date(), "dd/MM/yyyy @ HH:mm");
                        a.download = 'דוח' + ' - ' + date + '.xlsx';
                        document.body.appendChild(a);
                        a.click();
                    });
                else
                    return $http.get(path, {
                        withCredentials: true,
                        headers: headers
                    }).then(successCallback, errorCallback);
            case 'POST':
                headers['Content-Type'] = 'application/x-www-form-urlencoded';
                return $http.post(path, params, {
                    headers: headers,
                    withCredentials: true
                }).then(successCallback, errorCallback);
        }
    };

    var successCallback = function (response) {
        if ((response.data))
            return response.data;
    };

    var errorCallback = function (response) {
        if (response.data)
            return null;
    };


});

(function ()
{
    'use strict';
    angular.module('app.core').service('dtOptions', dtOptions);

    /** @ngInject */
    function dtOptions()
    {

        this.language = {
            "processing":   "מעבד...",
            "lengthMenu":   "הצג _MENU_ פריטים",
            "zeroRecords":  "לא נמצאו רשומות מתאימות",
            "emptyTable":   "לא נמצאו רשומות מתאימות",
            "info": "_START_ עד _END_ מתוך _TOTAL_ רשומות" ,
            "infoEmpty":    "0 עד 0 מתוך 0 רשומות",
            "infoFiltered": "(מסונן מסך _MAX_  רשומות)",
            "infoPostFix":  "",
            "search":       "חפש:",
            "url":          "",
            "paginate": {
                "first":    "ראשון",
                "previous": "קודם",
                "next":     "הבא",
                "last":     "אחרון"
            }
        };

        return this
    }
})();


/**
 * Created by marvilix-liran on 21/11/2016.
 */

angular.module('app.core').factory('dateHandler', function() {

    return {
        convertToString: function (date) {
            var dateObj = new Date(date);
            var year = dateObj.getFullYear();
            var month = dateObj.getMonth() + 1;
            var day = dateObj.getDate();
            var dateString = day + '/' + month + '/' + year;
            return dateString;
        },
        convertToDate: function (date) {
            date = date.replace(/-0+/g, '-');
            var splitDate = date.split('/');
            var newDate = splitDate[1] + '-' + splitDate[0] + '-' + splitDate[2];
            newDate = new Date(newDate);
            return newDate
        },
        convertToTimeStamp: function (data) {
            var datum = Date.parse(data);
            return datum/1000;

        },
        convertToSQLDate: function (dateObj) {
            var year = dateObj.getFullYear();
            var month = dateObj.getMonth() + 1;
            if(month.toString().length===1) month = '0'+month;
            var day = dateObj.getDate();
            if(day.toString().length===1) day = '0'+day;
            return year + '-' + month + '-' + day;
        }
    }

});
/**
 * Filters out all duplicate items from an array by checking the specified key
 * @param [key] {string} the name of the attribute of each object to compare for uniqueness
 if the key is empty, the entire object will be compared
 if the key === false then no filtering will be performed
 * @return {array}
 */
app.filter('unique', function () {

    return function (items, filterOn) {

        if (filterOn === false) {
            return items;
        }

        if ((filterOn || angular.isUndefined(filterOn)) && angular.isArray(items)) {
            var hashCheck = {}, newItems = [];

            var extractValueToCompare = function (item) {
                if (angular.isObject(item) && angular.isString(filterOn)) {
                    return item[filterOn];
                } else {
                    return item;
                }
            };

            angular.forEach(items, function (item) {
                var valueToCheck, isDuplicate = false;

                for (var i = 0; i < newItems.length; i++) {
                    if (angular.equals(extractValueToCompare(newItems[i]), extractValueToCompare(item))) {
                        isDuplicate = true;
                        break;
                    }
                }
                if (!isDuplicate) {
                    newItems.push(item);
                }

            });
            items = newItems;
        }
        return items;
    };
});

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('filterByTags', filterByTags)
        .filter('filterSingleByTags', filterSingleByTags);

    /** @ngInject */
    function filterByTags()
    {
        return function (items, tags)
        {
            if ( items.length === 0 || tags.length === 0 )
            {
                return items;
            }

            var filtered = [];

            items.forEach(function (item)
            {
                var match = tags.every(function (tag)
                {
                    var tagExists = false;

                    item.tags.forEach(function (itemTag)
                    {
                        if ( itemTag.name === tag.name )
                        {
                            tagExists = true;
                            return;
                        }
                    });

                    return tagExists;
                });

                if ( match )
                {
                    filtered.push(item);
                }
            });

            return filtered;
        };
    }

    /** @ngInject */
    function filterSingleByTags()
    {
        return function (itemTags, tags)
        {
            if ( itemTags.length === 0 || tags.length === 0 )
            {
                return;
            }

            if ( itemTags.length < tags.length )
            {
                return [];
            }

            var filtered = [];

            var match = tags.every(function (tag)
            {
                var tagExists = false;

                itemTags.forEach(function (itemTag)
                {
                    if ( itemTag.name === tag.name )
                    {
                        tagExists = true;
                        return;
                    }
                });

                return tagExists;
            });

            if ( match )
            {
                filtered.push(itemTags);
            }

            return filtered;
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('filterByPropIds', filterByPropIds);

    /** @ngInject */
    function filterByPropIds()
    {
        return function (items, parameter, ids)
        {
            if ( items.length === 0 || !ids || ids.length === 0 )
            {
                return items;
            }

            var filtered = [];

            for ( var i = 0; i < items.length; i++ )
            {
                var item = items[i];
                var match = false;

                for ( var j = 0; j < ids.length; j++ )
                {
                    var id = ids[j];
                    if ( item[parameter].indexOf(id) > -1 )
                    {
                        match = true;
                        break;
                    }
                }

                if ( match )
                {
                    filtered.push(item);
                }

            }

            return filtered;

        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('filterByIds', filterByIds);

    /** @ngInject */
    function filterByIds()
    {
        return function (items, ids)
        {

            if ( items.length === 0 || !ids )
            {
                return items;
            }

            if ( ids.length === 0 )
            {
                return [];
            }

            var filtered = [];

            for ( var i = 0; i < items.length; i++ )
            {
                var item = items[i];
                var match = false;

                for ( var j = 0; j < ids.length; j++ )
                {
                    var id = ids[j];
                    if ( item.id === id )
                    {
                        match = true;
                        break;
                    }
                }

                if ( match )
                {
                    filtered.push(item);
                }

            }

            return filtered;

        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('cmdate', filterByIds);

    /** @ngInject */
    function filterByIds($filter)
    {
        return function (input,format) {
            input= input*1000;
            var date = $filter('date')(new Date(input), format);
            return date;

        }
    }




})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('toTrusted', toTrustedFilter)
        .filter('htmlToPlaintext', htmlToPlainTextFilter)
        .filter('nospace', nospaceFilter)
        .filter('humanizeDoc', humanizeDocFilter)
        .filter('paymentStatus', paymentStatus)
        .filter('registrationSource', registrationSource);


    /** @ngInject */
    function toTrustedFilter($sce)
    {
        return function (value)
        {
            return $sce.trustAsHtml(value);
        };
    }

    /** @ngInject */
    function paymentStatus()
    {
        return function (value)
        {
            switch (value) {
                case 1:
                case '1':
                    return 'שולם';
                case 2:
                case '2':
                    return 'שולם לרכז';
                case 3:
                case '3':
                    return 'טרם אושר';
                default:
                    return 'לא שולם';

            }
        };
    }

    /** @ngInject */
    function registrationSource()
    {
        return function (value)
        {
            switch (value) {
                case 1:
                case '1':
                    return 'פרופיל הורה';
                case 2:
                case '2':
                    return 'מערכת ניהול';
                case 3:
                case '3':
                    return 'הרשמה חיצונית';
                default:
                    return 'לא ידוע';

            }
        };
    }

    /** @ngInject */
    function htmlToPlainTextFilter()
    {
        return function (text)
        {
            return String(text).replace(/<[^>]+>/gm, '');
        };
    }

    /** @ngInject */
    function nospaceFilter()
    {
        return function (value)
        {
            return (!value) ? '' : value.replace(/ /g, '');
        };
    }

    /** @ngInject */
    function humanizeDocFilter()
    {
        return function (doc)
        {
            if ( !doc )
            {
                return;
            }
            if ( doc.type === 'directive' )
            {
                return doc.name.replace(/([A-Z])/g, function ($1)
                {
                    return '-' + $1.toLowerCase();
                });
            }
            return doc.label || doc.name;
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('altDate', altDate);

    /** @ngInject */
    function altDate()
    {
        return function (value)
        {
            var diff = Date.now() - new Date(value);

            /**
             * If in a hour
             * e.g. "2 minutes ago"
             */
            if ( diff < (60 * 60 * 1000) )
            {
                return moment(value).fromNow();
            }
            /*
             * If in the day
             * e.g. "11:23"
             */
            else if ( diff < (60 * 60 * 24 * 1000) )
            {
                return moment(value).format('HH:mm');
            }
            /*
             * If in week
             * e.g "Tuesday"
             */
            else if ( diff < (60 * 60 * 24 * 7 * 1000) )
            {
                return moment(value).format('dddd');
            }
            /*
             * If more than a week
             * e.g. 03/29/2016
             */
            else
            {
                return moment(value).calendar();
            }

        };
    }

})();
(function () {
    'use strict';

    angular
        .module('app.core')
        .directive('hljs', hljsDirective);

    /** @ngInject */
    function hljsDirective($timeout, $q, $interpolate) {
        return {
            restrict: 'E',
            compile : function (element, attr) {
                var code;
                //No attribute? code is the content
                if (!attr.code) {
                    code = element.html();
                    element.empty();
                }

                return function (scope, element, attr) {

                    if (attr.code) {
                        // Attribute? code is the evaluation
                        code = scope.$eval(attr.code);
                    }
                    var shouldInterpolate = scope.$eval(attr.shouldInterpolate);

                    $q.when(code).then(function (code) {
                        if (code) {
                            if (shouldInterpolate) {
                                code = $interpolate(code)(scope);
                            }
                            var contentParent = angular.element(
                                '<pre><code class="highlight" ng-non-bindable></code></pre>'
                            );
                            element.append(contentParent);
                            // Defer highlighting 1-frame to prevent GA interference...
                            $timeout(function () {
                                render(code, contentParent);
                            }, 34, false);
                        }
                    });

                    function render(contents, parent) {

                        var codeElement = parent.find('code');
                        var lines = contents.split('\n');

                        // Remove empty lines
                        lines = lines.filter(function (line) {
                            return line.trim().length;
                        });

                        // Make it so each line starts at 0 whitespace
                        var firstLineWhitespace = lines[0].match(/^\s*/)[0];
                        var startingWhitespaceRegex = new RegExp('^' + firstLineWhitespace);
                        lines = lines.map(function (line) {
                            return line
                                .replace(startingWhitespaceRegex, '')
                                .replace(/\s+$/, '');
                        });

                        var highlightedCode = hljs.highlight(attr.language || attr.lang, lines.join('\n'), true);
                        highlightedCode.value = highlightedCode.value
                            .replace(/=<span class="hljs-value">""<\/span>/gi, '')
                            .replace('<head>', '')
                            .replace('<head/>', '');
                        codeElement.append(highlightedCode.value).addClass('highlight');
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('marvilixConfig', marvilixConfigProvider);

    /** @ngInject */
    function marvilixConfigProvider()
    {
        // Default configuration
        var marvilixConfiguration = {
            'disableCustomScrollbars'        : false,
            'disableMdInkRippleOnMobile'     : true,
            'disableCustomScrollbarsOnMobile': true
        };

        // Methods
        this.config = config;

        //////////

        /**
         * Extend default configuration with the given one
         *
         * @param configuration
         */
        function config(configuration)
        {
            marvilixConfiguration = angular.extend({}, marvilixConfiguration, configuration);
        }

        /**
         * Service
         */
        this.$get = function ()
        {
            var service = {
                getConfig: getConfig,
                setConfig: setConfig
            };

            return service;

            //////////

            /**
             * Returns a config value
             */
            function getConfig(configName)
            {
                if ( angular.isUndefined(marvilixConfiguration[configName]) )
                {
                    return false;
                }

                return marvilixConfiguration[configName];
            }

            /**
             * Creates or updates config object
             *
             * @param configName
             * @param configValue
             */
            function setConfig(configName, configValue)
            {
                marvilixConfiguration[configName] = configValue;
            }
        };
    }

})();
angular.module('app.core').service('appConfig', function ($rootScope) {
    'use strict';

    this.setOz = function () {
        $rootScope.appName = 'תנועת הנוער עוז';
        $rootScope.brandName = 'oz';
        $rootScope.favicon = 'oz-favicon.ico';
        this.appName = 'מערכת ניהול תנועת הנוער עוז';
        this.locationHost = 'admin-dev.oz-reg.com';
        this.localHostUrl = 'http://youth-movements.local';
        this.serverUrl = 'https://youth-movements-api1.marvilix.com';
        this.developmentHostUrl = 'http://youth-movements-api1.marvilix.com';
        this.profileTokenName = 'ozProfileAccessToken';
        this.profilePathCokieName = 'ozProfilePath';
        this.adminTokenName = 'ozAdminToken';
        this.developmentProfilePath = 'http://dev.oz-reg.com/';
        this.prodctionProfilePath = 'https://oz-reg.com/';
        this.appDomain = 'oz-reg.com';
        this.backRoundImage = '/assets/images/login/oz.jpg';
        this.logo = '/assets/images/logos/oz.png';
        this.paymentyCompany = 1;
        this.externalEventsEnabled = false;
        $rootScope.yearType = 1;
        $rootScope.genderType = 2;
        $rootScope.ExternalDiscountEnabled = false;
    };
    this.setIhudnik = function () {
        $rootScope.appName = 'האיחוד החקלאי';
        $rootScope.brandName = 'ihudnik';
        $rootScope.favicon = 'ihudnik-favicon.ico';
        this.appName = 'מערכת ניהול האיחוד החקלאי';
        this.locationHost = 'admin-dev.ihudnik-reg.com';
        this.localHostUrl = 'http://youth-movements.local';
        this.serverUrl = 'https://youth-movements-api2.marvilix.com';
        this.developmentHostUrl = 'http://youth-movements-api-dev.marvilix.com';
        this.profileTokenName = 'ihudnikProfileAccessToken';
        this.profilePathCokieName = 'ihudnikProfilePath';
        this.adminTokenName = 'ihudnikAdminToken';
        this.developmentProfilePath = 'http://dev.ihudnik-reg.com/';
        this.prodctionProfilePath = 'https://ihudnik-reg.com/';
        this.appDomain = 'ihudnik-reg.com';
        this.backRoundImage = '/assets/images/login/ihudnik.jpg';
        this.logo = '/assets/images/logos/ihudnik.png';
        this.paymentyCompany = 2;
        this.externalEventsEnabled = false;
        $rootScope.yearType = 1;
        $rootScope.genderType = 1;
        $rootScope.ExternalDiscountEnabled = false;
    };
    this.setTnuaHadasha = function () {
        $rootScope.appName = 'התנועה החדשה';
        $rootScope.brandName = 'hatnuaHahadasha';
        $rootScope.favicon = 'hashomer.ico';
        this.appName = 'מערכת ניהול התנועה החדשה';
        this.locationHost = 'admin-dev.hatnua-hahadasha.com';
        this.localHostUrl = 'http://youth-movements.local';
        this.serverUrl = 'https://youth-movements-api2.marvilix.com';
        this.developmentHostUrl = 'http://youth-movements-api2.marvilix.com';
        this.profileTokenName = 'hatnuaHahadashaProfileAccessToken';
        this.profilePathCokieName = 'hatnuaHahadashaProfilePath';
        this.adminTokenName = 'hatnuaHahadashaAdminToken';
        this.developmentProfilePath = 'http://dev.hatnua-hahadasha.com/';
        this.prodctionProfilePath = 'https://hatnua-hahadasha.com/';
        this.appDomain = 'hatnua-hahadasha.com';
        this.backRoundImage = '/assets/images/login/hatnuaHahadasha.jpg';
        this.logo = '/assets/images/logos/hatnuaHahadasha.png';
        this.paymentyCompany = 1;
        this.externalEventsEnabled = true;
        $rootScope.yearType = 1;
        $rootScope.genderType = 1;
        $rootScope.ExternalDiscountEnabled = false;
    };
    this.setTeva = function () {
        $rootScope.appName = 'החברה להגנת הטבע';
        $rootScope.brandName = 'teva';
        $rootScope.favicon = 'teva.ico';
        this.appName = 'מערכת ניהול החברה להגנת הטבע';
        this.locationHost = '';
        this.localHostUrl = 'http://youth-movements.local';
        this.serverUrl = 'https://youth-movements-api2.marvilix.com';
        this.developmentHostUrl = 'http://youth-movements-api2.marvilix.com';
        // this.developmentHostUrl = 'http://youth-movements-api-dev.marvilix.com';
        // this.serverUrl = 'https://youth-movements-api.marvilix.com';
        this.profileTokenName = 'tevaProfileAccessToken';
        this.profilePathCokieName = 'tevaProfilePath';
        this.adminTokenName = 'tevaAdminToken';
        this.developmentProfilePath = '';
        this.prodctionProfilePath = 'https://sayarut.teva.org.il/';
        this.appDomain = 'teva.org.il';
        this.backRoundImage = '/assets/images/login/teva.jpg';
        this.logo = '/assets/images/logos/teva.png';
        this.paymentyCompany = 2;
        this.externalEventsEnabled = false;
        $rootScope.yearType = 1;
        $rootScope.genderType = 1;
        $rootScope.ExternalDiscountEnabled = true;
    };
    this.setAriel = function () {
        $rootScope.appName = 'תנועת הנוער אריאל';
        $rootScope.brandName = 'ariel';
        $rootScope.favicon = 'ariel.ico';
        this.appName = 'מערכת ניהול תנועת הנוער אריאל';
        this.locationHost = 'admin-dev.tariel.co.il';
        this.localHostUrl = 'http://youth-movements.local';
        this.serverUrl = 'https://youth-movements-api1.marvilix.com';
        this.developmentHostUrl = 'http://youth-movements-api1.marvilix.com';
        // this.serverUrl = 'https://youth-movements-api.marvilix.com';
        // this.developmentHostUrl = 'http://youth-movements-api.marvilix.com';
        this.profileTokenName = 'arielProfileAccessToken';
        this.profilePathCokieName = 'arielProfilePath';
        this.adminTokenName = 'arielAdminToken';
        this.developmentProfilePath = 'http://dev.tariel.co.il/';
        this.prodctionProfilePath = 'https://rishum.tariel.co.il/';
        this.appDomain = 'tariel.co.il';
        this.backRoundImage = '/assets/images/login/ariel.jpg';
        this.logo = '/assets/images/logos/ariel.png';
        this.paymentyCompany = 2;
        this.externalEventsEnabled = false;
        $rootScope.yearType = 2;
        $rootScope.genderType = 2;
        $rootScope.ExternalDiscountEnabled = false;
    };
    this.setMaccabi = function () {
        $rootScope.appName = 'תנועת הנוער מכבי הצעיר';
        $rootScope.brandName = 'maccabi';
        $rootScope.favicon = 'maccabi-favicon.ico';
        this.appName = 'מערכת ניהול תנועת מכבי הצעיר';
        this.locationHost = 'admin-dev.mtz-mifalim.com';
        this.localHostUrl = 'http://youth-movements.local';
        this.serverUrl = 'https://youth-movements-api1.marvilix.com';
        this.developmentHostUrl = 'http://youth-movements-api1.marvilix.com';
        this.profileTokenName = 'maccabiProfileAccessToken';
        this.profilePathCokieName = 'maccabiProfilePath';
        this.adminTokenName = 'maccabiAdminToken';
        this.developmentProfilePath = 'http://profile-dev.mtz-mifalim.com/';
        this.prodctionProfilePath = 'https://mtz-mifalim.com/';
        this.appDomain = 'mtz-mifalim.com';
        this.backRoundImage = '/assets/images/login/maccabi.jpg';
        this.logo = '/assets/images/logos/maccabi.png';
        this.paymentyCompany = 2;
        this.externalEventsEnabled = false;
        $rootScope.yearType = 1;
        $rootScope.genderType = 1;
        $rootScope.ExternalDiscountEnabled = false;
    };
    this.setLatet = function () {
        $rootScope.appName = 'נוער לתת';
        $rootScope.favicon = 'latet-favicon.ico';
        $rootScope.brandName = 'noarlatet';
        this.appName = 'מערכת ניהול נוער לתת';
        this.locationHost = 'admin-dev.noarlatet-reg.com';
        this.localHostUrl = 'http://youth-movements.local';
        this.serverUrl = 'https://youth-movements-api2.marvilix.com';
        this.developmentHostUrl = 'http://youth-movements-api2.marvilix.com';
        this.profileTokenName = 'latetProfileAccessToken';
        this.profilePathCokieName = 'latetProfilePath';
        this.adminTokenName = 'latetAdminToken';
        this.developmentProfilePath = 'http://dev.noarlatet-reg.com/';
        this.prodctionProfilePath = 'https://noarlatet-reg.com/';
        this.appDomain = 'noarlatet-reg.com';
        this.backRoundImage = '/assets/images/login/latet.jpg';
        this.logo = '/assets/images/logos/latet.png';
        this.paymentyCompany = 1;
        this.externalEventsEnabled = false;
        $rootScope.yearType = 1;
        $rootScope.genderType = 1;
        $rootScope.ExternalDiscountEnabled = false;
    };
    this.setNoam = function () {
        $rootScope.appName = 'נועם';
        $rootScope.favicon = 'noam-favicon.ico';
        $rootScope.brandName = 'noam';
        this.appName = 'מערכת ניהול תנועת נועם';
        this.locationHost = 'dev-admin.noamist-reg.com';
        this.localHostUrl = 'http://youth-movements.local';
        this.serverUrl = 'https://youth-movements-api1.marvilix.com';
        this.developmentHostUrl = 'http://youth-movements-api1.marvilix.com';
        this.profileTokenName = 'noamProfileAccessToken';
        this.profilePathCokieName = 'noamProfilePath';
        this.adminTokenName = 'noamAdminToken';
        this.developmentProfilePath = 'http://dev.noamist-reg.com/';
        this.prodctionProfilePath = 'https://noamist-reg.com/';
        this.appDomain = 'noamist-reg.com';
        this.backRoundImage = '/assets/images/login/noam.jpg';
        this.logo = '/assets/images/logos/noam.png';
        this.paymentyCompany = 2;
        this.externalEventsEnabled = false;
        $rootScope.yearType = 1;
        $rootScope.genderType = 1;
        $rootScope.ExternalDiscountEnabled = false;
    };
    this.setTarbut = function () {
        $rootScope.appName = 'תנועת תרבות';
        $rootScope.brandName = 'tarbut';
        $rootScope.favicon = 'tarbut-favicon.ico';
        this.appName = 'מערכת ניהול תנועת תרבות';
        this.locationHost = 'admin-dev.tarbut-reg.com';
        this.localHostUrl = 'http://youth-movements.local';
        this.serverUrl = 'https://youth-movements-api1.marvilix.com';
        // this.serverUrl = 'https://youth-movements-api-dev.marvilix.com';
        // this.serverUrl = 'https://youth-movements-api2.marvilix.com';
        this.developmentHostUrl = 'https://youth-movements-api1.marvilix.com';
        this.profileTokenName = 'tarbutProfileAccessToken';
        this.profilePathCokieName = 'tarbutProfilePath';
        this.adminTokenName = 'tarbutAdminToken';
        this.developmentProfilePath = 'http://dev.tarbut-reg.com/';
        this.prodctionProfilePath = 'https://tarbut-reg.com/';
        this.appDomain = 'tarbut-reg.com';
        this.backRoundImage = '/assets/images/login/tarbut.jpg';
        this.logo = '/assets/images/logos/tarbut.png';
        this.paymentyCompany = 2;
        this.externalEventsEnabled = true;
        $rootScope.yearType = 1;
        $rootScope.genderType = 1;
        $rootScope.ExternalDiscountEnabled = false;
    };
    this.setHashomer = function () {
        $rootScope.appName = 'השומר הצעיר';
        $rootScope.brandName = 'hashomer';
        $rootScope.favicon = 'hashomer.ico';
        this.appName = 'מערכת ניהול השומר הצעיר';
        this.locationHost = 'admin-dev.hashomer-hatzair.com';
        this.localHostUrl = 'http://youth-movements.local';
        this.serverUrl = 'https://youth-movements-api1.marvilix.com';
        this.developmentHostUrl = 'http://youth-movements-api1.marvilix.com';
        this.profileTokenName = 'hashomerProfileAccessToken';
        this.profilePathCokieName = 'hashomerProfilePath';
        this.adminTokenName = 'hashomerAdminToken';
        this.developmentProfilePath = 'http://dev.hashomer-hatzair.com/';
        this.prodctionProfilePath = 'https://hashomer-hatzair.com/';
        this.appDomain = 'hashomer-hatzair.com';
        this.backRoundImage = '/assets/images/login/hashomer.jpg';
        this.logo = '/assets/images/logos/hashomer.png';
        this.paymentyCompany = 1;
        this.externalEventsEnabled = false;
        $rootScope.yearType = 1;
        $rootScope.genderType = 1;
        $rootScope.ExternalDiscountEnabled = false;
        $rootScope.fathersName = 'שם הורה';
    };
    this.setEzra = function () {
        $rootScope.appName = 'תנועת הנוער עזרא';
        $rootScope.favicon = 'ezra-favicon.ico';
        $rootScope.brandName = 'ezra';
        this.appName = 'מערכת ניהול תנועת הנוער עזרא';
        this.locationHost = 'admin-dev.ezra-reg.com';
        this.localHostUrl = 'http://youth-movements.local';
        this.serverUrl = 'https://youth-movements-api2.marvilix.com';
        this.developmentHostUrl = 'http://youth-movements-api-dev.marvilix.com';
        this.profileTokenName = 'ezraProfileAccessToken';
        this.profilePathCokieName = 'ezraProfilePath';
        this.adminTokenName = 'ezraAdminToken';
        this.developmentProfilePath = 'http://dev.ezra-reg.com/';
        this.prodctionProfilePath = 'https://ezra-reg.com/';
        this.appDomain = 'ezra-reg.com';
        this.backRoundImage = '/assets/images/login/ezra.jpg';
        this.logo = '/assets/images/logos/ezra.png';
        this.paymentyCompany = 1;
        this.externalEventsEnabled = true;
        $rootScope.yearType = 1;
        $rootScope.genderType = 1;
        $rootScope.ExternalDiscountEnabled = false;
    };
    if (location.hostname.indexOf('ezra') >= 0) {
        this.setEzra();
    } else if (location.hostname.indexOf('mtz') >= 0) {
        this.setMaccabi();
    } else if (location.hostname.indexOf('noarlatet') >= 0) {
        this.setLatet();
    } else if (location.hostname.indexOf('noam') >= 0) {
        this.setNoam();
    } else if (location.hostname.indexOf('tarbut') >= 0) {
        this.setTarbut();
    } else if (location.hostname.indexOf('hashomer') >= 0) {
        this.setHashomer();
    } else if (location.hostname.indexOf('oz') >= 0) {
        this.setOz();
    } else if (location.hostname.indexOf('ihudnik') >= 0) {
        this.setIhudnik();
    } else if (location.hostname.indexOf('hatnua-hahadasha') >= 0) {
        this.setTnuaHadasha();
    } else if (location.hostname.indexOf('tariel') >= 0) {
        this.setAriel();
    } else if (location.hostname.indexOf('teva') >= 0) {
        this.setTeva();
    } else {
        this.setAriel();
    }
});

(function ()
{
    'use strict';

    angular
        .module('app.upload', [])
        .config(config);

    /** @ngInject */
    function config($translatePartialLoaderProvider)
    {
        $translatePartialLoaderProvider.addPart('app/upload');
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.upload')
        .controller('UploadController', UploadController);

    /**
     *
     * @param $rootScope
     * @param $scope
     * @param Upload - upload plugin
     * @param $mdDialog
     * @param uploadTo(required, string) - set the object that the files will be attached to
     * @param uploadID(required, string) - set the object ID
     * @param restrictTo(optional, array) - restrict to specific file extensions
     * @param Notification
     * @param appConfig
     * @constructor
     */
    function UploadController($rootScope,$scope,Upload,$mdDialog,uploadTo,uploadID,restrictTo,Notification,appConfig) {

        var vm = this;
        vm.bodyEl = angular.element('body');


        $scope.closeDialog = function () {
            $mdDialog.hide();
        };

        $scope.$watch('files', function () {
            $scope.upload($scope.files);
        });

        $scope.filesUploading = [];

        var uploadURL = '';
        if (location.hostname === "localhost" || location.hostname === "127.0.0.1")
            uploadURL = appConfig.localHostUrl+'/'+uploadTo+'/'+uploadID+'/files?brand='+$rootScope.brandName+'&XDEBUG_SESSION_START';

        else if (location.host === appConfig.locationHost)
            uploadURL = appConfig.developmentHostUrl+'/'+uploadTo+'/'+uploadID+'/files?brand='+$rootScope.brandName;

        else
             uploadURL = appConfig.serverUrl+'/'+uploadTo+'/'+uploadID+'/files?brand='+$rootScope.brandName;


        $scope.upload = function (files) {
            if (files && files.length) {
                angular.forEach(files,function (file,key) {
                    var ext = getFileType(file);
                    if(restrictTo.length==0 || restrictTo.indexOf(ext)!='-1') {
                        $scope.isUploade = true;
                        Notification.info("נא להמתין לסיום טעינת הקבצים");
                        Upload.upload({
                            url: uploadURL,
                            data: {
                                file: file
                            },
                            headers: {
                                Authorization: 'Bearer ' + $rootScope.User.AccessToken
                            }
                        }).then(function (resp) {
                            $rootScope.fileResp = resp;
                            $scope.isUploade = false;
                            $scope.isUploading(false)
                            $mdDialog.hide();
                            Notification.success("קבצים נטענו בהצלחה!")

                        },null, function (evt) {
                            file.progress = parseInt(100.0 * evt.loaded / evt.total);
                            var index = $scope.filesUploading.indexOf(file);
                            if(index=='-1') {
                                $scope.filesUploading.push(file);
                            } else {
                                $scope.filesUploading[index] = file;
                            }
                            $scope.isUploading(true)
                        });
                    } else {
                        Notification.error('פורמט הקובץ אינו מותר');
                    }
                })
            }
        };

        /**
         * Get the file extension
         * @param file
         * @returns {string}
         */
        var getFileType = function (file) {
            return file.name.substr(file.name.lastIndexOf('.')+1)
        };

        /**
         * Function to check whether a file is being uploaded
         * @param status
         * @returns true or false
         */
        $scope.isUploading = function (status) {
            return $scope.fileInProgress = status;
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.toolbar', [])
        .config(config);

    /** @ngInject */
    function config($translatePartialLoaderProvider)
    {
        $translatePartialLoaderProvider.addPart('app/toolbar');
    }
})();

(function () {
    'use strict';

    angular
        .module('app.toolbar')
        .controller('ToolbarController', ToolbarController);

    /** @ngInject */
    function ToolbarController($rootScope, $location, $q, $state, $timeout, $mdSidenav, $translate, $mdToast, msNavigationService, $cookies, student, searchEndpoint, studentsEndpoint, coordinatorsEndpoint, coordinate, parent, parentsEndpoint, event, eventsEndpoint, $interval) {
        var vm = this;

        // Data
        $rootScope.global = {
            search: ''
        };

        vm.bodyEl = angular.element('body');
        vm.userStatusOptions = [
            {
                'title': 'Online',
                'icon': 'icon-checkbox-marked-circle',
                'color': '#4CAF50'
            },
            {
                'title': 'Away',
                'icon': 'icon-clock',
                'color': '#FFC107'
            },
            {
                'title': 'Do not Disturb',
                'icon': 'icon-minus-circle',
                'color': '#F44336'
            },
            {
                'title': 'Invisible',
                'icon': 'icon-checkbox-blank-circle-outline',
                'color': '#BDBDBD'
            },
            {
                'title': 'Offline',
                'icon': 'icon-checkbox-blank-circle-outline',
                'color': '#616161'
            }
        ];
        vm.languages = {
            /* en: {
             'title'      : 'English',
             'translation': 'TOOLBAR.ENGLISH',
             'code'       : 'en',
             'flag'       : 'us'
             },*/
            he: {
                'title': 'עברית',
                'translation': 'TOOLBAR.HEBREW',
                'code': 'he',
                'flag': 'il'
            },
        };

        // Methods
        vm.toggleSidenav = toggleSidenav;
        vm.logout = logout;
        vm.changeLanguage = changeLanguage;
        vm.setUserStatus = setUserStatus;
        vm.toggleHorizontalMobileMenu = toggleHorizontalMobileMenu;
        vm.toggleMsNavigationFolded = toggleMsNavigationFolded;
        vm.search = search;
        vm.searchResultClick = searchResultClick;
        vm.moveToProfile = moveToProfile;

        //////////

        init();

        /**
         * Initialize
         */
        function init() {
            // Select the first status as a default
            vm.userStatus = vm.userStatusOptions[0];

            // Get the selected language directly from angular-translate module setting
            vm.selectedLanguage = vm.languages[$translate.preferredLanguage()];
        }


        /**
         * Toggle sidenav
         *
         * @param sidenavId
         */
        function toggleSidenav(sidenavId) {
            $mdSidenav(sidenavId).toggle();
        }

        /**
         * Sets User Status
         * @param status
         */
        function setUserStatus(status) {
            vm.userStatus = status;
        }

        /**
         * Logout Function
         */
        function logout() {
            delete $cookies.remove("marvilixAccessToken");
            delete $cookies.remove("path");
            location.reload();
            msNavigationService.removeAll();
        }

        /**
         * Change Language
         */
        function changeLanguage(lang) {
            vm.selectedLanguage = lang;
            console.log(lang.code);

            /**
             * Show temporary message if user selects a language other than English
             *
             * angular-translate module will try to load language specific json files
             * as soon as you change the language. And because we don't have them, there
             * will be a lot of errors in the page potentially breaking couple functions
             * of the template.
             *
             * To prevent that from happening, we added a simple "return;" statement at the
             * end of this if block. If you have all the translation files, remove this if
             * block and the translations should work without any problems.
             */
            if (lang.code !== 'en' && lang.code !== 'he') {
                var message = 'marvilix supports translations through angular-translate module, but currently we do not have any translations other than English language. If you want to help us, send us a message through ThemeForest profile page.';

                $mdToast.show({
                    template: '<md-toast id="language-message" layout="column" layout-align="center start"><div class="md-toast-content">' + message + '</div></md-toast>',
                    hideDelay: 7000,
                    position: 'top left',
                    parent: '#content'
                });

                return;
            }

            // Change the language
            $translate.use(lang.code);
        }

        /**
         * Toggle horizontal mobile menu
         */
        function toggleHorizontalMobileMenu() {
            vm.bodyEl.toggleClass('ms-navigation-horizontal-mobile-menu-active');
        }

        /**
         * Toggle msNavigation folded
         */
        function toggleMsNavigationFolded() {
            msNavigationService.toggleFolded();
        }

        /**
         * Search action
         *
         * @param query
         * @returns {Promise}
         */
        function search(query) {
            var navigation = [],
                flatNavigation = msNavigationService.getFlatNavigation(),
                deferred = $q.defer();

            // Iterate through the navigation array and
            // make sure it doesn't have any groups or
            // none ui-sref items
            for (var x = 0; x < flatNavigation.length; x++) {
                if (flatNavigation[x].uisref) {
                    navigation.push(flatNavigation[x]);
                }
            }

            // If there is a query, filter the navigation;
            // otherwise we will return the entire navigation
            // list. Not exactly a good thing to do but it's
            // for demo purposes.
            if (query) {
                navigation = navigation.filter(function (item) {
                    if (angular.lowercase(item.title).search(angular.lowercase(query)) > -1) {
                        return true;
                    }
                });
            }

            // Fake service delay
            $timeout(function () {
                deferred.resolve(navigation);
            }, 1000);

            return deferred.promise;
        }

        /**
         * Search result click action
         *
         * @param item
         */
        function searchResultClick(item) {
            // If item has a link
            if (item.uisref) {
                // If there are state params,
                // use them...
                if (item.stateParams) {
                    $state.go(item.state, item.stateParams);
                } else {
                    $state.go(item.state);
                }
            }
        }


        vm.selectedItem = null;
        vm.searchText = null;
        vm.querySearch = querySearch;
        vm.lastSearchText = null;

        /**
         * Search for states... use $timeout to simulate
         * remote dataservice call.
         */

        function querySearch(query) {
            if (query.length < 3 || vm.lastSearchText === query)
                return function () {
                };
            var params = {};
            vm.results = [];
            params.SearchText = query;
            return searchEndpoint.get(params, function (data) {
                vm.results = data;
                vm.move = false;
                vm.lastSearchText = query;
                return data;
            });
        }

        function getData() {
            /* if (vm.interval)
                 $interval.cancel(vm.interval);
             vm.load=true;*/
            var params = {};
            vm.results = [];
            params.SearchText = vm.searchText;
            searchEndpoint.get(params, function (data) {
                vm.load = false;
                vm.results = data;
                vm.move = false;
                return data;
                /*$timeout(function () {
                    var element =  document.getElementById("fl-input-0");
                    if (element)
                        element.blur();
                    else{
                        element=document.getElementById("fl-input-1").blur();
                        element.focus();
                    }
                },500);
                $timeout(function () {
                    var element =  document.getElementById("fl-input-0");
                    if (element)
                        element.focus();
                    else {
                        element=document.getElementById("fl-input-1").blur();
                        element.focus();
                    }

                },1500);*/
            });
        }

        function moveToProfile(item) {
            if (item.Type) {
                if (item.Type === 'חניך')
                    $location.url('/student-profile?ID=' + item.ID);
                else if (item.Type === 'רכז')
                    $location.url('/coordinator-profile?ID=' + item.ID);
                else if (item.Type === 'הורה')
                    $location.url('/parent-profile?ID=' + item.ID);
                else if (item.Type === 'אירוע')
                    $location.url('/event-management?ID=' + item.ID);
            } else {
                debugger
            }
        }


    }


})();

(function ()
{
    'use strict';

    angular
        .module('app.navigation', [])
        .config(config);

    /** @ngInject */
    function config()
    {
        
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.navigation')
        .controller('NavigationController', NavigationController);

    /** @ngInject */
    function NavigationController($scope)
    {
        var vm = this;

        // Data
        vm.bodyEl = angular.element('body');
        vm.folded = false;
        vm.msScrollOptions = {
            suppressScrollX: false,
            suppressScrollY: true
        };

        // Methods
        vm.toggleMsNavigationFolded = toggleMsNavigationFolded;

        //////////

        /**
         * Toggle folded status
         */
        function toggleMsNavigationFolded()
        {
            vm.folded = !vm.folded;
        }

        // Close the mobile menu on $stateChangeSuccess
        $scope.$on('$stateChangeSuccess', function ()
        {
            vm.bodyEl.removeClass('ms-navigation-horizontal-mobile-menu-active');
        });
    }

})();
// comments out all modules i don't need - daniel 09/02/2017

(function ()
{
    'use strict';

    /**
     * Main module of the marvilix
     */
    angular
        .module('marvilix', [

            // Common 3rd Party Dependencies
            'uiGmapgoogle-maps',
            'textAngular',
            'xeditable',
            'vsGoogleAutocomplete',
            'moment-picker',
            'ngFileUpload',
            'tooltips',
            'textAngular',
            // Core
            'app.core',
            'app.save-changes',
            // Navigation
            'app.navigation',
            // Toolbar
            'app.toolbar',
            //Upload
            'app.upload',
            // Profile Panel
            //'app.profile-panel',
            'app.admin-profile-panel',
            // Apps
            'app.dashboard',
            // Pages
            'app.pages',
            'vcRecaptcha'
        ]);
})();

(function ()
{
    'use strict';

    angular
        .module('marvilix')
        .controller('MainController', MainController);

    /** @ngInject */
    function MainController($scope, $rootScope)
    {
        // Data

        //////////

        // Remove the splash screen
        $scope.$on('$viewContentAnimationEnded', function (event)
        {
            if ( event.targetScope.$id === $scope.$id )
            {
                $rootScope.$broadcast('msSplashScreen::remove');
            }
        });

    }
})();

(function ()
{
    'use strict';
    angular.module('app.core').service('privateIDCheck', privateIDCheck);

    /** @ngInject */
    function privateIDCheck()
    {
      this.privateIDCheck = function(privateID) {
          var tot = 0;
          var tz = String(privateID);
          for (i=0; i<8; i++)
          {
              var x = (((i%2)+1)*tz.charAt(i));
              if (x > 9)
              {
                  x =x.toString();
                  x=parseInt(x.charAt(0))+parseInt(x.charAt(1))
              }
              tot += x;
          }
          return (tot + parseInt(tz.charAt(8))) % 10 === 0;
        };
        return this;

    }
})();


(function ()
{
    'use strict';

    angular
        .module('app.core')
        .run(runBlock);

    /** @ngInject */
    function runBlock(msUtils, marvilixGenerator, marvilixConfig)
    {
        /**
         * Generate extra classes based on registered themes so we
         * can use same colors with non-angular-material elements
         */
        marvilixGenerator.generate();

        /**
         * Disable md-ink-ripple effects on mobile
         * if 'disableMdInkRippleOnMobile' config enabled
         */
        if ( marvilixConfig.getConfig('disableMdInkRippleOnMobile') && msUtils.isMobile() )
        {
            var bodyEl = angular.element('body');
            bodyEl.attr('md-no-ink', true);
        }

        /**
         * Put isMobile() to the html as a class
         */
        if ( msUtils.isMobile() )
        {
            angular.element('html').addClass('is-mobile');
        }

        /**
         * Put browser information to the html as a class
         */
        var browserInfo = msUtils.detectBrowser();
        if ( browserInfo )
        {
            var htmlClass = browserInfo.browser + ' ' + browserInfo.version + ' ' + browserInfo.os;
            angular.element('html').addClass(htmlClass);
        }

        //global dataTable action buttons rehook for responsive views
        $(document).on('click','table tr.child td.child span.dtr-data button',function(){
            var classList = '.' + $(this).attr('class').split(' ').join('.');
            $(this).parents('tr').prev().find('button'+classList).click();
        });
    }
})();


(function ()
{
    'use strict';

    angular
        .module('app.core')
        .config(config);

    /** @ngInject */
    function config($ariaProvider, $logProvider, msScrollConfigProvider, marvilixConfigProvider)
    {

        // Enable debug logging
        $logProvider.debugEnabled(true);

        /*eslint-disable */

        // ng-aria configuration
        $ariaProvider.config({
            tabindex: false
        });

        // marvilix theme configurations
        marvilixConfigProvider.config({
            'disableCustomScrollbars'        : false,
            'disableCustomScrollbarsOnMobile': true,
            'disableMdInkRippleOnMobile'     : true
        });

        // msScroll configuration
        msScrollConfigProvider.config({
            wheelPropagation: true
        });

        /*eslint-enable */
    }
})();
(function ()
{
    'use strict';

    angular
        .module('marvilix')
        .run(runBlock);

    /** @ngInject */
    function runBlock($rootScope, $timeout, $state, editableThemes)
    {
        // 3rd Party Dependencies
        editableThemes.default.submitTpl = '<md-button class="md-icon-button" type="submit" aria-label="save"><md-icon md-font-icon="icon-checkbox-marked-circle" class="md-accent-fg md-hue-1"></md-icon></md-button>';
        editableThemes.default.cancelTpl = '<md-button class="md-icon-button" ng-click="$form.$cancel()" aria-label="cancel"><md-icon md-font-icon="icon-close-circle" class="icon-cancel"></md-icon></md-button>';
/*
        // Activate loading indicator
        var stateChangeStartEvent = $rootScope.$on('$stateChangeStart', function ()
        {
            $rootScope.loadingProgress = true;
        });

        // De-activate loading indicator
        var stateChangeSuccessEvent = $rootScope.$on('$stateChangeSuccess', function ()
        {
            $timeout(function ()
            {
                $rootScope.loadingProgress = false;
            });
        });

        // Store state in the root scope for easy access
        $rootScope.state = $state;


        // Cleanup
        $rootScope.$on('$destroy', function ()
        {
            stateChangeStartEvent();
            stateChangeSuccessEvent();
        });*/
    }
})();

(function ()
{
    'use strict';

    angular
        .module('marvilix')
        .config(routeConfig)


    function routeConfig($stateProvider, $urlRouterProvider, $locationProvider)
    {
        $locationProvider.html5Mode(true);
        $urlRouterProvider.otherwise('/');

        /**
         * Layout Style Switcher
         *
         * This code is here for demonstration purposes.
         * If you don't need to switch between the layout
         * styles like in the demo, you can set one manually by
         * typing the template urls into the `State definitions`
         * area and remove this code
         */
        // Inject $cookies
        var $cookies;

        angular.injector(['ngCookies']).invoke([
            '$cookies', function (_$cookies)
            {
                $cookies = _$cookies;
            }
        ]);

        // Get active layout
        var layoutStyle = 'verticalNavigation';

        var layouts = {
            verticalNavigation  : {
                main      : 'app/core/layouts/vertical-navigation.html',
                toolbar   : 'app/toolbar/layouts/vertical-navigation/toolbar.html',
                navigation: 'app/navigation/layouts/vertical-navigation/navigation.html'
            },
            contentOnly         : {
                main      : 'app/core/layouts/content-only.html',
                toolbar   : '',
                navigation: ''
            }
        };
        // END - Layout Style Switcher

        // State definitions
        $stateProvider
            .state('app', {
                abstract: true,
                views: {
                    'main@'         : {
                        templateUrl: layouts[layoutStyle].main,
                        controller : 'MainController',
                        controllerAs: 'vm'
                    },
                    'toolbar@app'   : {
                        templateUrl: layouts[layoutStyle].toolbar,
                        controller : 'ToolbarController',
                        controllerAs: 'vm'
                    },
                    'upload@app'   : {
                        templateUrl: layouts[layoutStyle].upload,
                        controller : 'UploadController',
                        controllerAs: 'vm'
                    },
                    'navigation@app': {
                        templateUrl: layouts[layoutStyle].navigation,
                        controller : 'NavigationController',
                        controllerAs: 'vm'
                    },
                    'adminProfilePanel@app': {
                        templateUrl: 'app/main/pages/admin/admin-management/admin-profile-panel/admin-profile-panel.html',
                        controller : 'AdminProfilePanelController'
                    },
                    'studentPanel@app': {
                        templateUrl: 'app/main/pages/users/views/students/student-panel/student-panel.html',
                        controller : 'StudentPanelController'
                    },
                    'fieldPanel@app': {
                        templateUrl: 'app/main/pages/settings/tabs/profile/field-panel/field-panel.html',
                        controller : 'FieldPanelController'
                    },
                    'generalDiscountPanel@app': {
                        templateUrl: 'app/main/pages/events/views/events/event-management/tabs/discounts/tabs/general-discount-panel/general-discount-panel.html',
                        controller : 'GeneralDiscountPanelController'
                    },
                    'parentPanel@app': {
                        templateUrl: 'app/main/pages/users/views/parents/parent-panel/parent-panel.html',
                        controller : 'ParentPanelController'
                    },
                    'groupPanel@app': {
                        templateUrl: 'app/main/pages/branches/views/groups/groups-panel/groups-panel.html',
                        controller : 'GroupsPanelController'
                    },
                    'gradePanel@app': {
                        templateUrl: 'app/main/pages/branches/views/grades/grades-panel/grades-panel.html',
                        controller : 'GradesPanelController'
                    },

                    'coordinatorPanel@app': {
                        templateUrl: 'app/main/pages/users/views/coordinators/coordinators-panel/coordinators-panel.html',
                        controller : 'CoordinatePanelController'
                    },

                    'questionPanel@app': {
                        templateUrl: 'app/main/pages/events/views/questions/question-panel/question-panel.html',
                        controller : 'QuestionPanelController'
                    },
                    'transportationPanel@app': {
                        templateUrl: 'app/main/pages/events/views/transportation/transportation-panel/transportation-panel.html',
                        controller : 'TransportationPanelController'
                    },

                    'manageBranchesPanel@app': {
                        templateUrl: 'app/main/pages/branches/views/branches/branch-panel/branch-panel.html',
                        controller : 'BranchPanelController'
                    },
                    'activitiesPanel@app': {
                        templateUrl: 'app/main/pages/activities/activities-panel/activities-panel.html',
                        controller : 'ActivitiesPanelController'
                    },

                    'areaPanel@app': {
                        templateUrl: 'app/main/pages/branches/views/areas/areas-panel/areas-panel.html',
                        controller : 'AreasPanelController'
                    },
                    'editEventQuestionPanel@app': {
                        templateUrl: 'app/main/pages/events/views/events/event-management/tabs/questions/edit-event-question-panel/edit-event-question-panel.html',
                        controller : 'EditEventQuestionPanelController as vm'
                    },
                    'contactsPanel@app': {
                        templateUrl: 'app/main/pages/contacts/contact-panel/contact-panel.html',
                        controller : 'ContactsPanelController'
                    },

                    'saveChanges@app': {
                        templateUrl: 'app/main/pages/save-changes/save-changes.html',
                        controller : 'SaveChangesController'
                    }
                }
            });
    }


})();

(function ()
{
    'use strict';

    angular
        .module('marvilix')
        .controller('IndexController', IndexController);

    /** @ngInject */
    function IndexController(marvilixTheming)
    {
        var vm = this;

        // Data
        vm.themes = marvilixTheming.themes;

        //////////
    }
})();

(function ()
{
    'use strict';

    angular
        .module('marvilix');
})();

(function ()
{
    'use strict';

    angular
        .module('marvilix')
        .config(config);

    /** @ngInject */
    function config(uiGmapGoogleMapApiProvider, $translateProvider, $provide,momentPickerProvider,$mdIconProvider)
    {

        $mdIconProvider
            .defaultIconSet('../../assets/icons/mdi.svg');


        // Put your common app configurations here

        momentPickerProvider.options({
            locale: "he",
        });

        // uiGmapgoogle-maps configuration
        uiGmapGoogleMapApiProvider.configure({
            key: 'AIzaSyDYpkAWSyEAl81EVv1CNKOk1bZtkDc-zrI',
            //v: '3.20',
            libraries: 'visualization,places',
            language: 'he'
        });

        // angular-translate configuration
        $translateProvider.useLoader('$translatePartialLoader', {
            urlTemplate: '{part}/i18n/{lang}.json'
        });
        $translateProvider.preferredLanguage('he');
        $translateProvider.useSanitizeValueStrategy('sanitize');

        // Text Angular options
        $provide.decorator('taOptions', [
            '$delegate', function (taOptions)
            {
                taOptions.toolbar = [
                    ['bold', 'italics', 'underline', 'ul', 'ol', 'quote']
                ];

                taOptions.classes = {
                    focussed           : 'focussed',
                    toolbar            : 'ta-toolbar',
                    toolbarGroup       : 'ta-group',
                    toolbarButton      : 'md-button',
                    toolbarButtonActive: 'active',
                    disabled           : '',
                    textEditor         : 'form-control',
                    htmlEditor         : 'form-control'
                };

                return taOptions;
            }
        ]);

        // Text Angular tools
        $provide.decorator('taTools', [
            '$delegate', function (taTools)
            {
                taTools.quote.iconclass = 'icon-format-quote';
                taTools.bold.iconclass = 'icon-format-bold';
                taTools.italics.iconclass = 'icon-format-italic';
                taTools.underline.iconclass = 'icon-format-underline';
                taTools.strikeThrough.iconclass = 'icon-format-strikethrough';
                taTools.ul.iconclass = 'icon-format-list-bulleted';
                taTools.ol.iconclass = 'icon-format-list-numbers';
                taTools.redo.iconclass = 'icon-redo';
                taTools.undo.iconclass = 'icon-undo';
                taTools.clear.iconclass = 'icon-close-circle-outline';
                taTools.justifyLeft.iconclass = 'icon-format-align-left';
                taTools.justifyCenter.iconclass = 'icon-format-align-center';
                taTools.justifyRight.iconclass = 'icon-format-align-right';
                taTools.justifyFull.iconclass = 'icon-format-align-justify';
                taTools.indent.iconclass = 'icon-format-indent-increase';
                taTools.outdent.iconclass = 'icon-format-indent-decrease';
                taTools.html.iconclass = 'icon-code-tags';
                taTools.insertImage.iconclass = 'icon-file-image-box';
                taTools.insertLink.iconclass = 'icon-link';
                taTools.insertVideo.iconclass = 'icon-filmstrip';

                return taTools;
            }
        ]);
    }

})();
(function ()
{
    'use strict';

    angular
        .module('marvilix')
        .factory('api', apiService);

    /** @ngInject */
    function apiService($resource)
    {
        /**
         * You can use this service to define your API urls. The "api" service
         * is designed to work in parallel with "apiResolver" service which you can
         * find in the "app/core/services/api-resolver.service.js" file.
         *
         * You can structure your API urls whatever the way you want to structure them.
         * You can either use very simple definitions, or you can use multi-dimensional
         * objects.
         *
         * Here's a very simple API url definition example:
         *
         *      api.getBlogList = $resource('http://api.example.com/getBlogList');
         *
         * While this is a perfectly valid $resource definition, most of the time you will
         * find yourself in a more complex situation where you want url parameters:
         *
         *      api.getBlogById = $resource('http://api.example.com/blog/:id', {id: '@id'});
         *
         * You can also define your custom methods. Custom method definitions allow you to
         * add hardcoded parameters to your API calls that you want to sent every time you
         * make that API call:
         *
         *      api.getBlogById = $resource('http://api.example.com/blog/:id', {id: '@id'}, {
         *         'getFromHomeCategory' : {method: 'GET', params: {blogCategory: 'home'}}
         *      });
         *
         * In addition to these definitions, you can also create multi-dimensional objects.
         * They are nothing to do with the $resource object, it's just a more convenient
         * way that we have created for you to packing your related API urls together:
         *
         *      api.blog = {
         *                   list     : $resource('http://api.example.com/blog'),
         *                   getById  : $resource('http://api.example.com/blog/:id', {id: '@id'}),
         *                   getByDate: $resource('http://api.example.com/blog/:date', {id: '@date'}, {
         *                       get: {
         *                            method: 'GET',
         *                            params: {
         *                                getByDate: true
         *                            }
         *                       }
         *                   })
         *       }
         *
         * If you look at the last example from above, we overrode the 'get' method to put a
         * hardcoded parameter. Now every time we make the "getByDate" call, the {getByDate: true}
         * object will also be sent along with whatever data we are sending.
         *
         * All the above methods are using standard $resource service. You can learn more about
         * it at: https://docs.angularjs.org/api/ngResource/service/$resource
         *
         * -----
         *
         * After you defined your API urls, you can use them in Controllers, Services and even
         * in the UIRouter state definitions.
         *
         * If we use the last example from above, you can do an API call in your Controllers and
         * Services like this:
         *
         *      function MyController (api)
         *      {
         *          // Get the blog list
         *          api.blog.list.get({},
         *
         *              // Success
         *              function (response)
         *              {
         *                  console.log(response);
         *              },
         *
         *              // Error
         *              function (response)
         *              {
         *                  console.error(response);
         *              }
         *          );
         *
         *          // Get the blog with the id of 3
         *          var id = 3;
         *          api.blog.getById.get({'id': id},
         *
         *              // Success
         *              function (response)
         *              {
         *                  console.log(response);
         *              },
         *
         *              // Error
         *              function (response)
         *              {
         *                  console.error(response);
         *              }
         *          );
         *
         *          // Get the blog with the date by using custom defined method
         *          var date = 112314232132;
         *          api.blog.getByDate.get({'date': date},
         *
         *              // Success
         *              function (response)
         *              {
         *                  console.log(response);
         *              },
         *
         *              // Error
         *              function (response)
         *              {
         *                  console.error(response);
         *              }
         *          );
         *      }
         *
         * Because we are directly using $resource service, all your API calls will return a
         * $promise object.
         *
         * --
         *
         * If you want to do the same calls in your UI Router state definitions, you need to use
         * "apiResolver" service we have prepared for you:
         *
         *      $stateProvider.state('app.blog', {
         *          url      : '/blog',
         *          views    : {
         *               'content@app': {
         *                   templateUrl: 'app/main/apps/blog/blog.html',
         *                   controller : 'BlogController as vm'
         *               }
         *          },
         *          resolve  : {
         *              Blog: function (apiResolver)
         *              {
         *                  return apiResolver.resolve('blog.list@get');
         *              }
         *          }
         *      });
         *
         *  You can even use parameters with apiResolver service:
         *
         *      $stateProvider.state('app.blog.show', {
         *          url      : '/blog/:id',
         *          views    : {
         *               'content@app': {
         *                   templateUrl: 'app/main/apps/blog/blog.html',
         *                   controller : 'BlogController as vm'
         *               }
         *          },
         *          resolve  : {
         *              Blog: function (apiResolver, $stateParams)
         *              {
         *                  return apiResolver.resolve('blog.getById@get', {'id': $stateParams.id);
         *              }
         *          }
         *      });
         *
         *  And the "Blog" object will be available in your BlogController:
         *
         *      function BlogController(Blog)
         *      {
         *          var vm = this;
         *
         *          // Data
         *          vm.blog = Blog;
         *
         *          ...
         *      }
         */

        var api = {};

        // Base Url
        api.baseUrl = 'app/data/';

        /**
         * Here you can find all the definitions that the Demo Project requires
         *
         * If you wish to use this method, you can create your API definitions
         * in a similar way.
         */

        /*
         api.dashboard = {
         project  : $resource(api.baseUrl + 'dashboard/project/data.json'),
         server   : $resource(api.baseUrl + 'dashboard/server/data.json'),
         analytics: $resource(api.baseUrl + 'dashboard/analytics/data.json')
         };

         api.cards = $resource(api.baseUrl + 'cards/cards.json');

         api.fileManager = {
         documents: $resource(api.baseUrl + 'file-manager/documents.json')
         };

         api.ganttChart = {
         tasks: $resource(api.baseUrl + 'gantt-chart/tasks.json'),
         timespans : $resource(api.baseUrl + 'gantt-chart/timespans.json')
         };

         api.icons = $resource('assets/icons/selection.json');

         api.invoice = $resource(api.baseUrl + 'invoice/invoice.json');

         api.mail = {
         inbox: $resource(api.baseUrl + 'mail/inbox.json')
         };

         api.profile = {
         timeline    : $resource(api.baseUrl + 'profile/timeline.json'),
         about       : $resource(api.baseUrl + 'profile/about.json'),
         photosVideos: $resource(api.baseUrl + 'profile/photos-videos.json')
         };

         api.quickPanel = {
         activities: $resource(api.baseUrl + 'quick-panel/activities.json'),
         contacts  : $resource(api.baseUrl + 'quick-panel/contacts.json'),
         events    : $resource(api.baseUrl + 'quick-panel/events.json'),
         notes     : $resource(api.baseUrl + 'quick-panel/notes.json')
         };

         api.search = {
         classic : $resource(api.baseUrl + 'search/classic.json'),
         mails   : $resource(api.baseUrl + 'search/mails.json'),
         users   : $resource(api.baseUrl + 'search/users.json'),
         contacts: $resource(api.baseUrl + 'search/contacts.json')
         };

         api.scrumboard = {
         boardList: $resource(api.baseUrl + 'scrumboard/boardList.json'),
         board    : $resource(api.baseUrl + 'scrumboard/boards/:id.json')
         };

         api.tables = {
         employees   : $resource(api.baseUrl + 'tables/employees.json'),
         employees100: $resource(api.baseUrl + 'tables/employees100.json')
         };

         api.timeline = {
         page1: $resource(api.baseUrl + 'timeline/page-1.json'),
         page2: $resource(api.baseUrl + 'timeline/page-2.json'),
         page3: $resource(api.baseUrl + 'timeline/page-3.json')
         };

         api.todo = {
         tasks: $resource(api.baseUrl + 'todo/tasks.json'),
         tags : $resource(api.baseUrl + 'todo/tags.json')
         };
         */

        return api;
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.pages', [
            'app.pages.auth.login',
            'app.pages_auth_forgot-password',
            'app.pages_auth_reset-password',
            'app.pages.manage-admins',
            'app.pages.admin-profile',
            'app.pages.reports',
            'app.pages.users',
            'app.pages.branches',
            'app.pages.branch-management',
            'app.pages.group-management',
            'app.pages.student-profile',
            'app.pages.coordinators-profile',
            'app.pages.parent-profile',
            'app.pages.new-educator',
            'app.pages.events',
            'app.pages.event-management',
            'app.pages.new-coordinator',
            'app.pages.new-admin',
            'app.pages.activities',
            'app.pages.activities-profile',
            'app.pages.accountancy',
            'app.pages.settings',
            'app.pages.files',
            'app.pages.contacts',
            'app.pages.calendar',
            'app.pages.profile-forms',
            'app.pages.settings_menu',
        ])
        .config(config);

    /** @ngInject */
    function config(msNavigationServiceProvider)
    {
        // Navigation
        msNavigationServiceProvider.saveItem('pages', {
            title : '',
            group : true,
            weight: 1
        });
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.ui', [
            'app.ui.forms',
            'app.ui.helper-classes',
            'app.ui.icons',
            'app.ui.material-colors',
            'app.ui.page-layouts.blank',
            'app.ui.page-layouts.carded.fullwidth',
            'app.ui.page-layouts.carded.fullwidth-ii',
            'app.ui.page-layouts.carded.left-sidenav',
            'app.ui.page-layouts.carded.left-sidenav-ii',
            'app.ui.page-layouts.carded.right-sidenav',
            'app.ui.page-layouts.carded.right-sidenav-ii',
            'app.ui.page-layouts.simple.fullwidth',
            'app.ui.page-layouts.simple.left-sidenav',
            'app.ui.page-layouts.simple.left-sidenav-ii',
            'app.ui.page-layouts.simple.left-sidenav-iii',
            'app.ui.page-layouts.simple.right-sidenav',
            'app.ui.page-layouts.simple.right-sidenav-ii',
            'app.ui.page-layouts.simple.right-sidenav-iii',
            'app.ui.page-layouts.simple.tabbed',
            'app.ui.theme-colors',
            'app.ui.typography'
        ])
        .config(config);

    /** @ngInject */
    function config(msNavigationServiceProvider)
    {
        // Navigation
        msNavigationServiceProvider.saveItem('ui', {
            title : 'USER INTERFACE',
            group : true,
            weight: 3
        });

        msNavigationServiceProvider.saveItem('ui.forms', {
            title: 'Forms',
            icon : 'icon-window-restore',
            state: 'app.ui_forms'
        });

        msNavigationServiceProvider.saveItem('ui.icons', {
            title: 'Icons',
            icon : 'icon-file-image-box',
            state: 'app.ui_icons'
        });

        msNavigationServiceProvider.saveItem('ui.typography', {
            title: 'Typography',
            icon : 'icon-format-size',
            state: 'app.ui_typography'
        });

        msNavigationServiceProvider.saveItem('ui.helper-classes', {
            title: 'Helper Classes',
            icon : 'icon-help-circle',
            state: 'app.ui_helper-classes'
        });

        msNavigationServiceProvider.saveItem('ui.theme-colors', {
            title: 'Theme Colors',
            icon : 'icon-palette-advanced',
            state: 'app.ui_theme-colors'
        });

        msNavigationServiceProvider.saveItem('ui.material-colors', {
            title: 'Material Colors',
            icon : 'icon-palette',
            state: 'app.ui_material-colors'
        });


        msNavigationServiceProvider.saveItem('ui.page-layouts', {
            title: 'Page Layouts',
            icon : 'icon-view-quilt'
        });

        msNavigationServiceProvider.saveItem('ui.page-layouts.carded', {
            title: 'Carded'
        });

        msNavigationServiceProvider.saveItem('ui.page-layouts.carded.fullwidth', {
            title: 'Full Width (I)',
            state: 'app.ui_page-layouts_carded_fullwidth'
        });

        msNavigationServiceProvider.saveItem('ui.page-layouts.carded.fullwidth-ii', {
            title: 'Full Width (II)',
            state: 'app.ui_page-layouts_carded_fullwidth-ii'
        });

        msNavigationServiceProvider.saveItem('ui.page-layouts.carded.left-sidenav', {
            title: 'Left Sidenav (I)',
            state: 'app.ui_page-layouts_carded_left-sidenav'
        });

        msNavigationServiceProvider.saveItem('ui.page-layouts.carded.left-sidenav-ii', {
            title: 'Left Sidenav (II)',
            state: 'app.ui_page-layouts_carded_left-sidenav-ii'
        });

        msNavigationServiceProvider.saveItem('ui.page-layouts.carded.right-sidenav', {
            title: 'Right Sidenav (I)',
            state: 'app.ui_page-layouts_carded_right-sidenav'
        });

        msNavigationServiceProvider.saveItem('ui.page-layouts.carded.right-sidenav-ii', {
            title: 'Right Sidenav (II)',
            state: 'app.ui_page-layouts_carded_right-sidenav-ii'
        });

        msNavigationServiceProvider.saveItem('ui.page-layouts.simple', {
            title: 'Simple'
        });

        msNavigationServiceProvider.saveItem('ui.page-layouts.simple.fullwidth', {
            title: 'Full Width (I)',
            state: 'app.ui_page-layouts_simple_fullwidth'
        });

        msNavigationServiceProvider.saveItem('ui.page-layouts.simple.left-sidenav', {
            title: 'Left Sidenav (I)',
            state: 'app.ui_page-layouts_simple_left-sidenav'
        });

        msNavigationServiceProvider.saveItem('ui.page-layouts.simple.left-sidenav-ii', {
            title: 'Left Sidenav (II)',
            state: 'app.ui_page-layouts_simple_left-sidenav-ii'
        });

        msNavigationServiceProvider.saveItem('ui.page-layouts.simple.left-sidenav-iii', {
            title: 'Left Sidenav (III)',
            state: 'app.ui_page-layouts_simple_left-sidenav-iii'
        });

        msNavigationServiceProvider.saveItem('ui.page-layouts.simple.right-sidenav', {
            title: 'Right Sidenav (I)',
            state: 'app.ui_page-layouts_simple_right-sidenav'
        });

        msNavigationServiceProvider.saveItem('ui.page-layouts.simple.right-sidenav-ii', {
            title: 'Right Sidenav (II)',
            state: 'app.ui_page-layouts_simple_right-sidenav-ii'
        });

        msNavigationServiceProvider.saveItem('ui.page-layouts.simple.right-sidenav-iii', {
            title: 'Right Sidenav (III)',
            state: 'app.ui_page-layouts_simple_right-sidenav-iii'
        });

        msNavigationServiceProvider.saveItem('ui.page-layouts.simple.tabbed', {
            title: 'Tabbed',
            state: 'app.ui_page-layouts_simple_tabbed'
        });

        msNavigationServiceProvider.saveItem('ui.page-layouts.blank', {
            title: 'Blank',
            state: 'app.ui_page-layouts_blank'
        });
    }
})();
angular.module("marvilix").run(["$templateCache", function($templateCache) {$templateCache.put("app/upload/upload.html","<md-dialog aria-label=\"העלאת קבצים\" class=\"uploader\"><md-toolbar class=\"md-accent\" layout=\"column\"><div \nclass=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">\nהעלאת קבצים</span><md-button ng-disabled=\"isUploade\" class=\"md-icon-button\" ng-click=\"closeDialog()\" \naria-label=\"Close dialog\" translate translate-attr-aria-label=\"UPLOAD.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\">\n</md-icon></md-button></div></md-toolbar><md-dialog-content ngf-drop ngf-select ng-model=\"files\" ngf-multiple=\"true\">\n<div ng-if=\"filesUploading.length==0\" class=\"upload\"><span>גרור קבצים מכל מקום או לחץ כאן</span></div><div \nng-if=\"filesUploading.length>0\"><md-card ng-repeat=\"file in filesUploading\"><md-card-title><md-card-title-text><span \nclass=\"md-headline\">{{file.name}}</span></md-card-title-text></md-card-title><md-card-actions layout=\"row\" \nlayout-align=\"end center\"><md-progress-linear md-mode=\"determinate\" value=\"{{file.progress}}\"></md-progress-linear>\n</md-card-actions></md-card></div></md-dialog-content></md-dialog>");
$templateCache.put("app/core/layouts/content-only.html","<div id=\"layout-content-only\" class=\"template-layout\" layout=\"column\" flex><md-content id=\"content\" \nclass=\"animate-slide-up md-hue-2\" ui-view=\"content\" flex></md-content></div>");
$templateCache.put("app/core/layouts/vertical-navigation.html","<div id=\"layout-vertical-navigation\" class=\"template-layout\" layout=\"row\" flex><md-sidenav id=\"vertical-navigation\" \nclass=\"md-primary-bg md-sidenav-right\" md-is-locked-open=\"$mdMedia(\'gt-sm\')\" ng-if=\"$root.User\" \nmd-component-id=\"navigation\" ms-scroll ui-view=\"navigation\"></md-sidenav><div id=\"content-container\" flex \nlayout=\"column\"><div ng-if=\"$root.User\"><md-toolbar id=\"toolbar\" class=\"md-menu-toolbar md-whiteframe-1dp\" \nui-view=\"toolbar\"></md-toolbar><md-content id=\"content\" class=\"animate-slide-up md-hue-2\" ms-scroll ui-view=\"content\" \nflex></md-content><md-sidenav id=\"quick-panel\" class=\"md-sidenav-left md-whiteframe-4dp\" md-component-id=\"quick-panel\" \nms-scroll ui-view=\"quickPanel\"></md-sidenav><md-sidenav id=\"student-panel\" class=\"md-sidenav-left md-whiteframe-4dp\" \nmd-component-id=\"student-panel\" ms-scroll ui-view=\"studentPanel\"></md-sidenav><md-sidenav id=\"general-discount-panel\" \nclass=\"md-sidenav-left md-whiteframe-4dp\" md-component-id=\"general-discount-panel\" ms-scroll \nui-view=\"generalDiscountPanel\"></md-sidenav><md-sidenav id=\"group-panel\" class=\"md-sidenav-left md-whiteframe-4dp\" \nmd-component-id=\"groups-panel\" ms-scroll ui-view=\"groupPanel\"></md-sidenav><md-sidenav id=\"grade-panel\" \nclass=\"md-sidenav-left md-whiteframe-4dp\" md-component-id=\"grades-panel\" ms-scroll ui-view=\"gradePanel\"></md-sidenav>\n<md-sidenav id=\"parent-panel\" class=\"md-sidenav-left md-whiteframe-4dp\" md-component-id=\"parent-panel\" ms-scroll \nui-view=\"parentPanel\"></md-sidenav><md-sidenav id=\"coordinate-panel\" class=\"md-sidenav-left md-whiteframe-4dp\" \nmd-component-id=\"coordinate-panel\" ms-scroll ui-view=\"coordinatorPanel\"></md-sidenav><md-sidenav id=\"branch-panel\" \nclass=\"md-sidenav-left md-whiteframe-4dp\" md-component-id=\"branch-panel\" ms-scroll ui-view=\"manageBranchesPanel\">\n</md-sidenav><md-sidenav id=\"admin-profile-panel\" class=\"md-sidenav-left md-whiteframe-4dp\" \nmd-component-id=\"admin-profile-panel\" md-is-locked-open ms-scroll ui-view=\"adminProfilePanel\"></md-sidenav><md-sidenav \nid=\"question-panel\" class=\"md-sidenav-left md-whiteframe-4dp\" md-component-id=\"question-panel\" ms-scroll \nui-view=\"questionPanel\"></md-sidenav><md-sidenav id=\"transportation-panel\" class=\"md-sidenav-left md-whiteframe-4dp\" \nmd-component-id=\"transportation-panel\" ms-scroll ui-view=\"transportationPanel\"></md-sidenav><md-sidenav \nid=\"activities-panel\" class=\"md-sidenav-left md-whiteframe-4dp\" md-component-id=\"activities-panel\" ms-scroll \nui-view=\"activitiesPanel\"></md-sidenav><md-sidenav id=\"field-panel\" class=\"md-sidenav-left md-whiteframe-4dp\" \nmd-component-id=\"field-panel\" ms-scroll ui-view=\"fieldPanel\"></md-sidenav><md-sidenav id=\"area-panel\" \nclass=\"md-sidenav-left md-whiteframe-4dp\" md-component-id=\"area-panel\" ms-scroll ui-view=\"areaPanel\"></md-sidenav>\n<md-sidenav id=\"edit-event-question-panel\" class=\"md-sidenav-left md-whiteframe-4dp\" \nmd-component-id=\"edit-event-question-panel\" ms-scroll ui-view=\"editEventQuestionPanel\"></md-sidenav><md-sidenav \nid=\"contact-panel\" class=\"md-sidenav-left md-whiteframe-4dp\" md-component-id=\"contact-panel\" ms-scroll \nui-view=\"contactsPanel\"></md-sidenav><md-sidenav-bottom id=\"save-changes\" class=\"flex-100 md-closed\" \nmd-component-id=\"save-changes\" flex ui-view=\"saveChanges\" tabindex=\"-1\"></md-sidenav-bottom></div><md-content \nng-if=\"!$root.User\" ms-scroll ui-view=\"content\" flex></md-content></div></div>");
$templateCache.put("app/core/directives/ms-info-bar/ms-info-bar.html","<div id=\"ms-info-bar\" layout=\"row\" layout-align=\"start center\" flex><div id=\"ms-info-bar-message\" ng-transclude flex>\n</div><md-button id=\"ms-info-bar-close\" class=\"md-icon-button\" aria-label=\"Close\" ng-click=\"removeInfoBar()\"><md-icon \nmd-font-icon=\"icon-close s24\"></md-icon></md-button></div>");
$templateCache.put("app/core/directives/ms-material-color-picker/ms-material-color-picker.html","<md-menu md-position-mode=\"target-right target\"><div ng-click=\"$mdOpenMenu($event)\"><ms-color-picker-button><md-button \naria-label=\"Row Color\" md-menu-origin ng-click=\"$mdOpenMenu($event)\" ng-class=\"vm.selectedColor.class\"><span \nng-show=\"vm.selectedColor.palette\">{{vm.selectedColor.palette}} {{vm.selectedColor.hue}} </span><span \nng-show=\"!vm.selectedColor.palette\">Select Color</span></md-button></ms-color-picker-button></div><md-menu-content \nclass=\"ms-material-color-picker-menu-content\" layout-column><header \nng-class=\"vm.selectedColor.class || \'md-accent-bg\'\" class=\"md-whiteframe-4dp\" layout=\"row\" \nlayout-align=\"space-between center\"><md-button md-prevent-menu-close ng-click=\"vm.activateHueSelection(false,false)\" \nclass=\"md-icon-button\" ng-class=\"{\'hidden\':!vm.selectedPalette}\" aria-label=\"Palette\"><md-icon \nmd-font-icon=\"icon-arrow-left\" class=\"s20\"></md-icon></md-button><span ng-if=\"vm.selectedColor.palette\">\n{{vm.selectedColor.palette}} {{vm.selectedColor.hue}} </span><span ng-if=\"!vm.selectedColor.palette\">Select Color\n</span><md-button class=\"remove-color-button md-icon-button\" ng-click=\"vm.removeColor()\" aria-label=\"Remove Color\">\n<md-icon md-font-icon=\"icon-delete\" class=\"s20\"></md-icon></md-button></header><div class=\"colors\" ms-scroll><div \nng-show=\"!vm.selectedPalette\" layout=\"row\" layout-wrap><div class=\"color\" ng-class=\"\'md-\'+palette+\'-500-bg\'\" \nng-repeat=\"(palette, hues) in vm.palettes\" ng-click=\"vm.activateHueSelection(palette,hues)\" layout=\"row\" \nlayout-align=\"start end\" md-prevent-menu-close md-ink-ripple><span class=\"label\">{{palette}}</span></div></div><div \nng-show=\"vm.selectedPalette\" layout=\"row\" layout-wrap><div class=\"color\" \nng-class=\"\'md-\'+vm.selectedPalette+\'-\'+hue+\'-bg\'\" ng-repeat=\"(hue, values) in vm.selectedHues\" \nng-click=\"vm.selectColor(vm.selectedPalette,hue)\" layout=\"row\" layout-align=\"start end\" md-ink-ripple><span \nclass=\"label\">{{hue}} </span><i ng-if=\"vm.selectedPalette == vm.selectedColor.palette && hue == vm.selectedColor.hue\" \nclass=\"s16 icon-check\"></i></div></div></div></md-menu-content></md-menu>");
$templateCache.put("app/core/directives/ms-search-bar/ms-search-bar.html","<div flex layout=\"row\" layout-align=\"start center\"><label for=\"ms-search-bar-input\"><md-button \nclass=\"ms-search-bar-expander md-icon-button\" aria-label=\"Expand Search Bar\" ng-click=\"MsSearchBar.expand()\" \nng-if=\"!MsSearchBar.resultsLoading || MsSearchBar.collapsed\"><md-icon md-font-icon=\"icon-magnify\" class=\"icon s24\">\n</md-icon></md-button><div class=\"ms-search-bar-loader\" layout=\"row\" layout-align=\"center center\" \nng-if=\"MsSearchBar.resultsLoading && !MsSearchBar.collapsed\"><md-progress-circular class=\"md-accent\" md-diameter=\"32\" \nmd-mode=\"indeterminate\"></md-progress-circular></div></label><input id=\"ms-search-bar-input\" type=\"text\" \nplaceholder=\"Search\" flex ng-model=\"MsSearchBar.query\" ng-model-options=\"MsSearchBar.queryOptions\" \nng-blur=\"MsSearchBar.collapse()\" ng-keydown=\"MsSearchBar.handleKeydown($event)\"><md-button \nclass=\"ms-search-bar-collapser md-icon-button\" ng-click=\"MsSearchBar.collapse()\" aria-label=\"Collapse Search Bar\">\n<md-icon md-font-icon=\"icon-close\" class=\"icon s24\"></md-icon></md-button><div class=\"ms-search-bar-results\" \nng-if=\"MsSearchBar.results\" ms-scroll><div class=\"no-results\" ng-if=\"MsSearchBar.results.length === 0\">No Results!\n</div><div class=\"result\" ng-repeat=\"result in MsSearchBar.results\" ng-click=\"MsSearchBar.handleResultClick(result)\" \nng-mouseenter=\"MsSearchBar.handleMouseenter($index)\" ng-mousedown=\"MsSearchBar.absorbEvent($event)\" \nng-class=\"{\'selected\': $index == MsSearchBar.selectedResultIndex}\" md-ink-ripple><div layout=\"row\" \nlayout-align=\"start center\"><div class=\"icon-container\" layout=\"row\" layout-align=\"center center\"><i \nng-if=\"result.icon\" class=\"icon {{result.icon}}\"></i><div ng-if=\"!result.icon\" class=\"square md-accent-bg\"></div></div>\n<div><div class=\"title\">{{result.title}}</div><div class=\"description\" ng-if=\"result.description\">\n{{result.description}}</div></div></div></div></div></div>");
$templateCache.put("app/core/directives/ms-shortcuts/ms-shortcuts.html","<div class=\"shortcuts-container\" layout=\"row\" layout-align=\"space-between center\" flex \nng-class=\"{\'mobile-bar-active\': MsShortcuts.mobileBarActive}\"><div class=\"flex-noshrink\" layout=\"row\" \nlayout-align=\"start center\" flex><div class=\"shortcuts hide show-gt-xs\" layout=\"row\" layout-align=\"start center\" \nms-scroll ng-if=\"MsShortcuts.shortcuts.length > 0\" ng-sortable=\"MsShortcuts.sortableOptions\"><div \nng-repeat=\"shortcut in MsShortcuts.shortcuts\" layout=\"row\" layout-align=\"center center\"><md-button \nng-if=\"! shortcut.custom\" class=\"md-icon-button shortcut\" aria-label=\"{{shortcut.title}}\" \nui-sref=\"{{shortcut.uisref}}\"><md-icon ng-if=\"shortcut.icon\" md-font-icon=\"{{shortcut.icon}}\" class=\"icon s24\">\n</md-icon><div ng-if=\"!shortcut.icon\" class=\"first-letter\">{{shortcut.title.charAt(0)}}</div><md-tooltip \nmd-direction=\"left\">{{shortcut.title}}</md-tooltip></md-button><md-button ng-if=\"shortcut.custom\" \nclass=\"md-icon-button shortcut custom\" aria-label=\"{{shortcut.title}}\" ng-click=\"MsShortcuts.moveToShortcut(shortcut)\">\n<md-icon ng-if=\"shortcut.icon\" md-font-icon=\"{{shortcut.icon}}\" class=\"icon s24\"></md-icon><div ng-if=\"!shortcut.icon\" \nclass=\"first-letter\">{{shortcut.title.charAt(0)}}</div><md-tooltip md-direction=\"left\">{{shortcut.title}}</md-tooltip>\n</md-button></div></div><md-menu md-offset=\"8 56\" class=\"shortcut-menu hide show-gt-xs\"><md-button \nclass=\"md-icon-button add-shortcut-button\" aria-label=\"Add shortcut\" title=\"דפים מועדפים\" title-direction=\"bottom\" \nng-click=\"$mdOpenMenu($event)\"><md-icon md-menu-origin md-font-icon=\"icon-star\" class=\"icon amber-600-fg s24\">\n</md-icon></md-button><md-menu-content><div id=\"ms-shortcut-add-menu\"><div class=\"shortcut-add\" layout=\"row\" \nlayout-align=\"start center\"><div class=\"add-icon\" layout=\"row\" layout-align=\"center center\" \nng-if=\"!MsShortcuts.shotcutAddLoading\"><md-icon md-menu-align-target md-font-icon=\"icon-star-outline\" class=\"icon s24\">\n</md-icon></div><div class=\"shortcut-loader\" layout=\"row\" layout-align=\"center center\" \nng-if=\"MsShortcuts.shotcutAddLoading\"><md-progress-circular class=\"md-accent\" md-diameter=\"20\" md-mode=\"indeterminate\">\n</md-progress-circular></div><input type=\"text\" placeholder=\"הוסף דף נוכחי\" flex ng-model=\"MsShortcuts.addName\" \nng-model-options=\"MsShortcuts.queryOptions\" ng-keydown=\"MsShortcuts.handleAddKeyDown($event)\"></div><div \nclass=\"shortcut-search\" layout=\"row\" layout-align=\"start center\"><div class=\"search-icon\" layout=\"row\" \nlayout-align=\"center center\" ng-if=\"!MsShortcuts.resultsLoading\"><md-icon md-menu-align-target \nmd-font-icon=\"icon-magnify\" class=\"icon s24\"></md-icon></div><div class=\"shortcut-loader\" layout=\"row\" \nlayout-align=\"center center\" ng-if=\"MsShortcuts.resultsLoading\"><md-progress-circular class=\"md-accent\" \nmd-diameter=\"20\" md-mode=\"indeterminate\"></md-progress-circular></div><input type=\"text\" placeholder=\"חפש\" flex \nng-model=\"MsShortcuts.query\" ng-model-options=\"MsShortcuts.queryOptions\" \nng-keydown=\"MsShortcuts.handleKeydown($event)\"></div><div class=\"results\" ng-if=\"MsShortcuts.results\" ms-scroll><div \nclass=\"no-results\" ng-if=\"MsShortcuts.results.length === 0\">No Results!</div><div class=\"result\" \nng-repeat=\"result in MsShortcuts.results\" ng-click=\"MsShortcuts.handleResultClick(result)\" \nng-mouseenter=\"MsShortcuts.handleMouseenter($index)\" ng-mousedown=\"MsShortcuts.absorbEvent($event)\" \nng-class=\"{\'selected\': $index == MsShortcuts.selectedResultIndex}\" md-prevent-menu-close=\"md-prevent-menu-close\" \nmd-ink-ripple><div layout=\"row\" layout-align=\"start space-between\"><div layout=\"row\" layout-align=\"start center\" flex>\n<div class=\"icon icon-container\" layout=\"row\" layout-align=\"center center\"><i ng-if=\"result.icon\" \nclass=\"{{result.icon}}\"></i><div ng-if=\"!result.icon\" class=\"square md-accent-bg\"></div></div><div><div class=\"title\">\n{{result.title}}</div></div></div><md-icon md-font-icon=\"icon-pin\" class=\"icon s18\" \nng-class=\"{\'fade-text\': !result.hasShortcut}\"></md-icon></div></div></div></div></md-menu-content></md-menu></div>\n<md-button class=\"md-icon-button toggle-mobile-menu hide-gt-xs\" aria-label=\"Add shortcut\" \nng-click=\"MsShortcuts.toggleMobileBar()\"><md-icon md-menu-origin md-font-icon=\"icon-star\" \nclass=\"icon amber-600-fg s24\" ng-hide=\"MsShortcuts.mobileBarActive\"></md-icon><md-icon md-menu-origin \nmd-font-icon=\"icon-close\" class=\"icon s24\" ng-hide=\"!MsShortcuts.mobileBarActive\"></md-icon></md-button></div>");
$templateCache.put("app/main/apps/dashboard/dashboard.html","<div id=\"dashboard\" class=\"page-layout simple right-sidenav\" layout=\"row\" ng-init=\"vm.init()\"><div class=\"center\" flex \nms-scroll><div class=\"header md-accent-bg\" layout=\"column\" layout-align=\"space-between\"><div layout=\"row\" \nclass=\"welcome-msg\" layout-align=\"space-between\"><span class=\"md-display-1 font-weight-300\">\nשלום {{$root.User.FirstName}}</span></div><div layout=\"row\"><div class=\"selected-dashboard\">{{vm.appConfig.appName}}\n</div><div class=\"select-branch\"><md-select ng-model=\"vm.selectedBranch\" ng-disabled=\"!vm.branches\" \nng-change=\"vm.getStatistics()\" placeholder=\"בחירת {{$root.User.Branch}}\"><md-option ng-value=\"null\">כל הסניפים\n</md-option><md-option ng-repeat=\"branch in vm.branches\" ng-value=\"branch.ID\">{{branch.Name}}</md-option></md-select>\n</div></div></div><div layout=\"row\" layout-sm=\"column\" layout-align=\"space-around\" ng-show=\"!vm.statistics\" \nstyle=\"margin-top: 300px\"><md-progress-circular md-mode=\"indeterminate\"></md-progress-circular></div><div \nclass=\"content\" flex ng-show=\"vm.statistics\"><div class=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap><ms-widget \nflippable=\"true\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\"><ms-widget-front class=\"white-bg\"><div \nclass=\"ph-8 pv-16 h-55\" layout=\"row\" layout-align=\"space-between center\"></div><div class=\"pt-8 pb-32\" layout=\"column\" \nlayout-align=\"center center\"><div class=\"light-blue-fg font-size-72 line-height-72\">\n{{vm.statistics.TotalActiveStudents}}</div><div class=\"h3 secondary-text font-weight-500\">\nמספר חניכים שנרשמו ל{{$root.User.Event}} אחד לפחות בשנה החולפת</div></div><div class=\"p-16\" layout=\"row\" \nlayout-align=\"start center\"></div></ms-widget-front></ms-widget><ms-widget flippable=\"true\" layout=\"column\" flex=\"100\" \nflex-gt-xs=\"50\" flex-gt-md=\"25\"><ms-widget-front class=\"white-bg\"><div class=\"ph-8 pv-16 h-55\" layout=\"row\" \nlayout-align=\"space-between center\"></div><div class=\"pt-8 pb-32\" layout=\"column\" layout-align=\"center center\"><div \nclass=\"light-blue-fg font-size-72 line-height-72\">{{vm.statistics.ActiveStudents}}</div><div \nclass=\"h3 secondary-text font-weight-500\">מספר חניכים פעילים</div></div><div class=\"p-16\" layout=\"row\" \nlayout-align=\"start center\"></div></ms-widget-front></ms-widget><ms-widget flippable=\"true\" layout=\"column\" flex=\"100\" \nflex-gt-xs=\"50\" flex-gt-md=\"25\"><ms-widget-front class=\"white-bg\"><div class=\"ph-8 pv-16 h-55\" layout=\"row\" \nlayout-align=\"space-between center\"></div><div class=\"pt-8 pb-32\" layout=\"column\" layout-align=\"center center\"><div \nclass=\"light-blue-fg font-size-72 line-height-72\">{{vm.statistics.UnActiveStudents}}</div><div \nclass=\"h3 secondary-text font-weight-500\">מספר חניכים לא פעילים</div></div><div class=\"p-16\" layout=\"row\" \nlayout-align=\"start center\"></div></ms-widget-front></ms-widget><ms-widget flippable=\"true\" layout=\"column\" flex=\"100\" \nflex-gt-xs=\"50\" flex-gt-md=\"25\"><ms-widget-front class=\"white-bg\"><div class=\"ph-8 pv-16 h-55\" layout=\"row\" \nlayout-align=\"space-between center\"></div><div class=\"pt-8 pb-32\" layout=\"column\" layout-align=\"center center\"><div \nclass=\"light-blue-fg font-size-72 line-height-72\">{{vm.statistics.GraduatesStudents}}</div><div \nclass=\"h3 secondary-text font-weight-500\">מספר בוגרים</div></div><div class=\"p-16\" layout=\"row\" \nlayout-align=\"start center\"></div></ms-widget-front></ms-widget></div><div class=\"widget-group\" layout=\"row\" \nflex=\"100\" layout-wrap><ms-widget flippable=\"true\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\">\n<ms-widget-front class=\"white-bg\"><div class=\"ph-8 pv-16 h-55\" layout=\"row\" layout-align=\"space-between center\"></div>\n<div class=\"pt-8 pb-32\" layout=\"column\" layout-align=\"center center\"><div \nclass=\"light-blue-fg font-size-72 line-height-72\">{{vm.statistics.Educators}}</div><div \nclass=\"h3 secondary-text font-weight-500\">מספר מדריכים</div></div><div class=\"p-16\" layout=\"row\" \nlayout-align=\"start center\"></div></ms-widget-front></ms-widget><ms-widget flippable=\"true\" layout=\"column\" flex=\"100\" \nflex-gt-xs=\"50\" flex-gt-md=\"25\"><ms-widget-front class=\"white-bg\"><div class=\"ph-8 pv-16 h-55\" layout=\"row\" \nlayout-align=\"space-between center\"></div><div class=\"pt-8 pb-32\" layout=\"column\" layout-align=\"center center\"><div \nclass=\"light-blue-fg font-size-72 line-height-72\">{{vm.statistics.Coordinators}}</div><div \nclass=\"h3 secondary-text font-weight-500\">מספר {{$root.User.Coordinators}}</div></div><div class=\"p-16\" layout=\"row\" \nlayout-align=\"start center\"></div></ms-widget-front></ms-widget><ms-widget flippable=\"true\" layout=\"column\" flex=\"100\" \nflex-gt-xs=\"50\" flex-gt-md=\"25\"><ms-widget-front class=\"white-bg\"><div class=\"ph-8 pv-16 h-55\" layout=\"row\" \nlayout-align=\"space-between center\"></div><div class=\"pt-8 pb-32\" layout=\"column\" layout-align=\"center center\"><div \nclass=\"light-blue-fg font-size-72 line-height-72\">{{vm.statistics.ActiveBranches}}</div><div \nclass=\"h3 secondary-text font-weight-500\">מספר {{$root.User.Branches}} פעילים</div></div><div class=\"p-16\" \nlayout=\"row\" layout-align=\"start center\"></div></ms-widget-front></ms-widget><ms-widget flippable=\"true\" \nlayout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\"><ms-widget-front class=\"white-bg\"><div \nclass=\"ph-8 pv-16 h-55\" layout=\"row\" layout-align=\"space-between center\"></div><div class=\"pt-8 pb-32\" layout=\"column\" \nlayout-align=\"center center\"><div class=\"light-blue-fg font-size-72 line-height-72\">{{vm.statistics.ActiveGroups}}\n</div><div class=\"h3 secondary-text font-weight-500\">מספר {{$root.User.Groups}} {{$root.User.Activity}}</div></div><div\n class=\"p-16\" layout=\"row\" layout-align=\"start center\"></div></ms-widget-front></ms-widget></div><div \nclass=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap><ms-widget layout=\"column\" flex=\"100\" flex-gt-sm=\"50\">\n<ms-widget-front class=\"white-bg\"><div ng-if=\"!vm.selectedBranch\" class=\"h3 p-16\">\nחמשת ה{{$root.User.Branches}} עם מספר ההרשמות הגבוה ביותר בשנה החולפת</div><div ng-if=\"vm.selectedBranch\" \nclass=\"h3 p-16\">מספר ההרשמות ל{{$root.User.Events}} - {{vm.statistics[\'TopBranches\'][\'Labels\'][0]}}</div><md-divider>\n</md-divider><canvas class=\"chart chart-pie\" chart-data=\"vm.statistics.TopBranches.Data\" \nchart-colors=\"vm.statistics.colors\" chart-labels=\"vm.statistics.TopBranches.Labels\" \nchart-options=\"vm.statistics.options\"></canvas></ms-widget-front></ms-widget><ms-widget layout=\"column\" flex=\"100\" \nflex-gt-sm=\"50\"><ms-widget-front class=\"white-bg\"><div class=\"h3 p-16\">\nחמשת ה{{$root.User.Events}}\\מוצרים המבוקשים ביותר בשנה החולפת</div><md-divider></md-divider><canvas \nclass=\"chart chart-pie\" chart-data=\"vm.statistics.TopEvents.Data\" chart-colors=\"vm.statistics.colors2\" \nchart-labels=\"vm.statistics.TopEvents.Labels\" chart-options=\"vm.statistics.options\"></canvas></ms-widget-front>\n</ms-widget></div></div></div></div>");
$templateCache.put("app/main/pages/activities/activities.html","<div id=\"activities\" class=\"page-layout simple tabbed\" ng-init=\"getBranchesAndGroups();\"><div \nclass=\"header md-accent-bg\" layout=\"column\" layout-align=\"center center\" layout-gt-sm=\"row\" \nlayout-align-gt-sm=\"space-between start\"><div class=\"h1\" layout=\"row\" layout-align=\"start center\"><span \nclass=\"md-display-1 font-weight-300\">ניהול {{$root.User.Activities}}</span></div></div><div class=\"content\"><div \nclass=\"action-buttons\"><md-button class=\"md-fab md-accent md-icon-button\" id=\"add-newStudent-button\" \nng-click=\"openNewStudentDialog()\" ng-disabled=\"!activities\" aria-label=\"add systemUser\" \ntitle=\"יצירת {{$root.User.Activity}}\"><md-icon md-font-icon=\"icon-plus\"></md-icon></md-button></div><div layout=\"row\" \nlayout-wrap><div layout=\"column\" flex=\"100\" flex-gt-sm=\"100\" flex-gt-md=\"80\" flex-gt-lg=\"90\"><form name=\"UserForm\" \nclass=\"md-inline-form\" validate><div class=\"filters\" layout=\"row\" layout-xs=\"column\" flex=\"100\" flex-sm=\"100\" \nflex-gt-md=\"50\"><div layout=\"column\" flex=\"100\" flex-gt-sm=\"50\" flex-md=\"33\" flex-xs=\"100\"><md-input-container \nclass=\"md-icon-float md-block\" layout=\"column\" layout-xs=\"row\" flex=\"100\" flex-gt-sm=\"50\" flex-gt-md=\"35\" \nng-show=\"$root.AdminLevel>1\" title=\"התחל לרשום שם {{$root.User.Branch}}\"><label></label><md-icon \nmd-font-icon=\"icon-domain\"></md-icon><md-contact-chips ng-disabled=\"search.freeSearchFromDB\" \nng-model=\"search.branches\" ng-change=\"getGroups()\" md-contacts=\"branchesQuerySearch($query)\" md-contact-name=\"Name\" \nmd-require-match=\"true\" md-highlight-flags=\"i\" filter-selected=\"true\" placeholder=\"בחר {{$root.User.Branches}}\">\n</md-contact-chips></md-input-container></div><div layout=\"column\" flex=\"100\" flex-gt-sm=\"50\" flex-md=\"33\" \nflex-xs=\"100\"><md-input-container class=\"md-icon-float md-block\" ng-show=\"groups && search.branches.length>0\" \nlayout=\"column\" layout-xs=\"row\" flex=\"100\" flex-gt-sm=\"50\" flex-gt-md=\"35\" title=\"התחל לרשום שם {{$root.User.Group}}\">\n<label></label><md-icon md-font-icon=\"icon-account-multiple\"></md-icon><md-contact-chips \nng-disabled=\"search.freeSearchFromDB\" ng-model=\"search.groups\" md-contacts=\"groupsQuerySearch($query)\" \nmd-contact-name=\"Name\" md-require-match=\"true\" md-highlight-flags=\"i\" filter-selected=\"true\" \nplaceholder=\"בחר {{$root.User.Groups}}\"></md-contact-chips></md-input-container></div></div><div class=\"filters\" \nlayout=\"row\" layout-xs=\"column\" flex=\"100\" flex-sm=\"100\" flex-gt-md=\"50\"><div layout=\"column\" flex=\"100\" \nflex-gt-sm=\"50\" flex-md=\"33\" flex-xs=\"100\"><md-input-container class=\"md-icon-float md-block\"><md-icon \nmd-font-icon=\"icon-filter\"></md-icon><md-select ng-model=\"search.status\" placeholder=\"סטטוס {{$root.User.Activity}}\" \nng-disabled=\"!activities\"><md-option ng-value=\"null\">הצג הכל</md-option><md-option ng-value=\"1\" selected=\"selected\">\nפעילים</md-option><md-option ng-value=\"0\">לא פעילים</md-option></md-select></md-input-container></div><div \nlayout=\"column\" flex=\"100\" flex-gt-sm=\"50\" flex-md=\"33\" flex-xs=\"100\"><md-input-container id=\"free-search\" \nclass=\"md-icon-float md-block\"><md-icon md-font-icon=\"icon-magnify\"></md-icon><label>חיפוש חופשי</label><input \nng-model=\"search.freeSearchFromDB\" type=\"search\" ng-disabled=\"!activities\"></md-input-container></div></div><div \nclass=\"search-actions row\" layout=\"row\"><md-button type=\"submit\" \nng-disabled=\"isClicked || !activities || (search.branches.length>0 && search.groups.length==0)\" \nclass=\"md-raised md-accent\" aria-label=\"חפש\" ng-click=\"getActivities()\">סינון</md-button><md-button \nng-disabled=\"isClicked || !activities || (search.branches.length>0 && search.groups.length==0)\" \nclass=\"md-raised md-accent\" aria-label=\"חפש\" ng-click=\"getActivities(true)\">בטל סינון</md-button></div></form></div>\n</div><div layout=\"row\" layout-sm=\"column\" layout-align=\"space-around\" ng-if=\"!activities\"><md-progress-circular \nmd-mode=\"indeterminate\"></md-progress-circular></div><div ng-if=\"activities\" class=\"activities-table-c\"><table \nid=\"activities-table\" class=\"dataTable row-border hover stripe md-ink-ripple\" datatable=\"ng\" dt-instance=\"dtInstance\" \ndt-options=\"dtOptions\"><thead><tr><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">\nשם {{$root.User.Activity}}</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">תאריך</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">{{$root.User.Groups}}</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">סטטוס</span></div></th><th><div class=\"table-header\"><span class=\"column-title\">פעולות</span>\n</div></th></tr></thead><tbody><tr class=\"md-ink-ripple\" ng-repeat=\"item in activities\"><td>{{item.Name}}</td><td>\n{{item.Date}}</td><td>{{item.GroupName}}</td><td>{{item.Status==1 || item.Status==\'1\' ? \'פעיל\' : \'לא פעיל\'}}</td><td>\n<md-button class=\"preview-user\" ng-click=\"openActivitiesPanel(item)\" title=\"עריכה מהירה\"><md-icon md-svg-icon=\"pencil\">\n</md-icon></md-button><md-button class=\"preview-user\" ng-click=\"openActivitiesProfile(item)\" \ntitle=\"פרופיל {{$root.User.Activity}}\"><md-icon md-svg-icon=\"leaf\"></md-icon></md-button></td></tr></tbody></table>\n</div></div></div>");
$templateCache.put("app/main/pages/calendar/calendar.html","<div id=\"calendar\" class=\"page-layout simple right-sidenav\" layout=\"column\" ng-init=\"vm.getEvents()\"><div \nclass=\"center relative\" ms-scroll style=\"height:100%\"><div class=\"loader\" ng-show=\"vm.loading\"><md-progress-circular \nmd-mode=\"indeterminate\"></md-progress-circular></div><calendar-md id=\"calendar-demo\" flex layout layout-fill \non-prev-month=\"vm.getEvents\" on-next-month=\"vm.getEvents\" on-day-click=\"dayClick\" title-format=\"\'MMMM y\'\" \nng-model=\"vm.selectedDate\" day-format=\"vm.dayFormat\" day-label-format=\"\'EEE\'\" day-label-tooltip-format=\"\'EEEE\'\" \nday-tooltip-format=\"\'fullDate\'\" week-starts-on=\"vm.weekStartsOn\" start-date-of-month=\"1\" no-of-days=\"30\" \ntooltips=\"tooltips\" day-content=\"setDayContent\" disable-future-selection=\"disableFutureDates\"></calendar-md></div>\n</div>");
$templateCache.put("app/main/pages/contacts/contacts.html","<div id=\"contacts\" class=\"page-layout simple tabbed\" ng-init=\"vm.getBranches();vm.getGroups()\"><div \nclass=\"header md-accent-bg\" layout=\"column\" layout-align=\"center center\" layout-gt-sm=\"row\" \nlayout-align-gt-sm=\"space-between start\"><div class=\"h1\" layout=\"row\" layout-align=\"start center\"><span \nclass=\"md-display-1 font-weight-300\">אנשי קשר</span></div></div><div class=\"content\"><div class=\"action-buttons\">\n<md-button ng-if=\"$root.AdminLevel==3\" class=\"md-fab md-accent md-icon-button\" id=\"add-newContact-button\" \nng-click=\"vm.createNewContactDialog()\" title=\"הוספת איש קשר\" ng-disabled=\"!vm.contacts\"><md-icon \nmd-font-icon=\"icon-plus\"></md-icon></md-button></div><form class=\"md-inline-form\" validate><div class=\"filters\" \nlayout=\"row\" layout-xs=\"column\" flex=\"100\" flex-sm=\"100\" flex-gt-md=\"50\"><div layout=\"column\" flex=\"100\" \nflex-gt-sm=\"50\" flex-md=\"33\" flex-xs=\"100\"><md-input-container class=\"md-icon-float md-block\"><md-icon \nmd-font-icon=\"icon-filter\"></md-icon><md-select ng-model=\"vm.search.Status\" placeholder=\"סינון לפי סטטוס אנשי קשר\" \nng-init=\"vm.search.Status=1\" ng-disabled=\"!vm.contacts\"><md-option ng-value=\"undefined\">הצג הכל</md-option><md-option \nng-value=\"1\" selected=\"selected\">פעילים</md-option><md-option ng-value=\"0\">לא פעילים</md-option></md-select>\n</md-input-container></div><div layout=\"column\" flex=\"100\" flex-gt-sm=\"50\" flex-md=\"33\" flex-xs=\"100\">\n<md-input-container id=\"free-search\" class=\"md-icon-float md-block\"><md-icon md-font-icon=\"icon-magnify\"></md-icon>\n<label>חיפוש חופשי</label><input ng-model=\"vm.search.freeSearchFromDB\" type=\"search\" ng-disabled=\"!vm.contacts\">\n</md-input-container></div></div><div class=\"search-actions row\" layout=\"row\"><md-button type=\"submit\" \nng-disabled=\"vm.isClicked || !vm.contacts || !vm.branches || !vm.groups\" class=\"md-raised md-accent\" aria-label=\"חפש\" \nng-click=\"vm.getContacts()\">סינון</md-button><md-button \nng-disabled=\"vm.isClicked || !vm.contacts || !vm.branches || !vm.groups\" class=\"md-raised md-accent\" aria-label=\"חפש\" \nng-click=\"vm.getContacts(true)\">בטל סינון</md-button></div></form><div layout=\"row\" layout-sm=\"column\" \nlayout-align=\"space-around\" ng-if=\"!vm.contacts\"><md-progress-circular md-mode=\"indeterminate\"></md-progress-circular>\n</div><div ng-if=\"vm.contacts\"><table id=\"files-table\" class=\"dataTable row-border hover stripe md-ink-ripple\" \ndatatable=\"ng\" dt-instance=\"vm.dtInstance\" dt-options=\"vm.dtOptions\" dt-column-defs=\"vm.dtColumnDefs\"><thead><tr><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">שם</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">טלפון</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">מייל</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">תפקיד</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">סניפים</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">קבוצות</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">תצוגה בפרופיל הורה</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">סטטוס</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">פעולות</span></div></th></tr></thead>\n<tbody><tr class=\"md-ink-ripple\" ng-repeat=\"contact in vm.contacts \"><td>{{contact.Name}}</td><td>{{contact.Phone}}\n</td><td>{{contact.Email}}</td><td>{{contact.Role}}</td><td><md-tooltip md-direction=\"right\" \nng-if=\"contact.branchesString\">{{contact.branchesString}}</md-tooltip>\n{{contact.branchesString.length > 40? contact.branchesString.substr(0,40)+\'...\' : contact.branchesString}}</td><td>\n<md-tooltip md-direction=\"right\" ng-if=\"contact.groupsString\">{{contact.groupsString}}</md-tooltip>\n{{contact.groupsString.length > 40? contact.groupsString.substr(0,40)+\'...\' : contact.groupsString}}</td><td>\n{{contact.ShowInProfile? \'מוצג\' : \'לא מוצג\'}}</td><td>{{contact.Status==1 || contact.Status==\'1\' ? \'פעיל\' : \'לא פעיל\'}}\n</td><td><md-button class=\"preview-user md-icon-button\" ng-click=\"vm.editContact(contact)\" title=\"עריכה\"><md-icon \nmd-svg-icon=\"pencil\"></md-icon></md-button><md-button class=\"preview-user\" \nng-disabled=\"vm.isClicked || $root.AdminLevel!=3\" ng-click=\"vm.deleteContactDialog(contact)\" title=\"מחיקת איש קשר\">\n<md-icon md-svg-icon=\"delete\"></md-icon></md-button></td></tr></tbody></table></div></div></div>");
$templateCache.put("app/main/pages/files/files.html","<div id=\"files\" class=\"page-layout simple tabbed\"><div class=\"header md-accent-bg\" layout=\"column\" \nlayout-align=\"center center\" layout-gt-sm=\"row\" layout-align-gt-sm=\"space-between start\"><div class=\"h1\" layout=\"row\" \nlayout-align=\"start center\"><span class=\"md-display-1 font-weight-300\">קבצים</span></div></div><div class=\"content\">\n<div class=\"action-buttons\"><md-button ng-if=\"$root.AdminLevel==3\" class=\"md-fab md-accent md-icon-button\" \nid=\"add-newFile-button\" ng-click=\"vm.openNewFileDialog()\" title=\"הוספת קובץ\" ng-disabled=\"!vm.files\"><md-icon \nmd-font-icon=\"icon-plus\"></md-icon></md-button></div><form class=\"md-inline-form\" validate><div class=\"filters\" \nlayout=\"row\" layout-xs=\"column\" flex=\"100\" flex-sm=\"100\" flex-gt-md=\"50\"><div layout=\"column\" flex=\"100\" \nflex-gt-sm=\"50\" flex-md=\"33\" flex-xs=\"100\"><md-input-container id=\"free-search\" class=\"md-icon-float md-block\"><md-icon\n md-font-icon=\"icon-magnify\"></md-icon><label>חיפוש חופשי</label><input ng-model=\"vm.search.FreeSearch\" type=\"search\" \nng-disabled=\"!vm.files\"></md-input-container></div></div><div class=\"search-actions row\" layout=\"row\"><md-button \ntype=\"submit\" ng-disabled=\"vm.isClicked || !vm.files \" class=\"md-raised md-accent\" aria-label=\"חפש\" \nng-click=\"vm.getFiles()\">סינון</md-button></div></form><div layout=\"row\" layout-sm=\"column\" \nlayout-align=\"space-around\" ng-if=\"!vm.files\"><md-progress-circular md-mode=\"indeterminate\"></md-progress-circular>\n</div><div ng-if=\"vm.files\"><table id=\"files-table\" class=\"dataTable row-border hover stripe md-ink-ripple\" \ndatatable=\"ng\" dt-instance=\"vm.dtInstance\" dt-options=\"vm.dtOptions\" dt-column-defs=\"vm.dtColumnDefs\"><thead><tr><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">תאריך העלאה</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">סוג קובץ</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">שם קובץ</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">תיאור</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">פעולות</span></div></th></tr></thead>\n<tbody><tr class=\"md-ink-ripple\" ng-repeat=\"file in vm.files \"><td>{{file.Date *1000 | date:\'dd/MM/yyyy\'}}</td><td>\n{{file.Type}}</td><td><a href=\"{{file.Path}}\" target=\"_blank\">{{file.Name}}</a></td><td><md-input-container \nclass=\"md-icon-float md-block\"><label>תיאור</label><input ng-model=\"file.Description\" \nng-disabled=\"vm.isClicked || $root.AdminLevel!=3\" ng-blur=\"vm.updateDescription(file)\"></md-input-container></td><td>\n<md-button class=\"preview-user\" ng-disabled=\"vm.isClicked || $root.AdminLevel!=3\" ng-click=\"vm.deleteFileDialog(file)\" \ntitle=\"מחיקת קובץ\"><md-icon md-svg-icon=\"delete\"></md-icon></md-button></td></tr></tbody></table></div></div></div>");
$templateCache.put("app/main/pages/login/login.html","<div id=\"login\" ng-controller=\"LoginController\" ng-init=\"checkUserToken();getImages()\" ng-show=\"login\"><div \nclass=\"w100 inrowf\"><div id=\"login-form-wrapper\" class=\"fcc\"><div id=\"login-form\" class=\"h100 sflex fdc jcsb\"><div \nclass=\"topdiv\"><div class=\"top\"><div class=\"logo-wrapper\" ng-click=\"evop = evop + 2\" tabindex=\"0\" ng-keydown=\"down()\">\n<img ng-if=\"logo\" src=\"{{logo}}\" alt=\"Logo\" class=\"logo\"></div><div class=\"txt\"><h1 class=\"title hfs20 mb5 fw-medium\">\n{{$root.appName}}</h1></div></div><div class=\"f1 fcc\"><form \nng-keypress=\"[13, 32].includes($event.keyCode) && submit()\" name=\"loginForm\" id=\"loginForm\" class=\"inrowf\"><div \nclass=\"w100 mb30 relative\" ng-if=\"showEmail\"><label for=\"email\">מייל</label><input type=\"email\" id=\"email\" \nng-change=\"checkMail()\" ng-click=\"showErrorEmail = false\" ng-class=\"{error: showErrorEmail}\" ng-disabled=\"loogin\" \nng-model=\"form.email\" placeholder=\"כתובת מייל איתה נרשמת למערכת\"><div class=\"errorMsg\" \nng-class=\"{showError: showErrorEmail}\">כתובת מייל אינה תקינה</div></div><div class=\"w100 mb30 relative\" \nng-if=\"showOtp\"><label for=\"otp\">קוד אימות נשלח לתיבת הדואר האלקטרוני</label><input type=\"number\" id=\"otp\" \nng-click=\"showErrorOtp = false\" ng-class=\"{error: showErrorOtp}\" ng-disabled=\"loogin\" ng-model=\"form.OtpPwd\" \nplaceholder=\"קוד האימות שהתקבל\"><div class=\"errorMsg\" ng-class=\"{showError: showErrorOtp}\">הקוד שגוי</div><div \nclass=\"timer sflex jcsb aic\"><span>{{timerView}}</span> <button ng-click=\"submit()\" type=\"button\" class=\"resendButton\">\nשלח שוב</button></div></div><div class=\"w100 mb30 relative\" ng-if=\"showPwd\"><label for=\"password\">סיסמא</label><span \nclass=\"imginp sflex aic\" ng-class=\"{focus: focused , error: showErrorPassword}\"><input type=\"{{inputType}}\" \nng-change=\"checkPassword()\" ng-click=\"showErrorPassword = false\" ng-init=\"focused = false\" ng-focus=\"focused = true\" \nng-blur=\"focused = false\" ng-disabled=\"loogin\" id=\"password\" ng-model=\"form.password\" \nplaceholder=\"6 תווים (ספרות ואותיות בלועזית)\" required> <span ng-click=\"showHidePassword()\" class=\"showhide hfs13\">\n{{ showHideText }}</span><div class=\"errorMsg\" ng-class=\"{showError: showErrorPassword}\">סיסמא קצרה מדי</div><img \nng-if=\"!showPass\" ng-click=\"showHidePassword()\" src=\"/assets/icons/Show.svg\" alt=\"\"> <img ng-if=\"showPass\" \nng-click=\"showHidePassword()\" src=\"/assets/icons/Hide.svg\" alt=\"\"></span></div><div class=\"w100 inrowf mb30\"><div \nclass=\"w2s20 sflex aic\"><input type=\"checkbox\" name=\"remmber\" ng-model=\"form.remember\" id=\"remmber\"><label \nfor=\"remmber\">זכור אותי</label></div><div class=\"w2s20 sflex jcfe aic\"><a href=\"/reset-password\">שכחת סיסמא?</a></div>\n</div><div class=\"inrowf w100 jcc\"><div class=\"w100 sflex jcc\"><div ng-if=\"loogin\" class=\"loading\" \nng-class=\"{active: loogin}\"><span></span></div></div><button ng-disabled=\"loogin || loginForm.$invalid\" \nng-click=\"submit()\" class=\"stdButton green hfs15 fw-medium\">התחבר</button></div></form></div></div><div id=\"CopyR\" \nclass=\"center hfs15\"><span>Crafted By <a href=\"https://pionet.co.il\" class=\"notme pionet-logo\" target=\"_blank\"><img \nsrc=\"../../../assets/PionetLogo.svg\" alt=\"Pionet\"> </a>© All Rights Reserved</span></div></div></div><div \nng-if=\"backgroundUrl\" class=\"bgbox\" ng-style=\"{\'background-image\':\'url({{backgroundUrl}})\'}\"></div></div><div \nclass=\"errorBox inrowf\" ng-class=\"{show: popError}\"><div class=\"w100 sflex jcc aic\"><span class=\"hfs15\">\nמייל או סיסמא לא נכונים</span> <a href=\"/reset-password\">לחץ לשחזור סיסמא</a> <img src=\"/assets/icons/Close.svg\" \nalt=\"\" ng-click=\"popError = false\"></div></div><div class=\"errorBox inrowf\" ng-class=\"{show: popError2}\"><div \nclass=\"w100 sflex jcc aic\"><span class=\"hfs15\">משתמש חסום. יש להמתין {{TimeToWith}} דקות</span></div></div></div>");
$templateCache.put("app/main/pages/reports/reports.html","<div id=\"reports\" class=\"page-layout simple tabbed\"><div class=\"header md-accent-bg\" layout=\"column\" \nlayout-align=\"center center\" layout-gt-sm=\"row\" layout-align-gt-sm=\"space-between start\"><div class=\"h1\" layout=\"row\" \nlayout-align=\"start center\"><span class=\"md-display-1 font-weight-300\">דוחות</span></div></div><div class=\"content\">\n<div class=\"action-buttons\"><md-button class=\"md-fab md-accent md-icon-button\" id=\"add-newReport-button\" \nng-click=\"openNewReportDialog()\" title=\"יצירת דוח\" ng-disabled=\"!reports\"><md-icon md-font-icon=\"icon-plus\"></md-icon>\n</md-button></div><form class=\"md-inline-form\" validate><div class=\"filters\" layout=\"row\" layout-xs=\"column\" \nflex=\"100\" flex-sm=\"100\" flex-gt-md=\"50\"><div layout=\"column\" flex=\"100\" flex-gt-sm=\"50\" flex-md=\"33\" flex-xs=\"100\">\n<md-input-container id=\"free-search\" class=\"md-icon-float md-block\"><md-icon md-font-icon=\"icon-magnify\"></md-icon>\n<label>חיפוש חופשי</label><input ng-model=\"search.FreeSearch\" type=\"search\" ng-disabled=\"!reports\">\n</md-input-container></div></div><div class=\"search-actions row\" layout=\"row\"><md-button type=\"submit\" \nng-disabled=\"isClicked\" class=\"md-raised md-accent\" aria-label=\"חפש\" ng-click=\"getReports()\">סינון</md-button></div>\n</form><div layout=\"row\" layout-sm=\"column\" layout-align=\"space-around\" ng-if=\"!reports\"><md-progress-circular \nmd-mode=\"indeterminate\"></md-progress-circular></div><div ng-if=\"reports\"><table id=\"reports-table\" \nclass=\"dataTable row-border hover stripe md-ink-ripple\" datatable=\"ng\" dt-instance=\"dtInstance\" dt-options=\"dtOptions\">\n<thead><tr><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">שם</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">סוג דוח</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">{{$root.User.Branches}}</span></div></th>\n<th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">{{$root.User.Groups}}</span></div></th>\n<th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">{{$root.User.Grades}}</span></div></th>\n<th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">אזורים</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">שדות להצגה</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">פעולות</span></div></th></tr></thead>\n<tbody><tr class=\"md-ink-ripple\" ng-repeat=\"report in reports \"><td>{{report.Name}}</td><td>{{report.Type}}</td><td>\n<span ng-if=\"!report.Branches.length\">כולם</span> <span ng-repeat=\"branch in report.Branches\">{{branch.Name}}<span>\n{{$last ? \'\' : \', \'}}</span></span></td><td><span ng-if=\"!report.Groups\">כולם</span> <span \nng-repeat=\"group in report.Groups\">{{group.Name}}<span>{{$last ? \'\' : \', \'}}</span></span></td><td><span \nng-if=\"!report.Grades.length\">כולם</span> <span ng-repeat=\"grade in report.Grades\">{{grade.Name}}<span>\n{{$last ? \'\' : \', \'}}</span></span></td><td><span ng-if=\"!report.Areas.length\">כולם</span> <span \nng-repeat=\"area in report.Areas\">{{area.Name}}<span>{{$last ? \'\' : \', \'}}</span></span></td><td><span \nng-if=\"report.Fields.length>0\">לפי בחירה</span> <span ng-if=\"!report.Fields\">הכל</span></td><td><md-button \nclass=\"preview-user\" ng-disabled=\"isClicked\" ng-click=\"exportReport(report)\">ייצא</md-button><md-button \nclass=\"preview-user\" ng-disabled=\"isClicked\" ng-click=\"deleteReportDialog(report)\">מחק</md-button></td></tr></tbody>\n</table></div></div></div>");
$templateCache.put("app/main/pages/settings/settings.html","<div id=\"new-settings\" class=\"page-layout simple tabbed\" ng-init=\"getReports()\"><div class=\"header md-accent-bg\" \nlayout=\"column\" layout-align=\"center center\" layout-gt-sm=\"row\" layout-align-gt-sm=\"space-between start\"><div \nclass=\"h1\" layout=\"row\" layout-align=\"start center\"><span class=\"md-display-1 font-weight-300\">הגדרות מערכת</span>\n</div></div><div class=\"content\"><md-tabs md-dynamic-height md-selected=\"selectedTab\"><md-tab><md-tab-label><span>\nהעלאת {{$root.User.Grade}}</span></md-tab-label><md-tab-body><md-content class=\"about-tab\" \nng-include=\"\'app/main/pages/settings/tabs/grade-upgrade/grade-upgrade.html\'\"></md-content></md-tab-body></md-tab>\n<md-tab><md-tab-label><span>תגיות</span></md-tab-label><md-tab-body><md-content class=\"family-tab\" \nng-include=\"\'app/main/pages/settings/tabs/tags/tags.html\'\"></md-content></md-tab-body></md-tab><md-tab><md-tab-label>\n<span>טפסים</span></md-tab-label><md-tab-body><md-content class=\"family-tab\" \nng-include=\"\'app/main/pages/settings/tabs/forms/forms.html\'\"></md-content></md-tab-body></md-tab><md-tab><md-tab-label>\n<span>הנהלת חשבונות</span></md-tab-label><md-tab-body><md-content class=\"family-tab\" \nng-include=\"\'app/main/pages/settings/tabs/accountancy/accountancy.html\'\"></md-content></md-tab-body></md-tab><md-tab>\n<md-tab-label><span>הגדרות תוכנה</span></md-tab-label><md-tab-body><md-content class=\"family-tab\" \nng-include=\"\'app/main/pages/settings/tabs/system/system.html\'\"></md-content></md-tab-body></md-tab><md-tab>\n<md-tab-label><span>הגדרות פרופיל</span></md-tab-label><md-tab-body><md-content class=\"family-tab\" \nng-include=\"\'app/main/pages/settings/tabs/profile/profile.html\'\"></md-content></md-tab-body></md-tab><md-tab>\n<md-tab-label><span>מייל יום הולדת</span></md-tab-label><md-tab-body><md-content class=\"family-tab\" \nng-include=\"\'app/main/pages/settings/tabs/birthday/birthday.html\'\"></md-content></md-tab-body></md-tab><md-tab>\n<md-tab-label><span>תנאי שימוש - פרופיל</span></md-tab-label><md-tab-body><md-content class=\"family-tab\" \nng-include=\"\'app/main/pages/settings/tabs/terms/terms.html\'\"></md-content></md-tab-body></md-tab><md-tab><md-tab-label>\n<span>קבלות</span></md-tab-label><md-tab-body><md-content class=\"family-tab\" \nng-include=\"\'app/main/pages/settings/tabs/receipts/receipts.html\'\"></md-content></md-tab-body></md-tab><md-tab \nng-if=\"externalEventsEnabled\"><md-tab-label><span>הגדרות הרשמה חיצונית</span></md-tab-label><md-tab-body><md-content \nclass=\"family-tab\" ng-include=\"\'app/main/pages/settings/tabs/external-registerations/settings.html\'\"></md-content>\n</md-tab-body></md-tab><md-tab><md-tab-label><span>הגדרות רכזים</span></md-tab-label><md-tab-body><md-content \nclass=\"family-tab\" ng-include=\"\'app/main/pages/settings/tabs/coordinator-settings/coordinator-settings.html\'\">\n</md-content></md-tab-body></md-tab><md-tab><md-tab-label><span>הגדרות מדריכים</span></md-tab-label><md-tab-body>\n<md-content class=\"family-tab\" ng-include=\"\'app/main/pages/settings/tabs/educator-settings/educator-settings.html\'\">\n</md-content></md-tab-body></md-tab></md-tabs></div></div>");
$templateCache.put("app/main/pages/save-changes/save-changes.html","<md-content><div layout=\"row\" layout-align=\"space-between center\"><span layout-align=\"start center\"><span \nng-if=\"values.length == 1\">שדה 1 שונה האם ברצונך לשמור אותו?</span> <span ng-if=\"values.length > 1\">\n{{values.length}} שדות שונו, האם ברצונך לשמור אותם?</span> </span><span layout-align=\"end center\"><md-button \nclass=\"md-accent md-raised md-button md-ink-ripple\" aria-label=\"שמירה\" ng-click=\"editObject()\">שמירה</md-button>\n<md-button class=\"md-primary md-raised md-button md-ink-rippl\" aria-label=\"ביטול\" ng-click=\"closeWithOutSaving()\">ביטול\n</md-button></span></div></md-content>");
$templateCache.put("app/main/ui/forms/forms.html","<div id=\"forms\" class=\"page-layout simple fullwidth doc-page\" layout=\"column\"><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"space-between\"><div class=\"breadcrumb\" \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-home\" class=\"s16\"></md-icon><md-icon \nmd-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">USER INTERFACE</span></div><div \nclass=\"title\">Forms</div></div></div><div class=\"content\" layout=\"column\"><div class=\"md-title\">Stepper</div><div \nclass=\"pb-16\"><b>ms-stepper</b>\n is a custom made form wizard directive. It follows Google\'s Material Design specifications and we recommend you to use it. If for some reason, it\'s not suitable for your project, you can always use the Form Wizard that we put together using md-tabs and forms.\n</div><form name=\"horizontalStepper\" ms-horizontal-stepper ng-submit=\"vm.submitHorizontalStepper()\" \nng-model=\"vm.horizontalStepper\" novalidate><ms-horizontal-stepper-step ng-form=\"horizontalStep1\" step=\"1\" \nstep-title=\"\'Personal Information\'\"><div ng-include=\"\'app/main/ui/forms/stepper-steps/horizontal/step-1.html\'\"></div>\n</ms-horizontal-stepper-step><ms-horizontal-stepper-step ng-form=\"horizontalStep2\" step=\"2\" step-title=\"\'Birthplace\'\" \noptional-step hide-step=\"!vm.horizontalStepper.step1.lastname\"><div \nng-include=\"\'app/main/ui/forms/stepper-steps/horizontal/step-2.html\'\"></div></ms-horizontal-stepper-step>\n<ms-horizontal-stepper-step ng-form=\"horizontalStep3\" step=\"3\" step-title=\"\'SSN\'\" optional-step \nhide-step=\"!vm.horizontalStepper.step2.birthplace\"><div \nng-include=\"\'app/main/ui/forms/stepper-steps/horizontal/step-3.html\'\"></div></ms-horizontal-stepper-step>\n<ms-horizontal-stepper-step ng-form=\"horizontalStep4\" step=\"4\" step-title=\"\'Address\'\" optional-step><div \nng-include=\"\'app/main/ui/forms/stepper-steps/horizontal/step-4.html\'\"></div></ms-horizontal-stepper-step>\n<ms-horizontal-stepper-step ng-form=\"horizontalStep5\" step=\"5\" step-title=\"\'Payment Method\'\"><div \nng-include=\"\'app/main/ui/forms/stepper-steps/horizontal/step-5.html\'\"></div></ms-horizontal-stepper-step></form><div \nclass=\"mv-24\"></div><form name=\"verticalStepper\" ms-vertical-stepper ng-submit=\"vm.submitVerticalStepper()\" \nng-model=\"vm.verticalStepper\" novalidate><ms-vertical-stepper-step ng-form=\"verticalStep1\" step=\"1\" \nstep-title=\"\'Personal Information\'\"><div ng-include=\"\'app/main/ui/forms/stepper-steps/vertical/step-1.html\'\"></div>\n</ms-vertical-stepper-step><ms-vertical-stepper-step ng-form=\"verticalStep2\" step=\"2\" step-title=\"\'Birthplace\'\" \noptional-step hide-step=\"!vm.verticalStepper.step1.lastname\"><div \nng-include=\"\'app/main/ui/forms/stepper-steps/vertical/step-2.html\'\"></div></ms-vertical-stepper-step>\n<ms-vertical-stepper-step ng-form=\"verticalStep3\" step=\"3\" step-title=\"\'SSN\'\" optional-step \nhide-step=\"!vm.verticalStepper.step2.birthplace\"><div \nng-include=\"\'app/main/ui/forms/stepper-steps/vertical/step-3.html\'\"></div></ms-vertical-stepper-step>\n<ms-vertical-stepper-step ng-form=\"verticalStep4\" step=\"4\" step-title=\"\'Address\'\" optional-step><div \nng-include=\"\'app/main/ui/forms/stepper-steps/vertical/step-4.html\'\"></div></ms-vertical-stepper-step>\n<ms-vertical-stepper-step ng-form=\"verticalStep5\" step=\"5\" step-title=\"\'Payment Method\'\"><div \nng-include=\"\'app/main/ui/forms/stepper-steps/vertical/step-5.html\'\"></div></ms-vertical-stepper-step></form><div \nclass=\"md-title mt-32\">Form Wizard</div><div class=\"pb-16\">\nForm wizard is a combination of md-tabs and forms that we have created for you. You can have as many steps as you want.\n</div><div layout=\"row\"><ms-form-wizard flex><md-tabs md-dynamic-height md-selected=\"msWizard.selectedIndex\" \nmd-center-tabs=\"true\"><md-tab><md-tab-label><span class=\"ms-form-wizard-step-label\"><span \nclass=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep1.$invalid\">1</span> <span \nclass=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep1.$valid\"><i class=\"icon-check s16\"></i> </span><span \nclass=\"ms-form-wizard-step-text\">Personal Information</span></span></md-tab-label><md-tab-body><form \nname=\"wizardStep1\" class=\"md-inline-form\" ms-form-wizard-form novalidate><div layout=\"column\" layout-gt-xs=\"row\" flex>\n<md-input-container flex=\"100\" flex-gt-xs=\"50\"><input type=\"text\" name=\"firstname\" ng-model=\"vm.formWizard.firstname\" \nplaceholder=\"Firstname\" required><div ng-messages=\"wizardStep1.firstname.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Firstname field is required.</span></div></div></md-input-container><md-input-container \nflex=\"100\" flex-gt-xs=\"50\"><input type=\"text\" name=\"lastname\" ng-model=\"vm.formWizard.lastname\" placeholder=\"Lastname\" \nrequired><div ng-messages=\"wizardStep1.lastname.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nLastname field is required.</span></div></div></md-input-container></div><md-input-container class=\"md-block\"><input \ntype=\"email\" name=\"email\" ng-model=\"vm.formWizard.email\" placeholder=\"Email\" ng-pattern=\"/^.+@.+\\..+$/\" required><div \nng-messages=\"wizardStep1.email.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span>\nEmail field is required</span></div><div ng-message=\"pattern\"><span>Email must be a valid e-mail address</span></div>\n</div></md-input-container><div layout=\"column\" layout-gt-sm=\"row\" flex><md-input-container flex=\"100\" flex-gt-xs=\"50\">\n<input type=\"password\" name=\"password\" ng-model=\"vm.formWizard.password\" placeholder=\"Password\" required><div \nng-messages=\"wizardStep1.password.$error\" role=\"alert\"><div ng-message=\"required\"><span>Password field is required.\n</span></div></div></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><input type=\"password\" \nname=\"passwordConfirm\" ng-model=\"vm.formWizard.passwordConfirm\" placeholder=\"Password (Confirm)\" required><div \nng-messages=\"wizardStep1.passwordConfirm.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nPassword (Confirm) field is required.</span></div></div></md-input-container></div></form></md-tab-body></md-tab>\n<md-tab ng-disabled=\"wizardStep1.$invalid\"><md-tab-label><span class=\"ms-form-wizard-step-label\"><span \nclass=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep2.$invalid\">2</span> <span \nclass=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep2.$valid\"><i class=\"icon-check s16\"></i> </span><span \nclass=\"ms-form-wizard-step-text\">Address</span></span></md-tab-label><md-tab-body><form name=\"wizardStep2\" \nms-form-wizard-form novalidate><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex><label>City</label>\n<input type=\"text\" name=\"city\" ng-model=\"vm.formWizard.city\"></md-input-container><md-input-container flex><label>State\n</label><md-select ng-model=\"vm.formWizard.state\"><md-option ng-repeat=\"state in vm.states\" value=\"{{state.abbrev}}\">\n{{state.abbrev}}</md-option></md-select></md-input-container><md-input-container flex><label>Postal Code</label><input \nname=\"postalcode\" ng-model=\"vm.formWizard.postalCode\" placeholder=\"12345\" required ng-pattern=\"/^[0-9]{5}$/\" \nmd-maxlength=\"5\"><div ng-messages=\"wizardStep2.postalcode.$error\" role=\"alert\" multiple=\"multiple\"><div \nng-message=\"required\"><span>You must supply a postal code.</span></div><div ng-message=\"pattern\"><span>\nThat doesn\'t look like a valid postal code.</span></div><div ng-message=\"md-maxlength\"><span>\nPostal code can\'t be longer than 5 characters.</span></div></div></md-input-container></div><md-input-container \nclass=\"md-block\"><label>Address</label><textarea ng-model=\"vm.formWizard.address\" md-maxlength=\"150\" max-rows=\"5\" \nrequired></textarea><div ng-messages=\"wizardStep2.address.$error\" role=\"alert\" multiple=\"multiple\"><div \nng-message=\"required\"><span>Address field is required.</span></div><div ng-message=\"md-maxlength\"><span>\nAddress can\'t be longer than 150 characters.</span></div></div></md-input-container></form></md-tab-body></md-tab>\n<md-tab ng-disabled=\"wizardStep1.$invalid || wizardStep2.$invalid\"><md-tab-label><span \nclass=\"ms-form-wizard-step-label\"><span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep3.$invalid\">3\n</span> <span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep3.$valid\"><i class=\"icon-check s16\"></i>\n </span><span class=\"ms-form-wizard-step-text\">Payment Method</span></span></md-tab-label><md-tab-body><form \nname=\"wizardStep3\" ms-form-wizard-form novalidate><md-input-container class=\"md-block\"><input type=\"text\" \nname=\"cardholder\" ng-model=\"vm.formWizard.cardholder\" placeholder=\"Card Holder\" required><div \nng-messages=\"wizardStep3.cardholder.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nCard holder field is required.</span></div></div></md-input-container><div layout=\"column\" layout-gt-xs=\"row\">\n<md-input-container flex=\"100\" flex-gt-xs=\"33\"><input type=\"text\" name=\"cardnumber\" \nng-model=\"vm.formWizard.cardnumber\" placeholder=\"Card Number\" required><div \nng-messages=\"wizardStep3.cardnumber.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nCard number field is required.</span></div></div></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"33\">\n<input type=\"text\" name=\"CC2\" ng-model=\"vm.formWizard.cc2\" placeholder=\"CC2\" md-maxlength=\"3\" required><div \nng-messages=\"wizardStep3.cc2.$error\" role=\"alert\" multipl><div ng-message=\"required\"><span>CC2 field is required.\n</span></div><div ng-message=\"md-maxlength\"><span>CC2 can\'t be longer than 3 characters.</span></div></div>\n</md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"33\"><input type=\"text\" name=\"expirationDate\" \nng-model=\"vm.formWizard.expirationDate\" placeholder=\"Expiration Date\" required><div \nng-messages=\"wizardStep3.expirationDate.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nExpiration date field is required.</span></div></div></md-input-container></div></form></md-tab-body></md-tab>\n</md-tabs><div class=\"navigation\" flex layout=\"row\" layout-align=\"center center\"><md-button \nclass=\"md-raised md-accent\" ng-click=\"msWizard.previousStep()\" ng-disabled=\"msWizard.isFirstStep()\">Previous\n</md-button><div class=\"steps\"><span ng-repeat=\"form in msWizard.forms\" \nng-class=\"{\'selected md-accent-bg\':msWizard.selectedIndex === $index}\"></span></div><md-button \nclass=\"md-raised md-accent\" ng-click=\"msWizard.nextStep()\" ng-hide=\"msWizard.isLastStep()\" \nng-disabled=\"msWizard.currentStepInvalid()\">Next</md-button><md-button class=\"md-raised md-warn\" \nng-click=\"vm.sendForm(); msWizard.resetForm();\" ng-show=\"msWizard.isLastStep()\" \nng-disabled=\"msWizard.formsIncomplete()\">Send</md-button></div></ms-form-wizard></div><div class=\"md-title mt-32\">\nBasic form with validation</div><div class=\"pb-16\">\nWith this form example, Submit button will only be activated if all the required fields are filled and if there is no error on the form.\n</div><div layout=\"row\"><div class=\"form-wrapper md-whiteframe-1dp\" flex=\"60\"><form name=\"basicForm\" \nclass=\"md-inline-form\" novalidate><div class=\"form-title\">Optional form title</div><div layout=\"column\" \nlayout-gt-sm=\"row\"><md-input-container flex><input type=\"text\" name=\"firstname\" ng-model=\"vm.basicForm.firstname\" \nplaceholder=\"Firstname\" required><div ng-messages=\"basicForm.firstname.$error\" role=\"alert\"><div ng-message=\"required\">\n<span>Firstname field is required.</span></div></div></md-input-container><md-input-container flex><input type=\"text\" \nname=\"lastname\" ng-model=\"vm.basicForm.lastname\" placeholder=\"Lastname\" required><div \nng-messages=\"basicForm.lastname.$error\" role=\"alert\"><div ng-message=\"required\"><span>Lastname field is required.\n</span></div></div></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex><label>\nCity</label><input type=\"text\" name=\"city\" ng-model=\"vm.basicForm.city\"></md-input-container><md-input-container flex>\n<label>State</label><md-select ng-model=\"vm.basicForm.state\"><md-option ng-repeat=\"state in vm.states\" \nvalue=\"{{state.abbrev}}\">{{state.abbrev}}</md-option></md-select></md-input-container><md-input-container flex><label>\nPostal Code</label><input name=\"postalcode\" ng-model=\"vm.basicForm.postalCode\" placeholder=\"12345\" required \nng-pattern=\"/^[0-9]{5}$/\" md-maxlength=\"5\"><div ng-messages=\"basicForm.postalcode.$error\" role=\"alert\" \nmultiple=\"multiple\"><div ng-message=\"required\"><span>You must supply a postal code.</span></div><div \nng-message=\"pattern\"><span>That doesn\'t look like a valid postal code.</span></div><div ng-message=\"md-maxlength\">\n<span>Postal code can\'t be longer than 5 characters.</span></div></div></md-input-container></div><md-input-container \nclass=\"md-block\"><label>Biography</label><textarea ng-model=\"vm.basicForm.biography\" md-maxlength=\"150\" max-rows=\"5\">\n</textarea></md-input-container><md-button type=\"submit\" class=\"md-raised md-accent\" aria-label=\"Submit\" \nng-disabled=\"basicForm.$invalid || basicForm.$pristine\">Submit</md-button></form></div><div \nclass=\"form-wrapper form-data-wrapper md-whiteframe-1dp\" flex=\"40\"><div class=\"form-title\">Form ng-model data</div><div\n class=\"json-data-wrapper\"><pre>{{vm.basicForm | json}}</pre></div></div></div></div></div>");
$templateCache.put("app/main/ui/icons/icons.html","<div id=\"icons\" class=\"page-layout simple fullwidth doc-page\" layout=\"column\"><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\"><div class=\"breadcrumb\" \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-home\" class=\"s16\"></md-icon><md-icon \nmd-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">USER INTERFACE</span></div><div \nclass=\"title\">Icons</div></div><div layout=\"row\" layout-align=\"start center\"><md-button \nclass=\"md-raised reference-button\" href=\"https://materialdesignicons.com/\" target=\"_blank\"><md-icon \nmd-font-icon=\"icon-link\"></md-icon><span>Reference</span></md-button></div></div><div class=\"content\" layout=\"column\">\n<md-input-container class=\"md-block\"><label>Search an icon</label><input ng-model=\"vm.searchText\"></md-input-container>\n<div id=\"icons-list\" class=\"card md-whiteframe-1dp\" layout=\"row\" layout-wrap><div class=\"item\" \nng-repeat=\"icon in vm.icons | filter:{properties: {name:vm.searchText}} track by icon.properties.id\" \nlayout-align=\"start center\"><i class=\"icon icon-{{::icon.properties.name}} s40\"></i><div \nclass=\"name secondary-text text-center\">icon-{{::icon.properties.name}}</div></div></div></div></div>");
$templateCache.put("app/main/ui/helper-classes/helper-classes.html","<div id=\"helper-classes\" class=\"page-layout simple tabbed doc-page\" layout=\"column\"><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\"><div class=\"breadcrumb\" \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-home\" class=\"s16\"></md-icon><md-icon \nmd-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">USER INTERFACE</span></div><div \nclass=\"title\">Helper Classes</div></div></div><div class=\"content\" layout=\"column\"><md-tabs md-dynamic-height><md-tab \nlabel=\"Padding & Margin Helpers\"><div class=\"md-title\">Padding Helpers</div><div class=\"card md-whiteframe-4dp\" \nlayout=\"column\"><div layout=\"column\" layout-gt-md=\"row\"><div class=\"preview\" layout=\"column\" layout-align=\"center\" \nflex=\"50\"><span>no-padding</span></div><hljs lang=\"html\" class=\"source-code\" layout=\"column\" layout-align=\"center\" \nflex=\"50\"><span class=\"no-padding\">No padding</span></hljs></div><div layout=\"column\" layout-gt-md=\"row\"><div \nclass=\"preview\" layout=\"column\" layout-align=\"center\" flex=\"50\"><div class=\"md-caption mb-16\">Multiples of 5, Max:100\n</div><span>padding-(5x)</span></div><hljs lang=\"html\" class=\"source-code\" layout=\"column\" layout-align=\"center\" \nflex=\"50\"><span class=\"padding-5\">5px padding</span></hljs></div><div layout=\"column\" layout-gt-md=\"row\"><div \nclass=\"preview\" layout=\"column\" layout-align=\"center\" flex=\"50\"><div class=\"md-caption mb-16\">Multiples of 5, Max:100\n</div><span>p-(5x)</span></div><hljs lang=\"html\" class=\"source-code\" layout=\"column\" layout-align=\"center\" flex=\"50\">\n<span class=\"p-15\">15px padding</span></hljs></div><div layout=\"column\" layout-gt-md=\"row\"><div class=\"preview\" \nlayout=\"column\" layout-align=\"center\" flex=\"50\"><div class=\"md-caption mb-16\">Multiples of 8, Max:96</div><span>\npadding-(8x)</span></div><hljs lang=\"html\" class=\"source-code\" layout=\"column\" layout-align=\"center\" flex=\"50\"><span \nclass=\"padding-8\">8px padding</span></hljs></div><div layout=\"column\" layout-gt-md=\"row\"><div class=\"preview\" \nlayout=\"column\" layout-align=\"center\" flex=\"50\"><div class=\"md-caption mb-16\">Multiples of 8, Max:96</div><span>p-(8x)\n</span></div><hljs lang=\"html\" class=\"source-code\" layout=\"column\" layout-align=\"center\" flex=\"50\"><span class=\"p-32\">\n32px padding</span></hljs></div></div><div class=\"md-title\">Direction Specific Padding Helpers</div><div \nclass=\"card md-whiteframe-4dp\" layout=\"column\"><div layout=\"column\" layout-gt-md=\"row\"><div class=\"preview\" \nlayout=\"column\" layout-align=\"center\" flex=\"50\"><div class=\"md-caption mb-16\">Multiples of 5, Max:100</div><span>\npadding-top-(5x)</span> <span>padding-right-(5x)</span> <span>padding-bottom-(5x)</span> <span>padding-left-(5x)</span>\n <span>padding-horizontal-(5x)</span> <span>padding-vertical-(5x)</span></div><hljs lang=\"html\" class=\"source-code\" \nlayout=\"column\" layout-align=\"center\" flex=\"50\"><span class=\"padding-top-5\">5px from top</span> <span \nclass=\"padding-right-25\">25px from right</span> <span class=\"padding-bottom-10\">10px from bottom</span> <span \nclass=\"padding-left-20\">20px from left</span> <span class=\"padding-horizontal-5\">5px from left and right</span> <span \nclass=\"padding-vertical-5\">5px from top and bottom</span></hljs></div><div layout=\"column\" layout-gt-md=\"row\"><div \nclass=\"preview\" layout=\"column\" layout-align=\"center\" flex=\"50\"><div class=\"md-caption mb-16\">Multiples of 5, Max:100\n</div><span>pt-(5x)</span> <span>pr-(5x)</span> <span>pb-(5x)</span> <span>pl-(5x)</span> <span>ph-(5x)</span> <span>\npv-(5x)</span></div><hljs lang=\"html\" class=\"source-code\" layout=\"column\" layout-align=\"center\" flex=\"50\"><span \nclass=\"pt-5\">5px from top</span> <span class=\"pr-25\">25px from right</span> <span class=\"pb-10\">10px from bottom</span>\n <span class=\"pl-20\">20px from left</span> <span class=\"ph-5\">5px from left and right</span> <span class=\"pv-5\">\n5px from top and bottom</span></hljs></div><div layout=\"column\" layout-gt-md=\"row\"><div class=\"preview\" \nlayout=\"column\" layout-align=\"center\" flex=\"50\"><div class=\"md-caption mb-16\">Multiples of 8, Max:96</div><span>\npadding-top-(8x)</span> <span>padding-right-(8x)</span> <span>padding-bottom-(8x)</span> <span>padding-left-(8x)</span>\n <span>padding-horizontal-(8x)</span> <span>padding-vertical-(8x)</span></div><hljs lang=\"html\" class=\"source-code\" \nlayout=\"column\" layout-align=\"center\" flex=\"50\"><span class=\"padding-top-8\">8px from top</span> <span \nclass=\"padding-right-24\">24px from right</span> <span class=\"padding-bottom-16\">16px from bottom</span> <span \nclass=\"padding-left-8\">8px from left</span> <span class=\"padding-horizontal-8\">8px from left and right</span> <span \nclass=\"padding-vertical-8\">8px from top and bottom</span></hljs></div><div layout=\"column\" layout-gt-md=\"row\"><div \nclass=\"preview\" layout=\"column\" layout-align=\"center\" flex=\"50\"><div class=\"md-caption mb-16\">Multiples of 8, Max:96\n</div><span>pt-(8x)</span> <span>pr-(8x)</span> <span>pb-(8x)</span> <span>pl-(8x)</span> <span>ph-(8x)</span> <span>\npv-(8x)</span></div><hljs lang=\"html\" class=\"source-code\" layout=\"column\" layout-align=\"center\" flex=\"50\"><span \nclass=\"pt-8\">8px from top</span> <span class=\"pr-24\">24px from right</span> <span class=\"pb-16\">16px from bottom</span>\n <span class=\"pl-8\">8px from left</span> <span class=\"ph-8\">8px from left and right</span> <span class=\"pv-8\">\n8px from top and bottom</span></hljs></div></div><div class=\"md-title\">Margin Helpers</div><div \nclass=\"card md-whiteframe-4dp\" layout=\"column\"><div layout=\"column\" layout-gt-md=\"row\"><div class=\"preview\" \nlayout=\"column\" layout-align=\"center\" flex=\"50\"><span>no-margin</span></div><hljs lang=\"html\" class=\"source-code\" \nlayout=\"column\" layout-align=\"center\" flex=\"50\"><span class=\"no-margin\">No margin</span></hljs></div><div \nlayout=\"column\" layout-gt-md=\"row\"><div class=\"preview\" layout=\"column\" layout-align=\"center\" flex=\"50\"><div \nclass=\"md-caption mb-16\">Multiples of 5, Max:100</div><span>margin-(5x)</span></div><hljs lang=\"html\" \nclass=\"source-code\" layout=\"column\" layout-align=\"center\" flex=\"50\"><span class=\"margin-5\">5px margin</span></hljs>\n</div><div layout=\"column\" layout-gt-md=\"row\"><div class=\"preview\" layout=\"column\" layout-align=\"center\" flex=\"50\"><div\n class=\"md-caption mb-16\">Multiples of 5, Max:100</div><span>m-(5x)</span></div><hljs lang=\"html\" class=\"source-code\" \nlayout=\"column\" layout-align=\"center\" flex=\"50\"><span class=\"m-15\">15px margin</span></hljs></div><div layout=\"column\" \nlayout-gt-md=\"row\"><div class=\"preview\" layout=\"column\" layout-align=\"center\" flex=\"50\"><div class=\"md-caption mb-16\">\nMultiples of 8, Max:96</div><span>margin-(8x)</span></div><hljs lang=\"html\" class=\"source-code\" layout=\"column\" \nlayout-align=\"center\" flex=\"50\"><span class=\"margin-8\">8px margin</span></hljs></div><div layout=\"column\" \nlayout-gt-md=\"row\"><div class=\"preview\" layout=\"column\" layout-align=\"center\" flex=\"50\"><div class=\"md-caption mb-16\">\nMultiples of 8, Max:96</div><span>m-(8x)</span></div><hljs lang=\"html\" class=\"source-code\" layout=\"column\" \nlayout-align=\"center\" flex=\"50\"><span class=\"m-32\">32px margin</span></hljs></div></div><div class=\"md-title\">\nDirection Specific Margin Helpers</div><div class=\"card md-whiteframe-4dp\" layout=\"column\"><div layout=\"column\" \nlayout-gt-md=\"row\"><div class=\"preview\" layout=\"column\" layout-align=\"center\" flex=\"50\"><div class=\"md-caption mb-16\">\nMultiples of 5, Max:100</div><span>margin-top-(5x)</span> <span>margin-right-(5x)</span> <span>margin-bottom-(5x)\n</span> <span>margin-left-(5x)</span> <span>margin-horizontal-(5x)</span> <span>margin-vertical-(5x)</span></div><hljs \nlang=\"html\" class=\"source-code\" layout=\"column\" layout-align=\"center\" flex=\"50\"><span class=\"margin-top-5\">5px from top\n</span> <span class=\"margin-right-25\">25px from right</span> <span class=\"margin-bottom-10\">10px from bottom</span> \n<span class=\"margin-left-20\">20px from left</span> <span class=\"margin-horizontal-5\">5px from left and right</span> \n<span class=\"margin-vertical-5\">5px from top and bottom</span></hljs></div><div layout=\"column\" layout-gt-md=\"row\"><div\n class=\"preview\" layout=\"column\" layout-align=\"center\" flex=\"50\"><div class=\"md-caption mb-16\">Multiples of 5, Max:100\n</div><span>mt-(5x)</span> <span>mr-(5x)</span> <span>mb-(5x)</span> <span>ml-(5x)</span> <span>mh-(5x)</span> <span>\nmv-(5x)</span></div><hljs lang=\"html\" class=\"source-code\" layout=\"column\" layout-align=\"center\" flex=\"50\"><span \nclass=\"mt-5\">5px from top</span> <span class=\"mr-25\">25px from right</span> <span class=\"mb-10\">10px from bottom</span>\n <span class=\"ml-20\">20px from left</span> <span class=\"mh-5\">5px from left and right</span> <span class=\"mv-5\">\n5px from top and bottom</span></hljs></div><div layout=\"column\" layout-gt-md=\"row\"><div class=\"preview\" \nlayout=\"column\" layout-align=\"center\" flex=\"50\"><div class=\"md-caption mb-16\">Multiples of 8, Max:96</div><span>\nmargin-top-(8x)</span> <span>margin-right-(8x)</span> <span>margin-bottom-(8x)</span> <span>margin-left-(8x)</span> \n<span>margin-horizontal-(8x)</span> <span>margin-vertical-(8x)</span></div><hljs lang=\"html\" class=\"source-code\" \nlayout=\"column\" layout-align=\"center\" flex=\"50\"><span class=\"margin-top-8\">8px from top</span> <span \nclass=\"margin-right-24\">24px from right</span> <span class=\"margin-bottom-16\">16px from bottom</span> <span \nclass=\"margin-left-8\">8px from left</span> <span class=\"margin-horizontal-8\">8px from left and right</span> <span \nclass=\"margin-vertical-8\">8px from top and bottom</span></hljs></div><div layout=\"column\" layout-gt-md=\"row\"><div \nclass=\"preview\" layout=\"column\" layout-align=\"center\" flex=\"50\"><div class=\"md-caption mb-16\">Multiples of 8, Max:96\n</div><span>mt-(8x)</span> <span>mr-(8x)</span> <span>mb-(8x)</span> <span>ml-(8x)</span> <span>mh-(8x)</span> <span>\nmv-(8x)</span></div><hljs lang=\"html\" class=\"source-code\" layout=\"column\" layout-align=\"center\" flex=\"50\"><span \nclass=\"mt-8\">8px from top</span> <span class=\"mr-24\">24px from right</span> <span class=\"mb-16\">16px from bottom</span>\n <span class=\"ml-8\">8px from left</span> <span class=\"mh-8\">8px from left and right</span> <span class=\"mv-8\">\n8px from top and bottom</span></hljs></div></div></md-tab><md-tab label=\"Width & Height Helpers\"><div class=\"md-title\">\nWidth Helpers</div><div class=\"card md-whiteframe-4dp\" layout=\"column\"><div layout=\"column\" layout-gt-md=\"row\"><div \nclass=\"preview\" layout=\"column\" layout-align=\"center\" flex=\"50\"><div class=\"md-caption mb-16\">Multiples of 5, Max:500\n</div><span>width-(5x)</span></div><hljs lang=\"html\" class=\"source-code\" layout=\"column\" layout-align=\"center\" \nflex=\"50\"><span class=\"width-5\">5px fixed width</span></hljs></div><div layout=\"column\" layout-gt-md=\"row\"><div \nclass=\"preview\" layout=\"column\" layout-align=\"center\" flex=\"50\"><div class=\"md-caption mb-16\">Multiples of 5, Max:500\n</div><span>w-(5x)</span></div><hljs lang=\"html\" class=\"source-code\" layout=\"column\" layout-align=\"center\" flex=\"50\">\n<span class=\"w-350\">350px fixed width</span></hljs></div><div layout=\"column\" layout-gt-md=\"row\"><div class=\"preview\" \nlayout=\"column\" layout-align=\"center\" flex=\"50\"><div class=\"md-caption mb-16\">Multiples of 8, Max:800</div><span>\nwidth-(8x)</span></div><hljs lang=\"html\" class=\"source-code\" layout=\"column\" layout-align=\"center\" flex=\"50\"><span \nclass=\"width-8\">8px fixed width</span></hljs></div><div layout=\"column\" layout-gt-md=\"row\"><div class=\"preview\" \nlayout=\"column\" layout-align=\"center\" flex=\"50\"><div class=\"md-caption mb-16\">Multiples of 8, Max:800</div><span>w-(8x)\n</span></div><hljs lang=\"html\" class=\"source-code\" layout=\"column\" layout-align=\"center\" flex=\"50\"><span class=\"w-560\">\n560px fixed width</span></hljs></div></div><div class=\"md-title\">Height Helpers</div><div \nclass=\"card md-whiteframe-4dp\" layout=\"column\"><div layout=\"column\" layout-gt-md=\"row\"><div class=\"preview\" \nlayout=\"column\" layout-align=\"center\" flex=\"50\"><div class=\"md-caption mb-16\">Multiples of 5, Max:500</div><span>\nheight-(5x)</span></div><hljs lang=\"html\" class=\"source-code\" layout=\"column\" layout-align=\"center\" flex=\"50\"><span \nclass=\"height-5\">5px fixed height</span></hljs></div><div layout=\"column\" layout-gt-md=\"row\"><div class=\"preview\" \nlayout=\"column\" layout-align=\"center\" flex=\"50\"><div class=\"md-caption mb-16\">Multiples of 5, Max:500</div><span>h-(5x)\n</span></div><hljs lang=\"html\" class=\"source-code\" layout=\"column\" layout-align=\"center\" flex=\"50\"><span class=\"h-350\">\n350px fixed height</span></hljs></div><div layout=\"column\" layout-gt-md=\"row\"><div class=\"preview\" layout=\"column\" \nlayout-align=\"center\" flex=\"50\"><div class=\"md-caption mb-16\">Multiples of 8, Max:800</div><span>height-(8x)</span>\n</div><hljs lang=\"html\" class=\"source-code\" layout=\"column\" layout-align=\"center\" flex=\"50\"><span class=\"height-8\">\n8px fixed height</span></hljs></div><div layout=\"column\" layout-gt-md=\"row\"><div class=\"preview\" layout=\"column\" \nlayout-align=\"center\" flex=\"50\"><div class=\"md-caption mb-16\">Multiples of 8, Max:800</div><span>h-(8x)</span></div>\n<hljs lang=\"html\" class=\"source-code\" layout=\"column\" layout-align=\"center\" flex=\"50\"><span class=\"h-560\">\n560px fixed height</span></hljs></div></div></md-tab><md-tab label=\"Border Helpers\"><div class=\"md-title\">\nBorder Helpers</div><div class=\"card md-whiteframe-4dp\" layout=\"column\"><div layout=\"column\" layout-gt-md=\"row\"><div \nclass=\"preview\" layout=\"column\" layout-align=\"center\" flex=\"50\"><span>border</span></div><hljs lang=\"html\" \nclass=\"source-code\" layout=\"column\" layout-align=\"center\" flex=\"50\"><span class=\"border\">Border on all sides</span>\n</hljs></div><div layout=\"column\" layout-gt-md=\"row\"><div class=\"preview\" layout=\"column\" layout-align=\"center\" \nflex=\"50\"><span>b</span></div><hljs lang=\"html\" class=\"source-code\" layout=\"column\" layout-align=\"center\" flex=\"50\">\n<span class=\"b\">Border on all sides</span></hljs></div></div><div class=\"md-title\">Direction Specific Border Helpers\n</div><div class=\"card md-whiteframe-4dp\" layout=\"column\"><div layout=\"column\" layout-gt-md=\"row\"><div class=\"preview\" \nlayout=\"column\" layout-align=\"center\" flex=\"50\"><span>border-top</span> <span>border-right</span> <span>border-bottom\n</span> <span>border-left</span> <span>border-horizontal</span> <span>border-vertical</span></div><hljs lang=\"html\" \nclass=\"source-code\" layout=\"column\" layout-align=\"center\" flex=\"50\"><span class=\"border-top\">Border top</span> <span \nclass=\"border-right\">Border right</span> <span class=\"border-bottom\">Border bottom</span> <span class=\"border-left\">\nBorder left</span> <span class=\"border-horizontal\">Border left and right</span> <span class=\"border-vertical\">\nBorder top and bottom</span></hljs></div><div layout=\"column\" layout-gt-md=\"row\"><div class=\"preview\" layout=\"column\" \nlayout-align=\"center\" flex=\"50\"><span>bt</span> <span>br</span> <span>bb</span> <span>bl</span> <span>bh</span> <span>\nbv</span></div><hljs lang=\"html\" class=\"source-code\" layout=\"column\" layout-align=\"center\" flex=\"50\"><span class=\"bt\">\nBorder top</span> <span class=\"br\">Border right</span> <span class=\"bb\">Border bottom</span> <span class=\"bl\">\nBorder left</span> <span class=\"bh\">Border left and right</span> <span class=\"bv\">Border top and bottom</span></hljs>\n</div></div><div class=\"md-title\">Border Radius Helpers</div><div class=\"card md-whiteframe-4dp\" layout=\"column\"><div \nlayout=\"column\" layout-gt-md=\"row\"><div class=\"preview\" layout=\"column\" layout-align=\"center\" flex=\"50\"><div \nclass=\"md-caption mb-16\">Multiples of 1, Max:12</div><span>brad-*</span></div><hljs lang=\"html\" class=\"source-code\" \nlayout=\"column\" layout-align=\"center\" flex=\"50\"><span class=\"brad-2\">2px border radius</span> <span class=\"brad-5\">\n5px border radius</span></hljs></div></div></md-tab></md-tabs></div></div>");
$templateCache.put("app/main/ui/material-colors/material-colors.html","<div id=\"material-colors\" class=\"page-layout simple tabbed doc-page\" layout=\"column\"><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\"><div class=\"breadcrumb\" \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-home\" class=\"s16\"></md-icon><md-icon \nmd-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">USER INTERFACE</span></div><div \nclass=\"title\">Material Colors</div></div><div layout=\"row\" layout-align=\"start center\"><md-button \nclass=\"md-raised reference-button\" href=\"https://www.google.com/design/spec/style/color.html#color-color-palette\" \ntarget=\"_blank\"><md-icon md-font-icon=\"icon-link\"></md-icon><span>Reference</span></md-button></div></div><div \nclass=\"content\"><md-tabs class=\"color-tabs\" md-dynamic-height md-swipe-content><md-tab \nng-repeat=\"(paletteName, palette) in vm.palettes\" \nmd-on-select=\"vm.selected = paletteName; vm.selectedPalette = palette\"><md-tab-label><span class=\"text-capitalize\">\n{{paletteName}}</span></md-tab-label></md-tab></md-tabs><md-content class=\"color-tab\"><div class=\"h3 pb-16\">\nmarvilix has classes for every single color from <a \nhref=\"https://www.google.com/design/spec/style/color.html#color-color-palette\" target=\"_blank\">\nMaterial Design Color Palette</a>\n for your convenient. You can use them with pretty much every element except Angular Material directives.</div><div \nclass=\"color-header colored-bg\" ng-class=\"\'md-\'+vm.selected+\'-bg\'\" layout=\"row\" layout-align=\"start start\" layout-wrap \nlayout-padding><div flex=\"100\"><h3 class=\"text-capitalize\">{{vm.selected}}</h3></div><div layout=\"row\" \nlayout-align=\"space-between center\" flex=\"100\"><div>500</div><div>\nrgb({{vm.selectedPalette[\'500\'].value[0]}},{{vm.selectedPalette[\'500\'].value[1]}},{{vm.selectedPalette[\'500\'].value[2]}})\n</div></div></div><div class=\"color\" layout=\"row\" layout-wrap layout-align=\"center center\"><div class=\"colored-bg\" \nng-repeat=\"(hue, hueValue) in vm.selectedPalette\" flex=\"100\" layout=\"row\" layout-sm=\"column\" layout-padding \nng-class=\"vm.selected+\'-\'+hue+\'-bg\'\"><div flex>{{hue}}</div><div class=\"colored-bg\" \nng-class=\"\'md-\'+vm.selected+\'-\'+hue+\'-bg\'\" flex>.{{\'md-\'+vm.selected+\'-\'+hue+\'-bg\'}}</div><div flex>\n.{{vm.selected+\'-\'+hue+\'-bg\'}}</div><div class=\"fg-box white-bg md-whiteframe-2dp\" \nng-class=\"vm.selected+\'-\'+hue+\'-fg\'\">.{{vm.selected+\'-\'+hue+\'-fg\'}}</div></div></div></md-content></div></div>");
$templateCache.put("app/main/ui/theme-colors/theme-colors.html","<div id=\"theme-colors\" class=\"page-layout simple tabbed doc-page\" layout=\"column\"><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\"><div class=\"breadcrumb\" \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-home\" class=\"s16\"></md-icon><md-icon \nmd-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">USER INTERFACE</span></div><div \nclass=\"title\">Theme Colors</div></div><div layout=\"row\" layout-align=\"start center\"><md-button \nclass=\"md-raised md-warn reference-button\" ng-click=\"vm.createTheme($event);\"><md-icon md-font-icon=\"icon-palette\">\n</md-icon><span>Create Your Own Theme!</span></md-button></div></div><div class=\"content\"><md-tabs class=\"color-tabs\" \nmd-dynamic-height md-swipe-content md-stretch-tabs=\"always\"><md-tab label=\"Primary Color\"><md-content \nclass=\"color-tab\" ng-include=\"\'app/main/ui/theme-colors/tabs/primary/primary.html\'\"></md-content></md-tab><md-tab \nlabel=\"Accent Color\"><md-content class=\"color-tab\" ng-include=\"\'app/main/ui/theme-colors/tabs/accent/accent.html\'\">\n</md-content></md-tab><md-tab label=\"Warn Color\"><md-content class=\"color-tab\" \nng-include=\"\'app/main/ui/theme-colors/tabs/warn/warn.html\'\"></md-content></md-tab><md-tab label=\"Background Color\">\n<md-content class=\"color-tab\" ng-include=\"\'app/main/ui/theme-colors/tabs/background/background.html\'\"></md-content>\n</md-tab></md-tabs></div></div>");
$templateCache.put("app/main/ui/typography/typography.html","<div id=\"typography\" class=\"page-layout simple tabbed doc-page\" layout=\"column\"><div class=\"header md-accent-bg\" \nlayout=\"column\" layout-align=\"center start\"><div class=\"breadcrumb\" layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"icon-home\" class=\"s16\"></md-icon><md-icon md-font-icon=\"icon-chevron-right\" class=\"s16 separator\">\n</md-icon><span class=\"parent\">USER INTERFACE</span></div><div class=\"title\">Typography</div></div><div \nclass=\"content\"><md-tabs md-dynamic-height><md-tab label=\"Headings\"><div class=\"md-title\">Material design headings\n</div><div class=\"card md-whiteframe-4dp\" layout=\"column\"><div layout=\"column\" layout-gt-md=\"row\" flex><div \nclass=\"preview\" layout=\"column\" layout-align=\"center\" flex=\"50\"><div class=\"md-caption secondary-text\">112px</div><span\n class=\"md-display-4\">Display 4</span></div><hljs lang=\"html\" class=\"source-code\" layout=\"column\" \nlayout-align=\"center\" flex=\"50\"><span class=\"md-display-4\">Display 4</span></hljs></div><div layout=\"column\" \nlayout-gt-md=\"row\"><div class=\"preview\" layout=\"column\" layout-align=\"center\" flex=\"50\"><div \nclass=\"md-caption secondary-text\">56px</div><span class=\"md-display-3\">Display 3</span></div><hljs lang=\"html\" \nclass=\"source-code\" layout=\"column\" layout-align=\"center\" flex=\"50\"><span class=\"md-display-3\">Display 3</span></hljs>\n</div><div layout=\"column\" layout-gt-md=\"row\"><div class=\"preview\" layout=\"column\" layout-align=\"center\" flex=\"50\"><div\n class=\"md-caption secondary-text\">45px</div><span class=\"md-display-2\">Display 2</span></div><hljs lang=\"html\" \nclass=\"source-code\" layout=\"column\" layout-align=\"center\" flex=\"50\"><span class=\"md-display-2\">Display 2</span></hljs>\n</div><div layout=\"column\" layout-gt-md=\"row\"><div class=\"preview\" layout=\"column\" layout-align=\"center\" flex=\"50\"><div\n class=\"md-caption secondary-text\">34px</div><span class=\"md-display-1\">Display 1</span></div><hljs lang=\"html\" \nclass=\"source-code\" layout=\"column\" layout-align=\"center\" flex=\"50\"><span class=\"md-display-1\">Display 1</span></hljs>\n</div><div layout=\"column\" layout-gt-md=\"row\"><div class=\"preview\" layout=\"column\" layout-align=\"center\" flex=\"50\"><div\n class=\"md-caption secondary-text\">24px</div><span class=\"md-headline\">Headline</span></div><hljs lang=\"html\" \nclass=\"source-code\" layout=\"column\" layout-align=\"center\" flex=\"50\"><span class=\"md-headline\">Headline</span></hljs>\n</div><div layout=\"column\" layout-gt-md=\"row\"><div class=\"preview\" layout=\"column\" layout-align=\"center\" flex=\"50\"><div\n class=\"md-caption secondary-text\">20px</div><span class=\"md-title\">Title</span></div><hljs lang=\"html\" \nclass=\"source-code\" layout=\"column\" layout-align=\"center\" flex=\"50\"><span class=\"md-title\">Title</span></hljs></div>\n<div layout=\"column\" layout-gt-md=\"row\"><div class=\"preview\" layout=\"column\" layout-align=\"center\" flex=\"50\"><div \nclass=\"md-caption secondary-text\">16px</div><span class=\"md-subhead\">Subhead</span></div><hljs lang=\"html\" \nclass=\"source-code\" layout=\"column\" layout-align=\"center\" flex=\"50\"><span class=\"md-subhead\">Subhead</span></hljs>\n</div></div><div class=\"md-title\">Headings</div><div class=\"card md-whiteframe-4dp\" layout=\"column\"><div \nlayout=\"column\" layout-gt-md=\"row\"><div class=\"preview\" layout=\"column\" layout-align=\"center\" flex=\"50\"><div \nclass=\"md-caption secondary-text\">24px</div><h1>Heading 1</h1></div><hljs lang=\"html\" class=\"source-code\" \nlayout=\"column\" layout-align=\"center\" flex=\"50\"><h1>Heading 1</h1><div class=\"h1\">Heading 1</div></hljs></div><div \nlayout=\"column\" layout-gt-md=\"row\"><div class=\"preview\" layout=\"column\" layout-align=\"center\" flex=\"50\"><div \nclass=\"md-caption secondary-text\">20px</div><h2>Heading 2</h2></div><hljs lang=\"html\" class=\"source-code\" \nlayout=\"column\" layout-align=\"center\" flex=\"50\"><h2>Heading 2</h2><div class=\"h2\">Heading 2</div></hljs></div><div \nlayout=\"column\" layout-gt-md=\"row\"><div class=\"preview\" layout=\"column\" layout-align=\"center\" flex=\"50\"><div \nclass=\"md-caption secondary-text\">16px</div><h3>Heading 3</h3></div><hljs lang=\"html\" class=\"source-code\" \nlayout=\"column\" layout-align=\"center\" flex=\"50\"><h3>Heading 3</h3><div class=\"h3\">Heading 3</div></hljs></div><div \nlayout=\"column\" layout-gt-md=\"row\"><div class=\"preview\" layout=\"column\" layout-align=\"center\" flex=\"50\"><div \nclass=\"md-caption secondary-text\">14px</div><h4>Heading 4</h4></div><hljs lang=\"html\" class=\"source-code\" \nlayout=\"column\" layout-align=\"center\" flex=\"50\"><h4>Heading 4</h4><div class=\"h4\">Heading 4</div></hljs></div><div \nlayout=\"column\" layout-gt-md=\"row\"><div class=\"preview\" layout=\"column\" layout-align=\"center\" flex=\"50\"><div \nclass=\"md-caption secondary-text\">13px</div><h5>Heading 5</h5></div><hljs lang=\"html\" class=\"source-code\" \nlayout=\"column\" layout-align=\"center\" flex=\"50\"><h5>Heading 5</h5><div class=\"h5\">Heading 5</div></hljs></div><div \nlayout=\"column\" layout-gt-md=\"row\"><div class=\"preview\" layout=\"column\" layout-align=\"center\" flex=\"50\"><div \nclass=\"md-caption secondary-text\">12px</div><h6>Heading 6</h6></div><hljs lang=\"html\" class=\"source-code\" \nlayout=\"column\" layout-align=\"center\" flex=\"50\"><h6>Heading 6</h6><div class=\"h6\">Heading 6</div></hljs></div></div>\n</md-tab><md-tab label=\"Inline Text Elements\"><div class=\"card md-whiteframe-4dp\" layout=\"column\"><div layout=\"column\" \nlayout-gt-md=\"row\"><div class=\"preview\" layout=\"column\" layout-align=\"center\" flex=\"50\"><span><abbr \ntitle=\"Cascaded Style Sheet\">CSS</abbr></span></div><hljs lang=\"html\" class=\"source-code\" layout=\"column\" \nlayout-align=\"center\" flex=\"50\" ms-scroll><abbr title=\"Cascaded Style Sheet\">CSS</abbr></hljs></div><div \nlayout=\"column\" layout-gt-md=\"row\"><div class=\"preview\" layout=\"column\" layout-align=\"center\" flex=\"50\"><span>\nThis is a <mark>marked</mark> text.</span></div><hljs lang=\"html\" class=\"source-code\" layout=\"column\" \nlayout-align=\"center\" flex=\"50\" ms-scroll>This is a <mark>marked</mark> text.</hljs></div><div layout=\"column\" \nlayout-gt-md=\"row\"><div class=\"preview\" layout=\"column\" layout-align=\"center\" flex=\"50\"><span><del>\nThis is a deleted text.</del></span></div><hljs lang=\"html\" class=\"source-code\" layout=\"column\" layout-align=\"center\" \nflex=\"50\" ms-scroll><del>This is a deleted text.</del></hljs></div><div layout=\"column\" layout-gt-md=\"row\"><div \nclass=\"preview\" layout=\"column\" layout-align=\"center\" flex=\"50\"><span><s>This is a strike-through text.</s></span>\n</div><hljs lang=\"html\" class=\"source-code\" layout=\"column\" layout-align=\"center\" flex=\"50\" ms-scroll><s>\nThis is a strike-through text.</s></hljs></div><div layout=\"column\" layout-gt-md=\"row\"><div class=\"preview\" \nlayout=\"column\" layout-align=\"center\" flex=\"50\"><span><u>This is an underlined text.</u></span></div><hljs lang=\"html\" \nclass=\"source-code\" layout=\"column\" layout-align=\"center\" flex=\"50\" ms-scroll><u>This is an underlined text.</u></hljs>\n</div><div layout=\"column\" layout-gt-md=\"row\"><div class=\"preview\" layout=\"column\" layout-align=\"center\" flex=\"50\">\n<span><small>This is a small text.</small></span></div><hljs lang=\"html\" class=\"source-code\" layout=\"column\" \nlayout-align=\"center\" flex=\"50\" ms-scroll><small>This is a small text.</small></hljs></div><div layout=\"column\" \nlayout-gt-md=\"row\"><div class=\"preview\" layout=\"column\" layout-align=\"center\" flex=\"50\"><span><strong>\nThis is a strong text.</strong></span></div><hljs lang=\"html\" class=\"source-code\" layout=\"column\" \nlayout-align=\"center\" flex=\"50\" ms-scrollx><strong>This is a strong text.</strong></hljs></div><div layout=\"column\" \nlayout-gt-md=\"row\"><div class=\"preview\" layout=\"column\" layout-align=\"center\" flex=\"50\"><span><em>\nThis is an italic text.</em></span></div><hljs lang=\"html\" class=\"source-code\" layout=\"column\" layout-align=\"center\" \nflex=\"50\" ms-scroll><em>This is an italic text.</em></hljs></div><div layout=\"column\" layout-gt-md=\"row\"><div \nclass=\"preview\" layout=\"column\" layout-align=\"center\" flex=\"50\"><span>This is a <span class=\"text-super\">super</span>\n text.</span></div><hljs lang=\"html\" class=\"source-code\" layout=\"column\" layout-align=\"center\" flex=\"50\" ms-scroll>\nThis is a <span class=\"text-super\">super</span> text.</hljs></div><div layout=\"column\" layout-gt-md=\"row\"><div \nclass=\"preview\" layout=\"column\" layout-align=\"center\" flex=\"50\"><span>This is a <span class=\"text-sub\">sub</span> text.\n</span></div><hljs lang=\"html\" class=\"source-code\" layout=\"column\" layout-align=\"center\" flex=\"50\" ms-scroll>This is a \n<span class=\"text-sub\">sub</span> text.</hljs></div><div layout=\"column\" layout-gt-md=\"row\"><div class=\"preview\" \nlayout=\"column\" layout-align=\"center\" flex=\"50\"><span>This is a <span class=\"text-capitalize\">capitalized</span> text.\n</span></div><hljs lang=\"html\" class=\"source-code\" layout=\"column\" layout-align=\"center\" flex=\"50\" ms-scroll>This is a \n<span class=\"text-capitalized\">capitalized</span> text.</hljs></div><div layout=\"column\" layout-gt-md=\"row\"><div \nclass=\"preview\" layout=\"column\" layout-align=\"center\" flex=\"50\"><span>This is an <span class=\"text-uppercase\">uppercase\n</span> text.</span></div><hljs lang=\"html\" class=\"source-code\" layout=\"column\" layout-align=\"center\" flex=\"50\" \nms-scroll>This is an <span class=\"text-uppercase\">uppercase</span> text.</hljs></div><div layout=\"column\" \nlayout-gt-md=\"row\"><div class=\"preview\" layout=\"column\" layout-align=\"center\" flex=\"50\"><span>This is a <span \nclass=\"text-lowercase\">LOWERCASE</span> text.</span></div><hljs lang=\"html\" class=\"source-code\" layout=\"column\" \nlayout-align=\"center\" flex=\"50\" ms-scroll>This is a <span class=\"text-lowercase\">LOWERCASE</span> text.</hljs></div>\n</div></md-tab><md-tab label=\"Blockquotes & Lists\"><div class=\"md-title\">Blockquotes</div><div \nclass=\"card md-whiteframe-4dp\" layout=\"column\"><div layout=\"column\" layout-gt-md=\"row\"><div class=\"preview\" \nlayout=\"column\" layout-align=\"center\" flex=\"50\"><blockquote><p>\nThe bedding was hardly able to cover it and seemed ready to slide off any moment.</p></blockquote></div><hljs \nlang=\"html\" class=\"source-code\" layout=\"column\" layout-align=\"center\" flex=\"50\" ms-scroll><blockquote><p>\nThe bedding was hardly able to cover it and seemed ready to slide off any moment.</p></blockquote></hljs></div><div \nlayout=\"column\" layout-gt-md=\"row\"><div class=\"preview\" layout=\"column\" layout-align=\"center\" flex=\"50\"><blockquote><p>\nThe bedding was hardly able to cover it and seemed ready to slide off any moment.</p><footer>John Doe</footer>\n</blockquote></div><hljs lang=\"html\" class=\"source-code\" layout=\"column\" layout-align=\"center\" flex=\"50\" ms-scroll>\n<blockquote><p>The bedding was hardly able to cover it and seemed ready to slide off any moment.</p><footer>John Doe\n</footer></blockquote></hljs></div><div layout=\"column\" layout-gt-md=\"row\"><div class=\"preview\" layout=\"column\" \nlayout-align=\"center\" flex=\"50\"><blockquote class=\"reverse\"><p>\nThe bedding was hardly able to cover it and seemed ready to slide off any moment.</p><footer>John Doe</footer>\n</blockquote></div><hljs lang=\"html\" class=\"source-code\" layout=\"column\" layout-align=\"center\" flex=\"50\" ms-scroll>\n<blockquote class=\"reverse\"><p>The bedding was hardly able to cover it and seemed ready to slide off any moment.</p>\n<footer>John Doe</footer></blockquote></hljs></div></div><div class=\"md-title\">Lists</div><div \nclass=\"card md-whiteframe-4dp\" layout=\"column\"><div layout=\"column\" layout-gt-md=\"row\"><div class=\"preview\" \nlayout=\"column\" layout-align=\"center\" flex=\"50\"><ol><li>Ordered list item</li><li>Ordered list item<ol><li>\nOrdered list item</li><li>Ordered list item</li></ol></li><li>Ordered list item</li><li>Ordered list item</li></ol>\n</div><hljs lang=\"html\" class=\"source-code\" layout=\"column\" layout-align=\"center\" flex=\"50\" ms-scroll><ol><li>\nOrdered list item</li><li>Ordered list item<ol><li>Ordered list item</li><li>Ordered list item</li></ol></li><li>\nOrdered list item</li><li>Ordered list item</li></ol></hljs></div><div layout=\"column\" layout-gt-md=\"row\"><div \nclass=\"preview\" layout=\"column\" layout-align=\"center\" flex=\"50\"><ul><li>Unordered list item</li><li>Unordered list item\n<ul><li>Unordered list item</li><li>Unordered list item</li></ul></li><li>Unordered list item</li><li>\nUnordered list item</li></ul></div><hljs lang=\"html\" class=\"source-code\" layout=\"column\" layout-align=\"center\" \nflex=\"50\" ms-scroll><ul><li>Unordered list item</li><li>Unordered list item<ul><li>Unordered list item</li><li>\nUnordered list item</li></ul></li><li>Unordered list item</li><li>Unordered list item</li></ul></hljs></div></div><div \nclass=\"md-title\">Definition lists</div><div class=\"card md-whiteframe-4dp\" layout=\"column\"><div layout=\"column\" \nlayout-gt-md=\"row\"><div class=\"preview\" layout=\"column\" layout-align=\"center\" flex=\"50\"><dl><dt>Definition term</dt>\n<dd>This is the definition description</dd><dt>Another definition term</dt><dd>\nThis is also another definition description</dd></dl></div><hljs lang=\"html\" class=\"source-code\" layout=\"column\" \nlayout-align=\"center\" flex=\"50\" ms-scroll><dl><dt>Definition term</dt><dd>This is the definition description</dd><dt>\nAnother definition term</dt><dd>This is also another definition description</dd></dl></hljs></div></div></md-tab>\n<md-tab label=\"Helpers\"><div class=\"md-title\">Font weight</div><div class=\"card md-whiteframe-4dp\" layout=\"column\"><div\n layout=\"column\" layout-gt-md=\"row\"><div class=\"preview\" layout=\"column\" layout-align=\"center\" flex=\"50\"><div \nclass=\"md-caption mb-16\">From 100 to 900</div><span class=\"font-weight-100\">font-weight: 100</span> <span>...</span> \n<span class=\"font-weight-900\">font-weight: 900</span></div><hljs lang=\"html\" class=\"source-code\" layout=\"column\" \nlayout-align=\"center\" flex=\"50\" ms-scroll><span class=\"font-weight-100\">100 font weight</span> ... <span \nclass=\"font-weight-900\">900 font weight</span></hljs></div></div><div class=\"md-title\">Font Size</div><div \nclass=\"card md-whiteframe-4dp\" layout=\"column\"><div layout=\"column\" layout-gt-md=\"row\"><div class=\"preview\" \nlayout=\"column\" layout-align=\"center\" flex=\"50\"><div class=\"md-caption mb-16\">Multiplies of 2, max: 120</div><span \nclass=\"font-size-20\">font-size: 20</span></div><hljs lang=\"html\" class=\"source-code\" layout=\"column\" \nlayout-align=\"center\" flex=\"50\" ms-scroll><span class=\"font-size-20\">font-size: 20</span></hljs></div></div><div \nclass=\"md-title\">Line Height</div><div class=\"card md-whiteframe-4dp\" layout=\"column\"><div layout=\"column\" \nlayout-gt-md=\"row\"><div class=\"preview\" layout=\"column\" layout-align=\"center\" flex=\"50\"><div class=\"md-caption mb-16\">\nMultiplies of 2, max: 120</div><span>line-height: 2</span> <span>...</span> <span>line-height: 120</span></div><hljs \nlang=\"html\" class=\"source-code\" layout=\"column\" layout-align=\"center\" flex=\"50\" ms-scroll><span class=\"line-height-2\">\n2px line height</span> ... <span class=\"line-height-120\">120px line height</span></hljs></div></div><div \nclass=\"md-title\">Other helpers</div><div class=\"card md-whiteframe-4dp\" layout=\"column\"><div layout=\"column\" \nlayout-gt-md=\"row\"><div class=\"preview\" layout=\"column\" layout-align=\"center\" flex=\"50\"><div class=\"text-left\">\nLeft aligned text</div></div><hljs lang=\"html\" class=\"source-code\" layout=\"column\" layout-align=\"center\" flex=\"50\" \nms-scroll><div class=\"text-left\">Left aligned text</div></hljs></div><div layout=\"column\" layout-gt-md=\"row\"><div \nclass=\"preview\" layout=\"column\" layout-align=\"center\" flex=\"50\"><div class=\"text-center\">Center aligned text</div>\n</div><hljs lang=\"html\" class=\"source-code\" layout=\"column\" layout-align=\"center\" flex=\"50\" ms-scroll><div \nclass=\"text-center\">Center aligned text</div></hljs></div><div layout=\"column\" layout-gt-md=\"row\"><div class=\"preview\" \nlayout=\"column\" layout-align=\"center\" flex=\"50\"><div class=\"text-right\">Right aligned text</div></div><hljs \nlang=\"html\" class=\"source-code\" layout=\"column\" layout-align=\"center\" flex=\"50\" ms-scroll><div class=\"text-right\">\nRight aligned text</div></hljs></div><div layout=\"column\" layout-gt-md=\"row\"><div class=\"preview\" layout=\"column\" \nlayout-align=\"center\" flex=\"50\"><p><span class=\"text-boxed\">Boxed text</span></p></div><hljs lang=\"html\" \nclass=\"source-code\" layout=\"column\" layout-align=\"center\" flex=\"50\" ms-scroll><p><span class=\"text-boxed\">Boxed text\n</span></p></hljs></div><div layout=\"column\" layout-gt-md=\"row\"><div class=\"preview md-grey-700-bg\" layout=\"column\" \nlayout-align=\"center\" flex=\"50\"><p><span class=\"text-boxed-light\">Boxed text light</span></p></div><hljs lang=\"html\" \nclass=\"source-code\" layout=\"column\" layout-align=\"center\" flex=\"50\" ms-scroll><p><span class=\"text-boxed-light\">\nBoxed text light</span></p></hljs></div><div layout=\"column\" layout-gt-md=\"row\"><div class=\"preview\" layout=\"column\" \nlayout-align=\"center\" flex=\"50\"><p><span class=\"text-strike\">Strike-through text</span></p></div><hljs lang=\"html\" \nclass=\"source-code\" layout=\"column\" layout-align=\"center\" flex=\"50\" ms-scroll><p><span class=\"text-strike\">\nStrike-through text</span></p></hljs></div><div layout=\"column\" layout-gt-md=\"row\"><div class=\"preview\" \nlayout=\"column\" layout-align=\"center\" flex=\"50\"><div class=\"text-italic\">Italic text</div></div><hljs lang=\"html\" \nclass=\"source-code\" layout=\"column\" layout-align=\"center\" flex=\"50\" ms-scroll><div class=\"text-italic\">Italic text\n</div></hljs></div><div layout=\"column\" layout-gt-md=\"row\"><div class=\"preview\" layout=\"column\" layout-align=\"center\" \nflex=\"50\"><div class=\"text-semibold\">Semi-bold text</div></div><hljs lang=\"html\" class=\"source-code\" layout=\"column\" \nlayout-align=\"center\" flex=\"50\" ms-scroll><div class=\"text-semibold\">Semi-bold text</div></hljs></div><div \nlayout=\"column\" layout-gt-md=\"row\"><div class=\"preview\" layout=\"column\" layout-align=\"center\" flex=\"50\"><div \nclass=\"text-bold\">Bold text</div></div><hljs lang=\"html\" class=\"source-code\" layout=\"column\" layout-align=\"center\" \nflex=\"50\" ms-scroll><div class=\"text-bold\">Bold text</div></hljs></div><div layout=\"column\" layout-gt-md=\"row\"><div \nclass=\"preview\" layout=\"column\" layout-align=\"center\" flex><span class=\"text-truncate\">\nThis is a truncated text. It will be truncated if it\'s too long. Vivamus convallis dui porta massa.</span></div><hljs \nlang=\"html\" class=\"source-code\" layout=\"column\" layout-align=\"center\" flex=\"50\" ms-scroll><span class=\"text-truncate\">\nThis is a truncated text. It will be truncated if it\'s too long. Vivamus convallis dui porta massa.</span></hljs></div>\n</div></md-tab></md-tabs></div></div>");
$templateCache.put("app/navigation/layouts/horizontal-navigation/navigation.html","<div layout=\"row\" layout-align=\"start center\"><ms-navigation-horizontal></ms-navigation-horizontal></div>");
$templateCache.put("app/navigation/layouts/vertical-navigation/navigation.html","<md-toolbar class=\"navigation-header md-whiteframe-1dp\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"logo\" layout=\"row\" layout-align=\"start center\"><span class=\"logo-text\">{{$root.appName}}</span></div><md-icon \nclass=\"fold-toggle s18\" md-font-icon=\"icon-backburger\" hide show-gt-sm ng-click=\"vm.toggleMsNavigationFolded()\">\n</md-icon></md-toolbar><ms-navigation class=\"scrollable\" folded=\"vm.folded\" ms-scroll=\"vm.msScrollOptions\">\n</ms-navigation>");
$templateCache.put("app/navigation/layouts/vertical-navigation-fullwidth-toolbar-2/navigation.html","<ms-navigation class=\"scrollable\" folded=\"vm.folded\" ms-scroll=\"vm.msScrollOptions\"></ms-navigation>");
$templateCache.put("app/toolbar/layouts/vertical-navigation/toolbar.html","<div layout=\"row\" layout-align=\"start center\"><div layout=\"row\" layout-align=\"start center\" flex><md-button \nid=\"navigation-toggle\" class=\"md-icon-button sidenav-toggle\" ng-click=\"vm.toggleSidenav(\'navigation\')\" hide-gt-sm \naria-label=\"Toggle navigation\"></md-button><ms-shortcuts></ms-shortcuts><div class=\"toolbar-separator\"></div><div \nng-submit=\"\" class=\"hide-im-mobile fast-search\"><md-autocomplete ng-disabled=\"vm.move\" md-no-cache=\"vm.noCache\" \nmd-selected-item=\"vm.selectedItem\" md-search-text=\"vm.searchText\" md-selected-item-change=\"vm.moveToProfile(item)\" \nmd-items=\"item in vm.querySearch(vm.searchText)\" md-item-text=\"item.FullName ? item.FullName : item.Name\" \nmd-floating-label=\"חיפוש מהיר\"><md-item-template><span md-highlight-text=\"ctrl.searchText\">\n{{item.Type}} - {{item.FirstName}} {{item.LastName}} {{item.PrivateID}} {{item.Name}}</span></md-item-template>\n<md-not-found>אין תוצאות</md-not-found></md-autocomplete></div></div><div layout=\"row\" layout-align=\"start center\">\n<md-progress-circular id=\"toolbar-progress\" ng-disabled=\"!$root.loadingProgress\" class=\"md-accent\" md-diameter=\"32\">\n</md-progress-circular><md-menu-bar id=\"user-menu\"><md-menu md-position-mode=\"left bottom\"><md-button \nclass=\"user-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"User settings\" translate \ntranslate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"avatar-wrapper\"><img md-menu-align-target class=\"avatar\" \nng-src=\"{{$root.User.ProfileImage || \'assets/images/avatars/profile.jpg\'}}\"><md-icon md-font-icon \nng-class=\"vm.userStatus.icon\" ng-if=\"false\" ng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon status s16\">\n</md-icon></div><span class=\"username\" hide show-gt-sm>{{$root.User.FirstName}} {{$root.User.LastName}}</span><md-icon \nmd-font-icon=\"icon-chevron-down\" class=\"icon s16\" hide-xs></md-icon></div></md-button><md-menu-content width=\"3\">\n<md-menu-item class=\"md-indent\" ui-sref=\"app.pages_admin-profile\"><md-icon md-font-icon=\"icon-account\" class=\"icon\">\n</md-icon><md-button aria-label=\"User Management\">המשתמש שלי</md-button></md-menu-item><md-menu-item \nng-if=\"$root.User.SuperAdmin==1\" class=\"md-indent\" ui-sref=\"app.pages_manage-admins\"><md-icon \nmd-font-icon=\"icon-account-multiple\" class=\"icon\"></md-icon><md-button>ניהול משתמשים</md-button></md-menu-item>\n<md-menu-divider></md-menu-divider><md-menu-item class=\"md-indent\"><md-icon md-font-icon=\"icon-logout\" class=\"icon\">\n</md-icon><md-button ng-click=\"vm.logout()\">יציאה מהמערכת</md-button></md-menu-item></md-menu-content></md-menu>\n</md-menu-bar><div class=\"toolbar-separator\"></div><div class=\"toolbar-separator\"></div></div></div>");
$templateCache.put("app/core/directives/ms-navigation/templates/horizontal.html","<div class=\"navigation-toggle\" hide-gt-sm><md-button class=\"md-icon-button\" ng-click=\"vm.toggleHorizontalMobileMenu()\" \naria-label=\"Toggle Mobile Navigation\"><md-icon md-font-icon=\"icon-menu\"></md-icon></md-button></div><ul \nclass=\"horizontal\"><li ng-repeat=\"node in vm.navigation\" ms-navigation-horizontal-node=\"node\" \nng-class=\"{\'has-children\': vm.hasChildren}\" ng-include=\"\'navigation-horizontal-nested.html\'\"></li></ul><script \ntype=\"text/ng-template\" id=\"navigation-horizontal-nested.html\">\n<div ms-navigation-horizontal-item layout=\"row\" ng-if=\"!vm.isHidden()\">\r\n\r\n        <div class=\"ms-navigation-horizontal-button\" ng-if=\"!node.uisref && node.title\"\r\n             ng-class=\"{\'active md-accent-bg md-accent-fg\': vm.isActive}\">\r\n            <i class=\"icon s18 {{node.icon}}\" ng-if=\"node.icon\"></i>\r\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\r\n            <span class=\"badge white-fg\" style=\"background: {{node.badge.color}}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\r\n            <i class=\"icon-chevron-right s18 arrow\" ng-if=\"vm.hasChildren\"></i>\r\n        </div>\r\n\r\n        <a class=\"ms-navigation-horizontal-button\" ui-sref=\"{{node.uisref}}\" ui-sref-active=\"active md-accent-bg\"\r\n           ng-class=\"{\'active md-accent-bg md-accent-fg\': vm.isActive}\"\r\n           ng-if=\"node.uisref && node.title\">\r\n            <i class=\"icon s18 {{node.icon}}\" ng-if=\"node.icon\"></i>\r\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\r\n            <span class=\"badge white-fg\" style=\"background: {{node.badge.color}}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\r\n            <i class=\"icon-chevron-right s18 arrow\" ng-if=\"vm.hasChildren\"></i>\r\n        </a>\r\n\r\n    </div>\r\n\r\n    <ul ng-if=\"vm.hasChildren && !vm.isHidden()\">\r\n        <li ng-repeat=\"node in node.children\" ms-navigation-horizontal-node=\"node\"\r\n            ng-class=\"{\'has-children\': vm.hasChildren}\"\r\n            ng-include=\"\'navigation-horizontal-nested.html\'\"></li>\r\n    </ul>\n</script>");
$templateCache.put("app/core/directives/ms-navigation/templates/vertical.html","<ul><li ng-repeat=\"node in vm.navigation\" ms-navigation-node=\"node\" \nng-class=\"{\'collapsed\': vm.collapsed, \'has-children\': vm.hasChildren}\" ng-include=\"\'navigation-nested.html\'\"></li></ul>\n<script type=\"text/ng-template\" id=\"navigation-nested.html\">\n<div ms-navigation-item layout=\"row\" ng-if=\"!vm.isHidden()\">\r\n\r\n        <div class=\"ms-navigation-button\" ng-if=\"!node.uisref && node.title\">\r\n            <i class=\"icon s16 {{node.icon}}\" ng-if=\"node.icon\"></i>\r\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\r\n            <span class=\"badge white-fg\" ng-style=\"{\'background\': node.badge.color}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\r\n            <i class=\"icon-chevron-right s16 arrow\" ng-if=\"vm.collapsable && vm.hasChildren\"></i>\r\n        </div>\r\n\r\n        <a class=\"ms-navigation-button\" ui-sref=\"{{node.uisref}}\" ui-sref-active=\"active md-accent-bg\"\r\n           ng-if=\"node.uisref && node.title\">\r\n            <i class=\"icon s16 {{node.icon}}\" ng-if=\"node.icon\"></i>\r\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\r\n            <span class=\"badge white-fg\" ng-style=\"{\'background\': node.badge.color}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\r\n            <i class=\"icon-chevron-right s16 arrow\" ng-if=\"vm.collapsable && vm.hasChildren\"></i>\r\n        </a>\r\n\r\n    </div>\r\n\r\n    <ul ng-if=\"vm.hasChildren && !vm.isHidden()\">\r\n        <li ng-repeat=\"node in node.children\" ms-navigation-node=\"node\"\r\n            ng-class=\"{\'collapsed\': vm.collapsed, \'has-children\': vm.hasChildren}\"\r\n            ng-include=\"\'navigation-nested.html\'\"></li>\r\n    </ul>\n</script>");
$templateCache.put("app/main/apps/dashboard/tabs/events.html","<!DOCTYPE html><html lang=\"en\"><head><meta charset=\"UTF-8\"><title>Title</title></head><body></body></html>");
$templateCache.put("app/main/apps/dashboard/tabs/movement.html","");
$templateCache.put("app/main/apps/dashboard/updates-dialog/updates-dialog.html","<md-dialog class=\"new-activities-dialog\" aria-label=\"New Task\"><form name=\"newActivitiesForm\" \ndata-ng-model=\"newActivitiesForm\" class=\"md-inline-form\" validate><md-toolbar class=\"md-accent\" layout=\"column\" \nstyle=\"min-height: 30px;height: 57px\"><div class=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" \nlayout-align=\"space-between center\"><span class=\"title\">גרסה 2.9 (אוגוסט 2022) - פרטי העדכון</span><md-button \nclass=\"md-icon-button\" ng-click=\"closeDialog()\" ng-disabled=\"disable\" aria-label=\"Close dialog\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content \nstyle=\"overflow: visible !important\"><ul><li>שינוי גרפי של ממשק המשתמש בצד פרופיל ההורה</li><li>\nהקמת מנגנון פיצול תשלומים</li><ul><li>פיצול תשלום ליתרת הורה וכרטיס אשראי</li><li>\nפיצול תשלום למספר כרטיסי אשראי באופן שמחייב רק לאחר אישור סליקה מחברת האשראי לכלל הכרטיסים</li></ul></ul>\n</md-dialog-content></form></md-dialog>");
$templateCache.put("app/main/pages/activities/activities-panel/activities-panel.html","<md-content ms-scroll style=\"height: 1000px\"><form class=\"md-inline-form\" validate><md-toolbar class=\"md-accent\" \nlayout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\">\n<span class=\"title\">עריכת {{$root.User.Activity}}</span><md-button class=\"md-icon-button\" \nng-click=\"$root.closePanel()\" aria-label=\"Close Dialog\" translate \ntranslate-attr-aria-label=\"PROFILE_PANEL.CLOSE_PANEL\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-input-container class=\"md-icon-float md-block\"><label>שם {{$root.User.Activity}}</label><md-icon \nmd-font-icon=\"icon-account\" class=\"name\"></md-icon><input ng-model=\"activities.Name\" type=\"text\"></md-input-container>\n<md-input-container class=\"md-icon-float md-block md-icon-left\"><md-icon md-font-icon=\"icon-calendar-select\"></md-icon>\n<div start-view=\"day\" locale=\"he\" format=\"DD/MM/YYYY HH:mm\" moment-picker=\"activities.Date\"><label>\nתאריך ביצוע {{$root.User.Activity}}</label><input autocomplete=\"off\" ng-model=\"activities.Date\"></div>\n</md-input-container><md-input-container class=\"md-block\"><label>סטטוס</label><md-icon md-font-icon=\"icon-power\" \nclass=\"name\"></md-icon><md-select ng-model=\"activities.Status\" placeholder=\"סטטוס\"><md-option \nng-selected=\"activities.Status==1 || activities.Status==\'1\'\" ng-value=\"1\">פעיל</md-option><md-option \nng-selected=\"activities.Status==0 || activities.Status==\'0\'\" ng-value=\"0\">לא פעיל</md-option></md-select>\n</md-input-container></form></md-content>");
$templateCache.put("app/main/pages/activities/activities-profile/activities-profile.html","<div id=\"activities-profile\" class=\"page-layout simple tabbed\" ng-init=\"saveOnEnter()\"><div \nclass=\"header md-accent-bg\" layout=\"column\" layout-align=\"center center\" layout-gt-sm=\"row\" \nlayout-align-gt-sm=\"space-between end\"></div><div class=\"content\" flex><md-tabs md-dynamic-height \nmd-selected=\"selectedTab\"><md-tab><md-tab-label><span>כללי</span></md-tab-label><md-tab-body><md-content \nclass=\"about-tab\" ng-include=\"\'app/main/pages/activities/activities-profile/tabs/about/about.html\'\"></md-content>\n</md-tab-body></md-tab><md-tab><md-tab-label><span>רשימת נוכחות</span></md-tab-label><md-tab-body><md-content \nclass=\"about-tab\" ng-include=\"\'app/main/pages/activities/activities-profile/tabs/attendance/attendance.html\'\">\n</md-content></md-tab-body></md-tab></md-tabs></div></div>");
$templateCache.put("app/main/pages/activities/new-activities-dialog/new-activities-dialog.html","<md-dialog class=\"new-activities-dialog\" aria-label=\"New Task\" ng-init=\"getBranches()\"><form name=\"newActivitiesForm\" \ndata-ng-model=\"newActivitiesForm\" class=\"md-inline-form\" validate><md-toolbar class=\"md-accent\" layout=\"column\"><div \nclass=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">\nהוספת {{$root.User.Activity}} חדשה</span><md-button class=\"md-icon-button\" ng-click=\"closeDialog()\" \naria-label=\"Close dialog\" translate><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content style=\"overflow: visible !important\"><md-input-container class=\"md-block\"><md-icon \nmd-font-icon=\"icon-leaf\" class=\"name\"></md-icon><label>שם {{$root.User.Activity}}</label><input \nng-model=\"newActivities.Name\" type=\"text\" ng-required=\"true\" ng-disabled=\"isClicked\"></md-input-container>\n<md-input-container class=\"md-block\" ng-show=\"$root.AdminLevel>1\"><md-icon md-font-icon=\"icon-domain\" class=\"name\">\n</md-icon><label>בחר {{$root.User.Branch}}</label><md-select ng-change=\"getGroups()\" ng-model=\"newActivities.BranchID\" \nng-disabled=\"!branches || isClicked\" ng-required=\"$root.AdminLevel>1\"><md-option ng-repeat=\"branch in branches\" \nng-value=\"branch.ID\">{{branch.Name}}</md-option></md-select></md-input-container><md-input-container class=\"md-block\">\n<md-icon md-font-icon=\"icon-account-multiple\" class=\"name\"></md-icon><label>בחר {{$root.User.Groups}}</label><md-select\n ng-model=\"newActivities.GroupID\" ng-disabled=\"!groups || isClicked\" multiple=\"true\" required=\"true\"><md-option \nng-repeat=\"group in groups\" ng-value=\"group.ID\">{{group.Name}}</md-option></md-select></md-input-container>\n<md-input-container class=\"md-icon-float md-block md-icon-left\" layout=\"column\" layout-xs=\"row\" flex=\"100\" \nflex-xs=\"100\" flex-gt-sm=\"50\" flex-gt-md=\"50\" style=\"min-width: 430px\"><md-icon md-font-icon=\"icon-calendar-select\">\n</md-icon><div start-view=\"year\" locale=\"he\" format=\"DD/MM/YYYY HH:mm\" position=\"bottom right\" \nmoment-picker=\"newActivities.Date\"><label>תאריך</label><input autocomplete=\"off\" ng-model=\"newActivities.Date\" \nng-required=\"true\" ng-disabled=\"isClicked\"></div></md-input-container></md-dialog-content><md-dialog-actions \nlayout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-button \ndata-ng-disabled=\"newActivitiesForm.$invalid || isClicked\" type=\"submit\" ng-click=\"saveNewActivities()\" \nclass=\"send-button md-accent md-raised\" aria-label=\"Add Task\">שמירה</md-button><md-button \ndata-ng-disabled=\"newActivitiesForm.$invalid || isClicked\" type=\"submit\" ng-click=\"saveNewActivities(true)\" \nclass=\"send-button md-accent md-raised\" aria-label=\"Add Task\">שמירה ומעבר לעריכה מלאה</md-button></div>\n</md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/pages/admin/admin-management/manage-admins.html","<div id=\"manage-admins\" class=\"page-layout simple tabbed\"><div class=\"header md-accent-bg\" layout=\"column\" \nlayout-align=\"center center\" layout-gt-sm=\"row\" layout-align-gt-sm=\"space-between start\"><div class=\"h1\" layout=\"row\" \nlayout-align=\"start center\"><span class=\"md-display-1 font-weight-300\">ניהול משתמשים</span></div></div><div \nclass=\"content\"><div class=\"action-buttons\"><md-button ng-disabled=\"!admins\" ng-if=\"$root.User.SuperAdmin==1\" \nclass=\"md-fab md-accent md-icon-button\" id=\"add-systemUser-button\" ng-click=\"openNewAdminUserDialog()\" \naria-label=\"add systemUser\" title=\"הוספת משתמש חדש\"><md-icon md-font-icon=\"icon-plus\"></md-icon></md-button></div><form\n name=\"UserForm\" class=\"md-inline-form\" validate><div class=\"filters\" layout=\"row\" flex=\"100\" flex-gt-sm=\"100\" \nflex-gt-md=\"70\"><div layout=\"column\" flex=\"100\" flex-gt-sm=\"50\" flex-gt-md=\"33\"><md-input-container \nclass=\"md-icon-float md-block\"><md-icon md-font-icon=\"icon-power\"></md-icon><md-select ng-model=\"search.Status\" \nplaceholder=\"סינון לפי סטטוס\" ng-disabled=\"!admins\" ng-init=\"search.Status=1\"><md-option ng-value=\"null\">הצג הכל\n</md-option><md-option ng-value=\"1\">פעילים</md-option><md-option ng-value=\"0\">לא פעילים</md-option></md-select>\n</md-input-container></div></div><div class=\"filters\" layout=\"row\" flex=\"100\" flex-gt-sm=\"100\" flex-gt-md=\"70\"><div \nlayout=\"column\" flex=\"100\" flex-gt-sm=\"50\" flex-gt-md=\"33\"><md-input-container class=\"md-icon-float md-block\"><md-icon \nmd-font-icon=\"icon-magnify\"></md-icon><label>חיפוש חופשי</label><input ng-model=\"search.FreeSearchFromDB\" \ntype=\"search\" ng-disabled=\"!admins\"></md-input-container></div></div><div class=\"search-actions row\" layout=\"row\">\n<md-button type=\"submit\" ng-disabled=\"!admins\" class=\"md-raised md-accent\" aria-label=\"חפש\" ng-click=\"getAdmins()\">\nסינון</md-button><md-button ng-disabled=\"!admins\" class=\"md-raised md-accent\" aria-label=\"חפש\" \nng-click=\"getAdmins(true)\">בטל סינון</md-button></div></form><div layout=\"row\" layout-sm=\"column\" \nlayout-align=\"space-around\" ng-show=\"!admins\"><md-progress-circular md-mode=\"indeterminate\"></md-progress-circular>\n</div><table class=\"dataTable row-border hover stripe md-ink-ripple\" datatable=\"ng\" dt-instance=\"dtInstance\" \ndt-options=\"dtOptions\" ng-show=\"admins\"><thead><tr><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\"></span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">\nשם פרטי</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">שם משפחה\n</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">סטטוס</span></div>\n</th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">תאריך התחברות אחרון</span></div>\n</th><th><div class=\"table-header\"><span class=\"column-title\">פעולות</span></div></th></tr></thead><tbody><tr \nclass=\"md-ink-ripple\" ng-repeat=\"admin in admins\"><td><img class=\"avatar\" alt=\"{{admin.FirstName}}\" \nng-src=\"{{admin.ProfileImage || \'assets/images/avatars/profile.jpg\'}}\"></td><td>{{admin.FirstName}}</td><td>\n{{admin.LastName}}</td><td>{{admin.Status==1 || place.Status==\'1\'? \'פעיל\' : \'לא פעיל\'}}</td><td><span \nng-if=\"admin.LastLogin>0\">{{admin.LastLogin*1000 | date:\'HH:mm:ss dd/MM/yyyy\'}}</span> <span ng-if=\"admin.LastLogin<0\">\nלא התחבר</span></td><td><md-button ng-if=\"!admin.CreateTime\" aria-label=\"Use Android\" ng-click=\"sendAgain(admin)\">\n<span>שלח הזמנה בשנית</span></md-button><md-button class=\"preview-user\" ng-click=\"editAdminProfile(admin)\"><md-icon \nmd-svg-icon=\"pencil\"></md-icon></md-button></td></tr></tbody></table></div></div>");
$templateCache.put("app/main/pages/admin/admin-profile/admin-profile.html","<div id=\"admin-profile\" class=\"page-layout simple tabbed\" ng-init=\"\"><div class=\"header md-accent-bg\" layout=\"column\" \nlayout-align=\"center center\" layout-gt-sm=\"row\" layout-align-gt-sm=\"space-between end\"><div class=\"user-info\" \nlayout=\"column\" layout-align=\"center center\" layout-gt-sm=\"row\" layout-align-gt-sm=\"start center\"><img \nclass=\"profile-image avatar huge\" ng-src=\"{{ $root.User.ProfileImage || \'assets/images/avatars/profile.jpg\' }}\"><div \nclass=\"name\">{{$root.User.firstName}} {{$root.User.lastName}}</div></div><div class=\"actions\" layout=\"row\" \nlayout-align=\"end center\"></div></div><div class=\"content\" flex><md-tabs md-dynamic-height><md-tab><md-tab-label><span>\nכללי</span></md-tab-label><md-tab-body><md-content class=\"about-tab\" \nng-include=\"\'app/main/pages/admin/admin-profile/tabs/about/about.html\'\"></md-content></md-tab-body></md-tab><md-tab>\n<md-tab-label><span>סיסמה</span></md-tab-label><md-tab-body><md-content class=\"password-tab\" \nng-include=\"\'app/main/pages/admin/admin-profile/tabs/password/password.html\'\"></md-content></md-tab-body></md-tab>\n</md-tabs></div></div>");
$templateCache.put("app/main/pages/admin/new-admin/new-admin.html","<div id=\"forgot-password\" class=\"sflex aic fdc\" ng-init=\"validRequest()\"><div id=\"forgot-form\" \nng-class=\"{hideme: success}\"><h2 class=\"hfs65 center\">{{appConfig.appName}} - רישום מנהל חדש</h2><form><div><label \nclass=\"formlabel dblock fw-medium\">סיסמא חדשה</label><div class=\"inputform\"><input ng-change=\"matchPass()\" \nng-class=\"{error: shortPass || (!matchPassword && !matchFlags)}\" type=\"{{ inputType }}\" ng-model=\"form.password\" \nplaceholder=\"6 תווים (ספרות ואותיות בלועזית)\"> <button ng-click=\"showHidePassword()\" class=\"sflex aic btn\">\n{{ showHideText }} <img src=\"{{ showHideImg }}\" alt=\"\"></button><h5 class=\"hfs13 sflex jcfe\"><span \nng-class=\"{errors: !matchPasswords && !matchFlags}\">סיסמאות אינן תואמות</span> <span ng-class=\"{errors: shortPass}\">\nסיסא קצרה מדיי</span></h5></div></div><div class=\"mt40\"><label class=\"formlabel dblock fw-medium\">אימות סיסמא</label>\n<div class=\"inputform\"><input ng-class=\"{error: shortPass || (!matchPassword && !matchFlags)}\" ng-change=\"matchPass()\" \ntype=\"{{ inputType }}\" ng-model=\"passwordVerify\" placeholder=\"6 תווים (ספרות ואותיות בלועזית)\"> <button \nng-click=\"showHidePassword()\" class=\"sflex aic btn\">{{ showHideText }} <img src=\"{{ showHideImg }}\" alt=\"\"></button><h5\n class=\"hfs13 sflex jcfe\"><span ng-class=\"{errors: !matchPasswords && !matchFlags}\">סיסמאות אינן תואמות</span> <span \nng-class=\"{errors: shortPass}\">סיסמא קצרה מדיי</span></h5></div></div><div class=\"center mt40\"><div class=\"loading\" \nng-if=\"loading\" ng-class=\"{active: loading}\"><span></span></div><input type=\"submit\" \nng-disabled=\"!matchPasswords || loading\" ng-click=\"submit()\" value=\"עדכן סיסמא\"></div><div class=\"w100 center mt40\"><h4\n class=\"hfs15\">לחצו חזרה <a href=\"/\">לעמוד הכניסה</a></h4></div></form></div><div id=\"done-reset\" class=\"center\" \nng-class=\"{show: success}\"><img class=\"mb40\" src=\"/assets/icons/Done.svg\" alt=\"\"><h2 class=\"hfs65 mb30\">\nאיפוס סיסמא בוצע בהצלחה!</h2><h5 class=\"hfs27 fw-light\">מתבצע חיבור כעת</h5></div><div id=\"CopyR\" class=\"center hfs15\">\n<span>Crafted By <a href=\"https://www.marvilix.com\" target=\"_blank\">Marvilix </a>© All Rights Reserved</span></div><div\n class=\"errorBox inrowf\" ng-class=\"{show: fail}\"><div class=\"w100 center\"><span class=\"hfs15\">{{ errorInfo }}</span> \n<img src=\"/assets/icons/Close.svg\" alt=\"\" ng-click=\"fail = false\"></div></div></div>");
$templateCache.put("app/main/pages/contacts/contact-panel/contact-panel.html","<md-content ms-scroll><form id=\"contact-panel\" class=\"md-inline-form\" validate data-ng-model=\"contactForm\"><md-toolbar \nclass=\"md-accent\" layout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" \nlayout-align=\"space-between center\"><span class=\"title\">עריכת איש קשר</span><md-button class=\"md-icon-button\" \nng-click=\"$root.closePanel()\" aria-label=\"Close Dialog\" translate \ntranslate-attr-aria-label=\"PROFILE_PANEL.CLOSE_PANEL\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-input-container class=\"md-icon-float md-block\"><label>שם</label><md-icon md-font-icon=\"icon-account\" \nclass=\"name\"></md-icon><input ng-model=\"contact.Name\" type=\"text\"></md-input-container><md-input-container \nclass=\"md-block\"><md-icon md-font-icon=\"icon-phone\" class=\"name\"></md-icon><label>טלפון</label><input \nng-model=\"contact.Phone\" type=\"text\" data-ng-required=\"true\"></md-input-container><md-input-container class=\"md-block\">\n<md-icon md-font-icon=\"icon-email\" class=\"email\"></md-icon><label>מייל</label><input ng-model=\"contact.Email\" \ntype=\"email\"></md-input-container><md-input-container class=\"md-block\"><md-icon md-font-icon=\"icon-briefcase\" \nclass=\"name\"></md-icon><label>תפקיד</label><input ng-model=\"contact.Role\" type=\"text\"></md-input-container>\n<md-input-container class=\"md-block\"><md-icon md-font-icon=\"icon-comment\" class=\"name\"></md-icon><label>הערות</label>\n<textarea ng-model=\"contact.Comments\"></textarea></md-input-container><md-input-container class=\"md-block\"><md-icon \nmd-font-icon=\"icon-alert-circle\"></md-icon><label>הצג בפרופיל הורה</label><md-select ng-model=\"contact.ShowInProfile\" \nplaceholder=\"הצג בפרופיל הורה\"><md-option ng-selected=\"contact.ShowInProfile==1 || contact.ShowInProfile==\'1\'\" \nng-value=\"1\">מוצג</md-option><md-option ng-selected=\"contact.ShowInProfile==0 || contact.ShowInProfile==\'0\'\" \nng-value=\"0\">לא מוצג</md-option></md-select></md-input-container><md-input-container class=\"md-block\"><label>סטטוס\n</label><md-icon md-font-icon=\"icon-power\" class=\"name\"></md-icon><md-select ng-model=\"contact.Status\" \nplaceholder=\"סטטוס\"><md-option ng-selected=\"contact.Status==1 || contact.Status==\'1\'\" ng-value=\"1\">פעיל</md-option>\n<md-option ng-selected=\"contact.Status==0 || contact.Status==\'0\'\" ng-value=\"0\">לא פעיל</md-option></md-select>\n</md-input-container><md-input-container ng-if=\"branches.length\" class=\"md-block\" \ntitle=\"התחל לרשום שם {{$root.User.Branch}}\"><label>שיוך {{$root.User.Branches}}</label><md-contact-chips \nng-disabled=\"isClicked || !branches\" ng-model=\"selectedBranches\" md-contacts=\"branchesQuerySearch($query)\" \nmd-contact-name=\"Name\" md-require-match=\"true\" md-highlight-flags=\"i\" filter-selected=\"true\" \nplaceholder=\"בחר {{$root.User.Branches}}\"></md-contact-chips></md-input-container><md-input-container \nng-if=\"groups.length\" class=\"md-block\" title=\"התחל לרשום שם קבוצה\"><label>שיוך קבוצות</label><md-contact-chips \nng-disabled=\"isClicked || !groups\" ng-model=\"selectedGroups\" md-contacts=\"groupsQuerySearch($query)\" \nmd-contact-name=\"Name\" md-require-match=\"true\" md-highlight-flags=\"i\" filter-selected=\"true\" placeholder=\"בחר קבוצות\">\n</md-contact-chips></md-input-container></form></md-content>");
$templateCache.put("app/main/pages/contacts/new-contact-dialog/new-contact-dialog.html","<md-dialog class=\"newStudents-dialog\" aria-label=\"New Task\" ng-init=\"init()\"><form name=\"newContactForm\" \ndata-ng-model=\"newStudentsForm\" class=\"md-inline-form\" validate><md-toolbar class=\"md-accent\" layout=\"column\"><div \nclass=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">\nהוספת איש קשר חדש</span><md-button class=\"md-icon-button\" ng-click=\"closeDialog()\" aria-label=\"Close dialog\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><md-input-container \nclass=\"md-block\"><md-icon md-font-icon=\"icon-phone\" class=\"name\"></md-icon><label>טלפון</label><input \nng-change=\"checkForPhone()\" ng-model-options=\"{ debounce: 500 }\" ng-model=\"newContact.Phone\" type=\"text\" \ndata-ng-required=\"true\" ng-disabled=\"isClicked\"></md-input-container><md-input-container class=\"md-block\"><md-icon \nmd-font-icon=\"icon-account\" class=\"name\"></md-icon><label>שם</label><input ng-model=\"newContact.Name\" type=\"text\" \ndata-ng-required=\"true\" ng-disabled=\"isClicked || !phoneChecked\"></md-input-container><md-input-container \nclass=\"md-block\"><md-icon md-font-icon=\"icon-email\" class=\"email\"></md-icon><label>מייל</label><input \nng-model=\"newContact.Email\" type=\"email\" ng-disabled=\"isClicked || !phoneChecked\"></md-input-container>\n<md-input-container class=\"md-block\"><md-icon md-font-icon=\"icon-briefcase\" class=\"name\"></md-icon><label>תפקיד</label>\n<input ng-model=\"newContact.Role\" type=\"text\" ng-disabled=\"isClicked || !phoneChecked\"></md-input-container>\n<md-input-container class=\"md-block\"><md-icon md-font-icon=\"icon-comment\" class=\"name\"></md-icon><label>הערות</label>\n<textarea ng-model=\"newContact.Comments\" ng-disabled=\"isClicked || !phoneChecked\"></textarea></md-input-container>\n<md-input-container class=\"md-block\"><md-icon md-font-icon=\"icon-alert-circle\"></md-icon><label>הצג בפרופיל הורה\n</label><md-select ng-model=\"newContact.ShowInProfile\" placeholder=\"הצג בפרופיל הורה\" \nng-disabled=\"isClicked || !phoneChecked\"><md-option \nng-selected=\"contact.ShowInProfile==1 || contact.ShowInProfile==\'1\'\" ng-value=\"1\">מוצג</md-option><md-option \nng-selected=\"contact.ShowInProfile==0 || contact.ShowInProfile==\'0\'\" ng-value=\"0\">לא מוצג</md-option></md-select>\n</md-input-container><md-input-container ng-if=\"branches\" class=\"md-block\" title=\"התחל לרשום שם {{$root.User.Branch}}\">\n<label>שיוך {{$root.User.Branches}}</label><md-contact-chips ng-disabled=\"isClicked || !branches || !phoneChecked\" \nng-model=\"selectedBranches\" md-contacts=\"branchesQuerySearch($query)\" md-contact-name=\"Name\" md-require-match=\"true\" \nmd-highlight-flags=\"i\" filter-selected=\"true\" placeholder=\"בחר {{$root.User.Branches}}\"></md-contact-chips>\n</md-input-container><md-input-container ng-if=\"groups\" class=\"md-block\" title=\"התחל לרשום שם קבוצה\"><label>שיוך קבוצות\n</label><md-contact-chips ng-disabled=\"isClicked || !groups || !phoneChecked\" ng-model=\"selectedGroups\" \nmd-contacts=\"groupsQuerySearch($query)\" md-contact-name=\"Name\" md-require-match=\"true\" md-highlight-flags=\"i\" \nfilter-selected=\"true\" placeholder=\"בחר קבוצות\"></md-contact-chips></md-input-container></md-dialog-content>\n<md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\">\n<md-button data-ng-disabled=\"newContactForm.$invalid || isClicked\" type=\"submit\" ng-click=\"saveNewContact()\" \nclass=\"send-button md-accent md-raised\" aria-label=\"Add Task\">שמירה</md-button></div></md-dialog-actions></form>\n</md-dialog>");
$templateCache.put("app/main/pages/events-dialogs/cancel-registration-dialog/cancel-registration-dialog.html","<md-dialog class=\"newRegistration-dialog\" aria-label=\"New Task\"><md-toolbar class=\"md-accent\" layout=\"column\"><div \nclass=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">\nביטול הרשמה</span><md-button class=\"md-icon-button\" ng-click=\"closeDialog()\" aria-label=\"Close dialog\" translate \ntranslate-attr-aria-label=\"MANAGE_USERS.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content ms-scroll><div class=\"content\" flex><form name=\"cancelRegForm\" \ndata-ng-model=\"cancelRegForm\" class=\"md-inline-form\" validate><md-dialog-content ms-scroll><md-input-container \nclass=\"md-block\"><md-icon md-svg-icon=\"clipboard-text\" class=\"name\"></md-icon><label>סיבת ביטול</label><textarea \nng-model=\"cancelRegistration.CancelComment\" type=\"text\" ng-required=\"true\" ng-disabled=\"isClikced\"></textarea>\n</md-input-container></md-dialog-content></form></div></md-dialog-content><md-dialog-actions layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-button \nng-disabled=\"cancelRegForm.$invalid || isClikced\" ng-click=\"cancelReg()\" class=\"send-button md-accent md-raised\" \naria-label=\"Add Task\">ביטול הרשמה</md-button></div></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/pages/events-dialogs/full-registration-dialog/full-registration-dialog.html","<md-dialog class=\"full-registration-dialog\" ng-init=\"getFullRegistration()\" style=\"min-width: 850px\"><form \nname=\"newCoordinatorsForm\" data-ng-model=\"newCoordinatorsForm\" class=\"md-inline-form\" validate><md-toolbar \nclass=\"md-accent\" layout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" \nlayout-align=\"space-between center\"><span class=\"title\">פרטי הזמנה {{registrations.Registration.ID}}</span><md-button \nclass=\"md-icon-button\" ng-click=\"closeDialog()\" aria-label=\"Close dialog\" translate \ntranslate-attr-aria-label=\"MANAGE_USERS.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-tabs md-dynamic-height md-selected=\"selectedTab\"><md-tab><md-tab-label><span>פרטי הרשמה</span>\n</md-tab-label><md-tab-body><md-content class=\"about-tab\" style=\"padding: 50px\" \nng-include=\"\'app/main/pages/events-dialogs/full-registration-dialog/tabs/registration.html\'\"></md-content>\n</md-tab-body></md-tab><md-tab><md-tab-label><span>קבצים חתומים</span></md-tab-label><md-tab-body><md-content \nclass=\"about-tab\" style=\"padding: 50px\" \nng-include=\"\'app/main/pages/events-dialogs/full-registration-dialog/tabs/signedFile.html\'\"></md-content></md-tab-body>\n</md-tab><md-tab><md-tab-label><span>אמצעי תשלום</span></md-tab-label><md-tab-body><md-content class=\"about-tab\" \nstyle=\"padding: 50px\" ng-include=\"\'app/main/pages/events-dialogs/full-registration-dialog/tabs/paymnet.html\'\">\n</md-content></md-tab-body></md-tab><md-tab ng-disabled=\"registrations.Questions.length==0\"><md-tab-label><span>שאלות\n</span></md-tab-label><md-tab-body><md-content class=\"about-tab\" style=\"padding: 50px\" \nng-include=\"\'app/main/pages/events-dialogs/full-registration-dialog/tabs/questions.html\'\"></md-content></md-tab-body>\n</md-tab><md-tab ng-disabled=\"registrations.Transportation.length==0\"><md-tab-label><span>הסעות</span></md-tab-label>\n<md-tab-body><md-content class=\"about-tab\" style=\"padding: 50px\" \nng-include=\"\'app/main/pages/events-dialogs/full-registration-dialog/tabs/transportation.html\'\"></md-content>\n</md-tab-body></md-tab><md-tab><md-tab-label><span>הנחות</span></md-tab-label><md-tab-body><md-content \nng-disabled=\"$root.AdminLevel<3\" class=\"about-tab\" style=\"padding: 50px\" \nng-include=\"\'app/main/pages/events-dialogs/full-registration-dialog/tabs/discounts.html\'\"></md-content></md-tab-body>\n</md-tab><md-tab \nng-disabled=\"!(registrations.Registration.RefundReceiptID.length && registrations.Registration.RefundReceiptID[0].RefundDate) && !registrations.Registration.Canceled && !registrations.Registration.ParentsCashTransID\">\n<md-tab-label><span>פרטי ביטול וזיכוי</span></md-tab-label><md-tab-body><md-content ng-disabled=\"$root.AdminLevel<3\" \nclass=\"about-tab\" style=\"padding: 50px\" \nng-include=\"\'app/main/pages/events-dialogs/full-registration-dialog/tabs/cancel.html\'\"></md-content></md-tab-body>\n</md-tab><md-tab><md-tab-label><span>היסטורית שינויים</span></md-tab-label><md-tab-body><md-content \nng-disabled=\"$root.AdminLevel<3\" class=\"about-tab\" style=\"padding: 50px\" \nng-include=\"\'app/main/pages/events-dialogs/full-registration-dialog/tabs/logs.html\'\"></md-content></md-tab-body>\n</md-tab></md-tabs></form></md-dialog>");
$templateCache.put("app/main/pages/events-dialogs/refund-registration-dialog/refund-registration-dialog.html","<md-dialog class=\"newRegistration-dialog\" aria-label=\"New Task\"><md-toolbar class=\"md-accent\" layout=\"column\"><div \nclass=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">\nזיכוי הרשמה</span><md-button class=\"md-icon-button\" ng-click=\"closeDialog()\" aria-label=\"Close dialog\" translate \ntranslate-attr-aria-label=\"MANAGE_USERS.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content ms-scroll><div class=\"content\" flex><form name=\"cancelRegistrationForm\" \ndata-ng-model=\"cancelRegistrationForm\" class=\"md-inline-form\" validate ng-if=\"amountConfirmed\"><md-input-container \nclass=\"md-block\"><md-icon md-svg-icon=\"clipboard-text\" class=\"name\"></md-icon><label>סיבת זיכוי</label><textarea \nng-model=\"cancelRegistration.RefundComment\" type=\"text\" ng-required=\"true\" ng-disabled=\"isClikced\"></textarea>\n</md-input-container><md-input-container class=\"md-block\"><md-icon md-svg-icon=\"credit-card\" class=\"name\"></md-icon>\n<label>קבלה לזיכוי</label><md-select ng-required=\"true\" ng-change=\"changeRefundValue()\" \nng-model=\"cancelRegistration.ReceiptForRefund\" placeholder=\"קבלה לזיכוי\" ng-disabled=\"isClikced\"><md-option \nng-repeat=\"receipt in receipts\" ng-value=\"receipt\" ng-disabled=\"receipt.left==0\">{{receipt.text}}</md-option>\n</md-select></md-input-container><md-input-container class=\"md-block\"><md-icon md-svg-icon=\"credit-card\" class=\"name\">\n</md-icon><label>שיטת זיכוי</label><md-select ng-required=\"true\" ng-model=\"cancelRegistration.RefundType\" \nplaceholder=\"שיטת זיכוי\" ng-change=\"changeRefundType()\" ng-disabled=\"isClikced\"><md-option ng-value=\"1\" \nng-if=\"cancelRegistration.ReceiptForRefund && cancelRegistration.ReceiptForRefund.PaymentType == 1\">אשראי</md-option>\n<md-option ng-value=\"2\" \nng-if=\"cancelRegistration.ReceiptForRefund && cancelRegistration.ReceiptForRefund.PaymentType != 7\">מזומן</md-option>\n<md-option ng-value=\"3\" \nng-if=\"cancelRegistration.ReceiptForRefund && cancelRegistration.ReceiptForRefund.PaymentType != 7\">העברה בנקאית\n</md-option><md-option ng-value=\"4\" \nng-if=\"cancelRegistration.ReceiptForRefund && cancelRegistration.ReceiptForRefund.PaymentType != 7\">המחאה</md-option>\n<md-option ng-value=\"6\" \nng-if=\"cancelRegistration.ReceiptForRefund && cancelRegistration.ReceiptForRefund.PaymentType != 7\">\nאשראי - לא בוצע דרך המערכת</md-option><md-option ng-value=\"7\" \nng-if=\"cancelRegistration.ReceiptForRefund && parentLoaded && parent != false\">הוספה ליתרת הורה</md-option></md-select>\n</md-input-container><md-input-container class=\"md-block\" \nng-if=\"showRefundModelInit && showRefundModel && cancelRegistration.RefundType != 7\"><md-icon \nmd-svg-icon=\"credit-card\" class=\"name\"></md-icon><label>סוג זיכוי</label><md-select ng-required=\"true\" \nng-change=\"changeRefundValue()\" ng-model=\"cancelRegistration.RefundModel\" placeholder=\"סוג זיכוי\" \nng-disabled=\"!cancelRegistration.ReceiptForRefund\"><md-option ng-value=\"0\">זיכוי הרשמה</md-option><md-option \nng-value=\"1\">זיכוי מלא לקבלה</md-option></md-select></md-input-container><md-input-container class=\"md-block\"><md-icon \nmd-svg-icon=\"numeric\" class=\"name\"></md-icon><label>סכום לזיכוי</label><input ng-model=\"cancelRegistration.Refund\" \nng-disabled=\"isClikced\" ng-change=\"checkAmount()\" type=\"number\" ng-focus=\"true\" ng-required=\"true\">\n</md-input-container><div ng-if=\"cancelRegistration.RefundType==1\"><md-input-container class=\"md-block\"><md-icon \nmd-svg-icon=\"credit-card\" class=\"name\"></md-icon><label>CVV</label><input ng-model=\"cancelRegistration.CVV\" \nng-disabled=\"isClikced\"></md-input-container><md-input-container class=\"md-block\"><md-icon \nmd-svg-icon=\"account-card-details\" class=\"name\"></md-icon><label>תעודה מזהה</label><input \nng-model=\"cancelRegistration.PrivateID\" ng-disabled=\"isClikced\"></md-input-container></div><div \nng-if=\"cancelRegistration.RefundType==7 && parent != false\"><md-input-container class=\"md-block\"><div>\nשם ההורה לזיכויי: {{parent.LastName}} {{parent.FirstName}}</div></md-input-container></div><div \nng-if=\"cancelRegistration.RefundType==5\"><md-input-container class=\"md-block\"><md-icon md-svg-icon=\"credit-card\" \nclass=\"name\"></md-icon><label>4 ספרות אחרונות של כרטיס אשראי</label><input \nng-model=\"cancelRegistration.CreditCardNumber\" ng-disabled=\"isClikced\" required=\"cancelRegistration.RefundType==5\">\n</md-input-container></div><md-input-container class=\"md-block\"><md-icon md-svg-icon=\"delete\" class=\"name\"></md-icon>\n<label ng-if=\"cancelRegistration.RefundModel == 0 || cancelRegistration.RefundType == 7\">האם לבטל הזמנה?</label><label \nng-if=\"cancelRegistration.RefundModel == 1 && cancelRegistration.RefundType != 7\">\nהאם לבטל את כל ההזמנות הקשורות לקבלה זו?</label><md-select ng-required=\"true\" ng-model=\"cancelRegistration.Cancel\" \nplaceholder=\"{{cancelPlaceHolder}}\" ng-disabled=\"isClikced\"><md-option ng-value=\"1\">כן</md-option><md-option \nng-value=\"0\">לא</md-option></md-select></md-input-container><md-input-container class=\"md-block\" \nng-if=\"cancelRegistration.Cancel\"><md-icon md-svg-icon=\"clipboard-text\" class=\"name\"></md-icon><label>סיבת ביטול\n</label><textarea ng-model=\"cancelRegistration.CancelComment\" type=\"text\" ng-required=\"true\" ng-disabled=\"isClikced\">\n</textarea></md-input-container><div layout=\"row\" layout-align=\"start center\"><md-button \nng-disabled=\"cancelRegistrationForm.$invalid || isClikced\" ng-click=\"refundRegistration()\" \nclass=\"send-button md-accent md-raised\" aria-label=\"Add Task\">זיכוי הרשמה</md-button></div></form></div>\n</md-dialog-content></md-dialog>");
$templateCache.put("app/main/pages/forms-dialogs/cancellation-dialog/cancellation-dialog.html","<md-dialog class=\"subsidy-dialog\" aria-label=\"New Task\" style=\"min-width: 1000px\"><form name=\"cancel-form\" \ndata-ng-model=\"cancel-form\" class=\"md-inline-form\" validate><md-toolbar class=\"md-accent\" layout=\"column\"><div \nclass=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">\nבקשת ביטול</span><md-button class=\"md-icon-button\" ng-click=\"closeDialog()\" aria-label=\"Close dialog\" translate \ntranslate-attr-aria-label=\"MANAGE_USERS.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-content class=\"about-tab\" style=\"padding: 50px\"><form class=\"md-inline-form\" validate><div \nlayout=\"row\" layout-wrap><md-input-container class=\"md-icon-float md-block\" layout=\"column\" layout-xs=\"row\" flex=\"100\" \nflex-xs=\"100\" flex-gt-sm=\"50\" flex-gt-md=\"50\"><md-icon md-font-icon=\"icon-account\"></md-icon><label>שם חניך</label>\n<input ng-value=\"cancel.StudentName\" type=\"text\" readonly=\"readonly\"></md-input-container><md-input-container \nclass=\"md-icon-float md-block\" layout=\"column\" layout-xs=\"row\" flex=\"100\" flex-xs=\"100\" flex-gt-sm=\"50\" \nflex-gt-md=\"50\"><md-icon md-font-icon=\"icon-brightness-5\"></md-icon><label>שם {{$root.User.Event}}</label><input \nng-value=\"cancel.EventName\" type=\"text\" readonly=\"readonly\"></md-input-container></div><div layout=\"row\" layout-wrap>\n<md-input-container class=\"md-icon-float md-block\" layout=\"column\" layout-xs=\"row\" flex=\"100\" flex-xs=\"100\" \nflex-gt-sm=\"50\" flex-gt-md=\"50\"><md-icon md-font-icon=\"icon-cancel\"></md-icon><label>סיבת ביטול</label><input \nng-value=\"cancel.Reason==\'Other\' ? \'אחר\'  : \'מחלה\'\" type=\"text\" readonly=\"readonly\"></md-input-container>\n<md-input-container class=\"md-icon-float md-block\" layout=\"column\" layout-xs=\"row\" flex=\"100\" flex-xs=\"100\" \nflex-gt-sm=\"50\" flex-gt-md=\"50\"><md-icon md-font-icon=\"icon-cancel\"></md-icon><label>אחר</label><input \nng-value=\"cancel.OtherReason\" type=\"text\" readonly=\"readonly\"></md-input-container></div><div layout=\"row\" layout-wrap>\n<md-input-container class=\"md-icon-float md-block\" layout=\"column\" layout-xs=\"row\" flex=\"100\" flex-xs=\"100\" \nflex-gt-sm=\"50\" flex-gt-md=\"50\"><md-icon md-font-icon=\"icon-check\"></md-icon><label>סטטוס</label><md-select \nng-model=\"cancel.Status\"><md-option ng-value=\"\'טופל\'\">טופל</md-option><md-option ng-value=\"\'טרם טופל\'\">טרם טופל\n</md-option></md-select></md-input-container><md-input-container class=\"md-icon-float md-block\" layout=\"column\" \nlayout-xs=\"row\" flex=\"100\" flex-xs=\"100\" flex-gt-sm=\"50\" flex-gt-md=\"50\"><md-icon md-font-icon=\"icon-clipboard-text\">\n</md-icon><label>הערות (פנימי)</label><textarea ng-model=\"cancel.Comments\"></textarea></md-input-container></div>\n</form><a ng-if=\"cancel.FilePath\" style=\"font-size: 25px\" href=\"{{cancel.FilePath}}\" target=\"_self\" \ndownload=\"{{cancel.FileName}}\" title=\"{{cancel.FileName}}\" class=\"icon-file-document\"></a></md-content></form><div \nstyle=\"margin: auto\"><md-button ng-if=\"$root.AdminLevel==3\" type=\"submit\" ng-disabled=\"isClicked\" \nclass=\"md-raised md-accent\" aria-label=\"חפש\" ng-click=\"updateCancellationForm()\">עדכון</md-button></div></md-dialog>");
$templateCache.put("app/main/pages/forms-dialogs/contact-dialog/contact-dialog.html","<md-dialog class=\"subsidy-dialog\" aria-label=\"New Task\" style=\"min-width: 1000px\"><form name=\"contactForm-form\" \ndata-ng-model=\"contactForm-form\" class=\"md-inline-form\" validate><md-toolbar class=\"md-accent\" layout=\"column\"><div \nclass=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">\nטופס צור קשר</span><md-button class=\"md-icon-button\" ng-click=\"closeDialog()\" aria-label=\"Close dialog\" translate \ntranslate-attr-aria-label=\"MANAGE_USERS.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-content class=\"about-tab\" style=\"padding: 50px\"><form class=\"md-inline-form\" validate><div \nlayout=\"row\" layout-wrap><md-input-container class=\"md-icon-float md-block\" layout=\"column\" layout-xs=\"row\" flex=\"100\" \nflex-xs=\"100\" flex-gt-sm=\"50\" flex-gt-md=\"50\"><md-icon md-font-icon=\"icon-account\"></md-icon><label>שם חניך</label>\n<input ng-model=\"contactForm.StudentName\" type=\"text\" readonly=\"readonly\"></md-input-container><md-input-container \nclass=\"md-icon-float md-block\" layout=\"column\" layout-xs=\"row\" flex=\"100\" flex-xs=\"100\" flex-gt-sm=\"50\" \nflex-gt-md=\"50\"><md-icon md-font-icon=\"icon-account\"></md-icon><label>שם הורה</label><input \nng-model=\"contactForm.ParentName\" type=\"text\" readonly=\"readonly\"></md-input-container></div><div layout=\"row\" \nlayout-wrap><md-input-container class=\"md-icon-float md-block\" layout=\"column\" layout-xs=\"row\" flex=\"100\" \nflex-xs=\"100\" flex-gt-sm=\"50\" flex-gt-md=\"50\"><md-icon md-svg-icon=\"file-document-box\"></md-icon><label>נושא יצירת קשר\n</label><input ng-model=\"contactForm.Type\" type=\"text\" readonly=\"readonly\"></md-input-container></div><div \nlayout=\"row\" layout-wrap><md-input-container class=\"md-icon-float md-block\" layout=\"column\" layout-xs=\"row\" flex=\"100\">\n<md-icon md-font-icon=\"icon-email\"></md-icon><label>פרטי ההודעה</label><textarea ng-model=\"contactForm.Text\" \ntype=\"text\" readonly=\"readonly\"></textarea></md-input-container></div><div layout=\"row\" layout-wrap><md-input-container\n class=\"md-icon-float md-block\" layout=\"column\" layout-xs=\"row\" flex=\"100\" flex-xs=\"100\" flex-gt-sm=\"50\" \nflex-gt-md=\"50\"><md-icon md-font-icon=\"icon-check\"></md-icon><label>סטטוס</label><md-select \nng-model=\"contactForm.Status\"><md-option ng-value=\"\'טופל\'\">טופל</md-option><md-option ng-value=\"\'טרם טופל\'\">טרם טופל\n</md-option></md-select></md-input-container><md-input-container class=\"md-icon-float md-block\" layout=\"column\" \nlayout-xs=\"row\" flex=\"100\" flex-xs=\"100\" flex-gt-sm=\"50\" flex-gt-md=\"50\"><md-icon md-font-icon=\"icon-clipboard-text\">\n</md-icon><label>הערות (פנימי)</label><textarea ng-model=\"contactForm.Comments\"></textarea></md-input-container></div>\n</form><a ng-if=\"contactForm.FilePath\" style=\"font-size: 25px\" href=\"{{contactForm.FilePath}}\" target=\"_self\" \ndownload=\"{{contactForm.FileName}}\" title=\"{{contactForm.FileName}}\" class=\"icon-file-document\"></a></md-content>\n</form><div style=\"margin: auto\"><md-button ng-if=\"$root.AdminLevel==3\" type=\"submit\" ng-disabled=\"isClicked\" \nclass=\"md-raised md-accent\" aria-label=\"חפש\" ng-click=\"updateContactForm()\">עדכון</md-button></div></md-dialog>");
$templateCache.put("app/main/pages/password-reset/forgot-password/forgot-password.html","<div id=\"forgot-password\" class=\"sflex aic fdc\" ng-init=\"checkUserToken()\" ng-hide=\"!valid\"><div id=\"forgot-form\" \nng-class=\"{hideme: success}\"><h2 class=\"hfs65 center\">יצירת סיסמא חדשה</h2><form><div><label \nclass=\"formlabel dblock fw-medium\">סיסמא חדשה</label><div class=\"inputform\"><input ng-disabled=\"loading\" \nng-change=\"matchPass()\" ng-class=\"{error: shortPass || (!matchPassword && !matchFlags)}\" type=\"{{ inputType }}\" \nng-model=\"form.password\" placeholder=\"6 תווים (ספרות ואותיות בלועזית)\"> <button ng-click=\"showHidePassword()\" \nclass=\"sflex aic btn\">{{ showHideText }} <img src=\"{{ showHideImg }}\" alt=\"\"></button><h5 class=\"hfs13 sflex jcfe\">\n<span ng-class=\"{errors: !matchPasswords && !matchFlags}\">סיסמאות אינן תואמות</span> <span \nng-class=\"{errors: shortPass}\">סיסמא קצרה מדיי</span></h5></div></div><div class=\"mt40\"><label \nclass=\"formlabel dblock fw-medium\">אימות סיסמא</label><div class=\"inputform\"><input ng-disabled=\"loading\" \nng-class=\"{error: shortPass || (!matchPassword && !matchFlags)}\" ng-change=\"matchPass()\" type=\"{{ inputType }}\" \nng-model=\"passwordVerify\" placeholder=\"6 תווים (ספרות ואותיות בלועזית)\"> <button ng-click=\"showHidePassword()\" \nclass=\"sflex aic btn\">{{ showHideText }} <img src=\"{{ showHideImg }}\" alt=\"\"></button><h5 class=\"hfs13 sflex jcfe\">\n<span ng-class=\"{errors: !matchPasswords && !matchFlags}\">סיסמאות אינן תואמות</span> <span \nng-class=\"{errors: shortPass}\">סיסמא קצרה מדיי</span></h5></div></div><div class=\"center mt40\"><div class=\"loading\" \nng-if=\"loading\" ng-class=\"{active: loading}\"><span></span></div><input type=\"submit\" \nng-disabled=\"!matchPasswords || loading\" ng-click=\"submit()\" value=\"עדכן סיסמא\"></div><div class=\"w100 center mt40\"><h4\n class=\"hfs15\">לחצו חזרה <a href=\"/\">לעמוד הכניסה</a></h4></div></form></div><div id=\"done-reset\" class=\"center\" \nng-class=\"{show: success}\"><img class=\"mb40\" src=\"/assets/icons/Done.svg\" alt=\"\"><h2 class=\"hfs65 mb30\">\nאיפוס סיסמא בוצע בהצלחה!</h2><h5 class=\"hfs27 fw-light\">מתבצע חיבור כעת</h5></div><div id=\"CopyR\" class=\"center hfs15\">\n<span>Crafted By <a href=\"https://pionet.co.il\" class=\"notme pionet-logo\" target=\"_blank\"><img \nsrc=\"../../../assets/PionetLogo.svg\" alt=\"Pionet\"> </a>© All Rights Reserved</span></div></div>");
$templateCache.put("app/main/pages/password-reset/reset-password/reset-password.html","<div id=\"reset-password\" class=\"sflex aic fdc\"><div id=\"reset-part\" ng-class=\"{showme: success}\"><h2 \nclass=\"hfs65 mb20 center\">שכחת סיסמא?</h2><h3 class=\"hfs27 fw-light center\">\nנא להזין את כתובת המייל ואנחנו נשלח לך קישור לאיפוס סיסמא בדקות הקרובות</h3><form class=\"inrowf fdc\"><div \nclass=\"formlabel\"><label class=\"dblock fw-medium hfs15 mb5\" for=\"id\">דואר אלקטרוני</label><input type=\"email\" \nng-disabled=\"request\" ng-focus=\"wrongid = false\" ng-class=\"{error: wrongid }\" id=\"id\" ng-model=\"form.email\" \nplaceholder=\"דואר אלקטרוני איתו נרשמת למערכת\"><h5 class=\"hfs13 sflex jcfe\"><span ng-class=\"{errors: wrongid}\">\nדואר אלקטרוני לא תקין</span></h5></div><div class=\"w100 center buttonform\"><div class=\"loading\" ng-if=\"request\" \nng-class=\"{active: request}\"><span></span></div><input type=\"submit\" ng-disabled=\"request\" ng-click=\"forgot()\" \nvalue=\"איפוס סיסמא\"></div><div class=\"w100 center mt40\"><h4 class=\"hfs15\">לחצו חזרה <a href=\"/\">לעמוד הכניסה</a></h4>\n</div></form></div><div id=\"reset-success\" ng-class=\"{showme: success}\"><img src=\"/assets/icons/Sent_1.svg\" alt=\"\"><h2 \nclass=\"hfs65 mb40\">הודעת איפוס סיסמא נשלחה בהצלחה!</h2><h6 class=\"hfs27\">\nברגעים אלו נשלח אלייך מייל עם קישור ליצירת סיסמת כניסה חדשה.</h6><h6 class=\"hfs27\">\nאם לא קיבלת מייל תוך מספר דקות, מומלץ לבדוק את תיבת דואר הזבל.</h6><div class=\"w100 center mt40\"><h4 class=\"hfs15\">\nלחצו חזרה <a href=\"/\">לעמוד הכניסה</a></h4></div></div><div id=\"CopyR\" class=\"center hfs15\"><span>Crafted By <a \nhref=\"https://pionet.co.il\" class=\"notme pionet-logo\" target=\"_blank\"><img src=\"../../../assets/PionetLogo.svg\" \nalt=\"Pionet\"> </a>© All Rights Reserved</span></div><div class=\"errorBox inrowf\" ng-class=\"{show: fail}\"><div \nclass=\"w100 center\"><span class=\"hfs15\">מייל לא קיים במערכת</span> <img src=\"/assets/icons/Close.svg\" alt=\"\" \nng-click=\"fail = false\"></div></div></div>");
$templateCache.put("app/main/pages/reports/new-report-dialog/new-report-dialog.html","<md-dialog id=\"newReport-dialog\" aria-label=\"New Task\"><form name=\"newReportForm\" data-ng-model=\"newReportForm\" \nvalidate style=\"overflow: visible !important;min-height: 400px !important\"><md-toolbar class=\"md-accent\" \nlayout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\">\n<span class=\"title\">הוספת דוח חדש</span><md-button class=\"md-icon-button\" ng-click=\"closeDialog()\" \nng-disabled=\"isClicked\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content \nstyle=\"max-height:65vh;min-height: 450px !important\"><md-input-container class=\"md-block\"><md-icon \nmd-svg-icon=\"clipboard-text\"></md-icon><label>שם דוח</label><input type=\"text\" ng-model=\"report.Name\" \nplaceholder=\"הכנס/י שם כדי לשמור\"></md-input-container><md-input-container class=\"md-block\"><md-icon \nmd-svg-icon=\"file-excel\"></md-icon><label>בחר סוג דוח</label><md-select ng-model=\"report.Type\" ng-required=\"true\" \nng-change=\"getFields()\" ng-disabled=\"isClicked\"><md-option ng-value=\"1\">חניכים</md-option><md-option ng-value=\"2\" \nng-if=\"$root.AdminLevel>=2\">מחנכים</md-option><md-option ng-value=\"11\">הורים</md-option><md-option ng-value=\"3\" \nng-if=\"$root.AdminLevel>2\">{{$root.User.Coordinators}}</md-option><md-option ng-value=\"4\" ng-if=\"$root.AdminLevel>2\">\nמנהלים</md-option><md-option ng-value=\"5\" ng-if=\"$root.AdminLevel>2\" s>{{$root.User.Branches}}</md-option><md-option \nng-value=\"19\" ng-if=\"$root.AdminLevel>2\">תשלומים ל{{$root.User.Branches}}</md-option><md-option ng-value=\"6\" \nng-if=\"$root.AdminLevel>2\">{{$root.User.Groups}}</md-option><md-option ng-value=\"7\" ng-if=\"$root.AdminLevel>2\">תשלומים\n</md-option><md-option ng-value=\"8\" ng-if=\"$root.AdminLevel>2\">{{$root.User.Events}}\\מוצרים</md-option><md-option \nng-value=\"9\">{{$root.User.Events}}\\מוצרים - נרשמים</md-option><md-option ng-value=\"22\" ng-if=\"$root.AdminLevel>2\">\nהתפלגות הרשמות לפי {{$root.User.Branches}} ו{{$root.User.Grades}}</md-option><md-option ng-value=\"14\">\n{{$root.User.Events}} - נוכחות</md-option><md-option ng-value=\"15\" \nng-if=\"$root.AdminLevel>2 || $root.User.RegistrationsPer\">דוח נתוני הרשמות</md-option><md-option ng-value=\"10\" \nng-if=\"$root.AdminLevel>=2\">נרשמים לפי {{$root.User.Branch}}</md-option><md-option ng-value=\"12\" \nng-if=\"$root.AdminLevel>2\">הכנסות חודשיות</md-option><md-option ng-value=\"13\" ng-if=\"externalEventsEnabled\">\nהרשמות חיצוניות</md-option><md-option ng-value=\"16\">דוח {{$root.User.Activities}}</md-option><md-option ng-value=\"21\">\nדוח {{$root.User.Activities}} תקופתי</md-option><md-option ng-value=\"17\" ng-if=\"$root.AdminLevel>2\">דוח סיכום הנחות\n</md-option><md-option ng-value=\"18\" ng-if=\"$root.AdminLevel>2\">דוח סיבסודים</md-option><md-option ng-value=\"20\" \nng-if=\"$root.AdminLevel>2\">דוח הכנסות לפי עיר</md-option><md-option ng-value=\"23\" ng-if=\"$root.AdminLevel>=2\">\nדוח הרשמות - מטריצת {{$root.User.Branches}} ו{{$root.User.Grades}}</md-option><md-option ng-value=\"24\" \nng-if=\"$root.AdminLevel>=2\">דוח שכבות - אירועים</md-option><md-option ng-value=\"25\" ng-if=\"$root.AdminLevel>=2\">\nדוח יתרת הורים</md-option></md-select></md-input-container><md-input-container class=\"md-block\" \nng-if=\"[1,2,3,5,6,9,10,11,14,15,16,17,18,21,22,23].indexOf(report.Type) != -1\"><md-icon md-svg-icon=\"city\"></md-icon>\n<label>בחר {{$root.User.Branches}}</label><md-select multiple=\"multiple\" md-on-close=\"clearSearchTerm()\" \nng-model=\"report.Branches\" ng-disabled=\"!branches || isClicked || !branches\" ng-required=\"$root.AdminLevel==1\" \nmultiple=\"true\" ng-change=\"getGroups()\"><md-select-header class=\"demo-select-header\"><input ng-model=\"searchTerm\" \ntype=\"text\" ng-disabled=\"!branches || isClicked\" ng-keydown=\"$event.stopPropagation()\" \nplaceholder=\"חפש {{$root.User.Branches}}..\" class=\"demo-header-searchbox md-text\" autocomplete=\"off\">\n</md-select-header><md-optgroup ng-disabled=\"!branches || isClicked\"><md-option ng-value=\"branch\" \nng-repeat=\"branch in branches |filter:searchTerm\">{{branch.Name}}</md-option></md-optgroup></md-select>\n</md-input-container><md-input-container class=\"md-block\" ng-if=\"[19].indexOf(report.Type) != -1\"><md-icon \nmd-svg-icon=\"city\"></md-icon><label>בחר {{$root.User.Branch}}</label><md-select md-on-close=\"clearSearchTerm()\" \nng-model=\"report.Branches\" ng-disabled=\"!branches || isClicked || !branches\" ng-required=\"true\"><md-select-header \nclass=\"demo-select-header\"><input ng-model=\"searchTerm\" type=\"text\" ng-disabled=\"!branches || isClicked\" \nng-keydown=\"$event.stopPropagation()\" placeholder=\"חפש {{$root.User.Branch}}..\" class=\"demo-header-searchbox md-text\" \nautocomplete=\"off\"></md-select-header><md-optgroup ng-disabled=\"!branches || isClicked\"><md-option ng-value=\"branch\" \nng-repeat=\"branch in branches |filter:searchTerm\">{{branch.Name}}</md-option></md-optgroup></md-select>\n</md-input-container><md-input-container class=\"md-block\" ng-if=\"[20].indexOf(report.Type) != -1\"><md-icon \nmd-svg-icon=\"city\"></md-icon><label>בחר עיר</label><md-select md-on-close=\"clearSearchTerm()\" ng-model=\"report.City\" \nng-disabled=\"!cities || isClicked\" required><md-select-header class=\"demo-select-header\"><input ng-model=\"searchTerm\" \ntype=\"text\" ng-disabled=\"!cities || isClicked\" ng-keydown=\"$event.stopPropagation()\" placeholder=\"חפש עיר\" \nclass=\"demo-header-searchbox md-text\" autocomplete=\"off\"></md-select-header><md-optgroup \nng-disabled=\"!cities || isClicked\"><md-option ng-value=\"city.value\" ng-repeat=\"city in cities |filter:searchTerm\">\n{{city.display}}</md-option></md-optgroup></md-select></md-input-container><md-input-container class=\"md-block\" \nng-if=\"[1,2,9,14,16,17,21].indexOf(report.Type) != -1\" ng-required=\"$root.AdminLevel==1\" \nplaceholder=\"השאר ריק לבחירת כל ה{{$root.User.Groups}}\"><md-icon md-svg-icon=\"account-multiple\"></md-icon><label>\nבחר {{$root.User.Groups}}</label><md-select ng-model=\"report.Groups\" multiple=\"true\" ng-change=\"getActivities()\" \nng-disabled=\"!report.Branches || isClicked || !groups\"><md-option ng-value=\"null\">חניכים ללא {{$root.User.Groups}}\n</md-option><md-option ng-repeat=\"group in groups\" ng-value=\"group\">{{group.Name}}</md-option></md-select>\n</md-input-container><md-input-container class=\"md-block\" ng-if=\"report.Type ==16\" ng-required=\"true\"><md-icon \nmd-svg-icon=\"account-multiple\"></md-icon><label>בחר {{$root.User.Activities}}</label><md-select \nng-model=\"report.Activities\" multiple=\"true\" ng-disabled=\"!activities\"><md-option ng-repeat=\"activity in activities\" \nng-value=\"activity\">{{activity.Name}}</md-option></md-select></md-input-container><md-input-container class=\"md-block\" \nng-if=\"report.Type == 10\"><md-checkbox ng-model=\"report.DivideByGrades\" ng-true-value=\"1\" ng-false-value=\"0\" \naria-label=\"פילוג לפי {{$root.User.Grades}}\">פילוג לפי {{$root.User.Grades}}</md-checkbox></md-input-container>\n<md-input-container class=\"md-block\" \nng-if=\"[1,2,9,14,15,22,23,24].indexOf(report.Type) != -1 || (report.Type == 10 && report.DivideByGrades == 1)\" \nplaceholder=\"השאר ריק לבחירת כל {{$root.User.Grades}}\"><md-icon md-svg-icon=\"chair-school\"></md-icon><label>\nבחר {{$root.User.Grades}}</label><md-select ng-model=\"report.Grades\" multiple=\"true\" \nng-disabled=\"!grades || isClicked || !grades\" ng-change=\"getRelevantEvents()\"><md-option ng-value=\"null\">\nחניכים ללא {{$root.User.Grades}}</md-option><md-option ng-repeat=\"grade in grades\" ng-value=\"grade\">{{grade.Name}}\n</md-option></md-select></md-input-container><md-input-container class=\"md-block\" \nng-if=\"(report.Type>=1 && report.Type<=2) || (report.Type>8 && report.Type<10) || report.Type==14\" \nplaceholder=\"השאר ריק לבחירת כל האזורים\"><md-icon md-svg-icon=\"domain\"></md-icon><label>בחר איזור</label><md-select \nng-model=\"report.Areas\" multiple=\"true\" ng-disabled=\"!areas || isClicked\"><md-option ng-repeat=\"area in areas\" \nng-value=\"area\">{{area.Name}}</md-option></md-select></md-input-container><md-input-container class=\"md-block\" \nng-if=\"[8,9,10,13,14,15,17,19,20,22,23,24].indexOf(report.Type) != -1\"><label>בחר {{$root.User.Events}}\\מוצרים</label>\n<md-icon md-svg-icon=\"weather-sunny\"></md-icon><md-select md-on-close=\"clearSearchTerm()\" \nng-model=\"report.EventsSearch\" ng-disabled=\"isClicked\" \nng-required=\"report.Type>=8 && report.Type!=19 && report.Type!=20\"><md-select-header class=\"demo-select-header\"><input \nng-model=\"searchTerm\" type=\"text\" ng-disabled=\"isClicked\" ng-keydown=\"$event.stopPropagation()\" \nng-keyup=\"eventKeyPress($event)\" placeholder=\"חפש {{$root.User.Event}}..\" class=\"demo-header-searchbox md-text\" \nautocomplete=\"off\"></md-select-header><md-optgroup ng-disabled=\"!events || isClicked\"><md-option ng-value=\"event\" \nng-click=\"addToReportEvents(event)\" ng-repeat=\"event in events | filter: searchTerm\">{{event.Name}}</md-option>\n</md-optgroup></md-select></md-input-container><md-input-container class=\"md-block\" \nng-if=\"[8,9,10,13,14,15,17,19,20,23,24].indexOf(report.Type) != -1\"><md-list><md-list-item \nng-repeat=\"event in report.Events\" class=\"p0\"><div class=\"w100 sflex jcsb aic\"><span>{{event.Name}}</span><md-button \nng-click=\"removeFromReportEvents(event)\" class=\"send-button md-accent md-raised m0\"><md-icon md-font-icon=\"icon-trash\">\n</md-icon></md-button></div></md-list-item></md-list></md-input-container><md-input-container class=\"md-block\" \nng-if=\"[18].indexOf(report.Type) != -1\"><md-icon md-svg-icon=\"clipboard-text\"></md-icon><label>\n{{$root.User.Event}} (מלל חופשי)</label><input type=\"text\" ng-model=\"report.EventsFreeSearch\" \nplaceholder=\"הכנס/י שם {{$root.User.Event}}\"></md-input-container><md-input-container \nclass=\"md-icon-float md-block md-icon-left\" ng-if=\"[7,9,12,18,19,20,21].indexOf(report.Type) != -1\"><md-icon \nmd-font-icon=\"icon-calendar-select\" class=\"name\"></md-icon><label>תאריך התחלה</label><div start-view=\"day\" locale=\"he\" \nformat=\"DD/MM/YYYY\" moment-picker=\"report.startDate\" ng-if=\"report.Type != 12\"><input ng-required=\"report.Type==7\" \nautocomplete=\"off\" ng-model=\"report.startDate\" ng-disabled=\"isClicked\"></div><div start-view=\"month\" locale=\"he\" \nformat=\"MM/YYYY\" moment-picker=\"report.startDate\" ng-if=\"report.Type == 12\"><input ng-required=\"report.Type==7\" \nautocomplete=\"off\" ng-model=\"report.startDate\" ng-disabled=\"isClicked\"></div></md-input-container><md-input-container \nclass=\"md-icon-float md-block md-icon-left\" ng-if=\"[7,9,12,18,19,20,21,25].indexOf(report.Type) != -1\"><md-icon \nmd-font-icon=\"icon-calendar-select\" class=\"name\"></md-icon><label>תאריך סיום</label><div start-view=\"day\" locale=\"he\" \nformat=\"DD/MM/YYYY\" moment-picker=\"report.endDate\" ng-if=\"report.Type != 12\"><input ng-required=\"report.Type==7\" \nautocomplete=\"off\" ng-model=\"report.endDate\" ng-disabled=\"isClicked\"></div><div start-view=\"month\" locale=\"he\" \nformat=\"MM/YYYY\" moment-picker=\"report.endDate\" ng-if=\"report.Type == 12\"><input ng-required=\"report.Type==7\" \nautocomplete=\"off\" ng-model=\"report.endDate\" ng-disabled=\"isClicked\"></div></md-input-container><md-input-container \nclass=\"md-block\" ng-if=\"report.Type && (report.Type<7 || report.Type==9)\"><label>סטטוס</label><md-icon \nmd-svg-icon=\"power\"></md-icon><md-select ng-model=\"report.Status\" ng-disabled=\"isClicked\"><md-option ng-value=\"null\">\nהכל</md-option><md-option ng-value=\"1\">פעיל</md-option><md-option ng-value=\"0\">לא פעיל</md-option></md-select>\n</md-input-container><md-input-container class=\"md-block\" \nng-if=\"(report.Type>=1 && report.Type<=2) || (report.Type>8 && report.Type<10)\"><label>מין</label><md-icon \nmd-svg-icon=\"gender-male-female\"></md-icon><md-select ng-model=\"report.Gender\" ng-disabled=\"isClicked\"><md-option \nng-value=\"null\">הכל</md-option><md-option ng-value=\"1\">זכר</md-option><md-option ng-value=\"2\">נקבה</md-option>\n</md-select></md-input-container><md-input-container class=\"md-block\" \nng-if=\"report.Type && [10,18,19,20].indexOf(report.Type) == -1\"><md-icon md-svg-icon=\"notification-clear-all\">\n</md-icon><label>בחר שדות להצגה</label><md-select ng-model=\"report.Fields\" multiple=\"true\" \nng-disabled=\"!fields || fields.length==0 || isClicked\" placeholder=\"השאר ריק לבחירת כל השדות\"><md-option \nng-repeat=\"(fieldKey,fieldValue) in fields\" ng-value=\"fieldKey\">{{fieldValue}}</md-option></md-select>\n</md-input-container><md-input-container class=\"md-block\" ng-if=\"report.Type && report.Type==1\"><md-checkbox \nng-model=\"report.extraFields\" ng-disabled=\"isClicked\" ng-true-value=\"1\" ng-false-value=\"0\">הצג שדות נוספים בדו\"ח\n</md-checkbox></md-input-container></md-dialog-content><md-dialog-actions layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-button \ndata-ng-disabled=\"newReportForm.$invalid || isClicked || !report.Name || !branches\" type=\"submit\" \nng-click=\"saveNewReport()\" class=\"send-button md-accent md-raised\">שמירה</md-button><md-button \ndata-ng-disabled=\"newReportForm.$invalid || isClicked || !report.Name || !branches\" type=\"submit\" \nng-click=\"saveNewReport(true)\" class=\"send-button md-accent md-raised\">שמירה ויצוא</md-button><md-button \ndata-ng-disabled=\"newReportForm.$invalid || isClicked || !branches\" type=\"submit\" ng-click=\"saveNewReport(false,true)\" \nclass=\"send-button md-accent md-raised\">יצוא</md-button></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/pages/sms-email-dialogs/email-dialog/email-dialog.html","<md-dialog class=\"newStudents-dialog\" aria-label=\"New Task\"><form name=\"emailForm\" data-ng-model=\"emailForm\" \nclass=\"md-inline-form\" validate><md-toolbar class=\"md-accent\" layout=\"column\"><div \nclass=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">\nשליחת דואר אלקטרוני</span><md-button class=\"md-icon-button\" ng-click=\"closeDialog()\" ng-disabled=\"isClicked\" \naria-label=\"Close dialog\" translate translate-attr-aria-label=\"MANAGE_USERS.CLOSE_DIALOG\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><md-input-container \nclass=\"md-block\"><md-icon md-font-icon=\"icon-account\" class=\"name\"></md-icon><label>מספר {{typeText}} שנבחרו</label>\n<input ng-value=\"students.length\" type=\"number\" ng-disabled=\"true\"></md-input-container><md-input-container \nclass=\"md-block\" ng-if=\"!externalEmail && type==1\"><md-icon md-font-icon=\"icon-account-box\" class=\"name\"></md-icon>\n<label>נמען ההודעה</label><md-select ng-required=\"true\" ng-model=\"email.Type\" placeholder=\"נמען\" \nng-disabled=\"isClicked\"><md-option value=\"1\">חניכים בלבד</md-option><md-option value=\"2\">הורים בלבד</md-option>\n<md-option value=\"3\">הורים וחניכים</md-option></md-select></md-input-container><md-input-container class=\"md-block\">\n<md-icon md-font-icon=\"icon-email\" class=\"name\"></md-icon><label>נושא ההודעה</label><textarea \nng-disabled=\"email.Students.length==0 || isClicked\" ng-model=\"email.Subject\" ng-required=\"true\"></textarea>\n</md-input-container><md-input-container class=\"md-block\"><div ckeditor=\"options\" ng-model=\"email.Text\"></div>\n</md-input-container><md-progress-linear ng-show=\"isClicked\" md-mode=\"determinate\" value=\"{{determinateValue}}\">\n</md-progress-linear></md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><div \nlayout=\"row\" layout-align=\"start center\"><md-button \ndata-ng-disabled=\"emailForm.$invalid || isClicked || email.Students.length==0\" type=\"submit\" ng-click=\"sendEmail()\" \nclass=\"send-button md-accent md-raised\" aria-label=\"Add Task\">שליחת הודעה</md-button></div></md-dialog-actions></form>\n</md-dialog>");
$templateCache.put("app/main/pages/sms-email-dialogs/sms-dialog/sms-dialog.html","<md-dialog class=\"newStudents-dialog\" aria-label=\"New Task\" id=\"smsDialog\"><form name=\"smsForm\" \ndata-ng-model=\"smsForm\" class=\"md-inline-form\" validate><md-toolbar class=\"md-accent\" layout=\"column\"><div \nclass=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">\nשליחת הודעה</span><md-button class=\"md-icon-button\" ng-click=\"closeDialog()\" ng-disabled=\"isClicked\" \naria-label=\"Close dialog\" translate translate-attr-aria-label=\"MANAGE_USERS.CLOSE_DIALOG\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><div \nclass=\"info-header\"><md-icon md-svg-icon=\"information\"></md-icon><span class=\"title\">\nשימו לב- נמען שמספר הטלפון שלו לא תקין לא יקבל את ההודעה</span></div><md-input-container class=\"md-block\"><md-icon \nmd-font-icon=\"icon-account\" class=\"name\"></md-icon><label>מספר {{typeText}} שנבחרו</label><input \nng-value=\"sms.Students.length\" type=\"number\" ng-disabled=\"true\"></md-input-container><md-input-container \nclass=\"md-block\" ng-if=\"!externalSMS && type==1\"><md-icon md-font-icon=\"icon-account-box\" class=\"name\"></md-icon>\n<label>נמען ההודעה</label><md-select ng-required=\"true\" ng-model=\"sms.Type\" placeholder=\"נמען\" ng-disabled=\"isClicked\">\n<md-option value=\"1\">חניכים בלבד</md-option><md-option value=\"2\">הורים בלבד</md-option><md-option value=\"3\">\nהורים וחניכים</md-option></md-select></md-input-container><md-input-container class=\"md-block\"><md-icon \nmd-font-icon=\"icon-email\" class=\"name\"></md-icon><label>תוכן ההודעה</label><textarea \nng-disabled=\"sms.Students.length==0\" ng-model=\"sms.Text\" ng-required=\"true\" ng-disabled=\"isClicked\"></textarea>\n</md-input-container></md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><div \nlayout=\"row\" layout-align=\"start center\"><md-button data-ng-disabled=\"smsForm.$invalid || isClicked\" type=\"submit\" \nng-click=\"sendSMS()\" class=\"send-button md-accent md-raised\" aria-label=\"Add Task\">שליחת הודעה</md-button></div>\n</md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/ui/page-layouts/blank/blank.html","<div class=\"page-layout blank\" layout=\"row\"><h2>Blank page</h2></div>");
$templateCache.put("app/main/ui/page-layouts/demo/demo-content.html","<div class=\"demo-content\"><img src=\"assets/images/etc/early-sunrise.jpg\" class=\"md-card-image\" alt=\"sunrise\"><h1>\nEarly Sunrise</h1><h4 class=\"secondary-text\">Demo Content</h4><p>\nOne morning, when Gregor Samsa woke from troubled dreams, he found himself transformed in his bed into a horrible vermin. He lay on his armour-like back, and if he lifted his head a little he could see his brown belly, slightly domed and divided by arches into stiff sections.\n</p><blockquote><p>\nThe bedding was hardly able to cover it and seemed ready to slide off any moment. His many legs, pitifully thin compared with the size of the rest of him, waved about helplessly as he looked. \"What\'s happened to me? \" he thought. It wasn\'t a dream.\n</p><footer>John Doe</footer></blockquote><p>\nHis room, a proper human room although a little too small, lay peacefully between its four familiar walls. A collection of textile samples lay spread out on the table - Samsa was a travelling salesman - and above it there hung a picture that he had recently cut out of an illustrated magazine and housed in a nice, gilded frame.\n</p><p>\nIt showed a lady fitted out with a fur hat and fur boa who sat upright, raising a heavy fur muff that covered the whole of her lower arm towards the viewer. Gregor then turned to look out the window at the dull weather. Drops of rain could be heard hitting the pane, which made him feel quite sad.\n</p><p>\n\"How about if I sleep a little bit longer and forget all this nonsense\", he thought, but that was something he was unable to do because he was used to sleeping on his right, and in his present state couldn\'t get into that position. However hard he threw himself onto his right, he always rolled back to where he was.\n</p><p>\nHe must have tried it a hundred times, shut his eyes so that he wouldn\'t have to look at the floundering legs, and only stopped when he began to feel a mild, dull pain there that he had never felt before. \"Oh, God\", he thought, \"what a strenuous career it is that I\'ve chosen!\n</p><p>\nTravelling day in and day out. Doing business like this takes much more effort than doing your own business at home, and on top of that there\'s the curse of travelling, worries about making train connections, bad and irregular food, contact with different people all the time so that you can never get to know anyone or become friendly with them.\n</p><p>\n\"He felt a slight itch up on his belly; pushed himself slowly up on his back towards the headboard so that he could lift his head better; found where the itch was, and saw that it was covered with lots of little white spots which he didn\'t know what to make of; and when he tried to feel the place with one of his legs he drew it quickly back because as soon as he touched it he was overcome by a cold shudder. He slid back into his former position.\n</p><p>\n\"Getting up early all the time\", he thought, \"it makes you stupid. You\'ve got to get enough sleep. Other travelling salesmen live a life of luxury. For instance, whenever I go back to the guest house during the morning to copy out the contract, these gentlemen are always still sitting there eating their breakfasts. I ought to just try that with my boss; I\'d get kicked out on the spot. But who knows, maybe that would be the best thing for me...\n</p></div>");
$templateCache.put("app/main/ui/page-layouts/demo/demo-sidenav.html","<div class=\"demo-sidenav\"><md-list><md-subheader class=\"md-no-sticky\">Sidenav Demo</md-subheader><md-list-item><p>\nSidenav Item 1</p></md-list-item><md-divider></md-divider><md-list-item><p>Sidenav Item 2</p></md-list-item>\n<md-divider></md-divider><md-list-item><p>Sidenav Item 3</p></md-list-item><md-divider></md-divider><md-list-item><p>\nSidenav Item 4</p></md-list-item><md-divider></md-divider><md-list-item><p>Sidenav Item 5</p></md-list-item>\n<md-divider></md-divider><md-list-item><p>Sidenav Item 6</p></md-list-item><md-divider></md-divider><md-list-item><p>\nSidenav Item 7</p></md-list-item><md-divider></md-divider><md-list-item><p>Sidenav Item 8</p></md-list-item>\n<md-divider></md-divider><md-list-item><p>Sidenav Item 9</p></md-list-item><md-divider></md-divider><md-list-item><p>\nSidenav Item 10</p></md-list-item><md-divider></md-divider><md-list-item><p>Sidenav Item 11</p></md-list-item>\n<md-divider></md-divider><md-list-item><p>Sidenav Item 12</p></md-list-item><md-divider></md-divider><md-list-item><p>\nSidenav Item 13</p></md-list-item><md-divider></md-divider><md-list-item><p>Sidenav Item 14</p></md-list-item>\n<md-divider></md-divider><md-list-item><p>Sidenav Item 15</p></md-list-item><md-divider></md-divider><md-list-item><p>\nSidenav Item 16</p></md-list-item></md-list></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-2/template-2.html","<div class=\"template-2\"><div class=\"header p-16\" layout=\"row\" layout-align=\"start center\"><div ng-if=\"card.avatar\"><img\n class=\"avatar ml-16\" ng-src=\"{{card.avatar.src}}\" alt=\"{{card.avatar.alt}}\"></div><div class=\"info\"><div \nclass=\"title\" ng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">\n{{card.subtitle}}</div></div></div><div class=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div><div class=\"text p-16\" ng-if=\"card.text\">{{card.text}}\n</div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-10/template-10.html","<div class=\"template-10 p-16\"><div class=\"pb-16\" layout=\"row\" layout-align=\"space-between center\"><div class=\"info\">\n<div class=\"title secondary-text\" ng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle h2\" \nng-if=\"card.subtitle\">{{card.subtitle}}</div></div><div class=\"media ml-16\"><img class=\"image\" \nng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div><div \nclass=\"text\">{{card.text}}</div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-1/template-1.html","<div class=\"template-1\"><div class=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div><div class=\"content pv-24 ph-16\"><div class=\"title h1\" \nng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}\n</div><div class=\"text pt-16\" ng-if=\"card.text\">{{card.text}}</div></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-4/template-4.html","<div class=\"template-4\"><div class=\"info white-fg ph-16 pv-24\"><div class=\"title h1\" ng-if=\"card.title\">{{card.title}}\n</div><div class=\"text\" ng-if=\"card.text\">{{card.text}}</div></div><div class=\"media\"><img class=\"image\" \nng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-3/template-3.html","<div class=\"template-3 p-16 teal-bg white-fg\" layout=\"row\" layout-align=\"space-between\"><div layout=\"column\" \nlayout-align=\"space-between\"><div class=\"info\"><div class=\"title h1\" ng-if=\"card.title\">{{card.title}}</div><div \nclass=\"subtitle h3 secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}</div></div><div class=\"cta\"><md-button \nclass=\"m-0\">{{card.cta}}</md-button></div></div><div class=\"media pl-16\"><img class=\"image\" \nng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-5/template-5.html","<div class=\"template-5 p-16\" layout=\"row\" layout-align=\"space-between start\"><div class=\"info\"><div \nclass=\"title secondary-text\" ng-if=\"card.title\">{{card.title}}</div><div class=\"event h2\" ng-if=\"card.event\">\n{{card.event}}</div></div><div class=\"media ml-16\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-6/template-6.html","<div class=\"template-6\"><div class=\"content pv-24 ph-16\"><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">\n{{card.subtitle}}</div><div class=\"title h2\" ng-if=\"card.title\">{{card.title}}</div><div class=\"text pt-8\" \nng-if=\"card.text\">{{card.text}}</div></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-7/template-7.html","<div class=\"template-7\" layout=\"row\" layout-align=\"space-between\"><div class=\"info\" layout=\"column\" \nlayout-align=\"space-between\" layout-fill flex><div class=\"p-16\"><div class=\"title h1\" ng-if=\"card.title\">{{card.title}}\n</div><div class=\"subtitle h4 secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}</div><div class=\"text h4 pt-8\" \nng-if=\"card.text\">{{card.text}}</div></div><div><md-divider></md-divider><div class=\"p-8\" layout=\"row\"><md-icon \nmd-font-icon=\"icon-star-outline\" class=\"mh-5\"></md-icon><md-icon md-font-icon=\"icon-star-outline\" class=\"mh-5\">\n</md-icon><md-icon md-font-icon=\"icon-star-outline\" class=\"mh-5\"></md-icon><md-icon md-font-icon=\"icon-star-outline\" \nclass=\"mh-5\"></md-icon><md-icon md-font-icon=\"icon-star-outline\" class=\"mh-5\"></md-icon></div></div></div><div \nclass=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" \nng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-8/template-8.html","<div class=\"template-8\"><div class=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div><div class=\"content pv-24 ph-16\"><div class=\"title h1\" \nng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}\n</div><div class=\"buttons pt-16\"><md-button class=\"m-0\">{{card.button1}}</md-button><md-button class=\"m-0 md-accent\">\n{{card.button2}}</md-button></div><div class=\"text pt-16\" ng-if=\"card.text\">{{card.text}}</div></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-9/template-9.html","<div class=\"template-9\"><div class=\"header p-16\" layout=\"row\" layout-align=\"start center\"><div ng-if=\"card.avatar\"><img\n class=\"avatar ml-16\" ng-src=\"{{card.avatar.src}}\" alt=\"{{card.avatar.alt}}\"></div><div class=\"info\"><div \nclass=\"title\" ng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">\n{{card.subtitle}}</div></div></div><div class=\"text ph-16 pb-16\" ng-if=\"card.text\">{{card.text}}</div><div \nclass=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" \nng-show=\"card.media.image\"></div><div class=\"buttons m-8\"><md-button class=\"md-icon-button ml-16\" \naria-label=\"Favorite\"><md-icon md-font-icon=\"icon-heart-outline\" class=\"s24\"></md-icon></md-button><md-button \nclass=\"md-icon-button\" aria-label=\"Share\"><md-icon md-font-icon=\"icon-share\" class=\"s24\"></md-icon></md-button></div>\n</div>");
$templateCache.put("app/core/directives/ms-stepper/templates/horizontal/horizontal.html","<div class=\"ms-stepper-horizontal\"><div class=\"ms-stepper-navigation-wrapper\"><div class=\"ms-stepper-navigation\" \nlayout=\"row\" layout-align=\"center center\"><md-button class=\"ms-stepper-navigation-item\" \nng-class=\"{\'current\': MsStepper.isStepCurrent(step.stepNumber), \'valid\': MsStepper.isStepValid(step.stepNumber), \'disabled\': MsStepper.isStepDisabled(step.stepNumber), \'optional\': MsStepper.isStepOptional(step.stepNumber)}\" \nng-click=\"MsStepper.gotoStep(step.stepNumber)\" ng-disabled=\"MsStepper.isStepDisabled(step.stepNumber)\" \nng-repeat=\"step in MsStepper.steps | filter:MsStepper.filterHiddenStep\" layout=\"row\" layout-align=\"start center\"><div \nclass=\"step md-accent-bg\" layout=\"row\" layout-align=\"center center\"><span \nng-if=\"!MsStepper.isStepValid(step.stepNumber) || MsStepper.isStepOptional(step.stepNumber)\">{{$index + 1}} </span>\n<span ng-if=\"MsStepper.isStepValid(step.stepNumber) && !MsStepper.isStepOptional(step.stepNumber)\"><i \nclass=\"icon icon-check s18\"></i></span></div><div layout=\"column\" layout-align=\"start start\"><div class=\"title\" \ntranslate=\"{{step.stepTitleTranslate}}\">{{step.stepTitle}}</div><div class=\"subtitle\" \nng-if=\"MsStepper.isStepOptional(step.stepNumber)\">Optional</div></div></md-button></div></div><div \nclass=\"ms-stepper-steps\" ng-transclude></div><div class=\"ms-stepper-controls\" layout=\"row\" \nlayout-align=\"center center\"><md-button class=\"md-accent md-raised\" ng-disabled=\"MsStepper.isFirstStep()\" \nng-click=\"MsStepper.gotoPreviousStep()\">Back</md-button><div class=\"ms-stepper-dots\"><span \nng-repeat=\"step in MsStepper.steps\" ng-hide=\"MsStepper.isStepHidden(step.stepNumber)\" \nng-class=\"{\'selected md-accent-bg\':MsStepper.currentStepNumber === $index + 1}\"></span></div><md-button \nclass=\"md-accent md-raised\" ng-if=\"!MsStepper.isLastStep()\" \nng-disabled=\"!MsStepper.isStepValid(MsStepper.currentStepNumber)\" ng-click=\"MsStepper.gotoNextStep()\">Next</md-button>\n<md-button type=\"submit\" class=\"md-accent md-raised\" ng-click=\"MsStepper.resetForm()\" ng-if=\"MsStepper.isLastStep()\" \nng-disabled=\"!MsStepper.isFormValid()\">Submit</md-button></div></div>");
$templateCache.put("app/core/directives/ms-stepper/templates/vertical/vertical.html","<div class=\"ms-stepper-vertical\"><div class=\"ms-stepper-vertical-line\"></div><div class=\"ms-stepper-steps\" \nng-transclude></div></div>");
$templateCache.put("app/main/pages/accountancy/views/export-movements/export-movements.html","<div id=\"export-movements\" class=\"page-layout simple tabbed\"><div class=\"header md-accent-bg\" layout=\"column\" \nlayout-align=\"center center\" layout-gt-sm=\"row\" layout-align-gt-sm=\"space-between start\"><div class=\"h1\" layout=\"row\" \nlayout-align=\"start center\"><span class=\"md-display-1 font-weight-300\">יצוא תנועות</span></div></div><div \nclass=\"content\"><div layout=\"row\" layout-wrap><div layout=\"column\" flex=\"100\" flex-gt-sm=\"100\" flex-gt-md=\"80\" \nflex-gt-lg=\"90\"><form name=\"UserForm\" class=\"md-inline-form\" validate><div class=\"filters\" layout=\"row\" \nlayout-xs=\"column\" flex=\"100\" flex-sm=\"100\" flex-gt-md=\"50\"><div layout=\"column\" flex=\"100\" flex-gt-sm=\"50\" \nflex-md=\"33\" flex-xs=\"100\"><md-input-container class=\"md-icon-float md-block\" flex=\"25\" flex-xs=\"100\" \nstyle=\"padding: 0px 28px 0px\"><md-icon md-font-icon=\"icon-calendar-select\"></md-icon><div start-view=\"day\" locale=\"he\" \nformat=\"DD/MM/YYYY\" moment-picker=\"vm.search.From\"><label>מתאריך</label><input autocomplete=\"off\" \nng-model=\"vm.search.From\" ng-disabled=\"vm.load\"></div></md-input-container></div><div layout=\"column\" flex=\"100\" \nflex-gt-sm=\"50\" flex-md=\"33\" flex-xs=\"100\"><md-input-container class=\"md-icon-float md-block\" flex=\"25\" flex-xs=\"100\" \nstyle=\"padding: 0px 28px 0px\"><md-icon md-font-icon=\"icon-calendar-select\"></md-icon><div start-view=\"day\" locale=\"he\" \nformat=\"DD/MM/YYYY\" moment-picker=\"vm.search.To\"><label>עד לתאריך</label><input autocomplete=\"off\" \nng-model=\"vm.search.To\" ng-disabled=\"vm.load\"></div></md-input-container></div></div><div class=\"filters\" layout=\"row\" \nlayout-xs=\"column\" flex=\"100\" flex-sm=\"100\" flex-gt-md=\"50\"><div layout=\"column\" flex=\"100\" flex-gt-sm=\"50\" \nflex-md=\"33\" flex-xs=\"100\"><md-input-container class=\"md-icon-float md-block\" flex=\"25\" flex-xs=\"100\"><md-icon \nmd-font-icon=\"icon-file-document-box\"></md-icon><label>סוג דוח</label><md-select ng-model=\"vm.search.Type\" \nng-disabled=\"vm.load\" placeholder=\"סוג דוח\"><md-option ng-value=\"1\">סוג 1</md-option><md-option ng-value=\"2\">סוג 2\n</md-option><md-option ng-value=\"3\">סוג 3</md-option></md-select></md-input-container></div><div layout=\"column\" \nflex=\"100\" flex-gt-sm=\"50\" flex-md=\"33\" flex-xs=\"100\"><md-input-container class=\"md-icon-float md-block\" flex=\"25\" \nflex-xs=\"100\" ng-if=\"vm.search.Type==1\"><md-icon md-font-icon=\"icon-file-document-box\"></md-icon><label>שדות להצגה\n</label><md-select ng-model=\"vm.search.Fields\" placeholder=\"שדות להצגה\" title=\"השאר ריק כדי לבחור את כל השדות\" \nng-disabled=\"!vm.search.Type || vm.load\" multiple=\"true\"><md-option ng-value=\"\'כותרת\'\">כותרת</md-option><md-option \nng-value=\"\'סת\'\">ס\"ת</md-option><md-option ng-value=\"\'ח-ן חובה\'\">ח-ן חובה</md-option><md-option ng-value=\"\'ח-ן זכות\'\">\nח-ן זכות</md-option><md-option ng-value=\"\'תאריך\'\">תאריך</md-option><md-option ng-value=\"\'תאריך יעד\'\">תאריך יעד\n</md-option><md-option ng-value=\"\'פרטים\'\">קוד תמחיר</md-option><md-option ng-value=\"\'סכום\'\">סכום</md-option><md-option \nng-value=\"\'מטבע\'\">מטבע</md-option><md-option ng-value=\"\'מספר ריכוז\'\">מספר ריכוז</md-option><md-option \nng-value=\"\'סוג מסמך\'\">סוג מסמך</md-option><md-option ng-value=\"\'מספר הנהלת חשבונות\'\">מספר הנהלת חשבונות</md-option>\n<md-option ng-value=\"\'4 ספרות אחרונות\'\">4 ספרות אחרונות</md-option><md-option ng-value=\"\'קוד סניף\'\">קוד סניף\n</md-option></md-select></md-input-container><md-input-container class=\"md-icon-float md-block\" flex=\"25\" \nflex-xs=\"100\" ng-if=\"vm.search.Type==2\"><md-icon md-font-icon=\"icon-file-document-box\"></md-icon><label>שדות להצגה\n</label><md-select ng-model=\"vm.search.Fields\" placeholder=\"שדות להצגה\" title=\"השאר ריק כדי לבחור את כל השדות\" \nng-disabled=\"!vm.search.Type || vm.load\" multiple=\"true\"><md-option ng-value=\"\'כותרת\'\">כותרת</md-option><md-option \nng-value=\"\'תאריך\'\">תאריך</md-option><md-option ng-value=\"\'תאריך ערך\'\">תאריך ערך</md-option><md-option \nng-value=\"\'ח-ן זכות\'\">ח-ן זכות</md-option><md-option ng-value=\"\'קוד תמחיר\'\">קוד תמחיר</md-option><md-option \nng-value=\"\'מפעל\'\">מפעל</md-option><md-option ng-value=\"\'פרטים\'\">פרטים</md-option><md-option ng-value=\"\'סכום\'\">סכום\n</md-option><md-option ng-value=\"\'סכום חובה\'\">סכום חובה</md-option><md-option ng-value=\"\'סכום זכות\'\">סכום זכות\n</md-option><md-option ng-value=\"\'חברת אשראי\'\">חברת אשראי</md-option><md-option ng-value=\"\'מסוג מסמך\'\">סוג מסמך\n</md-option><md-option ng-value=\"\'סוג תשלום\'\">סוג תשלום</md-option><md-option ng-value=\"\'4 ספרות אחרונות\'\">\n4 ספרות אחרונות</md-option><md-option ng-value=\"\'קוד סניף\'\">קוד סניף</md-option></md-select></md-input-container></div>\n</div><div class=\"search-actions row\" layout=\"row\"><md-button type=\"submit\" \nng-disabled=\"(!vm.search.From && !vm.search.To) || !vm.search.Type || vm.load\" class=\"md-raised md-accent\" \naria-label=\"חפש\" ng-click=\"vm.createReport()\">יצא דוח</md-button></div></form></div></div><div ng-show=\"load\" \nlayout=\"row\" layout-sm=\"column\" layout-align=\"space-around\"><md-progress-circular md-mode=\"indeterminate\">\n</md-progress-circular></div></div></div>");
$templateCache.put("app/main/pages/accountancy/views/payments-match/payments-match.html","<div id=\"export-movements\" class=\"page-layout simple tabbed\"><div class=\"header md-accent-bg\" layout=\"column\" \nlayout-align=\"center center\" layout-gt-sm=\"row\" layout-align-gt-sm=\"space-between start\"><div class=\"h1\" layout=\"row\" \nlayout-align=\"start center\"><span class=\"md-display-1 font-weight-300\">התאמת חשבונוית מול ספק הסליקה</span></div></div>\n<div class=\"content\"><md-tabs md-dynamic-height md-selected=\"selectedTab\"><md-tab><md-tab-label><span>\nהתאמות לפי תאריכים</span></md-tab-label><md-tab-body style=\"background-color: #000000\"><div class=\"about-tab\" \nng-include=\"\'app/main/pages/accountancy/views/payments-match/tabs/match-by-dates.html\'\"></div></md-tab-body></md-tab>\n</md-tabs></div></div>");
$templateCache.put("app/main/pages/accountancy/views/receipts/receipts.html","<div id=\"receipts\" class=\"page-layout simple tabbed\"><div class=\"header md-accent-bg\" layout=\"column\" \nlayout-align=\"center center\" layout-gt-sm=\"row\" layout-align-gt-sm=\"space-between start\"><div class=\"h1\" layout=\"row\" \nlayout-align=\"start center\"><span class=\"md-display-1 font-weight-300\">קבלות</span></div></div><div class=\"content\">\n<div layout=\"row\" layout-wrap><div layout=\"column\" flex=\"100\" flex-gt-sm=\"100\" flex-gt-md=\"80\" flex-gt-lg=\"90\"><form \nname=\"UserForm\" class=\"md-inline-form\" validate><div class=\"filters\" layout=\"row\" layout-xs=\"column\" flex=\"100\" \nflex-sm=\"100\" flex-gt-md=\"50\"><div layout=\"column\" flex=\"100\" flex-gt-sm=\"50\" flex-md=\"33\" flex-xs=\"100\">\n<md-input-container class=\"md-block\"><md-icon md-svg-icon=\"cards-outline\" class=\"name\"></md-icon><label>סוג מסמך\n</label><md-select ng-model=\"vm.search.Type\" ng-disabled=\"isClicked\"><md-option ng-value=\"null\">הכל</md-option>\n<md-option ng-value=\"1\">קבלות</md-option><md-option ng-value=\"2\">זיכויים</md-option></md-select></md-input-container>\n</div><div layout=\"column\" flex=\"100\" flex-gt-sm=\"50\" flex-md=\"33\" flex-xs=\"100\" ng-if=\"externalEventsEnabled\">\n<md-input-container class=\"md-block\"><md-icon md-svg-icon=\"cards-outline\" class=\"name\"></md-icon><label>סוג הרשמה\n</label><md-select ng-model=\"vm.search.EventType\" ng-disabled=\"isClicked\"><md-option ng-value=\"null\">הכל</md-option>\n<md-option ng-value=\"1\">פנימית</md-option><md-option ng-value=\"2\">חיצונית</md-option></md-select></md-input-container>\n</div></div><div class=\"filters\" layout=\"row\" layout-xs=\"column\" flex=\"100\" flex-sm=\"100\" flex-gt-md=\"50\"><div \nlayout=\"column\" flex=\"100\" flex-gt-sm=\"50\" flex-md=\"33\" flex-xs=\"100\"><md-input-container \nclass=\"md-icon-float md-block\" layout=\"column\" layout-xs=\"row\" flex=\"100\" flex-gt-sm=\"50\" flex-gt-md=\"40\"><md-icon \nmd-font-icon=\"icon-magnify\"></md-icon><label>חיפוש לפי מספר קבלה</label><input ng-model=\"vm.search.FreeSearch\" \nng-disabled=\"isClicked\"></md-input-container></div><div layout=\"column\" flex=\"100\" flex-gt-sm=\"50\" flex-md=\"33\" \nflex-xs=\"100\"><md-input-container class=\"md-icon-float md-block\" layout=\"column\" layout-xs=\"row\" flex=\"100\" \nflex-gt-sm=\"50\" flex-gt-md=\"40\"><md-icon md-font-icon=\"icon-magnify\"></md-icon><label>חיפוש לפי 4 ספרות אחרונות</label>\n<input ng-model=\"vm.search.Last4Digit\" ng-disabled=\"isClicked\"></md-input-container></div></div><div \nclass=\"search-actions row\" layout=\"row\"><md-button type=\"submit\" ng-disabled=\"isClicked\" class=\"md-raised md-accent\" \naria-label=\"חפש\" ng-click=\"vm.getReceipts()\">סינון</md-button><md-button ng-disabled=\"isClicked\" \nclass=\"md-raised md-accent\" aria-label=\"חפש\" ng-click=\"vm.getReceipts(true)\">בטל סינון</md-button></div></form></div>\n</div><div ng-if=\"!vm.receipts\" layout=\"row\" layout-sm=\"column\" layout-align=\"space-around\"><md-progress-circular \nmd-mode=\"indeterminate\"></md-progress-circular></div><div ng-if=\"vm.receipts\"><table id=\"receipts-table\" \nclass=\"dataTable row-border hover stripe md-ink-ripple\" datatable=\"ng\" dt-instance=\"vm.dtInstance\" \ndt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">\nתאריך</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">שעה</span></div>\n</th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">סוג מסמך</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">פרטים נוספים</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">מספר מסמך</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">סכום</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">אמצעי תשלום</span></div></th></tr></thead>\n<tbody><tr class=\"entry-code-item\" ng-repeat=\"receipt in vm.receipts | orderBy:ID\" dt-column-defs=\"vm.dtColumnDefs\">\n<td>{{receipt.Date | cmdate:\'dd/MM/yyyy\'}}</td><td>{{receipt.Date | cmdate:\'HH:mm:ss\'}}</td><td>\n{{receipt.Type==1 ? \'קבלה\' : \'זיכוי\'}}</td><td>{{receipt.CreditCardNumber}}</td><td><a href=\"#\" \nng-click=\"vm.downloadReceipt(receipt)\">{{receipt.ID}}</a></td><td>{{receipt.Amount}}</td><td>{{receipt.PaymentType}}\n<md-button class=\"preview-user\" ng-disabled=\"true\"></md-button></td></tr></tbody></table></div></div></div>");
$templateCache.put("app/main/pages/admin/admin-management/admin-profile-panel/admin-profile-panel.html","<md-content ms-scroll><form name=\"systemUserForm\" data-ng-model=\"systemUserForm\" class=\"md-inline-form\" validate>\n<md-toolbar class=\"md-accent\" layout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" \nlayout-align=\"space-between center\"><span class=\"title\">עריכת מנהל</span><md-button class=\"md-icon-button\" \nng-click=\"$root.closePanel()\" aria-label=\"Close Dialog\" translate \ntranslate-attr-aria-label=\"PROFILE_PANEL.CLOSE_PANEL\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n<div class=\"md-toolbar-tools md-toolbar-tools-middle\" flex layout=\"column\" layout-align=\"center center\"><div \nlayout=\"column\" layout-align=\"center center\"><img \nng-src=\"{{adminProfile.ProfileImage || \'assets/images/avatars/profile.jpg\' }}\" \nclass=\"md-avatar avatar systemUser-avatar huge\" alt=\"{{adminProfile.UserName}}\"><div class=\"selectedUser-name\">\n{{ adminProfile.FirstName }} {{ adminProfile.LastName }}</div></div></div></md-toolbar><md-input-container \nclass=\"md-block\"><label>דואר אלקטרוני</label><md-icon md-font-icon=\"icon-email\" class=\"email\"></md-icon><input \nng-model=\"adminProfile.Email\" type=\"email\" ng-disabled=\"true\" data-ng-required=\"$root.newSystemUser\" autofocus>\n</md-input-container><md-input-container class=\"md-icon-float md-block\"><label>שם פרטי</label><md-icon \nmd-font-icon=\"icon-account\" class=\"email\"></md-icon><input ng-model=\"adminProfile.FirstName\" type=\"text\" \ndata-ng-required=\"$root.newSystemUser\"></md-input-container><md-input-container class=\"md-icon-float md-block\"><label>\nשם משפחה</label><md-icon md-font-icon=\"icon-account\" class=\"email\"></md-icon><input ng-model=\"adminProfile.LastName\" \ntype=\"text\" data-ng-required=\"$root.newSystemUser\"></md-input-container><md-input-container class=\"md-block\"><label>\nהרשאות מלאות</label><md-icon md-font-icon=\"icon-lock\"></md-icon><md-select ng-model=\"adminProfile.SuperAdmin\" \nplaceholder=\"סטטוס\"><md-option ng-selected=\"adminProfile.SuperAdmin==1\" ng-value=\"1\">כן</md-option><md-option \nng-selected=\"adminProfile.SuperAdmin==0\" ng-value=\"0\">לא</md-option></md-select></md-input-container>\n<md-input-container class=\"md-block\"><label>סטטוס</label><md-icon md-font-icon=\"icon-power\"></md-icon><md-select \nng-model=\"adminProfile.Status\" placeholder=\"סטטוס\"><md-option ng-selected=\"adminProfile.Status==1\" ng-value=\"1\">פעיל\n</md-option><md-option ng-selected=\"adminProfile.Status==0\" ng-value=\"0\">לא פעיל</md-option></md-select>\n</md-input-container></form></md-content>");
$templateCache.put("app/main/pages/admin/admin-management/new-admin-dialog/new-admin-dialog.html","<md-dialog class=\"newAdmins-dialog\" aria-label=\"New Task\"><form name=\"newAdminsForm\" data-ng-model=\"newAdminsForm\" \nclass=\"md-inline-form\" validate><md-toolbar class=\"md-accent\" layout=\"column\"><div \nclass=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">\nהוספת מנהל חדש</span><md-button class=\"md-icon-button\" ng-click=\"closeDialog()\" aria-label=\"Close dialog\" translate \ntranslate-attr-aria-label=\"MANAGE_USERS.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content ms-scroll><md-input-container class=\"md-block\"><md-icon md-font-icon=\"icon-account\" \nclass=\"name\"></md-icon><label>שם פרטי</label><input ng-model=\"newAdmin.FirstName\" type=\"text\" data-ng-required=\"true\" \nng-disabled=\"isClicked\"></md-input-container><md-input-container class=\"md-block\"><md-icon md-font-icon=\"icon-account\" \nclass=\"name\"></md-icon><label>שם משפחה</label><input ng-model=\"newAdmin.LastName\" type=\"text\" data-ng-required=\"true\" \nng-disabled=\"isClicked\"></md-input-container><md-input-container class=\"md-block\"><label>אימייל:</label><md-icon \nmd-font-icon=\"icon-email\" class=\"email\"></md-icon><input ng-required=\"true\" ng-model=\"newAdmin.Email\" type=\"email\" \nng-disabled=\"isClicked\" \nng-pattern=\"/[0-9a-zA-Z_-]+?(\\.[0-9a-zA-Z_-]+?|\\.[0-9a-zA-Z_-]+?\\.[0-9a-zA-Z_-]+?|\\.[0-9a-zA-Z_-]+?\\.[0-9a-zA-Z_-]+?\\.[0-9a-zA-Z_-]+?|)@[0-9a-zA-Z_-]+?\\.[0-9a-zA-Z]{2,15}(|\\.[0-9a-zA-Z]{2,15}|\\.[0-9a-zA-Z]{2,15}\\.[0-9a-zA-Z]{2,15}|\\.[0-9a-zA-Z]{2,15}\\.[0-9a-zA-Z]{2,15}\\.[0-9a-zA-Z]{2,15})/\">\n</md-input-container><md-input-container class=\"md-block\"><label>הרשאות מלאות</label><md-icon md-font-icon=\"icon-lock\">\n</md-icon><md-select ng-model=\"newAdmin.SuperAdmin\" ng-disabled=\"isClicked\" required><md-option ng-value=\"1\">כן\n</md-option><md-option ng-value=\"0\">לא</md-option></md-select></md-input-container></md-dialog-content>\n<md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\">\n<md-button ng-disabled=\"newAdminsForm.$invalid || isClicked\" type=\"submit\" ng-click=\"saveNewAdmin()\" \nclass=\"send-button md-accent md-raised\" aria-label=\"Add Task\">שלח הזמנה</md-button></div></md-dialog-actions></form>\n</md-dialog>");
$templateCache.put("app/main/pages/branches/views/areas/mange-areas.html","<div id=\"grades\" class=\"page-layout simple tabbed\" ng-init=\"vm.getAreas()\"><div class=\"header md-accent-bg\" \nlayout=\"column\" layout-align=\"center center\" layout-gt-sm=\"row\" layout-align-gt-sm=\"space-between start\"><div \nclass=\"h1\" layout=\"row\" layout-align=\"start center\"><span class=\"md-display-1 font-weight-300\">ניהול איזורים</span>\n</div></div><div class=\"content\"><div class=\"action-buttons\"><md-button class=\"md-fab md-accent md-icon-button\" \nid=\"add-newGrade-button\" ng-click=\"vm.addNewAreaDialog()\" aria-label=\"add new Grade\" title=\"הוספת אזור\"><md-icon \nmd-font-icon=\"icon-plus\"></md-icon></md-button></div><div layout=\"row\" layout-wrap><div layout=\"column\" flex=\"100\" \nflex-gt-sm=\"100\" flex-gt-md=\"80\" flex-gt-lg=\"90\"><form name=\"UserForm\" class=\"md-inline-form\" validate><div \nclass=\"filters\" layout=\"row\" layout-xs=\"column\" flex=\"100\" flex-sm=\"100\" flex-gt-md=\"50\"><div layout=\"column\" \nflex=\"100\" flex-gt-sm=\"50\" flex-md=\"33\" flex-xs=\"100\"><md-input-container class=\"md-icon-float md-block\"><md-icon \nmd-font-icon=\"icon-filter\"></md-icon><md-select ng-model=\"vm.search.Status\" placeholder=\"סטטוס\"><md-option \nng-value=\"undefined\">הצג הכל</md-option><md-option ng-value=\"1\" selected=\"selected\">פעילים</md-option><md-option \nng-value=\"0\">לא פעילים</md-option></md-select></md-input-container></div><div layout=\"column\" flex=\"100\" \nflex-gt-sm=\"50\" flex-md=\"33\" flex-xs=\"100\"><md-input-container class=\"md-icon-float md-block\" layout=\"column\" \nlayout-xs=\"row\" flex=\"100\" flex-gt-sm=\"50\" flex-gt-md=\"40\"><md-icon md-font-icon=\"icon-magnify\"></md-icon><label>\nחיפוש חופשי</label><input id=\"free-search\" ng-model=\"vm.search.freeSearchFromDB\" type=\"text\"></md-input-container>\n</div></div><div class=\"search-actions row\" layout=\"row\"><md-button type=\"submit\" ng-disabled=\"!vm.areas\" \nclass=\"md-raised md-accent\" aria-label=\"חפש\" ng-click=\"vm.getAreas()\">סינון</md-button><md-button \nng-disabled=\"!vm.areas\" class=\"md-raised md-accent\" aria-label=\"חפש\" ng-click=\"vm.getAreas(true)\">בטל סינון</md-button>\n</div></form></div></div><div layout=\"row\" layout-sm=\"column\" layout-align=\"space-around\" ng-if=\"!vm.areas\">\n<md-progress-circular md-mode=\"indeterminate\"></md-progress-circular></div><div ng-if=\"vm.areas\"><table \nid=\"areas-table\" class=\"dataTable row-border hover stripe md-ink-ripple\" datatable=\"ng\" dt-instance=\"dtInstance\" \ndt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">שם\n</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">סטטוס</span></div>\n</th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">פעולות</span></div></th></tr>\n</thead><tbody><tr class=\"entry-code-item\" ng-repeat=\"area in vm.areas\"><td>{{area.Name}}</td><td>\n{{area.Status ? \'פעיל\' : \'לא פעיל\'}}</td><td><md-button class=\"preview-user md-icon-button\" title=\"עריכה\" \nng-click=\"vm.editArea(area)\"><md-icon md-svg-icon=\"pencil\"></md-icon></md-button></td></tr></tbody></table></div></div>\n</div>");
$templateCache.put("app/main/pages/branches/views/grades/mange-grades.html","<div id=\"grades\" class=\"page-layout simple tabbed\"><div class=\"header md-accent-bg\" layout=\"column\" \nlayout-align=\"center center\" layout-gt-sm=\"row\" layout-align-gt-sm=\"space-between start\"><div class=\"h1\" layout=\"row\" \nlayout-align=\"start center\"><span class=\"md-display-1 font-weight-300\">ניהול {{$root.User.Grades}}</span></div></div>\n<div class=\"content\"><div class=\"action-buttons\"><md-button class=\"md-fab md-accent md-icon-button\" \nng-disabled=\"!grades\" id=\"add-newGrade-button\" ng-click=\"addNewGradesDialog()\" aria-label=\"add new Grade\" \ntitle=\"הוספה\"><md-icon md-font-icon=\"icon-plus\"></md-icon></md-button></div><div layout=\"row\" layout-wrap><div \nlayout=\"column\" flex=\"100\" flex-gt-sm=\"100\" flex-gt-md=\"80\" flex-gt-lg=\"90\"><form name=\"UserForm\" \nclass=\"md-inline-form\" validate><div class=\"filters\" layout=\"row\" layout-xs=\"column\" flex=\"100\" flex-sm=\"100\" \nflex-gt-md=\"50\"><div layout=\"column\" flex=\"100\" flex-gt-sm=\"50\" flex-md=\"33\" flex-xs=\"100\"><md-input-container \nclass=\"md-icon-float md-block\"><md-icon md-font-icon=\"icon-filter\"></md-icon><label>סטטוס</label><md-select \nng-model=\"search.status\" placeholder=\"סינון לפי סטטוס\" ng-init=\"search.status=1\" ng-disabled=\"!grades\"><md-option \nng-value=\"undefined\">הצג הכל</md-option><md-option ng-value=\"1\" selected=\"selected\">פעילים</md-option><md-option \nng-value=\"0\">לא פעילים</md-option></md-select></md-input-container></div><div layout=\"column\" flex=\"100\" \nflex-gt-sm=\"50\" flex-md=\"33\" flex-xs=\"100\"><md-input-container class=\"md-icon-float md-block\"><label>שכבת בוגרים\n</label><md-icon md-font-icon=\"icon-account-box\" class=\"name\"></md-icon><md-select ng-model=\"search.graduates\" \nplaceholder=\"סינון לפי סוג שכבה\" ng-disabled=\"!grades\"><md-option ng-value=\"undefined\">הצג הכל</md-option><md-option \nng-value=\"1\">כן</md-option><md-option ng-value=\"0\">לא</md-option></md-select></md-input-container></div></div><div \nclass=\"filters\" layout=\"row\" layout-xs=\"column\" flex=\"100\" flex-sm=\"100\" flex-gt-md=\"50\"><div layout=\"column\" \nflex=\"100\" flex-gt-sm=\"50\" flex-md=\"33\" flex-xs=\"100\"><md-input-container class=\"md-icon-float md-block\"><md-icon \nmd-font-icon=\"icon-magnify\"></md-icon><label>חיפוש חופשי</label><input id=\"free-search\" ng-model=\"search.freeSearch\" \ntype=\"text\" ng-disabled=\"!grades\"></md-input-container></div></div><div class=\"search-actions row\" layout=\"row\">\n<md-button type=\"submit\" ng-disabled=\"isClicked\" class=\"md-raised md-accent\" aria-label=\"חפש\" ng-click=\"getGrades()\">\nסינון</md-button></div></form></div></div><div layout=\"row\" layout-sm=\"column\" layout-align=\"space-around\" \nng-if=\"!grades\"><md-progress-circular md-mode=\"indeterminate\"></md-progress-circular></div><div ng-if=\"grades\" \nclass=\"branches-table-c\"><table id=\"grades-table\" class=\"dataTable row-border hover stripe md-ink-ripple\" \ndatatable=\"ng\" dt-instance=\"dtInstance\" dt-options=\"dtOptions\"><thead><tr><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">שם {{$root.User.Grade}}</span></div></th><th class=\"secondary-text\">\n<div class=\"table-header\"><span class=\"column-title\">שנתון</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">שכבת בוגרים</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">סטטוס</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">פעולות</span></div></th></tr></thead><tbody><tr \nclass=\"entry-code-item\" ng-repeat=\"grade in grades\"><td>{{grade.Name}}</td><td>{{grade.Year}}</td><td>\n{{grade.Graduates==\'1\' || grade.Graduates==1? \'כן\' : \'לא\'}}</td><td>\n{{grade.Status==1 || grade.Status==\'1\' ? \'פעיל\' : \'לא פעיל\'}}</td><td><md-button class=\"preview-user md-icon-button\" \nng-click=\"editGrade(grade)\" title=\"עריכה\"><md-icon md-svg-icon=\"pencil\"></md-icon></md-button></td></tr></tbody>\n</table></div></div></div>");
$templateCache.put("app/main/pages/branches/views/branches/branches.html","<div id=\"branches\" class=\"page-layout simple tabbed\" ng-init=\"getAreas();getTags()\"><div class=\"header md-accent-bg\" \nlayout=\"column\" layout-align=\"center center\" layout-gt-sm=\"row\" layout-align-gt-sm=\"space-between start\"><div \nclass=\"h1\" layout=\"row\" layout-align=\"start center\"><span class=\"md-display-1 font-weight-300\">\nניהול {{$root.User.Branches}}</span></div></div><div class=\"content\"><div class=\"action-buttons\"><md-button \nng-show=\"$root.AdminLevel>2\" ng-disabled=\"!branches\" class=\"md-fab md-accent md-icon-button\" id=\"add-newBranch-button\" \nng-click=\"addNewBranchDialog()\" aria-label=\"add new Branch\" title=\"הוספה\"><md-icon md-font-icon=\"icon-plus\"></md-icon>\n</md-button></div><div layout=\"row\" layout-wrap><div layout=\"column\" flex=\"100\" flex-gt-sm=\"100\" flex-gt-md=\"80\" \nflex-gt-lg=\"90\"><form name=\"UserForm\" class=\"md-inline-form\" validate><div class=\"filters\" layout=\"row\" \nlayout-xs=\"column\" flex=\"100\" flex-sm=\"100\" flex-gt-md=\"50\"><div layout=\"column\" flex=\"100\" flex-gt-sm=\"50\" \nflex-md=\"33\" flex-xs=\"100\"><md-input-container class=\"md-icon-float md-block\" layout=\"column\" layout-xs=\"row\" \nflex=\"100\" flex-gt-sm=\"50\" flex-gt-md=\"40\"><md-icon md-font-icon=\"icon-domain\"></md-icon><label>בחירת איזור</label>\n<md-select ng-model=\"search.area\" ng-disabled=\"!areas\"><md-select-header class=\"demo-select-header\"><input \nng-model=\"searchTerm\" type=\"text\" ng-keydown=\"$event.stopPropagation()\" placeholder=\"חיפוש איזור\" \nclass=\"demo-header-searchbox md-text\" autocomplete=\"off\"></md-select-header><md-optgroup><md-option \nng-repeat=\"area in areas | filter: searchTerm\" ng-value=\"area.ID\">{{area.Name}}</md-option></md-optgroup></md-select>\n</md-input-container></div><div layout=\"column\" flex=\"100\" flex-gt-sm=\"50\" flex-md=\"33\" flex-xs=\"100\">\n<md-input-container class=\"md-icon-float md-block\"><md-icon md-font-icon=\"icon-filter\"></md-icon><md-select \nng-model=\"search.status\" placeholder=\"סינון לפי סטטוס {{$root.User.Branch}}\" ng-init=\"search.status=1\" \nng-disabled=\"!branches\"><md-option ng-value=\"undefined\">הצג הכל</md-option><md-option ng-value=\"1\" selected=\"selected\">\nפעילים</md-option><md-option ng-value=\"0\">לא פעילים</md-option></md-select></md-input-container></div></div><div \nclass=\"filters\" layout=\"row\" layout-xs=\"column\" flex=\"100\" flex-sm=\"100\" flex-gt-md=\"50\"><div layout=\"column\" \nflex=\"100\" flex-gt-sm=\"50\" flex-md=\"33\" flex-xs=\"100\"><md-input-container class=\"md-icon-float md-block\"><md-icon \nmd-font-icon=\"icon-pound\"></md-icon><md-select ng-model=\"search.Tags\" placeholder=\"סינון לפי תגיות\" \nng-disabled=\"!branches || !tags\" multiple=\"multiple\"><md-option ng-repeat=\"tag in tags\" ng-value=\"tag\">{{tag}}\n</md-option></md-select></md-input-container></div><div layout=\"column\" flex=\"100\" flex-gt-sm=\"50\" flex-md=\"33\" \nflex-xs=\"100\"><md-input-container class=\"md-icon-float md-block\" layout=\"column\" layout-xs=\"row\" flex=\"100\" \nflex-gt-sm=\"50\" flex-gt-md=\"40\"><md-icon md-font-icon=\"icon-magnify\"></md-icon><label>חיפוש חופשי</label><input \nng-model=\"search.freeSearch\" type=\"text\" ng-disabled=\"!branches\"></md-input-container></div></div><div \nclass=\"search-actions row\" layout=\"row\"><md-button type=\"submit\" ng-disabled=\"!branches\" class=\"md-raised md-accent\" \naria-label=\"חפש\" ng-click=\"getBranches()\">סינון</md-button><md-button ng-disabled=\"!branches\" \nclass=\"md-raised md-accent\" aria-label=\"חפש\" ng-click=\"getBranches(true)\">בטל סינון</md-button></div></form></div>\n</div><div ng-show=\"!branches\" layout=\"row\" layout-sm=\"column\" layout-align=\"space-around\"><md-progress-circular \nmd-mode=\"indeterminate\"></md-progress-circular></div><div ng-if=\"branches\" class=\"branches-table-c\"><table \nid=\"branches-table\" class=\"dataTable row-border hover\" datatable=\"ng\" dt-instance=\"dtInstance\" dt-options=\"dtOptions\">\n<thead><tr><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">שם {{$root.User.Branch}}\n</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">ישוב</span></div>\n</th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">איזור</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">כתובת</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">טלפון</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">אימייל</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">סטטוס</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">פטור מדמי חבר</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">תשלום באמצעות טופס התחייבות</span></div>\n</th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">פעולות</span></div></th></tr>\n</thead><tbody><tr class=\"entry-code-item\" ng-repeat=\"branch in branches\"><td>{{branch.Name}}</td><td>{{branch.City}}\n</td><td>{{branch.Area}}</td><td>{{branch.Address}}</td><td>{{branch.Phone}}</td><td>{{branch.Email}}</td><td>\n{{branch.Status==1 || branch.Status==\'1\' ? \'פעיל\' : \'לא פעיל\'}}</td><td>\n{{branch.FreeMemberFay==1 || branch.FreeMemberFay==\'1\' ? \'כן\' : \'לא\'}}</td><td>\n{{branch.KibutzPay==1 || branch.KibutzPay==\'1\' ? \'כן\' : (+branch.KibutzPay == 2)? \'חלקי\' : \'לא\'}}</td><td><md-button \nclass=\"preview-user md-icon-button\" ng-click=\"editBranch(branch)\" title=\"עריכה\"><md-icon md-svg-icon=\"pencil\">\n</md-icon></md-button><md-button class=\"preview-user\" href=\"/branch-management?ID={{branch.ID}}\" \ntitle=\"ניהול {{$root.User.Branch}}\"><md-icon md-svg-icon=\"settings\"></md-icon></md-button></td></tr></tbody></table>\n</div></div></div>");
$templateCache.put("app/main/pages/branches/views/groups/mange-groups.html","<div id=\"groups\" class=\"page-layout simple tabbed\" ng-init=\"getBranches();getAreas();\"><div \nclass=\"header md-accent-bg\" layout=\"column\" layout-align=\"center center\" layout-gt-sm=\"row\" \nlayout-align-gt-sm=\"space-between start\"><div class=\"h1\" layout=\"row\" layout-align=\"start center\"><span \nclass=\"md-display-1 font-weight-300\">ניהול {{$root.User.Groups}}</span></div></div><div class=\"content\"><div \nclass=\"action-buttons\"><md-button ng-show=\"$root.AdminLevel>1\" ng-disabled=\"isClicked\" \nclass=\"md-fab md-accent md-icon-button\" id=\"add-newGroup-button\" ng-click=\"addNewGroupDialog()\" \naria-label=\"add new Group\" title=\"הוספה\"><md-icon md-font-icon=\"icon-plus\"></md-icon></md-button></div><div \nlayout=\"row\" layout-wrap><div layout=\"column\" flex=\"100\" flex-gt-sm=\"100\" flex-gt-md=\"80\" flex-gt-lg=\"90\"><form \nname=\"UserForm\" class=\"md-inline-form\" validate><div class=\"filters\" layout=\"row\" layout-xs=\"column\" flex=\"100\" \nflex-sm=\"100\" flex-gt-md=\"50\"><div layout=\"column\" flex=\"100\" flex-gt-sm=\"50\" flex-md=\"33\" flex-xs=\"100\">\n<md-input-container class=\"md-icon-float md-block\" layout=\"column\" layout-xs=\"row\" flex=\"100\" flex-gt-sm=\"50\" \nflex-gt-md=\"40\"><md-icon md-font-icon=\"icon-domain\"></md-icon><label>בחירת איזור</label><md-select \nng-model=\"search.AreaID\" ng-disabled=\"!areas || isClicked\" ng-change=\"getBranches()\"><md-select-header \nclass=\"demo-select-header\"><input ng-model=\"searchTerm\" type=\"text\" ng-keydown=\"$event.stopPropagation()\" \nplaceholder=\"חיפוש איזור\" class=\"demo-header-searchbox md-text\" autocomplete=\"off\"></md-select-header><md-optgroup>\n<md-option ng-repeat=\"area in areas | filter: searchTerm\" ng-value=\"area.ID\">{{area.Name}}</md-option></md-optgroup>\n</md-select></md-input-container></div><div layout=\"column\" flex=\"100\" flex-gt-sm=\"50\" flex-md=\"33\" flex-xs=\"100\">\n<md-input-container class=\"md-icon-float md-block\" layout=\"column\" layout-xs=\"row\" flex=\"100\" flex-gt-sm=\"50\" \nflex-gt-md=\"33\" ng-show=\"$root.AdminLevel>1\" title=\"התחל לרשום שם {{$root.User.Branch}}\"><md-icon \nmd-font-icon=\"icon-domain\"></md-icon><label>בחירת סניפים</label><md-select ng-model=\"search.Branches\" \nng-disabled=\"!branches || isClicked\" multiple=\"multiple\"><md-select-header class=\"demo-select-header\"><input \nng-model=\"searchTerm2\" type=\"text\" ng-keydown=\"$event.stopPropagation()\" placeholder=\"חיפוש סניף\" \nclass=\"demo-header-searchbox md-text\" autocomplete=\"off\"></md-select-header><md-optgroup><md-option \nng-repeat=\"branch in branches | filter: searchTerm2\" ng-value=\"branch.ID\">{{branch.Name}}</md-option></md-optgroup>\n</md-select></md-input-container></div></div><div class=\"filters\" layout=\"row\" layout-xs=\"column\" flex=\"100\" \nflex-sm=\"100\" flex-gt-md=\"50\"><div layout=\"column\" flex=\"100\" flex-gt-sm=\"50\" flex-md=\"33\" flex-xs=\"100\">\n<md-input-container class=\"md-icon-float md-block\" layout=\"column\" layout-xs=\"row\" flex=\"100\" flex-gt-sm=\"50\" \nflex-gt-md=\"33\"><md-icon md-font-icon=\"icon-filter\"></md-icon><md-select ng-model=\"search.status\" \nplaceholder=\"סינון לפי סטטוס {{$root.User.Group}}\" ng-disabled=\"isClicked\"><md-option ng-value=\"1\" selected=\"selected\">\nפעילים</md-option><md-option ng-value=\"0\">לא פעילים</md-option></md-select></md-input-container></div><div \nlayout=\"column\" flex=\"100\" flex-gt-sm=\"50\" flex-md=\"33\" flex-xs=\"100\"><md-input-container \nclass=\"md-icon-float md-block\" layout=\"column\" layout-xs=\"row\" flex=\"100\" flex-gt-sm=\"50\" flex-gt-md=\"33\"><md-icon \nmd-font-icon=\"icon-magnify\"></md-icon><label>חיפוש חופשי</label><input id=\"free-search\" \nng-model=\"search.freeSearchFromDB\" ng-disabled=\"isClicked\"></md-input-container></div></div><div \nclass=\"search-actions row\" layout=\"row\"><md-button type=\"submit\" ng-disabled=\"isClicked\" class=\"md-raised md-accent\" \naria-label=\"חפש\" ng-click=\"getGroups()\">סינון</md-button><md-button ng-disabled=\"isClicked\" \nclass=\"md-raised md-accent\" aria-label=\"חפש\" ng-click=\"getGroups(true)\">בטל סינון</md-button></div></form></div></div>\n<div layout=\"row\" layout-sm=\"column\" layout-align=\"space-around\" ng-show=\"isClicked\"><md-progress-circular \nmd-mode=\"indeterminate\"></md-progress-circular></div><div ng-if=\"!isClicked\" class=\"branches-table-c\"><table \nid=\"groups-table\" class=\"dataTable row-border hover stripe md-ink-ripple\" datatable=\"ng\" dt-instance=\"dtInstance\" \ndt-options=\"dtOptions\"><thead><tr><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">\nשם {{$root.User.Group}}</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">{{$root.User.Branch}}</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">{{$root.User.Grade}}</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">ישוב</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">סטטוס</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">פעולות</span></div></th></tr></thead><tbody><tr ng-repeat=\"group in groups\"><td>{{group.Name}}\n</td><td>{{group.BranchName}}</td><td><span ng-repeat=\"grade in group.GradesString\">{{grade}} <span ng-if=\"!$last\">,\n</span></span></td><td>{{group.City}}</td><td>{{group.Status==1 || group.Status==\'1\' ? \'פעיל\' : \'לא פעיל\'}}</td><td>\n<md-button class=\"preview-user md-icon-button\" ng-click=\"editGroup(group)\" title=\"עריכה\"><md-icon md-svg-icon=\"pencil\">\n</md-icon></md-button><md-button class=\"preview-user\" href=\"/group-management?ID={{group.ID}}\" title=\"ניהול קבוצה\">\n<md-icon md-svg-icon=\"settings\"></md-icon></md-button></td></tr></tbody></table></div></div></div>");
$templateCache.put("app/main/pages/events/views/attendance/attendance.html","<div id=\"attendance\" class=\"page-layout simple tabbed\" \nng-init=\"vm.getBranches();vm.getGrades();vm.getAreas();vm.getStatusValues()\"><div class=\"header md-accent-bg\" \nlayout=\"column\" layout-align=\"center center\" layout-gt-sm=\"row\" layout-align-gt-sm=\"space-between start\"><div \nclass=\"h1\" layout=\"row\" layout-align=\"start center\"><span class=\"md-display-1 font-weight-300\">נוכחות</span></div>\n</div><div class=\"content\"><form name=\"UserForm\" class=\"md-inline-form\" validate><div class=\"filters\" layout=\"row\" \nlayout-xs=\"column\" flex=\"100\" flex-sm=\"100\" flex-gt-md=\"50\"><div layout=\"column\" flex=\"100\" flex-gt-sm=\"50\" \nflex-md=\"33\" flex-xs=\"100\"><md-input-container class=\"md-icon-float md-block\"><label>{{$root.User.Event}}</label>\n<md-icon md-svg-icon=\"weather-sunny\"></md-icon><md-select md-on-close=\"clearSearchTerm()\" ng-model=\"vm.search.eventID\" \nng-disabled=\"!vm.students\"><md-select-header class=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" type=\"text\" \nng-disabled=\"isClicked\" ng-model-options=\"{debounce: 750}\" ng-disabled=\"!vm.students\" \nng-keydown=\"$event.stopPropagation()\" ng-change=\"vm.getEvents()\" placeholder=\"חפש {{$root.User.Event}}..\" \nclass=\"demo-header-searchbox md-text\" autocomplete=\"off\"></md-select-header><md-optgroup \nng-disabled=\"!vm.events || !vm.students\"><md-option ng-value=\"event.ID\" \nng-repeat=\"event in vm.events |filter:vm.searchTerm\">{{event.Name}}</md-option></md-optgroup></md-select>\n</md-input-container></div><div layout=\"column\" flex=\"100\" flex-gt-sm=\"50\" flex-md=\"33\" flex-xs=\"100\">\n<md-input-container class=\"md-icon-float md-block\"><md-icon md-font-icon=\"icon-power\"></md-icon><label>סטטוס נוכחות\n</label><md-select ng-model=\"vm.search.Attendance\" placeholder=\"סינון לפי סטטוס נוכחות\" ng-disabled=\"!vm.students\">\n<md-option ng-repeat=\"status in vm.statusArray\" ng-value=\"status\">{{status}}</md-option></md-select>\n</md-input-container></div></div><div class=\"filters\" layout=\"row\" layout-xs=\"column\" flex=\"100\" flex-sm=\"100\" \nflex-gt-md=\"50\"><div layout=\"column\" flex=\"100\" flex-gt-sm=\"50\" flex-md=\"33\" flex-xs=\"100\"><md-input-container \nclass=\"md-icon-float md-block\" ng-if=\"$root.AdminLevel>1\" title=\"התחל לרשום שם {{$root.User.Branch}}\"><label></label>\n<md-icon md-font-icon=\"icon-domain\"></md-icon><md-contact-chips ng-model=\"vm.search.branches\" \nmd-contacts=\"vm.branchesQuerySearch($query)\" md-contact-name=\"Name\" md-require-match=\"true\" md-highlight-flags=\"i\" \nfilter-selected=\"true\" placeholder=\"בחר {{$root.User.Branches}}\"></md-contact-chips></md-input-container></div><div \nlayout=\"column\" flex=\"100\" flex-gt-sm=\"50\" flex-md=\"33\" flex-xs=\"100\"><md-input-container \nclass=\"md-icon-float md-block\" layout=\"column\" layout-xs=\"row\" flex=\"100\" flex-gt-sm=\"100\" flex-gt-md=\"100\" \nng-if=\"$root.AdminLevel>1\" title=\"התחל לרשום שם שכבה\"><label></label><md-icon md-font-icon=\"icon-chair-school\">\n</md-icon><md-contact-chips ng-disabled=\"vm.search.freeSearchFromDB\" ng-model=\"vm.search.grades\" \nmd-contacts=\"vm.gradesQuerySearch($query)\" md-contact-name=\"Name\" md-require-match=\"true\" md-highlight-flags=\"i\" \nfilter-selected=\"true\" placeholder=\"בחר {{$root.User.Grades}}\"></md-contact-chips></md-input-container></div></div><div\n class=\"filters\" layout=\"row\" layout-xs=\"column\" flex=\"100\" flex-sm=\"100\" flex-gt-md=\"50\"><div layout=\"column\" \nflex=\"100\" flex-gt-sm=\"50\" flex-md=\"33\" flex-xs=\"100\"><md-input-container id=\"free-search\" \nclass=\"md-icon-float md-block\"><md-icon md-font-icon=\"icon-magnify\"></md-icon><label>חיפוש חופשי</label><input \nng-model=\"vm.search.freeSearchFromDB\" type=\"search\" ng-disabled=\"!vm.students\"></md-input-container></div></div><div \nclass=\"search-actions row\" layout=\"row\"><md-button type=\"submit\" ng-disabled=\"!vm.students || !vm.search.eventID\" \nclass=\"md-raised md-accent\" aria-label=\"חפש\" ng-click=\"vm.getStudents()\">סינון</md-button><md-button \nng-disabled=\"!vm.students\" class=\"md-raised md-accent\" aria-label=\"חפש\" ng-click=\"vm.getStudents(true)\">בטל סינון\n</md-button></div></form><div layout=\"row\" layout-sm=\"column\" layout-align=\"space-around\" ng-if=\"!vm.students\">\n<md-progress-circular md-mode=\"indeterminate\"></md-progress-circular></div><div ng-if=\"vm.students\"><table \nid=\"attendance-table\" class=\"dataTable row-border hover dt-responsive stripe md-ink-ripple\" datatable=\"ng\" \ndt-instance=\"vm.dtInstance\" dt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text all\"><div \nclass=\"table-header\"><span class=\"column-title\">שם</span></div></th><th class=\"secondary-text all\"><div \nclass=\"table-header\"><span class=\"column-title\">תעודת זהות</span></div></th><th class=\"secondary-text no-desktop\"><div \nclass=\"table-header\"><span class=\"column-title\">נייד</span></div></th><th class=\"secondary-text no-desktop\"><div \nclass=\"table-header\"><span class=\"column-title\">{{$root.User.Branch}}</span></div></th><th \nclass=\"secondary-text no-desktop\"><div class=\"table-header\"><span class=\"column-title\">{{$root.User.Grade}}</span>\n</div></th><th class=\"secondary-text no-desktop\"><div class=\"table-header\"><span class=\"column-title\">סטטוס הרשמה\n</span></div></th><th class=\"secondary-text no-desktop\"><div class=\"table-header\"><span class=\"column-title\">\nסטטוס תשלום</span></div></th><th class=\"secondary-text all\"><div class=\"table-header\"><span class=\"column-title\">\nסטטוס נוכחות</span></div></th><th class=\"secondary-text no-desktop\"><div class=\"table-header\"><span \nclass=\"column-title\">הערות</span></div></th></tr></thead><tbody><tr class=\"md-ink-ripple\" \nng-repeat=\"student in vm.students\"><td><a href=\"/student-profile?ID={{student.ID}}\" style=\"cursor: pointer\">\n{{student.FirstName}} {{student.LastName}}</a></td><td>{{student.PrivateID}}</td><td>{{student.PhoneNumber}}</td><td>\n{{student.BranchName}}</td><td>{{student.GradeName}}</td><td>{{student.Status==\'1\' ? \'פעיל\' : \'לא פעיל\'}}</td><td>\n{{student.PaymentStatus | paymentStatus}}</td><td><md-input-container><label>סטטוס</label><md-select \nng-model=\"student.Attendance\" ng-change=\"vm.updateAttendance(student)\"><md-option ng-repeat=\"status in vm.statusArray\" \nng-value=\"status\">{{status}}</md-option></md-select></md-input-container></td><td><md-input-container><input \nng-model=\"student.AttendanceComments\" ng-blur=\"vm.updateAttendance(student)\" placeholder=\"הערות\"></md-input-container>\n</td></tr></tbody></table></div></div></div>");
$templateCache.put("app/main/pages/events/views/events/events.html","<div id=\"events\" class=\"page-layout simple tabbed\" ng-init=\"init()\"><div class=\"header md-accent-bg\" layout=\"column\" \nlayout-align=\"center center\" layout-gt-sm=\"row\" layout-align-gt-sm=\"space-between start\"><div class=\"h1\" layout=\"row\" \nlayout-align=\"start center\"><span class=\"md-display-1 font-weight-300\">ניהול {{title}}</span></div></div><div \nclass=\"content\"><div class=\"action-buttons\"><md-button ng-if=\"$root.AdminLevel>2 || $root.User.EventsPer==1\" \nclass=\"md-fab md-accent md-icon-button\" id=\"add-newEvent-button\" ng-click=\"openNewEventDialog(title2)\" \naria-label=\"add systemUser\" title=\"יצירת {{title2}}\" ng-disabled=\"isClicked\"><md-icon md-font-icon=\"icon-plus\">\n</md-icon></md-button></div><div layout=\"row\" layout-wrap><div layout=\"column\" flex=\"100\" flex-gt-sm=\"100\" \nflex-gt-md=\"80\" flex-gt-lg=\"90\"><form name=\"UserForm\" class=\"md-inline-form\" validate><div class=\"filters\" \nlayout=\"row\" layout-xs=\"column\" flex=\"100\" flex-sm=\"100\" flex-gt-md=\"50\"><div ng-if=\"externalEventsEnabled\" \nlayout=\"column\" flex=\"100\" flex-gt-sm=\"50\" flex-md=\"33\" flex-xs=\"100\"><md-input-container \nclass=\"md-icon-float md-block\"><md-icon md-font-icon=\"icon-calendar\"></md-icon><label></label><md-select \nng-model=\"search.EventType\" placeholder=\"סוג {{title2}}\" ng-init=\"search.EventType=0\" ng-disabled=\"isClicked\">\n<md-option ng-value=\"0\">פורטל הורים</md-option><md-option ng-value=\"1\">אתר הרשמה ציבורי</md-option></md-select>\n</md-input-container></div><div layout=\"column\" flex=\"100\" flex-gt-sm=\"50\" flex-md=\"33\" flex-xs=\"100\">\n<md-input-container class=\"md-icon-float md-block\"><md-icon md-font-icon=\"icon-filter\"></md-icon><label>\nסטטוס {{title2}}</label><md-select ng-model=\"search.status\" ng-init=\"search.status=1\" \nplaceholder=\"סינון לפי סטטוס {{title2}}\" ng-disabled=\"isClicked\"><md-option ng-value=\"null\">הצג הכל</md-option>\n<md-option ng-value=\"1\" selected=\"selected\">פעילים</md-option><md-option ng-value=\"0\">לא פעילים</md-option></md-select>\n</md-input-container></div></div><div class=\"filters\" layout=\"row\" layout-xs=\"column\" flex=\"100\" flex-sm=\"100\" \nflex-gt-md=\"50\"><div layout=\"column\" flex=\"100\" flex-gt-sm=\"50\" flex-md=\"33\" flex-xs=\"100\"><md-input-container \nclass=\"md-icon-float md-block\"><md-icon md-font-icon=\"icon-filter\"></md-icon><label>{{title}} זמינים להרשמה בלבד\n</label><md-select ng-model=\"search.dateStatus\" ng-init=\"search.dateStatus=1\" \nplaceholder=\"{{title}} זמינים להרשמה בלבד\" ng-disabled=\"isClicked\"><md-option ng-value=\"null\">הצג הכל</md-option>\n<md-option ng-value=\"1\">כן</md-option><md-option ng-value=\"0\">לא</md-option></md-select></md-input-container></div>\n</div><div ng-if=\"search.EventType == 0 || externalEventsEnabled\" class=\"filters\" layout=\"row\" layout-xs=\"column\" \nflex=\"100\" flex-sm=\"100\" flex-gt-md=\"50\"><div layout=\"column\" flex=\"100\" flex-gt-sm=\"50\" flex-md=\"33\" flex-xs=\"100\">\n<md-input-container class=\"md-icon-float md-block\" title=\"התחל לרשום שם {{$root.User.Branch}}\"><label></label><md-icon \nmd-font-icon=\"icon-domain\"></md-icon><md-contact-chips ng-disabled=\"search.freeSearchFromDB\" \nng-model=\"search.branches\" md-contacts=\"branchesQuerySearch($query)\" md-contact-name=\"Name\" md-require-match=\"true\" \nmd-highlight-flags=\"i\" filter-selected=\"true\" placeholder=\"בחר {{$root.User.Branches}}\"></md-contact-chips>\n</md-input-container></div><div layout=\"column\" flex=\"100\" flex-gt-sm=\"50\" flex-md=\"33\" flex-xs=\"100\">\n<md-input-container class=\"md-icon-float md-block\" title=\"התחל לרשום שם {{$root.User.Grade}}\"><label></label><md-icon \nmd-font-icon=\"icon-chair-school\"></md-icon><md-contact-chips ng-disabled=\"search.freeSearchFromDB\" \nng-model=\"search.grades\" md-contacts=\"gradesQuerySearch($query)\" md-contact-name=\"Name\" md-require-match=\"true\" \nmd-highlight-flags=\"i\" filter-selected=\"true\" placeholder=\"בחר {{$root.User.Grades}}\"></md-contact-chips>\n</md-input-container></div></div><div class=\"filters\" layout=\"row\" layout-xs=\"column\" flex=\"100\" flex-sm=\"100\" \nflex-gt-md=\"50\"><div layout=\"column\" flex=\"100\" flex-gt-sm=\"50\" flex-md=\"33\" flex-xs=\"100\"><md-input-container \nid=\"free-search\" class=\"md-icon-float md-block\"><md-icon md-font-icon=\"icon-magnify\"></md-icon><label>חיפוש חופשי\n</label><input ng-model=\"search.freeSearchFromDB\" type=\"search\" ng-disabled=\"isClicked\"></md-input-container></div>\n</div><div class=\"search-actions row\" layout=\"row\"><md-button type=\"submit\" ng-disabled=\"isClicked \" \nclass=\"md-raised md-accent\" aria-label=\"חפש\" ng-click=\"getEvents()\">סינון</md-button><md-button \nng-disabled=\"isClicked\" class=\"md-raised md-accent\" aria-label=\"חפש\" ng-click=\"getEvents(true)\">בטל סינון</md-button>\n</div></form></div></div><div layout=\"row\" layout-sm=\"column\" layout-align=\"space-around\" ng-if=\"isClicked\">\n<md-progress-circular md-mode=\"indeterminate\"></md-progress-circular></div><div ng-if=\"!isClicked\" \nclass=\"events-table-c\"><table id=\"events-table\" class=\"dataTable row-border hover stripe md-ink-ripple\" datatable=\"ng\" \ndt-instance=\"dtInstance\" dt-options=\"dtOptions\" dt-column-defs=\"dtColumnDefs\"><thead><tr><th class=\"secondary-text\">\n<div class=\"table-header\"><span class=\"column-title\">שם ה{{title2}}</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">תאריך התחלה</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">תאריך סיום</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">תאריך סיום הרשמה</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">מחיר</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">מספר נרשמים</span></div></th><th class=\"secondary-text\" \nng-if=\"$root.AdminLevel>2\"><div class=\"table-header\"><span class=\"column-title\">הכנסות</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">סטטוס</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">פעולות</span></div></th></tr></thead>\n<tbody><tr class=\"md-ink-ripple\" ng-repeat=\"event in events\"><td>{{event.Name}}</td><td>{{event.StartDate}}</td><td>\n{{event.EndDate}}</td><td>{{event.RegistrationEndDate}}</td><td>{{event.Price}}</td><td>{{event.RegistrationCount}}\n</td><td ng-if=\"$root.AdminLevel>2\">{{event.Total}}</td><td>\n{{event.Status==1 || event.Status==\'1\' ? \'פעיל\' : \'לא פעיל\'}}</td><td><md-button class=\"preview-user\" \nhref=\"/event-management?ID={{event.ID}}\" title=\"ניהול {{title2}}\"><md-icon md-svg-icon=\"settings\"></md-icon>\n</md-button></td></tr></tbody></table></div></div></div>");
$templateCache.put("app/main/pages/events/views/questions/questions.html","<div id=\"questions\" class=\"page-layout simple tabbed\"><div class=\"header md-accent-bg\" layout=\"column\" \nlayout-align=\"center center\" layout-gt-sm=\"row\" layout-align-gt-sm=\"space-between start\"><div class=\"h1\" layout=\"row\" \nlayout-align=\"start center\"><span class=\"md-display-1 font-weight-300\">ניהול שאלות</span></div></div><div \nclass=\"content\"><div class=\"action-buttons\"><md-button class=\"md-fab md-accent md-icon-button\" \nid=\"add-newStudent-button\" ng-click=\"openNewQuestionDialog()\" aria-label=\"add systemUser\" title=\"יצירת שאלה\" \nng-disabled=\"isClicked\"><md-icon md-font-icon=\"icon-plus\"></md-icon></md-button></div><div layout=\"row\" layout-wrap>\n<div layout=\"column\" flex=\"100\" flex-gt-sm=\"100\" flex-gt-md=\"80\" flex-gt-lg=\"90\"></div></div><form \nclass=\"md-inline-form\" validate><div class=\"filters\" layout=\"row\" layout-xs=\"column\" flex=\"100\" flex-sm=\"100\" \nflex-gt-md=\"50\"><div layout=\"column\" flex=\"100\" flex-gt-sm=\"50\" flex-md=\"33\" flex-xs=\"100\"><md-input-container \nclass=\"md-icon-float md-block\"><md-icon md-font-icon=\"icon-filter\"></md-icon><md-select ng-model=\"search.Status\" \nplaceholder=\"סינון לפי סטטוס\" ng-disabled=\"!questions\" ng-init=\"search.Status=1\"><md-option ng-value=\"undefined\">\nהצג הכל</md-option><md-option ng-value=\"1\" selected=\"selected\">פעילים</md-option><md-option ng-value=\"0\">לא פעילים\n</md-option></md-select></md-input-container></div><div layout=\"column\" flex=\"100\" flex-gt-sm=\"50\" flex-md=\"33\" \nflex-xs=\"100\"><md-input-container id=\"free-search\" class=\"md-icon-float md-block\"><md-icon md-font-icon=\"icon-magnify\">\n</md-icon><label>חיפוש חופשי</label><input ng-model=\"search.FreeSearchFromDB\" type=\"search\" ng-disabled=\"!questions\">\n</md-input-container></div></div><div class=\"search-actions row\" layout=\"row\"><md-button type=\"submit\" \nng-disabled=\"!questions \" class=\"md-raised md-accent\" aria-label=\"חפש\" ng-click=\"getQuestions()\">סינון</md-button>\n</div></form><div layout=\"row\" layout-sm=\"column\" layout-align=\"space-around\" ng-show=\"!questions\">\n<md-progress-circular md-mode=\"indeterminate\"></md-progress-circular></div><div ng-if=\"questions\" \nclass=\"events-table-c\"><table id=\"questions-table\" class=\"dataTable row-border hover stripe md-ink-ripple\" \ndatatable=\"ng\" dt-instance=\"dtInstance\" dt-options=\"dtOptions\"><thead><tr><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">שאלה</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">סוג שאלה</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">סטטוס</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">פעולות</span></div></th></tr></thead><tbody><tr class=\"main-table-new\" \nng-repeat=\"question in questions  \"><td>{{question.Description}}</td><td>{{setType(question.AnswerType)}}</td><td>\n{{question.Status==1 || question.Status==\'1\' ? \'פעיל\' : \'לא פעיל\'}}</td><td><md-button class=\"preview-user\" \nng-click=\"editQuestion(question)\" title=\"עריכה\"><md-icon md-svg-icon=\"pencil\"></md-icon></md-button><md-button \nclass=\"preview-user\" ng-click=\"deleteQuestionDialog(question)\" title=\"מחיקה\"><md-icon md-svg-icon=\"delete\"></md-icon>\n</md-button></td></tr></tbody></table></div></div></div>");
$templateCache.put("app/main/pages/events/views/marketing/marketing.html","<div id=\"marketing\" class=\"page-layout simple tabbed\" \nng-init=\"vm.getBranches();vm.getGrades();vm.getAreas();vm.getEvents();\"><div class=\"header md-accent-bg\" \nlayout=\"column\" layout-align=\"center center\" layout-gt-sm=\"row\" layout-align-gt-sm=\"space-between start\"><div \nclass=\"h1\" layout=\"row\" layout-align=\"start center\"><span class=\"md-display-1 font-weight-300\">שיווק</span></div></div>\n<div class=\"content\"><div class=\"action-buttons\"><md-button ng-disabled=\"isClicked || !vm.leads\" \nng-if=\"$root.AdminLevel>2 || $root.User.EmailPer\" class=\"md-fab md-accent md-icon-button\" id=\"send-emailes-button\" \nng-click=\"vm.openSendEmail()\" aria-label=\"add systemUser\" title=\"שליחת אימיל\"><md-icon md-font-icon=\"icon-at\">\n</md-icon></md-button><md-button ng-disabled=\"isClicked || !vm.leads\" \nng-if=\"($root.AdminLevel>2 || $root.User.SmsPer) && !$root.User.SmsDisabled\" class=\"md-fab md-accent md-icon-button\" \nid=\"send-SMS-button\" ng-click=\"vm.openSendSMS()\" title=\"שליחת הודעה\" aria-label=\"add systemUser\"><md-icon \nmd-font-icon=\"icon-cellphone-android\"></md-icon></md-button></div><form name=\"UserForm\" class=\"md-inline-form\" \nvalidate><div class=\"filters\" layout=\"row\" layout-xs=\"column\" flex=\"100\" flex-sm=\"100\" flex-gt-md=\"50\"><div \nlayout=\"column\" flex=\"100\" flex-gt-sm=\"50\" flex-md=\"33\" flex-xs=\"100\"><md-input-container \nclass=\"md-icon-float md-block\"><md-icon md-font-icon=\"icon-brightness-5\"></md-icon><md-select \nng-model=\"vm.search.eventID\" placeholder=\"סינון לפי {{$root.User.Event}}\" ng-disabled=\"!vm.leads\" required><md-option \nng-repeat=\"event in vm.events\" ng-value=\"{{event.ID}}\">{{ event.Name}}</md-option></md-select></md-input-container>\n</div><div layout=\"column\" flex=\"100\" flex-gt-sm=\"50\" flex-md=\"33\" flex-xs=\"100\"><md-input-container \nclass=\"md-icon-float md-block\"><md-icon md-font-icon=\"icon-filter\"></md-icon><md-select ng-model=\"vm.search.area\" \nng-init=\"vm.search.status=1\" ng-disabled=\"!vm.leads\"><md-select-header class=\"demo-select-header\"><input \nng-model=\"searchTerm\" type=\"text\" ng-keydown=\"$event.stopPropagation()\" placeholder=\"חיפוש איזור\" \nclass=\"demo-header-searchbox md-text\" autocomplete=\"off\"></md-select-header><md-optgroup><md-option \nng-repeat=\"area in vm.area | filter: searchTerm\" ng-value=\"area.ID\">{{area.Name}}</md-option></md-optgroup></md-select>\n</md-input-container></div></div><div class=\"filters\" layout=\"row\" layout-xs=\"column\" flex=\"100\" flex-sm=\"100\" \nflex-gt-md=\"50\"><div layout=\"column\" flex=\"100\" flex-gt-sm=\"50\" flex-md=\"33\" flex-xs=\"100\"><md-input-container \nclass=\"md-icon-float md-block\" ng-if=\"$root.AdminLevel>1\" title=\"התחל לרשום שם {{$root.User.Branch}}\"><label></label>\n<md-icon md-font-icon=\"icon-domain\"></md-icon><md-contact-chips ng-model=\"vm.search.branches\" \nmd-contacts=\"vm.branchesQuerySearch($query)\" md-contact-name=\"Name\" md-require-match=\"true\" md-highlight-flags=\"i\" \nfilter-selected=\"true\" placeholder=\"בחר {{$root.User.Branches}}\"></md-contact-chips></md-input-container></div><div \nlayout=\"column\" flex=\"100\" flex-gt-sm=\"50\" flex-md=\"33\" flex-xs=\"100\"><md-input-container \nclass=\"md-icon-float md-block\" layout=\"column\" layout-xs=\"row\" flex=\"100\" flex-gt-sm=\"100\" flex-gt-md=\"100\" \nng-if=\"$root.AdminLevel>1\" title=\"התחל לרשום שם שכבה\"><label></label><md-icon md-font-icon=\"icon-chair-school\">\n</md-icon><md-contact-chips ng-disabled=\"vm.search.freeSearchFromDB\" ng-model=\"vm.search.grades\" \nmd-contacts=\"vm.gradesQuerySearch($query)\" md-contact-name=\"Name\" md-require-match=\"true\" md-highlight-flags=\"i\" \nfilter-selected=\"true\" placeholder=\"בחר {{$root.User.Grades}}\"></md-contact-chips></md-input-container></div></div><div\n class=\"filters\" layout=\"row\" layout-xs=\"column\" flex=\"100\" flex-sm=\"100\" flex-gt-md=\"50\"><div layout=\"column\" \nflex=\"100\" flex-gt-sm=\"50\" flex-md=\"33\" flex-xs=\"100\"><md-input-container id=\"free-search\" \nclass=\"md-icon-float md-block\"><md-icon md-font-icon=\"icon-magnify\"></md-icon><label>חיפוש חופשי</label><input \nng-model=\"vm.search.freeSearchFromDB\" type=\"search\" ng-disabled=\"!vm.leads\" style=\"width: 302px\"></md-input-container>\n</div></div><div class=\"search-actions row\" layout=\"row\"><md-button type=\"submit\" \nng-disabled=\"!vm.leads || !vm.search.eventID\" class=\"md-raised md-accent\" aria-label=\"חפש\" ng-click=\"vm.getLeads()\">\nסינון</md-button><md-button ng-disabled=\"!vm.leads\" class=\"md-raised md-accent\" aria-label=\"חפש\" \nng-click=\"vm.getLeads(true)\">בטל סינון</md-button></div></form><div layout=\"row\" layout-sm=\"column\" \nlayout-align=\"space-around\" ng-if=\"!vm.leads\"><md-progress-circular md-mode=\"indeterminate\"></md-progress-circular>\n</div><div ng-if=\"vm.leads\"><table id=\"leads-table\" class=\"dataTable row-border hover stripe md-ink-ripple\" \ndatatable=\"ng\" dt-instance=\"vm.dtInstance\" dt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\"><input ng-model=\"selectAll\" type=\"checkbox\" \nng-change=\"vm.setAll(selectAll)\"></span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">שם</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">מין</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">דואר אלקטרוני</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">{{$root.User.Group}}</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">{{$root.User.Grade}}</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">{{$root.User.Branch}}</span></div></th></tr></thead><tbody><tr class=\"md-ink-ripple\" \nng-repeat=\"student in vm.leads\"><td><input type=\"checkbox\" ng-model=\"student.Selected\"></td><td><a \nhref=\"/student-profile?ID={{student.ID}}\" style=\"cursor: pointer\">{{student.FirstName}} {{student.LastName}}</a></td>\n<td>{{student.Gender==\'Male\' ? \'זכר\' : \'נקבה\'}}</td><td ng-if=\"student.Gender==\'Male\'\">בן</td><td \nng-if=\"student.Gender==\'Female\'\">בת</td><td ng-if=\"student.Gender==\'Other\'\">אחר</td><td><a \nhref=\"mailto: {{student.Email}}\">{{student.Email}}</a></td><td>{{student.GroupName}}</td><td>{{student.GradeName}}</td>\n<td>{{student.BranchName}}</td></tr></tbody></table></div></div></div>");
$templateCache.put("app/main/pages/events/views/registrations/registrations.html","<div id=\"registrations\" class=\"page-layout simple tabbed\" \nng-init=\"getEvents();getBranchesAndGroups();getAreas();getGrades()\"><div class=\"header md-accent-bg\" layout=\"column\" \nlayout-align=\"center center\" layout-gt-sm=\"row\" layout-align-gt-sm=\"space-between start\"><div class=\"h1\" layout=\"row\" \nlayout-align=\"start center\"><span class=\"md-display-1 font-weight-300\">הרשמות</span></div></div><div class=\"content\">\n<div layout=\"row\" layout-wrap><div layout=\"column\" flex=\"100\" flex-gt-sm=\"100\" flex-gt-md=\"80\" flex-gt-lg=\"90\"><form \nname=\"UserForm\" class=\"md-inline-form\" validate><div class=\"filters\" layout=\"row\" layout-xs=\"column\" flex=\"100\" \nflex-sm=\"100\" flex-gt-md=\"50\"><div layout=\"column\" flex=\"100\" flex-gt-sm=\"50\" flex-md=\"33\" flex-xs=\"100\">\n<md-input-container class=\"md-icon-float md-block\" ng-if=\"$root.AdminLevel>1\" \ntitle=\"התחל לרשום שם {{$root.User.Branch}}\"><label></label><md-icon md-font-icon=\"icon-city\"></md-icon>\n<md-contact-chips ng-model=\"search.branches\" ng-change=\"getGroups()\" md-contacts=\"branchesQuerySearch($query)\" \nmd-contact-name=\"Name\" md-require-match=\"true\" md-highlight-flags=\"i\" filter-selected=\"true\" \nplaceholder=\"בחר {{$root.User.Branches}}\"></md-contact-chips></md-input-container></div><div layout=\"column\" \nflex=\"100\" flex-gt-sm=\"50\" flex-md=\"33\" flex-xs=\"100\"><md-input-container class=\"md-icon-float md-block\" \ntitle=\"התחל לרשום שם  {{$root.User.Group}}\" ng-if=\"groups && search.branches.length>0\"><label></label><md-icon \nmd-font-icon=\"icon-account-multiple\"></md-icon><md-contact-chips ng-model=\"search.groups\" \nmd-contacts=\"groupsQuerySearch($query)\" md-contact-name=\"Name\" md-require-match=\"true\" md-highlight-flags=\"i\" \nfilter-selected=\"true\" placeholder=\"בחר {{$root.User.Groups}}\"></md-contact-chips></md-input-container></div></div><div\n class=\"filters\" layout=\"row\" layout-xs=\"column\" flex=\"100\" flex-sm=\"100\" flex-gt-md=\"50\"><div layout=\"column\" \nflex=\"100\" flex-gt-sm=\"50\" flex-md=\"33\" flex-xs=\"100\"><md-input-container class=\"md-icon-float md-block\" \nlayout=\"column\" layout-xs=\"row\" flex=\"100\" flex-gt-sm=\"50\" flex-gt-md=\"33\" ng-if=\"$root.AdminLevel>1\" \ntitle=\"התחל לרשום שם {{$root.User.Grade}}\"><label></label><md-icon md-font-icon=\"icon-chair-school\"></md-icon>\n<md-contact-chips ng-disabled=\"search.freeSearchFromDB\" ng-model=\"search.grades\" \nmd-contacts=\"gradesQuerySearch($query)\" md-contact-name=\"Name\" md-require-match=\"true\" md-highlight-flags=\"i\" \nfilter-selected=\"true\" placeholder=\"בחר {{$root.User.Grades}}\"></md-contact-chips></md-input-container></div></div><div\n class=\"filters\" layout=\"row\" layout-xs=\"column\" flex=\"100\" flex-sm=\"100\" flex-gt-md=\"50\"><div layout=\"column\" \nflex=\"100\" flex-gt-sm=\"50\" flex-md=\"33\" flex-xs=\"100\"><md-input-container class=\"md-icon-float md-block\"><md-icon \nmd-font-icon=\"icon-filter\"></md-icon><md-select ng-model=\"search.area\" ng-init=\"search.status=1\" ng-disabled=\"loader\">\n<md-select-header class=\"demo-select-header\"><input ng-model=\"searchTerm\" type=\"text\" \nng-keydown=\"$event.stopPropagation()\" placeholder=\"סינון לפי אזור\" class=\"demo-header-searchbox md-text\" \nautocomplete=\"off\"></md-select-header><md-optgroup><md-option ng-repeat=\"pl in area | filter: searchTerm\" \nng-value=\"pl.ID\">{{pl.Name}}</md-option></md-optgroup></md-select></md-input-container></div><div layout=\"column\" \nflex=\"100\" flex-gt-sm=\"50\" flex-md=\"33\" flex-xs=\"100\"><md-input-container class=\"md-icon-float md-block md-icon-left\">\n<md-icon md-font-icon=\"icon-brightness-5\"></md-icon><label>{{$root.User.Event}}</label><md-select \nmd-on-close=\"clearSearchTerm()\" ng-model=\"search.Events\" ng-disabled=\"isClicked\" multiple=\"true\" \nng-required=\"$root.AdminLevel<3\"><md-select-header class=\"demo-select-header\"><input ng-model=\"searchTerm\" type=\"text\" \nng-disabled=\"isClicked\" placeholder=\"חפש {{$root.User.Event}}..\" class=\"demo-header-searchbox md-text\" \nautocomplete=\"off\"></md-select-header><md-optgroup ng-disabled=\"isClicked\"><md-option ng-value=\"event.ID\" \nng-repeat=\"event in events |filter:searchTerm\">{{event.Name}}</md-option></md-optgroup></md-select>\n</md-input-container></div></div><div class=\"filters\" layout=\"row\" layout-xs=\"column\" flex=\"100\" flex-sm=\"100\" \nflex-gt-md=\"50\"><div layout=\"column\" flex=\"100\" flex-gt-sm=\"50\" flex-md=\"33\" flex-xs=\"100\"><md-input-container \nclass=\"md-icon-float md-block\"><md-icon md-font-icon=\"icon-power\"></md-icon><label>סטטוס הזמנה</label><md-select \nng-model=\"search.Status\" placeholder=\"סינון לפי סטטוס הזמנה\" ng-disabled=\"!registrations\" ng-init=\"search.Status = 1\">\n<md-option ng-value=\"null\">הצג הכל</md-option><md-option ng-value=\"1\" selected=\"selected\">פעילים</md-option><md-option \nng-value=\"0\">לא פעילים</md-option></md-select></md-input-container></div><div layout=\"column\" flex=\"100\" \nflex-gt-sm=\"50\" flex-md=\"33\" flex-xs=\"100\"><md-input-container class=\"md-icon-float md-block\"><md-icon \nmd-svg-icon=\"credit-card\"></md-icon><label>סטטוס תשלום</label><md-select ng-model=\"search.PaymentStatus\" \nplaceholder=\"סינון לפי סטטוס תשלום\" ng-disabled=\"!registrations\" ng-init=\"search.PaymentStatus = 1\"><md-option \nng-value=\"null\">הצג הכל</md-option><md-option ng-value=\"1\">שולם</md-option><md-option ng-value=\"2\">\nשולם ל{{$root.User.Coordinators}}</md-option><md-option ng-value=\"3\">טרם אושר</md-option><md-option ng-value=\"0\">\nלא שולם</md-option></md-select></md-input-container></div></div><div class=\"filters\" layout=\"row\" layout-xs=\"column\" \nflex=\"100\" flex-sm=\"100\" flex-gt-md=\"50\"><div layout=\"column\" flex=\"100\" flex-gt-sm=\"50\" flex-md=\"33\" flex-xs=\"100\">\n<md-input-container class=\"md-icon-float md-block md-icon-left\"><md-icon md-font-icon=\"icon-calendar\"></md-icon><div \nstart-view=\"day\" locale=\"he\" format=\"DD/MM/YYYY HH:mm\" moment-picker=\"search.FromDate\"><label>מתאריך</label><input \nautocomplete=\"off\" ng-model=\"search.FromDate\" ng-disabled=\"isClicked\"></div></md-input-container></div><div \nlayout=\"column\" flex=\"100\" flex-gt-sm=\"50\" flex-md=\"33\" flex-xs=\"100\"><md-input-container \nclass=\"md-icon-float md-block md-icon-left\"><md-icon md-font-icon=\"icon-calendar\"></md-icon><div start-view=\"day\" \nlocale=\"he\" format=\"DD/MM/YYYY HH:mm\" moment-picker=\"search.ToDate\"><label>עד תאריך</label><input autocomplete=\"off\" \nng-model=\"search.ToDate\" ng-disabled=\"isClicked\"></div></md-input-container></div></div><div class=\"filters\" \nlayout=\"row\" layout-xs=\"column\" flex=\"100\" flex-sm=\"100\" flex-gt-md=\"50\"><div layout=\"column\" flex=\"100\" \nflex-gt-sm=\"50\" flex-md=\"33\" flex-xs=\"100\"><md-input-container id=\"free-search\" class=\"md-icon-float md-block\"><md-icon\n md-font-icon=\"icon-magnify\"></md-icon><label>חיפוש חופשי</label><input ng-model=\"search.freeSearchFromDB\" \ntype=\"search\" ng-disabled=\"!registrations\"></md-input-container></div></div><div class=\"search-actions row\" \nlayout=\"row\"><md-button type=\"submit\" \nng-disabled=\"isClicked || !search.FromDate || !search.ToDate || UserForm.$invalid \" class=\"md-raised md-accent\" \naria-label=\"חפש\" ng-click=\"getRegistrations()\">סינון</md-button></div></form></div></div><div ng-if=\"!registrations\" \nlayout=\"row\" layout-sm=\"column\" layout-align=\"space-around\"><md-progress-circular md-mode=\"indeterminate\">\n</md-progress-circular></div><div ng-if=\"registrations\" class=\"events-table-c\"><table id=\"registrations-table\" \nclass=\"dataTable row-border hover stripe md-ink-ripple\" datatable=\"ng\" dt-instance=\"dtInstance\" dt-options=\"dtOptions\" \ndt-column-defs=\"dtColumnDefs\"><thead><tr><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">תאריך הרשמה</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">שעת הרשמה</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">שם חניך</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">שם {{$root.User.Event}}</span></div></th><th class=\"secondary-text\"><div class=\"table-header\">\n<span class=\"column-title\">מחיר {{$root.User.Event}}</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">מחיר לתשלום</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">סטטוס הזמנה</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">סטטוס תשלום</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">מספר קבלה</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">מספר זיכוי</span></div></th><th class=\"secondary-text\" \nng-if=\"$root.AdminLevel==3 || ($root.AdminLevel==2 && $root.User.RegistrationsPer)\"><div class=\"table-header\"><span \nclass=\"column-title\">פעולות</span></div></th></tr></thead><tbody><tr class=\"entry-code-item\" \nng-repeat=\"reg in registrations | orderBy:ID\"><td>{{reg.RegistrationTime | cmdate:\'dd/MM/yyyy\'}}</td><td>\n{{reg.RegistrationTime | cmdate:\'HH:mm:ss\'}}</td><td>{{reg.FirstName}} {{reg.LastName}}</td><td>{{reg.EventName}} <span\n ng-if=\"reg.CartEventName\">({{reg.CartEventName}})</span></td><td>{{reg.EventPrice}}</td><td>{{reg.Price}}</td><td>\n{{reg.Status ? \'פעיל\' : \'לא פעיל\'}}</td><td>{{reg.PaymentStatus | paymentStatus}}</td><td><div class=\"sflex fdc hfs12\" \nng-if=\"reg.ReceiptID.length\"><a ng-repeat=\"receiptID in reg.ReceiptID\" ng-if=\"!receiptID.includes(\'יה\')\" href=\"#\" \nng-click=\"downloadReceipt(receiptID,1)\">{{receiptID}}</a> <span ng-repeat=\"receiptID in reg.ReceiptID\" \nng-if=\"receiptID.includes(\'יה\')\">{{receiptID}}</span></div></td><td><div class=\"sflex fdc hfs12\" \nng-if=\"reg.RefundReceiptID.length\"><a ng-repeat=\"refundReceiptID in reg.RefundReceiptID\" ng-if=\"refundReceiptID > 0\" \nhref=\"#\" ng-click=\"downloadReceipt(refundReceiptID,2)\">{{refundReceiptID}}</a> <span \nng-repeat=\"refundReceiptID in reg.RefundReceiptID\" ng-if=\"refundReceiptID.includes(\'-\')\">{{refundReceiptID}}</span>\n</div></td><td ng-if=\"$root.AdminLevel==3 || ($root.AdminLevel==2 && $root.User.RegistrationsPer)\"><md-button \nng-disabled=\"$root.User.SuperAdmin!=1 || reg.Canceled>0\" class=\"preview-user cancel\" \nng-click=\"cancelRegistration(reg)\" title=\"{{reg.Canceled==\'0\' ? \'ביטול הרשמה\' : \'הרשמה מבוטלת\'}}\"><md-icon \nng-class=\"{\'canceled\': reg.Canceled>0}\" md-svg-icon=\"delete\"></md-icon></md-button><md-button \nng-disabled=\"$root.User.SuperAdmin!=1 || reg.RefundDate\" class=\"preview-user refund\" \nng-click=\"refundRegistration(reg)\" title=\"{{!reg.RefundReceiptID.length ? \'זיכוי הרשמה\' : \'קיים זיכויי להרשמה\'}}\">\n<md-icon ng-class=\"{\'refunded\': reg.RefundReceiptID.length}\" md-svg-icon=\"credit-card\"></md-icon></md-button><md-button\n class=\"preview-user view\" ng-click=\"showFullRegistration(reg)\" title=\"צפייה בפרטי הזמנה\"><md-icon md-svg-icon=\"eye\">\n</md-icon></md-button></td></tr></tbody></table></div></div></div>");
$templateCache.put("app/main/pages/events/views/transportation/transportation.html","<div id=\"transportation\" class=\"page-layout simple tabbed\"><div class=\"header md-accent-bg\" layout=\"column\" \nlayout-align=\"center center\" layout-gt-sm=\"row\" layout-align-gt-sm=\"space-between start\"><div class=\"h1\" layout=\"row\" \nlayout-align=\"start center\"><span class=\"md-display-1 font-weight-300\">ניהול הסעות</span></div></div><div \nclass=\"content\"><div class=\"action-buttons\"><md-button class=\"md-fab md-accent md-icon-button\" \nid=\"add-newStudent-button\" ng-click=\"openNewTransportationDialog()\" aria-label=\"add systemUser\" title=\"יצירת הסעה\" \nng-disabled=\"isClicked\"><md-icon md-font-icon=\"icon-plus\"></md-icon></md-button></div><div layout=\"row\" layout-wrap>\n<div layout=\"column\" flex=\"100\" flex-gt-sm=\"100\" flex-gt-md=\"80\" flex-gt-lg=\"90\"></div></div><form \nclass=\"md-inline-form\" validate><div class=\"filters\" layout=\"row\" layout-xs=\"column\" flex=\"100\" flex-sm=\"100\" \nflex-gt-md=\"50\"><div layout=\"column\" flex=\"100\" flex-gt-sm=\"50\" flex-md=\"33\" flex-xs=\"100\"><md-input-container \nclass=\"md-icon-float md-block\"><md-icon md-font-icon=\"icon-filter\"></md-icon><md-select ng-model=\"search.status\" \nplaceholder=\"סינון לפי סטטוס\" ng-disabled=\"isClicked || transportation.length==0 || !transportation\" \nng-init=\"search.status=1\"><md-option ng-value=\"undefined\">הצג הכל</md-option><md-option ng-value=\"1\" \nselected=\"selected\">פעילים</md-option><md-option ng-value=\"null\">לא פעילים</md-option></md-select></md-input-container>\n</div></div><div class=\"search-actions row\" layout=\"row\"><md-button type=\"submit\" ng-disabled=\"!transportation \" \nclass=\"md-raised md-accent\" aria-label=\"חפש\" ng-click=\"getTransportation()\">סינון</md-button></div></form><div \nlayout=\"row\" layout-sm=\"column\" layout-align=\"space-around\" ng-if=\"!transportation\"><md-progress-circular \nmd-mode=\"indeterminate\"></md-progress-circular></div><div ng-if=\"transportation\" class=\"events-table-c\"><table \nid=\"transportation-table\" class=\"dataTable row-border hover stripe md-ink-ripple\" datatable=\"ng\" \ndt-instance=\"dtInstance\" dt-options=\"dtOptions\"><thead><tr><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">שם הסעה</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">סטטוס</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">פעולות</span></div></th></tr></thead><tbody><tr class=\"main-table-new\" \nng-repeat=\"item in transportation | filter:{ Status: search.status }\"><td>{{item.Name}}</td><td>\n{{item.Status==1 || item.Status==\'1\' ? \'פעיל\' : \'לא פעיל\'}}</td><td><md-button class=\"preview-user\" \nng-click=\"editTransportation(item)\" title=\"עריכה\"><md-icon md-svg-icon=\"pencil\"></md-icon></md-button><md-button \nclass=\"preview-user\" ng-click=\"deleteTransportationDialog(item)\" title=\"מחיקה\"><md-icon md-svg-icon=\"delete\"></md-icon>\n</md-button></td></tr></tbody></table></div></div></div>");
$templateCache.put("app/main/pages/events-dialogs/full-registration-dialog/tabs/cancel.html","<div layout=\"row\" layout-sm=\"column\" layout-align=\"space-around\" ng-show=\"!registrations\"><md-progress-circular \nmd-mode=\"indeterminate\"></md-progress-circular></div><div ng-show=\"registrations\"><form name=\"PaymentForm\" \ndata-ng-model=\"PaymentForm\" class=\"md-inline-form\"><div class=\"row separate-block\" layout=\"row\" \nng-if=\"registrations.Registration.Canceled\"><div layout=\"column\" flex=\"100\" flex-gt-sm=\"50\" flex-gt-md=\"50\">\n<md-input-container class=\"md-icon-float md-block\" layout=\"column\" layout-xs=\"row\" flex=\"100\" flex-xs=\"100\" \nflex-gt-sm=\"100\" flex-gt-md=\"100\"><md-icon md-svg-icon=\"calendar\" class=\"name\"></md-icon><label>תאריך ביטול</label>\n<input ng-if=\"registrations.Registration.Canceled\" \nng-value=\"registrations.Registration.Canceled*1000 | date:\'HH:mm:ss dd/MM/yyyy\'\" ng-disabled=\"true\">\n</md-input-container></div><div layout=\"column\" flex=\"100\" flex-gt-sm=\"50\" flex-gt-md=\"50\"><md-input-container \nclass=\"md-block\"><md-icon md-svg-icon=\"file-document-box\" class=\"name\"></md-icon><label>סיבת ביטול</label><textarea \nng-model=\"registrations.Registration.CanceledComment\" ng-disabled=\"true\"></textarea></md-input-container></div></div>\n<div ng-repeat=\"refund in registrations.Registration.RefundReceiptID\" class=\"separate-block\"><div class=\"sflex jcsb\">\n<h2 ng-if=\"refund.PaymentType != 7\">קבלת זיכויי: {{refund.ID}}</h2><h2 ng-if=\"refund.PaymentType == 7\">\nזיכויי ליתרת הורה: {{refund.ID}}</h2><md-button \nng-if=\"$root.AdminLevel==3 && refund.RefundID && refund.PaymentType != 7\" class=\"preview-user\" \ntitle=\"שליחת קבלה חוזרת\"><md-icon md-svg-icon=\"email\" ng-click=\"reSendReceipt(refund.RefundID,1)\"></md-icon>\n</md-button></div><div class=\"row\" layout=\"row\"><div layout=\"column\" flex=\"100\" flex-gt-sm=\"50\" flex-gt-md=\"50\">\n<md-input-container class=\"md-icon-float md-block\" layout=\"column\" layout-xs=\"row\" flex=\"100\" flex-xs=\"100\" \nflex-gt-sm=\"100\" flex-gt-md=\"100\"><md-icon md-svg-icon=\"cash-multiple\" class=\"name\"></md-icon><label>סכום זיכוי</label>\n<input ng-value=\"refund.RefundSum\" ng-disabled=\"true\"></md-input-container></div><div layout=\"column\" flex=\"100\" \nflex-gt-sm=\"50\" flex-gt-md=\"50\"><md-input-container class=\"md-block\"><md-icon md-svg-icon=\"cash\" class=\"name\">\n</md-icon><label>אמצעי תשלום זיכוי</label><input ng-model=\"refund.RefundPaymentTypeText\" ng-disabled=\"true\">\n</md-input-container></div></div><div class=\"row\" layout=\"row\" \nng-if=\"refund.RefundDate  || registrations.Registration.ParentsCashTransID \"><div layout=\"column\" flex=\"100\" \nflex-gt-sm=\"50\" flex-gt-md=\"50\"><md-input-container class=\"md-icon-float md-block\" layout=\"column\" layout-xs=\"row\" \nflex=\"100\" flex-xs=\"100\" flex-gt-sm=\"100\" flex-gt-md=\"100\"><md-icon md-svg-icon=\"calendar\" class=\"name\"></md-icon>\n<label>תאריך זיכוי</label><input ng-value=\"refund.RefundDate * 1000 | date:\'HH:mm:ss dd/MM/yyyy\'\" ng-disabled=\"true\">\n</md-input-container></div><div layout=\"column\" flex=\"100\" flex-gt-sm=\"50\" flex-gt-md=\"50\"><md-input-container \nclass=\"md-block\"><md-icon md-svg-icon=\"file-document-box\" class=\"name\"></md-icon><label>סיבת זיכוי</label><textarea \nng-model=\"refund.RefundComment\" ng-disabled=\"true\"></textarea></md-input-container></div></div></div></form></div>");
$templateCache.put("app/main/pages/events-dialogs/full-registration-dialog/tabs/discounts.html","<div layout=\"row\" layout-sm=\"column\" layout-align=\"space-around\" ng-show=\"!registrations\"><md-progress-circular \nmd-mode=\"indeterminate\"></md-progress-circular></div><div layout=\"row\" layout-sm=\"column\" layout-align=\"space-around\" \nng-if=\"registrations.Discounts.length==0\"><span>לא קיימות הנחות</span></div><table \nng-show=\"registrations.Discounts.length>0\" class=\"dataTable row-border hover stripe md-ink-ripple\"><thead><tr><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">סוג הנחה</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">סוג</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">רמה</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">סכום הנחה</span></div></th></tr></thead>\n<tbody><tr class=\"main-table-new\" ng-repeat=\"discount in registrations.Discounts\"><td>{{discount.DiscountType}}</td>\n<td>{{discount.Type==2 || discount.Type==\'2\' ? \'אחוזים\' : \'שקלים\'}}</td><td>\n{{discount.Level==2 || discount.Level==\'2\' ? \'מרובה\' : \'בודד\'}}</td><td>{{discount.Discount }}</td></tr></tbody>\n</table>");
$templateCache.put("app/main/pages/events-dialogs/full-registration-dialog/tabs/logs.html","<div id=\"logs\" class=\"page-layout simple tabbed\"><div layout=\"row\" layout-sm=\"column\" layout-align=\"space-around\" \nng-if=\"!logs\" style=\"padding: 30px\"><md-progress-circular md-mode=\"indeterminate\"></md-progress-circular></div><div \nclass=\"content\" ng-if=\"logs\" style=\"padding: 30px\"><table id=\"logs-table\" \nclass=\"dataTable row-border hover stripe md-ink-ripple\" datatable=\"ng\" dt-instance=\"dtInstance\" dt-options=\"dtOptions\">\n<thead><th><div class=\"table-header\"><span class=\"column-title\">תאריך</span></div></th><th><div class=\"table-header\">\n<span class=\"column-title\">משתמש</span></div></th><th><div class=\"table-header\"><span class=\"column-title\">פעולה</span>\n</div></th><th><div class=\"table-header\"><span class=\"column-title\">ערך ישן</span></div></th><th><div \nclass=\"table-header\"><span class=\"column-title\">ערך חדש</span></div></th></thead><tbody><tr class=\"md-ink-ripple\" \nng-repeat=\"item in logs\" style=\"height: 35px\"><td><span class=\"dpn\">{{item.Date}}</span>\n{{item.Date*1000 | date:\'HH:mm:ss dd/MM/yyyy\'}}</td><td>{{item.AdminName}}</td><td>{{item.Type}}</td><td>\n{{item.OldValue}}</td><td>{{item.NewValue}}</td></tr></tbody></table></div></div>");
$templateCache.put("app/main/pages/events-dialogs/full-registration-dialog/tabs/paymnet.html","<div layout=\"row\" layout-sm=\"column\" layout-align=\"space-around\" ng-show=\"!registrations\"><md-progress-circular \nmd-mode=\"indeterminate\"></md-progress-circular></div><md-button ng-if=\"! isFullyPaid() && !emptyPaymentAdded\" \nclass=\"md-raised md-accent\" id=\"add-payment-button\" aria-label=\"add systemUser\" title=\"הוספת תשלום\" \nng-click=\"addEmptyPayment()\" ng-disabled=\"isClicked\"><md-icon md-font-icon=\"icon-plus\"></md-icon>הוספת תשלום\n</md-button><div ng-show=\"registrations\" ng-repeat=\"receipt in registrations.Registration.ReceiptID\" \nclass=\"separate-block\"><div class=\"sflex jcsb\" ng-if=\"receipt.ID\"><h2 ng-if=\"receipt.PaymentType != 7\">\nקבלה: {{receipt.ID}}</h2><h2 ng-if=\"receipt.PaymentType == 7\">שימוש ביתרת הורה: {{receipt.ID}}</h2><md-button \nng-if=\"$root.AdminLevel==3 && receipt.ReceiptID\" class=\"preview-user\" title=\"שליחת קבלה חוזרת\"><md-icon \nmd-svg-icon=\"email\" ng-click=\"reSendReceipt(receipt.ReceiptID,1)\"></md-icon></md-button></div><form name=\"PaymentForm\" \ndata-ng-model=\"PaymentForm\" class=\"md-inline-form\"><div class=\"row\" layout=\"row\"><div layout=\"column\" flex=\"100\" \nflex-gt-sm=\"100\" flex-gt-md=\"33\"><md-input-container class=\"md-block\"><md-icon md-svg-icon=\"cash\" class=\"name\">\n</md-icon><label>אמצעי תשלום</label><md-select ng-required=\"true\" ng-model=\"receipt.PaymentType\" \nng-disabled=\"isClicked || $root.AdminLevel!=3 || receipt.ID || !banks\" ng-change=\"setPaymentType()\" \nplaceholder=\"אמצעי תשלום\"><md-option ng-value=\"0\" disabled=\"disabled\">ללא חיוב</md-option><md-option ng-value=\"1\">אשראי\n</md-option><md-option ng-value=\"2\">מזומן</md-option><md-option ng-value=\"3\" ng-disabled=\"banks.length == 0\">\nהעברה בנקאית</md-option><md-option ng-value=\"4\">המחאה</md-option><md-option ng-value=\"5\" disabled=\"disabled\">\nטופס התחייבות</md-option><md-option ng-value=\"7\" disabled=\"disabled\">יתרת הורה</md-option></md-select>\n</md-input-container></div><div layout=\"column\" flex=\"100\" flex-gt-sm=\"100\" flex-gt-md=\"33\" \nng-show=\"receipt.PaymentType==1 && receipt.CreditCardNumber\"><md-input-container class=\"md-icon-float md-block\" \nlayout=\"column\" layout-xs=\"row\" flex=\"100\" flex-xs=\"100\" flex-gt-sm=\"100\" flex-gt-md=\"100\"><md-icon \nmd-svg-icon=\"numeric\" class=\"name\"></md-icon><label>4 ספרות</label><input style=\"direction: ltr; text-align: right\" \nng-model=\"receipt.CreditCardNumber\" \nng-disabled=\"isClicked || $root.AdminLevel!=3 || registrations.Registration.PaymentStatus\" \nng-required=\"receipt.PaymentType==1\"></md-input-container></div><div layout=\"column\" flex=\"100\" flex-gt-sm=\"100\" \nflex-gt-md=\"33\"><md-input-container class=\"md-block\"><md-icon md-svg-icon=\"cash-multiple\" class=\"name\"></md-icon>\n<label>סכום</label><input ng-model=\"receipt.Sum\" ng-disabled=\"$root.AdminLevel < 3 || receipt.ID\"></md-input-container>\n</div></div><div class=\"iframe_container row w100\" layout=\"row\" ng-if=\"receipt.PaymentType==1 && receipt.iframe\">\n<iframe src=\"{{trustSrc(receipt.iframe)}}\" frameborder=\"0\" class=\"w100\"></iframe></div><div class=\"row\" layout=\"row\" \nng-show=\"receipt.PaymentType==3\"><div layout=\"column\" flex=\"100\" flex-gt-sm=\"50\" flex-gt-md=\"50\"><md-input-container \nclass=\"md-icon-float md-block\" layout=\"column\" layout-xs=\"row\" flex=\"100\" flex-xs=\"100\" flex-gt-sm=\"100\" \nflex-gt-md=\"100\"><md-icon md-svg-icon=\"numeric\" class=\"name\"></md-icon><label>שם בעל החשבון</label><input \nng-model=\"receipt.AccountName\" ng-disabled=\"isClicked || $root.AdminLevel!=3 || receipt.ID\" \nng-required=\"receipt.PaymentType==3\"></md-input-container></div><div layout=\"column\" flex=\"100\" flex-gt-sm=\"50\" \nflex-gt-md=\"50\"><md-input-container class=\"md-block\"><md-icon md-svg-icon=\"numeric\" class=\"name\"></md-icon><label>\nמספר בנק</label><input ng-model=\"receipt.BankNumber\" ng-disabled=\"isClicked || $root.AdminLevel!=3 || receipt.ID\" \nng-required=\"receipt.PaymentType==3\"></md-input-container></div></div><div class=\"row\" layout=\"row\" \nng-show=\"receipt.PaymentType==3\"><div layout=\"column\" flex=\"100\" flex-gt-sm=\"50\" flex-gt-md=\"50\"><md-input-container \nclass=\"md-icon-float md-block\" layout=\"column\" layout-xs=\"row\" flex=\"100\" flex-xs=\"100\" flex-gt-sm=\"100\" \nflex-gt-md=\"100\"><md-icon md-svg-icon=\"numeric\" class=\"name\"></md-icon><label>מספר סניף</label><input \nng-model=\"receipt.BranchNumber\" ng-disabled=\"isClicked || $root.AdminLevel!=3 || receipt.ID\" \nng-required=\"receipt.PaymentType==3\"></md-input-container></div><div layout=\"column\" flex=\"100\" flex-gt-sm=\"50\" \nflex-gt-md=\"50\"><md-input-container class=\"md-block\"><md-icon md-svg-icon=\"numeric\" class=\"name\"></md-icon><label>\nמספר חשבון</label><input ng-model=\"receipt.AccountNumber\" ng-disabled=\"isClicked || $root.AdminLevel!=3 || receipt.ID\" \nng-required=\"receipt.PaymentType==3\"></md-input-container></div></div><div class=\"row\" layout=\"row\" \nng-show=\"receipt.PaymentType==3\"><div layout=\"column\" flex=\"100\" flex-gt-sm=\"50\" flex-gt-md=\"50\"><md-input-container \nclass=\"md-icon-float md-block\" layout=\"column\" layout-xs=\"row\" flex=\"100\" flex-xs=\"100\" flex-gt-sm=\"100\" \nflex-gt-md=\"100\"><md-icon class=\"name\"></md-icon><label>בנק</label><md-icon md-svg-icon=\"bank\" class=\"name\"></md-icon>\n<md-select ng-model=\"receipt.BrandAccountNumber\" \nng-disabled=\"!banks || isClicked || $root.AdminLevel!=3 || receipt.ID\"><md-option ng-repeat=\"bank in banks\" \nng-value=\"bank.Number\">{{bank.Name}}</md-option></md-select></md-input-container></div><div layout=\"column\" flex=\"100\" \nflex-gt-sm=\"50\" flex-gt-md=\"50\"><md-input-container class=\"md-icon-float md-block\" layout=\"column\" layout-xs=\"row\" \nflex=\"100\" flex-xs=\"100\" flex-gt-sm=\"100\" flex-gt-md=\"100\"><md-icon ng-if=\"!receipt.FileRecipt\" md-svg-icon=\"upload\" \nclass=\"name\"></md-icon><md-icon ng-disabled=\"isClicked\" ng-if=\"receipt.FileRecipt\" md-svg-icon=\"eye\" \nhref=\"{{receipt.FileRecipt}}\" ng-click=\"viewFile(receipt.FileRecipt)\" style=\"cursor: pointer\" title=\"צפייה בקובץ\" \nclass=\"name\"></md-icon><label>אסמכתא</label><input ng-disabled=\"isClicked || receipt.ID\" \nngf-select=\"uploadFile($file,null,null,\'1\')\" placeholder=\"{{fileName2}}\" ng-model=\"file\" name=\"file\" \nstyle=\"cursor: pointer\" readonly=\"readonly\"></md-input-container></div></div><div class=\"row\" layout=\"row\" \nng-show=\"receipt.PaymentType==4\"><div layout=\"column\" flex=\"100\" flex-gt-sm=\"50\" flex-gt-md=\"50\"><md-input-container \nclass=\"md-icon-float md-block\" layout=\"column\" layout-xs=\"row\" flex=\"100\" flex-xs=\"100\" flex-gt-sm=\"100\" \nflex-gt-md=\"100\"><md-icon md-svg-icon=\"account\" class=\"name\"></md-icon><label>שם בעל הצ\'ק</label><input \nng-model=\"receipt.CheckOwner\" ng-disabled=\"isClicked || $root.AdminLevel!=3 || receipt.ID\" \nng-required=\"receipt.PaymentType==4\"></md-input-container></div><div layout=\"column\" flex=\"100\" flex-gt-sm=\"50\" \nflex-gt-md=\"50\"><md-input-container class=\"md-icon-float md-block\" layout=\"column\" layout-xs=\"row\" flex=\"100\" \nflex-xs=\"100\" flex-gt-sm=\"100\" flex-gt-md=\"100\"><md-icon md-svg-icon=\"numeric\" class=\"name\"></md-icon><label>מספר צ\'קים\n</label><input ng-model=\"receipt.NumberOfCheck\" ng-change=\"generateChecks()\" \nng-disabled=\"isClicked || $root.AdminLevel!=3 || receipt.ID\" ng-required=\"receipt.PaymentType==4\"></md-input-container>\n</div></div><div class=\"row\" layout=\"row\" \nng-show=\"receipt.PaymentType==4 && (receipt.ID && receipt.ChecksData.length == null)\"><div layout=\"column\" flex=\"100\" \nflex-gt-sm=\"50\" flex-gt-md=\"50\"><md-input-container class=\"md-icon-float md-block\" layout=\"column\" layout-xs=\"row\" \nflex=\"100\" flex-xs=\"100\" flex-gt-sm=\"100\" flex-gt-md=\"100\"><md-icon md-svg-icon=\"numeric\" class=\"name\"></md-icon>\n<label>מספר צ\'ק ראשון</label><input ng-model=\"receipt.CheckNumber\" \nng-disabled=\"isClicked || $root.AdminLevel!=3 || receipt.ID\" ng-required=\"receipt.PaymentType==4\"></md-input-container>\n</div><div layout=\"column\" flex=\"100\" flex-gt-sm=\"50\" flex-gt-md=\"50\"><md-input-container \nclass=\"md-icon-float md-block\" layout=\"column\" layout-xs=\"row\" flex=\"100\" flex-xs=\"100\" flex-gt-sm=\"100\" \nflex-gt-md=\"100\"><md-icon md-svg-icon=\"calendar\" class=\"name\"></md-icon><label>מועד פרעון ראשון</label><input \nng-required=\"receipt.PaymentType==4\" autocomplete=\"off\" ng-disabled=\"isClicked || $root.AdminLevel!=3 || receipt.ID\" \nng-model=\"receipt.CheckMaturityDate\"></md-input-container></div></div><div ng-repeat=\"check in receipt.ChecksData\" \nlayout=\"row\" flex=\"100\" ng-show=\"receipt.PaymentType==4 && receipt.ChecksData!= null\"><div layout=\"column\" flex=\"100\" \nflex-gt-sm=\"100\" flex-gt-md=\"33\"><md-input-container class=\"md-block\"><md-icon md-svg-icon=\"numeric\" class=\"name\">\n</md-icon><label>מספר צ\'ק</label><input ng-model=\"check.CheckNumber\" \nng-disabled=\"isClicked || $root.AdminLevel!=3 || receipt.ID\"></md-input-container></div><div layout=\"column\" \nflex=\"100\" flex-gt-sm=\"100\" flex-gt-md=\"33\"><md-input-container class=\"md-block md-icon-left\"><md-icon \nmd-svg-icon=\"calendar\" class=\"name\"></md-icon><div start-view=\"day\" locale=\"he\" format=\"DD/MM/YYYY\" \nmoment-picker=\"check.CheckMaturityDate\"><label>מועד פרעון</label><input ng-required=\"newRegistration.Type==4\" \nautocomplete=\"off\" ng-disabled=\"isClicked || $root.AdminLevel!=3 || receipt.ID\" ng-value=\"check.CheckMaturityDate\">\n</div></md-input-container></div><div layout=\"column\" flex=\"100\" flex-gt-sm=\"100\" flex-gt-md=\"33\"><md-input-container \nclass=\"md-block\"><md-icon md-svg-icon=\"cash-multiple\" class=\"name\"></md-icon><label>סכום הצ\'ק</label><input \nng-model=\"check.CheckAmount\" ng-disabled=\"isClicked || $root.AdminLevel!=3 || receipt.ID\"></md-input-container></div>\n</div><md-button ng-show=\"$root.AdminLevel==3\" ng-if=\"! receipt.ID && receipt.PaymentType && receipt.PaymentType != 1\" \ntype=\"submit\" \nng-disabled=\"isClicked || $root.AdminLevel!=3 || (receipt.PaymentStatus && receipt.PaymentType!=3) || PaymentForm.$invalid\" \nclass=\"md-raised md-accent\" aria-label=\"חפש\" ng-click=\"savePayment(receipt)\">עדכון</md-button></form></div>");
$templateCache.put("app/main/pages/events-dialogs/full-registration-dialog/tabs/questions.html","<div layout=\"row\" layout-sm=\"column\" layout-align=\"space-around\" ng-if=\"!registrations\"><md-progress-circular \nmd-mode=\"indeterminate\"></md-progress-circular></div><div layout=\"row\" layout-sm=\"column\" layout-align=\"space-around\" \nng-if=\"registrations.Questions.length==0\"><span>לא קיימות שאלות</span></div><form name=\"UserForm\" \nclass=\"md-inline-form\" validate ng-if=\"registrations.Questions.length>0\"><div layout=\"row\" layout-wrap \nng-repeat=\"question in registrations.Questions\"><md-input-container class=\"md-icon-float md-block\" layout=\"column\" \nlayout-xs=\"row\" flex=\"100\"><md-icon style=\"cursor: pointer\" md-svg-icon=\"help-circle\" class=\"name\"></md-icon><label>\n{{question.Description}}</label><input ng-if=\"question.AnswerType==1\" ng-model=\"question.Answer\" \nng-disabled=\"isClicked || $root.AdminLevel<3\"><md-select ng-if=\"question.AnswerType==2\" ng-model=\"question.Answer\" \nng-disabled=\"isClicked || $root.AdminLevel<3\"><md-option ng-repeat=\"questionOption in question.Options\" \nng-value=\"questionOption\">{{questionOption}}</md-option></md-select><div ng-if=\"question.AnswerType==4\" \nstart-view=\"day\" locale=\"he\" format=\"DD/MM/YYYY\" moment-picker=\"question.Answer\"><input autocomplete=\"off\" \nng-model=\"question.Answer\" ng-disabled=\"isClicked || $root.AdminLevel<3\"></div></md-input-container><div \nclass=\"w100a relative\"><md-input-container class=\"md-icon-float md-block\" layout=\"column\" layout-xs=\"row\" flex=\"100\" \nng-if=\"question.AnswerType==3\"><md-icon md-svg-icon=\"download\" class=\"name\"></md-icon><label>{{question.Description}}\n</label><input style=\"cursor: pointer\" ng-click=\"openFile(question.Answer)\" placeholder=\"לחצ\\י לצפייה בקובץ\" \nreadonly=\"readonly\"></md-input-container><label class=\"uploadfile\" ng-if=\"question.AnswerType==3\" \nfor=\"file{{question.ID}}\" title=\"החלפת קובץ\"><md-icon md-svg-icon=\"upload\" class=\"name\"></md-icon></label><input \nng-if=\"question.AnswerType==3\" ngf-select=\"uploadFile($file,\'q\',question,null)\" \nplaceholder=\"{{fileNames[question.ID]}}\" ng-model=\"file\" id=\"file{{question.ID}}\" name=\"file{{question.ID}}\" \nngf-pattern=\"\'image/*\'\" style=\"cursor: pointer; display:none\" readonly=\"readonly\"></div></div><md-button \nng-if=\"$root.AdminLevel==3\" type=\"submit\" ng-disabled=\"isClicked\" class=\"md-raised md-accent\" aria-label=\"חפש\" \nng-click=\"updateQuestions(registrations.Questions)\">עדכון</md-button></form>");
$templateCache.put("app/main/pages/events-dialogs/full-registration-dialog/tabs/registration.html","<div layout=\"row\" layout-sm=\"column\" layout-align=\"space-around\" ng-if=\"!registrations\"><md-progress-circular \nmd-mode=\"indeterminate\"></md-progress-circular></div><div ng-if=\"registrations.Registration\"><form name=\"UserForm\" \nclass=\"md-inline-form\"><div class=\"row\" layout=\"row\"><div layout=\"column\" flex=\"100\" flex-gt-sm=\"50\" flex-gt-md=\"50\">\n<md-input-container class=\"md-block\"><md-icon md-svg-icon=\"calendar\" class=\"name\"></md-icon><label>תאריך רישום</label>\n<input ng-value=\"registrations.Registration.RegistrationTime | cmdate:\'HH:mm:ss dd/MM/yyyy \'\" ng-disabled=\"true\">\n</md-input-container></div><div layout=\"column\" flex=\"100\" flex-gt-sm=\"50\" flex-gt-md=\"50\"><md-input-container \nclass=\"md-icon-float md-block\" layout=\"column\" layout-xs=\"row\" flex=\"100\" flex-xs=\"100\" flex-gt-sm=\"100\" \nflex-gt-md=\"100\"><md-icon md-svg-icon=\"cash-multiple\" class=\"name\"></md-icon><label>סכום תשלום</label><input \nng-value=\"registrations.Registration.FinalPrice\" ng-disabled=\"true\"></md-input-container></div></div><div class=\"row\" \nlayout=\"row\"><div layout=\"column\" flex=\"100\" flex-gt-sm=\"50\" flex-gt-md=\"50\"><md-input-container \nclass=\"md-icon-float md-block\" layout=\"column\" layout-xs=\"row\" flex=\"100\" flex-xs=\"100\" flex-gt-sm=\"100\" \nflex-gt-md=\"100\"><md-icon md-svg-icon=\"cash-multiple\" class=\"name\"></md-icon><label>סכום {{$root.User.Event}}</label>\n<input ng-if=\"registrations.Registration.Discount\" \nng-value=\"setPrice(registrations.Registration.FinalPrice,registrations.Registration.Discount)\" ng-disabled=\"true\"> \n<input ng-if=\"!registrations.Registration.Discount\" ng-value=\"registrations.Registration.FinalPrice\" \nng-disabled=\"true\"></md-input-container></div><div layout=\"column\" flex=\"100\" flex-gt-sm=\"50\" flex-gt-md=\"50\">\n<md-input-container class=\"md-icon-float md-block\" layout=\"column\" layout-xs=\"row\" flex=\"100\" flex-xs=\"100\" \nflex-gt-sm=\"100\" flex-gt-md=\"100\"><md-icon md-svg-icon=\"account-multiple-plus\" class=\"name\"></md-icon><label>\nסכום תרומה (אמץ חניך)</label><input ng-value=\"registrations.Registration.DonationAmount\" ng-disabled=\"true\">\n</md-input-container></div></div><div class=\"row\" layout=\"row\"><div layout=\"column\" flex=\"100\" flex-gt-sm=\"50\" \nflex-gt-md=\"50\"><md-input-container class=\"md-block\"><md-icon md-svg-icon=\"credit-card\" class=\"name\"></md-icon><label>\nאופן תשלום</label><input ng-value=\"registrations.Registration.PaymentTypeText\" ng-disabled=\"true\"></md-input-container>\n</div><div layout=\"column\" flex=\"100\" flex-gt-sm=\"50\" flex-gt-md=\"50\"><md-input-container class=\"md-block\"><md-icon \nmd-svg-icon=\"cards-outline\" class=\"name\"></md-icon><label>סטטוס תשלום</label><md-select \nng-model=\"registrations.Registration.PaymentStatus\" ng-change=\"sendReceipt(registrations.Registration)\" \nng-disabled=\"registrations.Registration.PaymentStatus===1 || isClicked || ($root.AdminLevel<3 && !$root.User.Payments)\">\n<md-option ng-value=\"1\">שולם</md-option><md-option ng-value=\"2\">שולם ל{{$root.User.Coordinators}}</md-option><md-option\n ng-value=\"3\" ng-disabled=\"registrations.Registration.PaymentStatus==1 || registrations.Registration.PaymentStatus==2\">\nטרם אושר</md-option><md-option ng-value=\"0\" \nng-disabled=\"registrations.Registration.PaymentStatus==1 || registrations.Registration.PaymentStatus==2\">לא שולם\n</md-option></md-select></md-input-container></div></div><div class=\"row\" layout=\"row\"><div layout=\"column\" flex=\"100\" \nflex-gt-sm=\"50\" flex-gt-md=\"50\"><md-input-container class=\"md-block\"><md-icon md-svg-icon=\"power\" class=\"name\">\n</md-icon><label>סטטוס הרשמה</label><md-select ng-model=\"registrations.Registration.Status\" \nng-disabled=\"!isFullyPaid() || isClicked || ($root.AdminLevel<3 && !$root.User.Payments)\"><md-option ng-value=\"\'1\'\">\nפעיל</md-option><md-option ng-value=\"\'0\'\">לא פעיל</md-option></md-select></md-input-container></div><div \nlayout=\"column\" flex=\"100\" flex-gt-sm=\"50\" flex-gt-md=\"50\"><md-input-container class=\"md-icon-float md-block\" \nlayout=\"column\" layout-xs=\"row\" flex=\"100\" flex-xs=\"100\" flex-gt-sm=\"100\" flex-gt-md=\"100\"><md-icon \nmd-svg-icon=\"account-box\" class=\"name\"></md-icon><label>מקור הרשמה</label><input \nng-value=\"registrations.Registration.Type | registrationSource\" ng-disabled=\"true\"></md-input-container></div></div>\n<div class=\"row\" layout=\"row\"><div layout=\"column\" flex=\"100\" flex-gt-sm=\"100\" flex-gt-md=\"100\"><md-input-container \nclass=\"md-block\"><md-icon md-svg-icon=\"clipboard-text\" class=\"name\"></md-icon><label>הערות פנימיות</label><textarea \nng-model=\"registrations.Registration.InternalComments\" ng-disabled=\"isClicked\"></textarea></md-input-container></div>\n</div><div class=\"row\" layout=\"row\"><div layout=\"column\" flex=\"100\" flex-gt-sm=\"50\" flex-gt-md=\"50\"><md-input-container\n class=\"md-icon-float md-block\" layout=\"column\" layout-xs=\"row\" flex=\"100\" flex-xs=\"100\" flex-gt-sm=\"100\" \nflex-gt-md=\"100\"><md-icon md-svg-icon=\"account-box\" class=\"name\"></md-icon><label>קבוצת {{$root.User.Event}}</label>\n<md-select ng-model=\"registrations.Registration.Group\" \nng-disabled=\"isClicked || $root.AdminLevel == 1 || registrations.Registration.EventsGroup.length == 0\"><md-option \nng-repeat=\"group in registrations.Registration.EventsGroup\" ng-value=\"group\">{{group}}</md-option></md-select>\n</md-input-container></div><div layout=\"column\" flex=\"100\" flex-gt-sm=\"50\" flex-gt-md=\"50\"><md-input-container \nclass=\"md-block\"><md-icon md-svg-icon=\"account\" class=\"name\"></md-icon><label>האם בוצע סבסוד להרשמה</label><md-select \nng-model=\"registrations.Registration.Subsidization\" ng-disabled=\"isClicked || $root.AdminLevel<3 \"><md-option \nng-value=\"1\">כן</md-option><md-option ng-value=\"0\">לא</md-option></md-select></md-input-container></div></div><div \nclass=\"row\" layout=\"row\" ng-if=\"registrations.Registration.Subsidization\"><div layout=\"column\" flex=\"100\" \nflex-gt-sm=\"50\" flex-gt-md=\"50\"><md-input-container class=\"account\"><md-icon md-svg-icon=\"clipboard-text\" class=\"name\">\n</md-icon><label>שם הגורם המסבסד</label><textarea ng-model=\"registrations.Registration.SubsidizationName\" \nng-disabled=\"isClicked\"></textarea></md-input-container></div><div layout=\"column\" flex=\"100\" flex-gt-sm=\"50\" \nflex-gt-md=\"50\"><md-input-container class=\"md-block\"><md-icon md-svg-icon=\"clipboard-text\" class=\"name\"></md-icon>\n<label>סכום אשר סובסד</label><textarea ng-model=\"registrations.Registration.SubsidizationSum\" ng-disabled=\"isClicked\">\n</textarea></md-input-container></div></div><md-button ng-if=\"$root.AdminLevel>=2\" type=\"submit\" \nng-disabled=\"isClicked\" class=\"md-raised md-accent\" aria-label=\"חפש\" \nng-click=\"updateRegistration(registrations.Registration)\">עדכון</md-button></form></div>");
$templateCache.put("app/main/pages/events-dialogs/full-registration-dialog/tabs/signedFile.html","<div class=\"center\"><h2>חוזר הורים</h2></div><div class=\"row\" layout=\"row\" \nng-if=\"!registrations.Registration.SingedInfoFile\"><div layout=\"column\" flex=\"100\" flex-gt-sm=\"50\" flex-gt-md=\"50\">\n<md-button ng-click=\"uploadSigneInfoFile()\" class=\"md-raised md-accent\" aria-label=\"העלאת קובץ\"><md-icon \nmd-font-icon=\"icon-attachment\"></md-icon>העלאת חוזר הורים חתום</md-button></div></div><div \nng-if=\"registrations.Registration.SingedInfoFile\"><embed class=\"w100 mh50vh\" \nng-src=\"{{trustSrc(registrations.Registration.SingedInfoFile)}}\"></div><md-divider \nng-if=\"registrations.Registration.HealthDeclaration\"></md-divider><div \nng-if=\"registrations.Registration.HealthDeclaration\"><div class=\"center\"><h2>הצהרת בריאות</h2></div><embed \nclass=\"w100 mh50vh\" ng-src=\"{{trustSrc(registrations.Registration.HealthDeclaration)}}\"></div>");
$templateCache.put("app/main/pages/events-dialogs/full-registration-dialog/tabs/transportation.html","<div layout=\"row\" layout-sm=\"column\" layout-align=\"space-around\" ng-if=\"!registrations\"><md-progress-circular \nmd-mode=\"indeterminate\"></md-progress-circular></div><div layout=\"row\" layout-sm=\"column\" layout-align=\"space-around\" \nng-if=\"registrations.Transportation.length==0\"><span>לא קיימות הסעות</span></div><form name=\"UserForm\" \nclass=\"md-inline-form\" validate ng-if=\"registrations.Transportation.length>0\"><div layout=\"row\" layout-wrap>\n<md-input-container class=\"md-icon-float md-block\" layout=\"column\" layout-xs=\"row\" flex=\"100\" flex-xs=\"100\" \nflex-gt-sm=\"100\" flex-gt-md=\"100\"><md-icon md-svg-icon=\"bus\" class=\"name\"></md-icon><label>הסעה הלוך</label><md-select \nng-model=\"registrations.Transportation.SelectedTransportationTo\" ng-disabled=\"isClicked || $root.AdminLevel<3\">\n<md-option ng-repeat=\"transportation in registrations.Transportation\" ng-selected=\"transportation.Selected\" \nng-value=\"transportation\" ng-if=\"transportation.Way==1\">{{transportation.Name}}</md-option></md-select>\n</md-input-container></div><div layout=\"row\" layout-wrap><md-input-container class=\"md-icon-float md-block\" \nlayout=\"column\" layout-xs=\"row\" flex=\"100\" flex-xs=\"100\" flex-gt-sm=\"100\" flex-gt-md=\"100\"><md-icon md-svg-icon=\"bus\" \nclass=\"name\"></md-icon><label>הסעה חזור</label><md-select ng-disabled=\"isClicked || $root.AdminLevel<3\" \nng-model=\"registrations.Transportation.SelectedTransportationFrom\"><md-option \nng-repeat=\"transportation in registrations.Transportation\" ng-selected=\"transportation.Selected\" \nng-if=\"transportation.Way==2\" ng-value=\"transportation\">{{transportation.Name}}</md-option></md-select>\n</md-input-container></div><md-button ng-if=\"$root.AdminLevel==3\" type=\"submit\" ng-disabled=\"isClicked\" \nclass=\"md-raised md-accent\" aria-label=\"חפש\" ng-click=\"updateTransportation()\">עדכון</md-button></form>");
$templateCache.put("app/main/pages/profile-forms/views/cancel-form/cancel-form.html","<div id=\"branches\" class=\"page-layout simple tabbed\" ng-init=\"vm.getEvents();\"><div class=\"header md-accent-bg\" \nlayout=\"column\" layout-align=\"center center\" layout-gt-sm=\"row\" layout-align-gt-sm=\"space-between start\"><div \nclass=\"h1\" layout=\"row\" layout-align=\"start center\"><span class=\"md-display-1 font-weight-300\">\nטפסי בקשה לביטול {{$root.User.Events}}</span></div></div><div class=\"content\"><div layout=\"row\" layout-wrap><div \nlayout=\"column\" flex=\"100\" flex-gt-sm=\"100\" flex-gt-md=\"70\"><form name=\"UserForm\" class=\"md-inline-form\" validate><div \nclass=\"filters\" layout=\"row\" layout-xs=\"column\" flex=\"100\" flex-sm=\"100\" flex-gt-md=\"50\"><div layout=\"column\" \nflex=\"100\" flex-gt-sm=\"50\" flex-md=\"33\" flex-xs=\"100\"><md-input-container class=\"md-icon-float md-block\" \nlayout=\"column\" layout-xs=\"row\" flex=\"100\" flex-gt-sm=\"50\" flex-gt-md=\"40\"><md-icon md-font-icon=\"icon-brightness-5\">\n</md-icon><label>{{$root.User.Event}}</label><md-select md-on-close=\"clearSearchTerm()\" ng-model=\"vm.search.EventID\" \nng-disabled=\"!vm.events || !vm.cancellation\"><md-select-header class=\"demo-select-header\"><input \nng-model=\"vm.searchTerm\" type=\"text\" ng-keydown=\"$event.stopPropagation()\" placeholder=\"חפש {{$root.User.Event}}..\" \nclass=\"demo-header-searchbox md-text\" autocomplete=\"off\"></md-select-header><md-optgroup><md-option \nng-value=\"event.ID\" ng-repeat=\"event in vm.events |filter:vm.searchTerm\">{{event.Name}}</md-option></md-optgroup>\n</md-select></md-input-container></div><div layout=\"column\" flex=\"100\" flex-gt-sm=\"50\" flex-md=\"33\" flex-xs=\"100\">\n<md-input-container class=\"md-icon-float md-block\" layout=\"column\" layout-xs=\"row\" flex=\"100\" flex-gt-sm=\"50\" \nflex-gt-md=\"40\"><label>סטטוס</label><md-icon md-font-icon=\"icon-power\"></md-icon><md-select \nng-model=\"vm.search.Status\" ng-disabled=\"!vm.cancellation\"><md-option ng-value=\"null\">הכל</md-option><md-option \nng-value=\"\'טופל\'\">טופל</md-option><md-option ng-value=\"\'טרם טופל\'\">טרם טופל</md-option></md-select>\n</md-input-container></div></div><div class=\"filters\" layout=\"row\" layout-xs=\"column\" flex=\"100\" flex-sm=\"100\" \nflex-gt-md=\"50\"><div layout=\"column\" flex=\"100\" flex-gt-sm=\"50\" flex-md=\"33\" flex-xs=\"100\"><md-input-container \nclass=\"md-icon-float md-block\" layout=\"column\" layout-xs=\"row\" flex=\"100\" flex-gt-sm=\"50\" flex-gt-md=\"40\"><md-icon \nmd-font-icon=\"icon-calendar\"></md-icon><div start-view=\"day\" locale=\"he\" format=\"DD/MM/YYYY\" \nmoment-picker=\"vm.search.FromDate\"><label>מתאריך</label><input autocomplete=\"off\" ng-model=\"vm.search.FromDate\" \nng-disabled=\"!vm.cancellation\"></div></md-input-container></div><div layout=\"column\" flex=\"100\" flex-gt-sm=\"50\" \nflex-md=\"33\" flex-xs=\"100\"><md-input-container class=\"md-icon-float md-block\" layout=\"column\" layout-xs=\"row\" \nflex=\"100\" flex-gt-sm=\"50\" flex-gt-md=\"40\"><md-icon md-font-icon=\"icon-calendar\"></md-icon><div start-view=\"day\" \nlocale=\"he\" format=\"DD/MM/YYYY\" moment-picker=\"vm.search.ToDate\"><label>עד תאריך</label><input autocomplete=\"off\" \nng-model=\"vm.search.ToDate\" ng-disabled=\"!vm.cancellation\"></div></md-input-container></div></div><div class=\"filters\" \nlayout=\"row\" layout-xs=\"column\" flex=\"100\" flex-sm=\"100\" flex-gt-md=\"50\"><div layout=\"column\" flex=\"100\" \nflex-gt-sm=\"50\" flex-md=\"33\" flex-xs=\"100\"><md-input-container class=\"md-icon-float md-block\" layout=\"column\" \nlayout-xs=\"row\" flex=\"100\" flex-gt-sm=\"50\" flex-gt-md=\"40\"><label>סיבת ביטול</label><md-icon \nmd-font-icon=\"icon-cancel\"></md-icon><md-select ng-model=\"vm.search.Reason\" ng-disabled=\"!vm.cancellation\"><md-option \nng-value=\"null\">הכל</md-option><md-option ng-value=\"\'Illness\'\">מחלה</md-option><md-option ng-value=\"\'Other\'\">אחר\n</md-option></md-select></md-input-container></div><div layout=\"column\" flex=\"100\" flex-gt-sm=\"50\" flex-md=\"33\" \nflex-xs=\"100\"><md-input-container id=\"free-search\" class=\"md-icon-float md-block\"><md-icon md-font-icon=\"icon-magnify\">\n</md-icon><label>חיפוש חופשי</label><input ng-model=\"vm.search.FreeSearchFromDB\" type=\"search\" \nng-disabled=\"!vm.cancellation\"></md-input-container></div></div><div class=\"search-actions row\" layout=\"row\"><md-button\n type=\"submit\" ng-disabled=\"!vm.cancellation || UserForm.$invalid \" class=\"md-raised md-accent\" aria-label=\"חפש\" \nng-click=\"vm.getCancelForms()\">סינון</md-button><md-button type=\"submit\" \nng-disabled=\"!vm.cancellation || UserForm.$invalid \" class=\"md-raised md-accent\" aria-label=\"חפש\" \nng-click=\"vm.getCancelForms(true)\">איפוס סינון</md-button></div></form></div></div><div ng-if=\"!vm.cancellation\" \nlayout=\"row\" layout-sm=\"column\" layout-align=\"space-around\"><md-progress-circular md-mode=\"indeterminate\">\n</md-progress-circular></div><div ng-if=\"vm.cancellation\" class=\"events-table-c\"><table id=\"cancellation-table\" \nclass=\"dataTable row-border hover stripe md-ink-ripple\" datatable=\"ng\" dt-instance=\"vm.dtInstance\" \ndt-options=\"vm.dtOptions\" dt-column-defs=\"vm.dtColumnDefs\"><thead><tr><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">תאריך</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">שם הורה</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">מייל הורה</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">טלפון נייד הורה</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">שם חניכ\\ה</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">{{$root.User.Branch}}</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">איזור</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">שם ה{{$root.User.Event}}</span></div></th><th class=\"secondary-text\">\n<div class=\"table-header\"><span class=\"column-title\">סיבת ביטול</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">סטטוס פניה</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">פעולות</span></div></th></tr></thead><tbody><tr \nclass=\"entry-code-item\" ng-repeat=\"cancel in  vm.cancellation | orderBy:ID\"><td>\n{{cancel.CreateTime | cmdate:\'HH:mm:ss dd/MM/yyyy \'}}</td><td><a href=\"/parent-profile?ID={{cancel.ParentID}}\" \ntarget=\"_blank\" style=\"cursor: pointer\">{{cancel.ParentName}}</a></td><td><a href=\"mailto:{{cancel.ParentEmail}}\">\n{{cancel.ParentEmail}}</a></td><td>{{cancel.ParentPhone}}</td><td><a href=\"/student-profile?ID={{cancel.StudentID}}\" \ntarget=\"_blank\" style=\"cursor: pointer\">{{cancel.StudentName}}</a></td><td>{{cancel.BranchName}}</td><td>\n{{cancel.AreaName}}</td><td>{{cancel.EventName}}</td><td>{{cancel.Reason==\'Other\' ? \'אחר\' : \'מחלה\'}}</td><td>\n{{cancel.Status}}</td><td><md-button class=\"preview-user\" ng-click=\"vm.openCancellationDialog(cancel)\" \ntitle=\"פרטי בקשה\"><md-icon md-svg-icon=\"eye\"></md-icon></md-button></td></tr></tbody></table></div></div></div>");
$templateCache.put("app/main/pages/profile-forms/views/contact-form/contact-form.html","<div id=\"branches\" class=\"page-layout simple tabbed\"><div class=\"header md-accent-bg\" layout=\"column\" \nlayout-align=\"center center\" layout-gt-sm=\"row\" layout-align-gt-sm=\"space-between start\"><div class=\"h1\" layout=\"row\" \nlayout-align=\"start center\"><span class=\"md-display-1 font-weight-300\">טפסי צור קשר</span></div></div><div \nclass=\"content\"><div class=\"action-buttons\"><md-button ng-if=\"$root.AdminLevel>2 || $root.User.EventsPer==1\" \nclass=\"md-fab md-accent md-icon-button\" id=\"add-newEvent-button\" ng-click=\"vm.downloadContactForms()\" \naria-label=\"add systemUser\" title=\"ייצוא נתונים\" ng-disabled=\"isClicked\"><md-icon md-svg-icon=\"file-excel\"></md-icon>\n</md-button></div><div layout=\"row\" layout-wrap><div layout=\"column\" flex=\"100\" flex-gt-sm=\"100\" flex-gt-md=\"70\"><form \nname=\"UserForm\" class=\"md-inline-form\" validate><div class=\"filters\" layout=\"row\" layout-xs=\"column\" flex=\"100\" \nflex-sm=\"100\" flex-gt-md=\"50\"><div layout=\"column\" flex=\"100\" flex-gt-sm=\"50\" flex-md=\"33\" flex-xs=\"100\">\n<md-input-container class=\"md-icon-float md-block\" layout=\"column\" layout-xs=\"row\" flex=\"100\" flex-gt-sm=\"50\" \nflex-gt-md=\"40\"><md-icon md-font-icon=\"icon-calendar\"></md-icon><div start-view=\"day\" locale=\"he\" format=\"DD/MM/YYYY\" \nmoment-picker=\"vm.search.FromDate\"><label>מתאריך</label><input autocomplete=\"off\" ng-model=\"vm.search.FromDate\" \nng-disabled=\"!vm.contact\"></div></md-input-container></div><div layout=\"column\" flex=\"100\" flex-gt-sm=\"50\" \nflex-md=\"33\" flex-xs=\"100\"><md-input-container class=\"md-icon-float md-block\" layout=\"column\" layout-xs=\"row\" \nflex=\"100\" flex-gt-sm=\"50\" flex-gt-md=\"40\"><md-icon md-font-icon=\"icon-calendar\"></md-icon><div start-view=\"day\" \nlocale=\"he\" format=\"DD/MM/YYYY\" moment-picker=\"vm.search.ToDate\"><label>עד תאריך</label><input autocomplete=\"off\" \nng-model=\"vm.search.ToDate\" ng-disabled=\"!vm.contact\"></div></md-input-container></div></div><div class=\"filters\" \nlayout=\"row\" layout-xs=\"column\" flex=\"100\" flex-sm=\"100\" flex-gt-md=\"50\"><div layout=\"column\" flex=\"100\" \nflex-gt-sm=\"50\" flex-md=\"33\" flex-xs=\"100\"><md-input-container class=\"md-icon-float md-block\" layout=\"column\" \nlayout-xs=\"row\" flex=\"100\" flex-gt-sm=\"50\" flex-gt-md=\"40\"><label>סטטוס</label><md-icon md-font-icon=\"icon-power\">\n</md-icon><md-select ng-model=\"vm.search.Status\" ng-disabled=\"!vm.contact\"><md-option ng-value=\"null\">הכל</md-option>\n<md-option ng-value=\"\'טופל\'\">טופל</md-option><md-option ng-value=\"\'טרם טופל\'\">טרם טופל</md-option></md-select>\n</md-input-container></div><div layout=\"column\" flex=\"100\" flex-gt-sm=\"50\" flex-md=\"33\" flex-xs=\"100\">\n<md-input-container id=\"free-search\" class=\"md-icon-float md-block\"><md-icon md-font-icon=\"icon-magnify\"></md-icon>\n<label>חיפוש חופשי</label><input ng-model=\"vm.search.FreeSearchFromDB\" type=\"search\" ng-disabled=\"!vm.contact\">\n</md-input-container></div></div><div class=\"search-actions row\" layout=\"row\"><md-button type=\"submit\" \nng-disabled=\"!vm.contact || UserForm.$invalid \" class=\"md-raised md-accent\" aria-label=\"חפש\" \nng-click=\"vm.getContactForms()\">סינון</md-button><md-button type=\"submit\" \nng-disabled=\"!vm.contact || UserForm.$invalid \" class=\"md-raised md-accent\" aria-label=\"חפש\" \nng-click=\"vm.getContactForms(true)\">איפוס סינון</md-button></div></form></div></div><div ng-if=\"!vm.contact\" \nlayout=\"row\" layout-sm=\"column\" layout-align=\"space-around\"><md-progress-circular md-mode=\"indeterminate\">\n</md-progress-circular></div><div ng-if=\"vm.contact\" class=\"events-table-c\"><table id=\"contact-table\" \nclass=\"dataTable row-border hover stripe md-ink-ripple\" datatable=\"ng\" dt-instance=\"vm.dtInstance\" \ndt-options=\"vm.dtOptions\" dt-column-defs=\"vm.dtColumnDefs\"><thead><tr><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">תאריך</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">שם הורה</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">מייל הורה</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">טלפון נייד הורה</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">שם חניכ\\ה</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">{{$root.User.Branch}}</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">איזור</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">סטטוס פניה</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">פעולות</span></div></th></tr></thead><tbody><tr \nclass=\"entry-code-item\" ng-repeat=\"contactForm in  vm.contact | orderBy:ID\"><td>\n{{contactForm.CreateTime | cmdate:\'HH:mm:ss dd/MM/yyyy \'}}</td><td><a \nhref=\"/parent-profile?ID={{contactForm.ParentID}}\" target=\"_blank\" style=\"cursor: pointer\">{{contactForm.ParentName}}\n</a></td><td><a href=\"mailto:{{contactForm.ParentEmail}}\">{{contactForm.ParentEmail}}</a></td><td>\n{{contactForm.ParentPhone}}</td><td><a href=\"/student-profile?ID={{contactForm.StudentID}}\" target=\"_blank\" \nstyle=\"cursor: pointer\">{{contactForm.StudentName}}</a></td><td>{{contactForm.BranchName}}</td><td>\n{{contactForm.AreaName}}</td><td>{{contactForm.Status}}</td><td><md-button class=\"preview-user\" \nng-click=\"vm.openContactDialog(contactForm)\" title=\"פרטי בקשה\"><md-icon md-svg-icon=\"eye\"></md-icon></md-button></td>\n</tr></tbody></table></div></div></div>");
$templateCache.put("app/main/pages/profile-forms/views/subsidy-form/subsidy-form.html","<div id=\"branches\" class=\"page-layout simple tabbed\"><div class=\"header md-accent-bg\" layout=\"column\" \nlayout-align=\"center center\" layout-gt-sm=\"row\" layout-align-gt-sm=\"space-between start\"><div class=\"h1\" layout=\"row\" \nlayout-align=\"start center\"><span class=\"md-display-1 font-weight-300\">בקשות סבסוד</span></div></div><div \nclass=\"content\"><div layout=\"row\" layout-wrap><div layout=\"column\" flex=\"100\" flex-gt-sm=\"100\" flex-gt-md=\"70\"><form \nname=\"UserForm\" class=\"md-inline-form\" validate><div class=\"filters\" layout=\"row\" layout-xs=\"column\" flex=\"100\" \nflex-sm=\"100\" flex-gt-md=\"50\"></div><br><div class=\"filters\" layout=\"row\" layout-xs=\"column\" flex=\"100\" flex-sm=\"100\" \nflex-gt-md=\"50\"><div layout=\"column\" flex=\"100\" flex-gt-sm=\"50\" flex-md=\"33\" flex-xs=\"100\"><md-input-container \nclass=\"md-icon-float md-block\" layout=\"column\" layout-xs=\"row\" flex=\"100\" flex-gt-sm=\"50\" flex-gt-md=\"40\"><md-icon \nmd-font-icon=\"icon-calendar\"></md-icon><div start-view=\"day\" locale=\"he\" format=\"DD/MM/YYYY\" \nmoment-picker=\"vm.search.FromDate\"><label>מתאריך</label><input autocomplete=\"off\" ng-model=\"vm.search.FromDate\" \nng-disabled=\"!vm.subsidyes\"></div></md-input-container></div><div layout=\"column\" flex=\"100\" flex-gt-sm=\"50\" \nflex-md=\"33\" flex-xs=\"100\"><md-input-container class=\"md-icon-float md-block\" layout=\"column\" layout-xs=\"row\" \nflex=\"100\" flex-gt-sm=\"50\" flex-gt-md=\"40\"><md-icon md-font-icon=\"icon-calendar\"></md-icon><div start-view=\"day\" \nlocale=\"he\" format=\"DD/MM/YYYY\" moment-picker=\"vm.search.ToDate\"><label>עד תאריך</label><input autocomplete=\"off\" \nng-model=\"vm.search.ToDate\" ng-disabled=\"!vm.subsidyes\"></div></md-input-container></div></div><br><div \nclass=\"filters\" layout=\"row\" layout-xs=\"column\" flex=\"100\" flex-sm=\"100\" flex-gt-md=\"50\"><div layout=\"column\" \nflex=\"100\" flex-gt-sm=\"50\" flex-md=\"33\" flex-xs=\"100\"><md-input-container class=\"md-icon-float md-block\" \nlayout=\"column\" layout-xs=\"row\" flex=\"100\" flex-gt-sm=\"50\" flex-gt-md=\"40\"><label>סטטוס</label><md-icon \nmd-font-icon=\"icon-power\"></md-icon><md-select ng-model=\"vm.search.Status\" ng-disabled=\"!vm.subsidyes\"><md-option \nng-value=\"null\">הכל</md-option><md-option ng-value=\"1\">טופל</md-option><md-option ng-value=\"-1\">טרם טופל</md-option>\n</md-select></md-input-container></div><div layout=\"column\" flex=\"100\" flex-gt-sm=\"50\" flex-md=\"33\" flex-xs=\"100\">\n<md-input-container id=\"free-search\" class=\"md-icon-float md-block\"><md-icon md-font-icon=\"icon-magnify\"></md-icon>\n<label>חיפוש חופשי</label><input ng-model=\"vm.search.FreeSearchFromDB\" type=\"search\" ng-disabled=\"!vm.subsidyes\">\n</md-input-container></div></div><div class=\"search-actions row\" layout=\"row\"><md-button type=\"submit\" \nng-disabled=\"!vm.subsidyes || UserForm.$invalid \" class=\"md-raised md-accent\" aria-label=\"חפש\" \nng-click=\"vm.getSubsidyForms()\">סינון</md-button><md-button type=\"submit\" \nng-disabled=\"!vm.subsidyes || UserForm.$invalid \" class=\"md-raised md-accent\" aria-label=\"חפש\" \nng-click=\"vm.getSubsidyForms(true)\">איפוס סינון</md-button></div></form></div></div><div ng-if=\"!vm.subsidyes\" \nlayout=\"row\" layout-sm=\"column\" layout-align=\"space-around\"><md-progress-circular md-mode=\"indeterminate\">\n</md-progress-circular></div><div ng-if=\"vm.subsidyes\" class=\"events-table-c\"><table id=\"contact-table\" \nclass=\"dataTable row-border hover stripe md-ink-ripple\" datatable=\"ng\" dt-instance=\"vm.dtInstance\" \ndt-options=\"vm.dtOptions\" dt-column-defs=\"vm.dtColumnDefs\"><thead><tr><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">תאריך</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">שם הורה</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">מייל הורה</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">טלפון נייד הורה</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">סטטוס פניה</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">פעולות</span></div></th></tr></thead><tbody><tr \nclass=\"entry-code-item\" ng-repeat=\"subsidyForm in  vm.subsidyes\"><td><span class=\"dpn\">{{subsidyForm.CreateTime}}\n</span>{{subsidyForm.CreateTime | cmdate:\'HH:mm:ss dd/MM/yyyy \'}}</td><td><a \nhref=\"/parent-profile?ID={{subsidyForm.ParentID}}\" target=\"_blank\" style=\"cursor: pointer\">{{subsidyForm.ParentName}}\n</a></td><td><a href=\"mailto:{{subsidyForm.ParentEmail}}\">{{subsidyForm.ParentEmail}}</a></td><td>\n{{subsidyForm.ParentPhone}}</td><td ng-if=\"subsidyForm.ApprovedTime > 0\">טופל</td><td \nng-if=\"subsidyForm.ApprovedTime == 0 || subsidyForm.ApprovedTime == null\">טרם טופל</td><td><md-button \nclass=\"preview-user\" ng-click=\"vm.openSubsidyDialog(subsidyForm)\" title=\"פרטי בקשה\"><md-icon md-svg-icon=\"eye\">\n</md-icon></md-button></td></tr></tbody></table></div></div></div>");
$templateCache.put("app/main/pages/settings/tabs/accountancy/accountancy.html","<div layout=\"row\" layout-xs=\"column\" layout-align=\"space-between\" ng-init=\"vm.getAccountancySettings()\"><div flex=\"50\" \nflex-xs=\"25\"><md-content class=\"profile-box info-box md-whiteframe-1dp\"><md-toolbar class=\"md-accent\" layout=\"column\">\n<div class=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"title\">הנהלת חשבונות</span><md-button class=\"md-icon-button\" title=\"הוספת בנק\" aria-label=\"הוספת בנק\" \nng-click=\"vm.addBank()\" ng-disabled=\"!vm.accountancy || vm.isClicked\"><md-icon md-font-icon=\"icon-plus\"></md-icon>\n</md-button></div></md-toolbar><md-content class=\"content md-padding\"><form name=\"upgradeGradeForm\" \nclass=\"md-inline-form\" validate><div class=\"row\" layout=\"row\"><div class=\"half\"><md-input-container class=\"md-block\">\n<label>מספר לקוח - מרבליקס</label><input ng-model=\"vm.accountancy.MarvilixID\" \nng-disabled=\"!vm.accountancy || vm.isClicked\"></md-input-container></div><div class=\"half\"><md-input-container \nclass=\"md-block\"><label>מספר קבוע צ\'קים</label><input ng-model=\"vm.accountancy.CheckID\" \nng-disabled=\"!vm.accountancy || vm.isClicked\"></md-input-container></div></div><div class=\"row\" layout=\"row\"><div \nclass=\"half\"><md-input-container class=\"md-block\"><label>מספר קבוע ויזה</label><input ng-model=\"vm.accountancy.VisaID\" \nng-disabled=\"!vm.accountancy || vm.isClicked\"></md-input-container></div><div class=\"half\"><md-input-container \nclass=\"md-block\"><label>מספר קבוע ישראקרד</label><input ng-model=\"vm.accountancy.IsraCard\" \nng-disabled=\"!vm.accountancy || vm.isClicked\"></md-input-container></div></div><div class=\"row\" layout=\"row\"><div \nclass=\"half\"><md-input-container class=\"md-block\"><label>מספר קבוע אמריקן אקספרס</label><input \nng-model=\"vm.accountancy.AmericanExpress\" ng-disabled=\"!vm.accountancy || vm.isClicked\"></md-input-container></div><div\n class=\"half\"><md-input-container class=\"md-block\"><label>מספר קבוע מאסטקארד</label><input \nng-model=\"vm.accountancy.MasterCard\" ng-disabled=\"!vm.accountancy || vm.isClicked\"></md-input-container></div></div>\n<div class=\"row\" layout=\"row\"><div class=\"half\"><md-input-container class=\"md-block\"><label>מספר קבוע דיינרס</label>\n<input ng-model=\"vm.accountancy.DinersID\" ng-disabled=\"!vm.accountancy || vm.isClicked\"></md-input-container></div><div\n class=\"half\"><md-input-container class=\"md-block\"><label>מספר קבוע מזומן</label><input \nng-model=\"vm.accountancy.CashID\" ng-disabled=\"!vm.accountancy || vm.isClicked\"></md-input-container></div></div><div>\n<div class=\"half\" lass=\"row\" layout=\"row\"><table class=\"dataTable row-border hover\"><thead><tr><th data-priority=\"1\" \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">שם בנק</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">מספר קבוע בנק</span></div></th></tr>\n</thead><tbody><tr ng-repeat=\"item in vm.accountancy.Banks\"><td><md-input-container class=\"md-block\"><label>שם בנק\n</label><input ng-model=\"item.Name\" ng-disabled=\"vm.isClicked\"></md-input-container></td><td><md-input-container \nclass=\"md-block\"><label>מספר קבוע בנק</label><input ng-model=\"item.Number\" ng-disabled=\"vm.isClicked\">\n</md-input-container></td></tr></tbody></table></div></div><md-button ng-disabled=\"vm.isClicked\" \nclass=\"md-raised md-accent\" ng-click=\"vm.updateAccountancy()\" style=\"margin-right: 0px\">עדכן</md-button></form>\n</md-content></md-content></div></div>");
$templateCache.put("app/main/pages/settings/tabs/birthday/birthday.html","<div layout=\"row\" layout-wrap ng-init=\"vm.getSystemBirthdaySettings()\"><div class=\"settings\" layout=\"column\" \nflex=\"100\" flex-gt-sm=\"100\" flex-gt-md=\"70\"><div class=\"profile-box info-box general md-whiteframe-1dp\" \nlayout=\"column\"><header class=\"md-accent-bg\"><div class=\"title\">מייל יום הולדת</div></header><div class=\"content\"><form\n name=\"upgradeGradeForm\" class=\"md-inline-form\" validate><div class=\"row\" layout=\"row\"><div class=\"half\">\n<md-input-container class=\"md-block\"><label>סטטוס</label><md-select ng-model=\"vm.birthdaySettings.Status\" \nng-required=\"true\" ng-disabled=\"!vm.birthdaySettings || vm.isClicked \"><md-option ng-value=\"1\">פעיל</md-option>\n<md-option ng-value=\"0\">לא פעיל</md-option></md-select></md-input-container></div></div><div class=\"row\" layout=\"row\">\n<div class=\"half\"><md-input-container class=\"md-block\"><label>כותרת להצגה בתבנית</label><textarea \nng-disabled=\"!vm.updateSystemBirthdaySettings || vm.isClicked \" ng-model=\"vm.birthdaySettings.Title\"></textarea>\n</md-input-container></div><div class=\"half\"><md-input-container class=\"md-block\"><label>תוכן להצגה בתבנית</label>\n<textarea ng-disabled=\"!vm.updateSystemBirthdaySettings || vm.isClicked \" ng-model=\"vm.birthdaySettings.Body\">\n</textarea></md-input-container></div></div><md-button ng-disabled=\"vm.isClicked || upgradeGradeForm.$invalid\" \nclass=\"md-raised md-accent\" aria-label=\"עדכן שכבה\" ng-click=\"vm.updateSystemBirthdaySettings()\" \nstyle=\"margin-right: 0px\">עדכן</md-button></form></div></div></div></div>");
$templateCache.put("app/main/pages/settings/tabs/coordinator-settings/coordinator-settings.html","<div ng-init=\"vm.getRoles()\"><div layout=\"row\" layout-wrap><div class=\"general\" layout=\"column\" flex=\"100\" \nflex-gt-sm=\"80\" flex-gt-md=\"80\" flex-gt-lg=\"80\"><div class=\"profile-box info-box md-whiteframe-1dp\" layout=\"column\">\n<header class=\"md-accent-bg\"><div class=\"title\">תפקידים</div></header><div class=\"content\"><form name=\"UserForm\" \nclass=\"md-inline-form\" validate><div layout=\"row\" layout-wrap><md-chips ng-hide=\"!vm.roles\" ng-model=\"vm.roles\" \nplaceholder=\"הוספת תפקיד\"></md-chips></div><br><md-button class=\"md-raised md-accent\" ng-disabled=\"vm.isClikced\" \nng-click=\"vm.updateRoles()\">עדכון</md-button></form></div></div></div></div></div>");
$templateCache.put("app/main/pages/settings/tabs/educator-settings/educator-settings.html","<div ng-init=\"vm.geEducatortRoles()\"><div layout=\"row\" layout-wrap><div class=\"general\" layout=\"column\" flex=\"100\" \nflex-gt-sm=\"80\" flex-gt-md=\"80\" flex-gt-lg=\"80\"><div class=\"profile-box info-box md-whiteframe-1dp\" layout=\"column\">\n<header class=\"md-accent-bg\"><div class=\"title\">תפקידים</div></header><div class=\"content\"><form name=\"UserForm\" \nclass=\"md-inline-form\" validate><div layout=\"row\" layout-wrap><md-chips ng-hide=\"!vm.educatorRoles\" \nng-model=\"vm.educatorRoles\" placeholder=\"הוספת תפקיד\"></md-chips></div><br><md-button class=\"md-raised md-accent\" \nng-disabled=\"vm.isClikced\" ng-click=\"vm.updateEducatorRoles()\">עדכון</md-button></form></div></div></div></div></div>");
$templateCache.put("app/main/pages/settings/tabs/external-registerations/settings.html","<div layout=\"row\" layout-xs=\"column\" layout-align=\"space-between\" ng-init=\"vm.getExternalSettings()\"><div flex=\"50\" \nflex-xs=\"25\"><md-content class=\"profile-box info-box md-whiteframe-1dp\"><md-toolbar class=\"md-accent\" layout=\"column\">\n<div class=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"title\">הגדרות מערכת - הרשמה חיצונית</span></div></md-toolbar><md-content class=\"content md-padding\"><form \nname=\"upgradeGradeForm\" class=\"inrowf\" validate><div class=\"col2s30 smw100\"><md-input-container \nclass=\"md-icon-float md-block\"><label>קישור פורטל תשלומים</label><md-icon md-svg-icon=\"link-variant\"></md-icon><input \nng-model=\"vm.externalEvent.Portal\" md-autofocus \nng-disabled=\"$root.AdminLevel==1 || ($root.AdminLevel==2 && event.CoordinatorID!=$root.User.ID)\"></md-input-container>\n</div><div class=\"col2s30 smw100\"><md-input-container class=\"md-icon-float md-block\"><label>קישור אתר התנועה</label>\n<md-icon md-svg-icon=\"link-variant\"></md-icon><input ng-model=\"vm.externalEvent.Website\" md-autofocus \nng-disabled=\"$root.AdminLevel==1 || ($root.AdminLevel==2 && event.CoordinatorID!=$root.User.ID)\"></md-input-container>\n</div><div class=\"col2s30 smw100\"><md-input-container class=\"md-icon-float md-block\"><label>קישור יצירת קשר</label>\n<md-icon md-svg-icon=\"link-variant\"></md-icon><input ng-model=\"vm.externalEvent.Contact\" md-autofocus \nng-disabled=\"$root.AdminLevel==1 || ($root.AdminLevel==2 && event.CoordinatorID!=$root.User.ID)\"></md-input-container>\n</div><div class=\"col2s30 smw100\"><md-input-container class=\"md-icon-float md-block\"><label>קישור אתר תרומות</label>\n<md-icon md-svg-icon=\"link-variant\"></md-icon><input ng-model=\"vm.externalEvent.Donate\" md-autofocus \nng-disabled=\"$root.AdminLevel==1 || ($root.AdminLevel==2 && event.CoordinatorID!=$root.User.ID)\"></md-input-container>\n</div><div class=\"col2s30 smw100\"><md-input-container class=\"md-icon-float md-block\"><label>כותרת ראשית אתר</label>\n<md-icon md-svg-icon=\"link-variant\"></md-icon><input ng-model=\"vm.externalEvent.MainTitle\" md-autofocus \nng-disabled=\"$root.AdminLevel==1 || ($root.AdminLevel==2 && event.CoordinatorID!=$root.User.ID)\"></md-input-container>\n</div><div class=\"col2s30 smw100\"><md-input-container class=\"md-icon-float md-block\"><label>כותרת משנית אתר</label>\n<md-icon md-svg-icon=\"link-variant\"></md-icon><input ng-model=\"vm.externalEvent.SubTitle\" md-autofocus \nng-disabled=\"$root.AdminLevel==1 || ($root.AdminLevel==2 && event.CoordinatorID!=$root.User.ID)\"></md-input-container>\n</div><div class=\"col2s30 smw100\"><md-input-container class=\"md-icon-float md-block\"><label>קישור אתר תרומות</label>\n<md-icon md-svg-icon=\"link-variant\"></md-icon><input ng-model=\"vm.externalEvent.Donate\" md-autofocus \nng-disabled=\"$root.AdminLevel==1 || ($root.AdminLevel==2 && event.CoordinatorID!=$root.User.ID)\"></md-input-container>\n</div><md-button ng-disabled=\"vm.isClicked\" class=\"md-raised md-accent\" aria-label=\"עדכן פרטים\" \nng-click=\"vm.updateExternalSettings()\">עדכן</md-button></form></md-content><div ckeditor=\"vm.options\" \nng-model=\"vm.externalEvent.Terms\"></div></md-content></div></div>");
$templateCache.put("app/main/pages/settings/tabs/forms/forms.html","<div layout=\"row\" layout-align=\"space-between \" layout-wrap ng-init=\"vm.getEmails();\"><div class=\"settings\" \nlayout=\"column\" flex=\"100\" flex-gt-sm=\"100\" flex-gt-md=\"60\"><div \nclass=\"profile-box info-box general md-whiteframe-1dp\" layout=\"column\"><header class=\"md-accent-bg\"><div class=\"title\">\nהגדרות טפסים</div></header><div class=\"content\"><form name=\"emailsForm\" class=\"md-inline-form\" validate><div \nclass=\"row\" layout=\"row\" ng-repeat=\"setting in vm.settings\" \nng-if=\"setting.DisplayName!=\'סוגי פניות מהפרופיל\' && vm.settingsReady\"><div class=\"half\" \nng-if=\"setting.Property != \'ContactText\'\"><md-input-container class=\"md-block\"><label>{{setting.DisplayName}}</label>\n<md-chips ng-model=\"setting.Value\" readonly=\"false\" md-removable=\"true\"></md-chips></md-input-container></div></div>\n<md-button ng-disabled=\"vm.isClicked || emailsForm.$invalid\" class=\"md-raised md-accent\" aria-label=\"עדכן שכבה\" \nng-click=\"vm.updateSettings()\" style=\"margin-right: 0px\">עדכן</md-button></form></div></div></div><div \nclass=\"settings\" layout=\"column\" flex=\"100\" flex-gt-sm=\"100\" flex-gt-md=\"30\"><div \nclass=\"profile-box info-box general md-whiteframe-1dp\" layout=\"column\"><header class=\"md-accent-bg\"><div class=\"title\">\nסוגי פניות</div></header><div class=\"content\"><form name=\"emailsForm\" class=\"md-inline-form\" validate><div class=\"row\" \nlayout=\"row\" ng-repeat=\"setting in vm.settings\" ng-if=\"setting.DisplayName==\'סוגי פניות מהפרופיל\' && vm.settingsReady\">\n<div class=\"half\"><md-input-container class=\"md-block\"><label>{{setting.DisplayName}}</label><md-chips \nng-model=\"setting.Value\" readonly=\"false\" md-removable=\"true\"></md-chips></md-input-container></div></div><md-button \nng-disabled=\"vm.isClicked || emailsForm.$invalid\" class=\"md-raised md-accent\" aria-label=\"עדכן שכבה\" \nng-click=\"vm.updateSettings()\" style=\"margin-right: 0px\">עדכן</md-button></form></div></div></div></div>");
$templateCache.put("app/main/pages/settings/tabs/grade-upgrade/grade-upgrade.html","<div layout=\"row\" layout-wrap ng-init=\"vm.getGrades()\"><div class=\"settings\" layout=\"column\" flex=\"100\" \nflex-gt-sm=\"100\" flex-gt-md=\"70\"><div class=\"profile-box info-box general md-whiteframe-1dp\" layout=\"column\"><header \nclass=\"md-accent-bg\"><div class=\"title\">העלאת {{$root.User.Grade}}</div></header><div class=\"content\"><ul><li><span \nclass=\"red\">יש להתחיל מהשכבה הגבוה ביותר</span></li></ul><form name=\"upgradeGradeForm\" class=\"md-inline-form\" validate>\n<div class=\"row\" layout=\"row\"><div class=\"half\"><md-input-container class=\"md-block\"><label>{{$root.User.Grade}} נבחרת\n</label><md-select ng-model=\"vm.upgrade.SelectedGrade\" ng-required=\"true\" ng-disabled=\"!vm.grades || vm.isClicked \">\n<md-option ng-repeat=\"gradeValue in vm.grades\" ng-value=\"gradeValue.ID\">{{gradeValue.Name}}</md-option></md-select>\n</md-input-container></div></div><div class=\"row\" layout=\"row\"><div class=\"half\"><md-input-container class=\"md-block\">\n<label>{{$root.User.Grade}} חדשה</label><md-select ng-model=\"vm.upgrade.NewGrade\" \nng-disabled=\"!vm.upgrade.SelectedGrade || vm.isClicked \" ng-required=\"true\"><md-option \nng-repeat=\"gradeValue in vm.grades\" ng-value=\"gradeValue.ID\">{{gradeValue.Name}}</md-option></md-select>\n</md-input-container></div></div><md-button ng-disabled=\"vm.isClicked || upgradeGradeForm.$invalid\" \nclass=\"md-raised md-accent\" aria-label=\"עדכן שכבה\" ng-click=\"vm.updateGrade(grade)\" style=\"margin-right: 0px\">עדכן\n</md-button></form></div></div></div></div>");
$templateCache.put("app/main/pages/settings/tabs/manage-areas/manage-areas.html","<div id=\"grades\" class=\"page-layout simple tabbed\" ng-init=\"vm.getAreas()\"><div class=\"content\"><div layout=\"row\" \nlayout-wrap><div layout=\"column\" flex=\"100\" flex-gt-sm=\"100\" flex-gt-md=\"70\"><form name=\"UserForm\" \nclass=\"md-inline-form\" validate><div layout=\"row\" flex=\"100\"><md-input-container class=\"md-icon-float md-block\" \nlayout=\"column\" layout-xs=\"row\" flex=\"100\" flex-gt-sm=\"50\" flex-gt-md=\"40\"><md-icon md-font-icon=\"icon-magnify\">\n</md-icon><label>חיפוש חופשי</label><input id=\"free-search\" ng-model=\"vm.search.freeSearch\" type=\"text\">\n</md-input-container></div></form></div></div><div layout=\"row\" layout-sm=\"column\" layout-align=\"space-around\" \nng-show=\"!vm.areas\"><md-progress-circular md-mode=\"indeterminate\"></md-progress-circular></div><div ng-if=\"vm.areas\">\n<table id=\"areas-table\" class=\"dataTable row-border hover stripe md-ink-ripple\" datatable=\"ng\" \ndt-instance=\"dtInstance\" dt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text\"><div class=\"table-header\">\n<span class=\"column-title\">שם</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">פעולות</span></div></th></tr></thead><tbody><tr class=\"entry-code-item\" \nng-repeat=\"area in vm.areas | filter:search.freeSearch\"><td>{{area.Name}}</td><td><md-button class=\"preview-user\" \nng-click=\"vm.editArea(area)\">ערוך</md-button></td></tr></tbody></table></div><md-button \nclass=\"md-fab md-accent md-icon-button\" id=\"add-newGrade-button\" ng-click=\"vm.addNewAreaDialog()\" \naria-label=\"add new Grade\" title=\"הוספת אזור\"><md-icon md-font-icon=\"icon-plus\"></md-icon></md-button></div></div>");
$templateCache.put("app/main/pages/settings/tabs/profile/profile.html","<div layout=\"row\" layout-wrap ng-init=\"vm.getProfileImages();vm.getProfileSettings();\"><div class=\"settings\" \nlayout=\"column\" flex=\"100\" flex-gt-sm=\"100\" flex-gt-md=\"70\"><div \nclass=\"profile-box info-box general md-whiteframe-1dp\" layout=\"column\"><header class=\"md-accent-bg\"><div class=\"title\">\nתמונות פרופיל הורה</div></header><div class=\"content\"><form name=\"upgradeGradeForm\" class=\"md-inline-form\" validate>\n<div class=\"row\" layout=\"row\"><div class=\"half\"><div layout=\"column\" flex=\"100\" flex-gt-sm=\"50\" flex-gt-md=\"50\">\n<md-input-container class=\"md-icon-float md-block\" layout=\"column\" layout-xs=\"row\" flex=\"100\" flex-xs=\"100\" \nflex-gt-sm=\"100\" ng-repeat=\"image in vm.profileImages\" flex-gt-md=\"100\"><md-icon ng-if=\"!image.Value\" \nmd-svg-icon=\"upload\" class=\"name\"></md-icon><md-icon ng-disabled=\"vm.isClicked\" ng-if=\"image.Value\" md-svg-icon=\"eye\" \nhref=\"{{image.Value}}\" ng-click=\"vm.viewFile(image.Value)\" style=\"cursor: pointer\" title=\"צפייה בקובץ\" class=\"name\">\n</md-icon><label>{{image.DisplayName}}</label><input ng-disabled=\"vm.isClicked\" \nngf-select=\"vm.uploadFile($file,image)\" placeholder=\"{{image.FileName}}\" ng-model=\"file\" name=\"file\" \nngf-pattern=\"\'image/*\'\" style=\"cursor: pointer\" readonly=\"readonly\"></md-input-container></div></div></div><md-button \nng-disabled=\"vm.isClicked\" class=\"md-raised md-accent\" ng-click=\"vm.updateProfileImageSettings()\" \nstyle=\"margin-right: 0px\">עדכון</md-button></form></div></div></div><div class=\"settings\" layout=\"column\" flex=\"100\" \nflex-gt-sm=\"100\" flex-gt-md=\"70\"><div class=\"profile-box info-box general md-whiteframe-1dp\" layout=\"column\"><header \nclass=\"md-accent-bg\"><div class=\"title\">הגדרות נוספות</div></header><div class=\"content\"><form name=\"upgradeGradeForm\" \nclass=\"md-inline-form\" validate><div class=\"row\" layout=\"row\"><div class=\"half\"><md-input-container \nstyle=\"width: 100%\"><label>טקסט בקשה לביטול הרשמה</label><md-icon md-svg-icon=\"cancel\" class=\"name\"></md-icon><textarea\n ng-model=\"vm.profile.CancelFormText.Value\" ng-disabled=\"vm.isClicked\"></textarea></md-input-container></div><div \nclass=\"half\"><md-input-container style=\"width: 100%\"><label>כתובת אתר האינטרנט של התנועה</label><md-icon \nmd-svg-icon=\"web\" class=\"name\"></md-icon><textarea ng-model=\"vm.profile.BrandSite.Value\" ng-disabled=\"vm.isClicked\">\n</textarea></md-input-container></div></div><div class=\"row\" layout=\"row\"><div class=\"half\"><md-input-container \nstyle=\"width: 100%\"><label>מספר טלפון של התנועה</label><md-icon md-svg-icon=\"phone\" class=\"name\"></md-icon><textarea \nng-model=\"vm.profile.BrandPhoneNumber.Value\" ng-disabled=\"vm.isClicked\"></textarea></md-input-container></div><div \nclass=\"half\"><md-input-container style=\"width: 100%\"><label>דואר אלקטרוני של התנועה</label><md-icon \nmd-svg-icon=\"email\" class=\"name\"></md-icon><textarea ng-model=\"vm.profile.BrandEmail.Value\" ng-disabled=\"vm.isClicked\">\n</textarea></md-input-container></div></div><div class=\"row\" layout=\"row\"><div class=\"half\"><md-input-container \nstyle=\"width: 100%\"><label>בקשות לביטול</label><md-icon md-svg-icon=\"cancel\" class=\"name\"></md-icon><md-select \nng-model=\"vm.profile.CancelEvents.Value\" ng-disabled=\"vm.isClicked\"><md-option ng-value=\"1\">פעיל</md-option><md-option \nng-value=\"0\">לא פעיל</md-option></md-select></md-input-container></div><div class=\"half\"><md-input-container \nstyle=\"width: 100%\"><label>טופס סיבסוד</label><md-icon md-svg-icon=\"newspaper\" class=\"name\"></md-icon><md-select \nng-model=\"vm.profile.SubsidyForm.Value\" ng-disabled=\"vm.isClicked\"><md-option ng-value=\"0\">ללא</md-option><md-option \nng-value=\"1\">תבנית 1</md-option><md-option ng-value=\"2\">תבנית 2</md-option><md-option ng-value=\"3\">תבנית 3</md-option>\n</md-select></md-input-container></div></div><div class=\"row\" layout=\"row\"><div class=\"half\"><md-input-container \nstyle=\"width: 100%\"><label>טקסט בצור קשר</label><md-icon md-svg-icon=\"email\" class=\"name\"></md-icon><textarea \nng-model=\"vm.profile.ContactText.Value\" ng-disabled=\"vm.isClicked\"></textarea></md-input-container></div></div>\n<md-button ng-disabled=\"vm.isClicked\" class=\"md-raised md-accent\" ng-click=\"vm.updateProfileSettings()\" \nstyle=\"margin-right: 0px\">עדכון</md-button></form></div></div></div><div class=\"settings\" layout=\"column\" flex=\"100\" \nflex-gt-sm=\"100\" flex-gt-md=\"70\"><div class=\"profile-box info-box general md-whiteframe-1dp\" layout=\"column\"><header \nclass=\"md-accent-bg\"><div class=\"title\">שדות חובה לרישום חניך</div></header><div class=\"content\"><div layout-wrap=\"\" \nlayout-gt-md=\"row\"><div flex-gt-md=\"30\" ng-repeat=\"field in vm.studentfields\"><md-input-container style=\"width: 100%\">\n<md-checkbox ng-model=\"field.required\" data-ng-disabled=\"vm.mandatoryStudentFields.includes(field.name)\" \naria-label=\"{{field.he_title}}\">{{field.he_title}}</md-checkbox></md-input-container></div></div><md-button \nng-disabled=\"vm.isClicked\" class=\"md-raised md-accent\" ng-click=\"vm.updateStudentFields()\" style=\"margin-right: 0px\">\nעדכון</md-button></div></div></div><div class=\"settings\" layout=\"column\" flex=\"100\" flex-gt-sm=\"100\" flex-gt-md=\"70\">\n<div class=\"profile-box info-box general md-whiteframe-1dp\" layout=\"column\"><header class=\"md-accent-bg\"><div \nclass=\"title\">שדות נוספים לרישום חניך</div></header><div class=\"content\"><div ng-if=\"vm.extraStudentFields\" \nclass=\"events-table-c\"><table id=\"fields-table\" class=\"dataTable row-border hover stripe md-ink-ripple\" datatable=\"ng\" \ndt-instance=\"dtInstance\" dt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text\"><div class=\"table-header\">\n<span class=\"column-title\">שאלה</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">סוג שאלה</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">סטטוס</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">פעולות</span></div></th></tr></thead><tbody><tr class=\"main-table-new\" \nng-repeat=\"field in vm.extraStudentFields  \"><td>{{field.Title}}</td><td>{{vm.extraFieldType(field.Type)}}</td><td>\n{{field.Status==1 || field.Status==\'1\' ? \'פעיל\' : \'לא פעיל\'}}</td><td><md-button class=\"preview-user\" \nng-click=\"vm.editField(field)\" title=\"עריכה\"><md-icon md-svg-icon=\"pencil\"></md-icon></md-button></td></tr></tbody>\n</table></div><md-button ng-disabled=\"vm.isClicked\" class=\"md-raised md-accent\" \nng-click=\"vm.updateExtraStudentFields()\" style=\"margin-right: 0px\">עדכון</md-button><md-button \nng-disabled=\"vm.isClicked\" class=\"md-raised md-accent\" ng-click=\"vm.openNewFieldDialog()\">שדה חדש</md-button></div>\n</div></div></div>");
$templateCache.put("app/main/pages/settings/tabs/receipts/receipts.html","<div layout=\"row\" layout-xs=\"column\" layout-align=\"space-between\" ng-init=\"vm.getSystemSettings()\"><div flex=\"50\" \nflex-xs=\"25\"><md-content class=\"profile-box info-box md-whiteframe-1dp\"><md-toolbar class=\"md-accent\" layout=\"column\">\n<div class=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"title\">פרטי קבלה</span></div></md-toolbar><md-content class=\"content md-padding\"><form name=\"upgradeGradeForm\" \nclass=\"md-inline-form\" validate><div class=\"row\" layout=\"row\"><div class=\"half\"><md-input-container class=\"md-block\">\n<md-icon md-font-icon=\"icon-city\" class=\"name\"></md-icon><label>שם הארגון</label><input \nng-model=\"vm.systemSettings.BranName\" ng-disabled=\"!vm.systemSettings || vm.isClicked\"></md-input-container></div><div \nclass=\"half\"><md-input-container class=\"md-block\"><md-icon md-svg-icon=\"numeric\" class=\"name\"></md-icon><label>\nמספר הארגון</label><input ng-model=\"vm.systemSettings.BranNumber\" ng-disabled=\"!vm.systemSettings || vm.isClicked\">\n</md-input-container></div></div><div class=\"row\" layout=\"row\"><div class=\"half\"><md-input-container class=\"md-block\">\n<label>כתובת הארגון</label><md-icon md-svg-icon=\"map-marker\" class=\"name\"></md-icon><input \nng-model=\"vm.systemSettings.BrandAddress\" ng-disabled=\"!vm.systemSettings || vm.isClicked\"></md-input-container></div>\n<div class=\"half\"><md-input-container class=\"md-block\"><md-icon md-font-icon=\"icon-phone\" class=\"name\"></md-icon>\n<label>מספר טלפון</label><input ng-model=\"vm.systemSettings.BrandPhoneNumber\" \nng-disabled=\"!vm.systemSettings || vm.isClicked\"></md-input-container></div></div><div class=\"row\" layout=\"row\"><div \nclass=\"half\"><md-input-container class=\"md-block\"><label>מספר פקס</label><md-icon md-svg-icon=\"fax\" class=\"name\">\n</md-icon><input ng-model=\"vm.systemSettings.BrandFaxNumber\" ng-disabled=\"!vm.systemSettings || vm.isClicked\">\n</md-input-container></div><div class=\"half\"><md-input-container class=\"md-block\"><md-icon md-font-icon=\"icon-email\" \nclass=\"name\"></md-icon><label>מייל</label><input ng-model=\"vm.systemSettings.BrandEmail\" \nng-disabled=\"!vm.systemSettings || vm.isClicked\"></md-input-container></div></div><div class=\"row\" layout=\"row\"><div \nclass=\"half\"><md-input-container class=\"md-block\"><label>אתר אינטרנט</label><md-icon md-font-icon=\"icon-web\" \nclass=\"name\"></md-icon><input ng-model=\"vm.systemSettings.BrandWebsite\" \nng-disabled=\"!vm.systemSettings || vm.isClicked\"></md-input-container></div><div class=\"half\"><md-input-container \nclass=\"md-block\"><md-icon md-svg-icon=\"file-image\" class=\"name\"></md-icon><label>לוגו</label><a title=\"צפייה בקובץ\" \nng-if=\"vm.systemSettings.BrandLogo\" ng-disabled=\"vm.isClicked\" href=\"{{vm.systemSettings.BrandLogo}}\" target=\"_blank\">\n<md-icon md-svg-icon=\"eye\"></md-icon></a><md-icon md-svg-icon=\"file\" class=\"name\"></md-icon><input \nplaceholder=\"עדכון קובץ\" style=\"cursor: pointer\" ng-click=\"vm.uploadImage(true)\" readonly=\"readonly\">\n</md-input-container></div></div><div class=\"row\" layout=\"row\"><div class=\"half\"><md-input-container class=\"md-block\">\n<label>הפקת קבלה - שולם לרכז</label><md-icon md-svg-icon=\"file-document\" class=\"name\"></md-icon><md-select \nng-model=\"vm.systemSettings.CoordinatorsReceipts\" ng-disabled=\"!vm.systemSettings || vm.isClicked\"><md-option \nng-value=\"1\">הפק קבלה</md-option><md-option ng-value=\"0\">ללא קבלה</md-option></md-select></md-input-container></div>\n</div><md-button ng-disabled=\"vm.isClicked\" class=\"md-raised md-accent\" aria-label=\"עדכן  {{$root.User.Grade}}\" \nng-click=\"vm.updateSystemSettings()\" style=\"margin-right: 0px\">עדכן</md-button></form></md-content></md-content></div>\n</div>");
$templateCache.put("app/main/pages/settings/tabs/students-fields/students-fields.html","<!DOCTYPE html><html lang=\"en\"><head><meta charset=\"UTF-8\"><title>Title</title></head><body></body></html>");
$templateCache.put("app/main/pages/settings/tabs/system/system.html","<div layout=\"row\" layout-xs=\"column\" layout-align=\"space-between\" id=\"profileSettings\" \nng-init=\"vm.getSystemSettings();vm.getAdminImages()\"><div flex=\"50\" flex-xs=\"25\"><md-content \nclass=\"profile-box info-box md-whiteframe-1dp\"><md-toolbar class=\"md-accent\" layout=\"column\"><div \nclass=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">\nמילון מונחים - כאן תוכלו לשנות את השמות שיופיעו בתוכנה ובפרופיל ההורה</span></div></md-toolbar><md-content \nclass=\"content md-padding\"><form name=\"upgradeGradeForm\" class=\"md-inline-form\" validate><div class=\"row\" layout=\"row\">\n<div class=\"half\"><md-input-container class=\"md-block\"><md-icon md-font-icon=\"icon-city\" class=\"name\"></md-icon><label>\nסניפים</label><input ng-model=\"vm.systemSettings.Branches\" ng-disabled=\"!vm.systemSettings || vm.isClicked\">\n</md-input-container></div><div class=\"half\"><md-input-container class=\"md-block\"><md-icon \nmd-font-icon=\"icon-account-multiple\" class=\"name\"></md-icon><label>קבוצות</label><input \nng-model=\"vm.systemSettings.Groups\" ng-disabled=\"!vm.systemSettings || vm.isClicked\"></md-input-container></div></div>\n<div class=\"row\" layout=\"row\"><div class=\"half\"><md-input-container class=\"md-block\"><label>שכבות</label><md-icon \nmd-font-icon=\"icon-chair-school\" class=\"name\"></md-icon><input ng-model=\"vm.systemSettings.Grades\" \nng-disabled=\"!vm.systemSettings || vm.isClicked\"></md-input-container></div><div class=\"half\"><md-input-container \nclass=\"md-block\"><md-icon md-font-icon=\"icon-city\" class=\"name\"></md-icon><label>סניף</label><input \nng-model=\"vm.systemSettings.Branch\" ng-disabled=\"!vm.systemSettings || vm.isClicked\"></md-input-container></div></div>\n<div class=\"row\" layout=\"row\"><div class=\"half\"><md-input-container class=\"md-block\"><label>שכבה</label><md-icon \nmd-font-icon=\"icon-chair-school\" class=\"name\"></md-icon><input ng-model=\"vm.systemSettings.Grade\" \nng-disabled=\"!vm.systemSettings || vm.isClicked\"></md-input-container></div><div class=\"half\"><md-input-container \nclass=\"md-block\"><md-icon md-font-icon=\"icon-account-multiple\" class=\"name\"></md-icon><label>קבוצות</label><input \nng-model=\"vm.systemSettings.Group\" ng-disabled=\"!vm.systemSettings || vm.isClicked\"></md-input-container></div></div>\n<div class=\"row\" layout=\"row\"><div class=\"half\"><md-input-container class=\"md-block\"><label>פעילויות</label><md-icon \nmd-font-icon=\"icon-leaf\" class=\"name\"></md-icon><input ng-model=\"vm.systemSettings.Activities\" \nng-disabled=\"!vm.systemSettings || vm.isClicked\"></md-input-container></div><div class=\"half\"><md-input-container \nclass=\"md-block\"><md-icon md-font-icon=\"icon-leaf\" class=\"name\"></md-icon><label>פעילות</label><input \nng-model=\"vm.systemSettings.Activity\" ng-disabled=\"!vm.systemSettings || vm.isClicked\"></md-input-container></div>\n</div><div class=\"row\" layout=\"row\"><div class=\"half\"><md-input-container class=\"md-block\"><label>\n{{$root.User.Coordinators}}</label><md-icon md-font-icon=\"icon-tie\" class=\"name\"></md-icon><input \nng-model=\"vm.systemSettings.Coordinators\" ng-disabled=\"!vm.systemSettings || vm.isClicked\"></md-input-container></div>\n<div class=\"half\"><md-input-container class=\"md-block\"><md-icon md-font-icon=\"icon-tie\" class=\"name\"></md-icon><label>\n{{$root.User.Coordinator}}</label><input ng-model=\"vm.systemSettings.Coordinator\" \nng-disabled=\"!vm.systemSettings || vm.isClicked\"></md-input-container></div></div><md-button \nng-disabled=\"vm.isClicked\" class=\"md-raised md-accent\" aria-label=\"עדכן  {{$root.User.Grade}}\" \nng-click=\"vm.updateSystemSettings()\" style=\"margin-right: 0px\">עדכן</md-button></form></md-content></md-content></div>\n<div flex=\"45\" flex-xs=\"25\"><md-content class=\"profile-box info-box md-whiteframe-1dp\"><md-toolbar class=\"md-accent\" \nlayout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\">\n<span class=\"title\">תמונות המערכת</span></div></md-toolbar><md-content class=\"content md-padding\"><form \nname=\"upgradeGradeForm\" class=\"md-inline-form\" validate><div class=\"row\" layout=\"row\"><div class=\"half\"><div \nlayout=\"column\" flex=\"100\" flex-gt-sm=\"50\" flex-gt-md=\"50\"><md-input-container class=\"md-icon-float md-block\" \nlayout=\"column\" layout-xs=\"row\" flex=\"100\" flex-xs=\"100\" flex-gt-sm=\"100\" ng-repeat=\"image in vm.adminImages\" \nflex-gt-md=\"100\"><md-icon ng-if=\"!image.Value\" md-svg-icon=\"upload\" class=\"name\"></md-icon><md-icon \nng-disabled=\"vm.isClicked\" ng-if=\"image.Value\" md-svg-icon=\"eye\" href=\"{{image.Value}}\" \nng-click=\"vm.viewFile(image.Value)\" style=\"cursor: pointer\" title=\"צפייה בקובץ\" class=\"name\"></md-icon><label>\n{{image.DisplayName}}</label><input ng-disabled=\"vm.isClicked\" ngf-select=\"vm.uploadFile($file,image)\" \nplaceholder=\"{{image.FileName}}\" ng-model=\"file\" name=\"file\" ngf-pattern=\"\'image/*\'\" style=\"cursor: pointer\" \nreadonly=\"readonly\"></md-input-container></div></div></div><md-button ng-disabled=\"vm.isClicked\" \nclass=\"md-raised md-accent\" ng-click=\"vm.updateAdminImageSettings()\" style=\"margin-right: 0px\">עדכון</md-button></form>\n</md-content></md-content></div><div flex=\"50\" flex-xs=\"25\"><md-content class=\"profile-box info-box md-whiteframe-1dp\">\n<md-toolbar class=\"md-accent\" layout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" \nlayout-align=\"space-between center\"><span class=\"title\">סוגי סטטוס נוכחות</span></div></md-toolbar><md-content \nclass=\"content md-padding\"><form name=\"upgradeGradeForm\" class=\"md-inline-form\" validate><md-chips \nng-model=\"vm.systemSettings.AttendenceStatus\" readonly=\"ctrl.readonly\" md-removable=\"ctrl.removable\"><md-chip-template>\n<strong>{{$chip}}</strong></md-chip-template></md-chips><md-button ng-disabled=\"vm.isClicked\" \nclass=\"md-raised md-accent\" ng-click=\"vm.updateSystemSettings()\" style=\"margin-right: 0px\">עדכון</md-button></form>\n</md-content></md-content></div></div>");
$templateCache.put("app/main/pages/settings/tabs/tags/tags.html","<div ng-init=\"vm.getTags()\"><div layout=\"row\" layout-wrap><div class=\"general\" layout=\"column\" flex=\"100\" \nflex-gt-sm=\"80\" flex-gt-md=\"80\" flex-gt-lg=\"80\"><div class=\"profile-box info-box md-whiteframe-1dp\" layout=\"column\">\n<header class=\"md-accent-bg\"><div class=\"title\">תגיות</div></header><div class=\"content\"><form name=\"UserForm\" \nclass=\"md-inline-form\" validate><div layout=\"row\" layout-wrap><md-chips ng-hide=\"!vm.studentsTags\" \nng-model=\"vm.studentsTags\" placeholder=\"הוספת תגית חניכים\"></md-chips></div><div layout=\"row\" layout-wrap><md-chips \nng-hide=\"!vm.parentsTags\" ng-model=\"vm.parentsTags\" placeholder=\"הוספת תגית הורים\"></md-chips></div><br><md-button \nclass=\"md-raised md-accent\" ng-disabled=\"vm.isClikced\" ng-click=\"vm.updateTags()\">עדכון</md-button></form></div></div>\n</div></div></div>");
$templateCache.put("app/main/pages/settings/tabs/terms/terms.html","<div ckeditor=\"vm.options\" ng-model=\"vm.terms.Name\"></div><div layout=\"row\" ng-init=\"vm.getTerms()\"><div \nstyle=\"padding-right: 13px\"><md-button type=\"submit\" ng-disabled=\"!vm.terms.Name || vm.isClicked\" \nclass=\"md-raised md-accent\" ng-click=\"vm.updateTerms()\">עדכון</md-button></div></div>");
$templateCache.put("app/main/pages/settings-menue/views/accountancy-settings/accountancy-settings.html","<div id=\"general-settings\" class=\"page-layout simple tabbed\"><div class=\"header md-accent-bg\" layout=\"column\" \nlayout-align=\"center center\" layout-gt-sm=\"row\" layout-align-gt-sm=\"space-between start\"><div class=\"h1\" layout=\"row\" \nlayout-align=\"start center\"><span class=\"md-display-1 font-weight-300\">הנהלת חשבונות</span></div></div><div \nclass=\"content\"><div class=\"content\"><md-tabs md-dynamic-height md-selected=\"selectedTab\"><md-tab><md-tab-label><span>\nכללי</span></md-tab-label><md-tab-body style=\"background-color: #000000\"><div class=\"about-tab\" \nng-include=\"\'app/main/pages/settings-menue/views/accountancy-settings/tabs/general.html\'\"></div></md-tab-body></md-tab>\n<md-tab><md-tab-label><span>תיקי הכנסות</span></md-tab-label><md-tab-body style=\"background-color: #000000\"><div \nclass=\"about-tab\" ng-include=\"\'app/main/pages/settings-menue/views/accountancy-settings/tabs/accounts.html\'\"></div>\n</md-tab-body></md-tab><md-tab><md-tab-label><span>חשבונות בנק</span></md-tab-label><md-tab-body \nstyle=\"background-color: #000000\"><div class=\"about-tab\" \nng-include=\"\'app/main/pages/settings-menue/views/accountancy-settings/tabs/banks.html\'\"></div></md-tab-body></md-tab>\n</md-tabs></div></div></div>");
$templateCache.put("app/main/pages/settings-menue/views/admin-settings/admin-settings.html","<div id=\"general-settings\" class=\"page-layout simple tabbed\"><div class=\"header md-accent-bg\" layout=\"column\" \nlayout-align=\"center center\" layout-gt-sm=\"row\" layout-align-gt-sm=\"space-between start\"><div class=\"h1\" layout=\"row\" \nlayout-align=\"start center\"><span class=\"md-display-1 font-weight-300\">מערכת ניהול</span></div></div><div \nclass=\"content\"><div class=\"content\"><md-tabs md-dynamic-height md-selected=\"selectedTab\"><md-tab><md-tab-label><span>\nתגיות וסטטוסים</span></md-tab-label><md-tab-body style=\"background-color: #000000\"><div class=\"about-tab\" \nng-include=\"\'app/main/pages/settings-menue/views/admin-settings/tabs/tags.html\'\"></div></md-tab-body></md-tab><md-tab>\n<md-tab-label><span>רכזים</span></md-tab-label><md-tab-body style=\"background-color: #000000\"><div class=\"about-tab\" \nng-include=\"\'app/main/pages/settings-menue/views/admin-settings/tabs/coordinators.html\'\"></div></md-tab-body></md-tab>\n<md-tab><md-tab-label><span>העלאת שכבה</span></md-tab-label><md-tab-body style=\"background-color: #000000\"><div \nclass=\"about-tab\" ng-include=\"\'app/main/pages/settings-menue/views/admin-settings/tabs/upgrade-grade.html\'\"></div>\n</md-tab-body></md-tab></md-tabs></div></div></div>");
$templateCache.put("app/main/pages/settings-menue/views/external-registrations-settings/external-registrations-settings.html","<div id=\"general-settings\" class=\"page-layout simple tabbed\"><div class=\"header md-accent-bg\" layout=\"column\" \nlayout-align=\"center center\" layout-gt-sm=\"row\" layout-align-gt-sm=\"space-between start\"><div class=\"h1\" layout=\"row\" \nlayout-align=\"start center\"><span class=\"md-display-1 font-weight-300\">הרשמות חיצוניות</span></div></div><div \nclass=\"content\"><div class=\"content\"><md-tabs md-dynamic-height md-selected=\"selectedTab\"><md-tab><md-tab-label><span>\nתנאי שימוש</span></md-tab-label><md-tab-body style=\"background-color: #000000\"><div class=\"about-tab\" \nng-include=\"\'app/main/pages/settings-menue/views/external-registrations-settings/tabs/terms.html\'\"></div></md-tab-body>\n</md-tab><md-tab><md-tab-label><span>לינקים</span></md-tab-label><md-tab-body style=\"background-color: #000000\"><div \nclass=\"about-tab\" ng-include=\"\'app/main/pages/settings-menue/views/external-registrations-settings/tabs/links.html\'\">\n</div></md-tab-body></md-tab></md-tabs></div></div></div>");
$templateCache.put("app/main/pages/settings-menue/views/general-settings/general-settings.html","<div id=\"general-settings\" class=\"page-layout simple tabbed\" ng-init=\"vm.getSystemSettings();vm.getAdminImages()\"><div \nclass=\"header md-accent-bg\" layout=\"column\" layout-align=\"center center\" layout-gt-sm=\"row\" \nlayout-align-gt-sm=\"space-between start\"><div class=\"h1\" layout=\"row\" layout-align=\"start center\"><span \nclass=\"md-display-1 font-weight-300\">הגדרות כלליות</span></div></div><div class=\"content\"><div class=\"content\"><md-tabs\n md-dynamic-height md-selected=\"selectedTab\"><md-tab><md-tab-label><span>פרטי הארגון</span></md-tab-label><md-tab-body \nstyle=\"background-color: #000000\"><div class=\"about-tab\" \nng-include=\"\'app/main/pages/settings-menue/views/general-settings/tabs/organization-details.html\'\"></div></md-tab-body>\n</md-tab><md-tab><md-tab-label><span>התאמה אישית</span></md-tab-label><md-tab-body style=\"background-color: #000000\">\n<div class=\"about-tab\" ng-include=\"\'app/main/pages/settings-menue/views/general-settings/tabs/personalized.html\'\">\n</div></md-tab-body></md-tab><md-tab><md-tab-label><span>מילון מונחים</span></md-tab-label><md-tab-body \nstyle=\"background-color: #000000\"><div class=\"about-tab\" \nng-include=\"\'app/main/pages/settings-menue/views/general-settings/tabs/entities.html\'\"></div></md-tab-body></md-tab>\n</md-tabs></div></div></div>");
$templateCache.put("app/main/pages/settings-menue/views/profile-settings/profile-settings.html","<div id=\"general-settings\" class=\"page-layout simple tabbed\"><div class=\"header md-accent-bg\" layout=\"column\" \nlayout-align=\"center center\" layout-gt-sm=\"row\" layout-align-gt-sm=\"space-between start\"><div class=\"h1\" layout=\"row\" \nlayout-align=\"start center\"><span class=\"md-display-1 font-weight-300\">הגדרות פרופיל</span></div></div><div \nclass=\"content\"><div class=\"content\"><md-tabs md-dynamic-height md-selected=\"selectedTab\"><md-tab><md-tab-label><span>\nתנאי שימוש</span></md-tab-label><md-tab-body style=\"background-color: #000000\"><div class=\"about-tab\" \nng-include=\"\'app/main/pages/settings-menue/views/profile-settings/tabs/terms.html\'\"></div></md-tab-body></md-tab>\n<md-tab><md-tab-label><span>טפסים ומיילים</span></md-tab-label><md-tab-body style=\"background-color: #000000\"><div \nclass=\"about-tab\" ng-include=\"\'app/main/pages/settings-menue/views/profile-settings/tabs/forms.html\'\"></div>\n</md-tab-body></md-tab><md-tab><md-tab-label><span>שדות חובה</span></md-tab-label><md-tab-body \nstyle=\"background-color: #000000\"><div class=\"about-tab\" \nng-include=\"\'app/main/pages/settings-menue/views/profile-settings/tabs/fields.html\'\"></div></md-tab-body></md-tab>\n<md-tab><md-tab-label><span>שדות דינמים</span></md-tab-label><md-tab-body style=\"background-color: #000000\"><div \nclass=\"about-tab\" ng-include=\"\'app/main/pages/settings-menue/views/profile-settings/tabs/fields-dy.html\'\"></div>\n</md-tab-body></md-tab><md-tab><md-tab-label><span>מייל יום הולדת</span></md-tab-label><md-tab-body \nstyle=\"background-color: #000000\"><div class=\"about-tab\" \nng-include=\"\'app/main/pages/settings-menue/views/profile-settings/tabs/birthday.html\'\"></div></md-tab-body></md-tab>\n<md-tab><md-tab-label><span>הודעה קופצת בפרופיל</span></md-tab-label><md-tab-body style=\"background-color: #000000\">\n<div class=\"about-tab\" \nng-include=\"\'app/main/pages/settings-menue/views/profile-settings/tabs/profile-popup-alert.html\'\"></div></md-tab-body>\n</md-tab><md-tab ng-if=\"vm.brandIsTeva\"><md-tab-label><span>הודעה קופצת בהרשמה</span></md-tab-label><md-tab-body \nstyle=\"background-color: #000000\"><div class=\"about-tab\" \nng-include=\"\'app/main/pages/settings-menue/views/profile-settings/tabs/externalDiscountPopup.html\'\"></div>\n</md-tab-body></md-tab></md-tabs></div></div></div>");
$templateCache.put("app/main/pages/users/views/parents/parents.html","<div id=\"parents\" class=\"page-layout simple tabbed\" ng-init=\"vm.getTags()\"><div class=\"header md-accent-bg\" \nlayout=\"column\" layout-align=\"center center\" layout-gt-sm=\"row\" layout-align-gt-sm=\"space-between start\"><div \nclass=\"h1\" layout=\"row\" layout-align=\"start center\"><span class=\"md-display-1 font-weight-300\">ניהול הורים</span></div>\n</div><div class=\"content\"><div class=\"action-buttons\"><md-button ng-disabled=\"!vm.parents\" \nng-if=\"$root.AdminLevel>2 || $root.User.EmailPer\" class=\"md-fab md-accent md-icon-button\" id=\"send-emailes-button\" \nng-click=\"vm.openSendEmail()\" aria-label=\"add systemUser\" title=\"שליחת אימיל\"><md-icon md-font-icon=\"icon-at\">\n</md-icon></md-button><md-button ng-disabled=\"!vm.parents\" \nng-if=\"($root.AdminLevel>2 || $root.User.SmsPer) && !$root.User.SmsDisabled\" class=\"md-fab md-accent md-icon-button\" \nid=\"send-SMS-button\" ng-click=\"vm.openSendSMS()\" title=\"שליחת הודעה\" aria-label=\"add systemUser\"><md-icon \nmd-font-icon=\"icon-cellphone-android\"></md-icon></md-button></div><div layout=\"row\" layout-wrap><div layout=\"column\" \nflex=\"100\" flex-gt-sm=\"100\" flex-gt-md=\"80\" flex-gt-lg=\"90\"><form name=\"UserForm\" class=\"md-inline-form\" validate><div \nclass=\"filters\" layout=\"row\" layout-xs=\"column\" flex=\"100\" flex-sm=\"100\" flex-gt-md=\"50\"><div layout=\"column\" \nflex=\"100\" flex-gt-sm=\"50\" flex-md=\"33\" flex-xs=\"100\"><md-input-container class=\"md-block\"><md-icon \nmd-font-icon=\"icon-cash\" class=\"name\"></md-icon><label>דרגת הנחה</label><md-select ng-model=\"vm.search.DiscountLevel\" \nplaceholder=\"דרגת הנחה\" ng-disabled=\"!vm.parents\"><md-option>בחר רמה</md-option><md-option ng-value=\"1\">1</md-option>\n<md-option ng-value=\"2\">2</md-option><md-option ng-value=\"3\">3</md-option><md-option ng-value=\"4\">4</md-option>\n<md-option ng-value=\"5\">5</md-option><md-option ng-value=\"6\">6</md-option></md-select></md-input-container></div><div \nlayout=\"column\" flex=\"100\" flex-gt-sm=\"50\" flex-md=\"33\" flex-xs=\"100\"><md-input-container \nclass=\"md-icon-float md-block\" layout=\"column\" layout-xs=\"row\" flex=\"100\" flex-gt-sm=\"50\" flex-gt-md=\"35\"><md-icon \nmd-svg-icon=\"pound-box\"></md-icon><md-contact-chips ng-disabled=\"vm.isClicked\" ng-model=\"vm.search.Tags\" \nmd-contacts=\"tagsQuerySearch($query)\" md-contact-name=\"Name\" md-require-match=\"true\" md-highlight-flags=\"i\" \nfilter-selected=\"true\" placeholder=\"חיפוש תגית\"></md-contact-chips></md-input-container></div></div><div \nclass=\"filters\" layout=\"row\" layout-xs=\"column\" flex=\"100\" flex-sm=\"100\" flex-gt-md=\"50\"><div layout=\"column\" \nflex=\"100\" flex-gt-sm=\"50\" flex-md=\"33\" flex-xs=\"100\"><md-input-container class=\"md-block\"><md-icon \nmd-font-icon=\"icon-calendar-select\"></md-icon><div start-view=\"day\" locale=\"he\" format=\"DD/MM/YYYY\" \nmoment-picker=\"vm.search.DiscountLevelStartDate\"><label>תאריך התחלה של מתן הדרגה</label><input autocomplete=\"off\" \nng-model=\"vm.search.DiscountLevelStartDate\" ng-disabled=\"!vm.parents\"></div></md-input-container></div><div \nlayout=\"column\" flex=\"100\" flex-gt-sm=\"50\" flex-md=\"33\" flex-xs=\"100\"><md-input-container class=\"md-block\"><md-icon \nmd-font-icon=\"icon-calendar-select\"></md-icon><div start-view=\"day\" locale=\"he\" format=\"DD/MM/YYYY\" \nmoment-picker=\"vm.search.DiscountLevelEndDate\"><label>תאריך סיום של מתן הדרגה</label><input autocomplete=\"off\" \nng-model=\"vm.search.DiscountLevelEndDate\" ng-disabled=\"!vm.parents\"></div></md-input-container></div></div><div \nclass=\"filters\" layout=\"row\" layout-xs=\"column\" flex=\"100\" flex-sm=\"100\" flex-gt-md=\"50\"><div layout=\"column\" \nflex=\"100\" flex-gt-sm=\"50\" flex-md=\"33\" flex-xs=\"100\"><md-input-container id=\"free-search\" \nclass=\"md-icon-float md-block\"><md-icon md-font-icon=\"icon-magnify\"></md-icon><label>חיפוש חופשי</label><input \nng-model=\"vm.search.freeSearchFromDB\" type=\"search\" ng-disabled=\"!vm.parents\"></md-input-container></div></div><div \nclass=\"search-actions row\" layout=\"row\"><md-button type=\"submit\" ng-disabled=\"!vm.parents\" class=\"md-raised md-accent\" \naria-label=\"חפש\" ng-click=\"vm.getParents()\">סינון</md-button></div></form></div></div><div layout=\"row\" \nlayout-sm=\"column\" layout-align=\"space-around\" ng-show=\"!vm.parents\"><md-progress-circular md-mode=\"indeterminate\">\n</md-progress-circular></div><div ng-show=\"vm.parents\" class=\"parents-table-c\"><table id=\"parents-Table\" \nclass=\"dataTable row-border hover\" dt-column-defs=\"vm.dtColumnDefs\" datatable=\"\" dt-instance=\"vm.dtInstance\" \ndt-columns=\"vm.dtColumns\" dt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text\"><div class=\"table-header\">\n<span class=\"column-title\"><input ng-model=\"vm.selectAll\" type=\"checkbox\" ng-change=\"vm.setAll(vm.selectAll)\"></span>\n</div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">תעודה מזהה</span></div></th>\n<th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">תאריך יצירה</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">התחברות אחרונה</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">שם</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">דואר אלקטרוני</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">טלפון</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">סטטוס</span></div></th><th><div \nclass=\"table-header\"><span class=\"column-title\">פעולות</span></div></th></tr></thead><tbody><tr class=\"main-table-new\" \nng-repeat=\"parent in vm.parents\"><td><input type=\"checkbox\" ng-model=\"parent.Selected\"></td><td>{{parent.PrivateID}}\n</td><td><span ng-if=\"parent.CreateTime\">{{parent.CreateTime*1000 | date:\'dd/MM/yyyy\'}}</span></td><td><span \nng-if=\"parent.LastLoginDays\">לפני {{parent.LastLoginDays}} ימים</span> <span \nng-if=\"parent.LastLoginDays===0 || parent.LastLoginDays===\'0\'\">היום</span></td><td>\n{{parent.FirstName}} {{parent.LastName}}</td><td><a href=\"mailto: {{parent.Email}}\">{{parent.Email}}</a></td><td>\n{{parent.MobileNumber}}</td><td>{{parent.Status==1 || parent.Status==\'1\' ? \'פעיל\' : \'לא פעיל\'}}</td><td><md-button \nclass=\"preview-user\" ng-click=\"vm.goToParentsPanel(parent)\" title=\"עריכה מהירה\"><md-icon md-svg-icon=\"pencil\">\n</md-icon></md-button><md-button class=\"preview-user\" href=\"/parent-profile?ID={{parent.ID}}\" title=\"צפיה בפרופיל\">\n<md-icon md-svg-icon=\"settings\"></md-icon></md-button><md-button class=\"preview-user\" \nng-if=\"$root.AdminLevel==3 || $root.User.ParentsLoginPer == 1\" ng-click=\"vm.loginToProfile(parent)\" \ntitle=\"מעבר לפרופיל הורה\"><md-icon md-svg-icon=\"login\"></md-icon></md-button></td></tr></tbody></table></div></div>\n</div>");
$templateCache.put("app/main/pages/users/views/coordinators/coordinators.html","<div id=\"coordinators\" class=\"page-layout simple tabbed\" ng-init=\"getBranches();getRoles()\"><div \nclass=\"header md-accent-bg\" layout=\"column\" layout-align=\"center center\" layout-gt-sm=\"row\" \nlayout-align-gt-sm=\"space-between start\"><div class=\"h1\" layout=\"row\" layout-align=\"start center\"><span \nclass=\"md-display-1 font-weight-300\">ניהול {{$root.User.Coordinators}}</span></div></div><div class=\"content\"><div \nclass=\"action-buttons\"><md-button class=\"md-fab md-accent md-icon-button\" id=\"add-newCoordinator-button\" \nng-click=\"openNewCoordinatDialog()\" ng-disabled=\"!coordinators\" aria-label=\"add systemUser\" \ntitle=\"הוספת {{$root.User.Coordinator}}\"><md-icon md-font-icon=\"icon-plus\"></md-icon></md-button><md-button \nng-disabled=\"isClicked || !coordinators\" ng-if=\"$root.AdminLevel>2 || $root.User.EmailPer\" \nclass=\"md-fab md-accent md-icon-button\" id=\"send-emailes-button\" ng-click=\"openSendEmail()\" \naria-label=\"add systemUser\" title=\"שליחת אימיל\"><md-icon md-font-icon=\"icon-at\"></md-icon></md-button><md-button \nng-disabled=\"isClicked || !coordinators\" ng-if=\"($root.AdminLevel>2 || $root.User.SmsPer) && !$root.User.SmsDisabled\" \nclass=\"md-fab md-accent md-icon-button\" id=\"send-SMS-button\" ng-click=\"openSendSMS()\" title=\"שליחת הודעה\" \naria-label=\"add systemUser\"><md-icon md-font-icon=\"icon-cellphone-android\"></md-icon></md-button><md-button \nng-disabled=\"isClicked\" ng-if=\"$root.AdminLevel>2\" class=\"md-fab md-accent md-icon-button\" \nid=\"resend-invitation-button\" ng-click=\"resendInvitation()\" title=\"שליחת הזמנות חוזרות\" aria-label=\"add systemUser\">\n<md-icon md-font-icon=\"icon-checkbox-multiple-marked\"></md-icon></md-button></div><div layout=\"row\" layout-wrap><div \nlayout=\"column\" flex=\"100\" flex-gt-sm=\"100\" flex-gt-md=\"80\" flex-gt-lg=\"90\"><form name=\"UserForm\" \nclass=\"md-inline-form\" validate><div class=\"filters\" layout=\"row\" layout-xs=\"column\" flex=\"100\" flex-sm=\"100\" \nflex-gt-md=\"50\"><div layout=\"column\" flex=\"100\" flex-gt-sm=\"50\" flex-md=\"33\" flex-xs=\"100\"><md-input-container \nclass=\"md-icon-float md-block\" layout=\"column\" layout-xs=\"row\" flex=\"100\" flex-gt-sm=\"50\" flex-gt-md=\"33\" \ntitle=\"התחל לרשום שם {{$root.User.Branch}}\"><md-icon md-font-icon=\"icon-domain\"></md-icon><label></label>\n<md-contact-chips ng-disabled=\"search.freeSearchFromDB\" ng-model=\"search.branches\" \nmd-contacts=\"branchesQuerySearch($query)\" md-contact-name=\"Name\" md-require-match=\"true\" md-highlight-flags=\"i\" \nfilter-selected=\"true\" placeholder=\"בחר {{$root.User.Branches}}\"></md-contact-chips></md-input-container></div><div \nlayout=\"column\" flex=\"100\" flex-gt-sm=\"50\" flex-md=\"33\" flex-xs=\"100\"><md-input-container \nclass=\"md-icon-float md-block\" layout=\"column\" flex=\"100\" flex-gt-sm=\"50\" flex-gt-md=\"33\"><md-icon \nmd-font-icon=\"icon-filter\"></md-icon><md-select ng-model=\"search.status\" \nplaceholder=\"סינון לפי סטטוס {{$root.User.Coordinators}}\" ng-disabled=\"!coordinators\"><md-option ng-value=\"null\">\nהצג הכל</md-option><md-option ng-value=\"1\" selected=\"selected\">פעילים</md-option><md-option ng-value=\"0\">לא פעילים\n</md-option></md-select></md-input-container></div></div><div class=\"filters\" layout=\"row\" layout-xs=\"column\" \nflex=\"100\" flex-sm=\"100\" flex-gt-md=\"50\"><div layout=\"column\" flex=\"100\" flex-gt-sm=\"50\" flex-md=\"33\" flex-xs=\"100\">\n<md-input-container class=\"md-icon-float md-block\" layout=\"column\" flex=\"100\" flex-gt-sm=\"50\" flex-gt-md=\"33\"><md-icon \nmd-font-icon=\"icon-tie\"></md-icon><md-select ng-model=\"search.role\" placeholder=\"סינון לפי תפקיד\" \nng-disabled=\"!coordinators\"><md-option ng-value=\"null\">הצג הכל</md-option><md-option ng-repeat=\"role in roles\" \nng-value=\"role.Name\">{{role.Name}}</md-option></md-select></md-input-container></div><div layout=\"column\" flex=\"100\" \nflex-gt-sm=\"50\" flex-md=\"33\" flex-xs=\"100\"><md-input-container class=\"md-icon-float md-block\" layout=\"column\" \nflex=\"100\" flex-gt-sm=\"50\" flex-gt-md=\"33\"><md-icon md-font-icon=\"icon-magnify\"></md-icon><label>חיפוש חופשי</label>\n<input id=\"free-search\" ng-model=\"search.freeSearchFromDB\" type=\"search\" ng-disabled=\"!coordinators\">\n</md-input-container></div></div><div class=\"search-actions row\" layout=\"row\"><md-button type=\"submit\" \nng-disabled=\"!coordinators\" class=\"md-raised md-accent\" aria-label=\"חפש\" ng-click=\"getCoordinators()\">סינון</md-button>\n<md-button ng-disabled=\"!coordinators\" class=\"md-raised md-accent\" aria-label=\"חפש\" ng-click=\"getCoordinators(true)\">\nבטל סינון</md-button></div></form></div></div><div layout=\"row\" layout-sm=\"column\" layout-align=\"space-around\" \nng-if=\"!coordinators\"><md-progress-circular md-mode=\"indeterminate\"></md-progress-circular></div><div \nng-if=\"coordinators\" class=\"coordinators-table-c\"><table id=\"coordinators-table\" \nclass=\"dataTable row-border hover stripe md-ink-ripple\" datatable=\"ng\" dt-instance=\"dtInstance\" dt-options=\"dtOptions\">\n<thead><tr><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\"><input ng-model=\"selectAll\" \ntype=\"checkbox\" ng-change=\"setAll(selectAll)\"></span></div></th><th class=\"secondary-text\"><div class=\"table-header\">\n<span class=\"column-title\">שם</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">דואר אלקטרוני</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">{{$root.User.Branches}}</span></div></th><th class=\"secondary-text\"><div class=\"table-header\">\n<span class=\"column-title\">סטטוס</span></div></th><th><div class=\"table-header\"><span class=\"column-title\">פעולות\n</span></div></th></tr></thead><tbody><tr class=\"main-table-new\" \nng-repeat=\"coordinator in coordinators | filter: filterByStatus  | filter: search.freeSearch\"><td><input \ntype=\"checkbox\" ng-model=\"coordinator.Selected\"></td><td>{{coordinator.FirstName}} {{coordinator.LastName}}</td><td>\n{{coordinator.Email}}</td><td><span ng-if=\"coordinator.Branches\" \nng-repeat=\"(branchKey,branchValue) in coordinator.Branches\">{{branchValue.Name}} <span \nng-if=\"brancheKey<coordinator.Branches.length-1\">,</span> </span><span ng-if=\"coordinator.Branches.length==0\">ללא שיבוץ\n</span></td><td>{{coordinator.Status==1 || coordinator.Status==\'1\' ? \'פעיל\' : \'לא פעיל\'}}</td><td><md-button \nclass=\"preview-user\" ng-click=\"openCoordinatPanel(coordinator)\" title=\"עריכה מהירה\"><md-icon md-svg-icon=\"pencil\">\n</md-icon></md-button><md-button class=\"preview-user md-icon-button\" href=\"/coordinator-profile?ID={{coordinator.ID}}\" \ntitle=\"צפייה בפרופיל\"><md-icon md-svg-icon=\"settings\"></md-icon></md-button></td></tr></tbody></table></div></div>\n</div>");
$templateCache.put("app/main/pages/users/views/students/students.html","<div id=\"students\" class=\"page-layout simple tabbed\" ng-init=\"vm.init()\"><div class=\"header md-accent-bg\" \nlayout=\"column\" layout-align=\"center center\" layout-gt-sm=\"row\" layout-align-gt-sm=\"space-between start\"><div \nclass=\"h1\" layout=\"row\" layout-align=\"start center\"><span class=\"md-display-1 font-weight-300\">ניהול חניכים ומדריכים\n</span></div></div><div class=\"content\"><div class=\"action-buttons\"><md-button ng-if=\"$root.AdminLevel>=2\" \nclass=\"md-fab md-accent md-icon-button\" id=\"add-newStudent-button\" ng-click=\"vm.openNewStudentDialog()\" \naria-label=\"add systemUser\" title=\"הוספת חניך חדש\"><md-icon md-font-icon=\"icon-plus\"></md-icon></md-button><md-button \nng-disabled=\"!vm.students || !vm.selectedStudentsCount\" ng-if=\"$root.AdminLevel>2 || $root.User.EmailPer\" \nclass=\"md-fab md-accent md-icon-button\" id=\"send-emails-button\" ng-click=\"vm.openSendEmail()\" \naria-label=\"add systemUser\" title=\"שליחת אימיל\"><md-icon md-font-icon=\"icon-at\"></md-icon></md-button><md-button \nng-disabled=\"!vm.students || !vm.selectedStudentsCount\" \nng-if=\"($root.AdminLevel>2 || $root.User.SmsPer) && !$root.User.SmsDisabled\" class=\"md-fab md-accent md-icon-button\" \nid=\"send-SMS-button\" ng-click=\"vm.openSendSMS()\" title=\"שליחת הודעה\" aria-label=\"add systemUser\"><md-icon \nmd-font-icon=\"icon-cellphone-android\"></md-icon></md-button><md-button \nng-disabled=\"!vm.students || !vm.selectedStudentsCount\" ng-if=\"$root.AdminLevel>2\" \nclass=\"md-fab md-accent md-icon-button\" id=\"change-GroupGrade-button\" ng-click=\"vm.openChangeGroupGrades()\" \ntitle=\"שינוי  {{$root.User.Group}}\\שכבה\" aria-label=\"add systemUser\"><md-icon md-font-icon=\"icon-chair-school\">\n</md-icon></md-button><md-button ng-if=\"$root.AdminLevel>2\" class=\"md-fab md-accent md-icon-button\" \nid=\"upload-students-button\" ng-click=\"vm.openStudentsImportDialog()\" title=\"טעינת חניכים מקובץ\" \naria-label=\"add systemUser\"><md-icon md-font-icon=\"icon-file-excel\"></md-icon></md-button></div><div layout=\"row\" \nlayout-wrap><div layout=\"column\" flex=\"100\" flex-gt-sm=\"100\" flex-gt-md=\"80\" flex-gt-lg=\"90\"><form name=\"UserForm\" \nclass=\"md-inline-form\" validate><div class=\"filters\" layout=\"row\" layout-xs=\"column\" flex=\"100\" flex-sm=\"100\" \nflex-gt-md=\"50\"><div layout=\"column\" flex=\"100\" flex-gt-sm=\"50\" flex-md=\"33\" flex-xs=\"100\"><md-input-container \nclass=\"md-icon-float md-block\" ng-if=\"$root.AdminLevel>1\" title=\"התחל לרשום שם {{$root.User.Branch}}\"><label></label>\n<md-icon md-font-icon=\"icon-domain\"></md-icon><md-contact-chips ng-model=\"vm.search.branches\" \nng-change=\"vm.getGroups()\" md-contacts=\"vm.branchesQuerySearch($query)\" md-contact-name=\"Name\" md-require-match=\"true\" \nmd-highlight-flags=\"i\" filter-selected=\"true\" placeholder=\"בחר {{$root.User.Branches}}\"></md-contact-chips>\n</md-input-container></div><div layout=\"column\" flex=\"100\" flex-gt-sm=\"50\" flex-md=\"33\" flex-xs=\"100\">\n<md-input-container class=\"md-icon-float md-block\"><md-icon md-font-icon=\"icon-filter\"></md-icon><md-select \nng-model=\"vm.search.area\" ng-init=\"search.status=1\" ng-disabled=\"!vm.students\"><md-select-header \nclass=\"demo-select-header\"><input ng-model=\"searchTerm\" type=\"text\" ng-keydown=\"$event.stopPropagation()\" \nplaceholder=\"חיפוש איזור\" class=\"demo-header-searchbox md-text\" autocomplete=\"off\"></md-select-header><md-optgroup>\n<md-option ng-repeat=\"area in vm.area | filter: searchTerm\" ng-value=\"area.ID\">{{area.Name}}</md-option></md-optgroup>\n</md-select></md-input-container></div></div><div class=\"filters\" layout=\"row\" layout-xs=\"column\" flex=\"100\" \nflex-sm=\"100\" flex-gt-md=\"50\"><div layout=\"column\" flex=\"100\" flex-gt-sm=\"50\" flex-md=\"33\" flex-xs=\"100\" \nng-if=\"$root.AdminLevel>1\"><md-input-container class=\"md-icon-float md-block\" layout=\"column\" layout-xs=\"row\" \nflex=\"100\" flex-gt-sm=\"50\" flex-gt-md=\"33\" title=\"התחל לרשום שם שכבה\"><label></label><md-icon \nmd-font-icon=\"icon-chair-school\"></md-icon><md-contact-chips ng-disabled=\"vm.search.freeSearchFromDB\" \nng-model=\"vm.search.grades\" md-contacts=\"vm.gradesQuerySearch($query)\" md-contact-name=\"Name\" md-require-match=\"true\" \nmd-highlight-flags=\"i\" filter-selected=\"true\" placeholder=\"בחר {{$root.User.Grades}}\"></md-contact-chips>\n</md-input-container></div><div layout=\"column\" flex=\"100\" flex-gt-sm=\"50\" flex-md=\"33\" flex-xs=\"100\" \nng-if=\"$root.AdminLevel>1\"><md-input-container class=\"md-icon-float md-block\"><md-icon md-font-icon=\"icon-filter\">\n</md-icon><md-select ng-model=\"vm.search.educator\" placeholder=\"סינון מדריכים\\חניכים\" ng-disabled=\"!vm.students\">\n<md-option ng-value=\"null\">הצג הכל</md-option><md-option ng-value=\"0\">חניכים</md-option><md-option ng-value=\"1\">מדריכים\n</md-option></md-select></md-input-container></div></div><div class=\"filters\" layout=\"row\" layout-xs=\"column\" \nflex=\"100\" flex-sm=\"100\" flex-gt-md=\"50\"><div layout=\"column\" flex=\"100\" flex-gt-sm=\"50\" flex-md=\"33\" flex-xs=\"100\">\n<md-input-container class=\"md-icon-float md-block\"><md-icon md-font-icon=\"icon-filter\"></md-icon><md-select \nng-model=\"vm.search.status\" ng-init=\"vm.search.status=1\" placeholder=\"סינון לפי סטטוס חניך\" ng-disabled=\"!vm.students\">\n<md-option ng-value=\"null\">הצג הכל</md-option><md-option ng-value=\"1\" selected=\"selected\">פעילים</md-option><md-option \nng-value=\"0\">לא פעילים</md-option></md-select></md-input-container></div><div layout=\"column\" flex=\"100\" \nflex-gt-sm=\"50\" flex-md=\"33\" flex-xs=\"100\" ng-show=\"$root.AdminLevel>1\"><md-input-container \nclass=\"md-icon-float md-block\" layout=\"column\" layout-xs=\"row\" flex=\"100\" flex-gt-sm=\"50\" flex-gt-md=\"35\"><md-icon \nmd-svg-icon=\"pound-box\"></md-icon><md-contact-chips ng-disabled=\"isClicked\" ng-model=\"vm.search.tags\" \nmd-contacts=\"vm.tagsQuerySearch($query)\" md-contact-name=\"Name\" md-require-match=\"true\" md-highlight-flags=\"i\" \nfilter-selected=\"true\" placeholder=\"חיפוש תגית\"></md-contact-chips></md-input-container></div></div><div \nclass=\"filters\" layout=\"row\" layout-xs=\"column\" flex=\"100\" flex-sm=\"100\" flex-gt-md=\"50\"><div layout=\"column\" \nflex=\"100\" flex-gt-sm=\"50\" flex-md=\"33\" flex-xs=\"100\"><md-input-container class=\"md-icon-float md-block\"><md-icon \nmd-font-icon=\"icon-account\"></md-icon><md-select ng-model=\"vm.search.type\" placeholder=\"סינון לפי סוג חניך\" \nng-disabled=\"!vm.students\"><md-option ng-value=\"null\">הצג הכל</md-option><md-option ng-value=\"1\">רגיל</md-option>\n<md-option ng-value=\"2\">בוגר</md-option></md-select></md-input-container></div><div layout=\"column\" flex=\"100\" \nflex-gt-sm=\"50\" flex-md=\"33\" flex-xs=\"100\"><md-input-container class=\"md-icon-float md-block\" layout=\"column\" \nlayout-xs=\"row\" flex=\"100\" flex-gt-sm=\"50\" flex-gt-md=\"35\"><md-icon md-svg-icon=\"tie\"></md-icon><md-contact-chips \nng-disabled=\"isClicked\" ng-model=\"vm.search.roles\" md-contacts=\"vm.rolesQuerySearch($query)\" md-contact-name=\"Name\" \nmd-require-match=\"true\" md-highlight-flags=\"i\" filter-selected=\"true\" placeholder=\"חיפוש תפקיד מדריך\">\n</md-contact-chips></md-input-container></div></div><div class=\"filters\" layout=\"row\" layout-xs=\"column\" flex=\"100\" \nflex-sm=\"100\" flex-gt-md=\"50\"><div layout=\"column\" flex=\"100\" flex-gt-sm=\"50\" flex-md=\"33\" flex-xs=\"100\" \nng-if=\"vm.search.educator!==0\"><md-input-container class=\"md-icon-float md-block\"><md-icon md-font-icon=\"icon-account\">\n</md-icon><md-select ng-model=\"vm.search.EducatorStatus\" placeholder=\"סטטוס מדריך\" ng-disabled=\"!vm.students\">\n<md-option ng-value=\"null\">הצג הכל</md-option><md-option ng-value=\"1\">פעיל</md-option><md-option ng-value=\"0\">לא פעיל\n</md-option></md-select></md-input-container></div><div layout=\"column\" flex=\"100\" flex-gt-sm=\"50\" flex-md=\"33\" \nflex-xs=\"100\"><md-input-container id=\"free-search\" class=\"md-icon-float md-block\"><md-icon md-font-icon=\"icon-magnify\">\n</md-icon><label>חיפוש חופשי</label><input ng-model=\"vm.search.freeSearchFromDB\" type=\"search\" \nng-disabled=\"!vm.students\"></md-input-container></div></div><div class=\"search-actions row\" layout=\"row\"><md-button \ntype=\"submit\" ng-disabled=\"isClicked\" class=\"md-raised md-accent\" aria-label=\"חפש\" ng-click=\"vm.getStudents()\">סינון\n</md-button><md-button ng-disabled=\"isClicked\" class=\"md-raised md-accent\" aria-label=\"חפש\" \nng-click=\"vm.getStudents(true)\">בטל סינון</md-button></div></form></div></div><div layout=\"row\" layout-sm=\"column\" \nlayout-align=\"space-around\" ng-if=\"!vm.students\"><md-progress-circular md-mode=\"indeterminate\"></md-progress-circular>\n</div><div class=\"students-table-c\" ng-show=\"vm.students\"><table id=\"students-Table\" \nclass=\"dataTable row-border hover\" datatable=\"\" dt-instance=\"vm.dtInstance\" dt-options=\"vm.dtOptions\"><thead><tr><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\"><input ng-model=\"vm.selectAll\" \ntype=\"checkbox\" ng-change=\"vm.setAll(vm.selectAll)\"></span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">תעודות זהות</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">שם</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">מין</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">דואר אלקטרוני</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">{{$root.User.Group}}</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">{{$root.User.Grade}}</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">{{$root.User.Branch}}</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">מדריך</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">סוג חניך</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">סטטוס</span></div></th><th><div class=\"table-header\"><span \nclass=\"column-title\">פעולות</span></div></th></tr></thead><tbody><tr class=\"md-ink-ripple\" \nng-repeat=\"student in vm.students\"><td><input type=\"checkbox\" ng-model=\"student.Selected\" \nng-click=\"vm.studentToggled(student)\"></td><td>{{student.PrivateID}}</td><td>{{student.FirstName}} {{student.LastName}}\n</td><td><span ng-if=\"student.Gender==\'Male\'\">בן</span> <span ng-if=\"student.Gender==\'Female\'\">בת</span> <span \nng-if=\"student.Gender==\'Other\'\">אחר</span> <span ng-if=\"student.Gender==null || student.Gender.length == 0\"></span>\n</td><td><a href=\"mailto: {{student.Email}}\">{{student.Email}}</a></td><td>{{student.GroupName}}</td><td>\n{{student.GradeName}}</td><td>{{student.BranchName}}</td><td>{{student.EducatorID ? \'כן\' : \'לא\'}}</td><td>\n{{student.Type==2 ? \'בוגר\' : \'רגיל\'}}</td><td>{{student.Status==1 || student.Status==\'1\' ? \'פעיל\' : \'לא פעיל\'}}</td>\n<td><md-button class=\"preview-user md-icon-button\" ng-click=\"vm.openStudentPanel(student)\" title=\"עריכה\"><md-icon \nmd-svg-icon=\"pencil\"></md-icon></md-button><md-button class=\"preview-user md-icon-button\" \nhref=\"/student-profile?ID={{student.ID}}\" title=\"צפייה בפרופיל\"><md-icon md-svg-icon=\"settings\"></md-icon></md-button>\n</td></tr></tbody></table></div></div></div>");
$templateCache.put("app/main/ui/forms/stepper-steps/horizontal/step-1.html","<div class=\"md-inline-form\"><p>Fill the <span class=\"text-bold\">Lastname</span> field to reveal the conditional step!\n</p><div layout=\"column\" layout-gt-xs=\"row\" flex><md-input-container flex=\"100\" flex-gt-xs=\"50\"><input type=\"text\" \nname=\"firstname\" ng-model=\"vm.horizontalStepper.step1.firstname\" placeholder=\"Firstname\" required><div \nng-messages=\"horizontalStep1.firstname.$error\" ng-show=\"horizontalStep1.firstname.$touched\" role=\"alert\"><div \nng-message=\"required\"><span>Firstname field is required.</span></div></div></md-input-container><md-input-container \nflex=\"100\" flex-gt-xs=\"50\"><input type=\"text\" name=\"lastname\" ng-model=\"vm.horizontalStepper.step1.lastname\" \nplaceholder=\"Lastname\"><div ng-messages=\"horizontalStep1.lastname.$error\" ng-show=\"horizontalStep1.lastname.$touched\" \nrole=\"alert\"><div ng-message=\"required\"><span>Lastname field is required.</span></div></div></md-input-container></div>\n</div>");
$templateCache.put("app/main/ui/forms/stepper-steps/horizontal/step-2.html","<div class=\"md-inline-form\"><p>Fill the <span class=\"text-bold\">Birthplace</span>\n field to reveal another conditional step! Conditional step-ception!</p><div layout=\"column\" layout-gt-xs=\"row\" flex>\n<md-input-container flex=\"100\" flex-gt-xs=\"50\"><input type=\"text\" name=\"birthplace\" \nng-model=\"vm.horizontalStepper.step2.birthplace\" placeholder=\"Birthplace\"></md-input-container></div></div>");
$templateCache.put("app/main/ui/forms/stepper-steps/horizontal/step-3.html","<div class=\"md-inline-form\"><div layout=\"column\" layout-gt-xs=\"row\" flex><md-input-container flex=\"100\" \nflex-gt-xs=\"50\"><input type=\"text\" name=\"ssn\" ng-model=\"vm.horizontalStepper.step3.ssn\" \nplaceholder=\"Social Security Number\"></md-input-container></div></div>");
$templateCache.put("app/main/ui/forms/stepper-steps/horizontal/step-4.html","<div class=\"md-inline-form\"><div layout=\"column\" layout-gt-xs=\"row\" flex><md-input-container flex=\"100\"><label>Address\n</label><textarea ng-model=\"vm.horizontalStepper.step4.address\" md-maxlength=\"150\" max-rows=\"5\"></textarea><div \nng-messages=\"horizontalStep4.address.$error\" ng-show=\"horizontalStep4.address.$touched\" role=\"alert\"></div>\n</md-input-container></div></div>");
$templateCache.put("app/main/ui/forms/stepper-steps/horizontal/step-5.html","<div class=\"md-inline-form\"><md-input-container class=\"md-block\"><input type=\"text\" name=\"cardholder\" \nng-model=\"vm.horizontalStepper.step5.cardholder\" placeholder=\"Card Holder\" required><div \nng-messages=\"horizontalStep5.cardholder.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nCard holder field is required.</span></div></div></md-input-container><div layout=\"column\" layout-gt-xs=\"row\">\n<md-input-container flex=\"100\" flex-gt-xs=\"33\"><input type=\"text\" name=\"cardnumber\" \nng-model=\"vm.horizontalStepper.step5.cardnumber\" placeholder=\"Card Number\" required><div \nng-messages=\"horizontalStep5.cardnumber.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nCard number field is required.</span></div></div></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"33\">\n<input type=\"text\" name=\"CC2\" ng-model=\"vm.horizontalStepper.step5.cc2\" placeholder=\"CC2\" md-maxlength=\"3\" required>\n<div ng-messages=\"horizontalStep5.cc2.$error\" role=\"alert\" multipl><div ng-message=\"required\"><span>\nCC2 field is required.</span></div><div ng-message=\"md-maxlength\"><span>CC2 can\'t be longer than 3 characters.</span>\n</div></div></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"33\"><input type=\"text\" \nname=\"expirationDate\" ng-model=\"vm.horizontalStepper.step5.expirationDate\" placeholder=\"Expiration Date\" required><div \nng-messages=\"horizontalStep5.expirationDate.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nExpiration date field is required.</span></div></div></md-input-container></div></div>");
$templateCache.put("app/main/ui/forms/stepper-steps/vertical/step-1.html","<div class=\"md-inline-form\"><p>Fill the <span class=\"text-bold\">Lastname</span> field to reveal the conditional step!\n</p><div layout=\"column\" layout-gt-xs=\"row\" flex><md-input-container flex=\"100\" flex-gt-xs=\"50\"><input type=\"text\" \nname=\"firstname\" ng-model=\"vm.verticalStepper.step1.firstname\" placeholder=\"Firstname\" required><div \nng-messages=\"verticalStep1.firstname.$error\" ng-show=\"verticalStep1.firstname.$touched\" role=\"alert\"><div \nng-message=\"required\"><span>Firstname field is required.</span></div></div></md-input-container><md-input-container \nflex=\"100\" flex-gt-xs=\"50\"><input type=\"text\" name=\"lastname\" ng-model=\"vm.verticalStepper.step1.lastname\" \nplaceholder=\"Lastname\"><div ng-messages=\"verticalStep1.lastname.$error\" ng-show=\"verticalStep1.lastname.$touched\" \nrole=\"alert\"><div ng-message=\"required\"><span>Lastname field is required.</span></div></div></md-input-container></div>\n</div>");
$templateCache.put("app/main/ui/forms/stepper-steps/vertical/step-2.html","<div class=\"md-inline-form\"><p>Fill the <span class=\"text-bold\">Birthplace</span>\n field to reveal another conditional step! Conditional step-ception!</p><div layout=\"column\" layout-gt-xs=\"row\" flex>\n<md-input-container flex=\"100\" flex-gt-xs=\"50\"><input type=\"text\" name=\"birthplace\" \nng-model=\"vm.verticalStepper.step2.birthplace\" placeholder=\"Birthplace\"></md-input-container></div></div>");
$templateCache.put("app/main/ui/forms/stepper-steps/vertical/step-3.html","<div class=\"md-inline-form\"><div layout=\"column\" layout-gt-xs=\"row\" flex><md-input-container flex=\"100\" \nflex-gt-xs=\"50\"><input type=\"text\" name=\"ssn\" ng-model=\"vm.verticalStepper.step3.ssn\" \nplaceholder=\"Social Security Number\"></md-input-container></div></div>");
$templateCache.put("app/main/ui/forms/stepper-steps/vertical/step-4.html","<div class=\"md-inline-form\"><div layout=\"column\" layout-gt-xs=\"row\" flex><md-input-container flex=\"100\"><label>Address\n</label><textarea ng-model=\"vm.verticalStepper.step4.address\" md-maxlength=\"150\" max-rows=\"5\"></textarea><div \nng-messages=\"verticalStep4.address.$error\" ng-show=\"verticalStep4.address.$touched\" role=\"alert\"></div>\n</md-input-container></div></div>");
$templateCache.put("app/main/ui/forms/stepper-steps/vertical/step-5.html","<div class=\"md-inline-form\"><md-input-container class=\"md-block\"><input type=\"text\" name=\"cardholder\" \nng-model=\"vm.verticalStepper.step5.cardholder\" placeholder=\"Card Holder\" required><div \nng-messages=\"step5.cardholder.$error\" role=\"alert\"><div ng-message=\"required\"><span>Card holder field is required.\n</span></div></div></md-input-container><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex=\"100\" \nflex-gt-xs=\"33\"><input type=\"text\" name=\"cardnumber\" ng-model=\"vm.verticalStepper.step5.cardnumber\" \nplaceholder=\"Card Number\" required><div ng-messages=\"verticalStep5.cardnumber.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Card number field is required.</span></div></div></md-input-container><md-input-container \nflex=\"100\" flex-gt-xs=\"33\"><input type=\"text\" name=\"CC2\" ng-model=\"vm.verticalStepper.step5.cc2\" placeholder=\"CC2\" \nmd-maxlength=\"3\" required><div ng-messages=\"verticalStep5.cc2.$error\" role=\"alert\" multipl><div ng-message=\"required\">\n<span>CC2 field is required.</span></div><div ng-message=\"md-maxlength\"><span>CC2 can\'t be longer than 3 characters.\n</span></div></div></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"33\"><input type=\"text\" \nname=\"expirationDate\" ng-model=\"vm.verticalStepper.step5.expirationDate\" placeholder=\"Expiration Date\" required><div \nng-messages=\"verticalStep5.expirationDate.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nExpiration date field is required.</span></div></div></md-input-container></div></div>");
$templateCache.put("app/main/ui/page-layouts/carded/fullwidth/fullwidth.html","<div class=\"page-layout carded fullwidth\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div><div class=\"center\" \nlayout=\"column\" flex><div class=\"header\"><span class=\"h2 white-fg\">Fullwidth with independent scroll</span></div><div \nclass=\"content-card\" layout=\"column\" flex><div class=\"toolbar\" layout=\"row\" layout-align=\"start center\"><span>\nContent toolbar</span></div><md-content class=\"content\" flex ms-scroll><div \nng-include=\"\'app/main/ui/page-layouts/demo/demo-content.html\'\"></div></md-content></div></div></div>");
$templateCache.put("app/main/ui/page-layouts/carded/left-sidenav/left-sidenav.html","<div class=\"page-layout carded left-sidenav\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div><md-sidenav \nclass=\"sidenav\" md-is-locked-open=\"$mdMedia(\'gt-md\')\" md-component-id=\"sidenav\" ms-scroll ms-sidenav-helper><div \nclass=\"header\"><p>Sidenav header</p></div><md-content class=\"content\" flex ms-scroll><div \nng-include=\"\'app/main/ui/page-layouts/demo/demo-sidenav.html\'\"></div></md-content></md-sidenav><div class=\"center\" \nlayout=\"column\" flex><div class=\"header\" layout=\"row\"><div><span class=\"h2 white-fg\">\nLeft sidenav with independent scroll</span></div></div><div class=\"content-card\" layout=\"column\" flex><div \nclass=\"toolbar\" layout=\"row\" layout-align=\"start center\"><md-button class=\"md-icon-button sidenav-toggle\" \nng-click=\"vm.toggleSidenav(\'sidenav\')\" hide-gt-md aria-label=\"Toggle left sidenav\"><md-icon md-font-icon=\"icon-menu\" \nclass=\"icon\"></md-icon></md-button><p>Content toolbar</p></div><md-content class=\"content\" flex ms-scroll><div \nng-include=\"\'app/main/ui/page-layouts/demo/demo-content.html\'\"></div></md-content></div></div></div>");
$templateCache.put("app/main/ui/page-layouts/carded/fullwidth-ii/fullwidth-ii.html","<div class=\"page-layout carded fullwidth single-scroll\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div><div \nclass=\"center\" flex><div class=\"header\"><span class=\"h2 white-fg\">Fullwidth with page scroll</span></div><div \nclass=\"content-card\"><div class=\"toolbar\" layout=\"row\" layout-align=\"start center\"><span>Content toolbar</span></div>\n<md-content class=\"content\" ms-scroll><div ng-include=\"\'app/main/ui/page-layouts/demo/demo-content.html\'\"></div>\n</md-content></div></div></div>");
$templateCache.put("app/main/ui/page-layouts/carded/left-sidenav-ii/left-sidenav-ii.html","<div class=\"page-layout carded left-sidenav single-scroll\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div>\n<md-sidenav class=\"sidenav\" md-is-locked-open=\"$mdMedia(\'gt-md\')\" md-component-id=\"sidenav\" ms-scroll \nms-sidenav-helper><div class=\"header\"><p>Sidenav header</p></div><md-content class=\"content\" ms-scroll><div \nng-include=\"\'app/main/ui/page-layouts/demo/demo-sidenav.html\'\"></div></md-content></md-sidenav><div class=\"center\" \nflex><div class=\"header\" layout=\"row\"><div><span class=\"h2 white-fg\">Left sidenav with page scroll</span></div></div>\n<div class=\"content-card\"><div class=\"toolbar\" layout=\"row\" layout-align=\"start center\"><md-button \nclass=\"md-icon-button sidenav-toggle\" ng-click=\"vm.toggleSidenav(\'sidenav\')\" hide-gt-md \naria-label=\"Toggle left sidenav\"><md-icon md-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button><p>\nContent toolbar</p></div><md-content class=\"content\" ms-scroll><div \nng-include=\"\'app/main/ui/page-layouts/demo/demo-content.html\'\"></div></md-content></div></div></div>");
$templateCache.put("app/main/ui/page-layouts/carded/right-sidenav/right-sidenav.html","<div class=\"page-layout carded right-sidenav\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div><div class=\"center\" \nlayout=\"column\" flex><div class=\"header\" layout=\"row\"><div><span class=\"h2 white-fg\">\nRight sidenav with independent scroll</span></div></div><div class=\"content-card\" layout=\"column\" flex><div \nclass=\"toolbar\" layout=\"row\" layout-align=\"space-between center\"><p>Content toolbar</p><md-button \nclass=\"md-icon-button sidenav-toggle\" ng-click=\"vm.toggleSidenav(\'sidenav\')\" hide-gt-md aria-label=\"Toggle right pane\">\n<md-icon md-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button></div><md-content class=\"content\" flex ms-scroll>\n<div ng-include=\"\'app/main/ui/page-layouts/demo/demo-content.html\'\"></div></md-content></div></div><md-sidenav \nclass=\"sidenav md-sidenav-right\" md-is-locked-open=\"$mdMedia(\'gt-md\')\" md-component-id=\"sidenav\" ms-scroll \nms-sidenav-helper><div class=\"header\"><p>Sidenav header</p></div><md-content class=\"content\" ms-scroll flex><div \nng-include=\"\'app/main/ui/page-layouts/demo/demo-sidenav.html\'\"></div></md-content></md-sidenav></div>");
$templateCache.put("app/main/ui/page-layouts/carded/right-sidenav-ii/right-sidenav-ii.html","<div class=\"page-layout carded right-sidenav single-scroll\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div><div \nclass=\"center\" flex><div class=\"header\" layout=\"row\"><div><span class=\"h2 white-fg\">Right sidenav with page scroll\n</span></div></div><div class=\"content-card\"><div class=\"toolbar\" layout=\"row\" layout-align=\"space-between center\"><p>\nContent toolbar</p><md-button class=\"md-icon-button sidenav-toggle\" ng-click=\"vm.toggleSidenav(\'sidenav\')\" hide-gt-md \naria-label=\"Toggle right pane\"><md-icon md-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button></div><md-content \nclass=\"content\" ms-scroll><div ng-include=\"\'app/main/ui/page-layouts/demo/demo-content.html\'\"></div></md-content></div>\n</div><md-sidenav class=\"sidenav md-sidenav-right\" md-is-locked-open=\"$mdMedia(\'gt-md\')\" md-component-id=\"sidenav\" \nms-scroll ms-sidenav-helper><div class=\"header\"><p>Sidenav header</p></div><md-content class=\"content\" ms-scroll><div \nng-include=\"\'app/main/ui/page-layouts/demo/demo-sidenav.html\'\"></div></md-content></md-sidenav></div>");
$templateCache.put("app/main/ui/page-layouts/simple/left-sidenav/left-sidenav.html","<div class=\"page-layout simple left-sidenav\" layout=\"row\"><md-sidenav class=\"sidenav\" \nmd-is-locked-open=\"$mdMedia(\'gt-md\')\" md-component-id=\"sidenav\" ms-scroll ms-sidenav-helper><div \nng-include=\"\'app/main/ui/page-layouts/demo/demo-sidenav.html\'\"></div></md-sidenav><div class=\"center\" flex ms-scroll>\n<div class=\"header md-accent-bg\" layout=\"row\"><md-button class=\"md-icon-button sidenav-toggle\" \nng-click=\"vm.toggleSidenav(\'sidenav\')\" hide-gt-md aria-label=\"Toggle sidenav\"><md-icon md-font-icon=\"icon-menu\" \nclass=\"icon\"></md-icon></md-button><div><span class=\"h2\">Left sidenav with independent scroll</span></div></div><div \nclass=\"content md-background-bg\"><div ng-include=\"\'app/main/ui/page-layouts/demo/demo-content.html\'\"></div></div></div>\n</div>");
$templateCache.put("app/main/ui/page-layouts/simple/fullwidth/fullwidth.html","<div class=\"page-layout simple fullwidth\"><div class=\"header md-accent-bg\"><span class=\"h2\">Fullwidth</span></div><div \nclass=\"content md-background-bg\"><div ng-include=\"\'app/main/ui/page-layouts/demo/demo-content.html\'\"></div></div></div>");
$templateCache.put("app/main/ui/page-layouts/simple/right-sidenav/right-sidenav.html","<div class=\"page-layout simple right-sidenav\" layout=\"row\"><div class=\"center\" flex ms-scroll><div \nclass=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between\"><div><span class=\"h2\">\nRight sidenav with independent scroll</span></div><md-button class=\"md-icon-button sidenav-toggle\" \nng-click=\"vm.toggleSidenav(\'sidenav\')\" hide-gt-md aria-label=\"Toggle sidenav\"><md-icon md-font-icon=\"icon-menu\" \nclass=\"icon\"></md-icon></md-button></div><div class=\"content md-background-bg\"><div \nng-include=\"\'app/main/ui/page-layouts/demo/demo-content.html\'\"></div></div></div><md-sidenav \nclass=\"sidenav md-sidenav-right\" md-is-locked-open=\"$mdMedia(\'gt-md\')\" md-component-id=\"sidenav\" ms-scroll \nms-sidenav-helper><div ng-include=\"\'app/main/ui/page-layouts/demo/demo-sidenav.html\'\"></div></md-sidenav></div>");
$templateCache.put("app/main/ui/page-layouts/simple/left-sidenav-ii/left-sidenav-ii.html","<div class=\"page-layout simple left-sidenav single-scroll\" layout=\"row\"><md-sidenav class=\"sidenav\" \nmd-is-locked-open=\"$mdMedia(\'gt-md\')\" md-component-id=\"sidenav\" ms-scroll ms-sidenav-helper><div \nng-include=\"\'app/main/ui/page-layouts/demo/demo-sidenav.html\'\"></div></md-sidenav><div class=\"center\" flex ms-scroll>\n<div class=\"header md-accent-bg\" layout=\"row\"><md-button class=\"md-icon-button sidenav-toggle\" \nng-click=\"vm.toggleSidenav(\'sidenav\')\" hide-gt-md aria-label=\"Toggle sidenav\"><md-icon md-font-icon=\"icon-menu\" \nclass=\"icon\"></md-icon></md-button><div><span class=\"h2\">Left sidenav with page scroll</span></div></div><div \nclass=\"content md-background-bg\"><div ng-include=\"\'app/main/ui/page-layouts/demo/demo-content.html\'\"></div></div></div>\n</div>");
$templateCache.put("app/main/ui/page-layouts/simple/left-sidenav-iii/left-sidenav-iii.html","<div class=\"page-layout simple left-sidenav inner-sidenav\"><div class=\"header md-accent-bg\"><md-button \nclass=\"md-icon-button sidenav-toggle\" ng-click=\"vm.toggleSidenav(\'sidenav\')\" hide-gt-md aria-label=\"Toggle sidenav\">\n<md-icon md-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button><span class=\"h2\">Inner Left Sidenav</span></div>\n<div class=\"content\" md-background-bg layout=\"row\" ms-scroll><md-sidenav class=\"sidenav\" \nmd-is-locked-open=\"$mdMedia(\'gt-md\')\" md-component-id=\"sidenav\" ms-scroll ms-sidenav-helper><div class=\"header\"><p>\nSidenav header</p></div><md-content class=\"content\"><div \nng-include=\"\'app/main/ui/page-layouts/demo/demo-sidenav.html\'\"></div></md-content></md-sidenav><div flex \nng-include=\"\'app/main/ui/page-layouts/demo/demo-content.html\'\"></div></div></div>");
$templateCache.put("app/main/ui/page-layouts/simple/right-sidenav-ii/right-sidenav-ii.html","<div class=\"page-layout simple right-sidenav single-scroll\" layout=\"row\"><div class=\"center\" flex ms-scroll><div \nclass=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between\"><div><span class=\"h2\">\nRight sidenav with page scroll</span></div><md-button class=\"md-icon-button sidenav-toggle\" \nng-click=\"vm.toggleSidenav(\'sidenav\')\" hide-gt-md aria-label=\"Toggle sidenav\"><md-icon md-font-icon=\"icon-menu\" \nclass=\"icon\"></md-icon></md-button></div><div class=\"content md-background-bg\"><div \nng-include=\"\'app/main/ui/page-layouts/demo/demo-content.html\'\"></div></div></div><md-sidenav \nclass=\"sidenav md-sidenav-right\" md-is-locked-open=\"$mdMedia(\'gt-md\')\" md-component-id=\"sidenav\" ms-scroll \nms-sidenav-helper><div ng-include=\"\'app/main/ui/page-layouts/demo/demo-sidenav.html\'\"></div></md-sidenav></div>");
$templateCache.put("app/main/ui/page-layouts/simple/right-sidenav-iii/right-sidenav-iii.html","<div class=\"page-layout simple right-sidenav inner-sidenav\"><div class=\"header md-accent-bg\"><md-button \nclass=\"md-icon-button sidenav-toggle\" ng-click=\"vm.toggleSidenav(\'sidenav\')\" hide-gt-md aria-label=\"Toggle sidenav\">\n<md-icon md-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button><span class=\"h2\">Inner Right Sidenav</span></div>\n<div class=\"content\" md-background-bg layout=\"row\" ms-scroll><div flex \nng-include=\"\'app/main/ui/page-layouts/demo/demo-content.html\'\"></div><md-sidenav class=\"sidenav md-sidenav-right\" \nmd-is-locked-open=\"$mdMedia(\'gt-md\')\" md-component-id=\"sidenav\" ms-scroll ms-sidenav-helper><div class=\"header\"><p>\nSidenav header</p></div><md-content class=\"content\"><div \nng-include=\"\'app/main/ui/page-layouts/demo/demo-sidenav.html\'\"></div></md-content></md-sidenav></div></div>");
$templateCache.put("app/main/ui/page-layouts/simple/tabbed/tabbed.html","<div class=\"page-layout simple tabbed\" layout=\"column\"><div class=\"header md-accent-bg\"><span class=\"h2\">Tabbed</span>\n</div><div class=\"content\"><md-tabs md-dynamic-height><md-tab label=\"Tab 1\"><div \nng-include=\"\'app/main/ui/page-layouts/demo/demo-content.html\'\"></div></md-tab><md-tab label=\"Tab 2\"><div \nng-include=\"\'app/main/ui/page-layouts/demo/demo-content.html\'\"></div></md-tab><md-tab label=\"Tab 3\"><div \nng-include=\"\'app/main/ui/page-layouts/demo/demo-content.html\'\"></div></md-tab></md-tabs></div></div>");
$templateCache.put("app/main/ui/theme-colors/dialogs/custom-theme/custom-theme-dialog.html","<md-dialog class=\"custom-theme-dialog\" aria-label=\"Custom Theme\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>\nCustom Theme Generator</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\"><md-icon \nmd-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content><div \nlayout=\"row\" ng-repeat=\"type in [\'primary\', \'accent\', \'warn\', \'background\']\"><h3 class=\"type\">{{type}}</h3>\n<md-input-container><label>Palette</label><md-select ng-model=\"vm.theme[type].name\" \nng-style=\"{\'background-color\': vm.rgba(vm.palettes[vm.theme[type].name][\'500\'].value), \'color\': vm.rgba(vm.palettes[vm.theme[type].name][\'500\'].contrast, 1)}\">\n<md-option ng-value=\"palette\" ng-repeat=\"(palette, hues) in vm.palettes\" \nng-style=\"{\'background-color\': vm.rgba(hues[\'500\'].value), \'color\': vm.rgba(hues[\'500\'].contrast, 1)}\">{{palette}}\n</md-option></md-select></md-input-container><div layout=\"row\" \nng-repeat=\"hueType in [\'default\', \'hue-1\', \'hue-2\', \'hue-3\']\"><md-input-container><label>{{hueType}}</label><md-select \nng-model=\"vm.theme[type].hues[hueType]\" \nng-style=\"{\'background-color\': vm.rgba(vm.palettes[vm.theme[type].name][vm.theme[type].hues[hueType]].value), \'color\': vm.rgba(vm.palettes[vm.theme[type].name][vm.theme[type].hues[hueType]].contrast, 1)}\">\n<md-option ng-value=\"hue\" ng-repeat=\"(hue, opt) in vm.palettes[vm.theme[type].name]\" \nng-style=\"{\'background-color\': vm.rgba(opt.value), \'color\': vm.rgba(opt.contrast, 1)}\">{{hue}}</md-option></md-select>\n</md-input-container></div></div><md-divider></md-divider><div layout=\"row\"><p>\nTo make this theme permanent, copy the below code and add it into the \"marvilixThemes\" object in \"core/theming/marvilix-themes.constant.js\" file. You can also replace the \"CUSTOM_THEME_NAME\" with your theme name.\n</p></div><div layout=\"row\"><textarea readonly=\"readonly\" class=\"theme-object\">\"CUSTOM_THEME_NAME\" : {{vm.theme}}\n</textarea></div></md-dialog-content><md-dialog-actions layout=\"row\"><span flex></span><md-button \nclass=\"md-raised md-accent\" ng-click=\"vm.setTheme()\">Set Theme</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/ui/theme-colors/tabs/accent/accent.html","<div class=\"color\" layout=\"row\" layout-wrap layout-align=\"center center\"><div class=\"md-accent-bg\" flex=\"100\" \nlayout=\"row\" layout-padding><div flex>Default</div><div flex>{{vm.themes.active.theme.accent.color}}</div><div flex>\n.md-accent-bg</div></div><div class=\"md-accent-bg\" flex=\"100\" layout=\"row\" layout-padding><div flex>Primary Text</div>\n<div flex>{{vm.themes.active.theme.accent.contrast1}}</div><div flex>.md-accent-bg</div></div><div \nclass=\"md-accent-bg\" flex=\"100\" class=\"secondary-text\" layout=\"row\" layout-padding><div class=\"secondary-text\" flex>\nSecondary Text / Icon</div><div class=\"secondary-text\" flex>{{vm.themes.active.theme.accent.contrast2}}</div><div \nclass=\"secondary-text\" flex>.md-accent-bg .secondary-text</div></div><div class=\"md-accent-bg\" flex=\"100\" \nclass=\"hint-text\" layout=\"row\" layout-padding><div class=\"hint-text\" flex>Hint Text / Disabled Text</div><div \nclass=\"hint-text\" flex>{{vm.themes.active.theme.accent.contrast3}}</div><div class=\"hint-text\" flex>\n.md-accent-bg .hint-text</div></div><div class=\"md-accent-bg\" flex=\"100\" class=\"divider\" layout=\"row\" layout-padding>\n<div class=\"fade-text\" flex>Fade Text / Divider</div><div class=\"fade-text\" flex>\n{{vm.themes.active.theme.accent.contrast4}}</div><div class=\"fade-text\" flex>.md-accent-bg .divider</div></div><div \nflex=\"100\" class=\"md-accent-fg\" layout=\"row\" layout-padding><div flex>As foreground color</div><div flex>\n{{vm.themes.active.theme.accent.color}}</div><div flex>.md-accent-fg</div></div></div><div class=\"color\" layout=\"row\" \nlayout-wrap layout-align=\"center center\"><div class=\"md-accent-bg md-hue-1\" flex=\"100\" layout=\"row\" layout-padding><div\n flex>Hue 1</div><div flex>{{vm.themes.active.theme.accent.hue1.color}}</div><div flex>.md-accent-bg .md-hue-1</div>\n</div><div class=\"md-accent-bg md-hue-1\" flex=\"100\" layout=\"row\" layout-padding><div flex>Primary Text</div><div flex>\n{{vm.themes.active.theme.accent.hue1.contrast1}}</div><div flex>.md-accent-bg</div></div><div \nclass=\"md-accent-bg md-hue-1\" flex=\"100\" class=\"secondary-text\" layout=\"row\" layout-padding><div \nclass=\"secondary-text\" flex>Secondary Text / Icon</div><div class=\"secondary-text\" flex>\n{{vm.themes.active.theme.accent.hue1.contrast2}}</div><div class=\"secondary-text\" flex>\n.md-accent-bg .md-hue-1 .secondary-text</div></div><div class=\"md-accent-bg md-hue-1\" flex=\"100\" class=\"hint-text\" \nlayout=\"row\" layout-padding><div class=\"hint-text\" flex>Hint Text / Disabled Text</div><div class=\"hint-text\" flex>\n{{vm.themes.active.theme.accent.hue1.contrast3}}</div><div class=\"hint-text\" flex>.md-accent-bg .md-hue-1 .hint-text\n</div></div><div class=\"md-accent-bg md-hue-1\" flex=\"100\" class=\"divider\" layout=\"row\" layout-padding><div \nclass=\"fade-text\" flex>Fade Text / Divider</div><div class=\"fade-text\" flex>\n{{vm.themes.active.theme.accent.hue1.contrast4}}</div><div class=\"fade-text\" flex>.md-accent-bg .md-hue-1 .divider\n</div></div><div flex=\"100\" class=\"md-accent-fg md-hue-1\" layout=\"row\" layout-padding><div flex>As foreground color\n</div><div flex>{{vm.themes.active.theme.accent.hue1.color}}</div><div flex>.md-accent-fg</div></div></div><div \nclass=\"color\" layout=\"row\" layout-wrap layout-align=\"center center\"><div class=\"md-accent-bg md-hue-2\" flex=\"100\" \nlayout=\"row\" layout-padding><div flex>Hue 2</div><div flex>{{vm.themes.active.theme.accent.hue2.color}}</div><div flex>\n.md-accent-bg .md-hue-2</div></div><div class=\"md-accent-bg md-hue-2\" flex=\"100\" layout=\"row\" layout-padding><div flex>\nPrimary Text</div><div flex>{{vm.themes.active.theme.accent.hue2.contrast1}}</div><div flex>.md-accent-bg</div></div>\n<div class=\"md-accent-bg md-hue-2\" flex=\"100\" class=\"secondary-text\" layout=\"row\" layout-padding><div \nclass=\"secondary-text\" flex>Secondary Text / Icon</div><div class=\"secondary-text\" flex>\n{{vm.themes.active.theme.accent.hue2.contrast2}}</div><div class=\"secondary-text\" flex>\n.md-accent-bg .md-hue-2 .secondary-text</div></div><div class=\"md-accent-bg md-hue-2\" flex=\"100\" class=\"hint-text\" \nlayout=\"row\" layout-padding><div class=\"hint-text\" flex>Hint Text / Disabled Text</div><div class=\"hint-text\" flex>\n{{vm.themes.active.theme.accent.hue2.contrast3}}</div><div class=\"hint-text\" flex>.md-accent-bg .md-hue-2 .hint-text\n</div></div><div class=\"md-accent-bg md-hue-2\" flex=\"100\" class=\"divider\" layout=\"row\" layout-padding><div \nclass=\"fade-text\" flex>Fade Text / Divider</div><div class=\"fade-text\" flex>\n{{vm.themes.active.theme.accent.hue2.contrast4}}</div><div class=\"fade-text\" flex>.md-accent-bg .md-hue-2 .divider\n</div></div><div flex=\"100\" class=\"md-accent-fg md-hue-2\" layout=\"row\" layout-padding><div flex>As foreground color\n</div><div flex>{{vm.themes.active.theme.accent.hue2.color}}</div><div flex>.md-accent-fg</div></div></div><div \nclass=\"color\" layout=\"row\" layout-wrap layout-align=\"center center\"><div class=\"md-accent-bg md-hue-3\" flex=\"100\" \nlayout=\"row\" layout-padding><div flex>Hue 3</div><div flex>{{vm.themes.active.theme.accent.hue3.color}}</div><div flex>\n.md-accent-bg .md-hue-3</div></div><div class=\"md-accent-bg md-hue-3\" flex=\"100\" layout=\"row\" layout-padding><div flex>\nPrimary Text</div><div flex>{{vm.themes.active.theme.accent.hue3.contrast1}}</div><div flex>.md-accent-bg</div></div>\n<div class=\"md-accent-bg md-hue-3\" flex=\"100\" class=\"secondary-text\" layout=\"row\" layout-padding><div \nclass=\"secondary-text\" flex>Secondary Text / Icon</div><div class=\"secondary-text\" flex>\n{{vm.themes.active.theme.accent.hue3.contrast2}}</div><div class=\"secondary-text\" flex>\n.md-accent-bg .md-hue-3 .secondary-text</div></div><div class=\"md-accent-bg md-hue-3\" flex=\"100\" class=\"hint-text\" \nlayout=\"row\" layout-padding><div class=\"hint-text\" flex>Hint Text / Disabled Text</div><div class=\"hint-text\" flex>\n{{vm.themes.active.theme.accent.hue3.contrast3}}</div><div class=\"hint-text\" flex>.md-accent-bg .md-hue-3 .hint-text\n</div></div><div class=\"md-accent-bg md-hue-3\" flex=\"100\" class=\"divider\" layout=\"row\" layout-padding><div \nclass=\"fade-text\" flex>Fade Text / Divider</div><div class=\"fade-text\" flex>\n{{vm.themes.active.theme.accent.hue3.contrast4}}</div><div class=\"fade-text\" flex>.md-accent-bg .md-hue-3 .divider\n</div></div><div flex=\"100\" class=\"md-accent-fg md-hue-3\" layout=\"row\" layout-padding><div flex>As foreground color\n</div><div flex>{{vm.themes.active.theme.accent.hue3.color}}</div><div flex>.md-accent-fg</div></div></div>");
$templateCache.put("app/main/ui/theme-colors/tabs/background/background.html","<div class=\"color\" layout=\"row\" layout-wrap layout-align=\"center center\"><div class=\"md-background-bg\" flex=\"100\" \nlayout=\"row\" layout-padding><div flex>Default</div><div flex>{{vm.themes.active.theme.background.color}}</div><div \nflex>.md-background-bg</div></div><div class=\"md-background-bg\" flex=\"100\" layout=\"row\" layout-padding><div flex>\nPrimary Text</div><div flex>{{vm.themes.active.theme.background.contrast1}}</div><div flex>.md-background-bg</div>\n</div><div class=\"md-background-bg\" flex=\"100\" class=\"secondary-text\" layout=\"row\" layout-padding><div \nclass=\"secondary-text\" flex>Secondary Text / Icon</div><div class=\"secondary-text\" flex>\n{{vm.themes.active.theme.background.contrast2}}</div><div class=\"secondary-text\" flex>.md-background-bg .secondary-text\n</div></div><div class=\"md-background-bg\" flex=\"100\" class=\"hint-text\" layout=\"row\" layout-padding><div \nclass=\"hint-text\" flex>Hint Text / Disabled Text</div><div class=\"hint-text\" flex>\n{{vm.themes.active.theme.background.contrast3}}</div><div class=\"hint-text\" flex>.md-background-bg .hint-text</div>\n</div><div class=\"md-background-bg\" flex=\"100\" class=\"divider\" layout=\"row\" layout-padding><div class=\"fade-text\" flex>\nFade Text / Divider</div><div class=\"fade-text\" flex>{{vm.themes.active.theme.background.contrast4}}</div><div \nclass=\"fade-text\" flex>.md-background-bg .divider</div></div><div flex=\"100\" class=\"md-primary-bg md-background-fg\" \nlayout=\"row\" layout-padding><div flex>As foreground color</div><div flex>{{vm.themes.active.theme.background.color}}\n</div><div flex>.md-background-fg</div></div></div><div class=\"color\" layout=\"row\" layout-wrap \nlayout-align=\"center center\"><div class=\"md-background-bg md-hue-1\" flex=\"100\" layout=\"row\" layout-padding><div flex>\nHue 1</div><div flex>{{vm.themes.active.theme.background.hue1.color}}</div><div flex>.md-background-bg .md-hue-1</div>\n</div><div class=\"md-background-bg md-hue-1\" flex=\"100\" layout=\"row\" layout-padding><div flex>Primary Text</div><div \nflex>{{vm.themes.active.theme.background.hue1.contrast1}}</div><div flex>.md-background-bg</div></div><div \nclass=\"md-background-bg md-hue-1\" flex=\"100\" class=\"secondary-text\" layout=\"row\" layout-padding><div \nclass=\"secondary-text\" flex>Secondary Text / Icon</div><div class=\"secondary-text\" flex>\n{{vm.themes.active.theme.background.hue1.contrast2}}</div><div class=\"secondary-text\" flex>\n.md-background-bg .md-hue-1 .secondary-text</div></div><div class=\"md-background-bg md-hue-1\" flex=\"100\" \nclass=\"hint-text\" layout=\"row\" layout-padding><div class=\"hint-text\" flex>Hint Text / Disabled Text</div><div \nclass=\"hint-text\" flex>{{vm.themes.active.theme.background.hue1.contrast3}}</div><div class=\"hint-text\" flex>\n.md-background-bg .md-hue-1 .hint-text</div></div><div class=\"md-background-bg md-hue-1\" flex=\"100\" class=\"divider\" \nlayout=\"row\" layout-padding><div class=\"fade-text\" flex>Fade Text / Divider</div><div class=\"fade-text\" flex>\n{{vm.themes.active.theme.background.hue1.contrast4}}</div><div class=\"fade-text\" flex>\n.md-background-bg .md-hue-1 .divider</div></div><div flex=\"100\" class=\"md-primary-bg\" layout=\"row\" layout-padding><div \nflex class=\"md-background-fg md-hue-1\">As foreground color</div><div flex class=\"md-background-fg md-hue-1\">\n{{vm.themes.active.theme.background.hue1.color}}</div><div flex class=\"md-background-fg md-hue-1\">.md-background-fg\n</div></div></div><div class=\"color\" layout=\"row\" layout-wrap layout-align=\"center center\"><div \nclass=\"md-background-bg md-hue-2\" flex=\"100\" layout=\"row\" layout-padding><div flex>Hue 2</div><div flex>\n{{vm.themes.active.theme.background.hue2.color}}</div><div flex>.md-background-bg .md-hue-2</div></div><div \nclass=\"md-background-bg md-hue-2\" flex=\"100\" layout=\"row\" layout-padding><div flex>Primary Text</div><div flex>\n{{vm.themes.active.theme.background.hue2.contrast1}}</div><div flex>.md-background-bg</div></div><div \nclass=\"md-background-bg md-hue-2\" flex=\"100\" class=\"secondary-text\" layout=\"row\" layout-padding><div \nclass=\"secondary-text\" flex>Secondary Text / Icon</div><div class=\"secondary-text\" flex>\n{{vm.themes.active.theme.background.hue2.contrast2}}</div><div class=\"secondary-text\" flex>\n.md-background-bg .md-hue-2 .secondary-text</div></div><div class=\"md-background-bg md-hue-2\" flex=\"100\" \nclass=\"hint-text\" layout=\"row\" layout-padding><div class=\"hint-text\" flex>Hint Text / Disabled Text</div><div \nclass=\"hint-text\" flex>{{vm.themes.active.theme.background.hue2.contrast3}}</div><div class=\"hint-text\" flex>\n.md-background-bg .md-hue-2 .hint-text</div></div><div class=\"md-background-bg md-hue-2\" flex=\"100\" class=\"divider\" \nlayout=\"row\" layout-padding><div class=\"fade-text\" flex>Fade Text / Divider</div><div class=\"fade-text\" flex>\n{{vm.themes.active.theme.background.hue2.contrast4}}</div><div class=\"fade-text\" flex>\n.md-background-bg .md-hue-2 .divider</div></div><div flex=\"100\" class=\"md-primary-bg\" layout=\"row\" layout-padding><div \nflex class=\"md-background-fg md-hue-2\">As foreground color</div><div flex class=\"md-background-fg md-hue-2\">\n{{vm.themes.active.theme.background.hue2.color}}</div><div flex class=\"md-background-fg md-hue-2\">.md-background-fg\n</div></div></div><div class=\"color\" layout=\"row\" layout-wrap layout-align=\"center center\"><div \nclass=\"md-background-bg md-hue-3\" flex=\"100\" layout=\"row\" layout-padding><div flex>Hue 3</div><div flex>\n{{vm.themes.active.theme.background.hue3.color}}</div><div flex>.md-background-bg .md-hue-3</div></div><div \nclass=\"md-background-bg md-hue-3\" flex=\"100\" layout=\"row\" layout-padding><div flex>Primary Text</div><div flex>\n{{vm.themes.active.theme.background.hue3.contrast1}}</div><div flex>.md-background-bg</div></div><div \nclass=\"md-background-bg md-hue-3\" flex=\"100\" class=\"secondary-text\" layout=\"row\" layout-padding><div \nclass=\"secondary-text\" flex>Secondary Text / Icon</div><div class=\"secondary-text\" flex>\n{{vm.themes.active.theme.background.hue3.contrast2}}</div><div class=\"secondary-text\" flex>\n.md-background-bg .md-hue-3 .secondary-text</div></div><div class=\"md-background-bg md-hue-3\" flex=\"100\" \nclass=\"hint-text\" layout=\"row\" layout-padding><div class=\"hint-text\" flex>Hint Text / Disabled Text</div><div \nclass=\"hint-text\" flex>{{vm.themes.active.theme.background.hue3.contrast3}}</div><div class=\"hint-text\" flex>\n.md-background-bg .md-hue-3 .hint-text</div></div><div class=\"md-background-bg md-hue-3\" flex=\"100\" class=\"divider\" \nlayout=\"row\" layout-padding><div class=\"fade-text\" flex>Fade Text / Divider</div><div class=\"fade-text\" flex>\n{{vm.themes.active.theme.background.hue3.contrast4}}</div><div class=\"fade-text\" flex>\n.md-background-bg .md-hue-3 .divider</div></div><div flex=\"100\" class=\"md-primary-bg\" layout=\"row\" layout-padding><div \nflex class=\"md-background-fg md-hue-3\">As foreground color</div><div flex class=\"md-background-fg md-hue-3\">\n{{vm.themes.active.theme.background.hue3.color}}</div><div flex class=\"md-background-fg md-hue-3\">.md-background-fg\n</div></div></div>");
$templateCache.put("app/main/ui/theme-colors/tabs/primary/primary.html","<div class=\"color\" layout=\"row\" layout-wrap layout-align=\"center center\"><div class=\"md-primary-bg\" flex=\"100\" \nlayout=\"row\" layout-padding><div flex>Default</div><div flex>{{vm.themes.active.theme.primary.color}}</div><div flex>\n.md-primary-bg</div></div><div class=\"md-primary-bg\" flex=\"100\" layout=\"row\" layout-padding><div flex>Primary Text\n</div><div flex>{{vm.themes.active.theme.primary.contrast1}}</div><div flex>.md-primary-bg</div></div><div \nclass=\"md-primary-bg\" flex=\"100\" class=\"secondary-text\" layout=\"row\" layout-padding><div class=\"secondary-text\" flex>\nSecondary Text / Icon</div><div class=\"secondary-text\" flex>{{vm.themes.active.theme.primary.contrast2}}</div><div \nclass=\"secondary-text\" flex>.md-primary-bg .secondary-text</div></div><div class=\"md-primary-bg\" flex=\"100\" \nclass=\"hint-text\" layout=\"row\" layout-padding><div class=\"hint-text\" flex>Hint Text / Disabled Text</div><div \nclass=\"hint-text\" flex>{{vm.themes.active.theme.primary.contrast3}}</div><div class=\"hint-text\" flex>\n.md-primary-bg .hint-text</div></div><div class=\"md-primary-bg\" flex=\"100\" class=\"divider\" layout=\"row\" layout-padding>\n<div class=\"fade-text\" flex>Fade Text / Divider</div><div class=\"fade-text\" flex>\n{{vm.themes.active.theme.primary.contrast4}}</div><div class=\"fade-text\" flex>.md-primary-bg .divider</div></div><div \nflex=\"100\" class=\"md-primary-fg\" layout=\"row\" layout-padding><div flex>As foreground color</div><div flex>\n{{vm.themes.active.theme.primary.color}}</div><div flex>.md-primary-fg</div></div></div><div class=\"color\" \nlayout=\"row\" layout-wrap layout-align=\"center center\"><div class=\"md-primary-bg md-hue-1\" flex=\"100\" layout=\"row\" \nlayout-padding><div flex>Hue 1</div><div flex>{{vm.themes.active.theme.primary.hue1.color}}</div><div flex>\n.md-primary-bg .md-hue-1</div></div><div class=\"md-primary-bg md-hue-1\" flex=\"100\" layout=\"row\" layout-padding><div \nflex>Primary Text</div><div flex>{{vm.themes.active.theme.primary.hue1.contrast1}}</div><div flex>.md-primary-bg</div>\n</div><div class=\"md-primary-bg md-hue-1\" flex=\"100\" class=\"secondary-text\" layout=\"row\" layout-padding><div \nclass=\"secondary-text\" flex>Secondary Text / Icon</div><div class=\"secondary-text\" flex>\n{{vm.themes.active.theme.primary.hue1.contrast2}}</div><div class=\"secondary-text\" flex>\n.md-primary-bg .md-hue-1 .secondary-text</div></div><div class=\"md-primary-bg md-hue-1\" flex=\"100\" class=\"hint-text\" \nlayout=\"row\" layout-padding><div class=\"hint-text\" flex>Hint Text / Disabled Text</div><div class=\"hint-text\" flex>\n{{vm.themes.active.theme.primary.hue1.contrast3}}</div><div class=\"hint-text\" flex>.md-primary-bg .md-hue-1 .hint-text\n</div></div><div class=\"md-primary-bg md-hue-1\" flex=\"100\" class=\"divider\" layout=\"row\" layout-padding><div \nclass=\"fade-text\" flex>Fade Text / Divider</div><div class=\"fade-text\" flex>\n{{vm.themes.active.theme.primary.hue1.contrast4}}</div><div class=\"fade-text\" flex>.md-primary-bg .md-hue-1 .divider\n</div></div><div flex=\"100\" class=\"md-primary-fg md-hue-1\" layout=\"row\" layout-padding><div flex>As foreground color\n</div><div flex>{{vm.themes.active.theme.primary.hue1.color}}</div><div flex>.md-primary-fg</div></div></div><div \nclass=\"color\" layout=\"row\" layout-wrap layout-align=\"center center\"><div class=\"md-primary-bg md-hue-2\" flex=\"100\" \nlayout=\"row\" layout-padding><div flex>Hue 2</div><div flex>{{vm.themes.active.theme.primary.hue2.color}}</div><div \nflex>.md-primary-bg .md-hue-2</div></div><div class=\"md-primary-bg md-hue-2\" flex=\"100\" layout=\"row\" layout-padding>\n<div flex>Primary Text</div><div flex>{{vm.themes.active.theme.primary.hue2.contrast1}}</div><div flex>.md-primary-bg\n</div></div><div class=\"md-primary-bg md-hue-2\" flex=\"100\" class=\"secondary-text\" layout=\"row\" layout-padding><div \nclass=\"secondary-text\" flex>Secondary Text / Icon</div><div class=\"secondary-text\" flex>\n{{vm.themes.active.theme.primary.hue2.contrast2}}</div><div class=\"secondary-text\" flex>\n.md-primary-bg .md-hue-2 .secondary-text</div></div><div class=\"md-primary-bg md-hue-2\" flex=\"100\" class=\"hint-text\" \nlayout=\"row\" layout-padding><div class=\"hint-text\" flex>Hint Text / Disabled Text</div><div class=\"hint-text\" flex>\n{{vm.themes.active.theme.primary.hue2.contrast3}}</div><div class=\"hint-text\" flex>.md-primary-bg .md-hue-2 .hint-text\n</div></div><div class=\"md-primary-bg md-hue-2\" flex=\"100\" class=\"divider\" layout=\"row\" layout-padding><div \nclass=\"fade-text\" flex>Fade Text / Divider</div><div class=\"fade-text\" flex>\n{{vm.themes.active.theme.primary.hue2.contrast4}}</div><div class=\"fade-text\" flex>.md-primary-bg .md-hue-2 .divider\n</div></div><div flex=\"100\" class=\"md-primary-fg md-hue-2\" layout=\"row\" layout-padding><div flex>As foreground color\n</div><div flex>{{vm.themes.active.theme.primary.hue2.color}}</div><div flex>.md-primary-fg</div></div></div><div \nclass=\"color\" layout=\"row\" layout-wrap layout-align=\"center center\"><div class=\"md-primary-bg md-hue-3\" flex=\"100\" \nlayout=\"row\" layout-padding><div flex>Hue 3</div><div flex>{{vm.themes.active.theme.primary.hue3.color}}</div><div \nflex>.md-primary-bg .md-hue-3</div></div><div class=\"md-primary-bg md-hue-3\" flex=\"100\" layout=\"row\" layout-padding>\n<div flex>Primary Text</div><div flex>{{vm.themes.active.theme.primary.hue3.contrast1}}</div><div flex>.md-primary-bg\n</div></div><div class=\"md-primary-bg md-hue-3\" flex=\"100\" class=\"secondary-text\" layout=\"row\" layout-padding><div \nclass=\"secondary-text\" flex>Secondary Text / Icon</div><div class=\"secondary-text\" flex>\n{{vm.themes.active.theme.primary.hue3.contrast2}}</div><div class=\"secondary-text\" flex>\n.md-primary-bg .md-hue-3 .secondary-text</div></div><div class=\"md-primary-bg md-hue-3\" flex=\"100\" class=\"hint-text\" \nlayout=\"row\" layout-padding><div class=\"hint-text\" flex>Hint Text / Disabled Text</div><div class=\"hint-text\" flex>\n{{vm.themes.active.theme.primary.hue3.contrast3}}</div><div class=\"hint-text\" flex>.md-primary-bg .md-hue-3 .hint-text\n</div></div><div class=\"md-primary-bg md-hue-3\" flex=\"100\" class=\"divider\" layout=\"row\" layout-padding><div \nclass=\"fade-text\" flex>Fade Text / Divider</div><div class=\"fade-text\" flex>\n{{vm.themes.active.theme.primary.hue3.contrast4}}</div><div class=\"fade-text\" flex>.md-primary-bg .md-hue-3 .divider\n</div></div><div flex=\"100\" class=\"md-primary-fg md-hue-3\" layout=\"row\" layout-padding><div flex>As foreground color\n</div><div flex>{{vm.themes.active.theme.primary.hue3.color}}</div><div flex>.md-primary-fg</div></div></div>");
$templateCache.put("app/main/ui/theme-colors/tabs/warn/warn.html","<div class=\"color\" layout=\"row\" layout-wrap layout-align=\"center center\"><div class=\"md-warn-bg\" flex=\"100\" \nlayout=\"row\" layout-padding><div flex>Default</div><div flex>{{vm.themes.active.theme.warn.color}}</div><div flex>\n.md-warn-bg</div></div><div class=\"md-warn-bg\" flex=\"100\" layout=\"row\" layout-padding><div flex>Primary Text</div><div \nflex>{{vm.themes.active.theme.warn.contrast1}}</div><div flex>.md-warn-bg</div></div><div class=\"md-warn-bg\" \nflex=\"100\" class=\"secondary-text\" layout=\"row\" layout-padding><div class=\"secondary-text\" flex>Secondary Text / Icon\n</div><div class=\"secondary-text\" flex>{{vm.themes.active.theme.warn.contrast2}}</div><div class=\"secondary-text\" flex>\n.md-warn-bg .secondary-text</div></div><div class=\"md-warn-bg\" flex=\"100\" class=\"hint-text\" layout=\"row\" \nlayout-padding><div class=\"hint-text\" flex>Hint Text / Disabled Text</div><div class=\"hint-text\" flex>\n{{vm.themes.active.theme.warn.contrast3}}</div><div class=\"hint-text\" flex>.md-warn-bg .hint-text</div></div><div \nclass=\"md-warn-bg\" flex=\"100\" class=\"divider\" layout=\"row\" layout-padding><div class=\"fade-text\" flex>\nFade Text / Divider</div><div class=\"fade-text\" flex>{{vm.themes.active.theme.warn.contrast4}}</div><div \nclass=\"fade-text\" flex>.md-warn-bg .divider</div></div><div flex=\"100\" class=\"md-warn-fg\" layout=\"row\" layout-padding>\n<div flex>As foreground color</div><div flex>{{vm.themes.active.theme.warn.color}}</div><div flex>.md-warn-fg</div>\n</div></div><div class=\"color\" layout=\"row\" layout-wrap layout-align=\"center center\"><div class=\"md-warn-bg md-hue-1\" \nflex=\"100\" layout=\"row\" layout-padding><div flex>Hue 1</div><div flex>{{vm.themes.active.theme.warn.hue1.color}}</div>\n<div flex>.md-warn-bg .md-hue-1</div></div><div class=\"md-warn-bg md-hue-1\" flex=\"100\" layout=\"row\" layout-padding><div\n flex>Primary Text</div><div flex>{{vm.themes.active.theme.warn.hue1.contrast1}}</div><div flex>.md-warn-bg</div></div>\n<div class=\"md-warn-bg md-hue-1\" flex=\"100\" class=\"secondary-text\" layout=\"row\" layout-padding><div \nclass=\"secondary-text\" flex>Secondary Text / Icon</div><div class=\"secondary-text\" flex>\n{{vm.themes.active.theme.warn.hue1.contrast2}}</div><div class=\"secondary-text\" flex>\n.md-warn-bg .md-hue-1 .secondary-text</div></div><div class=\"md-warn-bg md-hue-1\" flex=\"100\" class=\"hint-text\" \nlayout=\"row\" layout-padding><div class=\"hint-text\" flex>Hint Text / Disabled Text</div><div class=\"hint-text\" flex>\n{{vm.themes.active.theme.warn.hue1.contrast3}}</div><div class=\"hint-text\" flex>.md-warn-bg .md-hue-1 .hint-text</div>\n</div><div class=\"md-warn-bg md-hue-1\" flex=\"100\" class=\"divider\" layout=\"row\" layout-padding><div class=\"fade-text\" \nflex>Fade Text / Divider</div><div class=\"fade-text\" flex>{{vm.themes.active.theme.warn.hue1.contrast4}}</div><div \nclass=\"fade-text\" flex>.md-warn-bg .md-hue-1 .divider</div></div><div flex=\"100\" class=\"md-warn-fg md-hue-1\" \nlayout=\"row\" layout-padding><div flex>As foreground color</div><div flex>{{vm.themes.active.theme.warn.hue1.color}}\n</div><div flex>.md-warn-fg</div></div></div><div class=\"color\" layout=\"row\" layout-wrap layout-align=\"center center\">\n<div class=\"md-warn-bg md-hue-2\" flex=\"100\" layout=\"row\" layout-padding><div flex>Hue 2</div><div flex>\n{{vm.themes.active.theme.warn.hue2.color}}</div><div flex>.md-warn-bg .md-hue-2</div></div><div \nclass=\"md-warn-bg md-hue-2\" flex=\"100\" layout=\"row\" layout-padding><div flex>Primary Text</div><div flex>\n{{vm.themes.active.theme.warn.hue2.contrast1}}</div><div flex>.md-warn-bg</div></div><div class=\"md-warn-bg md-hue-2\" \nflex=\"100\" class=\"secondary-text\" layout=\"row\" layout-padding><div class=\"secondary-text\" flex>Secondary Text / Icon\n</div><div class=\"secondary-text\" flex>{{vm.themes.active.theme.warn.hue2.contrast2}}</div><div class=\"secondary-text\" \nflex>.md-warn-bg .md-hue-2 .secondary-text</div></div><div class=\"md-warn-bg md-hue-2\" flex=\"100\" class=\"hint-text\" \nlayout=\"row\" layout-padding><div class=\"hint-text\" flex>Hint Text / Disabled Text</div><div class=\"hint-text\" flex>\n{{vm.themes.active.theme.warn.hue2.contrast3}}</div><div class=\"hint-text\" flex>.md-warn-bg .md-hue-2 .hint-text</div>\n</div><div class=\"md-warn-bg md-hue-2\" flex=\"100\" class=\"divider\" layout=\"row\" layout-padding><div class=\"fade-text\" \nflex>Fade Text / Divider</div><div class=\"fade-text\" flex>{{vm.themes.active.theme.warn.hue2.contrast4}}</div><div \nclass=\"fade-text\" flex>.md-warn-bg .md-hue-2 .divider</div></div><div flex=\"100\" class=\"md-warn-fg md-hue-2\" \nlayout=\"row\" layout-padding><div flex>As foreground color</div><div flex>{{vm.themes.active.theme.warn.hue2.color}}\n</div><div flex>.md-warn-fg</div></div></div><div class=\"color\" layout=\"row\" layout-wrap layout-align=\"center center\">\n<div class=\"md-warn-bg md-hue-3\" flex=\"100\" layout=\"row\" layout-padding><div flex>Hue 3</div><div flex>\n{{vm.themes.active.theme.warn.hue3.color}}</div><div flex>.md-warn-bg .md-hue-3</div></div><div \nclass=\"md-warn-bg md-hue-3\" flex=\"100\" layout=\"row\" layout-padding><div flex>Primary Text</div><div flex>\n{{vm.themes.active.theme.warn.hue3.contrast1}}</div><div flex>.md-warn-bg</div></div><div class=\"md-warn-bg md-hue-3\" \nflex=\"100\" class=\"secondary-text\" layout=\"row\" layout-padding><div class=\"secondary-text\" flex>Secondary Text / Icon\n</div><div class=\"secondary-text\" flex>{{vm.themes.active.theme.warn.hue3.contrast2}}</div><div class=\"secondary-text\" \nflex>.md-warn-bg .md-hue-3 .secondary-text</div></div><div class=\"md-warn-bg md-hue-3\" flex=\"100\" class=\"hint-text\" \nlayout=\"row\" layout-padding><div class=\"hint-text\" flex>Hint Text / Disabled Text</div><div class=\"hint-text\" flex>\n{{vm.themes.active.theme.warn.hue3.contrast3}}</div><div class=\"hint-text\" flex>.md-warn-bg .md-hue-3 .hint-text</div>\n</div><div class=\"md-warn-bg md-hue-3\" flex=\"100\" class=\"divider\" layout=\"row\" layout-padding><div class=\"fade-text\" \nflex>Fade Text / Divider</div><div class=\"fade-text\" flex>{{vm.themes.active.theme.warn.hue3.contrast4}}</div><div \nclass=\"fade-text\" flex>.md-warn-bg .md-hue-3 .divider</div></div><div flex=\"100\" class=\"md-warn-fg md-hue-3\" \nlayout=\"row\" layout-padding><div flex>As foreground color</div><div flex>{{vm.themes.active.theme.warn.hue3.color}}\n</div><div flex>.md-warn-fg</div></div></div>");
$templateCache.put("app/core/directives/ms-stepper/templates/vertical/step/vertical-step.html","<md-button class=\"ms-stepper-navigation-item\" \nng-class=\"{\'current\': MsStepper.isStepCurrent(stepInfo.stepNumber), \'valid\': MsStepper.isStepValid(stepInfo.stepNumber), \'disabled\': MsStepper.isStepDisabled(stepInfo.stepNumber), \'optional\': MsStepper.isStepOptional(stepInfo.stepNumber)}\" \nng-click=\"MsStepper.gotoStep(stepInfo.stepNumber)\" ng-disabled=\"MsStepper.isStepDisabled(stepInfo.stepNumber)\" \nng-hide=\"MsStepper.isStepHidden(stepInfo.stepNumber)\" aria-label=\"Stepper navigation button\" layout=\"row\" \nlayout-align=\"start center\"><div class=\"step\" layout=\"row\" layout-align=\"center center\"><span \nng-if=\"!MsStepper.isStepValid(stepInfo.stepNumber) || MsStepper.isStepOptional(stepInfo.stepNumber)\"><i \nclass=\"icon icon-checkbox-blank-circle-outline s18 md-accent-fg\"></i> </span><span \nng-if=\"MsStepper.isStepValid(stepInfo.stepNumber) && !MsStepper.isStepOptional(stepInfo.stepNumber)\"><i \nclass=\"icon icon-check-circle s18 md-accent-fg\"></i></span></div><div layout=\"column\" layout-align=\"start start\"><div \nclass=\"title\" ng-if=\"stepInfo.stepTitleTranslate\">{{stepInfo.stepTitleTranslate | translate }}</div><div class=\"title\" \nng-if=\"!stepInfo.stepTitleTranslate\">{{stepInfo.stepTitle}}</div><div class=\"subtitle\" \nng-if=\"MsStepper.isStepOptional(stepInfo.stepNumber)\">Optional</div></div></md-button><div \nclass=\"ms-stepper-step-content\" ng-transclude></div><div class=\"ms-stepper-controls\" layout=\"row\" \nlayout-align=\"start center\" ng-show=\"MsStepper.isStepCurrent(stepInfo.stepNumber)\"><md-button \nclass=\"md-accent md-raised\" ng-disabled=\"MsStepper.isFirstStep()\" ng-click=\"MsStepper.gotoPreviousStep()\">Back\n</md-button><md-button class=\"md-accent md-raised\" ng-if=\"!MsStepper.isLastStep()\" \nng-disabled=\"!MsStepper.isStepValid(MsStepper.currentStepNumber)\" ng-click=\"MsStepper.gotoNextStep()\">Next</md-button>\n<md-button type=\"submit\" class=\"md-accent md-raised\" ng-click=\"MsStepper.resetForm()\" ng-if=\"MsStepper.isLastStep()\" \nng-disabled=\"!MsStepper.isFormValid()\">Submit</md-button></div>");
$templateCache.put("app/main/pages/accountancy/views/payments-match/tabs/match-by-dates.html","<div layout=\"row\" layout-wrap><div layout=\"column\" flex=\"100\" flex-gt-sm=\"100\" flex-gt-md=\"70\"><form name=\"UserForm\" \nclass=\"md-inline-form\" validate><div class=\"filters\" layout=\"row\" layout-xs=\"column\"><md-input-container \nclass=\"md-icon-float md-block\" flex=\"25\" flex-xs=\"100\" style=\"padding: 0px 28px 0px\"><md-icon \nmd-font-icon=\"icon-calendar-select\"></md-icon><div start-view=\"day\" locale=\"he\" format=\"DD/MM/YYYY\" \nmoment-picker=\"vm.search.StartDate\"><label>מתאריך</label><input autocomplete=\"off\" ng-model=\"vm.search.StartDate\" \nng-disabled=\"!vm.payments\"></div></md-input-container><md-input-container class=\"md-icon-float md-block\" flex=\"25\" \nflex-xs=\"100\" style=\"padding: 0px 28px 0px\"><md-icon md-font-icon=\"icon-calendar-select\"></md-icon><div \nstart-view=\"day\" locale=\"he\" format=\"DD/MM/YYYY\" moment-picker=\"vm.search.EndDate\"><label>עד לתאריך</label><input \nautocomplete=\"off\" ng-model=\"vm.search.EndDate\" ng-disabled=\"!vm.payments\"></div></md-input-container></div><div \nclass=\"search-actions row\" layout=\"row\"><md-input-container class=\"md-icon-float md-block\" flex=\"25\" flex-xs=\"100\" \nstyle=\"padding: 0px 0px 0px\" vc-recaptcha key=\"\'6LdOJx8hAAAAANkr5w01UyvEYcj8K6EEdPBtlhWN\'\" \nng-model=\"vm.search.captcha\" ng-required=\"true\"></md-input-container></div><div class=\"search-actions row\" \nlayout=\"row\"><md-button type=\"submit\" \nng-disabled=\"!vm.search.captcha || (!vm.search.StartDate && !vm.search.EndDate) || !vm.payments \" \nclass=\"md-raised md-accent\" aria-label=\"חפש\" ng-click=\"vm.getPayments()\">ביצוע התאמה</md-button></div></form></div>\n</div><div ng-if=\"!vm.payments\" layout=\"row\" layout-sm=\"column\" layout-align=\"space-around\"><md-progress-circular \nmd-mode=\"indeterminate\"></md-progress-circular></div><div ng-if=\"vm.payments\"><div>סה\"כ סכום חיובים עבור התקופה:</div>\n<div class=\"number-format\">{{vm.payments.TotalCharge}}</div><div>סה\"כ סכום חיובים חסר עבור התקופה:</div><div \nclass=\"number-format\">{{vm.payments.TotalMissingCharge}}</div><div>סה\"כ סכום זיכויים עבור התקופה:</div><div \nclass=\"number-format\">{{vm.payments.TotalRefunds}}</div><div>סה\"כ סכום זיכויים חסר עבור התקופה:</div><div \nclass=\"number-format\">{{vm.payments.TotalMissingRefunds}}</div></div><div ng-if=\"vm.payments\"><table \nid=\"payments-table\" class=\"dataTable row-border hover stripe md-ink-ripple\" datatable=\"ng\" dt-instance=\"vm.dtInstance\" \ndt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">\nתאריך עסקה</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">\nתאריך להתאמה</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">סוג מסמך\n</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">התאמה מערכת</span>\n</div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">התאמה חברת סליקה</span>\n</div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">סכום</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">פעולות</span></div></th></tr></thead>\n<tbody><tr class=\"entry-code-item\" ng-repeat=\"payment in vm.payments.Data | orderBy:Date\" \ndt-column-defs=\"vm.dtColumnDefs\"><td>{{payment.Date | cmdate:\'dd/MM/yyyy\'}}</td><td><div start-view=\"day\" locale=\"he\" \nformat=\"DD/MM/YYYY\" moment-picker=\"payment.MatchDate\"><input autocomplete=\"off\" ng-model=\"payment.MatchDate\"></div>\n</td><td>{{payment.Type == 1 ? \'קבלה\' : \'זיכוי\'}}</td><td>{{payment.ReceiptMatch ? \'התאמה מלאה\' : \'קיימת בעיה\'}}</td>\n<td>{{payment.TransactionMatch ? \'התאמה מלאה\' : \'קיימת בעיה\'}}</td><th>{{payment.Sum}} &#8362;</th><td><md-button \nng-if=\"!payment.ReceiptID && !payment.Disable\" ng-click=\"vm.createPayment(payment)\" class=\"preview-user\" \ntitle=\"יצירת קבלה + הרשמה\"><md-icon md-font-icon=\"icon-file-document\"></md-icon></md-button><md-button \nng-click=\"vm.openPaymentMatchDialog(payment)\" class=\"preview-user\" title=\"צפיה בפרטי קבלה\"><md-icon md-svg-icon=\"eye\">\n</md-icon></md-button></td></tr></tbody></table></div>");
$templateCache.put("app/main/pages/accountancy/views/payments-match/tabs/match-by-month.html","<div ng-init=\"vm.getPaymentsByMonth()\"><div ng-if=\"!vm.paymentsByMonth\" layout=\"row\" layout-sm=\"column\" \nlayout-align=\"space-around\"><md-progress-circular md-mode=\"indeterminate\"></md-progress-circular></div><div \nng-if=\"vm.paymentsByMonth\"><table id=\"payments-table\" class=\"dataTable row-border hover stripe md-ink-ripple\" \ndatatable=\"ng\" dt-instance=\"vm.dtInstance\" dt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">שנה</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">חודש</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">סה\"כ זיכווים ספק סליקה</span></div></th><th class=\"secondary-text\"><div\n class=\"table-header\"><span class=\"column-title\">סה\"כ זיכויים מערכת</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">סה\"כ חיובים ספק סליקה</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">סה\"כ חיובים מערכת</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">פער זיכויים</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">פער חיובים</span></div></th></tr></thead><tbody><tr \nclass=\"entry-code-item\" ng-repeat=\"payment in vm.paymentsByMonth\" dt-column-defs=\"vm.dtColumnDefs\"><td>{{payment.Year}}\n</td><td>{{payment.Month}}</td><td><span class=\"number-format\">{{payment.TotalPaymentCompanyRefund}}</span></td><td>\n<span class=\"number-format\">{{payment.TotalMarvilixRefund}}</span></td><td><span class=\"number-format\">\n{{payment.TotalPaymentCompanyCharge}}</span></td><td><span class=\"number-format\">{{payment.TotalMarvilixCharge}}</span>\n</td><td><span class=\"number-format\">{{payment.RefundDifferences}}</span></td><td><span class=\"number-format\">\n{{payment.ChargeDifferences}}</span></td></tr></tbody></table></div></div>");
$templateCache.put("app/main/pages/accountancy/views/payments-match/payment-match-dialog/payment-match-dialog.html","<md-dialog class=\"subsidy-dialog\" aria-label=\"New Task\" style=\"min-width: 1000px\" ng-init=\"vm.getDeal()\"><form \nname=\"contactForm-form\" class=\"md-inline-form\" validate><md-toolbar class=\"md-accent\" layout=\"column\"><div \nclass=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">\nטופס צור קשר</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" translate \ntranslate-attr-aria-label=\"MANAGE_USERS.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-content class=\"about-tab\" style=\"padding: 50px\"><form class=\"md-inline-form\" validate><div \nlayout=\"row\" layout-wrap><md-input-container class=\"md-icon-float md-block\" layout=\"column\" layout-xs=\"row\" flex=\"100\" \nflex-xs=\"100\" flex-gt-sm=\"50\" flex-gt-md=\"50\"><md-icon md-font-icon=\"icon-calender\"></md-icon><label>תאריך יצירה\n</label><input ng-value=\"vm.deal.CreateTime | cmdate:\'dd/MM/yyyy\'\" type=\"text\" readonly=\"readonly\">\n</md-input-container><md-input-container class=\"md-icon-float md-block\" layout=\"column\" layout-xs=\"row\" flex=\"100\" \nflex-xs=\"100\" flex-gt-sm=\"50\" flex-gt-md=\"50\"><md-icon md-svg-icon=\"account-box\" class=\"name\"></md-icon><label>\nמקור הרשמה</label><input ng-value=\"vm.deal.Source | registrationSource\" readonly=\"readonly\"></md-input-container></div>\n<div layout=\"row\" layout-wrap><md-input-container class=\"md-icon-float md-block\" layout=\"column\" layout-xs=\"row\" \nflex=\"100\" flex-xs=\"100\" flex-gt-sm=\"50\" flex-gt-md=\"50\"><md-icon md-font-icon=\"icon-account\"></md-icon><label>שם הורה\n</label><input value=\"{{vm.deal.Parent.FirstName}} {{vm.deal.Parent.LastName}}\" type=\"text\" readonly=\"readonly\">\n</md-input-container><md-input-container class=\"md-icon-float md-block\" layout=\"column\" layout-xs=\"row\" flex=\"100\" \nflex-xs=\"100\" flex-gt-sm=\"50\" flex-gt-md=\"50\"><md-icon md-font-icon=\"icon-calender\"></md-icon><label>סכום כולל</label>\n<input class=\"number-format\" ng-value=\"vm.deal.Sum\" type=\"text\" readonly=\"readonly\"></md-input-container></div><div \nng-repeat=\"item in vm.items\"><table class=\"dataTable row-border hover stripe md-ink-ripple\"><tr><th>שם חניך</th><th>\nשם {{$root.User.Event}}</th><th>מחיר סופי</th></tr><tbody><tr ng-repeat=\"event in item.SelectedEvents\"><th>\n{{item.FirstName}} {{item.LastName}}</th><th>{{event.Name}}</th><th><span class=\"number-format\">{{event.NewPrice}}\n</span></th></tr></tbody></table><hr></div></form></md-content></form></md-dialog>");
$templateCache.put("app/main/pages/activities/activities-profile/tabs/attendance/attendance.html","<div><div layout=\"row\" layout-wrap><div class=\"general\" layout=\"column\" flex=\"100\" flex-gt-sm=\"80\" flex-gt-md=\"70\" \nflex-gt-lg=\"60\"><div class=\"profile-box info-box md-whiteframe-1dp\" layout=\"column\"><header class=\"md-accent-bg\"><div \nclass=\"title\">רשימת משתתפים</div></header><div class=\"content\"><table \nclass=\"dataTable row-border hover stripe md-ink-ripple\" datatable=\"ng\" dt-instance=\"dtInstance\" dt-options=\"dtOptions\" \nng-show=\"attendance\"><thead><tr><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">\nשם משתתף</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">נוכחות</span>\n</div></th></tr></thead><tbody><tr class=\"md-ink-ripple\" ng-repeat=\"student in attendance\"><td>\n{{student.FirstName}} {{student.LastName}}</td><td><md-input-container class=\"md-icon-float md-block\" layout=\"column\" \nlayout-xs=\"row\" flex=\"100\" flex-xs=\"100\" flex-gt-sm=\"50\" flex-gt-md=\"50\"><md-checkbox \nng-checked=\"student.Attendance==1\" ng-click=\"updateStudentAttendance(student)\"></md-checkbox></md-input-container></td>\n</tr></tbody></table></div></div></div></div></div>");
$templateCache.put("app/main/pages/activities/activities-profile/tabs/about/about.html","<div ng-init=\"getBranches(); getGrades()\"><div layout=\"row\" layout-wrap><div class=\"general\" layout=\"column\" \nflex=\"100\" flex-gt-sm=\"80\" flex-gt-md=\"70\" flex-gt-lg=\"60\"><div class=\"profile-box info-box md-whiteframe-1dp\" \nlayout=\"column\"><header class=\"md-accent-bg\"><div class=\"title\">כללי</div></header><div class=\"content\"><form \nname=\"UserForm\" class=\"md-inline-form\" validate><div layout=\"row\" layout-wrap><md-input-container \nclass=\"md-icon-float md-block\" layout=\"column\" layout-xs=\"row\" flex=\"100\" flex-xs=\"100\" flex-gt-sm=\"50\" \nflex-gt-md=\"50\"><md-icon md-font-icon=\"icon-leaf\" class=\"name\"></md-icon><label>שם {{$root.User.Activity}}</label>\n<input ng-model=\"activities.Name\" type=\"text\"></md-input-container><md-input-container class=\"md-icon-float md-block\" \nlayout=\"column\" layout-xs=\"row\" flex=\"100\" flex-xs=\"100\" flex-gt-sm=\"50\" flex-gt-md=\"50\"><md-icon \nmd-font-icon=\"icon-calendar-select\"></md-icon><div start-view=\"day\" locale=\"he\" format=\"DD/MM/YYYY HH:mm\" \nmoment-picker=\"activities.Date\"><label>תאריך {{$root.User.Event}}</label><input autocomplete=\"off\" \nng-model=\"activities.Date\"></div></md-input-container></div><div layout=\"row\" layout-wrap><md-input-container \nclass=\"md-icon-float md-block\" layout=\"column\" layout-xs=\"row\" flex=\"100\" flex-xs=\"100\" flex-gt-sm=\"50\" \nflex-gt-md=\"50\"><md-icon md-font-icon=\"icon-account-multiple\" class=\"name\"></md-icon><label>שם {{$root.User.Groups}}\n</label><input ng-value=\"activities.GroupName\" type=\"text\" ng-disabled=\"true\"></md-input-container><md-input-container \nclass=\"md-icon-float md-block\" layout=\"column\" layout-xs=\"row\" flex=\"100\" flex-xs=\"100\" flex-gt-sm=\"50\" \nflex-gt-md=\"50\"><md-icon md-font-icon=\"icon-power\"></md-icon><label>סטטוס</label><md-select \nng-model=\"activities.Status\" placeholder=\"סטטוס\"><md-option \nng-selected=\"activities.Status==1 || activities.Status==\'1\'\" ng-value=\"1\">פעיל</md-option><md-option \nng-selected=\"activities.Status==0 || activities.Status==\'0\'\" ng-value=\"0\">לא פעיל</md-option></md-select>\n</md-input-container></div></form></div></div></div></div></div>");
$templateCache.put("app/main/pages/admin/admin-profile/tabs/about/about.html","<div layout=\"row\" layout-wrap><div class=\"about\" layout=\"column\" flex=\"100\" flex-gt-sm=\"100\" flex-gt-md=\"70\"><div \nclass=\"profile-box info-box general md-whiteframe-1dp\" layout=\"column\"><header class=\"md-accent-bg\"><div class=\"title\">\nכללי</div></header><div class=\"content\"><form name=\"UserForm\" class=\"md-inline-form\" validate><div class=\"row\" \nlayout=\"row\"><div class=\"half\"><md-input-container class=\"md-icon-float md-block\"><md-icon md-font-icon=\"icon-email\" \nclass=\"email\"></md-icon><label>דואר אלטקרני</label><input ng-model=\"$root.User.Email\" type=\"email\" \nng-disabled=\"$root.AdminLevel==1\"></md-input-container></div></div><div class=\"row\" layout=\"row\"><div class=\"half\">\n<md-input-container class=\"md-icon-float md-block\"><md-icon md-font-icon=\"icon-account\" class=\"account\"></md-icon>\n<label>שם פרטי</label><input ng-model=\"$root.User.FirstName\" type=\"text\" ng-disabled=\"$root.AdminLevel==1\">\n</md-input-container></div><div class=\"half\"><md-input-container class=\"md-icon-float md-block\"><md-icon></md-icon>\n<label>שם משפחה</label><input ng-model=\"$root.User.LastName\" type=\"text\" ng-disabled=\"$root.AdminLevel==1\">\n</md-input-container></div></div><div class=\"row\" layout=\"row\"><div class=\"half\"><div \nclass=\"md-icon-float md-block file-upload\"><md-icon style=\"color: #000\" md-font-icon=\"icon-file-image-box\"></md-icon>\n<div ngf-select=\"checkSize($file)\" accept=\"image/*\" style=\"display: inline-block; padding: 20px 0; cursor: pointer\">\n<div id=\"fake-input\">עדכון תמונת פרופיל</div></div></div></div></div><md-button ng-disabled=\"isClicked || !goodFile\" \nclass=\"md-raised md-accent\" aria-label=\"שמור את השדות\" ng-click=\"editAdmin()\" style=\"margin-right: 0px\">שמור\n</md-button></form></div></div></div></div>");
$templateCache.put("app/main/pages/admin/admin-profile/tabs/password/password.html","<div layout=\"row\" layout-wrap><div class=\"password_update\" layout=\"column\" flex=\"100\" flex-gt-sm=\"100\" flex-gt-md=\"70\">\n<div class=\"profile-box info-box general md-whiteframe-1dp\" layout=\"column\"><header class=\"md-accent-bg\"><div \nclass=\"title\">שינויי סיסמה</div></header><div class=\"content\"><ul><li>מינימום 8 תווים</li><li>אות אחת גדולה לפחות</li>\n<li>מספר אחד לפחות</li><li>אותיות באנגלית בלבד</li></ul><form name=\"PasswordForm\" class=\"md-inline-form\" \nng-submit=\"updatePassword()\" validate><div class=\"row\" layout=\"row\"><div class=\"full\"><md-input-container \nclass=\"md-icon-float md-block\"><md-icon md-font-icon=\"icon-key-variant\" class=\"email\"></md-icon><label>סיסמא נוכחית\n</label><input ng-model=\"$root.User.oldPassword\" type=\"password\" ng-required=\"true\"><div \nng-messages=\"$root.User.oldPassword.$error\"><div ng-message-exp=\"[\'required\']\"><span>השדה לא יכול להיות ריק</span>\n</div></div></md-input-container></div></div><div class=\"row\" layout=\"row\"><div class=\"full\"><md-input-container \nclass=\"md-icon-float md-block\"><md-icon md-font-icon=\"icon-lock\" class=\"account\"></md-icon><label>סיסמא חדשה</label>\n<input ng-model=\"$root.User.newPassword\" type=\"password\" ng-required=\"true\" \nng-pattern=\"/^(?=.*\\d)(?=.*[A-Z])(?!.*[^a-zA-Z0-9@#$^+=])(.{8,15})$/\"><div ng-messages=\"$root.User.newPassword.$error\">\n<div ng-message-exp=\"[\'required\', \'pattern\']\"><span>\nהסיסמא חייבת להיות באורך מינימלי של 8 תווים, צריכה להכיל לפחות אות אחת גדולה וספרה</span></div></div>\n</md-input-container></div></div><div class=\"row\" layout=\"row\"><div class=\"full\"><md-input-container \nclass=\"md-icon-float md-block\"><md-icon></md-icon><label>אימות סיסמא חדשה</label><md-icon md-font-icon=\"icon-lock\" \nclass=\"account\"></md-icon><input ng-model=\"$root.User.newPasswordConfirmation\" type=\"password\" \nng-class=\"{\'ng-valid\': $root.User.newPassword == $root.User.newPasswordConfirmation && $root.User.newPasswordConfirmation.length != 0}\" \nng-pattern=\"/^(?=.*\\d)(?=.*[A-Z])(?!.*[^a-zA-Z0-9@#$^+=])(.{8,15})$/\" ng-required=\"true\"><div \nng-messages=\"$root.User.newPasswordConfirmation.$error\"><div ng-message-exp=\"[\'pattern\']\"><span>\nהיסמאות צריכות להיות זהות</span></div></div></md-input-container></div></div><md-button type=\"submit\" \nng-disabled=\"isClicked || (!$root.User.newPassword && !$root.User.newPasswordConfirmation)\" \nclass=\"md-raised md-accent\" aria-label=\"שמור את השדות\" style=\"margin-right: 0px\">שמור</md-button></form></div></div>\n</div></div>");
$templateCache.put("app/main/pages/branches/views/areas/areas-panel/areas-panel.html","<md-content ms-scroll><form name=\"areaForm\" id=\"area-panel\" data-ng-model=\"areaForm\" class=\"md-inline-form\" validate>\n<md-toolbar class=\"md-accent\" layout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" \nlayout-align=\"space-between center\"><span class=\"title\">עריכת איזור</span><md-button class=\"md-icon-button\" \nng-click=\"$root.closePanel()\" aria-label=\"Close Dialog\" translate \ntranslate-attr-aria-label=\"PROFILE_PANEL.CLOSE_PANEL\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n<div class=\"md-toolbar-tools md-toolbar-tools-middle\" flex layout=\"column\" layout-align=\"center center\"><div \nclass=\"selectedUser-name\">{{ group.Name }}</div></div></md-toolbar><md-input-container class=\"md-icon-float md-block\">\n<label>שם</label><md-icon md-font-icon=\"icon-panorama-horizontal\" class=\"name\"></md-icon><input ng-model=\"area.Name\" \ntype=\"text\"></md-input-container><md-input-container class=\"md-icon-float md-block\"><md-icon md-font-icon=\"icon-email\">\n</md-icon><label>אימייל לקבלת בקשות סבסוד</label><md-chips ng-model=\"area.SubsidyEmail\" \nng-disabled=\"$root.AdminLevel<3\" type=\"email\"></md-chips></md-input-container><md-input-container class=\"md-block\">\n<md-icon md-font-icon=\"icon-power\"></md-icon><label>סטטוס</label><md-select ng-model=\"area.Status\" placeholder=\"סטטוס\" \nng-disabled=\"$root.AdminLevel<3\"><md-option ng-selected=\"area.Status==1 || area.Status==\'1\'\" ng-value=\"1\">פעיל\n</md-option><md-option ng-selected=\"area.Status==0 || area.Status==\'0\'\" ng-value=\"0\">לא פעיל</md-option></md-select>\n</md-input-container></form></md-content>");
$templateCache.put("app/main/pages/branches/views/areas/new-area-dialog/new-area-dialog.html","<md-dialog class=\"new-branch-dialog\" aria-label=\"New Task\"><form name=\"newAreaForm\" data-ng-model=\"newAreaForm\" \nclass=\"md-inline-form\" validate><md-toolbar class=\"md-accent\" layout=\"column\"><div \nclass=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">\nהוספת איזור חדש</span><md-button class=\"md-icon-button\" ng-click=\"closeDialog()\" aria-label=\"Close dialog\" translate \ntranslate-attr-aria-label=\"MANAGE_USERS.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content ms-scroll><md-input-container class=\"md-block\"><md-icon md-font-icon=\"icon-domain\" \nclass=\"name\"></md-icon><label>שם איזור</label><input ng-model=\"newArea.Name\" type=\"text\" ng-disabled=\"isClicked\">\n</md-input-container><md-input-container class=\"md-icon-float md-block\"><md-icon md-font-icon=\"icon-email\"></md-icon>\n<label>אימייל לקבלת בקשות סבסוד</label><input ng-model=\"newArea.SubsidyEmail\" type=\"email\" \nng-disabled=\"$root.AdminLevel<3\"></md-input-container></md-dialog-content><md-dialog-actions layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-button \ndata-ng-disabled=\"newAreaForm.$invalid || isClicked\" type=\"submit\" ng-click=\"saveNewBranch()\" \nclass=\"send-button md-accent md-raised\" aria-label=\"Add Task\">שמירה</md-button></div></md-dialog-actions></form>\n</md-dialog>");
$templateCache.put("app/main/pages/branches/views/grades/grades-panel/grades-panel.html","<md-content ms-scroll><form name=\"gradeForm\" id=\"grade-panel\" data-ng-model=\"groupForm\" class=\"md-inline-form\" \nvalidate><md-toolbar class=\"md-accent\" layout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" \nlayout-align=\"space-between center\" style=\"padding-top: 25px\"><span class=\"title\">עריכה מהירה</span><md-button \nclass=\"md-icon-button\" ng-click=\"$root.closePanel()\" aria-label=\"Close Dialog\" translate \ntranslate-attr-aria-label=\"PROFILE_PANEL.CLOSE_PANEL\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n<div class=\"md-toolbar-tools md-toolbar-tools-middle\" flex layout=\"column\" layout-align=\"center center\"><div \nclass=\"selectedUser-name\">{{ group.Name }}</div></div></md-toolbar><md-input-container class=\"md-icon-float md-block\">\n<label>שם</label><md-icon md-font-icon=\"icon-panorama-horizontal\" class=\"name\"></md-icon><input ng-model=\"grade.Name\">\n</md-input-container><md-input-container class=\"md-icon-float md-block\"><label>שנתון</label><md-icon \nmd-font-icon=\"icon-account\" class=\"name\"></md-icon><input ng-model=\"grade.Year\"></md-input-container>\n<md-input-container class=\"md-block\"><md-icon md-font-icon=\"\"></md-icon><label>שכבת בוגרים</label><md-icon \nmd-font-icon=\"icon-account-box\" class=\"name\"></md-icon><md-select ng-model=\"grade.Graduates\"><md-option \nng-selected=\"grade.Graduates==1 || grade.Graduates==\'1\'\" ng-value=\"1\">כן</md-option><md-option \nng-selected=\"grade.Graduates==0 || grade.Graduates==\'0\'\" ng-value=\"0\">לא</md-option></md-select></md-input-container>\n<md-input-container class=\"md-block\"><md-icon md-font-icon=\"icon-power\" class=\"name\"></md-icon><label>סטטוס</label>\n<md-select ng-model=\"grade.Status\" placeholder=\"סטטוס\"><md-option ng-selected=\"grade.Status==1 || grade.Status==\'1\'\" \nng-value=\"1\">פעיל</md-option><md-option ng-selected=\"grade.Status==0 || grade.Status==\'0\'\" ng-value=\"0\">לא פעיל\n</md-option></md-select></md-input-container></form></md-content>");
$templateCache.put("app/main/pages/branches/views/grades/new-grades-dialog/new-grades-dialog.html","<md-dialog class=\"new-grade-dialog\"><form name=\"newGradeForm\" data-ng-model=\"newGroupForm\" class=\"md-inline-form\" \nvalidate><md-toolbar class=\"md-accent\" layout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" \nlayout-align=\"space-between center\"><span class=\"title\">הוספה</span><md-button class=\"md-icon-button\" \nng-click=\"closeDialog()\" ng-disabled=\"isClicked\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content ms-scroll><md-input-container class=\"md-block\"><md-icon \nmd-font-icon=\"icon-panorama-horizontal\" class=\"name\"></md-icon><label>שם</label><input ng-model=\"newGrade.Name\" \nng-required=\"true\" ng-disabled=\"isClicked\"></md-input-container><md-input-container class=\"md-icon-float md-block\">\n<label>שנתון</label><md-icon md-font-icon=\"icon-account\" class=\"name\"></md-icon><input ng-model=\"newGrade.Year\" \nng-disabled=\"isClicked\"></md-input-container><md-input-container class=\"md-block\"><md-icon md-font-icon=\"\"></md-icon>\n<label>שכבת בוגרים</label><md-icon md-font-icon=\"icon-account-box\" class=\"name\"></md-icon><md-select \nng-model=\"newGrade.Graduates\" ng-disabled=\"isClicked\"><md-option ng-value=\"1\">כן</md-option><md-option ng-value=\"0\">לא\n</md-option></md-select></md-input-container></md-dialog-content><md-dialog-actions layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-button \ndata-ng-disabled=\"newGradeForm.$invalid || isClicked\" type=\"submit\" ng-click=\"saveNewGrade()\" \nclass=\"send-button md-accent md-raised\" aria-label=\"Add Task\">שמירה</md-button></div></md-dialog-actions></form>\n</md-dialog>");
$templateCache.put("app/main/pages/branches/views/branches/branch-management/branch-management.html","<div id=\"branch-management\" class=\"page-layout simple tabbed\"><div class=\"header md-accent-bg\" layout=\"column\" \nlayout-align=\"center center\" layout-gt-sm=\"row\" layout-align-gt-sm=\"space-between end\"><div class=\"user-info\" \nlayout=\"column\" layout-align=\"center center\" layout-gt-sm=\"row\" layout-align-gt-sm=\"start center\"><div class=\"name\">\n{{$root.User.Branch}} {{branch.Name}}</div></div></div><div class=\"content\" flex><div layout=\"row\" layout-sm=\"column\" \nlayout-align=\"space-around\" ng-if=\"!branch\"><md-progress-circular md-mode=\"indeterminate\"></md-progress-circular></div>\n<md-tabs md-dynamic-height id=\"branch-management-tab\" ng-if=\"branch\"><md-tab \nng-disabled=\"$root.isEdit && selectedTab!=0\" md-on-select=\"setTab(0)\"><md-tab-label><span>כללי</span></md-tab-label>\n<md-tab-body><md-content \nng-include=\"\'app/main/pages/branches/views/branches/branch-management/tabs/general/general.html\'\"></md-content>\n</md-tab-body></md-tab><md-tab ng-disabled=\"$root.isEdit && selectedTab!=1\" md-on-select=\"setTab(1)\"><md-tab-label>\n<span>שעות פעילות</span></md-tab-label><md-tab-body><md-content \nng-include=\"\'app/main/pages/branches/views/branches/branch-management/tabs/hours/hours.html\'\"></md-content>\n</md-tab-body></md-tab><md-tab ng-disabled=\"$root.isEdit && selectedTab!=2\" md-on-select=\"setTab(2)\"><md-tab-label>\n<span>אנשי קשר</span></md-tab-label><md-tab-body><md-content \nng-include=\"\'app/main/pages/branches/views/branches/branch-management/tabs/contacts/contacts.html\'\"></md-content>\n</md-tab-body></md-tab><md-tab ng-disabled=\"$root.isEdit && selectedTab!=3\" md-on-select=\"setTab(3)\"><md-tab-label>\n<span>קבצים</span></md-tab-label><md-tab-body><md-content \nng-include=\"\'app/main/pages/branches/views/branches/branch-management/tabs/files/files.html\'\"></md-content>\n</md-tab-body></md-tab><md-tab ng-disabled=\"$root.isEdit && selectedTab!=3\" md-on-select=\"setTab(3)\"><md-tab-label>\n<span>סטטיסטיקה</span></md-tab-label><md-tab-body><md-content \nng-include=\"\'app/main/pages/branches/views/branches/branch-management/tabs/statistics/statistics.html\'\"></md-content>\n</md-tab-body></md-tab></md-tabs></div></div>");
$templateCache.put("app/main/pages/branches/views/branches/branch-panel/branch-panel.html","<md-content ms-scroll><form name=\"branchsForm\" id=\"branchForm\" data-ng-model=\"branchForm\" class=\"md-inline-form\" \nvalidate><md-toolbar class=\"md-accent\" layout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" \nlayout-align=\"space-between center\"><span class=\"title\">עריכה {{$root.User.Branch}}</span><md-button \nclass=\"md-icon-button\" ng-click=\"$root.closePanel()\" aria-label=\"Close Dialog\"><md-icon md-font-icon=\"icon-close\">\n</md-icon></md-button></div></md-toolbar><md-input-container class=\"md-icon-float md-block\"><md-icon \nmd-font-icon=\"icon-domain\"></md-icon><label>שם</label><input ng-model=\"branch.Name\" \nng-disabled=\"$root.AdminLevel==1 || ($root.AdminLevel== 2 && !$root.User.BranchesPer)\"></md-input-container><div \nclass=\"md-block md-icon-left\" style=\"display: -webkit-box\"><md-icon md-font-icon=\"icon-city\" class=\"name\" \nstyle=\"padding-top: 38px;padding-right: 7px\"></md-icon><md-autocomplete \nstyle=\"min-width: 327px;padding-right: 36px;margin-right: -22px\" md-selected-item-change=\"setCity(item)\" \nng-disabled=\"$root.AdminLevel==1 || ($root.AdminLevel== 2 && !$root.User.BranchesPer)\" \nmd-input-name=\"autocompleteField\" md-no-cache=\"noCache\" md-selected-item=\"selectedItem\" md-search-text=\"searchText\" \nmd-items=\"item in querySearch(searchText)\" md-item-text=\"item.display\" md-min-length=\"0\" md-floating-label=\"שם ישוב\">\n<md-item-template><span md-highlight-text=\"searchText\" md-highlight-flags=\"^i\">{{item.display}}</span>\n</md-item-template><md-not-found>ישוב לא נמצא</md-not-found></md-autocomplete></div><md-input-container \nclass=\"md-block\"><md-icon md-font-icon=\"icon-domain\" class=\"name\"></md-icon><label>איזור</label><md-select \nng-model=\"branch.AreaID\" \nng-disabled=\"!areas || $root.AdminLevel==1 || ($root.AdminLevel== 2 && !$root.User.BranchesPer)\" \nng-change=\"setAreaName();\"><md-option ng-selected=\"branch.AreaID==area.ID\" ng-repeat=\"area in areas\" \nng-value=\"area.ID\">{{area.Name}}</md-option></md-select></md-input-container><md-input-container \nclass=\"md-icon-float md-block\"><md-icon md-font-icon=\"icon-panorama-horizontal\"></md-icon><label>כתובת</label><input \nng-model=\"branch.Address\" ng-disabled=\"$root.AdminLevel==1 || ($root.AdminLevel== 2 && !$root.User.BranchesPer)\">\n</md-input-container><md-input-container class=\"md-icon-float md-block\"><md-icon md-font-icon=\"icon-phone\"></md-icon>\n<label>טלפון</label><input ng-model=\"branch.Phone\" \nng-disabled=\"$root.AdminLevel==1 || ($root.AdminLevel== 2 && !$root.User.BranchesPer)\"></md-input-container>\n<md-input-container class=\"md-icon-float md-block\"><md-icon md-font-icon=\"icon-email\"></md-icon><label>אימייל</label>\n<input ng-model=\"branch.Email\" type=\"email\" \nng-disabled=\"$root.AdminLevel==1 || ($root.AdminLevel== 2 && !$root.User.BranchesPer)\"></md-input-container>\n<md-input-container class=\"md-icon-float md-block\"><md-icon md-font-icon=\"icon-email\"></md-icon><label>\nאימייל לקבלת בקשות סבסוד</label><md-chips ng-model=\"branch.SubsidyEmail\" ng-disabled=\"$root.AdminLevel<3\" type=\"email\" \nreadonly=\"$root.AdminLevel==1 || ($root.AdminLevel== 2 && !$root.User.BranchesPer)\"></md-chips></md-input-container>\n<md-input-container class=\"md-icon-float md-block\"><md-icon md-svg-icon=\"numeric\"></md-icon><label>קוד סניף</label>\n<input ng-model=\"branch.Code\" ng-disabled=\"$root.AdminLevel==1 || ($root.AdminLevel== 2 && !$root.User.BranchesPer)\">\n</md-input-container><md-input-container class=\"md-block\"><md-icon md-font-icon=\"icon-power\"></md-icon><label>סטטוס\n</label><md-select ng-model=\"branch.Status\" placeholder=\"סטטוס\" ng-disabled=\"$root.AdminLevel<3\"><md-option \nng-selected=\"branch.Status==1 || branch.Status==\'1\'\" ng-value=\"1\">פעיל</md-option><md-option \nng-selected=\"branch.Status==0 || branch.Status==\'0\'\" ng-value=\"0\">לא פעיל</md-option></md-select></md-input-container>\n<md-input-container class=\"md-block\"><md-icon md-font-icon=\"icon-account\"></md-icon><label>פטור מדמי חבר</label>\n<md-select ng-model=\"branch.FreeMemberFay\" placeholder=\"פטור מדמי חבר\" ng-disabled=\"$root.AdminLevel<3\"><md-option \nng-value=\"\'1\'\">כן</md-option><md-option ng-value=\"\'0\'\">לא</md-option></md-select></md-input-container>\n<md-input-container class=\"md-block\"><md-icon md-font-icon=\"icon-home\"></md-icon><label>תשלום בטופס התחייבות</label>\n<md-select ng-model=\"branch.KibutzPay\" placeholder=\"תשלום בטופס התחייבות\" ng-disabled=\"$root.AdminLevel<3\"><md-option \nng-value=\"\'2\'\">חלקי</md-option><md-option ng-value=\"\'1\'\">כן</md-option><md-option ng-value=\"\'0\'\">לא</md-option>\n</md-select></md-input-container><md-input-container class=\"md-block\" ng-if=\"branch.KibutzPay == \'1\'\"><md-icon \nmd-font-icon=\"icon-home\"></md-icon><label>נעילת תשלום באשראי</label><md-select ng-model=\"branch.LockCreditPay\" \nplaceholder=\"נעילת תשלום באשראי\" ng-disabled=\"$root.AdminLevel<3\"><md-option ng-value=\"\'1\'\">כן</md-option><md-option \nng-value=\"\'0\'\">לא</md-option></md-select></md-input-container></form></md-content>");
$templateCache.put("app/main/pages/branches/views/branches/new-branch-dialog/new-branch-dialog.html","<md-dialog class=\"new-branch-dialog\" aria-label=\"New Task\" ng-init=\"getAreas()\"><form name=\"newBranchForm\" \ndata-ng-model=\"newBranchForm\" class=\"md-inline-form\" validate><md-toolbar class=\"md-accent\" layout=\"column\"><div \nclass=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">\nיצירה חדשה</span><md-button class=\"md-icon-button\" ng-click=\"closeDialog()\" aria-label=\"Close dialog\" \nng-disabled=\"isClicked\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content \nms-scroll><md-input-container class=\"md-block\"><md-icon md-font-icon=\"icon-domain\" class=\"name\"></md-icon><label>שם\n</label><input ng-model=\"newBranch.Name\" ng-required=\"true\" ng-disabled=\"isClicked\"></md-input-container><div \nclass=\"md-block md-icon-left\" style=\"display: -webkit-box\"><md-icon md-font-icon=\"icon-city\" class=\"name\" \nstyle=\"padding-top: 20px\"></md-icon><md-autocomplete style=\"min-width: 410px\" md-selected-item-change=\"setCity(item)\" \nng-disabled=\"isClicked\" md-input-name=\"autocompleteField\" md-no-cache=\"noCache\" md-selected-item=\"selectedItem\" \nmd-search-text=\"searchText\" md-items=\"item in querySearch(searchText)\" md-item-text=\"item.display\" md-min-length=\"0\" \nmd-floating-label=\"שם ישוב\"><md-item-template><span md-highlight-text=\"searchText\" md-highlight-flags=\"^i\">\n{{item.display}}</span></md-item-template><md-not-found>ישוב לא נמצא</md-not-found></md-autocomplete></div>\n<md-input-container class=\"md-block\"><md-icon md-font-icon=\"icon-domain\" class=\"name\"></md-icon><label>איזור</label>\n<md-select ng-model=\"newBranch.AreaID\" ng-disabled=\"!areas || isClicked\"><md-option ng-repeat=\"area in areas\" \nng-value=\"area.ID\">{{area.Name}}</md-option></md-select></md-input-container><md-input-container class=\"md-block\">\n<md-icon md-font-icon=\"icon-panorama-horizontal\" class=\"name\"></md-icon><label>כתובת</label><input \nng-model=\"newBranch.Address\" ng-disabled=\"isClicked\"></md-input-container><md-input-container class=\"md-block\"><md-icon\n md-font-icon=\"icon-phone\" class=\"name\"></md-icon><label>מספר טלפון</label><input ng-model=\"newBranch.Phone\" \nng-disabled=\"isClicked\"></md-input-container><md-input-container class=\"md-block\"><md-icon md-font-icon=\"icon-email\" \nclass=\"name\"></md-icon><label>אימייל</label><input ng-model=\"newBranch.Email\" type=\"email\" ng-disabled=\"isClicked\">\n</md-input-container><md-input-container class=\"md-block\"><md-icon md-font-icon=\"icon-email\" class=\"name\"></md-icon>\n<label>אימייל לקבלת בקשות סבסוד</label><input ng-model=\"newBranch.SubsidyEmail\" type=\"email\" ng-disabled=\"isClicked\">\n</md-input-container><md-input-container class=\"md-block\"><md-icon md-font-icon=\"icon-power\" class=\"name\"></md-icon>\n<label>סטטוס</label><md-select ng-model=\"newBranch.Status\" placeholder=\"סטטוס\" ng-required=\"true\" \nng-disabled=\"isClicked\"><md-option ng-value=\"1\">פעיל</md-option><md-option ng-value=\"0\">לא פעיל</md-option></md-select>\n</md-input-container></md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><div \nlayout=\"row\" layout-align=\"start center\"><md-button data-ng-disabled=\"newBranchForm.$invalid || isClicked\" \ntype=\"submit\" ng-click=\"saveNewBranch()\" class=\"send-button md-accent md-raised\" aria-label=\"Add Task\">שמירה\n</md-button></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/pages/branches/views/groups/groups-panel/groups-panel.html","<md-content ms-scroll><form name=\"groupsForm\" id=\"groups-panel\" data-ng-model=\"groupForm\" class=\"md-inline-form\" \nvalidate><md-toolbar class=\"md-accent\" layout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" \nlayout-align=\"space-between center\" style=\"padding-top: 25px\"><span class=\"title\">עריכה מהירה</span><md-button \nclass=\"md-icon-button\" ng-click=\"$root.closePanel()\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-input-container class=\"md-icon-float md-block\"><label>שם {{$root.User.Group}}</label><md-icon \nmd-font-icon=\"icon-account-multiple\" class=\"name\"></md-icon><input ng-model=\"group.Name\" type=\"text\">\n</md-input-container><md-input-container class=\"md-block\"><md-icon md-font-icon=\"icon-city\" class=\"name\"></md-icon>\n<label>{{$root.User.Branch}}</label><md-select ng-model=\"group.BranchID\" ng-required=\"true\" \nng-disabled=\"!branches.length\"><md-option ng-repeat=\"branch in branches\" ng-value=\"branch.ID\">{{branch.Name}}\n</md-option></md-select></md-input-container><md-input-container class=\"md-block\"><md-icon \nmd-font-icon=\"icon-chair-school\" class=\"name\"></md-icon><label>{{$root.User.Grades}}</label><md-select \nmd-on-close=\"clearSearchTerm()\" ng-model=\"group.Grades\" ng-required=\"true\" multiple=\"true\"><md-select-header \nclass=\"demo-select-header\"><input ng-model=\"searchTerm\" type=\"text\" ng-disabled=\"!grades || isClicked\" \nng-keydown=\"$event.stopPropagation()\" placeholder=\"חפש שכבה..\" class=\"demo-header-searchbox md-text\" \nautocomplete=\"off\"></md-select-header><md-optgroup ng-disabled=\"!grades || isClicked\"><md-option ng-value=\"grade.ID\" \nng-repeat=\"grade in grades |filter:searchTerm\">{{grade.Name}}</md-option></md-optgroup></md-select>\n</md-input-container><md-input-container class=\"md-block\"><md-icon md-font-icon=\"icon-power\" class=\"name\"></md-icon>\n<label>סטטוס</label><md-select ng-model=\"group.Status\" placeholder=\"סטטוס\" ng-disabled=\"$root.AdminLevel<2\"><md-option \nng-selected=\"group.Status==1 || group.Status==\'1\'\" ng-value=\"1\">פעיל</md-option><md-option \nng-selected=\"group.Status==0 || group.Status==\'0\'\" ng-value=\"0\">לא פעיל</md-option></md-select></md-input-container>\n</form></md-content>");
$templateCache.put("app/main/pages/branches/views/groups/group-management/group-management.html","<div id=\"group-management\" class=\"page-layout simple tabbed\"><div class=\"header md-accent-bg\" layout=\"column\" \nlayout-align=\"center center\" layout-gt-sm=\"row\" layout-align-gt-sm=\"space-between end\"><div class=\"user-info\" \nlayout=\"column\" layout-align=\"center center\" layout-gt-sm=\"row\" layout-align-gt-sm=\"start center\"><div class=\"name\">\nקבוצה {{group.Name}}</div></div></div><div class=\"content\" flex><div layout=\"row\" layout-sm=\"column\" \nlayout-align=\"space-around\" ng-if=\"!group\"><md-progress-circular md-mode=\"indeterminate\"></md-progress-circular></div>\n<md-tabs md-dynamic-height id=\"group-management-tab\" ng-if=\"group\"><md-tab \nng-disabled=\"$root.isEdit && selectedTab!=0\" md-on-select=\"setTab(0)\"><md-tab-label><span>כללי</span></md-tab-label>\n<md-tab-body><md-content \nng-include=\"\'app/main/pages/branches/views/groups/group-management/tabs/general/general.html\'\"></md-content>\n</md-tab-body></md-tab><md-tab ng-disabled=\"$root.isEdit && selectedTab!=1\" md-on-select=\"setTab(1)\"><md-tab-label>\n<span>אנשי קשר</span></md-tab-label><md-tab-body><md-content \nng-include=\"\'app/main/pages/branches/views/groups/group-management/tabs/contacts/contacts.html\'\"></md-content>\n</md-tab-body></md-tab><md-tab ng-disabled=\"$root.isEdit && selectedTab!=2\" md-on-select=\"setTab(2)\"><md-tab-label>\n<span>מדריכים</span></md-tab-label><md-tab-body><md-content \nng-include=\"\'app/main/pages/branches/views/groups/group-management/tabs/educators/educators.html\'\"></md-content>\n</md-tab-body></md-tab></md-tabs></div></div>");
$templateCache.put("app/main/pages/branches/views/groups/new-group-dialog/new-group-dialog.html","<md-dialog class=\"new-group-dialog\" aria-label=\"New Task\" ng-init=\"getBranches();getGrades();\"><form \nname=\"newGroupForm\" data-ng-model=\"newGroupForm\" class=\"md-inline-form\" validate><md-toolbar class=\"md-accent\" \nlayout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\">\n<span class=\"title\">הוספה</span><md-button class=\"md-icon-button\" ng-click=\"closeDialog()\" aria-label=\"Close dialog\" \ntranslate translate-attr-aria-label=\"MANAGE_USERS.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content ms-scroll><md-input-container class=\"md-block\"><md-icon \nmd-font-icon=\"icon-account-multiple\" class=\"name\"></md-icon><label>שם</label><input ng-model=\"newGroup.Name\" \ntype=\"text\" ng-required=\"true\" ng-disabled=\"isClicked\"></md-input-container><md-input-container class=\"md-block\">\n<md-icon md-font-icon=\"icon-city\" class=\"name\"></md-icon><label>בחר {{$root.User.Branch}}</label><md-select \nng-model=\"newGroup.BranchID\" required ng-disabled=\"!branches.length || isClicked\"><md-select-header \nclass=\"demo-select-header\"><input ng-model=\"vm.searchTerm2\" type=\"text\" ng-keydown=\"$event.stopPropagation()\" \nplaceholder=\"חפש {{$root.User.Branch}}..\" class=\"demo-header-searchbox md-text\" autocomplete=\"off\"></md-select-header>\n<md-optgroup ng-disabled=\"!vm.branches || isClicked\"><md-option ng-value=\"branch.ID\" \nng-repeat=\"branch in branches |filter:vm.searchTerm2\">{{branch.Name}}</md-option></md-optgroup></md-select>\n</md-input-container><md-input-container class=\"md-block\"><md-icon md-font-icon=\"icon-chair-school\" class=\"name\">\n</md-icon><label>בחר {{$root.User.Grade}}</label><md-select md-on-close=\"clearSearchTerm()\" ng-model=\"newGroup.Grades\" \nng-required=\"true\" multiple=\"true\"><md-select-header class=\"demo-select-header\"><input ng-model=\"searchTerm\" \ntype=\"text\" ng-disabled=\"!grades || isClicked\" ng-keydown=\"$event.stopPropagation()\" placeholder=\"חפש שכבה..\" \nclass=\"demo-header-searchbox md-text\" autocomplete=\"off\"></md-select-header><md-optgroup \nng-disabled=\"!grades || isClicked\"><md-option ng-value=\"grade.ID\" ng-repeat=\"grade in grades |filter:searchTerm\">\n{{grade.Name}}</md-option></md-optgroup></md-select></md-input-container></md-dialog-content><md-dialog-actions \nlayout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-button \ndata-ng-disabled=\"newGroupForm.$invalid || isClicked\" type=\"submit\" ng-click=\"saveNewGroup()\" \nclass=\"send-button md-accent md-raised\" aria-label=\"Add Task\">שמירה</md-button></div></md-dialog-actions></form>\n</md-dialog>");
$templateCache.put("app/main/pages/events/views/events/event-management/event-management.html","<div id=\"event-management\" class=\"page-layout simple tabbed\"><div class=\"header md-accent-bg\" layout=\"column\" \nlayout-align=\"center center\" layout-gt-sm=\"row\" layout-align-gt-sm=\"space-between end\"><p class=\"user-info\" \nlayout=\"column\" layout-align=\"center center\" layout-gt-sm=\"row\" layout-align-gt-sm=\"start center\"><a \nng-click=\"updateImage()\" style=\"cursor: pointer\"><img style=\"background: gainsboro\" class=\"profile-image avatar huge\" \nng-src=\"{{event.Image ? event.Image : \'\'}}\"></a></p><div class=\"name\" ng-click=\"isInCart && goToCartEvent()\">\n{{event.Name}} {{isInCart? \' - משוייך לאירוע סל (\'+inCartDetails.CartName+\')\' : \'\'}}</div></div><div class=\"content\" \nflex><div layout=\"row\" layout-sm=\"column\" layout-align=\"space-around\" ng-if=\"!event\"><md-progress-circular \nmd-mode=\"indeterminate\"></md-progress-circular></div><md-tabs md-dynamic-height id=\"event-management-tab\" \nng-if=\"event\"><md-tab ng-disabled=\"$root.isEdit && selectedTab!=0\" md-on-select=\"setTab(0)\"><md-tab-label><span>כללי\n</span></md-tab-label><md-tab-body><md-content \nng-include=\"\'app/main/pages/events/views/events/event-management/tabs/general/general.html\'\"></md-content>\n</md-tab-body></md-tab><md-tab \nng-disabled=\"($root.isEdit && selectedTab!=1) || $root.AdminLevel==1 || ($root.AdminLevel==2 && event.CoordinatorID!=$root.User.ID)\" \nmd-on-select=\"setTab(1)\"><md-tab-label><span>תשלום</span></md-tab-label><md-tab-body><md-content \nng-include=\"\'app/main/pages/events/views/events/event-management/tabs/payments/payments.html\'\"></md-content>\n</md-tab-body></md-tab><md-tab ng-if=\"event.EventType != 1 && event.CartEvent!=1\" \nng-disabled=\"($root.isEdit && selectedTab!=2) || $root.AdminLevel==1 || ($root.AdminLevel==2 && event.CoordinatorID!=$root.User.ID)\" \nmd-on-select=\"setTab(2)\"><md-tab-label><span>שיוכים</span></md-tab-label><md-tab-body><md-content \nng-include=\"\'app/main/pages/events/views/events/event-management/tabs/association/association.html\'\"></md-content>\n</md-tab-body></md-tab><md-tab ng-if=\"event.EventType != 1\" \nng-disabled=\"($root.isEdit && selectedTab!=3) || $root.AdminLevel==1 || ($root.AdminLevel==2 && event.CoordinatorID!=$root.User.ID)\" \nmd-on-select=\"setTab(3)\"><md-tab-label><span>קבצים</span></md-tab-label><md-tab-body><md-content \nng-if=\"selectedTab==3\" ng-include=\"\'app/main/pages/events/views/events/event-management/tabs/files/files.html\'\">\n</md-content></md-tab-body></md-tab><md-tab ng-if=\"event.CartEvent!=1\" \nng-disabled=\"($root.isEdit && selectedTab!=4) || $root.AdminLevel==1 || (! $root.User.EditQuestions && $root.AdminLevel==2 && event.CoordinatorID!=$root.User.ID)\" \nmd-on-select=\"setTab(4)\"><md-tab-label><span>שאלות</span></md-tab-label><md-tab-body><md-content \nng-if=\"selectedTab==4\" \nng-include=\"\'app/main/pages/events/views/events/event-management/tabs/questions/questions.html\'\"></md-content>\n</md-tab-body></md-tab><md-tab ng-if=\"event.EventType != 1 && !event.IsProduct && event.CartEvent!=1\" \nng-disabled=\"($root.isEdit && selectedTab!=5 ) || $root.AdminLevel==1 || ($root.AdminLevel==2 && event.CoordinatorID!=$root.User.ID)\" \nmd-on-select=\"setTab(5)\"><md-tab-label><span>הסעות</span></md-tab-label><md-tab-body><md-content \nng-if=\"selectedTab==5\" \nng-include=\"\'app/main/pages/events/views/events/event-management/tabs/transportation/transportation.html\'\">\n</md-content></md-tab-body></md-tab><md-tab ng-if=\"event.EventType != 1 && !event.IsProduct\" \nng-disabled=\"($root.isEdit && selectedTab!=6) || $root.AdminLevel==1 || ($root.AdminLevel==2 && event.CoordinatorID!=$root.User.ID)\" \nmd-on-select=\"setTab(6)\"><md-tab-label><span>הנחות</span></md-tab-label><md-tab-body><md-content \nng-if=\"selectedTab==6\" \nng-include=\"\'app/main/pages/events/views/events/event-management/tabs/discounts/discounts.html\'\"></md-content>\n</md-tab-body></md-tab><md-tab ng-disabled=\"$root.isEdit && selectedTab!=7\" md-on-select=\"setTab(7)\"><md-tab-label>\n<span>נרשמים</span></md-tab-label><md-tab-body><md-content ng-if=\"event.EventType != 1 && selectedTab==7\" \nng-include=\"\'app/main/pages/events/views/events/event-management/tabs/subscribers/subscribers.html\'\"></md-content>\n<md-content ng-if=\"event.EventType == 1 && selectedTab==7\" \nng-include=\"\'app/main/pages/events/views/events/event-management/tabs/external-subscribers/external-subscribers.html\'\">\n</md-content></md-tab-body></md-tab><md-tab ng-disabled=\"($root.isEdit && selectedTab!=8 ) || $root.AdminLevel==1\" \nmd-on-select=\"setTab(8)\"><md-tab-label><span>סטטיסטיקה</span></md-tab-label><md-tab-body><md-content \nng-if=\"selectedTab==8\" \nng-include=\"\'app/main/pages/events/views/events/event-management/tabs/statistics/statistics.html\'\"></md-content>\n</md-tab-body></md-tab><md-tab ng-if=\"event.EventType != 1 && event.CartEvent!=1\" \nng-disabled=\"($root.isEdit && selectedTab!=9 ) || $root.AdminLevel==1 || ($root.AdminLevel==2 && event.CoordinatorID!=$root.User.ID)\" \nmd-on-select=\"setTab(9)\"><md-tab-label><span>הצעות רכישה</span></md-tab-label><md-tab-body><md-content \nng-if=\"selectedTab==9\" \nng-include=\"\'app/main/pages/events/views/events/event-management/tabs/suggestions/suggestions.html\'\"></md-content>\n</md-tab-body></md-tab><md-tab ng-if=\"event.EventType != 1\" \nng-disabled=\"($root.isEdit && selectedTab!=10 ) || $root.AdminLevel==1 || ($root.AdminLevel==2 && event.CoordinatorID!=$root.User.ID)\" \nmd-on-select=\"setTab(10)\"><md-tab-label><span>תרומות <span class=\"fcgreen hfs12\" \nng-if=\"totalDonations && totalDonations > 0 && ($root.AdminLevel == 3 || ($root.AdminLevel==2 && event.CoordinatorID==$root.User.ID))\">\n({{totalDonations}}₪)</span></span></md-tab-label><md-tab-body><md-content ng-if=\"selectedTab==10\" \nng-include=\"\'app/main/pages/events/views/events/event-management/tabs/donations/donations.html\'\"></md-content>\n</md-tab-body></md-tab><md-tab ng-if=\"event.CartEvent==1\" ng-disabled=\"$root.isEdit && selectedTab!=11\" \nmd-on-select=\"setTab(11)\"><md-tab-label><span>{{$root.User.Event}}י סל</span></md-tab-label><md-tab-body><md-content \nng-include=\"\'app/main/pages/events/views/events/event-management/tabs/cart-events/cart-events.html\'\"></md-content>\n</md-tab-body></md-tab></md-tabs></div></div>");
$templateCache.put("app/main/pages/events/views/events/new-event-dialog/new-event-dialog.html","<md-dialog class=\"new-Event-dialog\" aria-label=\"New Task\" style=\"overflow: visible !important\" ng-init=\"init();\"><form \nname=\"newEventForm\" data-ng-model=\"newEventForm\" class=\"md-inline-form\" validate style=\"overflow: visible !important\">\n<md-toolbar class=\"md-accent\" layout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" \nlayout-align=\"space-between center\"><span class=\"title\">הוספת {{title}} חדש</span><md-button class=\"md-icon-button\" \nng-click=\"closeDialog()\" aria-label=\"Close dialog\" translate translate-attr-aria-label=\"MANAGE_USERS.CLOSE_DIALOG\">\n<md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content \nstyle=\"overflow: visible !important\"><md-input-container class=\"md-icon-float md-block\" \nng-show=\"title==$root.User.Event\"><md-icon md-font-icon=\"icon-cart\"></md-icon><label>{{title}} סל</label><md-select \nng-model=\"newEvent.CartEvent\" placeholder=\"{{title}} סל\" ng-init=\"newEvent.CartEvent=0\" ng-disabled=\"isClicked\">\n<md-option ng-value=\"0\">לא</md-option><md-option ng-value=\"1\">כן</md-option></md-select></md-input-container>\n<md-input-container ng-show=\"externalEventsEnabled\" class=\"md-icon-float md-block\" ng-if=\"newEvent.CartEvent == 0\">\n<md-icon md-font-icon=\"icon-filter\"></md-icon><label></label><md-select ng-model=\"newEvent.EventType\" \nplaceholder=\"מקום הצגת {{title}}\" ng-disabled=\"isClicked\"><md-option ng-value=\"0\">{{title}} פורטל הורים</md-option>\n<md-option ng-value=\"1\">אתר הרשמה ציבורי</md-option></md-select></md-input-container><md-input-container \nclass=\"md-icon-float md-block\" ng-show=\"title==$root.User.Event && newEvent.CartEvent == 0\"><md-icon \nmd-font-icon=\"icon-weather-sunny\"></md-icon><label>יצירת {{title}}</label><md-select \nng-model=\"newEvent.DuplicateEventSelect\" placeholder=\"סוג {{title}}\" ng-init=\"newEvent.DuplicateEvent=1\" \nng-disabled=\"isClicked\"><md-option ng-value=\"1\">{{title}} חדש</md-option><md-option ng-value=\"2\">שכפול {{title}} קיים\n</md-option></md-select></md-input-container><md-input-container class=\"md-icon-float md-block\" \nng-show=\"(newEvent.DuplicateEventSelect==2 || newEvent.DuplicateEventSelect==\'2\') && title==$root.User.Event \"><label>\n{{title}}</label><md-icon md-svg-icon=\"weather-sunny\"></md-icon><md-select md-on-close=\"clearSearchTerm()\" \nng-model=\"newEvent.DuplicateEvent\" ng-change=\"setName()\" ng-disabled=\"isClicked\"><md-select-header \nclass=\"demo-select-header\"><input ng-model=\"searchTerm\" type=\"text\" ng-disabled=\"isClicked\" \nng-keydown=\"$event.stopPropagation()\" ng-keyup=\"eventKeyPress($event)\" placeholder=\"חפש {{title}}..\" \nclass=\"demo-header-searchbox md-text\" autocomplete=\"off\"></md-select-header><md-optgroup \nng-disabled=\"!events ||isClicked\"><md-option ng-value=\"event\" ng-repeat=\"event in events |filter:searchTerm\">\n{{event.Name}}</md-option></md-optgroup></md-select></md-input-container><md-input-container \nclass=\"md-icon-float md-block md-icon-left\"><md-icon md-font-icon=\"icon-weather-sunny\"></md-icon><label>שם {{title}}\n</label><input ng-model=\"newEvent.Name\" type=\"text\" ng-required=\"true\" ng-disabled=\"isClicked\"></md-input-container>\n<md-input-container class=\"md-icon-float md-block md-icon-left\" \nng-show=\"title==$root.User.Event && newEvent.CartEvent == 0\"><md-icon md-font-icon=\"icon-calendar-select\"></md-icon>\n<label>תאריך התחלה</label><div start-view=\"day\" locale=\"he\" format=\"DD/MM/YYYY\" moment-picker=\"newEvent.StartDate\">\n<input autocomplete=\"off\" ng-model=\"newEvent.StartDate\" \nng-required=\"title==$root.User.Event && newEvent.CartEvent == 0\" ng-disabled=\"isClicked\"></div></md-input-container>\n<md-input-container class=\"md-icon-float md-block md-icon-left\" \nng-show=\"title==$root.User.Event && newEvent.CartEvent == 0\"><md-icon md-font-icon=\"icon-calendar-select\"></md-icon>\n<div start-view=\"day\" locale=\"he\" format=\"DD/MM/YYYY\" moment-picker=\"newEvent.EndDate\"><label>תאריך סיום</label><input \nautocomplete=\"off\" ng-model=\"newEvent.EndDate\" ng-disabled=\"isClicked\" \nng-required=\"title==$root.User.Event  && newEvent.CartEvent == 0\"></div></md-input-container></md-dialog-content>\n<md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\">\n<md-button data-ng-disabled=\"newEventForm.$invalid || isClicked\" type=\"submit\" ng-click=\"saveNewEvent()\" \nclass=\"send-button md-accent md-raised\" aria-label=\"Add Task\">שמירה</md-button></div></md-dialog-actions></form>\n</md-dialog>");
$templateCache.put("app/main/pages/events/views/questions/new-question-dialog/new-question-dialog.html","<md-dialog class=\"newQuestion-dialog\" aria-label=\"New Task\" ng-init=\"getAllBranches()\"><form name=\"newQuestionForm\" \ndata-ng-model=\"newQuestionForm\" class=\"md-inline-form\" validate><md-toolbar class=\"md-accent\" layout=\"column\"><div \nclass=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">\nהוספת שאלה חדשה</span><md-button class=\"md-icon-button\" ng-click=\"closeDialog()\" aria-label=\"Close dialog\" translate \ntranslate-attr-aria-label=\"MANAGE_USERS.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content ms-scroll><md-input-container class=\"md-icon-float md-block\"><md-icon \nmd-font-icon=\"icon-question-mark-circle\"></md-icon><label>תיאור השאלה</label><textarea \nng-model=\"newQuestion.Description\" type=\"text\" ng-required=\"true\" ng-disabled=\"isClicked\"></textarea>\n</md-input-container><md-input-container class=\"md-block\"><md-icon md-font-icon=\"icon-format-align-right\"></md-icon>\n<label>סוג שאלה</label><md-select ng-model=\"newQuestion.AnswerType\" placeholder=\"סוג שאלה\" ng-required=\"true\" \nng-disabled=\"isClicked\"><md-option ng-value=\"1\">שאלה פתוחה</md-option><md-option ng-value=\"2\">אפשרויות</md-option>\n<md-option ng-value=\"3\">קובץ</md-option><md-option ng-value=\"4\">תאריך</md-option></md-select></md-input-container>\n<md-input-container class=\"md-icon-float md-block\" layout=\"row\" flex=\"100\" ng-if=\"eventID\"><md-icon \nmd-font-icon=\"icon-domain\"></md-icon><md-select ng-model=\"newQuestion.BranchID\"><md-select-header \nclass=\"demo-select-header\"><input ng-model=\"searchTerm2\" type=\"text\" ng-keydown=\"$event.stopPropagation()\" \nplaceholder=\"שיוך ל{{$root.User.Branch}} ספציפי\" class=\"demo-header-searchbox md-text\" autocomplete=\"off\">\n</md-select-header><md-optgroup><md-option ng-value=\"null\">כולם</md-option><md-option \nng-repeat=\"branch in branches | orderBy:\'Name\' | filter:searchTerm2\" ng-value=\"branch.ID\">{{branch.Name}}</md-option>\n</md-optgroup></md-select></md-input-container><md-input-container class=\"md-block\" ng-if=\"newQuestion.AnswerType==2\">\n<label>אפשרויות</label><md-chips ng-model=\"newQuestion.Options\" readonly=\"false\" md-removable=\"true\" \nng-required=\"true\" ng-disabled=\"isClicked\"></md-chips></md-input-container></md-dialog-content><md-dialog-actions \nlayout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-button \ndata-ng-disabled=\"newQuestionForm.$invalid || isClicked\" type=\"submit\" ng-click=\"saveNewQuestion()\" \nclass=\"send-button md-accent md-raised\" aria-label=\"Add Task\">שמירה</md-button></div></md-dialog-actions></form>\n</md-dialog>");
$templateCache.put("app/main/pages/events/views/questions/question-panel/question-panel.html","<md-content ms-scroll><form name=\"questionForm\" id=\"questionForm\" data-ng-model=\"questionForm\" class=\"md-inline-form\" \nvalidate><md-toolbar class=\"md-accent\" layout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" \nlayout-align=\"space-between center\"><span class=\"title\">עריכת שאלה</span><md-button class=\"md-icon-button\" \nng-click=\"$root.closePanel()\" aria-label=\"Close Dialog\" translate \ntranslate-attr-aria-label=\"PROFILE_PANEL.CLOSE_PANEL\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-input-container class=\"md-icon-float md-block\"><md-icon md-font-icon=\"icon-question-mark-circle\">\n</md-icon><label>תיאור השאלה</label><textarea ng-model=\"question.Description\" type=\"text\"></textarea>\n</md-input-container><md-input-container class=\"md-block\"><md-icon md-font-icon=\"icon-format-align-right\"></md-icon>\n<label>סוג שאלה</label><md-select ng-model=\"question.AnswerType\" placeholder=\"סוג שאלה\"><md-option \nng-selected=\"question.AnswerType==1 || question.AnswerType==\'1\'\" ng-value=\"1\">שאלה פתוחה</md-option><md-option \nng-selected=\"question.AnswerType==2 || question.AnswerType==\'2\'\" ng-value=\"2\">אפשרויות</md-option><md-option \nng-selected=\"question.AnswerType==3 || question.AnswerType==\'2\'\" ng-value=\"3\">קובץ</md-option><md-option \nng-selected=\"question.AnswerType==4 || question.AnswerType==\'4\'\" ng-value=\"4\">תאריך</md-option></md-select>\n</md-input-container><md-input-container class=\"md-block\" ng-if=\"question.AnswerType==2\"><md-icon md-font-icon=\"\">\n</md-icon><label>אפשרויות</label><md-chips ng-model=\"question.Options\" readonly=\"false\" md-removable=\"true\"></md-chips>\n</md-input-container><md-input-container class=\"md-block\"><md-icon md-font-icon=\"icon-power\"></md-icon><label>סטטוס\n</label><md-select ng-model=\"question.Status\" placeholder=\"סטטוס\"><md-option \nng-selected=\"question.Status==0 || question.Status==\'0\'\" ng-value=\"0\">לא פעיל</md-option><md-option \nng-selected=\"question.Status==1 || question.Status==\'1\'\" ng-value=\"1\">פעיל</md-option></md-select></md-input-container>\n</form></md-content>");
$templateCache.put("app/main/pages/events/views/transportation/new-transportation-dialog/new-transportation-dialog.html","<md-dialog class=\"newTransportation-dialog\" aria-label=\"New Task\"><form name=\"newTransportationForm\" \ndata-ng-model=\"newTransportationForm\" class=\"md-inline-form\" validate><md-toolbar class=\"md-accent\" layout=\"column\">\n<div class=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"title\">הוספת הסעה</span><md-button class=\"md-icon-button\" ng-click=\"closeDialog()\" aria-label=\"Close dialog\" \ntranslate translate-attr-aria-label=\"MANAGE_USERS.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content ms-scroll><md-input-container class=\"md-icon-float md-block\"><md-icon\n md-font-icon=\"icon-bus\"></md-icon><label>שם הסעה</label><textarea ng-model=\"newTransportation.Name\" type=\"text\" \nng-required=\"true\" ng-disabled=\"isClicked\"></textarea></md-input-container></md-dialog-content><md-dialog-actions \nlayout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-button \ndata-ng-disabled=\"newTransportationForm.$invalid || isClicked\" type=\"submit\" ng-click=\"saveNewTransportation()\" \nclass=\"send-button md-accent md-raised\" aria-label=\"Add Task\">שמירה</md-button></div></md-dialog-actions></form>\n</md-dialog>");
$templateCache.put("app/main/pages/events/views/transportation/transportation-panel/transportation-panel.html","<md-content ms-scroll><form name=\"questionForm\" id=\"questionForm\" data-ng-model=\"questionForm\" class=\"md-inline-form\" \nvalidate><md-toolbar class=\"md-accent\" layout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" \nlayout-align=\"space-between center\"><span class=\"title\">עריכת הסעה</span><md-button class=\"md-icon-button\" \nng-click=\"$root.closePanel()\" aria-label=\"Close Dialog\" translate \ntranslate-attr-aria-label=\"PROFILE_PANEL.CLOSE_PANEL\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-input-container class=\"md-icon-float md-block\"><md-icon md-font-icon=\"icon-bus\"></md-icon><label>\nשם הסעה</label><input type=\"text\" ng-model=\"transportation.Name\"></md-input-container><md-input-container \nclass=\"md-block\"><md-icon md-font-icon=\"icon-power\"></md-icon><label>סטטוס</label><md-select \nng-model=\"transportation.Status\" placeholder=\"סטטוס\"><md-option \nng-selected=\"transportation.Status==0 || transportation.Status==\'0\'\" ng-value=\"0\">לא פעיל</md-option><md-option \nng-selected=\"transportation.Status==1 || transportation.Status==\'1\'\" ng-value=\"1\">פעיל</md-option></md-select>\n</md-input-container></form></md-content>");
$templateCache.put("app/main/pages/settings/tabs/profile/field-panel/field-panel.html","<md-content ms-scroll><form name=\"fieldForm\" id=\"fieldForm\" data-ng-model=\"fieldForm\" class=\"md-inline-form\" validate>\n<md-toolbar class=\"md-accent\" layout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" \nlayout-align=\"space-between center\"><span class=\"title\">עריכת שדה</span><md-button class=\"md-icon-button\" \nng-click=\"$root.closePanel()\" aria-label=\"Close Dialog\" translate \ntranslate-attr-aria-label=\"PROFILE_PANEL.CLOSE_PANEL\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-input-container class=\"md-icon-float md-block\"><md-icon md-font-icon=\"icon-question-mark-circle\">\n</md-icon><label>תיאור שדה</label><textarea ng-model=\"field.Title\" type=\"text\"></textarea></md-input-container>\n<md-input-container class=\"md-block\"><md-icon md-font-icon=\"icon-format-align-right\"></md-icon><label>סוג שדה</label>\n<md-select ng-model=\"field.Type\" placeholder=\"סוג שדה\"><md-option \nng-selected=\"field.AnswerType==1 || field.AnswerType==\'1\'\" ng-value=\"1\">שאלה פתוחה</md-option><md-option \nng-selected=\"field.AnswerType==2 || field.AnswerType==\'2\'\" ng-value=\"2\">אפשרויות</md-option><md-option \nng-selected=\"field.AnswerType==3 || field.AnswerType==\'3\'\" ng-value=\"3\">תאריך</md-option><md-option \nng-selected=\"field.AnswerType==4 || field.AnswerType==\'4\'\" ng-value=\"4\">קובץ</md-option></md-select>\n</md-input-container><md-input-container class=\"md-block\"><md-icon md-font-icon=\"icon-account\"></md-icon><label>\nהאם להציג בפרופיל</label><md-select ng-model=\"field.ShowInProfile\" placeholder=\"האם להציג בפרופיל\" ng-required=\"true\" \nng-disabled=\"isClicked\"><md-option ng-value=\"1\">כן</md-option><md-option ng-value=\"0\">לא</md-option></md-select>\n</md-input-container><md-input-container class=\"md-block\" ng-if=\"field.Type==2\"><md-icon md-font-icon=\"\"></md-icon>\n<label>אפשרויות</label><md-chips ng-model=\"field.Values\" readonly=\"false\" md-removable=\"true\"></md-chips>\n</md-input-container><md-input-container class=\"md-block\"><md-checkbox ng-model=\"field.Requierd\" \nng-disabled=\"isClicked\" ng-true-value=\"\'1\'\" ng-false-value=\"\'0\'\">שדה חובה</md-checkbox></md-input-container>\n<md-input-container class=\"md-block\"><md-icon md-font-icon=\"icon-power\"></md-icon><label>סטטוס</label><md-select \nng-model=\"field.Status\" placeholder=\"סטטוס\"><md-option ng-selected=\"field.Status==0 || field.Status==\'0\'\" ng-value=\"0\">\nלא פעיל</md-option><md-option ng-selected=\"field.Status==1 || field.Status==\'1\'\" ng-value=\"1\">פעיל</md-option>\n</md-select></md-input-container></form></md-content>");
$templateCache.put("app/main/pages/settings/tabs/profile/new-field-dialog/new-field-dialog.html","<md-dialog class=\"newField-dialog\" aria-label=\"New Task\"><form name=\"newFieldForm\" data-ng-model=\"newFieldForm\" \nclass=\"md-inline-form\" validate><md-toolbar class=\"md-accent\" layout=\"column\"><div \nclass=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">\nהוספת שדה חדשה</span><md-button class=\"md-icon-button\" ng-click=\"closeDialog()\" aria-label=\"Close dialog\" translate \ntranslate-attr-aria-label=\"MANAGE_USERS.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content ms-scroll><md-input-container class=\"md-icon-float md-block\"><md-icon \nmd-font-icon=\"icon-question-mark-circle\"></md-icon><label>תיאור השדה</label><textarea ng-model=\"newField.Title\" \ntype=\"text\" ng-required=\"true\" ng-disabled=\"isClicked\"></textarea></md-input-container><md-input-container \nclass=\"md-block\"><md-icon md-font-icon=\"icon-format-align-right\"></md-icon><label>סוג שדה</label><md-select \nng-model=\"newField.Type\" placeholder=\"סוג שדה\" ng-required=\"true\" ng-disabled=\"isClicked\"><md-option ng-value=\"1\">\nשאלה פתוחה</md-option><md-option ng-value=\"2\">אפשרויות</md-option><md-option ng-value=\"3\">תאריך</md-option><md-option \nng-value=\"4\">קובץ</md-option></md-select></md-input-container><md-input-container class=\"md-block\"><md-icon \nmd-font-icon=\"icon-account\"></md-icon><label>האם להציג בפרופיל</label><md-select ng-model=\"newField.ShowInProfile\" \nplaceholder=\"האם להציג בפרופיל\" ng-required=\"true\" ng-disabled=\"isClicked\"><md-option ng-value=\"1\">כן</md-option>\n<md-option ng-value=\"0\">לא</md-option></md-select></md-input-container><md-input-container class=\"md-block\" \nng-if=\"newField.Type==2\"><label>אפשרויות</label><md-chips ng-model=\"newField.Values\" readonly=\"false\" \nmd-removable=\"true\" ng-required=\"true\" ng-disabled=\"isClicked\"></md-chips></md-input-container><md-input-container \nclass=\"md-block\"><md-checkbox ng-model=\"newField.Requierd\" ng-disabled=\"isClicked\" ng-true-value=\"1\" \nng-false-value=\"0\">שדה חובה</md-checkbox></md-input-container></md-dialog-content><md-dialog-actions layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-button \ndata-ng-disabled=\"newFieldForm.$invalid || isClicked\" type=\"submit\" ng-click=\"saveNewField()\" \nclass=\"send-button md-accent md-raised\" aria-label=\"Add Task\">שמירה</md-button></div></md-dialog-actions></form>\n</md-dialog>");
$templateCache.put("app/main/pages/settings-menue/views/accountancy-settings/tabs/accounts.html","<md-content class=\"profile-box info-box md-whiteframe-1dp\" ng-init=\"vm.getAccountancySettings()\"><div \nclass=\"info-header\"><md-icon md-svg-icon=\"information\"></md-icon><span class=\"title\">\nתיקי הכנסות יעודכנו בדו\"ח ייצוא הנהלת חשבונות מהמערכת</span></div><md-content class=\"content md-padding\"><div \nlayout=\"row\" layout-sm=\"column\" layout-align=\"space-around\" ng-show=\"!vm.accountancy\"><md-progress-circular \nmd-mode=\"indeterminate\"></md-progress-circular></div><form name=\"upgradeGradeForm\" class=\"md-inline-form\" validate \nng-show=\"vm.accountancy\"><div class=\"row\" layout=\"row\"><div class=\"half\"><md-input-container class=\"md-block\"><label>\nמספר לקוח - מרבליקס</label><input ng-model=\"vm.accountancy.MarvilixID\" ng-disabled=\"!vm.accountancy || vm.isClicked\">\n</md-input-container></div><div class=\"half\"><md-input-container class=\"md-block\"><label>מספר קבוע צ\'קים</label><input \nng-model=\"vm.accountancy.CheckID\" ng-disabled=\"!vm.accountancy || vm.isClicked\"></md-input-container></div></div><div \nclass=\"row\" layout=\"row\"><div class=\"half\"><md-input-container class=\"md-block\"><label>מספר קבוע ויזה</label><input \nng-model=\"vm.accountancy.VisaID\" ng-disabled=\"!vm.accountancy || vm.isClicked\"></md-input-container></div><div \nclass=\"half\"><md-input-container class=\"md-block\"><label>מספר קבוע ישראקרד</label><input \nng-model=\"vm.accountancy.IsraCard\" ng-disabled=\"!vm.accountancy || vm.isClicked\"></md-input-container></div></div><div \nclass=\"row\" layout=\"row\"><div class=\"half\"><md-input-container class=\"md-block\"><label>מספר קבוע אמריקן אקספרס</label>\n<input ng-model=\"vm.accountancy.AmericanExpress\" ng-disabled=\"!vm.accountancy || vm.isClicked\"></md-input-container>\n</div><div class=\"half\"><md-input-container class=\"md-block\"><label>מספר קבוע מאסטקארד</label><input \nng-model=\"vm.accountancy.MasterCard\" ng-disabled=\"!vm.accountancy || vm.isClicked\"></md-input-container></div></div>\n<div class=\"row\" layout=\"row\"><div class=\"half\"><md-input-container class=\"md-block\"><label>מספר קבוע דיינרס</label>\n<input ng-model=\"vm.accountancy.DinersID\" ng-disabled=\"!vm.accountancy || vm.isClicked\"></md-input-container></div><div\n class=\"half\"><md-input-container class=\"md-block\"><label>מספר קבוע מזומן</label><input \nng-model=\"vm.accountancy.CashID\" ng-disabled=\"!vm.accountancy || vm.isClicked\"></md-input-container></div></div><div \nclass=\"row\" layout=\"row\"><div class=\"half\"><md-input-container class=\"md-block\"><label>מספר קבוע חשבון פנימי</label>\n<input ng-model=\"vm.accountancy.InnerTransID\" ng-disabled=\"!vm.accountancy || vm.isClicked\"></md-input-container></div>\n<div class=\"half\"><md-input-container class=\"md-block\"><label>מספר תשלומים מקסימלי</label><input type=\"number\" \nng-model=\"vm.accountancy.GlobalMaxNumOfPayments\" ng-disabled=\"!vm.accountancy || vm.isClicked\"></md-input-container>\n</div></div><div class=\"row\" layout=\"row\"><div class=\"half\"><md-input-container class=\"md-block\"><label>\nמספר קבוע תרומות אמץ חניך</label><input ng-model=\"vm.accountancy.DonationsID\" \nng-disabled=\"!vm.accountancy || vm.isClicked\"></md-input-container></div></div><md-button ng-disabled=\"vm.isClicked\" \nclass=\"md-raised md-accent\" ng-click=\"vm.updateAccountancy()\" style=\"margin-right: 0px\">עדכון</md-button></form>\n</md-content></md-content>");
$templateCache.put("app/main/pages/settings-menue/views/accountancy-settings/tabs/banks.html","<md-content class=\"profile-box info-box md-whiteframe-1dp\"><div class=\"info-header\"><md-icon md-svg-icon=\"information\">\n</md-icon><span class=\"title\">\nחשבונות בנק שמקושרים לתנועה. בהוספת הרשמות חדשות באמצעות העברה בנקאית ניתן לבחור את החשבון שאליו הופקד התשלום.</span>\n</div><md-content class=\"content md-padding\"><form name=\"upgradeGradeForm\" class=\"md-inline-form\" validate><div><div \nclass=\"half\" lass=\"row\" layout=\"row\"><table class=\"dataTable row-border hover\"><thead><tr><th data-priority=\"1\" \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">שם בנק</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">מספר תיק הכנסות</span></div></th></tr>\n</thead><tbody><tr ng-repeat=\"item in vm.accountancy.Banks\"><td><md-input-container class=\"md-block\"><label>שם בנק\n</label><input ng-model=\"item.Name\" ng-disabled=\"vm.isClicked\"></md-input-container></td><td><md-input-container \nclass=\"md-block\"><label>מספר קבוע בנק</label><input ng-model=\"item.Number\" ng-disabled=\"vm.isClicked\">\n</md-input-container></td></tr></tbody></table></div></div><md-button ng-disabled=\"vm.isClicked\" \nclass=\"md-raised md-accent\" ng-click=\"vm.addBank()\" style=\"margin-right: 0px\">הוספת בנק</md-button><md-button \nng-disabled=\"vm.isClicked\" class=\"md-raised md-accent\" ng-click=\"vm.updateAccountancy()\" style=\"margin-right: 0px\">\nעדכון</md-button></form></md-content></md-content>");
$templateCache.put("app/main/pages/settings-menue/views/accountancy-settings/tabs/general.html","<md-content class=\"profile-box info-box md-whiteframe-1dp\"><md-content class=\"content md-padding\"><form \nname=\"upgradeGradeForm\" class=\"md-inline-form\" validate><div layout=\"row\" layout-wrap><div class=\"filters\" \nlayout=\"row\" layout-xs=\"column\" flex=\"100\" flex-sm=\"100\" flex-gt-md=\"50\"><div layout=\"column\" flex=\"100\" \nflex-gt-sm=\"50\" flex-md=\"33\" flex-xs=\"100\"><md-input-container class=\"md-icon-float md-block\" layout=\"column\" \nlayout-xs=\"row\" flex=\"100\" flex-gt-sm=\"50\" flex-gt-md=\"40\"><md-icon md-font-icon=\"icon-domain\" class=\"name\"></md-icon>\n<label>הפקת קבלה בסטטוס שולם לרכז</label><md-select ng-model=\"vm.accountancy.CoordinatorReceipts\"><md-option \nng-value=\"1\">פעיל</md-option><md-option ng-value=\"0\">לא פעיל</md-option></md-select></md-input-container></div><div \nlayout=\"column\" flex=\"100\" flex-gt-sm=\"50\" flex-md=\"33\" flex-xs=\"100\"><md-input-container \nclass=\"md-icon-float md-block\" layout=\"column\" layout-xs=\"row\" flex=\"100\" flex-gt-sm=\"50\" flex-gt-md=\"40\"><md-icon \nmd-font-icon=\"icon-cash\" class=\"name\"></md-icon><label>אמץ חניך פעיל (תרומות)</label><md-select \nng-model=\"vm.accountancy.EnableDonations\" ng-change=\"vm.showDonationsAlert()\"><md-option ng-value=\"1\">פעיל</md-option>\n<md-option ng-value=\"0\">לא פעיל</md-option></md-select></md-input-container></div></div></div><md-button \nng-disabled=\"vm.isClicked\" class=\"md-raised md-accent\" ng-click=\"vm.updateAccountancy()\" style=\"margin-right: 0px\">\nעדכון</md-button></form></md-content></md-content>");
$templateCache.put("app/main/pages/settings-menue/views/admin-settings/tabs/coordinators.html","<md-content class=\"profile-box info-box md-whiteframe-1dp\" ng-init=\"vm.getRoles()\"><div class=\"info-header\"><md-icon \nmd-svg-icon=\"information\"></md-icon><span class=\"title\">\nניתן לייצר הגדרות תפקידים של רכזים, לדגומא רכז מפעלים. לאחר מכן תוכלו לשייך כל רכז לתפקיד ולבצע חיפוש של רכזים לפי התפקיד שלהם\n</span></div><md-content class=\"content md-padding\" ng-hide=\"!vm.roles\"><form name=\"UserForm\" class=\"md-inline-form\" \nvalidate><div layout=\"row\" layout-wrap class=\"chip-container\"><label>הוספת תגית רכזים</label><md-chips \nng-model=\"vm.roles\"></md-chips></div><br><md-button class=\"md-raised md-accent\" ng-disabled=\"vm.isClikced\" \nng-click=\"vm.updateRoles()\">עדכון</md-button></form></md-content></md-content>");
$templateCache.put("app/main/pages/settings-menue/views/admin-settings/tabs/tags.html","<md-content class=\"profile-box info-box md-whiteframe-1dp\" ng-init=\"vm.getTags()\"><div class=\"info-header\"><md-icon \nmd-svg-icon=\"information\"></md-icon><span class=\"title\">\nתגיות מאפשרות לסווג חניכים והורים לקבוצות. בעמודי הניהול תוכלו לבצע חיפוש וסינון לפי התגיות. סטטוסים מאפשרים סיווג נרשים ע\"פי סטטוסים בעמוד נרשמים ל{{$root.User.Event}}.\n</span></div><md-content class=\"content md-padding\"><div layout=\"row\" layout-sm=\"column\" layout-align=\"space-around\" \nng-show=\"!vm.studentsTags || !vm.parentsTags\"><md-progress-circular md-mode=\"indeterminate\"></md-progress-circular>\n</div><form name=\"UserForm\" class=\"md-inline-form\" ng-show=\"vm.studentsTags && vm.parentsTags\" validate><div \nlayout=\"row\" layout-wrap class=\"pb10 chip-container\"><label>הוספת תגית חניכים</label><md-chips \nng-model=\"vm.studentsTags\"></md-chips></div><div layout=\"row\" layout-wrap class=\"chip-container\"><label>\nהוספת תגית הורים</label><md-chips ng-model=\"vm.parentsTags\"></md-chips></div><br><div layout=\"row\" layout-wrap \nclass=\"chip-container\"><label>סוגי סטטוס נוכחות</label><md-chips ng-model=\"vm.systemSettings.AttendenceStatus\">\n</md-chips></div><div layout=\"row\" layout-wrap class=\"chip-container\"><label>הוספת תגית {{$root.User.Branches}}</label>\n<md-chips ng-model=\"vm.systemSettings.BranchesTags\"></md-chips></div><br><md-button class=\"md-raised md-accent\" \nng-disabled=\"vm.isClikced\" ng-click=\"vm.updateTags()\">עדכון</md-button></form></md-content></md-content>");
$templateCache.put("app/main/pages/settings-menue/views/admin-settings/tabs/upgrade-grade.html","<md-content class=\"profile-box admin-settings info-box md-whiteframe-1dp\" ng-init=\"vm.getGrades()\"><div \nclass=\"info-header\"><md-icon md-svg-icon=\"information\"></md-icon><span class=\"title\">\nבכל סוף שנה\\תחילת שנה חדשה צריך להעביר את כל החניכים לשנה הבאה. <span class=\"red\">יש להתחיל מהשכבה הגובה ביותר</span>\n</span></div><md-content class=\"content md-padding\"><form name=\"upgradeGradeForm\" class=\"md-inline-form\" validate><div \nclass=\"row\" layout=\"row\"><md-input-container class=\"md-block\"><label>{{$root.User.Grade}} נבחרת</label><md-select \nng-model=\"vm.upgrade.SelectedGrade\" ng-required=\"true\" ng-disabled=\"!vm.grades || vm.isClicked \"><md-option \nng-repeat=\"gradeValue in vm.grades\" ng-value=\"gradeValue.ID\">{{gradeValue.Name}}</md-option></md-select>\n</md-input-container></div><div class=\"row\" layout=\"row\"><md-input-container class=\"md-block\"><label>\n{{$root.User.Grade}} חדשה</label><md-select ng-model=\"vm.upgrade.NewGrade\" \nng-disabled=\"!vm.upgrade.SelectedGrade || vm.isClicked \" ng-required=\"true\"><md-option \nng-repeat=\"gradeValue in vm.grades\" ng-value=\"gradeValue.ID\">{{gradeValue.Name}}</md-option></md-select>\n</md-input-container></div><div class=\"row\" layout=\"row\"><md-input-container class=\"md-block\"><md-radio-group \nng-model=\"vm.upgrade.Type\" ng-init=\"vm.upgrade.Type = 1\"><md-radio-button value=\"1\" \ntitle=\"יווצרו קבוצות חדשות עבור החניכים בהתאם לסניף ולשכבה החדשה\">יצירת קבוצות חדשות</md-radio-button><md-radio-button \nvalue=\"2\" title=\"הקבוצה הנוכחית של החניך תעלה שכבה ביחד איתו\">העלאת קבוצות ישנות</md-radio-button></md-radio-group>\n</md-input-container></div><md-button ng-disabled=\"vm.isClicked || upgradeGradeForm.$invalid\" \nclass=\"md-raised md-accent\" aria-label=\"עדכן שכבה\" ng-click=\"vm.updateGrade(grade)\" style=\"margin-right: 0px\">עדכן\n</md-button></form></md-content></md-content>");
$templateCache.put("app/main/pages/settings-menue/views/external-registrations-settings/tabs/links.html","<div flex=\"100\" flex-xs=\"100\" ng-init=\"vm.getExternalSettings()\"><md-content \nclass=\"profile-box info-box md-whiteframe-1dp\"><div class=\"info-header\"><md-icon md-svg-icon=\"information\"></md-icon>\n<span class=\"title\">לינקים להצגה באתר ההרשמות החיצוני</span></div><md-content class=\"content md-padding\"><form \nname=\"upgradeGradeForm\" class=\"md-inline-form\" validate><div class=\"row\"><md-input-container \nclass=\"md-icon-float md-block\"><label>קישור פורטל תשלומים</label><md-icon md-svg-icon=\"link-variant\"></md-icon><input \nng-model=\"vm.externalEvent.Portal\" md-autofocus \nng-disabled=\"$root.AdminLevel==1 || ($root.AdminLevel==2 && event.CoordinatorID!=$root.User.ID)\"></md-input-container>\n</div><div class=\"row\"><md-input-container class=\"md-icon-float md-block\"><label>קישור אתר התנועה</label><md-icon \nmd-svg-icon=\"link-variant\"></md-icon><input ng-model=\"vm.externalEvent.Website\" md-autofocus \nng-disabled=\"$root.AdminLevel==1 || ($root.AdminLevel==2 && event.CoordinatorID!=$root.User.ID)\"></md-input-container>\n</div><div class=\"row\"><md-input-container class=\"md-icon-float md-block\"><label>קישור יצירת קשר</label><md-icon \nmd-svg-icon=\"link-variant\"></md-icon><input ng-model=\"vm.externalEvent.Contact\" md-autofocus \nng-disabled=\"$root.AdminLevel==1 || ($root.AdminLevel==2 && event.CoordinatorID!=$root.User.ID)\"></md-input-container>\n</div><div class=\"row\"><md-input-container class=\"md-icon-float md-block\"><label>קישור אתר תרומות</label><md-icon \nmd-svg-icon=\"link-variant\"></md-icon><input ng-model=\"vm.externalEvent.Donate\" md-autofocus \nng-disabled=\"$root.AdminLevel==1 || ($root.AdminLevel==2 && event.CoordinatorID!=$root.User.ID)\"></md-input-container>\n</div><div class=\"row\"><md-input-container class=\"md-icon-float md-block\"><label>כותרת ראשית אתר</label><md-icon \nmd-svg-icon=\"link-variant\"></md-icon><input ng-model=\"vm.externalEvent.MainTitle\" md-autofocus \nng-disabled=\"$root.AdminLevel==1 || ($root.AdminLevel==2 && event.CoordinatorID!=$root.User.ID)\"></md-input-container>\n</div><div class=\"row\"><md-input-container class=\"md-icon-float md-block\"><label>כותרת משנית אתר</label><md-icon \nmd-svg-icon=\"link-variant\"></md-icon><input ng-model=\"vm.externalEvent.SubTitle\" md-autofocus \nng-disabled=\"$root.AdminLevel==1 || ($root.AdminLevel==2 && event.CoordinatorID!=$root.User.ID)\"></md-input-container>\n</div><div class=\"row\"><md-input-container class=\"md-icon-float md-block\"><label>קישור אתר תרומות</label><md-icon \nmd-svg-icon=\"link-variant\"></md-icon><input ng-model=\"vm.externalEvent.Donate\" md-autofocus \nng-disabled=\"$root.AdminLevel==1 || ($root.AdminLevel==2 && event.CoordinatorID!=$root.User.ID)\"></md-input-container>\n</div><md-button ng-disabled=\"vm.isClicked\" class=\"md-raised md-accent\" aria-label=\"עדכן פרטים\" \nng-click=\"vm.updateExternalSettings()\">עדכן</md-button></form></md-content></md-content></div>");
$templateCache.put("app/main/pages/settings-menue/views/external-registrations-settings/tabs/terms.html","<div flex=\"100\" flex-xs=\"100\" ng-init=\"vm.getExternalSettings()\"><md-content \nclass=\"profile-box info-box md-whiteframe-1dp\"><div class=\"info-header\"><md-icon md-svg-icon=\"information\"></md-icon>\n<span class=\"title\">תנאי השימוש יופיע במערכת הרישום החיצוני</span></div><md-content class=\"content md-padding\"><div \nlayout=\"row\" layout-sm=\"column\" layout-align=\"space-around\" ng-show=\"!vm.externalEvent\"><md-progress-circular \nmd-mode=\"indeterminate\"></md-progress-circular></div><form name=\"upgradeGradeForm\" class=\"md-inline-form\" \nng-show=\"vm.externalEvent\" validate><div class=\"row\" layout=\"row\"><div ckeditor=\"vm.options\" \nng-model=\"vm.externalEvent.Terms\"></div></div><md-button type=\"submit\" \nng-disabled=\"!vm.externalEvent.Terms || vm.isClicked\" class=\"md-raised md-accent\" \nng-click=\"vm.updateExternalSettings()\">עדכון</md-button></form></md-content></md-content></div>");
$templateCache.put("app/main/pages/settings-menue/views/general-settings/tabs/entities.html","<div flex=\"100\" flex-xs=\"100\"><md-content class=\"profile-box info-box md-whiteframe-1dp\"><div class=\"info-header\">\n<md-icon md-svg-icon=\"information\"></md-icon><span class=\"title\">\nלכל ארגון יש את הטרמינולוגיה שלו, כאן תוכלו לשנות את השמות שיופיע בתוכנה ובפרופיל ההורה בלשון יחיד ורבים</span></div>\n<md-content class=\"content md-padding\"><form name=\"upgradeGradeForm\" class=\"md-inline-form\" validate><div class=\"row\" \nlayout=\"row\"><div class=\"half\"><md-input-container class=\"md-block\"><md-icon md-font-icon=\"icon-city\" class=\"name\">\n</md-icon><label>סניף</label><input ng-model=\"vm.systemSettings.Branch\" \nng-disabled=\"!vm.systemSettings || vm.isClicked\"></md-input-container></div><div class=\"half\"><md-input-container \nclass=\"md-block\"><md-icon md-font-icon=\"icon-city\" class=\"name\"></md-icon><label>סניפים</label><input \nng-model=\"vm.systemSettings.Branches\" ng-disabled=\"!vm.systemSettings || vm.isClicked\"></md-input-container></div>\n</div><div class=\"row\" layout=\"row\"><div class=\"half\"><md-input-container class=\"md-block\"><label>שכבה</label><md-icon \nmd-font-icon=\"icon-chair-school\" class=\"name\"></md-icon><input ng-model=\"vm.systemSettings.Grade\" \nng-disabled=\"!vm.systemSettings || vm.isClicked\"></md-input-container></div><div class=\"half\"><md-input-container \nclass=\"md-block\"><label>שכבות</label><md-icon md-font-icon=\"icon-chair-school\" class=\"name\"></md-icon><input \nng-model=\"vm.systemSettings.Grades\" ng-disabled=\"!vm.systemSettings || vm.isClicked\"></md-input-container></div></div>\n<div class=\"row\" layout=\"row\"><div class=\"half\"><md-input-container class=\"md-block\"><md-icon \nmd-font-icon=\"icon-account-multiple\" class=\"name\"></md-icon><label>קבוצה</label><input \nng-model=\"vm.systemSettings.Group\" ng-disabled=\"!vm.systemSettings || vm.isClicked\"></md-input-container></div><div \nclass=\"half\"><md-input-container class=\"md-block\"><md-icon md-font-icon=\"icon-account-multiple\" class=\"name\"></md-icon>\n<label>קבוצות</label><input ng-model=\"vm.systemSettings.Groups\" ng-disabled=\"!vm.systemSettings || vm.isClicked\">\n</md-input-container></div></div><div class=\"row\" layout=\"row\"><div class=\"half\"><md-input-container class=\"md-block\">\n<md-icon md-font-icon=\"icon-leaf\" class=\"name\"></md-icon><label>פעילות</label><input \nng-model=\"vm.systemSettings.Activity\" ng-disabled=\"!vm.systemSettings || vm.isClicked\"></md-input-container></div><div \nclass=\"half\"><md-input-container class=\"md-block\"><label>פעילויות</label><md-icon md-font-icon=\"icon-leaf\" \nclass=\"name\"></md-icon><input ng-model=\"vm.systemSettings.Activities\" ng-disabled=\"!vm.systemSettings || vm.isClicked\">\n</md-input-container></div></div><div class=\"row\" layout=\"row\"><div class=\"half\"><md-input-container class=\"md-block\">\n<md-icon md-font-icon=\"icon-tie\" class=\"name\"></md-icon><label>רכז</label><input \nng-model=\"vm.systemSettings.Coordinator\" ng-disabled=\"!vm.systemSettings || vm.isClicked\"></md-input-container></div>\n<div class=\"half\"><md-input-container class=\"md-block\"><label>רכזים</label><md-icon md-font-icon=\"icon-tie\" \nclass=\"name\"></md-icon><input ng-model=\"vm.systemSettings.Coordinators\" \nng-disabled=\"!vm.systemSettings || vm.isClicked\"></md-input-container></div></div><div class=\"row\" layout=\"row\"><div \nclass=\"half\"><md-input-container class=\"md-block\"><md-icon md-font-icon=\"icon-calendar\" class=\"name\"></md-icon><label>\n{{$root.User.Event}}</label><input ng-model=\"vm.systemSettings.Event\" ng-disabled=\"!vm.systemSettings || vm.isClicked\">\n</md-input-container></div><div class=\"half\"><md-input-container class=\"md-block\"><label>{{$root.User.Events}}</label>\n<md-icon md-font-icon=\"icon-calendar\" class=\"name\"></md-icon><input ng-model=\"vm.systemSettings.Events\" \nng-disabled=\"!vm.systemSettings || vm.isClicked\"></md-input-container></div></div><md-button \nng-disabled=\"vm.isClicked\" class=\"md-raised md-accent\" aria-label=\"עדכן מילון מונחים\" \nng-click=\"vm.updateSystemSettings()\" style=\"margin-right: 0px\">עדכון</md-button></form></md-content></md-content></div>");
$templateCache.put("app/main/pages/settings-menue/views/general-settings/tabs/organization-details.html","<div flex=\"100\" flex-xs=\"100\"><md-content class=\"profile-box info-box md-whiteframe-1dp\"><div class=\"info-header\">\n<md-icon md-svg-icon=\"information\"></md-icon><span class=\"title\">פרטי הארגון - יופיעו בפרופיל ההורה ועל הקבלות שיופקו\n</span></div><md-content class=\"content md-padding\"><div layout=\"row\" layout-sm=\"column\" layout-align=\"space-around\" \nng-show=\"!vm.systemSettings\"><md-progress-circular md-mode=\"indeterminate\"></md-progress-circular></div><form \nname=\"upgradeGradeForm\" class=\"md-inline-form\" ng-show=\"vm.systemSettings\" validate><div class=\"row\" layout=\"row\"><div \nclass=\"w28\"><md-input-container class=\"md-block\"><md-icon md-font-icon=\"icon-city\" class=\"name\"></md-icon><label>\nשם הארגון</label><input ng-model=\"vm.systemSettings.BranName\" ng-disabled=\"!vm.systemSettings || vm.isClicked\">\n</md-input-container></div><div class=\"w28\"><md-input-container class=\"md-block\"><md-icon md-svg-icon=\"numeric\" \nclass=\"name\"></md-icon><label>מספר הארגון</label><input ng-model=\"vm.systemSettings.BranNumber\" \nng-disabled=\"!vm.systemSettings || vm.isClicked\"></md-input-container></div></div><div class=\"row\" layout=\"row\"><div \nclass=\"w28\"><md-input-container class=\"md-block\"><label>כתובת הארגון</label><md-icon md-svg-icon=\"map-marker\" \nclass=\"name\"></md-icon><input ng-model=\"vm.systemSettings.BrandAddress\" \nng-disabled=\"!vm.systemSettings || vm.isClicked\"></md-input-container></div><div class=\"w28\"><md-input-container \nclass=\"md-block\"><md-icon md-font-icon=\"icon-phone\" class=\"name\"></md-icon><label>מספר טלפון</label><input \nng-model=\"vm.systemSettings.BrandPhoneNumber\" ng-disabled=\"!vm.systemSettings || vm.isClicked\"></md-input-container>\n</div></div><div class=\"row\" layout=\"row\"><div class=\"w28\"><md-input-container class=\"md-block\"><label>מספר פקס</label>\n<md-icon md-svg-icon=\"fax\" class=\"name\"></md-icon><input ng-model=\"vm.systemSettings.BrandFaxNumber\" \nng-disabled=\"!vm.systemSettings || vm.isClicked\"></md-input-container></div><div class=\"w28\"><md-input-container \nclass=\"md-block\"><md-icon md-font-icon=\"icon-email\" class=\"name\"></md-icon><label>מייל</label><input \nng-model=\"vm.systemSettings.BrandEmail\" ng-disabled=\"!vm.systemSettings || vm.isClicked\"></md-input-container></div>\n</div><div class=\"row\" layout=\"row\"><div class=\"w28\"><md-input-container class=\"md-block\"><label>אתר אינטרנט</label>\n<md-icon md-font-icon=\"icon-web\" class=\"name\"></md-icon><input ng-model=\"vm.systemSettings.BrandWebsite\" \nng-disabled=\"!vm.systemSettings || vm.isClicked\"></md-input-container></div></div><md-button \nng-disabled=\"vm.isClicked\" class=\"md-raised md-accent\" aria-label=\"עדכן  {{$root.User.Grade}}\" \nng-click=\"vm.updateSystemSettings()\" style=\"margin-right: 0px\">עדכון</md-button></form></md-content></md-content></div>");
$templateCache.put("app/main/pages/settings-menue/views/general-settings/tabs/personalized.html","<div flex=\"100\" flex-xs=\"100\"><md-content class=\"profile-box info-box md-whiteframe-1dp\"><div class=\"info-header\">\n<md-icon md-svg-icon=\"information\"></md-icon><span class=\"title\">\nהתאמה אישית - הפרטים שתעדכנו יופיעו בפרופיל ההורה ובתוכנת הניהול</span></div><md-content class=\"content md-padding\">\n<form name=\"upgradeGradeForm\" class=\"md-inline-form\" validate><div class=\"row\" layout=\"row\"><div class=\"w28\"><div \nlayout=\"column\" flex=\"100\" flex-gt-sm=\"50\" flex-gt-md=\"50\"><md-input-container ng-repeat=\"image in vm.adminImages\" \nclass=\"md-icon-float md-block\" layout=\"column\" layout-xs=\"row\" flex=\"100\" flex-xs=\"100\" flex-gt-sm=\"100\" \nflex-gt-md=\"100\"><md-icon ng-if=\"!image.Value\" md-svg-icon=\"upload\" class=\"name\"></md-icon><md-icon \nng-disabled=\"vm.isClicked\" ng-if=\"image.Value\" md-svg-icon=\"eye\" href=\"{{image.Value}}\" \nng-click=\"vm.viewFile(image.Value)\" style=\"cursor: pointer\" title=\"צפייה בקובץ\" class=\"name\"></md-icon><label>\n{{image.DisplayName}}</label><input ng-disabled=\"vm.isClicked\" ngf-select=\"vm.uploadFile($file,image)\" \nplaceholder=\"{{image.FileName}}\" ng-model=\"file\" name=\"file\" ngf-pattern=\"\'image/*\'\" style=\"cursor: pointer\" \nreadonly=\"readonly\"></md-input-container></div></div></div><md-button ng-disabled=\"vm.isClicked\" \nclass=\"md-raised md-accent\" ng-click=\"vm.updateAdminImageSettings()\" style=\"margin-right: 0px\">עדכון</md-button></form>\n</md-content></md-content></div>");
$templateCache.put("app/main/pages/settings-menue/views/profile-settings/tabs/birthday.html","<div flex=\"100\" flex-xs=\"100\" class=\"fields-settings birthday-settings\" ng-init=\"vm.getSystemBirthdaySettings()\">\n<md-content class=\"profile-box info-box md-whiteframe-1dp\"><div class=\"info-header\"><md-icon md-svg-icon=\"information\">\n</md-icon><span class=\"title\">ניתן להגדיר שליחת ברכת יום הולדת בצורה אוטמטית לחניכים</span></div><md-content \nclass=\"content md-padding\"><form name=\"upgradeGradeForm\" class=\"md-inline-form\" validate><div class=\"row\" layout=\"row\">\n<md-input-container class=\"md-block\"><label>סטטוס</label><md-select ng-model=\"vm.birthdaySettings.Status\" \nng-required=\"true\" ng-disabled=\"!vm.birthdaySettings || vm.isClicked \"><md-option ng-value=\"1\">פעיל</md-option>\n<md-option ng-value=\"0\">לא פעיל</md-option></md-select></md-input-container></div><div class=\"row\" layout=\"row\">\n<md-input-container class=\"md-block\"><label>כותרת להצגה בתבנית</label><textarea \nng-disabled=\"!vm.updateSystemBirthdaySettings || vm.isClicked \" ng-model=\"vm.birthdaySettings.Title\"></textarea>\n</md-input-container></div><div class=\"row\" layout=\"row\"><md-input-container class=\"md-block\"><label>תוכן להצגה בתבנית\n</label><textarea ng-disabled=\"!vm.updateSystemBirthdaySettings || vm.isClicked \" ng-model=\"vm.birthdaySettings.Body\">\n</textarea></md-input-container></div><md-button ng-disabled=\"vm.isClicked || upgradeGradeForm.$invalid\" \nclass=\"md-raised md-accent\" aria-label=\"עדכן שכבה\" ng-click=\"vm.updateSystemBirthdaySettings()\" \nstyle=\"margin-right: 0px\">עדכן</md-button></form></md-content></md-content></div>");
$templateCache.put("app/main/pages/settings-menue/views/profile-settings/tabs/externalDiscountPopup.html","<div flex=\"100\" flex-xs=\"100\" class=\"fields-settings birthday-settings\" ng-init=\"vm.getSystemBirthdaySettings()\">\n<md-content class=\"profile-box info-box md-whiteframe-1dp\"><div class=\"info-header\"><md-icon md-svg-icon=\"information\">\n</md-icon><span class=\"title\">חלונית שתופיע לאחר הרשמת הורה חדש במידה ואינו רשום לרשות הטבע והגנים</span></div>\n<md-content class=\"content md-padding\"><form name=\"modalSettingsForm\" class=\"md-inline-form\" validate><div class=\"row\" \nlayout=\"row\"><md-input-container class=\"md-block\"><label>כותרת להצגה בתבנית</label><textarea \nng-disabled=\"!vm.updateExternalDiscountIdsSettings || vm.isClicked \" ng-model=\"vm.modalSettings.title\"></textarea>\n</md-input-container></div><div class=\"row\" layout=\"row\"><md-input-container class=\"md-block\"><label>תוכן להצגה בתבנית\n</label><textarea ng-disabled=\"!vm.updateExternalDiscountIdsSettings || vm.isClicked \" \nng-model=\"vm.modalSettings.content\"></textarea></md-input-container></div><div class=\"row\" layout=\"row\">\n<md-input-container class=\"md-block\"><label>טקסט על הכפתור</label><textarea \nng-disabled=\"!vm.updateExternalDiscountIdsSettings || vm.isClicked \" ng-model=\"vm.modalSettings.btnText\"></textarea>\n</md-input-container></div><div class=\"row\" layout=\"row\"><md-input-container class=\"md-block\"><label>\nקישור - לחיצה על הכפתור</label><textarea ng-disabled=\"!vm.updateExternalDiscountIdsSettings || vm.isClicked \" \nng-model=\"vm.modalSettings.btnLink\"></textarea></md-input-container></div><md-button \nng-disabled=\"vm.isClicked || modalSettingsForm.$invalid\" class=\"md-raised md-accent\" aria-label=\"עדכן \" \nng-click=\"vm.updateExternalDiscountIdsSettings()\" style=\"margin-right: 0px\">עדכן</md-button></form></md-content>\n</md-content></div>");
$templateCache.put("app/main/pages/settings-menue/views/profile-settings/tabs/fields-dy.html","<div flex=\"100\" flex-xs=\"100\" class=\"fields-settings\" ng-init=\"vm.fetchAllExtraStudentFields();\"><md-content \nclass=\"profile-box info-box md-whiteframe-1dp\"><div class=\"info-header\"><md-icon md-svg-icon=\"information\"></md-icon>\n<span class=\"title\">ניתן להגדיר שדות נוספים ברישום חניכים למערכת</span></div><md-content class=\"content md-padding\">\n<form name=\"emailsForm\" class=\"md-inline-form\" validate><div class=\"row form\" layout=\"row\"><div class=\"content table\">\n<div ng-if=\"vm.extraStudentFields\" class=\"events-table-c\"><table id=\"fields-table\" \nclass=\"dataTable row-border hover stripe md-ink-ripple\" datatable=\"ng\" dt-instance=\"dtInstance\" \ndt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">\nשאלה</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">סוג שאלה</span>\n</div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">סטטוס</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">פעולות</span></div></th></tr></thead>\n<tbody><tr class=\"main-table-new\" ng-repeat=\"field in vm.extraStudentFields  \"><td>{{field.Title}}</td><td>\n{{vm.extraFieldType(field.Type)}}</td><td>{{field.Status==1 || field.Status==\'1\' ? \'פעיל\' : \'לא פעיל\'}}</td><td>\n<md-button class=\"preview-user\" ng-click=\"vm.editField(field)\" title=\"עריכה\"><md-icon md-svg-icon=\"pencil\"></md-icon>\n</md-button></td></tr></tbody></table></div></div></div><md-button ng-disabled=\"vm.isClicked\" \nclass=\"md-raised md-accent\" ng-click=\"vm.openNewFieldDialog()\">שדה חדש</md-button></form></md-content></md-content>\n</div>");
$templateCache.put("app/main/pages/settings-menue/views/profile-settings/tabs/fields.html","<div flex=\"100\" flex-xs=\"100\" class=\"fields-settings\" ng-init=\"vm.fetchAllStudentFields()\"><md-content \nclass=\"profile-box info-box md-whiteframe-1dp\"><div class=\"info-header\"><md-icon md-svg-icon=\"information\"></md-icon>\n<span class=\"title\">ניתן להגדיר את שדות החובה ברישום חניך למערכת ולהוסיף שדות נוספים בצורה דינמית</span></div>\n<md-content class=\"content md-padding\"><form name=\"emailsForm\" class=\"md-inline-form\" validate><label \nclass=\"header-title\">שדות חובה לרישום חניך</label><div class=\"row form\" layout=\"row\"><div class=\"content\"><div \nlayout-wrap=\"\" layout-gt-md=\"row\"><div flex-gt-md=\"30\" ng-repeat=\"field in vm.studentfields\"><md-input-container \nstyle=\"width: 100%\"><md-checkbox ng-model=\"field.required\" \ndata-ng-disabled=\"vm.mandatoryStudentFields.includes(field.name)\" aria-label=\"{{field.he_title}}\">{{field.he_title}}\n</md-checkbox></md-input-container></div></div></div></div><md-button ng-disabled=\"vm.isClicked\" \nclass=\"md-raised md-accent\" ng-click=\"vm.updateStudentFields()\" style=\"margin-right: 0px\">עדכון</md-button></form>\n</md-content></md-content></div>");
$templateCache.put("app/main/pages/settings-menue/views/profile-settings/tabs/forms.html","<div flex=\"100\" flex-xs=\"100\" ng-init=\"vm.getEmails();vm.getProfileSettings();\" class=\"forms-settings\"><md-content \nclass=\"profile-box info-box md-whiteframe-1dp\"><div class=\"info-header\"><md-icon md-svg-icon=\"information\"></md-icon>\n<span class=\"title\">ניתן להגדיר כתובת מייל שקיבלו עדכון על כל פניה מכל טופס בפרופיל הורה בנוסך, הפניות יופיעו גם בתוכנה\n</span></div><md-content class=\"content md-padding\"><form name=\"emailsForm\" class=\"md-inline-form\" validate><label \nclass=\"header-title\">כתובת מיילים</label><div class=\"row form\" layout=\"row\" ng-repeat=\"setting in vm.settings\" \nng-if=\"setting.DisplayName!=\'סוגי פניות מהפרופיל\' && vm.settingsReady\"><div class=\"half\" \nng-if=\"setting.Property != \'ContactText\'\"><md-input-container class=\"md-block\"><label>{{setting.DisplayName}}</label>\n<md-chips ng-model=\"setting.Value\" readonly=\"false\" md-removable=\"true\"></md-chips></md-input-container></div></div>\n<label class=\"header-title\">סוגי פניות</label><div class=\"row form\" layout=\"row\" ng-repeat=\"setting in vm.settings\" \nng-if=\"setting.DisplayName==\'סוגי פניות מהפרופיל\' && vm.settingsReady\"><div class=\"half\"><md-input-container \nclass=\"md-block\"><label>{{setting.DisplayName}}</label><md-chips ng-model=\"setting.Value\" readonly=\"false\" \nmd-removable=\"true\"></md-chips></md-input-container></div></div><label class=\"header-title\">טפסים</label><div \nclass=\"row form\"><form name=\"upgradeGradeForm\" class=\"md-inline-form\" validate><div class=\"row\" layout=\"row\">\n<md-input-container><label>טקסט בקשה לביטול הרשמה</label><textarea ng-model=\"vm.profile.CancelFormText.Value\" \nng-disabled=\"vm.isClicked\"></textarea></md-input-container></div><div class=\"row\" layout=\"row\"><md-input-container>\n<label>בקשות לביטול</label><md-select ng-model=\"vm.profile.CancelEvents.Value\" ng-disabled=\"vm.isClicked\"><md-option \nng-value=\"1\">פעיל</md-option><md-option ng-value=\"0\">לא פעיל</md-option></md-select></md-input-container></div><div \nclass=\"row\" layout=\"row\"><md-input-container><label>טופס סיבסוד</label><md-select \nng-model=\"vm.profile.SubsidyForm.Value\" ng-disabled=\"vm.isClicked\"><md-option ng-value=\"0\">ללא</md-option><md-option \nng-value=\"1\">תבנית 1</md-option><md-option ng-value=\"2\">תבנית 2</md-option><md-option ng-value=\"3\">תבנית 3</md-option>\n</md-select></md-input-container></div><div class=\"row\" layout=\"row\"><md-input-container><label>טקסט בצור קשר</label>\n<textarea ng-model=\"vm.profile.ContactText.Value\" ng-disabled=\"vm.isClicked\"></textarea></md-input-container></div>\n</form></div><md-button ng-disabled=\"vm.isClicked || emailsForm.$invalid\" class=\"md-raised md-accent\" \nng-click=\"vm.updateSettings()\" style=\"margin-right: 0px\">עדכון</md-button></form></md-content></md-content></div>");
$templateCache.put("app/main/pages/settings-menue/views/profile-settings/tabs/profile-popup-alert.html","<div flex=\"100\" flex-xs=\"100\" ng-init=\"vm.getProfilePopUpAlert()\"><md-content \nclass=\"profile-box info-box md-whiteframe-1dp\"><div class=\"info-header\"><md-icon md-svg-icon=\"information\"></md-icon>\n<span class=\"title\">הודעת פרופיל אשר תוצג לכלל ההורים פעם אחת</span></div><md-content class=\"content md-padding\"><div \nlayout=\"row\" layout-sm=\"column\" layout-align=\"space-around\" ng-show=\"!vm.profilePopUpAlert\"><md-progress-circular \nmd-mode=\"indeterminate\"></md-progress-circular></div><form name=\"upgradeGradeForm\" class=\"md-inline-form\" \nng-show=\"vm.profilePopUpAlert\" validate><div class=\"row\" layout=\"row\"><div ckeditor=\"vm.options\" \nng-model=\"vm.profilePopUpAlert.Name\"></div><div layout=\"row\"></div></div><md-button type=\"submit\" \nng-disabled=\"vm.isClicked\" class=\"md-raised md-accent\" ng-click=\"vm.updateProfilePopUpAlert()\">עדכון</md-button></form>\n</md-content></md-content></div>");
$templateCache.put("app/main/pages/settings-menue/views/profile-settings/tabs/terms.html","<div flex=\"100\" flex-xs=\"100\" ng-init=\"vm.getTerms()\"><md-content class=\"profile-box info-box md-whiteframe-1dp\"><div \nclass=\"info-header\"><md-icon md-svg-icon=\"information\"></md-icon><span class=\"title\">\nתנאי השימוש יופיע בפרופיל ההורה ויוצגו גם בסוף תהליך הרישום</span></div><md-content class=\"content md-padding\"><div \nlayout=\"row\" layout-sm=\"column\" layout-align=\"space-around\" ng-show=\"!vm.terms\"><md-progress-circular \nmd-mode=\"indeterminate\"></md-progress-circular></div><form name=\"upgradeGradeForm\" class=\"md-inline-form\" \nng-show=\"vm.terms\" validate><div class=\"row\" layout=\"row\"><div ckeditor=\"vm.options\" ng-model=\"vm.terms.Name\"></div>\n<div layout=\"row\"></div></div><md-button type=\"submit\" ng-disabled=\"!vm.terms.Name || vm.isClicked\" \nclass=\"md-raised md-accent\" ng-click=\"vm.updateTerms()\">עדכון</md-button></form></md-content></md-content></div>");
$templateCache.put("app/main/pages/users/views/parents/parent-panel/parent-panel.html","<md-content ms-scroll><form name=\"parentForm\" id=\"parentForm\" data-ng-model=\"parentForm\" class=\"md-inline-form\" \nvalidate><md-toolbar class=\"md-accent\" layout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" \nlayout-align=\"space-between center\"><span class=\"title\">עריכת הורה</span><md-button class=\"md-icon-button\" \nng-click=\"$root.closePanel()\" aria-label=\"Close Dialog\" translate \ntranslate-attr-aria-label=\"PROFILE_PANEL.CLOSE_PANEL\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n<div class=\"md-toolbar-tools md-toolbar-tools-middle\" flex layout=\"column\" layout-align=\"center center\"><div \nlayout=\"column\" layout-align=\"center center\"><img ng-src=\"{{\'assets/images/avatars/profile.jpg\'}}\" \nclass=\"md-avatar avatar systemUser-avatar huge\" alt=\"{{parent.FirstName}} {{parent.LastName}}\"><div \nclass=\"selectedUser-name\">{{ parent.FirstName }} {{ parent.LastName }}</div></div></div></md-toolbar>\n<md-input-container class=\"md-icon-float md-block\"><md-icon md-font-icon=\"icon-account-box\" class=\"name\"></md-icon>\n<label>תעודת זהות</label><input ng-model=\"parent.PrivateID\" ng-disabled=\"true\"></md-input-container><md-input-container\n class=\"md-icon-float md-block\"><md-icon md-font-icon=\"icon-account\" class=\"name\"></md-icon><label>שם פרטי</label>\n<input ng-model=\"parent.FirstName\"></md-input-container><md-input-container class=\"md-icon-float md-block\"><md-icon \nmd-font-icon=\"icon-account\" class=\"name\"></md-icon><label>שם משפחה</label><input ng-model=\"parent.LastName\">\n</md-input-container><md-input-container class=\"md-block\"><md-icon md-font-icon=\"icon-email\" class=\"name\"></md-icon>\n<label>דואר אלקטרוני</label><input ng-model=\"parent.Email\" dir=\"ltr\" type=\"email\" \nng-pattern=\"/[0-9a-zA-Z_-]+?(\\.[0-9a-zA-Z_-]+?|\\.[0-9a-zA-Z_-]+?\\.[0-9a-zA-Z_-]+?|\\.[0-9a-zA-Z_-]+?\\.[0-9a-zA-Z_-]+?\\.[0-9a-zA-Z_-]+?|)@[0-9a-zA-Z_-]+?\\.[0-9a-zA-Z]{2,15}(|\\.[0-9a-zA-Z]{2,15}|\\.[0-9a-zA-Z]{2,15}\\.[0-9a-zA-Z]{2,15}|\\.[0-9a-zA-Z]{2,15}\\.[0-9a-zA-Z]{2,15}\\.[0-9a-zA-Z]{2,15})/\">\n</md-input-container><md-input-container class=\"md-block\"><md-icon md-font-icon=\"icon-cellphone-android\" class=\"name\">\n</md-icon><label>טלפון נייד</label><input ng-model=\"parent.MobileNumber\" dir=\"ltr\" type=\"tel\" \ndata-ng-patter=\"/([.+-]\\d{0,3})?([.0-9+-]{6,12})/\"></md-input-container><md-input-container class=\"md-block\"><md-icon \nmd-font-icon=\"icon-account\" class=\"name\"></md-icon><label>קשר משפחתי לחניכים</label><md-select \nng-model=\"parent.Relation\"><md-option ng-repeat=\"relation in relations\" ng-value=\"relation\">{{relation}}</md-option>\n</md-select></md-input-container><md-input-container class=\"md-block\"><md-icon md-font-icon=\"icon-power\" class=\"name\">\n</md-icon><label>סטטוס</label><md-select ng-model=\"parent.Status\" placeholder=\"סטטוס\" ng-disabled=\"$root.AdminLevel<3\">\n<md-option ng-selected=\"parent.Status==1 || parent.Status==\'1\'\" ng-value=\"1\">פעיל</md-option><md-option \nng-selected=\"parent.Status==0 || parent.Status==\'0\'\" ng-value=\"0\">לא פעיל</md-option></md-select></md-input-container>\n<md-input-container class=\"md-block\"><md-icon md-font-icon=\"icon-cash\" class=\"name\"></md-icon><label>דרגת הנחה</label>\n<md-select ng-model=\"parent.DiscountLevel\" placeholder=\"דרגת הנחה\" ng-disabled=\"$root.AdminLevel<3\"><md-option>בחר רמה\n</md-option><md-option ng-selected=\"parent.DiscountLevel==1 || parent.DiscountLevel==\'1\'\" ng-value=\"1\">1</md-option>\n<md-option ng-selected=\"parent.DiscountLevel==2 || parent.DiscountLevel==\'2\'\" ng-value=\"2\">2</md-option><md-option \nng-selected=\"parent.DiscountLevel==3 || parent.DiscountLevel==\'3\'\" ng-value=\"3\">3</md-option><md-option \nng-selected=\"parent.DiscountLevel==4 || parent.DiscountLevel==\'4\'\" ng-value=\"4\">4</md-option><md-option \nng-selected=\"parent.DiscountLevel==5 || parent.DiscountLevel==\'5\'\" ng-value=\"5\">5</md-option><md-option \nng-selected=\"parent.DiscountLevel==6 || parent.DiscountLevel==\'6\'\" ng-value=\"6\">6</md-option></md-select>\n</md-input-container><md-input-container class=\"md-block\"><md-icon md-font-icon=\"icon-calendar-select\"></md-icon><div \nstart-view=\"day\" locale=\"he\" format=\"DD/MM/YYYY\" moment-picker=\"parent.DiscountLevelStartDate\"><label>\nתאריך התחלה של מתן הדרגה</label><input autocomplete=\"off\" ng-model=\"parent.DiscountLevelStartDate\" \nng-disabled=\"$root.AdminLevel<3\"></div></md-input-container><md-input-container class=\"md-block\"><md-icon \nmd-font-icon=\"icon-calendar-select\"></md-icon><div start-view=\"day\" locale=\"he\" format=\"DD/MM/YYYY\" \nmoment-picker=\"parent.DiscountLevelEndDate\"><label>תאריך סיום של מתן הדרגה</label><input autocomplete=\"off\" \nng-model=\"parent.DiscountLevelEndDate\" ng-disabled=\"$root.AdminLevel<3\"></div></md-input-container></form></md-content>");
$templateCache.put("app/main/pages/users/views/parents/parents-profile/parents-profile.html","<div id=\"parent-profile\" class=\"page-layout simple tabbed\"><div class=\"header md-accent-bg\" layout=\"column\" \nlayout-align=\"center center\" layout-gt-sm=\"row\" layout-align-gt-sm=\"space-between end\"><div class=\"user-info\" \nlayout=\"column\" layout-align=\"center center\" layout-gt-sm=\"row\" layout-align-gt-sm=\"start center\"><img \nclass=\"profile-image avatar huge\" ng-src=\"{{parent.ProfileImage || \'assets/images/avatars/profile.jpg\' }}\"><div \nclass=\"name\">{{parent.FirstName}} {{parent.LastName}}</div></div><div class=\"actions\" layout=\"row\" \nlayout-align=\"end center\"><md-button data-ng-if=\"CurrentTotalCash\" class=\"md-raised sflex aic pen\"><md-icon \nmd-font-icon=\"icon-cash\" class=\"ml10\"></md-icon>יתרת חשבון פנימי : <span class=\"fw-bold\" \nng-class=\"{\'fcgreen\':CurrentTotalCash > 0,\'fcred\':CurrentTotalCash < 0}\">₪{{CurrentTotalCash}}</span></md-button>\n<md-button data-ng-if=\"coordinator.Email!= \'\'\" href=\"mailto: {{coordinator.Email}}\" class=\"md-raised md-primary\">\nשליחת הודעה</md-button><md-button ng-if=\"$root.AdminLevel==3  || $root.User.ParentsLoginPer == 1\" \nng-click=\"loginToProfile()\" class=\"md-raised md-primary\">התחבר לפרופיל</md-button></div></div><div layout=\"row\" \nlayout-sm=\"column\" layout-align=\"space-around\" ng-if=\"!parent\"><md-progress-circular md-mode=\"indeterminate\">\n</md-progress-circular></div><div class=\"content\" flex ng-if=\"parent\"><md-tabs md-dynamic-height \nmd-selected=\"selectedTab\"><md-tab><md-tab-label><span>כללי</span></md-tab-label><md-tab-body><md-content \nclass=\"about-tab\" ng-include=\"\'app/main/pages/users/views/parents/parents-profile/tabs/about/about.html\'\"></md-content>\n</md-tab-body></md-tab><md-tab><md-tab-label><span>משפחה</span></md-tab-label><md-tab-body><md-content \nclass=\"about-tab\" ng-include=\"\'app/main/pages/users/views/parents/parents-profile/tabs/family/family.html\'\">\n</md-content></md-tab-body></md-tab><md-tab><md-tab-label><span>קבלות</span></md-tab-label><md-tab-body><md-content \nclass=\"about-tab\" ng-include=\"\'app/main/pages/users/views/parents/parents-profile/tabs/payments/payments.html\'\">\n</md-content></md-tab-body></md-tab><md-tab><md-tab-label><span>הרשמות</span></md-tab-label><md-tab-body><md-content \nclass=\"about-tab\" \nng-include=\"\'app/main/pages/users/views/parents/parents-profile/tabs/registrations/registrations.html\'\"></md-content>\n</md-tab-body></md-tab><md-tab><md-tab-label><span>פניות צור קשר</span></md-tab-label><md-tab-body><md-content \nclass=\"about-tab\" ng-include=\"\'app/main/pages/users/views/parents/parents-profile/tabs/contact/contact.html\'\">\n</md-content></md-tab-body></md-tab><md-tab \nng-if=\"$root.AdminLevel == 3 || ($root.User.IsCoordinator && $root.User.SubsidyRequests == 1)\"><md-tab-label><span>\nבקשות לסבסוד</span></md-tab-label><md-tab-body><md-content class=\"about-tab\" \nng-include=\"\'app/main/pages/users/views/parents/parents-profile/tabs/subsidy/subsidy.html\'\"></md-content></md-tab-body>\n</md-tab><md-tab><md-tab-label><span>בקשות לביטול</span></md-tab-label><md-tab-body><md-content class=\"about-tab\" \nng-include=\"\'app/main/pages/users/views/parents/parents-profile/tabs/cancellation/cancellation.html\'\"></md-content>\n</md-tab-body></md-tab><md-tab><md-tab-label><span>הערות פנימיות</span></md-tab-label><md-tab-body><md-content \nclass=\"about-tab\" ng-include=\"\'app/main/pages/users/views/parents/parents-profile/tabs/comments/comments.html\'\">\n</md-content></md-tab-body></md-tab><md-tab ng-if=\"$root.AdminLevel == 3\"><md-tab-label><span>חשבון פנימי</span>\n</md-tab-label><md-tab-body><md-content class=\"about-tab\" \nng-include=\"\'app/main/pages/users/views/parents/parents-profile/tabs/cash/cash.html\'\"></md-content></md-tab-body>\n</md-tab><md-tab><md-tab-label><span>עדכון סיסמא</span></md-tab-label><md-tab-body><md-content class=\"about-tab\" \nng-include=\"\'app/main/pages/users/views/parents/parents-profile/tabs/reset-password/reset-password.html\'\"></md-content>\n</md-tab-body></md-tab></md-tabs></div></div>");
$templateCache.put("app/main/pages/users/views/coordinators/coordinators-profile/coordinators-profile.html","<div id=\"coordinator-profile\" class=\"page-layout simple tabbed\"><div class=\"header md-accent-bg\" layout=\"column\" \nlayout-align=\"center center\" layout-gt-sm=\"row\" layout-align-gt-sm=\"space-between end\"><div class=\"user-info\" \nlayout=\"column\" layout-align=\"center center\" layout-gt-sm=\"row\" layout-align-gt-sm=\"start center\"><img \nclass=\"profile-image avatar huge\" ng-src=\"{{coordinator.ProfileImage || \'assets/images/avatars/profile.jpg\' }}\"><div \nclass=\"name\">{{coordinator.FirstName}} {{coordinator.LastName}}</div></div><div class=\"actions\" layout=\"row\" \nlayout-align=\"end center\"><md-button data-ng-if=\"coordinator.Email!= \'\'\" href=\"mailto: {{coordinator.Email}}\" \nclass=\"md-raised md-primary\">שליחת הודעה</md-button></div></div><div class=\"content\" flex><md-tabs md-dynamic-height \nmd-selected=\"selectedTab\"><md-tab><md-tab-label><span>כללי</span></md-tab-label><md-tab-body><md-content \nclass=\"about-tab\" ng-include=\"\'app/main/pages/users/views/coordinators/coordinators-profile/tabs/about/about.html\'\">\n</md-content></md-tab-body></md-tab><md-tab><md-tab-label><span>הרשאות</span></md-tab-label><md-tab-body><md-content \nclass=\"about-tab\" \nng-include=\"\'app/main/pages/users/views/coordinators/coordinators-profile/tabs/permissions/permissions.html\'\">\n</md-content></md-tab-body></md-tab><md-tab><md-tab-label>{{$root.User.Branches}} ואזורים</md-tab-label><md-tab-body>\n<md-content class=\"about-tab\" \nng-include=\"\'app/main/pages/users/views/coordinators/coordinators-profile/tabs/branches/branches.html\'\"></md-content>\n</md-tab-body></md-tab></md-tabs></div></div>");
$templateCache.put("app/main/pages/users/views/coordinators/coordinators-panel/coordinators-panel.html","<md-content ms-scroll><form name=\"coordinatesForm\" id=\"coordinateForm\" data-ng-model=\"coordinateForm\" \nclass=\"md-inline-form\" validate><md-toolbar class=\"md-accent\" layout=\"column\"><div \nclass=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">\nעריכת {{$root.User.Coordinator}}</span><md-button class=\"md-icon-button\" ng-click=\"$root.closePanel()\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-input-container class=\"md-icon-float md-block\">\n<label>שם פרטי</label><md-icon md-font-icon=\"icon-account\" class=\"name\"></md-icon><input \nng-model=\"coordinate.FirstName\"></md-input-container><md-input-container class=\"md-icon-float md-block\"><label>שם משפחה\n</label><md-icon md-font-icon=\"icon-account\" class=\"name\"></md-icon><input ng-model=\"coordinate.LastName\">\n</md-input-container><md-input-container class=\"md-block\"><label>דואר אלקטרוני</label><md-icon \nmd-font-icon=\"icon-email\" class=\"email\"></md-icon><input ng-model=\"coordinate.Email\" dir=\"ltr\"></md-input-container>\n<md-input-container class=\"md-block\"><label>טלפון נייד</label><md-icon md-font-icon=\"icon-phone\"></md-icon><input \nng-model=\"coordinate.PhoneNumber\" dir=\"ltr\" type=\"tel\" data-ng-patter=\"/([.+-]\\d{0,3})?([.0-9+-]{6,12})/\">\n</md-input-container><md-input-container class=\"md-block\"><md-icon md-font-icon=\"icon-tie\"></md-icon><label>תפקיד\n</label><md-select ng-model=\"coordinate.Role\" placeholder=\"תפקיד\"><md-option ng-repeat=\"role in roles\" \nng-value=\"role.Name\">{{role.Name}}</md-option></md-select></md-input-container><md-input-container class=\"md-block\">\n<label>סטטוס</label><md-icon md-font-icon=\"icon-power\" class=\"name\"></md-icon><md-select ng-model=\"coordinate.Status\" \nplaceholder=\"סטטוס\"><md-option ng-selected=\"coordinate.Status==1 || coordinate.Status==\'1\'\" ng-value=\"1\">פעיל\n</md-option><md-option ng-selected=\"coordinate.Status==0 || coordinate.Status==\'0\'\" ng-value=\"0\">לא פעיל</md-option>\n</md-select></md-input-container></form></md-content>");
$templateCache.put("app/main/pages/users/views/coordinators/new-coordinator/new-coordinator.html","<div id=\"forgot-password\" class=\"sflex aic fdc\" ng-init=\"validRequest()\"><div id=\"forgot-form\" \nng-class=\"{hideme: success}\"><h2 class=\"hfs65 center\">{{appConfig.appName}} - רישום משתמש חדש</h2><form><div><label \nclass=\"formlabel dblock fw-medium\">סיסמא חדשה</label><div class=\"inputform\"><input ng-change=\"matchPass()\" \nng-class=\"{error: shortPass || (!matchPassword && !matchFlags)}\" type=\"{{ inputType }}\" ng-model=\"form.password\" \nplaceholder=\"6 תווים (ספרות ואותיות בלועזית)\"> <button ng-click=\"showHidePassword()\" class=\"sflex aic btn\">\n{{ showHideText }} <img src=\"{{ showHideImg }}\" alt=\"\"></button><h5 class=\"hfs13 sflex jcfe\"><span \nng-class=\"{errors: !matchPasswords && !matchFlags}\">סיסמאות אינן תואמות</span> <span ng-class=\"{errors: shortPass}\">\nסיסמא קצרה מדיי</span></h5></div></div><div class=\"mt40\"><label class=\"formlabel dblock fw-medium\">אימות סיסמא</label>\n<div class=\"inputform\"><input ng-class=\"{error: shortPass || (!matchPassword && !matchFlags)}\" ng-change=\"matchPass()\" \ntype=\"{{ inputType }}\" ng-model=\"passwordVerify\" placeholder=\"6 תווים (ספרות ואותיות בלועזית)\"> <button \nng-click=\"showHidePassword()\" class=\"sflex aic btn\">{{ showHideText }} <img src=\"{{ showHideImg }}\" alt=\"\"></button><h5\n class=\"hfs13 sflex jcfe\"><span ng-class=\"{errors: !matchPasswords && !matchFlags}\">סיסמאות אינן תואמות</span> <span \nng-class=\"{errors: shortPass}\">סיסמא קצרה מדיי</span></h5></div></div><div class=\"center mt40\"><div class=\"loading\" \nng-if=\"loading\" ng-class=\"{active: loading}\"><span></span></div><input type=\"submit\" \nng-disabled=\"!matchPasswords || loading\" ng-click=\"submit()\" value=\"עדכן סיסמא\"></div><div class=\"w100 center mt40\"><h4\n class=\"hfs15\">לחצו חזרה <a href=\"/\">לעמוד הכניסה</a></h4></div></form></div><div id=\"done-reset\" class=\"center\" \nng-class=\"{show: success}\"><img class=\"mb40\" src=\"/assets/icons/Done.svg\" alt=\"\"><h2 class=\"hfs65 mb30\">\nאיפוס סיסמא בוצע בהצלחה!</h2><h5 class=\"hfs27 fw-light\">מתבצע חיבור כעת</h5></div><div id=\"CopyR\" class=\"center hfs15\">\n<span>Crafted By <a href=\"https://www.marvilix.com\" target=\"_blank\">Marvilix </a>© All Rights Reserved</span></div><div\n class=\"errorBox inrowf\" ng-class=\"{show: fail}\"><div class=\"w100 center\"><span class=\"hfs15\">{{ errorInfo }}</span> \n<img src=\"/assets/icons/Close.svg\" alt=\"\" ng-click=\"fail = false\"></div></div></div>");
$templateCache.put("app/main/pages/users/views/coordinators/new-coordinators-dialog/new-coordinators-dialog.html","<md-dialog class=\"newCoordinators-dialog\" aria-label=\"New Task\"><form name=\"newCoordinatorsForm\" \ndata-ng-model=\"newCoordinatorsForm\" class=\"md-inline-form\" validate><md-toolbar class=\"md-accent\" layout=\"column\"><div \nclass=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">\nהוספת {{$root.User.Coordinator}} חדש</span><md-button class=\"md-icon-button\" ng-click=\"closeDialog()\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><md-input-container \nclass=\"md-block\"><md-icon md-font-icon=\"icon-account\" class=\"name\"></md-icon><label>שם פרטי</label><input \nng-model=\"newCoordinator.FirstName\" data-ng-required=\"true\" ng-disabled=\"isClicked\"></md-input-container>\n<md-input-container class=\"md-block\"><md-icon md-font-icon=\"icon-account\" class=\"name\"></md-icon><label>שם משפחה\n</label><input ng-model=\"newCoordinator.LastName\" data-ng-required=\"true\" ng-disabled=\"isClicked\"></md-input-container>\n<md-input-container class=\"md-block\"><md-icon md-font-icon=\"icon-phone\"></md-icon><label>טלפון נייד</label><input \nng-model=\"newCoordinator.PhoneNumber\" data-ng-required=\"true\" ng-disabled=\"isClicked\"></md-input-container>\n<md-input-container class=\"md-block\"><label>דואר אלקטרוני</label><md-icon md-font-icon=\"icon-email\" class=\"email\">\n</md-icon><input ng-required=\"true\" ng-model=\"newCoordinator.Email\" dir=\"ltr\" type=\"email\" ng-disabled=\"isClicked\" \nng-pattern=\"/[0-9a-zA-Z_-]+?(\\.[0-9a-zA-Z_-]+?|\\.[0-9a-zA-Z_-]+?\\.[0-9a-zA-Z_-]+?|\\.[0-9a-zA-Z_-]+?\\.[0-9a-zA-Z_-]+?\\.[0-9a-zA-Z_-]+?|)@[0-9a-zA-Z_-]+?\\.[0-9a-zA-Z]{2,15}(|\\.[0-9a-zA-Z]{2,15}|\\.[0-9a-zA-Z]{2,15}\\.[0-9a-zA-Z]{2,15}|\\.[0-9a-zA-Z]{2,15}\\.[0-9a-zA-Z]{2,15}\\.[0-9a-zA-Z]{2,15})/\">\n</md-input-container></md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><div \nlayout=\"row\" layout-align=\"start center\"><md-button data-ng-disabled=\"newCoordinatorsForm.$invalid || isClicked\" \ntype=\"submit\" ng-click=\"saveNesCoordinator()\" class=\"send-button md-accent md-raised\" aria-label=\"Add Task\">\nשמירה ומעבר לפרופיל</md-button></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/pages/users/views/students/change-group-grade-dialog/change-group-grade-dialog.html","<md-dialog class=\"newStudents-dialog\" aria-label=\"New Task\" ng-init=\"getBranches();getGrades()\"><form \nname=\"updateGroupForm\" data-ng-model=\"updateGroupForm\" class=\"md-inline-form\" validate><md-toolbar class=\"md-accent\" \nlayout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\">\n<span class=\"title\">שינוי {{$root.User.Grade}}\\{{$root.User.Group}}</span><md-button class=\"md-icon-button\" \nng-click=\"closeDialog()\" ng-disabled=\"isClicked\" aria-label=\"Close dialog\" translate \ntranslate-attr-aria-label=\"MANAGE_USERS.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content ms-scroll><md-input-container class=\"md-block\"><md-icon md-font-icon=\"icon-account\" \nclass=\"name\"></md-icon><label>מספר חניכים שנבחרו</label><input ng-value=\"changeForm.Students.length\" type=\"number\" \nng-disabled=\"true\"></md-input-container><md-input-container class=\"md-block\"><md-icon md-font-icon=\"icon-account-box\" \nclass=\"name\"></md-icon><label>סוג שינוי</label><md-select ng-required=\"true\" ng-model=\"changeForm.Type\" \nplaceholder=\"סוג שינוי\" ng-disabled=\"isClicked\"><md-option value=\"2\">העברת {{$root.User.Branch}}\\{{$root.User.Group}}\n</md-option><md-option value=\"3\">העברת {{$root.User.Grade}} + העברת {{$root.User.Group}}/{{$root.User.Branch}}\n</md-option></md-select></md-input-container><md-input-container class=\"md-block\" ng-if=\"changeForm.Type>=3\"><md-icon \nmd-font-icon=\"icon-chair-school\" class=\"name\"></md-icon><label>בחירת {{$root.User.Grade}}</label><md-select \nng-required=\"changeForm.Type>=3\" ng-model=\"changeForm.GradeID\" placeholder=\"בחירת {{$root.User.Grade}}\" \nng-disabled=\"isClicked || !grades\"><md-option ng-value=\"9999\">{{$root.User.Grade}} חדשה</md-option><md-option \nng-repeat=\"grade in grades\" ng-value=\"grade.ID\">{{grade.Name}}</md-option></md-select></md-input-container>\n<md-input-container class=\"md-block\" ng-if=\"changeForm.GradeID==9999\"><md-icon md-font-icon=\"icon-panorama-horizontal\" \nclass=\"name\"></md-icon><label>{{$root.User.Grade}} חדשה</label><input ng-model=\"changeForm.NewGradeName\" \nng-disabled=\"isClicked\" ng-required=\"changeForm.GradeID==9999\"></md-input-container><md-input-container \nclass=\"md-icon-float md-block\" ng-if=\"changeForm.GradeID==9999\"><label>שנתון</label><md-icon \nmd-font-icon=\"icon-account\" class=\"name\"></md-icon><input ng-model=\"changeForm.GradeYear\" ng-disabled=\"isClicked\">\n</md-input-container><md-input-container class=\"md-block\" ng-if=\"changeForm.GradeID==9999\"><md-icon md-font-icon=\"\">\n</md-icon><label>שכבת בוגרים</label><md-icon md-font-icon=\"icon-account-box\" class=\"name\"></md-icon><md-select \nng-model=\"changeForm.Graduates\" ng-disabled=\"isClicked\"><md-option ng-value=\"1\">כן</md-option><md-option ng-value=\"0\">\nלא</md-option></md-select></md-input-container><md-input-container class=\"md-block\" ng-if=\"changeForm.Type>=2\"><md-icon\n md-font-icon=\"icon-domain\" class=\"name\"></md-icon><label>בחירת {{$root.User.Branch}}</label><md-select \nng-required=\"true\" ng-model=\"changeForm.BranchID\" placeholder=\"בחירת {{$root.User.Branch}}\" \nng-disabled=\"isClicked || !branches\" ng-change=\"getGroupsByBranch()\"><md-option ng-repeat=\"branch in branches\" \nng-value=\"branch.ID\">{{branch.Name}}</md-option></md-select></md-input-container><md-input-container class=\"md-block\" \nng-if=\"changeForm.Type>=2\"><md-icon md-font-icon=\"icon-account-multiple\" class=\"name\"></md-icon><label>\nבחירת {{$root.User.Group}}</label><md-select ng-model=\"changeForm.GroupID\" placeholder=\"בחירת {{$root.User.Group}}\" \nng-disabled=\"isClicked || changeForm.GradeID==9999 || !groups\"><md-option ng-if=\"changeForm.Type==3\" ng-value=\"9999\" \nng-selected=\"changeForm.GradeID==9999\">{{$root.User.Group}} חדשה</md-option><md-option ng-repeat=\"group in groups\" \nng-value=\"group.ID\">{{group.Name}}</md-option></md-select></md-input-container><md-input-container class=\"md-block\" \nng-if=\"changeForm.GroupID==9999\"><md-icon md-font-icon=\"icon-account-multiple\" class=\"name\"></md-icon><label>\n{{$root.User.Group}} חדשה</label><input ng-model=\"changeForm.NewGroupName\" ng-required=\"changeForm.GroupID==9999\" \nng-disabled=\"isClicked\"></md-input-container></md-dialog-content><md-dialog-actions layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-button \ndata-ng-disabled=\"updateGroupForm.$invalid || isClicked\" type=\"submit\" ng-click=\"updateGradeAndGroups()\" \nclass=\"send-button md-accent md-raised\" aria-label=\"Add Task\">עדכון</md-button></div></md-dialog-actions></form>\n</md-dialog>");
$templateCache.put("app/main/pages/users/views/students/import-students-dialog/import-students-dialog.html","<md-dialog class=\"newStudents-dialog\" aria-label=\"New Task\" ng-init=\"getBranches();getGrades()\"><form \nname=\"updateGroupForm\" data-ng-model=\"updateGroupForm\" class=\"md-inline-form\" validate><md-toolbar class=\"md-accent\" \nlayout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\">\n<span class=\"title\">טעינת חניכים מקובץ</span><md-button class=\"md-icon-button\" ng-click=\"closeDialog()\" \nng-disabled=\"isClicked\" aria-label=\"Close dialog\" translate translate-attr-aria-label=\"MANAGE_USERS.CLOSE_DIALOG\">\n<md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><div \nlayout=\"row\" layout-align=\"start center\"><div layout=\"column\" flex=\"50\"><md-button \nng-click=\"getStudentUploadTemplate()\" class=\"send-button md-accent md-raised\" aria-label=\"Add Task\">הורדת תבנית\n</md-button></div><div layout=\"column\" flex=\"50\"><md-button ng-click=\"uploadExcelFile()\" \nclass=\"send-button md-accent md-raised\" aria-label=\"Add Task\">העלאת קובץ</md-button></div></div></md-dialog-content>\n<md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\">\n<md-button ng-click=\"closeDialog()\" class=\"send-button md-accent md-raised\" aria-label=\"Add Task\">סגירה</md-button>\n</div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/pages/users/views/students/new-educator/new-educator.html","<div id=\"forgot-password\" class=\"sflex aic fdc\" ng-init=\"validRequest()\"><div id=\"forgot-form\" \nng-class=\"{hideme: success}\"><h2 class=\"hfs65 center\">{{appConfig.appName}} - רישום מחנך חדש</h2><form><div><label \nclass=\"formlabel dblock fw-medium\">סיסמא חדשה</label><div class=\"inputform\"><input ng-change=\"matchPass()\" \nng-class=\"{error: shortPass || (!matchPassword && !matchFlags)}\" type=\"{{ inputType }}\" ng-model=\"form.password\" \nplaceholder=\"6 תווים (ספרות ואותיות בלועזית)\"> <button ng-click=\"showHidePassword()\" class=\"sflex aic btn\">\n{{ showHideText }} <img src=\"{{ showHideImg }}\" alt=\"\"></button><h5 class=\"hfs13 sflex jcfe\"><span \nng-class=\"{errors: !matchPasswords && !matchFlags}\">סיסמאות אינן תואמות</span> <span ng-class=\"{errors: shortPass}\">\nסיסמא קצרה מדיי</span></h5></div></div><div class=\"mt40\"><label class=\"formlabel dblock fw-medium\">אימות סיסמא</label>\n<div class=\"inputform\"><input ng-class=\"{error: shortPass || (!matchPassword && !matchFlags)}\" ng-change=\"matchPass()\" \ntype=\"{{ inputType }}\" ng-model=\"passwordVerify\" placeholder=\"6 תווים (ספרות ואותיות בלועזית)\"> <button \nng-click=\"showHidePassword()\" class=\"sflex aic btn\">{{ showHideText }} <img src=\"{{ showHideImg }}\" alt=\"\"></button><h5\n class=\"hfs13 sflex jcfe\"><span ng-class=\"{errors: !matchPasswords && !matchFlags}\">סיסמאות אינן תואמות</span> <span \nng-class=\"{errors: shortPass}\">סיסמא קצרה מדיי</span></h5></div></div><div class=\"center mt40\"><div class=\"loading\" \nng-if=\"loading\" ng-class=\"{active: loading}\"><span></span></div><input type=\"submit\" \nng-disabled=\"!matchPasswords || loading\" ng-click=\"submit()\" value=\"עדכן סיסמא\"></div><div class=\"w100 center mt40\"><h4\n class=\"hfs15\">לחצו חזרה <a href=\"/\">לעמוד הכניסה</a></h4></div></form></div><div id=\"done-reset\" class=\"center\" \nng-class=\"{show: success}\"><img class=\"mb40\" src=\"/assets/icons/Done.svg\" alt=\"\"><h2 class=\"hfs65 mb30\">\nאיפוס סיסמא בוצע בהצלחה!</h2><h5 class=\"hfs27 fw-light\">מתבצע חיבור כעת</h5></div><div id=\"CopyR\" class=\"center hfs15\">\n<span>Crafted By <a href=\"https://www.marvilix.com\" target=\"_blank\">Marvilix </a>© All Rights Reserved</span></div><div\n class=\"errorBox inrowf\" ng-class=\"{show: fail}\"><div class=\"w100 center\"><span class=\"hfs15\">{{ errorInfo }}</span> \n<img src=\"/assets/icons/Close.svg\" alt=\"\" ng-click=\"fail = false\"></div></div></div>");
$templateCache.put("app/main/pages/users/views/students/student-panel/student-panel.html","<md-content ms-scroll ng-init=\"getStudent();\"><form name=\"studentForm\" id=\"studentForm\" data-ng-model=\"studentForm\" \nclass=\"md-inline-form\" validate><md-toolbar class=\"md-accent\" layout=\"column\"><div \nclass=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">\nעריכת חניך</span><md-button class=\"md-icon-button\" ng-click=\"$root.closePanel()\"><md-icon md-font-icon=\"icon-close\">\n</md-icon></md-button></div><div class=\"md-toolbar-tools md-toolbar-tools-middle\" flex layout=\"column\" \nlayout-align=\"center center\"><div layout=\"column\" layout-align=\"center center\"><img \nng-src=\"{{\'assets/images/avatars/profile.jpg\'}}\" class=\"md-avatar avatar systemUser-avatar huge\" \nalt=\"{{student.FirstName}} {{student.LastName}}\"><div class=\"selectedUser-name\">\n{{ student.FirstName }} {{ student.LastName }}</div></div></div></md-toolbar><md-input-container \nclass=\"md-icon-float md-block\"><md-icon md-font-icon=\"icon-account-box\"></md-icon><label>תעודת זהות</label><input \nng-disabled=\"true\" ng-model=\"student.PrivateID\"></md-input-container><md-input-container \nclass=\"md-icon-float md-block\"><md-icon md-font-icon=\"icon-account\"></md-icon><label>שם פרטי</label><input \nng-model=\"student.FirstName\"></md-input-container><md-input-container class=\"md-icon-float md-block\"><md-icon \nmd-font-icon=\"icon-account\"></md-icon><label>שם משפחה</label><input ng-model=\"student.LastName\"></md-input-container>\n<md-input-container class=\"md-block\"><md-icon md-font-icon=\"icon-power\"></md-icon><label>סטטוס</label><md-select \nng-model=\"student.Status\" placeholder=\"סטטוס\"><md-option ng-selected=\"student.Status==1 || student.Status==\'1\'\" \nng-value=\"1\">פעיל</md-option><md-option ng-selected=\"student.Status==0 || student.Status==\'0\'\" ng-value=\"0\">לא פעיל\n</md-option></md-select></md-input-container><md-input-container class=\"md-block\" ng-if=\"!student.Status\"><md-icon \nmd-font-icon=\"icon-power\"></md-icon><label>סיבת סטטוס לא פעיל</label><textarea required \nng-model=\"student.StatusReason\" ng-if=\"!brandIsLatet\"></textarea><md-select ng-model=\"student.StatusReason\" \nng-if=\"brandIsLatet\" placeholder=\"בחירת סיבה\"><md-option ng-selected=\"student.StatusReason==\'סיים בית ספר\'\" \nng-value=\"\'סיים בית ספר\'\">סיים בית ספר</md-option><md-option ng-selected=\"student.StatusReason==\'עזב\'\" \nng-value=\"\'עזב\'\">עזב</md-option><md-option ng-selected=\"student.StatusReason==\'סניף נסגר\'\" ng-value=\"\'סניף נסגר\'\">\nסניף נסגר</md-option></md-select></md-input-container><md-input-container class=\"md-icon-float md-block md-icon-left\">\n<md-icon md-font-icon=\"icon-calendar-select\"></md-icon><div start-view=\"day\" locale=\"he\" format=\"DD/MM/YYYY\" \nmoment-picker=\"student.Birthday\"><label>תאריך לידה</label><input autocomplete=\"off\" ng-model=\"student.Birthday\"></div>\n</md-input-container><md-input-container class=\"md-block\"><md-icon md-font-icon=\"icon-email\"></md-icon><label>\nדואר אלקטרוני</label><input ng-model=\"student.Email\" dir=\"ltr\" type=\"email\" \nng-pattern=\"/[0-9a-zA-Z_-]+?(\\.[0-9a-zA-Z_-]+?|\\.[0-9a-zA-Z_-]+?\\.[0-9a-zA-Z_-]+?|\\.[0-9a-zA-Z_-]+?\\.[0-9a-zA-Z_-]+?\\.[0-9a-zA-Z_-]+?|)@[0-9a-zA-Z_-]+?\\.[0-9a-zA-Z]{2,15}(|\\.[0-9a-zA-Z]{2,15}|\\.[0-9a-zA-Z]{2,15}\\.[0-9a-zA-Z]{2,15}|\\.[0-9a-zA-Z]{2,15}\\.[0-9a-zA-Z]{2,15}\\.[0-9a-zA-Z]{2,15})/\">\n</md-input-container><md-input-container class=\"md-block\"><md-icon md-font-icon=\"icon-cellphone-android\"></md-icon>\n<label>טלפון נייד</label><input ng-model=\"student.PhoneNumber\" dir=\"ltr\" type=\"tel\" \ndata-ng-patter=\"/([.+-]\\d{0,3})?([.0-9+-]{6,12})/\"></md-input-container><md-input-container class=\"md-block\"><md-icon \nmd-font-icon=\"icon-account\"></md-icon><label>{{$root.fathersName?$root.fathersName : \'שם האב\' }}</label><input \nng-model=\"student.FatherName\" required type=\"text\"></md-input-container><md-input-container class=\"md-block\"><md-icon \nmd-font-icon=\"icon-gender-male-female\"></md-icon><label>{{$root.User.Grade}}</label><md-select \nng-model=\"student.GradeID\" required placeholder=\"{{$root.User.Grade}}\"><md-option ng-repeat=\"grade in grades\" \nng-value=\"grade.ID\">{{grade.Name}}</md-option></md-select></md-input-container><div ng-show=\"!allFields\" layout=\"row\" \nlayout-align=\"center center\"><md-button class=\"md-accent\" ng-click=\"changeAllFields()\">הצג את כל השדות</md-button>\n</div><div ng-show=\"allFields\"><md-input-container class=\"md-icon-float md-block\"><md-icon md-font-icon=\"icon-phone\">\n</md-icon><label>טלפון</label><input ng-model=\"student.Phone\"></md-input-container><div \nclass=\"md-block md-icon-left fix-label\" style=\"display: -webkit-box\"><md-icon md-font-icon=\"icon-city\" class=\"name\" \nstyle=\"padding-top: 38px;padding-right: 7px\"></md-icon><md-autocomplete \nstyle=\"min-width: 327px;padding-right: -16px;margin-right: -22px\" md-selected-item-change=\"setCity(item)\" \nng-disabled=\"isClicked\" md-input-name=\"autocompleteField\" md-no-cache=\"noCache\" md-selected-item=\"selectedItem\" \nmd-search-text=\"searchText\" md-items=\"item in querySearch(searchText)\" md-item-text=\"item.display\" md-min-length=\"0\" \nmd-floating-label=\"שם ישוב\"><md-item-template><span md-highlight-text=\"searchText\" md-highlight-flags=\"^i\">\n{{item.display}}</span></md-item-template><md-not-found>ישוב לא נמצא</md-not-found></md-autocomplete></div>\n<md-input-container class=\"md-icon-float md-block\"><md-icon md-font-icon=\"icon-panorama-horizontal\"></md-icon><label>\nרחוב</label><input ng-model=\"student.Street\"></md-input-container><md-input-container class=\"md-icon-float md-block\">\n<md-icon md-font-icon=\"icon-domain\"></md-icon><label>מיקוד</label><input ng-model=\"student.ZipCode\">\n</md-input-container><md-input-container class=\"md-block\"><md-icon md-font-icon=\"icon-account\"></md-icon><label>\nסוג חניך</label><md-select ng-model=\"student.Type\" placeholder=\"סוג חניך\"><md-option \nng-selected=\"student.Type==2 || student.Type==\'2\'\" ng-value=\"2\">בוגר</md-option><md-option \nng-selected=\"student.Type==1 || student.Type==\'1\'\" ng-value=\"1\">רגיל</md-option></md-select></md-input-container>\n<md-input-container class=\"md-block\"><md-icon md-font-icon=\"icon-gender-male-female\"></md-icon><label>מין</label>\n<md-select ng-model=\"student.Gender\" placeholder=\"מין\"><md-option ng-selected=\"student.Gender==\'Male\'\" \nng-value=\"\'Male\'\">בן</md-option><md-option ng-selected=\"student.Gender==\'Female\'\" ng-value=\"\'Female\'\">בת</md-option>\n<md-option ng-if=\"$root.GenderType == 1\" ng-selected=\"student.Gender==\'Other\'\" ng-value=\"\'Other\'\">אחר</md-option>\n</md-select></md-input-container><div layout=\"row\" layout-align=\"center center\"><md-button class=\"md-accent\" \nng-click=\"changeAllFields()\">הסתר שדות</md-button></div></div></form></md-content>");
$templateCache.put("app/main/pages/users/views/students/new-students-dialog/new-students-dialog.html","<md-dialog class=\"newStudents-dialog\" aria-label=\"New Task\" ng-init=\"getBranches();getGrades();\"><form \nname=\"newStudentsForm\" data-ng-model=\"newStudentsForm\" class=\"md-inline-form\" validate><md-toolbar class=\"md-accent\" \nlayout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\">\n<span class=\"title\">הוספת חניך חדש</span><md-button class=\"md-icon-button\" ng-click=\"closeDialog()\" \naria-label=\"Close dialog\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content ms-scroll><md-input-container class=\"md-block\"><span href=\"\" ng-if=\"!tz\" \nng-click=\"ChangeToPassport()\" style=\"cursor: pointer\" ng-disabled=\"isClicked\">החלף לדרכון / תעודה חריגה</span> <span \nhref=\"\" ng-if=\"tz\" ng-click=\"ChangeToPassport()\" style=\"cursor: pointer\" ng-disabled=\"isClicked\">החלף לתעודה מזהה\n</span></md-input-container><md-input-container class=\"md-block\"><md-icon md-font-icon=\"icon-account-box\" class=\"name\">\n</md-icon><label ng-if=\"!tz\">תעודת זהות</label><label ng-if=\"tz\">דרכון / תעודה חריגה</label><input \nng-model=\"newStudent.PrivateID\" type=\"text\" data-ng-required=\"true\" ng-disabled=\"isClicked\"></md-input-container>\n<md-input-container class=\"md-block\"><md-icon md-font-icon=\"icon-account\" class=\"name\"></md-icon><label>שם פרטי</label>\n<input ng-model=\"newStudent.FirstName\" type=\"text\" data-ng-required=\"true\" ng-disabled=\"isClicked\">\n</md-input-container><md-input-container class=\"md-block\"><md-icon md-font-icon=\"icon-account\" class=\"name\"></md-icon>\n<label>שם משפחה</label><input ng-model=\"newStudent.LastName\" type=\"text\" data-ng-required=\"true\" \nng-disabled=\"isClicked\"></md-input-container><md-input-container class=\"md-block\"><md-icon \nmd-font-icon=\"icon-gender-male-female\" class=\"name\"></md-icon><label>מין</label><md-select ng-required=\"true\" \nng-model=\"newStudent.Gender\" placeholder=\"מין\" ng-disabled=\"isClicked\"><md-option ng-value=\"\'Male\'\">בן</md-option>\n<md-option ng-value=\"\'Female\'\">בת</md-option><md-option ng-if=\"$root.GenderType == 1\" ng-value=\"\'Other\'\">אחר\n</md-option></md-select></md-input-container><md-input-container class=\"md-block\"><md-icon \nmd-font-icon=\"icon-account-box\" class=\"name\"></md-icon><label>תעודת זהות הורה 1</label><input \nng-model=\"newStudent.Parent1\" type=\"text\" ng-pattern=\"/^[a-zA-Z0-9_.-]*$/\" ng-disabled=\"isClicked\">\n</md-input-container><md-input-container class=\"md-block\"><md-icon md-font-icon=\"icon-account-box\" class=\"name\">\n</md-icon><label>תעודת זהות הורה 2</label><input ng-model=\"newStudent.Parent2\" ng-required=\"newStudent.Parent2\" \ntype=\"text\" ng-pattern=\"/^[a-zA-Z0-9_.-]*$/\" ng-disabled=\"isClicked\"></md-input-container><md-input-container \nclass=\"md-icon-float md-block\" layout=\"row\" layout-xs=\"row\" flex=\"100\"><md-icon md-font-icon=\"icon-cellphone-android\">\n</md-icon><label>מספר טלפון נייד</label><input ng-model=\"newStudent.PhoneNumber\" type=\"tel\" aria-label=\"phone number\">\n</md-input-container><md-input-container class=\"md-icon-float md-block md-icon-left\" style=\"padding: 0px 28px 0px\">\n<md-icon md-font-icon=\"icon-calendar-select\" class=\"name\"></md-icon><label>תאריך לידה</label><div start-view=\"day\" \nlocale=\"he\" format=\"DD/MM/YYYY\" moment-picker=\"newStudent.Birthday\"><input ng-required=\"$root.brandName != \'oz\'\" \nautocomplete=\"off\" ng-model=\"newStudent.Birthday\" ng-disabled=\"isClicked\"></div></md-input-container>\n<md-input-container class=\"md-icon-float md-block\" layout=\"row\" flex=\"100\"><md-icon md-font-icon=\"icon-account\">\n</md-icon><label>{{$root.fathersName?$root.fathersName : \'שם האב\' }}</label><input ng-model=\"newStudent.FatherName\" \nrequired type=\"text\"></md-input-container><md-input-container class=\"md-icon-float md-block\" layout=\"row\" flex=\"100\">\n<label>{{$root.User.Branch}}</label><md-icon md-font-icon=\"icon-domain\"></md-icon><md-select \nmd-on-close=\"vm.clearSearchTerm()\" ng-model=\"newStudent.BranchID\" id=\"BranchID\" ng-disabled=\"!branches || isClicked\">\n<md-select-header class=\"demo-select-header\"><input ng-model=\"searchTerm\" type=\"text\" \nng-keydown=\"$event.stopPropagation()\" placeholder=\"חיפוש {{$root.User.Branch}}\" class=\"demo-header-searchbox md-text\" \nautocomplete=\"off\"></md-select-header><md-optgroup><md-option ng-repeat=\"branch in branches | filter: searchTerm\" \nng-value=\"branch.ID\">{{branch.Name}}</md-option></md-optgroup></md-select></md-input-container><md-input-container \nclass=\"md-icon-float md-block\" layout=\"row\" flex=\"100\"><md-icon md-font-icon=\"icon-chair-school\"></md-icon><label>\n{{$root.User.Grade}}</label><md-select ng-model=\"newStudent.GradeID\" ng-change=\"disableBranchChange()\" \nng-disabled=\"!grades || isClicked\"><md-option ng-repeat=\"grade in grades\" ng-value=\"grade.ID\">{{grade.Name}}\n</md-option></md-select></md-input-container><md-input-container ng-if=\"tz\" \nclass=\"md-icon-float md-block md-icon-left\" style=\"padding: 0px 28px 0px\" vc-recaptcha \nkey=\"\'6LdOJx8hAAAAANkr5w01UyvEYcj8K6EEdPBtlhWN\'\" ng-model=\"newStudent.captcha\"></md-input-container>\n</md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" \nlayout-align=\"start center\"><md-button data-ng-disabled=\"newStudentsForm.$invalid || isClicked\" type=\"submit\" \nng-click=\"saveNesStudent()\" class=\"send-button md-accent md-raised\" aria-label=\"Add Task\">שמירה ומעבר לפרופיל\n</md-button></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/pages/users/views/students/student-profile/student-profile.html","<div id=\"student-profile\" class=\"page-layout simple tabbed\"><div class=\"header md-accent-bg\" layout=\"column\" \nlayout-align=\"center center\" layout-gt-sm=\"row\" layout-align-gt-sm=\"space-between end\"><div class=\"user-info\" \nlayout=\"column\" layout-align=\"center center\" layout-gt-sm=\"row\" layout-align-gt-sm=\"start center\"><img \nclass=\"profile-image avatar huge\" ng-src=\"{{student.ProfileImage || \'assets/images/avatars/profile.jpg\' }}\"><div \nclass=\"name\">{{student.FirstName}} {{student.LastName}}</div></div><div class=\"actions\" layout=\"row\" \nlayout-align=\"end center\"><md-button data-ng-if=\"student.Email!= \'\'\" href=\"mailto: {{student.Email}}\" \nclass=\"md-raised md-primary\">שליחת הודעה</md-button></div></div><div layout=\"row\" layout-sm=\"column\" \nlayout-align=\"space-around\" ng-if=\"!student\"><md-progress-circular md-mode=\"indeterminate\"></md-progress-circular>\n</div><div class=\"content\" flex ng-if=\"student\"><md-tabs md-dynamic-height md-selected=\"selectedTab\" \nstyle=\"overflow: visible\"><md-tab ng-disabled=\"$root.isEdit && selectedTab!=0\"><md-tab-label><span>כללי</span>\n</md-tab-label><md-tab-body><md-content class=\"about-tab\" style=\"overflow: visible\" \nng-include=\"\'app/main/pages/users/views/students/student-profile/tabs/about/about.html\'\"></md-content></md-tab-body>\n</md-tab><md-tab ng-disabled=\"$root.isEdit && selectedTab!=1\"><md-tab-label><span>מדריך</span></md-tab-label>\n<md-tab-body><md-content class=\"about-tab\" style=\"overflow: visible\" \nng-include=\"\'app/main/pages/users/views/students/student-profile/tabs/educator-groups/educator-groups.html\'\">\n</md-content></md-tab-body></md-tab><md-tab ng-disabled=\"$root.isEdit && selectedTab!=2\"><md-tab-label><span>משפחה\n</span></md-tab-label><md-tab-body><md-content class=\"family-tab\" \nng-include=\"\'app/main/pages/users/views/students/student-profile/tabs/family/family.html\'\"></md-content></md-tab-body>\n</md-tab><md-tab ng-if=\"$root.AdminLevel>1\" ng-disabled=\"$root.isEdit && selectedTab!=3\"><md-tab-label><span>\nהרשמות ל{{$root.User.Events}}</span></md-tab-label><md-tab-body><md-content class=\"payments-tab\" \nng-include=\"\'app/main/pages/users/views/students/student-profile/tabs/registrations/registrations.html\'\"></md-content>\n</md-tab-body></md-tab><md-tab ng-if=\"$root.AdminLevel>1\" ng-disabled=\"$root.isEdit && selectedTab!=4\"><md-tab-label>\n<span>פניות צור קשר</span></md-tab-label><md-tab-body><md-content class=\"payments-tab\" \nng-include=\"\'app/main/pages/users/views/students/student-profile/tabs/contact/contact.html\'\"></md-content>\n</md-tab-body></md-tab><md-tab ng-if=\"$root.AdminLevel>1\" ng-disabled=\"$root.isEdit && selectedTab!=5\"><md-tab-label>\n<span>בקשות לביטול</span></md-tab-label><md-tab-body><md-content class=\"payments-tab\" \nng-include=\"\'app/main/pages/users/views/students/student-profile/tabs/cancellation/cancellation.html\'\"></md-content>\n</md-tab-body></md-tab><md-tab ng-if=\"$root.AdminLevel>1\" ng-disabled=\"$root.isEdit && selectedTab!=6\"><md-tab-label>\n<span>הערות פנימיות</span></md-tab-label><md-tab-body><md-content class=\"payments-tab\" \nng-include=\"\'app/main/pages/users/views/students/student-profile/tabs/comments/comments.html\'\"></md-content>\n</md-tab-body></md-tab><md-tab ng-if=\"$root.AdminLevel>1\" ng-disabled=\"$root.isEdit && selectedTab!=6\"><md-tab-label>\n<span>היסטוריית שינויים</span></md-tab-label><md-tab-body><md-content class=\"payments-tab\" \nng-include=\"\'app/main/pages/users/views/students/student-profile/tabs/history/history.html\'\"></md-content>\n</md-tab-body></md-tab></md-tabs></div></div>");
$templateCache.put("app/main/pages/branches/views/branches/branch-management/add-new-branch-tag-dialog/add-new-branch-tag-dialog.html","<md-dialog class=\"new-branch-dialog\" aria-label=\"New Task\" ng-init=\"getTags()\"><form name=\"newBranchTagForm\" \ndata-ng-model=\"newBranchTagForm\" class=\"md-inline-form\" validate><md-toolbar class=\"md-accent\" layout=\"column\"><div \nclass=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">\nהוספת תגית</span><md-button class=\"md-icon-button\" ng-click=\"closeDialog()\" aria-label=\"Close dialog\" \nng-disabled=\"isClicked\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content \nms-scroll><div class=\"md-block md-icon-left\"><md-input-container class=\"md-icon-float md-block\"><md-icon \nmd-font-icon=\"icon-pound\" class=\"name\"></md-icon><label>תגית</label><md-select ng-model=\"newTag.Tag\" \nplaceholder=\"תגית\" ng-disabled=\"!tags\"><md-option ng-repeat=\"tag in tags\" ng-value=\"tag\">{{tag}}</md-option>\n</md-select></md-input-container></div></md-dialog-content><md-dialog-actions layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-button \ndata-ng-disabled=\"newBranchTagForm.$invalid || isClicked\" type=\"submit\" ng-click=\"saveNewBranchTag()\" \nclass=\"send-button md-accent md-raised\" aria-label=\"Add Task\">שמירה</md-button></div></md-dialog-actions></form>\n</md-dialog>");
$templateCache.put("app/main/pages/users/views/students/student-profile/new-educator-dialog/new-educator-dialog.html","<md-dialog class=\"newEducator-dialog\" aria-label=\"New Task\"><form name=\"newEducatorForm\" \ndata-ng-model=\"newEducatorForm\" class=\"md-inline-form\" validate><md-toolbar class=\"md-accent\" layout=\"column\"><div \nclass=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">\nשליחת הזמנה למחנך</span><md-button class=\"md-icon-button\" ng-click=\"closeDialog()\" aria-label=\"Close dialog\" translate \ntranslate-attr-aria-label=\"MANAGE_USERS.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content ms-scroll><md-input-container class=\"md-block\"><md-icon md-font-icon=\"icon-email\" \nclass=\"name\"></md-icon><label>דואר אלקטרוני</label><input ng-model=\"newEducator.Email\" type=\"text\" ng-disabled=\"true\">\n</md-input-container></md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><div \nlayout=\"row\" layout-align=\"start center\"><md-button data-ng-disabled=\"newEducatorForm.$invalid || isClicked\" \ntype=\"submit\" ng-click=\"sendInvitationToNewEducator()\" class=\"send-button md-accent md-raised\" aria-label=\"Add Task\">\nשליחה</md-button></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/pages/users/views/students/student-profile/new-parent-dialog/new-parent-dialog.html","<md-dialog class=\"newParent-dialog\" aria-label=\"New Task\"><form name=\"newParentForm\" data-ng-model=\"newParentForm\" \nclass=\"md-inline-form\" validate><md-toolbar class=\"md-accent\" layout=\"column\"><div \nclass=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">\nהוספת הורה</span><md-button class=\"md-icon-button\" ng-click=\"closeDialog()\" aria-label=\"Close dialog\" translate \ntranslate-attr-aria-label=\"MANAGE_USERS.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content ms-scroll><div><md-input-container class=\"md-block\"><span ng-disabled=\"isClicked\" \nhref=\"\" ng-if=\"!tz\" ng-click=\"ChangeToPassport()\" style=\"cursor: pointer\">החלף לדרכון</span> <span \nng-disabled=\"isClicked\" href=\"\" ng-if=\"tz\" ng-click=\"ChangeToPassport()\" style=\"cursor: pointer\">החלף לתעודה מזהה\n</span></md-input-container><md-input-container class=\"md-block\"><md-icon md-font-icon=\"icon-account-box\" class=\"name\">\n</md-icon><label ng-if=\"!tz\">תעודת זהות</label><label ng-if=\"tz\">דרכון</label><input ng-model=\"newParent.PrivateID\" \ntitle=\"במידה וההורה קיים יש להכניס ת.ז בלבד\" data-ng-required=\"true\" data-ng-pattern=\"pattern\" ng-required=\"true\" \nng-disabled=\"isClicked\"></md-input-container></div><div ng-show=\"more\"><md-input-container class=\"md-block\"><md-icon \nmd-font-icon=\"icon-account\" class=\"name\"></md-icon><label>שם פרטי</label><input ng-model=\"newParent.FirstName\" \nng-disabled=\"isClicked\"></md-input-container><md-input-container class=\"md-block\"><md-icon md-font-icon=\"icon-account\" \nclass=\"name\"></md-icon><label>שם משפחה</label><input ng-model=\"newParent.LastName\" ng-disabled=\"isClicked\">\n</md-input-container><md-input-container class=\"md-block\"><md-icon md-font-icon=\"icon-email\" class=\"name\"></md-icon>\n<label>דואר אלקטרוני</label><input ng-model=\"newParent.Email\" ng-disabled=\"isClicked\"></md-input-container>\n<md-input-container class=\"md-block\"><md-icon md-font-icon=\"icon-cellphone-android\" class=\"name\"></md-icon><label>\nמספר טלפון</label><input ng-model=\"newParent.PhoneNumber\" ng-disabled=\"isClicked\"></md-input-container></div><div>\n<md-input-container class=\"md-block\"><div ng-click=\"changeShowMore()\" style=\"cursor: pointer\" ng-disabled=\"isClicked\">\n<span ng-if=\"!more\">פרטים נוספים</span> <span ng-if=\"more\">פחות פרטים</span></div></md-input-container></div>\n</md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" \nlayout-align=\"start center\"><md-button data-ng-disabled=\"newParentForm.$invalid || isClicked\" type=\"submit\" \nng-click=\"saveNewParent()\" class=\"send-button md-accent md-raised\" aria-label=\"Add Task\">שמירה</md-button></div>\n</md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/pages/branches/views/branches/branch-management/tabs/contacts/contacts.html","<div class=\"hours-container\"><div class=\"action-buttons\"><md-button ng-show=\"$root.AdminLevel>=2\" \nclass=\"md-fab md-accent md-icon-button\" id=\"add-newBranchHour-button\" ng-click=\"addNewContact()\" \naria-label=\"add new Branch hour\" title=\"הוספה\"><md-icon md-font-icon=\"icon-plus\"></md-icon></md-button></div><div \nlayout=\"row\" layout-wrap><div layout=\"column\" flex=\"100\" flex-gt-sm=\"100\" flex-gt-md=\"80\" flex-gt-lg=\"90\"><form \nname=\"contactsForm\" class=\"md-inline-form\" validate><div class=\"filters\" layout=\"row\" layout-xs=\"column\" flex=\"100\" \nflex-gt-sm=\"100\" flex-gt-md=\"70\"><div layout=\"column\" flex=\"100\" flex-gt-sm=\"100\" flex-gt-md=\"33\"><md-input-container \nclass=\"md-icon-float md-block\"><md-icon md-font-icon=\"icon-power\"></md-icon><label>סטטוס איש קשר</label><md-select \nng-model=\"contactsSearch.Status\" placeholder=\"סינון לפי סטטוס איש קשר\" ng-disabled=\"!branchContacts\"><md-option \nng-value=\"null\">הצג הכל</md-option><md-option ng-value=\"1\">פעילים</md-option><md-option ng-value=\"0\">לא פעילים\n</md-option></md-select></md-input-container></div><div layout=\"column\" flex=\"100\" flex-gt-sm=\"100\" flex-gt-md=\"33\">\n<md-input-container id=\"free-search\" class=\"md-icon-float md-block\"><md-icon md-font-icon=\"icon-magnify\"></md-icon>\n<label>חיפוש חופשי</label><input ng-model=\"contactsSearch.freeSearchFromDB\" type=\"search\" \nng-disabled=\"!branchContacts\"></md-input-container></div></div><div class=\"search-actions row\" layout=\"row\"><md-button \ntype=\"submit\" ng-disabled=\"!branchContacts\" class=\"md-raised md-accent\" aria-label=\"חפש\" ng-click=\"getContacts()\">סינון\n</md-button><md-button ng-disabled=\"!branchContacts\" class=\"md-raised md-accent\" aria-label=\"חפש\" \nng-click=\"getContacts(true)\">בטל סינון</md-button></div></form></div></div><div class=\"content\"><div layout=\"row\" \nlayout-sm=\"column\" layout-align=\"space-around\" ng-if=\"!branchContacts\"><md-progress-circular md-mode=\"indeterminate\">\n</md-progress-circular></div><div ng-if=\"branchContacts\"><table id=\"branches-table\" \nclass=\"dataTable row-border hover stripe md-ink-ripple\" datatable=\"ng\" dt-instance=\"dtInstance\" dt-options=\"dtOptions\">\n<thead><tr><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">שם</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">טלפון</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">מייל</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">תפקיד</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">תצוגה בפרופיל הורה</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">סטטוס</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">פעולות</span></div></th></tr></thead>\n<tbody><tr class=\"entry-code-item\" ng-repeat=\"contact in branchContacts\"><td>{{contact.Name}}</td><td>{{contact.Phone}}\n</td><td>{{contact.Email}}</td><td>{{contact.Role}}</td><td>{{contact.ShowInProfile? \'מוצג\' : \'לא מוצג\'}}</td><td>\n{{contact.Status==1 || contact.Status==\'1\' ? \'פעיל\' : \'לא פעיל\'}}</td><td><md-button \nclass=\"preview-user md-icon-button\" ng-click=\"editContact(contact)\" title=\"עריכה\"><md-icon md-svg-icon=\"pencil\">\n</md-icon></md-button></td></tr></tbody></table></div></div></div>");
$templateCache.put("app/main/pages/branches/views/branches/branch-management/tabs/files/files.html","<div id=\"branch-files\" class=\"page-layout simple tabbed\"><div class=\"action-buttons\"><md-button \nng-if=\"$root.AdminLevel>=2\" class=\"md-fab md-accent md-icon-button\" id=\"add-newFile-button\" \nng-click=\"openNewFileDialog()\" title=\"הוספת קובץ\" ng-disabled=\"!files\"><md-icon md-font-icon=\"icon-plus\"></md-icon>\n</md-button></div><div layout=\"row\" layout-wrap><div layout=\"column\" flex=\"100\" flex-gt-sm=\"100\" flex-gt-md=\"80\" \nflex-gt-lg=\"90\"><form name=\"filesForm\" class=\"md-inline-form\" validate><div class=\"filters\" layout=\"row\" \nlayout-xs=\"column\" flex=\"100\" flex-gt-sm=\"100\" flex-gt-md=\"70\"><div layout=\"column\" flex=\"100\" flex-gt-sm=\"100\" \nflex-gt-md=\"33\"><md-input-container id=\"free-search\" class=\"md-icon-float md-block\"><md-icon \nmd-font-icon=\"icon-magnify\"></md-icon><label>חיפוש חופשי</label><input ng-model=\"fileSearch.freeSearchFromDB\" \ntype=\"search\" ng-disabled=\"!files\"></md-input-container></div></div><div class=\"search-actions row\" layout=\"row\">\n<md-button type=\"submit\" ng-disabled=\"!files\" class=\"md-raised md-accent\" aria-label=\"חפש\" ng-click=\"getFiles()\">סינון\n</md-button><md-button ng-disabled=\"!files\" class=\"md-raised md-accent\" aria-label=\"חפש\" ng-click=\"getFiles(true)\">\nבטל סינון</md-button></div></form></div></div><div class=\"content\"><div layout=\"row\" layout-sm=\"column\" \nlayout-align=\"space-around\" ng-if=\"!files\"><md-progress-circular md-mode=\"indeterminate\"></md-progress-circular></div>\n<div ng-if=\"files\"><table id=\"files-table\" class=\"dataTable row-border hover stripe md-ink-ripple\" datatable=\"ng\" \ndt-instance=\"dtInstance\" dt-options=\"dtOptions\"><thead><tr><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">תאריך העלאה</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">שם קובץ</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">פעולות</span></div></th></tr></thead><tbody><tr class=\"md-ink-ripple\" ng-repeat=\"file in files \">\n<td>{{file.UploadTime *1000 | date:\'dd/MM/yyyy\'}}</td><td><a href=\"{{file.Path}}\" target=\"_blank\">{{file.Name}}</a>\n</td><td><md-button class=\"preview-user\" ng-disabled=\"$root.AdminLevel!=3\" ng-click=\"deleteFileDialog(file)\" \ntitle=\"מחיקת קובץ\"><md-icon md-svg-icon=\"delete\"></md-icon></md-button></td></tr></tbody></table></div></div></div>");
$templateCache.put("app/main/pages/branches/views/branches/branch-management/tabs/general/general.html","<div><div layout=\"row\" layout-wrap class=\"jcsb\"><div class=\"general\" layout=\"column\" flex=\"100\" flex-gt-sm=\"80\" \nflex-gt-md=\"70\" flex-gt-lg=\"50\"><div class=\"profile-box info-box md-whiteframe-1dp\" layout=\"column\"><header \nclass=\"md-accent-bg\"><div class=\"title\">כללי</div></header><div class=\"content\"><form name=\"BranchForm\" \nclass=\"md-inline-form\" validate><div layout=\"row\" layout-wrap><md-input-container class=\"md-block md-icon-left\" \nlayout=\"column\" flex=\"50\" flex-xs=\"100\"><label>שם</label><md-icon md-font-icon=\"icon-account\" class=\"name\"></md-icon>\n<input ng-model=\"branch.Name\" md-autofocus \nng-disabled=\"$root.AdminLevel==1 || ($root.AdminLevel==2 && !$root.User.BranchesPer)\"></md-input-container><div \nclass=\"md-block md-icon-left\" layout=\"row\" flex=\"50\" flex-xs=\"100\"><md-icon md-font-icon=\"icon-city\" class=\"name\">\n</md-icon><md-autocomplete md-selected-item-change=\"setCity(item)\" \nng-disabled=\"isClicked || $root.AdminLevel==1 || ($root.AdminLevel==2 && !$root.User.BranchesPer)\" \nmd-input-name=\"autocompleteField\" md-no-cache=\"noCache\" md-selected-item=\"selectedItem\" md-search-text=\"searchText\" \nmd-items=\"item in querySearch(searchText)\" md-item-text=\"item.display\" md-min-length=\"0\" md-floating-label=\"שם ישוב\">\n<md-item-template><span md-highlight-text=\"searchText\" md-highlight-flags=\"^i\">{{item.display}}</span>\n</md-item-template><md-not-found>ישוב לא נמצא</md-not-found></md-autocomplete></div></div><div layout=\"row\" \nlayout-wrap><md-input-container class=\"md-block md-icon-left\" layout=\"column\" flex=\"50\" flex-xs=\"100\"><md-icon \nmd-font-icon=\"icon-domain\" class=\"name\"></md-icon><label>איזור</label><md-select ng-model=\"branch.AreaID\" \nng-disabled=\"!areas || $root.AdminLevel==1 || ($root.AdminLevel==2 && !$root.User.BranchesPer)\"><md-option \nng-selected=\"branch.AreaID==area.ID\" ng-repeat=\"area in areas\" ng-value=\"area.ID\">{{area.Name}}</md-option></md-select>\n</md-input-container><md-input-container class=\"md-block md-icon-left\" layout=\"column\" flex=\"50\" flex-xs=\"100\"><md-icon\n md-font-icon=\"icon-panorama-horizontal\"></md-icon><label>כתובת</label><input ng-model=\"branch.Address\" \nng-disabled=\"$root.AdminLevel==1 || ($root.AdminLevel==2 && !$root.User.BranchesPer)\"></md-input-container></div><div \nlayout=\"row\" layout-wrap><md-input-container class=\"md-block md-icon-left\" layout=\"column\" flex=\"50\" flex-xs=\"100\">\n<md-icon md-font-icon=\"icon-phone\"></md-icon><label>טלפון</label><input ng-model=\"branch.Phone\" \nng-disabled=\"$root.AdminLevel==1 || ($root.AdminLevel==2 && !$root.User.BranchesPer)\"></md-input-container>\n<md-input-container class=\"md-block md-icon-left\" layout=\"column\" flex=\"50\" flex-xs=\"100\"><md-icon \nmd-font-icon=\"icon-home\"></md-icon><label>נעילת תשלום באשראי</label><md-select ng-model=\"branch.LockCreditPay\" \nplaceholder=\"נעילת תשלום באשראי\" ng-disabled=\"$root.AdminLevel<3\"><md-option ng-value=\"\'1\'\">כן</md-option><md-option \nng-value=\"\'0\'\">לא</md-option></md-select></md-input-container></div><div layout=\"row\" layout-wrap><md-input-container \nclass=\"md-block md-icon-left\" layout=\"column\" flex=\"50\" flex-xs=\"100\"><md-icon md-svg-icon=\"numeric\"></md-icon><label>\nקוד סניף</label><input ng-model=\"branch.Code\" \nng-disabled=\"$root.AdminLevel==1 || ($root.AdminLevel==2 && !$root.User.BranchesPer)\"></md-input-container>\n<md-input-container class=\"md-block md-icon-left\" layout=\"column\" flex=\"50\" flex-xs=\"100\"><md-icon \nmd-font-icon=\"icon-power\"></md-icon><label>סטטוס</label><md-select ng-model=\"branch.Status\" placeholder=\"סטטוס\" \nng-disabled=\"$root.AdminLevel<3\"><md-option ng-selected=\"branch.Status==1 || branch.Status==\'1\'\" ng-value=\"1\">פעיל\n</md-option><md-option ng-selected=\"branch.Status==0 || branch.Status==\'0\'\" ng-value=\"0\">לא פעיל</md-option>\n</md-select></md-input-container></div><div layout=\"row\" layout-wrap><md-input-container class=\"md-block md-icon-left\" \nlayout=\"column\" flex=\"50\" flex-xs=\"100\"><md-icon md-font-icon=\"icon-account\"></md-icon><label>פטור מדמי חבר</label>\n<md-select ng-model=\"branch.FreeMemberFay\" placeholder=\"פטור מדמי חבר\" ng-disabled=\"$root.AdminLevel<3\"><md-option \nng-value=\"\'1\'\">כן</md-option><md-option ng-value=\"\'0\'\">לא</md-option></md-select></md-input-container>\n<md-input-container class=\"md-block md-icon-left\" layout=\"column\" flex=\"50\" flex-xs=\"100\"><md-icon \nmd-font-icon=\"icon-home\"></md-icon><label>תשלום בטופס התחייבות</label><md-select ng-model=\"branch.KibutzPay\" \nplaceholder=\"תשלום בטופס התחייבות\" \nng-disabled=\"$root.AdminLevel==1 || ($root.AdminLevel==2 && !$root.User.BranchesPer)\"><md-option ng-value=\"\'2\'\">חלקי\n</md-option><md-option ng-value=\"\'1\'\">כן</md-option><md-option ng-value=\"\'0\'\">לא</md-option></md-select>\n</md-input-container></div><div layout=\"row\" layout-wrap><md-input-container class=\"md-block md-icon-left\" \nlayout=\"column\" flex=\"50\" flex-xs=\"100\"><md-icon md-font-icon=\"icon-email\"></md-icon><label>אימייל</label><input \nng-model=\"branch.Email\" type=\"email\" \nng-disabled=\"$root.AdminLevel==1 || ($root.AdminLevel==2 && !$root.User.BranchesPer)\"></md-input-container></div><div \nlayout=\"row\" layout-wrap><md-input-container class=\"md-block md-icon-left\" layout=\"column\" flex=\"100\"><md-icon \nmd-font-icon=\"icon-email\"></md-icon><label>אימייל לקבלת בקשות סבסוד</label><md-chips ng-model=\"branch.SubsidyEmail\" \nreadonly=\"$root.AdminLevel==1 || ($root.AdminLevel==2 && !$root.User.BranchesPer)\" type=\"email\"></md-chips>\n</md-input-container></div><div layout=\"row\" layout-wrap ng-if=\"CreateTime\"><md-input-container \nclass=\"md-block md-icon-left\" layout=\"column\" flex=\"50\" flex-xs=\"100\"><label>תאריך הקמה</label><md-icon \nmd-font-icon=\"icon-account\" class=\"name\"></md-icon><input ng-value=\"CreateTime  * 1000 | date:\'HH:mm:ss dd/MM/yyyy\'\" \nng-disabled=\"true\"></md-input-container></div></form></div></div></div><div class=\"general\" layout=\"column\" flex=\"100\" \nflex-gt-sm=\"80\" flex-gt-md=\"70\" flex-gt-lg=\"30\"><div ng-show=\"$root.AdminLevel>1\" \nclass=\"profile-box info-box work md-whiteframe-1dp\" layout=\"column\"><header class=\"md-accent-bg sflex aic jcsb\"><div \nclass=\"title\">תגיות</div><span><md-icon md-font-icon=\"icon-plus\" title=\"הוספת תגית\" ng-click=\"addNewTag()\" class=\"cp\">\n</md-icon></span></header><div class=\"content\"><div class=\"loader w100 fcc\" ng-if=\"!tags\"><md-progress-circular \nmd-mode=\"indeterminate\"></md-progress-circular></div><div ng-repeat=\"tag in tags\" class=\"mt10 sflex jcsb aic\" \nng-if=\"tags\"><div><md-icon md-font-icon=\"icon-pound\" class=\"name\"></md-icon>{{tag.Tag}}</div><div><md-button \nng-click=\"deleteTag(tag)\" class=\"send-button md-accent md-raised m0\"><md-icon md-font-icon=\"icon-trash\"></md-icon>\n</md-button></div></div></div></div></div></div></div>");
$templateCache.put("app/main/pages/branches/views/branches/branch-management/tabs/statistics/statistics.html","<div id=\"branch-files\" class=\"page-layout simple tabbed\"><div class=\"content\"><div layout=\"row\" layout-sm=\"column\" \nlayout-align=\"space-around\" ng-show=\"!statistics\" style=\"margin-top: 300px\"><md-progress-circular \nmd-mode=\"indeterminate\"></md-progress-circular></div><div class=\"content\" flex ng-show=\"statistics\"><div \nclass=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap><ms-widget flippable=\"true\" layout=\"column\" flex=\"100\" \nflex-gt-xs=\"50\" flex-gt-md=\"25\"><ms-widget-front class=\"white-bg\"><div class=\"ph-8 pv-16 h-55\" layout=\"row\" \nlayout-align=\"space-between center\"></div><div class=\"pt-8 pb-32\" layout=\"column\" layout-align=\"center center\"><div \nclass=\"light-blue-fg font-size-72 line-height-72\">{{statistics.TotalActiveStudents}}</div><div \nclass=\"h3 secondary-text font-weight-500\">מספר חניכים שנרשמו ל{{$root.User.Event}} אחד לפחות בשנה החולפת</div></div>\n<div class=\"p-16\" layout=\"row\" layout-align=\"start center\"></div></ms-widget-front></ms-widget><ms-widget \nflippable=\"true\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\"><ms-widget-front class=\"white-bg\"><div \nclass=\"ph-8 pv-16 h-55\" layout=\"row\" layout-align=\"space-between center\"></div><div class=\"pt-8 pb-32\" layout=\"column\" \nlayout-align=\"center center\"><div class=\"light-blue-fg font-size-72 line-height-72\">{{statistics.ActiveStudents}}</div>\n<div class=\"h3 secondary-text font-weight-500\">מספר חניכים פעילים</div></div><div class=\"p-16\" layout=\"row\" \nlayout-align=\"start center\"></div></ms-widget-front></ms-widget><ms-widget flippable=\"true\" layout=\"column\" flex=\"100\" \nflex-gt-xs=\"50\" flex-gt-md=\"25\"><ms-widget-front class=\"white-bg\"><div class=\"ph-8 pv-16 h-55\" layout=\"row\" \nlayout-align=\"space-between center\"></div><div class=\"pt-8 pb-32\" layout=\"column\" layout-align=\"center center\"><div \nclass=\"light-blue-fg font-size-72 line-height-72\">{{statistics.UnActiveStudents}}</div><div \nclass=\"h3 secondary-text font-weight-500\">מספר חניכים לא פעילים</div></div><div class=\"p-16\" layout=\"row\" \nlayout-align=\"start center\"></div></ms-widget-front></ms-widget><ms-widget flippable=\"true\" layout=\"column\" flex=\"100\" \nflex-gt-xs=\"50\" flex-gt-md=\"25\"><ms-widget-front class=\"white-bg\"><div class=\"ph-8 pv-16 h-55\" layout=\"row\" \nlayout-align=\"space-between center\"></div><div class=\"pt-8 pb-32\" layout=\"column\" layout-align=\"center center\"><div \nclass=\"light-blue-fg font-size-72 line-height-72\">{{statistics.GraduatesStudents}}</div><div \nclass=\"h3 secondary-text font-weight-500\">מספר בוגרים</div></div><div class=\"p-16\" layout=\"row\" \nlayout-align=\"start center\"></div></ms-widget-front></ms-widget></div><div class=\"widget-group\" layout=\"row\" \nflex=\"100\" layout-wrap><ms-widget flippable=\"true\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\">\n<ms-widget-front class=\"white-bg\"><div class=\"ph-8 pv-16 h-55\" layout=\"row\" layout-align=\"space-between center\"></div>\n<div class=\"pt-8 pb-32\" layout=\"column\" layout-align=\"center center\"><div \nclass=\"light-blue-fg font-size-72 line-height-72\">{{statistics.Educators}}</div><div \nclass=\"h3 secondary-text font-weight-500\">מספר מדריכים</div></div><div class=\"p-16\" layout=\"row\" \nlayout-align=\"start center\"></div></ms-widget-front></ms-widget><ms-widget flippable=\"true\" layout=\"column\" flex=\"100\" \nflex-gt-xs=\"50\" flex-gt-md=\"25\"><ms-widget-front class=\"white-bg\"><div class=\"ph-8 pv-16 h-55\" layout=\"row\" \nlayout-align=\"space-between center\"></div><div class=\"pt-8 pb-32\" layout=\"column\" layout-align=\"center center\"><div \nclass=\"light-blue-fg font-size-72 line-height-72\">{{statistics.Coordinators}}</div><div \nclass=\"h3 secondary-text font-weight-500\">מספר {{$root.User.Coordinators}}</div></div><div class=\"p-16\" layout=\"row\" \nlayout-align=\"start center\"></div></ms-widget-front></ms-widget><ms-widget flippable=\"true\" layout=\"column\" flex=\"100\" \nflex-gt-xs=\"50\" flex-gt-md=\"25\"><ms-widget-front class=\"white-bg\"><div class=\"ph-8 pv-16 h-55\" layout=\"row\" \nlayout-align=\"space-between center\"></div><div class=\"pt-8 pb-32\" layout=\"column\" layout-align=\"center center\"><div \nclass=\"light-blue-fg font-size-72 line-height-72\">{{statistics.ActiveGroups}}</div><div \nclass=\"h3 secondary-text font-weight-500\">מספר {{$root.User.Groups}} {{$root.User.Activity}}</div></div><div \nclass=\"p-16\" layout=\"row\" layout-align=\"start center\"></div></ms-widget-front></ms-widget></div><div \nclass=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap><ms-widget layout=\"column\" flex=\"100\" flex-gt-sm=\"50\">\n<ms-widget-front class=\"white-bg\"><div class=\"h3 p-16\">חמשת ה{{$root.User.Events}}\\מוצרים המבוקשים ביותר בשנה החולפת\n</div><md-divider></md-divider><canvas class=\"chart chart-pie\" chart-data=\"statistics.TopEvents.Data\" \nchart-colors=\"statistics.colors2\" chart-labels=\"statistics.TopEvents.Labels\" chart-options=\"statistics.options\">\n</canvas></ms-widget-front></ms-widget></div></div></div></div>");
$templateCache.put("app/main/pages/branches/views/branches/branch-management/tabs/hours/hours.html","<div class=\"hours-container\"><div class=\"action-buttons\"><md-button ng-show=\"$root.AdminLevel>=2\" \nclass=\"md-fab md-accent md-icon-button\" id=\"add-newBranchHour-button\" ng-click=\"addNewHour()\" \naria-label=\"add new Branch hour\" title=\"הוספה\"><md-icon md-font-icon=\"icon-plus\"></md-icon></md-button></div><div \nlayout=\"row\" layout-wrap class=\"pt10\"><div class=\"general\" layout=\"column\" flex=\"100\" flex-gt-sm=\"80\"><div \nclass=\"profile-box info-box md-whiteframe-1dp\" layout=\"column\"><header class=\"md-accent-bg\"><div class=\"title\">\nשעות פעילות</div></header><div class=\"content\"><form name=\"hoursForm\" class=\"md-inline-form\" validate><div \nlayout=\"row\" layout-wrap ng-repeat=\"hour in hours\"><md-input-container class=\"md-block md-icon-left\" layout=\"column\" \nflex=\"20\" flex-xs=\"100\"><label>יום</label><md-select ng-model=\"hour.Day\" ng-disabled=\"$root.AdminLevel<2\" \nng-change=\"hour.dirty = true\"><md-option ng-value=\"1\">ראשון</md-option><md-option ng-value=\"2\">שני</md-option>\n<md-option ng-value=\"3\">שלישי</md-option><md-option ng-value=\"4\">רביעי</md-option><md-option ng-value=\"5\">חמישי\n</md-option><md-option ng-value=\"6\">שישי</md-option><md-option ng-value=\"7\">שבת</md-option></md-select>\n</md-input-container><md-input-container class=\"md-block md-icon-left\" layout=\"column\" flex=\"20\" flex-xs=\"100\"><label>\nמשעה</label><input ng-model=\"hour.FromHour\" required ng-disabled=\"$root.AdminLevel<2\" type=\"time\" \nng-change=\"hour.dirty = true\"></md-input-container><md-input-container class=\"md-block md-icon-left\" layout=\"column\" \nflex=\"20\" flex-xs=\"100\"><label>עד שעה</label><input ng-model=\"hour.ToHour\" required ng-disabled=\"$root.AdminLevel<2\" \ntype=\"time\" ng-change=\"hour.dirty = true\"></md-input-container><md-input-container class=\"md-block md-icon-left\" \nlayout=\"column\" flex=\"20\" flex-xs=\"100\"><label>קבוצה</label><md-select ng-model=\"hour.GroupID\" \nng-disabled=\"$root.AdminLevel<2\" ng-change=\"hour.dirty = true\"><md-option ng-repeat=\"group in groups\" \nng-value=\"group.ID\">{{group.Name}}</md-option></md-select></md-input-container><md-input-container \nclass=\"md-block md-icon-left\" layout=\"column\" flex=\"20\" flex-xs=\"100\"><md-button class=\"md-raised md-accent\" \nng-click=\"deleteHour(hour)\" ng-disabled=\"$root.AdminLevel<2\"><md-icon md-svg-icon=\"delete\"></md-icon></md-button>\n</md-input-container></div><div layout=\"row\"><md-input-container ng-if=\"displayHoursSave()\" \nclass=\"md-block md-icon-right\" layout=\"column\" flex=\"25\" flex-xs=\"100\"><md-button class=\"md-raised md-accent\" \nng-click=\"saveHours()\" ng-disabled=\"$root.AdminLevel<2\">שמירה</md-button></md-input-container></div></form></div></div>\n</div></div></div>");
$templateCache.put("app/main/pages/branches/views/groups/group-management/tabs/contacts/contacts.html","<div class=\"hours-container\"><div class=\"action-buttons\"><md-button ng-show=\"$root.AdminLevel>2\" \nclass=\"md-fab md-accent md-icon-button\" id=\"add-newBranchHour-button\" ng-click=\"addNewContact()\" \naria-label=\"add new Branch hour\" title=\"הוספה\"><md-icon md-font-icon=\"icon-plus\"></md-icon></md-button></div><div \nlayout=\"row\" layout-wrap><div layout=\"column\" flex=\"100\" flex-gt-sm=\"100\" flex-gt-md=\"80\" flex-gt-lg=\"90\"><form \nname=\"contactsForm\" class=\"md-inline-form\" validate><div class=\"filters\" layout=\"row\" layout-xs=\"column\" flex=\"100\" \nflex-gt-sm=\"100\" flex-gt-md=\"70\"><div layout=\"column\" flex=\"100\" flex-gt-sm=\"100\" flex-gt-md=\"33\"><md-input-container \nclass=\"md-icon-float md-block\"><md-icon md-font-icon=\"icon-power\"></md-icon><label>סטטוס איש קשר</label><md-select \nng-model=\"contactsSearch.Status\" placeholder=\"סינון לפי סטטוס איש קשר\" ng-disabled=\"!groupContacts\"><md-option \nng-value=\"null\">הצג הכל</md-option><md-option ng-value=\"1\">פעילים</md-option><md-option ng-value=\"0\">לא פעילים\n</md-option></md-select></md-input-container></div><div layout=\"column\" flex=\"100\" flex-gt-sm=\"100\" flex-gt-md=\"33\">\n<md-input-container id=\"free-search\" class=\"md-icon-float md-block\"><md-icon md-font-icon=\"icon-magnify\"></md-icon>\n<label>חיפוש חופשי</label><input ng-model=\"contactsSearch.freeSearchFromDB\" type=\"search\" ng-disabled=\"!groupContacts\">\n</md-input-container></div></div><div class=\"search-actions row\" layout=\"row\"><md-button type=\"submit\" \nng-disabled=\"!groupContacts\" class=\"md-raised md-accent\" aria-label=\"חפש\" ng-click=\"getContacts()\">סינון</md-button>\n<md-button ng-disabled=\"!groupContacts\" class=\"md-raised md-accent\" aria-label=\"חפש\" ng-click=\"getContacts(true)\">\nבטל סינון</md-button></div></form></div></div><div class=\"content\"><div layout=\"row\" layout-sm=\"column\" \nlayout-align=\"space-around\" ng-if=\"!groupContacts\"><md-progress-circular md-mode=\"indeterminate\">\n</md-progress-circular></div><div ng-if=\"groupContacts\"><table id=\"branches-table\" \nclass=\"dataTable row-border hover stripe md-ink-ripple\" datatable=\"ng\" dt-instance=\"dtInstance\" dt-options=\"dtOptions\">\n<thead><tr><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">שם</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">טלפון</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">מייל</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">תפקיד</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">תצוגה בפרופיל הורה</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">סטטוס</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">פעולות</span></div></th></tr></thead>\n<tbody><tr class=\"entry-code-item\" ng-repeat=\"contact in groupContacts\"><td>{{contact.Name}}</td><td>{{contact.Phone}}\n</td><td>{{contact.Email}}</td><td>{{contact.Role}}</td><td>{{contact.ShowInProfile? \'מוצג\' : \'לא מוצג\'}}</td><td>\n{{contact.Status==1 || contact.Status==\'1\' ? \'פעיל\' : \'לא פעיל\'}}</td><td><md-button \nclass=\"preview-user md-icon-button\" ng-click=\"editContact(contact)\" title=\"עריכה\"><md-icon md-svg-icon=\"pencil\">\n</md-icon></md-button></td></tr></tbody></table></div></div></div>");
$templateCache.put("app/main/pages/branches/views/groups/group-management/tabs/educators/educators.html","<div id=\"history_log\" ng-init=\"getEducators()\"><div layout=\"row\" layout-wrap><div class=\"general\" layout=\"column\" \nflex=\"100\" flex-gt-sm=\"80\" flex-gt-md=\"70\" flex-gt-lg=\"50\"><div class=\"profile-box info-box md-whiteframe-1dp\" \nlayout=\"column\"><header class=\"md-accent-bg\"><div class=\"title\">רשימת מדריכים</div></header><div class=\"content\"><form \nname=\"UserForm\" class=\"md-inline-form\" validate><div layout=\"row\" layout-wrap><table><thead><tr><th>שם פרטי</th><th>\nשם משפחה</th><th>מספר זהות</th><th>דואר אלקטרוני</th><th></th></tr></thead><tbody><tr \nng-repeat=\"educator in educators\"><td>{{educator.FirstName}}</td><td>{{educator.LastName}}</td><td>\n{{educator.PrivateID}}</td><td>{{educator.Email}}</td><td><span><md-button class=\"preview-user\" \nhref=\"/student-profile?ID={{educator.StudentID}}\" target=\"_blank\" title=\"מעבר לפרופיל\"><md-icon md-svg-icon=\"account\">\n</md-icon></md-button></span></td></tr></tbody></table></div></form></div></div></div></div><div layout=\"row\" \nlayout-wrap><div class=\"general\" layout=\"column\" flex=\"100\" flex-gt-sm=\"80\" flex-gt-md=\"70\" flex-gt-lg=\"50\"><div \nclass=\"profile-box info-box md-whiteframe-1dp\" layout=\"column\"><header class=\"md-accent-bg\"><div class=\"title\">היסטוריה\n</div></header><div class=\"content\"><div layout=\"row\" layout-wrap><table><thead><tr><th>תאריך</th><th>שם פרטי</th><th>\nשם משפחה</th><th>מספר זהות</th><th>ערך ישן</th><th>ערך חדש</th></tr></thead><tbody><tr ng-repeat=\"educator in history\">\n<td>{{educator.Timestamp * 1000 | date:\'HH:mm:ss dd/MM/yyyy\'}}</td><td>{{educator.FirstName}}</td><td>\n{{educator.LastName}}</td><td>{{educator.PrivateID}}</td><td><ul class=\"sflex fdc aifs\"><li \nng-repeat=\"item in educator.OldVal\">{{item.key}}: {{item.value}}</li></ul></td><td><ul class=\"sflex fdc aifs\"><li \nng-repeat=\"item in educator.NewVal\">{{item.key}}: {{item.value}}</li></ul></td></tr></tbody></table></div></div></div>\n</div></div></div>");
$templateCache.put("app/main/pages/branches/views/groups/group-management/tabs/general/general.html","<div><div layout=\"row\" layout-wrap><div class=\"general\" layout=\"column\" flex=\"100\" flex-gt-sm=\"80\" flex-gt-md=\"70\" \nflex-gt-lg=\"60\"><div class=\"profile-box info-box md-whiteframe-1dp\" layout=\"column\"><header class=\"md-accent-bg\"><div \nclass=\"title\">כללי</div></header><div class=\"content\"><form name=\"GroupForm\" class=\"md-inline-form\" validate><div \nlayout=\"row\" layout-wrap><md-input-container class=\"md-block md-icon-left\" layout=\"column\" flex=\"50\" flex-xs=\"100\">\n<label>שם</label><md-icon md-font-icon=\"icon-account\" class=\"name\"></md-icon><input ng-model=\"group.Name\" md-autofocus \nng-disabled=\"$root.AdminLevel==1\"></md-input-container><md-input-container class=\"md-block md-icon-left\" \nlayout=\"column\" flex=\"50\" flex-xs=\"100\"><md-icon md-font-icon=\"icon-city\" class=\"name\"></md-icon><label>\n{{$root.User.Branch}}</label><md-select ng-model=\"group.BranchID\" ng-required=\"true\" ng-disabled=\"!branches.length\">\n<md-option ng-repeat=\"branch in branches\" ng-value=\"branch.ID\">{{branch.Name}}</md-option></md-select>\n</md-input-container></div><div layout=\"row\" layout-wrap><md-input-container class=\"md-block md-icon-left\" \nlayout=\"column\" flex=\"50\" flex-xs=\"100\"><md-icon md-font-icon=\"icon-chair-school\" class=\"name\"></md-icon><label>\n{{$root.User.Grades}}</label><md-select md-on-close=\"clearSearchTerm()\" ng-model=\"group.Grades\" ng-required=\"true\" \nmultiple=\"true\"><md-select-header class=\"demo-select-header\"><input ng-model=\"searchTerm\" type=\"text\" \nng-disabled=\"!grades || isClicked\" ng-keydown=\"$event.stopPropagation()\" placeholder=\"חפש שכבה..\" \nclass=\"demo-header-searchbox md-text\" autocomplete=\"off\"></md-select-header><md-optgroup \nng-disabled=\"!grades || isClicked\"><md-option ng-value=\"grade.ID\" ng-repeat=\"grade in grades |filter:searchTerm\">\n{{grade.Name}}</md-option></md-optgroup></md-select></md-input-container><md-input-container \nclass=\"md-block md-icon-left\" layout=\"column\" flex=\"50\" flex-xs=\"100\"><md-icon md-font-icon=\"icon-power\" class=\"name\">\n</md-icon><label>סטטוס</label><md-select ng-model=\"group.Status\" placeholder=\"סטטוס\" ng-disabled=\"$root.AdminLevel<2\">\n<md-option ng-selected=\"group.Status==1 || group.Status==\'1\'\" ng-value=\"1\">פעיל</md-option><md-option \nng-selected=\"group.Status==0 || group.Status==\'0\'\" ng-value=\"0\">לא פעיל</md-option></md-select></md-input-container>\n</div><div layout=\"row\" layout-wrap ng-if=\"CreateTime\"><md-input-container class=\"md-block md-icon-left\" \nlayout=\"column\" flex=\"50\" flex-xs=\"100\"><label>תאריך הקמה</label><md-icon md-font-icon=\"icon-account\" class=\"name\">\n</md-icon><input ng-value=\"CreateTime  * 1000 | date:\'HH:mm:ss dd/MM/yyyy\'\" ng-disabled=\"true\"></md-input-container>\n</div></form></div></div></div></div></div>");
$templateCache.put("app/main/pages/events/views/events/event-management/tabs/association/association.html","<div><div layout=\"row\" layout-sm=\"column\" layout-align=\"space-around\" ng-if=\"!association\"><md-progress-circular \nmd-mode=\"indeterminate\"></md-progress-circular></div><div ng-if=\"association\"><div layout=\"row\" layout-wrap \nlayout-align=\"space-between\"><div class=\"general\" layout=\"column\" flex=\"100\" flex-gt-sm=\"70\" flex-gt-md=\"70\" \nflex-gt-lg=\"60\"><div class=\"profile-box info-box md-whiteframe-1dp\" layout=\"column\"><header class=\"md-accent-bg\"><div \nclass=\"title\">שיוכים נוספים</div></header><div class=\"content\"><form name=\"UserForm\" class=\"md-inline-form\" validate>\n<div class=\"row\" layout=\"row\"><div class=\"half\"><md-input-container class=\"md-icon-float md-block\"><label>מין</label>\n<md-icon md-svg-icon=\"gender-male-female\"></md-icon><md-select ng-model=\"event.Gender\" placeholder=\"מין\" \nng-disabled=\"$root.AdminLevel==1 || ($root.AdminLevel==2 && event.CoordinatorID!=$root.User.ID)\"><md-option \nng-value=\"0\" ng-selected=\"event.Gender==\'0\'\">הכל</md-option><md-option ng-selected=\"event.Gender==\'1\'\" ng-value=\"\'1\'\">\nזכר</md-option><md-option ng-selected=\"event.Gender==\'2\'\" ng-value=\"\'2\'\">נקבה</md-option></md-select>\n</md-input-container></div><div class=\"half\"><md-input-container class=\"md-icon-float md-block\"><label>\n{{$root.User.Event}} עבור מדריכים בלבד</label><md-icon md-svg-icon=\"tie\"></md-icon><md-select \nng-model=\"event.EducatorsOnly\" \nng-disabled=\"$root.AdminLevel==1 || ($root.AdminLevel==2 && event.CoordinatorID!=$root.User.ID)\"><md-option \nng-value=\"1\">כן</md-option><md-option ng-value=\"0\">לא</md-option></md-select></md-input-container></div></div></form>\n</div></div></div><div class=\"general\" layout=\"column\" flex=\"100\" flex-gt-sm=\"25\" flex-gt-md=\"25\" flex-gt-lg=\"35\" \nng-if=\"testDateEvent(event)\"><md-toolbar class=\"md-accent-bg md-menu-toolbar\"><div class=\"md-toolbar-tools inrowf\"><div\n class=\"title\">שיוך לחניך<md-icon md-font-icon=\"icon-information\" \ntitle=\"לחניכים אלו תנתן אפשרות לבצע רישום בכל עת כאשר ה{{$root.User.Event}} פעיל\"></md-icon></div><div \nclass=\"inrowf aic\"><md-input-container class=\"md-icon-float md-block\"><md-select ng-model=\"filters\" \nng-change=\"filterGeneral()\"><md-option ng-value=\"undefined\">הצג הכל</md-option><md-option ng-value=\"1\">פעילים\n</md-option><md-option ng-value=\"0\">לא פעילים</md-option></md-select></md-input-container><md-button \nclass=\"md-icon-button\" aria-label=\"הוסף חניך\" title=\"הוספת חניך\" ng-click=\"addNewStudentAssociation()\"><md-icon \nmd-font-icon=\"icon-plus\"></md-icon></md-button></div></div></md-toolbar><div class=\"content\"><table \nclass=\"dataTable row-border hover stripe md-ink-ripple\"><thead><tr><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">שם חניך</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">ת.ז.</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">סטטוס</span></div></th></tr></thead><tbody><tr class=\"main-table-new\" \nng-repeat=\"student in studentsAssociations | filter: {Status: filters}\"><td>{{student.Name}}</td><td>\n{{student.PrivateID}}</td><td><md-input-container><label>סטטוס</label><md-select ng-model=\"student.Status\" \nng-change=\"changeStudentStatus(student)\"><md-option value=\"1\" ng-selected=\"student.Status==1\">פעיל</md-option>\n<md-option value=\"0\" ng-selected=\"student.Status==0\">לא פעיל</md-option></md-select></md-input-container></td></tr>\n</tbody></table></div></div></div><div layout=\"row\" layout-wrap layout-align=\"space-between\"><div class=\"general\" \nlayout=\"column\" flex=\"100\" flex-gt-sm=\"70\" flex-gt-md=\"70\" flex-gt-lg=\"60\"><div \nclass=\"profile-box info-box md-whiteframe-1dp\" layout=\"column\"><header class=\"md-accent-bg sflex aic jcsb\"><div \nclass=\"title\">שיוך איזורים<md-icon md-font-icon=\"icon-information\" \ntitle=\"במידה ולא נבחרו שיוכים ה{{$root.User.Event}} פתוח לכל האיזורים הפעילים\"></md-icon></div><md-button \nclass=\"md-icon-button\" aria-label=\"הוסף איזור\" title=\"הוספת שיוך\" ng-click=\"addNewAssociation(1)\"><md-icon \nmd-font-icon=\"icon-plus\"></md-icon></md-button></header><div class=\"content\"><table \nclass=\"dataTable row-border hover stripe md-ink-ripple\"><thead><tr><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">איזור</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">פעולות</span></div></th></tr></thead><tbody><tr class=\"main-table-new\" \nng-repeat=\"association in areaAssociations\"><td>{{association.Name}}</td><td><md-button \nng-click=\"deleteAreaAssociation(association)\" class=\"send-button md-accent md-raised m0\"><md-icon \nmd-font-icon=\"icon-trash\"></md-icon></md-button></td></tr></tbody></table></div></div><div \nclass=\"profile-box info-box md-whiteframe-1dp\" layout=\"column\"><header class=\"md-accent-bg sflex aic jcsb\"><div \nclass=\"title\">שיוך {{$root.User.Branches}}<md-icon md-font-icon=\"icon-information\" \ntitle=\"במידה ולא נבחרו שיוכים ה{{$root.User.Event}} פתוח לכל ה{{$root.User.Branches}} הפעילים\"></md-icon></div>\n<md-button class=\"md-icon-button\" aria-label=\"הוסף {{$root.User.Branch}}\" title=\"הוספת שיוך\" \nng-click=\"addNewAssociation(2)\"><md-icon md-font-icon=\"icon-plus\"></md-icon></md-button></header><div class=\"content\">\n<table class=\"dataTable row-border hover stripe md-ink-ripple\"><thead><tr><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">{{$root.User.Branch}}</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">פעולות</span></div></th></tr></thead><tbody><tr class=\"main-table-new\" \nng-repeat=\"association in branchAssociations\"><td>{{association.Name}}</td><td><md-button \nng-click=\"deleteBranchAssociation(association)\" class=\"send-button md-accent md-raised m0\"><md-icon \nmd-font-icon=\"icon-trash\"></md-icon></md-button></td></tr></tbody></table></div></div><div \nclass=\"profile-box info-box md-whiteframe-1dp\" layout=\"column\"><header class=\"md-accent-bg sflex aic jcsb\"><div \nclass=\"title\">שיוך {{$root.User.Grades}}<md-icon md-font-icon=\"icon-information\" \ntitle=\"במידה ולא נבחרו שיוכים ה{{$root.User.Event}} פתוח לכל ה{{$root.User.Grades}} הפעילים\"></md-icon></div><md-button\n class=\"md-icon-button\" aria-label=\"הוסף {{$root.User.Grade\" title=\"הוספת שיוך\" ng-click=\"addNewAssociation(3)\">\n<md-icon md-font-icon=\"icon-plus\"></md-icon></md-button></header><div class=\"content\"><table \nclass=\"dataTable row-border hover stripe md-ink-ripple\"><thead><tr><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">{{$root.User.Grade}}</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">פעולות</span></div></th></tr></thead><tbody><tr class=\"main-table-new\" \nng-repeat=\"association in gradeAssociations\"><td>{{association.Name}}</td><td><md-button \nng-click=\"deleteGradeAssociation(association)\" class=\"send-button md-accent md-raised m0\"><md-icon \nmd-font-icon=\"icon-trash\"></md-icon></md-button></td></tr></tbody></table></div></div></div></div></div></div>");
$templateCache.put("app/main/pages/events/views/events/event-management/tabs/donations/donations.html","<div id=\"donations\" class=\"page-layout simple tabbed\"><div class=\"content\"><div layout=\"row\" layout-sm=\"column\" \nlayout-align=\"space-around\" ng-if=\"!donations\"><md-progress-circular md-mode=\"indeterminate\"></md-progress-circular>\n</div><div ng-if=\"donations\"><table id=\"type-subscribers-table\" \nclass=\"dataTable row-border hover stripe md-ink-ripple\" datatable=\"ng\" dt-column-defs=\"dtColumnDefs\" \ndt-instance=\"dtInstance\" dt-options=\"dtOptions\"><thead><tr><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">מספר הרשמה</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">שם חניך</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">קבלה</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">תרומה</span></div></th></tr></thead><tbody><tr class=\"md-ink-ripple\" \nng-repeat=\"donation in donations\"><td>{{donation.RegistrationID}}</td><td>{{donation.StudentName}}</td><td class=\"cp\" \nng-click=\"downloadReceipt(donation.ReceiptID,1)\"><a>{{donation.ReceiptID}}</a></td><td>{{donation.Amount}} &#8362;</td>\n</tr></tbody></table></div></div></div>");
$templateCache.put("app/main/pages/events/views/events/event-management/tabs/cart-events/cart-events.html","<div id=\"cart-events\" class=\"page-layout simple tabbed\" ng-init=\"getCartEvents();checkIfCanAdd();\"><div layout=\"row\" \nlayout-wrap><div class=\"profile-box info-box md-whiteframe-1dp\" layout=\"column\" flex=\"100\" flex-gt-sm=\"80\" \nflex-gt-md=\"70\" flex-gt-lg=\"60\"><md-toolbar class=\"md-accent-bg md-menu-toolbar\"><div class=\"md-toolbar-tools inrowf\">\n<div class=\"title\">{{$root.User.Event}}י סל</div><div class=\"inrowf aic\"><md-input-container \nclass=\"md-icon-float md-block\"><md-select ng-model=\"filterCartEvents\" placeholder=\"סינון לפי סטטוס\" \nng-init=\"filterCartEvents=1\"><md-option ng-value=\"undefined\">הצג הכל</md-option><md-option ng-value=\"1\">פעילים\n</md-option><md-option ng-value=\"0\">לא פעילים</md-option></md-select></md-input-container><md-button \nclass=\"md-icon-button\" title=\"הוספת {{$root.User.Event}}\" ng-click=\"addNewCartEvent()\" ng-if=\"allEvents\" \nng-disabled=\"!canAdd\"><md-icon md-font-icon=\"icon-plus\"></md-icon></md-button></div></div></md-toolbar><div \nclass=\"content\"><div layout=\"row\" layout-sm=\"column\" layout-align=\"space-around\" ng-show=\"!cartEvents\">\n<md-progress-circular md-mode=\"indeterminate\"></md-progress-circular></div><table ng-show=\"cartEvents\" \nclass=\"dataTable row-border hover stripe md-ink-ripple\"><thead><tr><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">שם {{$root.User.Event}}</span></div></th><th class=\"secondary-text\">\n<div class=\"table-header\"><span class=\"column-title\">אחוז מכלל הסל</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">פעולות</span></div></th></tr></thead><tbody><tr class=\"main-table-new\" \nng-repeat=\"event in cartEvents | filter:{Status : filterCartEvents}\"><td>{{event.Name}}</td><td><md-input-container>\n<input ng-model=\"event.ChargePercent\" ng-change=\"sumPercents()\" type=\"number\" min=\"1\" max=\"100\"><md-icon \nmd-font-icon=\"icon-percent\"></md-icon></md-input-container></td><td><md-button aria-label=\"Use Android\" \ntitle=\"הפוך לפעיל\\לא פעיל\" ng-disabled=\"isClicked\"><md-icon md-font-icon=\"icon-power\" \nng-class=\"{\'green600\':event.Status==1, \'red600\':event.Status==0}\" ng-click=\"updateCartEventStatus(event)\"></md-icon>\n</md-button></td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/main/pages/events/views/events/event-management/tabs/discounts/discounts.html","<div ng-controller=\"EventDiscountsController\" id=\"event-discounts\" class=\"page-layout simple tabbed\"><div \nclass=\"content\" flex><md-tabs md-dynamic-height><md-tab ng-disabled=\"$root.isEdit && selectedTab!=0\" \nmd-on-select=\"setTab(0)\" ng-if=\"!event.Level\"><md-tab-label><span>דרגת הנחה למשפחה</span></md-tab-label><md-tab-body>\n<md-content \nng-include=\"\'app/main/pages/events/views/events/event-management/tabs/discounts/tabs/discount-levels.html\'\">\n</md-content></md-tab-body></md-tab><md-tab ng-disabled=\"$root.isEdit && selectedTab!=1\" md-on-select=\"setTab(1)\">\n<md-tab-label><span>הנחת אחים</span></md-tab-label><md-tab-body><md-content \nng-include=\"\'app/main/pages/events/views/events/event-management/tabs/discounts/tabs/brothers-discounts.html\'\">\n</md-content></md-tab-body></md-tab><md-tab ng-disabled=\"$root.isEdit && selectedTab!=2\" md-on-select=\"setTab(2)\" \nng-if=\"!event.Level\"><md-tab-label><span>הנחות כלליות</span></md-tab-label><md-tab-body><md-content \nng-include=\"\'app/main/pages/events/views/events/event-management/tabs/discounts/tabs/general-discounts.html\'\">\n</md-content></md-tab-body></md-tab><md-tab ng-disabled=\"$root.isEdit && selectedTab!=3\" md-on-select=\"setTab(3)\" \nng-if=\"!event.Level\"><md-tab-label><span>הנחות חניכים</span></md-tab-label><md-tab-body><md-content \nng-include=\"\'app/main/pages/events/views/events/event-management/tabs/discounts/tabs/student-discounts.html\'\">\n</md-content></md-tab-body></md-tab><md-tab ng-disabled=\"$root.isEdit && selectedTab!=4\" md-on-select=\"setTab(4)\" \nng-if=\"!event.Level\"><md-tab-label><span>הנחות לפי תאריכים</span></md-tab-label><md-tab-body><md-content \nng-include=\"\'app/main/pages/events/views/events/event-management/tabs/discounts/tabs/date-discounts.html\'\">\n</md-content></md-tab-body></md-tab></md-tabs></div></div>");
$templateCache.put("app/main/pages/events/views/events/event-management/tabs/external-subscribers/external-subscribers.html","<div id=\"registers\" class=\"page-layout simple tabbed\" ng-controller=\"EventManagementExternalSubscribersController\"><div\n layout=\"row\" layout-wrap><form name=\"UserForm\" class=\"md-inline-form w100\" validate><div class=\"filters\" layout=\"row\" \nflex=\"100\" flex-gt-sm=\"100\" flex-gt-md=\"70\"><div layout=\"column\" flex=\"100\" flex-gt-sm=\"50\" flex-gt-md=\"33\">\n<md-input-container id=\"free-search\" class=\"md-icon-float md-block\"><md-icon md-font-icon=\"icon-magnify\"></md-icon>\n<label>חיפוש חופשי</label><input ng-model=\"search.freeSearchFromDB\" type=\"search\" ng-disabled=\"!subscribers\">\n</md-input-container></div><div layout=\"column\" flex=\"100\" flex-gt-sm=\"50\" flex-gt-md=\"33\"><md-input-container \nclass=\"md-icon-float md-block\"><md-icon md-font-icon=\"icon-power\"></md-icon><label>סטטוס הזמנה</label><md-select \nng-model=\"search.Status\" placeholder=\"סינון לפי סטטוס הזמנה\" ng-disabled=\"!subscribers\" ng-init=\"search.Status = 1\">\n<md-option ng-value=\"null\">הצג הכל</md-option><md-option ng-value=\"1\">פעילים</md-option><md-option ng-value=\"0\">\nלא פעילים</md-option></md-select></md-input-container></div></div><div class=\"search-actions row\" layout=\"row\">\n<md-button type=\"submit\" ng-disabled=\"!subscribers\" class=\"md-raised md-accent\" aria-label=\"חפש\" \nng-click=\"getSubscribers()\">סינון</md-button><md-button ng-disabled=\"!subscribers\" class=\"md-raised md-accent\" \naria-label=\"חפש\" ng-click=\"getSubscribers(true)\">בטל סינון</md-button></div></form><div class=\"content w100\"><div \nlayout=\"row\" layout-sm=\"column\" layout-align=\"space-around\" ng-if=\"!subscribers\"><md-progress-circular \nmd-mode=\"indeterminate\"></md-progress-circular></div><div ng-if=\"subscribers\" style=\"margin-top: 170px\"><table \nid=\"external-subscribers-table\" class=\"dataTable row-border hover stripe md-ink-ripple\" datatable=\"ng\" \ndt-instance=\"dtInstance\" dt-options=\"dtOptions\"><thead><tr><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\"><input ng-model=\"selectAll\" type=\"checkbox\" ng-change=\"setAll(selectAll)\"></span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">תאריך הרשמה</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">שם</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">דוא\"ל</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">אמצעי תשלום</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">סה\"כ תשלום</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">סטטוס הזמנה</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">סטטוס תשלום</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">קבלה</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">זיכוי</span></div></th><th><div \nclass=\"table-header\"><span class=\"column-title\">פעולות</span></div></th></tr></thead><tbody><tr class=\"md-ink-ripple\" \nng-repeat=\"(registrationKey,registrationValue) in subscribers\"><td><input type=\"checkbox\" \nng-model=\"registrationValue.Selected\"></td><td>{{registrationValue.RegistrationTime | cmdate:\'HH:mm:ss dd/MM/yyyy \'}}\n</td><td>{{registrationValue.Name}}</td><td><a href=\"mailto:{{registrationValue.Email}}\">{{registrationValue.Email}}\n</a></td><td>{{registrationValue.PaymentType}}</td><td>{{registrationValue.Price}}</td><td>\n{{registrationValue.Status==\'1\' ? \'פעיל\' : \'לא פעיל\'}}</td><td>{{registrationValue.PaymentStatus | paymentStatus}}</td>\n<td><a href=\"#\" ng-click=\"downloadReceipt(registrationValue.ReceiptID,1)\">{{registrationValue.ReceiptID}}</a></td><td>\n<a href=\"#\" ng-click=\"downloadReceipt(registrationValue.RefundID,2)\">{{registrationValue.RefundID}}</a></td><td>\n<md-button ng-disabled=\"$root.User.SuperAdmin!=1 || registrationValue.Canceled>0\" class=\"preview-user\" \nng-click=\"cancelRegistration(registrationValue)\" \ntitle=\"{{registrationValue.Canceled==\'0\' ? \'ביטול הרשמה\' : \'הרשמה מבוטלת\'}}\"><md-icon md-svg-icon=\"delete\"></md-icon>\n</md-button><md-button ng-disabled=\"$root.User.SuperAdmin!=1 || registrationValue.RefundID\" class=\"preview-user\" \nng-click=\"refundRegistration(registrationValue)\" \ntitle=\"{{!registrationValue.RefundID ? \'זיכוי הרשמה\' : \'הרשמה מזוכת\'}}\"><md-icon md-svg-icon=\"credit-card\"></md-icon>\n</md-button><md-button class=\"preview-user\" ng-click=\"showFullRegistration(registrationValue)\" \ntitle=\"צפייה בפרטי הזמנה\"><md-icon md-svg-icon=\"eye\"></md-icon></md-button></td></tr></tbody></table></div></div></div>\n<div class=\"button-down\"><md-button ng-if=\"$root.AdminLevel>2 || $root.User.Events==1 || $root.User.EventsPay\" \nclass=\"md-fab md-accent md-icon-button mb10\" ng-click=\"openNewRegistrationDialog()\" ng-disabled=\"!subscribers\" \naria-label=\"add\" title=\"הוספת הזמנה\"><md-icon md-font-icon=\"icon-plus\"></md-icon></md-button><md-button \nng-if=\"$root.AdminLevel>2 || $root.User.EmailPer\" class=\"md-fab md-accent md-icon-button mb10\" \nng-click=\"openSendEmail()\" ng-disabled=\"!subscribers || subscribers.length==0\" aria-label=\"add systemUser\" \ntitle=\"שליחת אימיל\"><md-icon md-font-icon=\"icon-at\"></md-icon></md-button><md-button \nng-if=\"($root.AdminLevel>2 || $root.User.SmsPer) && !$root.User.SmsDisabled\" \nclass=\"md-fab md-accent md-icon-button mb10\" ng-click=\"openSendSMS()\" title=\"שליחת הודעה\" \nng-disabled=\"!subscribers || subscribers.length==0\" aria-label=\"add systemUser\"><md-icon \nmd-font-icon=\"icon-cellphone-android\"></md-icon></md-button><md-button ng-if=\"$root.AdminLevel>2\" \nclass=\"md-fab md-accent md-icon-button mb10\" ng-click=\"changePaymentsStatus()\" title=\"אישור סטטוס תשלום\" \nng-disabled=\"!subscribers || subscribers.length==0\" aria-label=\"add systemUser\"><md-icon md-font-icon=\"icon-cash-100\">\n</md-icon></md-button></div></div>");
$templateCache.put("app/main/pages/events/views/events/event-management/tabs/files/files.html","<div ng-controller=\"EventManagementFilesController\"><div layout=\"row\" layout-wrap><div class=\"general\" layout=\"column\" \nflex=\"100\"><div class=\"profile-box info-box md-whiteframe-1dp\" layout=\"column\"><md-toolbar \nclass=\"md-accent-bg md-menu-toolbar\"><div class=\"md-toolbar-tools\"><div class=\"title\">חוזרי הורים</div><div \nclass=\"md-button\"><md-button class=\"md-icon-button\" aria-label=\"הוספת קובץ\" ng-click=\"uploadNewFileToEvent()\" \nng-disabled=\"$root.AdminLevel==1\" title=\"הוספת חוזה חדש\"><md-icon md-font-icon=\"icon-plus\"></md-icon></md-button></div>\n</div></md-toolbar><div class=\"content\"><p class=\"md-caption\" ng-show=\"!isClicked && eventFiles.length>0\">\nלבחירת כל ה{{$root.User.Branches}} יש להשאיר את הבחירה ריקה</p><div layout=\"row\" layout-sm=\"column\" \nlayout-align=\"space-around\" ng-show=\"!eventFiles\"><md-progress-circular md-mode=\"indeterminate\"></md-progress-circular>\n</div><table ng-show=\"!isClicked && eventFiles.length>0\" class=\"dataTable row-border hover stripe md-ink-ripple\" \ndatatable=\"ng\" dt-instance=\"dtInstance\" dt-options=\"dtOptions\"><thead><tr><th class=\"secondary-text no-sort\"><div \nclass=\"table-header\"><span class=\"column-title\"></span></div></th><th class=\"secondary-text\"><div class=\"table-header\">\n<span class=\"column-title\">שם</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">תאריך העלאה</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">סטטוס</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">{{$root.User.Branches}}</span></div></th><th class=\"secondary-text no-sort\"><div \nclass=\"table-header\"><span class=\"column-title\">פעולות</span></div></th></tr></thead><tbody><tr class=\"main-table-new\" \nng-repeat=\"file in eventFiles\"><td><md-icon md-font-icon=\"{{file.Icon}}\"></md-icon></td><td>{{file.Name}}</td><td>\n{{file.UploadTime | cmdate:\'dd/MM/yyyy\'}}</td><td><md-input-container class=\"md-block mdnone\" layout=\"row\" flex=\"100\">\n<label>סטטוס</label><md-select ng-model=\"file.Status\" placeholder=\"סטטוס\"><md-option \nng-selected=\"file.Status==1 || file.Status==\'1\'\" ng-value=\"1\">פעיל</md-option><md-option \nng-selected=\"file.Status==0 || file.Status==\'0\' \" ng-value=\"0\">לא פעיל</md-option></md-select></md-input-container>\n<select class=\"selectBoxMob dnone w100\" ng-model=\"file.Status\"><option \nng-selected=\"file.Status==1 || file.Status==\'1\'\" ng-value=\"1\">פעיל</option><option \nng-selected=\"file.Status==0 || file.Status==\'0\' \" ng-value=\"0\">לא פעיל</option></select></td><td><select \nmultiple=\"multiple\" class=\"selectBoxMob dnone w100\" ng-model=\"file.selectedBranches\"><option \nng-repeat=\"branch in file.Branches | orderBy:\'Name\' | filter:searchTerm2\" ng-value=\"branch\">{{branch.Name}}</option>\n</select><md-input-container class=\"md-icon-float md-block mdnone\" layout=\"row\" flex=\"100\"><label>\n{{$root.User.Branches}}</label><md-select ng-model=\"file.selectedBranches\" multiple=\"multiple\"><md-select-header \nclass=\"demo-select-header\"><input ng-model=\"searchTerm2\" type=\"text\" ng-keydown=\"$event.stopPropagation()\" \nplaceholder=\"חיפוש {{$root.User.Branch}}\" class=\"demo-header-searchbox md-text\" autocomplete=\"off\"></md-select-header>\n<md-optgroup><md-option ng-repeat=\"branch in file.Branches | orderBy:\'Name\' | filter:searchTerm2\" ng-value=\"branch\">\n{{branch.Name}}</md-option></md-optgroup></md-select></md-input-container></td><td><a href=\"{{file.Path}}\" \ntarget=\"_blank\"><md-button aria-label=\"הצגה\" class=\"md-icon-button\"><md-icon md-font-icon=\"icon-eye\"></md-icon>\n</md-button></a></td></tr></tbody></table></div></div><div class=\"profile-box info-box md-whiteframe-1dp\" \nlayout=\"column\" ng-if=\"event.CartEvent!=1\"><md-toolbar class=\"md-accent-bg md-menu-toolbar\"><div \nclass=\"md-toolbar-tools\"><div class=\"title\">הצהרות בריאות</div><div class=\"md-button\"><md-button \nclass=\"md-icon-button\" aria-label=\"הוספת הצברת בריאות\" ng-click=\"uploadNewHealthDeclarationToEvent()\" \nng-disabled=\"$root.AdminLevel==1\" title=\"הוספת הצהרת בריאות חדשה\"><md-icon md-font-icon=\"icon-plus\"></md-icon>\n</md-button></div></div></md-toolbar><div class=\"content\"><div layout=\"row\" layout-sm=\"column\" \nlayout-align=\"space-around\" ng-show=\"!healthDeclarations\"><md-progress-circular md-mode=\"indeterminate\">\n</md-progress-circular></div><table ng-show=\"!isClicked && healthDeclarations.length>0\" \nclass=\"dataTable row-border hover stripe md-ink-ripple\" datatable=\"ng\" dt-instance=\"dtInstance\" dt-options=\"dtOptions\">\n<thead><tr><th class=\"secondary-text no-sort\"><div class=\"table-header\"><span class=\"column-title\"></span></div></th>\n<th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">שם</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">תאריך העלאה</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">סטטוס</span></div></th><th \nclass=\"secondary-text no-sort\"><div class=\"table-header\"><span class=\"column-title\">פעולות</span></div></th></tr>\n</thead><tbody><tr class=\"main-table-new\" ng-repeat=\"file in healthDeclarations\"><td><md-icon \nmd-font-icon=\"{{file.Icon}}\"></md-icon></td><td>{{file.Name}}</td><td>{{file.CreationTime | cmdate:\'dd/MM/yyyy\'}}</td>\n<td><md-input-container class=\"md-block\"><label>סטטוס</label><md-select ng-model=\"file.Status\" placeholder=\"סטטוס\" \nng-change=\"updateHealthDeclaration(file)\"><md-option ng-value=\"1\">פעיל</md-option><md-option ng-value=\"0\">לא פעיל\n</md-option></md-select></md-input-container></td><td><a href=\"{{file.Path}}\" target=\"_blank\"><md-button \naria-label=\"הצגה\" class=\"md-icon-button\"><md-icon md-font-icon=\"icon-eye\"></md-icon></md-button></a></td></tr></tbody>\n</table></div></div></div></div></div>");
$templateCache.put("app/main/pages/events/views/events/event-management/tabs/general/general.html","<div ng-init=\"initAutocomplete()\"><div layout=\"row\" layout-wrap layout-align=\"space-between\"><div class=\"general\" \nlayout=\"column\" flex=\"100\" flex-gt-sm=\"80\" flex-gt-md=\"70\" flex-gt-lg=\"60\"><div \nclass=\"profile-box info-box md-whiteframe-1dp\" layout=\"column\"><header class=\"md-accent-bg\"><div class=\"title\">כללי\n</div></header><div class=\"content\"><form name=\"UserForm\" class=\"md-inline-form\" validate><div class=\"row\" \nlayout=\"row\"><div class=\"half\"><md-input-container class=\"md-icon-float md-block\"><label>שם</label><md-icon \nmd-svg-icon=\"weather-sunny\"></md-icon><input ng-model=\"event.Name\" md-autofocus \nng-disabled=\"$root.AdminLevel==1 || ($root.AdminLevel==2 && event.CoordinatorID!=$root.User.ID)\"></md-input-container>\n</div><div class=\"half\" ng-if=\"event.EventType != 1 && !event.IsProduct && event.CartEvent == 1\"><md-input-container \nclass=\"md-icon-float md-block\"><label>הרשמה ללא תלות בתאריכים</label><md-icon md-font-icon=\"icon-sign-caution\">\n</md-icon><md-select ng-model=\"event.IgnoreDates\" placeholder=\"הרשמה ללא תלות בתאריכים\" \nng-disabled=\"$root.AdminLevel==1 || ($root.AdminLevel==2 && event.CoordinatorID!=$root.User.ID)\"><md-option \nng-value=\"1\">כן</md-option><md-option ng-value=\"0\">לא</md-option></md-select></md-input-container></div></div><div \nclass=\"row\" layout=\"row\"><div class=\"half\"><md-input-container class=\"md-icon-float md-block\"><md-icon \nmd-svg-icon=\"clipboard-text\"></md-icon><label>תיאור</label><textarea ng-model=\"event.Description\" md-autofocus \nng-disabled=\"$root.AdminLevel==1 || ($root.AdminLevel==2 && event.CoordinatorID!=$root.User.ID)\" \nstyle=\"max-height:100px\"></textarea></md-input-container></div><div class=\"half\"><md-input-container \nclass=\"md-icon-float md-block\"><label>הערות</label><md-icon md-svg-icon=\"comment-text-outline\"></md-icon><textarea \nng-model=\"event.Comments\" md-autofocus \nng-disabled=\"$root.AdminLevel==1 || ($root.AdminLevel==2 && event.CoordinatorID!=$root.User.ID)\" \nstyle=\"max-height:100px\"></textarea></md-input-container></div></div><div class=\"row\" layout=\"row\"><div class=\"half\" \nng-if=\"event.EventType == 1\"><md-input-container class=\"md-icon-float md-block\"><label>הכנס כתובת</label><md-icon \nmd-svg-icon=\"earth\"></md-icon><input vs-google-autocomplete vs-autocomplete-validator ng-model=\"event.Address\" \ntype=\"text\" name=\"place\" id=\"place\" vs-latitude=\"event.Lat\" vs-longitude=\"event.Lng\"></md-input-container></div></div>\n<div class=\"row\" layout=\"row\"><div class=\"half\" ng-if=\"event.EventType != 1 \"><md-input-container \nclass=\"md-icon-float md-block\"><label>ביטול הנחת אחים - עסקה מפוצלת</label><md-icon md-svg-icon=\"account-off\">\n</md-icon><md-select ng-model=\"event.DisableBrotherDiscount\" placeholder=\"ביטול הנחת אחים - עסקה מפוצלת\" \nng-disabled=\"$root.AdminLevel==1 || ($root.AdminLevel==2 && event.CoordinatorID!=$root.User.ID)\"><md-option \nng-selected=\"event.DisableBrotherDiscount==1 || event.DisableBrotherDiscount==\'1\'\" ng-value=\"1\">כן</md-option>\n<md-option ng-selected=\"event.DisableBrotherDiscount==0 || event.DisableBrotherDiscount==\'0\'\" ng-value=\"0\">לא\n</md-option></md-select></md-input-container></div><div class=\"half\"><md-input-container \nclass=\"md-icon-float md-block\"><label>סטטוס</label><md-icon md-svg-icon=\"power\"></md-icon><md-select \nng-model=\"event.Status\" placeholder=\"סטטוס\" \nng-disabled=\"$root.AdminLevel==1 || ($root.AdminLevel==2 && event.CoordinatorID!=$root.User.ID)\"><md-option \nng-selected=\"event.Status==1 || event.Status==\'1\'\" ng-value=\"1\">פעיל</md-option><md-option \nng-selected=\"event.Status==0 || event.Status==\'0\'\" ng-value=\"0\">לא פעיל</md-option></md-select></md-input-container>\n</div></div><div class=\"row\" layout=\"row\"><div class=\"half\" ng-if=\"event.EventType != 1\"><md-input-container \nclass=\"md-icon-float md-block\"><label>{{$root.User.Event}} מאסטר</label><md-icon md-svg-icon=\"crown\"></md-icon>\n<md-select md-on-close=\"clearSearchTerm()\" ng-model=\"event.ParentEventID\" \nng-disabled=\"isClicked || ($root.AdminLevel==2 && event.CoordinatorID!=$root.User.ID)\"><md-select-header \nclass=\"demo-select-header\"><input ng-model=\"searchTerm\" type=\"text\" ng-disabled=\"!events || isClicked\" \nng-keydown=\"$event.stopPropagation()\" placeholder=\"חפש {{$root.User.Event}}..\" class=\"demo-header-searchbox md-text\" \nautocomplete=\"off\"></md-select-header><md-optgroup \nng-disabled=\"isClicked || ($root.AdminLevel==2 && event.CoordinatorID!=$root.User.ID)\"><md-option>ללא</md-option>\n<md-option ng-value=\"parentEvent.ID\" ng-repeat=\"parentEvent in events |filter:searchTerm\">{{parentEvent.Name}}\n</md-option></md-optgroup></md-select></md-input-container></div><div class=\"half\" \nng-if=\"event.EventType != 1 && !event.IsProduct && event.CartEvent == 1\"><md-input-container \nclass=\"md-icon-float md-block\"><label>פירוט מחירים בעגלה</label><md-icon md-font-icon=\"icon-sign-caution\"></md-icon>\n<md-select ng-model=\"event.DetailedCart\" placeholder=\"פירוט מחירים בעגלה\" \nng-disabled=\"$root.AdminLevel==1 || ($root.AdminLevel==2 && event.CoordinatorID!=$root.User.ID)\"><md-option \nng-value=\"1\">כן</md-option><md-option ng-value=\"0\">לא</md-option></md-select></md-input-container></div><div \nclass=\"half\" ng-if=\"event.EventType != 1 && event.CartEvent == 0\"><md-input-container class=\"md-icon-float md-block\">\n<label>רמה</label><md-icon md-svg-icon=\"numeric\"></md-icon><md-select ng-model=\"event.Level\" placeholder=\"רמה\" \nng-disabled=\"$root.AdminLevel==1 || ($root.AdminLevel==2 && event.CoordinatorID!=$root.User.ID)\"><md-option \nng-value=\"1\">מאסטר</md-option><md-option ng-value=\"0\">רגיל</md-option></md-select></md-input-container></div></div><div\n class=\"sflex w100 fdc aifs jcfs memberEventsArea\"><div class=\"sflex w100 aifs jcfs\"><md-input-container \nclass=\"md-icon-float md-block\" layout=\"column\" layout-xs=\"row\" flex=\"100\" flex-xs=\"100\" flex-gt-sm=\"50\" \nflex-gt-md=\"50\"><md-button ng-checked=\"enableMemberFields\" class=\"no-margin md-accent md-raised\" \nng-disabled=\"$root.AdminLevel==1 || ($root.AdminLevel==2 && event.CoordinatorID!=$root.User.ID)\" \nng-click=\"openMemberEventEditDialog()\">פתח הגדרת דמי חבר לעריכה</md-button></md-input-container></div><div \nclass=\"sflex aic jcsb w100 hp25\"><div class=\"sflex aic jcfs w50\" \nng-if=\"event.EventType != 1 && !event.IsProduct && event.CartEvent == 0\"><md-input-container \nclass=\"md-icon-float md-block\"><label>{{$root.User.Event}} דמי חבר</label><md-icon md-svg-icon=\"account-card-details\">\n</md-icon><md-select ng-model=\"event.MemberEvent\" placeholder=\"{{$root.User.Event}} דמי חבר\" \nng-disabled=\"true || !enableMemberFields || $root.AdminLevel==1 || ($root.AdminLevel==2 && event.CoordinatorID!=$root.User.ID)\" \nng-change=\"checkIfYearIsSet()\"><md-option ng-value=\"1\">כן</md-option><md-option ng-value=\"0\">לא</md-option></md-select>\n</md-input-container></div><div class=\"sflex aic jcfs w50\" ng-if=\"event.EventType != 1\" ng-show=\"event.MemberEvent!=1\">\n<md-input-container class=\"md-icon-float md-block\"><label>מחייב הרשמה לדמי חבר לשנת</label><md-icon \nmd-svg-icon=\"account-plus\"></md-icon><md-select ng-model=\"event.MinMemberYear\" placeholder=\"מינימום שנת דמי חבר\" \nng-disabled=\"true || $root.AdminLevel==1 || ($root.AdminLevel==2 && event.CoordinatorID!=$root.User.ID)\"><md-option \nng-value=\"0\">ללא</md-option><md-option ng-value=\"2015\">{{$root.yearType == 1 ? \'תשע\"ה\' : 2015}}</md-option><md-option \nng-value=\"2016\">{{$root.yearType == 1 ? \'תשע\"ו\' : 2016}}</md-option><md-option ng-value=\"2017\">\n{{$root.yearType == 1 ? \'תשע\"ז\' : 2017}}</md-option><md-option ng-value=\"2018\">{{$root.yearType == 1 ? \'תשע\"ח\' : 2018}}\n</md-option><md-option ng-value=\"2019\">{{$root.yearType == 1 ? \'תשע\"ט\' : 2019}}</md-option><md-option ng-value=\"2020\">\n{{$root.yearType == 1 ? \'תש\"פ\' : 2020}}</md-option><md-option ng-value=\"2021\">{{$root.yearType == 1 ? \'תשפ\"א\' : 2021}}\n</md-option><md-option ng-value=\"2022\">{{$root.yearType == 1 ? \'תשפ\"ב\' : 2022}}</md-option><md-option ng-value=\"2023\">\n{{$root.yearType == 1 ? \'תשפ\"ג\' : 2023}}</md-option><md-option ng-value=\"2024\">{{$root.yearType == 1 ? \'תשפ\"ד\' : 2024}}\n</md-option></md-select></md-input-container></div></div><div class=\"half\" \nng-if=\"event.EventType != 1 && !event.IsProduct\" ng-show=\"event.MemberEvent==1\"><md-input-container \nclass=\"md-icon-float md-block\"><label>שנת {{$root.User.Event}} דמי חבר</label><md-icon md-svg-icon=\"calendar-range\">\n</md-icon><md-select ng-model=\"event.MemberYear\" placeholder=\"שנת {{$root.User.Event}} דמי חבר\" \nng-disabled=\"true || $root.AdminLevel==1 || ($root.AdminLevel==2 && event.CoordinatorID!=$root.User.ID) || event.MemberEvent!=1\" \nng-required=\"event.MemberEvent==1\"><md-option ng-value=\"0\">ללא</md-option><md-option ng-value=\"2015\">\n{{$root.yearType == 1 ? \'תשע\"ה\' : 2015}}</md-option><md-option ng-value=\"2016\">{{$root.yearType == 1 ? \'תשע\"ו\' : 2016}}\n</md-option><md-option ng-value=\"2017\">{{$root.yearType == 1 ? \'תשע\"ז\' : 2017}}</md-option><md-option ng-value=\"2018\">\n{{$root.yearType == 1 ? \'תשע\"ח\' : 2018}}</md-option><md-option ng-value=\"2019\">{{$root.yearType == 1 ? \'תשע\"ט\' : 2019}}\n</md-option><md-option ng-value=\"2020\">{{$root.yearType == 1 ? \'תש\"פ\' : 2020}}</md-option><md-option ng-value=\"2021\">\n{{$root.yearType == 1 ? \'תשפ\"א\' : 2021}}</md-option><md-option ng-value=\"2022\">{{$root.yearType == 1 ? \'תשפ\"ב\' : 2022}}\n</md-option><md-option ng-value=\"2023\">{{$root.yearType == 1 ? \'תשפ\"ג\' : 2023}}</md-option><md-option ng-value=\"2024\">\n{{$root.yearType == 1 ? \'תשפ\"ד\' : 2024}}</md-option></md-select></md-input-container></div></div><div class=\"row\" \nlayout=\"row\" ng-if=\"event.IsProduct\"><div class=\"half\" ng-if=\"event.IsProduct\"><md-input-container \nclass=\"md-icon-float md-block\"><label>האם לנהל מלאי</label><md-icon md-svg-icon=\"shopping\"></md-icon><md-select \nng-model=\"event.Inventory\" placeholder=\"האם לנהל מלאי\" \nng-disabled=\"$root.AdminLevel==1 || ($root.AdminLevel==2 && event.CoordinatorID!=$root.User.ID)\"><md-option \nng-value=\"1\">כן</md-option><md-option ng-value=\"0\">לא</md-option></md-select></md-input-container></div><div \nclass=\"half\" ng-if=\"event.Inventory\"><md-input-container class=\"md-icon-float md-block\"><label>מלאי</label><md-icon \nmd-svg-icon=\"shopping\"></md-icon><input ng-model=\"event.InventoryAmount\" type=\"number\" md-autofocus \nng-disabled=\"$root.AdminLevel==1 || ($root.AdminLevel==2 && event.CoordinatorID!=$root.User.ID)\"></md-input-container>\n</div></div><div class=\"row\" layout=\"row\" layout-xs=\"column\" ng-if=\"!event.IsProduct\"><div class=\"half\">\n<md-input-container class=\"md-icon-float md-block\"><label>שיטת צבירת הנחות</label><md-icon md-svg-icon=\"sale\">\n</md-icon><md-select ng-model=\"event.DiscountType\" placeholder=\"שיטת צבירת הנחות\" \nng-disabled=\"$root.AdminLevel==1 || ($root.AdminLevel==2 && event.CoordinatorID!=$root.User.ID)\"><md-option \nng-value=\"0\">הנחה מהמחיר המקורי</md-option><md-option ng-value=\"1\">הנחה מהסכום הנצבר</md-option></md-select>\n</md-input-container></div><div class=\"half\"><md-input-container class=\"md-icon-float md-block\"><label>\nהגבלת כמות נרשמים</label><md-icon md-svg-icon=\"face\"></md-icon><input ng-model=\"event.MaxRegs\" type=\"number\" \nmd-autofocus ng-disabled=\"$root.AdminLevel==1 || ($root.AdminLevel==2 && event.CoordinatorID!=$root.User.ID)\">\n</md-input-container></div></div><div class=\"row\" layout=\"row\" layout-xs=\"column\" \nng-if=\"!event.IsProduct && event.CartEvent == 0\"><div class=\"half\"><md-input-container \nclass=\"md-icon-float md-block md-icon-left\"><md-icon md-font-icon=\"icon-calendar-select\"></md-icon><div \nstart-view=\"day\" locale=\"he\" format=\"DD/MM/YYYY\" moment-picker=\"event.StartDate\"><label>תאריך התחלה</label><input \nautocomplete=\"off\" ng-model=\"event.StartDate\" \nng-disabled=\"$root.AdminLevel==1 || ($root.AdminLevel==2 && event.CoordinatorID!=$root.User.ID)\"></div>\n</md-input-container></div><div class=\"half\"><md-input-container class=\"md-icon-float md-block md-icon-left\"><md-icon \nmd-font-icon=\"icon-calendar-select\"></md-icon><div start-view=\"day\" locale=\"he\" format=\"DD/MM/YYYY\" \nmoment-picker=\"event.EndDate\"><label>תאריך סיום</label><input autocomplete=\"off\" ng-model=\"event.EndDate\" \nng-disabled=\"$root.AdminLevel==1 || ($root.AdminLevel==2 && event.CoordinatorID!=$root.User.ID)\"></div>\n</md-input-container></div></div><div class=\"row\" layout=\"row\"><div class=\"half\"><md-input-container \nclass=\"md-icon-float md-block md-icon-left\"><md-icon md-font-icon=\"icon-calendar-select\"></md-icon><div locale=\"he\" \nformat=\"DD/MM/YYYY HH:mm\" moment-picker=\"event.RegistrationStartDate\"><label>התחלת רישום</label><input \nng-disabled=\"$root.AdminLevel==1 || ($root.AdminLevel==2 && event.CoordinatorID!=$root.User.ID)\" autocomplete=\"off\" \nng-model=\"event.RegistrationStartDate\"></div></md-input-container></div><div class=\"half\"><md-input-container \nclass=\"md-icon-float md-block md-icon-left\"><md-icon md-font-icon=\"icon-calendar-select\"></md-icon><div locale=\"he\" \nformat=\"DD/MM/YYYY HH:mm\" moment-picker=\"event.RegistrationEndDate\"><label>סיום רישום</label><input \nng-disabled=\"$root.AdminLevel==1 || ($root.AdminLevel==2 && event.CoordinatorID!=$root.User.ID)\" autocomplete=\"off\" \nng-model=\"event.RegistrationEndDate\"></div></md-input-container></div></div><div ng-if=\"!event.IsProduct\">\n<md-input-container class=\"md-icon-float md-block md-icon-left\"><md-icon md-svg-icon=\"account-box\" class=\"name\">\n</md-icon><label>קבוצות</label><md-chips ng-model=\"event.Groups\" placeholder=\"הוספת קבוצות\"></md-chips>\n</md-input-container></div></form></div></div></div><div ng-if=\"warningsList.length\" class=\"general\" layout=\"column\" \nflex=\"100\" flex-gt-sm=\"25\" flex-gt-md=\"25\" flex-gt-lg=\"35\"><md-toolbar class=\"md-accent-bg md-menu-toolbar\"><div \nclass=\"md-toolbar-tools inrowf\"><div class=\"title\">שים לב</div></div></md-toolbar><div class=\"content\"><div \nlayout=\"column\" flex=\"100\" class=\"warning-box\"><ul style=\"color: red\"><li ng-if=\"warningsList.includes(1)\">\nתאריכי האירוע אינם תקינים</li><li ng-if=\"warningsList.includes(2)\">תאריכי ההרשמה אינם תקינים</li><li \nng-if=\"warningsList.includes(3)\">האירוע בסטטוס לא פעיל</li><li ng-if=\"warningsList.includes(4)\">לא מוגדר מחיר לאירוע\n</li><li ng-if=\"warningsList.includes(5)\">האירוע מוגדר כאירוע מאסטר</li><li ng-if=\"warningsList.includes(6)\">\nהאירוע מוגדר כאירוע סל אך סך האירועים אינו מגיע ל100 אחוז</li><li ng-if=\"warningsList.includes(7)\">\nלא ניתן להגדיר אירוע סל עם 0 אחוזי תשלום</li><li ng-if=\"warningsList.includes(8)\">\nקיימים אירועים בסל עם טווח תאריכים לא תקין</li><li ng-if=\"warningsList.includes(9)\">\nקיימים אירועים בסל עם טווח תאריכי הרשמה לא תקין</li><li ng-if=\"warningsList.includes(10)\">\nקיימים אירועים בסל בסטטוס לא פעיל</li><li ng-if=\"warningsList.includes(11)\">קיימים אירועים בסל ללא מחיר</li></ul><p \nclass=\"warning hm5\">* יש לבדוק שיוכים וכלל הגדרות האירוע באופן פרטני בנוסף לכתוב לעיל</p></div></div></div></div></div>");
$templateCache.put("app/main/pages/events/views/events/event-management/tabs/payments/payments.html","<div id=\"payments\" class=\"allowOverflow\" ng-init=\"getPricesByBranches();getGlobalMaxNumOfPayments()\"><div layout=\"row\" \nlayout-wrap layout-align=\"space-between\"><div class=\"general\" layout=\"column\" flex=\"100\" flex-gt-sm=\"100\" \nflex-gt-md=\"70\" flex-gt-lg=\"60\"><div class=\"profile-box info-box md-whiteframe-1dp\" layout=\"column\"><header \nclass=\"md-accent-bg\"><div class=\"title\">תשלום</div></header><div class=\"content\"><form name=\"UserForm\" \nclass=\"md-inline-form\" validate><div class=\"row\" layout=\"row\"><div class=\"half\"><md-input-container \nclass=\"md-icon-float md-block\"><md-icon md-svg-icon=\"cash\" class=\"name\"></md-icon><label>מחיר</label><input \nng-model=\"event.Price\" md-autofocus ng-pattern=\"/^\\d+$/\" placeholder=\"יש להכניס מספר שלם\"></md-input-container></div>\n<div class=\"half\"><md-input-container class=\"md-icon-float md-block price-text\"><md-icon md-svg-icon=\"cash\" \nclass=\"name\"></md-icon><label>מלל במקום מחיר (מלל אשר יוצג במקום המחיר להורה בדף הראשי)</label><textarea \nng-model=\"event.PriceText\" md-autofocus></textarea></md-input-container></div></div><div class=\"row\" layout=\"row\"><div \nclass=\"half\"><md-input-container class=\"md-icon-float md-block\"><md-icon md-svg-icon=\"numeric\" class=\"name\"></md-icon>\n<label>מספר תשלומים מקסימלי</label><input type=\"number\" min=\"0\" max=\"{{globalMaxNumOfPayments}}\" \nng-model=\"event.MaxPayments\" md-autofocus></md-input-container></div></div><div class=\"row\" layout=\"row\"><div \nclass=\"half\"><md-input-container class=\"md-icon-float md-block\"><label>קוד תמחור</label><md-icon md-svg-icon=\"barcode\">\n</md-icon><input ng-model=\"event.CostingCode\" \nng-disabled=\"$root.AdminLevel==1 || ($root.AdminLevel==2 && event.CoordinatorID!=$root.User.ID)\"></md-input-container>\n</div><div class=\"half\"><md-input-container class=\"md-icon-float md-block\"><label>תוכנת הנהלת חשבונות</label><md-icon \nmd-svg-icon=\"desktop-classic\"></md-icon><textarea ng-model=\"event.HashavshevetID\" md-autofocus \nng-disabled=\"$root.AdminLevel==1 || ($root.AdminLevel==2 && event.CoordinatorID!=$root.User.ID)\"></textarea>\n</md-input-container></div></div></form></div></div></div><div class=\"general\" layout=\"column\" flex=\"100\" \nflex-gt-sm=\"100\" flex-gt-md=\"25\" flex-gt-lg=\"35\" ng-if=\"event.CartEvent!=1\"><div \nclass=\"profile-box info-box md-whiteframe-1dp\" layout=\"column\" flex=\"100\" flex-gt-sm=\"80\" flex-gt-md=\"70\" \nflex-gt-lg=\"60\"><md-toolbar class=\"md-accent-bg md-menu-toolbar\"><div class=\"md-toolbar-tools inrowf\"><div \nclass=\"title\">קבצים לצירוף לקבלה</div><div class=\"inrowf aic\"><md-button \nng-if=\"receiptFiles && receiptFiles.length == 0\" class=\"md-icon-button\" title=\"הוספת קובץ\" \nng-click=\"uploadNewEventReceiptFile()\"><md-icon md-font-icon=\"icon-plus\"></md-icon></md-button></div></div>\n</md-toolbar><div class=\"content\"><form name=\"UserForm\" class=\"md-inline-form\" validate><div layout=\"column\" \nflex=\"100\"><md-input-container ng-repeat=\"file in receiptFiles\" class=\"md-icon-float md-block\" layout=\"column\" \nlayout-xs=\"row\" flex=\"100\" flex-xs=\"100\" flex-gt-sm=\"100\" flex-gt-md=\"100\"><md-button class=\"md-raised md-accent\" \nng-click=\"openFile(file.Path)\"><md-icon md-svg-icon=\"eye\" class=\"name\"></md-icon>צפייה</md-button><md-button \nclass=\"md-raised md-accent\" ng-click=\"deleteEventReceiptFile(file)\"><md-icon md-svg-icon=\"delete\" class=\"name\">\n</md-icon>מחיקה</md-button><md-button class=\"md-raised md-accent\" ng-click=\"uploadNewEventReceiptFile(file.Path)\">\n<md-icon md-svg-icon=\"upload\" class=\"name\"></md-icon>קובץ חדש</md-button></md-input-container></div></form></div></div>\n</div></div></div><div ng-if=\"event.EventType != 1\" layout=\"row\" layout-wrap layout-align=\"space-between\" \nng-init=\"getPriceByAreas()\"><div class=\"profile-box info-box md-whiteframe-1dp\" layout=\"column\" flex=\"100\" \nflex-gt-sm=\"70\" flex-gt-md=\"60\" flex-gt-lg=\"60\"><md-toolbar class=\"md-accent-bg md-menu-toolbar\"><div \nclass=\"md-toolbar-tools inrowf\"><div class=\"title\">מחיר לפי איזור ו{{$root.User.Grades}}<md-icon \nmd-font-icon=\"icon-information\" \ntitle=\"בעת התנגשויות, המחיר יקבע על פי הדיוק הגדול ביותר (קבוצה > סניף ושכבה > איזור ושכבה > סניף > איזור)\"></md-icon>\n</div><div class=\"inrowf aic\"><md-input-container class=\"md-icon-float md-block\"><md-select ng-model=\"filterArea\" \nng-change=\"filterPriceByBranchs()\" placeholder=\"סינון לפי סטטוס\"><md-option ng-value=\"undefined\">הצג הכל</md-option>\n<md-option ng-value=\"1\">פעילים</md-option><md-option ng-value=\"0\">לא פעילים</md-option></md-select>\n</md-input-container><md-button class=\"md-icon-button\" title=\"הוספת הנחה\" ng-click=\"createNewPriceByArea()\"><md-icon \nmd-font-icon=\"icon-plus\"></md-icon></md-button></div></div></md-toolbar><div class=\"content\"><div layout=\"row\" \nlayout-sm=\"column\" layout-align=\"space-around\" ng-show=\"!priceByAreas || $root.discountsLoading\"><md-progress-circular \nmd-mode=\"indeterminate\"></md-progress-circular></div><table ng-show=\"priceByAreas\" \nclass=\"dataTable row-border hover stripe md-ink-ripple\"><thead><tr><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">מחיר</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">איזור</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">{{$root.User.Grades}}</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">פעולות</span></div></th></tr></thead><tbody><tr class=\"main-table-new\" \nng-repeat=\"priceByArea in priceByAreas | filter:{Status : filterArea}\"><td>{{priceByArea.Price}}</td><td>\n{{priceByArea.AreaName}}</td><td><span ng-repeat=\"grade in priceByArea.Grades\"><span>{{grade.GradeName}}</span><span \nng-if=\"!$last\">,</span></span></td><td><md-button aria-label=\"Use Android\" title=\"הפוך לפעיל\\לא פעיל\" \nng-disabled=\"isClicked\"><md-icon md-font-icon=\"icon-power\" \nng-class=\"{\'green600\':priceByArea.Status==1, \'red600\':priceByArea.Status==0}\" \nng-click=\"changeAreaPriceStatus(priceByArea)\"></md-icon></md-button></td></tr></tbody></table></div></div><div \nclass=\"general\" layout=\"column\" flex=\"100\" flex-gt-sm=\"100\" flex-gt-md=\"25\" flex-gt-lg=\"35\"><div \nclass=\"profile-box info-box md-whiteframe-1dp\" layout=\"column\" flex=\"100\" flex-gt-sm=\"80\" flex-gt-md=\"70\" \nflex-gt-lg=\"60\"><md-toolbar class=\"md-accent-bg md-menu-toolbar\"><div class=\"md-toolbar-tools inrowf\"><div \nclass=\"title\">סניפים - טופס התחייבות</div><div class=\"inrowf aic\"><md-button class=\"md-icon-button\" title=\"הוספת סניף\" \nng-click=\"createNewKibutzPayByBranch()\"><md-icon md-font-icon=\"icon-plus\"></md-icon></md-button></div></div>\n</md-toolbar><div class=\"content\"><form name=\"UserForm\" class=\"md-inline-form\" validate><div layout=\"column\" \nflex=\"100\"><md-input-container ng-repeat=\"branch in kibutzPayBranches\" class=\"md-icon-float md-block\" layout=\"column\" \nlayout-xs=\"row\" flex=\"100\" flex-xs=\"100\" flex-gt-sm=\"100\" flex-gt-md=\"100\">{{branch.Name}}<md-button \nclass=\"md-raised md-accent\" ng-click=\"deleteKibutzPay(branch.ID)\"><md-icon md-svg-icon=\"delete\" class=\"name\"></md-icon>\nמחיקה</md-button></md-input-container></div></form></div></div></div></div><div ng-if=\"event.EventType != 1\" \nlayout=\"row\" layout-wrap ng-init=\"getPriceByBranches()\"><div class=\"profile-box info-box md-whiteframe-1dp\" \nlayout=\"column\" flex=\"100\" flex-gt-sm=\"80\" flex-gt-md=\"70\" flex-gt-lg=\"60\"><md-toolbar \nclass=\"md-accent-bg md-menu-toolbar\"><div class=\"md-toolbar-tools inrowf\"><div class=\"title\">\nמחיר לפי {{$root.User.Branch}} ו{{$root.User.Grades}}<md-icon md-font-icon=\"icon-information\" \ntitle=\"בעת התנגשויות, המחיר יקבע על פי הדיוק הגדול ביותר (קבוצה > סניף ושכבה > איזור ושכבה > סניף > איזור)\"></md-icon>\n</div><div class=\"inrowf aic\"><md-input-container class=\"md-icon-float md-block\"><md-select ng-model=\"filterBranch\" \nplaceholder=\"סינון לפי סטטוס\"><md-option ng-value=\"undefined\">הצג הכל</md-option><md-option ng-value=\"1\">פעילים\n</md-option><md-option ng-value=\"0\">לא פעילים</md-option></md-select></md-input-container><md-button \nclass=\"md-icon-button\" title=\"הוספת הנחה\" ng-click=\"createNewPriceByBranch()\"><md-icon md-font-icon=\"icon-plus\">\n</md-icon></md-button></div></div></md-toolbar><div class=\"content\"><div layout=\"row\" layout-sm=\"column\" \nlayout-align=\"space-around\" ng-show=\"!priceByBranchs || $root.discountsLoading\"><md-progress-circular \nmd-mode=\"indeterminate\"></md-progress-circular></div><table ng-show=\"priceByBranchs\" \nclass=\"dataTable row-border hover stripe md-ink-ripple\"><thead><tr><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">מחיר</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">{{$root.User.Branch}}</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">{{$root.User.Grades}}</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">פעולות</span></div></th></tr></thead><tbody><tr class=\"main-table-new\" \nng-repeat=\"priceByBranc in priceByBranchs | filter:{Status : filterBranch}\"><td>{{priceByBranc.Price}}</td><td>\n{{priceByBranc.BranchName}}</td><td><span ng-repeat=\"grade in priceByBranc.Grades\"><span>{{grade.GradeName}}</span>\n<span ng-if=\"!$last\">,</span></span></td><td><md-button aria-label=\"Use Android\" title=\"הפוך לפעיל\\לא פעיל\" \nng-disabled=\"isClicked\"><md-icon md-font-icon=\"icon-power\" \nng-class=\"{\'green600\':priceByBranc.Status==1, \'red600\':priceByBranc.Status==0}\" \nng-click=\"changeBranchPriceStatus(priceByBranc)\"></md-icon></md-button></td></tr></tbody></table></div></div></div><div\n ng-if=\"event.EventType != 1\" layout=\"row\" layout-wrap ng-init=\"getPriceByGroups()\"><div \nclass=\"profile-box info-box md-whiteframe-1dp\" layout=\"column\" flex=\"100\" flex-gt-sm=\"80\" flex-gt-md=\"70\" \nflex-gt-lg=\"60\"><md-toolbar class=\"md-accent-bg md-menu-toolbar\"><div class=\"md-toolbar-tools inrowf\"><div \nclass=\"title\">מחיר לפי קבוצות<md-icon md-font-icon=\"icon-information\" \ntitle=\"בעת התנגשויות, המחיר יקבע על פי הדיוק הגדול ביותר (קבוצה > יישוב ושכבה > יישוב)\"></md-icon></div><div \nclass=\"inrowf aic\"><md-input-container class=\"md-icon-float md-block\"><md-select ng-model=\"filterGroup\" \nplaceholder=\"סינון לפי סטטוס\"><md-option ng-value=\"undefined\">הצג הכל</md-option><md-option ng-value=\"1\">פעילים\n</md-option><md-option ng-value=\"0\">לא פעילים</md-option></md-select></md-input-container><md-button \nclass=\"md-icon-button\" title=\"הוספת הנחה\" ng-click=\"createNewPriceByGroup()\"><md-icon md-font-icon=\"icon-plus\">\n</md-icon></md-button></div></div></md-toolbar><div class=\"content\"><div layout=\"row\" layout-sm=\"column\" \nlayout-align=\"space-around\" ng-show=\"!priceByGroups || $root.discountsLoading\"><md-progress-circular \nmd-mode=\"indeterminate\"></md-progress-circular></div><table ng-show=\"priceByGroups\" \nclass=\"dataTable row-border hover stripe md-ink-ripple\"><thead><tr><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">מחיר</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">קבוצה</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">פעולות</span></div></th></tr></thead><tbody><tr class=\"main-table-new\" \nng-repeat=\"priceByGroup in priceByGroups | filter:{Status : filterGroup}\"><td>{{priceByGroup.Price}}</td><td>\n{{priceByGroup.GroupName}}</td><td><md-button aria-label=\"Use Android\" title=\"הפוך לפעיל\\לא פעיל\" \nng-disabled=\"isClicked\"><md-icon md-font-icon=\"icon-power\" \nng-class=\"{\'green600\':priceByGroup.Status==1, \'red600\':priceByGroup.Status==0}\" \nng-click=\"changeGroupPriceStatus(priceByGroup)\"></md-icon></md-button></td></tr></tbody></table></div></div></div>");
$templateCache.put("app/main/pages/events/views/events/event-management/tabs/questions/questions.html","<div ng-controller=\"EventManagementQuestionsController\" ng-init=\"getEventQuestions()\"><div layout=\"row\" layout-wrap>\n<div class=\"general\" layout=\"column\" flex=\"100\" flex-gt-sm=\"80\" flex-gt-md=\"70\" flex-gt-lg=\"60\"><div \nclass=\"profile-box info-box md-whiteframe-1dp\" layout=\"column\"><md-toolbar class=\"md-accent-bg md-menu-toolbar\"><div \nclass=\"md-toolbar-tools\"><div class=\"title\">שאלות</div><div class=\"md-button\"><md-button class=\"md-icon-button\" \naria-label=\"הוסף שאלה\" ng-click=\"addQuestionsToEvent()\" ng-disabled=\"$root.AdminLevel==1\" title=\"הוספת שאלה קיימה\">\n<md-icon md-font-icon=\"icon-playlist-plus\"></md-icon></md-button><md-button class=\"md-icon-button\" \naria-label=\"הוסף שאלה\" ng-click=\"createNewEventQuestion()\" ng-disabled=\"$root.AdminLevel==1\" title=\"הוספת שאלה חדשה\">\n<md-icon md-font-icon=\"icon-plus\"></md-icon></md-button></div></div></md-toolbar><div class=\"content\"><div \nlayout=\"row\" layout-sm=\"column\" layout-align=\"space-around\" ng-show=\"!eventQuestions\"><md-progress-circular \nmd-mode=\"indeterminate\"></md-progress-circular></div><div ng-if=\"!isClicked && eventQuestions\"><table \nid=\"event-questions-table\" class=\"dataTable row-border hover stripe md-ink-ripple\" datatable=\"ng\" \ndt-instance=\"dtInstance\" dt-options=\"dtOptions\"><thead><tr><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">תאריך הוספה</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">שאלה</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">סוג שאלה</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">סניף</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">סטטוס</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">פעולות</span></div></th></tr></thead><tbody><tr class=\"main-table-new\" \nng-repeat=\"question in eventQuestions\"><td>{{question.CreatedAt | cmdate:\'dd/MM/yyyy HH:mm:ss\'}}</td><td>\n{{question.Description}}</td><td>{{setType(question.AnswerType)}}</td><td><span ng-if=\"question.BranchName\">\n{{question.BranchName}}</span> <span ng-if=\"!question.BranchName\">כולם</span></td><td>\n{{question.Status==1 || question.Status==\'1\' ? \'פעיל\' : \'לא פעיל\'}}</td><td><md-button class=\"preview-user\" \nng-click=\"openEventQuestionPanel(question)\" title=\"עריכת שאלה\"><md-icon md-svg-icon=\"pencil\"></md-icon></md-button>\n</td></tr></tbody></table></div></div></div></div></div></div>");
$templateCache.put("app/main/pages/events/views/events/event-management/tabs/registers/registers.html","<div id=\"registers\" class=\"page-layout simple tabbed\" ng-controller=\"EventManagementSubscribersController\"><div \nlayout=\"row\" layout-wrap><form name=\"UserForm\" class=\"md-inline-form w100\" validate><div class=\"filters\" layout=\"row\" \nflex=\"100\" flex-gt-sm=\"100\" flex-gt-md=\"70\"><div layout=\"column\" flex=\"100\" flex-gt-sm=\"50\" flex-gt-md=\"33\">\n<md-input-container id=\"free-search\" class=\"md-icon-float md-block\"><md-icon md-font-icon=\"icon-magnify\"></md-icon>\n<label>חיפוש חופשי</label><input ng-model=\"search.freeSearchFromDB\" type=\"search\" ng-disabled=\"!subscribers\">\n</md-input-container></div><div layout=\"column\" flex=\"100\" flex-gt-sm=\"50\" flex-gt-md=\"33\"><md-input-container \nclass=\"md-icon-float md-block\"><md-icon md-font-icon=\"icon-power\"></md-icon><label>סטטוס הזמנה</label><md-select \nng-model=\"search.Status\" placeholder=\"סינון לפי סטטוס הזמנה\" ng-disabled=\"!subscribers\" ng-init=\"search.Status = 1\">\n<md-option ng-value=\"null\">הצג הכל</md-option><md-option ng-value=\"1\">פעילים</md-option><md-option ng-value=\"0\">\nלא פעילים</md-option></md-select></md-input-container></div></div><div class=\"search-actions row\" layout=\"row\">\n<md-button type=\"submit\" ng-disabled=\"!subscribers\" class=\"md-raised md-accent\" aria-label=\"חפש\" \nng-click=\"getSubscribers()\">סינון</md-button><md-button ng-disabled=\"!subscribers\" class=\"md-raised md-accent\" \naria-label=\"חפש\" ng-click=\"getSubscribers(true)\">בטל סינון</md-button></div></form><div class=\"content w100\"><div \nlayout=\"row\" layout-sm=\"column\" layout-align=\"space-around\" ng-if=\"!subscribers\"><md-progress-circular \nmd-mode=\"indeterminate\"></md-progress-circular></div><div ng-if=\"subscribers\"><table \nclass=\"dataTable row-border hover stripe md-ink-ripple\" datatable=\"ng\" dt-instance=\"dtInstance\" dt-options=\"dtOptions\">\n<thead><tr><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\"><input ng-model=\"selectAll\" \ntype=\"checkbox\" ng-change=\"setAll(selectAll)\"></span></div></th><th class=\"secondary-text\"><div class=\"table-header\">\n<span class=\"column-title\">תאריך הרשמה</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">שם החניך</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">{{$root.User.Branch}}</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">מחיר {{$root.User.Event}}</span></div></th><th class=\"secondary-text\"><div class=\"table-header\">\n<span class=\"column-title\">אמצעי תשלום</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">סה\"כ תשלום</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">סטטוס הזמנה</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">סטטוס תשלום</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">קבלה</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">זיכוי</span></div></th><th><div class=\"table-header\" \nng-if=\"$root.AdminLevel==3 || ($root.AdminLevel==2 && $root.User.RegistrationsPer)\"><span class=\"column-title\">פעולות\n</span></div></th></tr></thead><tbody><tr class=\"md-ink-ripple\" \nng-repeat=\"(registrationKey,registrationValue) in subscribers\"><td><input type=\"checkbox\" \nng-model=\"registrationValue.Selected\"></td><td>{{registrationValue.RegistrationTime | cmdate:\'HH:mm:ss dd/MM/yyyy \'}}\n</td><td><a ng-click=\"goToStudentProfile(registrationValue)\" style=\"cursor: pointer\">\n{{registrationValue.FirstName}} {{registrationValue.LastName}}</a></td><td>{{registrationValue.BranchName}}</td><td>\n<span>{{registrationValue.EventPrice}}</span></td><td>{{registrationValue.PaymentType}}</td><td \nng-init=\"getFinalPrice(registrationKey,registrationValue)\">{{registrationValue.FinalPrice}}</td><td>\n{{registrationValue.Status==\'1\' ? \'פעיל\' : \'לא פעיל\'}}</td><td>{{registrationValue.PaymentStatus | paymentStatus}}</td>\n<td><a href=\"#\" ng-click=\"downloadReceipt(registrationValue.ReceiptID)\">{{registrationValue.ReceiptID}}</a></td><td><a \nhref=\"#\" ng-click=\"downloadReceipt(registrationValue.RefundID)\">{{registrationValue.RefundID}}</a></td><td \nng-if=\"$root.AdminLevel==3 || ($root.AdminLevel==2 && $root.User.RegistrationsPer)\"><md-button \nng-disabled=\"$root.User.SuperAdmin!=1 || registrationValue.Canceled>0\" class=\"preview-user\" \nng-click=\"cancelRegistration(registrationValue)\" \ntitle=\"{{registrationValue.Canceled==\'0\' ? \'ביטול הרשמה\' : \'הרשמה מבוטלת\'}}\"><md-icon \nng-class=\"{\'canceled\': registrationValue.Canceled>0}\" md-svg-icon=\"delete\"></md-icon></md-button><md-button \nng-disabled=\"$root.User.SuperAdmin!=1 || registrationValue.RefundDate\" class=\"preview-user\" \nng-click=\"refundRegistration(registrationValue)\" \ntitle=\"{{!registrationValue.RefundReceiptID.length ? \'זיכוי הרשמה\' : \'קיים זיכויי להרשמה\'}}\"><md-icon \nng-class=\"{\'refunded\': registrationValue.RefundReceiptID.length}\" md-svg-icon=\"credit-card\"></md-icon></md-button>\n<md-button class=\"preview-user\" ng-click=\"showFullRegistration(registrationValue)\" title=\"צפייה בפרטי הזמנה\"><md-icon \nmd-svg-icon=\"eye\"></md-icon></md-button></td></tr></tbody></table></div></div>{{showbtns}}</div><div \nclass=\"button-down\"><md-button ng-if=\"$root.AdminLevel>2 || $root.User.Events==1 || $root.User.EventsPay\" \nclass=\"md-fab md-accent md-icon-button mb10\" ng-click=\"changeBtns()\" ng-disabled=\"!subscribers\" aria-label=\"add\" \ntitle=\"פתיחת תפריט\"><md-icon md-font-icon=\"icon-power\"></md-icon></md-button><md-button ng-show=\"showbtns\" \nng-if=\"$root.AdminLevel>2 || $root.User.Events==1 || $root.User.EventsPay\" \nclass=\"md-fab md-accent md-icon-button mb10\" ng-click=\"openNewRegistrationDialog()\" ng-disabled=\"!subscribers\" \naria-label=\"add\" title=\"הוספת הזמנה\"><md-icon md-font-icon=\"icon-plus\"></md-icon></md-button><md-button \nng-show=\"showbtns\" ng-if=\"$root.AdminLevel>2 || $root.User.EmailPer\" class=\"md-fab md-accent md-icon-button mb10\" \nng-click=\"openSendEmail()\" ng-disabled=\"!subscribers || subscribers.length==0\" aria-label=\"add systemUser\" \ntitle=\"שליחת אימיל\"><md-icon md-font-icon=\"icon-at\"></md-icon></md-button><md-button ng-show=\"showbtns\" \nng-if=\"($root.AdminLevel>2 || $root.User.SmsPer) && !$root.User.SmsDisabled\" \nclass=\"md-fab md-accent md-icon-button mb10\" ng-click=\"openSendSMS()\" title=\"שליחת הודעה\" \nng-disabled=\"!subscribers || subscribers.length==0\" aria-label=\"add systemUser\"><md-icon \nmd-font-icon=\"icon-cellphone-android\"></md-icon></md-button><md-button ng-show=\"showbtns\" ng-if=\"$root.AdminLevel>2\" \nclass=\"md-fab md-accent md-icon-button mb10\" ng-click=\"changePaymentsStatus()\" title=\"אישור סטטוס תשלום\" \nng-disabled=\"!subscribers || subscribers.length==0\" aria-label=\"add systemUser\"><md-icon md-font-icon=\"icon-cash-100\">\n</md-icon></md-button></div></div>");
$templateCache.put("app/main/pages/events/views/events/event-management/tabs/statistics/statistics.html","<div ng-controller=\"EventManagementStatisticsController\"><div class=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap>\n<ms-widget flippable=\"true\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\"><ms-widget-front \nclass=\"white-bg\"><div class=\"ph-8 pv-16 h-55\" layout=\"row\" layout-align=\"space-between center\"></div><div \nclass=\"pt-8 pb-32\" layout=\"column\" layout-align=\"center center\"><div class=\"light-blue-fg font-size-72 line-height-72\">\n{{statistics.Subscribers.Total}}</div><div class=\"h3 secondary-text font-weight-500\">כמות רשומים</div></div><div \nclass=\"p-16\" layout=\"row\" layout-align=\"start center\"></div></ms-widget-front></ms-widget><ms-widget flippable=\"true\" \nlayout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\"><ms-widget-front class=\"white-bg\"><div \nclass=\"ph-8 pv-16 h-55\" layout=\"row\" layout-align=\"space-between center\"></div><div class=\"pt-8 pb-32\" layout=\"column\" \nlayout-align=\"center center\"><div class=\"light-blue-fg font-size-72 line-height-72\">{{statistics.Subscribers.LastDay}}\n</div><div class=\"h3 secondary-text font-weight-500\">כמות הרשמות ביום האחרון</div></div><div class=\"p-16\" layout=\"row\" \nlayout-align=\"start center\"></div></ms-widget-front></ms-widget><ms-widget flippable=\"true\" layout=\"column\" flex=\"100\" \nflex-gt-xs=\"50\" flex-gt-md=\"25\"><ms-widget-front class=\"white-bg\"><div class=\"ph-8 pv-16 h-55\" layout=\"row\" \nlayout-align=\"space-between center\"></div><div class=\"pt-8 pb-32\" layout=\"column\" layout-align=\"center center\"><div \nclass=\"light-blue-fg font-size-72 line-height-72\">{{statistics.Subscribers.LastWeek}}</div><div \nclass=\"h3 secondary-text font-weight-500\">כמות הרשמות בשבוע האחרון</div></div><div class=\"p-16\" layout=\"row\" \nlayout-align=\"start center\"></div></ms-widget-front></ms-widget><ms-widget flippable=\"true\" layout=\"column\" flex=\"100\" \nflex-gt-xs=\"50\" flex-gt-md=\"25\"><ms-widget-front class=\"white-bg\"><div class=\"ph-8 pv-16 h-55\" layout=\"row\" \nlayout-align=\"space-between center\"></div><div class=\"pt-8 pb-32\" layout=\"column\" layout-align=\"center center\"><div \nclass=\"light-blue-fg font-size-72 line-height-72\">{{statistics.Subscribers.LastMounts}}</div><div \nclass=\"h3 secondary-text font-weight-500\">כמות הרשמות בחודש האחרון</div></div><div class=\"p-16\" layout=\"row\" \nlayout-align=\"start center\"></div></ms-widget-front></ms-widget></div><div class=\"widget-group\" layout=\"row\" \nflex=\"100\" layout-wrap ng-if=\"$root.AdminLevel == 3 || ($root.AdminLevel==2 && event.CoordinatorID==$root.User.ID)\">\n<ms-widget flippable=\"true\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\"><ms-widget-front \nclass=\"white-bg\"><div class=\"ph-8 pv-16 h-55\" layout=\"row\" layout-align=\"space-between center\"></div><div \nclass=\"pt-8 pb-32\" layout=\"column\" layout-align=\"center center\"><div class=\"light-blue-fg font-size-72 line-height-72\">\n₪{{statistics.Revenues.Total}}</div><div class=\"h3 secondary-text font-weight-500\">הכנסות</div></div><div class=\"p-16\" \nlayout=\"row\" layout-align=\"start center\"></div></ms-widget-front></ms-widget><ms-widget flippable=\"true\" \nlayout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\"><ms-widget-front class=\"white-bg\"><div \nclass=\"ph-8 pv-16 h-55\" layout=\"row\" layout-align=\"space-between center\"></div><div class=\"pt-8 pb-32\" layout=\"column\" \nlayout-align=\"center center\"><div class=\"light-blue-fg font-size-72 line-height-72\">₪{{statistics.Revenues.LastDay}}\n</div><div class=\"h3 secondary-text font-weight-500\">הכנסות ביום האחרון</div></div><div class=\"p-16\" layout=\"row\" \nlayout-align=\"start center\"></div></ms-widget-front></ms-widget><ms-widget flippable=\"true\" layout=\"column\" flex=\"100\" \nflex-gt-xs=\"50\" flex-gt-md=\"25\"><ms-widget-front class=\"white-bg\"><div class=\"ph-8 pv-16 h-55\" layout=\"row\" \nlayout-align=\"space-between center\"></div><div class=\"pt-8 pb-32\" layout=\"column\" layout-align=\"center center\"><div \nclass=\"light-blue-fg font-size-72 line-height-72\">₪{{statistics.Revenues.LastWeek}}</div><div \nclass=\"h3 secondary-text font-weight-500\">הכנסות בשבוע האחרון</div></div><div class=\"p-16\" layout=\"row\" \nlayout-align=\"start center\"></div></ms-widget-front></ms-widget><ms-widget flippable=\"true\" layout=\"column\" flex=\"100\" \nflex-gt-xs=\"50\" flex-gt-md=\"25\"><ms-widget-front class=\"white-bg\"><div class=\"ph-8 pv-16 h-55\" layout=\"row\" \nlayout-align=\"space-between center\"></div><div class=\"pt-8 pb-32\" layout=\"column\" layout-align=\"center center\"><div \nclass=\"light-blue-fg font-size-72 line-height-72\">₪{{statistics.Revenues.LastMounts}}</div><div \nclass=\"h3 secondary-text font-weight-500\">הכנסות בחודש האחרון</div></div><div class=\"p-16\" layout=\"row\" \nlayout-align=\"start center\"></div></ms-widget-front></ms-widget></div></div>");
$templateCache.put("app/main/pages/events/views/events/event-management/tabs/subscribers/subscribers.html","<div id=\"subscribers\" class=\"page-layout simple tabbed\" \nng-init=\"getBranches();getAreas();getRegistrationsAmount();getTags();\" \nng-controller=\"EventManagementSubscribersController\"><div layout=\"row\" layout-wrap><div class=\"action-buttons\">\n<md-button ng-if=\"($root.AdminLevel>2 || ($root.AdminLevel == 2 && $root.User.EventsPay)) && !event.CartEvent\" \nng-class=\"{\'over-registered\':event.MaxRegs > 0 && registrationAmount > event.MaxRegs}\" \nclass=\"md-fab md-accent md-icon-button mb10 new\" ng-click=\"openNewRegistrationDialog()\" \nng-disabled=\"!subscribers || disableForUser || ($root.AdminLevel == 2 && !$root.User.EventsPay) || ($root.AdminLevel == 2 && !$root.User.OverRegsPer && event.MaxRegs > 0 && registrationAmount > event.MaxRegs)\" \naria-label=\"add\" title=\"הוספת הזמנה\"><md-icon md-font-icon=\"icon-plus\"></md-icon></md-button><md-button \nng-if=\"$root.AdminLevel>2 || $root.User.EmailPer\" class=\"md-fab md-accent md-icon-button mb10 email\" \nng-click=\"openSendEmail() || $root.User.EmailPer\" \nng-disabled=\"!subscribers || subscribers.length==0 || !selectedStudentsCount\" aria-label=\"add systemUser\" \ntitle=\"שליחת אימיל\"><md-icon md-font-icon=\"icon-at\"></md-icon></md-button><md-button \nng-if=\"($root.AdminLevel>2 || $root.User.SmsPer) && !$root.User.SmsDisabled\" \nclass=\"md-fab md-accent md-icon-button mb10 sms\" ng-click=\"openSendSMS()\" title=\"שליחת הודעה\" \nng-disabled=\"!subscribers || subscribers.length==0 || !selectedStudentsCount\" aria-label=\"add systemUser\"><md-icon \nmd-font-icon=\"icon-cellphone-android\"></md-icon></md-button><md-button ng-if=\"$root.AdminLevel>2 && !event.CartEvent\" \nclass=\"md-fab md-accent md-icon-button mb10 cash\" ng-click=\"changePaymentsStatus()\" title=\"אישור סטטוס תשלום\" \nng-disabled=\"!subscribers || subscribers.length==0\" aria-label=\"add systemUser\"><md-icon md-font-icon=\"icon-cash-100\">\n</md-icon></md-button><md-button ng-if=\"($root.AdminLevel>=2 || $root.User.CommitmentForm) && !event.CartEvent\" \nclass=\"md-fab md-accent md-icon-button mb10 file\" ng-click=\"createKibutzPDF()\" title=\"דוח טופס התחייבות\" \naria-label=\"add systemUser\"><md-icon md-svg-icon=\"file-pdf-box\"></md-icon></md-button><md-button \nng-if=\"showEventHealthDeclarationsBtn && ($root.AdminLevel>2 || $root.User.EmailPer) && !event.CartEvent\" \nclass=\"md-fab md-accent md-icon-button mb10 file\" ng-click=\"openHealthDeclaration()\" title=\"שליחת הצהרת בריאות\" \naria-label=\"add systemUser\"><md-icon md-font-icon=\"icon-star-of-david\"></md-icon></md-button></div><div \nlayout=\"column\" flex=\"100\" flex-gt-sm=\"100\" flex-gt-md=\"80\" flex-gt-lg=\"90\"><form name=\"UserForm\" \nclass=\"md-inline-form\" validate><div layout=\"row\" layout-xs=\"column\" flex=\"100\"><md-input-container \nclass=\"md-icon-float md-block\" layout=\"column\" layout-xs=\"row\" flex=\"100\" flex-gt-sm=\"100\" flex-gt-md=\"35\" \nng-show=\"$root.AdminLevel>1\" title=\"התחל לרשום שם {{$root.User.Branch}}\" style=\"padding-right: 27px\"><label></label>\n<md-icon md-font-icon=\"icon-domain\"></md-icon><md-contact-chips ng-disabled=\"search.freeSearchFromDB\" \nng-model=\"search.branches\" ng-change=\"getGroups()\" md-contacts=\"branchesQuerySearch($query)\" md-contact-name=\"Name\" \nmd-require-match=\"true\" md-highlight-flags=\"i\" filter-selected=\"true\" placeholder=\"בחר {{$root.User.Branches}}\">\n</md-contact-chips></md-input-container><md-input-container class=\"md-icon-float md-block\" \nng-show=\"groups && search.branches.length>0\" layout=\"column\" layout-xs=\"row\" flex=\"100\" flex-gt-sm=\"100\" \nflex-gt-md=\"35\" title=\"התחל לרשום שם {{$root.User.Group}}\" style=\"padding-right: 27px\"><label></label><md-icon \nmd-font-icon=\"icon-account-multiple\"></md-icon><md-contact-chips ng-disabled=\"search.freeSearchFromDB\" \nng-model=\"search.groups\" md-contacts=\"groupsQuerySearch($query)\" md-contact-name=\"Name\" md-require-match=\"true\" \nmd-highlight-flags=\"i\" filter-selected=\"true\" placeholder=\"בחר {{$root.User.Groups}}\"></md-contact-chips>\n</md-input-container></div><div layout=\"row\" layout-xs=\"column\" flex=\"100\"><md-input-container \nclass=\"md-icon-float md-block\" layout=\"column\" layout-xs=\"row\" flex=\"100\" flex-gt-sm=\"100\" flex-gt-md=\"35\" \nng-show=\"$root.AdminLevel>1\" title=\"התחל לרשום שם {{$root.User.Branch}}\" style=\"padding-right: 27px\"><label></label>\n<md-icon md-font-icon=\"icon-chair-school\"></md-icon><md-contact-chips ng-disabled=\"search.freeSearchFromDB\" \nng-model=\"search.grades\" md-contacts=\"grades2QuerySearch($query)\" md-contact-name=\"Name\" md-require-match=\"true\" \nmd-highlight-flags=\"i\" filter-selected=\"true\" placeholder=\"בחר {{$root.User.Grades}}\"></md-contact-chips>\n</md-input-container></div><div class=\"filters\" layout=\"row\" layout-xs=\"column\" flex=\"100\" flex-gt-sm=\"100\" \nflex-gt-md=\"70\"><div layout=\"column\" flex=\"100\" flex-gt-sm=\"100\" flex-gt-md=\"33\"><md-input-container \nclass=\"md-icon-float md-block\"><md-icon md-font-icon=\"icon-power\"></md-icon><label>סטטוס הזמנה</label><md-select \nng-model=\"search.Status\" placeholder=\"סינון לפי סטטוס הזמנה\" ng-disabled=\"!subscribers\" ng-init=\"search.Status = 1\">\n<md-option ng-value=\"null\">הצג הכל</md-option><md-option ng-value=\"1\">פעילים</md-option><md-option ng-value=\"0\">\nלא פעילים</md-option></md-select></md-input-container></div><div layout=\"column\" flex=\"100\" flex-gt-sm=\"100\" \nflex-gt-md=\"33\"><md-input-container class=\"md-icon-float md-block\"><md-icon md-svg-icon=\"credit-card\"></md-icon><label>\nסטטוס תשלום</label><md-select ng-model=\"search.PaymentStatus\" placeholder=\"סינון לפי סטטוס תשלום\" \nng-disabled=\"!subscribers\"><md-option ng-value=\"null\">הצג הכל</md-option><md-option ng-value=\"1\">שולם</md-option>\n<md-option ng-value=\"2\">שולם ל{{$root.User.Coordinator}}</md-option><md-option ng-value=\"3\">טרם אושר</md-option>\n<md-option ng-value=\"0\">לא שולם</md-option></md-select></md-input-container></div><div layout=\"column\" flex=\"100\" \nflex-gt-sm=\"100\" flex-gt-md=\"33\" ng-if=\"title==$root.User.Event\"><md-input-container class=\"md-icon-float md-block\">\n<md-icon md-svg-icon=\"account-box\" class=\"name\"></md-icon><label>קבוצת {{title}}</label><md-select \nng-model=\"search.EventGroup\" placeholder=\"סינון לפי קבוצת {{title}}\" ng-disabled=\"!subscribers\"><md-option \nng-value=\"null\">הצג הכל</md-option><md-option ng-repeat=\"group in event.Groups\" ng-value=\"group\">{{group}}</md-option>\n</md-select></md-input-container></div></div><div class=\"filters\" layout=\"row\" layout-xs=\"column\" flex=\"100\" \nflex-gt-sm=\"100\" flex-gt-md=\"70\"><div layout=\"column\" flex=\"100\" flex-gt-sm=\"100\" flex-gt-md=\"33\"><md-input-container \nclass=\"md-icon-float md-block\"><md-icon md-svg-icon=\"domain\"></md-icon><label>בחר איזור</label><md-select \nng-model=\"search.Areas\" multiple=\"true\" ng-disabled=\"!subscribers || !areas\"><md-option ng-repeat=\"area in areas\" \nng-value=\"area.ID\">{{area.Name}}</md-option></md-select></md-input-container></div><div layout=\"column\" flex=\"100\" \nflex-gt-sm=\"100\" flex-gt-md=\"33\"><md-input-container class=\"md-icon-float md-block\"><md-icon md-svg-icon=\"credit-card\">\n</md-icon><label>הזמנות מזוכות</label><md-select ng-model=\"search.Refund\" placeholder=\"סינון לפי הזמנות מזוכות\" \nng-disabled=\"!subscribers\"><md-option ng-value=\"null\">הצג הכל</md-option><md-option ng-value=\"1\">מזוכות</md-option>\n<md-option ng-value=\"0\">לא מזוכות</md-option></md-select></md-input-container></div><div layout=\"column\" flex=\"100\" \nflex-gt-sm=\"100\" flex-gt-md=\"33\"><md-input-container class=\"md-icon-float md-block\"><md-icon md-svg-icon=\"cash\" \nclass=\"name\"></md-icon><label>אמצעי תשלום</label><md-select ng-model=\"search.PaymentType\" ng-disabled=\"!subscribers\">\n<md-option ng-value=\"null\">הצג הכל</md-option><md-option ng-value=\"0\">ללא חיוב</md-option><md-option ng-value=\"1\">אשראי\n</md-option><md-option ng-value=\"2\">מזומן</md-option><md-option ng-value=\"3\">העברה בנקאית</md-option><md-option \nng-value=\"4\">המחאה</md-option><md-option ng-value=\"5\">טופס התחייבות</md-option><md-option ng-value=\"7\">חשבון פנימי\n</md-option></md-select></md-input-container></div></div><div class=\"filters\" layout=\"row\" layout-xs=\"column\" \nflex=\"100\" flex-gt-sm=\"100\" flex-gt-md=\"70\"><div layout=\"column\" flex=\"100\" flex-gt-sm=\"100\" flex-gt-md=\"33\">\n<md-input-container class=\"md-block\"><md-icon md-font-icon=\"icon-tag\"></md-icon><label>תגית חניך</label><md-select \nng-model=\"search.tags\" multiple=\"multiple\" ng-disabled=\"!Tags\"><md-option ng-value=\"tag\" ng-repeat=\"tag in Tags\">\n{{tag}}</md-option></md-select></md-input-container></div><div layout=\"column\" flex=\"100\" flex-gt-sm=\"100\" \nflex-gt-md=\"33\"><md-input-container id=\"free-search\" class=\"md-icon-float md-block\"><md-icon \nmd-font-icon=\"icon-magnify\"></md-icon><label>חיפוש חופשי</label><input ng-model=\"search.freeSearchFromDB\" \ntype=\"search\" ng-disabled=\"!subscribers\"></md-input-container></div></div><div class=\"search-actions row\" layout=\"row\">\n<md-button type=\"submit\" ng-disabled=\"!subscribers\" class=\"md-raised md-accent\" aria-label=\"חפש\" \nng-click=\"getSubscribers()\">סינון</md-button><md-button ng-disabled=\"!subscribers\" class=\"md-raised md-accent\" \naria-label=\"חפש\" ng-click=\"getSubscribers(true)\">בטל סינון</md-button></div></form></div></div><div class=\"content\">\n<div layout=\"row\" layout-sm=\"column\" layout-align=\"space-around\" ng-if=\"!subscribers\"><md-progress-circular \nmd-mode=\"indeterminate\"></md-progress-circular></div><div ng-if=\"subscribers\"><table id=\"type-subscribers-table\" \nclass=\"dataTable row-border hover stripe md-ink-ripple\" datatable=\"ng\" dt-column-defs=\"dtColumnDefs\" \ndt-instance=\"dtInstance\" dt-options=\"dtOptions\"><thead><tr><th class=\"secondary-text\"><div class=\"table-header\"><input \nng-model=\"selectAll\" type=\"checkbox\" ng-change=\"setAll(selectAll)\"></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">תאריך הרשמה</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">ת.ז</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">שם החניך</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">{{$root.User.Grade}}</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">{{$root.User.Branch}}</span></div></th><th class=\"secondary-text\" \nng-if=\"!event.CartEvent\"><div class=\"table-header\"><span class=\"column-title\">מחיר {{title}}</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">אמצעי תשלום</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">סה\"כ תשלום</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">סטטוס הזמנה</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">סטטוס תשלום</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">קבלה</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">זיכוי</span></div></th><th \nclass=\"secondary-text\" ng-if=\"!event.CartEvent\"><div class=\"table-header\"><span class=\"column-title\">נוכחות</span>\n</div></th><th class=\"secondary-text\" ng-if=\"event.IsProduct\"><div class=\"table-header\"><span class=\"column-title\">סופק\n</span></div></th><th ng-if=\"$root.AdminLevel==3 || ($root.AdminLevel==2 && $root.User.RegistrationsPer)\"><div \nclass=\"table-header\"><span class=\"column-title\">פעולות</span></div></th></tr></thead><tbody><tr class=\"md-ink-ripple\" \nng-repeat=\"(registrationKey,registrationValue) in subscribers\"><td><input type=\"checkbox\" \nng-model=\"registrationValue.Selected\" ng-click=\"studentToggled(registrationValue)\"></td><td>\n{{registrationValue.RegistrationTime | cmdate:\'HH:mm:ss dd/MM/yyyy \'}}</td><td>{{registrationValue.PrivateID}}</td><td>\n<a ng-click=\"moveToStudentProfile(registrationValue.StudentID)\" style=\"cursor: pointer\">\n{{registrationValue.FirstName}} {{registrationValue.LastName}}</a></td><td>{{registrationValue.GradeName}}</td><td>\n{{registrationValue.BranchName}}</td><td ng-if=\"!event.CartEvent\">{{registrationValue.EventPrice}}</td><td>\n{{registrationValue.PaymentType}}</td><td ng-init=\"getFinalPrice(registrationKey,registrationValue)\">\n{{registrationValue.FinalPrice}}</td><td>{{registrationValue.Status==\'1\' ? \'פעיל\' : \'לא פעיל\'}}</td><td>\n{{registrationValue.PaymentStatus | paymentStatus}}</td><td><div class=\"sflex fdc hfs12\" \nng-if=\"registrationValue.ReceiptID.length\"><a ng-repeat=\"receiptID in registrationValue.ReceiptID\" \nng-if=\"!receiptID.includes(\'יה\')\" href=\"#\" ng-click=\"downloadReceipt(receiptID,1)\">{{receiptID}}</a> <span \nng-repeat=\"receiptID in registrationValue.ReceiptID\" ng-if=\"receiptID.includes(\'יה\')\">{{receiptID}}</span></div></td>\n<td><div class=\"sflex fdc hfs12\" ng-if=\"registrationValue.RefundReceiptID.length\"><a \nng-repeat=\"refundReceiptID in registrationValue.RefundReceiptID\" ng-if=\"refundReceiptID > 0\" href=\"#\" \nng-click=\"downloadReceipt(refundReceiptID,2)\">{{refundReceiptID}}</a> <span \nng-repeat=\"refundReceiptID in registrationValue.RefundReceiptID\" ng-if=\"refundReceiptID.includes(\'-\')\">\n{{refundReceiptID}}</span></div></td><td ng-if=\"!event.CartEvent\">{{registrationValue.Attendance}}</td><td \nng-if=\"event.IsProduct\"><md-input-container class=\"md-icon-float md-block\"><md-select \nng-model=\"registrationValue.Supplied\" placeholder=\"סופק\" ng-change=\"updateSupplied(registrationValue)\"><md-option \nvalue=\"1\">כן</md-option><md-option value=\"0\">לא</md-option></md-select></md-input-container></td><td \nng-if=\"$root.AdminLevel==3 || ($root.AdminLevel==2 && $root.User.RegistrationsPer)\"><md-button \nng-if=\"!event.CartEvent\" ng-disabled=\"$root.User.SuperAdmin!=1 || registrationValue.Canceled>0\" \nclass=\"preview-user cancel\" ng-click=\"cancelRegistration(registrationValue)\" \ntitle=\"{{registrationValue.Canceled==\'0\' ? \'ביטול הרשמה\' : \'הרשמה מבוטלת\'}}\"><md-icon \nng-class=\"{\'canceled\': registrationValue.Canceled>0}\" md-svg-icon=\"delete\"></md-icon></md-button><md-button \nng-if=\"!event.CartEvent\" ng-disabled=\"$root.User.SuperAdmin!=1 || registrationValue.RefundDate\" \nclass=\"preview-user refund\" ng-click=\"refundRegistration(registrationValue)\" \ntitle=\"{{!registrationValue.RefundReceiptID.length ? \'זיכוי הרשמה\' : \'קיים זיכויי להרשמה\'}}\"><md-icon \nng-class=\"{\'refunded\': registrationValue.RefundReceiptID.length}\" md-svg-icon=\"credit-card\"></md-icon></md-button>\n<md-button class=\"preview-user view\" ng-if=\"!event.CartEvent\" ng-click=\"showFullRegistration(registrationValue)\" \ntitle=\"צפייה בפרטי הזמנה\"><md-icon md-svg-icon=\"eye\"></md-icon></md-button><md-button class=\"preview-user view\" \nng-if=\"event.CartEvent\" ng-click=\"openSelectRegistrationDialog(registrationValue)\" title=\"צפייה בפרטי הזמנה\"><md-icon \nmd-svg-icon=\"eye\"></md-icon></md-button></td></tr></tbody></table></div></div></div>");
$templateCache.put("app/main/pages/events/views/events/event-management/tabs/suggestions/suggestions.html","<div class=\"allowOverflow\" ng-init=\"getSuggestions()\"><div layout=\"row\" layout-wrap><div \nclass=\"profile-box info-box md-whiteframe-1dp\" layout=\"column\" flex=\"100\" flex-gt-sm=\"80\" flex-gt-md=\"70\" \nflex-gt-lg=\"60\"><md-toolbar class=\"md-accent-bg md-menu-toolbar\"><div class=\"md-toolbar-tools inrowf\"><div \nclass=\"title\">הצעות {{$root.User.Events}}/מוצרים<md-icon md-font-icon=\"icon-information\" \ntitle=\"ניתן לבחור אירועים או מוצרים שיוצעו להורה לרכישה\"></md-icon></div><div class=\"inrowf aic\"><md-input-container \nclass=\"md-icon-float md-block\"><md-select ng-model=\"filterEventSuggestions\" placeholder=\"סינון לפי סטטוס\"><md-option \nng-value=\"undefined\">הצג הכל</md-option><md-option ng-value=\"1\">פעילים</md-option><md-option ng-value=\"0\">לא פעילים\n</md-option></md-select></md-input-container><md-button class=\"md-icon-button\" title=\"הוספת הצעה\" \nng-click=\"createNewEventSuggestion()\"><md-icon md-font-icon=\"icon-plus\"></md-icon></md-button></div></div></md-toolbar>\n<div class=\"content\"><div layout=\"row\" layout-sm=\"column\" layout-align=\"space-around\" ng-show=\"!loadingSuggestions\">\n<md-progress-circular md-mode=\"indeterminate\"></md-progress-circular></div><table ng-show=\"loadingSuggestions\" \nclass=\"dataTable row-border hover stripe md-ink-ripple\"><thead><tr><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">שם אירוע</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">פעולות</span></div></th></tr></thead><tbody><tr class=\"main-table-new\" \nng-repeat=\"suggestion in suggestions | filter:{Status : filterEventSuggestions}\"><td>{{suggestion.Name}}</td><td>\n<md-button aria-label=\"Use Android\" title=\"הפוך לפעיל\\לא פעיל\" ng-disabled=\"isClicked\"><md-icon \nmd-font-icon=\"icon-power\" ng-class=\"{\'green600\':suggestion.Status==1, \'red600\':suggestion.Status==0}\" \nng-click=\"changeSuggestionStatus(suggestion)\"></md-icon></md-button></td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/main/pages/events/views/events/event-management/tabs/transportation/transportation.html","<div ng-controller=\"EventManagementTransportationController\" ng-init=\"getEventTransportation()\"><div layout=\"row\" \nlayout-wrap><div class=\"general\" layout=\"column\" flex=\"100\" flex-gt-sm=\"80\" flex-gt-md=\"70\" flex-gt-lg=\"60\"><div \nclass=\"profile-box info-box md-whiteframe-1dp\" layout=\"column\"><md-toolbar class=\"md-accent-bg md-menu-toolbar\"><div \nclass=\"md-toolbar-tools\"><div class=\"title\">הסעות</div><div class=\"md-button\"><md-button class=\"md-icon-button\" \naria-label=\"הוספת הסעה\" ng-click=\"addTransportationToEvent()\" ng-disabled=\"$root.AdminLevel==1\" \ntitle=\"הוספת הסעה קיימת\"><md-icon md-font-icon=\"icon-playlist-plus\"></md-icon></md-button><md-button \nclass=\"md-icon-button\" aria-label=\"הוספת הסעה\" ng-click=\"addNewTransportationToEvent()\" \nng-disabled=\"$root.AdminLevel==1\" title=\"הוספת הסעה חדשה\"><md-icon md-font-icon=\"icon-plus\"></md-icon></md-button>\n</div></div></md-toolbar><div class=\"content\"><div layout=\"row\" layout-sm=\"column\" layout-align=\"space-around\" \nng-show=\"!eventTransportation\"><md-progress-circular md-mode=\"indeterminate\"></md-progress-circular></div><table \nng-show=\"eventTransportation.length>0\" class=\"dataTable row-border hover stripe md-ink-ripple\" datatable=\"ng\" \ndt-instance=\"dtInstance\" dt-options=\"dtOptions\" ng-show=\"transportation\"><thead><tr><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">שם הסעה</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">כיוון</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">שיוך</span></div></th></tr></thead><tbody><tr class=\"main-table-new\" \nng-repeat=\"item in eventTransportation\"><td>{{item.Name}}</td><td>{{item.Way==1 ? \'הלוך\' : \'חזור\'}}</td><td><md-button \nclass=\"preview-user\" ng-click=\"changeTransportationStatus(item)\">{{item.Status==1 ? \'בטל שיוך\' : \'שחזר שיוך\'}}\n</md-button></td></tr></tbody></table></div></div></div></div></div>");
$templateCache.put("app/main/pages/users/views/parents/parents-profile/tabs/cancellation/cancellation.html","<div id=\"family\" ng-init=\"getCancellationForms()\"><div class=\"header\" layout=\"row\" layout-align=\"space-between center\">\n<div layout=\"column\" layout-align=\"start start\"><div class=\"h1\" layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"icon-file-document\"></md-icon><span>בקשות לביטול</span></div><div class=\"product-count secondary-text\">\n</div></div></div><div layout=\"row\" layout-sm=\"column\" layout-align=\"space-around\" ng-if=\"!cancellation\">\n<md-progress-circular md-mode=\"indeterminate\"></md-progress-circular></div><div ng-if=\"cancellation\"><table \nid=\"parent-cancellation-table\" class=\"dataTable row-border hover stripe md-ink-ripple\" datatable=\"ng\" \ndt-instance=\"dtInstance\" dt-options=\"dtOptions\" dt-column-defs=\"dtColumnDefs\"><thead><tr><th class=\"secondary-text\">\n<div class=\"table-header\"><span class=\"column-title\">תאריך</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">שם חניכ\\ה</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">שם ה{{$root.User.Event}}</span></div></th><th class=\"secondary-text\">\n<div class=\"table-header\"><span class=\"column-title\">סיבת ביטול</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">סטטוס פניה</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">פעולות</span></div></th></tr></thead><tbody><tr \nclass=\"entry-code-item\" ng-repeat=\"cancel in  cancellation | orderBy:ID\"><td><span class=\"dpn\">{{cancel.CreateTime}}\n</span>{{cancel.CreateTime | cmdate:\'HH:mm:ss dd/MM/yyyy \'}}</td><td><a \nhref=\"/student-profile?ID={{cancel.StudentID}}\" style=\"cursor: pointer\">{{cancel.StudentName}}</a></td><td>\n{{cancel.EventName}}</td><td>{{cancel.Reason==\'Other\' ? \'אחר\' : \'מחלה\'}}</td><td>{{cancel.Status}}</td><td><md-button \nclass=\"preview-user\" ng-click=\"openCancellationDialog(cancel)\" title=\"פרטי בקשה\"><md-icon md-svg-icon=\"eye\"></md-icon>\n</md-button></td></tr></tbody></table></div></div>");
$templateCache.put("app/main/pages/users/views/parents/parents-profile/tabs/about/about.html","<div><div layout=\"row\" layout-wrap><div layout=\"column\" flex=\"100\" flex-gt-sm=\"50\" flex-gt-md=\"60\"><div \nclass=\"profile-box info-box general md-whiteframe-1dp\" layout=\"column\"><header class=\"md-accent-bg\"><div class=\"title\">\nכללי</div></header><div class=\"content\" style=\"padding: 50px\"><form name=\"UserForm\" class=\"md-inline-form\" validate>\n<div class=\"row\" layout=\"row\"><div class=\"half\"><md-input-container class=\"md-icon-float md-block\" \nng-if=\"parent.LastLogin\"><md-icon md-font-icon=\"icon-clock\" class=\"name\"></md-icon><label>תאריך התחברות אחרון למערכת\n</label><input ng-value=\"parent.LastLogin*1000 | date:\'HH:mm:ss dd/MM/yyyy\'\" ng-disabled=\"true\"></md-input-container>\n<md-input-container class=\"md-icon-float md-block\" ng-if=\"!parent.LastLogin\"><md-icon md-font-icon=\"icon-clock\" \nclass=\"name\"></md-icon><label>תאריך התחברות אחרון למערכת</label><input ng-value=\"\'לא התבצע חיבור למערכת\'\" \nng-disabled=\"true\"></md-input-container></div></div><div class=\"row\" layout=\"row\"><div class=\"half\"><md-input-container\n class=\"md-icon-float md-block\"><md-icon md-font-icon=\"icon-account\" class=\"name\"></md-icon><label>תעודות זהות</label>\n<input ng-model=\"parent.PrivateID\" ng-disabled=\"true\" type=\"text\" md-autofocus></md-input-container></div><div \nclass=\"half\"><md-input-container class=\"md-icon-float md-block\"><md-icon md-font-icon=\"icon-phone\" class=\"name\">\n</md-icon><label>טלפון</label><input ng-model=\"parent.PhoneNumber\" type=\"text\" md-autofocus></md-input-container></div>\n</div><div class=\"row\" layout=\"row\"><div class=\"half\"><md-input-container class=\"md-icon-float md-block\"><md-icon \nmd-font-icon=\"icon-account\" class=\"name\"></md-icon><label>שם פרטי</label><input ng-model=\"parent.FirstName\" \ntype=\"text\" md-autofocus></md-input-container></div><div class=\"half\"><md-input-container \nclass=\"md-icon-float md-block\"><md-icon md-font-icon=\"icon-account\" class=\"name\"></md-icon><label>שם משפחה</label>\n<input ng-model=\"parent.LastName\" type=\"text\" md-autofocus></md-input-container></div></div><div class=\"row\" \nlayout=\"row\"><div class=\"half\"><md-input-container class=\"md-icon-float md-block\"><md-icon md-font-icon=\"icon-email\" \nclass=\"email\"></md-icon><label>דואר אלקטרוני</label><input ng-model=\"parent.Email\" type=\"email\"></md-input-container>\n</div><div class=\"half\"><md-input-container class=\"md-icon-float md-block\"><md-icon \nmd-font-icon=\"icon-cellphone-android\" class=\"name\"></md-icon><label>טלפון נייד</label><input \nng-model=\"parent.MobileNumber\" md-autofocus></md-input-container></div></div><div class=\"row\" layout=\"row\"><div \nclass=\"half\"><md-input-container class=\"md-icon-float md-block\"><md-icon md-font-icon=\"icon-power\" class=\"name\">\n</md-icon><label>סטטוס</label><md-select ng-model=\"parent.Status\" placeholder=\"סטטוס\"><md-option \nng-selected=\"parent.Status==1 || parent.Status==\'1\'\" ng-value=\"1\">פעיל</md-option><md-option \nng-selected=\"parent.Status==0 || parent.Status==\'0\'\" ng-value=\"0\">לא פעיל</md-option></md-select></md-input-container>\n</div><div class=\"half\" ng-if=\"$root.AdminLevel== 3 || ($root.AdminLevel==2 && $root.User.ParentsSocialEcoPer)\">\n<md-input-container class=\"md-icon-float md-block\"><md-icon md-font-icon=\"icon-cash\" class=\"name\"></md-icon><label>\nדרגת הנחה</label><md-select ng-model=\"parent.DiscountLevel\" placeholder=\"דרגת הנחה\"><md-option>בחר רמה</md-option>\n<md-option ng-selected=\"parent.DiscountLevel==1 || parent.DiscountLevel==\'1\'\" ng-value=\"1\">1</md-option><md-option \nng-selected=\"parent.DiscountLevel==2 || parent.DiscountLevel==\'2\'\" ng-value=\"2\">2</md-option><md-option \nng-selected=\"parent.DiscountLevel==3 || parent.DiscountLevel==\'3\'\" ng-value=\"3\">3</md-option><md-option \nng-selected=\"parent.DiscountLevel==4 || parent.DiscountLevel==\'4\'\" ng-value=\"4\">4</md-option><md-option \nng-selected=\"parent.DiscountLevel==5 || parent.DiscountLevel==\'5\'\" ng-value=\"5\">5</md-option><md-option \nng-selected=\"parent.DiscountLevel==6 || parent.DiscountLevel==\'6\'\" ng-value=\"6\">6</md-option></md-select>\n</md-input-container></div></div><div class=\"row\" layout=\"row\" \nng-if=\"$root.AdminLevel== 3 || ($root.AdminLevel==2 && $root.User.ParentsSocialEcoPer)\"><div class=\"half\">\n<md-input-container class=\"md-icon-float md-block md-icon-left\" layout=\"column\" layout-xs=\"row\"><md-icon \nmd-font-icon=\"icon-calendar-select\"></md-icon><div start-view=\"day\" locale=\"he\" format=\"DD/MM/YYYY\" \nmoment-picker=\"parent.DiscountLevelStartDate\"><label>תאריך התחלה של מתן הדרגה</label><input autocomplete=\"off\" \nng-model=\"parent.DiscountLevelStartDate\"></div></md-input-container></div><div class=\"half\"><md-input-container \nclass=\"md-icon-float md-block md-icon-left\" layout=\"column\" layout-xs=\"row\"><md-icon \nmd-font-icon=\"icon-calendar-select\"></md-icon><div start-view=\"day\" locale=\"he\" format=\"DD/MM/YYYY\" \nmoment-picker=\"parent.DiscountLevelEndDate\"><label>תאריך סיום של מתן הדרגה</label><input autocomplete=\"off\" \nng-model=\"parent.DiscountLevelEndDate\"></div></md-input-container></div></div><div class=\"row\" layout=\"row\"><div \nclass=\"half\"><div class=\"md-block md-icon-left\" style=\"display: -webkit-box\"><md-icon md-font-icon=\"icon-city\" \nclass=\"name\" style=\"padding-top: 26px\"></md-icon><md-autocomplete style=\"min-width: 400px; margin-right: 4px\" \nmd-selected-item-change=\"setCity(item)\" ng-disabled=\"isClicked\" md-input-name=\"autocompleteField\" \nmd-no-cache=\"noCache\" md-selected-item=\"selectedItem\" md-search-text=\"searchText\" \nmd-items=\"item in querySearch(searchText)\" md-item-text=\"item.display\" md-min-length=\"0\" md-floating-label=\"שם ישוב\">\n<md-item-template><span md-highlight-text=\"searchText\" md-highlight-flags=\"^i\">{{item.display}}</span>\n</md-item-template><md-not-found>ישוב לא נמצא</md-not-found></md-autocomplete></div></div><div class=\"half\">\n<md-input-container class=\"md-icon-float md-block\"><md-icon md-font-icon=\"icon-domain\" class=\"name\"></md-icon><label>\nכתובת מלאה</label><input ng-model=\"parent.Address\" type=\"text\" md-autofocus></md-input-container></div></div><div \nclass=\"row\" layout=\"row\"><div class=\"half\"><md-input-container class=\"md-icon-float md-block\"><md-icon \nmd-font-icon=\"icon-email\" class=\"email\"></md-icon><label>דירוג פידבק</label><input ng-model=\"parent.FeedBack\" \ntype=\"number\" disabled=\"disabled\"></md-input-container></div><div class=\"half\"><md-input-container \nclass=\"md-icon-float md-block\"><md-icon md-font-icon=\"icon-email\" class=\"email\"></md-icon><label>הערות פידבק</label>\n<textarea ng-model=\"parent.FeedBackComment\" disabled=\"disabled\"></textarea></md-input-container></div></div><div \nclass=\"row\" layout=\"row\"><div class=\"half\"><md-input-container class=\"md-icon-float md-block md-icon-left\" \nlayout=\"column\" layout-xs=\"row\"><md-icon md-font-icon=\"icon-account\" class=\"name\"></md-icon><label>קשר משפחתי לחניכים\n</label><md-select ng-model=\"parent.Relation\"><md-option ng-repeat=\"relation in relations\" ng-value=\"relation\">\n{{relation}}</md-option></md-select></md-input-container></div><div class=\"half\" ng-if=\"parent.Relation == \'אחר\'\">\n<md-input-container class=\"md-icon-float md-block md-icon-left\" layout=\"column\" layout-xs=\"row\"><md-icon \nmd-font-icon=\"icon-account\" class=\"name\"></md-icon><label>סוג קשר</label><input type=\"text\" ng-model=\"parent.Other\">\n</md-input-container></div></div><div layout=\"row\" layout-wrap><md-input-container class=\"md-icon-float md-block\" \nlayout=\"column\" layout-xs=\"row\" flex=\"100\" flex-xs=\"100\" flex-gt-sm=\"50\" flex-gt-md=\"50\"><md-icon \nmd-svg-icon=\"pound-box\"></md-icon><md-contact-chips style=\"padding-left: 1px\" ng-disabled=\"isClicked\" \nng-model=\"parent.Tags\" md-contacts=\"tagsQuerySearch($query)\" md-contact-name=\"Name\" md-require-match=\"true\" \nmd-highlight-flags=\"i\" filter-selected=\"true\" placeholder=\"חיפוש תגית\"></md-contact-chips></md-input-container></div>\n</form></div></div></div></div></div>");
$templateCache.put("app/main/pages/users/views/parents/parents-profile/tabs/cash/cash.html","<div id=\"cashTrans\"><div class=\"header\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"column\" \nlayout-align=\"start start\"><div class=\"h1\" layout=\"row\" layout-align=\"start center\"><md-icon md-svg-icon=\"cash\">\n</md-icon><span>תנועות בחשבון פנימי</span></div><div class=\"product-count secondary-text\"></div></div></div><table \nng-show=\"cashTrans\" class=\"dataTable row-border hover stripe md-ink-ripple\" datatable=\"ng\" dt-instance=\"dtInstance\" \ndt-options=\"cashDtOptions\"><thead><tr><th class=\"secondary-text\"><div class=\"table-header\"></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">מספר תנועה</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">תאריך</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">ילד</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">מספר הזמנה</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">סכום</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">יתרה</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">פעולות</span></div></th></tr></thead>\n<tbody><tr class=\"cash-item\" ng-class=\"cash.Amount > 0? \'plus\' : \'minus\'\" \nng-repeat=\"cash in cashTrans track by $index\"><td><md-icon class=\"indicator\" ng-if=\"cash.Amount > 0\" \nmd-svg-icon=\"plus-circle\"></md-icon><md-icon class=\"indicator\" ng-if=\"cash.Amount < 0\" md-svg-icon=\"minus-circle\">\n</md-icon></td><td>{{cash.ID}}</td><td>{{cash.CreationTime | cmdate:\'HH:mm:ss dd/MM/yyyy \'}}</td><td><a \nhref=\"/student-profile?ID={{cash.StudentID}}\" target=\"_blank\">{{cash.StudentFirstName}} {{cash.StudentLastName}}</a>\n</td><td>{{cash.RegistrationID}}</td><td>{{cash.Amount}}</td><td>{{cash.Total}}</td><td><md-button \nclass=\"preview-user\" ng-click=\"showFullRegistration({StudentID: cash.StudentID, ID: cash.RegistrationID})\" \ntitle=\"צפייה בפרטי הזמנה\"><md-icon md-svg-icon=\"eye\"></md-icon></md-button><md-button \nng-if=\"cash.Amount > 0 && (cash.Amount + cash.DeletedAmount) > 0\" class=\"preview-user\" \nng-click=\"deleteCashTransaction(cash)\" title=\"מחיקת זיכויי (יחזיר את ההרשמה לפעילה)\"><md-icon md-svg-icon=\"delete\">\n</md-icon></md-button></td></tr></tbody></table></div>");
$templateCache.put("app/main/pages/users/views/parents/parents-profile/tabs/comments/comments.html","<div id=\"comments\" class=\"page-layout simple tabbed\"><div class=\"profile-box info-box md-whiteframe-1dp commentDiv\" \nlayout=\"column\"><header class=\"md-accent-bg\"><div class=\"title\">הערות</div></header><div class=\"content\"><form \nname=\"UserForm\" class=\"md-inline-form\" validate><div layout=\"row\" layout-wrap><md-input-container class=\"md-block\" \nstyle=\"width: 100%\"><textarea rows=\"4\" cols=\"50\" style=\"border:solid 1px rgb(224,224,224)\" \nng-model=\"$root.commentText\" aria-label=\"\"></textarea></md-input-container></div><div><md-button \nclass=\"md-accent md-raised\" ng-click=\"addComment()\" ng-disabled=\"!$root.commentText\">הוספת הערה</md-button></div>\n</form></div></div><div class=\"content commentsLine\"><timeline><timeline-event ng-repeat=\"comment in Comments\" \nside=\"right\"><timeline-badge class=\"{{comment.badgeClass}}\"><md-icon md-svg-icon=\"checkbox-marked-circle-outline\">\n</md-icon></timeline-badge><timeline-panel class=\"{{comment.badgeClass}}\"><p \nstyle=\"font-weight: bold; font-size: 18px\">{{comment.user}}</p><timeline-heading><h4 style=\"font-size: 16px\" \nng-bind-html=\"comment.content\"></h4></timeline-heading><p style=\"font-size:12px\">{{comment.date | date: \'medium\'}}</p>\n</timeline-panel></timeline-event></timeline></div></div>");
$templateCache.put("app/main/pages/users/views/parents/parents-profile/tabs/contact/contact.html","<div id=\"family\"><div class=\"header\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"column\" \nlayout-align=\"start start\"><div class=\"h1\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-email\">\n</md-icon><span>פניות צור קשר</span></div><div class=\"product-count secondary-text\"></div></div></div><div \nlayout=\"row\" layout-sm=\"column\" layout-align=\"space-around\" ng-show=\"!contactss\"><md-progress-circular \nmd-mode=\"indeterminate\"></md-progress-circular></div><table id=\"contact-table\" \nclass=\"dataTable row-border hover stripe md-ink-ripple\" datatable=\"ng\" dt-instance=\"dtInstance\" dt-options=\"dtOptions\" \ndt-column-defs=\"dtColumnDefs\"><thead><tr><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">תאריך</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">שם חניכ\\ה</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">סטטוס פניה</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">פעולות</span></div></th></tr></thead><tbody><tr class=\"entry-code-item\" \nng-repeat=\"contactForm in  contactss | orderBy:ID\"><td>{{contactForm.CreateTime | cmdate:\'HH:mm:ss dd/MM/yyyy \'}}</td>\n<td><a href=\"/student-profile?ID={{contactForm.StudentID}}\" style=\"cursor: pointer\">{{contactForm.StudentName}}</a>\n</td><td>{{contactForm.Status}}</td><td><md-button class=\"preview-user\" ng-click=\"openContactDialog(contactForm)\" \ntitle=\"פרטי בקשה\"><md-icon md-svg-icon=\"eye\"></md-icon></md-button></td></tr></tbody></table></div>");
$templateCache.put("app/main/pages/users/views/parents/parents-profile/tabs/family/family.html","<div id=\"family\"><div class=\"header\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"column\" \nlayout-align=\"start start\"><div class=\"h1\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-home\">\n</md-icon><span>משפחה</span></div><div class=\"product-count secondary-text\"></div></div></div><div layout=\"row\" \nlayout-sm=\"column\" layout-align=\"space-around\" ng-if=\"!family\"><md-progress-circular md-mode=\"indeterminate\">\n</md-progress-circular></div><table class=\"dataTable row-border hover\" datatable=\"ng\" dt-instance=\"dtInstance\" \ndt-options=\"dtOptions\" ng-if=\"family\"><thead><tr><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">שם</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">תעודת זהות</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">דואר אלקטרני</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">{{$root.User.Branch}}</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">{{$root.User.Group}}</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">{{$root.User.Grade}}</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">מספר טלפון</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">סטטוס</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">פעולות</span></div></th></tr></thead><tbody><tr ng-repeat=\"familyMember in family\"><td>\n{{familyMember.FirstName}} {{familyMember.LastName}}</td><td>{{familyMember.PrivateID}}</td><td>{{familyMember.Email}}\n</td><td>{{familyMember.BranchName}}</td><td>{{familyMember.GroupName}}</td><td>{{familyMember.GradeName}}</td><td>\n{{familyMember.PhoneNumber}}</td><td>{{familyMember.Status ? \'פעיל\' : \'לא פעיל\'}}</td><td><span><md-button \nclass=\"preview-user\" href=\"/student-profile?ID={{familyMember.ID}}\" target=\"_blank\" title=\"מעבר לפרופיל\"><md-icon \nmd-svg-icon=\"account\"></md-icon></md-button></span><span><md-button class=\"preview-user\" \nng-click=\"editFamily(familyMember)\" title=\"ערוך\"><md-icon md-svg-icon=\"pencil\"></md-icon></md-button></span><span>\n<md-button class=\"preview-user\" ng-click=\"deleteFamily(familyMember)\" title=\"מחק\"><md-icon md-svg-icon=\"delete\">\n</md-icon></md-button></span></td></tr></tbody></table></div>");
$templateCache.put("app/main/pages/users/views/parents/parents-profile/tabs/payments/payments.html","<div id=\"entry-codes\"><table ng-show=\"receipts\" class=\"dataTable row-border hover stripe md-ink-ripple\" datatable=\"ng\" \ndt-instance=\"dtInstance\" dt-options=\"dtOptions\"><thead><tr><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">תאריך</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">סוג מסמך</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">מספר קבלה</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">סכום לתשלום</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">אמצעי תשלום</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">פעולות</span></div></th></tr></thead><tbody><tr class=\"entry-code-item\" \nng-repeat=\"receipt in receipts \"><td><span class=\"dpn\">{{receipt.Date}}</span>\n{{receipt.Date | cmdate:\'HH:mm:ss dd/MM/yyyy \'}}</td><td>{{receipt.Type==1 ? \'קבלה\' : \'זיכוי\'}}</td><td><a href=\"#\" \nng-click=\"downloadReceipt(receipt.ID,receipt.Type)\">{{receipt.ID}}</a></td><td>{{receipt.Amount}}</td><td>\n{{receipt.PaymentType}}</td><td><md-button class=\"preview-user\" title=\"שליחת קבלה חוזרת\"><md-icon md-svg-icon=\"email\" \nng-click=\"reSendReceipt(receipt)\"></md-icon></md-button></td></tr></tbody></table></div>");
$templateCache.put("app/main/pages/users/views/parents/parents-profile/tabs/registrations/registrations.html","<div id=\"payments\"><div layout=\"row\" layout-sm=\"column\" layout-align=\"space-around\" ng-show=\"!registrations\">\n<md-progress-circular md-mode=\"indeterminate\"></md-progress-circular></div><table id=\"parents-reg-table\" \nclass=\"dataTable row-border hover\" datatable=\"ng\" dt-instance=\"dtInstance\" dt-column-defs=\"dtColumnDefs\" \ndt-options=\"dtOptions\" ng-show=\"registrations\"><thead><tr><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">מספר הרשמה</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">תאריך הרשמה</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">שם ילד</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">שם {{$root.User.Event}}</span></div></th><th class=\"secondary-text\"><div class=\"table-header\">\n<span class=\"column-title\">מחיר</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">מחיר לתשלום</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">סטטוס הזמנה</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">סטטוס תשלום</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">מספר קבלה</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">מספר זיכוי</span></div></th><th class=\"secondary-text\" \nng-if=\"$root.AdminLevel==3 || ($root.AdminLevel==2 && $root.User.RegistrationsPer)\"><div class=\"table-header\"><span \nclass=\"column-title\">פעולות</span></div></th></tr></thead><tbody><tr \nng-repeat=\"registration in registrations | orderBy : \'ID\':reverse \"><td>{{registration.ID}}</td><td>\n{{registration.RegistrationTime | cmdate:\'HH:mm:ss dd/MM/yyyy \'}}</td><td>\n{{registration.StudentFirstName}} {{registration.StudentLastName}}</td><td>{{registration.EventName}} <span \nng-if=\"registration.CartEventName\">({{registration.CartEventName}})</span></td><td>{{registration.Price}}</td><td>\n{{registration.FinalPrice}}</td><td>{{registration.Status ? \'פעיל\' : \'לא פעיל\'}}</td><td>\n{{registration.PaymentStatus | paymentStatus}}</td><td><div class=\"sflex fdc hfs12\" \nng-if=\"registration.ReceiptID.length\"><a ng-repeat=\"receiptID in registration.ReceiptID\" \nng-if=\"!receiptID.includes(\'יה\')\" href=\"#\" ng-click=\"downloadReceipt(receiptID,1)\">{{receiptID}}</a> <span \nng-repeat=\"receiptID in registration.ReceiptID\" ng-if=\"receiptID.includes(\'יה\')\">{{receiptID}}</span></div></td><td>\n<div class=\"sflex fdc hfs12\" ng-if=\"registration.RefundReceiptID.length\"><a \nng-repeat=\"refundReceiptID in registration.RefundReceiptID\" ng-if=\"refundReceiptID > 0\" href=\"#\" \nng-click=\"downloadReceipt(refundReceiptID,2)\">{{refundReceiptID}}</a> <span \nng-repeat=\"refundReceiptID in registration.RefundReceiptID\" ng-if=\"refundReceiptID.includes(\'-\')\">{{refundReceiptID}}\n</span></div></td><td ng-if=\"$root.AdminLevel==3 || ($root.AdminLevel==2 && $root.User.RegistrationsPer)\"><md-button \nng-disabled=\"$root.User.SuperAdmin!=1 || registration.Canceled>0\" class=\"preview-user delete\" \nng-click=\"cancelRegistration(registration)\" title=\"{{!registration.Canceled>0 ? \'ביטול הרשמה\' : \'הרשמה מבוטלת\'}}\">\n<md-icon ng-class=\"{\'canceled\': registration.Canceled>0}\" md-svg-icon=\"delete\"></md-icon></md-button><md-button \nng-disabled=\"$root.User.SuperAdmin!=1 || !registration.PaymentStatus\" class=\"preview-user refund\" \nng-click=\"refundRegistration(registration)\" \ntitle=\"{{!registration.RefundReceiptID.length ? \'זיכוי הרשמה\' : \'קיים זיכויי להרשמה\'}}\"><md-icon \nng-class=\"{\'refunded\': registration.RefundReceiptID.length}\" md-svg-icon=\"credit-card\"></md-icon></md-button><md-button\n class=\"preview-user info\" ng-click=\"showFullRegistration(registration)\" title=\"צפייה בפרטי הזמנה\"><md-icon \nmd-svg-icon=\"eye\"></md-icon></md-button></td></tr></tbody></table></div>");
$templateCache.put("app/main/pages/users/views/parents/parents-profile/tabs/reset-password/reset-password.html","<div layout=\"row\" layout-wrap><div class=\"password_update\" layout=\"column\" flex=\"50\" flex-gt-sm=\"100\" flex-gt-md=\"50\">\n<div class=\"profile-box info-box general md-whiteframe-1dp\" layout=\"column\"><header class=\"md-accent-bg\"><div \nclass=\"title\">עדכון סיסמא</div></header><div class=\"content\"><ul><li>מינימום 8 תווים</li></ul><form \nname=\"PasswordForm\" class=\"md-inline-form\" ng-submit=\"updatePassword()\" validate><div class=\"row\" layout=\"row\"><div \nclass=\"full\"><md-input-container class=\"md-icon-float md-block\"><md-icon md-font-icon=\"icon-lock\" class=\"account\">\n</md-icon><label>סיסמא חדשה</label><input ng-model=\"newPassword\" type=\"password\" ng-required=\"true\" \nng-pattern=\"/[0-9a-zA-Z]{8,}/\"></md-input-container></div></div><md-button ng-disabled=\"isClicked || !newPassword\" \nclass=\"md-raised md-accent\" ng-click=\"updateParentPassword(newPassword)\" style=\"margin-right: 0px\">שמור</md-button>\n</form></div></div></div></div>");
$templateCache.put("app/main/pages/users/views/coordinators/coordinators-profile/tabs/about/about.html","<div><form name=\"UserForm\" class=\"md-inline-form\" validate><div layout=\"row\" layout-wrap><div class=\"general\" \nlayout=\"column\" flex=\"100\" flex-gt-sm=\"80\" flex-gt-md=\"70\" flex-gt-lg=\"50\"><div \nclass=\"profile-box info-box md-whiteframe-1dp\" layout=\"column\"><header class=\"md-accent-bg\"><div class=\"title\">כללי\n</div></header><div class=\"content\"><div layout=\"row\" layout-wrap><md-input-container class=\"md-icon-float md-block\" \nlayout=\"column\" layout-xs=\"row\" flex=\"100\" flex-xs=\"100\" flex-gt-sm=\"50\" flex-gt-md=\"50\"><md-icon \nmd-font-icon=\"icon-account\" class=\"name\"></md-icon><label>שם פרטי</label><input ng-model=\"coordinator.FirstName\" \ntype=\"text\" md-autofocus></md-input-container><md-input-container class=\"md-icon-float md-block\" layout=\"column\" \nlayout-xs=\"row\" flex=\"100\" flex-xs=\"100\" flex-gt-sm=\"50\" flex-gt-md=\"50\"><md-icon md-font-icon=\"icon-account\" \nclass=\"name\"></md-icon><label>שם משפחה</label><input ng-model=\"coordinator.LastName\" type=\"text\" md-autofocus>\n</md-input-container></div><div layout=\"row\" layout-wrap><md-input-container class=\"md-icon-float md-block\" \nlayout=\"column\" layout-xs=\"row\" flex=\"100\" flex-xs=\"100\" flex-gt-sm=\"50\" flex-gt-md=\"50\"><md-icon \nmd-font-icon=\"icon-email\" class=\"email\"></md-icon><label>דואר אלקטרוני</label><input ng-model=\"coordinator.Email\" \ntype=\"email\"></md-input-container><md-input-container class=\"md-icon-float md-block\" layout=\"column\" layout-xs=\"row\" \nflex=\"100\" flex-xs=\"100\" flex-gt-sm=\"50\" flex-gt-md=\"50\"><md-icon md-font-icon=\"icon-cellphone-android\" class=\"name\">\n</md-icon><input ng-model=\"coordinator.PhoneNumber\" type=\"tel\" md-autofocus></md-input-container></div><div \nlayout=\"row\" layout-wrap><md-input-container class=\"md-icon-float md-block\" layout=\"column\" layout-xs=\"row\" flex=\"100\" \nflex-xs=\"100\" flex-gt-sm=\"50\" flex-gt-md=\"50\"><md-icon md-font-icon=\"icon-power\" class=\"name\"></md-icon><label>סטטוס\n</label><md-select ng-model=\"coordinator.Status\" placeholder=\"סטטוס\"><md-option \nng-selected=\"coordinator.Status==1 || coordinator.Status==\'1\'\" ng-value=\"1\">פעיל</md-option><md-option \nng-selected=\"coordinator.Status==0 || coordinator.Status==\'0\'\" ng-value=\"0\">לא פעיל</md-option></md-select>\n</md-input-container><md-input-container class=\"md-icon-float md-block\" layout=\"column\" layout-xs=\"row\" flex=\"100\" \nflex-xs=\"100\" flex-gt-sm=\"50\" flex-gt-md=\"50\"><md-icon md-font-icon=\"icon-tie\"></md-icon><label>תפקיד</label><md-select\n ng-model=\"coordinator.Role\" placeholder=\"תפקיד\"><md-option ng-repeat=\"role in roles\" ng-value=\"role.Name\">\n{{role.Name}}</md-option></md-select></md-input-container></div></div></div></div><div class=\"about-sidebar\" \nlayout=\"column\" flex=\"100\" flex-gt-sm=\"50\" flex-gt-md=\"25\" ng-if=\"coordinator.CreateTime || coordinator.LastLogin\"><div\n class=\"profile-box info-box work md-whiteframe-1dp\" layout=\"column\"><header class=\"md-accent-bg\"><div class=\"title\">\nסטטיסטיקה</div></header><div class=\"content\" ng-if=\"coordinator.CreateTime\"><div class=\"info-line\"><div class=\"title\">\nתאריך יצירה</div><div class=\"info\"><span>{{coordinator.CreateTime | cmdate:\'HH:mm:ss בתאריך- dd/MM/yyyy בשעה\'}}</span>\n</div></div><div class=\"info-line\" ng-if=\"coordinator.LastLogin\"><div class=\"title\">תאריך התחברות אחרון</div><div \nclass=\"info\"><span>{{coordinator.LastLogin | cmdate:\'HH:mm:ss בתאריך- dd/MM/yyyy בשעה\'}}</span></div></div><div \nclass=\"info-line\" ng-if=\"coordinator.Password==0 || coordinator.Password==\'0\'\"><md-button class=\"md-raised md-accent\" \nng-click=\"openNewCoordinatorDialog()\">שליחת הזמנה חוזרת למערכת</md-button></div></div></div></div></div></form></div>");
$templateCache.put("app/main/pages/users/views/parents/parents-profile/tabs/subsidy/subsidy.html","<div id=\"family\"><div class=\"header\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"column\" \nlayout-align=\"start start\"><div class=\"h1\" layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"icon-file-document\"></md-icon><span>בקשות לסבסוד</span></div><div class=\"product-count secondary-text\">\n</div></div></div><div layout=\"row\" layout-sm=\"column\" layout-align=\"space-around\" ng-show=\"!subsidyes\">\n<md-progress-circular md-mode=\"indeterminate\"></md-progress-circular></div><table class=\"dataTable row-border hover\" \ndatatable=\"ng\" dt-instance=\"dtInstance\" dt-options=\"dtOptions\" ng-show=\"subsidyes\"><thead><tr><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">תאריך פניה</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">פעולות</span></div></th></tr></thead>\n<tbody><tr ng-repeat=\"subsidy in subsidyes\"><td><span class=\"dpn\">{{subsidy.CreateTime}}</span>\n{{subsidy.CreateTime | cmdate:\'HH:mm:ss dd/MM/yyyy \'}}</td><td><md-button ng-click=\"openSubsidyDialog(subsidy)\" \nclass=\"preview-user\" title=\"צפיה בבקשה\"><md-icon md-svg-icon=\"eye\"></md-icon></md-button></td></tr></tbody></table>\n</div>");
$templateCache.put("app/main/pages/users/views/coordinators/coordinators-profile/tabs/branches/branches.html","<div><form name=\"UserForm\" class=\"md-inline-form\" validate><div layout=\"row\" layout-wrap><div class=\"general\" \nlayout=\"column\" flex=\"100\" flex-gt-sm=\"80\" flex-gt-md=\"70\" flex-gt-lg=\"50\"><div \nclass=\"profile-box info-box work md-whiteframe-1dp\" layout=\"column\"><header class=\"md-accent-bg\"><div class=\"title\">\nפרטי ניהול {{$root.User.Branches}}</div></header><div class=\"content\"><div layout=\"row\" layout-wrap><md-input-container\n class=\"md-icon-float md-block\" layout=\"column\" layout-xs=\"row\" flex=\"100\"><md-contact-chips \nng-model=\"selectedBranches\" ng-disabled=\"!branches\" md-contacts=\"branchesQuerySearch($query)\" md-contact-name=\"Name\" \nmd-require-match=\"true\" md-highlight-flags=\"i\" filter-selected=\"true\" placeholder=\"בחר {{$root.User.Branches}}\">\n</md-contact-chips></md-input-container></div><div class=\"row\" layout=\"rot\"><md-button \nng-disabled=\"isClicked || !branches\" class=\"md-raised md-accent\" aria-label=\"חפש\" ng-click=\"updateBranches()\">עדכן\n</md-button></div></div></div></div></div><div layout=\"row\" layout-wrap><div class=\"general\" layout=\"column\" \nflex=\"100\" flex-gt-sm=\"80\" flex-gt-md=\"70\" flex-gt-lg=\"50\"><div class=\"profile-box info-box work md-whiteframe-1dp\" \nlayout=\"column\"><header class=\"md-accent-bg\"><div class=\"title\">פרטי ניהול איזורים</div></header><div class=\"content\">\n<div layout=\"row\" layout-wrap><md-input-container class=\"md-icon-float md-block\" layout=\"column\" layout-xs=\"row\" \nflex=\"100\"><md-contact-chips ng-model=\"selectedAreas\" ng-disabled=\"!areas\" md-contacts=\"areaQuerySearch($query)\" \nmd-contact-name=\"Name\" md-require-match=\"true\" md-highlight-flags=\"i\" filter-selected=\"true\" placeholder=\"בחר אזור\">\n</md-contact-chips></md-input-container></div><div class=\"row\" layout=\"rot\"><md-button \nng-disabled=\"isClicked || !areas\" class=\"md-raised md-accent\" aria-label=\"חפש\" ng-click=\"updateAreas()\">עדכן\n</md-button></div></div></div></div></div></form></div>");
$templateCache.put("app/main/pages/users/views/coordinators/coordinators-profile/tabs/permissions/permissions.html","<div><form name=\"UserForm\" class=\"md-inline-form\" validate ng-init=\"getGlobalMaxNumOfPayments()\"><div layout=\"row\" \nlayout-wrap><div class=\"general\" layout=\"column\" flex=\"100\" flex-gt-sm=\"80\" flex-gt-md=\"70\" flex-gt-lg=\"50\"><div \nclass=\"profile-box info-box md-whiteframe-1dp\" layout=\"column\"><header class=\"md-accent-bg\"><div class=\"title\">כללי\n</div></header><div class=\"content\"><div layout=\"row\" layout-wrap><md-input-container class=\"md-icon-float md-block\" \nlayout=\"column\" layout-xs=\"row\" flex=\"100\" flex-xs=\"100\" flex-gt-sm=\"50\" flex-gt-md=\"50\"><md-icon \nmd-svg-icon=\"cash-multiple\" class=\"name\" title=\"אפשרות לשנות סכומי תשלום וסטטוס הרשמה ותשלום בעת הרשמה חדשה/ קיימת\">\n</md-icon><label>הרשאות לאישור תשלום</label><md-select ng-model=\"coordinator.Payments\" \nplaceholder=\"הרשאות לאישור תשלום\"><md-option ng-value=\"1\">פעיל</md-option><md-option ng-value=\"0\">לא פעיל</md-option>\n</md-select></md-input-container><md-input-container class=\"md-icon-float md-block\" layout=\"column\" layout-xs=\"row\" \nflex=\"100\" flex-xs=\"100\" flex-gt-sm=\"50\" flex-gt-md=\"50\"><md-icon md-font-icon=\"icon-weather-sunny\" class=\"name\" \ntitle=\"אפשרות לפתוח {{$root.User.Events}} חדשים\"></md-icon><label>הרשאות ל{{$root.User.Events}}</label><md-select \nng-model=\"coordinator.EventsPer\" placeholder=\"הרשאות ל{{$root.User.Events}}\"><md-option ng-value=\"1\">פעיל</md-option>\n<md-option ng-value=\"0\">לא פעיל</md-option></md-select></md-input-container></div><div layout=\"row\" layout-wrap>\n<md-input-container class=\"md-icon-float md-block\" layout=\"column\" layout-xs=\"row\" flex=\"100\" flex-xs=\"100\" \nflex-gt-sm=\"50\" flex-gt-md=\"50\"><md-icon md-svg-icon=\"cash-100\" class=\"name\" \ntitle=\"אפשרות לרשום חניכים ל{{$root.User.Events}}\"></md-icon><label>הרשאות להרשמת חניכים</label><md-select \nng-model=\"coordinator.EventsPay\" placeholder=\"הרשאות להרשמת חניכים\"><md-option ng-value=\"1\">פעיל</md-option><md-option \nng-value=\"0\">לא פעיל</md-option></md-select></md-input-container><md-input-container class=\"md-icon-float md-block\" \nlayout=\"column\" layout-xs=\"row\" flex=\"100\" flex-xs=\"100\" flex-gt-sm=\"50\" flex-gt-md=\"50\"><md-icon \nmd-svg-icon=\"cash-100\" class=\"name\" title=\"אפשרות לשינויי נוכחות ל{{$root.User.Events}}\"></md-icon><label>\nהרשאות לנוכחות {{$root.User.Event}}</label><md-select ng-model=\"coordinator.Attendance\" \nplaceholder=\"הרשאות לנוכחות {{$root.User.Event}}\"><md-option ng-value=\"1\">פעיל</md-option><md-option ng-value=\"0\">\nלא פעיל</md-option></md-select></md-input-container></div><div layout=\"row\" layout-wrap><md-input-container \nclass=\"md-icon-float md-block\" layout=\"column\" layout-xs=\"row\" flex=\"100\" flex-xs=\"100\" flex-gt-sm=\"50\" \nflex-gt-md=\"50\"><md-icon md-svg-icon=\"cart\" class=\"name\" title=\"אפשרות לכניסה לתפריט שיווק {{$root.User.Events}}\">\n</md-icon><label>הרשאות לשיווק {{$root.User.Events}}</label><md-select ng-model=\"coordinator.Marketing\" \nplaceholder=\"הרשאות לשיווק {{$root.User.Events}}\"><md-option ng-value=\"1\">פעיל</md-option><md-option ng-value=\"0\">\nלא פעיל</md-option></md-select></md-input-container><md-input-container class=\"md-icon-float md-block\" layout=\"column\" \nlayout-xs=\"row\" flex=\"100\" flex-xs=\"100\" flex-gt-sm=\"50\" flex-gt-md=\"50\"><md-icon md-svg-icon=\"account\" class=\"name\" \ntitle=\"חסימת הרשאה לרישום ל{{$root.User.Event}} לאחר סיום הרשמה\"></md-icon><label>\nחסימת הרשאה לרישום ל{{$root.User.Event}} לאחר סיום הרשמה</label><md-select ng-model=\"coordinator.RegistrationClose\" \nplaceholder=\"חסימת הרשאה לרישום ל{{$root.User.Event}} לאחר סיום הרשמה\"><md-option ng-value=\"1\">פעיל</md-option>\n<md-option ng-value=\"0\">לא פעיל</md-option></md-select></md-input-container></div><div layout=\"row\" layout-wrap>\n<md-input-container class=\"md-icon-float md-block\" layout=\"column\" layout-xs=\"row\" flex=\"100\" flex-xs=\"100\" \nflex-gt-sm=\"50\" flex-gt-md=\"50\"><md-icon md-font-icon=\"icon-help-circle\" class=\"name\" \ntitle=\"הרשאות לעריכת שאלות {{$root.User.Events}}\"></md-icon><label>הרשאות לעריכת שאלות {{$root.User.Events}}</label>\n<md-select ng-model=\"coordinator.EditQuestions\" placeholder=\"הרשאות לעריכת שאלות {{$root.User.Events}}\"><md-option \nng-value=\"1\">פעיל</md-option><md-option ng-value=\"0\">לא פעיל</md-option></md-select></md-input-container>\n<md-input-container class=\"md-icon-float md-block\" layout=\"column\" layout-xs=\"row\" flex=\"100\" flex-xs=\"100\" \nflex-gt-sm=\"50\" flex-gt-md=\"50\"><md-icon md-font-icon=\"icon-help-circle\" class=\"name\" \ntitle=\"אפשרות לגשת לתפריטי בקשות סבסוד\"></md-icon><label>הרשאות בקשות סבסוד</label><md-select \nng-model=\"coordinator.SubsidyRequests\" placeholder=\"הרשאות בקשות סבסוד\"><md-option ng-value=\"1\">פעיל</md-option>\n<md-option ng-value=\"0\">לא פעיל</md-option></md-select></md-input-container></div><div layout=\"row\" layout-wrap>\n<md-input-container class=\"md-icon-float md-block\" layout=\"column\" layout-xs=\"row\" flex=\"100\" flex-xs=\"100\" \nflex-gt-sm=\"50\" flex-gt-md=\"50\"><md-icon md-font-icon=\"icon-help-circle\" class=\"name\" \ntitle=\"אפשרות לשלוח הודעות SMS מהמערכת\"></md-icon><label>הרשאות לשליחת SMS</label><md-select \nng-model=\"coordinator.SmsPer\" placeholder=\"הרשאות לשליחת SMS\"><md-option ng-value=\"1\">פעיל</md-option><md-option \nng-value=\"0\">לא פעיל</md-option></md-select></md-input-container><md-input-container class=\"md-icon-float md-block\" \nlayout=\"column\" layout-xs=\"row\" flex=\"100\" flex-xs=\"100\" flex-gt-sm=\"50\" flex-gt-md=\"50\"><md-icon \nmd-font-icon=\"icon-help-circle\" class=\"name\" title=\"אפשרות לשלוח הודעות דוא\'\'ל מהמערכת\"></md-icon><label>\nהרשאות לשליחת אימייל</label><md-select ng-model=\"coordinator.EmailPer\" placeholder=\"הרשאות לשליחת אימייל\"><md-option \nng-value=\"1\">פעיל</md-option><md-option ng-value=\"0\">לא פעיל</md-option></md-select></md-input-container></div><div \nlayout=\"row\" layout-wrap><md-input-container class=\"md-icon-float md-block\" layout=\"column\" layout-xs=\"row\" flex=\"100\" \nflex-xs=\"100\" flex-gt-sm=\"50\" flex-gt-md=\"50\"><md-icon md-font-icon=\"icon-help-circle\" class=\"name\" \ntitle=\"אפשרות לרשום חניכים ל{{$root.User.Events}} מעבר לכמות הנרשמים המוגבלת שנקבעה\"></md-icon><label>\nהרשאות להרשמה מעבר לכמות המוגבלת</label><md-select ng-model=\"coordinator.OverRegsPer\" \nplaceholder=\"הרשאות להרשמה לעבר לכמות המוגבלת\"><md-option ng-value=\"1\">פעיל</md-option><md-option ng-value=\"0\">לא פעיל\n</md-option></md-select></md-input-container><md-input-container class=\"md-icon-float md-block\" layout=\"column\" \nlayout-xs=\"row\" flex=\"100\" flex-xs=\"100\" flex-gt-sm=\"50\" flex-gt-md=\"50\"><md-icon md-svg-icon=\"numeric\" class=\"name\" \ntitle=\"כמות תשלומים המקסימלית שיוכל לקבוע\"></md-icon><label>מקסימום כמות תשלומים מותרת לקביעה</label><input \nmax=\"{{globalMaxNumOfPayments}}\" ng-model=\"coordinator.MaxNumOfPayments\" type=\"number\" \nplaceholder=\"מקסימום כמות תשלומים מותרת לקביעה\"></md-input-container></div><div layout=\"row\" layout-wrap>\n<md-input-container class=\"md-icon-float md-block\" layout=\"column\" layout-xs=\"row\" flex=\"100\" flex-xs=\"100\" \nflex-gt-sm=\"50\" flex-gt-md=\"50\"><md-icon md-font-icon=\"icon-help-circle\" class=\"name\" \ntitle=\"אפשרות לעריכת פרטי שלוחות\"></md-icon><label>הרשאות לניהול שלוחות</label><md-select \nng-model=\"coordinator.BranchesPer\" placeholder=\"הרשאות לניהול שלוחות\"><md-option ng-value=\"1\">פעיל</md-option>\n<md-option ng-value=\"0\">לא פעיל</md-option></md-select></md-input-container><md-input-container \nclass=\"md-icon-float md-block\" layout=\"column\" layout-xs=\"row\" flex=\"100\" flex-xs=\"100\" flex-gt-sm=\"50\" \nflex-gt-md=\"50\"><md-icon md-font-icon=\"icon-help-circle\" class=\"name\" title=\"צפייה בדרגות הנחה ובקשות סבסוד\"></md-icon>\n<label>הרשאות מידע סוציו-אקונומי</label><md-select ng-model=\"coordinator.ParentsSocialEcoPer\" \nplaceholder=\"הרשאות מידע סוציו-אקונומי\"><md-option ng-value=\"1\">פעיל</md-option><md-option ng-value=\"0\">לא פעיל\n</md-option></md-select></md-input-container></div><div layout=\"row\" layout-wrap><md-input-container \nclass=\"md-icon-float md-block\" layout=\"column\" layout-xs=\"row\" flex=\"100\" flex-xs=\"100\" flex-gt-sm=\"50\" \nflex-gt-md=\"50\"><md-icon md-font-icon=\"icon-help-circle\" class=\"name\" title=\"אפשרות צפייה בפרטי דרגת הנחה של הורה\">\n</md-icon><label>הרשאות צפייה בפרטי הרשמה</label><md-select ng-model=\"coordinator.RegistrationsPer\" \nplaceholder=\"הרשאות צפייה בפרטי הרשמה\"><md-option ng-value=\"1\">פעיל</md-option><md-option ng-value=\"0\">לא פעיל\n</md-option></md-select></md-input-container><md-input-container class=\"md-icon-float md-block\" layout=\"column\" \nlayout-xs=\"row\" flex=\"100\" flex-xs=\"100\" flex-gt-sm=\"50\" flex-gt-md=\"50\"><md-icon md-font-icon=\"icon-help-circle\" \nclass=\"name\" title=\"אפשרות להתחברות מהירה לפרופיל הורה מהמערכת\"></md-icon><label>הרשאות התחברות לפרופיל הורה</label>\n<md-select ng-model=\"coordinator.ParentsLoginPer\" placeholder=\"הרשאות התחברות לפרופיל הורה\"><md-option ng-value=\"1\">\nפעיל</md-option><md-option ng-value=\"0\">לא פעיל</md-option></md-select></md-input-container></div></div></div></div>\n</div></form></div>");
$templateCache.put("app/main/pages/users/views/students/student-profile/tabs/cancellation/cancellation.html","<div id=\"family\" ng-init=\"getCancellationForms()\"><div layout=\"row\" layout-sm=\"column\" layout-align=\"space-around\" \nng-show=\"!cancellation\"><md-progress-circular md-mode=\"indeterminate\"></md-progress-circular></div><table \nid=\"cancellation-table\" class=\"dataTable row-border hover stripe md-ink-ripple\" datatable=\"ng\" \ndt-instance=\"dtInstance\" dt-options=\"dtOptions\" dt-column-defs=\"dtColumnDefs\"><thead><tr><th class=\"secondary-text\">\n<div class=\"table-header\"><span class=\"column-title\">תאריך</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">שם הורה</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">מייל הורה</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">טלפון נייד הורה</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">שם ה{{$root.User.Event}}</span></div></th><th class=\"secondary-text\">\n<div class=\"table-header\"><span class=\"column-title\">סיבת ביטול</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">סטטוס פניה</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">פעולות</span></div></th></tr></thead><tbody><tr \nclass=\"entry-code-item\" ng-repeat=\"cancel in  cancellation | orderBy:ID\"><td>\n{{cancel.CreateTime | cmdate:\'HH:mm:ss dd/MM/yyyy \'}}</td><td><a href=\"/parent-profile?ID={{cancel.ParentID}}\" \nstyle=\"cursor: pointer\">{{cancel.ParentName}}</a></td><td><a href=\"mailto:{{cancel.ParentEmail}}\">\n{{cancel.ParentEmail}}</a></td><td>{{cancel.ParentPhone}}</td><td>{{cancel.EventName}}</td><td>\n{{cancel.Reason==\'Other\' ? \'אחר\' : \'מחלה\'}}</td><td>{{cancel.Status}}</td><td><md-button class=\"preview-user\" \nng-click=\"openCancellationDialog(cancel)\" title=\"פרטי בקשה\"><md-icon md-svg-icon=\"eye\"></md-icon></md-button></td></tr>\n</tbody></table></div>");
$templateCache.put("app/main/pages/users/views/students/student-profile/tabs/about/about.html","<div><div layout=\"row\" layout-wrap><div class=\"general\" layout=\"column\" flex=\"100\" flex-gt-sm=\"80\" flex-gt-md=\"70\" \nflex-gt-lg=\"50\"><div class=\"profile-box info-box md-whiteframe-1dp\" layout=\"column\"><header class=\"md-accent-bg\"><div \nclass=\"title\">כללי</div></header><div class=\"content\"><form name=\"UserForm\" class=\"md-inline-form\" validate><div \nlayout=\"row\" layout-wrap><md-input-container class=\"md-icon-float md-block\" layout=\"column\" layout-xs=\"row\" flex=\"100\" \nflex-xs=\"100\" flex-gt-sm=\"50\" flex-gt-md=\"50\"><md-icon md-font-icon=\"icon-account-box\" class=\"name\"></md-icon><label>\nתעודה מזהה\\דרכון</label><input ng-disabled=\"true\" ng-model=\"student.PrivateID\" type=\"text\"></md-input-container>\n<md-input-container class=\"md-icon-float md-block\" layout=\"column\" layout-xs=\"row\" flex=\"100\" flex-xs=\"100\" \nflex-gt-sm=\"50\" flex-gt-md=\"50\"><md-icon md-font-icon=\"icon-account\" class=\"name\"></md-icon><label>שם פרטי</label>\n<input ng-model=\"student.FirstName\" type=\"text\"></md-input-container></div><div layout=\"row\" layout-wrap>\n<md-input-container class=\"md-icon-float md-block\" layout=\"column\" layout-xs=\"row\" flex=\"100\" flex-xs=\"100\" \nflex-gt-sm=\"50\" flex-gt-md=\"50\"><md-icon md-font-icon=\"icon-account\" class=\"name\"></md-icon><label>שם משפחה</label>\n<input ng-model=\"student.LastName\" type=\"text\"></md-input-container><md-input-container class=\"md-icon-float md-block\" \nlayout=\"column\" layout-xs=\"row\" flex=\"100\" flex-xs=\"100\" flex-gt-sm=\"50\" flex-gt-md=\"50\"><md-icon \nmd-font-icon=\"icon-email\" class=\"email\"></md-icon><label>דואר אלקטרוני</label><input ng-model=\"student.Email\" \ntype=\"email\"></md-input-container></div><div layout=\"row\" layout-wrap><md-input-container \nclass=\"md-icon-float md-block md-icon-left\" layout=\"column\" layout-xs=\"row\" flex=\"100\" flex-xs=\"100\" flex-gt-sm=\"50\" \nflex-gt-md=\"50\"><md-icon md-font-icon=\"icon-calendar-select\"></md-icon><div start-view=\"day\" locale=\"he\" \nformat=\"DD/MM/YYYY\" moment-picker=\"student.Birthday\"><label>תאריך לידה</label><input autocomplete=\"off\" \nng-model=\"student.Birthday\"></div></md-input-container><md-input-container class=\"md-icon-float md-block\" \nlayout=\"column\" layout-xs=\"row\" flex=\"100\" flex-xs=\"100\" flex-gt-sm=\"50\" flex-gt-md=\"50\"><md-icon \nmd-svg-icon=\"hospital-building\"></md-icon><label>קופת חולים</label><md-select ng-model=\"student.HMO\" \nplaceholder=\"קופת חולים\"><md-option ng-repeat=\"hnm in HMOS\" ng-value=\"hnm\">{{hnm}}</md-option></md-select>\n</md-input-container></div><div layout=\"row\" layout-wrap><md-input-container class=\"md-icon-float md-block\" \nlayout=\"column\" layout-xs=\"row\" flex=\"100\" flex-xs=\"100\" flex-gt-sm=\"50\" flex-gt-md=\"50\"><md-icon \nmd-font-icon=\"icon-gender-male-female\"></md-icon><label>מין</label><md-select ng-model=\"student.Gender\" \nplaceholder=\"מין\"><md-option ng-selected=\"student.Gender==\'Male\'\" ng-value=\"\'Male\'\">בן</md-option><md-option \nng-selected=\"student.Gender==\'Female\'\" ng-value=\"\'Female\'\">בת</md-option><md-option ng-if=\"$root.GenderType == 1\" \nng-selected=\"student.Gender==\'Other\'\" ng-value=\"\'Other\'\">אחר</md-option></md-select></md-input-container></div><div \nlayout=\"row\" layout-wrap><md-input-container class=\"md-icon-float md-block\" layout=\"column\" layout-xs=\"row\" flex=\"100\" \nflex-xs=\"100\" flex-gt-sm=\"50\" flex-gt-md=\"50\"><md-icon md-font-icon=\"icon-panorama-horizontal\"></md-icon><label>רחוב\n</label><input ng-model=\"student.Street\" type=\"text\"></md-input-container><div class=\"half\"><div \nclass=\"md-block md-icon-left\" style=\"display: -webkit-box\"><md-icon md-font-icon=\"icon-city\" class=\"name\" \nstyle=\"padding-top: 26px\"></md-icon><md-autocomplete style=\"min-width: 400px; margin-right: 4px\" \nmd-selected-item-change=\"setCity(item)\" ng-disabled=\"isClicked\" md-input-name=\"autocompleteField\" \nmd-no-cache=\"noCache\" md-selected-item=\"selectedItem\" md-search-text=\"searchText\" \nmd-items=\"item in querySearch(searchText)\" md-item-text=\"item.display\" md-min-length=\"0\" md-floating-label=\"שם ישוב\">\n<md-item-template><span md-highlight-text=\"searchText\" md-highlight-flags=\"^i\">{{ item.value}}</span>\n</md-item-template><md-not-found>ישוב לא נמצא</md-not-found></md-autocomplete></div></div></div><div layout=\"row\" \nlayout-wrap><md-input-container class=\"md-icon-float md-block\" layout=\"column\" layout-xs=\"row\" flex=\"100\" \nflex-xs=\"100\" flex-gt-sm=\"50\" flex-gt-md=\"50\"><md-icon md-font-icon=\"icon-cellphone-android\"></md-icon><label>\nמספר טלפון נייד</label><input ng-model=\"student.PhoneNumber\" type=\"tel\" aria-label=\"phone number\"></md-input-container>\n<md-input-container class=\"md-icon-float md-block\" layout=\"column\" layout-xs=\"row\" flex=\"100\" flex-xs=\"100\" \nflex-gt-sm=\"50\" flex-gt-md=\"50\"><md-icon md-font-icon=\"icon-phone\"></md-icon><label>מספר טלפון</label><input \nng-model=\"student.Phone\" type=\"text\"></md-input-container></div><div layout=\"row\" layout-wrap><md-input-container \nclass=\"md-icon-float md-block\" layout=\"column\" layout-xs=\"row\" flex=\"100\" flex-xs=\"100\" flex-gt-sm=\"50\" \nflex-gt-md=\"50\"><md-icon md-font-icon=\"icon-power\"></md-icon><label>סטטוס</label><md-select ng-model=\"student.Status\" \nplaceholder=\"סטטוס\"><md-option ng-selected=\"student.Status==1 || student.Status==\'1\'\" ng-value=\"1\">פעיל</md-option>\n<md-option ng-selected=\"student.Status==0 || student.Status==\'0\'\" ng-value=\"0\">לא פעיל</md-option></md-select>\n</md-input-container><md-input-container class=\"md-icon-float md-block\" layout=\"column\" layout-xs=\"row\" flex=\"100\" \nflex-xs=\"100\" flex-gt-sm=\"50\" flex-gt-md=\"50\" ng-if=\"!student.Status\"><md-icon md-font-icon=\"icon-power\"></md-icon>\n<label>סיבת סטטוס לא פעיל</label><textarea required ng-model=\"student.StatusReason\" ng-if=\"!brandIsLatet\"></textarea>\n<md-select ng-model=\"student.StatusReason\" ng-if=\"brandIsLatet\" placeholder=\"בחירת סיבה\"><md-option \nng-selected=\"student.StatusReason==\'סיים בית ספר\'\" ng-value=\"\'סיים בית ספר\'\">סיים בית ספר</md-option><md-option \nng-selected=\"student.StatusReason==\'עזב\'\" ng-value=\"\'עזב\'\">עזב</md-option><md-option \nng-selected=\"student.StatusReason==\'סניף נסגר\'\" ng-value=\"\'סניף נסגר\'\">סניף נסגר</md-option></md-select>\n</md-input-container></div><div layout=\"row\" layout-wrap><md-input-container class=\"md-icon-float md-block\" \nlayout=\"row\" layout-xs=\"row\" flex=\"100\" flex-xs=\"100\" flex-gt-sm=\"50\" flex-gt-md=\"50\"><label>\nבעיות רפואוית/תרופות קבועות</label><md-icon md-font-icon=\"icon-hospital\"></md-icon><md-select \nng-model=\"student.MedicalProblemsQuestion\" placeholder=\"בעיות רפואוית/תרופות קבועות\"><md-option \nng-selected=\"student.MedicalProblemsQuestion==\'1\'\" ng-value=\"1\">כן</md-option><md-option \nng-selected=\"student.MedicalProblemsQuestion==\'0\'\" ng-value=\"0\">לא</md-option></md-select></md-input-container>\n<md-input-container class=\"md-icon-float md-block\" layout=\"column\" layout-xs=\"row\" flex=\"100\" flex-xs=\"100\" \nflex-gt-sm=\"50\" flex-gt-md=\"50\"><md-icon md-font-icon=\"icon-hospital\"></md-icon><label>\nפירוט בעיות רפואוית/תרופות קבועות</label><textarea ng-model=\"student.MedicalProblems\"></textarea></md-input-container>\n</div><div layout=\"row\" layout-wrap><md-input-container class=\"md-icon-float md-block\" layout=\"column\" layout-xs=\"row\" \nflex=\"100\" flex-xs=\"100\" flex-gt-sm=\"50\" flex-gt-md=\"50\"><label>רגישות למזון</label><md-icon md-svg-icon=\"food-off\">\n</md-icon><md-select ng-model=\"student.FoodSensitivityQuestion\" placeholder=\"רגישות למזון\"><md-option \nng-selected=\"student.FoodSensitivityQuestion==\'1\'\" ng-value=\"1\">כן</md-option><md-option \nng-selected=\"student.FoodSensitivityQuestion==\'0\'\" ng-value=\"0\">לא</md-option></md-select></md-input-container>\n<md-input-container class=\"md-icon-float md-block\" layout=\"column\" layout-xs=\"row\" flex=\"100\" flex-xs=\"100\" \nflex-gt-sm=\"50\" flex-gt-md=\"50\"><md-icon md-svg-icon=\"food-off\"></md-icon><label>רגישות למזון</label><textarea \nng-model=\"student.FoodSensitivity\"></textarea></md-input-container></div><div layout=\"row\" layout-wrap>\n<md-input-container class=\"md-icon-float md-block\" layout=\"column\" layout-xs=\"row\" flex=\"100\" flex-xs=\"100\" \nflex-gt-sm=\"50\" flex-gt-md=\"50\"><md-icon md-svg-icon=\"account-box\"></md-icon><label>\n{{$root.fathersName?$root.fathersName : \'שם האב\' }}</label><textarea ng-model=\"student.FatherName\"></textarea>\n</md-input-container><md-input-container class=\"md-icon-float md-block\" layout=\"column\" layout-xs=\"row\" flex=\"100\" \nflex-xs=\"100\" flex-gt-sm=\"50\" flex-gt-md=\"50\"><md-icon md-font-icon=\"icon-account\"></md-icon><label>סוג חניך</label>\n<md-select ng-model=\"student.Type\" placeholder=\"סוג חניך\"><md-option \nng-selected=\"student.Type==2 || student.Type==\'2\'\" ng-value=\"2\">בוגר</md-option><md-option \nng-selected=\"student.Type==1 || student.Type==\'1\'\" ng-value=\"1\">רגיל</md-option></md-select></md-input-container></div>\n<div layout=\"row\" layout-wrap><md-input-container class=\"md-icon-float md-block\" layout=\"column\" layout-xs=\"row\" \nflex=\"100\" flex-xs=\"100\" flex-gt-sm=\"50\" flex-gt-md=\"50\"><md-icon md-font-icon=\"icon-domain\"></md-icon><label>מיקוד\n</label><input ng-model=\"student.ZipCode\" type=\"text\"></md-input-container><md-input-container \nclass=\"md-icon-float md-block\" layout=\"column\" layout-xs=\"row\" flex=\"100\" flex-xs=\"100\" flex-gt-sm=\"50\" \nflex-gt-md=\"50\" ng-if=\"student.EducatorID\"><md-icon md-font-icon=\"icon-tie\"></md-icon><label>תפקיד מדריך</label>\n<md-select ng-model=\"student.Role\" placeholder=\"תפקיד\"><md-option ng-repeat=\"role in roles\" ng-value=\"role.Name\">\n{{role.Name}}</md-option></md-select></md-input-container></div></form></div></div></div><div class=\"about-sidebar\" \nlayout=\"column\" flex=\"100\" flex-gt-sm=\"80\" flex-gt-md=\"70\" flex-gt-lg=\"50\"><div ng-show=\"$root.AdminLevel>1\" \nclass=\"profile-box info-box work md-whiteframe-1dp\" layout=\"column\"><header class=\"md-accent-bg\"><div class=\"title\" \nstyle=\"display: flex;align-items: center;justify-content: space-between\"><span>פרטי שיבוץ וחניכה</span></div></header>\n<div class=\"content\"><form name=\"UserForm\" class=\"md-inline-form\" validate><div layout=\"row\" layout-wrap>\n<md-input-container class=\"md-icon-float md-block\" layout=\"row\" flex=\"100\"><label>{{$root.User.Branch}}</label><md-icon\n md-font-icon=\"icon-domain\"></md-icon><md-select md-on-close=\"vm.clearSearchTerm()\" ng-model=\"student.BranchID\" \nng-change=\"getGroupsByBranch(true,student.BranchID)\" id=\"BranchID\" ng-disabled=\"!branches\"><md-select-header \nclass=\"demo-select-header\"><input ng-model=\"searchTerm\" type=\"text\" ng-keydown=\"$event.stopPropagation()\" \nplaceholder=\"חיפוש {{$root.User.Branch}}\" class=\"demo-header-searchbox md-text\" autocomplete=\"off\"></md-select-header>\n<md-optgroup><md-option ng-repeat=\"branch in branches | filter: searchTerm\" ng-value=\"branch.ID\">{{branch.Name}}\n</md-option></md-optgroup></md-select></md-input-container></div><div layout=\"row\" layout-wrap><md-input-container \nclass=\"md-icon-float md-block\" layout=\"row\" flex=\"100\" ng-if=\"studentsGroups\"><label>{{$root.User.Group}}</label>\n<md-icon md-font-icon=\"icon-domain\"></md-icon><md-select md-on-close=\"vm.clearSearchTerm()\" ng-model=\"student.GroupID\" \nng-change=\"setGroupEducator()\" ng-disabled=\"!studentsGroups\"><md-select-header class=\"demo-select-header\"><input \nng-model=\"searchTerm2\" type=\"text\" ng-keydown=\"$event.stopPropagation()\" placeholder=\"חיפוש {{$root.User.Group}}\" \nclass=\"demo-header-searchbox md-text\" autocomplete=\"off\"></md-select-header><md-optgroup><md-option value>\nללא {{$root.User.Group}}</md-option><md-option ng-repeat=\"group in studentsGroups | filter: searchTerm2\" \nng-value=\"group.ID\">{{group.Name}}</md-option></md-optgroup></md-select></md-input-container></div><div layout=\"row\" \nlayout-wrap><md-input-container class=\"md-icon-float md-block\" layout=\"column\" layout-xs=\"row\" flex=\"100\" \nflex-xs=\"100\" flex-gt-sm=\"50\" flex-gt-md=\"50\"><md-icon md-font-icon=\"icon-domain\"></md-icon><label>מדריך</label><input \nng-model=\"educatorName\" type=\"text\" ng-disabled=\"true\"></md-input-container></div><div layout=\"row\" layout-wrap>\n<md-input-container class=\"md-icon-float md-block\" layout=\"row\" flex=\"100\" ng-if=\"grades\"><label>{{$root.User.Grade}}\n</label><md-icon md-font-icon=\"icon-domain\"></md-icon><md-select md-on-close=\"vm.clearSearchTerm()\" \nng-model=\"student.GradeID\" ng-disabled=\"!grades\"><md-select-header class=\"demo-select-header\"><input \nng-model=\"searchTerm3\" type=\"text\" ng-keydown=\"$event.stopPropagation()\" placeholder=\"חיפוש {{$root.User.Grade}}\" \nclass=\"demo-header-searchbox md-text\" autocomplete=\"off\"></md-select-header><md-optgroup><md-option value>\nללא {{$root.User.Grade}}</md-option><md-option ng-repeat=\"grade in grades | filter: searchTerm2\" ng-value=\"grade.ID\">\n{{grade.Name}}</md-option></md-optgroup></md-select></md-input-container></div></form></div></div><div \nng-show=\"$root.AdminLevel>1 && tags && tags.length\" class=\"profile-box info-box work md-whiteframe-1dp\" \nlayout=\"column\"><header class=\"md-accent-bg\"><div class=\"title\"><span>תגיות</span></div></header><div class=\"content\">\n<form name=\"UserForm\" class=\"md-inline-form\" validate><div layout=\"row\" layout-wrap><md-input-container \nclass=\"md-icon-float md-block\" layout=\"column\" layout-xs=\"row\" flex=\"100\"><md-contact-chips style=\"padding-left: 1px\" \nng-disabled=\"isClicked\" ng-model=\"student.Tags\" md-contacts=\"tagsQuerySearch($query)\" md-contact-name=\"Name\" \nmd-require-match=\"true\" md-highlight-flags=\"i\" filter-selected=\"true\" placeholder=\"חיפוש תגית\"></md-contact-chips>\n</md-input-container></div></form></div></div><div ng-if=\"extraFields\" \nclass=\"profile-box info-box work md-whiteframe-1dp\" layout=\"column\"><header class=\"md-accent-bg\"><div class=\"title\" \nstyle=\"display: flex;align-items: center;justify-content: space-between\"><span>שדות נוספים</span></div></header><div \nclass=\"content\"><form name=\"ExtraFieldsForm\" class=\"md-inline-form\" validate><div layout=\"row\" layout-wrap>\n<md-input-container ng-repeat=\"question in extraFields\" class=\"md-icon-float md-block\" layout=\"column\" layout-xs=\"row\" \nflex=\"100\"><md-icon md-font-icon=\"icon-question-mark-circle\"></md-icon><label \nng-if=\"question.Type == 1 || question.Type == 2\">{{question.Title}}</label><input ng-if=\"question.Type == 1\" \nng-model=\"question.Answer.Value\" type=\"text\"><md-select ng-if=\"question.Type == 2\" ng-model=\"question.Answer.Value\">\n<md-option ng-repeat=\"option in question.Values\" ng-value=\"option\">{{option}}</md-option></md-select><div \nng-if=\"question.Type == 3\" start-view=\"day\" locale=\"he\" format=\"DD/MM/YYYY\" moment-picker=\"question.Answer.Value\">\n<label>{{question.Title}}</label><input autocomplete=\"off\" ng-model=\"question.Answer.Value\"></div></md-input-container>\n</div></form></div></div></div></div></div>");
$templateCache.put("app/main/pages/users/views/students/student-profile/tabs/comments/comments.html","<div id=\"comments-page\" class=\"page-layout simple tabbed\"><div \nclass=\"profile-box info-box md-whiteframe-1dp commentDiv\" layout=\"column\"><header class=\"md-accent-bg\"><div \nclass=\"title\">הערות</div></header><div class=\"content\"><form name=\"UserForm\" class=\"md-inline-form\" validate><div \nlayout=\"row\" layout-wrap><md-input-container class=\"md-block\" style=\"width: 100%\"><textarea rows=\"4\" cols=\"50\" \nstyle=\"border:solid 1px rgb(224,224,224)\" ng-model=\"$root.commentText\" aria-label=\"\"></textarea></md-input-container>\n</div><div><md-button class=\"md-accent md-raised\" ng-click=\"addComment()\" ng-disabled=\"!$root.commentText\">הוספת הערה\n</md-button></div></form></div></div><div class=\"content commentsLine\"><timeline><timeline-event \nng-repeat=\"comment in Comments\" side=\"right\"><timeline-badge class=\"{{comment.badgeClass}}\"><md-icon \nmd-svg-icon=\"checkbox-marked-circle-outline\"></md-icon></timeline-badge><timeline-panel class=\"{{comment.badgeClass}}\">\n<p style=\"font-weight: bold; font-size: 18px\">{{comment.user}}</p><timeline-heading><h4 style=\"font-size: 16px\" \nng-bind-html=\"comment.content\"></h4></timeline-heading><p style=\"font-size:12px\">{{comment.date | date: \'medium\'}}</p>\n</timeline-panel></timeline-event></timeline></div></div>");
$templateCache.put("app/main/pages/users/views/students/student-profile/tabs/contact/contact.html","<div id=\"family\" ng-init=\"getContactForms()\"><div layout=\"row\" layout-sm=\"column\" layout-align=\"space-around\" \nng-show=\"!contactss\"><md-progress-circular md-mode=\"indeterminate\"></md-progress-circular></div><table \nid=\"contact-table\" class=\"dataTable row-border hover stripe md-ink-ripple\" datatable=\"ng\" dt-instance=\"dtInstance\" \ndt-options=\"dtOptions\" dt-column-defs=\"dtColumnDefs\"><thead><tr><th class=\"secondary-text\"><div class=\"table-header\">\n<span class=\"column-title\">תאריך</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">שם הורה</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">מייל הורה</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">טלפון נייד הורה</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">סטטוס פניה</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">פעולות</span></div></th></tr></thead><tbody><tr class=\"entry-code-item\" \nng-repeat=\"contactForm in  contactss | orderBy:ID\"><td>{{contactForm.CreateTime | cmdate:\'HH:mm:ss dd/MM/yyyy \'}}</td>\n<td><a href=\"/parent-profile?ID={{contactForm.ParentID}}\" style=\"cursor: pointer\">{{contactForm.ParentName}}</a></td>\n<td><a href=\"mailto:{{contactForm.ParentEmail}}\">{{contactForm.ParentEmail}}</a></td><td>{{contactForm.ParentPhone}}\n</td><td>{{contactForm.Status}}</td><td><md-button class=\"preview-user\" ng-click=\"openContactDialog(contactForm)\" \ntitle=\"פרטי בקשה\"><md-icon md-svg-icon=\"eye\"></md-icon></md-button></td></tr></tbody></table></div>");
$templateCache.put("app/main/pages/users/views/students/student-profile/tabs/educator-groups/educator-groups.html","<div layout=\"row\" layout-wrap ng-controller=\"EducatorGroupsController as vm\"><div class=\"general\" layout=\"column\" \nflex=\"100\" flex-gt-sm=\"80\" flex-gt-md=\"70\" flex-gt-lg=\"60\"><div class=\"profile-box info-box md-whiteframe-1dp\" \nlayout=\"column\"><md-toolbar class=\"md-accent-bg md-menu-toolbar\"><div class=\"md-toolbar-tools\"><div class=\"title\">מדריך\n</div><md-button class=\"md-icon-button\" title=\"הוספת {{$root.User.Group}}\" ng-click=\"vm.addNewGroup()\"><md-icon \nmd-font-icon=\"icon-plus\"></md-icon></md-button><md-button class=\"preview-user\" ng-if=\"vm.showResend\" \nng-click=\"vm.openNewEducatorDialog()\">שליחת הזמנה למערכת</md-button></div></md-toolbar><div class=\"content\"><div \nlayout=\"row\" layout-sm=\"column\" layout-align=\"space-around\" ng-show=\"!vm.educatorGroups\"><md-progress-circular \nmd-mode=\"indeterminate\"></md-progress-circular></div><div ng-if=\"vm.educatorGroups\"><table id=\"educatorGroupsTable\" \nclass=\"dataTable row-border hover stripe md-ink-ripple\"><thead><tr><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">{{$root.User.Branch}}</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">{{$root.User.Group}}</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">{{$root.User.Grade}}</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">סטטוס</span></div></th></tr></thead><tbody><tr class=\"main-table-new\" \nng-repeat=\"group in vm.educatorGroups\"><td>{{group.BranchName}}</td><td>{{group.GroupName}}</td><td>{{group.GradeName}}\n</td><td><md-input-container><label>סטטוס</label><md-select ng-model=\"group.Status\" ng-change=\"vm.updateStatus(group)\">\n<md-option value=\"1\" ng-selected=\"group.Status==1\">פעיל</md-option><md-option value=\"0\" ng-selected=\"group.Status==0\">\nלא פעיל</md-option></md-select></md-input-container></td></tr></tbody></table></div></div></div></div></div>");
$templateCache.put("app/main/pages/users/views/students/student-profile/tabs/family/family.html","<div id=\"family\" ng-init=\"getFamily()\"><div layout=\"row\" layout-sm=\"column\" layout-align=\"space-around\" \nng-show=\"!family\"><md-progress-circular md-mode=\"indeterminate\"></md-progress-circular></div><div \nstyle=\"padding-top: 65px\"><table class=\"dataTable row-border hover\" datatable=\"ng\" dt-instance=\"dtInstance\" \ndt-options=\"dtOptions\" ng-show=\"family\"><thead><tr><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">סוג קרבה</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">שם</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">תעודת זהות</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">דואר אלקטרני</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">מספר טלפון</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">סטטוס</span></div></th><th class=\"secondary-text\" ng-if=\"$root.AdminLevel>1\"><div \nclass=\"table-header\"><span class=\"column-title\">פעולות</span></div></th></tr></thead><tbody><tr \nng-repeat=\"familyMember in family\"><td><span ng-if=\"familyMember.BranchID && familyMember.Gender==\'Female\'\">אחות</span>\n <span ng-if=\"familyMember.BranchID && familyMember.Gender==\'Male\'\">אח</span> <span \nng-if=\"familyMember.BranchID && familyMember.Gender==\'Other\'\">אח</span> <span \nng-if=\"familyMember.BranchID && familyMember.Gender==\'\'\">אח/אחות</span> <span ng-if=\"!familyMember.BranchID\">הורה\n</span></td><td>{{familyMember.FirstName}} {{familyMember.LastName}}</td><td>{{familyMember.PrivateID}}</td><td>\n{{familyMember.Email}}</td><td>{{familyMember.PhoneNumber ? familyMember.PhoneNumber : familyMember.MobileNumber}}</td>\n<td>{{familyMember.Status ? \'פעיל\' : \'לא פעיל\'}}</td><td ng-if=\"$root.AdminLevel>1\"><span \nng-if=\"familyMember.BranchID\"><md-button ng-disabled=\"$root.AdminLevel<2\" class=\"preview-user\" \nhref=\"/student-profile?ID={{familyMember.ID}}\" target=\"_blank\" title=\"מעבר לפרופיל\"><md-icon md-svg-icon=\"account\">\n</md-icon></md-button></span><span ng-if=\"!familyMember.BranchID\"><md-button ng-disabled=\"$root.AdminLevel<2\" \nclass=\"preview-user\" href=\"/parent-profile?ID={{familyMember.ID}}\" target=\"_blank\" title=\"מעבר לפרופיל\"><md-icon \nmd-svg-icon=\"account\"></md-icon></md-button></span><span ng-if=\"familyMember.BranchID\"><md-button \nng-disabled=\"$root.AdminLevel<3\" class=\"preview-user\" ng-click=\"editStudent(familyMember)\" title=\"ערוך\"><md-icon \nmd-svg-icon=\"account-edit\"></md-icon></md-button></span><span ng-if=\"!familyMember.BranchID\"><md-button \nclass=\"preview-user\" ng-click=\"editParent(familyMember)\" title=\"ערוך\"><md-icon md-svg-icon=\"account-edit\"></md-icon>\n</md-button></span><span ng-if=\"!familyMember.BranchID\"><md-button ng-disabled=\"$root.AdminLevel<3\" \nclass=\"preview-user\" ng-click=\"deleteParentDialog(familyMember)\" title=\"מחק שיוך\"><md-icon md-svg-icon=\"delete\">\n</md-icon></md-button></span></td></tr></tbody></table></div><md-button class=\"md-fab md-accent md-icon-button\" \nid=\"add-newFamilyMember-button\" ng-click=\"openNewParentDialog()\" ng-show=\"$root.AdminLevel>1\" \naria-label=\"add systemUser\" ng-disabled=\"!family\"><md-icon md-font-icon=\"icon-plus\"></md-icon></md-button></div>");
$templateCache.put("app/main/pages/users/views/students/student-profile/tabs/history/history.html","<div id=\"history_log\" ng-init=\"getHistory()\"><div layout=\"row\" layout-wrap \nng-if=\"history.Status && history.Status.length\"><div class=\"general\" layout=\"column\" flex=\"100\" flex-gt-sm=\"80\" \nflex-gt-md=\"70\" flex-gt-lg=\"50\"><div class=\"profile-box info-box md-whiteframe-1dp\" layout=\"column\"><header \nclass=\"md-accent-bg\"><div class=\"title\">סטטוס</div></header><div class=\"content\"><form name=\"UserForm\" \nclass=\"md-inline-form\" validate><div layout=\"row\" layout-wrap><table><thead><tr><th>תאריך</th><th>ערך ישן</th><th>\nערך חדש</th></tr></thead><tbody><tr ng-repeat=\"status in history.Status\"><td>\n{{status.Timestamp * 1000 | date:\'HH:mm:ss dd/MM/yyyy\'}}</td><td>{{status.OldVal == \'0\' ? \'לא פעיל\' : \'פעיל\'}}</td><td>\n{{status.NewVal == \'0\' ? \'לא פעיל\' : \'פעיל\'}}</td></tr></tbody></table></div></form></div></div></div></div><div \nlayout=\"row\" layout-wrap ng-if=\"history.GradeID && history.GradeID.length\"><div class=\"general\" layout=\"column\" \nflex=\"100\" flex-gt-sm=\"80\" flex-gt-md=\"70\" flex-gt-lg=\"50\"><div class=\"profile-box info-box md-whiteframe-1dp\" \nlayout=\"column\"><header class=\"md-accent-bg\"><div class=\"title\">שכבה</div></header><div class=\"content\"><form \nname=\"UserForm\" class=\"md-inline-form\" validate><div layout=\"row\" layout-wrap><table><thead><tr><th>תאריך</th><th>\nערך ישן</th><th>ערך חדש</th></tr></thead><tbody><tr ng-repeat=\"grade in history.GradeID\"><td>\n{{grade.Timestamp * 1000 | date:\'HH:mm:ss dd/MM/yyyy\'}}</td><td>{{grade.OldVal}}</td><td>{{grade.NewVal }}</td></tr>\n</tbody></table></div></form></div></div></div></div><div layout=\"row\" layout-wrap \nng-if=\"history.GroupID && history.GroupID.length\"><div class=\"general\" layout=\"column\" flex=\"100\" flex-gt-sm=\"80\" \nflex-gt-md=\"70\" flex-gt-lg=\"50\"><div class=\"profile-box info-box md-whiteframe-1dp\" layout=\"column\"><header \nclass=\"md-accent-bg\"><div class=\"title\">קבוצה</div></header><div class=\"content\"><form name=\"UserForm\" \nclass=\"md-inline-form\" validate><div layout=\"row\" layout-wrap><table><thead><tr><th>תאריך</th><th>ערך ישן</th><th>\nערך חדש</th></tr></thead><tbody><tr ng-repeat=\"group in history.GroupID\"><td>\n{{group.Timestamp * 1000 | date:\'HH:mm:ss dd/MM/yyyy\'}}</td><td>{{group.OldVal}}</td><td>{{group.NewVal }}</td></tr>\n</tbody></table></div></form></div></div></div></div><div layout=\"row\" layout-wrap \nng-if=\"history.BranchID && history.BranchID.length\"><div class=\"general\" layout=\"column\" flex=\"100\" flex-gt-sm=\"80\" \nflex-gt-md=\"70\" flex-gt-lg=\"50\"><div class=\"profile-box info-box md-whiteframe-1dp\" layout=\"column\"><header \nclass=\"md-accent-bg\"><div class=\"title\">סניף</div></header><div class=\"content\"><form name=\"UserForm\" \nclass=\"md-inline-form\" validate><div layout=\"row\" layout-wrap><table><thead><tr><th>תאריך</th><th>ערך ישן</th><th>\nערך חדש</th></tr></thead><tbody><tr ng-repeat=\"branch in history.BranchID\"><td>\n{{branch.Timestamp * 1000 | date:\'HH:mm:ss dd/MM/yyyy\'}}</td><td>{{branch.OldVal}}</td><td>{{branch.NewVal }}</td></tr>\n</tbody></table></div></form></div></div></div></div></div>");
$templateCache.put("app/main/pages/users/views/students/student-profile/tabs/registrations/registrations.html","<div id=\"registrations\" ng-init=\"getRegistrations()\"><div layout=\"row\" layout-sm=\"column\" layout-align=\"space-around\" \nng-show=\"!registrations\"><md-progress-circular md-mode=\"indeterminate\"></md-progress-circular></div><div \nclass=\"registrations-table-c\"><table id=\"registrations-table\" class=\"dataTable row-border hover\" datatable=\"ng\" \ndt-instance=\"dtInstance\" dt-column-defs=\"dtColumnDefs\" dt-options=\"dtOptions\" ng-show=\"registrations\"><thead><tr><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">מספר הרשמה</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">תאריך הרשמה</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">שם {{$root.User.Event}}</span></div></th>\n<th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">מחיר</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">מחיר לתשלום</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">סטטוס הזמנה</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">סטטוס תשלום</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">מספר קבלה</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">מספר זיכוי</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">אופן תשלום</span></div></th><th \nclass=\"secondary-text\" ng-if=\"$root.AdminLevel==3 || ($root.AdminLevel==2 && $root.User.RegistrationsPer)\"><div \nclass=\"table-header\"><span class=\"column-title\">פעולות</span></div></th></tr></thead><tbody><tr \nng-repeat=\"registration in registrations | orderBy : \'registration.ID\' \"><td>{{registration.ID}}</td><td>\n{{registration.RegistrationTime | cmdate:\'HH:mm:ss dd/MM/yyyy \'}}</td><td>{{registration.Name}} <span \nng-if=\"registration.CartEventName\">({{registration.CartEventName}})</span></td><td>{{registration.Price}}</td><td>\n{{registration.FinalPrice}}</td><td>{{registration.Status==\'1\' ? \'פעיל\' : \'לא פעיל\'}}</td><td>\n{{registration.PaymentStatus | paymentStatus}}</td><td><div class=\"sflex fdc hfs12\" \nng-if=\"registration.ReceiptID.length\"><a ng-repeat=\"receiptID in registration.ReceiptID\" \nng-if=\"!receiptID.includes(\'יה\')\" href=\"#\" ng-click=\"downloadReceipt(receiptID,1)\">{{receiptID}}</a> <span \nng-repeat=\"receiptID in registration.ReceiptID\" ng-if=\"receiptID.includes(\'יה\')\">{{receiptID}}</span></div></td><td>\n<div class=\"sflex fdc hfs12\" ng-if=\"registration.RefundReceiptID.length\"><a \nng-repeat=\"refundReceiptID in registration.RefundReceiptID\" ng-if=\"refundReceiptID > 0\" href=\"#\" \nng-click=\"downloadReceipt(refundReceiptID,2)\">{{refundReceiptID}}</a> <span \nng-repeat=\"refundReceiptID in registration.RefundReceiptID\" ng-if=\"refundReceiptID.includes(\'-\')\">{{refundReceiptID}}\n</span></div></td><td>{{getPaymentType(registration)}}</td><td \nng-if=\"$root.AdminLevel==3 || ($root.AdminLevel==2 && $root.User.RegistrationsPer)\"><md-button \nng-disabled=\"$root.User.SuperAdmin!=1 || registration.Canceled>0\" class=\"preview-user cancel\" \nng-click=\"cancelRegistration(registration)\" title=\"{{!registration.Canceled>0 ? \'ביטול הרשמה\' : \'הרשמה מבוטלת\'}}\">\n<md-icon ng-class=\"{\'canceled\': registration.Canceled>0}\" md-svg-icon=\"delete\"></md-icon></md-button><md-button \nng-disabled=\"$root.User.SuperAdmin!=1 || !registration.PaymentStatus\" class=\"preview-user refund\" \nng-click=\"refundRegistration(registration)\" \ntitle=\"{{!registration.RefundReceiptID.length ? \'זיכוי הרשמה\' : \'קיים זיכויי להרשמה\'}}\"><md-icon \nng-class=\"{\'refunded\': registration.RefundReceiptID.length}\" md-svg-icon=\"credit-card\"></md-icon></md-button><md-button\n class=\"preview-user view\" ng-click=\"showFullRegistration(registration)\" title=\"צפייה בפרטי הזמנה\"><md-icon \nmd-svg-icon=\"eye\"></md-icon></md-button></td></tr></tbody></table></div></div>");
$templateCache.put("app/main/pages/events/views/events/event-management/tabs/association/add-new-association-dialog/add-new-association-dialog.html","<md-dialog class=\"newEventAssociation-dialog\" aria-label=\"New Task\"><form name=\"newEventAssociationForm\" \ndata-ng-model=\"newEventAssociationForm\" class=\"md-inline-form\" validate><md-toolbar class=\"md-accent\" layout=\"column\">\n<div class=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"title\">הוספת שיוך</span><md-button class=\"md-icon-button\" ng-click=\"closeDialog()\" aria-label=\"Close dialog\" \ntitle=\"הוספת שיוך\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content \nms-scroll><div><md-input-container class=\"md-block\" ng-if=\"type == 1\"><md-select ng-model=\"newAssociation.Areas\" \nmultiple=\"multiple\"><md-select-header class=\"demo-select-header\" placeholder=\"חיפוש איזורים\"><input \nng-model=\"searchTerm\" type=\"text\" ng-keydown=\"$event.stopPropagation()\" placeholder=\"חיפוש איזורים\" \nclass=\"demo-header-searchbox md-text\" autocomplete=\"off\"></md-select-header><md-optgroup><md-option \nng-repeat=\"area in areas | orderBy:\'Name\' | filter:searchTerm\" ng-value=\"area.ID\">{{area.Name}}</md-option>\n</md-optgroup></md-select></md-input-container><md-input-container class=\"md-block\" ng-if=\"type == 2\"><md-select \nng-model=\"newAssociation.Branches\" multiple=\"multiple\"><md-select-header class=\"demo-select-header\" \nplaceholder=\"חיפוש {{$root.User.Branches}}\"><input ng-model=\"searchTerm\" type=\"text\" \nng-keydown=\"$event.stopPropagation()\" placeholder=\"חיפוש {{$root.User.Branches}}\" \nclass=\"demo-header-searchbox md-text\" autocomplete=\"off\"></md-select-header><md-optgroup><md-option \nng-repeat=\"branch in branches | orderBy:\'Name\' | filter:searchTerm\" ng-value=\"branch.ID\">{{branch.Name}}</md-option>\n</md-optgroup></md-select></md-input-container><md-input-container class=\"md-block\" ng-if=\"type == 3\"><md-select \nng-model=\"newAssociation.Grades\" multiple=\"multiple\"><md-select-header class=\"demo-select-header\" \nplaceholder=\"חיפוש {{$root.User.Grades}}\"><input ng-model=\"searchTerm\" type=\"text\" \nng-keydown=\"$event.stopPropagation()\" placeholder=\"חיפוש {{$root.User.Grades}}\" class=\"demo-header-searchbox md-text\" \nautocomplete=\"off\"></md-select-header><md-optgroup><md-option \nng-repeat=\"grade in grades | orderBy:\'Name\' | filter:searchTerm\" ng-value=\"grade.ID\">{{grade.Name}}</md-option>\n</md-optgroup></md-select></md-input-container></div></md-dialog-content><md-dialog-actions layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-button \ndata-ng-disabled=\"newEventAssociationForm.$invalid || isClicked\" type=\"submit\" ng-click=\"saveNewAssociation()\" \nclass=\"send-button md-accent md-raised\" aria-label=\"Add Task\">שמירה</md-button></div></md-dialog-actions></form>\n</md-dialog>");
$templateCache.put("app/main/pages/events/views/events/event-management/tabs/association/new-student-association-dialog/new-student-association-dialog.html","<md-dialog class=\"newStudentAssociation-dialog\" aria-label=\"New Task\"><form name=\"newStudentAssociationForm\" \ndata-ng-model=\"newStudentAssociationForm\" class=\"md-inline-form\" validate><md-toolbar class=\"md-accent\" \nlayout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\">\n<span class=\"title\">הוספת שיוך לחניך</span><md-button class=\"md-icon-button\" ng-click=\"closeDialog()\" \naria-label=\"Close dialog\" title=\"הוספת הנחה\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content ms-scroll><div><md-input-container class=\"md-block\" ng-if=\"!withFile\"><label>ת.ז החניך\n</label><input type=\"text\" ng-model=\"newStudentAssociation.StudentID\" ng-required=\"true\" ng-disabled=\"isClicked\">\n</md-input-container></div></md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><div\n layout=\"row\" layout-align=\"start center\"><md-button \ndata-ng-disabled=\"newStudentAssociationForm.$invalid || isClicked\" type=\"submit\" \nng-click=\"saveNewStudentAssociation()\" class=\"send-button md-accent md-raised\" aria-label=\"Add Task\">שמירה</md-button>\n</div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/pages/events/views/events/event-management/tabs/cart-events/new-cart-event-dialog/new-cart-event-dialog.html","<md-dialog class=\"newCartEvent-dialog\" aria-label=\"New Task\"><form name=\"newCartEventForm\" \ndata-ng-model=\"newCartEventForm\" class=\"md-inline-form\" validate><md-toolbar class=\"md-accent\" layout=\"column\"><div \nclass=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">\nהוספת {{$root.User.Event}} לסל</span><md-button class=\"md-icon-button\" ng-click=\"closeDialog()\" \naria-label=\"Close dialog\" title=\"הוספת {{$root.User.Event}}\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button>\n</div></md-toolbar><md-dialog-content style=\"overflow: visible !important\"><md-input-container \nclass=\"md-icon-float md-block\"><label>בחר {{$root.User.Event}}</label><md-icon md-svg-icon=\"crown\"></md-icon><md-select\n md-on-close=\"clearSearchTerm()\" ng-model=\"newCartEvent.EventID\" ng-disabled=\"isClicked\"><md-select-header \nclass=\"demo-select-header\"><input ng-model=\"searchTerm\" type=\"text\" ng-disabled=\"!events || isClicked\" \nng-keydown=\"$event.stopPropagation()\" placeholder=\"חפש {{$root.User.Event}}..\" class=\"demo-header-searchbox md-text\" \nautocomplete=\"off\"></md-select-header><md-optgroup ng-disabled=\"isClicked\"><md-option ng-value=\"event.ID\" \nng-repeat=\"event in events |filter:searchTerm\">{{event.Name}}</md-option></md-optgroup></md-select>\n</md-input-container></md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><div \nlayout=\"row\" layout-align=\"start center\"><md-button data-ng-disabled=\"newCartEventForm.$invalid || isClicked\" \ntype=\"submit\" ng-click=\"saveNewStudentAssociation()\" class=\"send-button md-accent md-raised\" aria-label=\"Add Task\">\nהוספה</md-button></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/pages/events/views/events/event-management/tabs/discounts/tabs/brothers-discounts.html","<div layout=\"row\" layout-wrap><div class=\"general\" layout=\"column\" flex=\"100\" flex-gt-sm=\"80\" flex-gt-md=\"70\" \nflex-gt-lg=\"60\"><div class=\"profile-box info-box md-whiteframe-1dp\" layout=\"column\"><md-toolbar \nclass=\"md-accent-bg md-menu-toolbar\"><div class=\"md-toolbar-tools\"><div class=\"title\">הנחת אחים</div><md-button \nclass=\"md-icon-button\" title=\"הוספת הנחת אחים\" ng-click=\"addNewBrotherDiscount()\"><md-icon md-font-icon=\"icon-plus\">\n</md-icon></md-button></div></md-toolbar><div class=\"content\"><div layout=\"row\" layout-sm=\"column\" \nlayout-align=\"space-around\" ng-show=\"!BrotherDiscount || $root.discountsLoading\"><md-progress-circular \nmd-mode=\"indeterminate\"></md-progress-circular></div><table \nng-if=\"BrotherDiscount.length>0 && !$root.discountsLoading\" class=\"dataTable row-border hover stripe md-ink-ripple\">\n<thead><tr><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">מספר אח</span></div></th><th\n class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">סכום/אחוזים</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">רמת הנחה</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">סוג</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">סטטוס</span></div></th></tr></thead><tbody>\n<tr class=\"main-table-new\" ng-repeat=\"brother in BrotherDiscount | orderBy: \'BrotherNumber\'  track by $index\"><td>\n{{brother.BrotherNumber}}</td><td><md-input-container><label>הכנס/י מספר</label><input type=\"text\" \nng-model=\"brother.Discount\" ng-pattern=\"/^\\d+$/\"></md-input-container></td><td><md-input-container><label>רמה</label>\n<md-select ng-model=\"brother.Level\"><md-option value=\"1\" ng-selected=\"brother.Level==1\">בודדת</md-option><md-option \nvalue=\"2\" ng-selected=\"brother.Level==2\">מרובה</md-option></md-select></md-input-container></td><td>\n<md-input-container><label>סוג</label><md-select ng-model=\"brother.Type\"><md-option value=\"1\" \nng-selected=\"brother.Type==1\">ש\"ח</md-option><md-option value=\"2\" ng-selected=\"brother.Type==2\">אחוזים</md-option>\n</md-select></md-input-container></td><td><md-input-container><label>סטטוס</label><md-select ng-model=\"brother.Status\">\n<md-option value=\"1\" ng-selected=\"brother.Status==1\">פעיל</md-option><md-option value=\"0\" \nng-selected=\"brother.Status==0\">לא פעיל</md-option></md-select></md-input-container></td></tr></tbody></table></div>\n</div></div></div>");
$templateCache.put("app/main/pages/events/views/events/event-management/tabs/discounts/tabs/date-discounts.html","<div layout=\"row\" layout-wrap><div class=\"general\" layout=\"column\" flex=\"100\" flex-gt-sm=\"80\" flex-gt-md=\"70\" \nflex-gt-lg=\"60\"><div class=\"profile-box info-box md-whiteframe-1dp\" layout=\"column\"><md-toolbar \nclass=\"md-accent-bg md-menu-toolbar\"><div class=\"md-toolbar-tools inrowf\"><div class=\"title\">הנחות לפי תאריכים<md-icon \nmd-font-icon=\"icon-information\" title=\"במקרה של התנגשות, תופעל ההנחה הגדולה יותר\"></md-icon></div><div \nclass=\"inrowf aic\"><md-input-container class=\"md-icon-float md-block\"><md-select ng-model=\"filters\" \nng-change=\"filterGeneral()\" placeholder=\"סינון לפי סטטוס\"><md-option ng-value=\"undefined\">הצג הכל</md-option><md-option\n ng-value=\"1\">פעילים</md-option><md-option ng-value=\"0\">לא פעילים</md-option></md-select></md-input-container>\n<md-button class=\"md-icon-button\" aria-label=\"הוסף הנחה\" title=\"הוספת הנחת לפי תאריך\" \nng-click=\"createNewDateDiscount()\"><md-icon md-font-icon=\"icon-plus\"></md-icon></md-button></div></div></md-toolbar>\n</div><div class=\"content\"><div layout=\"row\" layout-sm=\"column\" layout-align=\"space-around\" \nng-show=\"!DatesDiscounts || $root.discountsLoading\"><md-progress-circular md-mode=\"indeterminate\">\n</md-progress-circular></div><table ng-if=\"DatesDiscounts.length>0 && !$root.discountsLoading\" \nclass=\"dataTable row-border hover stripe md-ink-ripple\"><thead><tr><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">מתאריך</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">עד תאריך</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">סכום</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">רמה</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">סוג</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">הערות</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">סטטוס</span></div></th></tr></thead><tbody><tr class=\"main-table-new\" \nng-repeat=\"discount in DatesDiscounts | filter: {Status: filters}\"><td><md-input-container><div start-view=\"day\" \nlocale=\"he\" format=\"DD/MM/YYYY\" moment-picker=\"discount.FromDate\"><input class=\"md-input\" autocomplete=\"off\" \nng-model=\"discount.FromDate\" required ng-disabled=\"isClicked\"></div></md-input-container></td><td><md-input-container>\n<div start-view=\"day\" locale=\"he\" format=\"DD/MM/YYYY\" moment-picker=\"discount.ToDate\"><input class=\"md-input\" \nautocomplete=\"off\" ng-model=\"discount.ToDate\" required ng-disabled=\"isClicked\"></div></md-input-container></td><td>\n<md-input-container><label>הכנס/י מספר</label><input type=\"text\" ng-model=\"discount.Discount\" ng-pattern=\"/^\\d+$/\" \nplaceholder=\"יש להכניס מספר שלם\"></md-input-container></td><td><md-input-container><label>רמה</label><md-select \nng-model=\"discount.Level\"><md-option value=\"1\" ng-selected=\"discount.Level==1\">בודדת</md-option><md-option value=\"2\" \nng-selected=\"discount.Level==2\">מרובה</md-option></md-select></md-input-container></td><td><md-input-container><label>\nסוג</label><md-select ng-model=\"discount.Type\"><md-option value=\"1\" ng-selected=\"discount.Type==1\">ש\"ח</md-option>\n<md-option value=\"2\" ng-selected=\"discount.Type==2\">אחוזים</md-option></md-select></md-input-container></td><td>\n<md-input-container><label>הערות</label><input ng-model=\"discount.Comments\"></md-input-container></td><td>\n<md-input-container><label>סטטוס</label><md-select ng-model=\"discount.Status\"><md-option value=\"1\" \nng-selected=\"discount.Status==1\">פעיל</md-option><md-option value=\"0\" ng-selected=\"discount.Status==0\">לא פעיל\n</md-option></md-select></md-input-container></td></tr></tbody></table></div></div></div>");
$templateCache.put("app/main/pages/events/views/events/event-management/tabs/discounts/tabs/discount-levels.html","<div layout=\"row\" layout-wrap><div class=\"general\" layout=\"column\" flex=\"100\" flex-gt-sm=\"80\" flex-gt-md=\"70\" \nflex-gt-lg=\"60\"><div class=\"profile-box info-box md-whiteframe-1dp\" layout=\"column\"><md-toolbar \nclass=\"md-accent-bg md-menu-toolbar\"><div class=\"md-toolbar-tools\"><div class=\"title\">דרגות הנחה</div></div>\n</md-toolbar><div class=\"content\"><div layout=\"row\" layout-sm=\"column\" layout-align=\"space-around\" \nng-show=\"!FamilyLevelDiscount || $root.discountsLoading\"><md-progress-circular md-mode=\"indeterminate\">\n</md-progress-circular></div><table ng-show=\"FamilyLevelDiscount && !$root.discountsLoading\" \nclass=\"dataTable row-border hover stripe md-ink-ripple\"><thead><tr><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">דרגה</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">סכום/אחוזים</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">רמת הנחה</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">סוג</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">סטטוס</span></div></th></tr></thead><tbody><tr class=\"main-table-new\" \nng-repeat=\"level in FamilyLevelDiscount | orderBy: DiscountLevel  track by $index\"><td>{{level.DiscountLevel}}</td><td>\n<md-input-container><label>הכנס/י מספר</label><input type=\"text\" ng-model=\"level.Discount\" ng-pattern=\"/^\\d+$/\" \nplaceholder=\"יש להכניס מספר שלם\"></md-input-container></td><td><md-input-container><label>רמה</label><md-select \nng-model=\"level.Level\"><md-option value=\"1\" ng-selected=\"level.Level==1\">בודדת</md-option><md-option value=\"2\" \nng-selected=\"level.Level==2\">מרובה</md-option></md-select></md-input-container></td><td><md-input-container><label>סוג\n</label><md-select ng-model=\"level.Type\"><md-option value=\"1\" ng-selected=\"level.Type==1\">ש\"ח</md-option><md-option \nvalue=\"2\" ng-selected=\"level.Type==2\">אחוזים</md-option></md-select></md-input-container></td><td><md-input-container>\n<label>סטטוס</label><md-select ng-model=\"level.Status\"><md-option value=\"1\" ng-selected=\"level.Status==1\">פעיל\n</md-option><md-option value=\"0\" ng-selected=\"level.Status==0\">לא פעיל</md-option></md-select></md-input-container>\n</td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/main/pages/events/views/events/event-management/tabs/discounts/tabs/general-discounts.html","<div class=\"profile-box info-box md-whiteframe-1dp\" layout=\"column\"><md-toolbar class=\"md-accent-bg md-menu-toolbar\">\n<div class=\"md-toolbar-tools inrowf\"><div class=\"title\">הנחות כלליות</div><div class=\"inrowf aic\"><md-input-container \nclass=\"md-icon-float md-block\"><md-select ng-model=\"filterg\" ng-change=\"filterGeneral()\" placeholder=\"סינון לפי סטטוס\">\n<md-option ng-value=\"undefined\">הצג הכל</md-option><md-option ng-value=\"1\">פעילים</md-option><md-option ng-value=\"0\">\nלא פעילים</md-option></md-select></md-input-container><md-button class=\"md-icon-button\" title=\"הוספת הנחה\" \nng-click=\"createNewGeneralDiscount()\"><md-icon md-font-icon=\"icon-plus\"></md-icon></md-button></div></div></md-toolbar>\n<div class=\"content\"><div layout=\"row\" layout-sm=\"column\" layout-align=\"space-around\" \nng-show=\"!GeneralDiscount || $root.discountsLoading\"><md-progress-circular md-mode=\"indeterminate\">\n</md-progress-circular></div><table ng-show=\"GeneralDiscount && !$root.discountsLoading\" \nclass=\"dataTable row-border hover stripe md-ink-ripple\"><thead><tr><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">רמה</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">תגיות</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">{{$root.User.Branches}}</span></div></th><th class=\"secondary-text\">\n<div class=\"table-header\"><span class=\"column-title\">{{$root.User.Event}}</span></div></th><th class=\"secondary-text\">\n<div class=\"table-header\"><span class=\"column-title\">אזור</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">{{$root.User.Grades}}</span></div></th><th class=\"secondary-text\" \nng-if=\"$root.ExternalDiscountEnabled\"><div class=\"table-header\"><span class=\"column-title\">חברות חיצוני</span></div>\n</th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">סכום</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">סוג</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">פעולות</span></div></th></tr></thead>\n<tbody><tr class=\"main-table-new\" \nng-repeat=\"(discountKey,discountValue) in GeneralDiscount | filter:{Status : filterg}\"><td>\n{{discountValue.Level==1 || discountValue.Level==\'1\' ? \'בודדת\' : \'מרובה\'}}</td><td><span \nng-repeat=\"tag in discountValue.Tags\">{{tag}}{{$last ? \'\' : \', \'}}</span></td><td><span \nng-repeat=\"branch in discountValue.Branches | filter: {\'Active\':\'1\'}\">{{branch.Name}}{{$last ? \'\' : \', \'}}</span></td>\n<td><span ng-repeat=\"event in discountValue.Events | filter: {\'Active\':\'1\'}\">{{event.Name}}{{$last ? \'\' : \', \'}}</span>\n</td><td><span ng-repeat=\"area in discountValue.Areas | filter: {\'Active\':\'1\'}\">{{area.Name}}{{$last ? \'\' : \', \'}}\n</span></td><td><span ng-repeat=\"grade in discountValue.Grades | filter: {\'Active\':\'1\'}\">\n{{grade.Name}}{{$last ? \'\' : \', \'}}</span></td><td ng-if=\"$root.ExternalDiscountEnabled\">\n{{discountValue.ExternalDiscount == 1? \'כן\' : \'לא\'}}</td><td>{{discountValue.Discount}}</td><td>\n{{discountValue.Type==2|| discountValue.Type==\'2\' ? \'אחוזים\' : \'ש\"ח\'}}</td><td><md-button class=\"preview-user\" \nng-click=\"editGeneralDiscount(discountValue)\"><md-icon md-font-icon=\"icon-magnify\"></md-icon></md-button><md-button \naria-label=\"Use Android\" title=\"הפוך לפעיל\\לא פעיל\" ng-disabled=\"isClicked\"><md-icon md-font-icon=\"icon-power\" \nng-class=\"{\'green600\':discountValue.Status==1, \'red600\':discountValue.Status==0}\" \nng-click=\"changeStatus(discountValue,discountKey)\"></md-icon></md-button></td></tr></tbody></table></div></div>");
$templateCache.put("app/main/pages/events/views/events/event-management/tabs/discounts/tabs/student-discounts.html","<div layout=\"row\" layout-wrap><div class=\"general\" layout=\"column\" flex=\"100\" flex-gt-sm=\"80\" flex-gt-md=\"70\" \nflex-gt-lg=\"60\"><div class=\"profile-box info-box md-whiteframe-1dp\" layout=\"column\"><md-toolbar \nclass=\"md-accent-bg md-menu-toolbar\"><div class=\"md-toolbar-tools inrowf\"><div class=\"title\">הנחות חניכים</div><div \nclass=\"inrowf aic\"><md-input-container class=\"md-icon-float md-block\"><md-select ng-model=\"filters\" \nng-change=\"filterGeneral()\" placeholder=\"סינון לפי סטטוס\"><md-option ng-value=\"undefined\">הצג הכל</md-option><md-option\n ng-value=\"1\">פעילים</md-option><md-option ng-value=\"0\">לא פעילים</md-option></md-select></md-input-container>\n<md-button class=\"md-icon-button\" aria-label=\"הוסף הנחה\" title=\"הוספת הנחת חניך\" ng-click=\"createNewStudentDiscount()\">\n<md-icon md-font-icon=\"icon-plus\"></md-icon></md-button><md-button class=\"md-icon-button\" aria-label=\"הוסף הנחה\" \ntitle=\"טעינת אקסל הנחות חניך\" ng-click=\"uploadExcelFile()\"><md-icon md-svg-icon=\"file-excel\"></md-icon></md-button>\n</div></div></md-toolbar></div><div class=\"content\"><div layout=\"row\" layout-sm=\"column\" layout-align=\"space-around\" \nng-show=\"!StudentDiscount || $root.discountsLoading\"><md-progress-circular md-mode=\"indeterminate\">\n</md-progress-circular></div><table ng-if=\"StudentDiscount.length>0 && !$root.discountsLoading\" \nclass=\"dataTable row-border hover stripe md-ink-ripple\"><thead><tr><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">שם חניך</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">ת.ז.</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">סכום</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">רמה</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">סוג</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">הערות</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">סטטוס</span></div></th></tr></thead><tbody><tr class=\"main-table-new\" \nng-repeat=\"discount in StudentDiscount | filter: {Status: filters}\" ng-class=\"{green: discount.Used}\"><td>\n{{discount.FirstName+\' \'+discount.LastName}}</td><td>{{discount.PrivateID}}</td><td><md-input-container><label>\nהכנס/י מספר</label><input type=\"text\" ng-model=\"discount.Discount\" ng-pattern=\"/^\\d+$/\" \nplaceholder=\"יש להכניס מספר שלם\"></md-input-container></td><td><md-input-container><label>רמה</label><md-select \nng-model=\"discount.Level\"><md-option value=\"1\" ng-selected=\"discount.Level==1\">בודדת</md-option><md-option value=\"2\" \nng-selected=\"discount.Level==2\">מרובה</md-option></md-select></md-input-container></td><td><md-input-container><label>\nסוג</label><md-select ng-model=\"discount.Type\"><md-option value=\"1\" ng-selected=\"discount.Type==1\">ש\"ח</md-option>\n<md-option value=\"2\" ng-selected=\"discount.Type==2\">אחוזים</md-option></md-select></md-input-container></td><td>\n<md-input-container><label>הערות</label><input ng-model=\"discount.Comments\"></md-input-container></td><td>\n<md-input-container><label>סטטוס</label><md-select ng-model=\"discount.Status\"><md-option value=\"1\">פעיל</md-option>\n<md-option value=\"0\">לא פעיל</md-option></md-select></md-input-container></td></tr></tbody></table></div></div></div>");
$templateCache.put("app/main/pages/events/views/events/event-management/tabs/external-subscribers/full-external-registration-dialog/full-external-registration-dialog.html","<md-dialog class=\"full-registration-dialog\" ng-init=\"getFullRegistration()\" style=\"min-width: 850px\"><form \nname=\"newCoordinatorsForm\" data-ng-model=\"newCoordinatorsForm\" class=\"md-inline-form\" validate><md-toolbar \nclass=\"md-accent\" layout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" \nlayout-align=\"space-between center\"><span class=\"title\">פרטי הזמנה</span><md-button class=\"md-icon-button\" \nng-click=\"closeDialog()\" aria-label=\"Close dialog\" translate translate-attr-aria-label=\"MANAGE_USERS.CLOSE_DIALOG\">\n<md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-tabs md-dynamic-height \nmd-selected=\"selectedTab\"><md-tab><md-tab-label><span>פרטי הרשמה</span></md-tab-label><md-tab-body><md-content \nclass=\"about-tab\" style=\"padding: 50px\" \nng-include=\"\'app/main/pages/events/views/events/event-management/tabs/external-subscribers/full-external-registration-dialog/tabs/registration.html\'\">\n</md-content></md-tab-body></md-tab><md-tab><md-tab-label><span>אמצעי תשלום</span></md-tab-label><md-tab-body>\n<md-content class=\"about-tab\" style=\"padding: 50px\" \nng-include=\"\'app/main/pages/events/views/events/event-management/tabs/external-subscribers/full-external-registration-dialog/tabs/paymnet.html\'\">\n</md-content></md-tab-body></md-tab><md-tab ng-disabled=\"registrations.Questions.length==0\"><md-tab-label><span>שאלות\n</span></md-tab-label><md-tab-body><md-content class=\"about-tab\" style=\"padding: 50px\" \nng-include=\"\'app/main/pages/events/views/events/event-management/tabs/external-subscribers/full-external-registration-dialog/tabs/questions.html\'\">\n</md-content></md-tab-body></md-tab><md-tab \nng-disabled=\"!registrations.Registration.RefundDate && !registrations.Registration.Canceled\"><md-tab-label><span>\nפרטי ביטול וזיכוי</span></md-tab-label><md-tab-body><md-content ng-disabled=\"$root.AdminLevel<3\" class=\"about-tab\" \nstyle=\"padding: 50px\" \nng-include=\"\'app/main/pages/events/views/events/event-management/tabs/external-subscribers/full-external-registration-dialog/tabs/cancel.html\'\">\n</md-content></md-tab-body></md-tab><md-tab><md-tab-label><span>היסטורית שינויים</span></md-tab-label><md-tab-body>\n<md-content ng-disabled=\"$root.AdminLevel<3\" class=\"about-tab\" style=\"padding: 50px\" \nng-include=\"\'app/main/pages/events/views/events/event-management/tabs/external-subscribers/full-external-registration-dialog/tabs/logs.html\'\">\n</md-content></md-tab-body></md-tab></md-tabs></form></md-dialog>");
$templateCache.put("app/main/pages/events/views/events/event-management/tabs/external-subscribers/new-external-registration-dialog/new-external-registration-dialog.html","<md-dialog id=\"newRegistration-dialog\" aria-label=\"New Task\"><md-toolbar class=\"md-accent\" layout=\"column\"><div \nclass=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">\nהוספת הזמנה חדשה</span><md-button class=\"md-icon-button\" ng-click=\"closeDialog()\" aria-label=\"Close dialog\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><div class=\"content\" flex><md-content \nclass=\"payments-tab\" style=\"height: 500px\"><form name=\"newRegistrationPart2Form\" data-ng-model=\"newParentForm\" \nclass=\"md-inline-form\" validate><md-input-container class=\"md-block\"><md-icon md-svg-icon=\"account\" class=\"name\">\n</md-icon><label>שם לקבלה</label><input ng-model=\"newRegistration.Name\" ng-disabled=\"isClicked\" ng-required=\"true\">\n</md-input-container><md-input-container class=\"md-block\"><md-icon md-svg-icon=\"phone\" class=\"name\"></md-icon><label>\nמספר טלפון</label><input ng-model=\"newRegistration.PhoneNumber\" ng-disabled=\"isClicked\" ng-required=\"true\">\n</md-input-container><md-input-container class=\"md-block\"><md-icon md-svg-icon=\"email\" class=\"name\"></md-icon><label>\nדוא\"ל</label><input ng-model=\"newRegistration.Email\" ng-disabled=\"isClicked\" ng-required=\"true\"></md-input-container>\n<md-input-container class=\"md-block\"><md-icon md-svg-icon=\"cash\" class=\"name\"></md-icon><label>אמצעי תשלום</label>\n<md-select ng-required=\"true\" ng-model=\"newRegistration.Type\" ng-disabled=\"isClicked || event.Price==0\" \nng-change=\"checkIfNoCharge()\" placeholder=\"אמצעי תשלום\"><md-option ng-value=\"0\" ng-disabled=\"$root.User.EventsPay\" \nng-selected=\"event.NewPrice==0 || event.Price==0\">ללא חיוב</md-option><md-option ng-value=\"1\">אשראי</md-option>\n<md-option ng-value=\"2\">מזומן</md-option><md-option ng-value=\"3\">העברה בנקאית</md-option><md-option ng-value=\"4\">המחאה\n</md-option></md-select></md-input-container><div ng-show=\"newRegistration.Type==3\"><md-input-container \nclass=\"md-block\"><md-icon md-svg-icon=\"account\" class=\"name\"></md-icon><label>שם בעל החשבון</label><input \nng-model=\"newRegistration.AccountName\" ng-disabled=\"isClicked\" ng-required=\"newRegistration.Type==3\">\n</md-input-container><md-input-container class=\"md-block\"><md-icon md-svg-icon=\"numeric\" class=\"name\"></md-icon><label>\nמספר בנק</label><input ng-model=\"newRegistration.BankNumber\" type=\"number\" ng-disabled=\"isClicked\" \nng-required=\"newRegistration.Type==3\"></md-input-container><md-input-container class=\"md-block\"><md-icon \nmd-svg-icon=\"numeric\" class=\"name\"></md-icon><label>מספר סניף</label><input ng-model=\"newRegistration.BranchNumber\" \ntype=\"number\" ng-disabled=\"isClicked\" ng-required=\"newRegistration.Type==3\"></md-input-container><md-input-container \nclass=\"md-block\"><md-icon md-svg-icon=\"numeric\" class=\"name\"></md-icon><label>מספר חשבון</label><input \nng-model=\"newRegistration.AccountNumber\" type=\"number\" ng-disabled=\"isClicked\" ng-required=\"newRegistration.Type==3\">\n</md-input-container><md-input-container class=\"md-block\"><md-icon class=\"name\"></md-icon><label>בנק</label><md-icon \nmd-svg-icon=\"bank\" class=\"name\"></md-icon><md-select ng-model=\"newRegistration.BrandAccountNumber\" \nng-disabled=\"!banks || isClicked\"><md-option ng-repeat=\"bank in banks\" ng-value=\"bank.Number\">{{bank.Name}}</md-option>\n</md-select></md-input-container></div><div ng-show=\"newRegistration.Type==4\"><md-input-container class=\"md-block\">\n<md-icon md-svg-icon=\"account\" class=\"name\"></md-icon><label>שם בעל הצ\'ק</label><input \nng-model=\"newRegistration.CheckOwner\" ng-disabled=\"isClicked\" ng-required=\"newRegistration.Type==4\">\n</md-input-container><md-input-container class=\"md-block\"><md-icon md-svg-icon=\"numeric\" class=\"name\"></md-icon><label>\nמספר צ\'קים</label><input ng-model=\"newRegistration.NumberOfCheck\" ng-disabled=\"isClicked\" \nng-required=\"newRegistration.Type==4\"></md-input-container><md-input-container class=\"md-block\"><md-icon \nmd-svg-icon=\"numeric\" class=\"name\"></md-icon><label>מספר צ\'ק ראשון</label><input \nng-model=\"newRegistration.CheckNumber\" type=\"number\" ng-disabled=\"isClicked\" ng-required=\"newRegistration.Type==4\">\n</md-input-container><md-input-container class=\"md-block md-icon-left\"><md-icon md-svg-icon=\"calendar\" class=\"name\">\n</md-icon><label>מועד פרעון ראשון</label><input ng-required=\"newRegistration.Type==4\" autocomplete=\"off\" \nng-disabled=\"isClicked\" ng-model=\"newRegistration.CheckMaturityDate\"></md-input-container></div><div \nng-show=\"newRegistration.Type>1\"><md-input-container class=\"md-block\"><md-icon md-svg-icon=\"power\" class=\"name\">\n</md-icon><label>סטטוס הרשמה</label><md-select ng-model=\"newRegistration.Status\" \nng-disabled=\"isClicked || ($root.AdminLevel<3 && !$root.User.Payments)\" ng-init=\"newRegistration.Status=1\"><md-option \nng-value=\"1\">פעיל</md-option><md-option ng-value=\"0\">לא פעיל</md-option></md-select></md-input-container>\n<md-input-container class=\"md-block\"><md-icon md-svg-icon=\"cards-outline\" class=\"name\"></md-icon><label>סטטוס תשלום\n</label><md-select ng-model=\"newRegistration.PaymentStatus\" \nng-init=\"($root.AdminLevel<3 && !$root.User.Payments) ? newRegistration.PaymentStatus=2 : newRegistration.PaymentStatus=1\" \nng-disabled=\"isClicked || ($root.AdminLevel<3 && !$root.User.Payments)\"><md-option ng-value=\"1\">שולם</md-option>\n<md-option ng-value=\"0\">לא שולם</md-option></md-select></md-input-container></div><div class=\"search-actions row\" \nlayout=\"row\" ng-if=\"payment.Type==1\"><md-input-container class=\"md-icon-float md-block\" flex=\"25\" flex-xs=\"100\" \nstyle=\"padding: 0px 0px 0px\" vc-recaptcha key=\"\'6LdOJx8hAAAAANkr5w01UyvEYcj8K6EEdPBtlhWN\'\" \nng-model=\"newRegistration.captcha\" ng-required=\"true\"></md-input-container></div><div class=\"iframe_container\" \nng-show=\"newRegistration.Type==1 && newRegistration.captcha\"><iframe src=\"{{trustSrc(iframe)}}\" frameborder=\"0\">\n</iframe></div><div ng-show=\"newRegistration.Type && newRegistration.Type!=1\"><md-input-container class=\"md-block\">\n<md-icon md-svg-icon=\"cash-multiple\" class=\"name\"></md-icon><label>סכום לחיוב</label><input ng-value=\"event.Price\" \nng-disabled=\"true\"></md-input-container></div><div layout=\"row\" layout-align=\"start center\" \nng-show=\" newRegistration.Type!=1\"><md-button data-ng-disabled=\"newRegistrationPart2Form.$invalid || isClicked\" \ntype=\"submit\" ng-click=\"saveNewRegistration()\" class=\"send-button md-accent md-raised\" aria-label=\"Add Task\">שמירה\n</md-button><md-button data-ng-disabled=\"newRegistrationPart2Form.$invalid || isClicked\" type=\"submit\" \nng-click=\"saveNewRegistration(true)\" class=\"send-button md-accent md-raised\" aria-label=\"Add Task\">\nשמירה והוספת הרשמה חדשה</md-button></div></form></md-content></div></md-dialog>");
$templateCache.put("app/main/pages/events/views/events/event-management/tabs/general/member-event-edit-dialog/member-event-edit-dialog.html","<md-dialog class=\"newAreaPrice-dialog\" aria-label=\"New Task\"><form name=\"newAreasPriceForm\" \ndata-ng-model=\"newAreasPriceForm\" class=\"md-inline-form\" validate><md-toolbar class=\"md-accent\" layout=\"column\"><div \nclass=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">\nעריכת שדות דמי חבר</span><md-button class=\"md-icon-button\" ng-click=\"closeDialog()\" aria-label=\"Close dialog\" \ntitle=\"סגירה\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll>\n<div><div class=\"sflex w100 fdc aifs jcfs memberEventsArea\"><div class=\"sflex aifs fdc w100 hp25\"><div \nclass=\"sflex aic jcfs w100\" ng-if=\"event.EventType != 1 && !event.IsProduct && event.CartEvent == 0\">\n<md-input-container class=\"md-icon-float md-block w100\"><label>{{$root.User.Event}} דמי חבר</label><md-icon \nmd-svg-icon=\"account-card-details\"></md-icon><md-select ng-model=\"event.MemberEvent\" \nplaceholder=\"{{$root.User.Event}} דמי חבר\" ng-change=\"checkIfYearIsSet()\"><md-option ng-value=\"1\">כן</md-option>\n<md-option ng-value=\"0\">לא</md-option></md-select></md-input-container></div><div class=\"sflex aic jcfs w100\" \nng-if=\"event.EventType != 1\" ng-show=\"event.MemberEvent!=1\"><md-input-container class=\"md-icon-float md-block w100\">\n<label>מחייב הרשמה לדמי חבר לשנת</label><md-icon md-svg-icon=\"account-plus\"></md-icon><md-select \nng-model=\"event.MinMemberYear\" placeholder=\"מינימום שנת דמי חבר\"><md-option ng-value=\"0\">ללא</md-option><md-option \nng-value=\"2015\">{{$root.yearType == 1 ? \'תשע\"ה\' : 2015}}</md-option><md-option ng-value=\"2016\">\n{{$root.yearType == 1 ? \'תשע\"ו\' : 2016}}</md-option><md-option ng-value=\"2017\">{{$root.yearType == 1 ? \'תשע\"ז\' : 2017}}\n</md-option><md-option ng-value=\"2018\">{{$root.yearType == 1 ? \'תשע\"ח\' : 2018}}</md-option><md-option ng-value=\"2019\">\n{{$root.yearType == 1 ? \'תשע\"ט\' : 2019}}</md-option><md-option ng-value=\"2020\">{{$root.yearType == 1 ? \'תש\"פ\' : 2020}}\n</md-option><md-option ng-value=\"2021\">{{$root.yearType == 1 ? \'תשפ\"א\' : 2021}}</md-option><md-option ng-value=\"2022\">\n{{$root.yearType == 1 ? \'תשפ\"ב\' : 2022}}</md-option><md-option ng-value=\"2023\">{{$root.yearType == 1 ? \'תשפ\"ג\' : 2023}}\n</md-option><md-option ng-value=\"2024\">{{$root.yearType == 1 ? \'תשפ\"ד\' : 2024}}</md-option></md-select>\n</md-input-container></div></div><div class=\"sflex aic jcfs w100\" ng-if=\"event.EventType != 1 && !event.IsProduct\" \nng-show=\"event.MemberEvent==1\"><md-input-container class=\"md-icon-float md-block w100\"><label>\nשנת {{$root.User.Event}} דמי חבר</label><md-icon md-svg-icon=\"calendar-range\"></md-icon><md-select \nng-model=\"event.MemberYear\" placeholder=\"שנת {{$root.User.Event}} דמי חבר\" ng-required=\"event.MemberEvent==1\">\n<md-option ng-value=\"0\">ללא</md-option><md-option ng-value=\"2015\">{{$root.yearType == 1 ? \'תשע\"ה\' : 2015}}</md-option>\n<md-option ng-value=\"2016\">{{$root.yearType == 1 ? \'תשע\"ו\' : 2016}}</md-option><md-option ng-value=\"2017\">\n{{$root.yearType == 1 ? \'תשע\"ז\' : 2017}}</md-option><md-option ng-value=\"2018\">{{$root.yearType == 1 ? \'תשע\"ח\' : 2018}}\n</md-option><md-option ng-value=\"2019\">{{$root.yearType == 1 ? \'תשע\"ט\' : 2019}}</md-option><md-option ng-value=\"2020\">\n{{$root.yearType == 1 ? \'תש\"פ\' : 2020}}</md-option><md-option ng-value=\"2021\">{{$root.yearType == 1 ? \'תשפ\"א\' : 2021}}\n</md-option><md-option ng-value=\"2022\">{{$root.yearType == 1 ? \'תשפ\"ב\' : 2022}}</md-option><md-option ng-value=\"2023\">\n{{$root.yearType == 1 ? \'תשפ\"ג\' : 2023}}</md-option><md-option ng-value=\"2024\">{{$root.yearType == 1 ? \'תשפ\"ד\' : 2024}}\n</md-option></md-select></md-input-container></div></div></div></md-dialog-content><md-dialog-actions layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-button \ndata-ng-disabled=\"newAreasPriceForm.$invalid || isClicked\" type=\"submit\" ng-click=\"save()\" \nclass=\"send-button md-accent md-raised\" aria-label=\"Add Task\">אישור</md-button></div></md-dialog-actions></form>\n</md-dialog>");
$templateCache.put("app/main/pages/events/views/events/event-management/tabs/payments/new-area-price-dialog/new-area-price-dialog.html","<md-dialog class=\"newAreaPrice-dialog\" aria-label=\"New Task\" ng-init=\"getAreas();getGrades();\"><form \nname=\"newAreasPriceForm\" data-ng-model=\"newAreasPriceForm\" class=\"md-inline-form\" validate><md-toolbar \nclass=\"md-accent\" layout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" \nlayout-align=\"space-between center\"><span class=\"title\">הוספת מחיר לפי אזור ושכבות</span><md-button \nclass=\"md-icon-button\" ng-click=\"closeDialog()\" aria-label=\"Close dialog\" title=\"הוספת הנחה\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><div>\n<md-input-container class=\"md-block\"><label>איזור</label><md-icon md-font-icon=\"icon-domain\"></md-icon><md-select \nmd-on-close=\"vm.clearSearchTerm()\" ng-model=\"newAreaPrice.AreaID\" id=\"BranchID\" ng-disabled=\"!areas || isClicked\" \nrequired=\"true\"><md-select-header class=\"demo-select-header\"><input ng-model=\"searchTerm\" type=\"text\" \nng-keydown=\"$event.stopPropagation()\" placeholder=\"חיפוש איזור\" class=\"demo-header-searchbox md-text\" \nautocomplete=\"off\"></md-select-header><md-optgroup><md-option ng-repeat=\"area in areas | filter: searchTerm\" \nng-value=\"area.ID\">{{area.Name}}</md-option></md-optgroup></md-select></md-input-container><md-input-container \nclass=\"md-block\"><md-icon md-font-icon=\"icon-chair-school\"></md-icon><label>{{$root.User.Grade}}</label><md-select \nng-model=\"newAreaPrice.GradesID\" multiple=\"true\"><md-option ng-repeat=\"grade in grades\" ng-value=\"grade.ID\">\n{{grade.Name}}</md-option></md-select></md-input-container><md-input-container class=\"md-block\"><label>מחיר</label>\n<md-icon md-svg-icon=\"cash\" class=\"name\"></md-icon><input type=\"text\" ng-model=\"newAreaPrice.Price\" ng-required=\"true\" \nng-disabled=\"isClicked\"></md-input-container></div></md-dialog-content><md-dialog-actions layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-button \ndata-ng-disabled=\"newAreasPriceForm.$invalid || isClicked\" type=\"submit\" ng-click=\"saveNewAreaPrice()\" \nclass=\"send-button md-accent md-raised\" aria-label=\"Add Task\">שמירה</md-button></div></md-dialog-actions></form>\n</md-dialog>");
$templateCache.put("app/main/pages/events/views/events/event-management/tabs/payments/new-branch-kibutzPay-dialog/new-branch-kibutzPay-dialog.html","<md-dialog class=\"newBranchPrice-dialog\" aria-label=\"New Task\" ng-init=\"init()\"><form name=\"newBranchPriceForm\" \ndata-ng-model=\"newBranchPriceForm\" class=\"md-inline-form\" validate><md-toolbar class=\"md-accent\" layout=\"column\"><div \nclass=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">\nהוספת סניף</span><md-button class=\"md-icon-button\" ng-click=\"closeDialog()\" aria-label=\"Close dialog\" \ntitle=\"הוספת הנחה\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content \nms-scroll><div><md-input-container class=\"md-block\"><label>{{$root.User.Branch}}</label><md-icon \nmd-font-icon=\"icon-domain\"></md-icon><md-select md-on-close=\"vm.clearSearchTerm()\" ng-model=\"newBranchPrice.BranchID\" \nid=\"BranchID\" ng-disabled=\"!branches || isClicked\" required=\"true\"><md-select-header class=\"demo-select-header\"><input \nng-model=\"searchTerm\" type=\"text\" ng-keydown=\"$event.stopPropagation()\" placeholder=\"חיפוש {{$root.User.Branch}}\" \nclass=\"demo-header-searchbox md-text\" autocomplete=\"off\"></md-select-header><md-optgroup><md-option \nng-repeat=\"branch in branches | filter: searchTerm\" ng-value=\"branch.ID\">{{branch.Name}}</md-option></md-optgroup>\n</md-select></md-input-container></div></md-dialog-content><md-dialog-actions layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-button \ndata-ng-disabled=\"newBranchPriceForm.$invalid || isClicked\" type=\"submit\" ng-click=\"saveNewBranchPrice()\" \nclass=\"send-button md-accent md-raised\" aria-label=\"Add Task\">שמירה</md-button></div></md-dialog-actions></form>\n</md-dialog>");
$templateCache.put("app/main/pages/events/views/events/event-management/tabs/payments/new-branch-price-dialog/new-branch-price-dialog.html","<md-dialog class=\"newBranchPrice-dialog\" aria-label=\"New Task\" ng-init=\"init()\"><form name=\"newBranchPriceForm\" \ndata-ng-model=\"newBranchPriceForm\" class=\"md-inline-form\" validate><md-toolbar class=\"md-accent\" layout=\"column\"><div \nclass=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">\nהוספת מחיר לפי סניף ושכבות</span><md-button class=\"md-icon-button\" ng-click=\"closeDialog()\" aria-label=\"Close dialog\" \ntitle=\"הוספת הנחה\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content \nms-scroll><div><md-input-container class=\"md-block\"><label>{{$root.User.Branch}}</label><md-icon \nmd-font-icon=\"icon-domain\"></md-icon><md-select md-on-close=\"vm.clearSearchTerm()\" ng-model=\"newBranchPrice.BranchID\" \nid=\"BranchID\" ng-disabled=\"!branches || isClicked\" required=\"true\"><md-select-header class=\"demo-select-header\"><input \nng-model=\"searchTerm\" type=\"text\" ng-keydown=\"$event.stopPropagation()\" placeholder=\"חיפוש {{$root.User.Branch}}\" \nclass=\"demo-header-searchbox md-text\" autocomplete=\"off\"></md-select-header><md-optgroup><md-option \nng-repeat=\"branch in branches | filter: searchTerm\" ng-value=\"branch.ID\">{{branch.Name}}</md-option></md-optgroup>\n</md-select></md-input-container><md-input-container class=\"md-block\"><md-icon md-font-icon=\"icon-chair-school\">\n</md-icon><label>{{$root.User.Grade}}</label><md-select ng-model=\"newBranchPrice.GradesID\" multiple=\"true\"><md-option \nng-repeat=\"grade in grades\" ng-value=\"grade.ID\">{{grade.Name}}</md-option></md-select></md-input-container>\n<md-input-container class=\"md-block\"><label>מחיר</label><md-icon md-svg-icon=\"cash\" class=\"name\"></md-icon><input \ntype=\"text\" ng-model=\"newBranchPrice.Price\" ng-required=\"true\" ng-disabled=\"isClicked\"></md-input-container></div>\n</md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" \nlayout-align=\"start center\"><md-button data-ng-disabled=\"newBranchPriceForm.$invalid || isClicked\" type=\"submit\" \nng-click=\"saveNewBranchPrice()\" class=\"send-button md-accent md-raised\" aria-label=\"Add Task\">שמירה</md-button></div>\n</md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/pages/events/views/events/event-management/tabs/payments/new-event-fee-dialog/new-event-fee-dialog.html","<md-dialog class=\"newEventFee-dialog\" aria-label=\"New Task\" ng-init=\"init()\"><form name=\"newEventFeeForm\" \ndata-ng-model=\"newEventFeeForm\" class=\"md-inline-form\" validate><md-toolbar class=\"md-accent\" layout=\"column\"><div \nclass=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">\nהוספת עמלה לפי כמות תשלומים</span><md-button class=\"md-icon-button\" ng-click=\"closeDialog()\" aria-label=\"Close dialog\" \ntitle=\"הוספת עמלה\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content \nms-scroll><div><md-input-container class=\"md-block\"><label>מספר תשלומים</label><md-icon md-svg-icon=\"cash\" \nclass=\"name\"></md-icon><md-select ng-model=\"newEventFee.NumOfPayments\" ng-required=\"true\"><md-option \nng-repeat=\"payment in payments\" ng-value=\"payment\">{{payment}}</md-option></md-select></md-input-container>\n<md-input-container class=\"md-block\"><label>עמלה</label><md-icon md-svg-icon=\"percent\" class=\"name\"></md-icon><input \ntype=\"text\" ng-model=\"newEventFee.Fee\" ng-required=\"true\" ng-disabled=\"isClicked\"></md-input-container></div>\n</md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" \nlayout-align=\"start center\"><md-button data-ng-disabled=\"newEventFeeForm.$invalid || isClicked\" type=\"submit\" \nng-click=\"saveNewEventFee()\" class=\"send-button md-accent md-raised\" aria-label=\"Add Task\">שמירה</md-button></div>\n</md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/pages/events/views/events/event-management/tabs/payments/new-group-price-dialog/new-group-price-dialog.html","<md-dialog class=\"newGroupPrice-dialog\" aria-label=\"New Task\" ng-init=\"getGroups();\"><form name=\"newGroupsPriceForm\" \ndata-ng-model=\"newGroupPriceForm\" class=\"md-inline-form\" validate><md-toolbar class=\"md-accent\" layout=\"column\"><div \nclass=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">\nהוספת מחיר לפי קבוצה</span><md-button class=\"md-icon-button\" ng-click=\"closeDialog()\" aria-label=\"Close dialog\" \ntitle=\"הוספת הנחה\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content \nms-scroll><div><md-input-container class=\"md-block\"><label>קבוצה</label><md-icon md-font-icon=\"icon-domain\"></md-icon>\n<md-select md-on-close=\"vm.clearSearchTerm()\" ng-model=\"newGroupPrice.GroupID\" id=\"GroupID\" \nng-disabled=\"!groups || isClicked\" required=\"true\"><md-select-header class=\"demo-select-header\"><input \nng-model=\"searchTerm\" type=\"text\" ng-keydown=\"$event.stopPropagation()\" placeholder=\"חיפוש קבוצה\" \nclass=\"demo-header-searchbox md-text\" autocomplete=\"off\"></md-select-header><md-optgroup><md-option \nng-repeat=\"group in groups | filter: searchTerm\" ng-value=\"group.ID\">{{group.Name}}</md-option></md-optgroup>\n</md-select></md-input-container><md-input-container class=\"md-block\"><label>מחיר</label><md-icon md-svg-icon=\"cash\" \nclass=\"name\"></md-icon><input type=\"text\" ng-model=\"newGroupPrice.Price\" ng-required=\"true\" ng-disabled=\"isClicked\">\n</md-input-container></div></md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><div\n layout=\"row\" layout-align=\"start center\"><md-button data-ng-disabled=\"newGroupsPriceForm.$invalid || isClicked\" \ntype=\"submit\" ng-click=\"saveNewGroupPrice()\" class=\"send-button md-accent md-raised\" aria-label=\"Add Task\">שמירה\n</md-button></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/pages/events/views/events/event-management/tabs/questions/add-questions-to-event-dialog/add-questions-to-event-dialog.html","<md-dialog class=\"newQuestion-dialog\" aria-label=\"New Task\" ng-init=\"init()\"><form name=\"newQuestionForm\" \ndata-ng-model=\"eventQuestions\" class=\"md-inline-form\" validate><md-toolbar class=\"md-accent\" layout=\"row\"><div \nclass=\"md-toolbar-tools md-toolbar-tools-top sflex jcsb aic\" layout=\"row\" layout-align=\"space-between\"><div>\n<md-input-container class=\"md-icon-float md-block\" layout=\"row\" flex=\"100\"><md-select ng-model=\"newQuestions.BranchID\">\n<md-select-header class=\"demo-select-header\"><input ng-model=\"searchTerm2\" type=\"text\" \nng-keydown=\"$event.stopPropagation()\" placeholder=\"שיוך ל{{$root.User.Branch}} ספציפי\" \nclass=\"demo-header-searchbox md-text\" autocomplete=\"off\"></md-select-header><md-optgroup><md-option ng-value=\"null\">\nכולם</md-option><md-option ng-repeat=\"branch in branches | orderBy:\'Name\' | filter:searchTerm2\" ng-value=\"branch.ID\">\n{{branch.Name}}</md-option></md-optgroup></md-select></md-input-container></div><div><span class=\"title\">\nהוספה מרשימת שאלות</span><md-button class=\"md-icon-button\" ng-click=\"closeDialog()\" aria-label=\"Close dialog\" \ntranslate translate-attr-aria-label=\"MANAGE_USERS.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon>\n</md-button></div></div></md-toolbar><md-dialog-content><div layout=\"row\" layout-sm=\"column\" \nlayout-align=\"space-around\" ng-show=\"!newQuestions\"><md-progress-circular md-mode=\"indeterminate\">\n</md-progress-circular></div><div ng-show=\"newQuestions.length==0\">לא נמצאו שאלות</div><md-list \nng-if=\"newQuestions.length>0\"><md-list-item ng-repeat=\"newQuestion in newQuestions | orderBy: \'AnswerType\'\" \nclass=\"noright questionsListIcons\"><p>{{ newQuestion.Description }}</p><img src=\"/assets/icons/edit.svg\" \nalt=\"שאלה פתוחה\" title=\"שאלה פתוחה\" ng-if=\"newQuestion.AnswerType == 1\"> <img src=\"/assets/icons/list.svg\" \nalt=\"אפשרויות\" title=\"אפשרויות\" ng-if=\"newQuestion.AnswerType == 2\"> <img src=\"/assets/icons/attachement.svg\" \nalt=\"קובץ\" title=\"קובץ\" ng-if=\"newQuestion.AnswerType == 3\"> <img src=\"/assets/icons/cal.svg\" alt=\"תאריך\" \ntitle=\"תאריך\" ng-if=\"newQuestion.AnswerType == 4\"><md-checkbox class=\"md-secondary\" ng-model=\"newQuestion.Add\" \nng-disabled=\"isClicked\"></md-checkbox></md-list-item></md-list></md-dialog-content><md-dialog-actions \nng-if=\"newQuestions.length>0\" layout=\"row\" layout-align=\"space-between center\"><md-button \ndata-ng-disabled=\"newQuestionForm.$invalid || isClicked\" type=\"submit\" ng-click=\"addQuestionsToEvent()\" \nclass=\"send-button md-accent md-raised\" aria-label=\"Add Task\">הוספה ושמירה</md-button></md-dialog-actions></form>\n</md-dialog>");
$templateCache.put("app/main/pages/events/views/events/event-management/tabs/questions/edit-event-question-panel/edit-event-question-panel.html","<md-content ms-scroll ng-init=\"vm.init()\"><form name=\"branchsForm\" id=\"branchForm\" data-ng-model=\"branchForm\" \nclass=\"md-inline-form\" validate><md-toolbar class=\"md-accent\" layout=\"column\"><div \nclass=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">\nעריכת שאלה</span><md-button class=\"md-icon-button\" ng-click=\"$root.closePanel()\" aria-label=\"Close Dialog\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-input-container class=\"md-block\"><md-icon \nmd-svg-icon=\"numeric\"></md-icon><label>מספר שאלה להצגה</label><input ng-model=\"vm.question.Number\">\n</md-input-container><md-input-container class=\"md-block\"><md-icon md-font-icon=\"icon-power\"></md-icon><label>סטטוס\n</label><md-select ng-model=\"vm.question.Status\"><md-option \nng-selected=\"vm.question.Status==1 || vm.question.Status==\'1\'\" ng-value=\"1\">פעיל</md-option><md-option \nng-selected=\"vm.question.Status==0 || vm.question.Status==\'0\'\" ng-value=\"0\">לא פעיל</md-option></md-select>\n</md-input-container><md-input-container class=\"md-block\"><md-icon md-svg-icon=\"alert-decagram\"></md-icon><label>\nשאלת חובה</label><md-select ng-model=\"vm.question.Required\"><md-option \nng-selected=\"vm.question.Required==1 || vm.question.Required==\'1\'\" ng-value=\"1\">כן</md-option><md-option \nng-selected=\"vm.question.Required==0 || vm.question.Required==\'0\'\" ng-value=\"0\">לא</md-option></md-select>\n</md-input-container><md-input-container class=\"md-block\"><md-icon md-font-icon=\"icon-domain\"></md-icon><md-select \nng-model=\"vm.question.BranchID\"><md-select-header class=\"demo-select-header\"><input ng-model=\"searchTerm2\" type=\"text\" \nng-keydown=\"$event.stopPropagation()\" placeholder=\"שיוך ל{{$root.User.Branch}} ספציפי\" \nclass=\"demo-header-searchbox md-text\" autocomplete=\"off\"></md-select-header><md-optgroup><md-option ng-value=\"null\">\nכולם</md-option><md-option ng-repeat=\"branch in vm.branches | orderBy:\'Name\' | filter:searchTerm2\" \nng-value=\"branch.ID\">{{branch.Name}}</md-option></md-optgroup></md-select></md-input-container><md-input-container \nclass=\"md-block\" ng-if=\"vm.question.AnswerType==1 || vm.question.AnswerType==\'1\'\"><md-icon \nmd-svg-icon=\"format-list-bulleted-type\"></md-icon><label>סוג שאלה</label><md-select \nng-model=\"vm.question.QuestionType\"><md-option ng-value=\"\'text\'\">טקסט</md-option><md-option ng-value=\"\'email\'\">\nדואר אלקטרוני</md-option><md-option ng-value=\"\'number\'\">מספרים</md-option><md-option ng-value=\"\'phonenumber\'\">\nמספר טלפון</md-option></md-select></md-input-container></form></md-content>");
$templateCache.put("app/main/pages/events/views/events/event-management/tabs/subscribers/create-kibutzPDF-dialog/create-kibutzPDF-dialog.html","<md-dialog class=\"newRegistration-dialog\" aria-label=\"New Task\" ng-init=\"getCoordinators()\"><md-toolbar \nclass=\"md-accent\" layout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" \nlayout-align=\"space-between center\"><span class=\"title\">יצירת טופס התחייבות</span><md-button class=\"md-icon-button\" \nng-click=\"closeDialog()\" aria-label=\"Close dialog\" translate translate-attr-aria-label=\"MANAGE_USERS.CLOSE_DIALOG\">\n<md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><div class=\"content\" flex><md-content \nclass=\"about-tab\"><form name=\"cancelRegForm\" data-ng-model=\"cancelRegForm\" class=\"md-inline-form\" validate>\n<md-dialog-content ms-scroll><md-input-container class=\"md-block\" style=\"width: 80%\"><md-icon \nmd-svg-icon=\"clipboard-text\" class=\"name\"></md-icon><label>בחר תפקיד</label><md-select \nng-model=\"report.CoordinatorRole\" ng-change=\"setCoordinator(report.CoordinatorRole)\"><md-option \nng-repeat=\"role in roles\" ng-value=\"role\">{{role}}</md-option><md-option value=\"all\">בחר הכל</md-option></md-select>\n</md-input-container><md-input-container class=\"md-block\" style=\"width: 80%\"><md-icon md-svg-icon=\"clipboard-text\" \nclass=\"name\"></md-icon><label>בחר {{$root.User.Coordinator}}</label><md-select md-on-close=\"clearSearchTerm()\" \nng-model=\"report.CoordinatorID\" ng-disabled=\"isClikced || !coordinators\"><md-select-header class=\"demo-select-header\">\n<input ng-model=\"searchTerm\" type=\"text\" ng-keydown=\"$event.stopPropagation()\" placeholder=\"חיפוש מהיר\" \nclass=\"demo-header-searchbox md-text\" autocomplete=\"off\"></md-select-header><md-optgroup><md-option \nng-value=\"coordinator.ID\" ng-repeat=\"coordinator in coordinators |filter:searchTerm\">\n{{coordinator.FirstName}} {{coordinator.LastName}}</md-option></md-optgroup></md-select></md-input-container>\n</md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" \nlayout-align=\"start center\"><md-button ng-disabled=\"cancelRegForm.$invalid || isClikced\" ng-click=\"createPDF()\" \nclass=\"send-button md-accent md-raised\" aria-label=\"Add Task\">יצירת דוח</md-button></div></md-dialog-actions></form>\n</md-content></div></md-dialog>");
$templateCache.put("app/main/pages/events/views/events/event-management/tabs/subscribers/new-registration-dialog/new-registration-dialog.html","<md-dialog class=\"newRegistration-dialog\" aria-label=\"New Task\"><md-toolbar class=\"md-accent\" layout=\"column\"><div \nclass=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">\nהוספת הזמנה חדשה</span><md-button class=\"md-icon-button\" ng-click=\"closeDialog()\" aria-label=\"Close dialog\" \nng-if=\"!restrictDialogClose\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content><div class=\"content\" flex><md-tabs md-dynamic-height md-selected=\"selectedTab\"><md-tab>\n<md-tab-label><span>בחירת חניך</span></md-tab-label><md-tab-body><md-content class=\"about-tab\"><form \nname=\"newRegistrationPart1Form\" data-ng-model=\"newRegistrationForm\" class=\"md-inline-form\" validate><md-dialog-content \nms-scroll><md-input-container class=\"md-block\"><span href=\"\" ng-if=\"!tz\" ng-click=\"ChangeToPassport()\" \nstyle=\"cursor: pointer\">החלף לדרכון / תעודה חריגה</span> <span href=\"\" ng-if=\"tz\" ng-click=\"ChangeToPassport()\" \nstyle=\"cursor: pointer\">החלף לתעודה מזהה</span></md-input-container><md-input-container class=\"md-block\"><md-icon \nmd-font-icon=\"icon-account-box\" class=\"name\"></md-icon><label ng-if=\"!tz\">תעודת זהות</label><label ng-if=\"tz\">\nדרכון/תעודה חריגה</label><input ng-model=\"newRegistration.PrivateID\" ng-change=\"getStudentByPrivateID\" \ndata-ng-required=\"true\" data-ng-pattern=\"/^[a-zA-Z0-9_.-]*$/\"></md-input-container><md-input-container \nclass=\"md-block\"><md-icon md-font-icon=\"icon-account\" class=\"name\"></md-icon><label>שם פרטי</label><input \nng-model=\"newRegistration.FirstName\" ng-disabled=\"!new\" ng-required=\"true\"></md-input-container><md-input-container \nclass=\"md-block\"><md-icon md-font-icon=\"icon-account\" class=\"name\"></md-icon><label>שם משפחה</label><input \nng-model=\"newRegistration.LastName\" ng-disabled=\"!new\" ng-required=\"true\"></md-input-container><md-input-container \nng-if=\"tz && !hide\" class=\"md-icon-float md-block md-icon-left\" style=\"padding: 0px 28px 0px\" vc-recaptcha \nkey=\"\'6LdOJx8hAAAAANkr5w01UyvEYcj8K6EEdPBtlhWN\'\" ng-model=\"newStudent.captcha\"></md-input-container><div \nng-if=\"notExist && !hide\"><div layout=\"row\" layout-align=\"start center\"><span>החניך לא קיים במערכת. להוספת חניך חדש <a \nstyle=\"cursor: pointer\" ng-click=\"newStudent()\">לחץ כאן</a></span></div></div><div ng-if=\"hide\"><md-input-container \nclass=\"md-block\"><md-icon md-font-icon=\"icon-account-box\" class=\"name\"></md-icon><label>תעודת זהות הורה</label><input \nng-model=\"newRegistration.Parent1\"></md-input-container><md-input-container class=\"md-block\"><md-icon \nmd-font-icon=\"icon-gender-male-female\" class=\"name\"></md-icon><label>מין</label><md-select ng-required=\"true\" \nng-model=\"newRegistration.Gender\" placeholder=\"מין\"><md-option ng-value=\"\'Male\'\">בן</md-option><md-option \nng-value=\"\'Female\'\">בת</md-option><md-option ng-if=\"$root.GenderType == 1\" ng-value=\"\'Other\'\">אחר</md-option>\n</md-select></md-input-container><md-input-container class=\"md-block\"><md-icon md-font-icon=\"icon-domain\"></md-icon>\n<label>{{$root.User.Grade}}</label><md-select ng-model=\"newRegistration.GradeID\" ng-disabled=\"!grades\" \nng-required=\"true\"><md-option ng-repeat=\"grade in grades\" ng-value=\"grade.ID\">{{grade.Name}}</md-option></md-select>\n</md-input-container><md-input-container class=\"md-block\"><md-icon md-font-icon=\"icon-domain\" class=\"name\"></md-icon>\n<label>בחירת סניף</label><md-select ng-required=\"true\" ng-model=\"newRegistration.BranchID\" placeholder=\"בחירת סניף\" \nng-disabled=\"!branches || !newRegistration.GradeID\" ng-change=\"getGroupsByBranch()\"><md-option \nng-repeat=\"branch in branches\" ng-value=\"branch.ID\">{{branch.Name}}</md-option></md-select></md-input-container>\n<md-input-container class=\"md-block\"><md-icon md-font-icon=\"icon-account-multiple\" class=\"name\"></md-icon><label>\nבחר {{$root.User.Group}}</label><md-select ng-model=\"newRegistration.GroupID\" \nng-disabled=\"!groups || !newRegistration.BranchID\"><md-option ng-repeat=\"group in groups\" ng-value=\"group.ID\">\n{{group.Name}}</md-option></md-select></md-input-container><md-input-container ng-if=\"tz && hide\" \nclass=\"md-icon-float md-block md-icon-left\" style=\"padding: 0px 28px 0px\" vc-recaptcha \nkey=\"\'6LdOJx8hAAAAANkr5w01UyvEYcj8K6EEdPBtlhWN\'\" ng-model=\"newStudent.captcha\"></md-input-container></div>\n</md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" \nlayout-align=\"start center\"><md-button ng-disabled=\"newRegistrationPart1Form.$invalid || !quesitons\" \nng-click=\"moveToPayments()\" class=\"send-button md-accent md-raised\" aria-label=\"Add Task\">המשך</md-button></div>\n</md-dialog-actions></form></md-content></md-tab-body></md-tab><md-tab ng-disabled=\"!newRegistration.LastName || new\" \nng-if=\"quesitons.length>0\"><md-tab-label><span>שאלות</span></md-tab-label><md-tab-body><form name=\"quetionsForm\" \nclass=\"md-inline-form\" validate><div layout=\"row\" layout-wrap ng-repeat=\"question in quesitons\"><md-input-container \nclass=\"md-icon-float md-block\" layout=\"column\" layout-xs=\"row\" flex=\"100\" ng-if=\"question.AnswerType!=3\"><md-icon \nstyle=\"cursor: pointer\" md-svg-icon=\"help-circle\" class=\"name\"></md-icon><label>{{question.Description}}</label><input \nng-if=\"question.AnswerType==1\" ng-model=\"question.Answer\" ng-disabled=\"isClicked\" ng-required=\"question.Required\">\n<md-select ng-if=\"question.AnswerType==2\" ng-model=\"question.Answer\" ng-disabled=\"isClicked\" \nng-required=\"question.Required\"><md-option ng-repeat=\"questionOption in question.Options\" ng-value=\"questionOption\">\n{{questionOption}}</md-option></md-select><div ng-if=\"question.AnswerType==4\" start-view=\"day\" locale=\"he\" \nformat=\"DD/MM/YYYY\" moment-picker=\"question.Answer\"><input autocomplete=\"off\" ng-model=\"question.Answer\" \nng-disabled=\"isClicked\" ng-required=\"question.Required\"></div></md-input-container></div><md-button type=\"submit\" \nng-disabled=\"quetionsForm.$invalid\" class=\"md-raised md-accent\" aria-label=\"חפש\" \nng-click=\"updateQuestions(registrations.Questions)\">המשך</md-button></form></md-tab-body></md-tab><md-tab \nng-disabled=\"(!newRegistration.LastName || new) || questionsDisable\" ng-if=\"transportation.length>0\"><md-tab-label>\n<span>הסעות</span></md-tab-label><md-tab-body><form name=\"TransportationForm\" class=\"md-inline-form\" validate><div \nlayout=\"row\" layout-wrap><md-input-container class=\"md-icon-float md-block\" layout=\"column\" layout-xs=\"row\" flex=\"100\" \nflex-xs=\"100\" flex-gt-sm=\"100\" flex-gt-md=\"100\"><md-icon md-svg-icon=\"bus\" class=\"name\"></md-icon><label>הסעה הלוך\n</label><md-select ng-model=\"selectedTransportation.SelectedTransportationTo\" ng-required=\"true\"><md-option \nng-repeat=\"transportationItem in transportation\" ng-value=\"transportationItem\" ng-if=\"transportationItem.Way==1\">\n{{transportationItem.Name}}</md-option></md-select></md-input-container></div><div layout=\"row\" layout-wrap>\n<md-input-container class=\"md-icon-float md-block\" layout=\"column\" layout-xs=\"row\" flex=\"100\" flex-xs=\"100\" \nflex-gt-sm=\"100\" flex-gt-md=\"100\"><md-icon md-svg-icon=\"bus\" class=\"name\"></md-icon><label>הסעה חזור</label><md-select \nng-disabled=\"isClicked\" ng-model=\"selectedTransportation.SelectedTransportationFrom\" ng-required=\"true\"><md-option \nng-repeat=\"transportationItem in transportation\" ng-if=\"transportationItem.Way==2\" ng-value=\"transportationItem\">\n{{transportationItem.Name}}</md-option></md-select></md-input-container></div><md-button type=\"submit\" \nng-disabled=\"TransportationForm.$invalid\" class=\"md-raised md-accent\" aria-label=\"חפש\" \nng-click=\"updateTransportations()\">המשך</md-button></form></md-tab-body></md-tab><md-tab \nng-disabled=\"(!newRegistration.LastName || new) || questionsDisable || transportationDisable\"><md-tab-label><span>תשלום\n</span></md-tab-label><md-tab-body><div layout=\"row\" layout-sm=\"column\" layout-align=\"space-around\" ng-show=\"!items\">\n<md-progress-circular md-mode=\"indeterminate\"></md-progress-circular></div><div class=\"total-price\" \nng-class=\"{\'fcred\':!getTotalAmountsValidity()}\">\nסכום כללי לחיוב: {{event.NewPrice != undefined? event.NewPrice : event.Price}}</div><md-content class=\"payments-tab\" \nstyle=\"height: 500px\" ng-show=\"items\"><form class=\"md-inline-form\" validate name=\"newRegistrationPart2Form\"><div \nclass=\"separate-block\" ng-class=\"{\'paid\':payment.ReceiptID != \'\'}\" ng-repeat=\"payment in payments\"><div layout=\"row\" \nflex=\"100\"><div layout=\"column\" flex=\"100\" flex-gt-sm=\"100\" flex-gt-md=\"100\"><md-input-container class=\"md-block\">\n<md-icon md-svg-icon=\"cash\" class=\"name\"></md-icon><label>שם ומייל לקבלה</label><md-select ng-required=\"true\" \nng-disabled=\"isClicked || payment.ReceiptID != \'\'\" ng-model=\"payment.parent\" ng-change=\"setParent($index)\" \nplaceholder=\"בחר הורה\"><md-option ng-repeat=\"parent in parents\" ng-value=\"parent\">{{parent.Name}} - {{parent.Email}}\n</md-option><md-option ng-value=\"\'other\'\">אחר</md-option></md-select></md-input-container></div></div><div \nlayout=\"row\" flex=\"100\" ng-if=\"payment.parent === \'other\'\"><div layout=\"column\" flex=\"100\" flex-gt-sm=\"100\" \nflex-gt-md=\"50\"><md-input-container class=\"md-block\"><md-icon md-font-icon=\"icon-account\" class=\"name\"></md-icon>\n<label>שם לקבלה</label><input ng-model=\"payment.Name\" ng-disabled=\"isClicked || payment.ReceiptID != \'\'\" required>\n</md-input-container></div><div layout=\"column\" flex=\"100\" flex-gt-sm=\"100\" flex-gt-md=\"50\"><md-input-container \nclass=\"md-block\"><md-icon md-font-icon=\"icon-email\" class=\"email\"></md-icon><label>מייל לשליחת קבלה</label><input \nng-model=\"payment.Email\" ng-disabled=\"isClicked || payment.ReceiptID != \'\'\" required></md-input-container></div></div>\n<div layout=\"row\" flex=\"100\"><div layout=\"column\" flex=\"100\" flex-gt-sm=\"100\" flex-gt-md=\"50\"><md-input-container \nclass=\"md-block md-icon-left\"><md-icon md-svg-icon=\"cash-multiple\" class=\"name\"></md-icon><label>סכום לחיוב</label>\n<input ng-model=\"payment.Amount\" type=\"number\" ng-change=\"payment.Type == 1 && checkIfNoCharge($index)\" \nng-disabled=\"isClicked || payment.Name == \'\' || payment.Email == \'\' || payment.ReceiptID != \'\' || ($root.AdminLevel<3 && !$root.User.Payments)\" \nmin=\"1\" ng-model-options=\"{debounce: 750}\" max=\"{{event.NewPrice? event.NewPrice : event.Price}}\" required>\n</md-input-container></div><div layout=\"column\" flex=\"100\" flex-gt-sm=\"100\" flex-gt-md=\"50\"><md-input-container \nclass=\"md-block\"><md-icon md-svg-icon=\"cash\" class=\"name\"></md-icon><label>אמצעי תשלום</label><md-select \nng-required=\"true\" ng-model=\"payment.Type\" \nng-disabled=\"isClicked || !items || event.NewPrice==0 || event.Price==0 || payment.Name == \'\' || payment.Email == \'\' || payment.ReceiptID != \'\'\" \nng-change=\"checkIfNoCharge($index)\" placeholder=\"אמצעי תשלום\"><md-option ng-value=\"0\" \nng-disabled=\"$root.User.EventsPay\" ng-selected=\"event.NewPrice==0 || event.Price==0\">ללא חיוב</md-option><md-option \nng-value=\"1\">אשראי</md-option><md-option ng-value=\"2\">מזומן</md-option><md-option ng-value=\"3\">העברה בנקאית</md-option>\n<md-option ng-value=\"4\">המחאה</md-option><md-option ng-value=\"5\" ng-if=\"KibutzPay\">טופס התחייבות</md-option>\n</md-select></md-input-container></div></div><div ng-show=\"payment.Type==3\"><md-input-container class=\"md-block\">\n<md-icon md-svg-icon=\"account\" class=\"name\"></md-icon><label>שם בעל החשבון</label><input \nng-model=\"payment.AccountName\" ng-disabled=\"isClicked || payment.ReceiptID != \'\'\" \nng-required=\"newRegistration.Type==3\"></md-input-container><md-input-container class=\"md-block\"><md-icon \nmd-svg-icon=\"numeric\" class=\"name\"></md-icon><label>מספר בנק</label><input ng-model=\"payment.BankNumber\" type=\"number\" \nng-disabled=\"isClicked || payment.ReceiptID != \'\'\" ng-required=\"newRegistration.Type==3\"></md-input-container>\n<md-input-container class=\"md-block\"><md-icon md-svg-icon=\"numeric\" class=\"name\"></md-icon><label>מספר סניף</label>\n<input ng-model=\"payment.BranchNumber\" type=\"number\" ng-disabled=\"isClicked || payment.ReceiptID != \'\'\" \nng-required=\"newRegistration.Type==3\"></md-input-container><md-input-container class=\"md-block\"><md-icon \nmd-svg-icon=\"numeric\" class=\"name\"></md-icon><label>מספר חשבון</label><input ng-model=\"payment.AccountNumber\" \ntype=\"number\" ng-disabled=\"isClicked || payment.ReceiptID != \'\'\" ng-required=\"newRegistration.Type==3\">\n</md-input-container><md-input-container class=\"md-block\"><md-icon md-svg-icon=\"upload\" class=\"name\"></md-icon><input \nngf-select=\"uploadFile($file,\'q\',question)\" placeholder=\"{{payment.fileName || \'העלאת אסמכתא\'}}\" \nng-model=\"payment.fileReceipt\" name=\"file\" ngf-pattern=\"\'image/*\'\" style=\"cursor: pointer\" readonly=\"readonly\">\n</md-input-container><md-input-container class=\"md-block\"><md-icon class=\"name\"></md-icon><label>בנק</label><md-icon \nmd-svg-icon=\"bank\" class=\"name\"></md-icon><md-select ng-model=\"payment.BrandAccountNumber\" \nng-disabled=\"!banks || isClicked || payment.ReceiptID != \'\'\"><md-option ng-repeat=\"bank in banks\" \nng-value=\"bank.Number\">{{bank.Name}}</md-option></md-select></md-input-container></div><div ng-show=\"payment.Type==4\">\n<md-input-container class=\"md-block\"><md-icon md-svg-icon=\"account\" class=\"name\"></md-icon><label>שם בעל הצ\'ק/ים\n</label><input ng-model=\"payment.CheckOwner\" ng-disabled=\"isClicked || payment.ReceiptID != \'\'\" \nng-required=\"newRegistration.Type==4\"></md-input-container><md-input-container class=\"md-block\"><md-icon \nmd-svg-icon=\"numeric\" class=\"name\"></md-icon><label>מספר צ\'קים</label><input ng-model=\"payment.NumberOfCheck\" \nng-disabled=\"isClicked || payment.ReceiptID != \'\'\" type=\"number\" min=\"1\" ng-required=\"newRegistration.Type==4\" \nng-change=\"generateChecks($index)\"></md-input-container><div ng-repeat=\"check in payment.checks\" \nng-if=\"payment.checks.length\" layout=\"row\" flex=\"100\"><div layout=\"column\" flex=\"100\" flex-gt-sm=\"100\" flex-gt-md=\"33\">\n<md-input-container class=\"md-block\"><md-icon md-svg-icon=\"numeric\" class=\"name\"></md-icon><label>מספר צ\'ק</label>\n<input ng-model=\"check.CheckNumber\" type=\"number\" ng-disabled=\"isClicked || payment.ReceiptID != \'\'\" \nng-required=\"newRegistration.Type==4\"></md-input-container></div><div layout=\"column\" flex=\"100\" flex-gt-sm=\"100\" \nflex-gt-md=\"33\"><md-input-container class=\"md-block md-icon-left\"><md-icon md-svg-icon=\"calendar\" class=\"name\">\n</md-icon><div start-view=\"day\" locale=\"he\" format=\"DD/MM/YYYY\" moment-picker=\"check.CheckMaturityDate\"><label>\nמועד פרעון</label><input ng-required=\"newRegistration.Type==4\" autocomplete=\"off\" \nng-disabled=\"isClicked || payment.ReceiptID != \'\'\" ng-model=\"check.CheckMaturityDate\"></div></md-input-container></div>\n<div layout=\"column\" flex=\"100\" flex-gt-sm=\"100\" flex-gt-md=\"33\"><md-input-container class=\"md-block\"><md-icon \nmd-svg-icon=\"cash-multiple\" class=\"name\"></md-icon><label>סכום הצ\'ק</label><input ng-model=\"check.CheckAmount\" \ntype=\"number\" ng-disabled=\"isClicked || payment.ReceiptID != \'\'\" ng-required=\"newRegistration.Type==4\">\n</md-input-container></div></div></div><div ng-show=\"payment.Type>1\"><md-input-container class=\"md-block\"><md-icon \nmd-svg-icon=\"cards-outline\" class=\"name\"></md-icon><label>סטטוס תשלום</label><md-select \nng-model=\"payment.PaymentStatus\" \nng-init=\"($root.AdminLevel<3 && !$root.User.Payments) ? payment.PaymentStatus=2 : payment.PaymentStatus=1\" \nng-disabled=\"isClicked || ($root.AdminLevel<3 && !$root.User.Payments)\"><md-option ng-value=\"1\">שולם</md-option>\n<md-option ng-value=\"2\">שולם ל{{$root.User.Coordinator}}</md-option><md-option ng-show=\"payment.Type != 2\" \nng-value=\"3\">טרם אושר</md-option><md-option ng-value=\"0\">לא שולם</md-option></md-select></md-input-container></div><div\n class=\"search-actions row\" layout=\"row\" ng-if=\"payment.Type==1\"><md-input-container class=\"md-icon-float md-block\" \nflex=\"25\" flex-xs=\"100\" style=\"padding: 0px 0px 0px\" vc-recaptcha key=\"\'6LdOJx8hAAAAANkr5w01UyvEYcj8K6EEdPBtlhWN\'\" \nng-model=\"payment.captcha\" ng-required=\"true\"></md-input-container></div><div class=\"iframe_container\" \nng-if=\"payment.Type==1 && payment.iframe != \'\' && payment.captcha\"><iframe src=\"{{trustSrc(payment.iframe)}}\" \nframeborder=\"0\"></iframe></div><div layout=\"row\" layout-align=\"start center\"><md-button \nng-if=\"payment.Type && checkChecksValidity(payment) && checkNameAndEmail($index) && ((payment.Type != 1 && payment.ReceiptID == \'\'))\" \nng-click=\"savePayment($index)\" class=\"send-button md-accent md-raised\" aria-label=\"Add Task\">שמירת תשלום</md-button>\n<md-button ng-if=\"$index == payments.length - 1 && ($root.AdminLevel == 3 || $root.User.Payments)\" \nng-disabled=\"payment.ReceiptID == \'\' || getTotalAmountsValidity() \" ng-click=\"addPaymentMissingPrice()\" \nclass=\"send-button md-accent md-raised\" aria-label=\"Add Task\">פצל תשלום</md-button><md-button \nng-if=\"payments.length != 1 && ($root.AdminLevel == 3 || $root.User.Payments)\" ng-disabled=\"payment.ReceiptID != \'\'\" \nng-click=\"removePayment($index)\" class=\"send-button md-accent md-raised\" aria-label=\"Add Task\">מחק תשלום</md-button>\n</div></div><div class=\"mt50\"><md-input-container class=\"md-block\"><md-icon md-svg-icon=\"power\" class=\"name\"></md-icon>\n<label>סטטוס הרשמה</label><md-select ng-model=\"newRegistration.Status\" \nng-disabled=\"isClicked || ($root.AdminLevel<3 && !$root.User.Payments)\" ng-init=\"newRegistration.Status=1\"><md-option \nng-value=\"1\">פעיל</md-option><md-option ng-value=\"0\">לא פעיל</md-option></md-select></md-input-container></div><div \nlayout=\"row\" layout-align=\"start center\" ng-show=\" newRegistration.Type!=1\"><md-button \ndata-ng-disabled=\"newRegistrationPart2Form.$invalid || isClicked || !paymentsValidity() || (payments.length == 0 && (!parents || parents.length == 0))\" \ntype=\"submit\" ng-click=\"saveNewRegistration()\" class=\"send-button md-accent md-raised\" aria-label=\"Add Task\">שמירה\n</md-button><md-button data-ng-disabled=\"newRegistrationPart2Form.$invalid || isClicked || !paymentsValidity()\" \ntype=\"submit\" ng-click=\"saveNewRegistration(true)\" class=\"send-button md-accent md-raised\" aria-label=\"Add Task\">\nשמירה והוספת הרשמה חדשה</md-button></div></form></md-content></md-tab-body></md-tab></md-tabs></div>\n</md-dialog-content></md-dialog>");
$templateCache.put("app/main/pages/events/views/events/event-management/tabs/subscribers/select-registration-dialog/select-registration-dialog.html","<md-dialog class=\"newRegistration-dialog\" aria-label=\"New Task\" ng-init=\"getCoordinators()\"><md-toolbar \nclass=\"md-accent\" layout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" \nlayout-align=\"space-between center\"><span class=\"title\">בחירת הרשמה</span><md-button class=\"md-icon-button\" \nng-click=\"closeDialog()\" aria-label=\"Close dialog\" translate translate-attr-aria-label=\"MANAGE_USERS.CLOSE_DIALOG\">\n<md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><div \nclass=\"content\" flex><form name=\"selectRegForm\" data-ng-model=\"cancelRegForm\" class=\"md-inline-form\" validate>\n<md-input-container class=\"md-block\"><md-icon md-svg-icon=\"clipboard-text\" class=\"name\"></md-icon><label>בחר הרשמה\n</label><md-select ng-model=\"registration\" ng-change=\"setCoordinator(report.CoordinatorRole)\" required><md-option \nng-repeat=\"reg in registrations\" ng-value=\"reg\">{{reg.EventName}}</md-option></md-select></md-input-container></form>\n</div></md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" \nlayout-align=\"start center\"><md-button ng-disabled=\"selectRegForm.$invalid\" ng-click=\"showFullRegistration()\" \nclass=\"send-button md-accent md-raised\" aria-label=\"Add Task\">בחירה</md-button></div></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/pages/events/views/events/event-management/tabs/subscribers/send-health-declaration-dialog/send-health-declaration-dialog.html","<md-dialog class=\"newRegistration-dialog\" aria-label=\"New Task\" ng-init=\"getCoordinators()\"><form \nname=\"healthDeclarationForm\" data-ng-model=\"cancelRegForm\" class=\"md-inline-form\" validate><md-toolbar \nclass=\"md-accent\" layout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" \nlayout-align=\"space-between center\"><span class=\"title\">שליחת הצהרת בריאות</span><md-button class=\"md-icon-button\" \nng-click=\"closeDialog()\" aria-label=\"Close dialog\" translate translate-attr-aria-label=\"MANAGE_USERS.CLOSE_DIALOG\">\n<md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><div \nclass=\"content\" flex><md-input-container class=\"md-block\"><md-icon md-font-icon=\"icon-account-multiple-outline\" \nclass=\"name\"></md-icon><label>נמענים</label><md-select ng-model=\"request.Recipients\" multiple=\"Multiple\" required>\n<md-option value=\"Students\">חניכים</md-option><md-option value=\"Parents\">הורים</md-option></md-select>\n</md-input-container></div></md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><div\n layout=\"row\" layout-align=\"start center\"><md-button ng-disabled=\"healthDeclarationForm.$invalid || isClicked \" \nng-click=\"sendHealthDeclarations()\" class=\"send-button md-accent md-raised\" aria-label=\"Add Task\">שלח</md-button></div>\n</md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/pages/events/views/events/event-management/tabs/suggestions/new-suggestion-dialog/new-suggestion-dialog.html","<md-dialog class=\"newEventSuggestion-dialog\" aria-label=\"New Task\" ng-init=\"init()\"><form \nname=\"newEventSuggestionForm\" data-ng-model=\"newEventSuggestionForm\" class=\"md-inline-form\" validate><md-toolbar \nclass=\"md-accent\" layout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" \nlayout-align=\"space-between center\"><span class=\"title\">הוספת הצעה ל{{$root.User.Event}}/מוצר</span><md-button \nclass=\"md-icon-button\" ng-click=\"closeDialog()\" aria-label=\"Close dialog\" title=\"סגירת חלון\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><md-input-container \nclass=\"md-block\" ng-if=\"events\"><label>בחר {{$root.User.Event}}\\מוצר</label><md-icon md-svg-icon=\"weather-sunny\">\n</md-icon><md-select ng-model=\"suggestedEvent.ID\" ng-disabled=\"!events\" ng-required=\"true\" ng-change=\"log()\">\n<md-select-header class=\"demo-select-header\"><input ng-model=\"searchTerm\" type=\"text\" \nng-disabled=\"!events || isClicked\" ng-keydown=\"$event.stopPropagation()\" placeholder=\"חפש {{$root.User.Event}}\\מוצר..\" \nclass=\"demo-header-searchbox md-text\" autocomplete=\"off\"></md-select-header><md-optgroup \nng-disabled=\"!events || isClicked\"><md-option ng-value=\"event.ID\" ng-repeat=\"event in events |filter:searchTerm\">\n{{event.Name}}</md-option></md-optgroup></md-select></md-input-container></md-dialog-content><md-dialog-actions \nlayout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-button \ndata-ng-disabled=\"newEventSuggestionForm.$invalid || isClicked\" type=\"submit\" ng-click=\"saveNewEventSuggestion()\" \nclass=\"send-button md-accent md-raised\" aria-label=\"Add Task\">שמירה</md-button></div></md-dialog-actions></form>\n</md-dialog>");
$templateCache.put("app/main/pages/events/views/events/event-management/tabs/transportation/add-new-transportation-to-event-dialog/add-new-transportation-to-event-dialog.html","<md-dialog class=\"newTransportation-dialog\" aria-label=\"New Task\"><form name=\"newTransportationForm\" \ndata-ng-model=\"evenTtransportations\" class=\"md-inline-form\" validate><md-toolbar class=\"md-accent\" layout=\"column\"><div\n class=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">\nהוספת הסעה חדשה</span><md-button class=\"md-icon-button\" ng-click=\"closeDialog()\" aria-label=\"Close dialog\" translate \ntranslate-attr-aria-label=\"MANAGE_USERS.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content ms-scroll><md-input-container class=\"md-icon-float md-block\"><md-icon \nmd-font-icon=\"icon-bus\"></md-icon><label>שם הסעה</label><input type=\"text\" ng-model=\"newTransportation.Name\" \nplaceholder=\"שם הסעה\" ng-required=\"true\" ng-disabled=\"isClicked\"></md-input-container><md-input-container \nclass=\"md-block\"><label>כיוון הסעה</label><md-icon md-font-icon=\"icon-road\"></md-icon><md-select \nng-model=\"newTransportation.Way\" placeholder=\"כיוון הסעה\" ng-required=\"true\" ng-disabled=\"isClicked\"><md-option \nng-selected=\"transportation.Way==1\" ng-value=\"1\">הלוך</md-option><md-option ng-selected=\"transportation.Way==2\" \nng-value=\"2\">חזור</md-option></md-select></md-input-container></md-dialog-content><md-dialog-actions layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-button \ndata-ng-disabled=\"newTransportationForm.$invalid || isClicked\" type=\"submit\" ng-click=\"addNewTransportation()\" \nclass=\"send-button md-accent md-raised\" aria-label=\"Add Task\">שמירה</md-button></div></md-dialog-actions></form>\n</md-dialog>");
$templateCache.put("app/main/pages/events/views/events/event-management/tabs/transportation/add-transportation-to-event-dialog/add-transportation-to-event-dialog.html","<md-dialog class=\"newTransportation-dialog\" aria-label=\"New Task\" ng-init=\"getAllTransportation()\"><form \nname=\"newTransportationForm\" data-ng-model=\"evenTtransportations\" class=\"md-inline-form\" validate><md-toolbar \nclass=\"md-accent\" layout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" \nlayout-align=\"space-between center\"><span class=\"title\">שיוך הסעה</span><md-button class=\"md-icon-button\" \nng-click=\"closeDialog()\" aria-label=\"Close dialog\" translate translate-attr-aria-label=\"MANAGE_USERS.CLOSE_DIALOG\">\n<md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll>\n<md-input-container class=\"md-icon-float md-block\"><label>בחר הסעה</label><md-select \nng-model=\"newTransportation.TransportationID\" placeholder=\"בחר הסעה\" ng-required=\"true\" ng-disabled=\"isClicked\">\n<md-option ng-repeat=\"item in transportation\" ng-value=\"item.ID\">{{item.Name}}</md-option></md-select>\n</md-input-container><md-input-container class=\"md-block\"><label>כיוון הסעה</label><md-select \nng-model=\"newTransportation.Way\" placeholder=\"כיוון הסעה\" ng-required=\"true\" ng-disabled=\"isClicked\"><md-option \nng-selected=\"transportation.Way==1\" ng-value=\"1\">הלוך</md-option><md-option ng-selected=\"transportation.Way==2\" \nng-value=\"2\">חזור</md-option></md-select></md-input-container></md-dialog-content><md-dialog-actions layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-button \ndata-ng-disabled=\"newTransportationForm.$invalid || isClicked\" type=\"submit\" ng-click=\"saveNewTransportation()\" \nclass=\"send-button md-accent md-raised\" aria-label=\"Add Task\">שמירה</md-button></div></md-dialog-actions></form>\n</md-dialog>");
$templateCache.put("app/main/pages/users/views/parents/parents-profile/tabs/subsidy/subsidy-dialog/subsidy-dialog.html","<md-dialog class=\"subsidy-dialog\" aria-label=\"New Task\" style=\"min-width: 1000px\"><form name=\"newCoordinatorsForm\" \ndata-ng-model=\"newCoordinatorsForm\" class=\"md-inline-form\" validate><md-toolbar class=\"md-accent\" layout=\"column\"><div \nclass=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">\nבקשת סבסוד</span><md-button class=\"md-icon-button\" ng-click=\"closeDialog()\" aria-label=\"Close dialog\" translate \ntranslate-attr-aria-label=\"MANAGE_USERS.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-tabs md-dynamic-height md-selected=\"selectedTab\" ng-if=\"+subsidy.typeForm === 1\"><md-tab>\n<md-tab-label><span>פרטי ילדים</span></md-tab-label><md-tab-body><md-content class=\"about-tab\" style=\"padding: 50px\" \nng-include=\"\'app/main/pages/users/views/parents/parents-profile/tabs/subsidy/subsidy-dialog/tabs/kids.html\'\">\n</md-content></md-tab-body></md-tab><md-tab><md-tab-label><span>מצב כלכלי</span></md-tab-label><md-tab-body><md-content\n class=\"about-tab\" style=\"padding: 50px\" \nng-include=\"\'app/main/pages/users/views/parents/parents-profile/tabs/subsidy/subsidy-dialog/tabs/economic.html\'\">\n</md-content></md-tab-body></md-tab><md-tab><md-tab-label><span>פרטי עיסוק</span></md-tab-label><md-tab-body>\n<md-content class=\"about-tab\" style=\"padding: 50px\" \nng-include=\"\'app/main/pages/users/views/parents/parents-profile/tabs/subsidy/subsidy-dialog/tabs/occupation.html\'\">\n</md-content></md-tab-body></md-tab><md-tab><md-tab-label><span>הכנסות נוספות</span></md-tab-label><md-tab-body>\n<md-content class=\"about-tab\" style=\"padding: 50px\" \nng-include=\"\'app/main/pages/users/views/parents/parents-profile/tabs/subsidy/subsidy-dialog/tabs/revenue.html\'\">\n</md-content></md-tab-body></md-tab><md-tab><md-tab-label><span>סיבות לבקשה וקבצים</span></md-tab-label><md-tab-body>\n<md-content class=\"about-tab\" style=\"padding: 50px\" \nng-include=\"\'app/main/pages/users/views/parents/parents-profile/tabs/subsidy/subsidy-dialog/tabs/details.html\'\">\n</md-content></md-tab-body></md-tab><md-tab><md-tab-label><span>שימוש פנימי</span></md-tab-label><md-tab-body>\n<md-content class=\"about-tab\" style=\"padding: 50px\" \nng-include=\"\'app/main/pages/users/views/parents/parents-profile/tabs/subsidy/subsidy-dialog/tabs/internal.html\'\">\n</md-content></md-tab-body></md-tab></md-tabs><md-tabs md-dynamic-height md-selected=\"selectedTab\" \nng-if=\"+subsidy.typeForm === 2\"><md-tab><md-tab-label><span>פרטי הטופס</span></md-tab-label><md-tab-body><md-content \nclass=\"general-tab\" style=\"padding: 50px\" \nng-include=\"\'app/main/pages/users/views/parents/parents-profile/tabs/subsidy/subsidy-dialog/form2/formtype2.html\'\">\n</md-content></md-tab-body></md-tab><md-tab><md-tab-label><span>שימוש פנימי</span></md-tab-label><md-tab-body>\n<md-content class=\"about-tab\" style=\"padding: 50px\" \nng-include=\"\'app/main/pages/users/views/parents/parents-profile/tabs/subsidy/subsidy-dialog/tabs/internal.html\'\">\n</md-content></md-tab-body></md-tab></md-tabs><md-tabs md-dynamic-height md-selected=\"selectedTab\" \nng-if=\"+subsidy.typeForm === 3\"><md-tab><md-tab-label><span>פרטי הטופס</span></md-tab-label><md-tab-body><md-content \nclass=\"general-tab\" style=\"padding: 50px\" \nng-include=\"\'app/main/pages/users/views/parents/parents-profile/tabs/subsidy/subsidy-dialog/form3/formtype3.html\'\">\n</md-content></md-tab-body></md-tab><md-tab><md-tab-label><span>פרטי ההורים</span></md-tab-label><md-tab-body>\n<md-content class=\"general-tab\" style=\"padding: 50px\" \nng-include=\"\'app/main/pages/users/views/parents/parents-profile/tabs/subsidy/subsidy-dialog/form3/formtype3Parents.html\'\">\n</md-content></md-tab-body></md-tab><md-tab><md-tab-label><span>שימוש פנימי</span></md-tab-label><md-tab-body>\n<md-content class=\"about-tab\" style=\"padding: 50px\" \nng-include=\"\'app/main/pages/users/views/parents/parents-profile/tabs/subsidy/subsidy-dialog/tabs/internal.html\'\">\n</md-content></md-tab-body></md-tab></md-tabs></form></md-dialog>");
$templateCache.put("app/main/pages/users/views/students/student-profile/tabs/educator-groups/new-educator-group-dialog/new-educator-group-dialog.html","<md-dialog class=\"newParent-dialog\" aria-label=\"New Task\" ng-init=\"vm.getBreaches()\"><form name=\"newParentForm\" \ndata-ng-model=\"newParentForm\" class=\"md-inline-form\" validate><md-toolbar class=\"md-accent\" layout=\"column\"><div \nclass=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">\nשיוך {{$root.User.Group}}</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" \naria-label=\"Close dialog\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content ms-scroll><div><md-input-container class=\"md-block\"><label>בחר {{$root.User.Branch}}</label><md-icon\n md-font-icon=\"icon-city\" class=\"name\"></md-icon><md-select md-on-close=\"vm.clearSearchTerm()\" \nng-change=\"vm.getGroupsByBranch()\" ng-model=\"vm.newGroup.BranchID\" ng-disabled=\"!vm.branches || vm.isClicked\" required>\n<md-select-header class=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" type=\"text\" \nng-disabled=\"!vm.branches || vm.isClicked\" ng-keydown=\"$event.stopPropagation()\" \nplaceholder=\"חפש {{$root.User.Branch}}..\" class=\"demo-header-searchbox md-text\" autocomplete=\"off\"></md-select-header>\n<md-optgroup ng-disabled=\"!vm.branches || isClicked\"><md-option ng-value=\"branch.ID\" \nng-repeat=\"branch in vm.branches |filter:vm.searchTerm\">{{branch.Name}}</md-option></md-optgroup></md-select>\n</md-input-container><md-input-container class=\"md-block\"><label>בחר {{$root.User.Group}}</label><md-icon \nmd-font-icon=\"icon-account-multiple\" class=\"name\"></md-icon><md-select md-on-close=\"vm.clearSearchTerm2()\" \nng-model=\"vm.newGroup.GroupID\" ng-disabled=\"!vm.groups || vm.isClicked\" required><md-select-header \nclass=\"demo-select-header\"><input ng-model=\"vm.searchTerm2\" type=\"text\" ng-disabled=\"!vm.groups || vm.isClicked\" \nng-keydown=\"$event.stopPropagation()\" placeholder=\"חפש {{$root.User.Group}}..\" class=\"demo-header-searchbox md-text\" \nautocomplete=\"off\"></md-select-header><md-optgroup ng-disabled=\"!groups || isClicked\"><md-option ng-value=\"group.ID\" \nng-repeat=\"group in vm.groups |filter:vm.searchTerm2\">{{group.Name}}</md-option></md-optgroup></md-select>\n</md-input-container></div></md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><div\n layout=\"row\" layout-align=\"start center\"><md-button ng-disabled=\"newParentForm.$invalid || vm.isClicked\" \ntype=\"submit\" ng-click=\"vm.addGroup()\" class=\"send-button md-accent md-raised\" aria-label=\"Add Task\">שמירה</md-button>\n</div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/pages/events/views/events/event-management/tabs/discounts/tabs/general-discount-panel/general-discount-panel.html","<md-content ms-scroll ng-init=\"getTags()\"><form name=\"generalDiscountForm\" id=\"generalDiscountForm\" \ndata-ng-model=\"generalDiscountForm\" class=\"md-inline-form\" validate><md-toolbar class=\"md-accent\" layout=\"column\"><div \nclass=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">\nהנחה כללית</span><md-button class=\"md-icon-button\" ng-click=\"$root.closePanel()\" aria-label=\"Close Dialog\" translate \ntranslate-attr-aria-label=\"PROFILE_PANEL.CLOSE_PANEL\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-input-container class=\"md-icon-float md-block md-icon-left\"><label>רמה</label><md-select \nng-model=\"editedGeneralDiscount.Level\" ng-disabled=\"true\"><md-option ng-value=\"1\" \nng-selected=\"generalDiscount.Level==1\">בודדת</md-option><md-option ng-value=\"2\" ng-selected=\"generalDiscount.Level==2\">\nמרובה</md-option></md-select></md-input-container><md-input-container class=\"md-block\"><label>תגית חניך</label>\n<md-select ng-model=\"generalDiscount.Tags\" multiple=\"multiple\" ng-disabled=\"true\"><md-option ng-value=\"tag\" \nng-repeat=\"tag in Tags\">{{tag}}</md-option></md-select></md-input-container><md-input-container \nclass=\"md-icon-float md-block md-icon-left\"><label>{{$root.User.Branches}}</label><md-select \nng-model=\"editedGeneralDiscount.Branches\" multiple=\"multiple\" ng-disabled=\"true\"><md-option \nng-repeat=\"branch in generalDiscount.Branches\" ng-selected=\"branch.Active\" ng-value=\"branch\">{{branch.Name}}\n</md-option></md-select></md-input-container><md-input-container class=\"md-icon-float md-block md-icon-left\"><label>\n{{$root.User.Event}}</label><md-select ng-model=\"editedGeneralDiscount.ParentEvent\" ng-disabled=\"true\"><md-option>ללא\n</md-option><md-option ng-repeat=\"event in generalDiscount.Events\" ng-selected=\"event.Active\" ng-value=\"event\">\n{{event.Name}}</md-option></md-select></md-input-container><md-input-container \nclass=\"md-icon-float md-block md-icon-left\"><label>אזור</label><md-select ng-model=\"editedGeneralDiscount.Areas\" \nmultiple=\"multiple\" ng-disabled=\"true\"><md-option ng-repeat=\"area in generalDiscount.Areas\" ng-selected=\"area.Active\" \nng-value=\"area\">{{area.Name}}</md-option></md-select></md-input-container><md-input-container \nclass=\"md-icon-float md-block md-icon-left\"><label>{{$root.User.Groups}}</label><md-select \nng-model=\"editedGeneralDiscount.Grades\" multiple=\"multiple\" ng-disabled=\"true\"><md-option \nng-repeat=\"grade in generalDiscount.Grades\" ng-selected=\"grade.Active\" ng-value=\"grade\">{{grade.Name}}</md-option>\n</md-select></md-input-container><md-input-container class=\"md-block md-icon-float md-block md-icon-left\"><label>\nסכום הנחה</label><input type=\"text\" ng-model=\"editedGeneralDiscount.Discount\" ng-value=\"generalDiscount.Discount\" \nng-disabled=\"true\" ng-required=\"true\" ng-pattern=\"/^\\d+$/\" placeholder=\"יש להכניס מספר שלם\"></md-input-container>\n<md-input-container class=\"md-block md-icon-float md-block md-icon-left\"><label>הנחה עבור הרשמה ראשונית לדמי חבר\n</label><input type=\"text\" ng-model=\"editedGeneralDiscount.NewMemberPay\" \nng-value=\"generalDiscount.NewMemberPay==1 ? \'כן\' : \'לא\'\" ng-disabled=\"true\" ng-required=\"true\"></md-input-container>\n<md-input-container class=\"md-block md-icon-float md-block md-icon-left\"><label>הנחה בלחיצת כפתור</label><input \ntype=\"text\" ng-model=\"editedGeneralDiscount.OnClickDiscount\" \nng-value=\"generalDiscount.OnClickDiscount==1 ? \'כן\' : \'לא\'\" ng-disabled=\"true\" ng-required=\"true\"></md-input-container>\n<md-input-container class=\"md-block md-icon-float md-block md-icon-left\" ng-if=\"generalDiscount.OnClickDiscount == 1\">\n<label>תיאור הנחה בלחיצת כפתור</label><input ng-model=\"generalDiscount.OnClickDiscountDescription\" \nplaceholder=\"תיאור הנחה בלחיצת כפתור\" ng-required=\"generalDiscount.OnClickDiscount == 1\" disabled=\"disabled\">\n</md-input-container><md-input-container class=\"md-icon-float md-block md-icon-left\"><label>סוג</label><md-select \nng-model=\"editedGeneralDiscount.Type\" ng-disabled=\"true\" ng-required=\"true\"><md-option ng-value=\"1\" \nng-selected=\"generalDiscount.Type==1\">ש\"ח</md-option><md-option ng-value=\"2\" ng-selected=\"generalDiscount.Type==2\">\nאחוזים</md-option></md-select></md-input-container><md-input-container class=\"md-icon-float md-block md-icon-left\">\n<label>סטטוס</label><md-select ng-model=\"editedGeneralDiscount.Status\" ng-disabled=\"true\" ng-required=\"true\"><md-option\n ng-value=\"1\" ng-selected=\"generalDiscount.Status==1\">פעיל</md-option><md-option ng-value=\"0\" \nng-selected=\"generalDiscount.Status==0\">לא פעיל</md-option></md-select></md-input-container></form></md-content>");
$templateCache.put("app/main/pages/events/views/events/event-management/tabs/discounts/tabs/new-brother-discount-dialog/new-brother-discount-dialog.html","<md-dialog class=\"newBrotherDiscount-dialog\" aria-label=\"New Task\" ng-init=\"getAllInformation()\"><form \nname=\"newBrotherDiscountForm\" data-ng-model=\"newBrotherDiscountForm\" class=\"md-inline-form\" validate><md-toolbar \nclass=\"md-accent\" layout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" \nlayout-align=\"space-between center\"><span class=\"title\">הוספת הנחת אחים חדשה</span><md-button class=\"md-icon-button\" \nng-click=\"closeDialog()\" aria-label=\"Close dialog\" title=\"הוספת הנחה\"><md-icon md-font-icon=\"icon-close\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content ms-scroll><div><md-input-container class=\"md-block\"><label>רמה\n</label><md-select ng-model=\"newBrotherDiscount.Level\" ng-required=\"true\" ng-disabled=\"isClicked\"><md-option value=\"1\">\nבודדת</md-option><md-option value=\"2\">מרובה</md-option></md-select></md-input-container><md-input-container \nclass=\"md-block\"><label>הכנס/י סכום/אחוזים</label><input type=\"text\" ng-model=\"newBrotherDiscount.Discount\" \nng-pattern=\"/^\\d+$/\" placeholder=\"יש להכניס מספר שלם\" ng-required=\"true\" ng-disabled=\"isClicked\"></md-input-container>\n<md-input-container class=\"md-block\"><label>סוג</label><md-select ng-model=\"newBrotherDiscount.Type\" \nng-required=\"true\" ng-disabled=\"isClicked\"><md-option value=\"1\">ש\"ח</md-option><md-option value=\"2\">אחוזים</md-option>\n</md-select></md-input-container><md-input-container class=\"md-block\"><label>סטטוס</label><md-select \nng-model=\"newBrotherDiscount.Status\" ng-required=\"true\" ng-disabled=\"isClicked\"><md-option value=\"1\">פעיל</md-option>\n<md-option value=\"0\">לא פעיל</md-option></md-select></md-input-container></div></md-dialog-content><md-dialog-actions \nlayout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-button \ndata-ng-disabled=\"newBrotherDiscountForm.$invalid || isClicked\" type=\"submit\" ng-click=\"saveNewBrotherDiscount()\" \nclass=\"send-button md-accent md-raised\" aria-label=\"Add Task\">שמירה</md-button></div></md-dialog-actions></form>\n</md-dialog>");
$templateCache.put("app/main/pages/events/views/events/event-management/tabs/discounts/tabs/new-general-discount-dialog/new-general-discount-dialog.html","<md-dialog class=\"newGeneralDiscount-dialog\" aria-label=\"New Task\" ng-init=\"getAllInformation()\"><form \nname=\"newGeneralDiscountForm\" data-ng-model=\"newGeneralDiscountForm\" class=\"md-inline-form\" validate><md-toolbar \nclass=\"md-accent\" layout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" \nlayout-align=\"space-between center\"><span class=\"title\">הוספת הנחה כללית חדשה</span><md-button class=\"md-icon-button\" \nng-click=\"closeDialog()\" aria-label=\"Close dialog\" title=\"הוספת הנחה\"><md-icon md-font-icon=\"icon-close\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content ms-scroll><div layout=\"row\" layout-sm=\"column\" \nlayout-align=\"space-around\" ng-show=\"endpointsReady<3\"><md-progress-circular md-mode=\"indeterminate\">\n</md-progress-circular></div><div ng-show=\"endpointsReady>=3\"><md-input-container class=\"md-block\"><label>רמה</label>\n<md-select ng-model=\"newGeneralDiscount.Level\" ng-required=\"true\" ng-disabled=\"isClicked\"><md-option value=\"1\">בודדת\n</md-option><md-option value=\"2\">מרובה</md-option></md-select></md-input-container><md-input-container \nclass=\"md-block\" ng-if=\"endpointData.Tags && endpointData.Tags.length\"><label>תגית חניך</label><md-select \nng-model=\"newGeneralDiscount.Tags\" multiple=\"multiple\" ng-disabled=\"isClicked\"><md-option ng-value=\"tag\" \nng-repeat=\"tag in endpointData.Tags\">{{tag}}</md-option></md-select></md-input-container><md-input-container \nclass=\"md-block\"><label>{{$root.User.Branches}}</label><md-select ng-model=\"newGeneralDiscount.Branches\" \nmultiple=\"multiple\" ng-disabled=\"isClicked\"><md-option ng-value=\"branch\" ng-repeat=\"branch in endpointData.Branches\">\n{{branch.Name}}</md-option></md-select></md-input-container><md-input-container class=\"md-block\"><label>\nרשום ל{{$root.User.Event}}</label><md-select md-on-close=\"clearSearchTerm()\" \nng-model=\"newGeneralDiscount.ParentEventID\" ng-disabled=\"isClicked\"><md-select-header class=\"demo-select-header\"><input\n ng-model=\"searchTerm\" type=\"text\" ng-disabled=\"isClicked\" ng-model-options=\"{debounce: 750}\" \nng-keydown=\"$event.stopPropagation()\" ng-change=\"getEvents()\" placeholder=\"חפש {{$root.User.Event}}..\" \nclass=\"demo-header-searchbox md-text\" autocomplete=\"off\"></md-select-header><md-optgroup ng-disabled=\"isClicked\" \nng-disabled=\"isClicked\"><md-option>ללא</md-option><md-option ng-value=\"event\" ng-repeat=\"event in endpointData.Events\">\n{{event.Name}}</md-option></md-optgroup></md-select></md-input-container><md-input-container class=\"md-block\"><label>\nאזור</label><md-select ng-model=\"newGeneralDiscount.Areas\" multiple=\"multiple\" ng-disabled=\"isClicked\"><md-option \nng-value=\"area\" ng-repeat=\"area in endpointData.Areas\">{{area.Name}}</md-option></md-select></md-input-container>\n<md-input-container class=\"md-block\"><label>{{$root.User.Grades}}</label><md-select \nng-model=\"newGeneralDiscount.Grades\" multiple=\"multiple\" ng-disabled=\"!endpointData.Grades || isClicked\"><md-option \nng-value=\"grade\" ng-repeat=\"grade in endpointData.Grades\">{{grade.Name}}</md-option></md-select></md-input-container>\n<md-input-container class=\"md-block\" ng-if=\"$root.ExternalDiscountEnabled\"><label>הנחת חברות חיצונית</label><md-select \nng-model=\"newGeneralDiscount.ExternalDiscount\" ng-required=\"true\" ng-disabled=\"isClicked\"><md-option value=\"1\">פעיל\n</md-option><md-option value=\"0\">לא פעיל</md-option></md-select></md-input-container><md-input-container \nclass=\"md-block\"><label>הכנס/י סכום/אחוזים</label><input type=\"text\" ng-model=\"newGeneralDiscount.Discount\" \nng-pattern=\"/^\\d+$/\" placeholder=\"יש להכניס מספר שלם\" ng-required=\"true\" ng-disabled=\"isClicked\"></md-input-container>\n<md-input-container class=\"md-block\"><label>סוג</label><md-select ng-model=\"newGeneralDiscount.Type\" \nng-required=\"true\" ng-disabled=\"isClicked\"><md-option value=\"1\">ש\"ח</md-option><md-option value=\"2\">אחוזים</md-option>\n</md-select></md-input-container><md-input-container class=\"md-block\"><label>הנחה עבור הרשמה ראשונית לדמי חבר</label>\n<md-select ng-model=\"newGeneralDiscount.NewMemberPay\" ng-required=\"true\" ng-disabled=\"isClicked\"><md-option value=\"1\">\nכן</md-option><md-option value=\"0\">לא</md-option></md-select></md-input-container><md-input-container class=\"md-block\">\n<label>הנחה בלחיצת כפתור</label><md-select ng-model=\"newGeneralDiscount.OnClickDiscount\" ng-required=\"true\" \nng-disabled=\"isClicked\"><md-option value=\"1\">כן</md-option><md-option value=\"0\">לא</md-option></md-select>\n</md-input-container><md-input-container class=\"md-block\" ng-if=\"newGeneralDiscount.OnClickDiscount == 1\"><label>\nתיאור הנחה בלחיצת כפתור</label><textarea ng-model=\"newGeneralDiscount.OnClickDiscountDescription\" \nplaceholder=\"תיאור הנחה בלחיצת כפתור\" ng-required=\"newGeneralDiscount.OnClickDiscount == 1\" ng-disabled=\"isClicked\">\n</textarea></md-input-container><md-input-container class=\"md-block\"><label>סטטוס</label><md-select \nng-model=\"newGeneralDiscount.Status\" ng-required=\"true\" ng-disabled=\"isClicked\"><md-option value=\"1\">פעיל</md-option>\n<md-option value=\"0\">לא פעיל</md-option></md-select></md-input-container></div></md-dialog-content><md-dialog-actions \nlayout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-button \ndata-ng-disabled=\"newGeneralDiscountForm.$invalid || isClicked\" type=\"submit\" ng-click=\"saveNewGeneralDiscount()\" \nclass=\"send-button md-accent md-raised\" aria-label=\"Add Task\">שמירה</md-button></div></md-dialog-actions></form>\n</md-dialog>");
$templateCache.put("app/main/pages/events/views/events/event-management/tabs/discounts/tabs/new-date-discount-dialog/new-date-discount-dialog.html","<md-dialog class=\"newSDateDiscount-dialog\" aria-label=\"New Task\"><form name=\"newDateDiscountForm\" \ndata-ng-model=\"newDateDiscountForm\" class=\"md-inline-form\" validate><md-toolbar class=\"md-accent\" layout=\"column\"><div \nclass=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">\nהוספת הנחה לפי תאריך</span><md-button class=\"md-icon-button\" ng-click=\"closeDialog()\" aria-label=\"Close dialog\" \ntitle=\"הוספת הנחה\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content \nms-scroll><div><md-input-container class=\"md-block\"><label>תאריך התחלת הנחה</label><div start-view=\"day\" locale=\"he\" \nformat=\"DD/MM/YYYY\" moment-picker=\"newDateDiscount.FromDate\"><input class=\"md-input\" autocomplete=\"off\" \nng-model=\"newDateDiscount.FromDate\" required ng-disabled=\"isClicked\"></div></md-input-container><md-input-container \nclass=\"md-block\"><label>תאריך סיום הנחה</label><div start-view=\"day\" locale=\"he\" format=\"DD/MM/YYYY\" \nmoment-picker=\"newDateDiscount.ToDate\"><input autocomplete=\"off\" ng-model=\"newDateDiscount.ToDate\" required \nng-disabled=\"isClicked\"></div></md-input-container><md-input-container class=\"md-block\"><label>רמה</label><md-select \nng-model=\"newDateDiscount.Level\" ng-required=\"true\" ng-disabled=\"isClicked\"><md-option value=\"1\">בודדת</md-option>\n<md-option value=\"2\">מרובה</md-option></md-select></md-input-container><md-input-container class=\"md-block\"><label>סוג\n</label><md-select ng-model=\"newDateDiscount.Type\" ng-required=\"true\" ng-disabled=\"isClicked\"><md-option value=\"1\">ש\"ח\n</md-option><md-option value=\"2\">אחוזים</md-option></md-select></md-input-container><md-input-container \nclass=\"md-block\"><label>הכנס/י סכום/אחוזים</label><input type=\"text\" ng-model=\"newDateDiscount.Discount\" \nng-pattern=\"/^\\d+$/\" placeholder=\"יש להכניס מספר שלם\" ng-required=\"true\" ng-disabled=\"isClicked\"></md-input-container>\n<md-input-container class=\"md-block\"><label>סטטוס</label><md-select ng-model=\"newDateDiscount.Status\" \nng-required=\"true\" ng-disabled=\"isClicked\"><md-option value=\"1\">פעיל</md-option><md-option value=\"0\">לא פעיל\n</md-option></md-select></md-input-container></div></md-dialog-content><md-dialog-actions layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-button \ndata-ng-disabled=\"newDateDiscountForm.$invalid || isClicked\" type=\"submit\" ng-click=\"saveDateDiscount()\" \nclass=\"send-button md-accent md-raised\" aria-label=\"Add Task\">שמירה</md-button></div></md-dialog-actions></form>\n</md-dialog>");
$templateCache.put("app/main/pages/events/views/events/event-management/tabs/discounts/tabs/new-student-discount-dialog/new-student-discount-dialog.html","<md-dialog class=\"newStudentDiscount-dialog\" aria-label=\"New Task\"><form name=\"newStudentDiscountForm\" \ndata-ng-model=\"newStudentDiscountForm\" class=\"md-inline-form\" validate><md-toolbar class=\"md-accent\" layout=\"column\">\n<div class=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"title\">הוספת הנחת חניך</span><md-button class=\"md-icon-button\" ng-click=\"closeDialog()\" \naria-label=\"Close dialog\" title=\"הוספת הנחה\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content ms-scroll><div><md-input-container class=\"md-block\" ng-if=\"!withFile\"><label>ת.ז החניך\n</label><input type=\"text\" ng-model=\"newStudentDiscount.StudentID\" ng-required=\"true\" ng-disabled=\"isClicked\">\n</md-input-container><md-input-container class=\"md-block\"><label>רמה</label><md-select \nng-model=\"newStudentDiscount.Level\" ng-required=\"true\" ng-disabled=\"isClicked\"><md-option value=\"1\">בודדת</md-option>\n<md-option value=\"2\">מרובה</md-option></md-select></md-input-container><md-input-container class=\"md-block\"><label>סוג\n</label><md-select ng-model=\"newStudentDiscount.Type\" ng-required=\"true\" ng-disabled=\"isClicked\"><md-option value=\"1\">\nש\"ח</md-option><md-option value=\"2\">אחוזים</md-option></md-select></md-input-container><md-input-container \nclass=\"md-block\"><label>הכנס/י סכום/אחוזים</label><input type=\"text\" ng-model=\"newStudentDiscount.Discount\" \nng-pattern=\"/^\\d+$/\" placeholder=\"יש להכניס מספר שלם\" ng-required=\"true\" ng-disabled=\"isClicked\"></md-input-container>\n<md-input-container class=\"md-block\"><label>סטטוס</label><md-select ng-model=\"newStudentDiscount.Status\" \nng-required=\"true\" ng-disabled=\"isClicked\"><md-option value=\"1\">פעיל</md-option><md-option value=\"0\">לא פעיל\n</md-option></md-select></md-input-container></div></md-dialog-content><md-dialog-actions layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-button \ndata-ng-disabled=\"newStudentDiscountForm.$invalid || isClicked\" type=\"submit\" ng-click=\"saveNewStudentDiscount()\" \nclass=\"send-button md-accent md-raised\" aria-label=\"Add Task\">שמירה</md-button></div></md-dialog-actions></form>\n</md-dialog>");
$templateCache.put("app/main/pages/events/views/events/event-management/tabs/external-subscribers/full-external-registration-dialog/tabs/cancel.html","<div layout=\"row\" layout-sm=\"column\" layout-align=\"space-around\" ng-show=\"!registrations\"><md-progress-circular \nmd-mode=\"indeterminate\"></md-progress-circular></div><div ng-show=\"registrations\"><form name=\"PaymentForm\" \ndata-ng-model=\"PaymentForm\" class=\"md-inline-form\"><div class=\"row\" layout=\"row\" \nng-if=\"registrations.Registration.Canceled\"><div layout=\"column\" flex=\"100\" flex-gt-sm=\"50\" flex-gt-md=\"50\">\n<md-input-container class=\"md-icon-float md-block\" layout=\"column\" layout-xs=\"row\" flex=\"100\" flex-xs=\"100\" \nflex-gt-sm=\"100\" flex-gt-md=\"100\"><md-icon md-svg-icon=\"calendar\" class=\"name\"></md-icon><label>תאריך ביטול</label>\n<input ng-if=\"registrations.Registration.Canceled\" \nng-value=\"registrations.Registration.Canceled*1000 | date:\'HH:mm:ss dd/MM/yyyy\'\" ng-disabled=\"true\">\n</md-input-container></div><div layout=\"column\" flex=\"100\" flex-gt-sm=\"50\" flex-gt-md=\"50\"><md-input-container \nclass=\"md-block\"><md-icon md-svg-icon=\"file-document-box\" class=\"name\"></md-icon><label>סיבת ביטול</label><textarea \nng-model=\"registrations.Registration.CanceledComment\" ng-disabled=\"true\"></textarea></md-input-container></div></div>\n<div class=\"row\" layout=\"row\" ng-if=\"registrations.Registration.RefundDate\"><div layout=\"column\" flex=\"100\" \nflex-gt-sm=\"50\" flex-gt-md=\"50\"><md-input-container class=\"md-icon-float md-block\" layout=\"column\" layout-xs=\"row\" \nflex=\"100\" flex-xs=\"100\" flex-gt-sm=\"100\" flex-gt-md=\"100\"><md-icon md-svg-icon=\"cash-multiple\" class=\"name\"></md-icon>\n<label>סכום זיכוי</label><input ng-if=\"registrations.Registration.RefundSum\" \nng-value=\"registrations.Registration.RefundSum\" ng-disabled=\"true\"></md-input-container></div><div layout=\"column\" \nflex=\"100\" flex-gt-sm=\"50\" flex-gt-md=\"50\"><md-input-container class=\"md-block\"><md-icon md-svg-icon=\"cash\" \nclass=\"name\"></md-icon><label>אמצעי תשלום זיכוי</label><input ng-model=\"registrations.Registration.RefundPaymentType\" \nng-disabled=\"true\"></md-input-container></div></div><div class=\"row\" layout=\"row\" \nng-if=\"registrations.Registration.RefundDate\"><div layout=\"column\" flex=\"100\" flex-gt-sm=\"50\" flex-gt-md=\"50\">\n<md-input-container class=\"md-icon-float md-block\" layout=\"column\" layout-xs=\"row\" flex=\"100\" flex-xs=\"100\" \nflex-gt-sm=\"100\" flex-gt-md=\"100\"><md-icon md-svg-icon=\"calendar\" class=\"name\"></md-icon><label>תאריך זיכוי</label>\n<input ng-if=\"registrations.Registration.RefundDate\" \nng-value=\"registrations.Registration.RefundDate*1000 | date:\'HH:mm:ss dd/MM/yyyy\'\" ng-disabled=\"true\">\n</md-input-container></div><div layout=\"column\" flex=\"100\" flex-gt-sm=\"50\" flex-gt-md=\"50\"><md-input-container \nclass=\"md-block\"><md-icon md-svg-icon=\"file-document-box\" class=\"name\"></md-icon><label>סיבת זיכוי</label><textarea \nng-model=\"registrations.Registration.RefundComment\" ng-disabled=\"true\"></textarea></md-input-container></div></div>\n</form></div>");
$templateCache.put("app/main/pages/events/views/events/event-management/tabs/external-subscribers/full-external-registration-dialog/tabs/logs.html","<div id=\"logs\" class=\"page-layout simple tabbed\"><div layout=\"row\" layout-sm=\"column\" layout-align=\"space-around\" \nng-if=\"!logs\" style=\"padding: 30px\"><md-progress-circular md-mode=\"indeterminate\"></md-progress-circular></div><div \nclass=\"content\" ng-if=\"logs\" style=\"padding: 30px\"><table id=\"logs-table\" \nclass=\"dataTable row-border hover stripe md-ink-ripple\" datatable=\"ng\" dt-instance=\"dtInstance\" dt-options=\"dtOptions\">\n<thead><th><div class=\"table-header\"><span class=\"column-title\">תאריך</span></div></th><th><div class=\"table-header\">\n<span class=\"column-title\">משתמש</span></div></th><th><div class=\"table-header\"><span class=\"column-title\">פעולה</span>\n</div></th><th><div class=\"table-header\"><span class=\"column-title\">ערך ישן</span></div></th><th><div \nclass=\"table-header\"><span class=\"column-title\">ערך חדש</span></div></th></thead><tbody><tr class=\"md-ink-ripple\" \nng-repeat=\"item in logs\" style=\"height: 35px\"><td>{{item.Date*1000 | date:\'HH:mm:ss dd/MM/yyyy\'}}</td><td>\n{{item.AdminName}}</td><td>{{item.Type}}</td><td>{{item.OldValue}}</td><td>{{item.NewValue}}</td></tr></tbody></table>\n</div></div>");
$templateCache.put("app/main/pages/events/views/events/event-management/tabs/external-subscribers/full-external-registration-dialog/tabs/paymnet.html","<div layout=\"row\" layout-sm=\"column\" layout-align=\"space-around\" ng-show=\"!registrations\"><md-progress-circular \nmd-mode=\"indeterminate\"></md-progress-circular></div><div ng-show=\"registrations\"><form name=\"PaymentForm\" \ndata-ng-model=\"PaymentForm\" class=\"md-inline-form\"><div class=\"row\" layout=\"row\"><div layout=\"column\" flex=\"100\" \nflex-gt-sm=\"100\" flex-gt-md=\"100\"><md-input-container class=\"md-block\"><md-icon md-svg-icon=\"cash\" class=\"name\">\n</md-icon><label>אמצעי תשלום</label><md-select ng-required=\"true\" ng-model=\"registrations.Registration.PaymentType\" \nng-disabled=\"isClicked || $root.AdminLevel!=3 || registrations.Registration.PaymentStatus || registrations.Registration.PaymentStatus\" \nng-change=\"getBanks()\" placeholder=\"אמצעי תשלום\"><md-option ng-value=\"0\">ללא חיוב</md-option><md-option ng-value=\"1\" \nng-disabled=\"true\">אשראי</md-option><md-option ng-value=\"2\">מזומן</md-option><md-option ng-value=\"3\">העברה בנקאית\n</md-option><md-option ng-value=\"4\">המחאה</md-option><md-option ng-value=\"5\">טופס התחייבות</md-option></md-select>\n</md-input-container></div></div><div class=\"row\" layout=\"row\" ng-show=\"registrations.Registration.PaymentType==3\"><div\n layout=\"column\" flex=\"100\" flex-gt-sm=\"50\" flex-gt-md=\"50\"><md-input-container class=\"md-icon-float md-block\" \nlayout=\"column\" layout-xs=\"row\" flex=\"100\" flex-xs=\"100\" flex-gt-sm=\"100\" flex-gt-md=\"100\"><md-icon \nmd-svg-icon=\"account\" class=\"name\"></md-icon><label>שם בעל החשבון</label><input \nng-model=\"registrations.Registration.AccountName\" \nng-disabled=\"isClicked || $root.AdminLevel!=3 || registrations.Registration.PaymentStatus \" \nng-required=\"registrations.Registration.PaymentType==3\"></md-input-container></div><div layout=\"column\" flex=\"100\" \nflex-gt-sm=\"50\" flex-gt-md=\"50\"><md-input-container class=\"md-block\"><md-icon md-svg-icon=\"numeric\" class=\"name\">\n</md-icon><label>מספר בנק</label><input ng-model=\"registrations.Registration.BankNumber\" \nng-disabled=\"isClicked || $root.AdminLevel!=3 || registrations.Registration.PaymentStatus\" \nng-required=\"registrations.Registration.PaymentType==3\"></md-input-container></div></div><div class=\"row\" layout=\"row\" \nng-show=\"registrations.Registration.PaymentType==3\"><div layout=\"column\" flex=\"100\" flex-gt-sm=\"50\" flex-gt-md=\"50\">\n<md-input-container class=\"md-icon-float md-block\" layout=\"column\" layout-xs=\"row\" flex=\"100\" flex-xs=\"100\" \nflex-gt-sm=\"100\" flex-gt-md=\"100\"><md-icon md-svg-icon=\"numeric\" class=\"name\"></md-icon><label>מספר סניף</label><input \nng-model=\"registrations.Registration.BranchNumber\" \nng-disabled=\"isClicked || $root.AdminLevel!=3 || registrations.Registration.PaymentStatus\" \nng-required=\"registrations.Registration.PaymentType==3\"></md-input-container></div><div layout=\"column\" flex=\"100\" \nflex-gt-sm=\"50\" flex-gt-md=\"50\"><md-input-container class=\"md-block\"><md-icon md-svg-icon=\"numeric\" class=\"name\">\n</md-icon><label>מספר חשבון</label><input ng-model=\"registrations.Registration.AccountNumber\" \nng-disabled=\"isClicked || $root.AdminLevel!=3 || registrations.Registration.PaymentStatus\" \nng-required=\"registrations.Registration.PaymentType==3\"></md-input-container></div></div><div class=\"row\" layout=\"row\" \nng-show=\"registrations.Registration.PaymentType==3\"><div layout=\"column\" flex=\"100\" flex-gt-sm=\"50\" flex-gt-md=\"50\">\n<md-input-container class=\"md-icon-float md-block\" layout=\"column\" layout-xs=\"row\" flex=\"100\" flex-xs=\"100\" \nflex-gt-sm=\"100\" flex-gt-md=\"100\"><md-icon class=\"name\"></md-icon><label>בנק</label><md-icon md-svg-icon=\"bank\" \nclass=\"name\"></md-icon><md-select ng-model=\"registrations.Registration.BrandAccountNumber\" \nng-disabled=\"!banks || isClicked || $root.AdminLevel!=3\"><md-option ng-repeat=\"bank in banks\" ng-value=\"bank.Number\">\n{{bank.Name}}</md-option></md-select></md-input-container></div></div><div class=\"row\" layout=\"row\" \nng-show=\"registrations.Registration.PaymentType==4\"><div layout=\"column\" flex=\"100\" flex-gt-sm=\"50\" flex-gt-md=\"50\">\n<md-input-container class=\"md-icon-float md-block\" layout=\"column\" layout-xs=\"row\" flex=\"100\" flex-xs=\"100\" \nflex-gt-sm=\"100\" flex-gt-md=\"100\"><md-icon md-svg-icon=\"account\" class=\"name\"></md-icon><label>שם בעל הצ\'ק</label>\n<input ng-model=\"registrations.Registration.CheckOwner\" \nng-disabled=\"isClicked || $root.AdminLevel!=3 || registrations.Registration.PaymentStatus\" \nng-required=\"registrations.Registration.PaymentType==4\"></md-input-container></div><div layout=\"column\" flex=\"100\" \nflex-gt-sm=\"50\" flex-gt-md=\"50\"><md-input-container class=\"md-icon-float md-block\" layout=\"column\" layout-xs=\"row\" \nflex=\"100\" flex-xs=\"100\" flex-gt-sm=\"100\" flex-gt-md=\"100\"><md-icon md-svg-icon=\"numeric\" class=\"name\"></md-icon>\n<label>מספר צ\'קים</label><input ng-model=\"registrations.Registration.NumberOfCheck\" \nng-disabled=\"isClicked || $root.AdminLevel!=3 || registrations.Registration.PaymentStatus\" \nng-required=\"registrations.Registration.PaymentType==4\"></md-input-container></div></div><div class=\"row\" layout=\"row\" \nng-show=\"registrations.Registration.PaymentType==4\"><div layout=\"column\" flex=\"100\" flex-gt-sm=\"50\" flex-gt-md=\"50\">\n<md-input-container class=\"md-icon-float md-block\" layout=\"column\" layout-xs=\"row\" flex=\"100\" flex-xs=\"100\" \nflex-gt-sm=\"100\" flex-gt-md=\"100\"><md-icon md-svg-icon=\"numeric\" class=\"name\"></md-icon><label>מספר צ\'ק ראשון</label>\n<input ng-model=\"registrations.Registration.CheckNumber\" \nng-disabled=\"isClicked || $root.AdminLevel!=3 || registrations.Registration.PaymentStatus\" \nng-required=\"registrations.Registration.PaymentType==4\"></md-input-container></div><div layout=\"column\" flex=\"100\" \nflex-gt-sm=\"50\" flex-gt-md=\"50\"><md-input-container class=\"md-icon-float md-block\" layout=\"column\" layout-xs=\"row\" \nflex=\"100\" flex-xs=\"100\" flex-gt-sm=\"100\" flex-gt-md=\"100\"><md-icon md-svg-icon=\"calendar\" class=\"name\"></md-icon>\n<label>מועד פרעון ראשון</label><input ng-required=\"registrations.Registration.PaymentType==4\" autocomplete=\"off\" \nng-disabled=\"isClicked || $root.AdminLevel!=3 || registrations.Registration.PaymentStatus\" \nng-model=\"registrations.Registration.CheckMaturityDate\"></md-input-container></div></div><md-button \nng-show=\"$root.AdminLevel==3\" type=\"submit\" \ndata-ng-disabled=\"isClicked || $root.AdminLevel!=3 || registrations.Registration.PaymentStatus || PaymentForm.$invalid\" \nclass=\"md-raised md-accent\" aria-label=\"חפש\" ng-click=\"updateRegistration(registrations.Registration)\">עדכון\n</md-button></form></div>");
$templateCache.put("app/main/pages/events/views/events/event-management/tabs/external-subscribers/full-external-registration-dialog/tabs/questions.html","<div layout=\"row\" layout-sm=\"column\" layout-align=\"space-around\" ng-if=\"!registrations\"><md-progress-circular \nmd-mode=\"indeterminate\"></md-progress-circular></div><div layout=\"row\" layout-sm=\"column\" layout-align=\"space-around\" \nng-if=\"registrations.Questions.length==0\"><span>לא קיימות שאלות</span></div><form name=\"UserForm\" \nclass=\"md-inline-form\" validate ng-if=\"registrations.Questions.length>0\"><div layout=\"row\" layout-wrap \nng-repeat=\"question in registrations.Questions\"><md-input-container class=\"md-icon-float md-block\" layout=\"column\" \nlayout-xs=\"row\" flex=\"100\"><md-icon style=\"cursor: pointer\" md-svg-icon=\"help-circle\" class=\"name\"></md-icon><label>\n{{question.Description}}</label><input ng-if=\"question.AnswerType==1\" ng-model=\"question.Answer\" \nng-disabled=\"isClicked || $root.AdminLevel<3\"><md-select ng-if=\"question.AnswerType==2\" ng-model=\"question.Answer\" \nng-disabled=\"isClicked || $root.AdminLevel<3\"><md-option ng-repeat=\"questionOption in question.Options\" \nng-value=\"questionOption\">{{questionOption}}</md-option></md-select><div ng-if=\"question.AnswerType==4\" \nstart-view=\"day\" locale=\"he\" format=\"DD/MM/YYYY\" moment-picker=\"question.Answer\"><input autocomplete=\"off\" \nng-model=\"question.Answer\" ng-disabled=\"isClicked || $root.AdminLevel<3\"></div></md-input-container><md-input-container\n class=\"md-icon-float md-block\" layout=\"column\" layout-xs=\"row\" flex=\"100\" ng-if=\"question.AnswerType==3\"><md-icon \nmd-svg-icon=\"download\" class=\"name\"></md-icon><label>{{question.Description}}</label><input style=\"cursor: pointer\" \nng-click=\"openFile(question.Answer)\" placeholder=\"לחצ\\י לצפייה בקובץ\" readonly=\"readonly\"></md-input-container></div>\n<md-button ng-if=\"$root.AdminLevel==3\" type=\"submit\" ng-disabled=\"isClicked\" class=\"md-raised md-accent\" \naria-label=\"חפש\" ng-click=\"updateQuestions(registrations.Questions)\">עדכון</md-button></form>");
$templateCache.put("app/main/pages/events/views/events/event-management/tabs/external-subscribers/full-external-registration-dialog/tabs/registration.html","<div layout=\"row\" layout-sm=\"column\" layout-align=\"space-around\" ng-if=\"!registrations\"><md-progress-circular \nmd-mode=\"indeterminate\"></md-progress-circular></div><div ng-if=\"registrations.Registration\"><form name=\"UserForm\" \nclass=\"md-inline-form\"><div class=\"row\" layout=\"row\"><div layout=\"column\" flex=\"100\" flex-gt-sm=\"50\" flex-gt-md=\"50\">\n<md-input-container class=\"md-block\"><md-icon md-svg-icon=\"account\" class=\"name\"></md-icon><label>שם</label><input \nng-value=\"orignalRegistration.Name\" ng-disabled=\"true\"></md-input-container></div><div layout=\"column\" flex=\"100\" \nflex-gt-sm=\"50\" flex-gt-md=\"50\"><md-input-container class=\"md-block\"><md-icon md-svg-icon=\"email\" class=\"name\">\n</md-icon><label>דוא\"ל</label><input ng-value=\"orignalRegistration.Email\" ng-disabled=\"true\"></md-input-container>\n</div></div><div class=\"row\" layout=\"row\"><div layout=\"column\" flex=\"100\" flex-gt-sm=\"50\" flex-gt-md=\"50\">\n<md-input-container class=\"md-block\"><md-icon md-svg-icon=\"phone\" class=\"name\"></md-icon><label>טלפון</label><input \nng-value=\"orignalRegistration.PhoneNumber\" ng-disabled=\"true\"></md-input-container></div></div><div class=\"row\" \nlayout=\"row\"><div layout=\"column\" flex=\"100\" flex-gt-sm=\"50\" flex-gt-md=\"50\"><md-input-container class=\"md-block\">\n<md-icon md-svg-icon=\"calendar\" class=\"name\"></md-icon><label>תאריך רישום</label><input \nng-value=\"registrations.Registration.RegistrationTime | cmdate:\'HH:mm:ss dd/MM/yyyy \'\" ng-disabled=\"true\">\n</md-input-container></div><div layout=\"column\" flex=\"100\" flex-gt-sm=\"50\" flex-gt-md=\"50\"><md-input-container \nclass=\"md-icon-float md-block\" layout=\"column\" layout-xs=\"row\" flex=\"100\" flex-xs=\"100\" flex-gt-sm=\"100\" \nflex-gt-md=\"100\"><md-icon md-svg-icon=\"cash-multiple\" class=\"name\"></md-icon><label>סכום תשלום</label><input \nng-value=\"registrations.Registration.Price\" ng-disabled=\"true\"></md-input-container></div></div><div class=\"row\" \nlayout=\"row\"><div layout=\"column\" flex=\"100\" flex-gt-sm=\"50\" flex-gt-md=\"50\"><md-input-container \nclass=\"md-icon-float md-block\" layout=\"column\" layout-xs=\"row\" flex=\"100\" flex-xs=\"100\" flex-gt-sm=\"100\" \nflex-gt-md=\"100\"><md-icon md-svg-icon=\"cash-multiple\" class=\"name\"></md-icon><label>סכום {{$root.User.Event}}</label>\n<input ng-if=\"!registrations.Registration.Discount\" ng-value=\"registrations.Registration.Price\" ng-disabled=\"true\">\n</md-input-container></div><div layout=\"column\" flex=\"100\" flex-gt-sm=\"50\" flex-gt-md=\"50\"><md-input-container \nclass=\"md-block\"><md-icon md-svg-icon=\"credit-card\" class=\"name\"></md-icon><label>אופן תשלום</label><input \nng-value=\"registrations.Registration.PaymentTypeText\" ng-disabled=\"true\"></md-input-container></div></div><div \nclass=\"row\" layout=\"row\"><div layout=\"column\" flex=\"100\" flex-gt-sm=\"50\" flex-gt-md=\"50\"><md-input-container \nclass=\"md-block\"><md-icon md-svg-icon=\"cards-outline\" class=\"name\"></md-icon><label>סטטוס תשלום</label><md-select \nng-model=\"registrations.Registration.PaymentStatus\" ng-change=\"sendReceipt(registrations.Registration)\" \nng-disabled=\"registrations.Registration.PaymentStatus===1 || isClicked || ($root.AdminLevel<3 && !$root.User.Payments)\">\n<md-option ng-value=\"1\">שולם</md-option><md-option ng-value=\"2\">שולם ל{{$root.User.Coordinators}}</md-option><md-option\n ng-value=\"0\" ng-disabled=\"registrations.Registration.PaymentStatus\">לא שולם</md-option></md-select>\n</md-input-container></div><div layout=\"column\" flex=\"100\" flex-gt-sm=\"50\" flex-gt-md=\"50\"><md-input-container \nclass=\"md-block\"><md-icon md-svg-icon=\"power\" class=\"name\"></md-icon><label>סטטוס הרשמה</label><md-select \nng-model=\"registrations.Registration.Status\" ng-disabled=\"isClicked || ($root.AdminLevel<3 && !$root.User.Payments)\">\n<md-option ng-value=\"\'1\'\">פעיל</md-option><md-option ng-value=\"\'0\'\">לא פעיל</md-option></md-select>\n</md-input-container></div></div><div class=\"row\" layout=\"row\"><div layout=\"column\" flex=\"100\" flex-gt-sm=\"100\" \nflex-gt-md=\"100\"><md-input-container class=\"md-block\"><md-icon md-svg-icon=\"clipboard-text\" class=\"name\"></md-icon>\n<label>הערות פנימיות</label><textarea ng-model=\"registrations.Registration.InternalComments\" ng-disabled=\"isClicked\">\n</textarea></md-input-container></div></div><div class=\"row\" layout=\"row\"><div layout=\"column\" flex=\"100\" \nflex-gt-sm=\"50\" flex-gt-md=\"50\"><md-input-container class=\"md-icon-float md-block\" layout=\"column\" layout-xs=\"row\" \nflex=\"100\" flex-xs=\"100\" flex-gt-sm=\"100\" flex-gt-md=\"100\"><md-icon ng-if=\"!registrations.Registration.File\" \nmd-svg-icon=\"upload\" class=\"name\"></md-icon><md-icon ng-disabled=\"isClicked\" ng-if=\"registrations.Registration.File\" \nmd-svg-icon=\"eye\" href=\"{{registrations.Registration.File}}\" ng-click=\"viewFile()\" style=\"cursor: pointer\" \ntitle=\"צפייה בקובץ\" class=\"name\"></md-icon><label>עדכון קובץ</label><input ng-disabled=\"isClicked\" \nngf-select=\"uploadFile($file)\" placeholder=\"{{fileName}}\" ng-model=\"file\" name=\"file\" ngf-pattern=\"\'image/*\'\" \nstyle=\"cursor: pointer\" readonly=\"readonly\"></md-input-container></div></div><div class=\"row\" layout=\"row\" \nng-if=\"registrations.Registration.Subsidization\"><div layout=\"column\" flex=\"100\" flex-gt-sm=\"50\" flex-gt-md=\"50\">\n<md-input-container class=\"account\"><md-icon md-svg-icon=\"clipboard-text\" class=\"name\"></md-icon><label>שם הגורם המסבסד\n</label><textarea ng-model=\"registrations.Registration.SubsidizationName\" ng-disabled=\"isClicked\"></textarea>\n</md-input-container></div><div layout=\"column\" flex=\"100\" flex-gt-sm=\"50\" flex-gt-md=\"50\"><md-input-container \nclass=\"md-block\"><md-icon md-svg-icon=\"clipboard-text\" class=\"name\"></md-icon><label>סכום אשר סובסד</label><textarea \nng-model=\"registrations.Registration.SubsidizationSum\" ng-disabled=\"isClicked\"></textarea></md-input-container></div>\n</div><md-button ng-if=\"$root.AdminLevel==3\" type=\"submit\" ng-disabled=\"isClicked\" class=\"md-raised md-accent\" \naria-label=\"חפש\" ng-click=\"updateRegistration(registrations.Registration)\">עדכון</md-button><md-button \nng-if=\"$root.AdminLevel==3 && registrations.Registration.ReceiptID\" class=\"preview-user\" title=\"שליחת קבלה חוזרת\">\n<md-icon md-svg-icon=\"email\" ng-click=\"reSendReceipt(registrations.Registration.ReceiptID,1)\"></md-icon></md-button>\n</form></div>");
$templateCache.put("app/main/pages/users/views/parents/parents-profile/tabs/subsidy/subsidy-dialog/form2/formtype2.html","<div id=\"tofes2\"><h2>שם ה{{$root.User.Event}}: {{subsidy.Event }}</h2><h3 class=\"hfs20 fw-light\">\nתאריך בקשה {{subsidy.CreateTime*1000 | date}}</h3><table ng-if=\"subsidy.Students\" \nclass=\"dataTable row-border hover stripe md-ink-ripple\"><thead><tr><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">תעודות זהות</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">שם</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">{{$root.User.Group}}</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">{{$root.User.Branch}}</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">סטטוס</span></div></th></tr></thead><tbody><tr class=\"md-ink-ripple\" \nng-repeat=\"student in subsidy.Students\"><td>{{student.PrivateID}}</td><td>{{student.FirstName}} {{student.LastName}}\n</td><td>{{student.GroupName}}</td><td>{{student.BranchName}}</td><td>{{student.Status ? \'פעיל\' : \'לא פעיל\'}}<md-button\n class=\"preview-user\" ng-disabled=\"true\"></md-button></td></tr><tr class=\"md-ink-ripple\" ng-repeat=\"kid in moreKids\">\n<td>{{kid.PrivateID}}</td><td>{{kid.FirstName + \" \" + kid.LastName}}</td><td>{{kid.GroupName}}</td><td>\n{{kid.BranchName}}</td><td>{{kid.student.Stats ? \'לא פעיל\' : \'פעיל\'}}<md-button class=\"preview-user\" \nng-disabled=\"true\"></md-button></td></tr></tbody></table><div class=\"w100 inrowf mt20\"><md-input-container \nng-if=\"subsidy.ParentFName\" class=\"md-icon-float md-block\" layout=\"column\" layout-xs=\"row\" flex=\"100\" flex-xs=\"100\" \nflex-gt-sm=\"50\" flex-gt-md=\"50\"><md-icon></md-icon><label>2 שם פרטי הורה</label><input ng-value=\"subsidy.ParentFName\" \ntype=\"text\" ng-disabled=\"true\"></md-input-container><md-input-container ng-if=\"subsidy.ParentFName\" \nclass=\"md-icon-float md-block\" layout=\"column\" layout-xs=\"row\" flex=\"100\" flex-xs=\"100\" flex-gt-sm=\"50\" \nflex-gt-md=\"50\"><md-icon></md-icon><label>שם משפחה הורה 2</label><input ng-value=\"subsidy.ParentLName\" type=\"text\" \nng-disabled=\"true\"></md-input-container><md-input-container ng-if=\"subsidy.ParentFName\" class=\"md-icon-float md-block\" \nlayout=\"column\" layout-xs=\"row\" flex=\"100\" flex-xs=\"100\" flex-gt-sm=\"50\" flex-gt-md=\"50\"><md-icon></md-icon><label>\n2 פלאפון הורה</label><input ng-value=\"subsidy.ParentMNumber\" type=\"text\" ng-disabled=\"true\"></md-input-container>\n<md-input-container ng-if=\"subsidy.ParentFName\" class=\"md-icon-float md-block\" layout=\"column\" layout-xs=\"row\" \nflex=\"100\" flex-xs=\"100\" flex-gt-sm=\"50\" flex-gt-md=\"50\"><md-icon></md-icon><label>אימייל הורה 2</label><input \nng-value=\"subsidy.ParentEmail\" type=\"text\" ng-disabled=\"true\"></md-input-container><div class=\"col4s20\" \nng-if=\"subsidy.Parent1PrivateIDFile.Path\">צילום ת.ז הורה 1 <a href=\"{{subsidy.Parent1PrivateIDFile.Path}}\" \ntarget=\"_blank\"><md-icon md-svg-icon=\"eye\"></md-icon></a></div><div class=\"col4s20\" \nng-if=\"subsidy.Parent1Paycheck1File.Path\">צילום משכורת ראשונה הורה 1 <a href=\"{{subsidy.Parent1Paycheck1File.Path}}\" \ntarget=\"_blank\"><md-icon md-svg-icon=\"eye\"></md-icon></a></div><div class=\"col4s20\" \nng-if=\"subsidy.Parent1Paycheck2File.Path\">צילום משכורת שנייה הורה 1 <a href=\"{{subsidy.Parent1Paycheck2File.Path}}\" \ntarget=\"_blank\"><md-icon md-svg-icon=\"eye\"></md-icon></a></div><div class=\"col4s20\" \nng-if=\"subsidy.Parent1Paycheck3File.Path\">צילום משכורת שלישית הורה 1 <a href=\"{{subsidy.Parent1Paycheck3File.Path}}\" \ntarget=\"_blank\"><md-icon md-svg-icon=\"eye\"></md-icon></a></div><div class=\"col4s20\" \nng-if=\"subsidy.Parent2PrivateIDFile.Path\">צילום ת.ז הורה 2 <a href=\"{{subsidy.Parent2PrivateIDFile.Path}}\" \ntarget=\"_blank\"><md-icon md-svg-icon=\"eye\"></md-icon></a></div><div class=\"col4s20\" \nng-if=\"subsidy.Parent2Paycheck1File.Path\">צילום משכורת ראשונה הורה 2 <a href=\"{{subsidy.Parent2Paycheck1File.Path}}\" \ntarget=\"_blank\"><md-icon md-svg-icon=\"eye\"></md-icon></a></div><div class=\"col4s20\" \nng-if=\"subsidy.Parent2Paycheck2File.Path\">צילום משכורת שנייה הורה 2 <a href=\"{{subsidy.Parent2Paycheck2File.Path}}\" \ntarget=\"_blank\"><md-icon md-svg-icon=\"eye\"></md-icon></a></div><div class=\"col4s20\" \nng-if=\"subsidy.Parent2Paycheck3File.Path\">צילום משכורת שלישית הורה 2 <a href=\"{{subsidy.Parent2Paycheck3File.Path}}\" \ntarget=\"_blank\"><md-icon md-svg-icon=\"eye\"></md-icon></a></div><div class=\"w100\"><ul><li \nng-repeat=\"item in subsidy.OtherFiles\"><a href=\"{{item.Path}}\" target=\"_blank\">{{item.Name}}</a></li></ul></div><div \nclass=\"w100\" ng-if=\"subsidy.Comment\"><h3 class=\"hfs25 fw-medium\">הערות נוספות</h3><p>{{subsidy.Comment}}</p></div>\n</div></div>");
$templateCache.put("app/main/pages/users/views/parents/parents-profile/tabs/subsidy/subsidy-dialog/form3/formtype3.html","<div id=\"tofes2\"><h2>שם ה{{$root.User.Event}}: {{subsidy.Event }}</h2><h3 class=\"hfs20 fw-light\">\nתאריך בקשה {{subsidy.CreateTime * 1000 | date}}</h3><div class=\"flex w100 aifs fdc jcfs border mb45 hp20 vp20\"><label \nclass=\"hfs20 fw-medium mt15\">פרטי הבקשה</label><table ng-if=\"subsidy\" class=\"dataTable hover\"><thead><tr><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">שם ממלא הטופס</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">קרבה לחניך</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">מצב משפחתי של הורי החניך</span></div></th>\n<th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">מספר ילדים מתחת לגיל 18</span></div>\n</th></tr></thead><tbody><tr class=\"\"><td>{{subsidy.SigneesName}}</td><td>{{subsidy.RelationToStudent}}</td><td>\n{{subsidy.FamilyStatus}}</td><td>{{subsidy.NumberOfKids}}</td></tr></tbody></table><label class=\"hfs20 fw-medium\">\nנימוקים:</label><p class=\"\">{{subsidy.Reasons}}</p></div><label class=\"hfs20 fw-medium mt15\">חניכים עבורם הוגשה הבקשה:\n</label><table ng-if=\"subsidy.Students\" class=\"dataTable row-border hover stripe md-ink-ripple\"><thead><tr><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">תעודות זהות</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">שם</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">{{$root.User.Group}}</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">{{$root.User.Branch}}</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">סטטוס</span></div></th></tr></thead><tbody>\n<tr class=\"md-ink-ripple\" ng-repeat=\"student in subsidy.Students\"><td>{{student.PrivateID}}</td><td>\n{{student.FirstName}} {{student.LastName}}</td><td>{{student.GroupName}}</td><td>{{student.BranchName}}</td><td>\n{{student.Status ? \'פעיל\' : \'לא פעיל\'}}<md-button class=\"preview-user\" ng-disabled=\"true\"></md-button></td></tr><tr \nclass=\"md-ink-ripple\" ng-repeat=\"kid in moreKids\"><td>{{kid.PrivateID}}</td><td>{{kid.FirstName + \" \" + kid.LastName}}\n</td><td>{{kid.GroupName}}</td><td>{{kid.BranchName}}</td><td>{{kid.student.Stats ? \'לא פעיל\' : \'פעיל\'}}<md-button \nclass=\"preview-user\" ng-disabled=\"true\"></md-button></td></tr></tbody></table></div>");
$templateCache.put("app/main/pages/users/views/parents/parents-profile/tabs/subsidy/subsidy-dialog/form3/formtype3Parents.html","<div class=\"w100 inrowf mt20\"><md-tabs md-dynamic-height md-selected=\"selectedTab\" ng-if=\"+subsidy.typeForm === 3\" \nclass=\"w100\"><md-tab><md-tab-label><span>פרטי האב</span></md-tab-label><md-tab-body><md-content class=\"general-tab\" \nstyle=\"padding: 50px\"><div class=\"w100 inrowf mt20 fdc\"><div class=\"w100 inrowf aic jcsb\"><md-input-container \nclass=\"col2s30 smw100\"><label>שם</label><input ng-value=\"subsidy.FathersName\" type=\"text\" ng-disabled=\"true\">\n</md-input-container><md-input-container ng-if=\"+subsidy.FatherIsEmployee === 1\" class=\"col2s30 smw100\"><label>\nמקום עבודה</label><input ng-value=\"subsidy.FathersWork\" type=\"text\" ng-disabled=\"true\"></md-input-container></div><div \nclass=\"w100 inrowf aic jcsb\"><md-input-container class=\"col2s30 smw100\"><label>תפקיד</label><input \nng-value=\"subsidy.FathersRole\" type=\"text\" ng-disabled=\"true\"></md-input-container></div><div \nclass=\"w100 inrowf aic jcsb\" ng-if=\"+subsidy.FatherIsEmployee === 1\"><md-input-container class=\"col2s30 smw100\"><label>\nנטו משכורת ינואר</label><input ng-value=\"subsidy.FathersSalary1Net\" type=\"text\" ng-disabled=\"true\">\n</md-input-container><md-input-container ng-if=\"+subsidy.FatherIsEmployee === 1\" class=\"col2s30 smw100\"><div class=\"\" \nng-if=\"subsidy.FathersSalary1File.Path\">תלוש שכר ינואר <a href=\"{{subsidy.FathersSalary1File.Path}}\" target=\"_blank\">\n<md-icon md-svg-icon=\"eye\"></md-icon></a></div></md-input-container></div><div class=\"w100 inrowf aic jcsb\" \nng-if=\"+subsidy.FatherIsEmployee === 1\"><md-input-container class=\"col2s30 smw100\"><label>נטו משכורת פברואר</label>\n<input ng-value=\"subsidy.FathersSalary2Net\" type=\"text\" ng-disabled=\"true\"></md-input-container><md-input-container \nng-if=\"+subsidy.FatherIsEmployee === 1\" class=\"col2s30 smw100\"><div class=\"\" ng-if=\"subsidy.FathersSalary2File.Path\">\nתלוש שכר פברואר <a href=\"{{subsidy.FathersSalary2File.Path}}\" target=\"_blank\"><md-icon md-svg-icon=\"eye\"></md-icon></a>\n</div></md-input-container></div><div class=\"w100 inrowf aic jcsb\" ng-if=\"+subsidy.FatherIsEmployee === 1\">\n<md-input-container class=\"col2s30 smw100\"><label>נטו משכורת מרץ</label><input ng-value=\"subsidy.FathersSalary3Net\" \ntype=\"text\" ng-disabled=\"true\"></md-input-container><md-input-container ng-if=\"+subsidy.FatherIsEmployee === 1\" \nclass=\"col2s30 smw100\"><div class=\"\" ng-if=\"subsidy.FathersSalary3File.Path\">תלוש שכר מרץ <a \nhref=\"{{subsidy.FathersSalary3File.Path}}\" target=\"_blank\"><md-icon md-svg-icon=\"eye\"></md-icon></a></div>\n</md-input-container></div><div class=\"w100 inrowf aic jcsb\" ng-if=\"+subsidy.FatherIsEmployee === 2\">\n<md-input-container class=\"col2s30 smw100\"><label>סך הכל הכנסות על פי חלקים 2, 3</label><input \nng-value=\"subsidy.FathersTotalIncome\" type=\"text\" ng-disabled=\"true\"></md-input-container><md-input-container \nclass=\"col2s30 smw100\"><label>מס מגיע</label><input ng-value=\"subsidy.FathersTax\" type=\"text\" ng-disabled=\"true\">\n</md-input-container></div><div class=\"w100 inrowf aic jcsb\" ng-if=\"+subsidy.FatherIsEmployee === 2\">\n<md-input-container class=\"col2s30 smw100\"><div class=\"\" ng-if=\"subsidy.FathersAssessmentFile.Path\">\nטופס שומת מס אחרונה <a href=\"{{subsidy.FathersAssessmentFile.Path}}\" target=\"_blank\"><md-icon md-svg-icon=\"eye\">\n</md-icon></a></div></md-input-container></div></div></md-content></md-tab-body></md-tab><md-tab><md-tab-label><span>\nפרטי האם</span></md-tab-label><md-tab-body><md-content class=\"general-tab\" style=\"padding: 50px\"><div \nclass=\"w100 inrowf mt20 fdc\"><div class=\"w100 inrowf aic jcsb\"><md-input-container class=\"col2s30 smw100\"><label>שם\n</label><input ng-value=\"subsidy.MothersName\" type=\"text\" ng-disabled=\"true\"></md-input-container><md-input-container \nng-if=\"+subsidy.MotherIsEmployee === 1\" class=\"col2s30 smw100\"><label>מקום עבודה</label><input \nng-value=\"subsidy.MothersWork\" type=\"text\" ng-disabled=\"true\"></md-input-container></div><div \nclass=\"w100 inrowf aic jcsb\"><md-input-container class=\"col2s30 smw100\"><label>תפקיד</label><input \nng-value=\"subsidy.MothersRole\" type=\"text\" ng-disabled=\"true\"></md-input-container></div><div \nclass=\"w100 inrowf aic jcsb\" ng-if=\"+subsidy.MotherIsEmployee === 1\"><md-input-container class=\"col2s30 smw100\"><label>\nנטו משכורת ינואר</label><input ng-value=\"subsidy.MothersSalary1Net\" type=\"text\" ng-disabled=\"true\">\n</md-input-container><md-input-container ng-if=\"+subsidy.MotherIsEmployee === 1\" class=\"col2s30 smw100\"><div class=\"\" \nng-if=\"subsidy.MothersSalary1File.Path\">תלוש שכר ינואר <a href=\"{{subsidy.MothersSalary1File.Path}}\" target=\"_blank\">\n<md-icon md-svg-icon=\"eye\"></md-icon></a></div></md-input-container></div><div class=\"w100 inrowf aic jcsb\" \nng-if=\"+subsidy.MotherIsEmployee === 1\"><md-input-container class=\"col2s30 smw100\"><label>נטו משכורת פברואר</label>\n<input ng-value=\"subsidy.MothersSalary2Net\" type=\"text\" ng-disabled=\"true\"></md-input-container><md-input-container \nng-if=\"+subsidy.MotherIsEmployee === 1\" class=\"col2s30 smw100\"><div class=\"\" ng-if=\"subsidy.MothersSalary2File.Path\">\nתלוש שכר פברואר <a href=\"{{subsidy.MothersSalary2File.Path}}\" target=\"_blank\"><md-icon md-svg-icon=\"eye\"></md-icon></a>\n</div></md-input-container></div><div class=\"w100 inrowf aic jcsb\" ng-if=\"+subsidy.MotherIsEmployee === 1\">\n<md-input-container class=\"col2s30 smw100\"><label>נטו משכורת מרץ</label><input ng-value=\"subsidy.MothersSalary3Net\" \ntype=\"text\" ng-disabled=\"true\"></md-input-container><md-input-container ng-if=\"+subsidy.MotherIsEmployee === 1\" \nclass=\"col2s30 smw100\"><div class=\"\" ng-if=\"subsidy.MothersSalary3File.Path\">תלוש שכר מרץ <a \nhref=\"{{subsidy.MothersSalary3File.Path}}\" target=\"_blank\"><md-icon md-svg-icon=\"eye\"></md-icon></a></div>\n</md-input-container></div><div class=\"w100 inrowf aic jcsb\" ng-if=\"+subsidy.MotherIsEmployee === 2\">\n<md-input-container class=\"w100\"><label>סך הכל הכנסות על פי חלקים 2, 3</label><input \nng-value=\"subsidy.MothersTotalIncome\" type=\"text\" ng-disabled=\"true\"></md-input-container></div><div \nclass=\"w100 inrowf aic jcsb\" ng-if=\"+subsidy.MotherIsEmployee === 2\"><md-input-container class=\"w100\"><label>מס מגיע\n</label><input ng-value=\"subsidy.MothersTax\" type=\"text\" ng-disabled=\"true\"></md-input-container></div><div \nclass=\"w100 inrowf aic jcsb\" ng-if=\"+subsidy.MotherIsEmployee === 2\"><md-input-container class=\"w100\"><div class=\"\" \nng-if=\"subsidy.MothersAssessmentFile.Path\">טופס שומת מס אחרונה <a href=\"{{subsidy.MothersAssessmentFile.Path}}\" \ntarget=\"_blank\"><md-icon md-svg-icon=\"eye\"></md-icon></a></div></md-input-container></div></div></md-content>\n</md-tab-body></md-tab></md-tabs><div class=\"w100\"><label>קבצים נוספים</label><ul><li \nng-repeat=\"item in subsidy.OtherFiles\"><a href=\"{{item.Path}}\" target=\"_blank\">{{item.Name}}</a></li></ul></div><div \nclass=\"w100\" ng-if=\"subsidy.Comment\"><h3 class=\"hfs25 fw-medium\">הערות נוספות</h3><p>{{subsidy.Comment}}</p></div>\n</div>");
$templateCache.put("app/main/pages/users/views/parents/parents-profile/tabs/subsidy/subsidy-dialog/tabs/details.html","<form class=\"md-inline-form\" validate><div layout=\"row\" layout-wrap><md-input-container class=\"md-icon-float md-block\" \nlayout=\"column\" layout-xs=\"row\" flex=\"100\" flex-xs=\"100\" flex-gt-sm=\"50\" flex-gt-md=\"50\"><label>סיבות לבקשה</label>\n<textarea ng-value=\"subsidy.Reason\" ng-disabled=\"true\"></textarea></md-input-container></div><span \nng-if=\"subsidy.Files\" ng-repeat=\"file in subsidy.Files\"><a style=\"font-size: 25px\" href=\"{{file.Path}}\" target=\"_self\" \ndownload=\"{{file.Name}}\" title=\"{{file.Name}}\" class=\"icon-file-document\"></a></span></form>");
$templateCache.put("app/main/pages/users/views/parents/parents-profile/tabs/subsidy/subsidy-dialog/tabs/economic.html","<form name=\"UserForm\" class=\"md-inline-form\" validate><div layout=\"row\" layout-wrap><md-input-container \nclass=\"md-icon-float md-block\" layout=\"column\" layout-xs=\"row\" flex=\"100\" flex-xs=\"100\" flex-gt-sm=\"50\" \nflex-gt-md=\"50\"><md-icon></md-icon><label>בית פרטי</label><input ng-value=\"subsidy.House==1 ? \'כן\' : \'לא\'\" type=\"text\" \nng-disabled=\"true\"></md-input-container><md-input-container class=\"md-icon-float md-block\" layout=\"column\" \nlayout-xs=\"row\" flex=\"100\" flex-xs=\"100\" flex-gt-sm=\"50\" flex-gt-md=\"50\"><md-icon></md-icon><label>דירת מגורים</label>\n<input ng-value=\"subsidy.Apartment==1 ? \'כן\' : \'לא\'\" type=\"text\" ng-disabled=\"true\"></md-input-container></div><div \nlayout=\"row\" layout-wrap><md-input-container class=\"md-icon-float md-block\" layout=\"column\" layout-xs=\"row\" flex=\"100\" \nflex-xs=\"100\" flex-gt-sm=\"50\" flex-gt-md=\"50\"><md-icon></md-icon><label>בבעלות</label><input \nng-value=\"subsidy.Ownership==\'Private\' ? \'שכירות\' : \'פרטית\'\" type=\"text\" ng-disabled=\"true\"></md-input-container>\n<md-input-container class=\"md-icon-float md-block\" layout=\"column\" layout-xs=\"row\" flex=\"100\" flex-xs=\"100\" \nflex-gt-sm=\"50\" flex-gt-md=\"50\"><md-icon></md-icon><label>אחר</label><input ng-value=\"subsidy.OtherHouse\" type=\"text\" \nng-disabled=\"true\"></md-input-container></div><div layout=\"row\" layout-wrap><md-input-container \nclass=\"md-icon-float md-block\" layout=\"column\" layout-xs=\"row\" flex=\"100\" flex-xs=\"100\" flex-gt-sm=\"50\" \nflex-gt-md=\"50\"><md-icon></md-icon><label>בעל רכב</label><input ng-value=\"subsidy.Vehicle==1 ? \'כן\' : \'לא\'\" \ntype=\"text\" ng-disabled=\"true\"></md-input-container><md-input-container class=\"md-icon-float md-block\" layout=\"column\" \nlayout-xs=\"row\" flex=\"100\" flex-xs=\"100\" flex-gt-sm=\"50\" flex-gt-md=\"50\"><md-icon></md-icon><label>סוג רכב</label>\n<input ng-value=\"subsidy.VehicleType\" type=\"text\" ng-disabled=\"true\"></md-input-container></div><div layout=\"row\" \nlayout-wrap><md-input-container class=\"md-icon-float md-block\" layout=\"column\" layout-xs=\"row\" flex=\"100\" \nflex-xs=\"100\" flex-gt-sm=\"50\" flex-gt-md=\"50\"><md-icon></md-icon><label>רכב חברה</label><input \nng-value=\"subsidy.CompanyVehicle==1 ? \'כן\' : \'לא\'\" type=\"text\" ng-disabled=\"true\"></md-input-container>\n<md-input-container class=\"md-icon-float md-block\" layout=\"column\" layout-xs=\"row\" flex=\"100\" flex-xs=\"100\" \nflex-gt-sm=\"50\" flex-gt-md=\"50\"><md-icon></md-icon><label>שנת הרכב</label><input ng-value=\"subsidy.VehicleYear\" \ntype=\"text\" ng-disabled=\"true\"></md-input-container></div><div layout=\"row\" layout-wrap><md-input-container \nclass=\"md-icon-float md-block\" layout=\"column\" layout-xs=\"row\" flex=\"100\" flex-xs=\"100\" flex-gt-sm=\"50\" \nflex-gt-md=\"50\"><md-icon></md-icon><label>רכב נוסף</label><input ng-value=\"subsidy.SecondVehicle==1 ? \'כן\' : \'לא\'\" \ntype=\"text\" ng-disabled=\"true\"></md-input-container><md-input-container class=\"md-icon-float md-block\" layout=\"column\" \nlayout-xs=\"row\" flex=\"100\" flex-xs=\"100\" flex-gt-sm=\"50\" flex-gt-md=\"50\"><md-icon></md-icon><label>סוג רכב</label>\n<input ng-value=\"subsidy.SecondVehicleType\" type=\"text\" ng-disabled=\"true\"></md-input-container></div><div \nlayout=\"row\" layout-wrap><md-input-container class=\"md-icon-float md-block\" layout=\"column\" layout-xs=\"row\" flex=\"100\" \nflex-xs=\"100\" flex-gt-sm=\"50\" flex-gt-md=\"50\"><md-icon></md-icon><label>רכב חברה</label><input \nng-value=\"subsidy.SecondCompanyVehicle==1 ? \'כן\' : \'לא\'\" type=\"text\" ng-disabled=\"true\"></md-input-container>\n<md-input-container class=\"md-icon-float md-block\" layout=\"column\" layout-xs=\"row\" flex=\"100\" flex-xs=\"100\" \nflex-gt-sm=\"50\" flex-gt-md=\"50\"><md-icon></md-icon><label>שנת הרכב</label><input ng-value=\"subsidy.SecondVehicleYear\" \ntype=\"text\" ng-disabled=\"true\"></md-input-container></div></form>");
$templateCache.put("app/main/pages/users/views/parents/parents-profile/tabs/subsidy/subsidy-dialog/tabs/internal.html","<form class=\"md-inline-form\" validate><div layout=\"row\" layout-wrap><md-input-container class=\"md-icon-float md-block\" \nlayout=\"column\" layout-xs=\"row\" flex=\"100\" flex-xs=\"100\" flex-gt-sm=\"50\" flex-gt-md=\"50\"><md-icon></md-icon><label>\nתשלום מאושר</label><md-select ng-model=\"subsidy.Confirmed\"><md-option ng-value=\"0\" \nng-selected=\"subsidy.Confirmed==0 || subsidy.Confirmed==\'0\'\">לא</md-option><md-option ng-value=\"1\" \nng-selected=\"subsidy.Confirmed==1 || subsidy.Confirmed==\'1\'\">כן</md-option></md-select></md-input-container>\n<md-input-container class=\"md-icon-float md-block\" layout=\"column\" layout-xs=\"row\" flex=\"100\" flex-xs=\"100\" \nflex-gt-sm=\"50\" flex-gt-md=\"50\"><md-icon></md-icon><label>סכום התשלום שאושר</label><input \nng-model=\"subsidy.NumberOfPayments\" type=\"number\"></md-input-container></div><div layout=\"row\" layout-wrap>\n<md-input-container class=\"md-icon-float md-block\" layout=\"column\" layout-xs=\"row\" flex=\"100\" flex-xs=\"100\" \nflex-gt-sm=\"50\" flex-gt-md=\"50\"><md-icon></md-icon><label>שם המאשר</label><input ng-model=\"subsidy.ApprovedName\" \ntype=\"text\"></md-input-container></div><div layout=\"row\" layout-wrap><md-input-container \nclass=\"md-icon-float md-block\" layout=\"column\" layout-xs=\"row\" flex=\"100\" flex-xs=\"100\" flex-gt-sm=\"50\" \nflex-gt-md=\"50\"><md-icon></md-icon><label>מאיזה תקציב</label><input ng-model=\"subsidy.FromBudget\" type=\"text\">\n</md-input-container></div><md-button type=\"submit\" ng-click=\"updateSubsidy()\" ng-disabled=\"isClicked\" \nclass=\"md-raised md-accent\" aria-label=\"שמור את השדות\" style=\"margin-right: 0px\">שמירה</md-button></form>");
$templateCache.put("app/main/pages/users/views/parents/parents-profile/tabs/subsidy/subsidy-dialog/tabs/kids.html","<table class=\"dataTable row-border hover stripe md-ink-ripple\"><thead><tr><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">תעודות זהות</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">שם</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">{{$root.User.Group}}</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">{{$root.User.Branch}}</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">סטטוס</span></div></th></tr></thead><tbody><tr class=\"md-ink-ripple\" \nng-repeat=\"student in subsidy.Students\"><td>{{student.PrivateID}}</td><td>{{student.FirstName}} {{student.LastName}}\n</td><td>{{student.GroupName}}</td><td>{{student.BranchName}}</td><td>{{student.Status ? \'פעיל\' : \'לא פעיל\'}}<md-button\n class=\"preview-user\" ng-disabled=\"true\"></md-button></td></tr><tr class=\"md-ink-ripple\" \nng-repeat=\"kid in subsidy.Kids\"><td>{{kid.TZ}}</td><td>{{kid.Name}}</td><td>לא חבר</td><td>לא חבר</td><td>לא חבר\n<md-button class=\"preview-user\" ng-disabled=\"true\"></md-button></td></tr></tbody></table>");
$templateCache.put("app/main/pages/users/views/parents/parents-profile/tabs/subsidy/subsidy-dialog/tabs/occupation.html","<form class=\"md-inline-form\" validate><div layout=\"row\" layout-wrap><md-input-container class=\"md-icon-float md-block\" \nlayout=\"column\" layout-xs=\"row\" flex=\"100\" flex-xs=\"100\" flex-gt-sm=\"50\" flex-gt-md=\"50\"><md-icon></md-icon><label>\nמקצוע הורה 1</label><input ng-value=\"subsidy.FatherProfession\" type=\"text\" ng-disabled=\"true\"></md-input-container>\n<md-input-container class=\"md-icon-float md-block\" layout=\"column\" layout-xs=\"row\" flex=\"100\" flex-xs=\"100\" \nflex-gt-sm=\"50\" flex-gt-md=\"50\"><md-icon></md-icon><label>מקום עבודה הורה 1</label><input \nng-value=\"subsidy.FatherWorkplace\" type=\"text\" ng-disabled=\"true\"></md-input-container></div><div layout=\"row\" \nlayout-wrap><md-input-container class=\"md-icon-float md-block\" layout=\"column\" layout-xs=\"row\" flex=\"100\" \nflex-xs=\"100\" flex-gt-sm=\"50\" flex-gt-md=\"50\"><md-icon></md-icon><label>סכום הכנסות הורה 1 ברוטו</label><input \nng-value=\"subsidy.FatherSalary\" type=\"text\" ng-disabled=\"true\"></md-input-container><md-input-container \nclass=\"md-icon-float md-block\" layout=\"column\" layout-xs=\"row\" flex=\"100\" flex-xs=\"100\" flex-gt-sm=\"50\" \nflex-gt-md=\"50\"><md-icon></md-icon><label>הערות הורה 1</label><input ng-value=\"subsidy.FatherNotes\" type=\"text\" \nng-disabled=\"true\"></md-input-container></div><div layout=\"row\" layout-wrap><md-input-container \nclass=\"md-icon-float md-block\" layout=\"column\" layout-xs=\"row\" flex=\"100\" flex-xs=\"100\" flex-gt-sm=\"50\" \nflex-gt-md=\"50\"><md-icon></md-icon><label>מקצוע הורה 2</label><input ng-value=\"subsidy.MotherProfession\" type=\"text\" \nng-disabled=\"true\"></md-input-container><md-input-container class=\"md-icon-float md-block\" layout=\"column\" \nlayout-xs=\"row\" flex=\"100\" flex-xs=\"100\" flex-gt-sm=\"50\" flex-gt-md=\"50\"><md-icon></md-icon><label>מקום עבודה הורה 2\n</label><input ng-value=\"subsidy.MotherWorkplace\" type=\"text\" ng-disabled=\"true\"></md-input-container></div><div \nlayout=\"row\" layout-wrap><md-input-container class=\"md-icon-float md-block\" layout=\"column\" layout-xs=\"row\" flex=\"100\" \nflex-xs=\"100\" flex-gt-sm=\"50\" flex-gt-md=\"50\"><md-icon></md-icon><label>סכום הכנסות הורה 2 ברוטו</label><input \nng-value=\"subsidy.MotherSalary\" type=\"text\" ng-disabled=\"true\"></md-input-container><md-input-container \nclass=\"md-icon-float md-block\" layout=\"column\" layout-xs=\"row\" flex=\"100\" flex-xs=\"100\" flex-gt-sm=\"50\" \nflex-gt-md=\"50\"><md-icon></md-icon><label>הערות הורה 2</label><input ng-value=\"subsidy.MotherNotes\" type=\"text\" \nng-disabled=\"true\"></md-input-container></div></form>");
$templateCache.put("app/main/pages/users/views/parents/parents-profile/tabs/subsidy/subsidy-dialog/tabs/revenue.html","<form class=\"md-inline-form\" validate><div layout=\"row\" layout-wrap><md-input-container class=\"md-icon-float md-block\" \nlayout=\"column\" layout-xs=\"row\" flex=\"100\" flex-xs=\"100\" flex-gt-sm=\"50\" flex-gt-md=\"50\"><md-icon></md-icon><label>\nמקצוע הורה 1</label><input ng-value=\"subsidy.FatherProfession\" type=\"text\" ng-disabled=\"true\"></md-input-container>\n<md-input-container class=\"md-icon-float md-block\" layout=\"column\" layout-xs=\"row\" flex=\"100\" flex-xs=\"100\" \nflex-gt-sm=\"50\" flex-gt-md=\"50\"><md-icon></md-icon><label>מקום עבודה הורה 1</label><input \nng-value=\"subsidy.FatherWorkplace\" type=\"text\" ng-disabled=\"true\"></md-input-container></div><div layout=\"row\" \nlayout-wrap><md-input-container class=\"md-icon-float md-block\" layout=\"column\" layout-xs=\"row\" flex=\"100\" \nflex-xs=\"100\" flex-gt-sm=\"50\" flex-gt-md=\"50\"><md-icon></md-icon><label>סכום הכנסות הורה 1 ברוטו</label><input \nng-value=\"subsidy.FatherSalary\" type=\"text\" ng-disabled=\"true\"></md-input-container><md-input-container \nclass=\"md-icon-float md-block\" layout=\"column\" layout-xs=\"row\" flex=\"100\" flex-xs=\"100\" flex-gt-sm=\"50\" \nflex-gt-md=\"50\"><md-icon></md-icon><label>הערות הורה 1</label><input ng-value=\"subsidy.FatherNotes\" type=\"text\" \nng-disabled=\"true\"></md-input-container></div><div layout=\"row\" layout-wrap><md-input-container \nclass=\"md-icon-float md-block\" layout=\"column\" layout-xs=\"row\" flex=\"100\" flex-xs=\"100\" flex-gt-sm=\"50\" \nflex-gt-md=\"50\"><md-icon></md-icon><label>ביטוח לאומי</label><input ng-value=\"subsidy.NationalSecurity\" type=\"text\" \nng-disabled=\"true\"></md-input-container><md-input-container class=\"md-icon-float md-block\" layout=\"column\" \nlayout-xs=\"row\" flex=\"100\" flex-xs=\"100\" flex-gt-sm=\"50\" flex-gt-md=\"50\"><md-icon></md-icon><label>עסק\\רכש</label>\n<input ng-value=\"subsidy.Business\" type=\"text\" ng-disabled=\"true\"></md-input-container></div><div layout=\"row\" \nlayout-wrap><md-input-container class=\"md-icon-float md-block\" layout=\"column\" layout-xs=\"row\" flex=\"100\" \nflex-xs=\"100\" flex-gt-sm=\"50\" flex-gt-md=\"50\"><md-icon></md-icon><label>אחר</label><input \nng-value=\"subsidy.ExtraIncome\" type=\"text\" ng-disabled=\"true\"></md-input-container></div></form>");}]);